/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 194);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(216)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(19);
var isBuffer = __webpack_require__(215);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(245)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7), __webpack_require__(224).setImmediate))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var hasClass = function hasClass(elem, className) {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
};

var addClass = function addClass(elem, className) {
  if (!hasClass(elem, className)) {
    elem.className += ' ' + className;
  }
};

var removeClass = function removeClass(elem, className) {
  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
  if (hasClass(elem, className)) {
    while (newClass.indexOf(' ' + className + ' ') >= 0) {
      newClass = newClass.replace(' ' + className + ' ', ' ');
    }
    elem.className = newClass.replace(/^\s+|\s+$/g, '');
  }
};

var escapeHtml = function escapeHtml(str) {
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
};

var _show = function _show(elem) {
  elem.style.opacity = '';
  elem.style.display = 'block';
};

var show = function show(elems) {
  if (elems && !elems.length) {
    return _show(elems);
  }
  for (var i = 0; i < elems.length; ++i) {
    _show(elems[i]);
  }
};

var _hide = function _hide(elem) {
  elem.style.opacity = '';
  elem.style.display = 'none';
};

var hide = function hide(elems) {
  if (elems && !elems.length) {
    return _hide(elems);
  }
  for (var i = 0; i < elems.length; ++i) {
    _hide(elems[i]);
  }
};

var isDescendant = function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

var getTopMargin = function getTopMargin(elem) {
  elem.style.left = '-9999px';
  elem.style.display = 'block';

  var height = elem.clientHeight,
      padding;
  if (typeof getComputedStyle !== 'undefined') {
    // IE 8
    padding = parseInt(getComputedStyle(elem).getPropertyValue('padding-top'), 10);
  } else {
    padding = parseInt(elem.currentStyle.padding);
  }

  elem.style.left = '';
  elem.style.display = 'none';
  return '-' + parseInt((height + padding) / 2) + 'px';
};

var fadeIn = function fadeIn(elem, interval) {
  if (+elem.style.opacity < 1) {
    interval = interval || 16;
    elem.style.opacity = 0;
    elem.style.display = 'block';
    var last = +new Date();
    var tick = (function (_tick) {
      function tick() {
        return _tick.apply(this, arguments);
      }

      tick.toString = function () {
        return _tick.toString();
      };

      return tick;
    })(function () {
      elem.style.opacity = +elem.style.opacity + (new Date() - last) / 100;
      last = +new Date();

      if (+elem.style.opacity < 1) {
        setTimeout(tick, interval);
      }
    });
    tick();
  }
  elem.style.display = 'block'; //fallback IE8
};

var fadeOut = function fadeOut(elem, interval) {
  interval = interval || 16;
  elem.style.opacity = 1;
  var last = +new Date();
  var tick = (function (_tick2) {
    function tick() {
      return _tick2.apply(this, arguments);
    }

    tick.toString = function () {
      return _tick2.toString();
    };

    return tick;
  })(function () {
    elem.style.opacity = +elem.style.opacity - (new Date() - last) / 100;
    last = +new Date();

    if (+elem.style.opacity > 0) {
      setTimeout(tick, interval);
    } else {
      elem.style.display = 'none';
    }
  });
  tick();
};

var fireClick = function fireClick(node) {
  // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
  // Then fixed for today's Chrome browser.
  if (typeof MouseEvent === 'function') {
    // Up-to-date approach
    var mevt = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: true
    });
    node.dispatchEvent(mevt);
  } else if (document.createEvent) {
    // Fallback
    var evt = document.createEvent('MouseEvents');
    evt.initEvent('click', false, false);
    node.dispatchEvent(evt);
  } else if (document.createEventObject) {
    node.fireEvent('onclick');
  } else if (typeof node.onclick === 'function') {
    node.onclick();
  }
};

var stopEventPropagation = function stopEventPropagation(e) {
  // In particular, make sure the space bar doesn't scroll the main window.
  if (typeof e.stopPropagation === 'function') {
    e.stopPropagation();
    e.preventDefault();
  } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
    window.event.cancelBubble = true;
  }
};

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.escapeHtml = escapeHtml;
exports._show = _show;
exports.show = show;
exports._hide = _hide;
exports.hide = hide;
exports.isDescendant = isDescendant;
exports.getTopMargin = getTopMargin;
exports.fadeIn = fadeIn;
exports.fadeOut = fadeOut;
exports.fireClick = fireClick;
exports.stopEventPropagation = stopEventPropagation;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	debugObject: function debugObject(_target) {
		var arr = [];
		for (var i in _target) {
			if (_target.hasOwnProperty(i)) {
				arr[i] = [_target[i]];
			}
		}
		console.table(arr);
	},
	PercentValues: function PercentValues(value, isAddSub) {
		var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

		var res = isAddSub ? value + 1 : value - 1;

		if (res > max) res = max;

		if (res <= 0) res = 0;

		return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(res, 1);
	},
	Flow: function Flow(from, to, value) {
		/*
  	{ name: 'l/s' },
  	{ name: 'CFM' },1 l/s > CFM = 2.11888 (0.471947)
  	{ name: 'm³/h' }, 1 m3/h = 0.277778 L/s; 1 L/s = 3.6 m3/h
  	{ name: 'm³/min' } 1 I/s > m³/min = 0.06 (16.666667)
  */
		var res = value;

		//from 0 and back
		if (from === 0 && to === 1) res = value * 2.11888;

		if (from === 1 && to === 0) res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.471947, 2);

		if (from === 0 && to === 2) res = value * 3.6;

		if (from === 2 && to === 0) res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.277778, 2);

		if (from === 0 && to === 3) res = value * 0.06;

		if (from === 3 && to === 0) res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 16.666667, 2);

		//from 1 and back
		if (from === 1 && to === 2) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.471947, 2); //to L/s
			res *= 3.6;
		}
		if (from === 2 && to === 1) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.277778, 2); //to L/s
			res *= 2.11888;
		}
		if (from === 1 && to === 3) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.471947, 2); //to L/s
			res *= 0.06;
		}
		if (from === 3 && to === 1) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 16.666667, 2); //to L/s
			res *= 2.11888;
		}

		//from 2 and back
		if (from === 2 && to === 3) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.277778, 2); //to L/s
			res *= 0.06;
		}
		if (from === 3 && to === 2) {
			res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 16.666667, 2); //to L/s
			res *= 3.6;
		}

		return res;
	},
	Pressure: function Pressure(from, to, value) {
		/*
  	1 bar = 14.5038 psi;
  	1 psi = 0.0689476 bar
  	{ name: 'bar' },
  	{ name: 'psi' },
  */
		var res = value;

		if (from === 0 && to === 1) res = value * 14.5038;

		if (from === 1 && to === 0) res = value * 0.0689476;

		// console.log('\n*Pressure value in:' + value);
		// console.log({
		// 	 res: res,
		//   resround: _.round(res, 1)
		// })
		return res;
	},
	TemperatureDelta: function TemperatureDelta(from, to, value) {
		/*
  	°F =  °C * 9/5 + 32
  	°C = (°F -32)/(9/5)
  
  	{ name: '°C' },
  	{ name: '°F' },
  */
		var res = value;

		if (from === 0 && to === 1) res = value * 9 / 5;

		if (from === 1 && to === 0) res = value / (9 / 5);

		return res;
	},
	Temperature: function Temperature(from, to, value) {
		/*
  	°F =  °C * 9/5 + 32
  	°C = (°F -32)/(9/5)
  
  	{ name: '°C' },
  	{ name: '°F' },
  */
		var res = value;

		if (from === 0 && to === 1) res = value * 9 / 5 + 32;

		if (from === 1 && to === 0) res = (value - 32) / (9 / 5);

		return res;
	},
	CoolingWaterFlow: function CoolingWaterFlow(from, to, value) {
		var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;

		/*
  	1 L/s =   15.850323 gal/min
  	1 gal/min = 0.06309 L/s
  	{ name: 'l/s' },
  	{ name: 'gpm' },
  */

		var res = value;

		if (from === 0 && to === 1) res = value * 15.850323;

		if (from === 1 && to === 0) res = value * 0.06309;

		return res;
	},
	CoolingWaterInput: function CoolingWaterInput(from, to, value) {
		/*
  	{ name: 'Flow' },
  	{ name: 'Delta T' },}
  */
	},
	toKelvinDeltaT: function toKelvinDeltaT(fromIndex, value) {
		//0 °C
		//1 °F
		var res = value;
		//console.log("toKelvinDeltaT", fromIndex);
		if (fromIndex === 1) {
			res = value * (5 / 9);
		}
		return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(res, 2);
	},
	toKelvin: function toKelvin(fromIndex, value) {
		//0 °C
		//1 °F
		var res = value;

		if (fromIndex === 0) res = value + 273.15; //to K

		if (fromIndex === 1) {
			res = (value - 32) / (9 / 5); //°F to °C
			res += 273.15; //to K
		}
		return res;
	},
	fromKelvin: function fromKelvin(toIndex, value) {
		//0 °C
		//1 °F
		var res = value;

		if (toIndex === 0) // to °C
			res = value - 273.15;

		if (toIndex === 1) {
			res = value - 273.15; // to °C
			res = res * 9 / 5 + 32; // to °F
		}
		return res;
	},
	toPascal: function toPascal(fromIndex, value) {
		//0 bar
		//1 psi

		var res = value;

		if (fromIndex === 0) // from Bar to PA
			res = value * 100000;

		if (fromIndex === 1) // from Psi to PA
			{
				res = value * 0.0689476; //form Psi to bar
				res = res * 100000; //from bar to PA	
			}
		return res;
	},
	toPascal_a: function toPascal_a(fromIndex, value, referenceBarA) {
		//0 bar
		//1 psi
		var res = value;
		if (fromIndex === 1) res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value * 0.0689476, 1);

		var ref = referenceBarA;
		if (fromIndex === 1) ref = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(referenceBarA * 0.0689476, 1);

		var result = res * 1e5 + ref * 1e5;

		// console.log('\n*toPascal_a value in:' + value);
		// console.log({
		// 	value: value,
		// 	res: res,
		// 	referenceBarA: referenceBarA,
		// 	ref: ref,
		// 	result: result,
		// 	'res * 1e5': res * 1e5,
		// 	'ref * 1e5': ref * 1e5
		// })


		return result;
	},
	fromPascal_a: function fromPascal_a(toIndex, value, referenceBarA, d) {
		//0 bar
		//1 psi

		var referenceBarAToPA = toIndex === 0 ? referenceBarA * 100000 : referenceBarA / 14.5038 * 100000;
		var PaToBar = (value - referenceBarAToPA) * 0.00001; //(value - 1 * 1e5) / 1e5;
		var PaToPSI = (value - referenceBarAToPA) / 6894.757293168;
		var res = PaToBar;
		if (toIndex === 1) res = PaToPSI;

		/*
  		const obj = {
  			value: value,
  			toIndex: toIndex,
  			referenceBarAToPA : referenceBarAToPA,
  			referenceBarA: referenceBarA,
  			PaToBar: PaToBar,
  			PaToPSI: PaToPSI,
  			result: res
  		}
  		this.debugObject(obj);
  */
		return res;
	},
	fromPascal: function fromPascal(toIndex, value) {
		var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

		//0 bar
		//1 psi

		var res = value;

		if (toIndex === 0) // from PA to bar
			res = value / 100000;

		if (toIndex === 1) // from PA to Psi
			{
				res = value / 100000; // from PA to bar	
				res = res * 14.5038; //form bar to Psi	
			}
		return res;
	},
	getReportvalue: function getReportvalue(unitType, unitObj, value) {
		var referencePressure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		var res = value;
		var decimalstemp = 2;
		var decimalsPressure = 2;
		var decimalsFlow = 2;

		switch (unitType) {
			case 'Temperature':
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.fromKelvin(unitObj.selected, value), decimalstemp) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'Pressure':
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.fromPascal_a(unitObj.selected, value, referencePressure, 3), decimalsPressure) + ' ' + unitObj.items[unitObj.selected].name + '(g)';
				break;
			case 'PressureNotA':
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.fromPascal(unitObj.selected, value, 3), decimalsPressure) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'Flow':
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.Flow(0, unitObj.selected, value / 0.001), decimalsFlow) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			case 'WaterFlow':
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.CoolingWaterFlow(0, unitObj.selected, value / 0.001, decimalsFlow), decimalsFlow) + ' ' + unitObj.items[unitObj.selected].name;
				break;
			//calc
			default:
				res = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(value, decimalstemp) + ' ' + unitObj.items[unitObj.selected].name;
				break;
		}
		return res;
	}
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _hexToRgb = __webpack_require__(10);

var _removeClass$getTopMargin$fadeIn$show$addClass = __webpack_require__(6);

var _defaultParams = __webpack_require__(143);

var _defaultParams2 = _interopRequireWildcard(_defaultParams);

/*
 * Add modal + overlay to DOM
 */

var _injectedHTML = __webpack_require__(222);

var _injectedHTML2 = _interopRequireWildcard(_injectedHTML);

var modalClass = '.sweet-alert';
var overlayClass = '.sweet-overlay';

var sweetAlertInitialize = function sweetAlertInitialize() {
  var sweetWrap = document.createElement('div');
  sweetWrap.innerHTML = _injectedHTML2['default'];

  // Append elements to body
  while (sweetWrap.firstChild) {
    document.body.appendChild(sweetWrap.firstChild);
  }
};

/*
 * Get DOM element of modal
 */
var getModal = (function (_getModal) {
  function getModal() {
    return _getModal.apply(this, arguments);
  }

  getModal.toString = function () {
    return _getModal.toString();
  };

  return getModal;
})(function () {
  var $modal = document.querySelector(modalClass);

  if (!$modal) {
    sweetAlertInitialize();
    $modal = getModal();
  }

  return $modal;
});

/*
 * Get DOM element of input (in modal)
 */
var getInput = function getInput() {
  var $modal = getModal();
  if ($modal) {
    return $modal.querySelector('input');
  }
};

/*
 * Get DOM element of overlay
 */
var getOverlay = function getOverlay() {
  return document.querySelector(overlayClass);
};

/*
 * Add box-shadow style to button (depending on its chosen bg-color)
 */
var setFocusStyle = function setFocusStyle($button, bgColor) {
  var rgbColor = _hexToRgb.hexToRgb(bgColor);
  $button.style.boxShadow = '0 0 2px rgba(' + rgbColor + ', 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)';
};

/*
 * Animation when opening modal
 */
var openModal = function openModal(callback) {
  var $modal = getModal();
  _removeClass$getTopMargin$fadeIn$show$addClass.fadeIn(getOverlay(), 10);
  _removeClass$getTopMargin$fadeIn$show$addClass.show($modal);
  _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'showSweetAlert');
  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'hideSweetAlert');

  window.previousActiveElement = document.activeElement;
  var $okButton = $modal.querySelector('button.confirm');
  $okButton.focus();

  setTimeout(function () {
    _removeClass$getTopMargin$fadeIn$show$addClass.addClass($modal, 'visible');
  }, 500);

  var timer = $modal.getAttribute('data-timer');

  if (timer !== 'null' && timer !== '') {
    var timerCallback = callback;
    $modal.timeout = setTimeout(function () {
      var doneFunctionExists = (timerCallback || null) && $modal.getAttribute('data-has-done-function') === 'true';
      if (doneFunctionExists) {
        timerCallback(null);
      } else {
        sweetAlert.close();
      }
    }, timer);
  }
};

/*
 * Reset the styling of the input
 * (for example if errors have been shown)
 */
var resetInput = function resetInput() {
  var $modal = getModal();
  var $input = getInput();

  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($modal, 'show-input');
  $input.value = _defaultParams2['default'].inputValue;
  $input.setAttribute('type', _defaultParams2['default'].inputType);
  $input.setAttribute('placeholder', _defaultParams2['default'].inputPlaceholder);

  resetInputError();
};

var resetInputError = function resetInputError(event) {
  // If press enter => ignore
  if (event && event.keyCode === 13) {
    return false;
  }

  var $modal = getModal();

  var $errorIcon = $modal.querySelector('.sa-input-error');
  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorIcon, 'show');

  var $errorContainer = $modal.querySelector('.sa-error-container');
  _removeClass$getTopMargin$fadeIn$show$addClass.removeClass($errorContainer, 'show');
};

/*
 * Set "margin-top"-property on modal based on its computed height
 */
var fixVerticalPosition = function fixVerticalPosition() {
  var $modal = getModal();
  $modal.style.marginTop = _removeClass$getTopMargin$fadeIn$show$addClass.getTopMargin(getModal());
};

exports.sweetAlertInitialize = sweetAlertInitialize;
exports.getModal = getModal;
exports.getOverlay = getOverlay;
exports.getInput = getInput;
exports.setFocusStyle = setFocusStyle;
exports.openModal = openModal;
exports.resetInput = resetInput;
exports.resetInputError = resetInputError;
exports.fixVerticalPosition = fixVerticalPosition;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
/*
 * Allow user to pass their own params
 */
var extend = function extend(a, b) {
  for (var key in b) {
    if (b.hasOwnProperty(key)) {
      a[key] = b[key];
    }
  }
  return a;
};

/*
 * Convert HEX codes to RGB values (#000000 -> rgb(0,0,0))
 */
var hexToRgb = function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) : null;
};

/*
 * Check if the user is using Internet Explorer 8 (for fallbacks)
 */
var isIE8 = function isIE8() {
  return window.attachEvent && !window.addEventListener;
};

/*
 * IE compatible logging for developers
 */
var logStr = function logStr(string) {
  if (window.console) {
    // IE...
    window.console.log('SweetAlert: ' + string);
  }
};

/*
 * Set hover, active and focus-states for buttons 
 * (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
 */
var colorLuminance = function colorLuminance(hex, lum) {
  // Validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // Convert to decimal and change luminosity
  var rgb = '#';
  var c;
  var i;

  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
};

exports.extend = extend;
exports.hexToRgb = hexToRgb;
exports.isIE8 = isIE8;
exports.logStr = logStr;
exports.colorLuminance = colorLuminance;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(144)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(184);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(15);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(15);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(176);
var buildURL = __webpack_require__(179);
var parseHeaders = __webpack_require__(185);
var isURLSameOrigin = __webpack_require__(183);
var createError = __webpack_require__(18);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(178);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(181);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(175);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кече саат] LT',
            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var defaultParams = {
  title: '',
  text: '',
  type: null,
  allowOutsideClick: false,
  showConfirmButton: true,
  showCancelButton: false,
  closeOnConfirm: true,
  closeOnCancel: true,
  confirmButtonText: 'OK',
  confirmButtonColor: '#8CD4F5',
  cancelButtonText: 'Cancel',
  imageUrl: null,
  imageSize: null,
  timer: null,
  customClass: '',
  html: false,
  animation: true,
  allowEscapeKey: true,
  inputType: 'text',
  inputPlaceholder: '',
  inputValue: '',
  showLoaderOnConfirm: false
};

exports['default'] = defaultParams;
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, b) {
	 true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		return a.svg4everybody = b();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = b() : a.svg4everybody = b();
}(this, function () {
	function a(a, b, c) {
		if (c) {
			var d = document.createDocumentFragment(),
			    e = !b.hasAttribute("viewBox") && c.getAttribute("viewBox");
			e && b.setAttribute("viewBox", e);
			for (var f = c.cloneNode(!0); f.childNodes.length;) {
				d.appendChild(f.firstChild);
			}a.appendChild(d);
		}
	}

	function b(b) {
		b.onreadystatechange = function () {
			if (4 === b.readyState) {
				var c = b._cachedDocument;
				c || (c = b._cachedDocument = document.implementation.createHTMLDocument(""), c.body.innerHTML = b.responseText, b._cachedTarget = {}), b._embeds.splice(0).map(function (d) {
					var e = b._cachedTarget[d.id];
					e || (e = b._cachedTarget[d.id] = c.getElementById(d.id)), a(d.parent, d.svg, e);
				});
			}
		}, b.onreadystatechange();
	}

	function c(c) {
		function e() {
			for (var c = 0; c < o.length;) {
				var h = o[c],
				    i = h.parentNode,
				    j = d(i),
				    k = h.getAttribute("xlink:href") || h.getAttribute("href");
				if (!k && g.attributeName && (k = h.getAttribute(g.attributeName)), j && k) {
					if (f) if (!g.validate || g.validate(k, j, h)) {
						i.removeChild(h);
						var l = k.split("#"),
						    q = l.shift(),
						    r = l.join("#");
						if (q.length) {
							var s = m[q];
							s || (s = m[q] = new XMLHttpRequest(), s.open("GET", q), s.send(), s._embeds = []), s._embeds.push({
								parent: i,
								svg: j,
								id: r
							}), b(s);
						} else a(i, j, document.getElementById(r));
					} else ++c, ++p;
				} else ++c;
			}(!o.length || o.length - p > 0) && n(e, 67);
		}
		var f,
		    g = Object(c),
		    h = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/,
		    i = /\bAppleWebKit\/(\d+)\b/,
		    j = /\bEdge\/12\.(\d+)\b/,
		    k = /\bEdge\/.(\d+)\b/,
		    l = window.top !== window.self;
		f = "polyfill" in g ? g.polyfill : h.test(navigator.userAgent) || (navigator.userAgent.match(j) || [])[1] < 10547 || (navigator.userAgent.match(i) || [])[1] < 537 || k.test(navigator.userAgent) && l;
		var m = {},
		    n = window.requestAnimationFrame || setTimeout,
		    o = document.getElementsByTagName("use"),
		    p = 0;
		f && e();
	}

	function d(a) {
		for (var b = a; "svg" !== b.nodeName.toLowerCase() && (b = b.parentNode);) {}
		return b;
	}
	return c;
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mutations__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {

		settings: {
			Language: {
				texts: {
					Title: 't-language',
					ddTitle: 't-select-language'
				},
				type: 'dropdown',
				selected: 0,
				items: [{ name: 'English' }, { name: 'German' }, { name: 'French' }, { name: 'Chinese' }, { name: 'Indian' }, { name: 'Italian' }, { name: 'Spanish' }, { name: 'Portugese' }, { name: 'Dutch' }, { name: 'Russian' }]
			},
			CompressedAirFlow: {
				texts: {
					Title: 't-compressed-air-flow'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: 'l/s' }, { name: 'CFM' }, { name: 'm³/h' }, { name: 'm³/min' }]
			},
			Pressure: {
				texts: {
					Title: 't-pressure'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: 'Bar' }, { name: 'Psi' }]
			},
			Temperature: {
				texts: {
					Title: 't-temperature'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: '°C' }, { name: '°F' }]
			},
			CoolingWaterflow: {
				texts: {
					Title: 't-cooling-water-flow'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: 'l/s' }, { name: 'gpm' }]
			},
			CoolingWaterInput: {
				texts: {
					Title: 't-cooling-water-input'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: 'Flow' }, { name: 'Delta T' }]
			},
			GlycolType: {
				texts: {
					Title: 't-Glycol-type'
				},
				type: 'tab',
				selected: 0,
				items: [{ name: 'Ethylene' }, { name: 'Propylene' }]
			},
			GlycolConcentrationInCoolingWater: {
				texts: {
					Title: 't-glycol-concetration-in-cooling-water'
				},
				type: 'input',
				defaultValue: 0,
				value: 0,
				maxValue: 60,
				inputParam: null
			},
			ReferenceTemperature: {
				texts: {
					Title: 't-reference-temperature'
				},
				type: 'input',
				defaultValue: 25,
				value: 25,
				inputParam: "Temperature"
			},
			ReferencePressure: {
				texts: {
					Title: 't-reference-pressure'
				},
				type: 'input',
				defaultValue: 1,
				value: 1,
				inputParam: "Pressure"
			},
			ReferenceRelativeHumidity: {
				texts: {
					Title: 't-reference-relative-humidity'
				},
				type: 'input',
				defaultValue: 0,
				value: 0,
				maxValue: 100,
				inputParam: null
			}
		}

	},
	getters: __WEBPACK_IMPORTED_MODULE_3__getters___default.a,
	mutations: __WEBPACK_IMPORTED_MODULE_4__mutations___default.a,
	actions: __WEBPACK_IMPORTED_MODULE_2__actions___default.a
});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(212).polyfill();


/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\icons\\apple-touch-icon.png?963ca284ae4e8ba3f489";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\icons\\favicon-16x16.png?963ca284ae4e8ba3f489";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\icons\\favicon-32x32.png?963ca284ae4e8ba3f489";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\icons\\safari-pinned-tab.svg?963ca284ae4e8ba3f489";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\svg_sprite\\svg_sprite.svg?963ca284ae4e8ba3f489";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

Object.defineProperty(exports, '__esModule', {
  value: true
});
// SweetAlert
// 2014-2015 (c) - Tristan Edwards
// github.com/t4t5/sweetalert

/*
 * jQuery-like functions for manipulating the DOM
 */

var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation = __webpack_require__(6);

/*
 * Handy utilities
 */

var _extend$hexToRgb$isIE8$logStr$colorLuminance = __webpack_require__(10);

/*
 *  Handle sweetAlert's DOM elements
 */

var _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition = __webpack_require__(9);

// Handle button events and keyboard events

var _handleButton$handleConfirm$handleCancel = __webpack_require__(220);

var _handleKeyDown = __webpack_require__(221);

var _handleKeyDown2 = _interopRequireWildcard(_handleKeyDown);

// Default values

var _defaultParams = __webpack_require__(143);

var _defaultParams2 = _interopRequireWildcard(_defaultParams);

var _setParameters = __webpack_require__(223);

var _setParameters2 = _interopRequireWildcard(_setParameters);

/*
 * Remember state in cases where opening and handling a modal will fiddle with it.
 * (We also use window.previousActiveElement as a global variable)
 */
var previousWindowKeyDown;
var lastFocusedButton;

/*
 * Global sweetAlert function
 * (this is what the user calls)
 */
var sweetAlert, swal;

exports['default'] = sweetAlert = swal = function () {
  var customizations = arguments[0];

  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(document.body, 'stop-scrolling');
  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.resetInput();

  /*
   * Use argument if defined or default value from params object otherwise.
   * Supports the case where a default value is boolean true and should be
   * overridden by a corresponding explicit argument which is boolean false.
   */
  function argumentOrDefault(key) {
    var args = customizations;
    return args[key] === undefined ? _defaultParams2['default'][key] : args[key];
  }

  if (customizations === undefined) {
    _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert expects at least 1 attribute!');
    return false;
  }

  var params = _extend$hexToRgb$isIE8$logStr$colorLuminance.extend({}, _defaultParams2['default']);

  switch (typeof customizations) {

    // Ex: swal("Hello", "Just testing", "info");
    case 'string':
      params.title = customizations;
      params.text = arguments[1] || '';
      params.type = arguments[2] || '';
      break;

    // Ex: swal({ title:"Hello", text: "Just testing", type: "info" });
    case 'object':
      if (customizations.title === undefined) {
        _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Missing "title" argument!');
        return false;
      }

      params.title = customizations.title;

      for (var customName in _defaultParams2['default']) {
        params[customName] = argumentOrDefault(customName);
      }

      // Show "Confirm" instead of "OK" if cancel button is visible
      params.confirmButtonText = params.showCancelButton ? 'Confirm' : _defaultParams2['default'].confirmButtonText;
      params.confirmButtonText = argumentOrDefault('confirmButtonText');

      // Callback function when clicking on "OK"/"Cancel"
      params.doneFunction = arguments[1] || null;

      break;

    default:
      _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('Unexpected type of argument! Expected "string" or "object", got ' + typeof customizations);
      return false;

  }

  _setParameters2['default'](params);
  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.fixVerticalPosition();
  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.openModal(arguments[1]);

  // Modal interactions
  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();

  /*
   * Make sure all modal buttons respond to all events
   */
  var $buttons = modal.querySelectorAll('button');
  var buttonEvents = ['onclick', 'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onfocus'];
  var onButtonEvent = function onButtonEvent(e) {
    return _handleButton$handleConfirm$handleCancel.handleButton(e, params, modal);
  };

  for (var btnIndex = 0; btnIndex < $buttons.length; btnIndex++) {
    for (var evtIndex = 0; evtIndex < buttonEvents.length; evtIndex++) {
      var btnEvt = buttonEvents[evtIndex];
      $buttons[btnIndex][btnEvt] = onButtonEvent;
    }
  }

  // Clicking outside the modal dismisses it (if allowed by user)
  _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay().onclick = onButtonEvent;

  previousWindowKeyDown = window.onkeydown;

  var onKeyEvent = function onKeyEvent(e) {
    return _handleKeyDown2['default'](e, params, modal);
  };
  window.onkeydown = onKeyEvent;

  window.onfocus = function () {
    // When the user has focused away and focused back from the whole window.
    setTimeout(function () {
      // Put in a timeout to jump out of the event sequence.
      // Calling focus() in the event sequence confuses things.
      if (lastFocusedButton !== undefined) {
        lastFocusedButton.focus();
        lastFocusedButton = undefined;
      }
    }, 0);
  };

  // Show alert with enabled buttons always
  swal.enableButtons();
};

/*
 * Set default params for each popup
 * @param {Object} userParams
 */
sweetAlert.setDefaults = swal.setDefaults = function (userParams) {
  if (!userParams) {
    throw new Error('userParams is required');
  }
  if (typeof userParams !== 'object') {
    throw new Error('userParams has to be a object');
  }

  _extend$hexToRgb$isIE8$logStr$colorLuminance.extend(_defaultParams2['default'], userParams);
};

/*
 * Animation when closing modal
 */
sweetAlert.close = swal.close = function () {
  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();

  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(_sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getOverlay(), 5);
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.fadeOut(modal, 5);
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'showSweetAlert');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass(modal, 'hideSweetAlert');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, 'visible');

  /*
   * Reset icon animations
   */
  var $successIcon = modal.querySelector('.sa-icon.sa-success');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon, 'animate');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-tip'), 'animateSuccessTip');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($successIcon.querySelector('.sa-long'), 'animateSuccessLong');

  var $errorIcon = modal.querySelector('.sa-icon.sa-error');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'animateErrorIcon');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon.querySelector('.sa-x-mark'), 'animateXMark');

  var $warningIcon = modal.querySelector('.sa-icon.sa-warning');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon, 'pulseWarning');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-body'), 'pulseWarningIns');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($warningIcon.querySelector('.sa-dot'), 'pulseWarningIns');

  // Reset custom class (delay so that UI changes aren't visible)
  setTimeout(function () {
    var customClass = modal.getAttribute('data-custom-class');
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(modal, customClass);
  }, 300);

  // Make page scrollable again
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass(document.body, 'stop-scrolling');

  // Reset the page to its previous state
  window.onkeydown = previousWindowKeyDown;
  if (window.previousActiveElement) {
    window.previousActiveElement.focus();
  }
  lastFocusedButton = undefined;
  clearTimeout(modal.timeout);

  return true;
};

/*
 * Validation of the input field is done by user
 * If something is wrong => call showInputError with errorMessage
 */
sweetAlert.showInputError = swal.showInputError = function (errorMessage) {
  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();

  var $errorIcon = modal.querySelector('.sa-input-error');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorIcon, 'show');

  var $errorContainer = modal.querySelector('.sa-error-container');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.addClass($errorContainer, 'show');

  $errorContainer.querySelector('p').innerHTML = errorMessage;

  setTimeout(function () {
    sweetAlert.enableButtons();
  }, 1);

  modal.querySelector('input').focus();
};

/*
 * Reset input error DOM elements
 */
sweetAlert.resetInputError = swal.resetInputError = function (event) {
  // If press enter => ignore
  if (event && event.keyCode === 13) {
    return false;
  }

  var $modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();

  var $errorIcon = $modal.querySelector('.sa-input-error');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorIcon, 'show');

  var $errorContainer = $modal.querySelector('.sa-error-container');
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide$isDescendant$getTopMargin$fadeIn$fadeOut$fireClick$stopEventPropagation.removeClass($errorContainer, 'show');
};

/*
 * Disable confirm and cancel buttons
 */
sweetAlert.disableButtons = swal.disableButtons = function (event) {
  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
  var $confirmButton = modal.querySelector('button.confirm');
  var $cancelButton = modal.querySelector('button.cancel');
  $confirmButton.disabled = true;
  $cancelButton.disabled = true;
};

/*
 * Enable confirm and cancel buttons
 */
sweetAlert.enableButtons = swal.enableButtons = function (event) {
  var modal = _sweetAlertInitialize$getModal$getOverlay$getInput$setFocusStyle$openModal$resetInput$fixVerticalPosition.getModal();
  var $confirmButton = modal.querySelector('button.confirm');
  var $cancelButton = modal.querySelector('button.cancel');
  $confirmButton.disabled = false;
  $cancelButton.disabled = false;
};

if (typeof window !== 'undefined') {
  // The 'handle-click' module requires
  // that 'sweetAlert' was set as global.
  window.sweetAlert = window.swal = sweetAlert;
} else {
  _extend$hexToRgb$isIE8$logStr$colorLuminance.logStr('SweetAlert is a frontend module!');
}
module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// list here all supported plugins
	var pluginsList = ['cordova-plugin-camera', 'cordova-plugin-device', 'cordova-plugin-geolocation', 'cordova-plugin-contacts'];

	exports.install = function (Vue, options) {

	  // declare global Vue.cordova object
	  Vue.cordova = Vue.cordova || {
	    deviceready: false,
	    plugins: []
	  };

	  // Cordova events wrapper
	  Vue.cordova.on = function (eventName, cb) {
	    document.addEventListener(eventName, cb, false);
	  };

	  // let Vue know that deviceready has been triggered
	  document.addEventListener('deviceready', function () {
	    Vue.cordova.deviceready = true;
	  }, false);

	  // load supported plugins
	  pluginsList.forEach(function (pluginName) {
	    var plugin = __webpack_require__(1)("./" + pluginName);
	    plugin.install(Vue, options, function (pluginLoaded) {
	      if (pluginLoaded) {
	        Vue.cordova.plugins.push(pluginName);
	      }
	      if (Vue.config.debug) {
	        console.log('[VueCordova]', pluginName, '→', pluginLoaded ? 'loaded' : 'not loaded');
	      }
	    });
	  });
	};

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./cordova-plugin-camera": 2,
		"./cordova-plugin-camera.js": 2,
		"./cordova-plugin-contacts": 3,
		"./cordova-plugin-contacts.js": 3,
		"./cordova-plugin-device": 4,
		"./cordova-plugin-device.js": 4,
		"./cordova-plugin-geolocation": 5,
		"./cordova-plugin-geolocation.js": 5
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1;


/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';

	exports.install = function (Vue, options, cb) {
	  document.addEventListener('deviceready', function () {

	    if (typeof navigator.camera === 'undefined') {
	      return cb(false);
	    }

	    // pass through the camera object
	    Vue.cordova.camera = navigator.camera;

	    return cb(true);
	  }, false);
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';

	exports.install = function (Vue, options, cb) {
	  document.addEventListener('deviceready', function () {

	    if (typeof navigator.contacts === 'undefined') {
	      return cb(false);
	    }

	    // pass through the contacts object
	    Vue.cordova.contacts = navigator.contacts;

	    return cb(true);
	  }, false);
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';

	exports.install = function (Vue, options, cb) {
	  document.addEventListener('deviceready', function () {

	    if (typeof device === 'undefined' || typeof device.cordova === 'undefined') {
	      return cb(false);
	    }

	    // default values
	    Vue.cordova.device = {
	      cordova: null,
	      model: null,
	      platform: null,
	      uuid: null,
	      version: null,
	      manufacturer: null,
	      isVirtual: null,
	      serial: null
	    };

	    Object.keys(Vue.cordova.device).forEach(function (key) {
	      if (typeof device[key] !== 'undefined') {
	        Vue.cordova.device[key] = device[key];
	      }
	    });

	    return cb(true);
	  }, false);
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';

	exports.install = function (Vue, options, cb) {
	  document.addEventListener('deviceready', function () {

	    if (typeof navigator.geolocation === 'undefined') {
	      return cb(false);
	    }

	    // pass through the geolocation object
	    Vue.cordova.geolocation = navigator.geolocation;

	    return cb(true);
	  }, false);
	};

/***/ }
/******/ ]);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/* vuex-i18n-store defines a vuex module to store locale translations. Make sure
** to also include the file vuex-i18n.js to enable easy access to localized
** strings in your vue components.
*/

// define a simple vuex module to handle locale translations
var i18nVuexModule = {
	namespaced: true,
	state: {
		locale: null,
		fallback: null,
		translations: {}
	},
	mutations: {

		// set the current locale
		SET_LOCALE: function SET_LOCALE(state, payload) {
			state.locale = payload.locale;
		},


		// add a new locale
		ADD_LOCALE: function ADD_LOCALE(state, payload) {

			// reduce the given translations to a single-depth tree
			var translations = flattenTranslations(payload.translations);

			if (state.translations.hasOwnProperty(payload.locale)) {
				// get the existing translations
				var existingTranslations = state.translations[payload.locale];
				// merge the translations
				state.translations[payload.locale] = Object.assign({}, existingTranslations, translations);
			} else {
				// just set the locale if it does not yet exist
				state.translations[payload.locale] = translations;
			}

			// make sure to notify vue of changes (this might break with new vue versions)
			try {
				if (state.translations.__ob__) {
					state.translations.__ob__.dep.notify();
				}
			} catch (ex) {}
		},


		// replace existing locale information with new translations
		REPLACE_LOCALE: function REPLACE_LOCALE(state, payload) {

			// reduce the given translations to a single-depth tree
			var translations = flattenTranslations(payload.translations);

			// replace the translations entirely
			state.translations[payload.locale] = translations;

			// make sure to notify vue of changes (this might break with new vue versions)
			try {
				if (state.translations.__ob__) {
					state.translations.__ob__.dep.notify();
				}
			} catch (ex) {}
		},


		// remove a locale from the store
		REMOVE_LOCALE: function REMOVE_LOCALE(state, payload) {

			// check if the given locale is present in the state
			if (state.translations.hasOwnProperty(payload.locale)) {

				// check if the current locale is the given locale to remvoe
				if (state.locale === payload.locale) {
					// reset the current locale
					state.locale = null;
				}

				// create a copy of the translations object
				var translationCopy = Object.assign({}, state.translations);

				// remove the given locale
				delete translationCopy[payload.locale];

				// set the state to the new object
				state.translations = translationCopy;
			}
		},
		SET_FALLBACK_LOCALE: function SET_FALLBACK_LOCALE(state, payload) {
			state.fallback = payload.locale;
		}
	},
	actions: {

		// set the current locale
		setLocale: function setLocale(context, payload) {
			context.commit({
				type: 'SET_LOCALE',
				locale: payload.locale
			});
		},


		// add or extend a locale with translations
		addLocale: function addLocale(context, payload) {
			context.commit({
				type: 'ADD_LOCALE',
				locale: payload.locale,
				translations: payload.translations
			});
		},


		// replace locale information
		replaceLocale: function replaceLocale(context, payload) {
			context.commit({
				type: 'REPLACE_LOCALE',
				locale: payload.locale,
				translations: payload.translations
			});
		},


		// remove the given locale translations
		removeLocale: function removeLocale(context, payload) {
			context.commit({
				type: 'REMOVE_LOCALE',
				locale: payload.locale,
				translations: payload.translations
			});
		},
		setFallbackLocale: function setFallbackLocale(context, payload) {
			context.commit({
				type: 'SET_FALLBACK_LOCALE',
				locale: payload.locale
			});
		}
	}
};

// flattenTranslations will convert object trees for translations into a
// single-depth object tree
var flattenTranslations = function flattenTranslations(translations) {

	var toReturn = {};

	for (var i in translations) {

		// check if the property is present
		if (!translations.hasOwnProperty(i)) {
			continue;
		}

		// get the type of the property
		var objType = _typeof(translations[i]);

		// allow unflattened array of strings
		if (isArray(translations[i])) {

			var count = translations[i].length;

			for (var index = 0; index < count; index++) {
				var itemType = _typeof(translations[i][index]);

				if (itemType !== 'string') {
					console.warn('i18n:', 'currently only arrays of strings are fully supported', translations[i]);
					break;
				}
			}

			toReturn[i] = translations[i];
		} else if (objType == 'object' && objType !== null) {

			var flatObject = flattenTranslations(translations[i]);

			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				toReturn[i + '.' + x] = flatObject[x];
			}
		} else {
			toReturn[i] = translations[i];
		}
	}
	return toReturn;
};

// check if the given object is an array
function isArray(obj) {
	return !!obj && Array === obj.constructor;
}

var plurals = {
	getTranslationIndex: function getTranslationIndex(languageCode, n) {
		switch (languageCode) {
			case 'ay': // Aymará
			case 'bo': // Tibetan
			case 'cgg': // Chiga
			case 'dz': // Dzongkha
			case 'fa': // Persian
			case 'id': // Indonesian
			case 'ja': // Japanese
			case 'jbo': // Lojban
			case 'ka': // Georgian
			case 'kk': // Kazakh
			case 'km': // Khmer
			case 'ko': // Korean
			case 'ky': // Kyrgyz
			case 'lo': // Lao
			case 'ms': // Malay
			case 'my': // Burmese
			case 'sah': // Yakut
			case 'su': // Sundanese
			case 'th': // Thai
			case 'tt': // Tatar
			case 'ug': // Uyghur
			case 'vi': // Vietnamese
			case 'wo': // Wolof
			case 'zh':
				// Chinese
				// 1 form
				return 0;
			case 'is':
				// Icelandic
				// 2 forms
				return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
			case 'jv':
				// Javanese
				// 2 forms
				return n !== 0 ? 1 : 0;
			case 'mk':
				// Macedonian
				// 2 forms
				return n === 1 || n % 10 === 1 ? 0 : 1;
			case 'ach': // Acholi
			case 'ak': // Akan
			case 'am': // Amharic
			case 'arn': // Mapudungun
			case 'br': // Breton
			case 'fil': // Filipino
			case 'fr': // French
			case 'gun': // Gun
			case 'ln': // Lingala
			case 'mfe': // Mauritian Creole
			case 'mg': // Malagasy
			case 'mi': // Maori
			case 'oc': // Occitan
			case 'pt_BR': // Brazilian Portuguese
			case 'tg': // Tajik
			case 'ti': // Tigrinya
			case 'tr': // Turkish
			case 'uz': // Uzbek
			case 'wa': // Walloon
			/* eslint-disable */
			/* Disable "Duplicate case label" because there are 2 forms of Chinese plurals */
			case 'zh':
				// Chinese
				/* eslint-enable */
				// 2 forms
				return n > 1 ? 1 : 0;
			case 'lv':
				// Latvian
				// 3 forms
				return n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2;
			case 'lt':
				// Lithuanian
				// 3 forms
				return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
			case 'be': // Belarusian
			case 'bs': // Bosnian
			case 'hr': // Croatian
			case 'ru': // Russian
			case 'sr': // Serbian
			case 'uk':
				// Ukrainian
				// 3 forms
				return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
			case 'mnk':
				// Mandinka
				// 3 forms
				return n === 0 ? 0 : n === 1 ? 1 : 2;
			case 'ro':
				// Romanian
				// 3 forms
				return n === 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2;
			case 'pl':
				// Polish
				// 3 forms
				return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
			case 'cs': // Czech
			case 'sk':
				// Slovak
				// 3 forms
				return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
			case 'csb':
				// Kashubian
				// 3 forms
				return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
			case 'sl':
				// Slovenian
				// 4 forms
				return n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3;
			case 'mt':
				// Maltese
				// 4 forms
				return n === 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;
			case 'gd':
				// Scottish Gaelic
				// 4 forms
				return n === 1 || n === 11 ? 0 : n === 2 || n === 12 ? 1 : n > 2 && n < 20 ? 2 : 3;
			case 'cy':
				// Welsh
				// 4 forms
				return n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3;
			case 'kw':
				// Cornish
				// 4 forms
				return n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3;
			case 'ga':
				// Irish
				// 5 forms
				return n === 1 ? 0 : n === 2 ? 1 : n > 2 && n < 7 ? 2 : n > 6 && n < 11 ? 3 : 4;
			case 'ar':
				// Arabic
				// 6 forms
				return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
			default:
				// Everything else
				return n !== 1 ? 1 : 0;
		}
	}
};

/* vuex-i18n defines the Vuexi18nPlugin to enable localization using a vuex
** module to store the translation information. Make sure to also include the
** file vuex-i18n-store.js to include a respective vuex module.
*/

// initialize the plugin object
var VuexI18nPlugin = {};

// internationalization plugin for vue js using vuex
VuexI18nPlugin.install = function install(Vue, store, config) {

	// TODO: remove this block for next major update (API break)
	if (typeof arguments[2] === 'string' || typeof arguments[3] === 'string') {
		console.warn('i18n: Registering the plugin vuex-i18n with a string for `moduleName` or `identifiers` is deprecated. Use a configuration object instead.', 'https://github.com/dkfbasel/vuex-i18n#setup');
		config = {
			moduleName: arguments[2],
			identifiers: arguments[3]
		};
	}

	// merge default options with user supplied options
	var mergedConfig = Object.assign({
		moduleName: 'i18n',
		identifiers: ['{', '}'],
		preserveState: false,
		onTranslationNotFound: function onTranslationNotFound() {}
	}, config);

	// define module name and identifiers as constants to prevent any changes
	var moduleName = mergedConfig.moduleName;
	var identifiers = mergedConfig.identifiers;

	// initialize the onTranslationNotFound function and make sure it is actually
	// a function
	var onTranslationNotFound = mergedConfig.onTranslationNotFound;
	if (typeof onTranslationNotFound !== 'function') {
		console.error('i18n: i18n config option onTranslationNotFound must be a function');
		onTranslationNotFound = function onTranslationNotFound() {};
	}

	// register the i18n module in the vuex store
	// preserveState can be used via configuration if server side rendering is used
	store.registerModule(moduleName, i18nVuexModule, { preserveState: mergedConfig.preserveState });

	// check if the plugin was correctly initialized
	if (store.state.hasOwnProperty(moduleName) === false) {
		console.error('i18n: i18n vuex module is not correctly initialized. Please check the module name:', moduleName);

		// always return the key if module is not initialized correctly
		Vue.prototype.$i18n = function (key) {
			return key;
		};

		Vue.prototype.$getLanguage = function () {
			return null;
		};

		Vue.prototype.$setLanguage = function () {
			console.error('i18n: i18n vuex module is not correctly initialized');
		};

		return;
	}

	// initialize the replacement function
	var render = renderFn(identifiers);

	// get localized string from store. note that we pass the arguments passed
	// to the function directly to the translateInLanguage function
	var translate = function $t() {

		// get the current language from the store
		var locale = store.state[moduleName].locale;

		return translateInLanguage.apply(undefined, [locale].concat(Array.prototype.slice.call(arguments)));
	};

	// get localized string from store in a given language if available.
	// there are two possible signatures for the function.
	// we will check the arguments to make up the options passed.
	// 1: locale, key, options, pluralization
	// 2: locale, key, defaultValue, options, pluralization
	var translateInLanguage = function translateInLanguage(locale) {

		// read the function arguments
		var args = arguments;

		// initialize options
		var key = '';
		var defaultValue = '';
		var options = {};
		var pluralization = null;

		var count = args.length;

		// check if a default value was specified and fill options accordingly
		if (count >= 3 && typeof args[2] === 'string') {

			key = args[1];
			defaultValue = args[2];

			if (count > 3) {
				options = args[3];
			}

			if (count > 4) {
				pluralization = args[4];
			}
		} else {

			key = args[1];

			// default value was not specified and is therefore the same as the key
			defaultValue = key;

			if (count > 2) {
				options = args[2];
			}

			if (count > 3) {
				pluralization = args[3];
			}
		}

		// return the default value if the locale is not set (could happen on initialization)
		if (!locale) {
			console.warn('i18n: i18n locale is not set when trying to access translations:', key);
			return defaultValue;
		}

		// get the translations from the store
		var translations = store.state[moduleName].translations;

		// get the last resort fallback from the store
		var fallback = store.state[moduleName].fallback;

		// split locale by - to support partial fallback for regional locales
		// like de-CH, en-UK
		var localeRegional = locale.split('-');

		// flag for translation to exist or not
		var translationExists = true;

		// check if the language exists in the store. return the key if not
		if (translations.hasOwnProperty(locale) === false) {
			translationExists = false;

			// check if the key exists in the store. return the key if not
		} else if (translations[locale].hasOwnProperty(key) === false) {
			translationExists = false;
		}

		// return the value from the store
		if (translationExists === true) {
			return render(locale, translations[locale][key], options, pluralization);
		}

		// check if a regional locale translation would be available for the key
		// i.e. de for de-CH
		if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) === true && translations[localeRegional[0]].hasOwnProperty(key) === true) {
			return render(localeRegional[0], translations[localeRegional[0]][key], options, pluralization);
		}

		// invoke a method if a translation is not found
		var asyncTranslation = onTranslationNotFound(locale, key, defaultValue);

		// resolve async translations by updating the store
		if (asyncTranslation) {
			Promise.resolve(asyncTranslation).then(function (value) {
				var additionalTranslations = {};
				additionalTranslations[key] = value;
				addLocale(locale, additionalTranslations);
			});
		}

		// check if a vaild fallback exists in the store.
		// return the default value if not
		if (translations.hasOwnProperty(fallback) === false) {
			return render(locale, defaultValue, options, pluralization);
		}

		// check if the key exists in the fallback locale in the store.
		// return the default value if not
		if (translations[fallback].hasOwnProperty(key) === false) {
			return render(fallback, defaultValue, options, pluralization);
		}

		return render(locale, translations[fallback][key], options, pluralization);
	};

	// check if the given key exists in the current locale
	var checkKeyExists = function checkKeyExists(key) {
		var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fallback';


		// get the current language from the store
		var locale = store.state[moduleName].locale;
		var fallback = store.state[moduleName].fallback;
		var translations = store.state[moduleName].translations;

		// check the current translation
		if (translations.hasOwnProperty(locale) && translations[locale].hasOwnProperty(key)) {
			return true;
		}

		if (scope == 'strict') {
			return false;
		}

		// check any localized translations
		var localeRegional = locale.split('-');

		if (localeRegional.length > 1 && translations.hasOwnProperty(localeRegional[0]) && translations[localeRegional[0]].hasOwnProperty(key)) {
			return true;
		}

		if (scope == 'locale') {
			return false;
		}

		// check if a fallback locale exists
		if (translations.hasOwnProperty(fallback) && translations[fallback].hasOwnProperty(key)) {
			return true;
		}

		// key does not exist in the store
		return false;
	};

	// set fallback locale
	var setFallbackLocale = function setFallbackLocale(locale) {
		store.dispatch({
			type: moduleName + '/setFallbackLocale',
			locale: locale
		});
	};

	// set the current locale
	var setLocale = function setLocale(locale) {
		store.dispatch({
			type: moduleName + '/setLocale',
			locale: locale
		});
	};

	// get the current locale
	var getLocale = function getLocale() {
		return store.state[moduleName].locale;
	};

	// get all available locales
	var getLocales = function getLocales() {
		return Object.keys(store.state[moduleName].translations);
	};

	// add predefined translations to the store (keeping existing information)
	var addLocale = function addLocale(locale, translations) {
		return store.dispatch({
			type: moduleName + '/addLocale',
			locale: locale,
			translations: translations
		});
	};

	// replace all locale information in the store
	var replaceLocale = function replaceLocale(locale, translations) {
		return store.dispatch({
			type: moduleName + '/replaceLocale',
			locale: locale,
			translations: translations
		});
	};

	// remove the givne locale from the store
	var removeLocale = function removeLocale(locale) {
		if (store.state[moduleName].translations.hasOwnProperty(locale)) {
			store.dispatch({
				type: moduleName + '/removeLocale',
				locale: locale
			});
		}
	};

	// we are phasing out the exists function
	var phaseOutExistsFn = function phaseOutExistsFn(locale) {
		console.warn('i18n: $i18n.exists is depreceated. Please use $i18n.localeExists instead. It provides exatly the same functionality.');
		return checkLocaleExists(locale);
	};

	// check if the given locale is already loaded
	var checkLocaleExists = function checkLocaleExists(locale) {
		return store.state[moduleName].translations.hasOwnProperty(locale);
	};

	// register vue prototype methods
	Vue.prototype.$i18n = {
		locale: getLocale,
		locales: getLocales,
		set: setLocale,
		add: addLocale,
		replace: replaceLocale,
		remove: removeLocale,
		fallback: setFallbackLocale,
		localeExists: checkLocaleExists,
		keyExists: checkKeyExists,

		translate: translate,
		translateIn: translateInLanguage,

		exists: phaseOutExistsFn
	};

	// register global methods
	Vue.i18n = {
		locale: getLocale,
		locales: getLocales,
		set: setLocale,
		add: addLocale,
		replace: replaceLocale,
		remove: removeLocale,
		fallback: setFallbackLocale,
		translate: translate,
		translateIn: translateInLanguage,
		localeExists: checkLocaleExists,
		keyExists: checkKeyExists,

		exists: phaseOutExistsFn
	};

	// register the translation function on the vue instance directly
	Vue.prototype.$t = translate;

	// register the specific language translation function on the vue instance directly
	Vue.prototype.$tlang = translateInLanguage;

	// register a filter function for translations
	Vue.filter('translate', translate);
};

// renderFn will initialize a function to render the variable substitutions in
// the translation string. identifiers specify the tags will be used to find
// variable substitutions, i.e. {test} or {{test}}, note that we are using a
// closure to avoid recompilation of the regular expression to match tags on
// every render cycle.
var renderFn = function renderFn(identifiers) {

	if (identifiers == null || identifiers.length != 2) {
		console.warn('i18n: You must specify the start and end character identifying variable substitutions');
	}

	// construct a regular expression ot find variable substitutions, i.e. {test}
	var matcher = new RegExp('' + identifiers[0] + '\\w+' + identifiers[1], 'g');

	// define the replacement function
	var replace = function replace(translation, replacements) {
		var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


		// check if the object has a replace property
		if (!translation.replace) {
			return translation;
		}

		return translation.replace(matcher, function (placeholder) {

			// remove the identifiers (can be set on the module level)
			var key = placeholder.replace(identifiers[0], '').replace(identifiers[1], '');

			if (replacements[key] !== undefined) {
				return replacements[key];
			}

			// warn user that the placeholder has not been found
			if (warn === true) {
				console.group ? console.group('i18n: Not all placeholders found') : console.warn('i18n: Not all placeholders found');
				console.warn('Text:', translation);
				console.warn('Placeholder:', placeholder);
				if (console.groupEnd) {
					console.groupEnd();
				}
			}

			// return the original placeholder
			return placeholder;
		});
	};

	// the render function will replace variable substitutions and prepare the
	// translations for rendering
	var render = function render(locale, translation) {
		var replacements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var pluralization = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		// get the type of the property
		var objType = typeof translation === 'undefined' ? 'undefined' : _typeof(translation);
		var pluralizationType = typeof pluralization === 'undefined' ? 'undefined' : _typeof(pluralization);

		var resolvePlaceholders = function resolvePlaceholders() {

			if (isArray$1(translation)) {

				// replace the placeholder elements in all sub-items
				return translation.map(function (item) {
					return replace(item, replacements, false);
				});
			} else if (objType === 'string') {
				return replace(translation, replacements, true);
			}
		};

		// return translation item directly
		if (pluralization === null) {
			return resolvePlaceholders();
		}

		// check if pluralization value is countable
		if (pluralizationType !== 'number') {
			console.warn('i18n: pluralization is not a number');
			return resolvePlaceholders();
		}

		// --- handle pluralizations ---

		// replace all placeholders
		var resolvedTranslation = resolvePlaceholders();

		// initialize pluralizations
		var pluralizations = null;

		// if translations are already an array and have more than one entry,
		// we will not perform a split operation on :::
		if (isArray$1(resolvedTranslation) && resolvedTranslation.length > 0) {
			pluralizations = resolvedTranslation;
		} else {
			// split translation strings by ::: to find create the pluralization array
			pluralizations = resolvedTranslation.split(':::');
		}

		// determine the pluralization version to use by locale
		var index = plurals.getTranslationIndex(locale, pluralization);

		// check if the specified index is present in the pluralization
		if (typeof pluralizations[index] === 'undefined') {
			console.warn('i18n: pluralization not provided in locale', translation, locale, index);

			// return the first element of the pluralization by default
			return pluralizations[0].trim();
		}

		// return the requested item from the pluralizations
		return pluralizations[index].trim();
	};

	// return the render function to the caller
	return render;
};

// check if the given object is an array
function isArray$1(obj) {
	return !!obj && Array === obj.constructor;
}

// import the vuex module for localization
// import the corresponding plugin for vue
// export both modules as one file
var index = {
	store: i18nVuexModule,
	plugin: VuexI18nPlugin
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"设置","t-language":"语言","t-select-language":"选择语言","t-compressed-air-flow":"压缩空气流量","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"压力","Bar":"Bar","Psi":"psi","t-temperature":"温度","°C":"°C","°F":"°F","t-cooling-water-flow":"冷却水量","gpm":"gpm","t-cooling-water-input":"冷却水输入","Flow":"流量","Delta T":"温差","t-Glycol-type":"Glycol 类型","Ethylene":"乙烯","Propylene":"丙烯","t-glycol-concetration-in-cooling-water":"冷却水中的乙二醇浓度","t-reference-conditions":"参考条件","t-reference-temperature":"参考温度","t-reference-pressure":"参考压力","t-inlet-compressed-air":"进口压缩空气","t-outlet-compressed-air":"出口压缩空气","t-reference-relative-humidity":"参考相对湿度","t-hd-coolers-calculation-tool":"HD 冷却器计算工具","t-cooling-water-output":"冷却水输出","ERRCODE_CALCULATION_FAILED ":"计算失败。","ERRCODE_CALCULATION_CONVERGE ":"冷却剂流量计算未汇集。该模型无法为规定冷却剂流量的情况找到合适的 DeltaT 值。","t-reference-conditions-explanation":"参考条件说明","t-reference-conditions-explanation-text":"如需计算 HD 冷却器性能数据，该程序将所提供的容积流速（压缩空气流量）转换至质量流速。如需精确计算质量流速，容积流速应考虑特定参考条件。","t-unit":"单元","t-Relativehumidity":"相对湿度"}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Instellingen","t-language":"Taal","t-select-language":"Taal selecteren","t-compressed-air-flow":"Persluchtdebiet","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Druk","Bar":"Bar","Psi":"psi","t-temperature":"Temperatuur","°C":"°C","°F":"°F","t-cooling-water-flow":"Koelwaterstroming","gpm":"gpm","t-cooling-water-input":"Koelwaterinvoer","Flow":"Luchtstroom","Delta T":"Delta T","t-Glycol-type":"Glycoltype","Ethylene":"Ethyleen","Propylene":"Propyleen","t-glycol-concetration-in-cooling-water":"Glycolconcentratie in koelwater","t-reference-conditions":"Referentieomstandigheden","t-reference-temperature":"Referentietemperatuur","t-reference-pressure":"Referentiedruk","t-inlet-compressed-air":"Persluchtinlaat","t-outlet-compressed-air":"Persluchtuitlaat","t-reference-relative-humidity":"Referentiewaarde relatieve vochtigheid","t-hd-coolers-calculation-tool":"Rekenhulp HD-koelers","t-cooling-water-output":"Koelwateruitvoer","ERRCODE_CALCULATION_FAILED ":"De berekening is mislukt.","ERRCODE_CALCULATION_CONVERGE ":"De berekening van de koelmiddelstroming convergeert niet. Het model kon geen geschikte waarde vinden voor DeltaT waarbij de koelmiddelstroming volgens specificatie is.","t-reference-conditions-explanation":"Uitleg referentieomstandigheden","t-reference-conditions-explanation-text":"Voor de berekening van de prestaties van de HD-koelers converteert het programma het gegeven volumedebiet (persluchtdebiet) naar een massadebiet. Voor een juiste berekening van het massadebiet moet rekening worden gehouden met specifieke referentieomstandigheden voor het volumedebiet.","t-unit":"Eenheid","t-Relativehumidity":"Relatieve vochtigheid"}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Settings","t-language":"Language","t-select-language":"Select language","t-compressed-air-flow":"Compressed Air Flow","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Pressure","Bar":"Bar","Psi":"psi","t-temperature":"Temperature","°C":"°C","°F":"°F","t-cooling-water-flow":"Cooling Water Flow","gpm":"gpm","t-cooling-water-input":"Cooling Water Input","Flow":"Flow","Delta T":"Delta T","t-Glycol-type":"Glycol Type","Ethylene":"Ethylene","Propylene":"Propylene","t-glycol-concetration-in-cooling-water":"Glycol concentration in cooling water","t-reference-conditions":"Reference conditions","t-reference-temperature":"Reference temperature","t-reference-pressure":"Reference pressure","t-inlet-compressed-air":"Inlet compressed air","t-outlet-compressed-air":"Outlet compressed air","t-reference-relative-humidity":"Reference relative humidity","t-hd-coolers-calculation-tool":"HD Coolers Calculation Tool","t-cooling-water-output":"Cooling Water Output","ERRCODE_CALCULATION_FAILED ":"The calculation failed.","ERRCODE_CALCULATION_CONVERGE ":"The calculation on coolant flow did not converge. The model could not find an appropriate DeltaT value for which the coolant flow is as specified. ","t-reference-conditions-explanation":"Reference conditions explanation","t-reference-conditions-explanation-text":"For calculation of the HD coolers performance, the program converts provided volumetric flow rate (compressed air flow) to a mass flow rate. For a proper calculation of the mass flow rate the volumetric flow rate should be referred to specific Reference conditions.","t-unit":"Unit","t-Relativehumidity":"Relative humidity"}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Paramètres","t-language":"Langue","t-select-language":"Sélectionner la langue","t-compressed-air-flow":"Débit d'air comprimé","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Pression","Bar":"Bar","Psi":"psi","t-temperature":"Température","°C":"°C","°F":"°F","t-cooling-water-flow":"Débit d'eau de refroidissement","gpm":"gpm","t-cooling-water-input":"Entrée d'eau de refroidissement","Flow":"Débit","Delta T":"Delta T","t-Glycol-type":"Type Glycol","Ethylene":"Éthylène","Propylene":"Propylène","t-glycol-concetration-in-cooling-water":"Concentration de glycol dans l'eau de refroidissement","t-reference-conditions":"Conditions de référence","t-reference-temperature":"Température de référence","t-reference-pressure":"Pression de référence","t-inlet-compressed-air":"Entrée d'air comprimé","t-outlet-compressed-air":"Sortie d'air comprimé","t-reference-relative-humidity":"Humidité relative de référence","t-hd-coolers-calculation-tool":"Calculateur pour refroidisseurs HD","t-cooling-water-output":"Sortie d'eau de refroidissement","ERRCODE_CALCULATION_FAILED ":"Échec du calcul.","ERRCODE_CALCULATION_CONVERGE ":"Le calcul du débit de fluide de refroidissement n'a rien donné. Le modèle n'a pu trouver aucune valeur DeltaT appropriée pour le débit de fluide de refroidissement spécifié.","t-reference-conditions-explanation":"Explication des conditions de référence","t-reference-conditions-explanation-text":"Pour calculer les performances des refroidisseurs HD, le programme convertit le débit volumétrique fourni (débit d'air comprimé) en un débit massique. Afin de calculer correctement le débit massique, le débit volumétrique doit être celui indiqué dans les conditions de référence spécifiques.","t-unit":"Unité","t-Relativehumidity":"Humidité relative"}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Einstellungen","t-language":"Sprache","t-select-language":"Sprache wählen","t-compressed-air-flow":"Druckluftstrom","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Druck","Bar":"Bar","Psi":"psi","t-temperature":"Temperatur","°C":"°C","°F":"°F","t-cooling-water-flow":"Kühlwasserstrom","gpm":"US-Gall./min","t-cooling-water-input":"Kühlwasser-Input","Flow":"Volumenstrom","Delta T":"Delta T","t-Glycol-type":"Glykol-Typ","Ethylene":"Äthylen","Propylene":"Propylen","t-glycol-concetration-in-cooling-water":"Glykolkonzentration im Kühlwasser","t-reference-conditions":"Referenzbedingungen","t-reference-temperature":"Referenztemperatur","t-reference-pressure":"Referenzdruck","t-inlet-compressed-air":"Einlassdruckluft","t-outlet-compressed-air":"Auslassdruckluft","t-reference-relative-humidity":"Bezugswert relative Luftfeuchtigkeit","t-hd-coolers-calculation-tool":"HD-Kühler-Rechner","t-cooling-water-output":"Kühlwasser-Output","ERRCODE_CALCULATION_FAILED ":"Die Berechnung ist fehlgeschlagen.","ERRCODE_CALCULATION_CONVERGE ":"Die Berechnung des Kühlmittelflusses ist nicht konvergiert. Das Modell konnte keinen geeigneten DeltaT-Wert finden, für den der Kühlmittelstrom dem angegeben entspricht.","t-reference-conditions-explanation":"Erklärung Referenzbedingungen","t-reference-conditions-explanation-text":"Für die Berechnung der Leistung des HD-Kühlers rechnet das Programm die bereitgestellte volumetrische Strömungsmenge (Druckluftstrom) in eine Massenströmungsmenge um. Für eine korrekte Berechnung der Massenströmungsmenge sollte die volumetrische Strömungsmenge unter bestimmten Bezugsbedingungen angegeben werden.","t-unit":"Einheit","t-Relativehumidity":"Relative Luftfeuchtigkeit"}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"ਸੈਟਿੰਗ","t-language":"ਭਾਸ਼ਾ","t-select-language":"ਭਾਸ਼ਾ ਚੁਣੋ","t-compressed-air-flow":"ਕੰਪਰੈੱਸਡ ਹਵਾ ਦਾ ਪ੍ਰਵਾਹ","l/s":"l/s","cfm³/h":"Cfm³/ਘੰ","m³/h":"M³/ਘੰ","m³/min":"M³/ਮਿੰਟ","t-pressure":"ਦਬਾਅ","Bar":"ਬਾਰ","Psi":"psi","t-temperature":"ਤਾਪਮਾਨ","°C":"°C","°F":"°F","t-cooling-water-flow":"ਠੰਡਾ ਕਰਨ ਵਾਲੇ ਪਾਣੀ ਦਾ ਪ੍ਰਵਾਹ","gpm":"gpm","t-cooling-water-input":"ਠੰਡਾ ਕਰਨ ਵਾਲੇ ਪਾਣੀ ਇਨਪੁਟ","Flow":"ਪ੍ਰਵਾਹ","Delta T":"ਡੈੱਲਟਾ ਟੀ","t-Glycol-type":"ਕਲਾਈਕੋਲ ਟਾਈਪ","Ethylene":"ਇਥੀਲੀਨ","Propylene":"ਪ੍ਰੌਪੀਲੇਨ","t-glycol-concetration-in-cooling-water":"ਠੰਡਾ ਕਰਨ ਵਾਲੇ ਪਾਣੀ ਵਿੱਚ ਗਲਾਈਕੋਲ ਦਾ ਇਕੱਤਰੀਕਰਨ","t-reference-conditions":"ਸੰਦਰਭ ਸਥਿਤੀਆਂ","t-reference-temperature":"ਸੰਦਰਭ ਤਾਪਮਾਨ","t-reference-pressure":"ਸੰਦਰਭ ਦਬਾਅ","t-inlet-compressed-air":"ਇਨਲੇਟ ਕੰਪਰੈੱਸਡ ਹਵਾ","t-outlet-compressed-air":"ਆਉਟਲੇਟ ਕੰਪਰੈੱਸਡ ਹਵਾ","t-reference-relative-humidity":"ਸੰਦਰਭ ਸਾਪੇਖ ਨਮੀ","t-hd-coolers-calculation-tool":"HD ਕੂਲਰਾਂ ਦਾ ਗਣਨਾ ਟੂਲ","t-cooling-water-output":"ਠੰਡਾ ਕਰਨ ਵਾਲੇ ਪਾਣੀ ਦਾ ਆਉਟਪੁਟ","ERRCODE_CALCULATION_FAILED ":"ਗਣਨਾ ਅਸਫਲ।","ERRCODE_CALCULATION_CONVERGE ":"ਕੂਲੈਂਟ ਪ੍ਰਵਾਹ 'ਤੇ ਗਣਨਾ ਕੇਂਦਰਿਤ ਨਹੀਂ ਹੋਈ। ਮਾਡਲ ਨੂੰ ਇੱਕ ਅਜਿਹਾ ਉਪਯੁਕਤ DeltaT ਮਾਨ ਨਹੀਂ ਮਿਲਿਆ ਜਿਸਦੇ ਲਈ ਕੂਲੈਂਟ ਪ੍ਰਵਾਹ ਉਸੇ ਰੂਪ ਵਿੱਚ ਨਿਸ਼ਚਿਤ ਕੀਤਾ ਗਿਆ ਹੈ।","t-reference-conditions-explanation":"ਸੰਦਰਭ ਸਥਿਤੀਆਂ ਸਪਸ਼ਟੀਕਰਨ","t-reference-conditions-explanation-text":"HD ਕੂਲਰਾਂ ਦੇ ਪ੍ਰਦਰਸ਼ਨ ਦੀ ਗਣਨਾ ਕਰਨ ਲਈ, ਪ੍ਰੋਗਰਾਮ ਪ੍ਰਦਾਨ ਕੀਤੀ ਮਾਤਰਾ ਪ੍ਰਵਾਹ ਦਰ (ਕੰਪਰੈੱਸਡ ਹਵਾ ਦਾ ਪ੍ਰਵਾਹ) ਨੂੰ ਵਿਆਪਕ ਪ੍ਰਵਾਹ ਦਰ ਵਿੱਚ ਬਦਲਦਾ ਹੈ। ਵਿਆਪਕ ਪ੍ਰਵਾਹ ਦਰ ਦੀ ਸਹੀ ਗਣਨਾ ਕਰਨ ਲਈ, ਮਾਤਰਾ ਪ੍ਰਵਾਹ ਦਰ ਨੂੰ ਖਾਸ ਸੰਦਰਭ ਸਥਿਤੀਆਂ ਦਾ ਹਵਾਲਾ ਲੈਣਾ ਚਾਹੀਦਾ ਹੈ।","t-unit":"ਇਕਾਈ","t-Relativehumidity":"ਸਾਪੇਖ ਨਮੀ"}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Impostazioni","t-language":"Lingua","t-select-language":"Seleziona lingua","t-compressed-air-flow":"Flusso d'aria compressa","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Pressione","Bar":"Bar","Psi":"psi","t-temperature":"Temperatura","°C":"°C","°F":"°F","t-cooling-water-flow":"Flusso d'acqua di raffreddamento","gpm":"gpm","t-cooling-water-input":"Ingresso dell'acqua di raffreddamento","Flow":"Portata","Delta T":"Delta T","t-Glycol-type":"Tipo di glicole","Ethylene":"Etilene","Propylene":"Propilene","t-glycol-concetration-in-cooling-water":"Concentrazione di glicole nell'acqua di raffreddamento","t-reference-conditions":"Condizioni di riferimento","t-reference-temperature":"Temperatura di riferimento","t-reference-pressure":"Pressione di riferimento","t-inlet-compressed-air":"Aria compressa in ingresso","t-outlet-compressed-air":"Aria compressa in uscita","t-reference-relative-humidity":"Umidità relativa di riferimento","t-hd-coolers-calculation-tool":"Strumento di calcolo dei refrigeratori HD","t-cooling-water-output":"Uscita dell'acqua di raffreddamento","ERRCODE_CALCULATION_FAILED ":"Calcolo non riuscito.","ERRCODE_CALCULATION_CONVERGE ":"Il calcolo del flusso del refrigerante non corrisponde. Il modello non è stato in grado di individuare un valore Delta T appropriato per il quale il flusso del refrigerante corrisponde a quello specificato.","t-reference-conditions-explanation":"Spiegazione delle condizioni di riferimento","t-reference-conditions-explanation-text":"Per calcolare le prestazioni dei refrigeratori HD, il programma converte la portata volumetrica (flusso d'aria compressa) in portata della massa. Per un calcolo accurato della portata della massa, la portata volumetrica deve essere riferita a condizioni di riferimento specifiche.","t-unit":"Unità","t-Relativehumidity":"Umidità relativa"}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Configurações","t-language":"Idioma","t-select-language":"Selecionar idioma","t-compressed-air-flow":"Fluxo de ar comprimido","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Pressão","Bar":"Bar","Psi":"psi","t-temperature":"Temperatura","°C":"°C","°F":"°F","t-cooling-water-flow":"Fluxo de água de resfriamento","gpm":"gpm","t-cooling-water-input":"Entrada de água de resfriamento","Flow":"Fluxo","Delta T":"Delta T","t-Glycol-type":"Tipo de glicol","Ethylene":"Etileno","Propylene":"Propileno","t-glycol-concetration-in-cooling-water":"Concentração de glicol em água de resfriamento","t-reference-conditions":"Condições de referência","t-reference-temperature":"Temperatura de referência","t-reference-pressure":"Pressão de referência","t-inlet-compressed-air":"Ar comprimido de entrada","t-outlet-compressed-air":"Ar comprimido de saída","t-reference-relative-humidity":"Consulte a umidade relativa","t-hd-coolers-calculation-tool":"Ferramenta de cálculo de resfriadores HD","t-cooling-water-output":"Saída de água de resfriamento","ERRCODE_CALCULATION_FAILED ":"Falha no cálculo.","ERRCODE_CALCULATION_CONVERGE ":"Não é possível calcular a conversão do fluxo do líquido arrefecedor. O modelo não encontrou o valor adequado do DeltaT para o qual o líquido arrefecedor foi especificado.","t-reference-conditions-explanation":"Consulta a explicação sobre as condições","t-reference-conditions-explanation-text":"Para calcular o desempenho dos resfriadores HD, o programa converte o fluxo volumétrico fornecido (fluxo de ar comprimido) para o fluxo de massa. Para calcular corretamente o fluxo de massa, o fluxo volumétrico deve ser consultado, de acordo com as condições específicas de Referência.","t-unit":"Unidade","t-Relativehumidity":"Umidade relativa"}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Настройки","t-language":"Язык","t-select-language":"Выберите язык","t-compressed-air-flow":"Расход сжатого воздуха","l/s":"л/с","cfm³/h":"куб. футов/м³/ч","m³/h":"м³/ч","m³/min":"м³/мин","t-pressure":"Давление","Bar":"бар","Psi":"фунтов/кв. дюйм","t-temperature":"Температура","°C":"°C","°F":"°F","t-cooling-water-flow":"Расход охлаждающей воды","gpm":"галлонов/мин","t-cooling-water-input":"Впуск охлаждающей воды","Flow":"Расход","Delta T":"Разница температур","t-Glycol-type":"Гликолевый тип","Ethylene":"Этилен","Propylene":"Пропилен","t-glycol-concetration-in-cooling-water":"Концентрация гликоля в охлаждающей воде","t-reference-conditions":"Стандартные условия:","t-reference-temperature":"Стандартная температура","t-reference-pressure":"Стандартное давление","t-inlet-compressed-air":"Впуск сжатого воздуха","t-outlet-compressed-air":"Выпуск сжатого воздуха","t-reference-relative-humidity":"Стандартная относительная влажность","t-hd-coolers-calculation-tool":"Инструмент расчета для охладителей HD","t-cooling-water-output":"Выпуск охлаждающей воды","ERRCODE_CALCULATION_FAILED ":"Ошибка при расчете.","ERRCODE_CALCULATION_CONVERGE ":"Несоответствие результатов расчета расхода охлаждающей жидкости. Модель не смогла найти требуемое значение перепада температур, соответствующее указанному расходу охлаждающей жидкости.","t-reference-conditions-explanation":"Описание стандартных условий","t-reference-conditions-explanation-text":"Для расчета производительности охладителей HD программа преобразует предоставленный объемный расход (расход сжатого воздуха) в массовый расход. Для правильного расчета массового расхода объемный расход должен соответствовать особым стандартным условиям.","t-unit":"Блок","t-Relativehumidity":"Относительная влажность"}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {"t-settings":"Ajustes","t-language":"Idioma","t-select-language":"Seleccionar idioma","t-compressed-air-flow":"Caudal de aire comprimido","l/s":"l/s","cfm³/h":"cfm³/h","m³/h":"m³/h","m³/min":"m³/min","t-pressure":"Presión","Bar":"Bar","Psi":"psi","t-temperature":"Temperatura","°C":"°C","°F":"°F","t-cooling-water-flow":"Caudal de agua de refrigeración","gpm":"gpm","t-cooling-water-input":"Entrada de agua de refrigeración","Flow":"Caudal","Delta T":"Diferencial de temperatura","t-Glycol-type":"Tipo de glicol","Ethylene":"Etileno","Propylene":"Propileno","t-glycol-concetration-in-cooling-water":"Concentración de glicol en el agua de refrigeración","t-reference-conditions":"Condiciones de referencia","t-reference-temperature":"Temperatura de referencia","t-reference-pressure":"Presión de referencia","t-inlet-compressed-air":"Aire comprimido de entrada","t-outlet-compressed-air":"Aire comprimido de salida","t-reference-relative-humidity":"Humedad relativa de referencia","t-hd-coolers-calculation-tool":"Herramienta de cálculo de refrigeradores HD","t-cooling-water-output":"Salida de agua de refrigeración","ERRCODE_CALCULATION_FAILED ":"Error de cálculo.","ERRCODE_CALCULATION_CONVERGE ":"El cálculo de flujo de refrigerante no es correcto. El modelo no ha podido encontrar el valor DeltaT correcto para el que se ha especificado el refrigerante.","t-reference-conditions-explanation":"Explicación de condiciones de referencia","t-reference-conditions-explanation-text":"Para calcular el rendimiento de los refrigeradores HD, el programa proporcionado convierte el caudal volumétrico (caudal de aire comprimido) en caudal másico. Para calcular el caudal másico correctamente, el caudal volumétrico debe corresponder a condiciones de referencia concretas.","t-unit":"Unidad","t-Relativehumidity":"Humedad relativa"}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(170);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(19);
var Axios = __webpack_require__(172);
var defaults = __webpack_require__(12);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(16);
axios.CancelToken = __webpack_require__(171);
axios.isCancel = __webpack_require__(17);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(186);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(16);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(12);
var utils = __webpack_require__(1);
var InterceptorManager = __webpack_require__(173);
var dispatchRequest = __webpack_require__(174);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(177);
var isCancel = __webpack_require__(17);
var defaults = __webpack_require__(12);
var isAbsoluteURL = __webpack_require__(182);
var combineURLs = __webpack_require__(180);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(18);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugin_api_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__convert_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__units_data_unitlist__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_SettingInput_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_SettingInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_SettingInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_SettingOuput_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_SettingOuput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_SettingOuput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_input_tabs_vue__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_input_tabs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_input_tabs_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_input_dropdown_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_input_dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_input_dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_input_field_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_input_field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_shared_input_field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_BgImage_vue__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_BgImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_shared_BgImage_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









//import pdfmake from 'pdfmake'

//inputs









var _isDebug = true;

/* harmony default export */ __webpack_exports__["default"] = ({
	name: "app",
	components: {
		inputComponent: __WEBPACK_IMPORTED_MODULE_6__components_shared_SettingInput_vue___default.a,
		outputComponent: __WEBPACK_IMPORTED_MODULE_7__components_shared_SettingOuput_vue___default.a,
		inputtabs: __WEBPACK_IMPORTED_MODULE_8__components_shared_input_tabs_vue___default.a,
		inputdropdown: __WEBPACK_IMPORTED_MODULE_9__components_shared_input_dropdown_vue___default.a,
		inputfield: __WEBPACK_IMPORTED_MODULE_10__components_shared_input_field_vue___default.a,
		BgImage: __WEBPACK_IMPORTED_MODULE_11__components_shared_BgImage_vue___default.a
	},
	data: function data() {
		return {
			cordova: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].cordova,
			browserFeatures: null,
			plugindataOutput: null,
			plugindataInput: {},
			plugindata: null,

			counter: 0,
			splashActive: false,
			referenceconditions: false,
			settingsActive: true,
			isContentActive: true,
			settings: this.$store.state.settings,
			unitlist: {
				selected: 0,
				items: []
			},
			//input -----------------------------------
			inletCompressedAir: [{
				name: "Flow",
				value: 250,
				inputParam: "CompressedAirFlow"
			}, {
				name: "t-temperature",
				value: 140,
				inputParam: "Temperature"
			}, {
				name: "t-pressure",
				value: 8,
				inputParam: "Pressure"
			}],
			coolingWateInput: [{
				name: "Delta T",
				value: 10,
				inputParam: "Temperature"
			}, {
				name: "Flow",
				value: 0.27,
				inputParam: "CoolingWaterflow"
			}, {
				name: "t-temperature",
				value: 25,
				inputParam: "Temperature"
			}, {
				name: "t-pressure",
				value: 3,
				inputParam: "Pressure"
			}],
			//output ----------------------------------
			outletCompressedAir: [{
				name: "t-temperature",
				value: 34.4444,
				inputParam: "Temperature"
			}, {
				name: "t-pressure",
				value: 7.4444444,
				inputParam: "Pressure"
			}],
			coolingWaterOuput: [{
				name: "Flow",
				value: 0.00026999956676767553,
				inputParam: "CoolingWaterflow"
			}, {
				name: "t-temperature",
				value: 25.44444,
				inputParam: "Temperature"
			}, {
				name: "t-pressure",
				value: 6.2444444,
				inputParam: "Pressure"
			}],
			referenceConditionsData: [{
				unit: "Nm3/h & Nm3/min",
				pressure: "1.013 bar(a)",
				temperature: "0 &#8451;",
				Relativehumidity: "0 %"
			}, {
				unit: "Sm3/h",
				pressure: "1 bar(a)",
				temperature: "15.6 &#8451;",
				Relativehumidity: "0 %"
			}, {
				unit: "scfm(ASME)",
				pressure: "14.7 psi(a)",
				temperature: "68 &#8457;",
				Relativehumidity: "36 %"
			}, {
				unit: "scfm(CAGI)",
				pressure: "14.5 psi(a)",
				temperature: "68 &#8457;",
				Relativehumidity: "0 %"
			}, {
				unit: "scfm(Can.)",
				pressure: "14.7 psi(a)",
				temperature: "70 &#8457;",
				Relativehumidity: "0 %"
			}, {
				unit: "scfm(US)",
				pressure: "14.7 psi(a)",
				temperature: "60 &#8457;",
				Relativehumidity: "0 %"
			}],
			Limitations: {
				Fluid: {
					Temperature_Min: 274.15,
					Temperature_Max: 493.15,
					Pressure_Min: 100000.0,
					Pressure_Max: 2100000.0
				},
				Coolant: {
					Temperature_Min: 274.15,
					Temperature_Max: 368.15,
					Pressure_Min: 100000,
					Pressure_Max: 800000.0
				}
			}
		};
	},

	computed: {
		getUnitImage: function getUnitImage() {
			if (this.unitlist.items.length > 0) {
				var image = this.unitlist.items[this.unitlist.selected].Image;
				return image;
			}
		},
		updateLanguage: function updateLanguage() {
			var langObj = this.$store.state.settings.Language;
			var lang = langObj.items[langObj.selected].name;
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].i18n.set(lang);
			return lang;
		},
		setDeviceClass: function setDeviceClass() {
			if (this.browserFeatures === null) return "";

			var res = "";
			if (this.browserFeatures.bMobile) res = this.browserFeatures.bIos ? "ios" : "android";

			return res;
		}
	},
	methods: {
		sendReport: function sendReport() {
			//debugbos
			//#region debug
			var debugSendReport = false;
			if (debugSendReport) {
				this.plugindataInput = {
					Unit: {
						Model: "HD650"
					},
					Fluid: {
						Flow: 0.25,
						Temperature: 413.15,
						Pressure: 900000,
						Humidity: 0
					},
					Coolant: {
						GlycolType: "Ethylene",
						GlycolContent: 0.6,
						InputType: "DeltaT",
						Flow: 0.000272451,
						DeltaT: 25,
						Temperature: 298.15,
						Pressure: 400000
					},
					Reference: {
						Temperature: 298.15,
						Pressure: 100000,
						Humidity: 0.6
					}
				};

				this.plugindataOutput = {
					Result: 0,
					Msg: "Success",
					Fluid: {
						Flow: 0.25,
						Temperature: 315.3932073137327,
						Pressure: 849769.196480225,
						WaterContent: 0.0,
						Condensate: 0.008109182832328232338
					},
					Coolant: {
						Flow: 0.0002724508150486337,
						Temperature: 323.15,
						Pressure: 398111.76926710226
					},
					Dimensions: {
						Air_In: "DIN80",
						Air_Out: 'R2 1/2"',
						Coolant_In: 'R1/2"',
						Coolant_Out: 'R1/2"',
						Length: 0.58,
						Width: 0.62,
						Height: 2.11,
						Weight: 140.0
					},
					Limitations: {
						Fluid: {
							Temperature_Min: 274.15,
							Temperature_Max: 493.15,
							Pressure_Min: 100000.0,
							Pressure_Max: 2100000.0
						},
						Coolant: {
							Temperature_Min: 274.15,
							Temperature_Max: 368.15,
							Pressure_Min: 100000.0,
							Pressure_Max: 800000.0
						}
					}
				};
			}
			//#endregion

			/*
       let title = "<small style='color: #F27474'>Not implemented yet. <div v-html'this.browserFeatures.bMobile'></div></small>";// "<small>Error occurred</small>!";
       let body = "";//"<span style='color: #F27474'>Not implemented yet.<span>";
        swal({
         title: title,
         text: body,
         confirmButtonText: "ok",
         confirmButtonColor: '#0078A1',
         type: "error",
         html: true
       });
       */
			//this.plugindataOutput
			//this.plugindataInput
			var fflowUnit = this.settings["CompressedAirFlow"];
			var wflowUnit = this.settings["CoolingWaterflow"];
			var tempUnit = this.settings["Temperature"];
			var presUnit = this.settings["Pressure"];

			var unitSelected = this.unitlist.items[this.unitlist.selected];

			var sidemargin = this.unitlist.selected > 1 ? 40 : 70; //placement of unitimage in the pdf

			//console.log(unitSelected);
			var reportData = {
				Cooler: [["Size", unitSelected.Model] //getUnitList
				// ['Image', ''] //getUnitList
				],
				PerformanceData: [["Air Temperature In", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataInput.Fluid.Temperature)], ["Air Temperature Out", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Fluid.Temperature)], ["Air Pressure In", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataInput.Fluid.Pressure, this.settings["ReferencePressure"].value)], ["Air Pressure Out", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Fluid.Pressure, this.settings["ReferencePressure"].value)], ["Air Pressure drop", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("PressureNotA", presUnit, this.plugindataInput.Fluid.Pressure - this.plugindataOutput.Fluid.Pressure)], ["Air Flow In", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Flow", fflowUnit, this.plugindataInput.Fluid.Flow)], ["Air flow Out", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Flow", fflowUnit, this.plugindataOutput.Fluid.Flow)], ["Condensate", _.round(this.plugindataOutput.Fluid.Condensate, 6) + " kg/s"], ["Water Temperature In", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataInput.Coolant.Temperature)], ["Water Temperature Out", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Coolant.Temperature)], ["Water Temperature Rise", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Calc", tempUnit, this.plugindataOutput.Coolant.Temperature - this.plugindataInput.Coolant.Temperature)], ["Water Pressure In", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataInput.Coolant.Pressure, this.settings["ReferencePressure"].value)], ["Water Pressure Out", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Coolant.Pressure, this.settings["ReferencePressure"].value)], ["Water Pressure drop", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("PressureNotA", presUnit, this.plugindataInput.Coolant.Pressure - this.plugindataOutput.Coolant.Pressure)], ["Water Flow", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("WaterFlow", wflowUnit, this.plugindataOutput.Coolant.Flow)], ["Glycol type", this.plugindataInput.Coolant.GlycolType], ["Glycol content", _.round(this.plugindataInput.Coolant.GlycolContent * 100, 1) + " %"]],
				Limitations: [["Min Compressed Air Temperature", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Limitations.Fluid.Temperature_Min)], //from output directly
				["Max Compressed Air Temperature", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Limitations.Fluid.Temperature_Max)], //from output directly
				["Min Compressed Air Pressure", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Limitations.Fluid.Pressure_Min)], //from output directly
				["Max Compressed Air Pressure", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Limitations.Fluid.Pressure_Max)], //from output directly
				["Min Cooling Water Temperature", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Limitations.Coolant.Temperature_Min)], //from output directly
				["Max Cooling Water Temperature", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataOutput.Limitations.Coolant.Temperature_Max)], //from output directly
				["Min Cooling Water Pressure", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Limitations.Coolant.Pressure_Min)], //from output directly
				["Max Cooling Water Pressure", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Pressure", presUnit, this.plugindataOutput.Limitations.Coolant.Pressure_Max)] //from output directly
				],
				Dimensions: [["Air Inlet Connection", this.plugindataOutput.Dimensions.Air_In], //from output directly
				["Air Outlet Connection", this.plugindataOutput.Dimensions.Air_Out], //from output directly
				["Water Inlet Connection", this.plugindataOutput.Dimensions.Coolant_In], //from output directly
				["Water Outlet connection", this.plugindataOutput.Dimensions.Coolant_Out], //from output directly
				["Length", this.plugindataOutput.Dimensions.Length + " m"], //from output directly
				["Width", this.plugindataOutput.Dimensions.Width + " m"], //from output directly
				["Height", this.plugindataOutput.Dimensions.Height + " m"], //from output directly
				["Weight", this.plugindataOutput.Dimensions.Weight + " kg"] //from output directly
				],
				ReferenceConditions: [["Reference Temperature", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("Temperature", tempUnit, this.plugindataInput.Reference.Temperature)], //from input directly
				["Reference Pressure", __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].getReportvalue("PressureNotA", presUnit, this.plugindataInput.Reference.Pressure) + "(g)"], //from input directly
				["Reference Humidity", _.round(this.plugindataInput.Reference.Humidity * 100, 1) + " %"] //from input directly
				]
				// tester: [
				//   [{ text: 'tester 4 cells ', style: 'lefta' }, { text: '2100000 kg', style: 'righta' }, { text: '2100000 kg', style: 'righta' }, { text: '2100000 kg', style: 'righta' }]
				// ]
			};

			if (__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].debugMode()) {
				//console.clear();
				console.log(JSON.stringify(reportData, null, 2));
			}

			//pdf setup
			var tableRowCellSize = ["*", 240];
			var tableRowCellSize4 = ["*", 90, 90, 90];
			var tableRowFillColor = "#EEF6F9";
			var tableHeaderColor = "#0099CC";
			var tableHeaderMargins = [0, 20, 0, 8];
			var tableLayout = {
				hLineWidth: function hLineWidth(i, node) {
					return i === 0 || i === node.table.body.length ? 0 : 1;
				},
				vLineWidth: function vLineWidth(i, node) {
					return i === 0 || i === node.table.widths.length ? 0 : 0;
				},
				hLineColor: function hLineColor(i, node) {
					return i === 0 || i === node.table.body.length ? "white" : "#cacaca";
				},
				// vLineColor: function(i, node) {
				//   return (i === 0 || i === node.table.widths.length) ? 'white' : '#cacaca';
				// },
				fillColor: function fillColor(i, node) {
					return i % 2 === 0 ? tableRowFillColor : null;
				}
			};

			var dd = {
				content: [{
					image: __WEBPACK_IMPORTED_MODULE_5__units_data_unitlist__["a" /* default */].getAClogo().image,
					width: 70
					// fit: [100, 100]
				}, {
					text: "Cooler",
					margin: tableHeaderMargins,
					color: tableHeaderColor
				}, {
					style: "tableExample",
					table: {
						widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
						body: reportData.Cooler
					},
					layout: tableLayout
				},

				// { text: 'tester', margin: tableHeaderMargins, color: tableHeaderColor },
				// {
				//     widths: tableRowCellSize4, //	widths: [100, '*', 200, '*'],
				//     body: reportData.tester
				//   },
				//   layout: tableLayout
				// },

				{
					text: "Performance Data",
					margin: tableHeaderMargins,
					color: tableHeaderColor
				}, {
					style: "tableExample",
					table: {
						widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
						body: reportData.PerformanceData
					},
					layout: tableLayout
				}, {
					text: "Limitations",
					margin: tableHeaderMargins,
					color: tableHeaderColor
				}, {
					style: "tableExample",
					table: {
						widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
						body: reportData.Limitations
					},
					layout: tableLayout,
					pageBreak: "after"
				}, {
					text: "Dimensions",
					margin: tableHeaderMargins,
					color: tableHeaderColor
				}, {
					style: "tableExample",
					table: {
						widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
						body: reportData.Dimensions
					},
					layout: tableLayout
				}, {
					text: "Reference conditions",
					margin: tableHeaderMargins,
					color: tableHeaderColor
				}, {
					style: "tableExample",
					table: {
						headerRows: 1,
						widths: tableRowCellSize, //	widths: [100, '*', 200, '*'],
						body: reportData.ReferenceConditions
					},
					layout: tableLayout
					// paddingLeft: function(i, node) { return 4; },
					// paddingRight: function(i, node) { return 4; },
					// paddingTop: function(i, node) { return 2; },
					// paddingBottom: function(i, node) { return 2; },
					// fillColor: function (i, node) { return null; }
				}, {
					style: "image",
					image: unitSelected.Image,
					fit: [300, 300],
					alignment: "right",
					margin: [sidemargin, 50]
				}],
				styles: {
					righta: {
						fontSize: 11,
						alignment: "right"
					},
					lefta: {
						fontSize: 11,
						alignment: "left"
					},
					image: {
						border: "1px solid red"
					}
				}
			};

			__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].openPDF(dd, unitSelected.Model);
		},
		unitlistClicked: function unitlistClicked(index) {
			var _self = this;
			this.unitlist.selected = index;

			var unit = this.unitlist.items[index];

			var flowUnit = this.settings["CompressedAirFlow"].selected;
			var cflowUnit = this.settings["CoolingWaterflow"].selected;
			var tempUnit = this.settings["Temperature"].selected;
			var presUnit = this.settings["Pressure"].selected;

			//Disabled updating values
			// this.inletCompressedAir[0].value = converter.Flow(0, flowUnit, (unit['Fluid']['Flow'] * 1000));
			// this.inletCompressedAir[1].value = converter.fromKelvin(tempUnit, unit['Fluid']['Temperature']);
			// this.inletCompressedAir[2].value = converter.fromPascal(presUnit, (unit['Fluid']['Pressure']));

			// this.coolingWateInput[0].value = converter.CoolingWaterFlow(0, cflowUnit, (unit['Coolant']['Flow'] * 1000));
			// this.coolingWateInput[1].value = converter.fromKelvin(tempUnit, unit['Coolant']['Temperature']);
			// this.coolingWateInput[2].value = converter.fromPascal(presUnit, (unit['Coolant']['Pressure']));

			this.updateCalculation();
		},
		toggleSettings: function toggleSettings() {
			var showReferenceconditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (showReferenceconditions) this.referenceconditions = !this.referenceconditions;

			this.settingsActive = !this.settingsActive;

			if (!this.settingsActive) {
				this.updateCalculation();
			}
		},
		updateCalculation: function updateCalculation() {
			var _self = this;
			var flowUnit = this.settings["CompressedAirFlow"].selected;
			var cflowUnit = this.settings["CoolingWaterflow"].selected;
			var tempUnit = this.settings["Temperature"].selected;
			var presUnit = this.settings["Pressure"].selected;

			//Inlet compressed air
			var fFlow = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].Flow(flowUnit, 0, this.inletCompressedAir[0].value) / 1000;
			var fTemperature = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toKelvin(tempUnit, this.inletCompressedAir[1].value);
			var fPressure = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toPascal_a(presUnit, this.inletCompressedAir[2].value, this.settings["ReferencePressure"].value); //
			//let fPressure = converter.toPascal(presUnit, this.inletCompressedAir[2].value);
			//let fPressure = converter.fromPascal_a(presUnit, this.inletCompressedAir[2].value, this.settings['ReferencePressure'].value);

			//Cooling Water Input
			var cDelta = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toKelvinDeltaT(tempUnit, this.coolingWateInput[0].value);

			//updated as per mail
			var cFlow = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].CoolingWaterFlow(cflowUnit, 0, this.coolingWateInput[1].value) / 1000;
			// console.log()
			// let cFlow = this.coolingWateInput[1].value / 1000;

			var cTemperature = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toKelvin(tempUnit, this.coolingWateInput[2].value);

			var cPressure = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toPascal_a(presUnit, this.coolingWateInput[3].value, this.settings["ReferencePressure"].value); //converter.toPascal(presUnit, this.coolingWateInput[2].value);
			//let cPressure = converter.toPascal(presUnit, this.coolingWateInput[3].value);

			var rGlycolContent = this.settings["GlycolConcentrationInCoolingWater"].value / 100;
			var rTemperature = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toKelvin(tempUnit, this.settings["ReferenceTemperature"].value);
			var rPressure = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].toPascal(presUnit, this.settings["ReferencePressure"].value);

			var rHumidity = this.unitlist.selected === 0 || this.unitlist.selected === 1 ? 0 : this.settings["ReferenceRelativeHumidity"].value / 100;

			var cCoolingWaterInputType = this.settings.CoolingWaterInput.items[this.settings.CoolingWaterInput.selected].name.replace(/ /g, "");

			var obj = {
				Unit: {
					Model: this.unitlist.items[this.unitlist.selected].Model
				},
				Fluid: {
					Flow: fFlow, //m3/s
					Temperature: fTemperature, // K
					Pressure: fPressure, //Pa
					Humidity: rHumidity //Relative humidity between 0 and 1 (keep at 0 for HD250/HD650, or if unknown)
				},
				Coolant: {
					GlycolType: this.settings.GlycolType.items[this.settings.GlycolType.selected].name, //"Ethylene"
					GlycolContent: rGlycolContent, //Glycol content between 0 and 0.6,
					InputType: cCoolingWaterInputType, //
					Flow: cFlow, // m3/s
					DeltaT: cDelta, // K or Celsius, since it is a temperature difference. To convert from Rankine or Fahrenheit to Celsius or Kelvin, multiply by 5/9,
					Temperature: cTemperature, //K
					Pressure: cPressure //Pa
				},
				Reference: {
					Temperature: rTemperature, //this.settings.ReferenceTemperature.value,         // K
					Pressure: rPressure, //this.settings.ReferencePressure.value,             // Pa
					Humidity: rHumidity
				}
			};

			this.plugindataInput = obj;

			if (__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].debugMode()) {
				//console.clear();
				console.log("plugindataInput\n", JSON.stringify(obj));
			}

			__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].calculate(obj, function (json) {
				//console.clear();

				var pluginCBData = !!window.cordova ? JSON.parse(json) : json;

				if (__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].debugMode()) console.log("plugindataOutput\n", pluginCBData);

				if (pluginCBData.Result !== 0) {
					window.AppVM.plugindataOutput = null;
					swal({
						title: "Error:" + pluginCBData.Result,
						text: pluginCBData.Msg,
						confirmButtonText: "ok",
						confirmButtonColor: "#0078A1",
						type: "error",
						html: true
					});
				} else {
					//set limitations
					_self.Limitations = pluginCBData["Limitations"];

					//set output fields (pressure out 'PA - ReferencePressure PA' converter.fromPascal_a)
					_self.outletCompressedAir[0].value = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].fromKelvin(tempUnit, pluginCBData["Fluid"]["Temperature"]);
					_self.outletCompressedAir[1].value = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].fromPascal_a(presUnit, pluginCBData["Fluid"]["Pressure"], _self.settings["ReferencePressure"].value);

					_self.coolingWaterOuput[0].value = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].CoolingWaterFlow(0, cflowUnit, pluginCBData["Coolant"]["Flow"] / 0.001, 2);
					_self.coolingWaterOuput[1].value = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].fromKelvin(tempUnit, pluginCBData["Coolant"]["Temperature"]);
					_self.coolingWaterOuput[2].value = __WEBPACK_IMPORTED_MODULE_4__convert_service__["a" /* default */].fromPascal_a(presUnit, pluginCBData["Coolant"]["Pressure"], _self.settings["ReferencePressure"].value);

					window.AppVM.plugindataOutput = pluginCBData;
				}

				/*
    var debugInOut = {
    	'input' :  obj,
    	'output' : pluginCBData
    }
    	console.log( JSON.stringify(debugInOut, null , "\t"));
    */
			}, function (json) {
				var msg = JSON.parse(json);
				if (__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].debugMode()) console.error("plugindataOutput error:", json);
				window.AppVM.plugindataOutput = null;
				swal({
					title: "Plugin error:",
					text: msg.Msg,
					confirmButtonText: "ok",
					confirmButtonColor: "#0078A1",
					type: "error",
					html: true
				});
				window.AppVM.plugindataOutput = msg;
			});
		},
		InitBrowserFeatures: function InitBrowserFeatures() {
			/* ===== BROWSER FEATURES ======================================================================= */
			function isInternetExplorer() {
				var isIE = navigator.appVersion.indexOf("MSIE") >= 0 && navigator.appVersion.indexOf("MSIE") < 18;
				//$("body").addClass("is-ie");
				return isIE;
			}

			function isIos() {
				var ua = navigator.userAgent;
				return ua.match(/iPad/i) || ua.match(/iPhone/i) || ua.match(/iPod/i) ? true : false;
			}

			function isMobile() {
				var bMobile = /iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent);
				window.isOnMobile = bMobile;
				return bMobile;
			}

			/* Create object to store browser features */
			function getBrowserFeatures() {
				return {
					bIE: isInternetExplorer(),
					bIos: isIos(),
					bMobile: isMobile()
				};
			}

			function isInLandscapeMode() {
				return window.orientation === 90 || window.orientation === -90;
			}
			// Orientationchange
			window.addEventListener("orientationchange", function () {
				if (isInLandscapeMode()) {
					//alert("plase use in landscape mode")
				}
			});

			/* ============================================================================ */
			//test for touch events support and if not supported, attach .no-touch class to the HTML tag.
			if (!("ontouchstart" in document.documentElement)) {
				document.documentElement.className += " no-touch";
			} else {
				//Fastclick
				//console.log('FastClick attach');
				__WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);
			}

			this.browserFeatures = getBrowserFeatures();
		},
		initApp: function initApp(isCordova) {
			console.log('initApp isCordova:', isCordova);
			__WEBPACK_IMPORTED_MODULE_3__plugin_api_js__["a" /* default */].init();
			this.unitlistClicked(0);
		}
	},
	mounted: function mounted() {
		// console.clear();
		__WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$on("updateCalculation", this.updateCalculation);
		var _self = this;
		window.AppVM = _self;

		_self.unitlist.items = __WEBPACK_IMPORTED_MODULE_5__units_data_unitlist__["a" /* default */].getUnitList();

		//check if running cordova
		if (!!window.cordova) {
			//in browser
			_self.initApp(false);
		} else {
			//on device
			__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].cordova.on("deviceready", function () {
				_self.initApp(true);
			});
		}

		this.InitBrowserFeatures();

		// https://github.com/jonathantneal/svg4everybody
		// SVG External Content support IE <= 11
		//svg4everybody();

		// setTimeout(function() {
		//   _self.sendReport();
		// }, 300);
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$off("updateCalculation", this.updateCalculation);
	}
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'bg-image',
	props: ['unitlist']
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__convert_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "inputComponent",
  props: ["item", "index", 'Limitations', 'inputType', 'plugindataInput'],
  data: function data() {
    return {
      title: null,
      settings: this.$store.state.settings,
      show: true,
      interval: .1
    };
  },

  methods: {
    selectItem: function selectItem() {
      this.tech.selected = !this.tech.selected;
      this.$emit("unit-clicked", this);
    },
    sub: function sub() {
      this.item.value -= this.interval;
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit("updateCalculation");
    },
    add: function add() {
      this.item.value += this.interval;
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit("updateCalculation");
    },
    onFocus: function onFocus(index, e) {
      console.log("onFocus:" + this.item.inputParam);
      if (navigator.userAgent.match(/Edge\/(13|14)/)) {
        return setTimeout(e.target.select.bind(e.target), 10);
      } else {
        e.target.select();
      }
    },
    onBlur: function onBlur(index, e) {
      console.log(this.item.inputParam + " onBlur:" + e.target.value);
      this.item.value = parseFloat(e.target.value);
      this.checkLimitations();
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit("updateCalculation");
    },
    checkLimitations: function checkLimitations() {

      //console.log('\n');

      var limits = this.Limitations[this.inputType];
      var ExceedsLimits = false;

      if (this.item.name === 'Delta T') return '';

      switch (this.item.inputParam) {
        case 'Temperature':
          var tempKevin = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].toKelvin(this.settings[this.item.inputParam].selected, this.item.value);
          // console.log('inputType',this.inputType);
          // console.log('inputParam',this.item.inputParam);
          // console.log(this.inputType,' Limitations Temperature:',limits.Temperature_Min,tempKevin,limits.Temperature_Max,this.item.value,this.settings[this.item.inputParam].selected);

          if (tempKevin > limits.Temperature_Max) ExceedsLimits = true;
          if (tempKevin < limits.Temperature_Min) ExceedsLimits = true;

          break;

        case 'Pressure':
          var pressPA = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].toPascal(this.settings[this.item.inputParam].selected, this.item.value);
          // console.log('inputType',this.inputType);
          // console.log('inputParam',this.item.inputParam);
          // console.log(this.inputType,' Limitations Pressure:',limits.Pressure_Min,pressPA,limits.Pressure_Max ,this.item.value );

          if (this.plugindataInput) if (this.plugindataInput.Reference) {
            if (pressPA > limits.Pressure_Max - this.plugindataInput.Reference.Pressure) ExceedsLimits = true;
            if (pressPA < limits.Pressure_Min - this.plugindataInput.Reference.Pressure) ExceedsLimits = true;
          }

          break;
      }

      return ExceedsLimits ? 'ExceedingLimitations' : '';
    }
  },
  computed: {
    isExceedingLimitations: function isExceedingLimitations() {

      return this.checkLimitations();
    },
    getLabel: function getLabel() {
      var res = this.item.name;
      var CoolingWaterInput = this.settings.CoolingWaterInput.selected;

      if (this.item.inputParam === "CoolingWaterflow" || res === "Delta T") {
        var show = false;
        if (res === "Delta T" && CoolingWaterInput === 1) show = true;
        if (this.item.inputParam === "CoolingWaterflow" && CoolingWaterInput === 0) show = true;

        this.show = show;
      }
      //console.log('getLabel');
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.translate(res);
    },
    converterType: function converterType() {
      var param = this.settings[this.item.inputParam];
      // console.log(
      //   this.item.inputParam +
      //     " from:" +
      //     this.prevIndex +
      //     " to:" +
      //     param.selected
      // );
      //convert item.value

      if (this.prevIndex !== undefined) {
        switch (this.item.inputParam) {
          case "CompressedAirFlow":
            this.item.value = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].Flow(this.prevIndex, param.selected, this.item.value);
            break;
          case "Temperature":
            //special conversion for DeltaT temperature
            if (this.item.name === "Delta T") this.item.value = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].TemperatureDelta(this.prevIndex, param.selected, this.item.value);else this.item.value = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].Temperature(this.prevIndex, param.selected, this.item.value);
            break;
          case "Pressure":
            this.item.value = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].Pressure(this.prevIndex, param.selected, this.item.value);
            break;
          case "CoolingWaterflow":
            this.item.value = __WEBPACK_IMPORTED_MODULE_1__convert_service__["a" /* default */].CoolingWaterFlow(this.prevIndex, param.selected, this.item.value);
            break;
        }
      }
      this.prevIndex = param.selected;
      var converterAddon = this.item.inputParam === "Pressure" ? "(g)" : "";
      return param.items[param.selected].name + converterAddon;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
    });
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__convert_service__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'outputComponent',
	props: ['item', 'index', 'inputType'],
	data: function data() {
		return {
			title: null,
			prevIndex: null,
			show: true
		};
	},

	methods: {
		selectItem: function selectItem() {
			//this.tech.selected = !this.tech.selected;
			this.$emit('unit-clicked', this);
		}
	},
	computed: {
		converterType: function converterType() {
			var param = this.$store.state.settings[this.item.inputParam];
			//console.log(this.item.inputParam + ' from:' + this.prevIndex + ' to:' + param.selected);
			//convert item.value
			if (this.prevIndex !== undefined) {
				switch (this.item.inputParam) {
					case 'CompressedAirFlow':
						this.item.value = __WEBPACK_IMPORTED_MODULE_0__convert_service__["a" /* default */].Flow(this.prevIndex, param.selected, this.item.value);
						break;
					case 'Temperature':
						if (this.inputType === 'Coolant') this.show = this.$store.state.settings.CoolingWaterInput.selected === 0 ? true : false;

						this.item.value = __WEBPACK_IMPORTED_MODULE_0__convert_service__["a" /* default */].Temperature(this.prevIndex, param.selected, this.item.value);
						break;
					case 'Pressure':
						this.item.value = __WEBPACK_IMPORTED_MODULE_0__convert_service__["a" /* default */].Pressure(this.prevIndex, param.selected, this.item.value);
						break;
					case 'CoolingWaterflow':
						this.show = this.$store.state.settings.CoolingWaterInput.selected === 1 ? true : false;

						this.item.value = __WEBPACK_IMPORTED_MODULE_0__convert_service__["a" /* default */].CoolingWaterFlow(this.prevIndex, param.selected, this.item.value);
						break;
				}
			}

			this.prevIndex = param.selected;
			var converterAddon = this.item.inputParam === 'Pressure' && param.selected === 0 ? "(g)" : '';
			return param.items[param.selected].name + converterAddon;
		}
	},
	mounted: function mounted() {
		this.$nextTick(function () {
			//this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
		});
	}
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'input-dropdown',
    props: ['item', 'index'],
    data: function data() {
        return {
            title: null
        };
    },

    methods: {
        selectItem: function selectItem() {
            //this.tech.selected = !this.tech.selected;
            //this.$emit('unit-clicked', this);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        });
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__convert_service__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'input-field',
    props: ['item', 'index', 'unit', 'selectedindex'],
    data: function data() {
        return {
            title: null,
            prevIndex: null,
            disabled: false,
            interval: .1
        };
    },

    computed: {
        converterType: function converterType() {

            if (this.item.inputParam === null) {
                if (this.item.texts.Title === 't-reference-relative-humidity') {
                    this.item.value = 0;
                    this.disabled = this.selectedindex === 0 || this.selectedindex === 1 ? true : false;
                }
                return this.unit;
            }

            var param = this.$store.state.settings[this.item.inputParam];
            //  console.log({
            //     inputParam: this.item.inputParam,
            //     prevIndex: this.prevIndex,
            //     selected: param.selected,
            //     value: this.item.value
            // });

            //console.log(this.item.inputParam + ' from:' + this.prevIndex + ' to:' + param.selected);
            //convert item.value

            if (this.prevIndex !== undefined) {
                switch (this.item.inputParam) {
                    case 'CompressedAirFlow':
                        this.item.value = __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].Flow(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'Temperature':
                        this.item.value = __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].Temperature(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'Pressure':
                        this.item.value = __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].Pressure(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'CoolingWaterflow':
                        this.item.value = __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].CoolingWaterFlow(this.prevIndex, param.selected, this.item.value);
                        break;
                }
            }

            this.prevIndex = param.selected;
            var converterAddon = this.item.inputParam === 'Pressure' ? "(a)" : '';
            return param.items[param.selected].name + converterAddon;
        }
    },
    methods: {
        selectItem: function selectItem() {
            //this.tech.selected = !this.tech.selected;
            this.$emit('unit-clicked', this);
        },
        sub: function sub() {
            this.item.value = this.item.inputParam === null ? __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].PercentValues(this.item.value, false, this.item.maxValue) : this.item.value - this.interval;
            __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('updateCalculation');
        },
        add: function add() {
            this.item.value = this.item.inputParam === null ? __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].PercentValues(this.item.value, true, this.item.maxValue) : this.item.value + this.interval;
            this.item.value = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.round(this.item.value, 1);
            __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('updateCalculation');
        },
        onFocus: function onFocus(index, e) {
            console.log('onFocus:' + this.item.inputParam);
            if (navigator.userAgent.match(/Edge\/(13|14)/)) {
                return setTimeout(e.target.select.bind(e.target), 10);
            } else {
                e.target.select();
            }
        },
        onBlur: function onBlur(index, e) {
            console.log(this.item.inputParam + ' onBlur:' + e.target.value);
            this.item.value = parseFloat(e.target.value);
            if (this.item.inputParam === null) this.item.value = __WEBPACK_IMPORTED_MODULE_2__convert_service__["a" /* default */].PercentValues(this.item.value, true, this.item.maxValue);
            //EventBus.$emit('updateCalculation');
        }
    },
    mounted: function mounted() {
        // this.$nextTick(function() {
        //     //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        // });
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'input-tabs',
    props: ['item', 'index'],
    data: function data() {
        return {
            title: null,
            prevIndex: null
        };
    },

    methods: {
        selectItem: function selectItem() {
            //this.tech.selected = !this.tech.selected;
            this.$emit('unit-clicked', this);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        });
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_src_scss_main_scss__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_src_scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_src_scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert_dist_sweetalert_css__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert_dist_sweetalert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert_dist_sweetalert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_svg4everybody_min_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_svg4everybody_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_js_svg4everybody_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_i18n__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_lang_English_json__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_lang_English_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__store_lang_English_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_lang_German_json__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_lang_German_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__store_lang_German_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_lang_French_json__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_lang_French_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__store_lang_French_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_lang_Chinese_json__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_lang_Chinese_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__store_lang_Chinese_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_lang_Indian_json__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_lang_Indian_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__store_lang_Indian_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_lang_Italian_json__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_lang_Italian_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__store_lang_Italian_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_lang_Spanish_json__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_lang_Spanish_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__store_lang_Spanish_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_lang_Portugese_json__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_lang_Portugese_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__store_lang_Portugese_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_lang_Dutch_json__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_lang_Dutch_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__store_lang_Dutch_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_lang_Russian_json__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_lang_Russian_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__store_lang_Russian_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_cordova__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_cordova___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_cordova__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_apple_touch_icon_png__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_apple_touch_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_apple_touch_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_favicon_32x32_png__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_favicon_32x32_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_favicon_32x32_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_favicon_16x16_png__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_favicon_16x16_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_favicon_16x16_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_safari_pinned_tab_svg__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_safari_pinned_tab_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_safari_pinned_tab_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_svg_sprite_svg_sprite_svg__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_svg_sprite_svg_sprite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_img_svg_sprite_svg_sprite_svg__);











__WEBPACK_IMPORTED_MODULE_6__assets_js_svg4everybody_min_js___default()({
  polyfill: true
});


// helper functions for components (i.e. this.$i18n.set, this.$t) and on the vue
// instance (i.e. Vue.i18n.set).
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */]);












// add translations directly to the application
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('English', __WEBPACK_IMPORTED_MODULE_8__store_lang_English_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('German', __WEBPACK_IMPORTED_MODULE_9__store_lang_German_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('French', __WEBPACK_IMPORTED_MODULE_10__store_lang_French_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Chinese', __WEBPACK_IMPORTED_MODULE_11__store_lang_Chinese_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Indian', __WEBPACK_IMPORTED_MODULE_12__store_lang_Indian_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Italian', __WEBPACK_IMPORTED_MODULE_13__store_lang_Italian_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Spanish', __WEBPACK_IMPORTED_MODULE_14__store_lang_Spanish_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Portugese', __WEBPACK_IMPORTED_MODULE_15__store_lang_Portugese_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Dutch', __WEBPACK_IMPORTED_MODULE_16__store_lang_Dutch_json___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.add('Russian', __WEBPACK_IMPORTED_MODULE_17__store_lang_Russian_json___default.a);

// set the start locale to use
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].i18n.set('English');




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue_cordova___default.a);

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  window.isCordovaApp = true;
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  cordovaScript.setAttribute('src', 'cordova.js');
  document.body.appendChild(cordovaScript);
}


//filter round to 2 decimals
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('Rounder', function (num) {
  return +(Math.round(num + "e+2") + "e-2"); //parseFloat(num).toFixed(1); //_.round(num, 3);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('RounderOut', function (num) {
  return __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.round(num, 2); //+(Math.round(num + "e+2")  + "e-2"); //parseFloat(num).toFixed(1); //_.round(num, 3);
});

//images
//import './assets/img/icons/favicon.ico' from webpack HtmlWebpackPlugin






var root = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_18__App_vue___default.a);
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__);

//Vue.prototype.$http = axios;

var hasCordova = true;
var isDebugMode = false;



__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

//const serverAPI = '/api/calculate';


var serverAPI = window.HDAPI.serverurl + '/api/calculate';

/* harmony default export */ __webpack_exports__["a"] = ({
	debugMode: function debugMode() {
		return isDebugMode;
	},
	init: function init() {

		//console.log("_packageVersion: " + PackageVersion)
		hasCordova = !!window.cordova;
		//console.log('plugin interface init: hasCordova:', hasCordova);
	},
	isRunningCordova: function isRunningCordova() {
		var cordovaDefined = !!window.cordova;
		return cordovaDefined;
	},
	debugObject: function debugObject(_target) {
		var arr = [];
		for (var i in _target) {
			if (_target.hasOwnProperty(i)) {
				arr[i] = [_target[i]];
			}
		}
		console.table(arr);
	},
	coolMethod: function coolMethod(str, success, error) {
		alert('coolMethod');
	},
	getUnitList: function getUnitList(str, success, error) {
		alert('getUnitList');
	},
	calculate: function calculate(obj, success, error) {
		if (!!window.cordova) {
			var jsonStr = JSON.stringify(obj, null, 2);
			cordova.plugins.hdcoolerslib.pl_calculate(jsonStr, success, error);
		} else {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(serverAPI, obj).then(function (resp) {
				return success(resp.data);
			}).catch(function (err) {
				return error(err);
			});
		}
	},
	openPDF: function openPDF(dd, unitname) {
		var filename = 'report_' + unitname + '_' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD");

		//debugbos
		if (!!window.cordova) {
			__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(dd).getBase64(function (base64encoded) {
				cordova.plugins.email.open({
					subject: 'AtlasCopco HD coolers report',
					attachments: ['base64:' + filename + '.pdf//' + base64encoded]
				});
			});
		} else {
			__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(dd).download(filename + '.pdf'); // open();
			/*
   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
   	window.navigator.msSaveOrOpenBlob(blob);
   } else {
   	var objectUrl = URL.createObjectURL(blob);
   	window.open(objectUrl);
   }
   */
		}
	}
});

/***/ }),
/* 196 */
/***/ (function(module, exports) {



/***/ }),
/* 197 */
/***/ (function(module, exports) {



/***/ }),
/* 198 */
/***/ (function(module, exports) {



/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aclogo; });
var aclogo = "data:image/png;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/4RDuRXhpZgAATU0AKgAAAAgABAE7AAIAAAAMAAAISodpAAQAAAABAAAIVpydAAEAAAAYAAAQzuocAAcAAAgMAAAAPgAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJvIFN0aWxsaW5nAAAFkAMAAgAAABQAABCkkAQAAgAAABQAABC4kpEAAgAAAAMzNwAAkpIAAgAAAAMzNwAA6hwABwAACAwAAAiYAAAAABzqAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAxNzowOToxMSAxNTowOToxOQAyMDE3OjA5OjExIDE1OjA5OjE5AAAAQgBvACAAUwB0AGkAbABsAGkAbgBnAAAA/+ELHmh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4NCjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iPjxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+PHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9InV1aWQ6ZmFmNWJkZDUtYmEzZC0xMWRhLWFkMzEtZDMzZDc1MTgyZjFiIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iLz48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyI+PHhtcDpDcmVhdGVEYXRlPjIwMTctMDktMTFUMTU6MDk6MTkuMzczPC94bXA6Q3JlYXRlRGF0ZT48L3JkZjpEZXNjcmlwdGlvbj48cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0idXVpZDpmYWY1YmRkNS1iYTNkLTExZGEtYWQzMS1kMzNkNzUxODJmMWIiIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyI+PGRjOmNyZWF0b3I+PHJkZjpTZXEgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj48cmRmOmxpPkJvIFN0aWxsaW5nPC9yZGY6bGk+PC9yZGY6U2VxPg0KCQkJPC9kYzpjcmVhdG9yPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L3g6eG1wbWV0YT4NCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgPD94cGFja2V0IGVuZD0ndyc/Pv/bAEMABwUFBgUEBwYFBggHBwgKEQsKCQkKFQ8QDBEYFRoZGBUYFxseJyEbHSUdFxgiLiIlKCkrLCsaIC8zLyoyJyorKv/bAEMBBwgICgkKFAsLFCocGBwqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKv/AABEIAXMC9AMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APevEniS08L6bHe6hHPJHJKIgIFBOSCe5HHymuZ/4W/oH/PpqX/fqP8A+Lo+L/8AyKNr/wBfyf8AouSvGq9zBYKjWo889z5PNM1xOFxLp02rWXQ9l/4W/oH/AD6al/36j/8Ai6P+Fv6B/wA+mpf9+o//AIuvGqK7P7Mw/Z/eeX/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLo/4W/oH/AD6al/36j/8Ai68aoo/szD9n94f29je6+49l/wCFv6B/z6al/wB+o/8A4uj/AIW/oH/PpqX/AH6j/wDi68aoo/szD9n94f29je6+49l/4W/oH/PpqX/fqP8A+Lo/4W/oH/PpqX/fqP8A+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8+mpf9+o//i6P+Fv6B/z6al/36j/+Lrxqij+zMP2f3h/b2N7r7j2X/hb+gf8APpqX/fqP/wCLrX8N+O9M8UalJZafBdxyRxGUmdFAwCB2Y8/MK8DrvfhB/wAjddf9eL/+jI6wxOAoU6Mpx3R2YHOMVXxMKc2rN9j2Wiiivnj7Q4L4v/8AIo2v/X8n/ouSvGq9l+L/APyKNr/1/J/6LkrxqvqMs/3f5s/P8+/31+iCiiivSPCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK734Qf8jddf9eL/wDoyOuCrvfhB/yN11/14v8A+jI65Mb/ALvP0PSyv/fafqey0UUV8gfpZwXxf/5FG1/6/k/9FyV41Xsvxf8A+RRtf+v5P/RcleNV9Rln+7/Nn5/n3++v0QUUUV6R4QUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABXe/CD/kbrr/AK8X/wDRkdcFXe/CD/kbrr/rxf8A9GR1yY3/AHefoellf++0/U9looor5A/Szgvi/wD8ija/9fyf+i5K8ar2X4v/APIo2v8A1/J/6LkrxqvqMs/3f5s/P8+/31+iCiiivSPCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK734Qf8jddf8AXi//AKMjrgq734Qf8jddf9eL/wDoyOuTG/7vP0PSyv8A32n6nstFFFfIH6WcF8X/APkUbX/r+T/0XJXjVey/F/8A5FG1/wCv5P8A0XJXjVfUZZ/u/wA2fn+ff76/RBRRRXpHhBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFd78IP8Akbrr/rxf/wBGR1wVd78IP+Ruuv8Arxf/ANGR1yY3/d5+h6WV/wC+0/U9looor5A/SzkviPomoa94cgtdJt/tEyXayMu9VwoRxnLEDqRXmX/CtvFn/QK/8mYv/iq96orvoY+rQhyRSt/XmePi8ooYur7Wo2n5W/yPBf8AhW3iz/oFf+TMX/xVH/CtvFn/AECv/JmL/wCKr3qit/7Vr9l+P+Zyf6u4T+aX3r/I8F/4Vt4s/wCgV/5Mxf8AxVH/AArbxZ/0Cv8AyZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf+FbeLP+gV/wCTMX/xVH/CtvFn/QK/8mYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/AIVt4s/6BX/kzF/8VR/wrbxZ/wBAr/yZi/8Aiq96oo/tWv2X4/5h/q7hP5pfev8AI8F/4Vt4s/6BX/kzF/8AFUf8K28Wf9Ar/wAmYv8A4qveqKP7Vr9l+P8AmH+ruE/ml96/yPBf+FbeLP8AoFf+TMX/AMVR/wAK28Wf9Ar/AMmYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/hW3iz/oFf8AkzF/8VR/wrbxZ/0Cv/JmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/wCFbeLP+gV/5Mxf/FUf8K28Wf8AQK/8mYv/AIqveqKP7Vr9l+P+Yf6u4T+aX3r/ACPBf+FbeLP+gV/5Mxf/ABVH/CtvFn/QK/8AJmL/AOKr3qij+1a/Zfj/AJh/q7hP5pfev8jwX/hW3iz/AKBX/kzF/wDFUf8ACtvFn/QK/wDJmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/4Vt4s/6BX/AJMxf/FUf8K28Wf9Ar/yZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf8AhW3iz/oFf+TMX/xVH/CtvFn/AECv/JmL/wCKr3qij+1a/Zfj/mH+ruE/ml96/wAjwX/hW3iz/oFf+TMX/wAVR/wrbxZ/0Cv/ACZi/wDiq96oo/tWv2X4/wCYf6u4T+aX3r/I8F/4Vt4s/wCgV/5Mxf8AxVH/AArbxZ/0Cv8AyZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf+FbeLP+gV/wCTMX/xVH/CtvFn/QK/8mYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/AIVt4s/6BX/kzF/8VR/wrbxZ/wBAr/yZi/8Aiq96oo/tWv2X4/5h/q7hP5pfev8AI8F/4Vt4s/6BX/kzF/8AFUf8K28Wf9Ar/wAmYv8A4qveqKP7Vr9l+P8AmH+ruE/ml96/yPBf+FbeLP8AoFf+TMX/AMVR/wAK28Wf9Ar/AMmYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/hW3iz/oFf8AkzF/8VR/wrbxZ/0Cv/JmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/wCFbeLP+gV/5Mxf/FUf8K28Wf8AQK/8mYv/AIqveqKP7Vr9l+P+Yf6u4T+aX3r/ACPBf+FbeLP+gV/5Mxf/ABVH/CtvFn/QK/8AJmL/AOKr3qij+1a/Zfj/AJh/q7hP5pfev8jwX/hW3iz/AKBX/kzF/wDFUf8ACtvFn/QK/wDJmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/4Vt4s/6BX/AJMxf/FUf8K28Wf9Ar/yZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf8AhW3iz/oFf+TMX/xVH/CtvFn/AECv/JmL/wCKr3qij+1a/Zfj/mH+ruE/ml96/wAjwX/hW3iz/oFf+TMX/wAVR/wrbxZ/0Cv/ACZi/wDiq96oo/tWv2X4/wCYf6u4T+aX3r/I8F/4Vt4s/wCgV/5Mxf8AxVH/AArbxZ/0Cv8AyZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf+FbeLP+gV/wCTMX/xVH/CtvFn/QK/8mYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/AIVt4s/6BX/kzF/8VR/wrbxZ/wBAr/yZi/8Aiq96oo/tWv2X4/5h/q7hP5pfev8AI8F/4Vt4s/6BX/kzF/8AFUf8K28Wf9Ar/wAmYv8A4qveqKP7Vr9l+P8AmH+ruE/ml96/yPBf+FbeLP8AoFf+TMX/AMVR/wAK28Wf9Ar/AMmYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/hW3iz/oFf8AkzF/8VR/wrbxZ/0Cv/JmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/wCFbeLP+gV/5Mxf/FUf8K28Wf8AQK/8mYv/AIqveqKP7Vr9l+P+Yf6u4T+aX3r/ACPBf+FbeLP+gV/5Mxf/ABVH/CtvFn/QK/8AJmL/AOKr3qij+1a/Zfj/AJh/q7hP5pfev8jwX/hW3iz/AKBX/kzF/wDFUf8ACtvFn/QK/wDJmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/4Vt4s/6BX/AJMxf/FUf8K28Wf9Ar/yZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf8AhW3iz/oFf+TMX/xVH/CtvFn/AECv/JmL/wCKr3qij+1a/Zfj/mH+ruE/ml96/wAjwX/hW3iz/oFf+TMX/wAVR/wrbxZ/0Cv/ACZi/wDiq96oo/tWv2X4/wCYf6u4T+aX3r/I8F/4Vt4s/wCgV/5Mxf8AxVH/AArbxZ/0Cv8AyZi/+Kr3qij+1a/Zfj/mH+ruE/ml96/yPBf+FbeLP+gV/wCTMX/xVH/CtvFn/QK/8mYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/AIVt4s/6BX/kzF/8VR/wrbxZ/wBAr/yZi/8Aiq96oo/tWv2X4/5h/q7hP5pfev8AI8F/4Vt4s/6BX/kzF/8AFUf8K28Wf9Ar/wAmYv8A4qveqKP7Vr9l+P8AmH+ruE/ml96/yPBf+FbeLP8AoFf+TMX/AMVR/wAK28Wf9Ar/AMmYv/iq96oo/tWv2X4/5h/q7hP5pfev8jwX/hW3iz/oFf8AkzF/8VR/wrbxZ/0Cv/JmL/4qveqKP7Vr9l+P+Yf6u4T+aX3r/I8F/wCFbeLP+gV/5Mxf/FUf8K28Wf8AQK/8mYv/AIqveqKP7Vr9l+P+Yf6u4T+aX3r/ACPBf+FbeLP+gV/5Mxf/ABVH/CtvFn/QK/8AJmL/AOKr3qij+1a/Zfj/AJh/q7hP5pfev8jwX/hW3iz/AKBX/kzF/wDFV13w48Ja3oPiOe61ay+zwvaNGreajZYuhxhST0Br0yis6uY1asHCSVn6/wCZvh8jw1CrGrGUrr0/yCiiivNPcCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooqtf6lZaXbG41G6itoh/FIwGfYepppNuyFKSirt2RZorz/V/i3pVruTSbaW+fs7fu0/Xk/kK5K++KviK6yLdrazHbyotx/Ns1308vxE9bW9Tx62dYOk7c3M/LX8dj22ivnebxj4inJ361ejP9yYp/LFVTr+sFtx1a+z6/aX/AMa6VlNTrJHA+I6PSD/A+kqK+bv+Eh1r/oL3/wD4Ev8A40f8JDrX/QXv/wDwJf8Axp/2TP8AmF/rJT/59v7z6Ror5u/4SHWv+gvf/wDgS/8AjW14QvdZ1nxZYWb6rftG0oeUG5fBRfmIPPcDH41M8rlCLk5bF0+IIVZqEabu3bc93ooorxz6YKKKKACiisfxF4o0/wAMW8MupeaRMxVBEoY8DJ7iqjGU5csVdkVKkKUXObskbFFcP/wtrw7/AHL3/vyP/iqP+FteHf7l7/35H/xVdH1PEfyM4v7Swf8Az8R3FFcP/wALa8O/3L3/AL8j/wCKo/4W14d/uXv/AH5H/wAVR9TxH8jD+0sH/wA/EdxRWL4c8VWHiiO4fTUnVYCoYzIFyTnpgn0rarnnCUJcslZnZTqQqwU4O6YUUUVJoFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRSMyohZ2CqoySTgAUALRXB+IPirpmmu9vpMZ1CdePMDbYgfr1b8OPevPtS+IPiTUmbdqL20Z6R2w8sD8R835mvRo5dXqq70XmeLic6wlB8qfM/L/ADPfaK+ZZNQvZSTLdzuT1LSsc/rVm08QaxYsrWmqXcW08BZmx+WcGup5TK2k/wADzlxJC+tN29f+AfSNFeT+HPizcRzLB4kjWWI8faYkwy+7KOCPpj8a7jX/ABjp2ieHk1VHW7Wfi2SN8eafr2A7+lefUwdanNQa32PaoZlha1J1YyslvfdHQUV5rY/FyS/1C3tIdB/eTyrGv+l92OP7nvXpVZ1sPUotKorXNsNjKGKTdF3t5NfmFFFFYHWFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRXl3xD8fuskui6HNtxlbm4Q857op/mfwrehQnXnyROPGYynhKXtKnyXc0/GHxLt9JaSx0TZdXq/K8p5jiP/sx/T+VeS6jqd7q121zqVzJcTN/E5zj2A6AewqrSojSOqRqWZjhVAySfSvqcPhaeHj7q17n59jMwr4yV5vToug6GGS4mSGCNpJJGCoiDJYnsBXoeg/CS7uoxNr1z9jB5EEWGf8T0H611XgPwTF4esUvL+NX1OVcsTz5IP8I9/U/hXZV5WKzKXNyUdu59Fl2Rw5FUxKu307ep478QfC2h+F9Is00+OU3dxKf3kspY7FHPHA6le1ef123xW1L7Z4v+yqcpZwrHj/aPzH9CB+FcTXq4Pn9hFzd29T57M/Z/W5xpJJLTTy3/ABCur+HWgW+v+JjHfw+dawQtJIhJAY9AOPc5/CuUr2D4Q6b5GhXeoOMNdTBFP+yg/wAWP5VOOqulQk1vsXlOHVfFxjJXS1fyN/8A4V/4X/6BEX/fb/41c0zwroujXZudMsI7eYqU3hmJwe3J9q16K+WdarJWcn95+gxwuHg+aMEn6IKKKhvLyDT7KW7vJFighUs7t2FZpNuyN20ldlPWPEGl6BHFJq92tuspKplWYsR14UE1X0rxhoWt3v2TS77z59pfYIXXgdTkqBXiPivxHN4m12W8k3LCvyQRn+BB0/E9TXafBzT8zalqLD7qrAh+vzN/Ja9epgIUcP7SbfMfNUM4q4nGqjSS5L763svmeqV5n8UNI1rW9Wso9N0+e4t7eEneg43seR+SrXplFedQrOhU50rnt4zCxxdF0pOyfY+e/wDhCPEv/QGuf++RWLcW8tpcyW9yhjliYo6HqpHUV9M3VwlpZzXMxxHDG0jH2Aya+Z7q4e7vJrmY5kmkaRj7k5NfRYLFVMTzcyskfFZrl1HAqKhJtu+5FRRSqrO4VASzHAA7mvRPDPcPhdp/2LwVFMww93K8x+mdo/Rc/jXY1U0qxXTdHtLJelvCkfHfAxmrdfFVqntKsp92fqeFpexoQp9kgooorI6QooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooqpqep2uj6bNfX8gjghXLHufQD1JppNuyJlJRTlLZDdX1iy0PT3vdSmEUS8D1Y+gHc14l4r8daj4lmeJWa20/PyW6n73u57n26D9apeKfE954o1Q3FySkCEiCAHiNf6k9zWJX02DwMaK556y/I+DzPN54lunSdofn/wPIKKK9J+HfgNb1Y9Z1uINb9ba3ccSf7TD09B3+nXtr14UIc8jy8JhamLqqnT/wCGOe8P/D/WvEEK3EcaWtq33ZpzjcP9kdT9envW3qHwg1G3s2lsb+G7lUZMJQxlvYHJ5+uK9fAAAAGAOgFFfPyzOu5Xjoux9nTyDCRhyyu33v8A1+p8vMrI5VwVZTggjBBpTI7RrGzsUTJVSeFz1wK6/wCJujDS/F0k8S7Yb5fOXA4DdGH58/8AAq46voqVRVYKa6nxOIoyw9WVKXR2Ov8Ahjpv2/xrDKwylnG05+v3R+rA/hXudec/B/TfK0i+1F1+a4lESE/3VGT+rfpXo1fNZjU58Q120Pu8ko+ywab3lr/XyCiiivOPaCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiq2o38Gl6bcX1222GBC7e+Ow9z0ppNuyFKSim3scj8SPF39h6b/Z1jJi/ul5ZTzFH0LfU9B+J7V4pV7WdVn1vWLjULs/vJ3zjPCjso9gMCqNfXYTDrD0+Xr1PzXMcbLGV3P7K29P+CFeh/Crwz9t1Ftau0zBattgBH3pPX8AfzI9K8/ghkubiOCBS8krhEUdyTgCvo7QNIj0LQbTTosHyYwHYfxMeWP4kmufMq/sqXIt5fkduR4NV8R7SS0j+fT/M0abI6xRtJIQqKCzE9gKdXOePtS/szwTfyKcSTJ5Ce5fg/pk/hXzdODqTUF1Pua1VUaUqj6Js8L1a/bU9Yu7585uJmkwewJyBVSiivtkklZH5TKTlJye7Cvo3wxpv9keF9PsiNrxwguP9s8t+pNeFeE9N/tbxZp1mV3I0wZx/sr8zfoDX0VXh5tU+Gn8z63hyj8dZ+n6v9AorldV+Iug6RqM9lcvcNNA21xHFkZx0zmsS9+MWnIh/s/TbmZ/+mzLGP03V5kMHXnqos96pmWDpNqVRafP8j0OSRIYmkldURBlmY4Cj1Jrxb4geN/8AhILj+z9NZhp0LZLdPPYd/oOw/H0xk+IvG2seJcx3cohtc5FvCML+Pc/jXPV7WDy/2T56mr/I+WzPOfrMfY0dI9X1f/ACvdvhpp/2DwPasRh7pmnb8Tgf+OqK8Jr1yx+KugWGnW9pFZahst4liX5E6KMf3/arzGFSpTUKavqY5JVoUa0qlaVtLL5no1FcHD8W9GnnjhisNQZ5GCqNicknA/jrvK+dqUalK3OrXPt6GKo4i7pSvY5f4jah/Z/ge92nD3G2Bffcef8Ax0NXgteo/GPUP+Qbpqn+9O4/8dX/ANmry6vo8tp8uHv3Ph89re0xjj/Kkv1/UK3vBOn/ANpeNNNgIyqzCVvonzf0x+NYNejfB7T/ADdYvr9hxBCIlPu5z/Jf1rpxVT2dCUvI4cvo+2xdOHn+Wp65RRRXxx+nBRRQTgZPAoAKK5XWfiN4f0eQxfaGvJh1S1AfH1bIH61zMvxmUMRBohK9me6wfyC/1rrhg8RUV4x/T8zzquaYOi+WdRX8tfyPUKK890z4vabczLHqdjNZA/8ALRW81R9eAfyBrs7jWrG30KTV/OEtmkRl3xHO4e3v2+tZ1MPVpNKcdzWjjcPXi5U5p23L9FcL/wALc8Pf88L/AP79L/8AFUf8Lc8Pf88L/wD79L/8VV/U8R/IzP8AtPB/8/Ed1RXK6H8QtJ8QatHp9hDeCaQMQZI1CgAZ5IY11VY1Kc6btNWZ1Ua9OvHmpO6CiiiszYKK53VfHfh7SHMdxqCyyjrHbjzCPYkcD8TXOz/GLTFJ+zabdyD1kZU/kTXTDCV5q8Ys4KuY4Sk7TqK/3/keiUV5qnxktS/7zR5lX1WcE/lgV0GjfEXw/rEixC4aznY4Edyu3J9m5H6054PEQV5RJpZng6suWFRX+78zqqKKK5T0QooooAK8R+I3iw67q5sLOTNhZsQMHiV+hb6DoPxPevQfiL4i/sLwy8cD7bu9zFFg8qP4m/AHH1IrwqvcyvDX/fS+R8ln+OathYPzf6L9fuCiiivePjzpPA3hk+JtfWOYH7HbgSXBHcdl/H+Wa98RFijVI1CIoAVVGAAO1c74E8Pjw/4XgjkTbdXAE05I5DEcL+A4+ua6SvlMdiPbVdNlsfo2U4JYXDq696Wr/wAvkFFFFcB655x8Y7VW0nTbr+KOdo/wZc/+yV5JXsfxdDSeG7KONGdjdhvlGcAI3+NeZ+HdGm1PxHYWckEgjlmUSZQ/dBy36A19Pl81HC3l0ufA5zSc8wcYrV2PcvCOm/2T4R060I2uIQ7j/ab5j+prZoqve6hZ6bbmfULqK2i/vyuFB9ua+bk5VJt9WfcwjGjTUdkl+RYori774q+HbRykDXN4R3hiwv5sRWaPjHp+/nS7rb671z+VdEcFiJK6gzjlmmCg7Oovz/I9Gorm9D8e6Fr0qwW9w0FwxwsNwuxm+hyQfpnNdJXPOnOm7TVmdlKtTrR5qck15BRRVHWNXtdC0uXUL9mEEZAO0ZJJIAwPxqYxcnZblylGEXKTskXqK4r/AIWt4b/vXf8A35/+vR/wtbw3/eu/+/P/ANeuj6piP5GcX9pYP/n4vvO1oriv+FreG/713/35/wDr1f0bx9o2u6pHYaf9paaQEjdFgAAZOTn2pSwtaKu4uxUcfhZyUY1E2/M6aisLW/GeiaAzR314GnUf6iEb3/EDp+OK5O4+Mlkr/wCi6TPIvrJKqH8gDTp4WvUV4xFWzHCUHy1JpP7/AMj0mivPbD4v6XPIFv7G4tQTjehEij3PQ/kDXc2GoWmqWa3Wn3EdxA3R4zkfT2PtU1cPVo/HGxeHxmHxP8Kaf9dizRRRWB1hRRRQAUUVlax4l0jQVzql9HC+MiIHc5/4COfxqoxlJ2irsidSFOPNN2XmatFecXvxisI2IsNLuJ/eWQR5/LdVaL4zDf8AvtEwnqlzkj/x2uxYDEtX5fyPMecYFO3tPwf+R6hRXPeHvG+jeI2EVpM0Nzj/AI95wFY/Tsfwroa5J05U3yzVmejSrU60eem7oKKKKg1Ciis/Vdd0zRIRJqt7Fbg/dDHLN9FHJpxi5OyVyZTjCPNJ2RoUVwF58XtHhZls7O7ucdGICKf1J/SqkXxktDIBNo8yJ3KTBj+WB/OutYHEtX5TzZZtgYuzqL8f8j0qiue0LxzofiBxFaXJhuD0guAEc/TnB/A10Nc06c6b5ZqzO+lWp1o81N3XkFFFFQahRRRQAUUUUAFeZ/F3XTFbW2iQNgy/v58f3QcKPzBP4CvTCcda+dPFOrnXPE17fA5jeQrF/uDhf0Ga9PLaPtK3M9ongZ7ifY4b2a3lp8uv+RkUUUV9OfAnZ/C/SP7S8XJcyLmGxQynPTd0Ufnk/wDAa9vrzL4Z6noeieHpXv8AUrWC6upizI8gDBV4UH9T+Ndl/wAJl4c/6DVn/wB/RXzGP9pVru0XZabH32T+xw+EjeSu9Xqv62NuvL/jFqXy6dpiHqWuJB/46v8A7NXa/wDCZeHP+g1Z/wDf0V41471iPWvF93cW8gkt02xQsDkFVHUexOT+NVl1Cft1KStYnOsZTWEcISTcmlo/mc7RRRX0p8Gei/B/TfO1i91Fx8tvEIkJ/vMf8F/WvXTwK4/4Yab9g8FwysMPeSNMfp90foufxrsK+Sx1T2mIk+2n3H6TlNH2ODgur1+//gHhOoeC/Feoanc3kmkS7riVpT+8T+I59fesvUvCet6PZm61Kwe3gDBd7Op5PQcGvoqvN/jFfbNL06xB5mmaUj2UY/8AZ/0r0MNmFWrUjTsrHiY/JsPh6E6/M216bv5HktFFFe6fIlvTdLvdXu/s2m27XE20tsXHQd+a1v8AhAvE/wD0B5v++l/xrrvg5p2ZNR1Nh0C26H6/M38lr1OvGxWYzo1XCCWh9Tl+S0sTh1VqSab7W/yPGPCPgXWofFlhPqmnSQW0Enms7FcAqMr0PqBXs9FRXVwlpZzXMxxHDG0jH2Aya8jEYieJmnJH0uCwVLA03GD311PC/iNqH9oeOL3acpb7YF9to5/8eLVy1S3Vw93eTXMpzJNI0jH3Jyair6ylD2dNQ7I/OMRVdatKo+rbCvbvhXp/2Pwatwww15M0mfYfKP8A0En8a8SUFmCqMknAA719KaNYDS9EsrEf8u8CRnHcgcn868zNalqSh3f5Hv8ADtHmryqP7K/P+mXaKKa7rFGzyMERQSzMcAAd6+cPtyG/v7bTLGW8vplhgiGXdu3+J9q8V8X/ABBvvEMklrZM1rpucCMHDSj1Y/06fWo/HfjGTxLqRgtmK6bbsREvTzD/AHz/AE9B+NcnX0mCwKppVKi978v+CfDZrm8q8nRou0O/f/gfmFWrDTL7VJfL06zmuXHURIWx9cdKu+GNAm8Sa9DYQkqh+eaT+4g6n+g9yK+gNM0uz0fT47PToVhhjHAA5J9Se5962xmNWH91K7ObLcqljbzk7RX4nztqWi6lpBQanYz22/7pkQgN9D0p1vrd9baLdaVHMfsd0VLxnoCCDkenTn1r3fxjpSax4Sv7Zl3OsRli9Q6jIx+WPxr54p4TELFQvJap/wDDEZjgpZfVSpydpL/gNBRRRXeeOekfB3T/ADNS1DUGHEMSwqT6scn/ANBH5161XHfC7T/sXgqKZhh7uV5j9M7R+i5/Guxr5LHVOfESfbT7j9Jymj7LBQXfX79SK5uYbO1kubqRYoYlLO7HhQK8T8X/ABBvtfmktrB3tNO5ARThpR6sf6dPrXR/F3XXjjttEgbAkHnz47jOFH5gn8BXldenl2Eio+2mtXseBneZTdR4ak7Jb+fkFaWi+H9S8QXRg0q2aYqMu2cKg9yeBWbXvPw4s4LXwNZPAo3T7pJGH8TbiP0AA/Cu7GYh4enzJas8nK8CsbX5JOySuzza5+F/iW3hMiwQT4/gimG79cVyU0MtvM8M8bRyxsVdHGCp9CK+jPEmovpPhq/vof8AWQwsUyOjdAfzNfOUssk8zyzOzyOxZmY5LE9SaywGIq4iLc7WR05vgsPg5RjSvd9z0H4b+Nbi11GHRdSmaW0nOyBnOTE/YZ/unpjscV6/XzFaM6XsDQ/6xZFKY9c8V9O15uaUYwqKUep7nD+JqVaMqc3fltb0fT8AooqlrOoLpWh3l+2P9HhZwD3IHA/E4FeTFOTsj6KUlCLk9keLfEjWjq3i+eNGzBZf6Og9x94/99ZH4CuTpzu0sjSSMWdiSxPcmm19rSpqnBQXQ/K8RWlXqyqy6sK6PwFow1vxfaxSruggPnyjttXoPxOB+Nc5Xrvwg0sQ6Peam6/PcS+UhP8AdXr+ZP6VhjavsqEpLfY7Mrw/1jFwi9lq/kei0UUV8gfpQUUUUAFFFea/Ebx21r5mi6LNifpczofuf7Cn19T26dem9ChOvPkicmLxVPCUnUqf8OXfGPxKg0d5LDRQtzer8rynmOI+n+0fboP0ryXUdUvtWujcaldSXMp/ikbOPYDoB7CqlXtG0qfW9Yt9PtB+8nfGSOFHUsfYDJr6ijhqWGhdfNn5/isdiMfUs9nskP0fQNT164MOlWjzlfvMMBV+rHgVf1vwRrnh+0+1X9spt84aSJwwQ9s+le56No9poWlxWFhGEjjHJ7u3dj7mrF7aRX9jPaXK7op4zG49iMV5cs1l7T3V7v4n0MOHafsffk+f8LnzICQcjg16/wDDTxnLqiHRtVlMl1Eu6CVjzIo6qfUj9R9K8kuYHtbqW3l+/E5RvqDg1Lp1/PpepW99aNtmgcOp+nY+x6V6uJoRxFPl69D5zA4yeCrqa26ryPpmuV+IGh6n4h0WCx0oR/64SSmR9vABwPzP6V0dldR31hb3cPMc8ayL9CMj+dT18nTnKlNSW6P0atShiKTg3pLsfPmv+DNU8NWcdzqZtwkj7ECSbmJxnpjpxWBXZfEzxANY8TG1gbdbWGYlx0Z/4z+YA/CuNr6/DyqSpKVTdn5rjYUadeUKPwrT/MKu6bq13pEk0mnyeTNLEYjKv3lUkE7T2PHWqVdL4K8Iy+KtTIkLRWMGDPKOp9FHuf0q6soQg5T2M8PTq1KqhR+J7HNktIzMxLMTkk8k+9JX0tpuk2GkWq22m2sdvEBjCLy31PUn615T8VvD9vpupWuo2MKwx3YZZVQYUOMc49wf0rgw+YRrVfZ8tux6+MyWphaHtnK9t1b+rnn9dB4P8U3HhjWEkDs1nKwFxD2Zf7wHqOv6Vz9FehOEakXGWzPFpVZ0ZqpB2aPqCORJY1kjYMjgMrDoQe9OrkPhlqx1LwbFFK26WycwHP8AdHK/oQPwrr6+Mq03SqOD6H6jh6yr0Y1V1VwpskqQxNLM6xxoCzMxwFHqTSTTR28DzTuscUalndjgKB1JrxPxz47l8RTtZaezRaZG3ToZyP4m9vQfifbfC4WeIlZbdWcuPx9PBU+aWrey7mz4u+KUkrSWXhomOMcNeEfM3+4Ow9zz9K82lmknmaWeRpJHOWd2JLH1JNMpURpJFSNSzsQFUDJJ9K+oo0KdCNoI/P8AFYyti581V/LovQtabpl5q98lnp1u8879FUdB6k9h7muxPwi10WvmC5sjLjPlb2z9M7cZ/SvQ/BXhWLwxoqI6qb6YBriQev8AdB9B/wDXrjfiB4/v7fVpdI0SY2yW52zTp95m7gHsB+ea8765Wr1vZ4e1l1Z7n9mYbB4X22MvzPov6+885nhudNv3hmV7e5t3wRnDIwPr/WvcPh94nfxJoJF22b20IjmP98H7rfjg/iDXhtzcz3lw093NJPM/3pJXLMe3JNd18IJ2TxRdw5+WS0JI9w64/ma3x9JTw7lLdHHk+IdLGKEfhlp/l8z2OiivMPiN47MbS6Ho0uG+7dTqenqin+Z/D1r52hQnXnyRPtsZi6eEpOpU+Xmyz4z+Ji2Ekmn+HmSW4HyyXX3ljPovYn36fWvKLm6nvbh57uaSeZzlnkYsT+JqKr2jaTca5rFvp1oP3k743EcKOpY+wGTX1NGhSw0NPmz89xWMxGPqrm67IdpGg6nr1wYdKtHuGX7xGAq/VjwKv634J1zQLUXV/aj7PnDSROHCn3x0r3TRtHtNC0uKxsIwkcY5Pd27sfUmrF9ZxahYT2dyu6KeMxuPYjFeVLNZe091e7+J9FDh2Hsfek+f8LnzKrFGDKSrA5BB5Br2H4c+OJNYA0jVnL3qKTDMf+Wqjsf9ofqPpz5DcwPa3UtvLw8TlG+oODUum382l6nb31scS28gdffHb6HpXq4nDxxFO3XofPYHGVMFXUlt1XkfTNFQ2d1HfWMF1AcxTxrIh9iMiivkGmnZn6WmmromooopDCiiigDD8Z6j/Zfg7UblW2v5JjQ9wzfKD+ufwr55r1z4waj5WkWOnKfmnlMrAf3VGP5t+leR19NldPloc3dnwef1ufFci+yvxev+QUUVp+HNP/tTxLp9lt3LLOocf7IOW/QGvTlJRi5PoeDCDnJQW70KH2ef/njJ/wB8mj7NP/zxk/74NfT1FeF/a7/k/H/gH1v+ra/5+/h/wT5hMEygkxOAOpKmo69z+Jup/wBn+C541bEl46wL9Dy36Aj8a8Mr1MLiHiIc7VjwcxwccFV9kpc2l9rBUlvA9zcxQQjdJK4RR6knAqOup+HOm/2j43s9wylrm4b22/d/8eK1tVmqcHN9Dkw9J1q0aa6tI9ysbRLDT7ezh+5bxLGv0Ax/Sp6KK+Kbbd2fqqSirIK8Q+KOp/b/ABi8CNmOyjWEY6bvvN/PH4V7JquoR6TpN1fz/ct4mcj1wOB+J4r5tubiS7u5bmdt0szmR29STk17GVUrzdR9D5jiLEctKNBbvX5L/g/kRUUVJbwPdXUVvEMySuEUepJwK+h2Pi0m3ZHu3w507+z/AAPZZGHuM3De+48f+Oha6iorW3Szs4baLhIY1jX6AYH8qlr4mrP2lRz7s/VsPSVGjGmuiSCuU+JOqDTfBVygbEl2Rbp+PLf+Og/nXV1458WtYF54gg02Jsx2UeXwf+Wjcn8gF/M104Gl7WvFdtThzbEewwk31ei+f/AOAooor60/Njc8Gaf/AGn4y023IyvnCRx/sp8x/livoavIfg/p/na3e37DIt4RGv8AvOf8FP5169XzOaVOavy9kfecP0eTCuf8z/LT/MK85+K3iY2lmmh2j4luF33BB+7H2X8SPyHvXfX99Bpunz3t22yGBC7n2H9a+ctY1SbWdYudQuf9ZO5bGfujsPwGB+FGW4f2lTnlsvzHnuM9hQ9lF+9L8uv37feUqKKVVLsFUZZjgAd6+mPgz2P4TaMLPw9LqciYlvXwhPaNeB+Zz+ld9VTSbFdM0e0skxi3hWPjuQME1br4zEVHVqyn3P1LB0Fh8PCkui/Hr+IEZGD0r5ecYdgOgNfR3iTUBpfhnULwnBigbbj+8Rhf1Ir5wr2Moi+WcvQ+Y4kmnKnDqrv77f5BSojSSKiAszHAA7mkrf8AA2n/ANpeNNNhIyiS+c/0T5v5gD8a9ipNQg5PofMUabq1I011aR7xpVkum6RaWSdLeFI+O+BjNW6KK+Jbbd2fq0YqKUV0PEPiojr44kL52tBGU+mMfzBrjK9j+Knht9S0qPVbRN09kCJVHVouufwPP0JrxyvrMDUVShG3TQ/Os3oSo4yd9par5hXofw48bw6Sv9j6u4jtXctBOekbHqp9FJ5z2OfXjzyit61GNaDhI48LiqmFqqrT3/M+mNQsodW0m4s5iGhuYihYc8EdR/OvCtX8B+INJumi/s+a7jz8k1rGZAw9cDkfjVrwl4/v/DjLbXO6707PMTH5o/dD/Tp9Otez6RrFjrmnreabOs0TcHsVPoR2NeH+/wAvb0vF/wBfI+tf1TOopt8s10/rdHlvgj4eajLq8Goa3bta2tuwkWKTh5WHIG3sM9c/SvYKKK4MRiJ4iXNI9jBYKlgqfJT67sK4L4t6l9m8MwWSNhrycbh6onJ/UrXe15H8Y5y2sadb/wAMduzj6s2P/Za1wEFPERv6nPnFR08FNrrp97/yPOaKKK+sPzgK+iPB9j/Z3g/TLfG1vIV2HozfMf1NfPdtCbi6igXrI4QficV9OooRFRBhVGAPQV4mbT92MT6zhunedSp2SX3/APDC0UUV4B9iFFFR3FxFa20lxcOI4okLu56KAMk0bibSV2cz498Vjw1ouy2Yfb7oFYB/cHd/w7e/414QzM7lnYszHJJOSTWt4o16XxHr89/JkRk7YUP8CDoP6n3JrIr63B4ZUKdnu9z84zTHPGV218K0X+fzCvVvhDomy3u9ZmT5pD5EJI7Dlj+JwPwNeUgEkADJPQCvpDw9pg0fw7Y2AGGhhUPj+8eWP5k1hmdXko8i6nZkGHVXEuo9or8Xt+ppUUUEhQSTgDkmvmT7w+bvEQ2+KNVA6C8mH/j5rOqa8nN1fT3B6yyM/wCZzUNfcQVopH5NUkpTbXc98+Hcxn8A6azHJVXTn2dgP0Ao8deJ18NaCxhYfbbkGO3X0Pd/w/niqng69tdA+F9ne6g/lRIjyMe5y7EAepOQBXkvibxDceJdakvrn5F+7FFnIjQdB/U+9fP0cL7bFTk/hTf57H2eKzD6rgKcIv35RXy03Mgkkkk5J6k0UUV9EfEiojSOqICzMcADua+ifC2hx+HvDttYqB5oXfMw/ikP3j/T6AV418PtNGpeNrFHXdHAxnf/AICMj/x7Fe+14ObVXeNJep9hw7h1yyrvfZfqFed/GLb/AGDp+fvfaTge205/pXoleW/GW5Bk0m2B5AkkYfXaB/I1w4BXxMf66Hr5xJRwNS/l+aPL6KKK+sPzc9Q+DU536tAT8uInA9PvA/0r1IkAEngDqa8u+DUBzq1wfu/ukH1+Yn+lQfETx79pMui6JL+5Hy3Nwh+/6op9PU9+nTr85iMPKvjJRh5X+4+5wWMhg8shUqedl31ZS+Injj+2J20rSpP9Ajb97Ip/17D/ANlH69fSuCoor3qNGNGChE+PxOJqYqq6tR6v8PIK7X4XaINT8UfbJl3Q2C+ZyOrnhf6n8K4qvbfhXpos/B4uiuJL2VpCe+0HaB+hP41zY+r7Og7bvQ78nw6r4yN9o6/d/wAGx2tfP3jvT5tO8aaiswOJ5TPG2OGVznj6ZI/CvoGsvW/Dml+IrdYtVthLszscEqyfQj+XSvAwWJWHqXktGfYZpgXjaKjF2ad0fONep/CPQZojc63cIUSRPIgyPvjILN9MgD863rH4XeG7O4ErxXF3g5CXEmV/IAZ/Gt3XNYs/DWhyXlwFWOJdsUS8b2/hUD/OBXfiscq8fZUVueRl+USwlT6xiWko6/8ABZgfETxh/wAI/posrCTGo3S8EdYU6Fvr2H4ntXiBJYkk5J5JPereq6nc6xqk9/evvmmbcfQDsB7AcVUr08Jhlh6fL16ngZjjpYytzfZWy/ruFer/AAh0Ty7W61mZPmlPkQkj+EcsfxOB+BrykAswCjJJwAO9fSHh/TRo/h6xsAADBCqvju3Vj+ZNcuaVeSjyLqehkGHVXEuo9or8X/TNGiigkAEk4A6mvmj7s+bvEQ2+KNVA6C8mH/j5rOqa8nN1fT3B6yyM/wCZzUNfcQVopH5NUkpTbXc98+Hdy1z4D05nOWRXjP0VyB+mKKb8OIDB4B0/d1fzH/Au2P0or47EW9tO3d/mfp2Bv9Vp3/lX5HUUUUVgdYUUVHcTpbW0s8x2xxIXY+gAyaNxN2V2eI/E/Uvt/jWaJTlLONYR9fvH9Wx+FcfU99dvf6hcXc3+suJWkb6k5/rUFfa0afs6cYdkfleJrOvXnU7thXofwi0g3Gt3GqyL+7tY/LQn++3+C5/MV59HG8sqxxKXdyFVQMkk9BX0N4S0FfDnhu3seDNjzJ2HeQ9fy4H4VxZlW9nR5VvL+metkeFdbEqo9o6/Pp/n8jaooor5c+/PIvjBqXnaxZach+W3iMjgf3mP+C/rXnVbHivU/wC1/FeoXituR5isZ9UX5V/QCsevssLT9lRjHyPzDH1vb4qdTz/BaIK9W+Dum7bXUNTccu6wIfYDc381/KvKa+gPAdgNP8EaagHzSxeex9S/zfyIH4VyZnU5aHL3Z6OQ0faYvnf2Vf8AQ6KiiszxDrtt4d0aa/uyPlGI488yP2Uf56Zr5qMXJqMd2fdznGnFzk7JHCfFvxBtjg0K3fl8TXOD2/hX8+fwFeV1Y1C/uNT1Ce9vH3zzuXc+/p9O1V6+ww1FUKSgfmeOxTxeIlVe3T0Cul+Hth9v8caerDKQsZ29toyP1xXNV6D8H4A/iS9nIz5drtHtlh/hSxcuShJ+Q8upqpi6cX3/AC1PYaKKCQoJJwBySe1fHH6cUNc1eDQ9FudQuSNsKEqufvt2X8TXzld3Ut9eTXVy2+aZzI7epJya674i+L18QaitlYPmwtWOGB4lfoW+g6D8T3ri6+oy/DOjT5pbs+AzrHLE1uSD92P4vqFFFFekeCe2fCrT/sng4XLDDXkzSZ/2R8o/kfzrtqoaFZDTvD9haKMeTbop+uOf1zVbxR4gg8NaHLfTENJjbBGT/rHPQfTufavjarlXrtx6s/UMPGGEwkVPRRWv6nC/FrxHnytBtX9JbrB/75X+v5V5fU13dTX15LdXUhkmmcu7HuTUNfV4eiqFNQR+eY3FSxdeVV/L0CtTwzbfbPFWlwYyHuo9303An9Ky66DwL/yPOlf9dv6GrrO1OTXZmWGipV4RfVr8z6Cooor4k/VTg/i1qYtfDEVirYkvJhkeqLyf1214zXV/EbWxrPi2YQvut7QeRGR0JH3j+efwArlK+twNL2VBJ7vU/N82xCxGLlJbLRfL/ghXpHwd0/zNS1DUWHEMSwqT6scn/wBBH515vXuXwv077D4KilZcPdyNMc9cfdH6Ln8ajManJh2u+htkdH2mMT/lu/0/U7Cs7VPEGk6Lgapfw27MMhGbLEeu0c4qxqV4NP0q7vSu4W8LylfXapOP0r5tvr641K+lvLyRpZ5mLOxP+eK8XBYP6y25OyR9RmmZvAqKiryZ9Eab4i0fWiU03UILhu8YbDY/3TzivN/HXw5ktJJdU8PxGS3Y7pbVBzF6lR3X27fTp55BPLa3CT28jRSxsGR0OCp9Qa+i/Dmovq/huwvphiSaFWf/AHuhP5iuqrSnl8lUpu6ZwYevTzmEqNeNpLVNHzhRXtXjH4c2mtrJe6SEtdQ+8y9EmPv6H3/P1rxq5tprO6kt7qNopomKujDBUjtXrYbFU8RG8d+x83jsBWwU7T1T2fcirU0DxDfeHNSW70+THQSRE/LKvoR/XtWXRXRKKmuWS0OKE5U5KcHZo+ktC1m21/R4NQsz8ko+ZT1Rh1U/StCvMvg1cyNa6rbEkxxvHIoz0LBgf/QR+Vem18fiqSo1pQXQ/TcBiHicNCrLd/poFeP/ABhjI8Q2MvZrXaPwc/417BXnPxh08y6TYX6rnyJWiYjsGGR+q/rW+XyUcTG/U5M6pueBnbpZ/ieR0UUV9WfnRoaCA3iTTQ3Q3cQP/fYr6Sr5ksbj7JqFtcf88ZVk/Ig19NKwdQykFWGQR3FeBm6fNB+p9lw21yVF5r9RaKKK8Q+rCvNPiv4mENuug2j/ALyXEl0Qei9VX8ev0A9a7XxL4gt/Deiy31zhmHywx55kc9B/U+1fPV9ez6jfTXl25kmmcu7HuTXr5bhueftZbL8z5vPcf7Kl9Xg/elv5L/gkFFFFfRnwxt+DNPGp+MtNtmGU84SMPUJ8xH6V9D1418I7QTeKri4b/l3tjt+rED+Wa9lr5rNJ81ZR7I+74fpcuFc+7/L+mFYnjHUf7L8H6lc5w3kmND/tN8o/U5rbry74v61/x56NC3/TxMAfwUf+hH8q5MJS9rWjE9PMcQsPhZz62svVnl1FFFfYH5ibeu+JJ9Xs7LT48xWFjEscUX94hcF29z+mfrmAaHPH4abWbnMUDyiG3BHMrckn/dAB59a6DwJ4Gk8RXAvtQVo9Mjb6Gcj+Ee3qfwHtp/F27jjutM0m2VY4reEybEGAMnaox7BT+dcHtoxqrD0vn/Xc9l4WpPDSxmI9I+fT7l0POKKKK7zxj034Oafm41LUWH3VWBD9Tub+S16rXI/DKw+w+B7dyMPdO87fido/RRXXV8jjanPiJP5fcfpWVUfZYOnHur/fqFeFfEzUv7Q8bXCKcpaItuvPccn9WI/CvbNSvotM0y5vrg4jt42kb3wOlfNd1cSXl5NczndJNI0jn1JOTXblNO85VH00PK4ir8tKFFdXf7v6/Aiooor6E+KOkt/FD6T4O/sfSiUnu3aS7nHBAPARfwHJ98Vj6Zpdxqtw8duvyxRtNNIfuxooyWNP0bRrzXtTjsdOj3yP1J+6i92J7CvXr7w5aeFPhrqlvZDfM9sfPnI+aQng/QcnArgrVqeHfLH4pP8Apns4XC1sbH2k/ggvy6L9TxKiiiu88YK+kfD1oLHw1p1sBgx20Yb67Rn9c184RgNIoPQkA19QAAAADAHQV4mby0hH1PrOG4LmqT9P1/yCiiivAPsRksscELyzOsccalndjgKB1Jrwbxv4sk8T6wTEWWwtyVt0PGfVz7n9BW78RvHP9pSPo2kS/wCiIcTzKf8AXMP4R/sj9T7deAhtprjzPIjZ/LQyOQPuqOpNfRZfhPZr2tTfp5HxOdZl7eX1ei/dW/m/8kR0UUV7B8wbvgrTxqfjPTbdhlBMJGHqEG7+mK+ha8b+EVoJvFFzct/ywtjj6swH8ga9kr5rNJ81ZR7I+84fpcuFc/5n+Wn+YVieMtS/srwfqNyDh/JMaf7zfKP55/CtuvLfi/rWWs9Ghbp/pEwB/BR/6EfyrkwlL2taMT0cyxCw+FnPray9WeX1JBDJc3EcEK7pJXCIvqScCo67D4ZaIdV8WR3Mi5gsB5zH/a/gH58/8Br6ytUVKm5vofnWGouvWjSj1Z7Rplkmm6Va2Uf3beFYwfXAxmirVFfFNtu7P1SMVFJLoFFcVqPj+HQvGl1perqRZ7UaOdFyYyVBIIHUfTn+m6ni3w88PmrrVjtxnBuFB/InNbSw9WKT5dGcsMZh5uUVJXTs0/I2K4z4ma+mleGJLKN/9KvwY1UdQn8R/Lj8ai134paPp8TJpROo3PQbQVjU+7Hr+H5ivItW1a81vUpL7UZTLNJ+AUdgB2Ar0MFgZymp1FZL8Txc1zalCk6NF3k9NNl/wSlRRXoPgn4cTalJHqGvRNDZD5kgbh5vr6L+p/WvdrVoUY802fI4bC1cVU9nSV/09S38L/B7Szpr+ox4jT/j0Rh95v7/ANB29+e1erU1ESKNY41CIoCqqjAAHYU6vk8RXlXqOcj9GwWDhg6KpQ+b7sKpazK8Gg380X347aRl+oUkVdpk8KXFvJDKMpIpRh6gjBrGLSabOuabi0j5goq3qunS6Tq1zYXAIkt5ChyOo7H8Rg/jVSvt001dH5NKLjJxe6CvpPQmRvDunNFgobWIrj02CvmytnTvF2vaTbC3sNTmihX7sZwwX6Ag4/CuHHYWWJilF2sevlWYQwM5OabT7Hver6zY6HYNd6lOsMa9AT8zn0UdzXhXi3xXdeKtT86UGK2iyIIM52j1PqTWVqGp32q3Hn6jdS3MnZpGJx7D0H0qzoPh7UPEV+LXTYdxHMkjcJGPUn/JqMNg6eFXtJvXv2NcdmdbMJKjSjaPbq/UzKK9S8X+BrfRvh+g01DLNazLNczEfNICCpP0GRx2Gfc15bXXQrwrxcoHm4vB1MJNQqbtXCu1+GOv2eia7PHqMywQ3UQUSscKrA5GT2HXmuKoq61NVYOEupnhq8sPVjVhuj6JvfF/h+whMlxq9qR/dikEjH8Fya8w8Y/Ei41yJ7HSVktLFuJGJxJMPQ46D27/AKVwtaug+HNS8R3ot9NgLAH95M3CRj1J/p1rgpYGhh/3k3e3c9fEZvi8b+5pq1+i3ZnRQSz7/JjZ9iF22j7qjqT7VHXu9h4Fs9J8JX2mWmJLq8t2SS5YYLsQcfQA9q8KdGjkZJFKupIZSMEEdq6MPio4hy5ehxY3L6mDjD2m8vw8htFFFdZ5p9AT+PPD1tpKXz6jC4dAywRMGkz6bRyD9cV414p8UXfinVPtNz+7hjysEAORGv8AUnuaxK6Hwp4PvvFF4BCphs0bE1yw4X2Hq3t+dedSwtDCXqN/Nnt4jMMVmTjQivkuvqQaN4Zu9Y0vUdQjUrbWMLSFsffYDO0fhkn/AOvWLX0pp+j2WmaQmmWkIW1VChQ87s9SfUmvBPFPh6fw3rs1nKpMRJeCQ/xoTwfr2PvSwmNWIqSj93oVmOVvB0YTWvf1Marek3x0zWLO+UEm3mSTA7gHJH41Uor0Wk1ZniRk4yUluj6cs7yDULOK6s5VlhlUMjqeorjPHnju30exl0/Sp1k1GQFC0ZyLcdyT/e9B+P18bju7iGJooriVI2+8iuQD9RUaI0kipGpd2OFVRkk+leRSyuEJ80nddj6XEcQVKtLkpx5W+t/yEorc13wpf+HtPsLnUF2teKxMeOYiMfKffBz/APqrDr1oTjNc0XdHzlSlOlLkmrMK988Ga7p114NsGFzDEbW3WKZXcLsKjBJz0zjP414HRXNisKsTFRbtY7svx8sDUc0r3Vj1Hx38Rreeym0nQH84TKUnuQPl2ngqvrn1/L1Hl1WtN0y81e+Sz06Bp536Ko6D1J7D3re8XeCbnwrDZzPJ9oimTbJIo4SXuv0x0PfBpUY0cNajF6v8R4mpisdzYma92P3IytC8Paj4ivlttOgZxkeZKR8kY9Sf6dTX0LplhHpelWtjBzHbxLGCR1wMZ/HrXhfgvxfL4U1GR2jM9pcACaMHB46MPcZP1r1W1+JHhe5jDHUfIbuk0TAj9MfrXnZlGvOSSjeK7Hu5FUwdKm5Snab3vp9x1NeL/FuGCPxfE8OBJJaq0uO53MAT74A/IV2msfFDQbC3f7BK2oXGPlSNSq592I6fTNeOapqdzrGpz398++aZtzHsPQD2A4pZbhqsantJKyHnmOoVKPsabUne+nQqUUV1/gXwVN4jvkuryNk0yJsu5480j+Bf6nt9a9qrUjSg5z2PlaFCpiKip01ds7v4V6JJpvhp72ddsmoOHUH/AJ5gYX88k/Qiu4pERY41SNQqKAFUDAA9KWvjq1V1ajm+p+nYWhHD0Y0o9ArN8RaQuu+H7zTmIBmjwjH+Fhyp/MCtKiojJxkpLdGs4RnFwls9D5gmhkt55IZlKSRsUdT1Ug4IplenfE3wZJ9ok1/TI96MM3cajlT/AHwPT1/P1x5jX2OHrxr01OJ+Y4zCzwlZ05/LzQV7r8O/EkWt+G4baSQfbbNBFKhPJUcK35Y/GvCqmtLy5sLlbiynkt5k+68bFSKzxeGWIp8uz6G2XY6WCrc9rp6NH05WZrniDTvD1k1zqU6px8kQOXkPoo7/AMq8Uf4heKXh8o6vIFxjKxIG/MLmsG6u7i9uDPeTy3ErdZJXLMfxNeXTymXN+8lp5H0FfiKHLajB38/+AavinxPd+KNUNzc/u4U+WCAHIjX+pPc1peGfBU+s6HqOqzqyww28n2ZenmyAH9B/P6GrPgv4e3WvSR3upq1vpoOQDw0/svoPf8vb2iC3htbZLe3iWOGNQqIowFHpW2KxkKEVSo9PwObL8sqYybxOK2f4+fp2/wAj5horpvHXheTw3r0nlp/oNyxe3YDgDun1H8sVzNetTqRqQU47M+crUZ0KjpzWqPSvg2V/tDVMn5/KjwPbJz/SvWK+e/B3iVvC+vLeNG0sDoY5o1PJU85HuCAa9Qn+KvhyK18yJ7maTHESwkHPuTgfrXgY/C1Z1+aMbpn2GT4/D08IqdSSTV9/vOn1fVbbRdKnv719sUK5x3Y9lHuTxXztq+pz6zq9zqF0f3s7liM8KOwHsBgfhWr4s8Y33iq6UzDyLSIkxW6nIHuT3PvWLZWN1qV2lrYQSTzuflRBkn/63vXoYHC/V4OU93+B42a5j9dqKnS+Fbeb/rYgrvPA/wAPJtZePUNZRodPHzJGeGn/AMF9+/b1rovCPwwh09477xBsuLgcpbDmOM/7X94/p9a9E6Vy4vMV8FH7/wDI9HLcjd1VxS9I/wCf+X3jIYY7eFIYI1jjjUKiIMBQOwFeAeOtR/tLxrqMoOUjl8lPog2/zBP417xql6um6Rd3r9LeF5Oe+BnFfNLu0kjO53MxJJPc1GUwvKVR+hpxFVtCFFev3aIbRRRXvnxp9L6VbR2Wj2dtAwaOGBEVl6EBQM1brxbwr8TLrQrKOw1C3+22sYxGwba8Y9PcenT61qaz8X5JrVotDsWgkYY8+dgSv0UcZ9yfwr5eeX4j2jSV/M/QKWdYL2Kk3ZpbW1J/iv4mUQpoFnJl2IkuiD0HVU/r+AryunzTSXEzzTu0kkjFndjksT1JNMr6DD0FQpqCPjMbi5Yuu6svl5IK1vD3hvUPEuoC20+P5VI82ZvuRj1J/p1Nb3hP4c3+vbLrUN1lYHkMR+8lH+yD0Huf1r2PTNLs9HsEs9OgWCFOgXqT6k9z71x4vMI0vdp6y/I9TLsmqYhqpW0h+L/ruU/Dnhqx8M6aLaxTc7YMszD5pT6n29B2qzrdidT0G+sh964t3jX2JU4/Wr1FfOOpJz529T7eNGnGn7KKtG1j5eZSjFWBVgcEEdDSV2vxL8NPpGvvqECf6HfMXBA4STqy/j1H4+lcVX2VGrGrBTj1Py/E0J4erKlPdACQQRwR0r6V0fUY9X0W0v4WDLPEGOOx7j8DkV81VsaL4r1nw+jR6XetFE5y0bKHXPrgjg/SuXHYV4mK5Xqj0cpzGOBnLnV4y7eR9ESSJDG0krqiIMszHAA9Sa8o8dfEcXiSaX4elIgYFZrocF/VV9vfv9OvG6v4q1rXV2anqEksf/PJcIn/AHyuAfxqLRNA1HxDfC20yAyH+NzwkY9WPaubD5fCh+8rPb7jvxuc1MX+4wsWr/e/8ipZWVzqN7FaWUTTTyttRFHU/wCe9ez6f4Eh0jwPqFjGFm1G8tmEkoHV9p2qPYH8+taPhLwbZeFrUlP397IMS3DDB/3V9B/OujrjxmPdSSjT2X4np5Zk8aEHOt8TVvS/6ny70orsfiL4XfQtde7t4z9gvGLoQOEc8sn9R7fSuOr6ClUjVgpx6nxeIoTw9V0p7o9M+DW37Zq2T8/lx4Htls/0r1avn3wZ4mPhfXhdvG0tvIhjmRepXOcj3BFen3HxU8NRW3mRS3E8mOIkhIbP1OB+teDj8NVlXcoxumfYZPj8PTwihUmk4339bnTavqttomlT39622KFc47seyj3J4r521bU59Z1a51C6P724csR/dHYD2AwPwrV8WeML3xVdqZh5FpESYrdTkD3J7msS0s7i/uo7azheeaQ4REGSa9DA4X6vBynu/wADxc2zH67UVOl8K283/Ww2CCW6uI4LeNpZZGCoijJYntXv/g3w0nhnQI7YgG6l/eXDju3p9B0/XvWV4F8Bx+HEF9qO2XUnXAxysAPUD1PqfwHv2lebmGMVV+zhsvxPeybLHhl7aqveey7L/MKKKK8k+iPJfiF4R1zUvFM+oWGnvcWzogDRspOQoB+XOf0ripfDWuQHEuj36+5tnx+eK+j6K9WlmdSnBQ5U7Hz2IyGjXqSqc7Tbv0PnK38L69dNtg0e9b3MDAfmRiuh0z4Va/esDe+TYR9/Mfe2PYLn9SK9sopzzWs17qSIpcPYaLvOTf4HKeHvh3o2gus7Ib66XkSzgEKfVV6D9T711dFFebUqTqS5pu7Peo0KVCPJSjZBRRRWZsFFFFAHMeLfA1j4oj87P2a/RcJOozuHow7j9R+leWah8OfEthKVFh9qTtJbMGB/Dg/pXvVFd9DHVqC5VqvM8jGZRhsVLneku6PnhfBviNumi3n4xEVdtfhz4num/wCQaYV/vTSKuPwzn9K96oroebVekUcMeHcMn70n+H+R5jo3wgRHWTXr7zAOsNtwD9WPP5AfWvRdP02z0qzW1063jt4V6Igxn3Pqfc1ZorgrYmrW+Nns4bA4fCr91Gz79RrossbRyKHRgVZWGQQe1eT+J/hVdRXD3PhvbPAxz9ldgHT2BPBH15+tetUUUMTUw8rwFjMDRxkOWqttn1R88/8ACFeJC+3+xrrP+5x+fStKy+GHia7YebaxWqn+KeZf5Lk/pXulFd0s1rNaJHkR4dwyd5Sb+7/I860b4RWNsyy61dveMOfJiGxPoT1P6V31nZW2n2q21jBHbwp91I1wBU9FcFXEVaz993PZw+DoYVWpRt+f3hXmvjr4cT6hey6roIVppTumtiQu5u7KTxk9wa9KoooV50J80AxWEpYun7Oqv+AfOEnhvW4pfKk0i+D+n2dzn6cc1o2Hw/8AEt+y7dMkgU9XuCI8fgef0r36ivRlm1RrSKPEjw5QTvKba+R5xoXwjtbdlm166+1MDnyIcqn4t1P6V6Hb20NpbpBaxJDDGMKkagBR7CpKK86tiKlZ3m7nt4bB0MLG1KNvz+8KyvEHh2w8SacbXUYzxzHKvDxn1B/pWrRWUZSg+aL1OipTjUi4TV0zw7WvhlrumSsbOL+0bfPyvD97HunX8s1z/wDwjut+Zs/se/3/AN37M+f5V9I0V6sM1qpWkkz52pw7h5SvCTS7bnhOmfDXxHqDKZLRbKI9XuHAI/4CMn9K9M8LeANM8NOLjJvL3GPPkUAJ/ur2+vJrqqK5q+PrVlyt2Xkd2EyjC4WXOld92Zuv6FaeItIksL0EK3zI46xsOjCvFda8Aa/o87AWUl5Dn5ZrZS4I9wOR+Ne+UUsNjKmH0Wq7F47K6GNtKWkl1R86WvhTX7xwsGj3pz3aFkX8zgV1WjfCTU7mRX1qeOyh7pGRJIfbjgfXJ+lew0V0VM0rSVopI4aPD+Gg7zbl+C/r5mXoXhzTfDloYNLg2bvvyMcvIfc/06Vb1DT7XVbCWzv4VmglGGQ/z9j71ZorzXOTlzN6nvRpU4w9mkuXt0PH9c+E2pW0ryaHKl5B1WORgki+3PB+vH0rlbjwj4htmIl0W9OO6Qlx+a5FfRVFelTzStFWkkzwq3D+Fm7wbj+R82HQtXBwdLvf/Ad/8KvWXgnxHfuFh0i5TP8AFMnlD82xX0LRWjzapbSKMI8OUU/em/wPM/D3wljhdLjxFcCYjn7LCSF/4E3U/QY+tekQQRW0CQ20aRRRjaiIuAo9AKkorza2IqV3ebPdwuDoYWPLSjb8wooorA6wooooADz1rgfEvwsstTke60WRbC4bloiMxMfw5X8Mj2rvqK2pVqlGXNB2ObEYWjiYclWNzwK++HviaxchtNedez27BwfwHP5iqcXhDxFM+1NFvgf9uBlH5mvomivSWbVbaxR4cuHcO3dTdvkeJad8KvEN4w+1rBYp3MsgZvwC5/Uiu80D4Z6NozpPdA6jcryGmGEU+oT/ABzXY0Vy1cfXqqzdl5Hdh8nwmHfMo3fnr/wA6UUUVwnrlPVdKs9a0+Sy1GFZoX7Hqp9Qex968o174UapZyvJojrfW/UIzBZV/Pg/h+Vex0V1YfFVcP8AA9Ox5+My7D4xfvFr3W586SeEvEMT7G0S/J/2bdmH5gYq3aeAvE17jy9JmjHrMRHj/vog19AUV3PNqttIo8mPDlC+s3b5Hlmj/B9yVk1y/CjqYbYZJ/4Ef8K9E0nQ9N0O38nS7SO3X+JgMs31Y8mr9FcFbFVq3xvQ9jDZfhsL/Cjr36hRRRXMdxxvxS1D7F4LkhU4e8lWIeuPvH/0HH414fXo/wAYdR83VrDT1PEERlYD1Y4H6L+tecV9Vl1Pkw6ffU/Pc7re1xsl/LZf18wrt/hl4etdd1HUDqMImto7fyyD2ZzwQexAU1xFe1fCfT/svhFrphhrydnB/wBlflH6hvzqsfVdOg2t2Rk+HVfGRUldK7f9epx+v/CzVtPneTRx9vtc/KAQJVHuOh+o/IVzZ8KeIA5T+xNQyP8Ap2fH54xX0ZRXkwzStFWkkz6Krw/hpy5oScfI8N0v4YeIr91NzAljEerzuCcf7oyfzxXovh34c6PoTLPMv2+7XkSzKNqn/ZXoPxya62iuetj69VWbsvI7MLk+Fwz5krvu/wCrBRRRXCeuFFFFAFbUdOtNWsZLPUIVmgkGGVv5j0PvXkmvfCjVLOZpNEZb+3JyEZgkij3zwfqPyr2SiurD4qrh37j07Hn4zL6GMX7xa91ufOj+EvEKSFG0S/JB/ht2I/MDFXrL4e+Jr1ht0x4V7tOwTH4E5/SvfaK7nm1W2kUeTHh3Dp+9N/geZ6L8IYY9suvXpmPUwW3C/QseT+AFeiWOn2mmWi22n28dvCvRI1wPr7n3qxRXn1sRVrP32e1hsFh8Kv3UbefX7wooornOwrahp9rqljJZ38KzwSDDI38/Y+9eT+IPhRqNpK82hOLy3zkQuwWRR6c8H9PpXsNFdWHxVXDv3Hp2ODGZfQxi/eLXutz5xm8Ma7bybJdHvgfa3Yg/iBVi08F+I71sQ6NdD3lTyx+bYr6GorvebVLaRR464co31m7fI8h0j4RahOVfWbuO0TvHF+8f8+g/WvSdD8NaX4dt/L0y2VGIw8rcyP8AVv6dK1aK4K2LrV9JvTsevhctw2F1px17vV/16BRRRXKegFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFU9Xvv7N0W8vepghdwPUgcD86aTbsiZSUYuT6Hg3jXUP7T8Z6lcA5QTGJPony/wBM/jWFUjRTMxZkcknJJU80nky/883/AO+TX20IqEVFdD8qqzlVqSqPq7jACTgDJNfSehaeNK0CxscYMECo3u2OT+ea8J8IaU+peL9Nt3ibZ5wd8rxtX5j+gxX0LXiZtU1jBep9Xw5Rsp1X6fq/0CiiivDPrAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAorkviPreoaD4cgutJuPs8z3axs2xWypRzjDAjqBXmX/CyfFn/QV/8AJaL/AOJrvoYCrXhzxat/XkePi83oYSr7Kom35W/zPeqK8F/4WT4s/wCgr/5LRf8AxNH/AAsnxZ/0Ff8AyWi/+Jrf+yq/dfj/AJHJ/rFhP5Zfcv8AM96orwX/AIWT4s/6Cv8A5LRf/E0f8LJ8Wf8AQV/8lov/AImj+yq/dfj/AJB/rFhP5Zfcv8z3qivBf+Fk+LP+gr/5LRf/ABNH/CyfFn/QV/8AJaL/AOJo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP8AoK/+S0X/AMTR/wALJ8Wf9BX/AMlov/iaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/oK/8AktF/8TR/wsnxZ/0Ff/JaL/4mj+yq/dfj/kH+sWE/ll9y/wAz3qivBf8AhZPiz/oK/wDktF/8TR/wsnxZ/wBBX/yWi/8AiaP7Kr91+P8AkH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/ktF/8AE0f8LJ8Wf9BX/wAlov8A4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/wCgr/5LRf8AxNH/AAsnxZ/0Ff8AyWi/+Jo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP+gr/wCS0X/xNH/CyfFn/QV/8lov/iaP7Kr91+P+Qf6xYT+WX3L/ADPeqK8F/wCFk+LP+gr/AOS0X/xNH/CyfFn/AEFf/JaL/wCJo/sqv3X4/wCQf6xYT+WX3L/M96orwX/hZPiz/oK/+S0X/wATR/wsnxZ/0Ff/ACWi/wDiaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/AKCv/ktF/wDE0f8ACyfFn/QV/wDJaL/4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/AJLRf/E0f8LJ8Wf9BX/yWi/+Jo/sqv3X4/5B/rFhP5Zfcv8AM96orwX/AIWT4s/6Cv8A5LRf/E0f8LJ8Wf8AQV/8lov/AImj+yq/dfj/AJB/rFhP5Zfcv8z3qivBf+Fk+LP+gr/5LRf/ABNH/CyfFn/QV/8AJaL/AOJo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP8AoK/+S0X/AMTR/wALJ8Wf9BX/AMlov/iaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/oK/8AktF/8TR/wsnxZ/0Ff/JaL/4mj+yq/dfj/kH+sWE/ll9y/wAz3qivBf8AhZPiz/oK/wDktF/8TR/wsnxZ/wBBX/yWi/8AiaP7Kr91+P8AkH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/ktF/8AE0f8LJ8Wf9BX/wAlov8A4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/wCgr/5LRf8AxNH/AAsnxZ/0Ff8AyWi/+Jo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP+gr/wCS0X/xNH/CyfFn/QV/8lov/iaP7Kr91+P+Qf6xYT+WX3L/ADPeqK8F/wCFk+LP+gr/AOS0X/xNH/CyfFn/AEFf/JaL/wCJo/sqv3X4/wCQf6xYT+WX3L/M96orwX/hZPiz/oK/+S0X/wATR/wsnxZ/0Ff/ACWi/wDiaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/AKCv/ktF/wDE0f8ACyfFn/QV/wDJaL/4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/AJLRf/E0f8LJ8Wf9BX/yWi/+Jo/sqv3X4/5B/rFhP5Zfcv8AM96orwX/AIWT4s/6Cv8A5LRf/E0f8LJ8Wf8AQV/8lov/AImj+yq/dfj/AJB/rFhP5Zfcv8z3qivBf+Fk+LP+gr/5LRf/ABNH/CyfFn/QV/8AJaL/AOJo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP8AoK/+S0X/AMTR/wALJ8Wf9BX/AMlov/iaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/oK/8AktF/8TR/wsnxZ/0Ff/JaL/4mj+yq/dfj/kH+sWE/ll9y/wAz3qivBf8AhZPiz/oK/wDktF/8TR/wsnxZ/wBBX/yWi/8AiaP7Kr91+P8AkH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/ktF/8AE0f8LJ8Wf9BX/wAlov8A4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/wCgr/5LRf8AxNH/AAsnxZ/0Ff8AyWi/+Jo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP+gr/wCS0X/xNH/CyfFn/QV/8lov/iaP7Kr91+P+Qf6xYT+WX3L/ADPeqK8F/wCFk+LP+gr/AOS0X/xNH/CyfFn/AEFf/JaL/wCJo/sqv3X4/wCQf6xYT+WX3L/M96orwX/hZPiz/oK/+S0X/wATR/wsnxZ/0Ff/ACWi/wDiaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/AKCv/ktF/wDE0f8ACyfFn/QV/wDJaL/4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/AJLRf/E0f8LJ8Wf9BX/yWi/+Jo/sqv3X4/5B/rFhP5Zfcv8AM96orwX/AIWT4s/6Cv8A5LRf/E0f8LJ8Wf8AQV/8lov/AImj+yq/dfj/AJB/rFhP5Zfcv8z3qivBf+Fk+LP+gr/5LRf/ABNH/CyfFn/QV/8AJaL/AOJo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP8AoK/+S0X/AMTR/wALJ8Wf9BX/AMlov/iaP7Kr91+P+Qf6xYT+WX3L/M96orwX/hZPiz/oK/8AktF/8TR/wsnxZ/0Ff/JaL/4mj+yq/dfj/kH+sWE/ll9y/wAz3qivBf8AhZPiz/oK/wDktF/8TR/wsnxZ/wBBX/yWi/8AiaP7Kr91+P8AkH+sWE/ll9y/zPeqK8F/4WT4s/6Cv/ktF/8AE0f8LJ8Wf9BX/wAlov8A4mj+yq/dfj/kH+sWE/ll9y/zPeqK8F/4WT4s/wCgr/5LRf8AxNH/AAsnxZ/0Ff8AyWi/+Jo/sqv3X4/5B/rFhP5Zfcv8z3qivBf+Fk+LP+gr/wCS0X/xNH/CyfFn/QV/8lov/iaP7Kr91+P+Qf6xYT+WX3L/ADPeqK8F/wCFk+LP+gr/AOS0X/xNdd8OPF2t694jntdWvftEKWjSKvlIuGDoM5UA9Cazq5dVpQc5NWXr/kb4fPMNXqxpRjK78l/memUUUV5p7hwXxf8A+RRtf+v5P/RcleNV7L8X/wDkUbX/AK/k/wDRcleNV9Rln+7/ADZ+f59/vr9EFFFFekeEFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAV3vwg/wCRuuv+vF//AEZHXBV3vwg/5G66/wCvF/8A0ZHXJjf93n6HpZX/AL7T9T2WiiivkD9LOC+L/wDyKNr/ANfyf+i5K8ar2X4v/wDIo2v/AF/J/wCi5K8ar6jLP93+bPz/AD7/AH1+iCiiivSPCCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAK734Qf8AI3XX/Xi//oyOuCrvfhB/yN11/wBeL/8AoyOuTG/7vP0PSyv/AH2n6nstFFFfIH6WcF8X/wDkUbX/AK/k/wDRcleNV7L8X/8AkUbX/r+T/wBFyV41X1GWf7v82fn+ff76/RBRRRXpHhBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFd78IP+Ruuv+vF//RkdcFXe/CD/AJG66/68X/8ARkdcmN/3efoellf++0/U9looor5A/Szgvi//AMija/8AX8n/AKLkrxqvZfi//wAija/9fyf+i5K8ar6jLP8Ad/mz8/z7/fX6IKKKK9I8IKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigArvfhB/yN11/14v8A+jI64Ku9+EH/ACN11/14v/6Mjrkxv+7z9D0sr/32n6nstFFFfIH6WcF8X/8AkUbX/r+T/wBFyV41X0X4k8N2nijTY7LUJJ4445RKDAwByAR3B4+Y1zP/AAqDQP8An71L/v7H/wDEV7mCxtGjR5J7nyeaZVicViXUppWsup41RXsv/CoNA/5+9S/7+x//ABFH/CoNA/5+9S/7+x//ABFdn9p4fu/uPL/sHG9l9541RXsv/CoNA/5+9S/7+x//ABFH/CoNA/5+9S/7+x//ABFH9p4fu/uD+wcb2X3njVFey/8ACoNA/wCfvUv+/sf/AMRR/wAKg0D/AJ+9S/7+x/8AxFH9p4fu/uD+wcb2X3njVFey/wDCoNA/5+9S/wC/sf8A8RR/wqDQP+fvUv8Av7H/APEUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/xFH/CoNA/5+9S/7+x//EUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/wARR/wqDQP+fvUv+/sf/wARR/aeH7v7g/sHG9l9541RXsv/AAqDQP8An71L/v7H/wDEUf8ACoNA/wCfvUv+/sf/AMRR/aeH7v7g/sHG9l9541RXsv8AwqDQP+fvUv8Av7H/APEUf8Kg0D/n71L/AL+x/wDxFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8RR/wqDQP+fvUv+/sf/xFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8AEUf8Kg0D/n71L/v7H/8AEUf2nh+7+4P7BxvZfeeNUV7L/wAKg0D/AJ+9S/7+x/8AxFH/AAqDQP8An71L/v7H/wDEUf2nh+7+4P7BxvZfeeNUV7L/AMKg0D/n71L/AL+x/wDxFH/CoNA/5+9S/wC/sf8A8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//EUf8Kg0D/n71L/v7H/8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//ABFH/CoNA/5+9S/7+x//ABFH9p4fu/uD+wcb2X3njVFey/8ACoNA/wCfvUv+/sf/AMRR/wAKg0D/AJ+9S/7+x/8AxFH9p4fu/uD+wcb2X3njVFey/wDCoNA/5+9S/wC/sf8A8RR/wqDQP+fvUv8Av7H/APEUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/xFH/CoNA/5+9S/7+x//EUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/wARR/wqDQP+fvUv+/sf/wARR/aeH7v7g/sHG9l9541RXsv/AAqDQP8An71L/v7H/wDEUf8ACoNA/wCfvUv+/sf/AMRR/aeH7v7g/sHG9l9541RXsv8AwqDQP+fvUv8Av7H/APEUf8Kg0D/n71L/AL+x/wDxFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8RR/wqDQP+fvUv+/sf/xFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8AEUf8Kg0D/n71L/v7H/8AEUf2nh+7+4P7BxvZfeeNUV7L/wAKg0D/AJ+9S/7+x/8AxFH/AAqDQP8An71L/v7H/wDEUf2nh+7+4P7BxvZfeeNUV7L/AMKg0D/n71L/AL+x/wDxFH/CoNA/5+9S/wC/sf8A8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//EUf8Kg0D/n71L/v7H/8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//ABFH/CoNA/5+9S/7+x//ABFH9p4fu/uD+wcb2X3njVFey/8ACoNA/wCfvUv+/sf/AMRR/wAKg0D/AJ+9S/7+x/8AxFH9p4fu/uD+wcb2X3njVFey/wDCoNA/5+9S/wC/sf8A8RR/wqDQP+fvUv8Av7H/APEUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/xFH/CoNA/5+9S/7+x//EUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/wARR/wqDQP+fvUv+/sf/wARR/aeH7v7g/sHG9l9541RXsv/AAqDQP8An71L/v7H/wDEUf8ACoNA/wCfvUv+/sf/AMRR/aeH7v7g/sHG9l9541RXsv8AwqDQP+fvUv8Av7H/APEUf8Kg0D/n71L/AL+x/wDxFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8RR/wqDQP+fvUv+/sf/xFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8AEUf8Kg0D/n71L/v7H/8AEUf2nh+7+4P7BxvZfeeNUV7L/wAKg0D/AJ+9S/7+x/8AxFH/AAqDQP8An71L/v7H/wDEUf2nh+7+4P7BxvZfeeNUV7L/AMKg0D/n71L/AL+x/wDxFH/CoNA/5+9S/wC/sf8A8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//EUf8Kg0D/n71L/v7H/8RR/aeH7v7g/sHG9l9541RXsv/CoNA/5+9S/7+x//ABFH/CoNA/5+9S/7+x//ABFH9p4fu/uD+wcb2X3njVFey/8ACoNA/wCfvUv+/sf/AMRR/wAKg0D/AJ+9S/7+x/8AxFH9p4fu/uD+wcb2X3njVFey/wDCoNA/5+9S/wC/sf8A8RR/wqDQP+fvUv8Av7H/APEUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/xFH/CoNA/5+9S/7+x//EUf2nh+7+4P7BxvZfeeNUV7L/wqDQP+fvUv+/sf/wARR/wqDQP+fvUv+/sf/wARR/aeH7v7g/sHG9l9541RXsv/AAqDQP8An71L/v7H/wDEUf8ACoNA/wCfvUv+/sf/AMRR/aeH7v7g/sHG9l9541RXsv8AwqDQP+fvUv8Av7H/APEUf8Kg0D/n71L/AL+x/wDxFH9p4fu/uD+wcb2X3njVFey/8Kg0D/n71L/v7H/8RR/wqDQP+fvUv+/sf/xFH9p4fu/uD+wcb2X3njVd78IP+Ruuv+vF/wD0ZHXUf8Kg0D/n71L/AL+x/wDxFa/hvwJpnhfUpL3T57uSSSIxETupGCQeyjn5RWGJx9CpRlCO7OzA5PiqGJhUmlZPudNRRRXzx9oFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAf/9k=";

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hd250_base64__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hd650_base64__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hd1500_base64__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hd3500_base64__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aclogo_base64__ = __webpack_require__(199);






/* harmony default export */ __webpack_exports__["a"] = ({
	getAClogo: function getAClogo() {
		return {
			image: __WEBPACK_IMPORTED_MODULE_4__aclogo_base64__["a" /* aclogo */]
		};
	},
	getUnitList: function getUnitList() {
		return [{
			"Model": "HD250",
			"Image": __WEBPACK_IMPORTED_MODULE_0__hd250_base64__["a" /* hd250base64 */],
			"Fluid": {
				"Flow": 0.25,
				"Temperature": 413.15,
				"Pressure": 900000,
				"Humidity": 0
			},
			"Coolant": {
				"GlycolType": "Ethylene",
				"GlycolContent": 0,
				"InputType": "Flow",
				"Flow": 0.0005,
				"DeltaT": 25,
				"Temperature": 298.15,
				"Pressure": 400000
			}
		}, {
			"Model": "HD650",
			"Image": __WEBPACK_IMPORTED_MODULE_1__hd650_base64__["a" /* hd650base64 */],
			"Fluid": {
				"Flow": 0.65,
				"Temperature": 413.15,
				"Pressure": 900000,
				"Humidity": 0
			},
			"Coolant": {
				"GlycolType": "Ethylene",
				"GlycolContent": 0.0,
				"InputType": "Flow",
				"Flow": 0.0013,
				"DeltaT": 25,
				"Temperature": 298.15,
				"Pressure": 400000.0
			}
		}, {
			"Model": "HD1500",
			"Image": __WEBPACK_IMPORTED_MODULE_2__hd1500_base64__["a" /* hd1500base64 */],
			"Fluid": {
				"Flow": 1.5,
				"Temperature": 413.15,
				"Pressure": 900000.0,
				"Humidity": 0
			},
			"Coolant": {
				"GlycolType": "Ethylene",
				"GlycolContent": 0.0,
				"InputType": "Flow",
				"Flow": 0.003,
				"DeltaT": 25,
				"Temperature": 298.15,
				"Pressure": 400000.0
			}
		}, {
			"Model": "HD3500",
			"Image": __WEBPACK_IMPORTED_MODULE_3__hd3500_base64__["a" /* hd3500base64 */],
			"Fluid": {
				"Flow": 3.5,
				"Temperature": 413.15,
				"Pressure": 900000,
				"Humidity": 0
			},
			"Coolant": {
				"GlycolType": "Ethylene",
				"GlycolContent": 0.0,
				"InputType": "Flow",
				"Flow": 0.0013,
				"DeltaT": 25,
				"Temperature": 298.15,
				"Pressure": 400000
			}
		}];
	}
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hd1500base64; });
var hd1500base64 = "data:image/png;base64,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";

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hd250base64; });
var hd250base64 = "data:image/png;base64,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";

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hd3500base64; });
var hd3500base64 = "data:image/png;base64,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";

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hd650base64; });
var hd650base64 = "data:image/png;base64,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";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".hidden{display:none;visibility:hidden}.aside-wrapper{backface-visibility:hidden!important}.android .aside-wrapper{box-shadow:none!important}.android .aside-overlay{transition:none}@keyframes rotating{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.rotating{animation:rotating 2s linear infinite}.bgimage{background-size:contain;background-repeat:no-repeat;background-position:50%;background-origin:content-box;padding:2%}.img-responsive{display:block;max-width:100%;height:auto}.slide-fade-enter-active{transition:all .3s ease}.slide-fade-leave-active{transition:all .8s cubic-bezier(1,.5,.8,1)}.slide-fade-enter,.slide-fade-leave-to{opacity:0}.reference-conditions-table{font-size:12px;width:100%;margin-top:20px}.reference-conditions-table td,.reference-conditions-table th{font-weight:300;border:1px solid #e1e1e1;text-align:center;padding:6px;margin:0}.reference-conditions-table td:first-child,.reference-conditions-table th:first-child{text-align:left}.reference-conditions-table th{font-weight:300;color:#fff;background:#0078a1;border:1px solid #0078a1}", ""]);

// exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".outer[data-v-f5701d8a]{position:relative;overflow:hidden;perspective:550px}.inner[data-v-f5701d8a]{position:absolute;top:0;bottom:0;left:0;right:0;margin:20px;padding:0;backface-visibility:hidden;transform-style:preserve-3d;transform:translateZ(1em);transform-origin:50% 50%}.imagelist-enter-active[data-v-f5701d8a],.imagelist-leave-active[data-v-f5701d8a]{transition:all .5s ease}.imagelist-enter[data-v-f5701d8a]{transform:translate3d(0,200px,300px)}.imagelist-leave-to[data-v-f5701d8a]{transform:translate3d(0,-200px,-300px);opacity:0}", ""]);

// exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".disabled .add[data-v-4558beca],.disabled .setting__label[data-v-4558beca],.disabled .setting__unit[data-v-4558beca],.disabled .sub[data-v-4558beca],input[type=number][data-v-4558beca]:disabled{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;opacity:.5}.disabled .add[data-v-4558beca],.disabled .sub[data-v-4558beca]{background-color:#ddd}input[type=number][data-v-4558beca]:disabled{background-color:#f5f5f6}", ""]);

// exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, ".ExceedingLimitations[data-v-734af0f6]{color:#ff6c6c}", ""]);

// exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(7)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return FastClick;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets\\img\\css\\logo.svg?963ca284ae4e8ba3f489";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 20,
	"./af.js": 20,
	"./ar": 27,
	"./ar-dz": 21,
	"./ar-dz.js": 21,
	"./ar-kw": 22,
	"./ar-kw.js": 22,
	"./ar-ly": 23,
	"./ar-ly.js": 23,
	"./ar-ma": 24,
	"./ar-ma.js": 24,
	"./ar-sa": 25,
	"./ar-sa.js": 25,
	"./ar-tn": 26,
	"./ar-tn.js": 26,
	"./ar.js": 27,
	"./az": 28,
	"./az.js": 28,
	"./be": 29,
	"./be.js": 29,
	"./bg": 30,
	"./bg.js": 30,
	"./bm": 31,
	"./bm.js": 31,
	"./bn": 32,
	"./bn.js": 32,
	"./bo": 33,
	"./bo.js": 33,
	"./br": 34,
	"./br.js": 34,
	"./bs": 35,
	"./bs.js": 35,
	"./ca": 36,
	"./ca.js": 36,
	"./cs": 37,
	"./cs.js": 37,
	"./cv": 38,
	"./cv.js": 38,
	"./cy": 39,
	"./cy.js": 39,
	"./da": 40,
	"./da.js": 40,
	"./de": 43,
	"./de-at": 41,
	"./de-at.js": 41,
	"./de-ch": 42,
	"./de-ch.js": 42,
	"./de.js": 43,
	"./dv": 44,
	"./dv.js": 44,
	"./el": 45,
	"./el.js": 45,
	"./en-au": 46,
	"./en-au.js": 46,
	"./en-ca": 47,
	"./en-ca.js": 47,
	"./en-gb": 48,
	"./en-gb.js": 48,
	"./en-ie": 49,
	"./en-ie.js": 49,
	"./en-il": 50,
	"./en-il.js": 50,
	"./en-nz": 51,
	"./en-nz.js": 51,
	"./eo": 52,
	"./eo.js": 52,
	"./es": 55,
	"./es-do": 53,
	"./es-do.js": 53,
	"./es-us": 54,
	"./es-us.js": 54,
	"./es.js": 55,
	"./et": 56,
	"./et.js": 56,
	"./eu": 57,
	"./eu.js": 57,
	"./fa": 58,
	"./fa.js": 58,
	"./fi": 59,
	"./fi.js": 59,
	"./fo": 60,
	"./fo.js": 60,
	"./fr": 63,
	"./fr-ca": 61,
	"./fr-ca.js": 61,
	"./fr-ch": 62,
	"./fr-ch.js": 62,
	"./fr.js": 63,
	"./fy": 64,
	"./fy.js": 64,
	"./gd": 65,
	"./gd.js": 65,
	"./gl": 66,
	"./gl.js": 66,
	"./gom-latn": 67,
	"./gom-latn.js": 67,
	"./gu": 68,
	"./gu.js": 68,
	"./he": 69,
	"./he.js": 69,
	"./hi": 70,
	"./hi.js": 70,
	"./hr": 71,
	"./hr.js": 71,
	"./hu": 72,
	"./hu.js": 72,
	"./hy-am": 73,
	"./hy-am.js": 73,
	"./id": 74,
	"./id.js": 74,
	"./is": 75,
	"./is.js": 75,
	"./it": 76,
	"./it.js": 76,
	"./ja": 77,
	"./ja.js": 77,
	"./jv": 78,
	"./jv.js": 78,
	"./ka": 79,
	"./ka.js": 79,
	"./kk": 80,
	"./kk.js": 80,
	"./km": 81,
	"./km.js": 81,
	"./kn": 82,
	"./kn.js": 82,
	"./ko": 83,
	"./ko.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mn": 93,
	"./mn.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 96,
	"./ms-my": 95,
	"./ms-my.js": 95,
	"./ms.js": 96,
	"./mt": 97,
	"./mt.js": 97,
	"./my": 98,
	"./my.js": 98,
	"./nb": 99,
	"./nb.js": 99,
	"./ne": 100,
	"./ne.js": 100,
	"./nl": 102,
	"./nl-be": 101,
	"./nl-be.js": 101,
	"./nl.js": 102,
	"./nn": 103,
	"./nn.js": 103,
	"./pa-in": 104,
	"./pa-in.js": 104,
	"./pl": 105,
	"./pl.js": 105,
	"./pt": 107,
	"./pt-br": 106,
	"./pt-br.js": 106,
	"./pt.js": 107,
	"./ro": 108,
	"./ro.js": 108,
	"./ru": 109,
	"./ru.js": 109,
	"./sd": 110,
	"./sd.js": 110,
	"./se": 111,
	"./se.js": 111,
	"./si": 112,
	"./si.js": 112,
	"./sk": 113,
	"./sk.js": 113,
	"./sl": 114,
	"./sl.js": 114,
	"./sq": 115,
	"./sq.js": 115,
	"./sr": 117,
	"./sr-cyrl": 116,
	"./sr-cyrl.js": 116,
	"./sr.js": 117,
	"./ss": 118,
	"./ss.js": 118,
	"./sv": 119,
	"./sv.js": 119,
	"./sw": 120,
	"./sw.js": 120,
	"./ta": 121,
	"./ta.js": 121,
	"./te": 122,
	"./te.js": 122,
	"./tet": 123,
	"./tet.js": 123,
	"./tg": 124,
	"./tg.js": 124,
	"./th": 125,
	"./th.js": 125,
	"./tl-ph": 126,
	"./tl-ph.js": 126,
	"./tlh": 127,
	"./tlh.js": 127,
	"./tr": 128,
	"./tr.js": 128,
	"./tzl": 129,
	"./tzl.js": 129,
	"./tzm": 131,
	"./tzm-latn": 130,
	"./tzm-latn.js": 130,
	"./tzm.js": 131,
	"./ug-cn": 132,
	"./ug-cn.js": 132,
	"./uk": 133,
	"./uk.js": 133,
	"./ur": 134,
	"./ur.js": 134,
	"./uz": 136,
	"./uz-latn": 135,
	"./uz-latn.js": 135,
	"./uz.js": 136,
	"./vi": 137,
	"./vi.js": 137,
	"./x-pseudo": 138,
	"./x-pseudo.js": 138,
	"./yo": 139,
	"./yo.js": 139,
	"./zh-cn": 140,
	"./zh-cn.js": 140,
	"./zh-hk": 141,
	"./zh-hk.js": 141,
	"./zh-tw": 142,
	"./zh-tw.js": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/*! pdfmake v0.1.39, @license MIT, @link http://pdfmake.org */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 122);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isString(variable) {
	return typeof variable === 'string' || variable instanceof String;
}

function isNumber(variable) {
	return typeof variable === 'number' || variable instanceof Number;
}

function isBoolean(variable) {
	return typeof variable === 'boolean';
}

function isArray(variable) {
	return Array.isArray(variable);
}

function isFunction(variable) {
	return typeof variable === 'function';
}

function isObject(variable) {
	return variable !== null && typeof variable === 'object';
}

function isNull(variable) {
	return variable === null;
}

function isUndefined(variable) {
	return variable === undefined;
}

function pack() {
	var result = {};

	for (var i = 0, l = arguments.length; i < l; i++) {
		var obj = arguments[i];

		if (obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					result[key] = obj[key];
				}
			}
		}
	}

	return result;
}

function offsetVector(vector, x, y) {
	switch (vector.type) {
		case 'ellipse':
		case 'rect':
			vector.x += x;
			vector.y += y;
			break;
		case 'line':
			vector.x1 += x;
			vector.x2 += x;
			vector.y1 += y;
			vector.y2 += y;
			break;
		case 'polyline':
			for (var i = 0, l = vector.points.length; i < l; i++) {
				vector.points[i].x += x;
				vector.points[i].y += y;
			}
			break;
	}
}

function fontStringify(key, val) {
	if (key === 'font') {
		return 'font';
	}
	return val;
}

module.exports = {
	isString: isString,
	isNumber: isNumber,
	isBoolean: isBoolean,
	isArray: isArray,
	isFunction: isFunction,
	isObject: isObject,
	isNull: isNull,
	isUndefined: isUndefined,
	pack: pack,
	fontStringify: fontStringify,
	offsetVector: offsetVector
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(124)
var ieee754 = __webpack_require__(125)
var isArray = __webpack_require__(77)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(2);
var ctx = __webpack_require__(20);
var hide = __webpack_require__(13);
var has = __webpack_require__(18);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(63)('wks');
var uid = __webpack_require__(40);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(90);
var toPrimitive = __webpack_require__(57);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, __dirname) {

function VirtualFileSystem() {
	this.fileSystem = {};
	this.dataSystem = {};
}

VirtualFileSystem.prototype.readFileSync = function (filename) {
	filename = fixFilename(filename);

	var dataContent = this.dataSystem[filename];
	if (dataContent) {
		return new Buffer(dataContent, typeof dataContent === 'string' ? 'base64' : undefined);
	}

	var content = this.fileSystem[filename];
	if (content) {
		return content;
	}

	throw 'File \'' + filename + '\' not found in virtual file system';
};

VirtualFileSystem.prototype.writeFileSync = function (filename, content) {
	this.fileSystem[fixFilename(filename)] = content;
};

VirtualFileSystem.prototype.bindFS = function (data) {
	this.dataSystem = data || {};
};


function fixFilename(filename) {
	if (filename.indexOf(__dirname) === 0) {
		filename = filename.substring(__dirname.length);
	}

	if (filename.indexOf('/') === 0) {
		filename = filename.substring(1);
	}

	return filename;
}

module.exports = new VirtualFileSystem();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, "/"))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var NumberT, PropertyDescriptor;

  NumberT = __webpack_require__(22).Number;

  exports.resolveLength = function(length, stream, parent) {
    var res;
    if (typeof length === 'number') {
      res = length;
    } else if (typeof length === 'function') {
      res = length.call(parent, parent);
    } else if (parent && typeof length === 'string') {
      res = parent[length];
    } else if (stream && length instanceof NumberT) {
      res = length.decode(stream);
    }
    if (isNaN(res)) {
      throw new Error('Not a fixed size');
    }
    return res;
  };

  PropertyDescriptor = (function() {
    function PropertyDescriptor(opts) {
      var key, val;
      if (opts == null) {
        opts = {};
      }
      this.enumerable = true;
      this.configurable = true;
      for (key in opts) {
        val = opts[key];
        this[key] = val;
      }
    }

    return PropertyDescriptor;

  })();

  exports.PropertyDescriptor = PropertyDescriptor;

}).call(this);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var createDesc = __webpack_require__(27);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(15);
/*</replacement>*/

var Readable = __webpack_require__(78);
var Writable = __webpack_require__(45);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(53);
var defined = __webpack_require__(55);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(92);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__(1)
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var DecodeStream, Fixed, NumberT,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  DecodeStream = __webpack_require__(50);

  NumberT = (function() {
    function NumberT(type, endian) {
      this.type = type;
      this.endian = endian != null ? endian : 'BE';
      this.fn = this.type;
      if (this.type[this.type.length - 1] !== '8') {
        this.fn += this.endian;
      }
    }

    NumberT.prototype.size = function() {
      return DecodeStream.TYPES[this.type];
    };

    NumberT.prototype.decode = function(stream) {
      return stream['read' + this.fn]();
    };

    NumberT.prototype.encode = function(stream, val) {
      return stream['write' + this.fn](val);
    };

    return NumberT;

  })();

  exports.Number = NumberT;

  exports.uint8 = new NumberT('UInt8');

  exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');

  exports.uint16le = new NumberT('UInt16', 'LE');

  exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');

  exports.uint24le = new NumberT('UInt24', 'LE');

  exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');

  exports.uint32le = new NumberT('UInt32', 'LE');

  exports.int8 = new NumberT('Int8');

  exports.int16be = exports.int16 = new NumberT('Int16', 'BE');

  exports.int16le = new NumberT('Int16', 'LE');

  exports.int24be = exports.int24 = new NumberT('Int24', 'BE');

  exports.int24le = new NumberT('Int24', 'LE');

  exports.int32be = exports.int32 = new NumberT('Int32', 'BE');

  exports.int32le = new NumberT('Int32', 'LE');

  exports.floatbe = exports.float = new NumberT('Float', 'BE');

  exports.floatle = new NumberT('Float', 'LE');

  exports.doublebe = exports.double = new NumberT('Double', 'BE');

  exports.doublele = new NumberT('Double', 'LE');

  Fixed = (function(_super) {
    __extends(Fixed, _super);

    function Fixed(size, endian, fracBits) {
      if (fracBits == null) {
        fracBits = size >> 1;
      }
      Fixed.__super__.constructor.call(this, "Int" + size, endian);
      this._point = 1 << fracBits;
    }

    Fixed.prototype.decode = function(stream) {
      return Fixed.__super__.decode.call(this, stream) / this._point;
    };

    Fixed.prototype.encode = function(stream, val) {
      return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
    };

    return Fixed;

  })(NumberT);

  exports.Fixed = Fixed;

  exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');

  exports.fixed16le = new Fixed(16, 'LE');

  exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');

  exports.fixed32le = new Fixed(32, 'LE');

}).call(this);


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(196)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(60)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

/*
PDFObject - converts JavaScript types into their corrisponding PDF types.
By Devon Govett
 */

(function() {
  var PDFObject, PDFReference;

  PDFObject = (function() {
    var escapable, escapableRe, pad, swapBytes;

    function PDFObject() {}

    pad = function(str, length) {
      return (Array(length + 1).join('0') + str).slice(-length);
    };

    escapableRe = /[\n\r\t\b\f\(\)\\]/g;

    escapable = {
      '\n': '\\n',
      '\r': '\\r',
      '\t': '\\t',
      '\b': '\\b',
      '\f': '\\f',
      '\\': '\\\\',
      '(': '\\(',
      ')': '\\)'
    };

    swapBytes = function(buff) {
      var a, i, j, l, ref;
      l = buff.length;
      if (l & 0x01) {
        throw new Error("Buffer length must be even");
      } else {
        for (i = j = 0, ref = l - 1; j < ref; i = j += 2) {
          a = buff[i];
          buff[i] = buff[i + 1];
          buff[i + 1] = a;
        }
      }
      return buff;
    };

    PDFObject.convert = function(object) {
      var e, i, isUnicode, items, j, key, out, ref, string, val;
      if (typeof object === 'string') {
        return '/' + object;
      } else if (object instanceof String) {
        string = object;
        isUnicode = false;
        for (i = j = 0, ref = string.length; j < ref; i = j += 1) {
          if (string.charCodeAt(i) > 0x7f) {
            isUnicode = true;
            break;
          }
        }
        if (isUnicode) {
          string = swapBytes(new Buffer('\ufeff' + string, 'utf16le')).toString('binary');
        }
        string = string.replace(escapableRe, function(c) {
          return escapable[c];
        });
        return '(' + string + ')';
      } else if (Buffer.isBuffer(object)) {
        return '<' + object.toString('hex') + '>';
      } else if (object instanceof PDFReference) {
        return object.toString();
      } else if (object instanceof Date) {
        return '(D:' + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z)';
      } else if (Array.isArray(object)) {
        items = ((function() {
          var k, len, results;
          results = [];
          for (k = 0, len = object.length; k < len; k++) {
            e = object[k];
            results.push(PDFObject.convert(e));
          }
          return results;
        })()).join(' ');
        return '[' + items + ']';
      } else if ({}.toString.call(object) === '[object Object]') {
        out = ['<<'];
        for (key in object) {
          val = object[key];
          out.push('/' + key + ' ' + PDFObject.convert(val));
        }
        out.push('>>');
        return out.join('\n');
      } else if (typeof object === 'number') {
        return PDFObject.number(object);
      } else {
        return '' + object;
      }
    };

    PDFObject.number = function(n) {
      if (n > -1e21 && n < 1e21) {
        return Math.round(n * 1e6) / 1e6;
      }
      throw new Error("unsupported number: " + n);
    };

    return PDFObject;

  })();

  module.exports = PDFObject;

  PDFReference = __webpack_require__(82);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(190);
var global = __webpack_require__(11);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(23);
var TO_STRING_TAG = __webpack_require__(4)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(96);
var enumBugKeys = __webpack_require__(64);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(55);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(32).EventEmitter;
var inherits = __webpack_require__(15);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(44);
Stream.Writable = __webpack_require__(136);
Stream.Duplex = __webpack_require__(137);
Stream.Transform = __webpack_require__(138);
Stream.PassThrough = __webpack_require__(139);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(1)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(14);
var dPs = __webpack_require__(95);
var enumBugKeys = __webpack_require__(64);
var IE_PROTO = __webpack_require__(62)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(91)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(194).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(61);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f;
var has = __webpack_require__(18);
var TAG = __webpack_require__(4)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(40)('meta');
var isObject = __webpack_require__(10);
var has = __webpack_require__(18);
var setDesc = __webpack_require__(6).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(20);
var call = __webpack_require__(106);
var isArrayIter = __webpack_require__(107);
var anObject = __webpack_require__(14);
var toLength = __webpack_require__(39);
var getIterFn = __webpack_require__(65);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(45);
exports.Duplex = __webpack_require__(16);
exports.Transform = __webpack_require__(81);
exports.PassThrough = __webpack_require__(135);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(15);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(134)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(79);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(34).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(80);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(16);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(16);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(132).setImmediate, __webpack_require__(7)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(34).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Buffer = __webpack_require__(1).Buffer;
var Transform = __webpack_require__(31).Transform;
var binding = __webpack_require__(140);
var util = __webpack_require__(48);
var assert = __webpack_require__(83).ok;
var kMaxLength = __webpack_require__(1).kMaxLength;
var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16 * 1024;

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
var bkeys = Object.keys(binding);
for (var bk = 0; bk < bkeys.length; bk++) {
  var bkey = bkeys[bk];
  if (bkey.match(/^Z/)) {
    Object.defineProperty(exports, bkey, {
      enumerable: true, value: binding[bkey], writable: false
    });
  }
}

// translation table for return codes.
var codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

var ckeys = Object.keys(codes);
for (var ck = 0; ck < ckeys.length; ck++) {
  var ckey = ckeys[ck];
  codes[codes[ckey]] = ckey;
}

Object.defineProperty(exports, 'codes', {
  enumerable: true, value: Object.freeze(codes), writable: false
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function (o) {
  return new Deflate(o);
};

exports.createInflate = function (o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function (o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function (o) {
  return new InflateRaw(o);
};

exports.createGzip = function (o) {
  return new Gzip(o);
};

exports.createGunzip = function (o) {
  return new Gunzip(o);
};

exports.createUnzip = function (o) {
  return new Unzip(o);
};

// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function (buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function (buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function (buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf;
    var err = null;

    if (nread >= kMaxLength) {
      err = new RangeError(kRangeErrorMessage);
    } else {
      buf = Buffer.concat(buffers, nread);
    }

    buffers = [];
    engine.close();
    callback(err, buf);
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string') buffer = Buffer.from(buffer);

  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

  var flushFlag = engine._finishFlushFlag;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}

// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}

// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}

// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}

function isValidFlushFlag(flag) {
  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}

// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  var _this = this;

  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush && !isValidFlushFlag(opts.flush)) {
    throw new Error('Invalid flush flag: ' + opts.flush);
  }
  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
    throw new Error('Invalid flush flag: ' + opts.finishFlush);
  }

  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._handle = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._handle.onerror = function (message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    _close(self);
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

  this._buffer = Buffer.allocUnsafe(this._chunkSize);
  this._offset = 0;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);

  Object.defineProperty(this, '_closed', {
    get: function () {
      return !_this._handle;
    },
    configurable: true,
    enumerable: true
  });
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function (level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function () {
      assert(self._handle, 'zlib binding closed');
      self._handle.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function () {
  assert(this._handle, 'zlib binding closed');
  return this._handle.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function (callback) {
  this._transform(Buffer.alloc(0), '', callback);
};

Zlib.prototype.flush = function (kind, callback) {
  var _this2 = this;

  var ws = this._writableState;

  if (typeof kind === 'function' || kind === undefined && !callback) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback) process.nextTick(callback);
  } else if (ws.ending) {
    if (callback) this.once('end', callback);
  } else if (ws.needDrain) {
    if (callback) {
      this.once('drain', function () {
        return _this2.flush(kind, callback);
      });
    }
  } else {
    this._flushFlag = kind;
    this.write(Buffer.alloc(0), '', callback);
  }
};

Zlib.prototype.close = function (callback) {
  _close(this, callback);
  process.nextTick(emitCloseNT, this);
};

function _close(engine, callback) {
  if (callback) process.nextTick(callback);

  // Caller may invoke .close after a zlib error (which will null _handle).
  if (!engine._handle) return;

  engine._handle.close();
  engine._handle = null;
}

function emitCloseNT(self) {
  self.emit('close');
}

Zlib.prototype._transform = function (chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

  if (!this._handle) return cb(new Error('zlib binding closed'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
  // (or whatever flag was provided using opts.finishFlush).
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last) flushFlag = this._finishFlushFlag;else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function (er) {
      error = er;
    });

    assert(this._handle, 'zlib binding closed');
    do {
      var res = this._handle.writeSync(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    if (nread >= kMaxLength) {
      _close(this);
      throw new RangeError(kRangeErrorMessage);
    }

    var buf = Buffer.concat(buffers, nread);
    _close(this);

    return buf;
  }

  assert(this._handle, 'zlib binding closed');
  var req = this._handle.write(flushFlag, chunk, // in
  inOff, // in_off
  availInBefore, // in_len
  this._buffer, // out
  this._offset, //out_off
  availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    // When the callback is used in an async write, the callback's
    // context is the `req` object that was created. The req object
    // is === this._handle, and that's why it's important to null
    // out the values after they are done being used. `this._handle`
    // can stay in memory longer than the callback and buffer are needed.
    if (this) {
      this.buffer = null;
      this.callback = null;
    }

    if (self._hadError) return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = Buffer.allocUnsafe(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += availInBefore - availInAfter;
      availInBefore = availInAfter;

      if (!async) return true;

      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async) return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(141);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(15);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
(function() {
  var EmbeddedFont, PDFFont, StandardFont, fontkit;

  fontkit = __webpack_require__(156);

  PDFFont = (function() {
    PDFFont.open = function(document, src, family, id) {
      var font;
      if (typeof src === 'string') {
        if (StandardFont.isStandardFont(src)) {
          return new StandardFont(document, src, id);
        }
        font = fontkit.openSync(src, family);
      } else if (Buffer.isBuffer(src)) {
        font = fontkit.create(src, family);
      } else if (src instanceof Uint8Array) {
        font = fontkit.create(new Buffer(src), family);
      } else if (src instanceof ArrayBuffer) {
        font = fontkit.create(new Buffer(new Uint8Array(src)), family);
      }
      if (font == null) {
        throw new Error('Not a supported font format or standard PDF font.');
      }
      return new EmbeddedFont(document, font, id);
    };

    function PDFFont() {
      throw new Error('Cannot construct a PDFFont directly.');
    }

    PDFFont.prototype.encode = function(text) {
      throw new Error('Must be implemented by subclasses');
    };

    PDFFont.prototype.widthOfString = function(text) {
      throw new Error('Must be implemented by subclasses');
    };

    PDFFont.prototype.ref = function() {
      return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
    };

    PDFFont.prototype.finalize = function() {
      if (this.embedded || (this.dictionary == null)) {
        return;
      }
      this.embed();
      return this.embedded = true;
    };

    PDFFont.prototype.embed = function() {
      throw new Error('Must be implemented by subclasses');
    };

    PDFFont.prototype.lineHeight = function(size, includeGap) {
      var gap;
      if (includeGap == null) {
        includeGap = false;
      }
      gap = includeGap ? this.lineGap : 0;
      return (this.ascender + gap - this.descender) / 1000 * size;
    };

    return PDFFont;

  })();

  module.exports = PDFFont;

  StandardFont = __webpack_require__(281);

  EmbeddedFont = __webpack_require__(283);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
(function() {
  var DecodeStream, iconv;

  try {
    iconv = __webpack_require__(51);
  } catch (_error) {}

  DecodeStream = (function() {
    var key;

    function DecodeStream(buffer) {
      this.buffer = buffer;
      this.pos = 0;
      this.length = this.buffer.length;
    }

    DecodeStream.TYPES = {
      UInt8: 1,
      UInt16: 2,
      UInt24: 3,
      UInt32: 4,
      Int8: 1,
      Int16: 2,
      Int24: 3,
      Int32: 4,
      Float: 4,
      Double: 8
    };

    for (key in Buffer.prototype) {
      if (key.slice(0, 4) === 'read') {
        (function(key) {
          var bytes;
          bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
          return DecodeStream.prototype[key] = function() {
            var ret;
            ret = this.buffer[key](this.pos);
            this.pos += bytes;
            return ret;
          };
        })(key);
      }
    }

    DecodeStream.prototype.readString = function(length, encoding) {
      var buf, byte, i, _i, _ref;
      if (encoding == null) {
        encoding = 'ascii';
      }
      switch (encoding) {
        case 'utf16le':
        case 'ucs2':
        case 'utf8':
        case 'ascii':
          return this.buffer.toString(encoding, this.pos, this.pos += length);
        case 'utf16be':
          buf = new Buffer(this.readBuffer(length));
          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
            byte = buf[i];
            buf[i] = buf[i + 1];
            buf[i + 1] = byte;
          }
          return buf.toString('utf16le');
        default:
          buf = this.readBuffer(length);
          if (iconv) {
            try {
              return iconv.decode(buf, encoding);
            } catch (_error) {}
          }
          return buf;
      }
    };

    DecodeStream.prototype.readBuffer = function(length) {
      return this.buffer.slice(this.pos, this.pos += length);
    };

    DecodeStream.prototype.readUInt24BE = function() {
      return (this.readUInt16BE() << 8) + this.readUInt8();
    };

    DecodeStream.prototype.readUInt24LE = function() {
      return this.readUInt16LE() + (this.readUInt8() << 16);
    };

    DecodeStream.prototype.readInt24BE = function() {
      return (this.readInt16BE() << 8) + this.readUInt8();
    };

    DecodeStream.prototype.readInt24LE = function() {
      return this.readUInt16LE() + (this.readInt8() << 16);
    };

    return DecodeStream;

  })();

  module.exports = DecodeStream;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// Some environments don't have global Buffer (e.g. React Native).
// Solution would be installing npm modules "buffer" and "stream" explicitly.
var Buffer = __webpack_require__(21).Buffer;

var bomHandling = __webpack_require__(159),
    iconv = module.exports;

// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
iconv.encodings = null;

// Characters emitted in case of error.
iconv.defaultCharUnicode = '�';
iconv.defaultCharSingleByte = '?';

// Public API.
iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.

    var encoder = iconv.getEncoder(encoding, options);

    var res = encoder.write(str);
    var trail = encoder.end();
    
    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
}

iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === 'string') {
        if (!iconv.skipDecodeWarning) {
            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
            iconv.skipDecodeWarning = true;
        }

        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }

    var decoder = iconv.getDecoder(encoding, options);

    var res = decoder.write(buf);
    var trail = decoder.end();

    return trail ? (res + trail) : res;
}

iconv.encodingExists = function encodingExists(enc) {
    try {
        iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
}

// Legacy aliases to convert functions
iconv.toEncoding = iconv.encode;
iconv.fromEncoding = iconv.decode;

// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
iconv._codecDataCache = {};
iconv.getCodec = function getCodec(encoding) {
    if (!iconv.encodings)
        iconv.encodings = __webpack_require__(160); // Lazy load all encoding definitions.
    
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = iconv._canonicalizeEncoding(encoding);

    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while (true) {
        var codec = iconv._codecDataCache[enc];
        if (codec)
            return codec;

        var codecDef = iconv.encodings[enc];

        switch (typeof codecDef) {
            case "string": // Direct alias to other encoding.
                enc = codecDef;
                break;

            case "object": // Alias with options. Can be layered.
                for (var key in codecDef)
                    codecOptions[key] = codecDef[key];

                if (!codecOptions.encodingName)
                    codecOptions.encodingName = enc;
                
                enc = codecDef.type;
                break;

            case "function": // Codec itself.
                if (!codecOptions.encodingName)
                    codecOptions.encodingName = enc;

                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, iconv);

                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;

            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
        }
    }
}

iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return (''+encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
}

iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = iconv.getCodec(encoding),
        encoder = new codec.encoder(options, codec);

    if (codec.bomAware && options && options.addBOM)
        encoder = new bomHandling.PrependBOM(encoder, options);

    return encoder;
}

iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = iconv.getCodec(encoding),
        decoder = new codec.decoder(options, codec);

    if (codec.bomAware && !(options && options.stripBOM === false))
        decoder = new bomHandling.StripBOM(decoder, options);

    return decoder;
}


// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
if (nodeVer) {

    // Load streaming support in Node v0.10+
    var nodeVerArr = nodeVer.split(".").map(Number);
    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
        __webpack_require__(174)(iconv);
    }

    // Load Node primitive extensions.
    __webpack_require__(175)(iconv);
}

if (false) {
    console.error("iconv-lite warning: javascript files use encoding different from utf-8. See https://github.com/ashtuchkin/iconv-lite/wiki/Javascript-source-file-encodings for more info.");
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(54);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(36);
var createDesc = __webpack_require__(27);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(57);
var has = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(90);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(5) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(2);
var fails = __webpack_require__(19);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(37);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(94);
var hide = __webpack_require__(13);
var Iterators = __webpack_require__(23);
var $iterCreate = __webpack_require__(192);
var setToStringTag = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(195);
var ITERATOR = __webpack_require__(4)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(63)('keys');
var uid = __webpack_require__(40);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(37) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(66);
var ITERATOR = __webpack_require__(4)('iterator');
var Iterators = __webpack_require__(23);
module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(54);
var TAG = __webpack_require__(4)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(98);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(205);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(4);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(37);
var wksExt = __webpack_require__(68);
var defineProperty = __webpack_require__(6).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 71 */
/***/ (function(module, exports) {



/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(212), __esModule: true };

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
var UnicodeTrie, inflate;

inflate = __webpack_require__(112);

UnicodeTrie = (function() {
  var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;

  SHIFT_1 = 6 + 5;

  SHIFT_2 = 5;

  SHIFT_1_2 = SHIFT_1 - SHIFT_2;

  OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;

  INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;

  INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;

  INDEX_SHIFT = 2;

  DATA_BLOCK_LENGTH = 1 << SHIFT_2;

  DATA_MASK = DATA_BLOCK_LENGTH - 1;

  LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;

  LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;

  INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;

  UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;

  UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;

  INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;

  DATA_GRANULARITY = 1 << INDEX_SHIFT;

  function UnicodeTrie(data) {
    var isBuffer, uncompressedLength, view;
    isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
    if (isBuffer || data instanceof Uint8Array) {
      if (isBuffer) {
        this.highStart = data.readUInt32BE(0);
        this.errorValue = data.readUInt32BE(4);
        uncompressedLength = data.readUInt32BE(8);
        data = data.slice(12);
      } else {
        view = new DataView(data.buffer);
        this.highStart = view.getUint32(0);
        this.errorValue = view.getUint32(4);
        uncompressedLength = view.getUint32(8);
        data = data.subarray(12);
      }
      data = inflate(data, new Uint8Array(uncompressedLength));
      data = inflate(data, new Uint8Array(uncompressedLength));
      this.data = new Uint32Array(data.buffer);
    } else {
      this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
  }

  UnicodeTrie.prototype.get = function(codePoint) {
    var index;
    if (codePoint < 0 || codePoint > 0x10ffff) {
      return this.errorValue;
    }
    if (codePoint < 0xd800 || (codePoint > 0xdbff && codePoint <= 0xffff)) {
      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint <= 0xffff) {
      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    if (codePoint < this.highStart) {
      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
      return this.data[index];
    }
    return this.data[this.data.length - DATA_GRANULARITY];
  };

  return UnicodeTrie;

})();

module.exports = UnicodeTrie;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(0).isString;
var isNumber = __webpack_require__(0).isNumber;
var isObject = __webpack_require__(0).isObject;
var isArray = __webpack_require__(0).isArray;
var isUndefined = __webpack_require__(0).isUndefined;
var LineBreaker = __webpack_require__(117);

var LEADING = /^(\s)+/g;
var TRAILING = /(\s)+$/g;

/**
 * Creates an instance of TextTools - text measurement utility
 *
 * @constructor
 * @param {FontProvider} fontProvider
 */
function TextTools(fontProvider) {
	this.fontProvider = fontProvider;
}

/**
 * Converts an array of strings (or inline-definition-objects) into a collection
 * of inlines and calculated minWidth/maxWidth.
 * and their min/max widths
 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   collection of inlines, minWidth, maxWidth
 */
TextTools.prototype.buildInlines = function (textArray, styleContextStack) {
	var measured = measure(this.fontProvider, textArray, styleContextStack);

	var minWidth = 0,
		maxWidth = 0,
		currentLineWidth;

	measured.forEach(function (inline) {
		minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);

		if (!currentLineWidth) {
			currentLineWidth = {width: 0, leadingCut: inline.leadingCut, trailingCut: 0};
		}

		currentLineWidth.width += inline.width;
		currentLineWidth.trailingCut = inline.trailingCut;

		maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));

		if (inline.lineEnd) {
			currentLineWidth = null;
		}
	});

	if (getStyleProperty({}, styleContextStack, 'noWrap', false)) {
		minWidth = maxWidth;
	}

	return {
		items: measured,
		minWidth: minWidth,
		maxWidth: maxWidth
	};

	function getTrimmedWidth(item) {
		return Math.max(0, item.width - item.leadingCut - item.trailingCut);
	}
};

/**
 * Returns size of the specified string (without breaking it) using the current style
 * @param  {String} text              text to be measured
 * @param  {Object} styleContextStack current style stack
 * @return {Object}                   size of the specified string
 */
TextTools.prototype.sizeOfString = function (text, styleContextStack) {
	text = text ? text.toString().replace(/\t/g, '    ') : '';

	//TODO: refactor - extract from measure
	var fontName = getStyleProperty({}, styleContextStack, 'font', 'Roboto');
	var fontSize = getStyleProperty({}, styleContextStack, 'fontSize', 12);
	var fontFeatures = getStyleProperty({}, styleContextStack, 'fontFeatures', null);
	var bold = getStyleProperty({}, styleContextStack, 'bold', false);
	var italics = getStyleProperty({}, styleContextStack, 'italics', false);
	var lineHeight = getStyleProperty({}, styleContextStack, 'lineHeight', 1);
	var characterSpacing = getStyleProperty({}, styleContextStack, 'characterSpacing', 0);

	var font = this.fontProvider.provideFont(fontName, bold, italics);

	return {
		width: widthOfString(text, font, fontSize, characterSpacing, fontFeatures),
		height: font.lineHeight(fontSize) * lineHeight,
		fontSize: fontSize,
		lineHeight: lineHeight,
		ascender: font.ascender / 1000 * fontSize,
		descender: font.descender / 1000 * fontSize
	};
};

TextTools.prototype.widthOfString = function (text, font, fontSize, characterSpacing, fontFeatures) {
	return widthOfString(text, font, fontSize, characterSpacing, fontFeatures);
};

function splitWords(text, noWrap) {
	var results = [];
	text = text.replace(/\t/g, '    ');

	if (noWrap) {
		results.push({text: text});
		return results;
	}

	var breaker = new LineBreaker(text);
	var last = 0;
	var bk;

	while (bk = breaker.nextBreak()) {
		var word = text.slice(last, bk.position);

		if (bk.required || word.match(/\r?\n$|\r$/)) { // new line
			word = word.replace(/\r?\n$|\r$/, '');
			results.push({text: word, lineEnd: true});
		} else {
			results.push({text: word});
		}

		last = bk.position;
	}

	return results;
}

function copyStyle(source, destination) {
	destination = destination || {};
	source = source || {}; //TODO: default style

	for (var key in source) {
		if (key != 'text' && source.hasOwnProperty(key)) {
			destination[key] = source[key];
		}
	}

	return destination;
}

function normalizeTextArray(array, styleContextStack) {
	function flatten(array) {
		return array.reduce(function (prev, cur) {
			var current = isArray(cur.text) ? flatten(cur.text) : cur;
			var more = [].concat(current).some(Array.isArray);
			return prev.concat(more ? flatten(current) : current);
		}, []);
	}

	function getOneWord(index, words, noWrap) {
		if (isUndefined(words[index])) {
			return null;
		}

		if (words[index].lineEnd) {
			return null;
		}

		var word = words[index].text;

		if (noWrap) {
			var tmpWords = splitWords(normalizeString(word), false);
			if (isUndefined(tmpWords[tmpWords.length - 1])) {
				return null;
			}
			word = tmpWords[tmpWords.length - 1].text;
		}

		return word;
	}

	var results = [];

	if (!isArray(array)) {
		array = [array];
	}

	array = flatten(array);

	var lastWord = null;
	for (var i = 0, l = array.length; i < l; i++) {
		var item = array[i];
		var style = null;
		var words;

		var noWrap = getStyleProperty(item || {}, styleContextStack, 'noWrap', false);
		if (isObject(item)) {
			if (item._textRef && item._textRef._textNodeRef.text) {
				item.text = item._textRef._textNodeRef.text;
			}
			words = splitWords(normalizeString(item.text), noWrap);
			style = copyStyle(item);
		} else {
			words = splitWords(normalizeString(item), noWrap);
		}

		if (lastWord && words.length) {
			var firstWord = getOneWord(0, words, noWrap);

			var wrapWords = splitWords(normalizeString(lastWord + firstWord), false);
			if (wrapWords.length === 1) {
				results[results.length - 1].noNewLine = true;
			}
		}

		for (var i2 = 0, l2 = words.length; i2 < l2; i2++) {
			var result = {
				text: words[i2].text
			};

			if (words[i2].lineEnd) {
				result.lineEnd = true;
			}

			copyStyle(style, result);

			results.push(result);
		}

		lastWord = null;
		if (i + 1 < l) {
			lastWord = getOneWord(words.length - 1, words, noWrap);
		}
	}

	return results;
}

function normalizeString(value) {
	if (value === undefined || value === null) {
		return '';
	} else if (isNumber(value)) {
		return value.toString();
	} else if (isString(value)) {
		return value;
	} else {
		return value.toString();
	}
}

function getStyleProperty(item, styleContextStack, property, defaultValue) {
	var value;

	if (item[property] !== undefined && item[property] !== null) {
		// item defines this property
		return item[property];
	}

	if (!styleContextStack) {
		return defaultValue;
	}

	styleContextStack.auto(item, function () {
		value = styleContextStack.getProperty(property);
	});

	if (value !== null && value !== undefined) {
		return value;
	} else {
		return defaultValue;
	}
}

function measure(fontProvider, textArray, styleContextStack) {
	var normalized = normalizeTextArray(textArray, styleContextStack);

	if (normalized.length) {
		var leadingIndent = getStyleProperty(normalized[0], styleContextStack, 'leadingIndent', 0);

		if (leadingIndent) {
			normalized[0].leadingCut = -leadingIndent;
			normalized[0].leadingIndent = leadingIndent;
		}
	}

	normalized.forEach(function (item) {
		var fontName = getStyleProperty(item, styleContextStack, 'font', 'Roboto');
		var fontSize = getStyleProperty(item, styleContextStack, 'fontSize', 12);
		var fontFeatures = getStyleProperty(item, styleContextStack, 'fontFeatures', null);
		var bold = getStyleProperty(item, styleContextStack, 'bold', false);
		var italics = getStyleProperty(item, styleContextStack, 'italics', false);
		var color = getStyleProperty(item, styleContextStack, 'color', 'black');
		var decoration = getStyleProperty(item, styleContextStack, 'decoration', null);
		var decorationColor = getStyleProperty(item, styleContextStack, 'decorationColor', null);
		var decorationStyle = getStyleProperty(item, styleContextStack, 'decorationStyle', null);
		var background = getStyleProperty(item, styleContextStack, 'background', null);
		var lineHeight = getStyleProperty(item, styleContextStack, 'lineHeight', 1);
		var characterSpacing = getStyleProperty(item, styleContextStack, 'characterSpacing', 0);
		var link = getStyleProperty(item, styleContextStack, 'link', null);
		var linkToPage = getStyleProperty(item, styleContextStack, 'linkToPage', null);
		var noWrap = getStyleProperty(item, styleContextStack, 'noWrap', null);
		var preserveLeadingSpaces = getStyleProperty(item, styleContextStack, 'preserveLeadingSpaces', false);
		var preserveTrailingSpaces = getStyleProperty(item, styleContextStack, 'preserveTrailingSpaces', false);

		var font = fontProvider.provideFont(fontName, bold, italics);

		item.width = widthOfString(item.text, font, fontSize, characterSpacing, fontFeatures);
		item.height = font.lineHeight(fontSize) * lineHeight;

		if (!item.leadingCut) {
			item.leadingCut = 0;
		}

		var leadingSpaces;
		if (!preserveLeadingSpaces && (leadingSpaces = item.text.match(LEADING))) {
			item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
		}

		var trailingSpaces;
		if (!preserveTrailingSpaces && (trailingSpaces = item.text.match(TRAILING))) {
			item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing, fontFeatures);
		} else {
			item.trailingCut = 0;
		}

		item.alignment = getStyleProperty(item, styleContextStack, 'alignment', 'left');
		item.font = font;
		item.fontSize = fontSize;
		item.fontFeatures = fontFeatures;
		item.characterSpacing = characterSpacing;
		item.color = color;
		item.decoration = decoration;
		item.decorationColor = decorationColor;
		item.decorationStyle = decorationStyle;
		item.background = background;
		item.link = link;
		item.linkToPage = linkToPage;
		item.noWrap = noWrap;
	});

	return normalized;
}

function widthOfString(text, font, fontSize, characterSpacing, fontFeatures) {
	return font.widthOfString(text, fontSize, fontFeatures) + ((characterSpacing || 0) * (text.length - 1));
}

module.exports = TextTools;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(0).isString;

function buildColumnWidths(columns, availableWidth) {
	var autoColumns = [],
		autoMin = 0, autoMax = 0,
		starColumns = [],
		starMaxMin = 0,
		starMaxMax = 0,
		fixedColumns = [],
		initial_availableWidth = availableWidth;

	columns.forEach(function (column) {
		if (isAutoColumn(column)) {
			autoColumns.push(column);
			autoMin += column._minWidth;
			autoMax += column._maxWidth;
		} else if (isStarColumn(column)) {
			starColumns.push(column);
			starMaxMin = Math.max(starMaxMin, column._minWidth);
			starMaxMax = Math.max(starMaxMax, column._maxWidth);
		} else {
			fixedColumns.push(column);
		}
	});

	fixedColumns.forEach(function (col) {
		// width specified as %
		if (isString(col.width) && /\d+%/.test(col.width)) {
			col.width = parseFloat(col.width) * initial_availableWidth / 100;
		}
		if (col.width < (col._minWidth) && col.elasticWidth) {
			col._calcWidth = col._minWidth;
		} else {
			col._calcWidth = col.width;
		}

		availableWidth -= col._calcWidth;
	});

	// http://www.freesoft.org/CIE/RFC/1942/18.htm
	// http://www.w3.org/TR/CSS2/tables.html#width-layout
	// http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
	var minW = autoMin + starMaxMin * starColumns.length;
	var maxW = autoMax + starMaxMax * starColumns.length;
	if (minW >= availableWidth) {
		// case 1 - there's no way to fit all columns within available width
		// that's actually pretty bad situation with PDF as we have no horizontal scroll
		// no easy workaround (unless we decide, in the future, to split single words)
		// currently we simply use minWidths for all columns
		autoColumns.forEach(function (col) {
			col._calcWidth = col._minWidth;
		});

		starColumns.forEach(function (col) {
			col._calcWidth = starMaxMin; // starMaxMin already contains padding
		});
	} else {
		if (maxW < availableWidth) {
			// case 2 - we can fit rest of the table within available space
			autoColumns.forEach(function (col) {
				col._calcWidth = col._maxWidth;
				availableWidth -= col._calcWidth;
			});
		} else {
			// maxW is too large, but minW fits within available width
			var W = availableWidth - minW;
			var D = maxW - minW;

			autoColumns.forEach(function (col) {
				var d = col._maxWidth - col._minWidth;
				col._calcWidth = col._minWidth + d * W / D;
				availableWidth -= col._calcWidth;
			});
		}

		if (starColumns.length > 0) {
			var starSize = availableWidth / starColumns.length;

			starColumns.forEach(function (col) {
				col._calcWidth = starSize;
			});
		}
	}
}

function isAutoColumn(column) {
	return column.width === 'auto';
}

function isStarColumn(column) {
	return column.width === null || column.width === undefined || column.width === '*' || column.width === 'star';
}

//TODO: refactor and reuse in measureTable
function measureMinMax(columns) {
	var result = {min: 0, max: 0};

	var maxStar = {min: 0, max: 0};
	var starCount = 0;

	for (var i = 0, l = columns.length; i < l; i++) {
		var c = columns[i];

		if (isStarColumn(c)) {
			maxStar.min = Math.max(maxStar.min, c._minWidth);
			maxStar.max = Math.max(maxStar.max, c._maxWidth);
			starCount++;
		} else if (isAutoColumn(c)) {
			result.min += c._minWidth;
			result.max += c._maxWidth;
		} else {
			result.min += ((c.width !== undefined && c.width) || c._minWidth);
			result.max += ((c.width !== undefined && c.width) || c._maxWidth);
		}
	}

	if (starCount) {
		result.min += starCount * maxStar.min;
		result.max += starCount * maxStar.max;
	}

	return result;
}

/**
 * Calculates column widths
 * @private
 */
module.exports = {
	buildColumnWidths: buildColumnWidths,
	measureMinMax: measureMinMax,
	isAutoColumn: isAutoColumn,
	isStarColumn: isStarColumn
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(77);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(32).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(79);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(34).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(15);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(129);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(130);
var destroyImpl = __webpack_require__(80);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(16);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(46).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(16);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(46).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(32).EventEmitter;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(33);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(16);

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(15);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

/*
PDFReference - represents a reference to another object in the PDF object heirarchy
By Devon Govett
 */

(function() {
  var PDFObject, PDFReference, stream, zlib,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  zlib = __webpack_require__(47);

  stream = __webpack_require__(31);

  PDFReference = (function(superClass) {
    extend(PDFReference, superClass);

    function PDFReference(document, id, data) {
      this.document = document;
      this.id = id;
      this.data = data != null ? data : {};
      this.finalize = bind(this.finalize, this);
      PDFReference.__super__.constructor.call(this, {
        decodeStrings: false
      });
      this.gen = 0;
      this.deflate = null;
      this.compress = this.document.compress && !this.data.Filter;
      this.uncompressedLength = 0;
      this.chunks = [];
    }

    PDFReference.prototype.initDeflate = function() {
      this.data.Filter = 'FlateDecode';
      this.deflate = zlib.createDeflate();
      this.deflate.on('data', (function(_this) {
        return function(chunk) {
          _this.chunks.push(chunk);
          return _this.data.Length += chunk.length;
        };
      })(this));
      return this.deflate.on('end', this.finalize);
    };

    PDFReference.prototype._write = function(chunk, encoding, callback) {
      var base;
      if (!Buffer.isBuffer(chunk)) {
        chunk = new Buffer(chunk + '\n', 'binary');
      }
      this.uncompressedLength += chunk.length;
      if ((base = this.data).Length == null) {
        base.Length = 0;
      }
      if (this.compress) {
        if (!this.deflate) {
          this.initDeflate();
        }
        this.deflate.write(chunk);
      } else {
        this.chunks.push(chunk);
        this.data.Length += chunk.length;
      }
      return callback();
    };

    PDFReference.prototype.end = function(chunk) {
      PDFReference.__super__.end.apply(this, arguments);
      if (this.deflate) {
        return this.deflate.end();
      } else {
        return this.finalize();
      }
    };

    PDFReference.prototype.finalize = function() {
      var chunk, i, len, ref;
      this.offset = this.document._offset;
      this.document._write(this.id + " " + this.gen + " obj");
      this.document._write(PDFObject.convert(this.data));
      if (this.chunks.length) {
        this.document._write('stream');
        ref = this.chunks;
        for (i = 0, len = ref.length; i < len; i++) {
          chunk = ref[i];
          this.document._write(chunk);
        }
        this.chunks.length = 0;
        this.document._write('\nendstream');
      }
      this.document._write('endobj');
      return this.document._refEnd(this);
    };

    PDFReference.prototype.toString = function() {
      return this.id + " " + this.gen + " R";
    };

    return PDFReference;

  })(stream.Writable);

  module.exports = PDFReference;

  PDFObject = __webpack_require__(26);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(48);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = [["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var ArrayT, NumberT, utils;

  NumberT = __webpack_require__(22).Number;

  utils = __webpack_require__(12);

  ArrayT = (function() {
    function ArrayT(type, length, lengthType) {
      this.type = type;
      this.length = length;
      this.lengthType = lengthType != null ? lengthType : 'count';
    }

    ArrayT.prototype.decode = function(stream, parent) {
      var ctx, i, length, pos, res, target, _i;
      pos = stream.pos;
      res = [];
      ctx = parent;
      if (this.length != null) {
        length = utils.resolveLength(this.length, stream, parent);
      }
      if (this.length instanceof NumberT) {
        Object.defineProperties(res, {
          parent: {
            value: parent
          },
          _startOffset: {
            value: pos
          },
          _currentOffset: {
            value: 0,
            writable: true
          },
          _length: {
            value: length
          }
        });
        ctx = res;
      }
      if ((length == null) || this.lengthType === 'bytes') {
        target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
        while (stream.pos < target) {
          res.push(this.type.decode(stream, ctx));
        }
      } else {
        for (i = _i = 0; _i < length; i = _i += 1) {
          res.push(this.type.decode(stream, ctx));
        }
      }
      return res;
    };

    ArrayT.prototype.size = function(array, ctx) {
      var item, size, _i, _len;
      if (!array) {
        return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
      }
      size = 0;
      if (this.length instanceof NumberT) {
        size += this.length.size();
        ctx = {
          parent: ctx
        };
      }
      for (_i = 0, _len = array.length; _i < _len; _i++) {
        item = array[_i];
        size += this.type.size(item, ctx);
      }
      return size;
    };

    ArrayT.prototype.encode = function(stream, array, parent) {
      var ctx, i, item, ptr, _i, _len;
      ctx = parent;
      if (this.length instanceof NumberT) {
        ctx = {
          pointers: [],
          startOffset: stream.pos,
          parent: parent
        };
        ctx.pointerOffset = stream.pos + this.size(array, ctx);
        this.length.encode(stream, array.length);
      }
      for (_i = 0, _len = array.length; _i < _len; _i++) {
        item = array[_i];
        this.type.encode(stream, item, ctx);
      }
      if (this.length instanceof NumberT) {
        i = 0;
        while (i < ctx.pointers.length) {
          ptr = ctx.pointers[i++];
          ptr.type.encode(stream, ptr.val);
        }
      }
    };

    return ArrayT;

  })();

  module.exports = ArrayT;

}).call(this);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Struct, utils;

  utils = __webpack_require__(12);

  Struct = (function() {
    function Struct(fields) {
      this.fields = fields != null ? fields : {};
    }

    Struct.prototype.decode = function(stream, parent, length) {
      var res, _ref;
      if (length == null) {
        length = 0;
      }
      res = this._setup(stream, parent, length);
      this._parseFields(stream, res, this.fields);
      if ((_ref = this.process) != null) {
        _ref.call(res, stream);
      }
      return res;
    };

    Struct.prototype._setup = function(stream, parent, length) {
      var res;
      res = {};
      Object.defineProperties(res, {
        parent: {
          value: parent
        },
        _startOffset: {
          value: stream.pos
        },
        _currentOffset: {
          value: 0,
          writable: true
        },
        _length: {
          value: length
        }
      });
      return res;
    };

    Struct.prototype._parseFields = function(stream, res, fields) {
      var key, type, val;
      for (key in fields) {
        type = fields[key];
        if (typeof type === 'function') {
          val = type.call(res, res);
        } else {
          val = type.decode(stream, res);
        }
        if (val !== void 0) {
          if (val instanceof utils.PropertyDescriptor) {
            Object.defineProperty(res, key, val);
          } else {
            res[key] = val;
          }
        }
        res._currentOffset = stream.pos - res._startOffset;
      }
    };

    Struct.prototype.size = function(val, parent, includePointers) {
      var ctx, key, size, type, _ref;
      if (val == null) {
        val = {};
      }
      if (includePointers == null) {
        includePointers = true;
      }
      ctx = {
        parent: parent,
        val: val,
        pointerSize: 0
      };
      size = 0;
      _ref = this.fields;
      for (key in _ref) {
        type = _ref[key];
        if (type.size != null) {
          size += type.size(val[key], ctx);
        }
      }
      if (includePointers) {
        size += ctx.pointerSize;
      }
      return size;
    };

    Struct.prototype.encode = function(stream, val, parent) {
      var ctx, i, key, ptr, type, _ref, _ref1;
      if ((_ref = this.preEncode) != null) {
        _ref.call(val, stream);
      }
      ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent,
        val: val,
        pointerSize: 0
      };
      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
      _ref1 = this.fields;
      for (key in _ref1) {
        type = _ref1[key];
        if (type.encode != null) {
          type.encode(stream, val[key], ctx);
        }
      }
      i = 0;
      while (i < ctx.pointers.length) {
        ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    };

    return Struct;

  })();

  module.exports = Struct;

}).call(this);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(91)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(6);
var anObject = __webpack_require__(14);
var getKeys = __webpack_require__(29);

module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(18);
var toIObject = __webpack_require__(17);
var arrayIndexOf = __webpack_require__(193)(false);
var IE_PROTO = __webpack_require__(62)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(204), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(54);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(96);
var hiddenKeys = __webpack_require__(64).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(72);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(6).f;
var create = __webpack_require__(38);
var redefineAll = __webpack_require__(104);
var ctx = __webpack_require__(20);
var anInstance = __webpack_require__(105);
var forOf = __webpack_require__(43);
var $iterDefine = __webpack_require__(60);
var step = __webpack_require__(93);
var setSpecies = __webpack_require__(217);
var DESCRIPTORS = __webpack_require__(5);
var fastKey = __webpack_require__(42).fastKey;
var validate = __webpack_require__(73);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(13);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(14);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(23);
var ITERATOR = __webpack_require__(4)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var $export = __webpack_require__(3);
var meta = __webpack_require__(42);
var fails = __webpack_require__(19);
var hide = __webpack_require__(13);
var redefineAll = __webpack_require__(104);
var forOf = __webpack_require__(43);
var anInstance = __webpack_require__(105);
var isObject = __webpack_require__(10);
var setToStringTag = __webpack_require__(41);
var dP = __webpack_require__(6).f;
var each = __webpack_require__(218)(0);
var DESCRIPTORS = __webpack_require__(5);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(66);
var from = __webpack_require__(222);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(92);
var ctx = __webpack_require__(20);
var forOf = __webpack_require__(43);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

var TINF_OK = 0;
var TINF_DATA_ERROR = -3;

function Tree() {
  this.table = new Uint16Array(16);   /* table of code length counts */
  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
}

function Data(source, dest) {
  this.source = source;
  this.sourceIndex = 0;
  this.tag = 0;
  this.bitcount = 0;
  
  this.dest = dest;
  this.destLen = 0;
  
  this.ltree = new Tree();  /* dynamic length/symbol tree */
  this.dtree = new Tree();  /* dynamic distance tree */
}

/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */

var sltree = new Tree();
var sdtree = new Tree();

/* extra bits and base tables for length codes */
var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);

/* extra bits and base tables for distance codes */
var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);

/* special ordering of code length codes */
var clcidx = new Uint8Array([
  16, 17, 18, 0, 8, 7, 9, 6,
  10, 5, 11, 4, 12, 3, 13, 2,
  14, 1, 15
]);

/* used by tinf_decode_trees, avoids allocations every call */
var code_tree = new Tree();
var lengths = new Uint8Array(288 + 32);

/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */

/* build extra bits and base tables */
function tinf_build_bits_base(bits, base, delta, first) {
  var i, sum;

  /* build bits table */
  for (i = 0; i < delta; ++i) bits[i] = 0;
  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

  /* build base table */
  for (sum = first, i = 0; i < 30; ++i) {
    base[i] = sum;
    sum += 1 << bits[i];
  }
}

/* build the fixed huffman trees */
function tinf_build_fixed_trees(lt, dt) {
  var i;

  /* build fixed length tree */
  for (i = 0; i < 7; ++i) lt.table[i] = 0;

  lt.table[7] = 24;
  lt.table[8] = 152;
  lt.table[9] = 112;

  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

  /* build fixed distance tree */
  for (i = 0; i < 5; ++i) dt.table[i] = 0;

  dt.table[5] = 32;

  for (i = 0; i < 32; ++i) dt.trans[i] = i;
}

/* given an array of code lengths, build a tree */
var offs = new Uint16Array(16);

function tinf_build_tree(t, lengths, off, num) {
  var i, sum;

  /* clear code length count table */
  for (i = 0; i < 16; ++i) t.table[i] = 0;

  /* scan symbol lengths, and sum code length counts */
  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

  t.table[0] = 0;

  /* compute offset table for distribution sort */
  for (sum = 0, i = 0; i < 16; ++i) {
    offs[i] = sum;
    sum += t.table[i];
  }

  /* create code->symbol translation table (symbols sorted by code) */
  for (i = 0; i < num; ++i) {
    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
  }
}

/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */

/* get one bit from source stream */
function tinf_getbit(d) {
  /* check if tag is empty */
  if (!d.bitcount--) {
    /* load next tag */
    d.tag = d.source[d.sourceIndex++];
    d.bitcount = 7;
  }

  /* shift bit out of tag */
  var bit = d.tag & 1;
  d.tag >>>= 1;

  return bit;
}

/* read a num bit value from a stream and add base */
function tinf_read_bits(d, num, base) {
  if (!num)
    return base;

  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }

  var val = d.tag & (0xffff >>> (16 - num));
  d.tag >>>= num;
  d.bitcount -= num;
  return val + base;
}

/* given a data stream and a tree, decode a symbol */
function tinf_decode_symbol(d, t) {
  while (d.bitcount < 24) {
    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
    d.bitcount += 8;
  }
  
  var sum = 0, cur = 0, len = 0;
  var tag = d.tag;

  /* get more bits while code value is above sum */
  do {
    cur = 2 * cur + (tag & 1);
    tag >>>= 1;
    ++len;

    sum += t.table[len];
    cur -= t.table[len];
  } while (cur >= 0);
  
  d.tag = tag;
  d.bitcount -= len;

  return t.trans[sum + cur];
}

/* given a data stream, decode dynamic trees from it */
function tinf_decode_trees(d, lt, dt) {
  var hlit, hdist, hclen;
  var i, num, length;

  /* get 5 bits HLIT (257-286) */
  hlit = tinf_read_bits(d, 5, 257);

  /* get 5 bits HDIST (1-32) */
  hdist = tinf_read_bits(d, 5, 1);

  /* get 4 bits HCLEN (4-19) */
  hclen = tinf_read_bits(d, 4, 4);

  for (i = 0; i < 19; ++i) lengths[i] = 0;

  /* read code lengths for code length alphabet */
  for (i = 0; i < hclen; ++i) {
    /* get 3 bits code length (0-7) */
    var clen = tinf_read_bits(d, 3, 0);
    lengths[clcidx[i]] = clen;
  }

  /* build code length tree */
  tinf_build_tree(code_tree, lengths, 0, 19);

  /* decode code lengths for the dynamic trees */
  for (num = 0; num < hlit + hdist;) {
    var sym = tinf_decode_symbol(d, code_tree);

    switch (sym) {
      case 16:
        /* copy previous code length 3-6 times (read 2 bits) */
        var prev = lengths[num - 1];
        for (length = tinf_read_bits(d, 2, 3); length; --length) {
          lengths[num++] = prev;
        }
        break;
      case 17:
        /* repeat code length 0 for 3-10 times (read 3 bits) */
        for (length = tinf_read_bits(d, 3, 3); length; --length) {
          lengths[num++] = 0;
        }
        break;
      case 18:
        /* repeat code length 0 for 11-138 times (read 7 bits) */
        for (length = tinf_read_bits(d, 7, 11); length; --length) {
          lengths[num++] = 0;
        }
        break;
      default:
        /* values 0-15 represent the actual code lengths */
        lengths[num++] = sym;
        break;
    }
  }

  /* build dynamic trees */
  tinf_build_tree(lt, lengths, 0, hlit);
  tinf_build_tree(dt, lengths, hlit, hdist);
}

/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */

/* given a stream and two trees, inflate a block of data */
function tinf_inflate_block_data(d, lt, dt) {
  while (1) {
    var sym = tinf_decode_symbol(d, lt);

    /* check for end of block */
    if (sym === 256) {
      return TINF_OK;
    }

    if (sym < 256) {
      d.dest[d.destLen++] = sym;
    } else {
      var length, dist, offs;
      var i;

      sym -= 257;

      /* possibly get more bits from length code */
      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

      dist = tinf_decode_symbol(d, dt);

      /* possibly get more bits from distance code */
      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

      /* copy match */
      for (i = offs; i < offs + length; ++i) {
        d.dest[d.destLen++] = d.dest[i];
      }
    }
  }
}

/* inflate an uncompressed block of data */
function tinf_inflate_uncompressed_block(d) {
  var length, invlength;
  var i;
  
  /* unread from bitbuffer */
  while (d.bitcount > 8) {
    d.sourceIndex--;
    d.bitcount -= 8;
  }

  /* get length */
  length = d.source[d.sourceIndex + 1];
  length = 256 * length + d.source[d.sourceIndex];

  /* get one's complement of length */
  invlength = d.source[d.sourceIndex + 3];
  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

  /* check length */
  if (length !== (~invlength & 0x0000ffff))
    return TINF_DATA_ERROR;

  d.sourceIndex += 4;

  /* copy block */
  for (i = length; i; --i)
    d.dest[d.destLen++] = d.source[d.sourceIndex++];

  /* make sure we start next block on a byte boundary */
  d.bitcount = 0;

  return TINF_OK;
}

/* inflate stream from source to dest */
function tinf_uncompress(source, dest) {
  var d = new Data(source, dest);
  var bfinal, btype, res;

  do {
    /* read final block flag */
    bfinal = tinf_getbit(d);

    /* read block type (2 bits) */
    btype = tinf_read_bits(d, 2, 0);

    /* decompress block */
    switch (btype) {
      case 0:
        /* decompress uncompressed block */
        res = tinf_inflate_uncompressed_block(d);
        break;
      case 1:
        /* decompress block with fixed huffman trees */
        res = tinf_inflate_block_data(d, sltree, sdtree);
        break;
      case 2:
        /* decompress block with dynamic huffman trees */
        tinf_decode_trees(d, d.ltree, d.dtree);
        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
        break;
      default:
        res = TINF_DATA_ERROR;
    }

    if (res !== TINF_OK)
      throw new Error('Data error');

  } while (!bfinal);

  if (d.destLen < d.dest.length) {
    if (typeof d.dest.slice === 'function')
      return d.dest.slice(0, d.destLen);
    else
      return d.dest.subarray(0, d.destLen);
  }
  
  return d.dest;
}

/* -------------------- *
 * -- initialization -- *
 * -------------------- */

/* build fixed huffman trees */
tinf_build_fixed_trees(sltree, sdtree);

/* build extra bits and base tables */
tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);

/* fix a special case */
length_bits[28] = 0;
length_base[28] = 258;

module.exports = tinf_uncompress;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

var BrotliInput = __webpack_require__(114).BrotliInput;
var BrotliOutput = __webpack_require__(114).BrotliOutput;
var BrotliBitReader = __webpack_require__(274);
var BrotliDictionary = __webpack_require__(115);
var HuffmanCode = __webpack_require__(116).HuffmanCode;
var BrotliBuildHuffmanTable = __webpack_require__(116).BrotliBuildHuffmanTable;
var Context = __webpack_require__(278);
var Prefix = __webpack_require__(279);
var Transform = __webpack_require__(280);

var kDefaultCodeLength = 8;
var kCodeLengthRepeatCode = 16;
var kNumLiteralCodes = 256;
var kNumInsertAndCopyCodes = 704;
var kNumBlockLengthCodes = 26;
var kLiteralContextBits = 6;
var kDistanceContextBits = 2;

var HUFFMAN_TABLE_BITS = 8;
var HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */
var HUFFMAN_MAX_TABLE_SIZE = 1080;

var CODE_LENGTH_CODES = 18;
var kCodeLengthCodeOrder = new Uint8Array([
  1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
]);

var NUM_DISTANCE_SHORT_CODES = 16;
var kDistanceShortCodeIndexOffset = new Uint8Array([
  3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2
]);

var kDistanceShortCodeValueOffset = new Int8Array([
  0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3
]);

var kMaxHuffmanTableSize = new Uint16Array([
  256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758, 790, 822,
  854, 886, 920, 952, 984, 1016, 1048, 1080
]);

function DecodeWindowBits(br) {
  var n;
  if (br.readBits(1) === 0) {
    return 16;
  }
  
  n = br.readBits(3);
  if (n > 0) {
    return 17 + n;
  }
  
  n = br.readBits(3);
  if (n > 0) {
    return 8 + n;
  }
  
  return 17;
}

/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
function DecodeVarLenUint8(br) {
  if (br.readBits(1)) {
    var nbits = br.readBits(3);
    if (nbits === 0) {
      return 1;
    } else {
      return br.readBits(nbits) + (1 << nbits);
    }
  }
  return 0;
}

function MetaBlockLength() {
  this.meta_block_length = 0;
  this.input_end = 0;
  this.is_uncompressed = 0;
  this.is_metadata = false;
}

function DecodeMetaBlockLength(br) {
  var out = new MetaBlockLength;  
  var size_nibbles;
  var size_bytes;
  var i;
  
  out.input_end = br.readBits(1);
  if (out.input_end && br.readBits(1)) {
    return out;
  }
  
  size_nibbles = br.readBits(2) + 4;
  if (size_nibbles === 7) {
    out.is_metadata = true;
    
    if (br.readBits(1) !== 0)
      throw new Error('Invalid reserved bit');
    
    size_bytes = br.readBits(2);
    if (size_bytes === 0)
      return out;
    
    for (i = 0; i < size_bytes; i++) {
      var next_byte = br.readBits(8);
      if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
        throw new Error('Invalid size byte');
      
      out.meta_block_length |= next_byte << (i * 8);
    }
  } else {
    for (i = 0; i < size_nibbles; ++i) {
      var next_nibble = br.readBits(4);
      if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0)
        throw new Error('Invalid size nibble');
      
      out.meta_block_length |= next_nibble << (i * 4);
    }
  }
  
  ++out.meta_block_length;
  
  if (!out.input_end && !out.is_metadata) {
    out.is_uncompressed = br.readBits(1);
  }
  
  return out;
}

/* Decodes the next Huffman code from bit-stream. */
function ReadSymbol(table, index, br) {
  var start_index = index;
  
  var nbits;
  br.fillBitWindow();
  index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
  nbits = table[index].bits - HUFFMAN_TABLE_BITS;
  if (nbits > 0) {
    br.bit_pos_ += HUFFMAN_TABLE_BITS;
    index += table[index].value;
    index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
  }
  br.bit_pos_ += table[index].bits;
  return table[index].value;
}

function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
  var symbol = 0;
  var prev_code_len = kDefaultCodeLength;
  var repeat = 0;
  var repeat_code_len = 0;
  var space = 32768;
  
  var table = [];
  for (var i = 0; i < 32; i++)
    table.push(new HuffmanCode(0, 0));
  
  BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);

  while (symbol < num_symbols && space > 0) {
    var p = 0;
    var code_len;
    
    br.readMoreInput();
    br.fillBitWindow();
    p += (br.val_ >>> br.bit_pos_) & 31;
    br.bit_pos_ += table[p].bits;
    code_len = table[p].value & 0xff;
    if (code_len < kCodeLengthRepeatCode) {
      repeat = 0;
      code_lengths[symbol++] = code_len;
      if (code_len !== 0) {
        prev_code_len = code_len;
        space -= 32768 >> code_len;
      }
    } else {
      var extra_bits = code_len - 14;
      var old_repeat;
      var repeat_delta;
      var new_len = 0;
      if (code_len === kCodeLengthRepeatCode) {
        new_len = prev_code_len;
      }
      if (repeat_code_len !== new_len) {
        repeat = 0;
        repeat_code_len = new_len;
      }
      old_repeat = repeat;
      if (repeat > 0) {
        repeat -= 2;
        repeat <<= extra_bits;
      }
      repeat += br.readBits(extra_bits) + 3;
      repeat_delta = repeat - old_repeat;
      if (symbol + repeat_delta > num_symbols) {
        throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
      }
      
      for (var x = 0; x < repeat_delta; x++)
        code_lengths[symbol + x] = repeat_code_len;
      
      symbol += repeat_delta;
      
      if (repeat_code_len !== 0) {
        space -= repeat_delta << (15 - repeat_code_len);
      }
    }
  }
  if (space !== 0) {
    throw new Error("[ReadHuffmanCodeLengths] space = " + space);
  }
  
  for (; symbol < num_symbols; symbol++)
    code_lengths[symbol] = 0;
}

function ReadHuffmanCode(alphabet_size, tables, table, br) {
  var table_size = 0;
  var simple_code_or_skip;
  var code_lengths = new Uint8Array(alphabet_size);
  
  br.readMoreInput();
  
  /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
  simple_code_or_skip = br.readBits(2);
  if (simple_code_or_skip === 1) {
    /* Read symbols, codes & code lengths directly. */
    var i;
    var max_bits_counter = alphabet_size - 1;
    var max_bits = 0;
    var symbols = new Int32Array(4);
    var num_symbols = br.readBits(2) + 1;
    while (max_bits_counter) {
      max_bits_counter >>= 1;
      ++max_bits;
    }

    for (i = 0; i < num_symbols; ++i) {
      symbols[i] = br.readBits(max_bits) % alphabet_size;
      code_lengths[symbols[i]] = 2;
    }
    code_lengths[symbols[0]] = 1;
    switch (num_symbols) {
      case 1:
        break;
      case 3:
        if ((symbols[0] === symbols[1]) ||
            (symbols[0] === symbols[2]) ||
            (symbols[1] === symbols[2])) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        break;
      case 2:
        if (symbols[0] === symbols[1]) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        
        code_lengths[symbols[1]] = 1;
        break;
      case 4:
        if ((symbols[0] === symbols[1]) ||
            (symbols[0] === symbols[2]) ||
            (symbols[0] === symbols[3]) ||
            (symbols[1] === symbols[2]) ||
            (symbols[1] === symbols[3]) ||
            (symbols[2] === symbols[3])) {
          throw new Error('[ReadHuffmanCode] invalid symbols');
        }
        
        if (br.readBits(1)) {
          code_lengths[symbols[2]] = 3;
          code_lengths[symbols[3]] = 3;
        } else {
          code_lengths[symbols[0]] = 2;
        }
        break;
    }
  } else {  /* Decode Huffman-coded code lengths. */
    var i;
    var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
    var space = 32;
    var num_codes = 0;
    /* Static Huffman code for the code length code lengths */
    var huff = [
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 1),
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 5)
    ];
    for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
      var code_len_idx = kCodeLengthCodeOrder[i];
      var p = 0;
      var v;
      br.fillBitWindow();
      p += (br.val_ >>> br.bit_pos_) & 15;
      br.bit_pos_ += huff[p].bits;
      v = huff[p].value;
      code_length_code_lengths[code_len_idx] = v;
      if (v !== 0) {
        space -= (32 >> v);
        ++num_codes;
      }
    }
    
    if (!(num_codes === 1 || space === 0))
      throw new Error('[ReadHuffmanCode] invalid num_codes or space');
    
    ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
  }
  
  table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
  
  if (table_size === 0) {
    throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
  }
  
  return table_size;
}

function ReadBlockLength(table, index, br) {
  var code;
  var nbits;
  code = ReadSymbol(table, index, br);
  nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
  return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}

function TranslateShortCodes(code, ringbuffer, index) {
  var val;
  if (code < NUM_DISTANCE_SHORT_CODES) {
    index += kDistanceShortCodeIndexOffset[code];
    index &= 3;
    val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
  } else {
    val = code - NUM_DISTANCE_SHORT_CODES + 1;
  }
  return val;
}

function MoveToFront(v, index) {
  var value = v[index];
  var i = index;
  for (; i; --i) v[i] = v[i - 1];
  v[0] = value;
}

function InverseMoveToFrontTransform(v, v_len) {
  var mtf = new Uint8Array(256);
  var i;
  for (i = 0; i < 256; ++i) {
    mtf[i] = i;
  }
  for (i = 0; i < v_len; ++i) {
    var index = v[i];
    v[i] = mtf[index];
    if (index) MoveToFront(mtf, index);
  }
}

/* Contains a collection of huffman trees with the same alphabet size. */
function HuffmanTreeGroup(alphabet_size, num_htrees) {
  this.alphabet_size = alphabet_size;
  this.num_htrees = num_htrees;
  this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]);  
  this.htrees = new Uint32Array(num_htrees);
}

HuffmanTreeGroup.prototype.decode = function(br) {
  var i;
  var table_size;
  var next = 0;
  for (i = 0; i < this.num_htrees; ++i) {
    this.htrees[i] = next;
    table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
    next += table_size;
  }
};

function DecodeContextMap(context_map_size, br) {
  var out = { num_htrees: null, context_map: null };
  var use_rle_for_zeros;
  var max_run_length_prefix = 0;
  var table;
  var i;
  
  br.readMoreInput();
  var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;

  var context_map = out.context_map = new Uint8Array(context_map_size);
  if (num_htrees <= 1) {
    return out;
  }

  use_rle_for_zeros = br.readBits(1);
  if (use_rle_for_zeros) {
    max_run_length_prefix = br.readBits(4) + 1;
  }
  
  table = [];
  for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
    table[i] = new HuffmanCode(0, 0);
  }
  
  ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
  
  for (i = 0; i < context_map_size;) {
    var code;

    br.readMoreInput();
    code = ReadSymbol(table, 0, br);
    if (code === 0) {
      context_map[i] = 0;
      ++i;
    } else if (code <= max_run_length_prefix) {
      var reps = 1 + (1 << code) + br.readBits(code);
      while (--reps) {
        if (i >= context_map_size) {
          throw new Error("[DecodeContextMap] i >= context_map_size");
        }
        context_map[i] = 0;
        ++i;
      }
    } else {
      context_map[i] = code - max_run_length_prefix;
      ++i;
    }
  }
  if (br.readBits(1)) {
    InverseMoveToFrontTransform(context_map, context_map_size);
  }
  
  return out;
}

function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
  var ringbuffer = tree_type * 2;
  var index = tree_type;
  var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
  var block_type;
  if (type_code === 0) {
    block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
  } else if (type_code === 1) {
    block_type = ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
  } else {
    block_type = type_code - 2;
  }
  if (block_type >= max_block_type) {
    block_type -= max_block_type;
  }
  block_types[tree_type] = block_type;
  ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
  ++indexes[index];
}

function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
  var rb_size = ringbuffer_mask + 1;
  var rb_pos = pos & ringbuffer_mask;
  var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
  var nbytes;

  /* For short lengths copy byte-by-byte */
  if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
    while (len-- > 0) {
      br.readMoreInput();
      ringbuffer[rb_pos++] = br.readBits(8);
      if (rb_pos === rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos = 0;
      }
    }
    return;
  }

  if (br.bit_end_pos_ < 32) {
    throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
  }

  /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
  while (br.bit_pos_ < 32) {
    ringbuffer[rb_pos] = (br.val_ >>> br.bit_pos_);
    br.bit_pos_ += 8;
    ++rb_pos;
    --len;
  }

  /* Copy remaining bytes from br.buf_ to ringbuffer. */
  nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
  if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
    var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
    for (var x = 0; x < tail; x++)
      ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    
    nbytes -= tail;
    rb_pos += tail;
    len -= tail;
    br_pos = 0;
  }

  for (var x = 0; x < nbytes; x++)
    ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
  
  rb_pos += nbytes;
  len -= nbytes;

  /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */
  if (rb_pos >= rb_size) {
    output.write(ringbuffer, rb_size);
    rb_pos -= rb_size;    
    for (var x = 0; x < rb_pos; x++)
      ringbuffer[x] = ringbuffer[rb_size + x];
  }

  /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */
  while (rb_pos + len >= rb_size) {
    nbytes = rb_size - rb_pos;
    if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
      throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    }
    output.write(ringbuffer, rb_size);
    len -= nbytes;
    rb_pos = 0;
  }

  /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */
  if (br.input_.read(ringbuffer, rb_pos, len) < len) {
    throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
  }

  /* Restore the state of the bit reader. */
  br.reset();
}

/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */
function JumpToByteBoundary(br) {
  var new_bit_pos = (br.bit_pos_ + 7) & ~7;
  var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
  return pad_bits == 0;
}

function BrotliDecompressedSize(buffer) {
  var input = new BrotliInput(buffer);
  var br = new BrotliBitReader(input);
  DecodeWindowBits(br);
  var out = DecodeMetaBlockLength(br);
  return out.meta_block_length;
}

exports.BrotliDecompressedSize = BrotliDecompressedSize;

function BrotliDecompressBuffer(buffer, output_size) {
  var input = new BrotliInput(buffer);
  
  if (output_size == null) {
    output_size = BrotliDecompressedSize(buffer);
  }
  
  var output_buffer = new Uint8Array(output_size);
  var output = new BrotliOutput(output_buffer);
  
  BrotliDecompress(input, output);
  
  if (output.pos < output.buffer.length) {
    output.buffer = output.buffer.subarray(0, output.pos);
  }
  
  return output.buffer;
}

exports.BrotliDecompressBuffer = BrotliDecompressBuffer;

function BrotliDecompress(input, output) {
  var i;
  var pos = 0;
  var input_end = 0;
  var window_bits = 0;
  var max_backward_distance;
  var max_distance = 0;
  var ringbuffer_size;
  var ringbuffer_mask;
  var ringbuffer;
  var ringbuffer_end;
  /* This ring buffer holds a few past copy distances that will be used by */
  /* some special distance codes. */
  var dist_rb = [ 16, 15, 11, 4 ];
  var dist_rb_idx = 0;
  /* The previous 2 bytes used for context. */
  var prev_byte1 = 0;
  var prev_byte2 = 0;
  var hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
  var block_type_trees;
  var block_len_trees;
  var br;

  /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */
  var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;

  br = new BrotliBitReader(input);

  /* Decode window size. */
  window_bits = DecodeWindowBits(br);
  max_backward_distance = (1 << window_bits) - 16;

  ringbuffer_size = 1 << window_bits;
  ringbuffer_mask = ringbuffer_size - 1;
  ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
  ringbuffer_end = ringbuffer_size;

  block_type_trees = [];
  block_len_trees = [];
  for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
    block_type_trees[x] = new HuffmanCode(0, 0);
    block_len_trees[x] = new HuffmanCode(0, 0);
  }

  while (!input_end) {
    var meta_block_remaining_len = 0;
    var is_uncompressed;
    var block_length = [ 1 << 28, 1 << 28, 1 << 28 ];
    var block_type = [ 0 ];
    var num_block_types = [ 1, 1, 1 ];
    var block_type_rb = [ 0, 1, 0, 1, 0, 1 ];
    var block_type_rb_index = [ 0 ];
    var distance_postfix_bits;
    var num_direct_distance_codes;
    var distance_postfix_mask;
    var num_distance_codes;
    var context_map = null;
    var context_modes = null;
    var num_literal_htrees;
    var dist_context_map = null;
    var num_dist_htrees;
    var context_offset = 0;
    var context_map_slice = null;
    var literal_htree_index = 0;
    var dist_context_offset = 0;
    var dist_context_map_slice = null;
    var dist_htree_index = 0;
    var context_lookup_offset1 = 0;
    var context_lookup_offset2 = 0;
    var context_mode;
    var htree_command;

    for (i = 0; i < 3; ++i) {
      hgroup[i].codes = null;
      hgroup[i].htrees = null;
    }

    br.readMoreInput();
    
    var _out = DecodeMetaBlockLength(br);
    meta_block_remaining_len = _out.meta_block_length;
    if (pos + meta_block_remaining_len > output.buffer.length) {
      /* We need to grow the output buffer to fit the additional data. */
      var tmp = new Uint8Array( pos + meta_block_remaining_len );
      tmp.set( output.buffer );
      output.buffer = tmp;
    }    
    input_end = _out.input_end;
    is_uncompressed = _out.is_uncompressed;
    
    if (_out.is_metadata) {
      JumpToByteBoundary(br);
      
      for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
        br.readMoreInput();
        /* Read one byte and ignore it. */
        br.readBits(8);
      }
      
      continue;
    }
    
    if (meta_block_remaining_len === 0) {
      continue;
    }
    
    if (is_uncompressed) {
      br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
      CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos,
                                    ringbuffer, ringbuffer_mask, br);
      pos += meta_block_remaining_len;
      continue;
    }
    
    for (i = 0; i < 3; ++i) {
      num_block_types[i] = DecodeVarLenUint8(br) + 1;
      if (num_block_types[i] >= 2) {
        ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
        block_type_rb_index[i] = 1;
      }
    }
    
    br.readMoreInput();
    
    distance_postfix_bits = br.readBits(2);
    num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
    distance_postfix_mask = (1 << distance_postfix_bits) - 1;
    num_distance_codes = (num_direct_distance_codes + (48 << distance_postfix_bits));
    context_modes = new Uint8Array(num_block_types[0]);

    for (i = 0; i < num_block_types[0]; ++i) {
       br.readMoreInput();
       context_modes[i] = (br.readBits(2) << 1);
    }
    
    var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
    num_literal_htrees = _o1.num_htrees;
    context_map = _o1.context_map;
    
    var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
    num_dist_htrees = _o2.num_htrees;
    dist_context_map = _o2.context_map;
    
    hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
    hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
    hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);

    for (i = 0; i < 3; ++i) {
      hgroup[i].decode(br);
    }

    context_map_slice = 0;
    dist_context_map_slice = 0;
    context_mode = context_modes[block_type[0]];
    context_lookup_offset1 = Context.lookupOffsets[context_mode];
    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
    htree_command = hgroup[1].htrees[0];

    while (meta_block_remaining_len > 0) {
      var cmd_code;
      var range_idx;
      var insert_code;
      var copy_code;
      var insert_length;
      var copy_length;
      var distance_code;
      var distance;
      var context;
      var j;
      var copy_dst;

      br.readMoreInput();
      
      if (block_length[1] === 0) {
        DecodeBlockType(num_block_types[1],
                        block_type_trees, 1, block_type, block_type_rb,
                        block_type_rb_index, br);
        block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
        htree_command = hgroup[1].htrees[block_type[1]];
      }
      --block_length[1];
      cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
      range_idx = cmd_code >> 6;
      if (range_idx >= 2) {
        range_idx -= 2;
        distance_code = -1;
      } else {
        distance_code = 0;
      }
      insert_code = Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
      copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
      insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset +
          br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
      copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset +
          br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
      prev_byte1 = ringbuffer[pos-1 & ringbuffer_mask];
      prev_byte2 = ringbuffer[pos-2 & ringbuffer_mask];
      for (j = 0; j < insert_length; ++j) {
        br.readMoreInput();

        if (block_length[0] === 0) {
          DecodeBlockType(num_block_types[0],
                          block_type_trees, 0, block_type, block_type_rb,
                          block_type_rb_index, br);
          block_length[0] = ReadBlockLength(block_len_trees, 0, br);
          context_offset = block_type[0] << kLiteralContextBits;
          context_map_slice = context_offset;
          context_mode = context_modes[block_type[0]];
          context_lookup_offset1 = Context.lookupOffsets[context_mode];
          context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
        }
        context = (Context.lookup[context_lookup_offset1 + prev_byte1] |
                   Context.lookup[context_lookup_offset2 + prev_byte2]);
        literal_htree_index = context_map[context_map_slice + context];
        --block_length[0];
        prev_byte2 = prev_byte1;
        prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
        ringbuffer[pos & ringbuffer_mask] = prev_byte1;
        if ((pos & ringbuffer_mask) === ringbuffer_mask) {
          output.write(ringbuffer, ringbuffer_size);
        }
        ++pos;
      }
      meta_block_remaining_len -= insert_length;
      if (meta_block_remaining_len <= 0) break;

      if (distance_code < 0) {
        var context;
        
        br.readMoreInput();
        if (block_length[2] === 0) {
          DecodeBlockType(num_block_types[2],
                          block_type_trees, 2, block_type, block_type_rb,
                          block_type_rb_index, br);
          block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
          dist_context_offset = block_type[2] << kDistanceContextBits;
          dist_context_map_slice = dist_context_offset;
        }
        --block_length[2];
        context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
        dist_htree_index = dist_context_map[dist_context_map_slice + context];
        distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
        if (distance_code >= num_direct_distance_codes) {
          var nbits;
          var postfix;
          var offset;
          distance_code -= num_direct_distance_codes;
          postfix = distance_code & distance_postfix_mask;
          distance_code >>= distance_postfix_bits;
          nbits = (distance_code >> 1) + 1;
          offset = ((2 + (distance_code & 1)) << nbits) - 4;
          distance_code = num_direct_distance_codes +
              ((offset + br.readBits(nbits)) <<
               distance_postfix_bits) + postfix;
        }
      }

      /* Convert the distance code to the actual distance by possibly looking */
      /* up past distnaces from the ringbuffer. */
      distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
      if (distance < 0) {
        throw new Error('[BrotliDecompress] invalid distance');
      }

      if (pos < max_backward_distance &&
          max_distance !== max_backward_distance) {
        max_distance = pos;
      } else {
        max_distance = max_backward_distance;
      }

      copy_dst = pos & ringbuffer_mask;

      if (distance > max_distance) {
        if (copy_length >= BrotliDictionary.minDictionaryWordLength &&
            copy_length <= BrotliDictionary.maxDictionaryWordLength) {
          var offset = BrotliDictionary.offsetsByLength[copy_length];
          var word_id = distance - max_distance - 1;
          var shift = BrotliDictionary.sizeBitsByLength[copy_length];
          var mask = (1 << shift) - 1;
          var word_idx = word_id & mask;
          var transform_idx = word_id >> shift;
          offset += word_idx * copy_length;
          if (transform_idx < Transform.kNumTransforms) {
            var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
            copy_dst += len;
            pos += len;
            meta_block_remaining_len -= len;
            if (copy_dst >= ringbuffer_end) {
              output.write(ringbuffer, ringbuffer_size);
              
              for (var _x = 0; _x < (copy_dst - ringbuffer_end); _x++)
                ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
            }
          } else {
            throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
              " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
          }
        } else {
          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
        }
      } else {
        if (distance_code > 0) {
          dist_rb[dist_rb_idx & 3] = distance;
          ++dist_rb_idx;
        }

        if (copy_length > meta_block_remaining_len) {
          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
        }

        for (j = 0; j < copy_length; ++j) {
          ringbuffer[pos & ringbuffer_mask] = ringbuffer[(pos - distance) & ringbuffer_mask];
          if ((pos & ringbuffer_mask) === ringbuffer_mask) {
            output.write(ringbuffer, ringbuffer_size);
          }
          ++pos;
          --meta_block_remaining_len;
        }
      }

      /* When we get here, we must have inserted at least one literal and */
      /* made a copy of at least length two, therefore accessing the last 2 */
      /* bytes is valid. */
      prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
      prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
    }

    /* Protect pos from overflow, wrap it around at every GB of input data */
    pos &= 0x3fffffff;
  }

  output.write(ringbuffer, pos & ringbuffer_mask);
}

exports.BrotliDecompress = BrotliDecompress;

BrotliDictionary.init();


/***/ }),
/* 114 */
/***/ (function(module, exports) {

function BrotliInput(buffer) {
  this.buffer = buffer;
  this.pos = 0;
}

BrotliInput.prototype.read = function(buf, i, count) {
  if (this.pos + count > this.buffer.length) {
    count = this.buffer.length - this.pos;
  }
  
  for (var p = 0; p < count; p++)
    buf[i + p] = this.buffer[this.pos + p];
  
  this.pos += count;
  return count;
}

exports.BrotliInput = BrotliInput;

function BrotliOutput(buf) {
  this.buffer = buf;
  this.pos = 0;
}

BrotliOutput.prototype.write = function(buf, count) {
  if (this.pos + count > this.buffer.length)
    throw new Error('Output buffer is not large enough');
  
  this.buffer.set(buf.subarray(0, count), this.pos);
  this.pos += count;
  return count;
};

exports.BrotliOutput = BrotliOutput;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/

var data = __webpack_require__(275);
exports.init = function() {
  exports.dictionary = data.init();
};

exports.offsetsByLength = new Uint32Array([
     0,     0,     0,     0,     0,  4096,  9216, 21504, 35840, 44032,
 53248, 63488, 74752, 87040, 93696, 100864, 104704, 106752, 108928, 113536,
 115968, 118528, 119872, 121280, 122016,
]);

exports.sizeBitsByLength = new Uint8Array([
  0,  0,  0,  0, 10, 10, 11, 11, 10, 10,
 10, 10, 10,  9,  9,  8,  7,  7,  8,  7,
  7,  6,  6,  5,  5,
]);

exports.minDictionaryWordLength = 4;
exports.maxDictionaryWordLength = 24;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

function HuffmanCode(bits, value) {
  this.bits = bits;   /* number of bits used for this symbol */
  this.value = value; /* symbol value or table offset */
}

exports.HuffmanCode = HuffmanCode;

var MAX_LENGTH = 15;

/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */
function GetNextKey(key, len) {
  var step = 1 << (len - 1);
  while (key & step) {
    step >>= 1;
  }
  return (key & (step - 1)) + step;
}

/* Stores code in table[0], table[step], table[2*step], ..., table[end] */
/* Assumes that end is an integer multiple of step */
function ReplicateValue(table, i, step, end, code) {
  do {
    end -= step;
    table[i + end] = new HuffmanCode(code.bits, code.value);
  } while (end > 0);
}

/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */
function NextTableBitSize(count, len, root_bits) {
  var left = 1 << (len - root_bits);
  while (len < MAX_LENGTH) {
    left -= count[len];
    if (left <= 0) break;
    ++len;
    left <<= 1;
  }
  return len - root_bits;
}

exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
  var start_table = table;
  var code;            /* current table entry */
  var len;             /* current code length */
  var symbol;          /* symbol index in original or sorted table */
  var key;             /* reversed prefix code */
  var step;            /* step size to replicate values in current table */
  var low;             /* low bits for current root entry */
  var mask;            /* mask for low bits */
  var table_bits;      /* key length of current table */
  var table_size;      /* size of current table */
  var total_size;      /* sum of root table size and 2nd level table sizes */
  var sorted;          /* symbols sorted by code length */
  var count = new Int32Array(MAX_LENGTH + 1);  /* number of codes of each length */
  var offset = new Int32Array(MAX_LENGTH + 1);  /* offsets in sorted table for each length */

  sorted = new Int32Array(code_lengths_size);

  /* build histogram of code lengths */
  for (symbol = 0; symbol < code_lengths_size; symbol++) {
    count[code_lengths[symbol]]++;
  }

  /* generate offsets into sorted symbol table by code length */
  offset[1] = 0;
  for (len = 1; len < MAX_LENGTH; len++) {
    offset[len + 1] = offset[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (symbol = 0; symbol < code_lengths_size; symbol++) {
    if (code_lengths[symbol] !== 0) {
      sorted[offset[code_lengths[symbol]]++] = symbol;
    }
  }
  
  table_bits = root_bits;
  table_size = 1 << table_bits;
  total_size = table_size;

  /* special case code with only one value */
  if (offset[MAX_LENGTH] === 1) {
    for (key = 0; key < total_size; ++key) {
      root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
    }
    
    return total_size;
  }

  /* fill in root table */
  key = 0;
  symbol = 0;
  for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
    for (; count[len] > 0; --count[len]) {
      code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
      ReplicateValue(root_table, table + key, step, table_size, code);
      key = GetNextKey(key, len);
    }
  }

  /* fill in 2nd level tables and add pointers to root table */
  mask = total_size - 1;
  low = -1;
  for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
    for (; count[len] > 0; --count[len]) {
      if ((key & mask) !== low) {
        table += table_size;
        table_bits = NextTableBitSize(count, len, root_bits);
        table_size = 1 << table_bits;
        total_size += table_size;
        low = key & mask;
        root_table[start_table + low] = new HuffmanCode((table_bits + root_bits) & 0xff, ((table - start_table) - low) & 0xffff);
      }
      code = new HuffmanCode((len - root_bits) & 0xff, sorted[symbol++] & 0xffff);
      ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
      key = GetNextKey(key, len);
    }
  }
  
  return total_size;
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var AI, AL, BA, BK, CB, CI_BRK, CJ, CP_BRK, CR, DI_BRK, ID, IN_BRK, LF, LineBreaker, NL, NS, PR_BRK, SA, SG, SP, UnicodeTrie, WJ, XX, base64, characterClasses, classTrie, data, fs, pairTable, _ref, _ref1;

  UnicodeTrie = __webpack_require__(74);

  

  base64 = __webpack_require__(286);

  _ref = __webpack_require__(287), BK = _ref.BK, CR = _ref.CR, LF = _ref.LF, NL = _ref.NL, CB = _ref.CB, BA = _ref.BA, SP = _ref.SP, WJ = _ref.WJ, SP = _ref.SP, BK = _ref.BK, LF = _ref.LF, NL = _ref.NL, AI = _ref.AI, AL = _ref.AL, SA = _ref.SA, SG = _ref.SG, XX = _ref.XX, CJ = _ref.CJ, ID = _ref.ID, NS = _ref.NS, characterClasses = _ref.characterClasses;

  _ref1 = __webpack_require__(288), DI_BRK = _ref1.DI_BRK, IN_BRK = _ref1.IN_BRK, CI_BRK = _ref1.CI_BRK, CP_BRK = _ref1.CP_BRK, PR_BRK = _ref1.PR_BRK, pairTable = _ref1.pairTable;

  data = base64.toByteArray("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");

  classTrie = new UnicodeTrie(data);

  LineBreaker = (function() {
    var Break, mapClass, mapFirst;

    function LineBreaker(string) {
      this.string = string;
      this.pos = 0;
      this.lastPos = 0;
      this.curClass = null;
      this.nextClass = null;
    }

    LineBreaker.prototype.nextCodePoint = function() {
      var code, next;
      code = this.string.charCodeAt(this.pos++);
      next = this.string.charCodeAt(this.pos);
      if ((0xd800 <= code && code <= 0xdbff) && (0xdc00 <= next && next <= 0xdfff)) {
        this.pos++;
        return ((code - 0xd800) * 0x400) + (next - 0xdc00) + 0x10000;
      }
      return code;
    };

    mapClass = function(c) {
      switch (c) {
        case AI:
          return AL;
        case SA:
        case SG:
        case XX:
          return AL;
        case CJ:
          return NS;
        default:
          return c;
      }
    };

    mapFirst = function(c) {
      switch (c) {
        case LF:
        case NL:
          return BK;
        case CB:
          return BA;
        case SP:
          return WJ;
        default:
          return c;
      }
    };

    LineBreaker.prototype.nextCharClass = function(first) {
      if (first == null) {
        first = false;
      }
      return mapClass(classTrie.get(this.nextCodePoint()));
    };

    Break = (function() {
      function Break(position, required) {
        this.position = position;
        this.required = required != null ? required : false;
      }

      return Break;

    })();

    LineBreaker.prototype.nextBreak = function() {
      var cur, lastClass, shouldBreak;
      if (this.curClass == null) {
        this.curClass = mapFirst(this.nextCharClass());
      }
      while (this.pos < this.string.length) {
        this.lastPos = this.pos;
        lastClass = this.nextClass;
        this.nextClass = this.nextCharClass();
        if (this.curClass === BK || (this.curClass === CR && this.nextClass !== LF)) {
          this.curClass = mapFirst(mapClass(this.nextClass));
          return new Break(this.lastPos, true);
        }
        cur = (function() {
          switch (this.nextClass) {
            case SP:
              return this.curClass;
            case BK:
            case LF:
            case NL:
              return BK;
            case CR:
              return CR;
            case CB:
              return BA;
          }
        }).call(this);
        if (cur != null) {
          this.curClass = cur;
          if (this.nextClass === CB) {
            return new Break(this.lastPos);
          }
          continue;
        }
        shouldBreak = false;
        switch (pairTable[this.curClass][this.nextClass]) {
          case DI_BRK:
            shouldBreak = true;
            break;
          case IN_BRK:
            shouldBreak = lastClass === SP;
            break;
          case CI_BRK:
            shouldBreak = lastClass === SP;
            if (!shouldBreak) {
              continue;
            }
            break;
          case CP_BRK:
            if (lastClass !== SP) {
              continue;
            }
        }
        this.curClass = this.nextClass;
        if (shouldBreak) {
          return new Break(this.lastPos);
        }
      }
      if (this.pos >= this.string.length) {
        if (this.lastPos < this.string.length) {
          this.lastPos = this.string.length;
          return new Break(this.string.length);
        } else {
          return null;
        }
      }
    };

    return LineBreaker;

  })();

  module.exports = LineBreaker;

}).call(this);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function TraversalTracker() {
	this.events = {};
}

TraversalTracker.prototype.startTracking = function (event, callback) {
	var callbacks = this.events[event] || (this.events[event] = []);

	if (callbacks.indexOf(callback) < 0) {
		callbacks.push(callback);
	}
};

TraversalTracker.prototype.stopTracking = function (event, callback) {
	var callbacks = this.events[event];

	if (!callbacks) {
		return;
	}

	var index = callbacks.indexOf(callback);
	if (index >= 0) {
		callbacks.splice(index, 1);
	}
};

TraversalTracker.prototype.emit = function (event) {
	var args = Array.prototype.slice.call(arguments, 1);
	var callbacks = this.events[event];

	if (!callbacks) {
		return;
	}

	callbacks.forEach(function (callback) {
		callback.apply(this, args);
	});
};

TraversalTracker.prototype.auto = function (event, callback, innerFunction) {
	this.startTracking(event, callback);
	innerFunction();
	this.stopTracking(event, callback);
};

module.exports = TraversalTracker;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(0).isString;
var isArray = __webpack_require__(0).isArray;
var isUndefined = __webpack_require__(0).isUndefined;
var isNull = __webpack_require__(0).isNull;

/**
 * Creates an instance of StyleContextStack used for style inheritance and style overrides
 *
 * @constructor
 * @this {StyleContextStack}
 * @param {Object} named styles dictionary
 * @param {Object} optional default style definition
 */
function StyleContextStack(styleDictionary, defaultStyle) {
	this.defaultStyle = defaultStyle || {};
	this.styleDictionary = styleDictionary;
	this.styleOverrides = [];
}

/**
 * Creates cloned version of current stack
 * @return {StyleContextStack} current stack snapshot
 */
StyleContextStack.prototype.clone = function () {
	var stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);

	this.styleOverrides.forEach(function (item) {
		stack.styleOverrides.push(item);
	});

	return stack;
};

/**
 * Pushes style-name or style-overrides-object onto the stack for future evaluation
 *
 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
 *                                            a new dictionary defining overriding properties
 */
StyleContextStack.prototype.push = function (styleNameOrOverride) {
	this.styleOverrides.push(styleNameOrOverride);
};

/**
 * Removes last style-name or style-overrides-object from the stack
 *
 * @param {Number} howMany - optional number of elements to be popped (if not specified,
 *                           one element will be removed from the stack)
 */
StyleContextStack.prototype.pop = function (howMany) {
	howMany = howMany || 1;

	while (howMany-- > 0) {
		this.styleOverrides.pop();
	}
};

/**
 * Creates a set of named styles or/and a style-overrides-object based on the item,
 * pushes those elements onto the stack for future evaluation and returns the number
 * of elements pushed, so they can be easily poped then.
 *
 * @param {Object} item - an object with optional style property and/or style overrides
 * @return the number of items pushed onto the stack
 */
StyleContextStack.prototype.autopush = function (item) {
	if (isString(item)) {
		return 0;
	}

	var styleNames = [];

	if (item.style) {
		if (isArray(item.style)) {
			styleNames = item.style;
		} else {
			styleNames = [item.style];
		}
	}

	for (var i = 0, l = styleNames.length; i < l; i++) {
		this.push(styleNames[i]);
	}

	var styleProperties = [
		'font',
		'fontSize',
		'fontFeatures',
		'bold',
		'italics',
		'alignment',
		'color',
		'columnGap',
		'fillColor',
		'decoration',
		'decorationStyle',
		'decorationColor',
		'background',
		'lineHeight',
		'characterSpacing',
		'noWrap',
		'markerColor',
		'leadingIndent'
			//'tableCellPadding'
			// 'cellBorder',
			// 'headerCellBorder',
			// 'oddRowCellBorder',
			// 'evenRowCellBorder',
			// 'tableBorder'
	];
	var styleOverrideObject = {};
	var pushStyleOverrideObject = false;

	styleProperties.forEach(function (key) {
		if (!isUndefined(item[key]) && !isNull(item[key])) {
			styleOverrideObject[key] = item[key];
			pushStyleOverrideObject = true;
		}
	});

	if (pushStyleOverrideObject) {
		this.push(styleOverrideObject);
	}

	return styleNames.length + (pushStyleOverrideObject ? 1 : 0);
};

/**
 * Automatically pushes elements onto the stack, using autopush based on item,
 * executes callback and then pops elements back. Returns value returned by callback
 *
 * @param  {Object}   item - an object with optional style property and/or style overrides
 * @param  {Function} function to be called between autopush and pop
 * @return {Object} value returned by callback
 */
StyleContextStack.prototype.auto = function (item, callback) {
	var pushedItems = this.autopush(item);
	var result = callback();

	if (pushedItems > 0) {
		this.pop(pushedItems);
	}

	return result;
};

/**
 * Evaluates stack and returns value of a named property
 *
 * @param {String} property - property name
 * @return property value or null if not found
 */
StyleContextStack.prototype.getProperty = function (property) {
	if (this.styleOverrides) {
		for (var i = this.styleOverrides.length - 1; i >= 0; i--) {
			var item = this.styleOverrides[i];

			if (isString(item)) {
				// named-style-override
				var style = this.styleDictionary[item];
				if (style && !isUndefined(style[property]) && !isNull(style[property])) {
					return style[property];
				}
			} else if (!isUndefined(item[property]) && !isNull(item[property])) {
				// style-overrides-object
				return item[property];
			}
		}
	}

	return this.defaultStyle && this.defaultStyle[property];
};

module.exports = StyleContextStack;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TraversalTracker = __webpack_require__(118);
var isString = __webpack_require__(0).isString;

/**
 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
 * It facilitates column divisions and vertical sync
 */
function DocumentContext(pageSize, pageMargins) {
	this.pages = [];

	this.pageMargins = pageMargins;

	this.x = pageMargins.left;
	this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
	this.availableHeight = 0;
	this.page = -1;

	this.snapshots = [];

	this.endingCell = null;

	this.tracker = new TraversalTracker();

	this.backgroundLength = [];

	this.addPage(pageSize);
}

DocumentContext.prototype.beginColumnGroup = function () {
	this.snapshots.push({
		x: this.x,
		y: this.y,
		availableHeight: this.availableHeight,
		availableWidth: this.availableWidth,
		page: this.page,
		bottomMost: {
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			page: this.page
		},
		endingCell: this.endingCell,
		lastColumnWidth: this.lastColumnWidth
	});

	this.lastColumnWidth = 0;
};

DocumentContext.prototype.beginColumn = function (width, offset, endingCell) {
	var saved = this.snapshots[this.snapshots.length - 1];

	this.calculateBottomMost(saved);

	this.endingCell = endingCell;
	this.page = saved.page;
	this.x = this.x + this.lastColumnWidth + (offset || 0);
	this.y = saved.y;
	this.availableWidth = width;	//saved.availableWidth - offset;
	this.availableHeight = saved.availableHeight;

	this.lastColumnWidth = width;
};

DocumentContext.prototype.calculateBottomMost = function (destContext) {
	if (this.endingCell) {
		this.saveContextInEndingCell(this.endingCell);
		this.endingCell = null;
	} else {
		destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
	}
};

DocumentContext.prototype.markEnding = function (endingCell) {
	this.page = endingCell._columnEndingContext.page;
	this.x = endingCell._columnEndingContext.x;
	this.y = endingCell._columnEndingContext.y;
	this.availableWidth = endingCell._columnEndingContext.availableWidth;
	this.availableHeight = endingCell._columnEndingContext.availableHeight;
	this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
};

DocumentContext.prototype.saveContextInEndingCell = function (endingCell) {
	endingCell._columnEndingContext = {
		page: this.page,
		x: this.x,
		y: this.y,
		availableHeight: this.availableHeight,
		availableWidth: this.availableWidth,
		lastColumnWidth: this.lastColumnWidth
	};
};

DocumentContext.prototype.completeColumnGroup = function (height) {
	var saved = this.snapshots.pop();

	this.calculateBottomMost(saved);

	this.endingCell = null;
	this.x = saved.x;

	var y = saved.bottomMost.y;
	if (height) {
		if (saved.page === saved.bottomMost.page) {
			if ((saved.y + height) > y) {
				y = saved.y + height;
			}
		} else {
			y += height;
		}
	}

	this.y = y;
	this.page = saved.bottomMost.page;
	this.availableWidth = saved.availableWidth;
	this.availableHeight = saved.bottomMost.availableHeight;
	if (height) {
		this.availableHeight -= (y - saved.bottomMost.y);
	}
	this.lastColumnWidth = saved.lastColumnWidth;
};

DocumentContext.prototype.addMargin = function (left, right) {
	this.x += left;
	this.availableWidth -= left + (right || 0);
};

DocumentContext.prototype.moveDown = function (offset) {
	this.y += offset;
	this.availableHeight -= offset;

	return this.availableHeight > 0;
};

DocumentContext.prototype.initializePage = function () {
	this.y = this.pageMargins.top;
	this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
	this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
};

DocumentContext.prototype.pageSnapshot = function () {
	if (this.snapshots[0]) {
		return this.snapshots[0];
	} else {
		return this;
	}
};

DocumentContext.prototype.moveTo = function (x, y) {
	if (x !== undefined && x !== null) {
		this.x = x;
		this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
	}
	if (y !== undefined && y !== null) {
		this.y = y;
		this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
	}
};

DocumentContext.prototype.beginDetachedBlock = function () {
	this.snapshots.push({
		x: this.x,
		y: this.y,
		availableHeight: this.availableHeight,
		availableWidth: this.availableWidth,
		page: this.page,
		endingCell: this.endingCell,
		lastColumnWidth: this.lastColumnWidth
	});
};

DocumentContext.prototype.endDetachedBlock = function () {
	var saved = this.snapshots.pop();

	this.x = saved.x;
	this.y = saved.y;
	this.availableWidth = saved.availableWidth;
	this.availableHeight = saved.availableHeight;
	this.page = saved.page;
	this.endingCell = saved.endingCell;
	this.lastColumnWidth = saved.lastColumnWidth;
};

function pageOrientation(pageOrientationString, currentPageOrientation) {
	if (pageOrientationString === undefined) {
		return currentPageOrientation;
	} else if (isString(pageOrientationString) && (pageOrientationString.toLowerCase() === 'landscape')) {
		return 'landscape';
	} else {
		return 'portrait';
	}
}

var getPageSize = function (currentPage, newPageOrientation) {

	newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);

	if (newPageOrientation !== currentPage.pageSize.orientation) {
		return {
			orientation: newPageOrientation,
			width: currentPage.pageSize.height,
			height: currentPage.pageSize.width
		};
	} else {
		return {
			orientation: currentPage.pageSize.orientation,
			width: currentPage.pageSize.width,
			height: currentPage.pageSize.height
		};
	}

};


DocumentContext.prototype.moveToNextPage = function (pageOrientation) {
	var nextPageIndex = this.page + 1;

	var prevPage = this.page;
	var prevY = this.y;

	var createNewPage = nextPageIndex >= this.pages.length;
	if (createNewPage) {
		var currentAvailableWidth = this.availableWidth;
		var currentPageOrientation = this.getCurrentPage().pageSize.orientation;

		var pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
		this.addPage(pageSize);

		if (currentPageOrientation === pageSize.orientation) {
			this.availableWidth = currentAvailableWidth;
		}
	} else {
		this.page = nextPageIndex;
		this.initializePage();
	}

	return {
		newPageCreated: createNewPage,
		prevPage: prevPage,
		prevY: prevY,
		y: this.y
	};
};


DocumentContext.prototype.addPage = function (pageSize) {
	var page = {items: [], pageSize: pageSize};
	this.pages.push(page);
	this.backgroundLength.push(0);
	this.page = this.pages.length - 1;
	this.initializePage();

	this.tracker.emit('pageAdded');

	return page;
};

DocumentContext.prototype.getCurrentPage = function () {
	if (this.page < 0 || this.page >= this.pages.length) {
		return null;
	}

	return this.pages[this.page];
};

DocumentContext.prototype.getCurrentPosition = function () {
	var pageSize = this.getCurrentPage().pageSize;
	var innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
	var innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;

	return {
		pageNumber: this.page + 1,
		pageOrientation: pageSize.orientation,
		pageInnerHeight: innerHeight,
		pageInnerWidth: innerWidth,
		left: this.x,
		top: this.y,
		verticalRatio: ((this.y - this.pageMargins.top) / innerHeight),
		horizontalRatio: ((this.x - this.pageMargins.left) / innerWidth)
	};
};

function bottomMostContext(c1, c2) {
	var r;

	if (c1.page > c2.page) {
		r = c1;
	} else if (c2.page > c1.page) {
		r = c2;
	} else {
		r = (c1.y > c2.y) ? c1 : c2;
	}

	return {
		page: r.page,
		x: r.x,
		y: r.y,
		availableHeight: r.availableHeight,
		availableWidth: r.availableWidth
	};
}

module.exports = DocumentContext;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates an instance of Line
 *
 * @constructor
 * @this {Line}
 * @param {Number} Maximum width this line can have
 */
function Line(maxWidth) {
	this.maxWidth = maxWidth;
	this.leadingCut = 0;
	this.trailingCut = 0;
	this.inlineWidths = 0;
	this.inlines = [];
}

Line.prototype.getAscenderHeight = function () {
	var y = 0;

	this.inlines.forEach(function (inline) {
		y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
	});
	return y;
};

Line.prototype.hasEnoughSpaceForInline = function (inline, nextInlines) {
	nextInlines = nextInlines || [];

	if (this.inlines.length === 0) {
		return true;
	}
	if (this.newLineForced) {
		return false;
	}

	var inlineWidth = inline.width;
	var inlineTrailingCut = inline.trailingCut || 0;
	if (inline.noNewLine) {
		for (var i = 0, l = nextInlines.length; i < l; i++) {
			var nextInline = nextInlines[i];
			inlineWidth += nextInline.width;
			inlineTrailingCut += nextInline.trailingCut || 0;
			if (!nextInline.noNewLine) {
				break;
			}
		}
	}

	return (this.inlineWidths + inlineWidth - this.leadingCut - inlineTrailingCut) <= this.maxWidth;
};

Line.prototype.addInline = function (inline) {
	if (this.inlines.length === 0) {
		this.leadingCut = inline.leadingCut || 0;
	}
	this.trailingCut = inline.trailingCut || 0;

	inline.x = this.inlineWidths - this.leadingCut;

	this.inlines.push(inline);
	this.inlineWidths += inline.width;

	if (inline.lineEnd) {
		this.newLineForced = true;
	}
};

Line.prototype.getWidth = function () {
	return this.inlineWidths - this.leadingCut - this.trailingCut;
};

Line.prototype.getAvailableWidth = function () {
	return this.maxWidth - this.getWidth();
};

/**
 * Returns line height
 * @return {Number}
 */
Line.prototype.getHeight = function () {
	var max = 0;

	this.inlines.forEach(function (item) {
		max = Math.max(max, item.height || 0);
	});

	return max;
};

module.exports = Line;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["pdfMake"] = __webpack_require__(123);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, global) {

var PdfPrinter = __webpack_require__(126);
var isFunction = __webpack_require__(0).isFunction;
var FileSaver = __webpack_require__(307);
var saveAs = FileSaver.saveAs;

var defaultClientFonts = {
	Roboto: {
		normal: 'Roboto-Regular.ttf',
		bold: 'Roboto-Medium.ttf',
		italics: 'Roboto-Italic.ttf',
		bolditalics: 'Roboto-MediumItalic.ttf'
	}
};

function Document(docDefinition, tableLayouts, fonts, vfs) {
	this.docDefinition = docDefinition;
	this.tableLayouts = tableLayouts || null;
	this.fonts = fonts || defaultClientFonts;
	this.vfs = vfs;
}

function canCreatePdf() {
	// Ensure the browser provides the level of support needed
	if (!Object.keys) {
		return false;
	}
	return true;
}

Document.prototype._createDoc = function (options, callback) {
	options = options || {};
	if (this.tableLayouts) {
		options.tableLayouts = this.tableLayouts;
	}

	var printer = new PdfPrinter(this.fonts);
	__webpack_require__(9).bindFS(this.vfs); // bind virtual file system to file system

	var doc = printer.createPdfKitDocument(this.docDefinition, options);
	var chunks = [];
	var result;

	doc.on('readable', function () {
		var chunk;
		while ((chunk = doc.read(9007199254740991)) !== null) {
			chunks.push(chunk);
		}
	});
	doc.on('end', function () {
		result = Buffer.concat(chunks);
		callback(result, doc._pdfMakePages);
	});
	doc.end();
};

Document.prototype._getPages = function (options, cb) {
	if (!cb) {
		throw '_getPages is an async method and needs a callback argument';
	}
	this._createDoc(options, function (ignoreBuffer, pages) {
		cb(pages);
	});
};

Document.prototype._bufferToBlob = function (buffer) {
	var blob;
	try {
		blob = new Blob([buffer], {type: 'application/pdf'});
	} catch (e) {
		// Old browser which can't handle it without making it an byte array (ie10)
		if (e.name === 'InvalidStateError') {
			var byteArray = new Uint8Array(buffer);
			blob = new Blob([byteArray.buffer], {type: 'application/pdf'});
		}
	}

	if (!blob) {
		throw 'Could not generate blob';
	}

	return blob;
};

Document.prototype._openWindow = function () {
	// we have to open the window immediately and store the reference
	// otherwise popup blockers will stop us
	var win = window.open('', '_blank');
	if (win === null) {
		throw 'Open PDF in new window blocked by browser';
	}

	return win;
};

Document.prototype._openPdf = function (options, win) {
	if (!win) {
		win = this._openWindow();
	}
	try {
		this.getBlob(function (result) {
			var urlCreator = window.URL || window.webkitURL;
			var pdfUrl = urlCreator.createObjectURL(result);
			win.location.href = pdfUrl;
		}, options);
	} catch (e) {
		win.close();
		throw e;
	}
};

Document.prototype.open = function (options, win) {
	options = options || {};
	options.autoPrint = false;
	win = win || null;

	this._openPdf(options, win);
};


Document.prototype.print = function (options, win) {
	options = options || {};
	options.autoPrint = true;
	win = win || null;

	this._openPdf(options, win);
};

Document.prototype.download = function (defaultFileName, cb, options) {
	if (isFunction(defaultFileName)) {
		cb = defaultFileName;
		defaultFileName = null;
	}

	defaultFileName = defaultFileName || 'file.pdf';
	this.getBlob(function (result) {
		saveAs(result, defaultFileName);

		if (isFunction(cb)) {
			cb();
		}
	}, options);
};

Document.prototype.getBase64 = function (cb, options) {
	if (!cb) {
		throw 'getBase64 is an async method and needs a callback argument';
	}
	this.getBuffer(function (buffer) {
		cb(buffer.toString('base64'));
	}, options);
};

Document.prototype.getDataUrl = function (cb, options) {
	if (!cb) {
		throw 'getDataUrl is an async method and needs a callback argument';
	}
	this.getBuffer(function (buffer) {
		cb('data:application/pdf;base64,' + buffer.toString('base64'));
	}, options);
};

Document.prototype.getBlob = function (cb, options) {
	if (!cb) {
		throw 'getBlob is an async method and needs a callback argument';
	}
	var that = this;
	this.getBuffer(function (result) {
		var blob = that._bufferToBlob(result);
		cb(blob);
	}, options);
};

Document.prototype.getBuffer = function (cb, options) {
	if (!cb) {
		throw 'getBuffer is an async method and needs a callback argument';
	}
	this._createDoc(options, function (buffer) {
		cb(buffer);
	});
};

module.exports = {
	createPdf: function (docDefinition) {
		if (!canCreatePdf()) {
			throw 'Your browser does not provide the level of support needed';
		}
		return new Document(docDefinition, global.pdfMake.tableLayouts, global.pdfMake.fonts, global.pdfMake.vfs);
	}
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(7)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 125 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-unused-vars: ["error", {"args": "none"}]*/


var PdfKitEngine = __webpack_require__(127);
var FontProvider = __webpack_require__(296);
var LayoutBuilder = __webpack_require__(297);
var sizes = __webpack_require__(304);
var ImageMeasure = __webpack_require__(305);
var textDecorator = __webpack_require__(306);
var TextTools = __webpack_require__(75);
var isFunction = __webpack_require__(0).isFunction;
var isString = __webpack_require__(0).isString;
var isNumber = __webpack_require__(0).isNumber;
var isBoolean = __webpack_require__(0).isBoolean;
var isArray = __webpack_require__(0).isArray;
var isUndefined = __webpack_require__(0).isUndefined;

////////////////////////////////////////
// PdfPrinter

/**
 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
 *
 * @param {Object} fontDescriptors font definition dictionary
 *
 * @example
 * var fontDescriptors = {
 *	Roboto: {
 *		normal: 'fonts/Roboto-Regular.ttf',
 *		bold: 'fonts/Roboto-Medium.ttf',
 *		italics: 'fonts/Roboto-Italic.ttf',
 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
 *	}
 * };
 *
 * var printer = new PdfPrinter(fontDescriptors);
 */
function PdfPrinter(fontDescriptors) {
	this.fontDescriptors = fontDescriptors;
}

/**
 * Executes layout engine for the specified document and renders it into a pdfkit document
 * ready to be saved.
 *
 * @param {Object} docDefinition document definition
 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
 * @param {Number} docDefinition.pageSize.width width
 * @param {Number} docDefinition.pageSize.height height
 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
 *
 * @example
 *
 * var docDefinition = {
 * 	info: {
 *		title: 'awesome Document',
 *		author: 'john doe',
 *		subject: 'subject of document',
 *		keywords: 'keywords for document',
 * 	},
 *	content: [
 *		'First paragraph',
 *		'Second paragraph, this time a little bit longer',
 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
 *		{ text: 'Another paragraph using a named style', style: 'header' },
 *		{ text: ['playing with ', 'inlines' ] },
 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
 *	],
 *	styles: {
 *		header: { fontSize: 30, bold: true }
 *	}
 * }
 *
 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
 *
 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
 * pdfKitDoc.end();
 *
 * @return {Object} a pdfKit document object which can be saved or encode to data-url
 */
PdfPrinter.prototype.createPdfKitDocument = function (docDefinition, options) {
	options = options || {};

	var pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);
	var compressPdf = isBoolean(docDefinition.compress) ? docDefinition.compress : true;
	var bufferPages = options.bufferPages || false;

	this.pdfKitDoc = PdfKitEngine.createPdfDocument({size: [pageSize.width, pageSize.height], bufferPages: bufferPages, autoFirstPage: false, compress: compressPdf});
	setMetadata(docDefinition, this.pdfKitDoc);

	this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);

	docDefinition.images = docDefinition.images || {};

	var builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins || 40), new ImageMeasure(this.pdfKitDoc, docDefinition.images));

	registerDefaultTableLayouts(builder);
	if (options.tableLayouts) {
		builder.registerTableLayouts(options.tableLayouts);
	}

	var pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {fontSize: 12, font: 'Roboto'}, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
	var maxNumberPages = docDefinition.maxPagesNumber || -1;
	if (isNumber(maxNumberPages) && maxNumberPages > -1) {
		pages = pages.slice(0, maxNumberPages);
	}

	// if pageSize.height is set to Infinity, calculate the actual height of the page that
	// was laid out using the height of each of the items in the page.
	if (pageSize.height === Infinity) {
		var pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
		this.pdfKitDoc.options.size = [pageSize.width, pageHeight];
	}

	renderPages(pages, this.fontProvider, this.pdfKitDoc, options.progressCallback);

	if (options.autoPrint) {
		var printActionRef = this.pdfKitDoc.ref({
			Type: 'Action',
			S: 'Named',
			N: 'Print'
		});
		this.pdfKitDoc._root.data.OpenAction = printActionRef;
		printActionRef.end();
	}
	return this.pdfKitDoc;
};

function setMetadata(docDefinition, pdfKitDoc) {
	// PDF standard has these properties reserved: Title, Author, Subject, Keywords,
	// Creator, Producer, CreationDate, ModDate, Trapped.
	// To keep the pdfmake api consistent, the info field are defined lowercase.
	// Custom properties don't contain a space.
	function standardizePropertyKey(key) {
		var standardProperties = ['Title', 'Author', 'Subject', 'Keywords',
			'Creator', 'Producer', 'CreationDate', 'ModDate', 'Trapped'];
		var standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
		if (standardProperties.indexOf(standardizedKey) !== -1) {
			return standardizedKey;
		}

		return key.replace(/\s+/g, '');
	}

	pdfKitDoc.info.Producer = 'pdfmake';
	pdfKitDoc.info.Creator = 'pdfmake';

	if (docDefinition.info) {
		for (var key in docDefinition.info) {
			var value = docDefinition.info[key];
			if (value) {
				key = standardizePropertyKey(key);
				pdfKitDoc.info[key] = value;
			}
		}
	}
}

function calculatePageHeight(pages, margins) {
	function getItemHeight(item) {
		if (isFunction(item.item.getHeight)) {
			return item.item.getHeight();
		} else if (item.item._height) {
			return item.item._height;
		} else {
			// TODO: add support for next item types
			return 0;
		}
	}

	function getBottomPosition(item) {
		var top = item.item.y;
		var height = getItemHeight(item);
		return top + height;
	}

	var fixedMargins = fixPageMargins(margins || 40);
	var height = fixedMargins.top;

	pages.forEach(function (page) {
		page.items.forEach(function (item) {
			var bottomPosition = getBottomPosition(item);
			if (bottomPosition > height) {
				height = bottomPosition;
			}
		});
	});

	height += fixedMargins.bottom;

	return height;
}

function fixPageSize(pageSize, pageOrientation) {
	function isNeedSwapPageSizes(pageOrientation) {
		if (isString(pageOrientation)) {
			pageOrientation = pageOrientation.toLowerCase();
			return ((pageOrientation === 'portrait') && (size.width > size.height)) ||
				((pageOrientation === 'landscape') && (size.width < size.height));
		}
		return false;
	}

	// if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
	if (pageSize && pageSize.height === 'auto') {
		pageSize.height = Infinity;
	}

	var size = pageSize2widthAndHeight(pageSize || 'A4');
	if (isNeedSwapPageSizes(pageOrientation)) { // swap page sizes
		size = {width: size.height, height: size.width};
	}
	size.orientation = size.width > size.height ? 'landscape' : 'portrait';
	return size;
}

function fixPageMargins(margin) {
	if (!margin) {
		return null;
	}

	if (isNumber(margin)) {
		margin = {left: margin, right: margin, top: margin, bottom: margin};
	} else if (isArray(margin)) {
		if (margin.length === 2) {
			margin = {left: margin[0], top: margin[1], right: margin[0], bottom: margin[1]};
		} else if (margin.length === 4) {
			margin = {left: margin[0], top: margin[1], right: margin[2], bottom: margin[3]};
		} else {
			throw 'Invalid pageMargins definition';
		}
	}

	return margin;
}

function registerDefaultTableLayouts(layoutBuilder) {
	layoutBuilder.registerTableLayouts({
		noBorders: {
			hLineWidth: function (i) {
				return 0;
			},
			vLineWidth: function (i) {
				return 0;
			},
			paddingLeft: function (i) {
				return i && 4 || 0;
			},
			paddingRight: function (i, node) {
				return (i < node.table.widths.length - 1) ? 4 : 0;
			}
		},
		headerLineOnly: {
			hLineWidth: function (i, node) {
				if (i === 0 || i === node.table.body.length) {
					return 0;
				}
				return (i === node.table.headerRows) ? 2 : 0;
			},
			vLineWidth: function (i) {
				return 0;
			},
			paddingLeft: function (i) {
				return i === 0 ? 0 : 8;
			},
			paddingRight: function (i, node) {
				return (i === node.table.widths.length - 1) ? 0 : 8;
			}
		},
		lightHorizontalLines: {
			hLineWidth: function (i, node) {
				if (i === 0 || i === node.table.body.length) {
					return 0;
				}
				return (i === node.table.headerRows) ? 2 : 1;
			},
			vLineWidth: function (i) {
				return 0;
			},
			hLineColor: function (i) {
				return i === 1 ? 'black' : '#aaa';
			},
			paddingLeft: function (i) {
				return i === 0 ? 0 : 8;
			},
			paddingRight: function (i, node) {
				return (i === node.table.widths.length - 1) ? 0 : 8;
			}
		}
	});
}

function pageSize2widthAndHeight(pageSize) {
	if (isString(pageSize)) {
		var size = sizes[pageSize.toUpperCase()];
		if (!size) {
			throw 'Page size ' + pageSize + ' not recognized';
		}
		return {width: size[0], height: size[1]};
	}

	return pageSize;
}

function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
	var previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? 'landscape' : 'portrait';

	if (currentPage.pageSize.orientation !== previousPageOrientation) {
		var width = pdfKitDoc.options.size[0];
		var height = pdfKitDoc.options.size[1];
		pdfKitDoc.options.size = [height, width];
	}
}

function renderPages(pages, fontProvider, pdfKitDoc, progressCallback) {
	pdfKitDoc._pdfMakePages = pages;
	pdfKitDoc.addPage();

	var totalItems = 0;
	if (progressCallback) {
		pages.forEach(function (page) {
			totalItems += page.items.length;
		});
	}

	var renderedItems = 0;
	progressCallback = progressCallback || function () {};

	for (var i = 0; i < pages.length; i++) {
		if (i > 0) {
			updatePageOrientationInOptions(pages[i], pdfKitDoc);
			pdfKitDoc.addPage(pdfKitDoc.options);
		}

		var page = pages[i];
		for (var ii = 0, il = page.items.length; ii < il; ii++) {
			var item = page.items[ii];
			switch (item.type) {
				case 'vector':
					renderVector(item.item, pdfKitDoc);
					break;
				case 'line':
					renderLine(item.item, item.item.x, item.item.y, pdfKitDoc);
					break;
				case 'image':
					renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
					break;
				case 'beginClip':
					beginClip(item.item, pdfKitDoc);
					break;
				case 'endClip':
					endClip(pdfKitDoc);
					break;
			}
			renderedItems++;
			progressCallback(renderedItems / totalItems);
		}
		if (page.watermark) {
			renderWatermark(page, pdfKitDoc);
		}
	}
}

function renderLine(line, x, y, pdfKitDoc) {
	function preparePageNodeRefLine(_pageNodeRef, inline) {
		var newWidth;
		var diffWidth;
		var textTools = new TextTools(null);

		if (isUndefined(_pageNodeRef.positions)) {
			throw 'Page reference id not found';
		}

		var pageNumber = _pageNodeRef.positions[0].pageNumber.toString();

		inline.text = pageNumber;
		inline.linkToPage = pageNumber;
		newWidth = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);
		diffWidth = inline.width - newWidth;
		inline.width = newWidth;

		switch (inline.alignment) {
			case 'right':
				inline.x += diffWidth;
				break;
			case 'center':
				inline.x += diffWidth / 2;
				break;
		}
	}

	if (line._pageNodeRef) {
		preparePageNodeRefLine(line._pageNodeRef, line.inlines[0]);
	}

	x = x || 0;
	y = y || 0;

	var lineHeight = line.getHeight();
	var ascenderHeight = line.getAscenderHeight();
	var descent = lineHeight - ascenderHeight;

	textDecorator.drawBackground(line, x, y, pdfKitDoc);

	//TODO: line.optimizeInlines();
	for (var i = 0, l = line.inlines.length; i < l; i++) {
		var inline = line.inlines[i];
		var shiftToBaseline = lineHeight - ((inline.font.ascender / 1000) * inline.fontSize) - descent;

		if (inline._pageNodeRef) {
			preparePageNodeRefLine(inline._pageNodeRef, inline);
		}

		var options = {
			lineBreak: false,
			textWidth: inline.width,
			characterSpacing: inline.characterSpacing,
			wordCount: 1,
			link: inline.link
		};

		if (inline.fontFeatures) {
			options.features = inline.fontFeatures;
		}

		pdfKitDoc.fill(inline.color || 'black');

		pdfKitDoc._font = inline.font;
		pdfKitDoc.fontSize(inline.fontSize);
		pdfKitDoc.text(inline.text, x + inline.x, y + shiftToBaseline, options);

		if (inline.linkToPage) {
			var _ref = pdfKitDoc.ref({Type: 'Action', S: 'GoTo', D: [inline.linkToPage, 0, 0]}).end();
			pdfKitDoc.annotate(x + inline.x, y + shiftToBaseline, inline.width, inline.height, {Subtype: 'Link', Dest: [inline.linkToPage - 1, 'XYZ', null, null, null]});
		}

	}

	textDecorator.drawDecorations(line, x, y, pdfKitDoc);
}

function renderWatermark(page, pdfKitDoc) {
	var watermark = page.watermark;

	pdfKitDoc.fill(watermark.color);
	pdfKitDoc.opacity(watermark.opacity);

	pdfKitDoc.save();

	var angle = Math.atan2(pdfKitDoc.page.height, pdfKitDoc.page.width) * -180 / Math.PI;
	pdfKitDoc.rotate(angle, {origin: [pdfKitDoc.page.width / 2, pdfKitDoc.page.height / 2]});

	var x = pdfKitDoc.page.width / 2 - watermark.size.size.width / 2;
	var y = pdfKitDoc.page.height / 2 - watermark.size.size.height / 4;

	pdfKitDoc._font = watermark.font;
	pdfKitDoc.fontSize(watermark.size.fontSize);
	pdfKitDoc.text(watermark.text, x, y, {lineBreak: false});

	pdfKitDoc.restore();
}

function renderVector(vector, pdfKitDoc) {
	//TODO: pdf optimization (there's no need to write all properties everytime)
	pdfKitDoc.lineWidth(vector.lineWidth || 1);
	if (vector.dash) {
		pdfKitDoc.dash(vector.dash.length, {space: vector.dash.space || vector.dash.length, phase: vector.dash.phase || 0});
	} else {
		pdfKitDoc.undash();
	}
	pdfKitDoc.lineJoin(vector.lineJoin || 'miter');
	pdfKitDoc.lineCap(vector.lineCap || 'butt');

	//TODO: clipping

	switch (vector.type) {
		case 'ellipse':
			pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);
			break;
		case 'rect':
			if (vector.r) {
				pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
			} else {
				pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
			}

			if (vector.linearGradient) {
				var gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
				var step = 1 / (vector.linearGradient.length - 1);

				for (var i = 0; i < vector.linearGradient.length; i++) {
					gradient.stop(i * step, vector.linearGradient[i]);
				}

				vector.color = gradient;
			}
			break;
		case 'line':
			pdfKitDoc.moveTo(vector.x1, vector.y1);
			pdfKitDoc.lineTo(vector.x2, vector.y2);
			break;
		case 'polyline':
			if (vector.points.length === 0) {
				break;
			}

			pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
			for (var i = 1, l = vector.points.length; i < l; i++) {
				pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
			}

			if (vector.points.length > 1) {
				var p1 = vector.points[0];
				var pn = vector.points[vector.points.length - 1];

				if (vector.closePath || p1.x === pn.x && p1.y === pn.y) {
					pdfKitDoc.closePath();
				}
			}
			break;
		case 'path':
			pdfKitDoc.path(vector.d);
			break;
	}

	if (vector.color && vector.lineColor) {
		pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
		pdfKitDoc.strokeColor(vector.lineColor, vector.strokeOpacity || 1);
		pdfKitDoc.fillAndStroke();
	} else if (vector.color) {
		pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
		pdfKitDoc.fill();
	} else {
		pdfKitDoc.strokeColor(vector.lineColor || 'black', vector.strokeOpacity || 1);
		pdfKitDoc.stroke();
	}
}

function renderImage(image, x, y, pdfKitDoc) {
	pdfKitDoc.opacity(image.opacity || 1);
	pdfKitDoc.image(image.image, image.x, image.y, {width: image._width, height: image._height});
	if (image.link) {
		pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
	}
}

function beginClip(rect, pdfKitDoc) {
	pdfKitDoc.save();
	pdfKitDoc.addContent('' + rect.x + ' ' + rect.y + ' ' + rect.width + ' ' + rect.height + ' re');
	pdfKitDoc.clip();
}

function endClip(pdfKitDoc) {
	pdfKitDoc.restore();
}

module.exports = PdfPrinter;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault(ex) {
	return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex;
}

var PdfKit = _interopDefault(__webpack_require__(128));

function getEngineInstance() {
	return PdfKit;
}

function createPdfDocument(options) {
	options = options || {};
	return new PdfKit(options);
}

module.exports = {
	getEngineInstance: getEngineInstance,
	createPdfDocument: createPdfDocument
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

/*
PDFDocument - represents an entire PDF document
By Devon Govett
 */

(function() {
  var PDFDocument, PDFObject, PDFPage, PDFReference, fs, stream,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  stream = __webpack_require__(31);

  fs = __webpack_require__(9);

  PDFObject = __webpack_require__(26);

  PDFReference = __webpack_require__(82);

  PDFPage = __webpack_require__(150);

  PDFDocument = (function(superClass) {
    var mixin;

    extend(PDFDocument, superClass);

    function PDFDocument(options1) {
      var key, ref1, ref2, val;
      this.options = options1 != null ? options1 : {};
      PDFDocument.__super__.constructor.apply(this, arguments);
      this.version = 1.3;
      this.compress = (ref1 = this.options.compress) != null ? ref1 : true;
      this._pageBuffer = [];
      this._pageBufferStart = 0;
      this._offsets = [];
      this._waiting = 0;
      this._ended = false;
      this._offset = 0;
      this._root = this.ref({
        Type: 'Catalog',
        Pages: this.ref({
          Type: 'Pages',
          Count: 0,
          Kids: []
        })
      });
      this.page = null;
      this.initColor();
      this.initVector();
      this.initFonts();
      this.initText();
      this.initImages();
      this.info = {
        Producer: 'PDFKit',
        Creator: 'PDFKit',
        CreationDate: new Date()
      };
      if (this.options.info) {
        ref2 = this.options.info;
        for (key in ref2) {
          val = ref2[key];
          this.info[key] = val;
        }
      }
      this._write("%PDF-" + this.version);
      this._write("%\xFF\xFF\xFF\xFF");
      if (this.options.autoFirstPage !== false) {
        this.addPage();
      }
    }

    mixin = function(methods) {
      var method, name, results;
      results = [];
      for (name in methods) {
        method = methods[name];
        results.push(PDFDocument.prototype[name] = method);
      }
      return results;
    };

    mixin(__webpack_require__(151));

    mixin(__webpack_require__(153));

    mixin(__webpack_require__(155));

    mixin(__webpack_require__(284));

    mixin(__webpack_require__(289));

    mixin(__webpack_require__(295));

    PDFDocument.prototype.addPage = function(options) {
      var pages;
      if (options == null) {
        options = this.options;
      }
      if (!this.options.bufferPages) {
        this.flushPages();
      }
      this.page = new PDFPage(this, options);
      this._pageBuffer.push(this.page);
      pages = this._root.data.Pages.data;
      pages.Kids.push(this.page.dictionary);
      pages.Count++;
      this.x = this.page.margins.left;
      this.y = this.page.margins.top;
      this._ctm = [1, 0, 0, 1, 0, 0];
      this.transform(1, 0, 0, -1, 0, this.page.height);
      this.emit('pageAdded');
      return this;
    };

    PDFDocument.prototype.bufferedPageRange = function() {
      return {
        start: this._pageBufferStart,
        count: this._pageBuffer.length
      };
    };

    PDFDocument.prototype.switchToPage = function(n) {
      var page;
      if (!(page = this._pageBuffer[n - this._pageBufferStart])) {
        throw new Error("switchToPage(" + n + ") out of bounds, current buffer covers pages " + this._pageBufferStart + " to " + (this._pageBufferStart + this._pageBuffer.length - 1));
      }
      return this.page = page;
    };

    PDFDocument.prototype.flushPages = function() {
      var i, len, page, pages;
      pages = this._pageBuffer;
      this._pageBuffer = [];
      this._pageBufferStart += pages.length;
      for (i = 0, len = pages.length; i < len; i++) {
        page = pages[i];
        page.end();
      }
    };

    PDFDocument.prototype.ref = function(data) {
      var ref;
      ref = new PDFReference(this, this._offsets.length + 1, data);
      this._offsets.push(null);
      this._waiting++;
      return ref;
    };

    PDFDocument.prototype._read = function() {};

    PDFDocument.prototype._write = function(data) {
      if (!Buffer.isBuffer(data)) {
        data = new Buffer(data + '\n', 'binary');
      }
      this.push(data);
      return this._offset += data.length;
    };

    PDFDocument.prototype.addContent = function(data) {
      this.page.write(data);
      return this;
    };

    PDFDocument.prototype._refEnd = function(ref) {
      this._offsets[ref.id - 1] = ref.offset;
      if (--this._waiting === 0 && this._ended) {
        this._finalize();
        return this._ended = false;
      }
    };

    PDFDocument.prototype.write = function(filename, fn) {
      var err;
      err = new Error('PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.');
      console.warn(err.stack);
      this.pipe(fs.createWriteStream(filename));
      this.end();
      return this.once('end', fn);
    };

    PDFDocument.prototype.output = function(fn) {
      throw new Error('PDFDocument#output is deprecated, and has been removed from PDFKit. Please pipe the document into a Node stream.');
    };

    PDFDocument.prototype.end = function() {
      var font, key, name, ref1, ref2, val;
      this.flushPages();
      this._info = this.ref();
      ref1 = this.info;
      for (key in ref1) {
        val = ref1[key];
        if (typeof val === 'string') {
          val = new String(val);
        }
        this._info.data[key] = val;
      }
      this._info.end();
      ref2 = this._fontFamilies;
      for (name in ref2) {
        font = ref2[name];
        font.finalize();
      }
      this._root.end();
      this._root.data.Pages.end();
      if (this._waiting === 0) {
        return this._finalize();
      } else {
        return this._ended = true;
      }
    };

    PDFDocument.prototype._finalize = function(fn) {
      var i, len, offset, ref1, xRefOffset;
      xRefOffset = this._offset;
      this._write("xref");
      this._write("0 " + (this._offsets.length + 1));
      this._write("0000000000 65535 f ");
      ref1 = this._offsets;
      for (i = 0, len = ref1.length; i < len; i++) {
        offset = ref1[i];
        offset = ('0000000000' + offset).slice(-10);
        this._write(offset + ' 00000 n ');
      }
      this._write('trailer');
      this._write(PDFObject.convert({
        Size: this._offsets.length + 1,
        Root: this._root,
        Info: this._info
      }));
      this._write('startxref');
      this._write("" + xRefOffset);
      this._write('%%EOF');
      return this.push(null);
    };

    PDFDocument.prototype.toString = function() {
      return "[object PDFDocument]";
    };

    return PDFDocument;

  })(stream.Readable);

  module.exports = PDFDocument;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 129 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(34).Buffer;
var util = __webpack_require__(131);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(133);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(81);

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(15);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(45);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44).Transform


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(44).PassThrough


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {
/* eslint camelcase: "off" */

var assert = __webpack_require__(83);

var Zstream = __webpack_require__(142);
var zlib_deflate = __webpack_require__(143);
var zlib_inflate = __webpack_require__(146);
var constants = __webpack_require__(149);

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
    throw new TypeError('Bad argument');
  }

  this.dictionary = null;
  this.err = 0;
  this.flush = 0;
  this.init_done = false;
  this.level = 0;
  this.memLevel = 0;
  this.mode = mode;
  this.strategy = 0;
  this.windowBits = 0;
  this.write_in_progress = false;
  this.pending_close = false;
  this.gzip_id_bytes_read = 0;
}

Zlib.prototype.close = function () {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }

  this.pending_close = false;

  assert(this.init_done, 'close before init');
  assert(this.mode <= exports.UNZIP);

  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
    zlib_inflate.inflateEnd(this.strm);
  }

  this.mode = exports.NONE;

  this.dictionary = null;
};

Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
  assert.equal(arguments.length, 8);

  assert(this.init_done, 'write before init');
  assert(this.mode !== exports.NONE, 'already finalized');
  assert.equal(false, this.write_in_progress, 'write already in progress');
  assert.equal(false, this.pending_close, 'close is pending');

  this.write_in_progress = true;

  assert.equal(false, flush === undefined, 'must provide flush value');

  this.write_in_progress = true;

  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
    throw new Error('Invalid flush value');
  }

  if (input == null) {
    input = Buffer.alloc(0);
    in_len = 0;
    in_off = 0;
  }

  this.strm.avail_in = in_len;
  this.strm.input = input;
  this.strm.next_in = in_off;
  this.strm.avail_out = out_len;
  this.strm.output = out;
  this.strm.next_out = out_off;
  this.flush = flush;

  if (!async) {
    // sync version
    this._process();

    if (this._checkError()) {
      return this._afterSync();
    }
    return;
  }

  // async version
  var self = this;
  process.nextTick(function () {
    self._process();
    self._after();
  });

  return this;
};

Zlib.prototype._afterSync = function () {
  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  return [avail_in, avail_out];
};

Zlib.prototype._process = function () {
  var next_expected_header_byte = null;

  // If the avail_out is left at 0, then it means that it ran out
  // of room.  If there was avail_out left over, then it means
  // that all of the input was consumed.
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflate(this.strm, this.flush);
      break;
    case exports.UNZIP:
      if (this.strm.avail_in > 0) {
        next_expected_header_byte = this.strm.next_in;
      }

      switch (this.gzip_id_bytes_read) {
        case 0:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
            this.gzip_id_bytes_read = 1;
            next_expected_header_byte++;

            if (this.strm.avail_in === 1) {
              // The only available byte was already read.
              break;
            }
          } else {
            this.mode = exports.INFLATE;
            break;
          }

        // fallthrough
        case 1:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
            this.gzip_id_bytes_read = 2;
            this.mode = exports.GUNZIP;
          } else {
            // There is no actual difference between INFLATE and INFLATERAW
            // (after initialization).
            this.mode = exports.INFLATE;
          }

          break;
        default:
          throw new Error('invalid number of gzip magic number bytes read');
      }

    // fallthrough
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      this.err = zlib_inflate.inflate(this.strm, this.flush

      // If data was encoded with dictionary
      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
        // Load it
        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
        if (this.err === exports.Z_OK) {
          // And try to decode again
          this.err = zlib_inflate.inflate(this.strm, this.flush);
        } else if (this.err === exports.Z_DATA_ERROR) {
          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
          // Make it possible for After() to tell a bad dictionary from bad
          // input.
          this.err = exports.Z_NEED_DICT;
        }
      }
      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
        // Bytes remain in input buffer. Perhaps this is another compressed
        // member in the same archive, or just trailing garbage.
        // Trailing zero bytes are okay, though, since they are frequently
        // used for padding.

        this.reset();
        this.err = zlib_inflate.inflate(this.strm, this.flush);
      }
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }
};

Zlib.prototype._checkError = function () {
  // Acceptable error states depend on the type of zlib stream.
  switch (this.err) {
    case exports.Z_OK:
    case exports.Z_BUF_ERROR:
      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
        this._error('unexpected end of file');
        return false;
      }
      break;
    case exports.Z_STREAM_END:
      // normal statuses, not fatal
      break;
    case exports.Z_NEED_DICT:
      if (this.dictionary == null) {
        this._error('Missing dictionary');
      } else {
        this._error('Bad dictionary');
      }
      return false;
    default:
      // something else.
      this._error('Zlib error');
      return false;
  }

  return true;
};

Zlib.prototype._after = function () {
  if (!this._checkError()) {
    return;
  }

  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  // call the write() cb
  this.callback(avail_in, avail_out);

  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype._error = function (message) {
  if (this.strm.msg) {
    message = this.strm.msg;
  }
  this.onerror(message, this.err

  // no hope of rescue.
  );this.write_in_progress = false;
  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
  assert(level >= -1 && level <= 9, 'invalid compression level');

  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

  this._init(level, windowBits, memLevel, strategy, dictionary);
  this._setDictionary();
};

Zlib.prototype.params = function () {
  throw new Error('deflateParams Not supported');
};

Zlib.prototype.reset = function () {
  this._reset();
  this._setDictionary();
};

Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
  this.level = level;
  this.windowBits = windowBits;
  this.memLevel = memLevel;
  this.strategy = strategy;

  this.flush = exports.Z_NO_FLUSH;

  this.err = exports.Z_OK;

  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
    this.windowBits += 16;
  }

  if (this.mode === exports.UNZIP) {
    this.windowBits += 32;
  }

  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
    this.windowBits = -1 * this.windowBits;
  }

  this.strm = new Zstream();

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }

  if (this.err !== exports.Z_OK) {
    this._error('Init error');
  }

  this.dictionary = dictionary;

  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype._setDictionary = function () {
  if (this.dictionary == null) {
    return;
  }

  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to set dictionary');
  }
};

Zlib.prototype._reset = function () {
  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
    case exports.GZIP:
      this.err = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
    case exports.GUNZIP:
      this.err = zlib_inflate.inflateReset(this.strm);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to reset stream');
  }
};

exports.Zlib = Zlib;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(8)))

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__(35);
var trees   = __webpack_require__(144);
var adler32 = __webpack_require__(84);
var crc32   = __webpack_require__(85);
var msg     = __webpack_require__(145);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(35);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__(35);
var adler32       = __webpack_require__(84);
var crc32         = __webpack_require__(85);
var inflate_fast  = __webpack_require__(147);
var inflate_table = __webpack_require__(148);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(35);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6

/*
PDFPage - represents a single page in the PDF document
By Devon Govett
 */

(function() {
  var PDFPage;

  PDFPage = (function() {
    var DEFAULT_MARGINS, SIZES;

    function PDFPage(document, options) {
      var dimensions;
      this.document = document;
      if (options == null) {
        options = {};
      }
      this.size = options.size || 'letter';
      this.layout = options.layout || 'portrait';
      if (typeof options.margin === 'number') {
        this.margins = {
          top: options.margin,
          left: options.margin,
          bottom: options.margin,
          right: options.margin
        };
      } else {
        this.margins = options.margins || DEFAULT_MARGINS;
      }
      dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
      this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
      this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
      this.content = this.document.ref();
      this.resources = this.document.ref({
        ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI']
      });
      Object.defineProperties(this, {
        fonts: {
          get: (function(_this) {
            return function() {
              var base;
              return (base = _this.resources.data).Font != null ? base.Font : base.Font = {};
            };
          })(this)
        },
        xobjects: {
          get: (function(_this) {
            return function() {
              var base;
              return (base = _this.resources.data).XObject != null ? base.XObject : base.XObject = {};
            };
          })(this)
        },
        ext_gstates: {
          get: (function(_this) {
            return function() {
              var base;
              return (base = _this.resources.data).ExtGState != null ? base.ExtGState : base.ExtGState = {};
            };
          })(this)
        },
        patterns: {
          get: (function(_this) {
            return function() {
              var base;
              return (base = _this.resources.data).Pattern != null ? base.Pattern : base.Pattern = {};
            };
          })(this)
        },
        annotations: {
          get: (function(_this) {
            return function() {
              var base;
              return (base = _this.dictionary.data).Annots != null ? base.Annots : base.Annots = [];
            };
          })(this)
        }
      });
      this.dictionary = this.document.ref({
        Type: 'Page',
        Parent: this.document._root.data.Pages,
        MediaBox: [0, 0, this.width, this.height],
        Contents: this.content,
        Resources: this.resources
      });
    }

    PDFPage.prototype.maxY = function() {
      return this.height - this.margins.bottom;
    };

    PDFPage.prototype.write = function(chunk) {
      return this.content.write(chunk);
    };

    PDFPage.prototype.end = function() {
      this.dictionary.end();
      this.resources.end();
      return this.content.end();
    };

    DEFAULT_MARGINS = {
      top: 72,
      left: 72,
      bottom: 72,
      right: 72
    };

    SIZES = {
      '4A0': [4767.87, 6740.79],
      '2A0': [3370.39, 4767.87],
      A0: [2383.94, 3370.39],
      A1: [1683.78, 2383.94],
      A2: [1190.55, 1683.78],
      A3: [841.89, 1190.55],
      A4: [595.28, 841.89],
      A5: [419.53, 595.28],
      A6: [297.64, 419.53],
      A7: [209.76, 297.64],
      A8: [147.40, 209.76],
      A9: [104.88, 147.40],
      A10: [73.70, 104.88],
      B0: [2834.65, 4008.19],
      B1: [2004.09, 2834.65],
      B2: [1417.32, 2004.09],
      B3: [1000.63, 1417.32],
      B4: [708.66, 1000.63],
      B5: [498.90, 708.66],
      B6: [354.33, 498.90],
      B7: [249.45, 354.33],
      B8: [175.75, 249.45],
      B9: [124.72, 175.75],
      B10: [87.87, 124.72],
      C0: [2599.37, 3676.54],
      C1: [1836.85, 2599.37],
      C2: [1298.27, 1836.85],
      C3: [918.43, 1298.27],
      C4: [649.13, 918.43],
      C5: [459.21, 649.13],
      C6: [323.15, 459.21],
      C7: [229.61, 323.15],
      C8: [161.57, 229.61],
      C9: [113.39, 161.57],
      C10: [79.37, 113.39],
      RA0: [2437.80, 3458.27],
      RA1: [1729.13, 2437.80],
      RA2: [1218.90, 1729.13],
      RA3: [864.57, 1218.90],
      RA4: [609.45, 864.57],
      SRA0: [2551.18, 3628.35],
      SRA1: [1814.17, 2551.18],
      SRA2: [1275.59, 1814.17],
      SRA3: [907.09, 1275.59],
      SRA4: [637.80, 907.09],
      EXECUTIVE: [521.86, 756.00],
      FOLIO: [612.00, 936.00],
      LEGAL: [612.00, 1008.00],
      LETTER: [612.00, 792.00],
      TABLOID: [792.00, 1224.00]
    };

    return PDFPage;

  })();

  module.exports = PDFPage;

}).call(this);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var PDFGradient, PDFLinearGradient, PDFRadialGradient, namedColors, ref;

  ref = __webpack_require__(152), PDFGradient = ref.PDFGradient, PDFLinearGradient = ref.PDFLinearGradient, PDFRadialGradient = ref.PDFRadialGradient;

  module.exports = {
    initColor: function() {
      this._opacityRegistry = {};
      this._opacityCount = 0;
      return this._gradCount = 0;
    },
    _normalizeColor: function(color) {
      var hex, part;
      if (color instanceof PDFGradient) {
        return color;
      }
      if (typeof color === 'string') {
        if (color.charAt(0) === '#') {
          if (color.length === 4) {
            color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
          }
          hex = parseInt(color.slice(1), 16);
          color = [hex >> 16, hex >> 8 & 0xff, hex & 0xff];
        } else if (namedColors[color]) {
          color = namedColors[color];
        }
      }
      if (Array.isArray(color)) {
        if (color.length === 3) {
          color = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = color.length; i < len; i++) {
              part = color[i];
              results.push(part / 255);
            }
            return results;
          })();
        } else if (color.length === 4) {
          color = (function() {
            var i, len, results;
            results = [];
            for (i = 0, len = color.length; i < len; i++) {
              part = color[i];
              results.push(part / 100);
            }
            return results;
          })();
        }
        return color;
      }
      return null;
    },
    _setColor: function(color, stroke) {
      var op, space;
      color = this._normalizeColor(color);
      if (!color) {
        return false;
      }
      op = stroke ? 'SCN' : 'scn';
      if (color instanceof PDFGradient) {
        this._setColorSpace('Pattern', stroke);
        color.apply(op);
      } else {
        space = color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
        this._setColorSpace(space, stroke);
        color = color.join(' ');
        this.addContent(color + " " + op);
      }
      return true;
    },
    _setColorSpace: function(space, stroke) {
      var op;
      op = stroke ? 'CS' : 'cs';
      return this.addContent("/" + space + " " + op);
    },
    fillColor: function(color, opacity) {
      var set;
      set = this._setColor(color, false);
      if (set) {
        this.fillOpacity(opacity);
      }
      this._fillColor = [color, opacity];
      return this;
    },
    strokeColor: function(color, opacity) {
      var set;
      set = this._setColor(color, true);
      if (set) {
        this.strokeOpacity(opacity);
      }
      return this;
    },
    opacity: function(opacity) {
      this._doOpacity(opacity, opacity);
      return this;
    },
    fillOpacity: function(opacity) {
      this._doOpacity(opacity, null);
      return this;
    },
    strokeOpacity: function(opacity) {
      this._doOpacity(null, opacity);
      return this;
    },
    _doOpacity: function(fillOpacity, strokeOpacity) {
      var dictionary, id, key, name, ref1;
      if (!((fillOpacity != null) || (strokeOpacity != null))) {
        return;
      }
      if (fillOpacity != null) {
        fillOpacity = Math.max(0, Math.min(1, fillOpacity));
      }
      if (strokeOpacity != null) {
        strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
      }
      key = fillOpacity + "_" + strokeOpacity;
      if (this._opacityRegistry[key]) {
        ref1 = this._opacityRegistry[key], dictionary = ref1[0], name = ref1[1];
      } else {
        dictionary = {
          Type: 'ExtGState'
        };
        if (fillOpacity != null) {
          dictionary.ca = fillOpacity;
        }
        if (strokeOpacity != null) {
          dictionary.CA = strokeOpacity;
        }
        dictionary = this.ref(dictionary);
        dictionary.end();
        id = ++this._opacityCount;
        name = "Gs" + id;
        this._opacityRegistry[key] = [dictionary, name];
      }
      this.page.ext_gstates[name] = dictionary;
      return this.addContent("/" + name + " gs");
    },
    linearGradient: function(x1, y1, x2, y2) {
      return new PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient: function(x1, y1, r1, x2, y2, r2) {
      return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    }
  };

  namedColors = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    grey: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  };

}).call(this);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var PDFGradient, PDFLinearGradient, PDFRadialGradient,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  PDFGradient = (function() {
    function PDFGradient(doc) {
      this.doc = doc;
      this.stops = [];
      this.embedded = false;
      this.transform = [1, 0, 0, 1, 0, 0];
      this._colorSpace = 'DeviceRGB';
    }

    PDFGradient.prototype.stop = function(pos, color, opacity) {
      if (opacity == null) {
        opacity = 1;
      }
      opacity = Math.max(0, Math.min(1, opacity));
      this.stops.push([pos, this.doc._normalizeColor(color), opacity]);
      return this;
    };

    PDFGradient.prototype.setTransform = function(m11, m12, m21, m22, dx, dy) {
      this.transform = [m11, m12, m21, m22, dx, dy];
      return this;
    };

    PDFGradient.prototype.embed = function(m) {
      var bounds, encode, fn, form, grad, gstate, i, j, k, last, len, opacityPattern, pageBBox, pattern, ref, ref1, shader, stop, stops, v;
      if (this.stops.length === 0) {
        return;
      }
      this.embedded = true;
      this.matrix = m;
      last = this.stops[this.stops.length - 1];
      if (last[0] < 1) {
        this.stops.push([1, last[1], last[2]]);
      }
      bounds = [];
      encode = [];
      stops = [];
      for (i = j = 0, ref = this.stops.length - 1; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        encode.push(0, 1);
        if (i + 2 !== this.stops.length) {
          bounds.push(this.stops[i + 1][0]);
        }
        fn = this.doc.ref({
          FunctionType: 2,
          Domain: [0, 1],
          C0: this.stops[i + 0][1],
          C1: this.stops[i + 1][1],
          N: 1
        });
        stops.push(fn);
        fn.end();
      }
      if (stops.length === 1) {
        fn = stops[0];
      } else {
        fn = this.doc.ref({
          FunctionType: 3,
          Domain: [0, 1],
          Functions: stops,
          Bounds: bounds,
          Encode: encode
        });
        fn.end();
      }
      this.id = 'Sh' + (++this.doc._gradCount);
      shader = this.shader(fn);
      shader.end();
      pattern = this.doc.ref({
        Type: 'Pattern',
        PatternType: 2,
        Shading: shader,
        Matrix: (function() {
          var k, len, ref1, results;
          ref1 = this.matrix;
          results = [];
          for (k = 0, len = ref1.length; k < len; k++) {
            v = ref1[k];
            results.push(+v.toFixed(5));
          }
          return results;
        }).call(this)
      });
      pattern.end();
      if (this.stops.some(function(stop) {
        return stop[2] < 1;
      })) {
        grad = this.opacityGradient();
        grad._colorSpace = 'DeviceGray';
        ref1 = this.stops;
        for (k = 0, len = ref1.length; k < len; k++) {
          stop = ref1[k];
          grad.stop(stop[0], [stop[2]]);
        }
        grad = grad.embed(this.matrix);
        pageBBox = [0, 0, this.doc.page.width, this.doc.page.height];
        form = this.doc.ref({
          Type: 'XObject',
          Subtype: 'Form',
          FormType: 1,
          BBox: pageBBox,
          Group: {
            Type: 'Group',
            S: 'Transparency',
            CS: 'DeviceGray'
          },
          Resources: {
            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
            Pattern: {
              Sh1: grad
            }
          }
        });
        form.write("/Pattern cs /Sh1 scn");
        form.end((pageBBox.join(" ")) + " re f");
        gstate = this.doc.ref({
          Type: 'ExtGState',
          SMask: {
            Type: 'Mask',
            S: 'Luminosity',
            G: form
          }
        });
        gstate.end();
        opacityPattern = this.doc.ref({
          Type: 'Pattern',
          PatternType: 1,
          PaintType: 1,
          TilingType: 2,
          BBox: pageBBox,
          XStep: pageBBox[2],
          YStep: pageBBox[3],
          Resources: {
            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
            Pattern: {
              Sh1: pattern
            },
            ExtGState: {
              Gs1: gstate
            }
          }
        });
        opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
        opacityPattern.end((pageBBox.join(" ")) + " re f");
        this.doc.page.patterns[this.id] = opacityPattern;
      } else {
        this.doc.page.patterns[this.id] = pattern;
      }
      return pattern;
    };

    PDFGradient.prototype.apply = function(op) {
      var dx, dy, m, m0, m1, m11, m12, m2, m21, m22, m3, m4, m5, ref, ref1;
      ref = this.doc._ctm.slice(), m0 = ref[0], m1 = ref[1], m2 = ref[2], m3 = ref[3], m4 = ref[4], m5 = ref[5];
      ref1 = this.transform, m11 = ref1[0], m12 = ref1[1], m21 = ref1[2], m22 = ref1[3], dx = ref1[4], dy = ref1[5];
      m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];
      if (!(this.embedded && m.join(" ") === this.matrix.join(" "))) {
        this.embed(m);
      }
      return this.doc.addContent("/" + this.id + " " + op);
    };

    return PDFGradient;

  })();

  PDFLinearGradient = (function(superClass) {
    extend(PDFLinearGradient, superClass);

    function PDFLinearGradient(doc, x1, y1, x2, y2) {
      this.doc = doc;
      this.x1 = x1;
      this.y1 = y1;
      this.x2 = x2;
      this.y2 = y2;
      PDFLinearGradient.__super__.constructor.apply(this, arguments);
    }

    PDFLinearGradient.prototype.shader = function(fn) {
      return this.doc.ref({
        ShadingType: 2,
        ColorSpace: this._colorSpace,
        Coords: [this.x1, this.y1, this.x2, this.y2],
        Function: fn,
        Extend: [true, true]
      });
    };

    PDFLinearGradient.prototype.opacityGradient = function() {
      return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
    };

    return PDFLinearGradient;

  })(PDFGradient);

  PDFRadialGradient = (function(superClass) {
    extend(PDFRadialGradient, superClass);

    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
      this.doc = doc;
      this.x1 = x1;
      this.y1 = y1;
      this.r1 = r1;
      this.x2 = x2;
      this.y2 = y2;
      this.r2 = r2;
      PDFRadialGradient.__super__.constructor.apply(this, arguments);
    }

    PDFRadialGradient.prototype.shader = function(fn) {
      return this.doc.ref({
        ShadingType: 3,
        ColorSpace: this._colorSpace,
        Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
        Function: fn,
        Extend: [true, true]
      });
    };

    PDFRadialGradient.prototype.opacityGradient = function() {
      return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
    };

    return PDFRadialGradient;

  })(PDFGradient);

  module.exports = {
    PDFGradient: PDFGradient,
    PDFLinearGradient: PDFLinearGradient,
    PDFRadialGradient: PDFRadialGradient
  };

}).call(this);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var KAPPA, SVGPath, number,
    slice = [].slice;

  SVGPath = __webpack_require__(154);

  number = __webpack_require__(26).number;

  KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);

  module.exports = {
    initVector: function() {
      this._ctm = [1, 0, 0, 1, 0, 0];
      return this._ctmStack = [];
    },
    save: function() {
      this._ctmStack.push(this._ctm.slice());
      return this.addContent('q');
    },
    restore: function() {
      this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
      return this.addContent('Q');
    },
    closePath: function() {
      return this.addContent('h');
    },
    lineWidth: function(w) {
      return this.addContent((number(w)) + " w");
    },
    _CAP_STYLES: {
      BUTT: 0,
      ROUND: 1,
      SQUARE: 2
    },
    lineCap: function(c) {
      if (typeof c === 'string') {
        c = this._CAP_STYLES[c.toUpperCase()];
      }
      return this.addContent(c + " J");
    },
    _JOIN_STYLES: {
      MITER: 0,
      ROUND: 1,
      BEVEL: 2
    },
    lineJoin: function(j) {
      if (typeof j === 'string') {
        j = this._JOIN_STYLES[j.toUpperCase()];
      }
      return this.addContent(j + " j");
    },
    miterLimit: function(m) {
      return this.addContent((number(m)) + " M");
    },
    dash: function(length, options) {
      var phase, ref, space, v;
      if (options == null) {
        options = {};
      }
      if (length == null) {
        return this;
      }
      if (Array.isArray(length)) {
        length = ((function() {
          var i, len, results;
          results = [];
          for (i = 0, len = length.length; i < len; i++) {
            v = length[i];
            results.push(number(v));
          }
          return results;
        })()).join(' ');
        phase = options.phase || 0;
        return this.addContent("[" + length + "] " + (number(phase)) + " d");
      } else {
        space = (ref = options.space) != null ? ref : length;
        phase = options.phase || 0;
        return this.addContent("[" + (number(length)) + " " + (number(space)) + "] " + (number(phase)) + " d");
      }
    },
    undash: function() {
      return this.addContent("[] 0 d");
    },
    moveTo: function(x, y) {
      return this.addContent((number(x)) + " " + (number(y)) + " m");
    },
    lineTo: function(x, y) {
      return this.addContent((number(x)) + " " + (number(y)) + " l");
    },
    bezierCurveTo: function(cp1x, cp1y, cp2x, cp2y, x, y) {
      return this.addContent((number(cp1x)) + " " + (number(cp1y)) + " " + (number(cp2x)) + " " + (number(cp2y)) + " " + (number(x)) + " " + (number(y)) + " c");
    },
    quadraticCurveTo: function(cpx, cpy, x, y) {
      return this.addContent((number(cpx)) + " " + (number(cpy)) + " " + (number(x)) + " " + (number(y)) + " v");
    },
    rect: function(x, y, w, h) {
      return this.addContent((number(x)) + " " + (number(y)) + " " + (number(w)) + " " + (number(h)) + " re");
    },
    roundedRect: function(x, y, w, h, r) {
      var c;
      if (r == null) {
        r = 0;
      }
      r = Math.min(r, 0.5 * w, 0.5 * h);
      c = r * (1.0 - KAPPA);
      this.moveTo(x + r, y);
      this.lineTo(x + w - r, y);
      this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
      this.lineTo(x + w, y + h - r);
      this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
      this.lineTo(x + r, y + h);
      this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
      this.lineTo(x, y + r);
      this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
      return this.closePath();
    },
    ellipse: function(x, y, r1, r2) {
      var ox, oy, xe, xm, ye, ym;
      if (r2 == null) {
        r2 = r1;
      }
      x -= r1;
      y -= r2;
      ox = r1 * KAPPA;
      oy = r2 * KAPPA;
      xe = x + r1 * 2;
      ye = y + r2 * 2;
      xm = x + r1;
      ym = y + r2;
      this.moveTo(x, ym);
      this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
      this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
      this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
      this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
      return this.closePath();
    },
    circle: function(x, y, radius) {
      return this.ellipse(x, y, radius);
    },
    arc: function(x, y, radius, startAngle, endAngle, anticlockwise) {
      var HALF_PI, TWO_PI, ax, ay, cp1x, cp1y, cp2x, cp2y, curAng, deltaAng, deltaCx, deltaCy, dir, handleLen, i, numSegs, ref, segAng, segIdx;
      if (anticlockwise == null) {
        anticlockwise = false;
      }
      TWO_PI = 2.0 * Math.PI;
      HALF_PI = 0.5 * Math.PI;
      deltaAng = endAngle - startAngle;
      if (Math.abs(deltaAng) > TWO_PI) {
        deltaAng = TWO_PI;
      } else if (deltaAng !== 0 && anticlockwise !== (deltaAng < 0)) {
        dir = anticlockwise ? -1 : 1;
        deltaAng = dir * TWO_PI + deltaAng;
      }
      numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
      segAng = deltaAng / numSegs;
      handleLen = (segAng / HALF_PI) * KAPPA * radius;
      curAng = startAngle;
      deltaCx = -Math.sin(curAng) * handleLen;
      deltaCy = Math.cos(curAng) * handleLen;
      ax = x + Math.cos(curAng) * radius;
      ay = y + Math.sin(curAng) * radius;
      this.moveTo(ax, ay);
      for (segIdx = i = 0, ref = numSegs; 0 <= ref ? i < ref : i > ref; segIdx = 0 <= ref ? ++i : --i) {
        cp1x = ax + deltaCx;
        cp1y = ay + deltaCy;
        curAng += segAng;
        ax = x + Math.cos(curAng) * radius;
        ay = y + Math.sin(curAng) * radius;
        deltaCx = -Math.sin(curAng) * handleLen;
        deltaCy = Math.cos(curAng) * handleLen;
        cp2x = ax - deltaCx;
        cp2y = ay - deltaCy;
        this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
      }
      return this;
    },
    polygon: function() {
      var i, len, point, points;
      points = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      this.moveTo.apply(this, points.shift());
      for (i = 0, len = points.length; i < len; i++) {
        point = points[i];
        this.lineTo.apply(this, point);
      }
      return this.closePath();
    },
    path: function(path) {
      SVGPath.apply(this, path);
      return this;
    },
    _windingRule: function(rule) {
      if (/even-?odd/.test(rule)) {
        return '*';
      }
      return '';
    },
    fill: function(color, rule) {
      if (/(even-?odd)|(non-?zero)/.test(color)) {
        rule = color;
        color = null;
      }
      if (color) {
        this.fillColor(color);
      }
      return this.addContent('f' + this._windingRule(rule));
    },
    stroke: function(color) {
      if (color) {
        this.strokeColor(color);
      }
      return this.addContent('S');
    },
    fillAndStroke: function(fillColor, strokeColor, rule) {
      var isFillRule;
      if (strokeColor == null) {
        strokeColor = fillColor;
      }
      isFillRule = /(even-?odd)|(non-?zero)/;
      if (isFillRule.test(fillColor)) {
        rule = fillColor;
        fillColor = null;
      }
      if (isFillRule.test(strokeColor)) {
        rule = strokeColor;
        strokeColor = fillColor;
      }
      if (fillColor) {
        this.fillColor(fillColor);
        this.strokeColor(strokeColor);
      }
      return this.addContent('B' + this._windingRule(rule));
    },
    clip: function(rule) {
      return this.addContent('W' + this._windingRule(rule) + ' n');
    },
    transform: function(m11, m12, m21, m22, dx, dy) {
      var m, m0, m1, m2, m3, m4, m5, v, values;
      m = this._ctm;
      m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5];
      m[0] = m0 * m11 + m2 * m12;
      m[1] = m1 * m11 + m3 * m12;
      m[2] = m0 * m21 + m2 * m22;
      m[3] = m1 * m21 + m3 * m22;
      m[4] = m0 * dx + m2 * dy + m4;
      m[5] = m1 * dx + m3 * dy + m5;
      values = ((function() {
        var i, len, ref, results;
        ref = [m11, m12, m21, m22, dx, dy];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          v = ref[i];
          results.push(number(v));
        }
        return results;
      })()).join(' ');
      return this.addContent(values + " cm");
    },
    translate: function(x, y) {
      return this.transform(1, 0, 0, 1, x, y);
    },
    rotate: function(angle, options) {
      var cos, rad, ref, sin, x, x1, y, y1;
      if (options == null) {
        options = {};
      }
      rad = angle * Math.PI / 180;
      cos = Math.cos(rad);
      sin = Math.sin(rad);
      x = y = 0;
      if (options.origin != null) {
        ref = options.origin, x = ref[0], y = ref[1];
        x1 = x * cos - y * sin;
        y1 = x * sin + y * cos;
        x -= x1;
        y -= y1;
      }
      return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale: function(xFactor, yFactor, options) {
      var ref, x, y;
      if (yFactor == null) {
        yFactor = xFactor;
      }
      if (options == null) {
        options = {};
      }
      if (typeof yFactor === "object") {
        options = yFactor;
        yFactor = xFactor;
      }
      x = y = 0;
      if (options.origin != null) {
        ref = options.origin, x = ref[0], y = ref[1];
        x -= xFactor * x;
        y -= yFactor * y;
      }
      return this.transform(xFactor, 0, 0, yFactor, x, y);
    }
  };

}).call(this);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var SVGPath;

  SVGPath = (function() {
    var apply, arcToSegments, cx, cy, parameters, parse, px, py, runners, segmentToBezier, solveArc, sx, sy;

    function SVGPath() {}

    SVGPath.apply = function(doc, path) {
      var commands;
      commands = parse(path);
      return apply(commands, doc);
    };

    parameters = {
      A: 7,
      a: 7,
      C: 6,
      c: 6,
      H: 1,
      h: 1,
      L: 2,
      l: 2,
      M: 2,
      m: 2,
      Q: 4,
      q: 4,
      S: 4,
      s: 4,
      T: 2,
      t: 2,
      V: 1,
      v: 1,
      Z: 0,
      z: 0
    };

    parse = function(path) {
      var args, c, cmd, curArg, foundDecimal, j, len, params, ret;
      ret = [];
      args = [];
      curArg = "";
      foundDecimal = false;
      params = 0;
      for (j = 0, len = path.length; j < len; j++) {
        c = path[j];
        if (parameters[c] != null) {
          params = parameters[c];
          if (cmd) {
            if (curArg.length > 0) {
              args[args.length] = +curArg;
            }
            ret[ret.length] = {
              cmd: cmd,
              args: args
            };
            args = [];
            curArg = "";
            foundDecimal = false;
          }
          cmd = c;
        } else if ((c === " " || c === ",") || (c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== 'e') || (c === "." && foundDecimal)) {
          if (curArg.length === 0) {
            continue;
          }
          if (args.length === params) {
            ret[ret.length] = {
              cmd: cmd,
              args: args
            };
            args = [+curArg];
            if (cmd === "M") {
              cmd = "L";
            }
            if (cmd === "m") {
              cmd = "l";
            }
          } else {
            args[args.length] = +curArg;
          }
          foundDecimal = c === ".";
          curArg = c === '-' || c === '.' ? c : '';
        } else {
          curArg += c;
          if (c === '.') {
            foundDecimal = true;
          }
        }
      }
      if (curArg.length > 0) {
        if (args.length === params) {
          ret[ret.length] = {
            cmd: cmd,
            args: args
          };
          args = [+curArg];
          if (cmd === "M") {
            cmd = "L";
          }
          if (cmd === "m") {
            cmd = "l";
          }
        } else {
          args[args.length] = +curArg;
        }
      }
      ret[ret.length] = {
        cmd: cmd,
        args: args
      };
      return ret;
    };

    cx = cy = px = py = sx = sy = 0;

    apply = function(commands, doc) {
      var c, i, j, len, name;
      cx = cy = px = py = sx = sy = 0;
      for (i = j = 0, len = commands.length; j < len; i = ++j) {
        c = commands[i];
        if (typeof runners[name = c.cmd] === "function") {
          runners[name](doc, c.args);
        }
      }
      return cx = cy = px = py = 0;
    };

    runners = {
      M: function(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
      },
      m: function(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
      },
      C: function(doc, a) {
        cx = a[4];
        cy = a[5];
        px = a[2];
        py = a[3];
        return doc.bezierCurveTo.apply(doc, a);
      },
      c: function(doc, a) {
        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
        px = cx + a[2];
        py = cy + a[3];
        cx += a[4];
        return cy += a[5];
      },
      S: function(doc, a) {
        if (px === null) {
          px = cx;
          py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
        px = a[0];
        py = a[1];
        cx = a[2];
        return cy = a[3];
      },
      s: function(doc, a) {
        if (px === null) {
          px = cx;
          py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
      },
      Q: function(doc, a) {
        px = a[0];
        py = a[1];
        cx = a[2];
        cy = a[3];
        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
      },
      q: function(doc, a) {
        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
      },
      T: function(doc, a) {
        if (px === null) {
          px = cx;
          py = cy;
        } else {
          px = cx - (px - cx);
          py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, a[0], a[1]);
        px = cx - (px - cx);
        py = cy - (py - cy);
        cx = a[0];
        return cy = a[1];
      },
      t: function(doc, a) {
        if (px === null) {
          px = cx;
          py = cy;
        } else {
          px = cx - (px - cx);
          py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
        cx += a[0];
        return cy += a[1];
      },
      A: function(doc, a) {
        solveArc(doc, cx, cy, a);
        cx = a[5];
        return cy = a[6];
      },
      a: function(doc, a) {
        a[5] += cx;
        a[6] += cy;
        solveArc(doc, cx, cy, a);
        cx = a[5];
        return cy = a[6];
      },
      L: function(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      l: function(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      H: function(doc, a) {
        cx = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      h: function(doc, a) {
        cx += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      V: function(doc, a) {
        cy = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      v: function(doc, a) {
        cy += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
      },
      Z: function(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
      },
      z: function(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
      }
    };

    solveArc = function(doc, x, y, coords) {
      var bez, ex, ey, j, large, len, results, rot, rx, ry, seg, segs, sweep;
      rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
      segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
      results = [];
      for (j = 0, len = segs.length; j < len; j++) {
        seg = segs[j];
        bez = segmentToBezier.apply(null, seg);
        results.push(doc.bezierCurveTo.apply(doc, bez));
      }
      return results;
    };

    arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
      var a00, a01, a10, a11, cos_th, d, i, j, pl, ref, result, segments, sfactor, sfactor_sq, sin_th, th, th0, th1, th2, th3, th_arc, x0, x1, xc, y0, y1, yc;
      th = rotateX * (Math.PI / 180);
      sin_th = Math.sin(th);
      cos_th = Math.cos(th);
      rx = Math.abs(rx);
      ry = Math.abs(ry);
      px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
      py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
      pl = (px * px) / (rx * rx) + (py * py) / (ry * ry);
      if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
      }
      a00 = cos_th / rx;
      a01 = sin_th / rx;
      a10 = (-sin_th) / ry;
      a11 = cos_th / ry;
      x0 = a00 * ox + a01 * oy;
      y0 = a10 * ox + a11 * oy;
      x1 = a00 * x + a01 * y;
      y1 = a10 * x + a11 * y;
      d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
      sfactor_sq = 1 / d - 0.25;
      if (sfactor_sq < 0) {
        sfactor_sq = 0;
      }
      sfactor = Math.sqrt(sfactor_sq);
      if (sweep === large) {
        sfactor = -sfactor;
      }
      xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
      yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
      th0 = Math.atan2(y0 - yc, x0 - xc);
      th1 = Math.atan2(y1 - yc, x1 - xc);
      th_arc = th1 - th0;
      if (th_arc < 0 && sweep === 1) {
        th_arc += 2 * Math.PI;
      } else if (th_arc > 0 && sweep === 0) {
        th_arc -= 2 * Math.PI;
      }
      segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
      result = [];
      for (i = j = 0, ref = segments; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        th2 = th0 + i * th_arc / segments;
        th3 = th0 + (i + 1) * th_arc / segments;
        result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
      }
      return result;
    };

    segmentToBezier = function(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
      var a00, a01, a10, a11, t, th_half, x1, x2, x3, y1, y2, y3;
      a00 = cos_th * rx;
      a01 = -sin_th * ry;
      a10 = sin_th * rx;
      a11 = cos_th * ry;
      th_half = 0.5 * (th1 - th0);
      t = (8 / 3) * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
      x1 = cx + Math.cos(th0) - t * Math.sin(th0);
      y1 = cy + Math.sin(th0) + t * Math.cos(th0);
      x3 = cx + Math.cos(th1);
      y3 = cy + Math.sin(th1);
      x2 = x3 + t * Math.sin(th1);
      y2 = y3 - t * Math.cos(th1);
      return [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
    };

    return SVGPath;

  })();

  module.exports = SVGPath;

}).call(this);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var PDFFont;

  PDFFont = __webpack_require__(49);

  module.exports = {
    initFonts: function() {
      this._fontFamilies = {};
      this._fontCount = 0;
      this._fontSize = 12;
      this._font = null;
      this._registeredFonts = {};
      
    },
    font: function(src, family, size) {
      var cacheKey, font, id, ref;
      if (typeof family === 'number') {
        size = family;
        family = null;
      }
      if (typeof src === 'string' && this._registeredFonts[src]) {
        cacheKey = src;
        ref = this._registeredFonts[src], src = ref.src, family = ref.family;
      } else {
        cacheKey = family || src;
        if (typeof cacheKey !== 'string') {
          cacheKey = null;
        }
      }
      if (size != null) {
        this.fontSize(size);
      }
      if (font = this._fontFamilies[cacheKey]) {
        this._font = font;
        return this;
      }
      id = 'F' + (++this._fontCount);
      this._font = PDFFont.open(this, src, family, id);
      if (font = this._fontFamilies[this._font.name]) {
        this._font = font;
        return this;
      }
      if (cacheKey) {
        this._fontFamilies[cacheKey] = this._font;
      }
      if (this._font.name) {
        this._fontFamilies[this._font.name] = this._font;
      }
      return this;
    },
    fontSize: function(_fontSize) {
      this._fontSize = _fontSize;
      return this;
    },
    currentLineHeight: function(includeGap) {
      if (includeGap == null) {
        includeGap = false;
      }
      return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont: function(name, src, family) {
      this._registeredFonts[name] = {
        src: src,
        family: family
      };
      return this;
    }
  };

}).call(this);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var r = _interopDefault(__webpack_require__(157));
var _Object$getOwnPropertyDescriptor = _interopDefault(__webpack_require__(186));
var _getIterator = _interopDefault(__webpack_require__(59));
var _Object$freeze = _interopDefault(__webpack_require__(198));
var _Object$keys = _interopDefault(__webpack_require__(201));
var _typeof = _interopDefault(__webpack_require__(67));
var _Object$defineProperty = _interopDefault(__webpack_require__(72));
var _classCallCheck = _interopDefault(__webpack_require__(101));
var _createClass = _interopDefault(__webpack_require__(102));
var _Map = _interopDefault(__webpack_require__(214));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(225));
var _inherits = _interopDefault(__webpack_require__(226));
var restructure_src_utils = __webpack_require__(12);
var _Object$defineProperties = _interopDefault(__webpack_require__(234));
var isEqual = _interopDefault(__webpack_require__(237));
var _Object$assign = _interopDefault(__webpack_require__(240));
var _String$fromCodePoint = _interopDefault(__webpack_require__(244));
var _Array$from = _interopDefault(__webpack_require__(247));
var _Set = _interopDefault(__webpack_require__(252));
var unicode = _interopDefault(__webpack_require__(258));
var UnicodeTrie = _interopDefault(__webpack_require__(74));
var StateMachine = _interopDefault(__webpack_require__(260));
var _Number$EPSILON = _interopDefault(__webpack_require__(269));
var cloneDeep = _interopDefault(__webpack_require__(272));
var inflate = _interopDefault(__webpack_require__(112));
var brotli = _interopDefault(__webpack_require__(273));



var fontkit = {};
fontkit.logErrors = false;

var formats = [];
fontkit.registerFormat = function (format) {
  formats.push(format);
};

fontkit.openSync = function (filename, postscriptName) {
  var buffer = __webpack_require__(9).readFileSync(filename);
  return fontkit.create(buffer, postscriptName);
};

fontkit.open = function (filename, postscriptName, callback) {
  if (typeof postscriptName === 'function') {
    callback = postscriptName;
    postscriptName = null;
  }

  __webpack_require__(9).readFile(filename, function (err, buffer) {
    if (err) {
      return callback(err);
    }

    try {
      var font = fontkit.create(buffer, postscriptName);
    } catch (e) {
      return callback(e);
    }

    return callback(null, font);
  });

  return;
};

fontkit.create = function (buffer, postscriptName) {
  for (var i = 0; i < formats.length; i++) {
    var format = formats[i];
    if (format.probe(buffer)) {
      var font = new format(new r.DecodeStream(buffer));
      if (postscriptName) {
        return font.getFont(postscriptName);
      }

      return font;
    }
  }

  throw new Error('Unknown font format');
};

/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */
function cache(target, key, descriptor) {
  if (descriptor.get) {
    var get = descriptor.get;
    descriptor.get = function () {
      var value = get.call(this);
      _Object$defineProperty(this, key, { value: value });
      return value;
    };
  } else if (typeof descriptor.value === 'function') {
    var fn = descriptor.value;

    return {
      get: function get() {
        var cache = new _Map();
        function memoized() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var key = args.length > 0 ? args[0] : 'value';
          if (cache.has(key)) {
            return cache.get(key);
          }

          var result = fn.apply(this, args);
          cache.set(key, result);
          return result;
        };

        _Object$defineProperty(this, key, { value: memoized });
        return memoized;
      }
    };
  }
}

var SubHeader = new r.Struct({
  firstCode: r.uint16,
  entryCount: r.uint16,
  idDelta: r.int16,
  idRangeOffset: r.uint16
});

var CmapGroup = new r.Struct({
  startCharCode: r.uint32,
  endCharCode: r.uint32,
  glyphID: r.uint32
});

var UnicodeValueRange = new r.Struct({
  startUnicodeValue: r.uint24,
  additionalCount: r.uint8
});

var UVSMapping = new r.Struct({
  unicodeValue: r.uint24,
  glyphID: r.uint16
});

var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);

var VarSelectorRecord = new r.Struct({
  varSelector: r.uint24,
  defaultUVS: new r.Pointer(r.uint32, DefaultUVS, { type: 'parent' }),
  nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, { type: 'parent' })
});

var CmapSubtable = new r.VersionedStruct(r.uint16, {
  0: { // Byte encoding
    length: r.uint16, // Total table length in bytes (set to 262 for format 0)
    language: r.uint16, // Language code for this encoding subtable, or zero if language-independent
    codeMap: new r.LazyArray(r.uint8, 256)
  },

  2: { // High-byte mapping (CJK)
    length: r.uint16,
    language: r.uint16,
    subHeaderKeys: new r.Array(r.uint16, 256),
    subHeaderCount: function subHeaderCount(t) {
      return Math.max.apply(Math, t.subHeaderKeys);
    },
    subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
    glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount')
  },

  4: { // Segment mapping to delta values
    length: r.uint16, // Total table length in bytes
    language: r.uint16, // Language code
    segCountX2: r.uint16,
    segCount: function segCount(t) {
      return t.segCountX2 >> 1;
    },
    searchRange: r.uint16,
    entrySelector: r.uint16,
    rangeShift: r.uint16,
    endCode: new r.LazyArray(r.uint16, 'segCount'),
    reservedPad: new r.Reserved(r.uint16), // This value should be zero
    startCode: new r.LazyArray(r.uint16, 'segCount'),
    idDelta: new r.LazyArray(r.int16, 'segCount'),
    idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
    glyphIndexArray: new r.LazyArray(r.uint16, function (t) {
      return (t.length - t._currentOffset) / 2;
    })
  },

  6: { // Trimmed table
    length: r.uint16,
    language: r.uint16,
    firstCode: r.uint16,
    entryCount: r.uint16,
    glyphIndices: new r.LazyArray(r.uint16, 'entryCount')
  },

  8: { // mixed 16-bit and 32-bit coverage
    reserved: new r.Reserved(r.uint16),
    length: r.uint32,
    language: r.uint16,
    is32: new r.LazyArray(r.uint8, 8192),
    nGroups: r.uint32,
    groups: new r.LazyArray(CmapGroup, 'nGroups')
  },

  10: { // Trimmed Array
    reserved: new r.Reserved(r.uint16),
    length: r.uint32,
    language: r.uint32,
    firstCode: r.uint32,
    entryCount: r.uint32,
    glyphIndices: new r.LazyArray(r.uint16, 'numChars')
  },

  12: { // Segmented coverage
    reserved: new r.Reserved(r.uint16),
    length: r.uint32,
    language: r.uint32,
    nGroups: r.uint32,
    groups: new r.LazyArray(CmapGroup, 'nGroups')
  },

  13: { // Many-to-one range mappings (same as 12 except for group.startGlyphID)
    reserved: new r.Reserved(r.uint16),
    length: r.uint32,
    language: r.uint32,
    nGroups: r.uint32,
    groups: new r.LazyArray(CmapGroup, 'nGroups')
  },

  14: { // Unicode Variation Sequences
    length: r.uint32,
    numRecords: r.uint32,
    varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords')
  }
});

var CmapEntry = new r.Struct({
  platformID: r.uint16, // Platform identifier
  encodingID: r.uint16, // Platform-specific encoding identifier
  table: new r.Pointer(r.uint32, CmapSubtable, { type: 'parent', lazy: true })
});

// character to glyph mapping
var cmap = new r.Struct({
  version: r.uint16,
  numSubtables: r.uint16,
  tables: new r.Array(CmapEntry, 'numSubtables')
});

// font header
var head = new r.Struct({
  version: r.int32, // 0x00010000 (version 1.0)
  revision: r.int32, // set by font manufacturer
  checkSumAdjustment: r.uint32,
  magicNumber: r.uint32, // set to 0x5F0F3CF5
  flags: r.uint16,
  unitsPerEm: r.uint16, // range from 64 to 16384
  created: new r.Array(r.int32, 2),
  modified: new r.Array(r.int32, 2),
  xMin: r.int16, // for all glyph bounding boxes
  yMin: r.int16, // for all glyph bounding boxes
  xMax: r.int16, // for all glyph bounding boxes
  yMax: r.int16, // for all glyph bounding boxes
  macStyle: new r.Bitfield(r.uint16, ['bold', 'italic', 'underline', 'outline', 'shadow', 'condensed', 'extended']),
  lowestRecPPEM: r.uint16, // smallest readable size in pixels
  fontDirectionHint: r.int16,
  indexToLocFormat: r.int16, // 0 for short offsets, 1 for long
  glyphDataFormat: r.int16 // 0 for current format
});

// horizontal header
var hhea = new r.Struct({
  version: r.int32,
  ascent: r.int16, // Distance from baseline of highest ascender
  descent: r.int16, // Distance from baseline of lowest descender
  lineGap: r.int16, // Typographic line gap
  advanceWidthMax: r.uint16, // Maximum advance width value in 'hmtx' table
  minLeftSideBearing: r.int16, // Maximum advance width value in 'hmtx' table
  minRightSideBearing: r.int16, // Minimum right sidebearing value
  xMaxExtent: r.int16,
  caretSlopeRise: r.int16, // Used to calculate the slope of the cursor (rise/run); 1 for vertical
  caretSlopeRun: r.int16, // 0 for vertical
  caretOffset: r.int16, // Set to 0 for non-slanted fonts
  reserved: new r.Reserved(r.int16, 4),
  metricDataFormat: r.int16, // 0 for current format
  numberOfMetrics: r.uint16 // Number of advance widths in 'hmtx' table
});

var HmtxEntry = new r.Struct({
  advance: r.uint16,
  bearing: r.int16
});

var hmtx = new r.Struct({
  metrics: new r.LazyArray(HmtxEntry, function (t) {
    return t.parent.hhea.numberOfMetrics;
  }),
  bearings: new r.LazyArray(r.int16, function (t) {
    return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
  })
});

// maxiumum profile
var maxp = new r.Struct({
  version: r.int32,
  numGlyphs: r.uint16, // The number of glyphs in the font
  maxPoints: r.uint16, // Maximum points in a non-composite glyph
  maxContours: r.uint16, // Maximum contours in a non-composite glyph
  maxComponentPoints: r.uint16, // Maximum points in a composite glyph
  maxComponentContours: r.uint16, // Maximum contours in a composite glyph
  maxZones: r.uint16, // 1 if instructions do not use the twilight zone, 2 otherwise
  maxTwilightPoints: r.uint16, // Maximum points used in Z0
  maxStorage: r.uint16, // Number of Storage Area locations
  maxFunctionDefs: r.uint16, // Number of FDEFs
  maxInstructionDefs: r.uint16, // Number of IDEFs
  maxStackElements: r.uint16, // Maximum stack depth
  maxSizeOfInstructions: r.uint16, // Maximum byte count for glyph instructions
  maxComponentElements: r.uint16, // Maximum number of components referenced at “top level” for any composite glyph
  maxComponentDepth: r.uint16 // Maximum levels of recursion; 1 for simple components
});

/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */
function getEncoding(platformID, encodingID) {
  var languageID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
    return MAC_LANGUAGE_ENCODINGS[languageID];
  }

  return ENCODINGS[platformID][encodingID];
}

// Map of platform ids to encoding ids.
var ENCODINGS = [
// unicode
['utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be'],

// macintosh
// Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
// 0	Roman                 17	Malayalam
// 1	Japanese	            18	Sinhalese
// 2	Traditional Chinese	  19	Burmese
// 3	Korean	              20	Khmer
// 4	Arabic	              21	Thai
// 5	Hebrew	              22	Laotian
// 6	Greek	                23	Georgian
// 7	Russian	              24	Armenian
// 8	RSymbol	              25	Simplified Chinese
// 9	Devanagari	          26	Tibetan
// 10	Gurmukhi	            27	Mongolian
// 11	Gujarati	            28	Geez
// 12	Oriya	                29	Slavic
// 13	Bengali	              30	Vietnamese
// 14	Tamil	                31	Sindhi
// 15	Telugu	              32	(Uninterpreted)
// 16	Kannada
['macroman', 'shift-jis', 'big5', 'euc-kr', 'iso-8859-6', 'iso-8859-8', 'macgreek', 'maccyrillic', 'symbol', 'Devanagari', 'Gurmukhi', 'Gujarati', 'Oriya', 'Bengali', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Sinhalese', 'Burmese', 'Khmer', 'macthai', 'Laotian', 'Georgian', 'Armenian', 'gb-2312-80', 'Tibetan', 'Mongolian', 'Geez', 'maccenteuro', 'Vietnamese', 'Sindhi'],

// ISO (deprecated)
['ascii'],

// windows
// Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
['symbol', 'utf16be', 'shift-jis', 'gb18030', 'big5', 'wansung', 'johab', null, null, null, 'utf16be']];

// Overrides for Mac scripts by language id.
// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var MAC_LANGUAGE_ENCODINGS = {
  15: 'maciceland',
  17: 'macturkish',
  18: 'maccroatian',
  24: 'maccenteuro',
  25: 'maccenteuro',
  26: 'maccenteuro',
  27: 'maccenteuro',
  28: 'maccenteuro',
  30: 'maciceland',
  37: 'macromania',
  38: 'maccenteuro',
  39: 'maccenteuro',
  40: 'maccenteuro',
  143: 'macinuit', // Unsupported by iconv-lite
  146: 'macgaelic' // Unsupported by iconv-lite
};

// Map of platform ids to BCP-47 language codes.
var LANGUAGES = [
// unicode
[], { // macintosh
  0: 'en', 30: 'fo', 60: 'ks', 90: 'rw',
  1: 'fr', 31: 'fa', 61: 'ku', 91: 'rn',
  2: 'de', 32: 'ru', 62: 'sd', 92: 'ny',
  3: 'it', 33: 'zh', 63: 'bo', 93: 'mg',
  4: 'nl', 34: 'nl-BE', 64: 'ne', 94: 'eo',
  5: 'sv', 35: 'ga', 65: 'sa', 128: 'cy',
  6: 'es', 36: 'sq', 66: 'mr', 129: 'eu',
  7: 'da', 37: 'ro', 67: 'bn', 130: 'ca',
  8: 'pt', 38: 'cz', 68: 'as', 131: 'la',
  9: 'no', 39: 'sk', 69: 'gu', 132: 'qu',
  10: 'he', 40: 'si', 70: 'pa', 133: 'gn',
  11: 'ja', 41: 'yi', 71: 'or', 134: 'ay',
  12: 'ar', 42: 'sr', 72: 'ml', 135: 'tt',
  13: 'fi', 43: 'mk', 73: 'kn', 136: 'ug',
  14: 'el', 44: 'bg', 74: 'ta', 137: 'dz',
  15: 'is', 45: 'uk', 75: 'te', 138: 'jv',
  16: 'mt', 46: 'be', 76: 'si', 139: 'su',
  17: 'tr', 47: 'uz', 77: 'my', 140: 'gl',
  18: 'hr', 48: 'kk', 78: 'km', 141: 'af',
  19: 'zh-Hant', 49: 'az-Cyrl', 79: 'lo', 142: 'br',
  20: 'ur', 50: 'az-Arab', 80: 'vi', 143: 'iu',
  21: 'hi', 51: 'hy', 81: 'id', 144: 'gd',
  22: 'th', 52: 'ka', 82: 'tl', 145: 'gv',
  23: 'ko', 53: 'mo', 83: 'ms', 146: 'ga',
  24: 'lt', 54: 'ky', 84: 'ms-Arab', 147: 'to',
  25: 'pl', 55: 'tg', 85: 'am', 148: 'el-polyton',
  26: 'hu', 56: 'tk', 86: 'ti', 149: 'kl',
  27: 'es', 57: 'mn-CN', 87: 'om', 150: 'az',
  28: 'lv', 58: 'mn', 88: 'so', 151: 'nn',
  29: 'se', 59: 'ps', 89: 'sw'
},

// ISO (deprecated)
[], { // windows                                        
  0x0436: 'af', 0x4009: 'en-IN', 0x0487: 'rw', 0x0432: 'tn',
  0x041C: 'sq', 0x1809: 'en-IE', 0x0441: 'sw', 0x045B: 'si',
  0x0484: 'gsw', 0x2009: 'en-JM', 0x0457: 'kok', 0x041B: 'sk',
  0x045E: 'am', 0x4409: 'en-MY', 0x0412: 'ko', 0x0424: 'sl',
  0x1401: 'ar-DZ', 0x1409: 'en-NZ', 0x0440: 'ky', 0x2C0A: 'es-AR',
  0x3C01: 'ar-BH', 0x3409: 'en-PH', 0x0454: 'lo', 0x400A: 'es-BO',
  0x0C01: 'ar', 0x4809: 'en-SG', 0x0426: 'lv', 0x340A: 'es-CL',
  0x0801: 'ar-IQ', 0x1C09: 'en-ZA', 0x0427: 'lt', 0x240A: 'es-CO',
  0x2C01: 'ar-JO', 0x2C09: 'en-TT', 0x082E: 'dsb', 0x140A: 'es-CR',
  0x3401: 'ar-KW', 0x0809: 'en-GB', 0x046E: 'lb', 0x1C0A: 'es-DO',
  0x3001: 'ar-LB', 0x0409: 'en', 0x042F: 'mk', 0x300A: 'es-EC',
  0x1001: 'ar-LY', 0x3009: 'en-ZW', 0x083E: 'ms-BN', 0x440A: 'es-SV',
  0x1801: 'ary', 0x0425: 'et', 0x043E: 'ms', 0x100A: 'es-GT',
  0x2001: 'ar-OM', 0x0438: 'fo', 0x044C: 'ml', 0x480A: 'es-HN',
  0x4001: 'ar-QA', 0x0464: 'fil', 0x043A: 'mt', 0x080A: 'es-MX',
  0x0401: 'ar-SA', 0x040B: 'fi', 0x0481: 'mi', 0x4C0A: 'es-NI',
  0x2801: 'ar-SY', 0x080C: 'fr-BE', 0x047A: 'arn', 0x180A: 'es-PA',
  0x1C01: 'aeb', 0x0C0C: 'fr-CA', 0x044E: 'mr', 0x3C0A: 'es-PY',
  0x3801: 'ar-AE', 0x040C: 'fr', 0x047C: 'moh', 0x280A: 'es-PE',
  0x2401: 'ar-YE', 0x140C: 'fr-LU', 0x0450: 'mn', 0x500A: 'es-PR',
  0x042B: 'hy', 0x180C: 'fr-MC', 0x0850: 'mn-CN', 0x0C0A: 'es',
  0x044D: 'as', 0x100C: 'fr-CH', 0x0461: 'ne', 0x040A: 'es',
  0x082C: 'az-Cyrl', 0x0462: 'fy', 0x0414: 'nb', 0x540A: 'es-US',
  0x042C: 'az', 0x0456: 'gl', 0x0814: 'nn', 0x380A: 'es-UY',
  0x046D: 'ba', 0x0437: 'ka', 0x0482: 'oc', 0x200A: 'es-VE',
  0x042D: 'eu', 0x0C07: 'de-AT', 0x0448: 'or', 0x081D: 'sv-FI',
  0x0423: 'be', 0x0407: 'de', 0x0463: 'ps', 0x041D: 'sv',
  0x0845: 'bn', 0x1407: 'de-LI', 0x0415: 'pl', 0x045A: 'syr',
  0x0445: 'bn-IN', 0x1007: 'de-LU', 0x0416: 'pt', 0x0428: 'tg',
  0x201A: 'bs-Cyrl', 0x0807: 'de-CH', 0x0816: 'pt-PT', 0x085F: 'tzm',
  0x141A: 'bs', 0x0408: 'el', 0x0446: 'pa', 0x0449: 'ta',
  0x047E: 'br', 0x046F: 'kl', 0x046B: 'qu-BO', 0x0444: 'tt',
  0x0402: 'bg', 0x0447: 'gu', 0x086B: 'qu-EC', 0x044A: 'te',
  0x0403: 'ca', 0x0468: 'ha', 0x0C6B: 'qu', 0x041E: 'th',
  0x0C04: 'zh-HK', 0x040D: 'he', 0x0418: 'ro', 0x0451: 'bo',
  0x1404: 'zh-MO', 0x0439: 'hi', 0x0417: 'rm', 0x041F: 'tr',
  0x0804: 'zh', 0x040E: 'hu', 0x0419: 'ru', 0x0442: 'tk',
  0x1004: 'zh-SG', 0x040F: 'is', 0x243B: 'smn', 0x0480: 'ug',
  0x0404: 'zh-TW', 0x0470: 'ig', 0x103B: 'smj-NO', 0x0422: 'uk',
  0x0483: 'co', 0x0421: 'id', 0x143B: 'smj', 0x042E: 'hsb',
  0x041A: 'hr', 0x045D: 'iu', 0x0C3B: 'se-FI', 0x0420: 'ur',
  0x101A: 'hr-BA', 0x085D: 'iu-Latn', 0x043B: 'se', 0x0843: 'uz-Cyrl',
  0x0405: 'cs', 0x083C: 'ga', 0x083B: 'se-SE', 0x0443: 'uz',
  0x0406: 'da', 0x0434: 'xh', 0x203B: 'sms', 0x042A: 'vi',
  0x048C: 'prs', 0x0435: 'zu', 0x183B: 'sma-NO', 0x0452: 'cy',
  0x0465: 'dv', 0x0410: 'it', 0x1C3B: 'sms', 0x0488: 'wo',
  0x0813: 'nl-BE', 0x0810: 'it-CH', 0x044F: 'sa', 0x0485: 'sah',
  0x0413: 'nl', 0x0411: 'ja', 0x1C1A: 'sr-Cyrl-BA', 0x0478: 'ii',
  0x0C09: 'en-AU', 0x044B: 'kn', 0x0C1A: 'sr', 0x046A: 'yo',
  0x2809: 'en-BZ', 0x043F: 'kk', 0x181A: 'sr-Latn-BA',
  0x1009: 'en-CA', 0x0453: 'km', 0x081A: 'sr-Latn',
  0x2409: 'en-029', 0x0486: 'quc', 0x046C: 'nso'
}];

var NameRecord = new r.Struct({
  platformID: r.uint16,
  encodingID: r.uint16,
  languageID: r.uint16,
  nameID: r.uint16,
  length: r.uint16,
  string: new r.Pointer(r.uint16, new r.String('length', function (t) {
    return getEncoding(t.platformID, t.encodingID, t.languageID);
  }), { type: 'parent', relativeTo: 'parent.stringOffset', allowNull: false })
});

var LangTagRecord = new r.Struct({
  length: r.uint16,
  tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), { type: 'parent', relativeTo: 'stringOffset' })
});

var NameTable = new r.VersionedStruct(r.uint16, {
  0: {
    count: r.uint16,
    stringOffset: r.uint16,
    records: new r.Array(NameRecord, 'count')
  },
  1: {
    count: r.uint16,
    stringOffset: r.uint16,
    records: new r.Array(NameRecord, 'count'),
    langTagCount: r.uint16,
    langTags: new r.Array(LangTagRecord, 'langTagCount')
  }
});

var NAMES = ['copyright', 'fontFamily', 'fontSubfamily', 'uniqueSubfamily', 'fullName', 'version', 'postscriptName', // Note: A font may have only one PostScript name and that name must be ASCII.
'trademark', 'manufacturer', 'designer', 'description', 'vendorURL', 'designerURL', 'license', 'licenseURL', null, // reserved
'preferredFamily', 'preferredSubfamily', 'compatibleFull', 'sampleText', 'postscriptCIDFontName', 'wwsFamilyName', 'wwsSubfamilyName'];

NameTable.process = function (stream) {
  var records = {};
  for (var _iterator = this.records, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var record = _ref;

    // find out what language this is for
    var language = LANGUAGES[record.platformID][record.languageID];

    if (language == null && this.langTags != null && record.languageID >= 0x8000) {
      language = this.langTags[record.languageID - 0x8000].tag;
    }

    if (language == null) {
      language = record.platformID + '-' + record.languageID;
    }

    // if the nameID is >= 256, it is a font feature record (AAT)
    var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
    if (records[key] == null) {
      records[key] = {};
    }

    var obj = records[key];
    if (record.nameID >= 256) {
      obj = obj[record.nameID] || (obj[record.nameID] = {});
    }

    if (typeof record.string === 'string' || typeof obj[language] !== 'string') {
      obj[language] = record.string;
    }
  }

  this.records = records;
};

NameTable.preEncode = function () {
  if (Array.isArray(this.records)) return;
  this.version = 0;

  var records = [];
  for (var key in this.records) {
    var val = this.records[key];
    if (key === 'fontFeatures') continue;

    records.push({
      platformID: 3,
      encodingID: 1,
      languageID: 0x409,
      nameID: NAMES.indexOf(key),
      length: Buffer.byteLength(val.en, 'utf16le'),
      string: val.en
    });

    if (key === 'postscriptName') {
      records.push({
        platformID: 1,
        encodingID: 0,
        languageID: 0,
        nameID: NAMES.indexOf(key),
        length: val.en.length,
        string: val.en
      });
    }
  }

  this.records = records;
  this.count = records.length;
  this.stringOffset = NameTable.size(this, null, false);
};

var OS2 = new r.VersionedStruct(r.uint16, {
  header: {
    xAvgCharWidth: r.int16, // average weighted advance width of lower case letters and space
    usWeightClass: r.uint16, // visual weight of stroke in glyphs
    usWidthClass: r.uint16, // relative change from the normal aspect ratio (width to height ratio)
    fsType: new r.Bitfield(r.uint16, [// Indicates font embedding licensing rights
    null, 'noEmbedding', 'viewOnly', 'editable', null, null, null, null, 'noSubsetting', 'bitmapOnly']),
    ySubscriptXSize: r.int16, // recommended horizontal size in pixels for subscripts
    ySubscriptYSize: r.int16, // recommended vertical size in pixels for subscripts
    ySubscriptXOffset: r.int16, // recommended horizontal offset for subscripts
    ySubscriptYOffset: r.int16, // recommended vertical offset form the baseline for subscripts
    ySuperscriptXSize: r.int16, // recommended horizontal size in pixels for superscripts
    ySuperscriptYSize: r.int16, // recommended vertical size in pixels for superscripts
    ySuperscriptXOffset: r.int16, // recommended horizontal offset for superscripts
    ySuperscriptYOffset: r.int16, // recommended vertical offset from the baseline for superscripts
    yStrikeoutSize: r.int16, // width of the strikeout stroke
    yStrikeoutPosition: r.int16, // position of the strikeout stroke relative to the baseline
    sFamilyClass: r.int16, // classification of font-family design
    panose: new r.Array(r.uint8, 10), // describe the visual characteristics of a given typeface
    ulCharRange: new r.Array(r.uint32, 4),
    vendorID: new r.String(4), // four character identifier for the font vendor
    fsSelection: new r.Bitfield(r.uint16, [// bit field containing information about the font
    'italic', 'underscore', 'negative', 'outlined', 'strikeout', 'bold', 'regular', 'useTypoMetrics', 'wws', 'oblique']),
    usFirstCharIndex: r.uint16, // The minimum Unicode index in this font
    usLastCharIndex: r.uint16 // The maximum Unicode index in this font
  },

  // The Apple version of this table ends here, but the Microsoft one continues on...
  0: {},

  1: {
    typoAscender: r.int16,
    typoDescender: r.int16,
    typoLineGap: r.int16,
    winAscent: r.uint16,
    winDescent: r.uint16,
    codePageRange: new r.Array(r.uint32, 2)
  },

  2: {
    // these should be common with version 1 somehow
    typoAscender: r.int16,
    typoDescender: r.int16,
    typoLineGap: r.int16,
    winAscent: r.uint16,
    winDescent: r.uint16,
    codePageRange: new r.Array(r.uint32, 2),

    xHeight: r.int16,
    capHeight: r.int16,
    defaultChar: r.uint16,
    breakChar: r.uint16,
    maxContent: r.uint16
  },

  5: {
    typoAscender: r.int16,
    typoDescender: r.int16,
    typoLineGap: r.int16,
    winAscent: r.uint16,
    winDescent: r.uint16,
    codePageRange: new r.Array(r.uint32, 2),

    xHeight: r.int16,
    capHeight: r.int16,
    defaultChar: r.uint16,
    breakChar: r.uint16,
    maxContent: r.uint16,

    usLowerOpticalPointSize: r.uint16,
    usUpperOpticalPointSize: r.uint16
  }
});

var versions = OS2.versions;
versions[3] = versions[4] = versions[2];

// PostScript information
var post = new r.VersionedStruct(r.fixed32, {
  header: { // these fields exist at the top of all versions
    italicAngle: r.fixed32, // Italic angle in counter-clockwise degrees from the vertical.
    underlinePosition: r.int16, // Suggested distance of the top of the underline from the baseline
    underlineThickness: r.int16, // Suggested values for the underline thickness
    isFixedPitch: r.uint32, // Whether the font is monospaced
    minMemType42: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
    maxMemType42: r.uint32, // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
    minMemType1: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
    maxMemType1: r.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
  },

  1: {}, // version 1 has no additional fields

  2: {
    numberOfGlyphs: r.uint16,
    glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
    names: new r.Array(new r.String(r.uint8))
  },

  2.5: {
    numberOfGlyphs: r.uint16,
    offsets: new r.Array(r.uint8, 'numberOfGlyphs')
  },

  3: {}, // version 3 has no additional fields

  4: {
    map: new r.Array(r.uint32, function (t) {
      return t.parent.maxp.numGlyphs;
    })
  }
});

// An array of predefined values accessible by instructions
var cvt = new r.Struct({
  controlValues: new r.Array(r.int16)
});

// A list of instructions that are executed once when a font is first used.
// These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
var fpgm = new r.Struct({
  instructions: new r.Array(r.uint8)
});

var loca = new r.VersionedStruct('head.indexToLocFormat', {
  0: {
    offsets: new r.Array(r.uint16)
  },
  1: {
    offsets: new r.Array(r.uint32)
  }
});

loca.process = function () {
  if (this.version === 0) {
    for (var i = 0; i < this.offsets.length; i++) {
      this.offsets[i] <<= 1;
    }
  }
};

loca.preEncode = function () {
  if (this.version != null) return;

  // assume this.offsets is a sorted array
  this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;

  if (this.version === 0) {
    for (var i = 0; i < this.offsets.length; i++) {
      this.offsets[i] >>>= 1;
    }
  }
};

// Set of instructions executed whenever the point size or font transformation change
var prep = new r.Struct({
  controlValueProgram: new r.Array(r.uint8)
});

// only used for encoding
var glyf = new r.Array(new r.Buffer());

var CFFIndex = function () {
  function CFFIndex(type) {
    _classCallCheck(this, CFFIndex);

    this.type = type;
  }

  CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
    while (ctx && !ctx.hdrSize) {
      ctx = ctx.parent;
    }

    return ctx ? ctx.version : -1;
  };

  CFFIndex.prototype.decode = function decode(stream, parent) {
    var version = this.getCFFVersion(parent);
    var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();

    if (count === 0) {
      return [];
    }

    var offSize = stream.readUInt8();
    var offsetType = void 0;
    if (offSize === 1) {
      offsetType = r.uint8;
    } else if (offSize === 2) {
      offsetType = r.uint16;
    } else if (offSize === 3) {
      offsetType = r.uint24;
    } else if (offSize === 4) {
      offsetType = r.uint32;
    } else {
      throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
    }

    var ret = [];
    var startPos = stream.pos + (count + 1) * offSize - 1;

    var start = offsetType.decode(stream);
    for (var i = 0; i < count; i++) {
      var end = offsetType.decode(stream);

      if (this.type != null) {
        var pos = stream.pos;
        stream.pos = startPos + start;

        parent.length = end - start;
        ret.push(this.type.decode(stream, parent));
        stream.pos = pos;
      } else {
        ret.push({
          offset: startPos + start,
          length: end - start
        });
      }

      start = end;
    }

    stream.pos = startPos + start;
    return ret;
  };

  CFFIndex.prototype.size = function size(arr, parent) {
    var size = 2;
    if (arr.length === 0) {
      return size;
    }

    var type = this.type || new r.Buffer();

    // find maximum offset to detminine offset type
    var offset = 1;
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      offset += type.size(item, parent);
    }

    var offsetType = void 0;
    if (offset <= 0xff) {
      offsetType = r.uint8;
    } else if (offset <= 0xffff) {
      offsetType = r.uint16;
    } else if (offset <= 0xffffff) {
      offsetType = r.uint24;
    } else if (offset <= 0xffffffff) {
      offsetType = r.uint32;
    } else {
      throw new Error("Bad offset in CFFIndex");
    }

    size += 1 + offsetType.size() * (arr.length + 1);
    size += offset - 1;

    return size;
  };

  CFFIndex.prototype.encode = function encode(stream, arr, parent) {
    stream.writeUInt16BE(arr.length);
    if (arr.length === 0) {
      return;
    }

    var type = this.type || new r.Buffer();

    // find maximum offset to detminine offset type
    var sizes = [];
    var offset = 1;
    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var item = _ref;

      var s = type.size(item, parent);
      sizes.push(s);
      offset += s;
    }

    var offsetType = void 0;
    if (offset <= 0xff) {
      offsetType = r.uint8;
    } else if (offset <= 0xffff) {
      offsetType = r.uint16;
    } else if (offset <= 0xffffff) {
      offsetType = r.uint24;
    } else if (offset <= 0xffffffff) {
      offsetType = r.uint32;
    } else {
      throw new Error("Bad offset in CFFIndex");
    }

    // write offset size
    stream.writeUInt8(offsetType.size());

    // write elements
    offset = 1;
    offsetType.encode(stream, offset);

    for (var _iterator2 = sizes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var size = _ref2;

      offset += size;
      offsetType.encode(stream, offset);
    }

    for (var _iterator3 = arr, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var _item = _ref3;

      type.encode(stream, _item, parent);
    }

    return;
  };

  return CFFIndex;
}();

var FLOAT_EOF = 0xf;
var FLOAT_LOOKUP = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];

var FLOAT_ENCODE_LOOKUP = {
  '.': 10,
  'E': 11,
  'E-': 12,
  '-': 14
};

var CFFOperand = function () {
  function CFFOperand() {
    _classCallCheck(this, CFFOperand);
  }

  CFFOperand.decode = function decode(stream, value) {
    if (32 <= value && value <= 246) {
      return value - 139;
    }

    if (247 <= value && value <= 250) {
      return (value - 247) * 256 + stream.readUInt8() + 108;
    }

    if (251 <= value && value <= 254) {
      return -(value - 251) * 256 - stream.readUInt8() - 108;
    }

    if (value === 28) {
      return stream.readInt16BE();
    }

    if (value === 29) {
      return stream.readInt32BE();
    }

    if (value === 30) {
      var str = '';
      while (true) {
        var b = stream.readUInt8();

        var n1 = b >> 4;
        if (n1 === FLOAT_EOF) {
          break;
        }
        str += FLOAT_LOOKUP[n1];

        var n2 = b & 15;
        if (n2 === FLOAT_EOF) {
          break;
        }
        str += FLOAT_LOOKUP[n2];
      }

      return parseFloat(str);
    }

    return null;
  };

  CFFOperand.size = function size(value) {
    // if the value needs to be forced to the largest size (32 bit)
    // e.g. for unknown pointers, set to 32768
    if (value.forceLarge) {
      value = 32768;
    }

    if ((value | 0) !== value) {
      // floating point
      var str = '' + value;
      return 1 + Math.ceil((str.length + 1) / 2);
    } else if (-107 <= value && value <= 107) {
      return 1;
    } else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) {
      return 2;
    } else if (-32768 <= value && value <= 32767) {
      return 3;
    } else {
      return 5;
    }
  };

  CFFOperand.encode = function encode(stream, value) {
    // if the value needs to be forced to the largest size (32 bit)
    // e.g. for unknown pointers, save the old value and set to 32768
    var val = Number(value);

    if (value.forceLarge) {
      stream.writeUInt8(29);
      return stream.writeInt32BE(val);
    } else if ((val | 0) !== val) {
      // floating point
      stream.writeUInt8(30);

      var str = '' + val;
      for (var i = 0; i < str.length; i += 2) {
        var c1 = str[i];
        var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;

        if (i === str.length - 1) {
          var n2 = FLOAT_EOF;
        } else {
          var c2 = str[i + 1];
          var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
        }

        stream.writeUInt8(n1 << 4 | n2 & 15);
      }

      if (n2 !== FLOAT_EOF) {
        return stream.writeUInt8(FLOAT_EOF << 4);
      }
    } else if (-107 <= val && val <= 107) {
      return stream.writeUInt8(val + 139);
    } else if (108 <= val && val <= 1131) {
      val -= 108;
      stream.writeUInt8((val >> 8) + 247);
      return stream.writeUInt8(val & 0xff);
    } else if (-1131 <= val && val <= -108) {
      val = -val - 108;
      stream.writeUInt8((val >> 8) + 251);
      return stream.writeUInt8(val & 0xff);
    } else if (-32768 <= val && val <= 32767) {
      stream.writeUInt8(28);
      return stream.writeInt16BE(val);
    } else {
      stream.writeUInt8(29);
      return stream.writeInt32BE(val);
    }
  };

  return CFFOperand;
}();

var CFFDict = function () {
  function CFFDict() {
    var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, CFFDict);

    this.ops = ops;
    this.fields = {};
    for (var _iterator = ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var field = _ref;

      var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
      this.fields[key] = field;
    }
  }

  CFFDict.prototype.decodeOperands = function decodeOperands(type, stream, ret, operands) {
    var _this = this;

    if (Array.isArray(type)) {
      return operands.map(function (op, i) {
        return _this.decodeOperands(type[i], stream, ret, [op]);
      });
    } else if (type.decode != null) {
      return type.decode(stream, ret, operands);
    } else {
      switch (type) {
        case 'number':
        case 'offset':
        case 'sid':
          return operands[0];
        case 'boolean':
          return !!operands[0];
        default:
          return operands;
      }
    }
  };

  CFFDict.prototype.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
    var _this2 = this;

    if (Array.isArray(type)) {
      return operands.map(function (op, i) {
        return _this2.encodeOperands(type[i], stream, ctx, op)[0];
      });
    } else if (type.encode != null) {
      return type.encode(stream, operands, ctx);
    } else if (typeof operands === 'number') {
      return [operands];
    } else if (typeof operands === 'boolean') {
      return [+operands];
    } else if (Array.isArray(operands)) {
      return operands;
    } else {
      return [operands];
    }
  };

  CFFDict.prototype.decode = function decode(stream, parent) {
    var end = stream.pos + parent.length;
    var ret = {};
    var operands = [];

    // define hidden properties
    _Object$defineProperties(ret, {
      parent: { value: parent },
      _startOffset: { value: stream.pos }
    });

    // fill in defaults
    for (var key in this.fields) {
      var field = this.fields[key];
      ret[field[1]] = field[3];
    }

    while (stream.pos < end) {
      var b = stream.readUInt8();
      if (b < 28) {
        if (b === 12) {
          b = b << 8 | stream.readUInt8();
        }

        var _field = this.fields[b];
        if (!_field) {
          throw new Error('Unknown operator ' + b);
        }

        var val = this.decodeOperands(_field[2], stream, ret, operands);
        if (val != null) {
          if (val instanceof restructure_src_utils.PropertyDescriptor) {
            _Object$defineProperty(ret, _field[1], val);
          } else {
            ret[_field[1]] = val;
          }
        }

        operands = [];
      } else {
        operands.push(CFFOperand.decode(stream, b));
      }
    }

    return ret;
  };

  CFFDict.prototype.size = function size(dict, parent) {
    var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var ctx = {
      parent: parent,
      val: dict,
      pointerSize: 0,
      startOffset: parent.startOffset || 0
    };

    var len = 0;

    for (var k in this.fields) {
      var field = this.fields[k];
      var val = dict[field[1]];
      if (val == null || isEqual(val, field[3])) {
        continue;
      }

      var operands = this.encodeOperands(field[2], null, ctx, val);
      for (var _iterator2 = operands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var op = _ref2;

        len += CFFOperand.size(op);
      }

      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
      len += key.length;
    }

    if (includePointers) {
      len += ctx.pointerSize;
    }

    return len;
  };

  CFFDict.prototype.encode = function encode(stream, dict, parent) {
    var ctx = {
      pointers: [],
      startOffset: stream.pos,
      parent: parent,
      val: dict,
      pointerSize: 0
    };

    ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);

    for (var _iterator3 = this.ops, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var field = _ref3;

      var val = dict[field[1]];
      if (val == null || isEqual(val, field[3])) {
        continue;
      }

      var operands = this.encodeOperands(field[2], stream, ctx, val);
      for (var _iterator4 = operands, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var op = _ref4;

        CFFOperand.encode(stream, op);
      }

      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
      for (var _iterator5 = key, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var _op = _ref5;

        stream.writeUInt8(_op);
      }
    }

    var i = 0;
    while (i < ctx.pointers.length) {
      var ptr = ctx.pointers[i++];
      ptr.type.encode(stream, ptr.val, ptr.parent);
    }

    return;
  };

  return CFFDict;
}();

var CFFPointer = function (_r$Pointer) {
  _inherits(CFFPointer, _r$Pointer);

  function CFFPointer(type) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, CFFPointer);

    if (options.type == null) {
      options.type = 'global';
    }

    return _possibleConstructorReturn(this, _r$Pointer.call(this, null, type, options));
  }

  CFFPointer.prototype.decode = function decode(stream, parent, operands) {
    this.offsetType = {
      decode: function decode() {
        return operands[0];
      }
    };

    return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
  };

  CFFPointer.prototype.encode = function encode(stream, value, ctx) {
    if (!stream) {
      // compute the size (so ctx.pointerSize is correct)
      this.offsetType = {
        size: function size() {
          return 0;
        }
      };

      this.size(value, ctx);
      return [new Ptr(0)];
    }

    var ptr = null;
    this.offsetType = {
      encode: function encode(stream, val) {
        return ptr = val;
      }
    };

    _r$Pointer.prototype.encode.call(this, stream, value, ctx);
    return [new Ptr(ptr)];
  };

  return CFFPointer;
}(r.Pointer);

var Ptr = function () {
  function Ptr(val) {
    _classCallCheck(this, Ptr);

    this.val = val;
    this.forceLarge = true;
  }

  Ptr.prototype.valueOf = function valueOf() {
    return this.val;
  };

  return Ptr;
}();

var CFFBlendOp = function () {
  function CFFBlendOp() {
    _classCallCheck(this, CFFBlendOp);
  }

  CFFBlendOp.decode = function decode(stream, parent, operands) {
    var numBlends = operands.pop();

    // TODO: actually blend. For now just consume the deltas
    // since we don't use any of the values anyway.
    while (operands.length > numBlends) {
      operands.pop();
    }
  };

  return CFFBlendOp;
}();

var CFFPrivateDict = new CFFDict([
// key       name                    type                                          default
[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'number', 0.039625], [[12, 10], 'BlueShift', 'number', 7], [[12, 11], 'BlueFuzz', 'number', 1], [10, 'StdHW', 'number', null], [11, 'StdVW', 'number', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'boolean', false], [[12, 17], 'LanguageGroup', 'number', 0], [[12, 18], 'ExpansionFactor', 'number', 0.06], [[12, 19], 'initialRandomSeed', 'number', 0], [20, 'defaultWidthX', 'number', 0], [21, 'nominalWidthX', 'number', 0], [22, 'vsindex', 'number', 0], [23, 'blend', CFFBlendOp, null], [19, 'Subrs', new CFFPointer(new CFFIndex(), { type: 'local' }), null]]);

// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var standardStrings = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];

var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];

var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];

var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];

//########################
// Scripts and Languages #
//########################

var LangSysTable = new r.Struct({
  reserved: new r.Reserved(r.uint16),
  reqFeatureIndex: r.uint16,
  featureCount: r.uint16,
  featureIndexes: new r.Array(r.uint16, 'featureCount')
});

var LangSysRecord = new r.Struct({
  tag: new r.String(4),
  langSys: new r.Pointer(r.uint16, LangSysTable, { type: 'parent' })
});

var Script = new r.Struct({
  defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
  count: r.uint16,
  langSysRecords: new r.Array(LangSysRecord, 'count')
});

var ScriptRecord = new r.Struct({
  tag: new r.String(4),
  script: new r.Pointer(r.uint16, Script, { type: 'parent' })
});

var ScriptList = new r.Array(ScriptRecord, r.uint16);

//#######################
// Features and Lookups #
//#######################

var Feature = new r.Struct({
  featureParams: r.uint16, // pointer
  lookupCount: r.uint16,
  lookupListIndexes: new r.Array(r.uint16, 'lookupCount')
});

var FeatureRecord = new r.Struct({
  tag: new r.String(4),
  feature: new r.Pointer(r.uint16, Feature, { type: 'parent' })
});

var FeatureList = new r.Array(FeatureRecord, r.uint16);

var LookupFlags = new r.Struct({
  markAttachmentType: r.uint8,
  flags: new r.Bitfield(r.uint8, ['rightToLeft', 'ignoreBaseGlyphs', 'ignoreLigatures', 'ignoreMarks', 'useMarkFilteringSet'])
});

function LookupList(SubTable) {
  var Lookup = new r.Struct({
    lookupType: r.uint16,
    flags: LookupFlags,
    subTableCount: r.uint16,
    subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
    markFilteringSet: new r.Optional(r.uint16, function (t) {
      return t.flags.flags.useMarkFilteringSet;
    })
  });

  return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
}

//#################
// Coverage Table #
//#################

var RangeRecord = new r.Struct({
  start: r.uint16,
  end: r.uint16,
  startCoverageIndex: r.uint16
});

var Coverage = new r.VersionedStruct(r.uint16, {
  1: {
    glyphCount: r.uint16,
    glyphs: new r.Array(r.uint16, 'glyphCount')
  },
  2: {
    rangeCount: r.uint16,
    rangeRecords: new r.Array(RangeRecord, 'rangeCount')
  }
});

//#########################
// Class Definition Table #
//#########################

var ClassRangeRecord = new r.Struct({
  start: r.uint16,
  end: r.uint16,
  class: r.uint16
});

var ClassDef = new r.VersionedStruct(r.uint16, {
  1: { // Class array
    startGlyph: r.uint16,
    glyphCount: r.uint16,
    classValueArray: new r.Array(r.uint16, 'glyphCount')
  },
  2: { // Class ranges
    classRangeCount: r.uint16,
    classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount')
  }
});

//###############
// Device Table #
//###############

var Device = new r.Struct({
  a: r.uint16, // startSize for hinting Device, outerIndex for VariationIndex
  b: r.uint16, // endSize for Device, innerIndex for VariationIndex
  deltaFormat: r.uint16
});

//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################

var LookupRecord = new r.Struct({
  sequenceIndex: r.uint16,
  lookupListIndex: r.uint16
});

var Rule = new r.Struct({
  glyphCount: r.uint16,
  lookupCount: r.uint16,
  input: new r.Array(r.uint16, function (t) {
    return t.glyphCount - 1;
  }),
  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
});

var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);

var ClassRule = new r.Struct({
  glyphCount: r.uint16,
  lookupCount: r.uint16,
  classes: new r.Array(r.uint16, function (t) {
    return t.glyphCount - 1;
  }),
  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
});

var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);

var Context = new r.VersionedStruct(r.uint16, {
  1: { // Simple context
    coverage: new r.Pointer(r.uint16, Coverage),
    ruleSetCount: r.uint16,
    ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount')
  },
  2: { // Class-based context
    coverage: new r.Pointer(r.uint16, Coverage),
    classDef: new r.Pointer(r.uint16, ClassDef),
    classSetCnt: r.uint16,
    classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt')
  },
  3: {
    glyphCount: r.uint16,
    lookupCount: r.uint16,
    coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
  }
});

//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################

var ChainRule = new r.Struct({
  backtrackGlyphCount: r.uint16,
  backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
  inputGlyphCount: r.uint16,
  input: new r.Array(r.uint16, function (t) {
    return t.inputGlyphCount - 1;
  }),
  lookaheadGlyphCount: r.uint16,
  lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
  lookupCount: r.uint16,
  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
});

var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);

var ChainingContext = new r.VersionedStruct(r.uint16, {
  1: { // Simple context glyph substitution
    coverage: new r.Pointer(r.uint16, Coverage),
    chainCount: r.uint16,
    chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
  },

  2: { // Class-based chaining context
    coverage: new r.Pointer(r.uint16, Coverage),
    backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
    inputClassDef: new r.Pointer(r.uint16, ClassDef),
    lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
    chainCount: r.uint16,
    chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
  },

  3: { // Coverage-based chaining context
    backtrackGlyphCount: r.uint16,
    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
    inputGlyphCount: r.uint16,
    inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
    lookaheadGlyphCount: r.uint16,
    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
    lookupCount: r.uint16,
    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
  }
});

var _;

/*******************
 * Variation Store *
 *******************/

var F2DOT14 = new r.Fixed(16, 'BE', 14);
var RegionAxisCoordinates = new r.Struct({
  startCoord: F2DOT14,
  peakCoord: F2DOT14,
  endCoord: F2DOT14
});

var VariationRegionList = new r.Struct({
  axisCount: r.uint16,
  regionCount: r.uint16,
  variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
});

var DeltaSet = new r.Struct({
  shortDeltas: new r.Array(r.int16, function (t) {
    return t.parent.shortDeltaCount;
  }),
  regionDeltas: new r.Array(r.int8, function (t) {
    return t.parent.regionIndexCount - t.parent.shortDeltaCount;
  }),
  deltas: function deltas(t) {
    return t.shortDeltas.concat(t.regionDeltas);
  }
});

var ItemVariationData = new r.Struct({
  itemCount: r.uint16,
  shortDeltaCount: r.uint16,
  regionIndexCount: r.uint16,
  regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
  deltaSets: new r.Array(DeltaSet, 'itemCount')
});

var ItemVariationStore = new r.Struct({
  format: r.uint16,
  variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
  variationDataCount: r.uint16,
  itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount')
});

/**********************
 * Feature Variations *
 **********************/

var ConditionTable = new r.VersionedStruct(r.uint16, {
  1: (_ = {
    axisIndex: r.uint16
  }, _['axisIndex'] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
});

var ConditionSet = new r.Struct({
  conditionCount: r.uint16,
  conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount')
});

var FeatureTableSubstitutionRecord = new r.Struct({
  featureIndex: r.uint16,
  alternateFeatureTable: new r.Pointer(r.uint32, Feature, { type: 'parent' })
});

var FeatureTableSubstitution = new r.Struct({
  version: r.fixed32,
  substitutionCount: r.uint16,
  substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount')
});

var FeatureVariationRecord = new r.Struct({
  conditionSet: new r.Pointer(r.uint32, ConditionSet, { type: 'parent' }),
  featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, { type: 'parent' })
});

var FeatureVariations = new r.Struct({
  majorVersion: r.uint16,
  minorVersion: r.uint16,
  featureVariationRecordCount: r.uint32,
  featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount')
});

// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.

var PredefinedOp = function () {
  function PredefinedOp(predefinedOps, type) {
    _classCallCheck(this, PredefinedOp);

    this.predefinedOps = predefinedOps;
    this.type = type;
  }

  PredefinedOp.prototype.decode = function decode(stream, parent, operands) {
    if (this.predefinedOps[operands[0]]) {
      return this.predefinedOps[operands[0]];
    }

    return this.type.decode(stream, parent, operands);
  };

  PredefinedOp.prototype.size = function size(value, ctx) {
    return this.type.size(value, ctx);
  };

  PredefinedOp.prototype.encode = function encode(stream, value, ctx) {
    var index = this.predefinedOps.indexOf(value);
    if (index !== -1) {
      return index;
    }

    return this.type.encode(stream, value, ctx);
  };

  return PredefinedOp;
}();

var CFFEncodingVersion = function (_r$Number) {
  _inherits(CFFEncodingVersion, _r$Number);

  function CFFEncodingVersion() {
    _classCallCheck(this, CFFEncodingVersion);

    return _possibleConstructorReturn(this, _r$Number.call(this, 'UInt8'));
  }

  CFFEncodingVersion.prototype.decode = function decode(stream) {
    return r.uint8.decode(stream) & 0x7f;
  };

  return CFFEncodingVersion;
}(r.Number);

var Range1 = new r.Struct({
  first: r.uint16,
  nLeft: r.uint8
});

var Range2 = new r.Struct({
  first: r.uint16,
  nLeft: r.uint16
});

var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
  0: {
    nCodes: r.uint8,
    codes: new r.Array(r.uint8, 'nCodes')
  },

  1: {
    nRanges: r.uint8,
    ranges: new r.Array(Range1, 'nRanges')
  }

  // TODO: supplement?
});

var CFFEncoding = new PredefinedOp([StandardEncoding, ExpertEncoding], new CFFPointer(CFFCustomEncoding, { lazy: true }));

// Decodes an array of ranges until the total
// length is equal to the provided length.

var RangeArray = function (_r$Array) {
  _inherits(RangeArray, _r$Array);

  function RangeArray() {
    _classCallCheck(this, RangeArray);

    return _possibleConstructorReturn(this, _r$Array.apply(this, arguments));
  }

  RangeArray.prototype.decode = function decode(stream, parent) {
    var length = restructure_src_utils.resolveLength(this.length, stream, parent);
    var count = 0;
    var res = [];
    while (count < length) {
      var range = this.type.decode(stream, parent);
      range.offset = count;
      count += range.nLeft + 1;
      res.push(range);
    }

    return res;
  };

  return RangeArray;
}(r.Array);

var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
  0: {
    glyphs: new r.Array(r.uint16, function (t) {
      return t.parent.CharStrings.length - 1;
    })
  },

  1: {
    ranges: new RangeArray(Range1, function (t) {
      return t.parent.CharStrings.length - 1;
    })
  },

  2: {
    ranges: new RangeArray(Range2, function (t) {
      return t.parent.CharStrings.length - 1;
    })
  }
});

var CFFCharset = new PredefinedOp([ISOAdobeCharset, ExpertCharset, ExpertSubsetCharset], new CFFPointer(CFFCustomCharset, { lazy: true }));

var FDRange3 = new r.Struct({
  first: r.uint16,
  fd: r.uint8
});

var FDRange4 = new r.Struct({
  first: r.uint32,
  fd: r.uint16
});

var FDSelect = new r.VersionedStruct(r.uint8, {
  0: {
    fds: new r.Array(r.uint8, function (t) {
      return t.parent.CharStrings.length;
    })
  },

  3: {
    nRanges: r.uint16,
    ranges: new r.Array(FDRange3, 'nRanges'),
    sentinel: r.uint16
  },

  4: {
    nRanges: r.uint32,
    ranges: new r.Array(FDRange4, 'nRanges'),
    sentinel: r.uint32
  }
});

var ptr = new CFFPointer(CFFPrivateDict);

var CFFPrivateOp = function () {
  function CFFPrivateOp() {
    _classCallCheck(this, CFFPrivateOp);
  }

  CFFPrivateOp.prototype.decode = function decode(stream, parent, operands) {
    parent.length = operands[0];
    return ptr.decode(stream, parent, [operands[1]]);
  };

  CFFPrivateOp.prototype.size = function size(dict, ctx) {
    return [CFFPrivateDict.size(dict, ctx, false), ptr.size(dict, ctx)[0]];
  };

  CFFPrivateOp.prototype.encode = function encode(stream, dict, ctx) {
    return [CFFPrivateDict.size(dict, ctx, false), ptr.encode(stream, dict, ctx)[0]];
  };

  return CFFPrivateOp;
}();

var FontDict = new CFFDict([
// key       name                   type(s)                                 default
[18, 'Private', new CFFPrivateOp(), null], [[12, 38], 'FontName', 'sid', null]]);

var CFFTopDict = new CFFDict([
// key       name                   type(s)                                 default
[[12, 30], 'ROS', ['sid', 'sid', 'number'], null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'boolean', false], [[12, 2], 'ItalicAngle', 'number', 0], [[12, 3], 'UnderlinePosition', 'number', -100], [[12, 4], 'UnderlineThickness', 'number', 50], [[12, 5], 'PaintType', 'number', 0], [[12, 6], 'CharstringType', 'number', 2], [[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'number', null], [5, 'FontBBox', 'array', [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'number', 0], [14, 'XUID', 'array', null], [15, 'charset', CFFCharset, ISOAdobeCharset], [16, 'Encoding', CFFEncoding, StandardEncoding], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [18, 'Private', new CFFPrivateOp(), null], [[12, 20], 'SyntheticBase', 'number', null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null],

// CID font specific
[[12, 31], 'CIDFontVersion', 'number', 0], [[12, 32], 'CIDFontRevision', 'number', 0], [[12, 33], 'CIDFontType', 'number', 0], [[12, 34], 'CIDCount', 'number', 8720], [[12, 35], 'UIDBase', 'number', null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [[12, 38], 'FontName', 'sid', null]]);

var VariationStore = new r.Struct({
  length: r.uint16,
  itemVariationStore: ItemVariationStore
});

var CFF2TopDict = new CFFDict([[[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [24, 'vstore', new CFFPointer(VariationStore), null], [25, 'maxstack', 'number', 193]]);

var CFFTop = new r.VersionedStruct(r.fixed16, {
  1: {
    hdrSize: r.uint8,
    offSize: r.uint8,
    nameIndex: new CFFIndex(new r.String('length')),
    topDictIndex: new CFFIndex(CFFTopDict),
    stringIndex: new CFFIndex(new r.String('length')),
    globalSubrIndex: new CFFIndex()
  },

  2: {
    hdrSize: r.uint8,
    length: r.uint16,
    topDict: CFF2TopDict,
    globalSubrIndex: new CFFIndex()
  }
});

var CFFFont = function () {
  function CFFFont(stream) {
    _classCallCheck(this, CFFFont);

    this.stream = stream;
    this.decode();
  }

  CFFFont.decode = function decode(stream) {
    return new CFFFont(stream);
  };

  CFFFont.prototype.decode = function decode() {
    var start = this.stream.pos;
    var top = CFFTop.decode(this.stream);
    for (var key in top) {
      var val = top[key];
      this[key] = val;
    }

    if (this.version < 2) {
      if (this.topDictIndex.length !== 1) {
        throw new Error("Only a single font is allowed in CFF");
      }

      this.topDict = this.topDictIndex[0];
    }

    this.isCIDFont = this.topDict.ROS != null;
    return this;
  };

  CFFFont.prototype.string = function string(sid) {
    if (this.version >= 2) {
      return null;
    }

    if (sid < standardStrings.length) {
      return standardStrings[sid];
    }

    return this.stringIndex[sid - standardStrings.length];
  };

  CFFFont.prototype.getCharString = function getCharString(glyph) {
    this.stream.pos = this.topDict.CharStrings[glyph].offset;
    return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
  };

  CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
    // CFF2 glyph names are in the post table.
    if (this.version >= 2) {
      return null;
    }

    // CID-keyed fonts don't have glyph names
    if (this.isCIDFont) {
      return null;
    }

    var charset = this.topDict.charset;

    if (Array.isArray(charset)) {
      return charset[gid];
    }

    if (gid === 0) {
      return '.notdef';
    }

    gid -= 1;

    switch (charset.version) {
      case 0:
        return this.string(charset.glyphs[gid]);

      case 1:
      case 2:
        for (var i = 0; i < charset.ranges.length; i++) {
          var range = charset.ranges[i];
          if (range.offset <= gid && gid <= range.offset + range.nLeft) {
            return this.string(range.first + (gid - range.offset));
          }
        }
        break;
    }

    return null;
  };

  CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
    if (!this.topDict.FDSelect) {
      return null;
    }

    switch (this.topDict.FDSelect.version) {
      case 0:
        return this.topDict.FDSelect.fds[gid];

      case 3:
      case 4:
        var ranges = this.topDict.FDSelect.ranges;

        var low = 0;
        var high = ranges.length - 1;

        while (low <= high) {
          var mid = low + high >> 1;

          if (gid < ranges[mid].first) {
            high = mid - 1;
          } else if (mid < high && gid > ranges[mid + 1].first) {
            low = mid + 1;
          } else {
            return ranges[mid].fd;
          }
        }
      default:
        throw new Error('Unknown FDSelect version: ' + this.topDict.FDSelect.version);
    }
  };

  CFFFont.prototype.privateDictForGlyph = function privateDictForGlyph(gid) {
    if (this.topDict.FDSelect) {
      var fd = this.fdForGlyph(gid);
      if (this.topDict.FDArray[fd]) {
        return this.topDict.FDArray[fd].Private;
      }

      return null;
    }

    if (this.version < 2) {
      return this.topDict.Private;
    }

    return this.topDict.FDArray[0].Private;
  };

  _createClass(CFFFont, [{
    key: 'postscriptName',
    get: function get() {
      if (this.version < 2) {
        return this.nameIndex[0];
      }

      return null;
    }
  }, {
    key: 'fullName',
    get: function get() {
      return this.string(this.topDict.FullName);
    }
  }, {
    key: 'familyName',
    get: function get() {
      return this.string(this.topDict.FamilyName);
    }
  }]);

  return CFFFont;
}();

var VerticalOrigin = new r.Struct({
  glyphIndex: r.uint16,
  vertOriginY: r.int16
});

var VORG = new r.Struct({
  majorVersion: r.uint16,
  minorVersion: r.uint16,
  defaultVertOriginY: r.int16,
  numVertOriginYMetrics: r.uint16,
  metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics')
});

var BigMetrics = new r.Struct({
  height: r.uint8,
  width: r.uint8,
  horiBearingX: r.int8,
  horiBearingY: r.int8,
  horiAdvance: r.uint8,
  vertBearingX: r.int8,
  vertBearingY: r.int8,
  vertAdvance: r.uint8
});

var SmallMetrics = new r.Struct({
  height: r.uint8,
  width: r.uint8,
  bearingX: r.int8,
  bearingY: r.int8,
  advance: r.uint8
});

var EBDTComponent = new r.Struct({
  glyph: r.uint16,
  xOffset: r.int8,
  yOffset: r.int8
});

var ByteAligned = function ByteAligned() {
  _classCallCheck(this, ByteAligned);
};

var BitAligned = function BitAligned() {
  _classCallCheck(this, BitAligned);
};

var glyph = new r.VersionedStruct('version', {
  1: {
    metrics: SmallMetrics,
    data: ByteAligned
  },

  2: {
    metrics: SmallMetrics,
    data: BitAligned
  },

  // format 3 is deprecated
  // format 4 is not supported by Microsoft

  5: {
    data: BitAligned
  },

  6: {
    metrics: BigMetrics,
    data: ByteAligned
  },

  7: {
    metrics: BigMetrics,
    data: BitAligned
  },

  8: {
    metrics: SmallMetrics,
    pad: new r.Reserved(r.uint8),
    numComponents: r.uint16,
    components: new r.Array(EBDTComponent, 'numComponents')
  },

  9: {
    metrics: BigMetrics,
    pad: new r.Reserved(r.uint8),
    numComponents: r.uint16,
    components: new r.Array(EBDTComponent, 'numComponents')
  },

  17: {
    metrics: SmallMetrics,
    dataLen: r.uint32,
    data: new r.Buffer('dataLen')
  },

  18: {
    metrics: BigMetrics,
    dataLen: r.uint32,
    data: new r.Buffer('dataLen')
  },

  19: {
    dataLen: r.uint32,
    data: new r.Buffer('dataLen')
  }
});

var SBitLineMetrics = new r.Struct({
  ascender: r.int8,
  descender: r.int8,
  widthMax: r.uint8,
  caretSlopeNumerator: r.int8,
  caretSlopeDenominator: r.int8,
  caretOffset: r.int8,
  minOriginSB: r.int8,
  minAdvanceSB: r.int8,
  maxBeforeBL: r.int8,
  minAfterBL: r.int8,
  pad: new r.Reserved(r.int8, 2)
});

var CodeOffsetPair = new r.Struct({
  glyphCode: r.uint16,
  offset: r.uint16
});

var IndexSubtable = new r.VersionedStruct(r.uint16, {
  header: {
    imageFormat: r.uint16,
    imageDataOffset: r.uint32
  },

  1: {
    offsetArray: new r.Array(r.uint32, function (t) {
      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
    })
  },

  2: {
    imageSize: r.uint32,
    bigMetrics: BigMetrics
  },

  3: {
    offsetArray: new r.Array(r.uint16, function (t) {
      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
    })
  },

  4: {
    numGlyphs: r.uint32,
    glyphArray: new r.Array(CodeOffsetPair, function (t) {
      return t.numGlyphs + 1;
    })
  },

  5: {
    imageSize: r.uint32,
    bigMetrics: BigMetrics,
    numGlyphs: r.uint32,
    glyphCodeArray: new r.Array(r.uint16, 'numGlyphs')
  }
});

var IndexSubtableArray = new r.Struct({
  firstGlyphIndex: r.uint16,
  lastGlyphIndex: r.uint16,
  subtable: new r.Pointer(r.uint32, IndexSubtable)
});

var BitmapSizeTable = new r.Struct({
  indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), { type: 'parent' }),
  indexTablesSize: r.uint32,
  numberOfIndexSubTables: r.uint32,
  colorRef: r.uint32,
  hori: SBitLineMetrics,
  vert: SBitLineMetrics,
  startGlyphIndex: r.uint16,
  endGlyphIndex: r.uint16,
  ppemX: r.uint8,
  ppemY: r.uint8,
  bitDepth: r.uint8,
  flags: new r.Bitfield(r.uint8, ['horizontal', 'vertical'])
});

var EBLC = new r.Struct({
  version: r.uint32, // 0x00020000
  numSizes: r.uint32,
  sizes: new r.Array(BitmapSizeTable, 'numSizes')
});

var ImageTable = new r.Struct({
  ppem: r.uint16,
  resolution: r.uint16,
  imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), function (t) {
    return t.parent.parent.maxp.numGlyphs + 1;
  })
});

// This is the Apple sbix table, used by the "Apple Color Emoji" font.
// It includes several image tables with images for each bitmap glyph
// of several different sizes.
var sbix = new r.Struct({
  version: r.uint16,
  flags: new r.Bitfield(r.uint16, ['renderOutlines']),
  numImgTables: r.uint32,
  imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables')
});

var LayerRecord = new r.Struct({
  gid: r.uint16, // Glyph ID of layer glyph (must be in z-order from bottom to top).
  paletteIndex: r.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.

var BaseGlyphRecord = new r.Struct({
  gid: r.uint16, // Glyph ID of reference glyph. This glyph is for reference only
  // and is not rendered for color.
  firstLayerIndex: r.uint16, // Index (from beginning of the Layer Records) to the layer record.
  // There will be numLayers consecutive entries for this base glyph.
  numLayers: r.uint16
});

var COLR = new r.Struct({
  version: r.uint16,
  numBaseGlyphRecords: r.uint16,
  baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
  layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), { lazy: true }),
  numLayerRecords: r.uint16
});

var ColorRecord = new r.Struct({
  blue: r.uint8,
  green: r.uint8,
  red: r.uint8,
  alpha: r.uint8
});

var CPAL = new r.VersionedStruct(r.uint16, {
  header: {
    numPaletteEntries: r.uint16,
    numPalettes: r.uint16,
    numColorRecords: r.uint16,
    colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
    colorRecordIndices: new r.Array(r.uint16, 'numPalettes')
  },
  0: {},
  1: {
    offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
    offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
    offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries'))
  }
});

var BaseCoord = new r.VersionedStruct(r.uint16, {
  1: { // Design units only
    coordinate: r.int16 // X or Y value, in design units
  },

  2: { // Design units plus contour point
    coordinate: r.int16, // X or Y value, in design units
    referenceGlyph: r.uint16, // GlyphID of control glyph
    baseCoordPoint: r.uint16 // Index of contour point on the referenceGlyph
  },

  3: { // Design units plus Device table
    coordinate: r.int16, // X or Y value, in design units
    deviceTable: new r.Pointer(r.uint16, Device) // Device table for X or Y value
  }
});

var BaseValues = new r.Struct({
  defaultIndex: r.uint16, // Index of default baseline for this script-same index in the BaseTagList
  baseCoordCount: r.uint16,
  baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount')
});

var FeatMinMaxRecord = new r.Struct({
  tag: new r.String(4), // 4-byte feature identification tag-must match FeatureTag in FeatureList
  minCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }), // May be NULL
  maxCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }) // May be NULL
});

var MinMax = new r.Struct({
  minCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
  maxCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
  featMinMaxCount: r.uint16, // May be 0
  featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});

var BaseLangSysRecord = new r.Struct({
  tag: new r.String(4), // 4-byte language system identification tag
  minMax: new r.Pointer(r.uint16, MinMax, { type: 'parent' })
});

var BaseScript = new r.Struct({
  baseValues: new r.Pointer(r.uint16, BaseValues), // May be NULL
  defaultMinMax: new r.Pointer(r.uint16, MinMax), // May be NULL
  baseLangSysCount: r.uint16, // May be 0
  baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});

var BaseScriptRecord = new r.Struct({
  tag: new r.String(4), // 4-byte script identification tag
  script: new r.Pointer(r.uint16, BaseScript, { type: 'parent' })
});

var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16);

// Array of 4-byte baseline identification tags-must be in alphabetical order
var BaseTagList = new r.Array(new r.String(4), r.uint16);

var Axis = new r.Struct({
  baseTagList: new r.Pointer(r.uint16, BaseTagList), // May be NULL
  baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
});

var BASE = new r.VersionedStruct(r.uint32, {
  header: {
    horizAxis: new r.Pointer(r.uint16, Axis), // May be NULL
    vertAxis: new r.Pointer(r.uint16, Axis) // May be NULL
  },

  0x00010000: {},
  0x00010001: {
    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
  }
});

var AttachPoint = new r.Array(r.uint16, r.uint16);
var AttachList = new r.Struct({
  coverage: new r.Pointer(r.uint16, Coverage),
  glyphCount: r.uint16,
  attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount')
});

var CaretValue = new r.VersionedStruct(r.uint16, {
  1: { // Design units only
    coordinate: r.int16
  },

  2: { // Contour point
    caretValuePoint: r.uint16
  },

  3: { // Design units plus Device table
    coordinate: r.int16,
    deviceTable: new r.Pointer(r.uint16, Device)
  }
});

var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);

var LigCaretList = new r.Struct({
  coverage: new r.Pointer(r.uint16, Coverage),
  ligGlyphCount: r.uint16,
  ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount')
});

var MarkGlyphSetsDef = new r.Struct({
  markSetTableFormat: r.uint16,
  markSetCount: r.uint16,
  coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount')
});

var GDEF = new r.VersionedStruct(r.uint32, {
  header: {
    glyphClassDef: new r.Pointer(r.uint16, ClassDef),
    attachList: new r.Pointer(r.uint16, AttachList),
    ligCaretList: new r.Pointer(r.uint16, LigCaretList),
    markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
  },

  0x00010000: {},
  0x00010002: {
    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef)
  },
  0x00010003: {
    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
  }
});

var ValueFormat = new r.Bitfield(r.uint16, ['xPlacement', 'yPlacement', 'xAdvance', 'yAdvance', 'xPlaDevice', 'yPlaDevice', 'xAdvDevice', 'yAdvDevice']);

var types = {
  xPlacement: r.int16,
  yPlacement: r.int16,
  xAdvance: r.int16,
  yAdvance: r.int16,
  xPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
  yPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
  xAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
  yAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' })
};

var ValueRecord = function () {
  function ValueRecord() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valueFormat';

    _classCallCheck(this, ValueRecord);

    this.key = key;
  }

  ValueRecord.prototype.buildStruct = function buildStruct(parent) {
    var struct = parent;
    while (!struct[this.key] && struct.parent) {
      struct = struct.parent;
    }

    if (!struct[this.key]) return;

    var fields = {};
    fields.rel = function () {
      return struct._startOffset;
    };

    var format = struct[this.key];
    for (var key in format) {
      if (format[key]) {
        fields[key] = types[key];
      }
    }

    return new r.Struct(fields);
  };

  ValueRecord.prototype.size = function size(val, ctx) {
    return this.buildStruct(ctx).size(val, ctx);
  };

  ValueRecord.prototype.decode = function decode(stream, parent) {
    var res = this.buildStruct(parent).decode(stream, parent);
    delete res.rel;
    return res;
  };

  return ValueRecord;
}();

var PairValueRecord = new r.Struct({
  secondGlyph: r.uint16,
  value1: new ValueRecord('valueFormat1'),
  value2: new ValueRecord('valueFormat2')
});

var PairSet = new r.Array(PairValueRecord, r.uint16);

var Class2Record = new r.Struct({
  value1: new ValueRecord('valueFormat1'),
  value2: new ValueRecord('valueFormat2')
});

var Anchor = new r.VersionedStruct(r.uint16, {
  1: { // Design units only
    xCoordinate: r.int16,
    yCoordinate: r.int16
  },

  2: { // Design units plus contour point
    xCoordinate: r.int16,
    yCoordinate: r.int16,
    anchorPoint: r.uint16
  },

  3: { // Design units plus Device tables
    xCoordinate: r.int16,
    yCoordinate: r.int16,
    xDeviceTable: new r.Pointer(r.uint16, Device),
    yDeviceTable: new r.Pointer(r.uint16, Device)
  }
});

var EntryExitRecord = new r.Struct({
  entryAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' }),
  exitAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
});

var MarkRecord = new r.Struct({
  class: r.uint16,
  markAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
});

var MarkArray = new r.Array(MarkRecord, r.uint16);

var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
  return t.parent.classCount;
});
var BaseArray = new r.Array(BaseRecord, r.uint16);

var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
  return t.parent.parent.classCount;
});
var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);

var GPOSLookup = new r.VersionedStruct('lookupType', {
  1: new r.VersionedStruct(r.uint16, { // Single Adjustment
    1: { // Single positioning value
      coverage: new r.Pointer(r.uint16, Coverage),
      valueFormat: ValueFormat,
      value: new ValueRecord()
    },
    2: {
      coverage: new r.Pointer(r.uint16, Coverage),
      valueFormat: ValueFormat,
      valueCount: r.uint16,
      values: new r.LazyArray(new ValueRecord(), 'valueCount')
    }
  }),

  2: new r.VersionedStruct(r.uint16, { // Pair Adjustment Positioning
    1: { // Adjustments for glyph pairs
      coverage: new r.Pointer(r.uint16, Coverage),
      valueFormat1: ValueFormat,
      valueFormat2: ValueFormat,
      pairSetCount: r.uint16,
      pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount')
    },

    2: { // Class pair adjustment
      coverage: new r.Pointer(r.uint16, Coverage),
      valueFormat1: ValueFormat,
      valueFormat2: ValueFormat,
      classDef1: new r.Pointer(r.uint16, ClassDef),
      classDef2: new r.Pointer(r.uint16, ClassDef),
      class1Count: r.uint16,
      class2Count: r.uint16,
      classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count')
    }
  }),

  3: { // Cursive Attachment Positioning
    format: r.uint16,
    coverage: new r.Pointer(r.uint16, Coverage),
    entryExitCount: r.uint16,
    entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount')
  },

  4: { // MarkToBase Attachment Positioning
    format: r.uint16,
    markCoverage: new r.Pointer(r.uint16, Coverage),
    baseCoverage: new r.Pointer(r.uint16, Coverage),
    classCount: r.uint16,
    markArray: new r.Pointer(r.uint16, MarkArray),
    baseArray: new r.Pointer(r.uint16, BaseArray)
  },

  5: { // MarkToLigature Attachment Positioning
    format: r.uint16,
    markCoverage: new r.Pointer(r.uint16, Coverage),
    ligatureCoverage: new r.Pointer(r.uint16, Coverage),
    classCount: r.uint16,
    markArray: new r.Pointer(r.uint16, MarkArray),
    ligatureArray: new r.Pointer(r.uint16, LigatureArray)
  },

  6: { // MarkToMark Attachment Positioning
    format: r.uint16,
    mark1Coverage: new r.Pointer(r.uint16, Coverage),
    mark2Coverage: new r.Pointer(r.uint16, Coverage),
    classCount: r.uint16,
    mark1Array: new r.Pointer(r.uint16, MarkArray),
    mark2Array: new r.Pointer(r.uint16, BaseArray)
  },

  7: Context, // Contextual positioning
  8: ChainingContext, // Chaining contextual positioning

  9: { // Extension Positioning
    posFormat: r.uint16,
    lookupType: r.uint16, // cannot also be 9
    extension: new r.Pointer(r.uint32, GPOSLookup)
  }
});

// Fix circular reference
GPOSLookup.versions[9].extension.type = GPOSLookup;

var GPOS = new r.VersionedStruct(r.uint32, {
  header: {
    scriptList: new r.Pointer(r.uint16, ScriptList),
    featureList: new r.Pointer(r.uint16, FeatureList),
    lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
  },

  0x00010000: {},
  0x00010001: {
    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
  }
});

var Sequence = new r.Array(r.uint16, r.uint16);
var AlternateSet = Sequence;

var Ligature = new r.Struct({
  glyph: r.uint16,
  compCount: r.uint16,
  components: new r.Array(r.uint16, function (t) {
    return t.compCount - 1;
  })
});

var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);

var GSUBLookup = new r.VersionedStruct('lookupType', {
  1: new r.VersionedStruct(r.uint16, { // Single Substitution
    1: {
      coverage: new r.Pointer(r.uint16, Coverage),
      deltaGlyphID: r.int16
    },
    2: {
      coverage: new r.Pointer(r.uint16, Coverage),
      glyphCount: r.uint16,
      substitute: new r.LazyArray(r.uint16, 'glyphCount')
    }
  }),

  2: { // Multiple Substitution
    substFormat: r.uint16,
    coverage: new r.Pointer(r.uint16, Coverage),
    count: r.uint16,
    sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count')
  },

  3: { // Alternate Substitution
    substFormat: r.uint16,
    coverage: new r.Pointer(r.uint16, Coverage),
    count: r.uint16,
    alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count')
  },

  4: { // Ligature Substitution
    substFormat: r.uint16,
    coverage: new r.Pointer(r.uint16, Coverage),
    count: r.uint16,
    ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count')
  },

  5: Context, // Contextual Substitution
  6: ChainingContext, // Chaining Contextual Substitution

  7: { // Extension Substitution
    substFormat: r.uint16,
    lookupType: r.uint16, // cannot also be 7
    extension: new r.Pointer(r.uint32, GSUBLookup)
  },

  8: { // Reverse Chaining Contextual Single Substitution
    substFormat: r.uint16,
    coverage: new r.Pointer(r.uint16, Coverage),
    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
    lookaheadGlyphCount: r.uint16,
    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
    glyphCount: r.uint16,
    substitutes: new r.Array(r.uint16, 'glyphCount')
  }
});

// Fix circular reference
GSUBLookup.versions[7].extension.type = GSUBLookup;

var GSUB = new r.VersionedStruct(r.uint32, {
  header: {
    scriptList: new r.Pointer(r.uint16, ScriptList),
    featureList: new r.Pointer(r.uint16, FeatureList),
    lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
  },

  0x00010000: {},
  0x00010001: {
    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
  }
});

var JstfGSUBModList = new r.Array(r.uint16, r.uint16);

var JstfPriority = new r.Struct({
  shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
  shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
  shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
  shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
  shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
  extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
  extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
  extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
  extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
  extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
});

var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);

var JstfLangSysRecord = new r.Struct({
  tag: new r.String(4),
  jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
});

var JstfScript = new r.Struct({
  extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)), // array of glyphs to extend line length
  defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
  langSysCount: r.uint16,
  langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount')
});

var JstfScriptRecord = new r.Struct({
  tag: new r.String(4),
  script: new r.Pointer(r.uint16, JstfScript, { type: 'parent' })
});

var JSTF = new r.Struct({
  version: r.uint32, // should be 0x00010000
  scriptCount: r.uint16,
  scriptList: new r.Array(JstfScriptRecord, 'scriptCount')
});

// TODO: add this to restructure

var VariableSizeNumber = function () {
  function VariableSizeNumber(size) {
    _classCallCheck(this, VariableSizeNumber);

    this._size = size;
  }

  VariableSizeNumber.prototype.decode = function decode(stream, parent) {
    switch (this.size(0, parent)) {
      case 1:
        return stream.readUInt8();
      case 2:
        return stream.readUInt16BE();
      case 3:
        return stream.readUInt24BE();
      case 4:
        return stream.readUInt32BE();
    }
  };

  VariableSizeNumber.prototype.size = function size(val, parent) {
    return restructure_src_utils.resolveLength(this._size, null, parent);
  };

  return VariableSizeNumber;
}();

var MapDataEntry = new r.Struct({
  entry: new VariableSizeNumber(function (t) {
    return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
  }),
  outerIndex: function outerIndex(t) {
    return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
  },
  innerIndex: function innerIndex(t) {
    return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
  }
});

var DeltaSetIndexMap = new r.Struct({
  entryFormat: r.uint16,
  mapCount: r.uint16,
  mapData: new r.Array(MapDataEntry, 'mapCount')
});

var HVAR = new r.Struct({
  majorVersion: r.uint16,
  minorVersion: r.uint16,
  itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
  advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
  LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
  RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
});

var Signature = new r.Struct({
  format: r.uint32,
  length: r.uint32,
  offset: r.uint32
});

var SignatureBlock = new r.Struct({
  reserved: new r.Reserved(r.uint16, 2),
  cbSignature: r.uint32, // Length (in bytes) of the PKCS#7 packet in pbSignature
  signature: new r.Buffer('cbSignature')
});

var DSIG = new r.Struct({
  ulVersion: r.uint32, // Version number of the DSIG table (0x00000001)
  usNumSigs: r.uint16, // Number of signatures in the table
  usFlag: r.uint16, // Permission flags
  signatures: new r.Array(Signature, 'usNumSigs'),
  signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs')
});

var GaspRange = new r.Struct({
  rangeMaxPPEM: r.uint16, // Upper limit of range, in ppem
  rangeGaspBehavior: new r.Bitfield(r.uint16, [// Flags describing desired rasterizer behavior
  'grayscale', 'gridfit', 'symmetricSmoothing', 'symmetricGridfit' // only in version 1, for ClearType
  ])
});

var gasp = new r.Struct({
  version: r.uint16, // set to 0
  numRanges: r.uint16,
  gaspRanges: new r.Array(GaspRange, 'numRanges') // Sorted by ppem
});

var DeviceRecord = new r.Struct({
  pixelSize: r.uint8,
  maximumWidth: r.uint8,
  widths: new r.Array(r.uint8, function (t) {
    return t.parent.parent.maxp.numGlyphs;
  })
});

// The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
var hdmx = new r.Struct({
  version: r.uint16,
  numRecords: r.int16,
  sizeDeviceRecord: r.int32,
  records: new r.Array(DeviceRecord, 'numRecords')
});

var KernPair = new r.Struct({
  left: r.uint16,
  right: r.uint16,
  value: r.int16
});

var ClassTable = new r.Struct({
  firstGlyph: r.uint16,
  nGlyphs: r.uint16,
  offsets: new r.Array(r.uint16, 'nGlyphs'),
  max: function max(t) {
    return t.offsets.length && Math.max.apply(Math, t.offsets);
  }
});

var Kern2Array = new r.Struct({
  off: function off(t) {
    return t._startOffset - t.parent.parent._startOffset;
  },
  len: function len(t) {
    return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
  },
  values: new r.LazyArray(r.int16, 'len')
});

var KernSubtable = new r.VersionedStruct('format', {
  0: {
    nPairs: r.uint16,
    searchRange: r.uint16,
    entrySelector: r.uint16,
    rangeShift: r.uint16,
    pairs: new r.Array(KernPair, 'nPairs')
  },

  2: {
    rowWidth: r.uint16,
    leftTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
    rightTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
    array: new r.Pointer(r.uint16, Kern2Array, { type: 'parent' })
  },

  3: {
    glyphCount: r.uint16,
    kernValueCount: r.uint8,
    leftClassCount: r.uint8,
    rightClassCount: r.uint8,
    flags: r.uint8,
    kernValue: new r.Array(r.int16, 'kernValueCount'),
    leftClass: new r.Array(r.uint8, 'glyphCount'),
    rightClass: new r.Array(r.uint8, 'glyphCount'),
    kernIndex: new r.Array(r.uint8, function (t) {
      return t.leftClassCount * t.rightClassCount;
    })
  }
});

var KernTable = new r.VersionedStruct('version', {
  0: { // Microsoft uses this format
    subVersion: r.uint16, // Microsoft has an extra sub-table version number
    length: r.uint16, // Length of the subtable, in bytes
    format: r.uint8, // Format of subtable
    coverage: new r.Bitfield(r.uint8, ['horizontal', // 1 if table has horizontal data, 0 if vertical
    'minimum', // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
    'crossStream', // If set to 1, kerning is perpendicular to the flow of the text
    'override' // If set to 1 the value in this table replaces the accumulated value
    ]),
    subtable: KernSubtable,
    padding: new r.Reserved(r.uint8, function (t) {
      return t.length - t._currentOffset;
    })
  },
  1: { // Apple uses this format
    length: r.uint32,
    coverage: new r.Bitfield(r.uint8, [null, null, null, null, null, 'variation', // Set if table has variation kerning values
    'crossStream', // Set if table has cross-stream kerning values
    'vertical' // Set if table has vertical kerning values
    ]),
    format: r.uint8,
    tupleIndex: r.uint16,
    subtable: KernSubtable,
    padding: new r.Reserved(r.uint8, function (t) {
      return t.length - t._currentOffset;
    })
  }
});

var kern = new r.VersionedStruct(r.uint16, {
  0: { // Microsoft Version
    nTables: r.uint16,
    tables: new r.Array(KernTable, 'nTables')
  },

  1: { // Apple Version
    reserved: new r.Reserved(r.uint16), // the other half of the version number
    nTables: r.uint32,
    tables: new r.Array(KernTable, 'nTables')
  }
});

// Linear Threshold table
// Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
var LTSH = new r.Struct({
  version: r.uint16,
  numGlyphs: r.uint16,
  yPels: new r.Array(r.uint8, 'numGlyphs')
});

// PCL 5 Table
// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
var PCLT = new r.Struct({
  version: r.uint16,
  fontNumber: r.uint32,
  pitch: r.uint16,
  xHeight: r.uint16,
  style: r.uint16,
  typeFamily: r.uint16,
  capHeight: r.uint16,
  symbolSet: r.uint16,
  typeface: new r.String(16),
  characterComplement: new r.String(8),
  fileName: new r.String(6),
  strokeWeight: new r.String(1),
  widthType: new r.String(1),
  serifStyle: r.uint8,
  reserved: new r.Reserved(r.uint8)
});

// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.

var Ratio = new r.Struct({
  bCharSet: r.uint8, // Character set
  xRatio: r.uint8, // Value to use for x-Ratio
  yStartRatio: r.uint8, // Starting y-Ratio value
  yEndRatio: r.uint8 // Ending y-Ratio value
});

var vTable = new r.Struct({
  yPelHeight: r.uint16, // yPelHeight to which values apply
  yMax: r.int16, // Maximum value (in pels) for this yPelHeight
  yMin: r.int16 // Minimum value (in pels) for this yPelHeight
});

var VdmxGroup = new r.Struct({
  recs: r.uint16, // Number of height records in this group
  startsz: r.uint8, // Starting yPelHeight
  endsz: r.uint8, // Ending yPelHeight
  entries: new r.Array(vTable, 'recs') // The VDMX records
});

var VDMX = new r.Struct({
  version: r.uint16, // Version number (0 or 1)
  numRecs: r.uint16, // Number of VDMX groups present
  numRatios: r.uint16, // Number of aspect ratio groupings
  ratioRanges: new r.Array(Ratio, 'numRatios'), // Ratio ranges
  offsets: new r.Array(r.uint16, 'numRatios'), // Offset to the VDMX group for this ratio range
  groups: new r.Array(VdmxGroup, 'numRecs') // The actual VDMX groupings
});

// Vertical Header Table
var vhea = new r.Struct({
  version: r.uint16, // Version number of the Vertical Header Table
  ascent: r.int16, // The vertical typographic ascender for this font
  descent: r.int16, // The vertical typographic descender for this font
  lineGap: r.int16, // The vertical typographic line gap for this font
  advanceHeightMax: r.int16, // The maximum advance height measurement found in the font
  minTopSideBearing: r.int16, // The minimum top side bearing measurement found in the font
  minBottomSideBearing: r.int16, // The minimum bottom side bearing measurement found in the font
  yMaxExtent: r.int16,
  caretSlopeRise: r.int16, // Caret slope (rise/run)
  caretSlopeRun: r.int16,
  caretOffset: r.int16, // Set value equal to 0 for nonslanted fonts
  reserved: new r.Reserved(r.int16, 4),
  metricDataFormat: r.int16, // Set to 0
  numberOfMetrics: r.uint16 // Number of advance heights in the Vertical Metrics table
});

var VmtxEntry = new r.Struct({
  advance: r.uint16, // The advance height of the glyph
  bearing: r.int16 // The top sidebearing of the glyph
});

// Vertical Metrics Table
var vmtx = new r.Struct({
  metrics: new r.LazyArray(VmtxEntry, function (t) {
    return t.parent.vhea.numberOfMetrics;
  }),
  bearings: new r.LazyArray(r.int16, function (t) {
    return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
  })
});

var shortFrac = new r.Fixed(16, 'BE', 14);

var Correspondence = new r.Struct({
  fromCoord: shortFrac,
  toCoord: shortFrac
});

var Segment = new r.Struct({
  pairCount: r.uint16,
  correspondence: new r.Array(Correspondence, 'pairCount')
});

var avar = new r.Struct({
  version: r.fixed32,
  axisCount: r.uint32,
  segment: new r.Array(Segment, 'axisCount')
});

var UnboundedArrayAccessor = function () {
  function UnboundedArrayAccessor(type, stream, parent) {
    _classCallCheck(this, UnboundedArrayAccessor);

    this.type = type;
    this.stream = stream;
    this.parent = parent;
    this.base = this.stream.pos;
    this._items = [];
  }

  UnboundedArrayAccessor.prototype.getItem = function getItem(index) {
    if (this._items[index] == null) {
      var pos = this.stream.pos;
      this.stream.pos = this.base + this.type.size(null, this.parent) * index;
      this._items[index] = this.type.decode(this.stream, this.parent);
      this.stream.pos = pos;
    }

    return this._items[index];
  };

  UnboundedArrayAccessor.prototype.inspect = function inspect() {
    return '[UnboundedArray ' + this.type.constructor.name + ']';
  };

  return UnboundedArrayAccessor;
}();

var UnboundedArray = function (_r$Array) {
  _inherits(UnboundedArray, _r$Array);

  function UnboundedArray(type) {
    _classCallCheck(this, UnboundedArray);

    return _possibleConstructorReturn(this, _r$Array.call(this, type, 0));
  }

  UnboundedArray.prototype.decode = function decode(stream, parent) {
    return new UnboundedArrayAccessor(this.type, stream, parent);
  };

  return UnboundedArray;
}(r.Array);

var LookupTable = function LookupTable() {
  var ValueType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r.uint16;

  // Helper class that makes internal structures invisible to pointers
  var Shadow = function () {
    function Shadow(type) {
      _classCallCheck(this, Shadow);

      this.type = type;
    }

    Shadow.prototype.decode = function decode(stream, ctx) {
      ctx = ctx.parent.parent;
      return this.type.decode(stream, ctx);
    };

    Shadow.prototype.size = function size(val, ctx) {
      ctx = ctx.parent.parent;
      return this.type.size(val, ctx);
    };

    Shadow.prototype.encode = function encode(stream, val, ctx) {
      ctx = ctx.parent.parent;
      return this.type.encode(stream, val, ctx);
    };

    return Shadow;
  }();

  ValueType = new Shadow(ValueType);

  var BinarySearchHeader = new r.Struct({
    unitSize: r.uint16,
    nUnits: r.uint16,
    searchRange: r.uint16,
    entrySelector: r.uint16,
    rangeShift: r.uint16
  });

  var LookupSegmentSingle = new r.Struct({
    lastGlyph: r.uint16,
    firstGlyph: r.uint16,
    value: ValueType
  });

  var LookupSegmentArray = new r.Struct({
    lastGlyph: r.uint16,
    firstGlyph: r.uint16,
    values: new r.Pointer(r.uint16, new r.Array(ValueType, function (t) {
      return t.lastGlyph - t.firstGlyph + 1;
    }), { type: 'parent' })
  });

  var LookupSingle = new r.Struct({
    glyph: r.uint16,
    value: ValueType
  });

  return new r.VersionedStruct(r.uint16, {
    0: {
      values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
    },
    2: {
      binarySearchHeader: BinarySearchHeader,
      segments: new r.Array(LookupSegmentSingle, function (t) {
        return t.binarySearchHeader.nUnits;
      })
    },
    4: {
      binarySearchHeader: BinarySearchHeader,
      segments: new r.Array(LookupSegmentArray, function (t) {
        return t.binarySearchHeader.nUnits;
      })
    },
    6: {
      binarySearchHeader: BinarySearchHeader,
      segments: new r.Array(LookupSingle, function (t) {
        return t.binarySearchHeader.nUnits;
      })
    },
    8: {
      firstGlyph: r.uint16,
      count: r.uint16,
      values: new r.Array(ValueType, 'count')
    }
  });
};

function StateTable() {
  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;

  var entry = _Object$assign({
    newState: r.uint16,
    flags: r.uint16
  }, entryData);

  var Entry = new r.Struct(entry);
  var StateArray = new UnboundedArray(new r.Array(r.uint16, function (t) {
    return t.nClasses;
  }));

  var StateHeader = new r.Struct({
    nClasses: r.uint32,
    classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
    stateArray: new r.Pointer(r.uint32, StateArray),
    entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
  });

  return StateHeader;
}

// This is the old version of the StateTable structure
function StateTable1() {
  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;

  var ClassLookupTable = new r.Struct({
    version: function version() {
      return 8;
    },
    // simulate LookupTable
    firstGlyph: r.uint16,
    values: new r.Array(r.uint8, r.uint16)
  });

  var entry = _Object$assign({
    newStateOffset: r.uint16,
    // convert offset to stateArray index
    newState: function newState(t) {
      return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
    },
    flags: r.uint16
  }, entryData);

  var Entry = new r.Struct(entry);
  var StateArray = new UnboundedArray(new r.Array(r.uint8, function (t) {
    return t.nClasses;
  }));

  var StateHeader1 = new r.Struct({
    nClasses: r.uint16,
    classTable: new r.Pointer(r.uint16, ClassLookupTable),
    stateArray: new r.Pointer(r.uint16, StateArray),
    entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
  });

  return StateHeader1;
}

var BslnSubtable = new r.VersionedStruct('format', {
  0: { // Distance-based, no mapping
    deltas: new r.Array(r.int16, 32)
  },

  1: { // Distance-based, with mapping
    deltas: new r.Array(r.int16, 32),
    mappingData: new LookupTable(r.uint16)
  },

  2: { // Control point-based, no mapping
    standardGlyph: r.uint16,
    controlPoints: new r.Array(r.uint16, 32)
  },

  3: { // Control point-based, with mapping
    standardGlyph: r.uint16,
    controlPoints: new r.Array(r.uint16, 32),
    mappingData: new LookupTable(r.uint16)
  }
});

var bsln = new r.Struct({
  version: r.fixed32,
  format: r.uint16,
  defaultBaseline: r.uint16,
  subtable: BslnSubtable
});

var Setting = new r.Struct({
  setting: r.uint16,
  nameIndex: r.int16,
  name: function name(t) {
    return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
  }
});

var FeatureName = new r.Struct({
  feature: r.uint16,
  nSettings: r.uint16,
  settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), { type: 'parent' }),
  featureFlags: new r.Bitfield(r.uint8, [null, null, null, null, null, null, 'hasDefault', 'exclusive']),
  defaultSetting: r.uint8,
  nameIndex: r.int16,
  name: function name(t) {
    return t.parent.parent.name.records.fontFeatures[t.nameIndex];
  }
});

var feat = new r.Struct({
  version: r.fixed32,
  featureNameCount: r.uint16,
  reserved1: new r.Reserved(r.uint16),
  reserved2: new r.Reserved(r.uint32),
  featureNames: new r.Array(FeatureName, 'featureNameCount')
});

var Axis$1 = new r.Struct({
  axisTag: new r.String(4),
  minValue: r.fixed32,
  defaultValue: r.fixed32,
  maxValue: r.fixed32,
  flags: r.uint16,
  nameID: r.uint16,
  name: function name(t) {
    return t.parent.parent.name.records.fontFeatures[t.nameID];
  }
});

var Instance = new r.Struct({
  nameID: r.uint16,
  name: function name(t) {
    return t.parent.parent.name.records.fontFeatures[t.nameID];
  },
  flags: r.uint16,
  coord: new r.Array(r.fixed32, function (t) {
    return t.parent.axisCount;
  }),
  postscriptNameID: new r.Optional(r.uint16, function (t) {
    return t.parent.instanceSize - t._currentOffset > 0;
  })
});

var fvar = new r.Struct({
  version: r.fixed32,
  offsetToData: r.uint16,
  countSizePairs: r.uint16,
  axisCount: r.uint16,
  axisSize: r.uint16,
  instanceCount: r.uint16,
  instanceSize: r.uint16,
  axis: new r.Array(Axis$1, 'axisCount'),
  instance: new r.Array(Instance, 'instanceCount')
});

var shortFrac$1 = new r.Fixed(16, 'BE', 14);

var Offset = function () {
  function Offset() {
    _classCallCheck(this, Offset);
  }

  Offset.decode = function decode(stream, parent) {
    // In short format, offsets are multiplied by 2.
    // This doesn't seem to be documented by Apple, but it
    // is implemented this way in Freetype.
    return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
  };

  return Offset;
}();

var gvar = new r.Struct({
  version: r.uint16,
  reserved: new r.Reserved(r.uint16),
  axisCount: r.uint16,
  globalCoordCount: r.uint16,
  globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
  glyphCount: r.uint16,
  flags: r.uint16,
  offsetToData: r.uint32,
  offsets: new r.Array(new r.Pointer(Offset, 'void', { relativeTo: 'offsetToData', allowNull: false }), function (t) {
    return t.glyphCount + 1;
  })
});

var ClassTable$1 = new r.Struct({
  length: r.uint16,
  coverage: r.uint16,
  subFeatureFlags: r.uint32,
  stateTable: new StateTable1()
});

var WidthDeltaRecord = new r.Struct({
  justClass: r.uint32,
  beforeGrowLimit: r.fixed32,
  beforeShrinkLimit: r.fixed32,
  afterGrowLimit: r.fixed32,
  afterShrinkLimit: r.fixed32,
  growFlags: r.uint16,
  shrinkFlags: r.uint16
});

var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);

var ActionData = new r.VersionedStruct('actionType', {
  0: { // Decomposition action
    lowerLimit: r.fixed32,
    upperLimit: r.fixed32,
    order: r.uint16,
    glyphs: new r.Array(r.uint16, r.uint16)
  },

  1: { // Unconditional add glyph action
    addGlyph: r.uint16
  },

  2: { // Conditional add glyph action
    substThreshold: r.fixed32,
    addGlyph: r.uint16,
    substGlyph: r.uint16
  },

  3: {}, // Stretch glyph action (no data, not supported by CoreText)

  4: { // Ductile glyph action (not supported by CoreText)
    variationAxis: r.uint32,
    minimumLimit: r.fixed32,
    noStretchValue: r.fixed32,
    maximumLimit: r.fixed32
  },

  5: { // Repeated add glyph action
    flags: r.uint16,
    glyph: r.uint16
  }
});

var Action = new r.Struct({
  actionClass: r.uint16,
  actionType: r.uint16,
  actionLength: r.uint32,
  actionData: ActionData,
  padding: new r.Reserved(r.uint8, function (t) {
    return t.actionLength - t._currentOffset;
  })
});

var PostcompensationAction = new r.Array(Action, r.uint32);
var PostCompensationTable = new r.Struct({
  lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction))
});

var JustificationTable = new r.Struct({
  classTable: new r.Pointer(r.uint16, ClassTable$1, { type: 'parent' }),
  wdcOffset: r.uint16,
  postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, { type: 'parent' }),
  widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, { type: 'parent', relativeTo: 'wdcOffset' }))
});

var just = new r.Struct({
  version: r.uint32,
  format: r.uint16,
  horizontal: new r.Pointer(r.uint16, JustificationTable),
  vertical: new r.Pointer(r.uint16, JustificationTable)
});

var LigatureData = {
  action: r.uint16
};

var ContextualData = {
  markIndex: r.uint16,
  currentIndex: r.uint16
};

var InsertionData = {
  currentInsertIndex: r.uint16,
  markedInsertIndex: r.uint16
};

var SubstitutionTable = new r.Struct({
  items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable()))
});

var SubtableData = new r.VersionedStruct('type', {
  0: { // Indic Rearrangement Subtable
    stateTable: new StateTable()
  },

  1: { // Contextual Glyph Substitution Subtable
    stateTable: new StateTable(ContextualData),
    substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
  },

  2: { // Ligature subtable
    stateTable: new StateTable(LigatureData),
    ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
    components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
    ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
  },

  4: { // Non-contextual Glyph Substitution Subtable
    lookupTable: new LookupTable()
  },

  5: { // Glyph Insertion Subtable
    stateTable: new StateTable(InsertionData),
    insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
  }
});

var Subtable = new r.Struct({
  length: r.uint32,
  coverage: r.uint24,
  type: r.uint8,
  subFeatureFlags: r.uint32,
  table: SubtableData,
  padding: new r.Reserved(r.uint8, function (t) {
    return t.length - t._currentOffset;
  })
});

var FeatureEntry = new r.Struct({
  featureType: r.uint16,
  featureSetting: r.uint16,
  enableFlags: r.uint32,
  disableFlags: r.uint32
});

var MorxChain = new r.Struct({
  defaultFlags: r.uint32,
  chainLength: r.uint32,
  nFeatureEntries: r.uint32,
  nSubtables: r.uint32,
  features: new r.Array(FeatureEntry, 'nFeatureEntries'),
  subtables: new r.Array(Subtable, 'nSubtables')
});

var morx = new r.Struct({
  version: r.uint16,
  unused: new r.Reserved(r.uint16),
  nChains: r.uint32,
  chains: new r.Array(MorxChain, 'nChains')
});

var OpticalBounds = new r.Struct({
  left: r.int16,
  top: r.int16,
  right: r.int16,
  bottom: r.int16
});

var opbd = new r.Struct({
  version: r.fixed32,
  format: r.uint16,
  lookupTable: new LookupTable(OpticalBounds)
});

var tables = {};
// Required Tables
tables.cmap = cmap;
tables.head = head;
tables.hhea = hhea;
tables.hmtx = hmtx;
tables.maxp = maxp;
tables.name = NameTable;
tables['OS/2'] = OS2;
tables.post = post;

// TrueType Outlines
tables.fpgm = fpgm;
tables.loca = loca;
tables.prep = prep;
tables['cvt '] = cvt;
tables.glyf = glyf;

// PostScript Outlines
tables['CFF '] = CFFFont;
tables['CFF2'] = CFFFont;
tables.VORG = VORG;

// Bitmap Glyphs
tables.EBLC = EBLC;
tables.CBLC = tables.EBLC;
tables.sbix = sbix;
tables.COLR = COLR;
tables.CPAL = CPAL;

// Advanced OpenType Tables
tables.BASE = BASE;
tables.GDEF = GDEF;
tables.GPOS = GPOS;
tables.GSUB = GSUB;
tables.JSTF = JSTF;

// OpenType variations tables
tables.HVAR = HVAR;

// Other OpenType Tables
tables.DSIG = DSIG;
tables.gasp = gasp;
tables.hdmx = hdmx;
tables.kern = kern;
tables.LTSH = LTSH;
tables.PCLT = PCLT;
tables.VDMX = VDMX;
tables.vhea = vhea;
tables.vmtx = vmtx;

// Apple Advanced Typography Tables
tables.avar = avar;
tables.bsln = bsln;
tables.feat = feat;
tables.fvar = fvar;
tables.gvar = gvar;
tables.just = just;
tables.morx = morx;
tables.opbd = opbd;

var TableEntry = new r.Struct({
  tag: new r.String(4),
  checkSum: r.uint32,
  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
  length: r.uint32
});

var Directory = new r.Struct({
  tag: new r.String(4),
  numTables: r.uint16,
  searchRange: r.uint16,
  entrySelector: r.uint16,
  rangeShift: r.uint16,
  tables: new r.Array(TableEntry, 'numTables')
});

Directory.process = function () {
  var tables = {};
  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var table = _ref;

    tables[table.tag] = table;
  }

  this.tables = tables;
};

Directory.preEncode = function (stream) {
  var tables$$ = [];
  for (var tag in this.tables) {
    var table = this.tables[tag];
    if (table) {
      tables$$.push({
        tag: tag,
        checkSum: 0,
        offset: new r.VoidPointer(tables[tag], table),
        length: tables[tag].size(table)
      });
    }
  }

  this.tag = 'true';
  this.numTables = tables$$.length;
  this.tables = tables$$;

  this.searchRange = Math.floor(Math.log(this.numTables) / Math.LN2) * 16;
  this.entrySelector = Math.floor(this.searchRange / Math.LN2);
  this.rangeShift = this.numTables * 16 - this.searchRange;
};

function binarySearch(arr, cmp) {
  var min = 0;
  var max = arr.length - 1;
  while (min <= max) {
    var mid = min + max >> 1;
    var res = cmp(arr[mid]);

    if (res < 0) {
      max = mid - 1;
    } else if (res > 0) {
      min = mid + 1;
    } else {
      return mid;
    }
  }

  return -1;
}

function range(index, end) {
  var range = [];
  while (index < end) {
    range.push(index++);
  }
  return range;
}

var _class$1;
function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// iconv-lite is an optional dependency.
try {
  var iconv = __webpack_require__(51);
} catch (err) {}

var CmapProcessor = (_class$1 = function () {
  function CmapProcessor(cmapTable) {
    _classCallCheck(this, CmapProcessor);

    // Attempt to find a Unicode cmap first
    this.encoding = null;
    this.cmap = this.findSubtable(cmapTable, [
    // 32-bit subtables
    [3, 10], [0, 6], [0, 4],

    // 16-bit subtables
    [3, 1], [0, 3], [0, 2], [0, 1], [0, 0]]);

    // If not unicode cmap was found, and iconv-lite is installed,
    // take the first table with a supported encoding.
    if (!this.cmap && iconv) {
      for (var _iterator = cmapTable.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var cmap = _ref;

        var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
        if (iconv.encodingExists(encoding)) {
          this.cmap = cmap.table;
          this.encoding = encoding;
        }
      }
    }

    if (!this.cmap) {
      throw new Error("Could not find a supported cmap table");
    }

    this.uvs = this.findSubtable(cmapTable, [[0, 5]]);
    if (this.uvs && this.uvs.version !== 14) {
      this.uvs = null;
    }
  }

  CmapProcessor.prototype.findSubtable = function findSubtable(cmapTable, pairs) {
    for (var _iterator2 = pairs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var _ref3 = _ref2,
          platformID = _ref3[0],
          encodingID = _ref3[1];

      for (var _iterator3 = cmapTable.tables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref4;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref4 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref4 = _i3.value;
        }

        var cmap = _ref4;

        if (cmap.platformID === platformID && cmap.encodingID === encodingID) {
          return cmap.table;
        }
      }
    }

    return null;
  };

  CmapProcessor.prototype.lookup = function lookup(codepoint, variationSelector) {
    // If there is no Unicode cmap in this font, we need to re-encode
    // the codepoint in the encoding that the cmap supports.
    if (this.encoding) {
      var buf = iconv.encode(_String$fromCodePoint(codepoint), this.encoding);
      codepoint = 0;
      for (var i = 0; i < buf.length; i++) {
        codepoint = codepoint << 8 | buf[i];
      }

      // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
    } else if (variationSelector) {
      var gid = this.getVariationSelector(codepoint, variationSelector);
      if (gid) {
        return gid;
      }
    }

    var cmap = this.cmap;
    switch (cmap.version) {
      case 0:
        return cmap.codeMap.get(codepoint) || 0;

      case 4:
        {
          var min = 0;
          var max = cmap.segCount - 1;
          while (min <= max) {
            var mid = min + max >> 1;

            if (codepoint < cmap.startCode.get(mid)) {
              max = mid - 1;
            } else if (codepoint > cmap.endCode.get(mid)) {
              min = mid + 1;
            } else {
              var rangeOffset = cmap.idRangeOffset.get(mid);
              var _gid = void 0;

              if (rangeOffset === 0) {
                _gid = codepoint + cmap.idDelta.get(mid);
              } else {
                var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                _gid = cmap.glyphIndexArray.get(index) || 0;
                if (_gid !== 0) {
                  _gid += cmap.idDelta.get(mid);
                }
              }

              return _gid & 0xffff;
            }
          }

          return 0;
        }

      case 8:
        throw new Error('TODO: cmap format 8');

      case 6:
      case 10:
        return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;

      case 12:
      case 13:
        {
          var _min = 0;
          var _max = cmap.nGroups - 1;
          while (_min <= _max) {
            var _mid = _min + _max >> 1;
            var group = cmap.groups.get(_mid);

            if (codepoint < group.startCharCode) {
              _max = _mid - 1;
            } else if (codepoint > group.endCharCode) {
              _min = _mid + 1;
            } else {
              if (cmap.version === 12) {
                return group.glyphID + (codepoint - group.startCharCode);
              } else {
                return group.glyphID;
              }
            }
          }

          return 0;
        }

      case 14:
        throw new Error('TODO: cmap format 14');

      default:
        throw new Error('Unknown cmap format ' + cmap.version);
    }
  };

  CmapProcessor.prototype.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
    if (!this.uvs) {
      return 0;
    }

    var selectors = this.uvs.varSelectors.toArray();
    var i = binarySearch(selectors, function (x) {
      return variationSelector - x.varSelector;
    });
    var sel = selectors[i];

    if (i !== -1 && sel.defaultUVS) {
      i = binarySearch(sel.defaultUVS, function (x) {
        return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? +1 : 0;
      });
    }

    if (i !== -1 && sel.nonDefaultUVS) {
      i = binarySearch(sel.nonDefaultUVS, function (x) {
        return codepoint - x.unicodeValue;
      });
      if (i !== -1) {
        return sel.nonDefaultUVS[i].glyphID;
      }
    }

    return 0;
  };

  CmapProcessor.prototype.getCharacterSet = function getCharacterSet() {
    var cmap = this.cmap;
    switch (cmap.version) {
      case 0:
        return range(0, cmap.codeMap.length);

      case 4:
        {
          var res = [];
          var endCodes = cmap.endCode.toArray();
          for (var i = 0; i < endCodes.length; i++) {
            var tail = endCodes[i] + 1;
            var start = cmap.startCode.get(i);
            res.push.apply(res, range(start, tail));
          }

          return res;
        }

      case 8:
        throw new Error('TODO: cmap format 8');

      case 6:
      case 10:
        return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);

      case 12:
      case 13:
        {
          var _res = [];
          for (var _iterator4 = cmap.groups.toArray(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
            var _ref5;

            if (_isArray4) {
              if (_i4 >= _iterator4.length) break;
              _ref5 = _iterator4[_i4++];
            } else {
              _i4 = _iterator4.next();
              if (_i4.done) break;
              _ref5 = _i4.value;
            }

            var group = _ref5;

            _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
          }

          return _res;
        }

      case 14:
        throw new Error('TODO: cmap format 14');

      default:
        throw new Error('Unknown cmap format ' + cmap.version);
    }
  };

  CmapProcessor.prototype.codePointsForGlyph = function codePointsForGlyph(gid) {
    var cmap = this.cmap;
    switch (cmap.version) {
      case 0:
        {
          var res = [];
          for (var i = 0; i < 256; i++) {
            if (cmap.codeMap.get(i) === gid) {
              res.push(i);
            }
          }

          return res;
        }

      case 4:
        {
          var _res2 = [];
          for (var _i5 = 0; _i5 < cmap.segCount; _i5++) {
            var end = cmap.endCode.get(_i5);
            var start = cmap.startCode.get(_i5);
            var rangeOffset = cmap.idRangeOffset.get(_i5);
            var delta = cmap.idDelta.get(_i5);

            for (var c = start; c <= end; c++) {
              var g = 0;
              if (rangeOffset === 0) {
                g = c + delta;
              } else {
                var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i5);
                g = cmap.glyphIndexArray.get(index) || 0;
                if (g !== 0) {
                  g += delta;
                }
              }

              if (g === gid) {
                _res2.push(c);
              }
            }
          }

          return _res2;
        }

      case 12:
        {
          var _res3 = [];
          for (var _iterator5 = cmap.groups.toArray(), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
            var _ref6;

            if (_isArray5) {
              if (_i6 >= _iterator5.length) break;
              _ref6 = _iterator5[_i6++];
            } else {
              _i6 = _iterator5.next();
              if (_i6.done) break;
              _ref6 = _i6.value;
            }

            var group = _ref6;

            if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) {
              _res3.push(group.startCharCode + (gid - group.glyphID));
            }
          }

          return _res3;
        }

      case 13:
        {
          var _res4 = [];
          for (var _iterator6 = cmap.groups.toArray(), _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
            var _ref7;

            if (_isArray6) {
              if (_i7 >= _iterator6.length) break;
              _ref7 = _iterator6[_i7++];
            } else {
              _i7 = _iterator6.next();
              if (_i7.done) break;
              _ref7 = _i7.value;
            }

            var _group = _ref7;

            if (gid === _group.glyphID) {
              _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
            }
          }

          return _res4;
        }

      default:
        throw new Error('Unknown cmap format ' + cmap.version);
    }
  };

  return CmapProcessor;
}(), (_applyDecoratedDescriptor$1(_class$1.prototype, 'getCharacterSet', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'getCharacterSet'), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, 'codePointsForGlyph', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'codePointsForGlyph'), _class$1.prototype)), _class$1);

var KernProcessor = function () {
  function KernProcessor(font) {
    _classCallCheck(this, KernProcessor);

    this.kern = font.kern;
  }

  KernProcessor.prototype.process = function process(glyphs, positions) {
    for (var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
      var left = glyphs[glyphIndex].id;
      var right = glyphs[glyphIndex + 1].id;
      positions[glyphIndex].xAdvance += this.getKerning(left, right);
    }
  };

  KernProcessor.prototype.getKerning = function getKerning(left, right) {
    var res = 0;

    for (var _iterator = this.kern.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var table = _ref;

      if (table.coverage.crossStream) {
        continue;
      }

      switch (table.version) {
        case 0:
          if (!table.coverage.horizontal) {
            continue;
          }

          break;
        case 1:
          if (table.coverage.vertical || table.coverage.variation) {
            continue;
          }

          break;
        default:
          throw new Error('Unsupported kerning table version ' + table.version);
      }

      var val = 0;
      var s = table.subtable;
      switch (table.format) {
        case 0:
          var pairIdx = binarySearch(s.pairs, function (pair) {
            return left - pair.left || right - pair.right;
          });

          if (pairIdx >= 0) {
            val = s.pairs[pairIdx].value;
          }

          break;

        case 2:
          var leftOffset = 0,
              rightOffset = 0;
          if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) {
            leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
          } else {
            leftOffset = s.array.off;
          }

          if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) {
            rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
          }

          var index = (leftOffset + rightOffset - s.array.off) / 2;
          val = s.array.values.get(index);
          break;

        case 3:
          if (left >= s.glyphCount || right >= s.glyphCount) {
            return 0;
          }

          val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
          break;

        default:
          throw new Error('Unsupported kerning sub-table format ' + table.format);
      }

      // Microsoft supports the override flag, which resets the result
      // Otherwise, the sum of the results from all subtables is returned
      if (table.coverage.override) {
        res = val;
      } else {
        res += val;
      }
    }

    return res;
  };

  return KernProcessor;
}();

/**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */

var UnicodeLayoutEngine = function () {
  function UnicodeLayoutEngine(font) {
    _classCallCheck(this, UnicodeLayoutEngine);

    this.font = font;
  }

  UnicodeLayoutEngine.prototype.positionGlyphs = function positionGlyphs(glyphs, positions) {
    // find each base + mark cluster, and position the marks relative to the base
    var clusterStart = 0;
    var clusterEnd = 0;
    for (var index = 0; index < glyphs.length; index++) {
      var glyph = glyphs[index];
      if (glyph.isMark) {
        // TODO: handle ligatures
        clusterEnd = index;
      } else {
        if (clusterStart !== clusterEnd) {
          this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        }

        clusterStart = clusterEnd = index;
      }
    }

    if (clusterStart !== clusterEnd) {
      this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
    }

    return positions;
  };

  UnicodeLayoutEngine.prototype.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
    var base = glyphs[clusterStart];
    var baseBox = base.cbox.copy();

    // adjust bounding box for ligature glyphs
    if (base.codePoints.length > 1) {
      // LTR. TODO: RTL support.
      baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
    }

    var xOffset = -positions[clusterStart].xAdvance;
    var yOffset = 0;
    var yGap = this.font.unitsPerEm / 16;

    // position each of the mark glyphs relative to the base glyph
    for (var index = clusterStart + 1; index <= clusterEnd; index++) {
      var mark = glyphs[index];
      var markBox = mark.cbox;
      var position = positions[index];

      var combiningClass = this.getCombiningClass(mark.codePoints[0]);

      if (combiningClass !== 'Not_Reordered') {
        position.xOffset = position.yOffset = 0;

        // x positioning
        switch (combiningClass) {
          case 'Double_Above':
          case 'Double_Below':
            // LTR. TODO: RTL support.
            position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
            break;

          case 'Attached_Below_Left':
          case 'Below_Left':
          case 'Above_Left':
            // left align
            position.xOffset += baseBox.minX - markBox.minX;
            break;

          case 'Attached_Above_Right':
          case 'Below_Right':
          case 'Above_Right':
            // right align
            position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
            break;

          default:
            // Attached_Below, Attached_Above, Below, Above, other
            // center align
            position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
        }

        // y positioning
        switch (combiningClass) {
          case 'Double_Below':
          case 'Below_Left':
          case 'Below':
          case 'Below_Right':
          case 'Attached_Below_Left':
          case 'Attached_Below':
            // add a small gap between the glyphs if they are not attached
            if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') {
              baseBox.minY += yGap;
            }

            position.yOffset = -baseBox.minY - markBox.maxY;
            baseBox.minY += markBox.height;
            break;

          case 'Double_Above':
          case 'Above_Left':
          case 'Above':
          case 'Above_Right':
          case 'Attached_Above':
          case 'Attached_Above_Right':
            // add a small gap between the glyphs if they are not attached
            if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') {
              baseBox.maxY += yGap;
            }

            position.yOffset = baseBox.maxY - markBox.minY;
            baseBox.maxY += markBox.height;
            break;
        }

        position.xAdvance = position.yAdvance = 0;
        position.xOffset += xOffset;
        position.yOffset += yOffset;
      } else {
        xOffset -= position.xAdvance;
        yOffset -= position.yAdvance;
      }
    }

    return;
  };

  UnicodeLayoutEngine.prototype.getCombiningClass = function getCombiningClass(codePoint) {
    var combiningClass = unicode.getCombiningClass(codePoint);

    // Thai / Lao need some per-character work
    if ((codePoint & ~0xff) === 0x0e00) {
      if (combiningClass === 'Not_Reordered') {
        switch (codePoint) {
          case 0x0e31:
          case 0x0e34:
          case 0x0e35:
          case 0x0e36:
          case 0x0e37:
          case 0x0e47:
          case 0x0e4c:
          case 0x0e3d:
          case 0x0e4e:
            return 'Above_Right';

          case 0x0eb1:
          case 0x0eb4:
          case 0x0eb5:
          case 0x0eb6:
          case 0x0eb7:
          case 0x0ebb:
          case 0x0ecc:
          case 0x0ecd:
            return 'Above';

          case 0x0ebc:
            return 'Below';
        }
      } else if (codePoint === 0x0e3a) {
        // virama
        return 'Below_Right';
      }
    }

    switch (combiningClass) {
      // Hebrew

      case 'CCC10': // sheva
      case 'CCC11': // hataf segol
      case 'CCC12': // hataf patah
      case 'CCC13': // hataf qamats
      case 'CCC14': // hiriq
      case 'CCC15': // tsere
      case 'CCC16': // segol
      case 'CCC17': // patah
      case 'CCC18': // qamats
      case 'CCC20': // qubuts
      case 'CCC22':
        // meteg
        return 'Below';

      case 'CCC23':
        // rafe
        return 'Attached_Above';

      case 'CCC24':
        // shin dot
        return 'Above_Right';

      case 'CCC25': // sin dot
      case 'CCC19':
        // holam
        return 'Above_Left';

      case 'CCC26':
        // point varika
        return 'Above';

      case 'CCC21':
        // dagesh
        break;

      // Arabic and Syriac

      case 'CCC27': // fathatan
      case 'CCC28': // dammatan
      case 'CCC30': // fatha
      case 'CCC31': // damma
      case 'CCC33': // shadda
      case 'CCC34': // sukun
      case 'CCC35': // superscript alef
      case 'CCC36':
        // superscript alaph
        return 'Above';

      case 'CCC29': // kasratan
      case 'CCC32':
        // kasra
        return 'Below';

      // Thai

      case 'CCC103':
        // sara u / sara uu
        return 'Below_Right';

      case 'CCC107':
        // mai
        return 'Above_Right';

      // Lao

      case 'CCC118':
        // sign u / sign uu
        return 'Below';

      case 'CCC122':
        // mai
        return 'Above';

      // Tibetan

      case 'CCC129': // sign aa
      case 'CCC132':
        // sign u
        return 'Below';

      case 'CCC130':
        // sign i
        return 'Above';
    }

    return combiningClass;
  };

  return UnicodeLayoutEngine;
}();

/**
 * Represents a glyph bounding box
 */
var BBox = function () {
  function BBox() {
    var minX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
    var minY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    var maxX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
    var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;

    _classCallCheck(this, BBox);

    /**
     * The minimum X position in the bounding box
     * @type {number}
     */
    this.minX = minX;

    /**
     * The minimum Y position in the bounding box
     * @type {number}
     */
    this.minY = minY;

    /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */
    this.maxX = maxX;

    /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */
    this.maxY = maxY;
  }

  /**
   * The width of the bounding box
   * @type {number}
   */


  BBox.prototype.addPoint = function addPoint(x, y) {
    if (Math.abs(x) !== Infinity) {
      if (x < this.minX) {
        this.minX = x;
      }

      if (x > this.maxX) {
        this.maxX = x;
      }
    }

    if (Math.abs(y) !== Infinity) {
      if (y < this.minY) {
        this.minY = y;
      }

      if (y > this.maxY) {
        this.maxY = y;
      }
    }
  };

  BBox.prototype.copy = function copy() {
    return new BBox(this.minX, this.minY, this.maxX, this.maxY);
  };

  _createClass(BBox, [{
    key: "width",
    get: function get() {
      return this.maxX - this.minX;
    }

    /**
     * The height of the bounding box
     * @type {number}
     */

  }, {
    key: "height",
    get: function get() {
      return this.maxY - this.minY;
    }
  }]);

  return BBox;
}();

// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
var UNICODE_SCRIPTS = {
  Caucasian_Albanian: 'aghb',
  Arabic: 'arab',
  Imperial_Aramaic: 'armi',
  Armenian: 'armn',
  Avestan: 'avst',
  Balinese: 'bali',
  Bamum: 'bamu',
  Bassa_Vah: 'bass',
  Batak: 'batk',
  Bengali: ['bng2', 'beng'],
  Bopomofo: 'bopo',
  Brahmi: 'brah',
  Braille: 'brai',
  Buginese: 'bugi',
  Buhid: 'buhd',
  Chakma: 'cakm',
  Canadian_Aboriginal: 'cans',
  Carian: 'cari',
  Cham: 'cham',
  Cherokee: 'cher',
  Coptic: 'copt',
  Cypriot: 'cprt',
  Cyrillic: 'cyrl',
  Devanagari: ['dev2', 'deva'],
  Deseret: 'dsrt',
  Duployan: 'dupl',
  Egyptian_Hieroglyphs: 'egyp',
  Elbasan: 'elba',
  Ethiopic: 'ethi',
  Georgian: 'geor',
  Glagolitic: 'glag',
  Gothic: 'goth',
  Grantha: 'gran',
  Greek: 'grek',
  Gujarati: ['gjr2', 'gujr'],
  Gurmukhi: ['gur2', 'guru'],
  Hangul: 'hang',
  Han: 'hani',
  Hanunoo: 'hano',
  Hebrew: 'hebr',
  Hiragana: 'hira',
  Pahawh_Hmong: 'hmng',
  Katakana_Or_Hiragana: 'hrkt',
  Old_Italic: 'ital',
  Javanese: 'java',
  Kayah_Li: 'kali',
  Katakana: 'kana',
  Kharoshthi: 'khar',
  Khmer: 'khmr',
  Khojki: 'khoj',
  Kannada: ['knd2', 'knda'],
  Kaithi: 'kthi',
  Tai_Tham: 'lana',
  Lao: 'lao ',
  Latin: 'latn',
  Lepcha: 'lepc',
  Limbu: 'limb',
  Linear_A: 'lina',
  Linear_B: 'linb',
  Lisu: 'lisu',
  Lycian: 'lyci',
  Lydian: 'lydi',
  Mahajani: 'mahj',
  Mandaic: 'mand',
  Manichaean: 'mani',
  Mende_Kikakui: 'mend',
  Meroitic_Cursive: 'merc',
  Meroitic_Hieroglyphs: 'mero',
  Malayalam: ['mlm2', 'mlym'],
  Modi: 'modi',
  Mongolian: 'mong',
  Mro: 'mroo',
  Meetei_Mayek: 'mtei',
  Myanmar: ['mym2', 'mymr'],
  Old_North_Arabian: 'narb',
  Nabataean: 'nbat',
  Nko: 'nko ',
  Ogham: 'ogam',
  Ol_Chiki: 'olck',
  Old_Turkic: 'orkh',
  Oriya: ['ory2', 'orya'],
  Osmanya: 'osma',
  Palmyrene: 'palm',
  Pau_Cin_Hau: 'pauc',
  Old_Permic: 'perm',
  Phags_Pa: 'phag',
  Inscriptional_Pahlavi: 'phli',
  Psalter_Pahlavi: 'phlp',
  Phoenician: 'phnx',
  Miao: 'plrd',
  Inscriptional_Parthian: 'prti',
  Rejang: 'rjng',
  Runic: 'runr',
  Samaritan: 'samr',
  Old_South_Arabian: 'sarb',
  Saurashtra: 'saur',
  Shavian: 'shaw',
  Sharada: 'shrd',
  Siddham: 'sidd',
  Khudawadi: 'sind',
  Sinhala: 'sinh',
  Sora_Sompeng: 'sora',
  Sundanese: 'sund',
  Syloti_Nagri: 'sylo',
  Syriac: 'syrc',
  Tagbanwa: 'tagb',
  Takri: 'takr',
  Tai_Le: 'tale',
  New_Tai_Lue: 'talu',
  Tamil: ['tml2', 'taml'],
  Tai_Viet: 'tavt',
  Telugu: ['tel2', 'telu'],
  Tifinagh: 'tfng',
  Tagalog: 'tglg',
  Thaana: 'thaa',
  Thai: 'thai',
  Tibetan: 'tibt',
  Tirhuta: 'tirh',
  Ugaritic: 'ugar',
  Vai: 'vai ',
  Warang_Citi: 'wara',
  Old_Persian: 'xpeo',
  Cuneiform: 'xsux',
  Yi: 'yi  ',
  Inherited: 'zinh',
  Common: 'zyyy',
  Unknown: 'zzzz'
};

var OPENTYPE_SCRIPTS = {};
for (var script in UNICODE_SCRIPTS) {
  var tag = UNICODE_SCRIPTS[script];
  if (Array.isArray(tag)) {
    for (var _iterator = tag, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var t = _ref;

      OPENTYPE_SCRIPTS[t] = script;
    }
  } else {
    OPENTYPE_SCRIPTS[tag] = script;
  }
}

function fromOpenType(tag) {
  return OPENTYPE_SCRIPTS[tag];
}

function forString(string) {
  var len = string.length;
  var idx = 0;
  while (idx < len) {
    var code = string.charCodeAt(idx++);

    // Check if this is a high surrogate
    if (0xd800 <= code && code <= 0xdbff && idx < len) {
      var next = string.charCodeAt(idx);

      // Check if this is a low surrogate
      if (0xdc00 <= next && next <= 0xdfff) {
        idx++;
        code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
      }
    }

    var _script = unicode.getScript(code);
    if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') {
      return UNICODE_SCRIPTS[_script];
    }
  }

  return UNICODE_SCRIPTS.Unknown;
}

function forCodePoints(codePoints) {
  for (var i = 0; i < codePoints.length; i++) {
    var codePoint = codePoints[i];
    var _script2 = unicode.getScript(codePoint);
    if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') {
      return UNICODE_SCRIPTS[_script2];
    }
  }

  return UNICODE_SCRIPTS.Unknown;
}

// The scripts in this map are written from right to left
var RTL = {
  arab: true, // Arabic
  hebr: true, // Hebrew
  syrc: true, // Syriac
  thaa: true, // Thaana
  cprt: true, // Cypriot Syllabary
  khar: true, // Kharosthi
  phnx: true, // Phoenician
  'nko ': true, // N'Ko
  lydi: true, // Lydian
  avst: true, // Avestan
  armi: true, // Imperial Aramaic
  phli: true, // Inscriptional Pahlavi
  prti: true, // Inscriptional Parthian
  sarb: true, // Old South Arabian
  orkh: true, // Old Turkic, Orkhon Runic
  samr: true, // Samaritan
  mand: true, // Mandaic, Mandaean
  merc: true, // Meroitic Cursive
  mero: true, // Meroitic Hieroglyphs

  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
  mani: true, // Manichaean
  mend: true, // Mende Kikakui
  nbat: true, // Nabataean
  narb: true, // Old North Arabian
  palm: true, // Palmyrene
  phlp: true // Psalter Pahlavi
};

function direction(script) {
  if (RTL[script]) {
    return 'rtl';
  }

  return 'ltr';
}

/**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */

var GlyphRun = function () {
  function GlyphRun(glyphs, features, script, language, direction$$) {
    _classCallCheck(this, GlyphRun);

    /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */
    this.glyphs = glyphs;

    /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */
    this.positions = null;

    /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */
    this.script = script;

    /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */
    this.language = language || null;

    /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */
    this.direction = direction$$ || direction(script);

    /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */
    this.features = {};

    // Convert features to an object
    if (Array.isArray(features)) {
      for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var tag = _ref;

        this.features[tag] = true;
      }
    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
      this.features = features;
    }
  }

  /**
   * The total advance width of the run.
   * @type {number}
   */


  _createClass(GlyphRun, [{
    key: 'advanceWidth',
    get: function get() {
      var width = 0;
      for (var _iterator2 = this.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var position = _ref2;

        width += position.xAdvance;
      }

      return width;
    }

    /**
     * The total advance height of the run.
     * @type {number}
     */

  }, {
    key: 'advanceHeight',
    get: function get() {
      var height = 0;
      for (var _iterator3 = this.positions, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var position = _ref3;

        height += position.yAdvance;
      }

      return height;
    }

    /**
     * The bounding box containing all glyphs in the run.
     * @type {BBox}
     */

  }, {
    key: 'bbox',
    get: function get() {
      var bbox = new BBox();

      var x = 0;
      var y = 0;
      for (var index = 0; index < this.glyphs.length; index++) {
        var glyph = this.glyphs[index];
        var p = this.positions[index];
        var b = glyph.bbox;

        bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
        bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);

        x += p.xAdvance;
        y += p.yAdvance;
      }

      return bbox;
    }
  }]);

  return GlyphRun;
}();

/**
 * Represents positioning information for a glyph in a GlyphRun.
 */
var GlyphPosition = function GlyphPosition() {
  var xAdvance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var yAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var xOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var yOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  _classCallCheck(this, GlyphPosition);

  /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */
  this.xAdvance = xAdvance;

  /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */
  this.yAdvance = yAdvance;

  /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */
  this.xOffset = xOffset;

  /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */
  this.yOffset = yOffset;
};

// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
var features = {
  allTypographicFeatures: {
    code: 0,
    exclusive: false,
    allTypeFeatures: 0
  },
  ligatures: {
    code: 1,
    exclusive: false,
    requiredLigatures: 0,
    commonLigatures: 2,
    rareLigatures: 4,
    // logos: 6
    rebusPictures: 8,
    diphthongLigatures: 10,
    squaredLigatures: 12,
    abbrevSquaredLigatures: 14,
    symbolLigatures: 16,
    contextualLigatures: 18,
    historicalLigatures: 20
  },
  cursiveConnection: {
    code: 2,
    exclusive: true,
    unconnected: 0,
    partiallyConnected: 1,
    cursive: 2
  },
  letterCase: {
    code: 3,
    exclusive: true
  },
  // upperAndLowerCase: 0          # deprecated
  // allCaps: 1                    # deprecated
  // allLowerCase: 2               # deprecated
  // smallCaps: 3                  # deprecated
  // initialCaps: 4                # deprecated
  // initialCapsAndSmallCaps: 5    # deprecated
  verticalSubstitution: {
    code: 4,
    exclusive: false,
    substituteVerticalForms: 0
  },
  linguisticRearrangement: {
    code: 5,
    exclusive: false,
    linguisticRearrangement: 0
  },
  numberSpacing: {
    code: 6,
    exclusive: true,
    monospacedNumbers: 0,
    proportionalNumbers: 1,
    thirdWidthNumbers: 2,
    quarterWidthNumbers: 3
  },
  smartSwash: {
    code: 8,
    exclusive: false,
    wordInitialSwashes: 0,
    wordFinalSwashes: 2,
    // lineInitialSwashes: 4
    // lineFinalSwashes: 6
    nonFinalSwashes: 8
  },
  diacritics: {
    code: 9,
    exclusive: true,
    showDiacritics: 0,
    hideDiacritics: 1,
    decomposeDiacritics: 2
  },
  verticalPosition: {
    code: 10,
    exclusive: true,
    normalPosition: 0,
    superiors: 1,
    inferiors: 2,
    ordinals: 3,
    scientificInferiors: 4
  },
  fractions: {
    code: 11,
    exclusive: true,
    noFractions: 0,
    verticalFractions: 1,
    diagonalFractions: 2
  },
  overlappingCharacters: {
    code: 13,
    exclusive: false,
    preventOverlap: 0
  },
  typographicExtras: {
    code: 14,
    exclusive: false,
    // hyphensToEmDash: 0
    // hyphenToEnDash: 2
    slashedZero: 4
  },
  // formInterrobang: 6
  // smartQuotes: 8
  // periodsToEllipsis: 10
  mathematicalExtras: {
    code: 15,
    exclusive: false,
    // hyphenToMinus: 0
    // asteristoMultiply: 2
    // slashToDivide: 4
    // inequalityLigatures: 6
    // exponents: 8
    mathematicalGreek: 10
  },
  ornamentSets: {
    code: 16,
    exclusive: true,
    noOrnaments: 0,
    dingbats: 1,
    piCharacters: 2,
    fleurons: 3,
    decorativeBorders: 4,
    internationalSymbols: 5,
    mathSymbols: 6
  },
  characterAlternatives: {
    code: 17,
    exclusive: true,
    noAlternates: 0
  },
  // user defined options
  designComplexity: {
    code: 18,
    exclusive: true,
    designLevel1: 0,
    designLevel2: 1,
    designLevel3: 2,
    designLevel4: 3,
    designLevel5: 4
  },
  styleOptions: {
    code: 19,
    exclusive: true,
    noStyleOptions: 0,
    displayText: 1,
    engravedText: 2,
    illuminatedCaps: 3,
    titlingCaps: 4,
    tallCaps: 5
  },
  characterShape: {
    code: 20,
    exclusive: true,
    traditionalCharacters: 0,
    simplifiedCharacters: 1,
    JIS1978Characters: 2,
    JIS1983Characters: 3,
    JIS1990Characters: 4,
    traditionalAltOne: 5,
    traditionalAltTwo: 6,
    traditionalAltThree: 7,
    traditionalAltFour: 8,
    traditionalAltFive: 9,
    expertCharacters: 10,
    JIS2004Characters: 11,
    hojoCharacters: 12,
    NLCCharacters: 13,
    traditionalNamesCharacters: 14
  },
  numberCase: {
    code: 21,
    exclusive: true,
    lowerCaseNumbers: 0,
    upperCaseNumbers: 1
  },
  textSpacing: {
    code: 22,
    exclusive: true,
    proportionalText: 0,
    monospacedText: 1,
    halfWidthText: 2,
    thirdWidthText: 3,
    quarterWidthText: 4,
    altProportionalText: 5,
    altHalfWidthText: 6
  },
  transliteration: {
    code: 23,
    exclusive: true,
    noTransliteration: 0
  },
  // hanjaToHangul: 1
  // hiraganaToKatakana: 2
  // katakanaToHiragana: 3
  // kanaToRomanization: 4
  // romanizationToHiragana: 5
  // romanizationToKatakana: 6
  // hanjaToHangulAltOne: 7
  // hanjaToHangulAltTwo: 8
  // hanjaToHangulAltThree: 9
  annotation: {
    code: 24,
    exclusive: true,
    noAnnotation: 0,
    boxAnnotation: 1,
    roundedBoxAnnotation: 2,
    circleAnnotation: 3,
    invertedCircleAnnotation: 4,
    parenthesisAnnotation: 5,
    periodAnnotation: 6,
    romanNumeralAnnotation: 7,
    diamondAnnotation: 8,
    invertedBoxAnnotation: 9,
    invertedRoundedBoxAnnotation: 10
  },
  kanaSpacing: {
    code: 25,
    exclusive: true,
    fullWidthKana: 0,
    proportionalKana: 1
  },
  ideographicSpacing: {
    code: 26,
    exclusive: true,
    fullWidthIdeographs: 0,
    proportionalIdeographs: 1,
    halfWidthIdeographs: 2
  },
  unicodeDecomposition: {
    code: 27,
    exclusive: false,
    canonicalComposition: 0,
    compatibilityComposition: 2,
    transcodingComposition: 4
  },
  rubyKana: {
    code: 28,
    exclusive: false,
    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
    // rubyKana: 1     # deprecated - use rubyKanaOn instead
    rubyKana: 2
  },
  CJKSymbolAlternatives: {
    code: 29,
    exclusive: true,
    noCJKSymbolAlternatives: 0,
    CJKSymbolAltOne: 1,
    CJKSymbolAltTwo: 2,
    CJKSymbolAltThree: 3,
    CJKSymbolAltFour: 4,
    CJKSymbolAltFive: 5
  },
  ideographicAlternatives: {
    code: 30,
    exclusive: true,
    noIdeographicAlternatives: 0,
    ideographicAltOne: 1,
    ideographicAltTwo: 2,
    ideographicAltThree: 3,
    ideographicAltFour: 4,
    ideographicAltFive: 5
  },
  CJKVerticalRomanPlacement: {
    code: 31,
    exclusive: true,
    CJKVerticalRomanCentered: 0,
    CJKVerticalRomanHBaseline: 1
  },
  italicCJKRoman: {
    code: 32,
    exclusive: false,
    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
    CJKItalicRoman: 2
  },
  caseSensitiveLayout: {
    code: 33,
    exclusive: false,
    caseSensitiveLayout: 0,
    caseSensitiveSpacing: 2
  },
  alternateKana: {
    code: 34,
    exclusive: false,
    alternateHorizKana: 0,
    alternateVertKana: 2
  },
  stylisticAlternatives: {
    code: 35,
    exclusive: false,
    noStylisticAlternates: 0,
    stylisticAltOne: 2,
    stylisticAltTwo: 4,
    stylisticAltThree: 6,
    stylisticAltFour: 8,
    stylisticAltFive: 10,
    stylisticAltSix: 12,
    stylisticAltSeven: 14,
    stylisticAltEight: 16,
    stylisticAltNine: 18,
    stylisticAltTen: 20,
    stylisticAltEleven: 22,
    stylisticAltTwelve: 24,
    stylisticAltThirteen: 26,
    stylisticAltFourteen: 28,
    stylisticAltFifteen: 30,
    stylisticAltSixteen: 32,
    stylisticAltSeventeen: 34,
    stylisticAltEighteen: 36,
    stylisticAltNineteen: 38,
    stylisticAltTwenty: 40
  },
  contextualAlternates: {
    code: 36,
    exclusive: false,
    contextualAlternates: 0,
    swashAlternates: 2,
    contextualSwashAlternates: 4
  },
  lowerCase: {
    code: 37,
    exclusive: true,
    defaultLowerCase: 0,
    lowerCaseSmallCaps: 1,
    lowerCasePetiteCaps: 2
  },
  upperCase: {
    code: 38,
    exclusive: true,
    defaultUpperCase: 0,
    upperCaseSmallCaps: 1,
    upperCasePetiteCaps: 2
  },
  languageTag: { // indices into ltag table
    code: 39,
    exclusive: true
  },
  CJKRomanSpacing: {
    code: 103,
    exclusive: true,
    halfWidthCJKRoman: 0,
    proportionalCJKRoman: 1,
    defaultCJKRoman: 2,
    fullWidthCJKRoman: 3
  }
};

var feature = function feature(name, selector) {
  return [features[name].code, features[name][selector]];
};

var OTMapping = {
  rlig: feature('ligatures', 'requiredLigatures'),
  clig: feature('ligatures', 'contextualLigatures'),
  dlig: feature('ligatures', 'rareLigatures'),
  hlig: feature('ligatures', 'historicalLigatures'),
  liga: feature('ligatures', 'commonLigatures'),
  hist: feature('ligatures', 'historicalLigatures'), // ??

  smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
  pcap: feature('lowerCase', 'lowerCasePetiteCaps'),

  frac: feature('fractions', 'diagonalFractions'),
  dnom: feature('fractions', 'diagonalFractions'), // ??
  numr: feature('fractions', 'diagonalFractions'), // ??
  afrc: feature('fractions', 'verticalFractions'),
  // aalt
  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
  // unic, vatu, vhal, vjmo, vpal, vrt2
  // dist -> trak table?
  // kern, vkrn -> kern table
  // lfbd + opbd + rtbd -> opbd table?
  // mark, mkmk -> acnt table?
  // locl -> languageTag + ltag table

  case: feature('caseSensitiveLayout', 'caseSensitiveLayout'), // also caseSensitiveSpacing
  ccmp: feature('unicodeDecomposition', 'canonicalComposition'), // compatibilityComposition?
  cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'), // guess..., probably not given below
  valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
  swsh: feature('contextualAlternates', 'swashAlternates'),
  cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
  curs: feature('cursiveConnection', 'cursive'), // ??
  c2pc: feature('upperCase', 'upperCasePetiteCaps'),
  c2sc: feature('upperCase', 'upperCaseSmallCaps'),

  init: feature('smartSwash', 'wordInitialSwashes'), // ??
  fin2: feature('smartSwash', 'wordFinalSwashes'), // ??
  medi: feature('smartSwash', 'nonFinalSwashes'), // ??
  med2: feature('smartSwash', 'nonFinalSwashes'), // ??
  fin3: feature('smartSwash', 'wordFinalSwashes'), // ??
  fina: feature('smartSwash', 'wordFinalSwashes'), // ??

  pkna: feature('kanaSpacing', 'proportionalKana'),
  half: feature('textSpacing', 'halfWidthText'), // also HalfWidthCJKRoman, HalfWidthIdeographs?
  halt: feature('textSpacing', 'altHalfWidthText'),

  hkna: feature('alternateKana', 'alternateHorizKana'),
  vkna: feature('alternateKana', 'alternateVertKana'),
  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated

  ital: feature('italicCJKRoman', 'CJKItalicRoman'),
  lnum: feature('numberCase', 'upperCaseNumbers'),
  onum: feature('numberCase', 'lowerCaseNumbers'),
  mgrk: feature('mathematicalExtras', 'mathematicalGreek'),

  // nalt: not enough info. what type of annotation?
  // ornm: ditto, which ornament style?

  calt: feature('contextualAlternates', 'contextualAlternates'), // or more?
  vrt2: feature('verticalSubstitution', 'substituteVerticalForms'), // oh... below?
  vert: feature('verticalSubstitution', 'substituteVerticalForms'),
  tnum: feature('numberSpacing', 'monospacedNumbers'),
  pnum: feature('numberSpacing', 'proportionalNumbers'),
  sups: feature('verticalPosition', 'superiors'),
  subs: feature('verticalPosition', 'inferiors'),
  ordn: feature('verticalPosition', 'ordinals'),
  pwid: feature('textSpacing', 'proportionalText'),
  hwid: feature('textSpacing', 'halfWidthText'),
  qwid: feature('textSpacing', 'quarterWidthText'), // also QuarterWidthNumbers?
  twid: feature('textSpacing', 'thirdWidthText'), // also ThirdWidthNumbers?
  fwid: feature('textSpacing', 'proportionalText'), //??
  palt: feature('textSpacing', 'altProportionalText'),
  trad: feature('characterShape', 'traditionalCharacters'),
  smpl: feature('characterShape', 'simplifiedCharacters'),
  jp78: feature('characterShape', 'JIS1978Characters'),
  jp83: feature('characterShape', 'JIS1983Characters'),
  jp90: feature('characterShape', 'JIS1990Characters'),
  jp04: feature('characterShape', 'JIS2004Characters'),
  expt: feature('characterShape', 'expertCharacters'),
  hojo: feature('characterShape', 'hojoCharacters'),
  nlck: feature('characterShape', 'NLCCharacters'),
  tnam: feature('characterShape', 'traditionalNamesCharacters'),
  ruby: feature('rubyKana', 'rubyKana'),
  titl: feature('styleOptions', 'titlingCaps'),
  zero: feature('typographicExtras', 'slashedZero'),

  ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
  ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
  ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
  ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
  ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
  ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
  ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
  ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
  ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
  ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
  ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
  ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
  ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
  ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
  ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
  ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
  ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
  ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
  ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
  ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
};

// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose

// Add cv01-cv99 features
for (var i = 1; i <= 99; i++) {
  OTMapping['cv' + ('00' + i).slice(-2)] = [features.characterAlternatives.code, i];
}

// create inverse mapping
var AATMapping = {};
for (var ot in OTMapping) {
  var aat = OTMapping[ot];
  if (AATMapping[aat[0]] == null) {
    AATMapping[aat[0]] = {};
  }

  AATMapping[aat[0]][aat[1]] = ot;
}

// Maps an array of OpenType features to AAT features
// in the form of {featureType:{featureSetting:true}}
function mapOTToAAT(features) {
  var res = {};
  for (var k in features) {
    var r = void 0;
    if (r = OTMapping[k]) {
      if (res[r[0]] == null) {
        res[r[0]] = {};
      }

      res[r[0]][r[1]] = features[k];
    }
  }

  return res;
}

// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function mapFeatureStrings(f) {
  var type = f[0],
      setting = f[1];

  if (isNaN(type)) {
    var typeCode = features[type] && features[type].code;
  } else {
    var typeCode = type;
  }

  if (isNaN(setting)) {
    var settingCode = features[type] && features[type][setting];
  } else {
    var settingCode = setting;
  }

  return [typeCode, settingCode];
}

// Maps AAT features to an array of OpenType features
// Supports both arrays in the form of [[featureType, featureSetting]]
// and objects in the form of {featureType:{featureSetting:true}}
// featureTypes and featureSettings can be either strings or number codes
function mapAATToOT(features) {
  var res = {};
  if (Array.isArray(features)) {
    for (var k = 0; k < features.length; k++) {
      var r = void 0;
      var f = mapFeatureStrings(features[k]);
      if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) {
        res[r] = true;
      }
    }
  } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
    for (var type in features) {
      var _feature = features[type];
      for (var setting in _feature) {
        var _r = void 0;
        var _f = mapFeatureStrings([type, setting]);
        if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) {
          res[_r] = true;
        }
      }
    }
  }

  return _Object$keys(res);
}

var _class$3;
function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AATLookupTable = (_class$3 = function () {
  function AATLookupTable(table) {
    _classCallCheck(this, AATLookupTable);

    this.table = table;
  }

  AATLookupTable.prototype.lookup = function lookup(glyph) {
    switch (this.table.version) {
      case 0:
        // simple array format
        return this.table.values.getItem(glyph);

      case 2: // segment format
      case 4:
        {
          var min = 0;
          var max = this.table.binarySearchHeader.nUnits - 1;

          while (min <= max) {
            var mid = min + max >> 1;
            var seg = this.table.segments[mid];

            // special end of search value
            if (seg.firstGlyph === 0xffff) {
              return null;
            }

            if (glyph < seg.firstGlyph) {
              max = mid - 1;
            } else if (glyph > seg.lastGlyph) {
              min = mid + 1;
            } else {
              if (this.table.version === 2) {
                return seg.value;
              } else {
                return seg.values[glyph - seg.firstGlyph];
              }
            }
          }

          return null;
        }

      case 6:
        {
          // lookup single
          var _min = 0;
          var _max = this.table.binarySearchHeader.nUnits - 1;

          while (_min <= _max) {
            var mid = _min + _max >> 1;
            var seg = this.table.segments[mid];

            // special end of search value
            if (seg.glyph === 0xffff) {
              return null;
            }

            if (glyph < seg.glyph) {
              _max = mid - 1;
            } else if (glyph > seg.glyph) {
              _min = mid + 1;
            } else {
              return seg.value;
            }
          }

          return null;
        }

      case 8:
        // lookup trimmed
        return this.table.values[glyph - this.table.firstGlyph];

      default:
        throw new Error('Unknown lookup table format: ' + this.table.version);
    }
  };

  AATLookupTable.prototype.glyphsForValue = function glyphsForValue(classValue) {
    var res = [];

    switch (this.table.version) {
      case 2: // segment format
      case 4:
        {
          for (var _iterator = this.table.segments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var segment = _ref;

            if (this.table.version === 2 && segment.value === classValue) {
              res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
            } else {
              for (var index = 0; index < segment.values.length; index++) {
                if (segment.values[index] === classValue) {
                  res.push(segment.firstGlyph + index);
                }
              }
            }
          }

          break;
        }

      case 6:
        {
          // lookup single
          for (var _iterator2 = this.table.segments, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var _segment = _ref2;

            if (_segment.value === classValue) {
              res.push(_segment.glyph);
            }
          }

          break;
        }

      case 8:
        {
          // lookup trimmed
          for (var i = 0; i < this.table.values.length; i++) {
            if (this.table.values[i] === classValue) {
              res.push(this.table.firstGlyph + i);
            }
          }

          break;
        }

      default:
        throw new Error('Unknown lookup table format: ' + this.table.version);
    }

    return res;
  };

  return AATLookupTable;
}(), (_applyDecoratedDescriptor$3(_class$3.prototype, 'glyphsForValue', [cache], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'glyphsForValue'), _class$3.prototype)), _class$3);

var START_OF_TEXT_STATE = 0;
var END_OF_TEXT_CLASS = 0;
var OUT_OF_BOUNDS_CLASS = 1;
var DELETED_GLYPH_CLASS = 2;
var DONT_ADVANCE = 0x4000;

var AATStateMachine = function () {
  function AATStateMachine(stateTable) {
    _classCallCheck(this, AATStateMachine);

    this.stateTable = stateTable;
    this.lookupTable = new AATLookupTable(stateTable.classTable);
  }

  AATStateMachine.prototype.process = function process(glyphs, reverse, processEntry) {
    var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
    var index = reverse ? glyphs.length - 1 : 0;
    var dir = reverse ? -1 : 1;

    while (dir === 1 && index <= glyphs.length || dir === -1 && index >= -1) {
      var glyph = null;
      var classCode = OUT_OF_BOUNDS_CLASS;
      var shouldAdvance = true;

      if (index === glyphs.length || index === -1) {
        classCode = END_OF_TEXT_CLASS;
      } else {
        glyph = glyphs[index];
        if (glyph.id === 0xffff) {
          // deleted glyph
          classCode = DELETED_GLYPH_CLASS;
        } else {
          classCode = this.lookupTable.lookup(glyph.id);
          if (classCode == null) {
            classCode = OUT_OF_BOUNDS_CLASS;
          }
        }
      }

      var row = this.stateTable.stateArray.getItem(currentState);
      var entryIndex = row[classCode];
      var entry = this.stateTable.entryTable.getItem(entryIndex);

      if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
        processEntry(glyph, entry, index);
        shouldAdvance = !(entry.flags & DONT_ADVANCE);
      }

      currentState = entry.newState;
      if (shouldAdvance) {
        index += dir;
      }
    }

    return glyphs;
  };

  /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */


  AATStateMachine.prototype.traverse = function traverse(opts) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Set();

    if (visited.has(state)) {
      return;
    }

    visited.add(state);

    var _stateTable = this.stateTable,
        nClasses = _stateTable.nClasses,
        stateArray = _stateTable.stateArray,
        entryTable = _stateTable.entryTable;

    var row = stateArray.getItem(state);

    // Skip predefined classes
    for (var classCode = 4; classCode < nClasses; classCode++) {
      var entryIndex = row[classCode];
      var entry = entryTable.getItem(entryIndex);

      // Try all glyphs in the class
      for (var _iterator = this.lookupTable.glyphsForValue(classCode), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var glyph = _ref;

        if (opts.enter) {
          opts.enter(glyph, entry);
        }

        if (entry.newState !== 0) {
          this.traverse(opts, entry.newState, visited);
        }

        if (opts.exit) {
          opts.exit(glyph, entry);
        }
      }
    }
  };

  return AATStateMachine;
}();

var _class$2;
function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

// indic replacement flags
var MARK_FIRST = 0x8000;
var MARK_LAST = 0x2000;
var VERB = 0x000F;

// contextual substitution and glyph insertion flag
var SET_MARK = 0x8000;

// ligature entry flags
var SET_COMPONENT = 0x8000;
var PERFORM_ACTION = 0x2000;

// ligature action masks
var LAST_MASK = 0x80000000;
var STORE_MASK = 0x40000000;
var OFFSET_MASK = 0x3FFFFFFF;

var REVERSE_DIRECTION = 0x400000;
var CURRENT_INSERT_BEFORE = 0x0800;
var MARKED_INSERT_BEFORE = 0x0400;
var CURRENT_INSERT_COUNT = 0x03E0;
var MARKED_INSERT_COUNT = 0x001F;

var AATMorxProcessor = (_class$2 = function () {
  function AATMorxProcessor(font) {
    _classCallCheck(this, AATMorxProcessor);

    this.processIndicRearragement = this.processIndicRearragement.bind(this);
    this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
    this.processLigature = this.processLigature.bind(this);
    this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
    this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
    this.font = font;
    this.morx = font.morx;
    this.inputCache = null;
  }

  // Processes an array of glyphs and applies the specified features
  // Features should be in the form of {featureType:{featureSetting:true}}


  AATMorxProcessor.prototype.process = function process(glyphs) {
    var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var _iterator = this.morx.chains, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var chain = _ref;

      var flags = chain.defaultFlags;

      // enable/disable the requested features
      for (var _iterator2 = chain.features, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var feature = _ref2;

        var f = void 0;
        if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
          flags &= feature.disableFlags;
          flags |= feature.enableFlags;
        }
      }

      for (var _iterator3 = chain.subtables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var subtable = _ref3;

        if (subtable.subFeatureFlags & flags) {
          this.processSubtable(subtable, glyphs);
        }
      }
    }

    // remove deleted glyphs
    var index = glyphs.length - 1;
    while (index >= 0) {
      if (glyphs[index].id === 0xffff) {
        glyphs.splice(index, 1);
      }

      index--;
    }

    return glyphs;
  };

  AATMorxProcessor.prototype.processSubtable = function processSubtable(subtable, glyphs) {
    this.subtable = subtable;
    this.glyphs = glyphs;
    if (this.subtable.type === 4) {
      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
      return;
    }

    this.ligatureStack = [];
    this.markedGlyph = null;
    this.firstGlyph = null;
    this.lastGlyph = null;
    this.markedIndex = null;

    var stateMachine = this.getStateMachine(subtable);
    var process = this.getProcessor();

    var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
    return stateMachine.process(this.glyphs, reverse, process);
  };

  AATMorxProcessor.prototype.getStateMachine = function getStateMachine(subtable) {
    return new AATStateMachine(subtable.table.stateTable);
  };

  AATMorxProcessor.prototype.getProcessor = function getProcessor() {
    switch (this.subtable.type) {
      case 0:
        return this.processIndicRearragement;
      case 1:
        return this.processContextualSubstitution;
      case 2:
        return this.processLigature;
      case 4:
        return this.processNoncontextualSubstitutions;
      case 5:
        return this.processGlyphInsertion;
      default:
        throw new Error('Invalid morx subtable type: ' + this.subtable.type);
    }
  };

  AATMorxProcessor.prototype.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
    if (entry.flags & MARK_FIRST) {
      this.firstGlyph = index;
    }

    if (entry.flags & MARK_LAST) {
      this.lastGlyph = index;
    }

    reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
  };

  AATMorxProcessor.prototype.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
    var subsitutions = this.subtable.table.substitutionTable.items;
    if (entry.markIndex !== 0xffff) {
      var lookup = subsitutions.getItem(entry.markIndex);
      var lookupTable = new AATLookupTable(lookup);
      glyph = this.glyphs[this.markedGlyph];
      var gid = lookupTable.lookup(glyph.id);
      if (gid) {
        this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
      }
    }

    if (entry.currentIndex !== 0xffff) {
      var _lookup = subsitutions.getItem(entry.currentIndex);
      var _lookupTable = new AATLookupTable(_lookup);
      glyph = this.glyphs[index];
      var gid = _lookupTable.lookup(glyph.id);
      if (gid) {
        this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
      }
    }

    if (entry.flags & SET_MARK) {
      this.markedGlyph = index;
    }
  };

  AATMorxProcessor.prototype.processLigature = function processLigature(glyph, entry, index) {
    if (entry.flags & SET_COMPONENT) {
      this.ligatureStack.push(index);
    }

    if (entry.flags & PERFORM_ACTION) {
      var _ligatureStack;

      var actions = this.subtable.table.ligatureActions;
      var components = this.subtable.table.components;
      var ligatureList = this.subtable.table.ligatureList;

      var actionIndex = entry.action;
      var last = false;
      var ligatureIndex = 0;
      var codePoints = [];
      var ligatureGlyphs = [];

      while (!last) {
        var _codePoints;

        var componentGlyph = this.ligatureStack.pop();
        (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);

        var action = actions.getItem(actionIndex++);
        last = !!(action & LAST_MASK);
        var store = !!(action & STORE_MASK);
        var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
        offset += this.glyphs[componentGlyph].id;

        var component = components.getItem(offset);
        ligatureIndex += component;

        if (last || store) {
          var ligatureEntry = ligatureList.getItem(ligatureIndex);
          this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
          ligatureGlyphs.push(componentGlyph);
          ligatureIndex = 0;
          codePoints = [];
        } else {
          this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
        }
      }

      // Put ligature glyph indexes back on the stack
      (_ligatureStack = this.ligatureStack).push.apply(_ligatureStack, ligatureGlyphs);
    }
  };

  AATMorxProcessor.prototype.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
    var lookupTable = new AATLookupTable(subtable.table.lookupTable);

    for (index = 0; index < glyphs.length; index++) {
      var glyph = glyphs[index];
      if (glyph.id !== 0xffff) {
        var gid = lookupTable.lookup(glyph.id);
        if (gid) {
          // 0 means do nothing
          glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
      }
    }
  };

  AATMorxProcessor.prototype._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
    var _glyphs;

    var insertions = [];
    while (count--) {
      var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
      insertions.push(this.font.getGlyph(gid));
    }

    if (!isBefore) {
      glyphIndex++;
    }

    (_glyphs = this.glyphs).splice.apply(_glyphs, [glyphIndex, 0].concat(insertions));
  };

  AATMorxProcessor.prototype.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
    if (entry.flags & SET_MARK) {
      this.markedIndex = index;
    }

    if (entry.markedInsertIndex !== 0xffff) {
      var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
      var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
      this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
    }

    if (entry.currentInsertIndex !== 0xffff) {
      var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
      var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
      this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
    }
  };

  AATMorxProcessor.prototype.getSupportedFeatures = function getSupportedFeatures() {
    var features = [];
    for (var _iterator4 = this.morx.chains, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var chain = _ref4;

      for (var _iterator5 = chain.features, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var feature = _ref5;

        features.push([feature.featureType, feature.featureSetting]);
      }
    }

    return features;
  };

  AATMorxProcessor.prototype.generateInputs = function generateInputs(gid) {
    if (!this.inputCache) {
      this.generateInputCache();
    }

    return this.inputCache[gid] || [];
  };

  AATMorxProcessor.prototype.generateInputCache = function generateInputCache() {
    this.inputCache = {};

    for (var _iterator6 = this.morx.chains, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
      var _ref6;

      if (_isArray6) {
        if (_i6 >= _iterator6.length) break;
        _ref6 = _iterator6[_i6++];
      } else {
        _i6 = _iterator6.next();
        if (_i6.done) break;
        _ref6 = _i6.value;
      }

      var chain = _ref6;

      var flags = chain.defaultFlags;

      for (var _iterator7 = chain.subtables, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var subtable = _ref7;

        if (subtable.subFeatureFlags & flags) {
          this.generateInputsForSubtable(subtable);
        }
      }
    }
  };

  AATMorxProcessor.prototype.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
    var _this = this;

    // Currently, only supporting ligature subtables.
    if (subtable.type !== 2) {
      return;
    }

    var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
    if (reverse) {
      throw new Error('Reverse subtable, not supported.');
    }

    this.subtable = subtable;
    this.ligatureStack = [];

    var stateMachine = this.getStateMachine(subtable);
    var process = this.getProcessor();

    var input = [];
    var stack = [];
    this.glyphs = [];

    stateMachine.traverse({
      enter: function enter(glyph, entry) {
        var glyphs = _this.glyphs;
        stack.push({
          glyphs: glyphs.slice(),
          ligatureStack: _this.ligatureStack.slice()
        });

        // Add glyph to input and glyphs to process.
        var g = _this.font.getGlyph(glyph);
        input.push(g);
        glyphs.push(input[input.length - 1]);

        // Process ligature substitution
        process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);

        // Add input to result if only one matching (non-deleted) glyph remains.
        var count = 0;
        var found = 0;
        for (var i = 0; i < glyphs.length && count <= 1; i++) {
          if (glyphs[i].id !== 0xffff) {
            count++;
            found = glyphs[i].id;
          }
        }

        if (count === 1) {
          var result = input.map(function (g) {
            return g.id;
          });
          var _cache = _this.inputCache[found];
          if (_cache) {
            _cache.push(result);
          } else {
            _this.inputCache[found] = [result];
          }
        }
      },

      exit: function exit() {
        var _stack$pop = stack.pop();

        _this.glyphs = _stack$pop.glyphs;
        _this.ligatureStack = _stack$pop.ligatureStack;

        input.pop();
      }
    });
  };

  return AATMorxProcessor;
}(), (_applyDecoratedDescriptor$2(_class$2.prototype, 'getStateMachine', [cache], _Object$getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype)), _class$2);

function swap(glyphs, rangeA, rangeB) {
  var reverseA = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var reverseB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
  if (reverseB) {
    end.reverse();
  }

  var start = glyphs.splice.apply(glyphs, [rangeA[0], rangeA[1]].concat(end));
  if (reverseA) {
    start.reverse();
  }

  glyphs.splice.apply(glyphs, [rangeB[0] - (rangeA[1] - 1), 0].concat(start));
  return glyphs;
}

function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
  var length = lastGlyph - firstGlyph + 1;
  switch (verb) {
    case 0:
      // no change
      return glyphs;

    case 1:
      // Ax => xA
      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 0]);

    case 2:
      // xD => Dx
      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 1]);

    case 3:
      // AxD => DxA
      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 1]);

    case 4:
      // ABx => xAB
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0]);

    case 5:
      // ABx => xBA
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0], true, false);

    case 6:
      // xCD => CDx
      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2]);

    case 7:
      // xCD => DCx
      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2], false, true);

    case 8:
      // AxCD => CDxA
      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2]);

    case 9:
      // AxCD => DCxA
      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2], false, true);

    case 10:
      // ABxD => DxAB
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1]);

    case 11:
      // ABxD => DxBA
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1], true, false);

    case 12:
      // ABxCD => CDxAB
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2]);

    case 13:
      // ABxCD => CDxBA
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, false);

    case 14:
      // ABxCD => DCxAB
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], false, true);

    case 15:
      // ABxCD => DCxBA
      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, true);

    default:
      throw new Error('Unknown verb: ' + verb);
  }
}

var AATLayoutEngine = function () {
  function AATLayoutEngine(font) {
    _classCallCheck(this, AATLayoutEngine);

    this.font = font;
    this.morxProcessor = new AATMorxProcessor(font);
    this.fallbackPosition = false;
  }

  AATLayoutEngine.prototype.substitute = function substitute(glyphRun) {
    // AAT expects the glyphs to be in visual order prior to morx processing,
    // so reverse the glyphs if the script is right-to-left.
    if (glyphRun.direction === 'rtl') {
      glyphRun.glyphs.reverse();
    }

    this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
  };

  AATLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
    return mapAATToOT(this.morxProcessor.getSupportedFeatures());
  };

  AATLayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
    var glyphStrings = this.morxProcessor.generateInputs(gid);
    var result = new _Set();

    for (var _iterator = glyphStrings, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var glyphs = _ref;

      this._addStrings(glyphs, 0, result, '');
    }

    return result;
  };

  AATLayoutEngine.prototype._addStrings = function _addStrings(glyphs, index, strings, string) {
    var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);

    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var codePoint = _ref2;

      var s = string + _String$fromCodePoint(codePoint);
      if (index < glyphs.length - 1) {
        this._addStrings(glyphs, index + 1, strings, s);
      } else {
        strings.add(s);
      }
    }
  };

  return AATLayoutEngine;
}();

/**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */

var ShapingPlan = function () {
  function ShapingPlan(font, script, direction) {
    _classCallCheck(this, ShapingPlan);

    this.font = font;
    this.script = script;
    this.direction = direction;
    this.stages = [];
    this.globalFeatures = {};
    this.allFeatures = {};
  }

  /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */


  ShapingPlan.prototype._addFeatures = function _addFeatures(features, global) {
    var stageIndex = this.stages.length - 1;
    var stage = this.stages[stageIndex];
    for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var feature = _ref;

      if (this.allFeatures[feature] == null) {
        stage.push(feature);
        this.allFeatures[feature] = stageIndex;

        if (global) {
          this.globalFeatures[feature] = true;
        }
      }
    }
  };

  /**
   * Add features to the last stage
   */


  ShapingPlan.prototype.add = function add(arg) {
    var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (this.stages.length === 0) {
      this.stages.push([]);
    }

    if (typeof arg === 'string') {
      arg = [arg];
    }

    if (Array.isArray(arg)) {
      this._addFeatures(arg, global);
    } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
      this._addFeatures(arg.global || [], true);
      this._addFeatures(arg.local || [], false);
    } else {
      throw new Error("Unsupported argument to ShapingPlan#add");
    }
  };

  /**
   * Add a new stage
   */


  ShapingPlan.prototype.addStage = function addStage(arg, global) {
    if (typeof arg === 'function') {
      this.stages.push(arg, []);
    } else {
      this.stages.push([]);
      this.add(arg, global);
    }
  };

  ShapingPlan.prototype.setFeatureOverrides = function setFeatureOverrides(features) {
    if (Array.isArray(features)) {
      this.add(features);
    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
      for (var tag in features) {
        if (features[tag]) {
          this.add(tag);
        } else if (this.allFeatures[tag] != null) {
          var stage = this.stages[this.allFeatures[tag]];
          stage.splice(stage.indexOf(tag), 1);
          delete this.allFeatures[tag];
          delete this.globalFeatures[tag];
        }
      }
    }
  };

  /**
   * Assigns the global features to the given glyphs
   */


  ShapingPlan.prototype.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
    for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var glyph = _ref2;

      for (var feature in this.globalFeatures) {
        glyph.features[feature] = true;
      }
    }
  };

  /**
   * Executes the planned stages using the given OTProcessor
   */


  ShapingPlan.prototype.process = function process(processor, glyphs, positions) {
    for (var _iterator3 = this.stages, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var stage = _ref3;

      if (typeof stage === 'function') {
        if (!positions) {
          stage(this.font, glyphs, this);
        }
      } else if (stage.length > 0) {
        processor.applyFeatures(stage, glyphs, positions);
      }
    }
  };

  return ShapingPlan;
}();

var _class$4;
var _temp;
var VARIATION_FEATURES = ['rvrn'];
var COMMON_FEATURES = ['ccmp', 'locl', 'rlig', 'mark', 'mkmk'];
var FRACTIONAL_FEATURES = ['frac', 'numr', 'dnom'];
var HORIZONTAL_FEATURES = ['calt', 'clig', 'liga', 'rclt', 'curs', 'kern'];
var DIRECTIONAL_FEATURES = {
  ltr: ['ltra', 'ltrm'],
  rtl: ['rtla', 'rtlm']
};

var DefaultShaper = (_temp = _class$4 = function () {
  function DefaultShaper() {
    _classCallCheck(this, DefaultShaper);
  }

  DefaultShaper.plan = function plan(_plan, glyphs, features) {
    // Plan the features we want to apply
    this.planPreprocessing(_plan);
    this.planFeatures(_plan);
    this.planPostprocessing(_plan, features);

    // Assign the global features to all the glyphs
    _plan.assignGlobalFeatures(glyphs);

    // Assign local features to glyphs
    this.assignFeatures(_plan, glyphs);
  };

  DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
    plan.add({
      global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
      local: FRACTIONAL_FEATURES
    });
  };

  DefaultShaper.planFeatures = function planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
  };

  DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
    plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
    plan.setFeatureOverrides(userFeatures);
  };

  DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
    // Enable contextual fractions
    for (var i = 0; i < glyphs.length; i++) {
      var glyph = glyphs[i];
      if (glyph.codePoints[0] === 0x2044) {
        // fraction slash
        var start = i;
        var end = i + 1;

        // Apply numerator
        while (start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])) {
          glyphs[start - 1].features.numr = true;
          glyphs[start - 1].features.frac = true;
          start--;
        }

        // Apply denominator
        while (end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])) {
          glyphs[end].features.dnom = true;
          glyphs[end].features.frac = true;
          end++;
        }

        // Apply fraction slash
        glyph.features.frac = true;
        i = end - 1;
      }
    }
  };

  return DefaultShaper;
}(), _class$4.zeroMarkWidths = 'AFTER_GPOS', _temp);

var trie = new UnicodeTrie(Buffer("AAEQAAAAAAAAADGgAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=","base64"));
var FEATURES = ['isol', 'fina', 'fin2', 'fin3', 'medi', 'med2', 'init'];

var ShapingClasses = {
  Non_Joining: 0,
  Left_Joining: 1,
  Right_Joining: 2,
  Dual_Joining: 3,
  Join_Causing: 3,
  ALAPH: 4,
  'DALATH RISH': 5,
  Transparent: 6
};

var ISOL = 'isol';
var FINA = 'fina';
var FIN2 = 'fin2';
var FIN3 = 'fin3';
var MEDI = 'medi';
var MED2 = 'med2';
var INIT = 'init';
var NONE = null;

// Each entry is [prevAction, curAction, nextState]
var STATE_TABLE = [
//   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
// State 0: prev was U,  not willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 6]],

// State 1: prev was R or ISOL/ALAPH,  not willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN2, 5], [NONE, ISOL, 6]],

// State 2: prev was D/L in ISOL form,  willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [INIT, FINA, 1], [INIT, FINA, 3], [INIT, FINA, 4], [INIT, FINA, 6]],

// State 3: prev was D in FINA form,  willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [MEDI, FINA, 1], [MEDI, FINA, 3], [MEDI, FINA, 4], [MEDI, FINA, 6]],

// State 4: prev was FINA ALAPH,  not willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [MED2, ISOL, 1], [MED2, ISOL, 2], [MED2, FIN2, 5], [MED2, ISOL, 6]],

// State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [ISOL, ISOL, 1], [ISOL, ISOL, 2], [ISOL, FIN2, 5], [ISOL, ISOL, 6]],

// State 6: prev was DALATH/RISH,  not willing to join.
[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN3, 5], [NONE, ISOL, 6]]];

/**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */

var ArabicShaper = function (_DefaultShaper) {
  _inherits(ArabicShaper, _DefaultShaper);

  function ArabicShaper() {
    _classCallCheck(this, ArabicShaper);

    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
  }

  ArabicShaper.planFeatures = function planFeatures(plan) {
    plan.add(['ccmp', 'locl']);
    for (var i = 0; i < FEATURES.length; i++) {
      var feature = FEATURES[i];
      plan.addStage(feature, false);
    }

    plan.addStage('mset');
  };

  ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
    _DefaultShaper.assignFeatures.call(this, plan, glyphs);

    var prev = -1;
    var state = 0;
    var actions = [];

    // Apply the state machine to map glyphs to features
    for (var i = 0; i < glyphs.length; i++) {
      var curAction = void 0,
          prevAction = void 0;
      var glyph = glyphs[i];
      var type = getShapingClass(glyph.codePoints[0]);
      if (type === ShapingClasses.Transparent) {
        actions[i] = NONE;
        continue;
      }

      var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
      prevAction = _STATE_TABLE$state$ty[0];
      curAction = _STATE_TABLE$state$ty[1];
      state = _STATE_TABLE$state$ty[2];


      if (prevAction !== NONE && prev !== -1) {
        actions[prev] = prevAction;
      }

      actions[i] = curAction;
      prev = i;
    }

    // Apply the chosen features to their respective glyphs
    for (var index = 0; index < glyphs.length; index++) {
      var feature = void 0;
      var glyph = glyphs[index];
      if (feature = actions[index]) {
        glyph.features[feature] = true;
      }
    }
  };

  return ArabicShaper;
}(DefaultShaper);

function getShapingClass(codePoint) {
  var res = trie.get(codePoint);
  if (res) {
    return res - 1;
  }

  var category = unicode.getCategory(codePoint);
  if (category === 'Mn' || category === 'Me' || category === 'Cf') {
    return ShapingClasses.Transparent;
  }

  return ShapingClasses.Non_Joining;
}

var GlyphIterator = function () {
  function GlyphIterator(glyphs, options) {
    _classCallCheck(this, GlyphIterator);

    this.glyphs = glyphs;
    this.reset(options);
  }

  GlyphIterator.prototype.reset = function reset() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    this.options = options;
    this.flags = options.flags || {};
    this.markAttachmentType = options.markAttachmentType || 0;
    this.index = index;
  };

  GlyphIterator.prototype.shouldIgnore = function shouldIgnore(glyph) {
    return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
  };

  GlyphIterator.prototype.move = function move(dir) {
    this.index += dir;
    while (0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) {
      this.index += dir;
    }

    if (0 > this.index || this.index >= this.glyphs.length) {
      return null;
    }

    return this.glyphs[this.index];
  };

  GlyphIterator.prototype.next = function next() {
    return this.move(+1);
  };

  GlyphIterator.prototype.prev = function prev() {
    return this.move(-1);
  };

  GlyphIterator.prototype.peek = function peek() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var idx = this.index;
    var res = this.increment(count);
    this.index = idx;
    return res;
  };

  GlyphIterator.prototype.peekIndex = function peekIndex() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var idx = this.index;
    this.increment(count);
    var res = this.index;
    this.index = idx;
    return res;
  };

  GlyphIterator.prototype.increment = function increment() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var dir = count < 0 ? -1 : 1;
    count = Math.abs(count);
    while (count--) {
      this.move(dir);
    }

    return this.glyphs[this.index];
  };

  _createClass(GlyphIterator, [{
    key: "cur",
    get: function get() {
      return this.glyphs[this.index] || null;
    }
  }]);

  return GlyphIterator;
}();

var DEFAULT_SCRIPTS = ['DFLT', 'dflt', 'latn'];

var OTProcessor = function () {
  function OTProcessor(font, table) {
    _classCallCheck(this, OTProcessor);

    this.font = font;
    this.table = table;

    this.script = null;
    this.scriptTag = null;

    this.language = null;
    this.languageTag = null;

    this.features = {};
    this.lookups = {};

    // Setup variation substitutions
    this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;

    // initialize to default script + language
    this.selectScript();

    // current context (set by applyFeatures)
    this.glyphs = [];
    this.positions = []; // only used by GPOS
    this.ligatureID = 1;
    this.currentFeature = null;
  }

  OTProcessor.prototype.findScript = function findScript(script) {
    if (this.table.scriptList == null) {
      return null;
    }

    if (!Array.isArray(script)) {
      script = [script];
    }

    for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var s = _ref;

      for (var _iterator2 = this.table.scriptList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var entry = _ref2;

        if (entry.tag === s) {
          return entry;
        }
      }
    }

    return null;
  };

  OTProcessor.prototype.selectScript = function selectScript(script, language, direction$$) {
    var changed = false;
    var entry = void 0;
    if (!this.script || script !== this.scriptTag) {
      entry = this.findScript(script);
      if (!entry) {
        entry = this.findScript(DEFAULT_SCRIPTS);
      }

      if (!entry) {
        return this.scriptTag;
      }

      this.scriptTag = entry.tag;
      this.script = entry.script;
      this.language = null;
      this.languageTag = null;
      changed = true;
    }

    if (!direction$$ || direction$$ !== this.direction) {
      this.direction = direction$$ || direction(script);
    }

    if (language && language.length < 4) {
      language += ' '.repeat(4 - language.length);
    }

    if (!language || language !== this.languageTag) {
      this.language = null;

      for (var _iterator3 = this.script.langSysRecords, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var lang = _ref3;

        if (lang.tag === language) {
          this.language = lang.langSys;
          this.languageTag = lang.tag;
          break;
        }
      }

      if (!this.language) {
        this.language = this.script.defaultLangSys;
        this.languageTag = null;
      }

      changed = true;
    }

    // Build a feature lookup table
    if (changed) {
      this.features = {};
      if (this.language) {
        for (var _iterator4 = this.language.featureIndexes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
          var _ref4;

          if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
          } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
          }

          var featureIndex = _ref4;

          var record = this.table.featureList[featureIndex];
          var substituteFeature = this.substituteFeatureForVariations(featureIndex);
          this.features[record.tag] = substituteFeature || record.feature;
        }
      }
    }

    return this.scriptTag;
  };

  OTProcessor.prototype.lookupsForFeatures = function lookupsForFeatures() {
    var userFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var exclude = arguments[1];

    var lookups = [];
    for (var _iterator5 = userFeatures, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
      var _ref5;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref5 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref5 = _i5.value;
      }

      var tag = _ref5;

      var feature = this.features[tag];
      if (!feature) {
        continue;
      }

      for (var _iterator6 = feature.lookupListIndexes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
        var _ref6;

        if (_isArray6) {
          if (_i6 >= _iterator6.length) break;
          _ref6 = _iterator6[_i6++];
        } else {
          _i6 = _iterator6.next();
          if (_i6.done) break;
          _ref6 = _i6.value;
        }

        var lookupIndex = _ref6;

        if (exclude && exclude.indexOf(lookupIndex) !== -1) {
          continue;
        }

        lookups.push({
          feature: tag,
          index: lookupIndex,
          lookup: this.table.lookupList.get(lookupIndex)
        });
      }
    }

    lookups.sort(function (a, b) {
      return a.index - b.index;
    });
    return lookups;
  };

  OTProcessor.prototype.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
    if (this.variationsIndex === -1) {
      return null;
    }

    var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
    var substitutions = record.featureTableSubstitution.substitutions;
    for (var _iterator7 = substitutions, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
      var _ref7;

      if (_isArray7) {
        if (_i7 >= _iterator7.length) break;
        _ref7 = _iterator7[_i7++];
      } else {
        _i7 = _iterator7.next();
        if (_i7.done) break;
        _ref7 = _i7.value;
      }

      var substitution = _ref7;

      if (substitution.featureIndex === featureIndex) {
        return substitution.alternateFeatureTable;
      }
    }

    return null;
  };

  OTProcessor.prototype.findVariationsIndex = function findVariationsIndex(coords) {
    var variations = this.table.featureVariations;
    if (!variations) {
      return -1;
    }

    var records = variations.featureVariationRecords;
    for (var i = 0; i < records.length; i++) {
      var conditions = records[i].conditionSet.conditionTable;
      if (this.variationConditionsMatch(conditions, coords)) {
        return i;
      }
    }

    return -1;
  };

  OTProcessor.prototype.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
    return conditions.every(function (condition) {
      var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
      return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
    });
  };

  OTProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
    var lookups = this.lookupsForFeatures(userFeatures);
    this.applyLookups(lookups, glyphs, advances);
  };

  OTProcessor.prototype.applyLookups = function applyLookups(lookups, glyphs, positions) {
    this.glyphs = glyphs;
    this.positions = positions;
    this.glyphIterator = new GlyphIterator(glyphs);

    for (var _iterator8 = lookups, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _getIterator(_iterator8);;) {
      var _ref8;

      if (_isArray8) {
        if (_i8 >= _iterator8.length) break;
        _ref8 = _iterator8[_i8++];
      } else {
        _i8 = _iterator8.next();
        if (_i8.done) break;
        _ref8 = _i8.value;
      }

      var _ref9 = _ref8,
          feature = _ref9.feature,
          lookup = _ref9.lookup;

      this.currentFeature = feature;
      this.glyphIterator.reset(lookup.flags);

      while (this.glyphIterator.index < glyphs.length) {
        if (!(feature in this.glyphIterator.cur.features)) {
          this.glyphIterator.next();
          continue;
        }

        for (var _iterator9 = lookup.subTables, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _getIterator(_iterator9);;) {
          var _ref10;

          if (_isArray9) {
            if (_i9 >= _iterator9.length) break;
            _ref10 = _iterator9[_i9++];
          } else {
            _i9 = _iterator9.next();
            if (_i9.done) break;
            _ref10 = _i9.value;
          }

          var table = _ref10;

          var res = this.applyLookup(lookup.lookupType, table);
          if (res) {
            break;
          }
        }

        this.glyphIterator.next();
      }
    }
  };

  OTProcessor.prototype.applyLookup = function applyLookup(lookup, table) {
    throw new Error("applyLookup must be implemented by subclasses");
  };

  OTProcessor.prototype.applyLookupList = function applyLookupList(lookupRecords) {
    var options = this.glyphIterator.options;
    var glyphIndex = this.glyphIterator.index;

    for (var _iterator10 = lookupRecords, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _getIterator(_iterator10);;) {
      var _ref11;

      if (_isArray10) {
        if (_i10 >= _iterator10.length) break;
        _ref11 = _iterator10[_i10++];
      } else {
        _i10 = _iterator10.next();
        if (_i10.done) break;
        _ref11 = _i10.value;
      }

      var lookupRecord = _ref11;

      // Reset flags and find glyph index for this lookup record
      this.glyphIterator.reset(options, glyphIndex);
      this.glyphIterator.increment(lookupRecord.sequenceIndex);

      // Get the lookup and setup flags for subtables
      var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
      this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);

      // Apply lookup subtables until one matches
      for (var _iterator11 = lookup.subTables, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _getIterator(_iterator11);;) {
        var _ref12;

        if (_isArray11) {
          if (_i11 >= _iterator11.length) break;
          _ref12 = _iterator11[_i11++];
        } else {
          _i11 = _iterator11.next();
          if (_i11.done) break;
          _ref12 = _i11.value;
        }

        var table = _ref12;

        if (this.applyLookup(lookup.lookupType, table)) {
          break;
        }
      }
    }

    this.glyphIterator.reset(options, glyphIndex);
    return true;
  };

  OTProcessor.prototype.coverageIndex = function coverageIndex(coverage, glyph) {
    if (glyph == null) {
      glyph = this.glyphIterator.cur.id;
    }

    switch (coverage.version) {
      case 1:
        return coverage.glyphs.indexOf(glyph);

      case 2:
        for (var _iterator12 = coverage.rangeRecords, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _getIterator(_iterator12);;) {
          var _ref13;

          if (_isArray12) {
            if (_i12 >= _iterator12.length) break;
            _ref13 = _iterator12[_i12++];
          } else {
            _i12 = _iterator12.next();
            if (_i12.done) break;
            _ref13 = _i12.value;
          }

          var range = _ref13;

          if (range.start <= glyph && glyph <= range.end) {
            return range.startCoverageIndex + glyph - range.start;
          }
        }

        break;
    }

    return -1;
  };

  OTProcessor.prototype.match = function match(sequenceIndex, sequence, fn, matched) {
    var pos = this.glyphIterator.index;
    var glyph = this.glyphIterator.increment(sequenceIndex);
    var idx = 0;

    while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
      if (matched) {
        matched.push(this.glyphIterator.index);
      }

      idx++;
      glyph = this.glyphIterator.next();
    }

    this.glyphIterator.index = pos;
    if (idx < sequence.length) {
      return false;
    }

    return matched || true;
  };

  OTProcessor.prototype.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
    return this.match(sequenceIndex, sequence, function (component, glyph) {
      return component === glyph.id;
    });
  };

  OTProcessor.prototype.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
    var _this = this;

    return this.match(sequenceIndex, sequence, function (component, glyph) {
      // If the current feature doesn't apply to this glyph,
      if (!(_this.currentFeature in glyph.features)) {
        return false;
      }

      return component === glyph.id;
    }, []);
  };

  OTProcessor.prototype.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
    var _this2 = this;

    return this.match(sequenceIndex, sequence, function (coverage, glyph) {
      return _this2.coverageIndex(coverage, glyph.id) >= 0;
    });
  };

  OTProcessor.prototype.getClassID = function getClassID(glyph, classDef) {
    switch (classDef.version) {
      case 1:
        // Class array
        var i = glyph - classDef.startGlyph;
        if (i >= 0 && i < classDef.classValueArray.length) {
          return classDef.classValueArray[i];
        }

        break;

      case 2:
        for (var _iterator13 = classDef.classRangeRecord, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _getIterator(_iterator13);;) {
          var _ref14;

          if (_isArray13) {
            if (_i13 >= _iterator13.length) break;
            _ref14 = _iterator13[_i13++];
          } else {
            _i13 = _iterator13.next();
            if (_i13.done) break;
            _ref14 = _i13.value;
          }

          var range = _ref14;

          if (range.start <= glyph && glyph <= range.end) {
            return range.class;
          }
        }

        break;
    }

    return 0;
  };

  OTProcessor.prototype.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
    var _this3 = this;

    return this.match(sequenceIndex, sequence, function (classID, glyph) {
      return classID === _this3.getClassID(glyph.id, classDef);
    });
  };

  OTProcessor.prototype.applyContext = function applyContext(table) {
    switch (table.version) {
      case 1:
        var index = this.coverageIndex(table.coverage);
        if (index === -1) {
          return false;
        }

        var set = table.ruleSets[index];
        for (var _iterator14 = set, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _getIterator(_iterator14);;) {
          var _ref15;

          if (_isArray14) {
            if (_i14 >= _iterator14.length) break;
            _ref15 = _iterator14[_i14++];
          } else {
            _i14 = _iterator14.next();
            if (_i14.done) break;
            _ref15 = _i14.value;
          }

          var rule = _ref15;

          if (this.sequenceMatches(1, rule.input)) {
            return this.applyLookupList(rule.lookupRecords);
          }
        }

        break;

      case 2:
        if (this.coverageIndex(table.coverage) === -1) {
          return false;
        }

        index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
        if (index === -1) {
          return false;
        }

        set = table.classSet[index];
        for (var _iterator15 = set, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _getIterator(_iterator15);;) {
          var _ref16;

          if (_isArray15) {
            if (_i15 >= _iterator15.length) break;
            _ref16 = _iterator15[_i15++];
          } else {
            _i15 = _iterator15.next();
            if (_i15.done) break;
            _ref16 = _i15.value;
          }

          var _rule = _ref16;

          if (this.classSequenceMatches(1, _rule.classes, table.classDef)) {
            return this.applyLookupList(_rule.lookupRecords);
          }
        }

        break;

      case 3:
        if (this.coverageSequenceMatches(0, table.coverages)) {
          return this.applyLookupList(table.lookupRecords);
        }

        break;
    }

    return false;
  };

  OTProcessor.prototype.applyChainingContext = function applyChainingContext(table) {
    switch (table.version) {
      case 1:
        var index = this.coverageIndex(table.coverage);
        if (index === -1) {
          return false;
        }

        var set = table.chainRuleSets[index];
        for (var _iterator16 = set, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _getIterator(_iterator16);;) {
          var _ref17;

          if (_isArray16) {
            if (_i16 >= _iterator16.length) break;
            _ref17 = _iterator16[_i16++];
          } else {
            _i16 = _iterator16.next();
            if (_i16.done) break;
            _ref17 = _i16.value;
          }

          var rule = _ref17;

          if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) {
            return this.applyLookupList(rule.lookupRecords);
          }
        }

        break;

      case 2:
        if (this.coverageIndex(table.coverage) === -1) {
          return false;
        }

        index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
        var rules = table.chainClassSet[index];
        if (!rules) {
          return false;
        }

        for (var _iterator17 = rules, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _getIterator(_iterator17);;) {
          var _ref18;

          if (_isArray17) {
            if (_i17 >= _iterator17.length) break;
            _ref18 = _iterator17[_i17++];
          } else {
            _i17 = _iterator17.next();
            if (_i17.done) break;
            _ref18 = _i17.value;
          }

          var _rule2 = _ref18;

          if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) {
            return this.applyLookupList(_rule2.lookupRecords);
          }
        }

        break;

      case 3:
        if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) {
          return this.applyLookupList(table.lookupRecords);
        }

        break;
    }

    return false;
  };

  return OTProcessor;
}();

var GlyphInfo = function () {
  function GlyphInfo(font, id) {
    var codePoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var features = arguments[3];

    _classCallCheck(this, GlyphInfo);

    this._font = font;
    this.codePoints = codePoints;
    this.id = id;

    this.features = {};
    if (Array.isArray(features)) {
      for (var i = 0; i < features.length; i++) {
        var feature = features[i];
        this.features[feature] = true;
      }
    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
      _Object$assign(this.features, features);
    }

    this.ligatureID = null;
    this.ligatureComponent = null;
    this.isLigated = false;
    this.cursiveAttachment = null;
    this.markAttachment = null;
    this.shaperInfo = null;
    this.substituted = false;
    this.isMultiplied = false;
  }

  GlyphInfo.prototype.copy = function copy() {
    return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
  };

  _createClass(GlyphInfo, [{
    key: 'id',
    get: function get() {
      return this._id;
    },
    set: function set(id) {
      this._id = id;
      this.substituted = true;

      var GDEF = this._font.GDEF;
      if (GDEF && GDEF.glyphClassDef) {
        // TODO: clean this up
        var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
        this.isBase = classID === 1;
        this.isLigature = classID === 2;
        this.isMark = classID === 3;
        this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
      } else {
        this.isMark = this.codePoints.every(unicode.isMark);
        this.isBase = !this.isMark;
        this.isLigature = this.codePoints.length > 1;
        this.markAttachmentType = 0;
      }
    }
  }]);

  return GlyphInfo;
}();

var _class$5;
var _temp$1;
/**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */
var HangulShaper = (_temp$1 = _class$5 = function (_DefaultShaper) {
  _inherits(HangulShaper, _DefaultShaper);

  function HangulShaper() {
    _classCallCheck(this, HangulShaper);

    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
  }

  HangulShaper.planFeatures = function planFeatures(plan) {
    plan.add(['ljmo', 'vjmo', 'tjmo'], false);
  };

  HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
    var state = 0;
    var i = 0;
    while (i < glyphs.length) {
      var action = void 0;
      var glyph = glyphs[i];
      var code = glyph.codePoints[0];
      var type = getType(code);

      var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
      action = _STATE_TABLE$state$ty[0];
      state = _STATE_TABLE$state$ty[1];


      switch (action) {
        case DECOMPOSE:
          // Decompose the composed syllable if it is not supported by the font.
          if (!plan.font.hasGlyphForCodePoint(code)) {
            i = decompose(glyphs, i, plan.font);
          }
          break;

        case COMPOSE:
          // Found a decomposed syllable. Try to compose if supported by the font.
          i = compose(glyphs, i, plan.font);
          break;

        case TONE_MARK:
          // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
          reorderToneMark(glyphs, i, plan.font);
          break;

        case INVALID:
          // Tone mark has no valid syllable to attach to, so insert a dotted circle
          i = insertDottedCircle(glyphs, i, plan.font);
          break;
      }

      i++;
    }
  };

  return HangulShaper;
}(DefaultShaper), _class$5.zeroMarkWidths = 'NONE', _temp$1);
var HANGUL_BASE = 0xac00;
var HANGUL_END = 0xd7a4;
var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
var L_BASE = 0x1100; // lead
var V_BASE = 0x1161; // vowel
var T_BASE = 0x11a7; // trail
var L_COUNT = 19;
var V_COUNT = 21;
var T_COUNT = 28;
var L_END = L_BASE + L_COUNT - 1;
var V_END = V_BASE + V_COUNT - 1;
var T_END = T_BASE + T_COUNT - 1;
var DOTTED_CIRCLE = 0x25cc;

var isL = function isL(code) {
  return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
};
var isV = function isV(code) {
  return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
};
var isT = function isT(code) {
  return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
};
var isTone = function isTone(code) {
  return 0x302e <= code && code <= 0x302f;
};
var isLVT = function isLVT(code) {
  return HANGUL_BASE <= code && code <= HANGUL_END;
};
var isLV = function isLV(code) {
  return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
};
var isCombiningL = function isCombiningL(code) {
  return L_BASE <= code && code <= L_END;
};
var isCombiningV = function isCombiningV(code) {
  return V_BASE <= code && code <= V_END;
};
var isCombiningT = function isCombiningT(code) {
  return T_BASE + 1 && 1 <= code && code <= T_END;
};

// Character categories
var X = 0; // Other character
var L = 1; // Leading consonant
var V = 2; // Medial vowel
var T = 3; // Trailing consonant
var LV = 4; // Composed <LV> syllable
var LVT = 5; // Composed <LVT> syllable
var M = 6; // Tone mark

// This function classifies a character using the above categories.
function getType(code) {
  if (isL(code)) {
    return L;
  }
  if (isV(code)) {
    return V;
  }
  if (isT(code)) {
    return T;
  }
  if (isLV(code)) {
    return LV;
  }
  if (isLVT(code)) {
    return LVT;
  }
  if (isTone(code)) {
    return M;
  }
  return X;
}

// State machine actions
var NO_ACTION = 0;
var DECOMPOSE = 1;
var COMPOSE = 2;
var TONE_MARK = 4;
var INVALID = 5;

// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
var STATE_TABLE$1 = [
//       X                 L                 V                T                  LV                LVT               M
// State 0: start state
[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],

// State 1: <L>
[[NO_ACTION, 0], [NO_ACTION, 1], [COMPOSE, 2], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],

// State 2: <L,V> or <LV>
[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [COMPOSE, 3], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]],

// State 3: <L,V,T> or <LVT>
[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]]];

function getGlyph(font, code, features) {
  return new GlyphInfo(font, font.glyphForCodePoint(code).id, [code], features);
}

function decompose(glyphs, i, font) {
  var glyph = glyphs[i];
  var code = glyph.codePoints[0];

  var s = code - HANGUL_BASE;
  var t = T_BASE + s % T_COUNT;
  s = s / T_COUNT | 0;
  var l = L_BASE + s / V_COUNT | 0;
  var v = V_BASE + s % V_COUNT;

  // Don't decompose if all of the components are not available
  if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) {
    return i;
  }

  // Replace the current glyph with decomposed L, V, and T glyphs,
  // and apply the proper OpenType features to each component.
  var ljmo = getGlyph(font, l, glyph.features);
  ljmo.features.ljmo = true;

  var vjmo = getGlyph(font, v, glyph.features);
  vjmo.features.vjmo = true;

  var insert = [ljmo, vjmo];

  if (t > T_BASE) {
    var tjmo = getGlyph(font, t, glyph.features);
    tjmo.features.tjmo = true;
    insert.push(tjmo);
  }

  glyphs.splice.apply(glyphs, [i, 1].concat(insert));
  return i + insert.length - 1;
}

function compose(glyphs, i, font) {
  var glyph = glyphs[i];
  var code = glyphs[i].codePoints[0];
  var type = getType(code);

  var prev = glyphs[i - 1].codePoints[0];
  var prevType = getType(prev);

  // Figure out what type of syllable we're dealing with
  var lv = void 0,
      ljmo = void 0,
      vjmo = void 0,
      tjmo = void 0;
  if (prevType === LV && type === T) {
    // <LV,T>
    lv = prev;
    tjmo = glyph;
  } else {
    if (type === V) {
      // <L,V>
      ljmo = glyphs[i - 1];
      vjmo = glyph;
    } else {
      // <L,V,T>
      ljmo = glyphs[i - 2];
      vjmo = glyphs[i - 1];
      tjmo = glyph;
    }

    var l = ljmo.codePoints[0];
    var v = vjmo.codePoints[0];

    // Make sure L and V are combining characters
    if (isCombiningL(l) && isCombiningV(v)) {
      lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
    }
  }

  var t = tjmo && tjmo.codePoints[0] || T_BASE;
  if (lv != null && (t === T_BASE || isCombiningT(t))) {
    var s = lv + (t - T_BASE);

    // Replace with a composed glyph if supported by the font,
    // otherwise apply the proper OpenType features to each component.
    if (font.hasGlyphForCodePoint(s)) {
      var del = prevType === V ? 3 : 2;
      glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
      return i - del + 1;
    }
  }

  // Didn't compose (either a non-combining component or unsupported by font).
  if (ljmo) {
    ljmo.features.ljmo = true;
  }
  if (vjmo) {
    vjmo.features.vjmo = true;
  }
  if (tjmo) {
    tjmo.features.tjmo = true;
  }

  if (prevType === LV) {
    // Sequence was originally <L,V>, which got combined earlier.
    // Either the T was non-combining, or the LVT glyph wasn't supported.
    // Decompose the glyph again and apply OT features.
    decompose(glyphs, i - 1, font);
    return i + 1;
  }

  return i;
}

function getLength(code) {
  switch (getType(code)) {
    case LV:
    case LVT:
      return 1;
    case V:
      return 2;
    case T:
      return 3;
  }
}

function reorderToneMark(glyphs, i, font) {
  var glyph = glyphs[i];
  var code = glyphs[i].codePoints[0];

  // Move tone mark to the beginning of the previous syllable, unless it is zero width
  if (font.glyphForCodePoint(code).advanceWidth === 0) {
    return;
  }

  var prev = glyphs[i - 1].codePoints[0];
  var len = getLength(prev);

  glyphs.splice(i, 1);
  return glyphs.splice(i - len, 0, glyph);
}

function insertDottedCircle(glyphs, i, font) {
  var glyph = glyphs[i];
  var code = glyphs[i].codePoints[0];

  if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
    var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features);

    // If the tone mark is zero width, insert the dotted circle before, otherwise after
    var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
    glyphs.splice(idx, 0, dottedCircle);
    i++;
  }

  return i;
}

var stateTable = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16, 17], [0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0, 37, 0], [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0], [0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0, 62, 0], [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0], [0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0], [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0, 0], [0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0, 0], [0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110, 0, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 0, 0], [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0], [0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0], [0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 150, 0, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0, 75, 16, 0], [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0], [0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124, 0, 0], [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0], [0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0, 0], [0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178, 0, 0], [0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0], [0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0, 0, 0], [0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0, 0], [0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0], [0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0], [0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 249, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0, 0, 0], [0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0, 75, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0], [0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273, 0, 0], [0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0], [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0, 0, 0], [0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 340, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355, 0, 0], [0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0], [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0], [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410, 0, 0], [0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0, 0], [0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0], [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0], [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451, 0, 0], [0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0, 0, 0], [0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0], [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460, 0, 0], [0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0, 0, 0], [0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0], [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0], [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 482, 0, 0], [0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0, 0, 0], [0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0], [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0], [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0], [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530, 0, 0], [0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0, 0], [0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0], [0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0], [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0], [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556, 0, 0], [0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0, 0, 0], [0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562, 0, 0], [0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0, 0, 0], [0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0], [0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 578, 0, 0], [0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0, 0, 0], [0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0], [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0], [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0, 0], [0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0], [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0, 0, 0], [0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0, 0, 0], [0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0, 0, 0], [0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0]];
var accepting = [false, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, false, false, true, false, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, false, false, true, true, false, false, true, true, true, false, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, false, false, false, false, false, false, false, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, false, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, false, true, true, true];
var tags = [[], ["broken_cluster"], ["consonant_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["symbol_cluster"], [], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], ["consonant_syllable"], ["vowel_syllable"], ["standalone_cluster"]];
var indicMachine = {
	stateTable: stateTable,
	accepting: accepting,
	tags: tags
};

var categories = ["O", "IND", "S", "GB", "B", "FM", "CGJ", "VMAbv", "VMPst", "VAbv", "VPst", "CMBlw", "VPre", "VBlw", "H", "VMBlw", "CMAbv", "MBlw", "CS", "R", "SUB", "MPst", "MPre", "FAbv", "FPst", "FBlw", "SMAbv", "SMBlw", "VMPre", "ZWNJ", "ZWJ", "WJ", "VS", "N", "HN", "MAbv"];
var decompositions$1 = { "2507": [2503, 2494], "2508": [2503, 2519], "2888": [2887, 2902], "2891": [2887, 2878], "2892": [2887, 2903], "3018": [3014, 3006], "3019": [3015, 3006], "3020": [3014, 3031], "3144": [3142, 3158], "3264": [3263, 3285], "3271": [3270, 3285], "3272": [3270, 3286], "3274": [3270, 3266], "3275": [3270, 3266, 3285], "3402": [3398, 3390], "3403": [3399, 3390], "3404": [3398, 3415], "3546": [3545, 3530], "3548": [3545, 3535], "3549": [3545, 3535, 3530], "3550": [3545, 3551], "3635": [3661, 3634], "3763": [3789, 3762], "3955": [3953, 3954], "3957": [3953, 3956], "3958": [4018, 3968], "3959": [4018, 3953, 3968], "3960": [4019, 3968], "3961": [4019, 3953, 3968], "3969": [3953, 3968], "6971": [6970, 6965], "6973": [6972, 6965], "6976": [6974, 6965], "6977": [6975, 6965], "6979": [6978, 6965], "69934": [69937, 69927], "69935": [69938, 69927], "70475": [70471, 70462], "70476": [70471, 70487], "70843": [70841, 70842], "70844": [70841, 70832], "70846": [70841, 70845], "71098": [71096, 71087], "71099": [71097, 71087] };
var stateTable$1 = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 2, 0, 24, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 27, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 39, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 49, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 53, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0]];
var accepting$1 = [false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true];
var tags$1 = [[], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["virama_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["number_joiner_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["numeral_cluster"]];
var useData = {
	categories: categories,
	decompositions: decompositions$1,
	stateTable: stateTable$1,
	accepting: accepting$1,
	tags: tags$1
};

// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
var CATEGORIES = {
  X: 1 << 0,
  C: 1 << 1,
  V: 1 << 2,
  N: 1 << 3,
  H: 1 << 4,
  ZWNJ: 1 << 5,
  ZWJ: 1 << 6,
  M: 1 << 7,
  SM: 1 << 8,
  VD: 1 << 9,
  A: 1 << 10,
  Placeholder: 1 << 11,
  Dotted_Circle: 1 << 12,
  RS: 1 << 13, // Register Shifter, used in Khmer OT spec.
  Coeng: 1 << 14, // Khmer-style Virama.
  Repha: 1 << 15, // Atomically-encoded logical or visual repha.
  Ra: 1 << 16,
  CM: 1 << 17, // Consonant-Medial.
  Symbol: 1 << 18 // Avagraha, etc that take marks (SM,A,VD).
};

// Visual positions in a syllable from left to right.
var POSITIONS = {
  Start: 1 << 0,

  Ra_To_Become_Reph: 1 << 1,
  Pre_M: 1 << 2,
  Pre_C: 1 << 3,

  Base_C: 1 << 4,
  After_Main: 1 << 5,

  Above_C: 1 << 6,

  Before_Sub: 1 << 7,
  Below_C: 1 << 8,
  After_Sub: 1 << 9,

  Before_Post: 1 << 10,
  Post_C: 1 << 11,
  After_Post: 1 << 12,

  Final_C: 1 << 13,
  SMVD: 1 << 14,

  End: 1 << 15
};

var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;

var INDIC_CONFIGS = {
  Default: {
    hasOldSpec: false,
    virama: 0,
    basePos: 'Last',
    rephPos: POSITIONS.Before_Post,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Devanagari: {
    hasOldSpec: true,
    virama: 0x094D,
    basePos: 'Last',
    rephPos: POSITIONS.Before_Post,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Bengali: {
    hasOldSpec: true,
    virama: 0x09CD,
    basePos: 'Last',
    rephPos: POSITIONS.After_Sub,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Gurmukhi: {
    hasOldSpec: true,
    virama: 0x0A4D,
    basePos: 'Last',
    rephPos: POSITIONS.Before_Sub,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Gujarati: {
    hasOldSpec: true,
    virama: 0x0ACD,
    basePos: 'Last',
    rephPos: POSITIONS.Before_Post,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Oriya: {
    hasOldSpec: true,
    virama: 0x0B4D,
    basePos: 'Last',
    rephPos: POSITIONS.After_Main,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Tamil: {
    hasOldSpec: true,
    virama: 0x0BCD,
    basePos: 'Last',
    rephPos: POSITIONS.After_Post,
    rephMode: 'Implicit',
    blwfMode: 'Pre_And_Post'
  },

  Telugu: {
    hasOldSpec: true,
    virama: 0x0C4D,
    basePos: 'Last',
    rephPos: POSITIONS.After_Post,
    rephMode: 'Explicit',
    blwfMode: 'Post_Only'
  },

  Kannada: {
    hasOldSpec: true,
    virama: 0x0CCD,
    basePos: 'Last',
    rephPos: POSITIONS.After_Post,
    rephMode: 'Implicit',
    blwfMode: 'Post_Only'
  },

  Malayalam: {
    hasOldSpec: true,
    virama: 0x0D4D,
    basePos: 'Last',
    rephPos: POSITIONS.After_Main,
    rephMode: 'Log_Repha',
    blwfMode: 'Pre_And_Post'
  },

  // Handled by UniversalShaper
  // Sinhala: {
  //   hasOldSpec: false,
  //   virama: 0x0DCA,
  //   basePos: 'Last_Sinhala',
  //   rephPos: POSITIONS.After_Main,
  //   rephMode: 'Explicit',
  //   blwfMode: 'Pre_And_Post'
  // },

  Khmer: {
    hasOldSpec: false,
    virama: 0x17D2,
    basePos: 'First',
    rephPos: POSITIONS.Ra_To_Become_Reph,
    rephMode: 'Vis_Repha',
    blwfMode: 'Pre_And_Post'
  }
};

// Additional decompositions that aren't in Unicode
var INDIC_DECOMPOSITIONS = {
  // Khmer
  0x17BE: [0x17C1, 0x17BE],
  0x17BF: [0x17C1, 0x17BF],
  0x17C0: [0x17C1, 0x17C0],
  0x17C4: [0x17C1, 0x17C4],
  0x17C5: [0x17C1, 0x17C5]
};

var _class$6;
var _temp$2;
var decompositions = useData.decompositions;

var trie$1 = new UnicodeTrie(Buffer("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","base64"));
var stateMachine = new StateMachine(indicMachine);

/**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */
var IndicShaper = (_temp$2 = _class$6 = function (_DefaultShaper) {
  _inherits(IndicShaper, _DefaultShaper);

  function IndicShaper() {
    _classCallCheck(this, IndicShaper);

    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
  }

  IndicShaper.planFeatures = function planFeatures(plan) {
    plan.addStage(setupSyllables);

    plan.addStage(['locl', 'ccmp']);

    plan.addStage(initialReordering);

    plan.addStage('nukt');
    plan.addStage('akhn');
    plan.addStage('rphf', false);
    plan.addStage('rkrf');
    plan.addStage('pref', false);
    plan.addStage('blwf', false);
    plan.addStage('abvf', false);
    plan.addStage('half', false);
    plan.addStage('pstf', false);
    plan.addStage('vatu');
    plan.addStage('cjct');
    plan.addStage('cfar', false);

    plan.addStage(finalReordering);

    plan.addStage({
      local: ['init'],
      global: ['pres', 'abvs', 'blws', 'psts', 'haln', 'dist', 'abvm', 'blwm', 'calt', 'clig']
    });

    // Setup the indic config for the selected script
    plan.unicodeScript = fromOpenType(plan.script);
    plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
    plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';

    // TODO: turn off kern (Khmer) and liga features.
  };

  IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
    var _loop = function _loop(i) {
      var codepoint = glyphs[i].codePoints[0];
      var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions[codepoint];
      if (d) {
        var decomposed = d.map(function (c) {
          var g = plan.font.glyphForCodePoint(c);
          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
        });

        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
      }
    };

    // Decompose split matras
    // TODO: do this in a more general unicode normalizer
    for (var i = glyphs.length - 1; i >= 0; i--) {
      _loop(i);
    }
  };

  return IndicShaper;
}(DefaultShaper), _class$6.zeroMarkWidths = 'NONE', _temp$2);
function indicCategory(glyph) {
  return trie$1.get(glyph.codePoints[0]) >> 8;
}

function indicPosition(glyph) {
  return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
}

var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
  _classCallCheck(this, IndicInfo);

  this.category = category;
  this.position = position;
  this.syllableType = syllableType;
  this.syllable = syllable;
};

function setupSyllables(font, glyphs) {
  var syllable = 0;
  var last = 0;
  for (var _iterator = stateMachine.match(glyphs.map(indicCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        start = _ref2[0],
        end = _ref2[1],
        tags = _ref2[2];

    if (start > last) {
      ++syllable;
      for (var _i2 = last; _i2 < start; _i2++) {
        glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
      }
    }

    ++syllable;

    // Create shaper info
    for (var _i3 = start; _i3 <= end; _i3++) {
      glyphs[_i3].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i3]), indicPosition(glyphs[_i3]), tags[0], syllable);
    }

    last = end + 1;
  }

  if (last < glyphs.length) {
    ++syllable;
    for (var i = last; i < glyphs.length; i++) {
      glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
    }
  }
}

function isConsonant(glyph) {
  return glyph.shaperInfo.category & CONSONANT_FLAGS;
}

function isJoiner(glyph) {
  return glyph.shaperInfo.category & JOINER_FLAGS;
}

function isHalantOrCoeng(glyph) {
  return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
}

function wouldSubstitute(glyphs, feature) {
  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
    var _glyph$features;

    var _ref3;

    if (_isArray2) {
      if (_i4 >= _iterator2.length) break;
      _ref3 = _iterator2[_i4++];
    } else {
      _i4 = _iterator2.next();
      if (_i4.done) break;
      _ref3 = _i4.value;
    }

    var glyph = _ref3;

    glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
  }

  var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
  GSUB.applyFeatures([feature], glyphs);

  return glyphs.length === 1;
}

function consonantPosition(font, consonant, virama) {
  var glyphs = [virama, consonant, virama];
  if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) {
    return POSITIONS.Below_C;
  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) {
    return POSITIONS.Post_C;
  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) {
    return POSITIONS.Post_C;
  }

  return POSITIONS.Base_C;
}

function initialReordering(font, glyphs, plan) {
  var indicConfig = plan.indicConfig;
  var features = font._layoutEngine.engine.GSUBProcessor.features;

  var dottedCircle = font.glyphForCodePoint(0x25cc).id;
  var virama = font.glyphForCodePoint(indicConfig.virama).id;
  if (virama) {
    var info = new GlyphInfo(font, virama, [indicConfig.virama]);
    for (var i = 0; i < glyphs.length; i++) {
      if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
        glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
      }
    }
  }

  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
    var _glyphs$start$shaperI = glyphs[start].shaperInfo,
        category = _glyphs$start$shaperI.category,
        syllableType = _glyphs$start$shaperI.syllableType;


    if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') {
      continue;
    }

    if (syllableType === 'broken_cluster' && dottedCircle) {
      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
      g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);

      // Insert after possible Repha.
      var _i5 = start;
      while (_i5 < end && glyphs[_i5].shaperInfo.category === CATEGORIES.Repha) {
        _i5++;
      }

      glyphs.splice(_i5++, 0, g);
      end++;
    }

    // 1. Find base consonant:
    //
    // The shaping engine finds the base consonant of the syllable, using the
    // following algorithm: starting from the end of the syllable, move backwards
    // until a consonant is found that does not have a below-base or post-base
    // form (post-base forms have to follow below-base forms), or that is not a
    // pre-base reordering Ra, or arrive at the first consonant. The consonant
    // stopped at will be the base.

    var base = end;
    var limit = start;
    var hasReph = false;

    // If the syllable starts with Ra + Halant (in a script that has Reph)
    // and has more than one consonant, Ra is excluded from candidates for
    // base consonants.
    if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
      // See if it matches the 'rphf' feature.
      var _g = [glyphs[start].copy(), glyphs[start + 1].copy(), glyphs[start + 2].copy()];
      if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
        limit += 2;
        while (limit < end && isJoiner(glyphs[limit])) {
          limit++;
        }
        base = start;
        hasReph = true;
      }
    } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
      limit++;
      while (limit < end && isJoiner(glyphs[limit])) {
        limit++;
      }
      base = start;
      hasReph = true;
    }

    switch (indicConfig.basePos) {
      case 'Last':
        {
          // starting from the end of the syllable, move backwards
          var _i6 = end;
          var seenBelow = false;

          do {
            var _info = glyphs[--_i6].shaperInfo;

            // until a consonant is found
            if (isConsonant(glyphs[_i6])) {
              // that does not have a below-base or post-base form
              // (post-base forms have to follow below-base forms),
              if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                base = _i6;
                break;
              }

              // or that is not a pre-base reordering Ra,
              //
              // IMPLEMENTATION NOTES:
              //
              // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
              // by the logic above already.
              //

              // or arrive at the first consonant. The consonant stopped at will
              // be the base.
              if (_info.position === POSITIONS.Below_C) {
                seenBelow = true;
              }

              base = _i6;
            } else if (start < _i6 && _info.category === CATEGORIES.ZWJ && glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H) {
              // A ZWJ after a Halant stops the base search, and requests an explicit
              // half form.
              // A ZWJ before a Halant, requests a subjoined form instead, and hence
              // search continues.  This is particularly important for Bengali
              // sequence Ra,H,Ya that should form Ya-Phalaa by subjoining Ya.
              break;
            }
          } while (_i6 > limit);
          break;
        }

      case 'First':
        {
          // The first consonant is always the base.
          base = start;

          // Mark all subsequent consonants as below.
          for (var _i7 = base + 1; _i7 < end; _i7++) {
            if (isConsonant(glyphs[_i7])) {
              glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
            }
          }
        }
    }

    // If the syllable starts with Ra + Halant (in a script that has Reph)
    // and has more than one consonant, Ra is excluded from candidates for
    // base consonants.
    //
    //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
    if (hasReph && base === start && limit - base <= 2) {
      hasReph = false;
    }

    // 2. Decompose and reorder Matras:
    //
    // Each matra and any syllable modifier sign in the cluster are moved to the
    // appropriate position relative to the consonant(s) in the cluster. The
    // shaping engine decomposes two- or three-part matras into their constituent
    // parts before any repositioning. Matra characters are classified by which
    // consonant in a conjunct they have affinity for and are reordered to the
    // following positions:
    //
    //   o Before first half form in the syllable
    //   o After subjoined consonants
    //   o After post-form consonant
    //   o After main consonant (for above marks)
    //
    // IMPLEMENTATION NOTES:
    //
    // The normalize() routine has already decomposed matras for us, so we don't
    // need to worry about that.

    // 3.  Reorder marks to canonical order:
    //
    // Adjacent nukta and halant or nukta and vedic sign are always repositioned
    // if necessary, so that the nukta is first.
    //
    // IMPLEMENTATION NOTES:
    //
    // We don't need to do this: the normalize() routine already did this for us.

    // Reorder characters

    for (var _i8 = start; _i8 < base; _i8++) {
      var _info2 = glyphs[_i8].shaperInfo;
      _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
    }

    if (base < end) {
      glyphs[base].shaperInfo.position = POSITIONS.Base_C;
    }

    // Mark final consonants.  A final consonant is one appearing after a matra,
    // like in Khmer.
    for (var _i9 = base + 1; _i9 < end; _i9++) {
      if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
        for (var j = _i9 + 1; j < end; j++) {
          if (isConsonant(glyphs[j])) {
            glyphs[j].shaperInfo.position = POSITIONS.Final_C;
            break;
          }
        }
        break;
      }
    }

    // Handle beginning Ra
    if (hasReph) {
      glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
    }

    // For old-style Indic script tags, move the first post-base Halant after
    // last consonant.
    //
    // Reports suggest that in some scripts Uniscribe does this only if there
    // is *not* a Halant after last consonant already (eg. Kannada), while it
    // does it unconditionally in other scripts (eg. Malayalam).  We don't
    // currently know about other scripts, so we single out Malayalam for now.
    //
    // Kannada test case:
    // U+0C9A,U+0CCD,U+0C9A,U+0CCD
    // With some versions of Lohit Kannada.
    // https://bugs.freedesktop.org/show_bug.cgi?id=59118
    //
    // Malayalam test case:
    // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
    // With lohit-ttf-20121122/Lohit-Malayalam.ttf
    if (plan.isOldSpec) {
      var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
      for (var _i10 = base + 1; _i10 < end; _i10++) {
        if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
          var _j = void 0;
          for (_j = end - 1; _j > _i10; _j--) {
            if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) {
              break;
            }
          }

          if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i10) {
            // Move Halant to after last consonant.
            var t = glyphs[_i10];
            glyphs.splice.apply(glyphs, [_i10, 0].concat(glyphs.splice(_i10 + 1, _j - _i10)));
            glyphs[_j] = t;
          }

          break;
        }
      }
    }

    // Attach misc marks to previous char to move with them.
    var lastPos = POSITIONS.Start;
    for (var _i11 = start; _i11 < end; _i11++) {
      var _info3 = glyphs[_i11].shaperInfo;
      if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
        _info3.position = lastPos;
        if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
          // Uniscribe doesn't move the Halant with Left Matra.
          // TEST: U+092B,U+093F,U+094DE
          // We follow.  This is important for the Sinhala
          // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
          // where U+0DD9 is a left matra and U+0DCA is the virama.
          // We don't want to move the virama with the left matra.
          // TEST: U+0D9A,U+0DDA
          for (var _j2 = _i11; _j2 > start; _j2--) {
            if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
              _info3.position = glyphs[_j2 - 1].shaperInfo.position;
              break;
            }
          }
        }
      } else if (_info3.position !== POSITIONS.SMVD) {
        lastPos = _info3.position;
      }
    }

    // For post-base consonants let them own anything before them
    // since the last consonant or matra.
    var last = base;
    for (var _i12 = base + 1; _i12 < end; _i12++) {
      if (isConsonant(glyphs[_i12])) {
        for (var _j3 = last + 1; _j3 < _i12; _j3++) {
          if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
            glyphs[_j3].shaperInfo.position = glyphs[_i12].shaperInfo.position;
          }
        }
        last = _i12;
      } else if (glyphs[_i12].shaperInfo.category === CATEGORIES.M) {
        last = _i12;
      }
    }

    var arr = glyphs.slice(start, end);
    arr.sort(function (a, b) {
      return a.shaperInfo.position - b.shaperInfo.position;
    });
    glyphs.splice.apply(glyphs, [start, arr.length].concat(arr));

    // Find base again
    for (var _i13 = start; _i13 < end; _i13++) {
      if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
        base = _i13;
        break;
      }
    }

    // Setup features now

    // Reph
    for (var _i14 = start; _i14 < end && glyphs[_i14].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i14++) {
      glyphs[_i14].features.rphf = true;
    }

    // Pre-base
    var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
    for (var _i15 = start; _i15 < base; _i15++) {
      glyphs[_i15].features.half = true;
      if (blwf) {
        glyphs[_i15].features.blwf = true;
      }
    }

    // Post-base
    for (var _i16 = base + 1; _i16 < end; _i16++) {
      glyphs[_i16].features.abvf = true;
      glyphs[_i16].features.pstf = true;
      glyphs[_i16].features.blwf = true;
    }

    if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
      // Old-spec eye-lash Ra needs special handling.  From the
      // spec:
      //
      // "The feature 'below-base form' is applied to consonants
      // having below-base forms and following the base consonant.
      // The exception is vattu, which may appear below half forms
      // as well as below the base glyph. The feature 'below-base
      // form' will be applied to all such occurrences of Ra as well."
      //
      // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
      // with Sanskrit 2003 font.
      //
      // However, note that Ra,Halant,ZWJ is the correct way to
      // request eyelash form of Ra, so we wouldbn't inhibit it
      // in that sequence.
      //
      // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
      for (var _i17 = start; _i17 + 1 < base; _i17++) {
        if (glyphs[_i17].shaperInfo.category === CATEGORIES.Ra && glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H && (_i17 + 1 === base || glyphs[_i17 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
          glyphs[_i17].features.blwf = true;
          glyphs[_i17 + 1].features.blwf = true;
        }
      }
    }

    var prefLen = 2;
    if (features.pref && base + prefLen < end) {
      // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
      for (var _i18 = base + 1; _i18 + prefLen - 1 < end; _i18++) {
        var _g2 = [glyphs[_i18].copy(), glyphs[_i18 + 1].copy()];
        if (wouldSubstitute(_g2, 'pref')) {
          for (var _j4 = 0; _j4 < prefLen; _j4++) {
            glyphs[_i18++].features.pref = true;
          }

          // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
          // Read the feature spec.
          // This allows distinguishing the following cases with MS Khmer fonts:
          // U+1784,U+17D2,U+179A,U+17D2,U+1782
          // U+1784,U+17D2,U+1782,U+17D2,U+179A
          if (features.cfar) {
            for (; _i18 < end; _i18++) {
              glyphs[_i18].features.cfar = true;
            }
          }

          break;
        }
      }
    }

    // Apply ZWJ/ZWNJ effects
    for (var _i19 = start + 1; _i19 < end; _i19++) {
      if (isJoiner(glyphs[_i19])) {
        var nonJoiner = glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
        var _j5 = _i19;

        do {
          _j5--;

          // ZWJ/ZWNJ should disable CJCT.  They do that by simply
          // being there, since we don't skip them for the CJCT
          // feature (ie. F_MANUAL_ZWJ)

          // A ZWNJ disables HALF.
          if (nonJoiner) {
            delete glyphs[_j5].features.half;
          }
        } while (_j5 > start && !isConsonant(glyphs[_j5]));
      }
    }
  }
}

function finalReordering(font, glyphs, plan) {
  var indicConfig = plan.indicConfig;
  var features = font._layoutEngine.engine.GSUBProcessor.features;

  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
    // 4. Final reordering:
    //
    // After the localized forms and basic shaping forms GSUB features have been
    // applied (see below), the shaping engine performs some final glyph
    // reordering before applying all the remaining font features to the entire
    // cluster.

    var tryPref = !!features.pref;

    // Find base again
    var base = start;
    for (; base < end; base++) {
      if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
        if (tryPref && base + 1 < end) {
          for (var i = base + 1; i < end; i++) {
            if (glyphs[i].features.pref) {
              if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                // Ok, this was a 'pref' candidate but didn't form any.
                // Base is around here...
                base = i;
                while (base < end && isHalantOrCoeng(glyphs[base])) {
                  base++;
                }
                glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                tryPref = false;
              }
              break;
            }
          }
        }

        // For Malayalam, skip over unformed below- (but NOT post-) forms.
        if (plan.unicodeScript === 'Malayalam') {
          for (var _i20 = base + 1; _i20 < end; _i20++) {
            while (_i20 < end && isJoiner(glyphs[_i20])) {
              _i20++;
            }

            if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) {
              break;
            }

            _i20++; // Skip halant.
            while (_i20 < end && isJoiner(glyphs[_i20])) {
              _i20++;
            }

            if (_i20 < end && isConsonant(glyphs[_i20]) && glyphs[_i20].shaperInfo.position === POSITIONS.Below_C) {
              base = _i20;
              glyphs[base].shaperInfo.position = POSITIONS.Base_C;
            }
          }
        }

        if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) {
          base--;
        }
        break;
      }
    }

    if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) {
      base--;
    }

    if (base < end) {
      while (start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS)) {
        base--;
      }
    }

    // o Reorder matras:
    //
    // If a pre-base matra character had been reordered before applying basic
    // features, the glyph can be moved closer to the main consonant based on
    // whether half-forms had been formed. Actual position for the matra is
    // defined as “after last standalone halant glyph, after initial matra
    // position and before the main consonant”. If ZWJ or ZWNJ follow this
    // halant, position is moved after it.
    //

    if (start + 1 < end && start < base) {
      // Otherwise there can't be any pre-base matra characters.
      // If we lost track of base, alas, position before last thingy.
      var newPos = base === end ? base - 2 : base - 1;

      // Malayalam / Tamil do not have "half" forms or explicit virama forms.
      // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
      // We want to position matra after them.
      if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
        while (newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
          newPos--;
        }

        // If we found no Halant we are done.
        // Otherwise only proceed if the Halant does
        // not belong to the Matra itself!
        if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
          // If ZWJ or ZWNJ follow this halant, position is moved after it.
          if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
            newPos++;
          }
        } else {
          newPos = start; // No move.
        }
      }

      if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
        // Now go see if there's actually any matras...
        for (var _i21 = newPos; _i21 > start; _i21--) {
          if (glyphs[_i21 - 1].shaperInfo.position === POSITIONS.Pre_M) {
            var oldPos = _i21 - 1;
            if (oldPos < base && base <= newPos) {
              // Shouldn't actually happen.
              base--;
            }

            var tmp = glyphs[oldPos];
            glyphs.splice.apply(glyphs, [oldPos, 0].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
            glyphs[newPos] = tmp;

            newPos--;
          }
        }
      }
    }

    // o Reorder reph:
    //
    // Reph’s original position is always at the beginning of the syllable,
    // (i.e. it is not reordered at the character reordering stage). However,
    // it will be reordered according to the basic-forms shaping results.
    // Possible positions for reph, depending on the script, are; after main,
    // before post-base consonant forms, and after post-base consonant forms.

    // Two cases:
    //
    // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
    //   we should only move it if the sequence ligated to the repha form.
    //
    // - If repha is encoded separately and in the logical position, we should only
    //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
    //   to make it work without the reordering.
    if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
      var newRephPos = void 0;
      var rephPos = indicConfig.rephPos;
      var found = false;

      // 1. If reph should be positioned after post-base consonant forms,
      //    proceed to step 5.
      if (rephPos !== POSITIONS.After_Post) {
        //  2. If the reph repositioning class is not after post-base: target
        //     position is after the first explicit halant glyph between the
        //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
        //     are following this halant, position is moved after it. If such
        //     position is found, this is the target position. Otherwise,
        //     proceed to the next step.
        //
        //     Note: in old-implementation fonts, where classifications were
        //     fixed in shaping engine, there was no case where reph position
        //     will be found on this step.
        newRephPos = start + 1;
        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
          newRephPos++;
        }

        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
            newRephPos++;
          }

          found = true;
        }

        // 3. If reph should be repositioned after the main consonant: find the
        //    first consonant not ligated with main, or find the first
        //    consonant that is not a potential pre-base reordering Ra.
        if (!found && rephPos === POSITIONS.After_Main) {
          newRephPos = base;
          while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main) {
            newRephPos++;
          }

          found = newRephPos < end;
        }

        // 4. If reph should be positioned before post-base consonant, find
        //    first post-base classified consonant not ligated with main. If no
        //    consonant is found, the target position should be before the
        //    first matra, syllable modifier sign or vedic sign.
        //
        // This is our take on what step 4 is trying to say (and failing, BADLY).
        if (!found && rephPos === POSITIONS.After_Sub) {
          newRephPos = base;
          while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD))) {
            newRephPos++;
          }

          found = newRephPos < end;
        }
      }

      //  5. If no consonant is found in steps 3 or 4, move reph to a position
      //     immediately before the first post-base matra, syllable modifier
      //     sign or vedic sign that has a reordering class after the intended
      //     reph position. For example, if the reordering position for reph
      //     is post-main, it will skip above-base matras that also have a
      //     post-main position.
      if (!found) {
        // Copied from step 2.
        newRephPos = start + 1;
        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
          newRephPos++;
        }

        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
            newRephPos++;
          }

          found = true;
        }
      }

      // 6. Otherwise, reorder reph to the end of the syllable.
      if (!found) {
        newRephPos = end - 1;
        while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD) {
          newRephPos--;
        }

        // If the Reph is to be ending up after a Matra,Halant sequence,
        // position it before that Halant so it can interact with the Matra.
        // However, if it's a plain Consonant,Halant we shouldn't do that.
        // Uniscribe doesn't do this.
        // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
        if (isHalantOrCoeng(glyphs[newRephPos])) {
          for (var _i22 = base + 1; _i22 < newRephPos; _i22++) {
            if (glyphs[_i22].shaperInfo.category === CATEGORIES.M) {
              newRephPos--;
            }
          }
        }
      }

      var reph = glyphs[start];
      glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, newRephPos - start)));
      glyphs[newRephPos] = reph;

      if (start < base && base <= newRephPos) {
        base--;
      }
    }

    // o Reorder pre-base reordering consonants:
    //
    // If a pre-base reordering consonant is found, reorder it according to
    // the following rules:
    if (tryPref && base + 1 < end) {
      for (var _i23 = base + 1; _i23 < end; _i23++) {
        if (glyphs[_i23].features.pref) {
          // 1. Only reorder a glyph produced by substitution during application
          //    of the <pref> feature. (Note that a font may shape a Ra consonant with
          //    the feature generally but block it in certain contexts.)

          // Note: We just check that something got substituted.  We don't check that
          // the <pref> feature actually did it...
          //
          // Reorder pref only if it ligated.
          if (glyphs[_i23].isLigated && !glyphs[_i23].isMultiplied) {
            // 2. Try to find a target position the same way as for pre-base matra.
            //    If it is found, reorder pre-base consonant glyph.
            //
            // 3. If position is not found, reorder immediately before main
            //    consonant.
            var _newPos = base;

            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
              while (_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
                _newPos--;
              }

              // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
              // split matra, it should be reordered to *before* the left part of such matra.
              if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                var _oldPos2 = _i23;
                for (var j = base + 1; j < _oldPos2; j++) {
                  if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                    _newPos--;
                    break;
                  }
                }
              }
            }

            if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) {
              // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
              if (_newPos < end && isJoiner(glyphs[_newPos])) {
                _newPos++;
              }
            }

            var _oldPos = _i23;
            var _tmp = glyphs[_oldPos];
            glyphs.splice.apply(glyphs, [_newPos + 1, 0].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
            glyphs[_newPos] = _tmp;

            if (_newPos <= base && base < _oldPos) {
              base++;
            }
          }

          break;
        }
      }
    }

    // Apply 'init' to the Left Matra if it's a word start.
    if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) {
      glyphs[start].features.init = true;
    }
  }
}

function nextSyllable(glyphs, start) {
  if (start >= glyphs.length) return start;
  var syllable = glyphs[start].shaperInfo.syllable;
  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
  return start;
}

var _class$7;
var _temp$3;
var categories$1 = useData.categories;
var decompositions$2 = useData.decompositions;
var trie$2 = new UnicodeTrie(Buffer("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","base64"));
var stateMachine$1 = new StateMachine(useData);

/**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */
var UniversalShaper = (_temp$3 = _class$7 = function (_DefaultShaper) {
  _inherits(UniversalShaper, _DefaultShaper);

  function UniversalShaper() {
    _classCallCheck(this, UniversalShaper);

    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
  }

  UniversalShaper.planFeatures = function planFeatures(plan) {
    plan.addStage(setupSyllables$1);

    // Default glyph pre-processing group
    plan.addStage(['locl', 'ccmp', 'nukt', 'akhn']);

    // Reordering group
    plan.addStage(clearSubstitutionFlags);
    plan.addStage(['rphf'], false);
    plan.addStage(recordRphf);
    plan.addStage(clearSubstitutionFlags);
    plan.addStage(['pref']);
    plan.addStage(recordPref);

    // Orthographic unit shaping group
    plan.addStage(['rkrf', 'abvf', 'blwf', 'half', 'pstf', 'vatu', 'cjct']);
    plan.addStage(reorder);

    // Topographical features
    // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
    // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);

    // Standard topographic presentation and positional feature application
    plan.addStage(['abvs', 'blws', 'pres', 'psts', 'dist', 'abvm', 'blwm']);
  };

  UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
    var _loop = function _loop(i) {
      var codepoint = glyphs[i].codePoints[0];
      if (decompositions$2[codepoint]) {
        var decomposed = decompositions$2[codepoint].map(function (c) {
          var g = plan.font.glyphForCodePoint(c);
          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
        });

        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
      }
    };

    // Decompose split vowels
    // TODO: do this in a more general unicode normalizer
    for (var i = glyphs.length - 1; i >= 0; i--) {
      _loop(i);
    }
  };

  return UniversalShaper;
}(DefaultShaper), _class$7.zeroMarkWidths = 'BEFORE_GPOS', _temp$3);
function useCategory(glyph) {
  return trie$2.get(glyph.codePoints[0]);
}

var USEInfo = function USEInfo(category, syllableType, syllable) {
  _classCallCheck(this, USEInfo);

  this.category = category;
  this.syllableType = syllableType;
  this.syllable = syllable;
};

function setupSyllables$1(font, glyphs) {
  var syllable = 0;
  for (var _iterator = stateMachine$1.match(glyphs.map(useCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var _ref2 = _ref,
        start = _ref2[0],
        end = _ref2[1],
        tags = _ref2[2];

    ++syllable;

    // Create shaper info
    for (var i = start; i <= end; i++) {
      glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
    }

    // Assign rphf feature
    var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
    for (var _i2 = start; _i2 < start + limit; _i2++) {
      glyphs[_i2].features.rphf = true;
    }
  }
}

function clearSubstitutionFlags(font, glyphs) {
  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
    var _ref3;

    if (_isArray2) {
      if (_i3 >= _iterator2.length) break;
      _ref3 = _iterator2[_i3++];
    } else {
      _i3 = _iterator2.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var glyph = _ref3;

    glyph.substituted = false;
  }
}

function recordRphf(font, glyphs) {
  for (var _iterator3 = glyphs, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
    var _ref4;

    if (_isArray3) {
      if (_i4 >= _iterator3.length) break;
      _ref4 = _iterator3[_i4++];
    } else {
      _i4 = _iterator3.next();
      if (_i4.done) break;
      _ref4 = _i4.value;
    }

    var glyph = _ref4;

    if (glyph.substituted && glyph.features.rphf) {
      // Mark a substituted repha.
      glyph.shaperInfo.category = 'R';
    }
  }
}

function recordPref(font, glyphs) {
  for (var _iterator4 = glyphs, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
    var _ref5;

    if (_isArray4) {
      if (_i5 >= _iterator4.length) break;
      _ref5 = _iterator4[_i5++];
    } else {
      _i5 = _iterator4.next();
      if (_i5.done) break;
      _ref5 = _i5.value;
    }

    var glyph = _ref5;

    if (glyph.substituted) {
      // Mark a substituted pref as VPre, as they behave the same way.
      glyph.shaperInfo.category = 'VPre';
    }
  }
}

function reorder(font, glyphs) {
  var dottedCircle = font.glyphForCodePoint(0x25cc).id;

  for (var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)) {
    var i = void 0,
        j = void 0;
    var info = glyphs[start].shaperInfo;
    var type = info.syllableType;

    // Only a few syllable types need reordering.
    if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') {
      continue;
    }

    // Insert a dotted circle glyph in broken clusters.
    if (type === 'broken_cluster' && dottedCircle) {
      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
      g.shaperInfo = info;

      // Insert after possible Repha.
      for (i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++) {}
      glyphs.splice(++i, 0, g);
      end++;
    }

    // Move things forward.
    if (info.category === 'R' && end - start > 1) {
      // Got a repha. Reorder it to after first base, before first halant.
      for (i = start + 1; i < end; i++) {
        info = glyphs[i].shaperInfo;
        if (isBase(info) || isHalant(glyphs[i])) {
          // If we hit a halant, move before it; otherwise it's a base: move to it's
          // place, and shift things in between backward.
          if (isHalant(glyphs[i])) {
            i--;
          }

          glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, i - start), [glyphs[i]]));
          break;
        }
      }
    }

    // Move things back.
    for (i = start, j = end; i < end; i++) {
      info = glyphs[i].shaperInfo;
      if (isBase(info) || isHalant(glyphs[i])) {
        // If we hit a halant, move after it; otherwise it's a base: move to it's
        // place, and shift things in between backward.
        j = isHalant(glyphs[i]) ? i + 1 : i;
      } else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) {
        glyphs.splice.apply(glyphs, [j, 1, glyphs[i]].concat(glyphs.splice(j, i - j)));
      }
    }
  }
}

function nextSyllable$1(glyphs, start) {
  if (start >= glyphs.length) return start;
  var syllable = glyphs[start].shaperInfo.syllable;
  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
  return start;
}

function isHalant(glyph) {
  return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}

function isBase(info) {
  return info.category === 'B' || info.category === 'GB';
}

var SHAPERS = {
  arab: ArabicShaper, // Arabic
  mong: ArabicShaper, // Mongolian
  syrc: ArabicShaper, // Syriac
  'nko ': ArabicShaper, // N'Ko
  phag: ArabicShaper, // Phags Pa
  mand: ArabicShaper, // Mandaic
  mani: ArabicShaper, // Manichaean
  phlp: ArabicShaper, // Psalter Pahlavi

  hang: HangulShaper, // Hangul

  bng2: IndicShaper, // Bengali
  beng: IndicShaper, // Bengali
  dev2: IndicShaper, // Devanagari
  deva: IndicShaper, // Devanagari
  gjr2: IndicShaper, // Gujarati
  gujr: IndicShaper, // Gujarati
  guru: IndicShaper, // Gurmukhi
  gur2: IndicShaper, // Gurmukhi
  knda: IndicShaper, // Kannada
  knd2: IndicShaper, // Kannada
  mlm2: IndicShaper, // Malayalam
  mlym: IndicShaper, // Malayalam
  ory2: IndicShaper, // Oriya
  orya: IndicShaper, // Oriya
  taml: IndicShaper, // Tamil
  tml2: IndicShaper, // Tamil
  telu: IndicShaper, // Telugu
  tel2: IndicShaper, // Telugu
  khmr: IndicShaper, // Khmer

  bali: UniversalShaper, // Balinese
  batk: UniversalShaper, // Batak
  brah: UniversalShaper, // Brahmi
  bugi: UniversalShaper, // Buginese
  buhd: UniversalShaper, // Buhid
  cakm: UniversalShaper, // Chakma
  cham: UniversalShaper, // Cham
  dupl: UniversalShaper, // Duployan
  egyp: UniversalShaper, // Egyptian Hieroglyphs
  gran: UniversalShaper, // Grantha
  hano: UniversalShaper, // Hanunoo
  java: UniversalShaper, // Javanese
  kthi: UniversalShaper, // Kaithi
  kali: UniversalShaper, // Kayah Li
  khar: UniversalShaper, // Kharoshthi
  khoj: UniversalShaper, // Khojki
  sind: UniversalShaper, // Khudawadi
  lepc: UniversalShaper, // Lepcha
  limb: UniversalShaper, // Limbu
  mahj: UniversalShaper, // Mahajani
  // mand: UniversalShaper, // Mandaic
  // mani: UniversalShaper, // Manichaean
  mtei: UniversalShaper, // Meitei Mayek
  modi: UniversalShaper, // Modi
  // mong: UniversalShaper, // Mongolian
  // 'nko ': UniversalShaper, // N’Ko
  hmng: UniversalShaper, // Pahawh Hmong
  // phag: UniversalShaper, // Phags-pa
  // phlp: UniversalShaper, // Psalter Pahlavi
  rjng: UniversalShaper, // Rejang
  saur: UniversalShaper, // Saurashtra
  shrd: UniversalShaper, // Sharada
  sidd: UniversalShaper, // Siddham
  sinh: UniversalShaper, // Sinhala
  sund: UniversalShaper, // Sundanese
  sylo: UniversalShaper, // Syloti Nagri
  tglg: UniversalShaper, // Tagalog
  tagb: UniversalShaper, // Tagbanwa
  tale: UniversalShaper, // Tai Le
  lana: UniversalShaper, // Tai Tham
  tavt: UniversalShaper, // Tai Viet
  takr: UniversalShaper, // Takri
  tibt: UniversalShaper, // Tibetan
  tfng: UniversalShaper, // Tifinagh
  tirh: UniversalShaper, // Tirhuta

  latn: DefaultShaper, // Latin
  DFLT: DefaultShaper // Default
};

function choose(script) {
  if (!Array.isArray(script)) {
    script = [script];
  }

  for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var s = _ref;

    var shaper = SHAPERS[s];
    if (shaper) {
      return shaper;
    }
  }

  return DefaultShaper;
}

var GSUBProcessor = function (_OTProcessor) {
  _inherits(GSUBProcessor, _OTProcessor);

  function GSUBProcessor() {
    _classCallCheck(this, GSUBProcessor);

    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
  }

  GSUBProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
    var _this2 = this;

    switch (lookupType) {
      case 1:
        {
          // Single Substitution
          var index = this.coverageIndex(table.coverage);
          if (index === -1) {
            return false;
          }

          var glyph = this.glyphIterator.cur;
          switch (table.version) {
            case 1:
              glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
              break;

            case 2:
              glyph.id = table.substitute.get(index);
              break;
          }

          return true;
        }

      case 2:
        {
          // Multiple Substitution
          var _index = this.coverageIndex(table.coverage);
          if (_index !== -1) {
            var _glyphs;

            var sequence = table.sequences.get(_index);
            this.glyphIterator.cur.id = sequence[0];
            this.glyphIterator.cur.ligatureComponent = 0;

            var features = this.glyphIterator.cur.features;
            var curGlyph = this.glyphIterator.cur;
            var replacement = sequence.slice(1).map(function (gid, i) {
              var glyph = new GlyphInfo(_this2.font, gid, undefined, features);
              glyph.shaperInfo = curGlyph.shaperInfo;
              glyph.isLigated = curGlyph.isLigated;
              glyph.ligatureComponent = i + 1;
              glyph.substituted = true;
              glyph.isMultiplied = true;
              return glyph;
            });

            (_glyphs = this.glyphs).splice.apply(_glyphs, [this.glyphIterator.index + 1, 0].concat(replacement));
            return true;
          }

          return false;
        }

      case 3:
        {
          // Alternate Substitution
          var _index2 = this.coverageIndex(table.coverage);
          if (_index2 !== -1) {
            var USER_INDEX = 0; // TODO
            this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
            return true;
          }

          return false;
        }

      case 4:
        {
          // Ligature Substitution
          var _index3 = this.coverageIndex(table.coverage);
          if (_index3 === -1) {
            return false;
          }

          for (var _iterator = table.ligatureSets.get(_index3), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var ligature = _ref;

            var matched = this.sequenceMatchIndices(1, ligature.components);
            if (!matched) {
              continue;
            }

            var _curGlyph = this.glyphIterator.cur;

            // Concatenate all of the characters the new ligature will represent
            var characters = _curGlyph.codePoints.slice();
            for (var _iterator2 = matched, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
              var _ref2;

              if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
              } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
              }

              var _index4 = _ref2;

              characters.push.apply(characters, this.glyphs[_index4].codePoints);
            }

            // Create the replacement ligature glyph
            var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
            ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
            ligatureGlyph.isLigated = true;
            ligatureGlyph.substituted = true;

            // From Harfbuzz:
            // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
            //   the ligature to keep its old ligature id.  This will allow it to attach to
            //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
            //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
            //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
            //   later, we don't want them to lose their ligature id/component, otherwise
            //   GPOS will fail to correctly position the mark ligature on top of the
            //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
            //
            // - If a ligature is formed of components that some of which are also ligatures
            //   themselves, and those ligature components had marks attached to *their*
            //   components, we have to attach the marks to the new ligature component
            //   positions!  Now *that*'s tricky!  And these marks may be following the
            //   last component of the whole sequence, so we should loop forward looking
            //   for them and update them.
            //
            //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
            //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
            //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
            //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
            //   the new ligature with a component value of 2.
            //
            //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
            var isMarkLigature = _curGlyph.isMark;
            for (var i = 0; i < matched.length && isMarkLigature; i++) {
              isMarkLigature = this.glyphs[matched[i]].isMark;
            }

            ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;

            var lastLigID = _curGlyph.ligatureID;
            var lastNumComps = _curGlyph.codePoints.length;
            var curComps = lastNumComps;
            var idx = this.glyphIterator.index + 1;

            // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
            // This allows GPOS to attach marks to the correct ligature components.
            for (var _iterator3 = matched, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
              var _ref3;

              if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
              } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
              }

              var matchIndex = _ref3;

              // Don't assign new ligature components for mark ligatures (see above)
              if (isMarkLigature) {
                idx = matchIndex;
              } else {
                while (idx < matchIndex) {
                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                  this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                  this.glyphs[idx].ligatureComponent = ligatureComponent;
                  idx++;
                }
              }

              lastLigID = this.glyphs[idx].ligatureID;
              lastNumComps = this.glyphs[idx].codePoints.length;
              curComps += lastNumComps;
              idx++; // skip base glyph
            }

            // Adjust ligature components for any marks following
            if (lastLigID && !isMarkLigature) {
              for (var _i4 = idx; _i4 < this.glyphs.length; _i4++) {
                if (this.glyphs[_i4].ligatureID === lastLigID) {
                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i4].ligatureComponent || 1, lastNumComps);
                  this.glyphs[_i4].ligatureComponent = ligatureComponent;
                } else {
                  break;
                }
              }
            }

            // Delete the matched glyphs, and replace the current glyph with the ligature glyph
            for (var _i5 = matched.length - 1; _i5 >= 0; _i5--) {
              this.glyphs.splice(matched[_i5], 1);
            }

            this.glyphs[this.glyphIterator.index] = ligatureGlyph;
            return true;
          }

          return false;
        }

      case 5:
        // Contextual Substitution
        return this.applyContext(table);

      case 6:
        // Chaining Contextual Substitution
        return this.applyChainingContext(table);

      case 7:
        // Extension Substitution
        return this.applyLookup(table.lookupType, table.extension);

      default:
        throw new Error('GSUB lookupType ' + lookupType + ' is not supported');
    }
  };

  return GSUBProcessor;
}(OTProcessor);

var GPOSProcessor = function (_OTProcessor) {
  _inherits(GPOSProcessor, _OTProcessor);

  function GPOSProcessor() {
    _classCallCheck(this, GPOSProcessor);

    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
  }

  GPOSProcessor.prototype.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
    var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
    if (value.xAdvance != null) {
      position.xAdvance += value.xAdvance;
    }

    if (value.yAdvance != null) {
      position.yAdvance += value.yAdvance;
    }

    if (value.xPlacement != null) {
      position.xOffset += value.xPlacement;
    }

    if (value.yPlacement != null) {
      position.yOffset += value.yPlacement;
    }

    // Adjustments for font variations
    var variationProcessor = this.font._variationProcessor;
    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
    if (variationProcessor && variationStore) {
      if (value.xPlaDevice) {
        position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
      }

      if (value.yPlaDevice) {
        position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
      }

      if (value.xAdvDevice) {
        position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
      }

      if (value.yAdvDevice) {
        position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
      }
    }

    // TODO: device tables
  };

  GPOSProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
    switch (lookupType) {
      case 1:
        {
          // Single positioning value
          var index = this.coverageIndex(table.coverage);
          if (index === -1) {
            return false;
          }

          switch (table.version) {
            case 1:
              this.applyPositionValue(0, table.value);
              break;

            case 2:
              this.applyPositionValue(0, table.values.get(index));
              break;
          }

          return true;
        }

      case 2:
        {
          // Pair Adjustment Positioning
          var nextGlyph = this.glyphIterator.peek();
          if (!nextGlyph) {
            return false;
          }

          var _index = this.coverageIndex(table.coverage);
          if (_index === -1) {
            return false;
          }

          switch (table.version) {
            case 1:
              // Adjustments for glyph pairs
              var set = table.pairSets.get(_index);

              for (var _iterator = set, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
                var _ref;

                if (_isArray) {
                  if (_i >= _iterator.length) break;
                  _ref = _iterator[_i++];
                } else {
                  _i = _iterator.next();
                  if (_i.done) break;
                  _ref = _i.value;
                }

                var _pair = _ref;

                if (_pair.secondGlyph === nextGlyph.id) {
                  this.applyPositionValue(0, _pair.value1);
                  this.applyPositionValue(1, _pair.value2);
                  return true;
                }
              }

              return false;

            case 2:
              // Class pair adjustment
              var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
              var class2 = this.getClassID(nextGlyph.id, table.classDef2);
              if (class1 === -1 || class2 === -1) {
                return false;
              }

              var pair = table.classRecords.get(class1).get(class2);
              this.applyPositionValue(0, pair.value1);
              this.applyPositionValue(1, pair.value2);
              return true;
          }
        }

      case 3:
        {
          // Cursive Attachment Positioning
          var nextIndex = this.glyphIterator.peekIndex();
          var _nextGlyph = this.glyphs[nextIndex];
          if (!_nextGlyph) {
            return false;
          }

          var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
          if (!curRecord || !curRecord.exitAnchor) {
            return false;
          }

          var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
          if (!nextRecord || !nextRecord.entryAnchor) {
            return false;
          }

          var entry = this.getAnchor(nextRecord.entryAnchor);
          var exit = this.getAnchor(curRecord.exitAnchor);

          var cur = this.positions[this.glyphIterator.index];
          var next = this.positions[nextIndex];

          switch (this.direction) {
            case 'ltr':
              cur.xAdvance = exit.x + cur.xOffset;

              var d = entry.x + next.xOffset;
              next.xAdvance -= d;
              next.xOffset -= d;
              break;

            case 'rtl':
              d = exit.x + cur.xOffset;
              cur.xAdvance -= d;
              cur.xOffset -= d;
              next.xAdvance = entry.x + next.xOffset;
              break;
          }

          if (this.glyphIterator.flags.rightToLeft) {
            this.glyphIterator.cur.cursiveAttachment = nextIndex;
            cur.yOffset = entry.y - exit.y;
          } else {
            _nextGlyph.cursiveAttachment = this.glyphIterator.index;
            cur.yOffset = exit.y - entry.y;
          }

          return true;
        }

      case 4:
        {
          // Mark to base positioning
          var markIndex = this.coverageIndex(table.markCoverage);
          if (markIndex === -1) {
            return false;
          }

          // search backward for a base glyph
          var baseGlyphIndex = this.glyphIterator.index;
          while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) {}

          if (baseGlyphIndex < 0) {
            return false;
          }

          var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
          if (baseIndex === -1) {
            return false;
          }

          var markRecord = table.markArray[markIndex];
          var baseAnchor = table.baseArray[baseIndex][markRecord.class];
          this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
          return true;
        }

      case 5:
        {
          // Mark to ligature positioning
          var _markIndex = this.coverageIndex(table.markCoverage);
          if (_markIndex === -1) {
            return false;
          }

          // search backward for a base glyph
          var _baseGlyphIndex = this.glyphIterator.index;
          while (--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark) {}

          if (_baseGlyphIndex < 0) {
            return false;
          }

          var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
          if (ligIndex === -1) {
            return false;
          }

          var ligAttach = table.ligatureArray[ligIndex];
          var markGlyph = this.glyphIterator.cur;
          var ligGlyph = this.glyphs[_baseGlyphIndex];
          var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;

          var _markRecord = table.markArray[_markIndex];
          var _baseAnchor = ligAttach[compIndex][_markRecord.class];
          this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
          return true;
        }

      case 6:
        {
          // Mark to mark positioning
          var mark1Index = this.coverageIndex(table.mark1Coverage);
          if (mark1Index === -1) {
            return false;
          }

          // get the previous mark to attach to
          var prevIndex = this.glyphIterator.peekIndex(-1);
          var prev = this.glyphs[prevIndex];
          if (!prev || !prev.isMark) {
            return false;
          }

          var _cur = this.glyphIterator.cur;

          // The following logic was borrowed from Harfbuzz
          var good = false;
          if (_cur.ligatureID === prev.ligatureID) {
            if (!_cur.ligatureID) {
              // Marks belonging to the same base
              good = true;
            } else if (_cur.ligatureComponent === prev.ligatureComponent) {
              // Marks belonging to the same ligature component
              good = true;
            }
          } else {
            // If ligature ids don't match, it may be the case that one of the marks
            // itself is a ligature, in which case match.
            if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) {
              good = true;
            }
          }

          if (!good) {
            return false;
          }

          var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
          if (mark2Index === -1) {
            return false;
          }

          var _markRecord2 = table.mark1Array[mark1Index];
          var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
          this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
          return true;
        }

      case 7:
        // Contextual positioning
        return this.applyContext(table);

      case 8:
        // Chaining contextual positioning
        return this.applyChainingContext(table);

      case 9:
        // Extension positioning
        return this.applyLookup(table.lookupType, table.extension);

      default:
        throw new Error('Unsupported GPOS table: ' + lookupType);
    }
  };

  GPOSProcessor.prototype.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
    var baseCoords = this.getAnchor(baseAnchor);
    var markCoords = this.getAnchor(markRecord.markAnchor);

    var basePos = this.positions[baseGlyphIndex];
    var markPos = this.positions[this.glyphIterator.index];

    markPos.xOffset = baseCoords.x - markCoords.x;
    markPos.yOffset = baseCoords.y - markCoords.y;
    this.glyphIterator.cur.markAttachment = baseGlyphIndex;
  };

  GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
    // TODO: contour point, device tables
    var x = anchor.xCoordinate;
    var y = anchor.yCoordinate;

    // Adjustments for font variations
    var variationProcessor = this.font._variationProcessor;
    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
    if (variationProcessor && variationStore) {
      if (anchor.xDeviceTable) {
        x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
      }

      if (anchor.yDeviceTable) {
        y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
      }
    }

    return { x: x, y: y };
  };

  GPOSProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
    _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);

    for (var i = 0; i < this.glyphs.length; i++) {
      this.fixCursiveAttachment(i);
    }

    this.fixMarkAttachment();
  };

  GPOSProcessor.prototype.fixCursiveAttachment = function fixCursiveAttachment(i) {
    var glyph = this.glyphs[i];
    if (glyph.cursiveAttachment != null) {
      var j = glyph.cursiveAttachment;

      glyph.cursiveAttachment = null;
      this.fixCursiveAttachment(j);

      this.positions[i].yOffset += this.positions[j].yOffset;
    }
  };

  GPOSProcessor.prototype.fixMarkAttachment = function fixMarkAttachment() {
    for (var i = 0; i < this.glyphs.length; i++) {
      var glyph = this.glyphs[i];
      if (glyph.markAttachment != null) {
        var j = glyph.markAttachment;

        this.positions[i].xOffset += this.positions[j].xOffset;
        this.positions[i].yOffset += this.positions[j].yOffset;

        if (this.direction === 'ltr') {
          for (var k = j; k < i; k++) {
            this.positions[i].xOffset -= this.positions[k].xAdvance;
            this.positions[i].yOffset -= this.positions[k].yAdvance;
          }
        } else {
          for (var _k = j + 1; _k < i + 1; _k++) {
            this.positions[i].xOffset += this.positions[_k].xAdvance;
            this.positions[i].yOffset += this.positions[_k].yAdvance;
          }
        }
      }
    }
  };

  return GPOSProcessor;
}(OTProcessor);

var OTLayoutEngine = function () {
  function OTLayoutEngine(font) {
    _classCallCheck(this, OTLayoutEngine);

    this.font = font;
    this.glyphInfos = null;
    this.plan = null;
    this.GSUBProcessor = null;
    this.GPOSProcessor = null;
    this.fallbackPosition = true;

    if (font.GSUB) {
      this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
    }

    if (font.GPOS) {
      this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
    }
  }

  OTLayoutEngine.prototype.setup = function setup(glyphRun) {
    var _this = this;

    // Map glyphs to GlyphInfo objects so data can be passed between
    // GSUB and GPOS without mutating the real (shared) Glyph objects.
    this.glyphInfos = glyphRun.glyphs.map(function (glyph) {
      return new GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
    });

    // Select a script based on what is available in GSUB/GPOS.
    var script = null;
    if (this.GPOSProcessor) {
      script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
    }

    if (this.GSUBProcessor) {
      script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
    }

    // Choose a shaper based on the script, and setup a shaping plan.
    // This determines which features to apply to which glyphs.
    this.shaper = choose(script);
    this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
    this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);

    // Assign chosen features to output glyph run
    for (var key in this.plan.allFeatures) {
      glyphRun.features[key] = true;
    }
  };

  OTLayoutEngine.prototype.substitute = function substitute(glyphRun) {
    var _this2 = this;

    if (this.GSUBProcessor) {
      this.plan.process(this.GSUBProcessor, this.glyphInfos);

      // Map glyph infos back to normal Glyph objects
      glyphRun.glyphs = this.glyphInfos.map(function (glyphInfo) {
        return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
      });
    }
  };

  OTLayoutEngine.prototype.position = function position(glyphRun) {
    if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') {
      this.zeroMarkAdvances(glyphRun.positions);
    }

    if (this.GPOSProcessor) {
      this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
    }

    if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') {
      this.zeroMarkAdvances(glyphRun.positions);
    }

    // Reverse the glyphs and positions if the script is right-to-left
    if (glyphRun.direction === 'rtl') {
      glyphRun.glyphs.reverse();
      glyphRun.positions.reverse();
    }

    return this.GPOSProcessor && this.GPOSProcessor.features;
  };

  OTLayoutEngine.prototype.zeroMarkAdvances = function zeroMarkAdvances(positions) {
    for (var i = 0; i < this.glyphInfos.length; i++) {
      if (this.glyphInfos[i].isMark) {
        positions[i].xAdvance = 0;
        positions[i].yAdvance = 0;
      }
    }
  };

  OTLayoutEngine.prototype.cleanup = function cleanup() {
    this.glyphInfos = null;
    this.plan = null;
    this.shaper = null;
  };

  OTLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
    var features = [];

    if (this.GSUBProcessor) {
      this.GSUBProcessor.selectScript(script, language);
      features.push.apply(features, _Object$keys(this.GSUBProcessor.features));
    }

    if (this.GPOSProcessor) {
      this.GPOSProcessor.selectScript(script, language);
      features.push.apply(features, _Object$keys(this.GPOSProcessor.features));
    }

    return features;
  };

  return OTLayoutEngine;
}();

var LayoutEngine = function () {
  function LayoutEngine(font) {
    _classCallCheck(this, LayoutEngine);

    this.font = font;
    this.unicodeLayoutEngine = null;
    this.kernProcessor = null;

    // Choose an advanced layout engine. We try the AAT morx table first since more
    // scripts are currently supported because the shaping logic is built into the font.
    if (this.font.morx) {
      this.engine = new AATLayoutEngine(this.font);
    } else if (this.font.GSUB || this.font.GPOS) {
      this.engine = new OTLayoutEngine(this.font);
    }
  }

  LayoutEngine.prototype.layout = function layout(string, features, script, language, direction) {
    // Make the features parameter optional
    if (typeof features === 'string') {
      direction = language;
      language = script;
      script = features;
      features = [];
    }

    // Map string to glyphs if needed
    if (typeof string === 'string') {
      // Attempt to detect the script from the string if not provided.
      if (script == null) {
        script = forString(string);
      }

      var glyphs = this.font.glyphsForString(string);
    } else {
      // Attempt to detect the script from the glyph code points if not provided.
      if (script == null) {
        var codePoints = [];
        for (var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var glyph = _ref;

          codePoints.push.apply(codePoints, glyph.codePoints);
        }

        script = forCodePoints(codePoints);
      }

      var glyphs = string;
    }

    var glyphRun = new GlyphRun(glyphs, features, script, language, direction);

    // Return early if there are no glyphs
    if (glyphs.length === 0) {
      glyphRun.positions = [];
      return glyphRun;
    }

    // Setup the advanced layout engine
    if (this.engine && this.engine.setup) {
      this.engine.setup(glyphRun);
    }

    // Substitute and position the glyphs
    this.substitute(glyphRun);
    this.position(glyphRun);

    this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);

    // Let the layout engine clean up any state it might have
    if (this.engine && this.engine.cleanup) {
      this.engine.cleanup();
    }

    return glyphRun;
  };

  LayoutEngine.prototype.substitute = function substitute(glyphRun) {
    // Call the advanced layout engine to make substitutions
    if (this.engine && this.engine.substitute) {
      this.engine.substitute(glyphRun);
    }
  };

  LayoutEngine.prototype.position = function position(glyphRun) {
    // Get initial glyph positions
    glyphRun.positions = glyphRun.glyphs.map(function (glyph) {
      return new GlyphPosition(glyph.advanceWidth);
    });
    var positioned = null;

    // Call the advanced layout engine. Returns the features applied.
    if (this.engine && this.engine.position) {
      positioned = this.engine.position(glyphRun);
    }

    // if there is no GPOS table, use unicode properties to position marks.
    if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
      if (!this.unicodeLayoutEngine) {
        this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
      }

      this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
    }

    // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
    if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
      if (!this.kernProcessor) {
        this.kernProcessor = new KernProcessor(this.font);
      }

      this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
      glyphRun.features.kern = true;
    }
  };

  LayoutEngine.prototype.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
    var space = this.font.glyphForCodePoint(0x20);
    for (var i = 0; i < glyphs.length; i++) {
      if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
        glyphs[i] = space;
        positions[i].xAdvance = 0;
        positions[i].yAdvance = 0;
      }
    }
  };

  LayoutEngine.prototype.isDefaultIgnorable = function isDefaultIgnorable(ch) {
    // From DerivedCoreProperties.txt in the Unicode database,
    // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
    // Harfbuzz and Uniscribe do.
    var plane = ch >> 16;
    if (plane === 0) {
      // BMP
      switch (ch >> 8) {
        case 0x00:
          return ch === 0x00AD;
        case 0x03:
          return ch === 0x034F;
        case 0x06:
          return ch === 0x061C;
        case 0x17:
          return 0x17B4 <= ch && ch <= 0x17B5;
        case 0x18:
          return 0x180B <= ch && ch <= 0x180E;
        case 0x20:
          return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
        case 0xFE:
          return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
        case 0xFF:
          return 0xFFF0 <= ch && ch <= 0xFFF8;
        default:
          return false;
      }
    } else {
      // Other planes
      switch (plane) {
        case 0x01:
          return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
        case 0x0E:
          return 0xE0000 <= ch && ch <= 0xE0FFF;
        default:
          return false;
      }
    }
  };

  LayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
    var features = [];

    if (this.engine) {
      features.push.apply(features, this.engine.getAvailableFeatures(script, language));
    }

    if (this.font.kern && features.indexOf('kern') === -1) {
      features.push('kern');
    }

    return features;
  };

  LayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
    var result = new _Set();

    var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var codePoint = _ref2;

      result.add(_String$fromCodePoint(codePoint));
    }

    if (this.engine && this.engine.stringsForGlyph) {
      for (var _iterator3 = this.engine.stringsForGlyph(gid), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var string = _ref3;

        result.add(string);
      }
    }

    return _Array$from(result);
  };

  return LayoutEngine;
}();

var SVG_COMMANDS = {
  moveTo: 'M',
  lineTo: 'L',
  quadraticCurveTo: 'Q',
  bezierCurveTo: 'C',
  closePath: 'Z'
};

/**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */

var Path = function () {
  function Path() {
    _classCallCheck(this, Path);

    this.commands = [];
    this._bbox = null;
    this._cbox = null;
  }

  /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */


  Path.prototype.toFunction = function toFunction() {
    var cmds = this.commands.map(function (c) {
      return '  ctx.' + c.command + '(' + c.args.join(', ') + ');';
    });
    return new Function('ctx', cmds.join('\n'));
  };

  /**
   * Converts the path to an SVG path data string
   * @return {string}
   */


  Path.prototype.toSVG = function toSVG() {
    var cmds = this.commands.map(function (c) {
      var args = c.args.map(function (arg) {
        return Math.round(arg * 100) / 100;
      });
      return '' + SVG_COMMANDS[c.command] + args.join(' ');
    });

    return cmds.join('');
  };

  /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */


  /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */
  Path.prototype.mapPoints = function mapPoints(fn) {
    var path = new Path();

    for (var _iterator = this.commands, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var c = _ref;

      var args = [];
      for (var _i2 = 0; _i2 < c.args.length; _i2 += 2) {
        var _fn = fn(c.args[_i2], c.args[_i2 + 1]),
            x = _fn[0],
            y = _fn[1];

        args.push(x, y);
      }

      path[c.command].apply(path, args);
    }

    return path;
  };

  /**
   * Transforms the path by the given matrix.
   */


  Path.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
    return this.mapPoints(function (x, y) {
      x = m0 * x + m2 * y + m4;
      y = m1 * x + m3 * y + m5;
      return [x, y];
    });
  };

  /**
   * Translates the path by the given offset.
   */


  Path.prototype.translate = function translate(x, y) {
    return this.transform(1, 0, 0, 1, x, y);
  };

  /**
   * Rotates the path by the given angle (in radians).
   */


  Path.prototype.rotate = function rotate(angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return this.transform(cos, sin, -sin, cos, 0, 0);
  };

  /**
   * Scales the path.
   */


  Path.prototype.scale = function scale(scaleX) {
    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;

    return this.transform(scaleX, 0, 0, scaleY, 0, 0);
  };

  _createClass(Path, [{
    key: 'cbox',
    get: function get() {
      if (!this._cbox) {
        var cbox = new BBox();
        for (var _iterator2 = this.commands, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
          var _ref2;

          if (_isArray2) {
            if (_i3 >= _iterator2.length) break;
            _ref2 = _iterator2[_i3++];
          } else {
            _i3 = _iterator2.next();
            if (_i3.done) break;
            _ref2 = _i3.value;
          }

          var command = _ref2;

          for (var _i4 = 0; _i4 < command.args.length; _i4 += 2) {
            cbox.addPoint(command.args[_i4], command.args[_i4 + 1]);
          }
        }

        this._cbox = _Object$freeze(cbox);
      }

      return this._cbox;
    }

    /**
     * Gets the exact bounding box of the path by evaluating curve segments.
     * Slower to compute than the control box, but more accurate.
     * @type {BBox}
     */

  }, {
    key: 'bbox',
    get: function get() {
      if (this._bbox) {
        return this._bbox;
      }

      var bbox = new BBox();
      var cx = 0,
          cy = 0;

      var f = function f(t) {
        return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
      };

      for (var _iterator3 = this.commands, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i5 >= _iterator3.length) break;
          _ref3 = _iterator3[_i5++];
        } else {
          _i5 = _iterator3.next();
          if (_i5.done) break;
          _ref3 = _i5.value;
        }

        var c = _ref3;

        switch (c.command) {
          case 'moveTo':
          case 'lineTo':
            var _c$args = c.args,
                x = _c$args[0],
                y = _c$args[1];

            bbox.addPoint(x, y);
            cx = x;
            cy = y;
            break;

          case 'quadraticCurveTo':
          case 'bezierCurveTo':
            if (c.command === 'quadraticCurveTo') {
              // http://fontforge.org/bezier.html
              var _c$args2 = c.args,
                  qp1x = _c$args2[0],
                  qp1y = _c$args2[1],
                  p3x = _c$args2[2],
                  p3y = _c$args2[3];

              var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
              var cp1y = cy + 2 / 3 * (qp1y - cy);
              var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
              var cp2y = p3y + 2 / 3 * (qp1y - p3y);
            } else {
              var _c$args3 = c.args,
                  cp1x = _c$args3[0],
                  cp1y = _c$args3[1],
                  cp2x = _c$args3[2],
                  cp2y = _c$args3[3],
                  p3x = _c$args3[4],
                  p3y = _c$args3[5];
            }

            // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
            bbox.addPoint(p3x, p3y);

            var p0 = [cx, cy];
            var p1 = [cp1x, cp1y];
            var p2 = [cp2x, cp2y];
            var p3 = [p3x, p3y];

            for (var i = 0; i <= 1; i++) {
              var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
              var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
              c = 3 * p1[i] - 3 * p0[i];

              if (a === 0) {
                if (b === 0) {
                  continue;
                }

                var t = -c / b;
                if (0 < t && t < 1) {
                  if (i === 0) {
                    bbox.addPoint(f(t), bbox.maxY);
                  } else if (i === 1) {
                    bbox.addPoint(bbox.maxX, f(t));
                  }
                }

                continue;
              }

              var b2ac = Math.pow(b, 2) - 4 * c * a;
              if (b2ac < 0) {
                continue;
              }

              var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
              if (0 < t1 && t1 < 1) {
                if (i === 0) {
                  bbox.addPoint(f(t1), bbox.maxY);
                } else if (i === 1) {
                  bbox.addPoint(bbox.maxX, f(t1));
                }
              }

              var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
              if (0 < t2 && t2 < 1) {
                if (i === 0) {
                  bbox.addPoint(f(t2), bbox.maxY);
                } else if (i === 1) {
                  bbox.addPoint(bbox.maxX, f(t2));
                }
              }
            }

            cx = p3x;
            cy = p3y;
            break;
        }
      }

      return this._bbox = _Object$freeze(bbox);
    }
  }]);

  return Path;
}();

var _arr = ['moveTo', 'lineTo', 'quadraticCurveTo', 'bezierCurveTo', 'closePath'];

var _loop = function _loop() {
  var command = _arr[_i6];
  Path.prototype[command] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this._bbox = this._cbox = null;
    this.commands.push({
      command: command,
      args: args
    });

    return this;
  };
};

for (var _i6 = 0; _i6 < _arr.length; _i6++) {
  _loop();
}

var StandardNames = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

var _class$8;
function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */
var Glyph = (_class$8 = function () {
  function Glyph(id, codePoints, font) {
    _classCallCheck(this, Glyph);

    /**
     * The glyph id in the font
     * @type {number}
     */
    this.id = id;

    /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */
    this.codePoints = codePoints;
    this._font = font;

    // TODO: get this info from GDEF if available
    this.isMark = this.codePoints.every(unicode.isMark);
    this.isLigature = this.codePoints.length > 1;
  }

  Glyph.prototype._getPath = function _getPath() {
    return new Path();
  };

  Glyph.prototype._getCBox = function _getCBox() {
    return this.path.cbox;
  };

  Glyph.prototype._getBBox = function _getBBox() {
    return this.path.bbox;
  };

  Glyph.prototype._getTableMetrics = function _getTableMetrics(table) {
    if (this.id < table.metrics.length) {
      return table.metrics.get(this.id);
    }

    var metric = table.metrics.get(table.metrics.length - 1);
    var res = {
      advance: metric ? metric.advance : 0,
      bearing: table.bearings.get(this.id - table.metrics.length) || 0
    };

    return res;
  };

  Glyph.prototype._getMetrics = function _getMetrics(cbox) {
    if (this._metrics) {
      return this._metrics;
    }

    var _getTableMetrics2 = this._getTableMetrics(this._font.hmtx),
        advanceWidth = _getTableMetrics2.advance,
        leftBearing = _getTableMetrics2.bearing;

    // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea


    if (this._font.vmtx) {
      var _getTableMetrics3 = this._getTableMetrics(this._font.vmtx),
          advanceHeight = _getTableMetrics3.advance,
          topBearing = _getTableMetrics3.bearing;
    } else {
      var os2 = void 0;
      if (typeof cbox === 'undefined' || cbox === null) {
        cbox = this.cbox;
      }

      if ((os2 = this._font['OS/2']) && os2.version > 0) {
        var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
        var topBearing = os2.typoAscender - cbox.maxY;
      } else {
        var hhea = this._font.hhea;

        var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
        var topBearing = hhea.ascent - cbox.maxY;
      }
    }

    if (this._font._variationProcessor && this._font.HVAR) {
      advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
    }

    return this._metrics = { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing };
  };

  /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */


  /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */
  Glyph.prototype.getScaledPath = function getScaledPath(size) {
    var scale = 1 / this._font.unitsPerEm * size;
    return this.path.scale(scale);
  };

  /**
   * The glyph's advance width.
   * @type {number}
   */


  Glyph.prototype._getName = function _getName() {
    var post = this._font.post;

    if (!post) {
      return null;
    }

    switch (post.version) {
      case 1:
        return StandardNames[this.id];

      case 2:
        var id = post.glyphNameIndex[this.id];
        if (id < StandardNames.length) {
          return StandardNames[id];
        }

        return post.names[id - StandardNames.length];

      case 2.5:
        return StandardNames[this.id + post.offsets[this.id]];

      case 4:
        return String.fromCharCode(post.map[this.id]);
    }
  };

  /**
   * The glyph's name
   * @type {string}
   */


  /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */
  Glyph.prototype.render = function render(ctx, size) {
    ctx.save();

    var scale = 1 / this._font.head.unitsPerEm * size;
    ctx.scale(scale, scale);

    var fn = this.path.toFunction();
    fn(ctx);
    ctx.fill();

    ctx.restore();
  };

  _createClass(Glyph, [{
    key: 'cbox',
    get: function get() {
      return this._getCBox();
    }

    /**
     * The glyph’s bounding box, i.e. the rectangle that encloses the
     * glyph outline as tightly as possible.
     * @type {BBox}
     */

  }, {
    key: 'bbox',
    get: function get() {
      return this._getBBox();
    }

    /**
     * A vector Path object representing the glyph outline.
     * @type {Path}
     */

  }, {
    key: 'path',
    get: function get() {
      // Cache the path so we only decode it once
      // Decoding is actually performed by subclasses
      return this._getPath();
    }
  }, {
    key: 'advanceWidth',
    get: function get() {
      return this._getMetrics().advanceWidth;
    }

    /**
     * The glyph's advance height.
     * @type {number}
     */

  }, {
    key: 'advanceHeight',
    get: function get() {
      return this._getMetrics().advanceHeight;
    }
  }, {
    key: 'ligatureCaretPositions',
    get: function get() {}
  }, {
    key: 'name',
    get: function get() {
      return this._getName();
    }
  }]);

  return Glyph;
}(), (_applyDecoratedDescriptor$4(_class$8.prototype, 'cbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'cbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'bbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'path', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'path'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceWidth', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceWidth'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceHeight', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceHeight'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'name', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'name'), _class$8.prototype)), _class$8);

// The header for both simple and composite glyphs
var GlyfHeader = new r.Struct({
  numberOfContours: r.int16, // if negative, this is a composite glyph
  xMin: r.int16,
  yMin: r.int16,
  xMax: r.int16,
  yMax: r.int16
});

// Flags for simple glyphs
var ON_CURVE = 1 << 0;
var X_SHORT_VECTOR = 1 << 1;
var Y_SHORT_VECTOR = 1 << 2;
var REPEAT = 1 << 3;
var SAME_X = 1 << 4;
var SAME_Y = 1 << 5;

// Flags for composite glyphs
var ARG_1_AND_2_ARE_WORDS = 1 << 0;
var WE_HAVE_A_SCALE = 1 << 3;
var MORE_COMPONENTS = 1 << 5;
var WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
var WE_HAVE_A_TWO_BY_TWO = 1 << 7;
var WE_HAVE_INSTRUCTIONS = 1 << 8;
// Represents a point in a simple glyph
var Point = function () {
  function Point(onCurve, endContour) {
    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Point);

    this.onCurve = onCurve;
    this.endContour = endContour;
    this.x = x;
    this.y = y;
  }

  Point.prototype.copy = function copy() {
    return new Point(this.onCurve, this.endContour, this.x, this.y);
  };

  return Point;
}();

// Represents a component in a composite glyph

var Component = function Component(glyphID, dx, dy) {
  _classCallCheck(this, Component);

  this.glyphID = glyphID;
  this.dx = dx;
  this.dy = dy;
  this.pos = 0;
  this.scaleX = this.scaleY = 1;
  this.scale01 = this.scale10 = 0;
};

/**
 * Represents a TrueType glyph.
 */


var TTFGlyph = function (_Glyph) {
  _inherits(TTFGlyph, _Glyph);

  function TTFGlyph() {
    _classCallCheck(this, TTFGlyph);

    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
  }

  // Parses just the glyph header and returns the bounding box
  TTFGlyph.prototype._getCBox = function _getCBox(internal) {
    // We need to decode the glyph if variation processing is requested,
    // so it's easier just to recompute the path's cbox after decoding.
    if (this._font._variationProcessor && !internal) {
      return this.path.cbox;
    }

    var stream = this._font._getTableStream('glyf');
    stream.pos += this._font.loca.offsets[this.id];
    var glyph = GlyfHeader.decode(stream);

    var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
    return _Object$freeze(cbox);
  };

  // Parses a single glyph coordinate


  TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
    if (short) {
      var val = stream.readUInt8();
      if (!same) {
        val = -val;
      }

      val += prev;
    } else {
      if (same) {
        var val = prev;
      } else {
        var val = prev + stream.readInt16BE();
      }
    }

    return val;
  };

  // Decodes the glyph data into points for simple glyphs,
  // or components for composite glyphs


  TTFGlyph.prototype._decode = function _decode() {
    var glyfPos = this._font.loca.offsets[this.id];
    var nextPos = this._font.loca.offsets[this.id + 1];

    // Nothing to do if there is no data for this glyph
    if (glyfPos === nextPos) {
      return null;
    }

    var stream = this._font._getTableStream('glyf');
    stream.pos += glyfPos;
    var startPos = stream.pos;

    var glyph = GlyfHeader.decode(stream);

    if (glyph.numberOfContours > 0) {
      this._decodeSimple(glyph, stream);
    } else if (glyph.numberOfContours < 0) {
      this._decodeComposite(glyph, stream, startPos);
    }

    return glyph;
  };

  TTFGlyph.prototype._decodeSimple = function _decodeSimple(glyph, stream) {
    // this is a simple glyph
    glyph.points = [];

    var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
    glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);

    var flags = [];
    var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;

    while (flags.length < numCoords) {
      var flag = stream.readUInt8();
      flags.push(flag);

      // check for repeat flag
      if (flag & REPEAT) {
        var count = stream.readUInt8();
        for (var j = 0; j < count; j++) {
          flags.push(flag);
        }
      }
    }

    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
      glyph.points.push(point);
    }

    var px = 0;
    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
    }

    var py = 0;
    for (var i = 0; i < flags.length; i++) {
      var flag = flags[i];
      glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
    }

    if (this._font._variationProcessor) {
      var points = glyph.points.slice();
      points.push.apply(points, this._getPhantomPoints(glyph));

      this._font._variationProcessor.transformPoints(this.id, points);
      glyph.phantomPoints = points.slice(-4);
    }

    return;
  };

  TTFGlyph.prototype._decodeComposite = function _decodeComposite(glyph, stream) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    // this is a composite glyph
    glyph.components = [];
    var haveInstructions = false;
    var flags = MORE_COMPONENTS;

    while (flags & MORE_COMPONENTS) {
      flags = stream.readUInt16BE();
      var gPos = stream.pos - offset;
      var glyphID = stream.readUInt16BE();
      if (!haveInstructions) {
        haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
      }

      if (flags & ARG_1_AND_2_ARE_WORDS) {
        var dx = stream.readInt16BE();
        var dy = stream.readInt16BE();
      } else {
        var dx = stream.readInt8();
        var dy = stream.readInt8();
      }

      var component = new Component(glyphID, dx, dy);
      component.pos = gPos;

      if (flags & WE_HAVE_A_SCALE) {
        // fixed number with 14 bits of fraction
        component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
      }

      glyph.components.push(component);
    }

    if (this._font._variationProcessor) {
      var points = [];
      for (var j = 0; j < glyph.components.length; j++) {
        var component = glyph.components[j];
        points.push(new Point(true, true, component.dx, component.dy));
      }

      points.push.apply(points, this._getPhantomPoints(glyph));

      this._font._variationProcessor.transformPoints(this.id, points);
      glyph.phantomPoints = points.splice(-4, 4);

      for (var i = 0; i < points.length; i++) {
        var point = points[i];
        glyph.components[i].dx = point.x;
        glyph.components[i].dy = point.y;
      }
    }

    return haveInstructions;
  };

  TTFGlyph.prototype._getPhantomPoints = function _getPhantomPoints(glyph) {
    var cbox = this._getCBox(true);
    if (this._metrics == null) {
      this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
    }

    var _metrics = this._metrics,
        advanceWidth = _metrics.advanceWidth,
        advanceHeight = _metrics.advanceHeight,
        leftBearing = _metrics.leftBearing,
        topBearing = _metrics.topBearing;


    return [new Point(false, true, glyph.xMin - leftBearing, 0), new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0), new Point(false, true, 0, glyph.yMax + topBearing), new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)];
  };

  // Decodes font data, resolves composite glyphs, and returns an array of contours


  TTFGlyph.prototype._getContours = function _getContours() {
    var glyph = this._decode();
    if (!glyph) {
      return [];
    }

    var points = [];

    if (glyph.numberOfContours < 0) {
      // resolve composite glyphs
      for (var _iterator = glyph.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var component = _ref;

        var _contours = this._font.getGlyph(component.glyphID)._getContours();
        for (var i = 0; i < _contours.length; i++) {
          var contour = _contours[i];
          for (var j = 0; j < contour.length; j++) {
            var _point = contour[j];
            var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
            var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
            points.push(new Point(_point.onCurve, _point.endContour, x, y));
          }
        }
      }
    } else {
      points = glyph.points || [];
    }

    // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
    if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
      this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
      this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
      this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
      this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
    }

    var contours = [];
    var cur = [];
    for (var k = 0; k < points.length; k++) {
      var point = points[k];
      cur.push(point);
      if (point.endContour) {
        contours.push(cur);
        cur = [];
      }
    }

    return contours;
  };

  TTFGlyph.prototype._getMetrics = function _getMetrics() {
    if (this._metrics) {
      return this._metrics;
    }

    var cbox = this._getCBox(true);
    _Glyph.prototype._getMetrics.call(this, cbox);

    if (this._font._variationProcessor && !this._font.HVAR) {
      // No HVAR table, decode the glyph. This triggers recomputation of metrics.
      this.path;
    }

    return this._metrics;
  };

  // Converts contours to a Path object that can be rendered


  TTFGlyph.prototype._getPath = function _getPath() {
    var contours = this._getContours();
    var path = new Path();

    for (var i = 0; i < contours.length; i++) {
      var contour = contours[i];
      var firstPt = contour[0];
      var lastPt = contour[contour.length - 1];
      var start = 0;

      if (firstPt.onCurve) {
        // The first point will be consumed by the moveTo command, so skip in the loop
        var curvePt = null;
        start = 1;
      } else {
        if (lastPt.onCurve) {
          // Start at the last point if the first point is off curve and the last point is on curve
          firstPt = lastPt;
        } else {
          // Start at the middle if both the first and last points are off curve
          firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
        }

        var curvePt = firstPt;
      }

      path.moveTo(firstPt.x, firstPt.y);

      for (var j = start; j < contour.length; j++) {
        var pt = contour[j];
        var prevPt = j === 0 ? firstPt : contour[j - 1];

        if (prevPt.onCurve && pt.onCurve) {
          path.lineTo(pt.x, pt.y);
        } else if (prevPt.onCurve && !pt.onCurve) {
          var curvePt = pt;
        } else if (!prevPt.onCurve && !pt.onCurve) {
          var midX = (prevPt.x + pt.x) / 2;
          var midY = (prevPt.y + pt.y) / 2;
          path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
          var curvePt = pt;
        } else if (!prevPt.onCurve && pt.onCurve) {
          path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
          var curvePt = null;
        } else {
          throw new Error("Unknown TTF path state");
        }
      }

      // Connect the first and last points
      if (curvePt) {
        path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
      }

      path.closePath();
    }

    return path;
  };

  return TTFGlyph;
}(Glyph);

/**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */

var CFFGlyph = function (_Glyph) {
  _inherits(CFFGlyph, _Glyph);

  function CFFGlyph() {
    _classCallCheck(this, CFFGlyph);

    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
  }

  CFFGlyph.prototype._getName = function _getName() {
    if (this._font.CFF2) {
      return _Glyph.prototype._getName.call(this);
    }

    return this._font['CFF '].getGlyphName(this.id);
  };

  CFFGlyph.prototype.bias = function bias(s) {
    if (s.length < 1240) {
      return 107;
    } else if (s.length < 33900) {
      return 1131;
    } else {
      return 32768;
    }
  };

  CFFGlyph.prototype._getPath = function _getPath() {
    var stream = this._font.stream;
    var pos = stream.pos;


    var cff = this._font.CFF2 || this._font['CFF '];
    var str = cff.topDict.CharStrings[this.id];
    var end = str.offset + str.length;
    stream.pos = str.offset;

    var path = new Path();
    var stack = [];
    var trans = [];

    var width = null;
    var nStems = 0;
    var x = 0,
        y = 0;
    var usedGsubrs = void 0;
    var usedSubrs = void 0;
    var open = false;

    this._usedGsubrs = usedGsubrs = {};
    this._usedSubrs = usedSubrs = {};

    var gsubrs = cff.globalSubrIndex || [];
    var gsubrsBias = this.bias(gsubrs);

    var privateDict = cff.privateDictForGlyph(this.id);
    var subrs = privateDict.Subrs || [];
    var subrsBias = this.bias(subrs);

    var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
    var vsindex = privateDict.vsindex;
    var variationProcessor = this._font._variationProcessor;

    function checkWidth() {
      if (width == null) {
        width = stack.shift() + privateDict.nominalWidthX;
      }
    }

    function parseStems() {
      if (stack.length % 2 !== 0) {
        checkWidth();
      }

      nStems += stack.length >> 1;
      return stack.length = 0;
    }

    function moveTo(x, y) {
      if (open) {
        path.closePath();
      }

      path.moveTo(x, y);
      open = true;
    }

    var parse = function parse() {
      while (stream.pos < end) {
        var op = stream.readUInt8();
        if (op < 32) {
          switch (op) {
            case 1: // hstem
            case 3: // vstem
            case 18: // hstemhm
            case 23:
              // vstemhm
              parseStems();
              break;

            case 4:
              // vmoveto
              if (stack.length > 1) {
                checkWidth();
              }

              y += stack.shift();
              moveTo(x, y);
              break;

            case 5:
              // rlineto
              while (stack.length >= 2) {
                x += stack.shift();
                y += stack.shift();
                path.lineTo(x, y);
              }
              break;

            case 6: // hlineto
            case 7:
              // vlineto
              var phase = op === 6;
              while (stack.length >= 1) {
                if (phase) {
                  x += stack.shift();
                } else {
                  y += stack.shift();
                }

                path.lineTo(x, y);
                phase = !phase;
              }
              break;

            case 8:
              // rrcurveto
              while (stack.length > 0) {
                var c1x = x + stack.shift();
                var c1y = y + stack.shift();
                var c2x = c1x + stack.shift();
                var c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y + stack.shift();
                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;

            case 10:
              // callsubr
              var index = stack.pop() + subrsBias;
              var subr = subrs[index];
              if (subr) {
                usedSubrs[index] = true;
                var p = stream.pos;
                var e = end;
                stream.pos = subr.offset;
                end = subr.offset + subr.length;
                parse();
                stream.pos = p;
                end = e;
              }
              break;

            case 11:
              // return
              if (cff.version >= 2) {
                break;
              }
              return;

            case 14:
              // endchar
              if (cff.version >= 2) {
                break;
              }

              if (stack.length > 0) {
                checkWidth();
              }

              if (open) {
                path.closePath();
                open = false;
              }
              break;

            case 15:
              {
                // vsindex
                if (cff.version < 2) {
                  throw new Error('vsindex operator not supported in CFF v1');
                }

                vsindex = stack.pop();
                break;
              }

            case 16:
              {
                // blend
                if (cff.version < 2) {
                  throw new Error('blend operator not supported in CFF v1');
                }

                if (!variationProcessor) {
                  throw new Error('blend operator in non-variation font');
                }

                var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                var numBlends = stack.pop();
                var numOperands = numBlends * blendVector.length;
                var delta = stack.length - numOperands;
                var base = delta - numBlends;

                for (var i = 0; i < numBlends; i++) {
                  var sum = stack[base + i];
                  for (var j = 0; j < blendVector.length; j++) {
                    sum += blendVector[j] * stack[delta++];
                  }

                  stack[base + i] = sum;
                }

                while (numOperands--) {
                  stack.pop();
                }

                break;
              }

            case 19: // hintmask
            case 20:
              // cntrmask
              parseStems();
              stream.pos += nStems + 7 >> 3;
              break;

            case 21:
              // rmoveto
              if (stack.length > 2) {
                checkWidth();
              }

              x += stack.shift();
              y += stack.shift();
              moveTo(x, y);
              break;

            case 22:
              // hmoveto
              if (stack.length > 1) {
                checkWidth();
              }

              x += stack.shift();
              moveTo(x, y);
              break;

            case 24:
              // rcurveline
              while (stack.length >= 8) {
                var c1x = x + stack.shift();
                var c1y = y + stack.shift();
                var c2x = c1x + stack.shift();
                var c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y + stack.shift();
                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }

              x += stack.shift();
              y += stack.shift();
              path.lineTo(x, y);
              break;

            case 25:
              // rlinecurve
              while (stack.length >= 8) {
                x += stack.shift();
                y += stack.shift();
                path.lineTo(x, y);
              }

              var c1x = x + stack.shift();
              var c1y = y + stack.shift();
              var c2x = c1x + stack.shift();
              var c2y = c1y + stack.shift();
              x = c2x + stack.shift();
              y = c2y + stack.shift();
              path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              break;

            case 26:
              // vvcurveto
              if (stack.length % 2) {
                x += stack.shift();
              }

              while (stack.length >= 4) {
                c1x = x;
                c1y = y + stack.shift();
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x;
                y = c2y + stack.shift();
                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;

            case 27:
              // hhcurveto
              if (stack.length % 2) {
                y += stack.shift();
              }

              while (stack.length >= 4) {
                c1x = x + stack.shift();
                c1y = y;
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y;
                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
              }
              break;

            case 28:
              // shortint
              stack.push(stream.readInt16BE());
              break;

            case 29:
              // callgsubr
              index = stack.pop() + gsubrsBias;
              subr = gsubrs[index];
              if (subr) {
                usedGsubrs[index] = true;
                var p = stream.pos;
                var e = end;
                stream.pos = subr.offset;
                end = subr.offset + subr.length;
                parse();
                stream.pos = p;
                end = e;
              }
              break;

            case 30: // vhcurveto
            case 31:
              // hvcurveto
              phase = op === 31;
              while (stack.length >= 4) {
                if (phase) {
                  c1x = x + stack.shift();
                  c1y = y;
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  y = c2y + stack.shift();
                  x = c2x + (stack.length === 1 ? stack.shift() : 0);
                } else {
                  c1x = x;
                  c1y = y + stack.shift();
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  x = c2x + stack.shift();
                  y = c2y + (stack.length === 1 ? stack.shift() : 0);
                }

                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                phase = !phase;
              }
              break;

            case 12:
              op = stream.readUInt8();
              switch (op) {
                case 3:
                  // and
                  var a = stack.pop();
                  var b = stack.pop();
                  stack.push(a && b ? 1 : 0);
                  break;

                case 4:
                  // or
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a || b ? 1 : 0);
                  break;

                case 5:
                  // not
                  a = stack.pop();
                  stack.push(a ? 0 : 1);
                  break;

                case 9:
                  // abs
                  a = stack.pop();
                  stack.push(Math.abs(a));
                  break;

                case 10:
                  // add
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a + b);
                  break;

                case 11:
                  // sub
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a - b);
                  break;

                case 12:
                  // div
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a / b);
                  break;

                case 14:
                  // neg
                  a = stack.pop();
                  stack.push(-a);
                  break;

                case 15:
                  // eq
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a === b ? 1 : 0);
                  break;

                case 18:
                  // drop
                  stack.pop();
                  break;

                case 20:
                  // put
                  var val = stack.pop();
                  var idx = stack.pop();
                  trans[idx] = val;
                  break;

                case 21:
                  // get
                  idx = stack.pop();
                  stack.push(trans[idx] || 0);
                  break;

                case 22:
                  // ifelse
                  var s1 = stack.pop();
                  var s2 = stack.pop();
                  var v1 = stack.pop();
                  var v2 = stack.pop();
                  stack.push(v1 <= v2 ? s1 : s2);
                  break;

                case 23:
                  // random
                  stack.push(Math.random());
                  break;

                case 24:
                  // mul
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(a * b);
                  break;

                case 26:
                  // sqrt
                  a = stack.pop();
                  stack.push(Math.sqrt(a));
                  break;

                case 27:
                  // dup
                  a = stack.pop();
                  stack.push(a, a);
                  break;

                case 28:
                  // exch
                  a = stack.pop();
                  b = stack.pop();
                  stack.push(b, a);
                  break;

                case 29:
                  // index
                  idx = stack.pop();
                  if (idx < 0) {
                    idx = 0;
                  } else if (idx > stack.length - 1) {
                    idx = stack.length - 1;
                  }

                  stack.push(stack[idx]);
                  break;

                case 30:
                  // roll
                  var n = stack.pop();
                  var _j = stack.pop();

                  if (_j >= 0) {
                    while (_j > 0) {
                      var t = stack[n - 1];
                      for (var _i = n - 2; _i >= 0; _i--) {
                        stack[_i + 1] = stack[_i];
                      }

                      stack[0] = t;
                      _j--;
                    }
                  } else {
                    while (_j < 0) {
                      var t = stack[0];
                      for (var _i2 = 0; _i2 <= n; _i2++) {
                        stack[_i2] = stack[_i2 + 1];
                      }

                      stack[n - 1] = t;
                      _j++;
                    }
                  }
                  break;

                case 34:
                  // hflex
                  c1x = x + stack.shift();
                  c1y = y;
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  var c3x = c2x + stack.shift();
                  var c3y = c2y;
                  var c4x = c3x + stack.shift();
                  var c4y = c3y;
                  var c5x = c4x + stack.shift();
                  var c5y = c4y;
                  var c6x = c5x + stack.shift();
                  var c6y = c5y;
                  x = c6x;
                  y = c6y;

                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                  break;

                case 35:
                  // flex
                  var pts = [];

                  for (var _i3 = 0; _i3 <= 5; _i3++) {
                    x += stack.shift();
                    y += stack.shift();
                    pts.push(x, y);
                  }

                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
                  path.bezierCurveTo.apply(path, pts.slice(6));
                  stack.shift(); // fd
                  break;

                case 36:
                  // hflex1
                  c1x = x + stack.shift();
                  c1y = y + stack.shift();
                  c2x = c1x + stack.shift();
                  c2y = c1y + stack.shift();
                  c3x = c2x + stack.shift();
                  c3y = c2y;
                  c4x = c3x + stack.shift();
                  c4y = c3y;
                  c5x = c4x + stack.shift();
                  c5y = c4y + stack.shift();
                  c6x = c5x + stack.shift();
                  c6y = c5y;
                  x = c6x;
                  y = c6y;

                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                  break;

                case 37:
                  // flex1
                  var startx = x;
                  var starty = y;

                  pts = [];
                  for (var _i4 = 0; _i4 <= 4; _i4++) {
                    x += stack.shift();
                    y += stack.shift();
                    pts.push(x, y);
                  }

                  if (Math.abs(x - startx) > Math.abs(y - starty)) {
                    // horizontal
                    x += stack.shift();
                    y = starty;
                  } else {
                    x = startx;
                    y += stack.shift();
                  }

                  pts.push(x, y);
                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
                  path.bezierCurveTo.apply(path, pts.slice(6));
                  break;

                default:
                  throw new Error('Unknown op: 12 ' + op);
              }
              break;

            default:
              throw new Error('Unknown op: ' + op);
          }
        } else if (op < 247) {
          stack.push(op - 139);
        } else if (op < 251) {
          var b1 = stream.readUInt8();
          stack.push((op - 247) * 256 + b1 + 108);
        } else if (op < 255) {
          var b1 = stream.readUInt8();
          stack.push(-(op - 251) * 256 - b1 - 108);
        } else {
          stack.push(stream.readInt32BE() / 65536);
        }
      }
    };

    parse();

    if (open) {
      path.closePath();
    }

    return path;
  };

  return CFFGlyph;
}(Glyph);

var SBIXImage = new r.Struct({
  originX: r.uint16,
  originY: r.uint16,
  type: new r.String(4),
  data: new r.Buffer(function (t) {
    return t.parent.buflen - t._currentOffset;
  })
});

/**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */

var SBIXGlyph = function (_TTFGlyph) {
  _inherits(SBIXGlyph, _TTFGlyph);

  function SBIXGlyph() {
    _classCallCheck(this, SBIXGlyph);

    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
  }

  /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */
  SBIXGlyph.prototype.getImageForSize = function getImageForSize(size) {
    for (var i = 0; i < this._font.sbix.imageTables.length; i++) {
      var table = this._font.sbix.imageTables[i];
      if (table.ppem >= size) {
        break;
      }
    }

    var offsets = table.imageOffsets;
    var start = offsets[this.id];
    var end = offsets[this.id + 1];

    if (start === end) {
      return null;
    }

    this._font.stream.pos = start;
    return SBIXImage.decode(this._font.stream, { buflen: end - start });
  };

  SBIXGlyph.prototype.render = function render(ctx, size) {
    var img = this.getImageForSize(size);
    if (img != null) {
      var scale = size / this._font.unitsPerEm;
      ctx.image(img.data, { height: size, x: img.originX, y: (this.bbox.minY - img.originY) * scale });
    }

    if (this._font.sbix.flags.renderOutlines) {
      _TTFGlyph.prototype.render.call(this, ctx, size);
    }
  };

  return SBIXGlyph;
}(TTFGlyph);

var COLRLayer = function COLRLayer(glyph, color) {
  _classCallCheck(this, COLRLayer);

  this.glyph = glyph;
  this.color = color;
};

/**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */


var COLRGlyph = function (_Glyph) {
  _inherits(COLRGlyph, _Glyph);

  function COLRGlyph() {
    _classCallCheck(this, COLRGlyph);

    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
  }

  COLRGlyph.prototype._getBBox = function _getBBox() {
    var bbox = new BBox();
    for (var i = 0; i < this.layers.length; i++) {
      var layer = this.layers[i];
      var b = layer.glyph.bbox;
      bbox.addPoint(b.minX, b.minY);
      bbox.addPoint(b.maxX, b.maxY);
    }

    return bbox;
  };

  /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */


  COLRGlyph.prototype.render = function render(ctx, size) {
    for (var _iterator = this.layers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var _ref2 = _ref,
          glyph = _ref2.glyph,
          color = _ref2.color;

      ctx.fillColor([color.red, color.green, color.blue], color.alpha / 255 * 100);
      glyph.render(ctx, size);
    }

    return;
  };

  _createClass(COLRGlyph, [{
    key: 'layers',
    get: function get() {
      var cpal = this._font.CPAL;
      var colr = this._font.COLR;
      var low = 0;
      var high = colr.baseGlyphRecord.length - 1;

      while (low <= high) {
        var mid = low + high >> 1;
        var rec = colr.baseGlyphRecord[mid];

        if (this.id < rec.gid) {
          high = mid - 1;
        } else if (this.id > rec.gid) {
          low = mid + 1;
        } else {
          var baseLayer = rec;
          break;
        }
      }

      // if base glyph not found in COLR table,
      // default to normal glyph from glyf or CFF
      if (baseLayer == null) {
        var g = this._font._getBaseGlyph(this.id);
        var color = {
          red: 0,
          green: 0,
          blue: 0,
          alpha: 255
        };

        return [new COLRLayer(g, color)];
      }

      // otherwise, return an array of all the layers
      var layers = [];
      for (var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
        var rec = colr.layerRecords[i];
        var color = cpal.colorRecords[rec.paletteIndex];
        var g = this._font._getBaseGlyph(rec.gid);
        layers.push(new COLRLayer(g, color));
      }

      return layers;
    }
  }]);

  return COLRGlyph;
}(Glyph);

var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
var TUPLE_COUNT_MASK = 0x0fff;
var EMBEDDED_TUPLE_COORD = 0x8000;
var INTERMEDIATE_TUPLE = 0x4000;
var PRIVATE_POINT_NUMBERS = 0x2000;
var TUPLE_INDEX_MASK = 0x0fff;
var POINTS_ARE_WORDS = 0x80;
var POINT_RUN_COUNT_MASK = 0x7f;
var DELTAS_ARE_ZERO = 0x80;
var DELTAS_ARE_WORDS = 0x40;
var DELTA_RUN_COUNT_MASK = 0x3f;

/**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */

var GlyphVariationProcessor = function () {
  function GlyphVariationProcessor(font, coords) {
    _classCallCheck(this, GlyphVariationProcessor);

    this.font = font;
    this.normalizedCoords = this.normalizeCoords(coords);
    this.blendVectors = new _Map();
  }

  GlyphVariationProcessor.prototype.normalizeCoords = function normalizeCoords(coords) {
    // the default mapping is linear along each axis, in two segments:
    // from the minValue to defaultValue, and from defaultValue to maxValue.
    var normalized = [];
    for (var i = 0; i < this.font.fvar.axis.length; i++) {
      var axis = this.font.fvar.axis[i];
      if (coords[i] < axis.defaultValue) {
        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.defaultValue - axis.minValue + _Number$EPSILON));
      } else {
        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.maxValue - axis.defaultValue + _Number$EPSILON));
      }
    }

    // if there is an avar table, the normalized value is calculated
    // by interpolating between the two nearest mapped values.
    if (this.font.avar) {
      for (var i = 0; i < this.font.avar.segment.length; i++) {
        var segment = this.font.avar.segment[i];
        for (var j = 0; j < segment.correspondence.length; j++) {
          var pair = segment.correspondence[j];
          if (j >= 1 && normalized[i] < pair.fromCoord) {
            var prev = segment.correspondence[j - 1];
            normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + _Number$EPSILON) / (pair.fromCoord - prev.fromCoord + _Number$EPSILON) + prev.toCoord;

            break;
          }
        }
      }
    }

    return normalized;
  };

  GlyphVariationProcessor.prototype.transformPoints = function transformPoints(gid, glyphPoints) {
    if (!this.font.fvar || !this.font.gvar) {
      return;
    }

    var gvar = this.font.gvar;

    if (gid >= gvar.glyphCount) {
      return;
    }

    var offset = gvar.offsets[gid];
    if (offset === gvar.offsets[gid + 1]) {
      return;
    }

    // Read the gvar data for this glyph
    var stream = this.font.stream;

    stream.pos = offset;
    if (stream.pos >= stream.length) {
      return;
    }

    var tupleCount = stream.readUInt16BE();
    var offsetToData = offset + stream.readUInt16BE();

    if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
      var here = stream.pos;
      stream.pos = offsetToData;
      var sharedPoints = this.decodePoints();
      offsetToData = stream.pos;
      stream.pos = here;
    }

    var origPoints = glyphPoints.map(function (pt) {
      return pt.copy();
    });

    tupleCount &= TUPLE_COUNT_MASK;
    for (var i = 0; i < tupleCount; i++) {
      var tupleDataSize = stream.readUInt16BE();
      var tupleIndex = stream.readUInt16BE();

      if (tupleIndex & EMBEDDED_TUPLE_COORD) {
        var tupleCoords = [];
        for (var a = 0; a < gvar.axisCount; a++) {
          tupleCoords.push(stream.readInt16BE() / 16384);
        }
      } else {
        if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) {
          throw new Error('Invalid gvar table');
        }

        var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
      }

      if (tupleIndex & INTERMEDIATE_TUPLE) {
        var startCoords = [];
        for (var _a = 0; _a < gvar.axisCount; _a++) {
          startCoords.push(stream.readInt16BE() / 16384);
        }

        var endCoords = [];
        for (var _a2 = 0; _a2 < gvar.axisCount; _a2++) {
          endCoords.push(stream.readInt16BE() / 16384);
        }
      }

      // Get the factor at which to apply this tuple
      var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
      if (factor === 0) {
        offsetToData += tupleDataSize;
        continue;
      }

      var here = stream.pos;
      stream.pos = offsetToData;

      if (tupleIndex & PRIVATE_POINT_NUMBERS) {
        var points = this.decodePoints();
      } else {
        var points = sharedPoints;
      }

      // points.length = 0 means there are deltas for all points
      var nPoints = points.length === 0 ? glyphPoints.length : points.length;
      var xDeltas = this.decodeDeltas(nPoints);
      var yDeltas = this.decodeDeltas(nPoints);

      if (points.length === 0) {
        // all points
        for (var _i = 0; _i < glyphPoints.length; _i++) {
          var point = glyphPoints[_i];
          point.x += Math.round(xDeltas[_i] * factor);
          point.y += Math.round(yDeltas[_i] * factor);
        }
      } else {
        var outPoints = origPoints.map(function (pt) {
          return pt.copy();
        });
        var hasDelta = glyphPoints.map(function () {
          return false;
        });

        for (var _i2 = 0; _i2 < points.length; _i2++) {
          var idx = points[_i2];
          if (idx < glyphPoints.length) {
            var _point = outPoints[idx];
            hasDelta[idx] = true;

            _point.x += Math.round(xDeltas[_i2] * factor);
            _point.y += Math.round(yDeltas[_i2] * factor);
          }
        }

        this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);

        for (var _i3 = 0; _i3 < glyphPoints.length; _i3++) {
          var deltaX = outPoints[_i3].x - origPoints[_i3].x;
          var deltaY = outPoints[_i3].y - origPoints[_i3].y;

          glyphPoints[_i3].x += deltaX;
          glyphPoints[_i3].y += deltaY;
        }
      }

      offsetToData += tupleDataSize;
      stream.pos = here;
    }
  };

  GlyphVariationProcessor.prototype.decodePoints = function decodePoints() {
    var stream = this.font.stream;
    var count = stream.readUInt8();

    if (count & POINTS_ARE_WORDS) {
      count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
    }

    var points = new Uint16Array(count);
    var i = 0;
    var point = 0;
    while (i < count) {
      var run = stream.readUInt8();
      var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
      var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;

      for (var j = 0; j < runCount && i < count; j++) {
        point += fn.call(stream);
        points[i++] = point;
      }
    }

    return points;
  };

  GlyphVariationProcessor.prototype.decodeDeltas = function decodeDeltas(count) {
    var stream = this.font.stream;
    var i = 0;
    var deltas = new Int16Array(count);

    while (i < count) {
      var run = stream.readUInt8();
      var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;

      if (run & DELTAS_ARE_ZERO) {
        i += runCount;
      } else {
        var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
        for (var j = 0; j < runCount && i < count; j++) {
          deltas[i++] = fn.call(stream);
        }
      }
    }

    return deltas;
  };

  GlyphVariationProcessor.prototype.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
    var normalized = this.normalizedCoords;
    var gvar = this.font.gvar;

    var factor = 1;

    for (var i = 0; i < gvar.axisCount; i++) {
      if (tupleCoords[i] === 0) {
        continue;
      }

      if (normalized[i] === 0) {
        return 0;
      }

      if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
        if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) {
          return 0;
        }

        factor = (factor * normalized[i] + _Number$EPSILON) / (tupleCoords[i] + _Number$EPSILON);
      } else {
        if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) {
          return 0;
        } else if (normalized[i] < tupleCoords[i]) {
          factor = factor * (normalized[i] - startCoords[i] + _Number$EPSILON) / (tupleCoords[i] - startCoords[i] + _Number$EPSILON);
        } else {
          factor = factor * (endCoords[i] - normalized[i] + _Number$EPSILON) / (endCoords[i] - tupleCoords[i] + _Number$EPSILON);
        }
      }
    }

    return factor;
  };

  // Interpolates points without delta values.
  // Needed for the Ø and Q glyphs in Skia.
  // Algorithm from Freetype.


  GlyphVariationProcessor.prototype.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
    if (points.length === 0) {
      return;
    }

    var point = 0;
    while (point < points.length) {
      var firstPoint = point;

      // find the end point of the contour
      var endPoint = point;
      var pt = points[endPoint];
      while (!pt.endContour) {
        pt = points[++endPoint];
      }

      // find the first point that has a delta
      while (point <= endPoint && !hasDelta[point]) {
        point++;
      }

      if (point > endPoint) {
        continue;
      }

      var firstDelta = point;
      var curDelta = point;
      point++;

      while (point <= endPoint) {
        // find the next point with a delta, and interpolate intermediate points
        if (hasDelta[point]) {
          this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
          curDelta = point;
        }

        point++;
      }

      // shift contour if we only have a single delta
      if (curDelta === firstDelta) {
        this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
      } else {
        // otherwise, handle the remaining points at the end and beginning of the contour
        this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);

        if (firstDelta > 0) {
          this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
        }
      }

      point = endPoint + 1;
    }
  };

  GlyphVariationProcessor.prototype.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
    if (p1 > p2) {
      return;
    }

    var iterable = ['x', 'y'];
    for (var i = 0; i < iterable.length; i++) {
      var k = iterable[i];
      if (inPoints[ref1][k] > inPoints[ref2][k]) {
        var p = ref1;
        ref1 = ref2;
        ref2 = p;
      }

      var in1 = inPoints[ref1][k];
      var in2 = inPoints[ref2][k];
      var out1 = outPoints[ref1][k];
      var out2 = outPoints[ref2][k];

      // If the reference points have the same coordinate but different
      // delta, inferred delta is zero.  Otherwise interpolate.
      if (in1 !== in2 || out1 === out2) {
        var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);

        for (var _p = p1; _p <= p2; _p++) {
          var out = inPoints[_p][k];

          if (out <= in1) {
            out += out1 - in1;
          } else if (out >= in2) {
            out += out2 - in2;
          } else {
            out = out1 + (out - in1) * scale;
          }

          outPoints[_p][k] = out;
        }
      }
    }
  };

  GlyphVariationProcessor.prototype.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
    var deltaX = outPoints[ref].x - inPoints[ref].x;
    var deltaY = outPoints[ref].y - inPoints[ref].y;

    if (deltaX === 0 && deltaY === 0) {
      return;
    }

    for (var p = p1; p <= p2; p++) {
      if (p !== ref) {
        outPoints[p].x += deltaX;
        outPoints[p].y += deltaY;
      }
    }
  };

  GlyphVariationProcessor.prototype.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
    var outerIndex = void 0,
        innerIndex = void 0;

    if (table.advanceWidthMapping) {
      var idx = gid;
      if (idx >= table.advanceWidthMapping.mapCount) {
        idx = table.advanceWidthMapping.mapCount - 1;
      }

      var entryFormat = table.advanceWidthMapping.entryFormat;
      var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
      outerIndex = _table$advanceWidthMa.outerIndex;
      innerIndex = _table$advanceWidthMa.innerIndex;
    } else {
      outerIndex = 0;
      innerIndex = gid;
    }

    return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
  };

  // See pseudo code from `Font Variations Overview'
  // in the OpenType specification.


  GlyphVariationProcessor.prototype.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
    if (outerIndex >= itemStore.itemVariationData.length) {
      return 0;
    }

    var varData = itemStore.itemVariationData[outerIndex];
    if (innerIndex >= varData.deltaSets.length) {
      return 0;
    }

    var deltaSet = varData.deltaSets[innerIndex];
    var blendVector = this.getBlendVector(itemStore, outerIndex);
    var netAdjustment = 0;

    for (var master = 0; master < varData.regionIndexCount; master++) {
      netAdjustment += deltaSet.deltas[master] * blendVector[master];
    }

    return netAdjustment;
  };

  GlyphVariationProcessor.prototype.getBlendVector = function getBlendVector(itemStore, outerIndex) {
    var varData = itemStore.itemVariationData[outerIndex];
    if (this.blendVectors.has(varData)) {
      return this.blendVectors.get(varData);
    }

    var normalizedCoords = this.normalizedCoords;
    var blendVector = [];

    // outer loop steps through master designs to be blended
    for (var master = 0; master < varData.regionIndexCount; master++) {
      var scalar = 1;
      var regionIndex = varData.regionIndexes[master];
      var axes = itemStore.variationRegionList.variationRegions[regionIndex];

      // inner loop steps through axes in this region
      for (var j = 0; j < axes.length; j++) {
        var axis = axes[j];
        var axisScalar = void 0;

        // compute the scalar contribution of this axis
        // ignore invalid ranges
        if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) {
          axisScalar = 1;
        } else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) {
          axisScalar = 1;

          // peak of 0 means ignore this axis
        } else if (axis.peakCoord === 0) {
          axisScalar = 1;

          // ignore this region if coords are out of range
        } else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) {
          axisScalar = 0;

          // calculate a proportional factor
        } else {
          if (normalizedCoords[j] === axis.peakCoord) {
            axisScalar = 1;
          } else if (normalizedCoords[j] < axis.peakCoord) {
            axisScalar = (normalizedCoords[j] - axis.startCoord + _Number$EPSILON) / (axis.peakCoord - axis.startCoord + _Number$EPSILON);
          } else {
            axisScalar = (axis.endCoord - normalizedCoords[j] + _Number$EPSILON) / (axis.endCoord - axis.peakCoord + _Number$EPSILON);
          }
        }

        // take product of all the axis scalars
        scalar *= axisScalar;
      }

      blendVector[master] = scalar;
    }

    this.blendVectors.set(varData, blendVector);
    return blendVector;
  };

  return GlyphVariationProcessor;
}();

var Subset = function () {
  function Subset(font) {
    _classCallCheck(this, Subset);

    this.font = font;
    this.glyphs = [];
    this.mapping = {};

    // always include the missing glyph
    this.includeGlyph(0);
  }

  Subset.prototype.includeGlyph = function includeGlyph(glyph) {
    if ((typeof glyph === 'undefined' ? 'undefined' : _typeof(glyph)) === 'object') {
      glyph = glyph.id;
    }

    if (this.mapping[glyph] == null) {
      this.glyphs.push(glyph);
      this.mapping[glyph] = this.glyphs.length - 1;
    }

    return this.mapping[glyph];
  };

  Subset.prototype.encodeStream = function encodeStream() {
    var _this = this;

    var s = new r.EncodeStream();

    process.nextTick(function () {
      _this.encode(s);
      return s.end();
    });

    return s;
  };

  return Subset;
}();

// Flags for simple glyphs
var ON_CURVE$1 = 1 << 0;
var X_SHORT_VECTOR$1 = 1 << 1;
var Y_SHORT_VECTOR$1 = 1 << 2;
var REPEAT$1 = 1 << 3;
var SAME_X$1 = 1 << 4;
var SAME_Y$1 = 1 << 5;

var Point$1 = function () {
  function Point() {
    _classCallCheck(this, Point);
  }

  Point.size = function size(val) {
    return val >= 0 && val <= 255 ? 1 : 2;
  };

  Point.encode = function encode(stream, value) {
    if (value >= 0 && value <= 255) {
      stream.writeUInt8(value);
    } else {
      stream.writeInt16BE(value);
    }
  };

  return Point;
}();

var Glyf = new r.Struct({
  numberOfContours: r.int16, // if negative, this is a composite glyph
  xMin: r.int16,
  yMin: r.int16,
  xMax: r.int16,
  yMax: r.int16,
  endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
  instructions: new r.Array(r.uint8, r.uint16),
  flags: new r.Array(r.uint8, 0),
  xPoints: new r.Array(Point$1, 0),
  yPoints: new r.Array(Point$1, 0)
});

/**
 * Encodes TrueType glyph outlines
 */

var TTFGlyphEncoder = function () {
  function TTFGlyphEncoder() {
    _classCallCheck(this, TTFGlyphEncoder);
  }

  TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(path) {
    var instructions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var endPtsOfContours = [];
    var xPoints = [];
    var yPoints = [];
    var flags = [];
    var same = 0;
    var lastX = 0,
        lastY = 0,
        lastFlag = 0;
    var pointCount = 0;

    for (var i = 0; i < path.commands.length; i++) {
      var c = path.commands[i];

      for (var j = 0; j < c.args.length; j += 2) {
        var x = c.args[j];
        var y = c.args[j + 1];
        var flag = 0;

        // If the ending point of a quadratic curve is the midpoint
        // between the control point and the control point of the next
        // quadratic curve, we can omit the ending point.
        if (c.command === 'quadraticCurveTo' && j === 2) {
          var next = path.commands[i + 1];
          if (next && next.command === 'quadraticCurveTo') {
            var midX = (lastX + next.args[0]) / 2;
            var midY = (lastY + next.args[1]) / 2;

            if (x === midX && y === midY) {
              continue;
            }
          }
        }

        // All points except control points are on curve.
        if (!(c.command === 'quadraticCurveTo' && j === 0)) {
          flag |= ON_CURVE$1;
        }

        flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
        flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);

        if (flag === lastFlag && same < 255) {
          flags[flags.length - 1] |= REPEAT$1;
          same++;
        } else {
          if (same > 0) {
            flags.push(same);
            same = 0;
          }

          flags.push(flag);
          lastFlag = flag;
        }

        lastX = x;
        lastY = y;
        pointCount++;
      }

      if (c.command === 'closePath') {
        endPtsOfContours.push(pointCount - 1);
      }
    }

    // Close the path if the last command didn't already
    if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') {
      endPtsOfContours.push(pointCount - 1);
    }

    var bbox = path.bbox;
    var glyf = {
      numberOfContours: endPtsOfContours.length,
      xMin: bbox.minX,
      yMin: bbox.minY,
      xMax: bbox.maxX,
      yMax: bbox.maxY,
      endPtsOfContours: endPtsOfContours,
      instructions: instructions,
      flags: flags,
      xPoints: xPoints,
      yPoints: yPoints
    };

    var size = Glyf.size(glyf);
    var tail = 4 - size % 4;

    var stream = new r.EncodeStream(size + tail);
    Glyf.encode(stream, glyf);

    // Align to 4-byte length
    if (tail !== 0) {
      stream.fill(0, tail);
    }

    return stream.buffer;
  };

  TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
    var diff = value - last;

    if (value === last) {
      flag |= sameFlag;
    } else {
      if (-255 <= diff && diff <= 255) {
        flag |= shortFlag;
        if (diff < 0) {
          diff = -diff;
        } else {
          flag |= sameFlag;
        }
      }

      points.push(diff);
    }

    return flag;
  };

  return TTFGlyphEncoder;
}();

var TTFSubset = function (_Subset) {
  _inherits(TTFSubset, _Subset);

  function TTFSubset(font) {
    _classCallCheck(this, TTFSubset);

    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));

    _this.glyphEncoder = new TTFGlyphEncoder();
    return _this;
  }

  TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
    var glyph = this.font.getGlyph(gid);
    var glyf = glyph._decode();

    // get the offset to the glyph from the loca table
    var curOffset = this.font.loca.offsets[gid];
    var nextOffset = this.font.loca.offsets[gid + 1];

    var stream = this.font._getTableStream('glyf');
    stream.pos += curOffset;

    var buffer = stream.readBuffer(nextOffset - curOffset);

    // if it is a compound glyph, include its components
    if (glyf && glyf.numberOfContours < 0) {
      buffer = new Buffer(buffer);
      for (var _iterator = glyf.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var component = _ref;

        gid = this.includeGlyph(component.glyphID);
        buffer.writeUInt16BE(gid, component.pos);
      }
    } else if (glyf && this.font._variationProcessor) {
      // If this is a TrueType variation glyph, re-encode the path
      buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
    }

    this.glyf.push(buffer);
    this.loca.offsets.push(this.offset);

    this.hmtx.metrics.push({
      advance: glyph.advanceWidth,
      bearing: glyph._getMetrics().leftBearing
    });

    this.offset += buffer.length;
    return this.glyf.length - 1;
  };

  TTFSubset.prototype.encode = function encode(stream) {
    // tables required by PDF spec:
    //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
    //
    // additional tables required for standalone fonts:
    //   name, cmap, OS/2, post

    this.glyf = [];
    this.offset = 0;
    this.loca = {
      offsets: []
    };

    this.hmtx = {
      metrics: [],
      bearings: []
    };

    // include all the glyphs
    // not using a for loop because we need to support adding more
    // glyphs to the array as we go, and CoffeeScript caches the length.
    var i = 0;
    while (i < this.glyphs.length) {
      this._addGlyph(this.glyphs[i++]);
    }

    var maxp = cloneDeep(this.font.maxp);
    maxp.numGlyphs = this.glyf.length;

    this.loca.offsets.push(this.offset);
    tables.loca.preEncode.call(this.loca);

    var head = cloneDeep(this.font.head);
    head.indexToLocFormat = this.loca.version;

    var hhea = cloneDeep(this.font.hhea);
    hhea.numberOfMetrics = this.hmtx.metrics.length;

    // map = []
    // for index in [0...256]
    //     if index < @numGlyphs
    //         map[index] = index
    //     else
    //         map[index] = 0
    //
    // cmapTable =
    //     version: 0
    //     length: 262
    //     language: 0
    //     codeMap: map
    //
    // cmap =
    //     version: 0
    //     numSubtables: 1
    //     tables: [
    //         platformID: 1
    //         encodingID: 0
    //         table: cmapTable
    //     ]

    // TODO: subset prep, cvt, fpgm?
    Directory.encode(stream, {
      tables: {
        head: head,
        hhea: hhea,
        loca: this.loca,
        maxp: maxp,
        'cvt ': this.font['cvt '],
        prep: this.font.prep,
        glyf: this.glyf,
        hmtx: this.hmtx,
        fpgm: this.font.fpgm

        // name: clone @font.name
        // 'OS/2': clone @font['OS/2']
        // post: clone @font.post
        // cmap: cmap
      }
    });
  };

  return TTFSubset;
}(Subset);

var CFFSubset = function (_Subset) {
  _inherits(CFFSubset, _Subset);

  function CFFSubset(font) {
    _classCallCheck(this, CFFSubset);

    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));

    _this.cff = _this.font['CFF '];
    if (!_this.cff) {
      throw new Error('Not a CFF Font');
    }
    return _this;
  }

  CFFSubset.prototype.subsetCharstrings = function subsetCharstrings() {
    this.charstrings = [];
    var gsubrs = {};

    for (var _iterator = this.glyphs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var gid = _ref;

      this.charstrings.push(this.cff.getCharString(gid));

      var glyph = this.font.getGlyph(gid);
      var path = glyph.path; // this causes the glyph to be parsed

      for (var subr in glyph._usedGsubrs) {
        gsubrs[subr] = true;
      }
    }

    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
  };

  CFFSubset.prototype.subsetSubrs = function subsetSubrs(subrs, used) {
    var res = [];
    for (var i = 0; i < subrs.length; i++) {
      var subr = subrs[i];
      if (used[i]) {
        this.cff.stream.pos = subr.offset;
        res.push(this.cff.stream.readBuffer(subr.length));
      } else {
        res.push(new Buffer([11])); // return
      }
    }

    return res;
  };

  CFFSubset.prototype.subsetFontdict = function subsetFontdict(topDict) {
    topDict.FDArray = [];
    topDict.FDSelect = {
      version: 0,
      fds: []
    };

    var used_fds = {};
    var used_subrs = [];
    for (var _iterator2 = this.glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var gid = _ref2;

      var fd = this.cff.fdForGlyph(gid);
      if (fd == null) {
        continue;
      }

      if (!used_fds[fd]) {
        topDict.FDArray.push(_Object$assign({}, this.cff.topDict.FDArray[fd]));
        used_subrs.push({});
      }

      used_fds[fd] = true;
      topDict.FDSelect.fds.push(topDict.FDArray.length - 1);

      var glyph = this.font.getGlyph(gid);
      var path = glyph.path; // this causes the glyph to be parsed
      for (var subr in glyph._usedSubrs) {
        used_subrs[used_subrs.length - 1][subr] = true;
      }
    }

    for (var i = 0; i < topDict.FDArray.length; i++) {
      var dict = topDict.FDArray[i];
      delete dict.FontName;
      if (dict.Private && dict.Private.Subrs) {
        dict.Private = _Object$assign({}, dict.Private);
        dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
      }
    }

    return;
  };

  CFFSubset.prototype.createCIDFontdict = function createCIDFontdict(topDict) {
    var used_subrs = {};
    for (var _iterator3 = this.glyphs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var gid = _ref3;

      var glyph = this.font.getGlyph(gid);
      var path = glyph.path; // this causes the glyph to be parsed

      for (var subr in glyph._usedSubrs) {
        used_subrs[subr] = true;
      }
    }

    var privateDict = _Object$assign({}, this.cff.topDict.Private);
    privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);

    topDict.FDArray = [{ Private: privateDict }];
    return topDict.FDSelect = {
      version: 3,
      nRanges: 1,
      ranges: [{ first: 0, fd: 0 }],
      sentinel: this.charstrings.length
    };
  };

  CFFSubset.prototype.addString = function addString(string) {
    if (!string) {
      return null;
    }

    if (!this.strings) {
      this.strings = [];
    }

    this.strings.push(string);
    return standardStrings.length + this.strings.length - 1;
  };

  CFFSubset.prototype.encode = function encode(stream) {
    this.subsetCharstrings();

    var charset = {
      version: this.charstrings.length > 255 ? 2 : 1,
      ranges: [{ first: 1, nLeft: this.charstrings.length - 2 }]
    };

    var topDict = _Object$assign({}, this.cff.topDict);
    topDict.Private = null;
    topDict.charset = charset;
    topDict.Encoding = null;
    topDict.CharStrings = this.charstrings;

    var _arr = ['version', 'Notice', 'Copyright', 'FullName', 'FamilyName', 'Weight', 'PostScript', 'BaseFontName', 'FontName'];
    for (var _i4 = 0; _i4 < _arr.length; _i4++) {
      var key = _arr[_i4];
      topDict[key] = this.addString(this.cff.string(topDict[key]));
    }

    topDict.ROS = [this.addString('Adobe'), this.addString('Identity'), 0];
    topDict.CIDCount = this.charstrings.length;

    if (this.cff.isCIDFont) {
      this.subsetFontdict(topDict);
    } else {
      this.createCIDFontdict(topDict);
    }

    var top = {
      version: 1,
      hdrSize: this.cff.hdrSize,
      offSize: this.cff.length,
      header: this.cff.header,
      nameIndex: [this.cff.postscriptName],
      topDictIndex: [topDict],
      stringIndex: this.strings,
      globalSubrIndex: this.gsubrs
    };

    CFFTop.encode(stream, top);
  };

  return CFFSubset;
}(Subset);

var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */
var TTFFont = (_class = function () {
  TTFFont.probe = function probe(buffer) {
    var format = buffer.toString('ascii', 0, 4);
    return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
  };

  function TTFFont(stream) {
    var variationCoords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, TTFFont);

    this.stream = stream;
    this.variationCoords = variationCoords;

    this._directoryPos = this.stream.pos;
    this._tables = {};
    this._glyphs = {};
    this._decodeDirectory();

    // define properties for each table to lazily parse
    for (var tag in this.directory.tables) {
      var table = this.directory.tables[tag];
      if (tables[tag] && table.length > 0) {
        _Object$defineProperty(this, tag, {
          get: this._getTable.bind(this, table)
        });
      }
    }
  }

  TTFFont.prototype._getTable = function _getTable(table) {
    if (!(table.tag in this._tables)) {
      try {
        this._tables[table.tag] = this._decodeTable(table);
      } catch (e) {
        if (fontkit.logErrors) {
          console.error('Error decoding table ' + table.tag);
          console.error(e.stack);
        }
      }
    }

    return this._tables[table.tag];
  };

  TTFFont.prototype._getTableStream = function _getTableStream(tag) {
    var table = this.directory.tables[tag];
    if (table) {
      this.stream.pos = table.offset;
      return this.stream;
    }

    return null;
  };

  TTFFont.prototype._decodeDirectory = function _decodeDirectory() {
    return this.directory = Directory.decode(this.stream, { _startOffset: 0 });
  };

  TTFFont.prototype._decodeTable = function _decodeTable(table) {
    var pos = this.stream.pos;

    var stream = this._getTableStream(table.tag);
    var result = tables[table.tag].decode(stream, this, table.length);

    this.stream.pos = pos;
    return result;
  };

  /**
   * The unique PostScript name for this font
   * @type {string}
   */


  /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */
  TTFFont.prototype.getName = function getName(key) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var record = this.name.records[key];
    if (record) {
      return record[lang];
    }

    return null;
  };

  /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */


  /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */
  TTFFont.prototype.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
    return !!this._cmapProcessor.lookup(codePoint);
  };

  /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */


  TTFFont.prototype.glyphForCodePoint = function glyphForCodePoint(codePoint) {
    return this.getGlyph(this._cmapProcessor.lookup(codePoint), [codePoint]);
  };

  /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */


  TTFFont.prototype.glyphsForString = function glyphsForString(string) {
    var glyphs = [];
    var len = string.length;
    var idx = 0;
    var last = -1;
    var state = -1;

    while (idx <= len) {
      var code = 0;
      var nextState = 0;

      if (idx < len) {
        // Decode the next codepoint from UTF 16
        code = string.charCodeAt(idx++);
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
          var next = string.charCodeAt(idx);
          if (0xdc00 <= next && next <= 0xdfff) {
            idx++;
            code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
          }
        }

        // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
        nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
      } else {
        idx++;
      }

      if (state === 0 && nextState === 1) {
        // Variation selector following normal codepoint.
        glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [last, code]));
      } else if (state === 0 && nextState === 0) {
        // Normal codepoint following normal codepoint.
        glyphs.push(this.glyphForCodePoint(last));
      }

      last = code;
      state = nextState;
    }

    return glyphs;
  };

  /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */
  TTFFont.prototype.layout = function layout(string, userFeatures, script, language, direction) {
    return this._layoutEngine.layout(string, userFeatures, script, language, direction);
  };

  /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */


  TTFFont.prototype.stringsForGlyph = function stringsForGlyph(gid) {
    return this._layoutEngine.stringsForGlyph(gid);
  };

  /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */


  TTFFont.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
    return this._layoutEngine.getAvailableFeatures(script, language);
  };

  TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!this._glyphs[glyph]) {
      if (this.directory.tables.glyf) {
        this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
      } else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) {
        this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
      }
    }

    return this._glyphs[glyph] || null;
  };

  /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */


  TTFFont.prototype.getGlyph = function getGlyph(glyph) {
    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!this._glyphs[glyph]) {
      if (this.directory.tables.sbix) {
        this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
      } else if (this.directory.tables.COLR && this.directory.tables.CPAL) {
        this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
      } else {
        this._getBaseGlyph(glyph, characters);
      }
    }

    return this._glyphs[glyph] || null;
  };

  /**
   * Returns a Subset for this font.
   * @return {Subset}
   */


  TTFFont.prototype.createSubset = function createSubset() {
    if (this.directory.tables['CFF ']) {
      return new CFFSubset(this);
    }

    return new TTFSubset(this);
  };

  /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */


  /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */
  TTFFont.prototype.getVariation = function getVariation(settings) {
    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) {
      throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
    }

    if (typeof settings === 'string') {
      settings = this.namedVariations[settings];
    }

    if ((typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) !== 'object') {
      throw new Error('Variation settings must be either a variation name or settings object.');
    }

    // normalize the coordinates
    var coords = this.fvar.axis.map(function (axis, i) {
      var axisTag = axis.axisTag.trim();
      if (axisTag in settings) {
        return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
      } else {
        return axis.defaultValue;
      }
    });

    var stream = new r.DecodeStream(this.stream.buffer);
    stream.pos = this._directoryPos;

    var font = new TTFFont(stream, coords);
    font._tables = this._tables;

    return font;
  };

  // Standardized format plugin API
  TTFFont.prototype.getFont = function getFont(name) {
    return this.getVariation(name);
  };

  _createClass(TTFFont, [{
    key: 'postscriptName',
    get: function get() {
      var name = this.name.records.postscriptName;
      if (name) {
        var lang = _Object$keys(name)[0];
        return name[lang];
      }

      return null;
    }
  }, {
    key: 'fullName',
    get: function get() {
      return this.getName('fullName');
    }

    /**
     * The font's family name, e.g. "Helvetica"
     * @type {string}
     */

  }, {
    key: 'familyName',
    get: function get() {
      return this.getName('fontFamily');
    }

    /**
     * The font's sub-family, e.g. "Bold".
     * @type {string}
     */

  }, {
    key: 'subfamilyName',
    get: function get() {
      return this.getName('fontSubfamily');
    }

    /**
     * The font's copyright information
     * @type {string}
     */

  }, {
    key: 'copyright',
    get: function get() {
      return this.getName('copyright');
    }

    /**
     * The font's version number
     * @type {string}
     */

  }, {
    key: 'version',
    get: function get() {
      return this.getName('version');
    }

    /**
     * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
     * @type {number}
     */

  }, {
    key: 'ascent',
    get: function get() {
      return this.hhea.ascent;
    }

    /**
     * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
     * @type {number}
     */

  }, {
    key: 'descent',
    get: function get() {
      return this.hhea.descent;
    }

    /**
     * The amount of space that should be included between lines
     * @type {number}
     */

  }, {
    key: 'lineGap',
    get: function get() {
      return this.hhea.lineGap;
    }

    /**
     * The offset from the normal underline position that should be used
     * @type {number}
     */

  }, {
    key: 'underlinePosition',
    get: function get() {
      return this.post.underlinePosition;
    }

    /**
     * The weight of the underline that should be used
     * @type {number}
     */

  }, {
    key: 'underlineThickness',
    get: function get() {
      return this.post.underlineThickness;
    }

    /**
     * If this is an italic font, the angle the cursor should be drawn at to match the font design
     * @type {number}
     */

  }, {
    key: 'italicAngle',
    get: function get() {
      return this.post.italicAngle;
    }

    /**
     * The height of capital letters above the baseline.
     * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
     * @type {number}
     */

  }, {
    key: 'capHeight',
    get: function get() {
      var os2 = this['OS/2'];
      return os2 ? os2.capHeight : this.ascent;
    }

    /**
     * The height of lower case letters in the font.
     * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
     * @type {number}
     */

  }, {
    key: 'xHeight',
    get: function get() {
      var os2 = this['OS/2'];
      return os2 ? os2.xHeight : 0;
    }

    /**
     * The number of glyphs in the font.
     * @type {number}
     */

  }, {
    key: 'numGlyphs',
    get: function get() {
      return this.maxp.numGlyphs;
    }

    /**
     * The size of the font’s internal coordinate grid
     * @type {number}
     */

  }, {
    key: 'unitsPerEm',
    get: function get() {
      return this.head.unitsPerEm;
    }

    /**
     * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
     * @type {BBox}
     */

  }, {
    key: 'bbox',
    get: function get() {
      return _Object$freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
    }
  }, {
    key: '_cmapProcessor',
    get: function get() {
      return new CmapProcessor(this.cmap);
    }

    /**
     * An array of all of the unicode code points supported by the font.
     * @type {number[]}
     */

  }, {
    key: 'characterSet',
    get: function get() {
      return this._cmapProcessor.getCharacterSet();
    }
  }, {
    key: '_layoutEngine',
    get: function get() {
      return new LayoutEngine(this);
    }
  }, {
    key: 'availableFeatures',
    get: function get() {
      return this._layoutEngine.getAvailableFeatures();
    }
  }, {
    key: 'variationAxes',
    get: function get() {
      var res = {};
      if (!this.fvar) {
        return res;
      }

      for (var _iterator = this.fvar.axis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var axis = _ref;

        res[axis.axisTag.trim()] = {
          name: axis.name.en,
          min: axis.minValue,
          default: axis.defaultValue,
          max: axis.maxValue
        };
      }

      return res;
    }

    /**
     * Returns an object describing the named variation instances
     * that the font designer has specified. Keys are variation names
     * and values are the variation settings for this instance.
     *
     * @type {object}
     */

  }, {
    key: 'namedVariations',
    get: function get() {
      var res = {};
      if (!this.fvar) {
        return res;
      }

      for (var _iterator2 = this.fvar.instance, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var instance = _ref2;

        var settings = {};
        for (var i = 0; i < this.fvar.axis.length; i++) {
          var axis = this.fvar.axis[i];
          settings[axis.axisTag.trim()] = instance.coord[i];
        }

        res[instance.name.en] = settings;
      }

      return res;
    }
  }, {
    key: '_variationProcessor',
    get: function get() {
      if (!this.fvar) {
        return null;
      }

      var variationCoords = this.variationCoords;

      // Ignore if no variation coords and not CFF2
      if (!variationCoords && !this.CFF2) {
        return null;
      }

      if (!variationCoords) {
        variationCoords = this.fvar.axis.map(function (axis) {
          return axis.defaultValue;
        });
      }

      return new GlyphVariationProcessor(this, variationCoords);
    }
  }]);

  return TTFFont;
}(), (_applyDecoratedDescriptor(_class.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'bbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cmapProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_cmapProcessor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'characterSet', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'characterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_layoutEngine', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_layoutEngine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'variationAxes', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'variationAxes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'namedVariations', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'namedVariations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_variationProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_variationProcessor'), _class.prototype)), _class);

var WOFFDirectoryEntry = new r.Struct({
  tag: new r.String(4),
  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
  compLength: r.uint32,
  length: r.uint32,
  origChecksum: r.uint32
});

var WOFFDirectory = new r.Struct({
  tag: new r.String(4), // should be 'wOFF'
  flavor: r.uint32,
  length: r.uint32,
  numTables: r.uint16,
  reserved: new r.Reserved(r.uint16),
  totalSfntSize: r.uint32,
  majorVersion: r.uint16,
  minorVersion: r.uint16,
  metaOffset: r.uint32,
  metaLength: r.uint32,
  metaOrigLength: r.uint32,
  privOffset: r.uint32,
  privLength: r.uint32,
  tables: new r.Array(WOFFDirectoryEntry, 'numTables')
});

WOFFDirectory.process = function () {
  var tables = {};
  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var table = _ref;

    tables[table.tag] = table;
  }

  this.tables = tables;
};

var WOFFFont = function (_TTFFont) {
  _inherits(WOFFFont, _TTFFont);

  function WOFFFont() {
    _classCallCheck(this, WOFFFont);

    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
  }

  WOFFFont.probe = function probe(buffer) {
    return buffer.toString('ascii', 0, 4) === 'wOFF';
  };

  WOFFFont.prototype._decodeDirectory = function _decodeDirectory() {
    this.directory = WOFFDirectory.decode(this.stream, { _startOffset: 0 });
  };

  WOFFFont.prototype._getTableStream = function _getTableStream(tag) {
    var table = this.directory.tables[tag];
    if (table) {
      this.stream.pos = table.offset;

      if (table.compLength < table.length) {
        this.stream.pos += 2; // skip deflate header
        var outBuffer = new Buffer(table.length);
        var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
        return new r.DecodeStream(buf);
      } else {
        return this.stream;
      }
    }

    return null;
  };

  return WOFFFont;
}(TTFFont);

/**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */

var WOFF2Glyph = function (_TTFGlyph) {
  _inherits(WOFF2Glyph, _TTFGlyph);

  function WOFF2Glyph() {
    _classCallCheck(this, WOFF2Glyph);

    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
  }

  WOFF2Glyph.prototype._decode = function _decode() {
    // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
    return this._font._transformedGlyphs[this.id];
  };

  WOFF2Glyph.prototype._getCBox = function _getCBox() {
    return this.path.bbox;
  };

  return WOFF2Glyph;
}(TTFGlyph);

var Base128 = {
  decode: function decode(stream) {
    var result = 0;
    var iterable = [0, 1, 2, 3, 4];
    for (var j = 0; j < iterable.length; j++) {
      var i = iterable[j];
      var code = stream.readUInt8();

      // If any of the top seven bits are set then we're about to overflow.
      if (result & 0xe0000000) {
        throw new Error('Overflow');
      }

      result = result << 7 | code & 0x7f;
      if ((code & 0x80) === 0) {
        return result;
      }
    }

    throw new Error('Bad base 128 number');
  }
};

var knownTags = ['cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'OS/2', 'post', 'cvt ', 'fpgm', 'glyf', 'loca', 'prep', 'CFF ', 'VORG', 'EBDT', 'EBLC', 'gasp', 'hdmx', 'kern', 'LTSH', 'PCLT', 'VDMX', 'vhea', 'vmtx', 'BASE', 'GDEF', 'GPOS', 'GSUB', 'EBSC', 'JSTF', 'MATH', 'CBDT', 'CBLC', 'COLR', 'CPAL', 'SVG ', 'sbix', 'acnt', 'avar', 'bdat', 'bloc', 'bsln', 'cvar', 'fdsc', 'feat', 'fmtx', 'fvar', 'gvar', 'hsty', 'just', 'lcar', 'mort', 'morx', 'opbd', 'prop', 'trak', 'Zapf', 'Silf', 'Glat', 'Gloc', 'Feat', 'Sill'];

var WOFF2DirectoryEntry = new r.Struct({
  flags: r.uint8,
  customTag: new r.Optional(new r.String(4), function (t) {
    return (t.flags & 0x3f) === 0x3f;
  }),
  tag: function tag(t) {
    return t.customTag || knownTags[t.flags & 0x3f];
  }, // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
  length: Base128,
  transformVersion: function transformVersion(t) {
    return t.flags >>> 6 & 0x03;
  },
  transformed: function transformed(t) {
    return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
  },
  transformLength: new r.Optional(Base128, function (t) {
    return t.transformed;
  })
});

var WOFF2Directory = new r.Struct({
  tag: new r.String(4), // should be 'wOF2'
  flavor: r.uint32,
  length: r.uint32,
  numTables: r.uint16,
  reserved: new r.Reserved(r.uint16),
  totalSfntSize: r.uint32,
  totalCompressedSize: r.uint32,
  majorVersion: r.uint16,
  minorVersion: r.uint16,
  metaOffset: r.uint32,
  metaLength: r.uint32,
  metaOrigLength: r.uint32,
  privOffset: r.uint32,
  privLength: r.uint32,
  tables: new r.Array(WOFF2DirectoryEntry, 'numTables')
});

WOFF2Directory.process = function () {
  var tables = {};
  for (var i = 0; i < this.tables.length; i++) {
    var table = this.tables[i];
    tables[table.tag] = table;
  }

  return this.tables = tables;
};

/**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */

var WOFF2Font = function (_TTFFont) {
  _inherits(WOFF2Font, _TTFFont);

  function WOFF2Font() {
    _classCallCheck(this, WOFF2Font);

    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
  }

  WOFF2Font.probe = function probe(buffer) {
    return buffer.toString('ascii', 0, 4) === 'wOF2';
  };

  WOFF2Font.prototype._decodeDirectory = function _decodeDirectory() {
    this.directory = WOFF2Directory.decode(this.stream);
    this._dataPos = this.stream.pos;
  };

  WOFF2Font.prototype._decompress = function _decompress() {
    // decompress data and setup table offsets if we haven't already
    if (!this._decompressed) {
      this.stream.pos = this._dataPos;
      var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);

      var decompressedSize = 0;
      for (var tag in this.directory.tables) {
        var entry = this.directory.tables[tag];
        entry.offset = decompressedSize;
        decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
      }

      var decompressed = brotli(buffer, decompressedSize);
      if (!decompressed) {
        throw new Error('Error decoding compressed data in WOFF2');
      }

      this.stream = new r.DecodeStream(new Buffer(decompressed));
      this._decompressed = true;
    }
  };

  WOFF2Font.prototype._decodeTable = function _decodeTable(table) {
    this._decompress();
    return _TTFFont.prototype._decodeTable.call(this, table);
  };

  // Override this method to get a glyph and return our
  // custom subclass if there is a glyf table.


  WOFF2Font.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!this._glyphs[glyph]) {
      if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
        if (!this._transformedGlyphs) {
          this._transformGlyfTable();
        }
        return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
      } else {
        return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
      }
    }
  };

  WOFF2Font.prototype._transformGlyfTable = function _transformGlyfTable() {
    this._decompress();
    this.stream.pos = this.directory.tables.glyf.offset;
    var table = GlyfTable.decode(this.stream);
    var glyphs = [];

    for (var index = 0; index < table.numGlyphs; index++) {
      var glyph = {};
      var nContours = table.nContours.readInt16BE();
      glyph.numberOfContours = nContours;

      if (nContours > 0) {
        // simple glyph
        var nPoints = [];
        var totalPoints = 0;

        for (var i = 0; i < nContours; i++) {
          var _r = read255UInt16(table.nPoints);
          totalPoints += _r;
          nPoints.push(totalPoints);
        }

        glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
        for (var _i = 0; _i < nContours; _i++) {
          glyph.points[nPoints[_i] - 1].endContour = true;
        }

        var instructionSize = read255UInt16(table.glyphs);
      } else if (nContours < 0) {
        // composite glyph
        var haveInstructions = TTFGlyph.prototype._decodeComposite.call({ _font: this }, glyph, table.composites);
        if (haveInstructions) {
          var instructionSize = read255UInt16(table.glyphs);
        }
      }

      glyphs.push(glyph);
    }

    this._transformedGlyphs = glyphs;
  };

  return WOFF2Font;
}(TTFFont);

var Substream = function () {
  function Substream(length) {
    _classCallCheck(this, Substream);

    this.length = length;
    this._buf = new r.Buffer(length);
  }

  Substream.prototype.decode = function decode(stream, parent) {
    return new r.DecodeStream(this._buf.decode(stream, parent));
  };

  return Substream;
}();

// This struct represents the entire glyf table


var GlyfTable = new r.Struct({
  version: r.uint32,
  numGlyphs: r.uint16,
  indexFormat: r.uint16,
  nContourStreamSize: r.uint32,
  nPointsStreamSize: r.uint32,
  flagStreamSize: r.uint32,
  glyphStreamSize: r.uint32,
  compositeStreamSize: r.uint32,
  bboxStreamSize: r.uint32,
  instructionStreamSize: r.uint32,
  nContours: new Substream('nContourStreamSize'),
  nPoints: new Substream('nPointsStreamSize'),
  flags: new Substream('flagStreamSize'),
  glyphs: new Substream('glyphStreamSize'),
  composites: new Substream('compositeStreamSize'),
  bboxes: new Substream('bboxStreamSize'),
  instructions: new Substream('instructionStreamSize')
});

var WORD_CODE = 253;
var ONE_MORE_BYTE_CODE2 = 254;
var ONE_MORE_BYTE_CODE1 = 255;
var LOWEST_U_CODE = 253;

function read255UInt16(stream) {
  var code = stream.readUInt8();

  if (code === WORD_CODE) {
    return stream.readUInt16BE();
  }

  if (code === ONE_MORE_BYTE_CODE1) {
    return stream.readUInt8() + LOWEST_U_CODE;
  }

  if (code === ONE_MORE_BYTE_CODE2) {
    return stream.readUInt8() + LOWEST_U_CODE * 2;
  }

  return code;
}

function withSign(flag, baseval) {
  return flag & 1 ? baseval : -baseval;
}

function decodeTriplet(flags, glyphs, nPoints) {
  var y = void 0;
  var x = y = 0;
  var res = [];

  for (var i = 0; i < nPoints; i++) {
    var dx = 0,
        dy = 0;
    var flag = flags.readUInt8();
    var onCurve = !(flag >> 7);
    flag &= 0x7f;

    if (flag < 10) {
      dx = 0;
      dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
    } else if (flag < 20) {
      dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
      dy = 0;
    } else if (flag < 84) {
      var b0 = flag - 20;
      var b1 = glyphs.readUInt8();
      dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
      dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
    } else if (flag < 120) {
      var b0 = flag - 84;
      dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
      dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
    } else if (flag < 124) {
      var b1 = glyphs.readUInt8();
      var b2 = glyphs.readUInt8();
      dx = withSign(flag, (b1 << 4) + (b2 >> 4));
      dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
    } else {
      dx = withSign(flag, glyphs.readUInt16BE());
      dy = withSign(flag >> 1, glyphs.readUInt16BE());
    }

    x += dx;
    y += dy;
    res.push(new Point(onCurve, false, x, y));
  }

  return res;
}

var TTCHeader = new r.VersionedStruct(r.uint32, {
  0x00010000: {
    numFonts: r.uint32,
    offsets: new r.Array(r.uint32, 'numFonts')
  },
  0x00020000: {
    numFonts: r.uint32,
    offsets: new r.Array(r.uint32, 'numFonts'),
    dsigTag: r.uint32,
    dsigLength: r.uint32,
    dsigOffset: r.uint32
  }
});

var TrueTypeCollection = function () {
  TrueTypeCollection.probe = function probe(buffer) {
    return buffer.toString('ascii', 0, 4) === 'ttcf';
  };

  function TrueTypeCollection(stream) {
    _classCallCheck(this, TrueTypeCollection);

    this.stream = stream;
    if (stream.readString(4) !== 'ttcf') {
      throw new Error('Not a TrueType collection');
    }

    this.header = TTCHeader.decode(stream);
  }

  TrueTypeCollection.prototype.getFont = function getFont(name) {
    for (var _iterator = this.header.offsets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var offset = _ref;

      var stream = new r.DecodeStream(this.stream.buffer);
      stream.pos = offset;
      var font = new TTFFont(stream);
      if (font.postscriptName === name) {
        return font;
      }
    }

    return null;
  };

  _createClass(TrueTypeCollection, [{
    key: 'fonts',
    get: function get() {
      var fonts = [];
      for (var _iterator2 = this.header.offsets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var offset = _ref2;

        var stream = new r.DecodeStream(this.stream.buffer);
        stream.pos = offset;
        fonts.push(new TTFFont(stream));
      }

      return fonts;
    }
  }]);

  return TrueTypeCollection;
}();

var DFontName = new r.String(r.uint8);
var DFontData = new r.Struct({
  len: r.uint32,
  buf: new r.Buffer('len')
});

var Ref = new r.Struct({
  id: r.uint16,
  nameOffset: r.int16,
  attr: r.uint8,
  dataOffset: r.uint24,
  handle: r.uint32
});

var Type = new r.Struct({
  name: new r.String(4),
  maxTypeIndex: r.uint16,
  refList: new r.Pointer(r.uint16, new r.Array(Ref, function (t) {
    return t.maxTypeIndex + 1;
  }), { type: 'parent' })
});

var TypeList = new r.Struct({
  length: r.uint16,
  types: new r.Array(Type, function (t) {
    return t.length + 1;
  })
});

var DFontMap = new r.Struct({
  reserved: new r.Reserved(r.uint8, 24),
  typeList: new r.Pointer(r.uint16, TypeList),
  nameListOffset: new r.Pointer(r.uint16, 'void')
});

var DFontHeader = new r.Struct({
  dataOffset: r.uint32,
  map: new r.Pointer(r.uint32, DFontMap),
  dataLength: r.uint32,
  mapLength: r.uint32
});

var DFont = function () {
  DFont.probe = function probe(buffer) {
    var stream = new r.DecodeStream(buffer);

    try {
      var header = DFontHeader.decode(stream);
    } catch (e) {
      return false;
    }

    for (var _iterator = header.map.typeList.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var type = _ref;

      if (type.name === 'sfnt') {
        return true;
      }
    }

    return false;
  };

  function DFont(stream) {
    _classCallCheck(this, DFont);

    this.stream = stream;
    this.header = DFontHeader.decode(this.stream);

    for (var _iterator2 = this.header.map.typeList.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var type = _ref2;

      for (var _iterator3 = type.refList, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var ref = _ref3;

        if (ref.nameOffset >= 0) {
          this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
          ref.name = DFontName.decode(this.stream);
        } else {
          ref.name = null;
        }
      }

      if (type.name === 'sfnt') {
        this.sfnt = type;
      }
    }
  }

  DFont.prototype.getFont = function getFont(name) {
    if (!this.sfnt) {
      return null;
    }

    for (var _iterator4 = this.sfnt.refList, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var ref = _ref4;

      var pos = this.header.dataOffset + ref.dataOffset + 4;
      var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
      var font = new TTFFont(stream);
      if (font.postscriptName === name) {
        return font;
      }
    }

    return null;
  };

  _createClass(DFont, [{
    key: 'fonts',
    get: function get() {
      var fonts = [];
      for (var _iterator5 = this.sfnt.refList, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var ref = _ref5;

        var pos = this.header.dataOffset + ref.dataOffset + 4;
        var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
        fonts.push(new TTFFont(stream));
      }

      return fonts;
    }
  }]);

  return DFont;
}();

// Register font formats
fontkit.registerFormat(TTFFont);
fontkit.registerFormat(WOFFFont);
fontkit.registerFormat(WOFF2Font);
fontkit.registerFormat(TrueTypeCollection);
fontkit.registerFormat(DFont);

module.exports = fontkit;
//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer, __webpack_require__(8)))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var key, val, _ref, _ref1;

  exports.EncodeStream = __webpack_require__(158);

  exports.DecodeStream = __webpack_require__(50);

  exports.Array = __webpack_require__(88);

  exports.LazyArray = __webpack_require__(176);

  exports.Bitfield = __webpack_require__(177);

  exports.Boolean = __webpack_require__(178);

  exports.Buffer = __webpack_require__(179);

  exports.Enum = __webpack_require__(180);

  exports.Optional = __webpack_require__(181);

  exports.Reserved = __webpack_require__(182);

  exports.String = __webpack_require__(183);

  exports.Struct = __webpack_require__(89);

  exports.VersionedStruct = __webpack_require__(184);

  _ref = __webpack_require__(22);
  for (key in _ref) {
    val = _ref[key];
    exports[key] = val;
  }

  _ref1 = __webpack_require__(185);
  for (key in _ref1) {
    val = _ref1[key];
    exports[key] = val;
  }

}).call(this);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
(function() {
  var DecodeStream, EncodeStream, iconv, stream,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  stream = __webpack_require__(31);

  DecodeStream = __webpack_require__(50);

  try {
    iconv = __webpack_require__(51);
  } catch (_error) {}

  EncodeStream = (function(_super) {
    var key;

    __extends(EncodeStream, _super);

    function EncodeStream(bufferSize) {
      if (bufferSize == null) {
        bufferSize = 65536;
      }
      EncodeStream.__super__.constructor.apply(this, arguments);
      this.buffer = new Buffer(bufferSize);
      this.bufferOffset = 0;
      this.pos = 0;
    }

    for (key in Buffer.prototype) {
      if (key.slice(0, 5) === 'write') {
        (function(key) {
          var bytes;
          bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
          return EncodeStream.prototype[key] = function(value) {
            this.ensure(bytes);
            this.buffer[key](value, this.bufferOffset);
            this.bufferOffset += bytes;
            return this.pos += bytes;
          };
        })(key);
      }
    }

    EncodeStream.prototype._read = function() {};

    EncodeStream.prototype.ensure = function(bytes) {
      if (this.bufferOffset + bytes > this.buffer.length) {
        return this.flush();
      }
    };

    EncodeStream.prototype.flush = function() {
      if (this.bufferOffset > 0) {
        this.push(new Buffer(this.buffer.slice(0, this.bufferOffset)));
        return this.bufferOffset = 0;
      }
    };

    EncodeStream.prototype.writeBuffer = function(buffer) {
      this.flush();
      this.push(buffer);
      return this.pos += buffer.length;
    };

    EncodeStream.prototype.writeString = function(string, encoding) {
      var buf, byte, i, _i, _ref;
      if (encoding == null) {
        encoding = 'ascii';
      }
      switch (encoding) {
        case 'utf16le':
        case 'ucs2':
        case 'utf8':
        case 'ascii':
          return this.writeBuffer(new Buffer(string, encoding));
        case 'utf16be':
          buf = new Buffer(string, 'utf16le');
          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
            byte = buf[i];
            buf[i] = buf[i + 1];
            buf[i + 1] = byte;
          }
          return this.writeBuffer(buf);
        default:
          if (iconv) {
            return this.writeBuffer(iconv.encode(string, encoding));
          } else {
            throw new Error('Install iconv-lite to enable additional string encodings.');
          }
      }
    };

    EncodeStream.prototype.writeUInt24BE = function(val) {
      this.ensure(3);
      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
      this.buffer[this.bufferOffset++] = val & 0xff;
      return this.pos += 3;
    };

    EncodeStream.prototype.writeUInt24LE = function(val) {
      this.ensure(3);
      this.buffer[this.bufferOffset++] = val & 0xff;
      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
      return this.pos += 3;
    };

    EncodeStream.prototype.writeInt24BE = function(val) {
      if (val >= 0) {
        return this.writeUInt24BE(val);
      } else {
        return this.writeUInt24BE(val + 0xffffff + 1);
      }
    };

    EncodeStream.prototype.writeInt24LE = function(val) {
      if (val >= 0) {
        return this.writeUInt24LE(val);
      } else {
        return this.writeUInt24LE(val + 0xffffff + 1);
      }
    };

    EncodeStream.prototype.fill = function(val, length) {
      var buf;
      if (length < this.buffer.length) {
        this.ensure(length);
        this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
        this.bufferOffset += length;
        return this.pos += length;
      } else {
        buf = new Buffer(length);
        buf.fill(val);
        return this.writeBuffer(buf);
      }
    };

    EncodeStream.prototype.end = function() {
      this.flush();
      return this.push(null);
    };

    return EncodeStream;

  })(stream.Readable);

  module.exports = EncodeStream;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BOMChar = '\uFEFF';

exports.PrependBOM = PrependBOMWrapper
function PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}

PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = BOMChar + str;
        this.addBOM = false;
    }

    return this.encoder.write(str);
}

PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
}


//------------------------------------------------------------------------------

exports.StripBOM = StripBOMWrapper;
function StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}

StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res)
        return res;

    if (res[0] === BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function')
            this.options.stripBOM();
    }

    this.pass = true;
    return res;
}

StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
}



/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var modules = [
    __webpack_require__(161),
    __webpack_require__(162),
    __webpack_require__(163),
    __webpack_require__(164),
    __webpack_require__(165),
    __webpack_require__(166),
    __webpack_require__(167),
    __webpack_require__(168),
];

// Put all encoding/alias/codec definitions to single object and export it. 
for (var i = 0; i < modules.length; i++) {
    var module = modules[i];
    for (var enc in module)
        if (Object.prototype.hasOwnProperty.call(module, enc))
            exports[enc] = module[enc];
}


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer;

// Export Node.js internal encodings.

module.exports = {
    // Encodings
    utf8:   { type: "_internal", bomAware: true},
    cesu8:  { type: "_internal", bomAware: true},
    unicode11utf8: "utf8",

    ucs2:   { type: "_internal", bomAware: true},
    utf16le: "ucs2",

    binary: { type: "_internal" },
    base64: { type: "_internal" },
    hex:    { type: "_internal" },

    // Codec.
    _internal: InternalCodec,
};

//------------------------------------------------------------------------------

function InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;

    if (this.enc === "base64")
        this.encoder = InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = InternalEncoderCesu8;

        // Add decoder for versions of Node not supporting CESU-8
        if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== '💩') {
            this.decoder = InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}

InternalCodec.prototype.encoder = InternalEncoder;
InternalCodec.prototype.decoder = InternalDecoder;

//------------------------------------------------------------------------------

// We use node.js internal decoder. Its signature is the same as ours.
var StringDecoder = __webpack_require__(46).StringDecoder;

if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
    StringDecoder.prototype.end = function() {};


function InternalDecoder(options, codec) {
    StringDecoder.call(this, codec.enc);
}

InternalDecoder.prototype = StringDecoder.prototype;


//------------------------------------------------------------------------------
// Encoder is mostly trivial

function InternalEncoder(options, codec) {
    this.enc = codec.enc;
}

InternalEncoder.prototype.write = function(str) {
    return Buffer.from(str, this.enc);
}

InternalEncoder.prototype.end = function() {
}


//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.

function InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}

InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - (str.length % 4);
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);

    return Buffer.from(str, "base64");
}

InternalEncoderBase64.prototype.end = function() {
    return Buffer.from(this.prevStr, "base64");
}


//------------------------------------------------------------------------------
// CESU-8 encoder is also special.

function InternalEncoderCesu8(options, codec) {
}

InternalEncoderCesu8.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
    for (var i = 0; i < str.length; i++) {
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80)
            buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
        else { // charCode will always be < 0x10000 in javascript.
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
}

InternalEncoderCesu8.prototype.end = function() {
}

//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+

function InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}

InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
        res = '';
    for (var i = 0; i < buf.length; i++) {
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) { // Leading byte
            if (contBytes > 0) { // Previous code is invalid
                res += this.defaultCharUnicode;
                contBytes = 0;
            }

            if (curByte < 0x80) { // Single-byte code
                res += String.fromCharCode(curByte);
            } else if (curByte < 0xE0) { // Two-byte code
                acc = curByte & 0x1F;
                contBytes = 1; accBytes = 1;
            } else if (curByte < 0xF0) { // Three-byte code
                acc = curByte & 0x0F;
                contBytes = 2; accBytes = 1;
            } else { // Four or more are not supported for CESU-8.
                res += this.defaultCharUnicode;
            }
        } else { // Continuation byte
            if (contBytes > 0) { // We're waiting for it.
                acc = (acc << 6) | (curByte & 0x3f);
                contBytes--; accBytes++;
                if (contBytes === 0) {
                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                    if (accBytes === 2 && acc < 0x80 && acc > 0)
                        res += this.defaultCharUnicode;
                    else if (accBytes === 3 && acc < 0x800)
                        res += this.defaultCharUnicode;
                    else
                        // Actually add character.
                        res += String.fromCharCode(acc);
                }
            } else { // Unexpected continuation byte
                res += this.defaultCharUnicode;
            }
        }
    }
    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
    return res;
}

InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0)
        res += this.defaultCharUnicode;
    return res;
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer;

// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js

// == UTF16-BE codec. ==========================================================

exports.utf16be = Utf16BECodec;
function Utf16BECodec() {
}

Utf16BECodec.prototype.encoder = Utf16BEEncoder;
Utf16BECodec.prototype.decoder = Utf16BEDecoder;
Utf16BECodec.prototype.bomAware = true;


// -- Encoding

function Utf16BEEncoder() {
}

Utf16BEEncoder.prototype.write = function(str) {
    var buf = Buffer.from(str, 'ucs2');
    for (var i = 0; i < buf.length; i += 2) {
        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
    }
    return buf;
}

Utf16BEEncoder.prototype.end = function() {
}


// -- Decoding

function Utf16BEDecoder() {
    this.overflowByte = -1;
}

Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0)
        return '';

    var buf2 = Buffer.alloc(buf.length + 1),
        i = 0, j = 0;

    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1; j = 2;
    }

    for (; i < buf.length-1; i += 2, j+= 2) {
        buf2[j] = buf[i+1];
        buf2[j+1] = buf[i];
    }

    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;

    return buf2.slice(0, j).toString('ucs2');
}

Utf16BEDecoder.prototype.end = function() {
}


// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});

// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).

exports.utf16 = Utf16Codec;
function Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}

Utf16Codec.prototype.encoder = Utf16Encoder;
Utf16Codec.prototype.decoder = Utf16Decoder;


// -- Encoding (pass-through)

function Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined)
        options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}

Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
}

Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
}


// -- Decoding

function Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;

    this.options = options || {};
    this.iconv = codec.iconv;
}

Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        
        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
            return '';

        // We have enough bytes -> detect endianness.
        var buf = Buffer.concat(this.initialBytes),
            encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }

    return this.decoder.write(buf);
}

Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = Buffer.concat(this.initialBytes),
            encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);

        var res = this.decoder.write(buf),
            trail = this.decoder.end();

        return trail ? (res + trail) : res;
    }
    return this.decoder.end();
}

function detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';

    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
            enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
            enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.

            for (var i = 0; i < _len; i += 2) {
                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
            }

            if (asciiCharsBE > asciiCharsLE)
                enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE)
                enc = 'utf-16le';
        }
    }

    return enc;
}




/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer;

// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3

exports.utf7 = Utf7Codec;
exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
};

Utf7Codec.prototype.encoder = Utf7Encoder;
Utf7Codec.prototype.decoder = Utf7Decoder;
Utf7Codec.prototype.bomAware = true;


// -- Encoding

var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;

function Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}

Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return Buffer.from(str.replace(nonDirectChars, function(chunk) {
        return "+" + (chunk === '+' ? '' : 
            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
            + "-";
    }.bind(this)));
}

Utf7Encoder.prototype.end = function() {
}


// -- Decoding

function Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}

var base64Regex = /[A-Za-z0-9\/+]/;
var base64Chars = [];
for (var i = 0; i < 256; i++)
    base64Chars[i] = base64Regex.test(String.fromCharCode(i));

var plusChar = '+'.charCodeAt(0), 
    minusChar = '-'.charCodeAt(0),
    andChar = '&'.charCodeAt(0);

Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0,
        inBase64 = this.inBase64,
        base64Accum = this.base64Accum;

    // The decoder is more involved as we must handle chunks in stream.

    for (var i = 0; i < buf.length; i++) {
        if (!inBase64) { // We're in direct mode.
            // Write direct chars until '+'
            if (buf[i] == plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i+1;
                inBase64 = true;
            }
        } else { // We decode base64.
            if (!base64Chars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
                    res += "+";
                } else {
                    var b64str = base64Accum + buf.slice(lastI, i).toString();
                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                }

                if (buf[i] != minusChar) // Minus is absorbed after base64.
                    i--;

                lastI = i+1;
                inBase64 = false;
                base64Accum = '';
            }
        }
    }

    if (!inBase64) {
        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    } else {
        var b64str = base64Accum + buf.slice(lastI).toString();

        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);

        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }

    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;

    return res;
}

Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0)
        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");

    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}


// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.


exports.utf7imap = Utf7IMAPCodec;
function Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
};

Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
Utf7IMAPCodec.prototype.bomAware = true;


// -- Encoding

function Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = Buffer.alloc(6);
    this.base64AccumIdx = 0;
}

Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64,
        base64Accum = this.base64Accum,
        base64AccumIdx = this.base64AccumIdx,
        buf = Buffer.alloc(str.length*5 + 10), bufIdx = 0;

    for (var i = 0; i < str.length; i++) {
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }

                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }

            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character

                if (uChar === andChar)  // Ampersand -> '&-'
                    buf[bufIdx++] = minusChar;
            }

        } else { // Non-direct character
            if (!inBase64) {
                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;

                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }

    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;

    return buf.slice(0, bufIdx);
}

Utf7IMAPEncoder.prototype.end = function() {
    var buf = Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }

        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }

    return buf.slice(0, bufIdx);
}


// -- Decoding

function Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}

var base64IMAPChars = base64Chars.slice();
base64IMAPChars[','.charCodeAt(0)] = true;

Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0,
        inBase64 = this.inBase64,
        base64Accum = this.base64Accum;

    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).

    for (var i = 0; i < buf.length; i++) {
        if (!inBase64) { // We're in direct mode.
            // Write direct chars until '&'
            if (buf[i] == andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i+1;
                inBase64 = true;
            }
        } else { // We decode base64.
            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
                    res += "&";
                } else {
                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                    res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
                }

                if (buf[i] != minusChar) // Minus may be absorbed after base64.
                    i--;

                lastI = i+1;
                inBase64 = false;
                base64Accum = '';
            }
        }
    }

    if (!inBase64) {
        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    } else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');

        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);

        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }

    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;

    return res;
}

Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0)
        res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");

    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}




/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer;

// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 

exports._sbcs = SBCSCodec;
function SBCSCodec(codecOptions, iconv) {
    if (!codecOptions)
        throw new Error("SBCS codec is called without the data.")
    
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
    
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for (var i = 0; i < 128; i++)
            asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }

    this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');
    
    // Encoding buffer.
    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));

    for (var i = 0; i < codecOptions.chars.length; i++)
        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;

    this.encodeBuf = encodeBuf;
}

SBCSCodec.prototype.encoder = SBCSEncoder;
SBCSCodec.prototype.decoder = SBCSDecoder;


function SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}

SBCSEncoder.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length);
    for (var i = 0; i < str.length; i++)
        buf[i] = this.encodeBuf[str.charCodeAt(i)];
    
    return buf;
}

SBCSEncoder.prototype.end = function() {
}


function SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}

SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = Buffer.alloc(buf.length*2);
    var idx1 = 0, idx2 = 0;
    for (var i = 0; i < buf.length; i++) {
        idx1 = buf[i]*2; idx2 = i*2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2+1] = decodeBuf[idx1+1];
    }
    return newBuf.toString('ucs2');
}

SBCSDecoder.prototype.end = function() {
}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Manually added data to be used by sbcs codec in addition to generated one.

module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
    },

    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
    },

    "mik": {
        "type": "_sbcs",
        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя└┴┬├─┼╣║╚╔╩╦╠═╬┐░▒▓│┤№§╗╝┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
    },

    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",

    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",

    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek" : "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",

    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",

    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",

    "cp819": "iso88591",
    "ibm819": "iso88591",

    "cyrillic": "iso88595",

    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",

    "greek" : "iso88597",
    "greek8" : "iso88597",
    "ecma118" : "iso88597",
    "elot928" : "iso88597",

    "hebrew": "iso88598",
    "hebrew8": "iso88598",

    "turkish": "iso88599",
    "turkish8": "iso88599",

    "thai": "iso885911",
    "thai8": "iso885911",

    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",

    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",

    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",

    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",

    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",

    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",

    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",

    "strk10482002": "rk1048",

    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",

    "gb198880": "iso646cn",
    "cn": "iso646cn",

    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",

    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",

    "mac": "macintosh",
    "csmacintosh": "macintosh",
};



/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
  "437": "cp437",
  "737": "cp737",
  "775": "cp775",
  "850": "cp850",
  "852": "cp852",
  "855": "cp855",
  "856": "cp856",
  "857": "cp857",
  "858": "cp858",
  "860": "cp860",
  "861": "cp861",
  "862": "cp862",
  "863": "cp863",
  "864": "cp864",
  "865": "cp865",
  "866": "cp866",
  "869": "cp869",
  "874": "windows874",
  "922": "cp922",
  "1046": "cp1046",
  "1124": "cp1124",
  "1125": "cp1125",
  "1129": "cp1129",
  "1133": "cp1133",
  "1161": "cp1161",
  "1162": "cp1162",
  "1163": "cp1163",
  "1250": "windows1250",
  "1251": "windows1251",
  "1252": "windows1252",
  "1253": "windows1253",
  "1254": "windows1254",
  "1255": "windows1255",
  "1256": "windows1256",
  "1257": "windows1257",
  "1258": "windows1258",
  "28591": "iso88591",
  "28592": "iso88592",
  "28593": "iso88593",
  "28594": "iso88594",
  "28595": "iso88595",
  "28596": "iso88596",
  "28597": "iso88597",
  "28598": "iso88598",
  "28599": "iso88599",
  "28600": "iso885910",
  "28601": "iso885911",
  "28603": "iso885913",
  "28604": "iso885914",
  "28605": "iso885915",
  "28606": "iso885916",
  "windows874": {
    "type": "_sbcs",
    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "win874": "windows874",
  "cp874": "windows874",
  "windows1250": {
    "type": "_sbcs",
    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
  },
  "win1250": "windows1250",
  "cp1250": "windows1250",
  "windows1251": {
    "type": "_sbcs",
    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "win1251": "windows1251",
  "cp1251": "windows1251",
  "windows1252": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "win1252": "windows1252",
  "cp1252": "windows1252",
  "windows1253": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
  },
  "win1253": "windows1253",
  "cp1253": "windows1253",
  "windows1254": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
  },
  "win1254": "windows1254",
  "cp1254": "windows1254",
  "windows1255": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
  },
  "win1255": "windows1255",
  "cp1255": "windows1255",
  "windows1256": {
    "type": "_sbcs",
    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
  },
  "win1256": "windows1256",
  "cp1256": "windows1256",
  "windows1257": {
    "type": "_sbcs",
    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
  },
  "win1257": "windows1257",
  "cp1257": "windows1257",
  "windows1258": {
    "type": "_sbcs",
    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "win1258": "windows1258",
  "cp1258": "windows1258",
  "iso88591": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "cp28591": "iso88591",
  "iso88592": {
    "type": "_sbcs",
    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
  },
  "cp28592": "iso88592",
  "iso88593": {
    "type": "_sbcs",
    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
  },
  "cp28593": "iso88593",
  "iso88594": {
    "type": "_sbcs",
    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
  },
  "cp28594": "iso88594",
  "iso88595": {
    "type": "_sbcs",
    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
  },
  "cp28595": "iso88595",
  "iso88596": {
    "type": "_sbcs",
    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
  },
  "cp28596": "iso88596",
  "iso88597": {
    "type": "_sbcs",
    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
  },
  "cp28597": "iso88597",
  "iso88598": {
    "type": "_sbcs",
    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
  },
  "cp28598": "iso88598",
  "iso88599": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
  },
  "cp28599": "iso88599",
  "iso885910": {
    "type": "_sbcs",
    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
  },
  "cp28600": "iso885910",
  "iso885911": {
    "type": "_sbcs",
    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "cp28601": "iso885911",
  "iso885913": {
    "type": "_sbcs",
    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
  },
  "cp28603": "iso885913",
  "iso885914": {
    "type": "_sbcs",
    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
  },
  "cp28604": "iso885914",
  "iso885915": {
    "type": "_sbcs",
    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "cp28605": "iso885915",
  "iso885916": {
    "type": "_sbcs",
    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
  },
  "cp28606": "iso885916",
  "cp437": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm437": "cp437",
  "csibm437": "cp437",
  "cp737": {
    "type": "_sbcs",
    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
  },
  "ibm737": "cp737",
  "csibm737": "cp737",
  "cp775": {
    "type": "_sbcs",
    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
  },
  "ibm775": "cp775",
  "csibm775": "cp775",
  "cp850": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm850": "cp850",
  "csibm850": "cp850",
  "cp852": {
    "type": "_sbcs",
    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
  },
  "ibm852": "cp852",
  "csibm852": "cp852",
  "cp855": {
    "type": "_sbcs",
    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
  },
  "ibm855": "cp855",
  "csibm855": "cp855",
  "cp856": {
    "type": "_sbcs",
    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm856": "cp856",
  "csibm856": "cp856",
  "cp857": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
  },
  "ibm857": "cp857",
  "csibm857": "cp857",
  "cp858": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
  },
  "ibm858": "cp858",
  "csibm858": "cp858",
  "cp860": {
    "type": "_sbcs",
    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm860": "cp860",
  "csibm860": "cp860",
  "cp861": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm861": "cp861",
  "csibm861": "cp861",
  "cp862": {
    "type": "_sbcs",
    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm862": "cp862",
  "csibm862": "cp862",
  "cp863": {
    "type": "_sbcs",
    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm863": "cp863",
  "csibm863": "cp863",
  "cp864": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
  },
  "ibm864": "cp864",
  "csibm864": "cp864",
  "cp865": {
    "type": "_sbcs",
    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
  },
  "ibm865": "cp865",
  "csibm865": "cp865",
  "cp866": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
  },
  "ibm866": "cp866",
  "csibm866": "cp866",
  "cp869": {
    "type": "_sbcs",
    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
  },
  "ibm869": "cp869",
  "csibm869": "cp869",
  "cp922": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
  },
  "ibm922": "cp922",
  "csibm922": "cp922",
  "cp1046": {
    "type": "_sbcs",
    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
  },
  "ibm1046": "cp1046",
  "csibm1046": "cp1046",
  "cp1124": {
    "type": "_sbcs",
    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
  },
  "ibm1124": "cp1124",
  "csibm1124": "cp1124",
  "cp1125": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
  },
  "ibm1125": "cp1125",
  "csibm1125": "cp1125",
  "cp1129": {
    "type": "_sbcs",
    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "ibm1129": "cp1129",
  "csibm1129": "cp1129",
  "cp1133": {
    "type": "_sbcs",
    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
  },
  "ibm1133": "cp1133",
  "csibm1133": "cp1133",
  "cp1161": {
    "type": "_sbcs",
    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
  },
  "ibm1161": "cp1161",
  "csibm1161": "cp1161",
  "cp1162": {
    "type": "_sbcs",
    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  },
  "ibm1162": "cp1162",
  "csibm1162": "cp1162",
  "cp1163": {
    "type": "_sbcs",
    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
  },
  "ibm1163": "cp1163",
  "csibm1163": "cp1163",
  "maccroatian": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
  },
  "maccyrillic": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
  },
  "macgreek": {
    "type": "_sbcs",
    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
  },
  "maciceland": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macroman": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macromania": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macthai": {
    "type": "_sbcs",
    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
  },
  "macturkish": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "macukraine": {
    "type": "_sbcs",
    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
  },
  "koi8r": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8u": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8ru": {
    "type": "_sbcs",
    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "koi8t": {
    "type": "_sbcs",
    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
  },
  "armscii8": {
    "type": "_sbcs",
    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
  },
  "rk1048": {
    "type": "_sbcs",
    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "tcvn": {
    "type": "_sbcs",
    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
  },
  "georgianacademy": {
    "type": "_sbcs",
    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "georgianps": {
    "type": "_sbcs",
    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
  },
  "pt154": {
    "type": "_sbcs",
    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
  },
  "viscii": {
    "type": "_sbcs",
    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
  },
  "iso646cn": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
  },
  "iso646jp": {
    "type": "_sbcs",
    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
  },
  "hproman8": {
    "type": "_sbcs",
    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
  },
  "macintosh": {
    "type": "_sbcs",
    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
  },
  "ascii": {
    "type": "_sbcs",
    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
  },
  "tis620": {
    "type": "_sbcs",
    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
  }
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(21).Buffer;

// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.

exports._dbcs = DBCSCodec;

var UNASSIGNED = -1,
    GB18030_CODE = -2,
    SEQ_START  = -10,
    NODE_START = -1000,
    UNASSIGNED_NODE = new Array(0x100),
    DEF_CHAR = -1;

for (var i = 0; i < 0x100; i++)
    UNASSIGNED_NODE[i] = UNASSIGNED;


// Class DBCSCodec reads and initializes mapping tables.
function DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions)
        throw new Error("DBCS codec is called without the data.")
    if (!codecOptions.table)
        throw new Error("Encoding '" + this.encodingName + "' has no data.");

    // Load tables.
    var mappingTable = codecOptions.table();


    // Decode tables: MBCS -> Unicode.

    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.

    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];

    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for (var i = 0; i < mappingTable.length; i++)
        this._addDecodeChunk(mappingTable[i]);

    this.defaultCharUnicode = iconv.defaultCharUnicode;

    
    // Encode tables: Unicode -> DBCS.

    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];

    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals)
        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
            var val = codecOptions.encodeSkipVals[i];
            if (typeof val === 'number')
                skipEncodeChars[val] = true;
            else
                for (var j = val.from; j <= val.to; j++)
                    skipEncodeChars[j] = true;
        }
        
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);

    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for (var uChar in codecOptions.encodeAdd)
            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }

    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);


    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.

        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);

        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);

        for (var i = 0x81; i <= 0xFE; i++) {
            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for (var j = 0x30; j <= 0x39; j++)
                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
        }
        for (var i = 0x81; i <= 0xFE; i++)
            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
        for (var i = 0x30; i <= 0x39; i++)
            fourthByteNode[i] = GB18030_CODE
    }        
}

DBCSCodec.prototype.encoder = DBCSEncoder;
DBCSCodec.prototype.decoder = DBCSDecoder;

// Decoder helpers
DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for (; addr > 0; addr >>= 8)
        bytes.push(addr & 0xFF);
    if (bytes.length == 0)
        bytes.push(0);

    var node = this.decodeTables[0];
    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
        var val = node[bytes[i]];

        if (val == UNASSIGNED) { // Create new node.
            node[bytes[i]] = NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
        }
        else if (val <= NODE_START) { // Existing node.
            node = this.decodeTables[NODE_START - val];
        }
        else
            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
}


DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);

    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;

    // Write all other elements of the chunk to the table.
    for (var k = 1; k < chunk.length; k++) {
        var part = chunk[k];
        if (typeof part === "string") { // String, write as-is.
            for (var l = 0; l < part.length;) {
                var code = part.charCodeAt(l++);
                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
                    var codeTrail = part.charCodeAt(l++);
                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                    else
                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
                }
                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
                    var len = 0xFFF - code + 2;
                    var seq = [];
                    for (var m = 0; m < len; m++)
                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.

                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                    this.decodeTableSeq.push(seq);
                }
                else
                    writeTable[curAddr++] = code; // Basic char
            }
        } 
        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
            var charCode = writeTable[curAddr - 1] + 1;
            for (var l = 0; l < part; l++)
                writeTable[curAddr++] = charCode++;
        }
        else
            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF)
        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
}

// Encoder helpers
DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined)
        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
}

DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= SEQ_START)
        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == UNASSIGNED)
        bucket[low] = dbcsCode;
}

DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;

    var node;
    if (bucket[low] <= SEQ_START) {
        // There's already a sequence with  - use it.
        node = this.encodeTableSeq[SEQ_START-bucket[low]];
    }
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }

    // Traverse the character tree, allocating new nodes as needed.
    for (var j = 1; j < seq.length-1; j++) {
        var oldVal = node[uCode];
        if (typeof oldVal === 'object')
            node = oldVal;
        else {
            node = node[uCode] = {}
            if (oldVal !== undefined)
                node[DEF_CHAR] = oldVal
        }
    }

    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length-1];
    node[uCode] = dbcsCode;
}

DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for (var i = 0; i < 0x100; i++) {
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode])
            continue;

        if (uCode >= 0)
            this._setEncodeChar(uCode, mbCode);
        else if (uCode <= NODE_START)
            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= SEQ_START)
            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
    }
}



// == Encoder ==================================================================

function DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}

DBCSEncoder.prototype.write = function(str) {
    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)),
        leadSurrogate = this.leadSurrogate,
        seqObj = this.seqObj, nextChar = -1,
        i = 0, j = 0;

    while (true) {
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        }
        else {
            var uCode = nextChar;
            nextChar = -1;    
        }

        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
            if (uCode < 0xDC00) { // We've got lead surrogate.
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = UNASSIGNED;
                }
            } else { // We've got trail surrogate.
                if (leadSurrogate !== -1) {
                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                    leadSurrogate = -1;
                } else {
                    // Incomplete surrogate pair - only trail surrogate found.
                    uCode = UNASSIGNED;
                }
                
            }
        }
        else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }

        // 2. Convert uCode character.
        var dbcsCode = UNASSIGNED;
        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') { // Sequence continues.
                seqObj = resCode;
                continue;

            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
                dbcsCode = resCode;

            } else if (resCode == undefined) { // Current character is not part of the sequence.

                // Try default character for this sequence
                resCode = seqObj[DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.

                } else {
                    // TODO: What if we have no default? (resCode == undefined)
                    // Then, we should write first char of the sequence as-is and try the rest recursively.
                    // Didn't do it for now because no encoding has this situation yet.
                    // Currently, just skip the sequence and write current char.
                }
            }
            seqObj = undefined;
        }
        else if (uCode >= 0) {  // Regular character
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined)
                dbcsCode = subtable[uCode & 0xFF];
            
            if (dbcsCode <= SEQ_START) { // Sequence start
                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
                continue;
            }

            if (dbcsCode == UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }

        // 3. Write dbcsCode character.
        if (dbcsCode === UNASSIGNED)
            dbcsCode = this.defaultCharSingleByte;
        
        if (dbcsCode < 0x100) {
            newBuf[j++] = dbcsCode;
        }
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8;   // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        }
        else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }

    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
}

DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined)
        return; // All clean. Most often case.

    var newBuf = Buffer.alloc(10), j = 0;

    if (this.seqObj) { // We're in the sequence.
        var dbcsCode = this.seqObj[DEF_CHAR];
        if (dbcsCode !== undefined) { // Write beginning of the sequence.
            if (dbcsCode < 0x100) {
                newBuf[j++] = dbcsCode;
            }
            else {
                newBuf[j++] = dbcsCode >> 8;   // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else {
            // See todo above.
        }
        this.seqObj = undefined;
    }

    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    
    return newBuf.slice(0, j);
}

// Export for testing
DBCSEncoder.prototype.findIdx = findIdx;


// == Decoder ==================================================================

function DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = Buffer.alloc(0);

    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}

DBCSDecoder.prototype.write = function(buf) {
    var newBuf = Buffer.alloc(buf.length*2),
        nodeIdx = this.nodeIdx, 
        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
        uCode;

    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
    
    for (var i = 0, j = 0; i < buf.length; i++) {
        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];

        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];

        if (uCode >= 0) { 
            // Normal character, just use it.
        }
        else if (uCode === UNASSIGNED) { // Unknown char.
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        }
        else if (uCode === GB18030_CODE) {
            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
            var idx = findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        }
        else if (uCode <= NODE_START) { // Go to next trie node.
            nodeIdx = NODE_START - uCode;
            continue;
        }
        else if (uCode <= SEQ_START) { // Output a sequence of chars.
            var seq = this.decodeTableSeq[SEQ_START - uCode];
            for (var k = 0; k < seq.length - 1; k++) {
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length-1];
        }
        else
            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);

        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) { 
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;

            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;

        // Reset trie node.
        nodeIdx = 0; seqStart = i+1;
    }

    this.nodeIdx = nodeIdx;
    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
}

DBCSDecoder.prototype.end = function() {
    var ret = '';

    // Try to parse all remaining chars.
    while (this.prevBuf.length > 0) {
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1);

        // Parse remaining as usual.
        this.prevBuf = Buffer.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0)
            ret += this.write(buf);
    }

    this.nodeIdx = 0;
    return ret;
}

// Binary search for GB18030. Returns largest i such that table[i] <= val.
function findIdx(table, val) {
    if (table[0] > val)
        return -1;

    var l = 0, r = table.length;
    while (l < r-1) { // always table[l] <= val < table[r]
        var mid = l + Math.floor((r-l+1)/2);
        if (table[mid] <= val)
            l = mid;
        else
            r = mid;
    }
    return l;
}



/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.

module.exports = {
    
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)

    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html

    'shiftjis': {
        type: '_dbcs',
        table: function() { return __webpack_require__(169) },
        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',

    'eucjp': {
        type: '_dbcs',
        table: function() { return __webpack_require__(170) },
        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
    },

    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.


    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder

    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',

    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function() { return __webpack_require__(52) },
    },

    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function() { return __webpack_require__(52).concat(__webpack_require__(86)) },
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',

    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function() { return __webpack_require__(52).concat(__webpack_require__(86)) },
        gb18030: function() { return __webpack_require__(171) },
        encodeSkipVals: [0x80],
        encodeAdd: {'€': 0xA2E3},
    },

    'chinese': 'gb18030',


    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function() { return __webpack_require__(172) },
    },

    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',


    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.

    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function() { return __webpack_require__(87) },
    },

    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function() { return __webpack_require__(87).concat(__webpack_require__(173)) },
        encodeSkipVals: [0xa2cc],
    },

    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs',
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = {"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = [["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]

/***/ }),
/* 174 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 175 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  ArrayT = __webpack_require__(88);

  NumberT = __webpack_require__(22).Number;

  utils = __webpack_require__(12);

  inspect = __webpack_require__(48).inspect;

  LazyArrayT = (function(_super) {
    __extends(LazyArrayT, _super);

    function LazyArrayT() {
      return LazyArrayT.__super__.constructor.apply(this, arguments);
    }

    LazyArrayT.prototype.decode = function(stream, parent) {
      var length, pos, res;
      pos = stream.pos;
      length = utils.resolveLength(this.length, stream, parent);
      if (this.length instanceof NumberT) {
        parent = {
          parent: parent,
          _startOffset: pos,
          _currentOffset: 0,
          _length: length
        };
      }
      res = new LazyArray(this.type, length, stream, parent);
      stream.pos += length * this.type.size(null, parent);
      return res;
    };

    LazyArrayT.prototype.size = function(val, ctx) {
      if (val instanceof LazyArray) {
        val = val.toArray();
      }
      return LazyArrayT.__super__.size.call(this, val, ctx);
    };

    LazyArrayT.prototype.encode = function(stream, val, ctx) {
      if (val instanceof LazyArray) {
        val = val.toArray();
      }
      return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
    };

    return LazyArrayT;

  })(ArrayT);

  LazyArray = (function() {
    function LazyArray(type, length, stream, ctx) {
      this.type = type;
      this.length = length;
      this.stream = stream;
      this.ctx = ctx;
      this.base = this.stream.pos;
      this.items = [];
    }

    LazyArray.prototype.get = function(index) {
      var pos;
      if (index < 0 || index >= this.length) {
        return void 0;
      }
      if (this.items[index] == null) {
        pos = this.stream.pos;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
        this.items[index] = this.type.decode(this.stream, this.ctx);
        this.stream.pos = pos;
      }
      return this.items[index];
    };

    LazyArray.prototype.toArray = function() {
      var i, _i, _ref, _results;
      _results = [];
      for (i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1) {
        _results.push(this.get(i));
      }
      return _results;
    };

    LazyArray.prototype.inspect = function() {
      return inspect(this.toArray());
    };

    return LazyArray;

  })();

  module.exports = LazyArrayT;

}).call(this);


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Bitfield;

  Bitfield = (function() {
    function Bitfield(type, flags) {
      this.type = type;
      this.flags = flags != null ? flags : [];
    }

    Bitfield.prototype.decode = function(stream) {
      var flag, i, res, val, _i, _len, _ref;
      val = this.type.decode(stream);
      res = {};
      _ref = this.flags;
      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
        flag = _ref[i];
        if (flag != null) {
          res[flag] = !!(val & (1 << i));
        }
      }
      return res;
    };

    Bitfield.prototype.size = function() {
      return this.type.size();
    };

    Bitfield.prototype.encode = function(stream, keys) {
      var flag, i, val, _i, _len, _ref;
      val = 0;
      _ref = this.flags;
      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
        flag = _ref[i];
        if (flag != null) {
          if (keys[flag]) {
            val |= 1 << i;
          }
        }
      }
      return this.type.encode(stream, val);
    };

    return Bitfield;

  })();

  module.exports = Bitfield;

}).call(this);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var BooleanT;

  BooleanT = (function() {
    function BooleanT(type) {
      this.type = type;
    }

    BooleanT.prototype.decode = function(stream, parent) {
      return !!this.type.decode(stream, parent);
    };

    BooleanT.prototype.size = function(val, parent) {
      return this.type.size(val, parent);
    };

    BooleanT.prototype.encode = function(stream, val, parent) {
      return this.type.encode(stream, +val, parent);
    };

    return BooleanT;

  })();

  module.exports = BooleanT;

}).call(this);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var BufferT, NumberT, utils;

  utils = __webpack_require__(12);

  NumberT = __webpack_require__(22).Number;

  BufferT = (function() {
    function BufferT(length) {
      this.length = length;
    }

    BufferT.prototype.decode = function(stream, parent) {
      var length;
      length = utils.resolveLength(this.length, stream, parent);
      return stream.readBuffer(length);
    };

    BufferT.prototype.size = function(val, parent) {
      if (!val) {
        return utils.resolveLength(this.length, null, parent);
      }
      return val.length;
    };

    BufferT.prototype.encode = function(stream, buf, parent) {
      if (this.length instanceof NumberT) {
        this.length.encode(stream, buf.length);
      }
      return stream.writeBuffer(buf);
    };

    return BufferT;

  })();

  module.exports = BufferT;

}).call(this);


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Enum;

  Enum = (function() {
    function Enum(type, options) {
      this.type = type;
      this.options = options != null ? options : [];
    }

    Enum.prototype.decode = function(stream) {
      var index;
      index = this.type.decode(stream);
      return this.options[index] || index;
    };

    Enum.prototype.size = function() {
      return this.type.size();
    };

    Enum.prototype.encode = function(stream, val) {
      var index;
      index = this.options.indexOf(val);
      if (index === -1) {
        throw new Error("Unknown option in enum: " + val);
      }
      return this.type.encode(stream, index);
    };

    return Enum;

  })();

  module.exports = Enum;

}).call(this);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Optional;

  Optional = (function() {
    function Optional(type, condition) {
      this.type = type;
      this.condition = condition != null ? condition : true;
    }

    Optional.prototype.decode = function(stream, parent) {
      var condition;
      condition = this.condition;
      if (typeof condition === 'function') {
        condition = condition.call(parent, parent);
      }
      if (condition) {
        return this.type.decode(stream, parent);
      }
    };

    Optional.prototype.size = function(val, parent) {
      var condition;
      condition = this.condition;
      if (typeof condition === 'function') {
        condition = condition.call(parent, parent);
      }
      if (condition) {
        return this.type.size(val, parent);
      } else {
        return 0;
      }
    };

    Optional.prototype.encode = function(stream, val, parent) {
      var condition;
      condition = this.condition;
      if (typeof condition === 'function') {
        condition = condition.call(parent, parent);
      }
      if (condition) {
        return this.type.encode(stream, val, parent);
      }
    };

    return Optional;

  })();

  module.exports = Optional;

}).call(this);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Reserved, utils;

  utils = __webpack_require__(12);

  Reserved = (function() {
    function Reserved(type, count) {
      this.type = type;
      this.count = count != null ? count : 1;
    }

    Reserved.prototype.decode = function(stream, parent) {
      stream.pos += this.size(null, parent);
      return void 0;
    };

    Reserved.prototype.size = function(data, parent) {
      var count;
      count = utils.resolveLength(this.count, null, parent);
      return this.type.size() * count;
    };

    Reserved.prototype.encode = function(stream, val, parent) {
      return stream.fill(0, this.size(val, parent));
    };

    return Reserved;

  })();

  module.exports = Reserved;

}).call(this);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
(function() {
  var NumberT, StringT, utils;

  NumberT = __webpack_require__(22).Number;

  utils = __webpack_require__(12);

  StringT = (function() {
    function StringT(length, encoding) {
      this.length = length;
      this.encoding = encoding != null ? encoding : 'ascii';
    }

    StringT.prototype.decode = function(stream, parent) {
      var buffer, encoding, length, pos, string;
      length = (function() {
        if (this.length != null) {
          return utils.resolveLength(this.length, stream, parent);
        } else {
          buffer = stream.buffer, length = stream.length, pos = stream.pos;
          while (pos < length && buffer[pos] !== 0x00) {
            ++pos;
          }
          return pos - stream.pos;
        }
      }).call(this);
      encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent, parent) || 'ascii';
      }
      string = stream.readString(length, encoding);
      if ((this.length == null) && stream.pos < stream.length) {
        stream.pos++;
      }
      return string;
    };

    StringT.prototype.size = function(val, parent) {
      var encoding, size;
      if (!val) {
        return utils.resolveLength(this.length, null, parent);
      }
      encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
      }
      if (encoding === 'utf16be') {
        encoding = 'utf16le';
      }
      size = Buffer.byteLength(val, encoding);
      if (this.length instanceof NumberT) {
        size += this.length.size();
      }
      if (this.length == null) {
        size++;
      }
      return size;
    };

    StringT.prototype.encode = function(stream, val, parent) {
      var encoding;
      encoding = this.encoding;
      if (typeof encoding === 'function') {
        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
      }
      if (this.length instanceof NumberT) {
        this.length.encode(stream, Buffer.byteLength(val, encoding));
      }
      stream.writeString(val, encoding);
      if (this.length == null) {
        return stream.writeUInt8(0x00);
      }
    };

    return StringT;

  })();

  module.exports = StringT;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Struct, VersionedStruct,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Struct = __webpack_require__(89);

  VersionedStruct = (function(_super) {
    __extends(VersionedStruct, _super);

    function VersionedStruct(type, versions) {
      this.type = type;
      this.versions = versions != null ? versions : {};
      if (typeof this.type === 'string') {
        this.versionGetter = new Function('parent', "return parent." + this.type);
        this.versionSetter = new Function('parent', 'version', "return parent." + this.type + " = version");
      }
    }

    VersionedStruct.prototype.decode = function(stream, parent, length) {
      var fields, res, _ref;
      if (length == null) {
        length = 0;
      }
      res = this._setup(stream, parent, length);
      if (typeof this.type === 'string') {
        res.version = this.versionGetter(parent);
      } else {
        res.version = this.type.decode(stream);
      }
      if (this.versions.header) {
        this._parseFields(stream, res, this.versions.header);
      }
      fields = this.versions[res.version];
      if (fields == null) {
        throw new Error("Unknown version " + res.version);
      }
      if (fields instanceof VersionedStruct) {
        return fields.decode(stream, parent);
      }
      this._parseFields(stream, res, fields);
      if ((_ref = this.process) != null) {
        _ref.call(res, stream);
      }
      return res;
    };

    VersionedStruct.prototype.size = function(val, parent, includePointers) {
      var ctx, fields, key, size, type, _ref;
      if (includePointers == null) {
        includePointers = true;
      }
      if (!val) {
        throw new Error('Not a fixed size');
      }
      ctx = {
        parent: parent,
        val: val,
        pointerSize: 0
      };
      size = 0;
      if (typeof this.type !== 'string') {
        size += this.type.size(val.version, ctx);
      }
      if (this.versions.header) {
        _ref = this.versions.header;
        for (key in _ref) {
          type = _ref[key];
          if (type.size != null) {
            size += type.size(val[key], ctx);
          }
        }
      }
      fields = this.versions[val.version];
      if (fields == null) {
        throw new Error("Unknown version " + val.version);
      }
      for (key in fields) {
        type = fields[key];
        if (type.size != null) {
          size += type.size(val[key], ctx);
        }
      }
      if (includePointers) {
        size += ctx.pointerSize;
      }
      return size;
    };

    VersionedStruct.prototype.encode = function(stream, val, parent) {
      var ctx, fields, i, key, ptr, type, _ref, _ref1;
      if ((_ref = this.preEncode) != null) {
        _ref.call(val, stream);
      }
      ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent,
        val: val,
        pointerSize: 0
      };
      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
      if (typeof this.type !== 'string') {
        this.type.encode(stream, val.version);
      }
      if (this.versions.header) {
        _ref1 = this.versions.header;
        for (key in _ref1) {
          type = _ref1[key];
          if (type.encode != null) {
            type.encode(stream, val[key], ctx);
          }
        }
      }
      fields = this.versions[val.version];
      for (key in fields) {
        type = fields[key];
        if (type.encode != null) {
          type.encode(stream, val[key], ctx);
        }
      }
      i = 0;
      while (i < ctx.pointers.length) {
        ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    };

    return VersionedStruct;

  })(Struct);

  module.exports = VersionedStruct;

}).call(this);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
  var Pointer, VoidPointer, utils;

  utils = __webpack_require__(12);

  Pointer = (function() {
    function Pointer(offsetType, type, options) {
      var _base, _base1, _base2, _base3;
      this.offsetType = offsetType;
      this.type = type;
      this.options = options != null ? options : {};
      if (this.type === 'void') {
        this.type = null;
      }
      if ((_base = this.options).type == null) {
        _base.type = 'local';
      }
      if ((_base1 = this.options).allowNull == null) {
        _base1.allowNull = true;
      }
      if ((_base2 = this.options).nullValue == null) {
        _base2.nullValue = 0;
      }
      if ((_base3 = this.options).lazy == null) {
        _base3.lazy = false;
      }
      if (this.options.relativeTo) {
        this.relativeToGetter = new Function('ctx', "return ctx." + this.options.relativeTo);
      }
    }

    Pointer.prototype.decode = function(stream, ctx) {
      var c, decodeValue, offset, ptr, relative, val;
      offset = this.offsetType.decode(stream, ctx);
      if (offset === this.options.nullValue && this.options.allowNull) {
        return null;
      }
      relative = (function() {
        switch (this.options.type) {
          case 'local':
            return ctx._startOffset;
          case 'immediate':
            return stream.pos - this.offsetType.size();
          case 'parent':
            return ctx.parent._startOffset;
          default:
            c = ctx;
            while (c.parent) {
              c = c.parent;
            }
            return c._startOffset || 0;
        }
      }).call(this);
      if (this.options.relativeTo) {
        relative += this.relativeToGetter(ctx);
      }
      ptr = offset + relative;
      if (this.type != null) {
        val = null;
        decodeValue = (function(_this) {
          return function() {
            var pos;
            if (val != null) {
              return val;
            }
            pos = stream.pos;
            stream.pos = ptr;
            val = _this.type.decode(stream, ctx);
            stream.pos = pos;
            return val;
          };
        })(this);
        if (this.options.lazy) {
          return new utils.PropertyDescriptor({
            get: decodeValue
          });
        }
        return decodeValue();
      } else {
        return ptr;
      }
    };

    Pointer.prototype.size = function(val, ctx) {
      var parent, type;
      parent = ctx;
      switch (this.options.type) {
        case 'local':
        case 'immediate':
          break;
        case 'parent':
          ctx = ctx.parent;
          break;
        default:
          while (ctx.parent) {
            ctx = ctx.parent;
          }
      }
      type = this.type;
      if (type == null) {
        if (!(val instanceof VoidPointer)) {
          throw new Error("Must be a VoidPointer");
        }
        type = val.type;
        val = val.value;
      }
      if (val && ctx) {
        ctx.pointerSize += type.size(val, parent);
      }
      return this.offsetType.size();
    };

    Pointer.prototype.encode = function(stream, val, ctx) {
      var parent, relative, type;
      parent = ctx;
      if (val == null) {
        this.offsetType.encode(stream, this.options.nullValue);
        return;
      }
      switch (this.options.type) {
        case 'local':
          relative = ctx.startOffset;
          break;
        case 'immediate':
          relative = stream.pos + this.offsetType.size(val, parent);
          break;
        case 'parent':
          ctx = ctx.parent;
          relative = ctx.startOffset;
          break;
        default:
          relative = 0;
          while (ctx.parent) {
            ctx = ctx.parent;
          }
      }
      if (this.options.relativeTo) {
        relative += this.relativeToGetter(parent.val);
      }
      this.offsetType.encode(stream, ctx.pointerOffset - relative);
      type = this.type;
      if (type == null) {
        if (!(val instanceof VoidPointer)) {
          throw new Error("Must be a VoidPointer");
        }
        type = val.type;
        val = val.value;
      }
      ctx.pointers.push({
        type: type,
        val: val,
        parent: parent
      });
      return ctx.pointerOffset += type.size(val, parent);
    };

    return Pointer;

  })();

  VoidPointer = (function() {
    function VoidPointer(type, value) {
      this.type = type;
      this.value = value;
    }

    return VoidPointer;

  })();

  exports.Pointer = Pointer;

  exports.VoidPointer = VoidPointer;

}).call(this);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(187), __esModule: true };

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(188);
var $Object = __webpack_require__(2).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(17);
var $getOwnPropertyDescriptor = __webpack_require__(56).f;

__webpack_require__(58)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(24);
module.exports = __webpack_require__(197);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(191);
var step = __webpack_require__(93);
var Iterators = __webpack_require__(23);
var toIObject = __webpack_require__(17);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(60)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(38);
var descriptor = __webpack_require__(27);
var setToStringTag = __webpack_require__(41);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(17);
var toLength = __webpack_require__(39);
var toAbsoluteIndex = __webpack_require__(97);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(18);
var toObject = __webpack_require__(30);
var IE_PROTO = __webpack_require__(62)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(61);
var defined = __webpack_require__(55);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var get = __webpack_require__(65);
module.exports = __webpack_require__(2).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(199), __esModule: true };

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
module.exports = __webpack_require__(2).Object.freeze;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(42).onFreeze;

__webpack_require__(58)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(203);
module.exports = __webpack_require__(2).Object.keys;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(30);
var $keys = __webpack_require__(29);

__webpack_require__(58)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24);
__webpack_require__(28);
module.exports = __webpack_require__(68).f('iterator');


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(206), __esModule: true };

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(207);
__webpack_require__(71);
__webpack_require__(210);
__webpack_require__(211);
module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(5);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(94);
var META = __webpack_require__(42).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(63);
var setToStringTag = __webpack_require__(41);
var uid = __webpack_require__(40);
var wks = __webpack_require__(4);
var wksExt = __webpack_require__(68);
var wksDefine = __webpack_require__(69);
var enumKeys = __webpack_require__(208);
var isArray = __webpack_require__(99);
var anObject = __webpack_require__(14);
var isObject = __webpack_require__(10);
var toIObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(57);
var createDesc = __webpack_require__(27);
var _create = __webpack_require__(38);
var gOPNExt = __webpack_require__(209);
var $GOPD = __webpack_require__(56);
var $DP = __webpack_require__(6);
var $keys = __webpack_require__(29);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(100).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(36).f = $propertyIsEnumerable;
  __webpack_require__(70).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(37)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(70);
var pIE = __webpack_require__(36);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(17);
var gOPN = __webpack_require__(100).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('asyncIterator');


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('observable');


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(213);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperty: __webpack_require__(6).f });


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(215), __esModule: true };

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
__webpack_require__(24);
__webpack_require__(28);
__webpack_require__(216);
__webpack_require__(221);
__webpack_require__(223);
__webpack_require__(224);
module.exports = __webpack_require__(2).Map;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(103);
var validate = __webpack_require__(73);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(108)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var core = __webpack_require__(2);
var dP = __webpack_require__(6);
var DESCRIPTORS = __webpack_require__(5);
var SPECIES = __webpack_require__(4)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(20);
var IObject = __webpack_require__(53);
var toObject = __webpack_require__(30);
var toLength = __webpack_require__(39);
var asc = __webpack_require__(219);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(220);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var isArray = __webpack_require__(99);
var SPECIES = __webpack_require__(4)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(109)('Map') });


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(43);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(110)('Map');


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(111)('Map');


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(67);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(227);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(231);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(67);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(228), __esModule: true };

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(229);
module.exports = __webpack_require__(2).Object.setPrototypeOf;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(230).set });


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(14);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(20)(Function.call, __webpack_require__(56).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(232), __esModule: true };

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
var $Object = __webpack_require__(2).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(38) });


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(235), __esModule: true };

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(236);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(5), 'Object', { defineProperties: __webpack_require__(95) });


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(238);
var isArguments = __webpack_require__(239);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 238 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 239 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(242);
module.exports = __webpack_require__(2).Object.assign;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(243) });


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(70);
var pIE = __webpack_require__(36);
var toObject = __webpack_require__(30);
var IObject = __webpack_require__(53);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(245), __esModule: true };

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(246);
module.exports = __webpack_require__(2).String.fromCodePoint;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(97);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(248), __esModule: true };

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24);
__webpack_require__(249);
module.exports = __webpack_require__(2).Array.from;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(20);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(30);
var call = __webpack_require__(106);
var isArrayIter = __webpack_require__(107);
var toLength = __webpack_require__(39);
var createProperty = __webpack_require__(250);
var getIterFn = __webpack_require__(65);

$export($export.S + $export.F * !__webpack_require__(251)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6);
var createDesc = __webpack_require__(27);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(4)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(253), __esModule: true };

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
__webpack_require__(24);
__webpack_require__(28);
__webpack_require__(254);
__webpack_require__(255);
__webpack_require__(256);
__webpack_require__(257);
module.exports = __webpack_require__(2).Set;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(103);
var validate = __webpack_require__(73);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(108)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(109)('Set') });


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(110)('Set');


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(111)('Set');


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.9.1
var CATEGORY_BITS, CATEGORY_MASK, CATEGORY_SHIFT, COMBINING_BITS, COMBINING_MASK, COMBINING_SHIFT, EAW_BITS, EAW_MASK, EAW_SHIFT, NUMBER_BITS, NUMBER_MASK, SCRIPT_BITS, SCRIPT_MASK, SCRIPT_SHIFT, UnicodeTrie, bits, data, fs, log2, trie;

UnicodeTrie = __webpack_require__(74);

data = __webpack_require__(259);



trie = new UnicodeTrie(Buffer("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","base64"));

log2 = Math.log2 || function(n) {
  return Math.log(n) / Math.LN2;
};

bits = function(n) {
  return (log2(n) + 1) | 0;
};

CATEGORY_BITS = bits(data.categories.length - 1);

COMBINING_BITS = bits(data.combiningClasses.length - 1);

SCRIPT_BITS = bits(data.scripts.length - 1);

EAW_BITS = bits(data.eaw.length - 1);

NUMBER_BITS = 10;

CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;

COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;

SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;

EAW_SHIFT = NUMBER_BITS;

CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;

COMBINING_MASK = (1 << COMBINING_BITS) - 1;

SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;

EAW_MASK = (1 << EAW_BITS) - 1;

NUMBER_MASK = (1 << NUMBER_BITS) - 1;

exports.getCategory = function(codePoint) {
  var val;
  val = trie.get(codePoint);
  return data.categories[(val >> CATEGORY_SHIFT) & CATEGORY_MASK];
};

exports.getCombiningClass = function(codePoint) {
  var val;
  val = trie.get(codePoint);
  return data.combiningClasses[(val >> COMBINING_SHIFT) & COMBINING_MASK];
};

exports.getScript = function(codePoint) {
  var val;
  val = trie.get(codePoint);
  return data.scripts[(val >> SCRIPT_SHIFT) & SCRIPT_MASK];
};

exports.getEastAsianWidth = function(codePoint) {
  var val;
  val = trie.get(codePoint);
  return data.eaw[(val >> EAW_SHIFT) & EAW_MASK];
};

exports.getNumericValue = function(codePoint) {
  var denominator, exp, num, numerator, val;
  val = trie.get(codePoint);
  num = val & NUMBER_MASK;
  if (num === 0) {
    return null;
  } else if (num <= 50) {
    return num - 1;
  } else if (num < 0x1e0) {
    numerator = (num >> 4) - 12;
    denominator = (num & 0xf) + 1;
    return numerator / denominator;
  } else if (num < 0x300) {
    val = (num >> 5) - 14;
    exp = (num & 0x1f) + 2;
    while (exp > 0) {
      val *= 10;
      exp--;
    }
    return val;
  } else {
    val = (num >> 2) - 0xbf;
    exp = (num & 3) + 1;
    while (exp > 0) {
      val *= 60;
      exp--;
    }
    return val;
  }
};

exports.isAlphabetic = function(codePoint) {
  var ref;
  return (ref = exports.getCategory(codePoint)) === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Nl';
};

exports.isDigit = function(codePoint) {
  return exports.getCategory(codePoint) === 'Nd';
};

exports.isPunctuation = function(codePoint) {
  var ref;
  return (ref = exports.getCategory(codePoint)) === 'Pc' || ref === 'Pd' || ref === 'Pe' || ref === 'Pf' || ref === 'Pi' || ref === 'Po' || ref === 'Ps';
};

exports.isLowerCase = function(codePoint) {
  return exports.getCategory(codePoint) === 'Ll';
};

exports.isUpperCase = function(codePoint) {
  return exports.getCategory(codePoint) === 'Lu';
};

exports.isTitleCase = function(codePoint) {
  return exports.getCategory(codePoint) === 'Lt';
};

exports.isWhiteSpace = function(codePoint) {
  var ref;
  return (ref = exports.getCategory(codePoint)) === 'Zs' || ref === 'Zl' || ref === 'Zp';
};

exports.isBaseForm = function(codePoint) {
  var ref;
  return (ref = exports.getCategory(codePoint)) === 'Nd' || ref === 'No' || ref === 'Nl' || ref === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Me' || ref === 'Mc';
};

exports.isMark = function(codePoint) {
  var ref;
  return (ref = exports.getCategory(codePoint)) === 'Mn' || ref === 'Me' || ref === 'Mc';
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = {"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Tirhuta","Siddham","Modi","Takri","Ahom","Warang_Citi","Pau_Cin_Hau","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Miao","Duployan","SignWriting","Mende_Kikakui"],"eaw":["N","Na","A","W","H","F"]}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _slicedToArray = _interopDefault(__webpack_require__(261));
var _getIterator = _interopDefault(__webpack_require__(59));
var _defineProperty = _interopDefault(__webpack_require__(265));
var _regeneratorRuntime = _interopDefault(__webpack_require__(266));
var _Symbol$iterator = _interopDefault(__webpack_require__(98));
var _classCallCheck = _interopDefault(__webpack_require__(101));
var _createClass = _interopDefault(__webpack_require__(102));

var INITIAL_STATE = 1;
var FAIL_STATE = 0;

/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */

var StateMachine = function () {
  function StateMachine(dfa) {
    _classCallCheck(this, StateMachine);

    this.stateTable = dfa.stateTable;
    this.accepting = dfa.accepting;
    this.tags = dfa.tags;
  }

  /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */


  _createClass(StateMachine, [{
    key: 'match',
    value: function match(str) {
      var self = this;
      return _defineProperty({}, _Symbol$iterator, _regeneratorRuntime.mark(function _callee() {
        var state, startRun, lastAccepting, lastState, p, c;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = INITIAL_STATE;
                startRun = null;
                lastAccepting = null;
                lastState = null;
                p = 0;

              case 5:
                if (!(p < str.length)) {
                  _context.next = 21;
                  break;
                }

                c = str[p];


                lastState = state;
                state = self.stateTable[state][c];

                if (!(state === FAIL_STATE)) {
                  _context.next = 15;
                  break;
                }

                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return [startRun, lastAccepting, self.tags[lastState]];

              case 13:

                // reset the state as if we started over from the initial state
                state = self.stateTable[INITIAL_STATE][c];
                startRun = null;

              case 15:

                // start a run if not in the failure state
                if (state !== FAIL_STATE && startRun == null) {
                  startRun = p;
                }

                // if accepting, mark the potential match end
                if (self.accepting[state]) {
                  lastAccepting = p;
                }

                // reset the state to the initial state if we get into the failure state
                if (state === FAIL_STATE) {
                  state = INITIAL_STATE;
                }

              case 18:
                p++;
                _context.next = 5;
                break;

              case 21:
                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 24;
                return [startRun, lastAccepting, self.tags[state]];

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }

    /**
     * For each match over the input sequence, action functions matching
     * the tag definitions in the input pattern are called with the startIndex,
     * endIndex, and sub-match sequence.
     */

  }, {
    key: 'apply',
    value: function apply(str, actions) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(this.match(str)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 3);

          var start = _step$value[0];
          var end = _step$value[1];
          var tags = _step$value[2];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _getIterator(tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var tag = _step2.value;

              if (typeof actions[tag] === 'function') {
                actions[tag](start, end, str.slice(start, end + 1));
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);

  return StateMachine;
}();

module.exports = StateMachine;
//# sourceMappingURL=index.js.map


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(262);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(59);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(263), __esModule: true };

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(24);
module.exports = __webpack_require__(264);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(66);
var ITERATOR = __webpack_require__(4)('iterator');
var Iterators = __webpack_require__(23);
module.exports = __webpack_require__(2).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(72);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(267);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(268);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(270), __esModule: true };

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271);
module.exports = Math.pow(2, -52);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
'use strict';

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/
function clone(parent, circular, depth, prototype) {
  var filter;
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    filter = circular.filter;
    circular = circular.circular
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
};
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
};
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
};
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
};
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
};
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(113).BrotliDecompressBuffer;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/

var BROTLI_READ_SIZE = 4096;
var BROTLI_IBUF_SIZE =  (2 * BROTLI_READ_SIZE + 32);
var BROTLI_IBUF_MASK =  (2 * BROTLI_READ_SIZE - 1);

var kBitMask = new Uint32Array([
  0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767,
  65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215
]);

/* Input byte buffer, consist of a ringbuffer and a "slack" region where */
/* bytes from the start of the ringbuffer are copied. */
function BrotliBitReader(input) {
  this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
  this.input_ = input;    /* input callback */
  
  this.reset();
}

BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;

BrotliBitReader.prototype.reset = function() {
  this.buf_ptr_ = 0;      /* next input will write here */
  this.val_ = 0;          /* pre-fetched bits */
  this.pos_ = 0;          /* byte position in stream */
  this.bit_pos_ = 0;      /* current bit-reading position in val_ */
  this.bit_end_pos_ = 0;  /* bit-reading end position from LSB of val_ */
  this.eos_ = 0;          /* input stream is finished */
  
  this.readMoreInput();
  for (var i = 0; i < 4; i++) {
    this.val_ |= this.buf_[this.pos_] << (8 * i);
    ++this.pos_;
  }
  
  return this.bit_end_pos_ > 0;
};

/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/
BrotliBitReader.prototype.readMoreInput = function() {
  if (this.bit_end_pos_ > 256) {
    return;
  } else if (this.eos_) {
    if (this.bit_pos_ > this.bit_end_pos_)
      throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
  } else {
    var dst = this.buf_ptr_;
    var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
    if (bytes_read < 0) {
      throw new Error('Unexpected end of input');
    }
    
    if (bytes_read < BROTLI_READ_SIZE) {
      this.eos_ = 1;
      /* Store 32 bytes of zero after the stream end. */
      for (var p = 0; p < 32; p++)
        this.buf_[dst + bytes_read + p] = 0;
    }
    
    if (dst === 0) {
      /* Copy the head of the ringbuffer to the slack region. */
      for (var p = 0; p < 32; p++)
        this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];

      this.buf_ptr_ = BROTLI_READ_SIZE;
    } else {
      this.buf_ptr_ = 0;
    }
    
    this.bit_end_pos_ += bytes_read << 3;
  }
};

/* Guarantees that there are at least 24 bits in the buffer. */
BrotliBitReader.prototype.fillBitWindow = function() {    
  while (this.bit_pos_ >= 8) {
    this.val_ >>>= 8;
    this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
    ++this.pos_;
    this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
    this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
  }
};

/* Reads the specified number of bits from Read Buffer. */
BrotliBitReader.prototype.readBits = function(n_bits) {
  if (32 - this.bit_pos_ < n_bits) {
    this.fillBitWindow();
  }
  
  var val = ((this.val_ >>> this.bit_pos_) & kBitMask[n_bits]);
  this.bit_pos_ += n_bits;
  return val;
};

module.exports = BrotliBitReader;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var base64 = __webpack_require__(276);
var fs = __webpack_require__(9);

/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */
exports.init = function() {
  var BrotliDecompressBuffer = __webpack_require__(113).BrotliDecompressBuffer;
  var compressed = base64.toByteArray(__webpack_require__(277));
  return BrotliDecompressBuffer(compressed);
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports="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";


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/

var CONTEXT_LSB6         = 0;
var CONTEXT_MSB6         = 1;
var CONTEXT_UTF8         = 2;
var CONTEXT_SIGNED       = 3;

/* Common context lookup table for all context modes. */
exports.lookup = new Uint8Array([
  /* CONTEXT_UTF8, last byte. */
  /* ASCII range. */
   0,  0,  0,  0,  0,  0,  0,  0,  0,  4,  4,  0,  0,  4,  0,  0,
   0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,
   8, 12, 16, 12, 12, 20, 12, 16, 24, 28, 12, 12, 32, 12, 36, 12,
  44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32, 32, 24, 40, 28, 12,
  12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52, 52, 52, 52, 48,
  52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12, 28, 12, 12,
  12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60, 60, 56,
  60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12,  0,
  /* UTF8 continuation byte range. */
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
  /* UTF8 lead byte range. */
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
  /* CONTEXT_UTF8 second last byte. */
  /* ASCII range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1,
  1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1,
  1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
  /* UTF8 continuation byte range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  /* UTF8 lead byte range. */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  /* CONTEXT_SIGNED, second last byte. */
  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7,
  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
   0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
  48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
  /* CONTEXT_LSB6, last byte. */
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  /* CONTEXT_MSB6, last byte. */
   0,  0,  0,  0,  1,  1,  1,  1,  2,  2,  2,  2,  3,  3,  3,  3,
   4,  4,  4,  4,  5,  5,  5,  5,  6,  6,  6,  6,  7,  7,  7,  7,
   8,  8,  8,  8,  9,  9,  9,  9, 10, 10, 10, 10, 11, 11, 11, 11,
  12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15,
  16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19,
  20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23,
  24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
  28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31,
  32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35,
  36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39,
  40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43,
  44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47,
  48, 48, 48, 48, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51,
  52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55,
  56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59,
  60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63,
  /* CONTEXT_{M,L}SB6, second last byte, */
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]);

exports.lookupOffsets = new Uint16Array([
  /* CONTEXT_LSB6 */
  1024, 1536,
  /* CONTEXT_MSB6 */
  1280, 1536,
  /* CONTEXT_UTF8 */
  0, 256,
  /* CONTEXT_SIGNED */
  768, 512,
]);


/***/ }),
/* 279 */
/***/ (function(module, exports) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/

/* Represents the range of values belonging to a prefix code: */
/* [offset, offset + 2^nbits) */
function PrefixCodeRange(offset, nbits) {
  this.offset = offset;
  this.nbits = nbits;
}

exports.kBlockLengthPrefixCode = [
  new PrefixCodeRange(1, 2), new PrefixCodeRange(5, 2), new PrefixCodeRange(9, 2), new PrefixCodeRange(13, 2),
  new PrefixCodeRange(17, 3), new PrefixCodeRange(25, 3), new PrefixCodeRange(33, 3), new PrefixCodeRange(41, 3),
  new PrefixCodeRange(49, 4), new PrefixCodeRange(65, 4), new PrefixCodeRange(81, 4), new PrefixCodeRange(97, 4),
  new PrefixCodeRange(113, 5), new PrefixCodeRange(145, 5), new PrefixCodeRange(177, 5), new PrefixCodeRange(209, 5),
  new PrefixCodeRange(241, 6), new PrefixCodeRange(305, 6), new PrefixCodeRange(369, 7), new PrefixCodeRange(497, 8),
  new PrefixCodeRange(753, 9), new PrefixCodeRange(1265, 10), new PrefixCodeRange(2289, 11), new PrefixCodeRange(4337, 12),
  new PrefixCodeRange(8433, 13), new PrefixCodeRange(16625, 24)
];

exports.kInsertLengthPrefixCode = [
  new PrefixCodeRange(0, 0), new PrefixCodeRange(1, 0), new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0),
  new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0), new PrefixCodeRange(6, 1), new PrefixCodeRange(8, 1),
  new PrefixCodeRange(10, 2), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 3), new PrefixCodeRange(26, 3),
  new PrefixCodeRange(34, 4), new PrefixCodeRange(50, 4), new PrefixCodeRange(66, 5), new PrefixCodeRange(98, 5),
  new PrefixCodeRange(130, 6), new PrefixCodeRange(194, 7), new PrefixCodeRange(322, 8), new PrefixCodeRange(578, 9),
  new PrefixCodeRange(1090, 10), new PrefixCodeRange(2114, 12), new PrefixCodeRange(6210, 14), new PrefixCodeRange(22594, 24),
];

exports.kCopyLengthPrefixCode = [
  new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0), new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0),
  new PrefixCodeRange(6, 0), new PrefixCodeRange(7, 0), new PrefixCodeRange(8, 0), new PrefixCodeRange(9, 0),
  new PrefixCodeRange(10, 1), new PrefixCodeRange(12, 1), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 2),
  new PrefixCodeRange(22, 3), new PrefixCodeRange(30, 3), new PrefixCodeRange(38, 4), new PrefixCodeRange(54, 4),
  new PrefixCodeRange(70, 5), new PrefixCodeRange(102, 5), new PrefixCodeRange(134, 6), new PrefixCodeRange(198, 7),
  new PrefixCodeRange(326, 8), new PrefixCodeRange(582, 9), new PrefixCodeRange(1094, 10), new PrefixCodeRange(2118, 24),
];

exports.kInsertRangeLut = [
  0, 0, 8, 8, 0, 16, 8, 16, 16,
];

exports.kCopyRangeLut = [
  0, 8, 0, 8, 16, 0, 16, 8, 16,
];


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/

var BrotliDictionary = __webpack_require__(115);

var kIdentity       = 0;
var kOmitLast1      = 1;
var kOmitLast2      = 2;
var kOmitLast3      = 3;
var kOmitLast4      = 4;
var kOmitLast5      = 5;
var kOmitLast6      = 6;
var kOmitLast7      = 7;
var kOmitLast8      = 8;
var kOmitLast9      = 9;
var kUppercaseFirst = 10;
var kUppercaseAll   = 11;
var kOmitFirst1     = 12;
var kOmitFirst2     = 13;
var kOmitFirst3     = 14;
var kOmitFirst4     = 15;
var kOmitFirst5     = 16;
var kOmitFirst6     = 17;
var kOmitFirst7     = 18;
var kOmitFirst8     = 19;
var kOmitFirst9     = 20;

function Transform(prefix, transform, suffix) {
  this.prefix = new Uint8Array(prefix.length);
  this.transform = transform;
  this.suffix = new Uint8Array(suffix.length);
  
  for (var i = 0; i < prefix.length; i++)
    this.prefix[i] = prefix.charCodeAt(i);
  
  for (var i = 0; i < suffix.length; i++)
    this.suffix[i] = suffix.charCodeAt(i);
}

var kTransforms = [
     new Transform(         "", kIdentity,       ""           ),
     new Transform(         "", kIdentity,       " "          ),
     new Transform(        " ", kIdentity,       " "          ),
     new Transform(         "", kOmitFirst1,     ""           ),
     new Transform(         "", kUppercaseFirst, " "          ),
     new Transform(         "", kIdentity,       " the "      ),
     new Transform(        " ", kIdentity,       ""           ),
     new Transform(       "s ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       " of "       ),
     new Transform(         "", kUppercaseFirst, ""           ),
     new Transform(         "", kIdentity,       " and "      ),
     new Transform(         "", kOmitFirst2,     ""           ),
     new Transform(         "", kOmitLast1,      ""           ),
     new Transform(       ", ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       ", "         ),
     new Transform(        " ", kUppercaseFirst, " "          ),
     new Transform(         "", kIdentity,       " in "       ),
     new Transform(         "", kIdentity,       " to "       ),
     new Transform(       "e ", kIdentity,       " "          ),
     new Transform(         "", kIdentity,       "\""         ),
     new Transform(         "", kIdentity,       "."          ),
     new Transform(         "", kIdentity,       "\">"        ),
     new Transform(         "", kIdentity,       "\n"         ),
     new Transform(         "", kOmitLast3,      ""           ),
     new Transform(         "", kIdentity,       "]"          ),
     new Transform(         "", kIdentity,       " for "      ),
     new Transform(         "", kOmitFirst3,     ""           ),
     new Transform(         "", kOmitLast2,      ""           ),
     new Transform(         "", kIdentity,       " a "        ),
     new Transform(         "", kIdentity,       " that "     ),
     new Transform(        " ", kUppercaseFirst, ""           ),
     new Transform(         "", kIdentity,       ". "         ),
     new Transform(        ".", kIdentity,       ""           ),
     new Transform(        " ", kIdentity,       ", "         ),
     new Transform(         "", kOmitFirst4,     ""           ),
     new Transform(         "", kIdentity,       " with "     ),
     new Transform(         "", kIdentity,       "'"          ),
     new Transform(         "", kIdentity,       " from "     ),
     new Transform(         "", kIdentity,       " by "       ),
     new Transform(         "", kOmitFirst5,     ""           ),
     new Transform(         "", kOmitFirst6,     ""           ),
     new Transform(    " the ", kIdentity,       ""           ),
     new Transform(         "", kOmitLast4,      ""           ),
     new Transform(         "", kIdentity,       ". The "     ),
     new Transform(         "", kUppercaseAll,   ""           ),
     new Transform(         "", kIdentity,       " on "       ),
     new Transform(         "", kIdentity,       " as "       ),
     new Transform(         "", kIdentity,       " is "       ),
     new Transform(         "", kOmitLast7,      ""           ),
     new Transform(         "", kOmitLast1,      "ing "       ),
     new Transform(         "", kIdentity,       "\n\t"       ),
     new Transform(         "", kIdentity,       ":"          ),
     new Transform(        " ", kIdentity,       ". "         ),
     new Transform(         "", kIdentity,       "ed "        ),
     new Transform(         "", kOmitFirst9,     ""           ),
     new Transform(         "", kOmitFirst7,     ""           ),
     new Transform(         "", kOmitLast6,      ""           ),
     new Transform(         "", kIdentity,       "("          ),
     new Transform(         "", kUppercaseFirst, ", "         ),
     new Transform(         "", kOmitLast8,      ""           ),
     new Transform(         "", kIdentity,       " at "       ),
     new Transform(         "", kIdentity,       "ly "        ),
     new Transform(    " the ", kIdentity,       " of "       ),
     new Transform(         "", kOmitLast5,      ""           ),
     new Transform(         "", kOmitLast9,      ""           ),
     new Transform(        " ", kUppercaseFirst, ", "         ),
     new Transform(         "", kUppercaseFirst, "\""         ),
     new Transform(        ".", kIdentity,       "("          ),
     new Transform(         "", kUppercaseAll,   " "          ),
     new Transform(         "", kUppercaseFirst, "\">"        ),
     new Transform(         "", kIdentity,       "=\""        ),
     new Transform(        " ", kIdentity,       "."          ),
     new Transform(    ".com/", kIdentity,       ""           ),
     new Transform(    " the ", kIdentity,       " of the "   ),
     new Transform(         "", kUppercaseFirst, "'"          ),
     new Transform(         "", kIdentity,       ". This "    ),
     new Transform(         "", kIdentity,       ","          ),
     new Transform(        ".", kIdentity,       " "          ),
     new Transform(         "", kUppercaseFirst, "("          ),
     new Transform(         "", kUppercaseFirst, "."          ),
     new Transform(         "", kIdentity,       " not "      ),
     new Transform(        " ", kIdentity,       "=\""        ),
     new Transform(         "", kIdentity,       "er "        ),
     new Transform(        " ", kUppercaseAll,   " "          ),
     new Transform(         "", kIdentity,       "al "        ),
     new Transform(        " ", kUppercaseAll,   ""           ),
     new Transform(         "", kIdentity,       "='"         ),
     new Transform(         "", kUppercaseAll,   "\""         ),
     new Transform(         "", kUppercaseFirst, ". "         ),
     new Transform(        " ", kIdentity,       "("          ),
     new Transform(         "", kIdentity,       "ful "       ),
     new Transform(        " ", kUppercaseFirst, ". "         ),
     new Transform(         "", kIdentity,       "ive "       ),
     new Transform(         "", kIdentity,       "less "      ),
     new Transform(         "", kUppercaseAll,   "'"          ),
     new Transform(         "", kIdentity,       "est "       ),
     new Transform(        " ", kUppercaseFirst, "."          ),
     new Transform(         "", kUppercaseAll,   "\">"        ),
     new Transform(        " ", kIdentity,       "='"         ),
     new Transform(         "", kUppercaseFirst, ","          ),
     new Transform(         "", kIdentity,       "ize "       ),
     new Transform(         "", kUppercaseAll,   "."          ),
     new Transform( "\xc2\xa0", kIdentity,       ""           ),
     new Transform(        " ", kIdentity,       ","          ),
     new Transform(         "", kUppercaseFirst, "=\""        ),
     new Transform(         "", kUppercaseAll,   "=\""        ),
     new Transform(         "", kIdentity,       "ous "       ),
     new Transform(         "", kUppercaseAll,   ", "         ),
     new Transform(         "", kUppercaseFirst, "='"         ),
     new Transform(        " ", kUppercaseFirst, ","          ),
     new Transform(        " ", kUppercaseAll,   "=\""        ),
     new Transform(        " ", kUppercaseAll,   ", "         ),
     new Transform(         "", kUppercaseAll,   ","          ),
     new Transform(         "", kUppercaseAll,   "("          ),
     new Transform(         "", kUppercaseAll,   ". "         ),
     new Transform(        " ", kUppercaseAll,   "."          ),
     new Transform(         "", kUppercaseAll,   "='"         ),
     new Transform(        " ", kUppercaseAll,   ". "         ),
     new Transform(        " ", kUppercaseFirst, "=\""        ),
     new Transform(        " ", kUppercaseAll,   "='"         ),
     new Transform(        " ", kUppercaseFirst, "='"         )
];

exports.kTransforms = kTransforms;
exports.kNumTransforms = kTransforms.length;

function ToUpperCase(p, i) {
  if (p[i] < 0xc0) {
    if (p[i] >= 97 && p[i] <= 122) {
      p[i] ^= 32;
    }
    return 1;
  }
  
  /* An overly simplified uppercasing model for utf-8. */
  if (p[i] < 0xe0) {
    p[i + 1] ^= 32;
    return 2;
  }
  
  /* An arbitrary transform for three byte characters. */
  p[i + 2] ^= 5;
  return 3;
}

exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
  var prefix = kTransforms[transform].prefix;
  var suffix = kTransforms[transform].suffix;
  var t = kTransforms[transform].transform;
  var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
  var i = 0;
  var start_idx = idx;
  var uppercase;
  
  if (skip > len) {
    skip = len;
  }
  
  var prefix_pos = 0;
  while (prefix_pos < prefix.length) {
    dst[idx++] = prefix[prefix_pos++];
  }
  
  word += skip;
  len -= skip;
  
  if (t <= kOmitLast9) {
    len -= t;
  }
  
  for (i = 0; i < len; i++) {
    dst[idx++] = BrotliDictionary.dictionary[word + i];
  }
  
  uppercase = idx - len;
  
  if (t === kUppercaseFirst) {
    ToUpperCase(dst, uppercase);
  } else if (t === kUppercaseAll) {
    while (len > 0) {
      var step = ToUpperCase(dst, uppercase);
      uppercase += step;
      len -= step;
    }
  }
  
  var suffix_pos = 0;
  while (suffix_pos < suffix.length) {
    dst[idx++] = suffix[suffix_pos++];
  }
  
  return idx - start_idx;
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {// Generated by CoffeeScript 1.12.6
(function() {
  var AFMFont, PDFFont, StandardFont, fs,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AFMFont = __webpack_require__(282);

  PDFFont = __webpack_require__(49);

  fs = __webpack_require__(9);

  StandardFont = (function(superClass) {
    var STANDARD_FONTS;

    extend(StandardFont, superClass);

    function StandardFont(document, name1, id) {
      var ref;
      this.document = document;
      this.name = name1;
      this.id = id;
      this.font = new AFMFont(STANDARD_FONTS[this.name]());
      ref = this.font, this.ascender = ref.ascender, this.descender = ref.descender, this.bbox = ref.bbox, this.lineGap = ref.lineGap;
    }

    StandardFont.prototype.embed = function() {
      this.dictionary.data = {
        Type: 'Font',
        BaseFont: this.name,
        Subtype: 'Type1',
        Encoding: 'WinAnsiEncoding'
      };
      return this.dictionary.end();
    };

    StandardFont.prototype.encode = function(text) {
      var advances, encoded, glyph, glyphs, i, j, len, positions;
      encoded = this.font.encodeText(text);
      glyphs = this.font.glyphsForString('' + text);
      advances = this.font.advancesForGlyphs(glyphs);
      positions = [];
      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
        glyph = glyphs[i];
        positions.push({
          xAdvance: advances[i],
          yAdvance: 0,
          xOffset: 0,
          yOffset: 0,
          advanceWidth: this.font.widthOfGlyph(glyph)
        });
      }
      return [encoded, positions];
    };

    StandardFont.prototype.widthOfString = function(string, size) {
      var advance, advances, glyphs, j, len, scale, width;
      glyphs = this.font.glyphsForString('' + string);
      advances = this.font.advancesForGlyphs(glyphs);
      width = 0;
      for (j = 0, len = advances.length; j < len; j++) {
        advance = advances[j];
        width += advance;
      }
      scale = size / 1000;
      return width * scale;
    };

    StandardFont.isStandardFont = function(name) {
      return name in STANDARD_FONTS;
    };

    STANDARD_FONTS = {
      "Courier": function() {
        return fs.readFileSync(__dirname + "/../font/data/Courier.afm", 'utf8');
      },
      "Courier-Bold": function() {
        return fs.readFileSync(__dirname + "/../font/data/Courier-Bold.afm", 'utf8');
      },
      "Courier-Oblique": function() {
        return fs.readFileSync(__dirname + "/../font/data/Courier-Oblique.afm", 'utf8');
      },
      "Courier-BoldOblique": function() {
        return fs.readFileSync(__dirname + "/../font/data/Courier-BoldOblique.afm", 'utf8');
      },
      "Helvetica": function() {
        return fs.readFileSync(__dirname + "/../font/data/Helvetica.afm", 'utf8');
      },
      "Helvetica-Bold": function() {
        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Bold.afm", 'utf8');
      },
      "Helvetica-Oblique": function() {
        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Oblique.afm", 'utf8');
      },
      "Helvetica-BoldOblique": function() {
        return fs.readFileSync(__dirname + "/../font/data/Helvetica-BoldOblique.afm", 'utf8');
      },
      "Times-Roman": function() {
        return fs.readFileSync(__dirname + "/../font/data/Times-Roman.afm", 'utf8');
      },
      "Times-Bold": function() {
        return fs.readFileSync(__dirname + "/../font/data/Times-Bold.afm", 'utf8');
      },
      "Times-Italic": function() {
        return fs.readFileSync(__dirname + "/../font/data/Times-Italic.afm", 'utf8');
      },
      "Times-BoldItalic": function() {
        return fs.readFileSync(__dirname + "/../font/data/Times-BoldItalic.afm", 'utf8');
      },
      "Symbol": function() {
        return fs.readFileSync(__dirname + "/../font/data/Symbol.afm", 'utf8');
      },
      "ZapfDingbats": function() {
        return fs.readFileSync(__dirname + "/../font/data/ZapfDingbats.afm", 'utf8');
      }
    };

    return StandardFont;

  })(PDFFont);

  module.exports = StandardFont;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var AFMFont, fs;

  fs = __webpack_require__(9);

  AFMFont = (function() {
    var WIN_ANSI_MAP, characters;

    AFMFont.open = function(filename) {
      return new AFMFont(fs.readFileSync(filename, 'utf8'));
    };

    function AFMFont(contents) {
      var e, i;
      this.contents = contents;
      this.attributes = {};
      this.glyphWidths = {};
      this.boundingBoxes = {};
      this.kernPairs = {};
      this.parse();
      this.charWidths = (function() {
        var j, results;
        results = [];
        for (i = j = 0; j <= 255; i = ++j) {
          results.push(this.glyphWidths[characters[i]]);
        }
        return results;
      }).call(this);
      this.bbox = (function() {
        var j, len, ref, results;
        ref = this.attributes['FontBBox'].split(/\s+/);
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          e = ref[j];
          results.push(+e);
        }
        return results;
      }).call(this);
      this.ascender = +(this.attributes['Ascender'] || 0);
      this.descender = +(this.attributes['Descender'] || 0);
      this.lineGap = (this.bbox[3] - this.bbox[1]) - (this.ascender - this.descender);
    }

    AFMFont.prototype.parse = function() {
      var a, j, key, len, line, match, name, ref, section, value;
      section = '';
      ref = this.contents.split('\n');
      for (j = 0, len = ref.length; j < len; j++) {
        line = ref[j];
        if (match = line.match(/^Start(\w+)/)) {
          section = match[1];
          continue;
        } else if (match = line.match(/^End(\w+)/)) {
          section = '';
          continue;
        }
        switch (section) {
          case 'FontMetrics':
            match = line.match(/(^\w+)\s+(.*)/);
            key = match[1];
            value = match[2];
            if (a = this.attributes[key]) {
              if (!Array.isArray(a)) {
                a = this.attributes[key] = [a];
              }
              a.push(value);
            } else {
              this.attributes[key] = value;
            }
            break;
          case 'CharMetrics':
            if (!/^CH?\s/.test(line)) {
              continue;
            }
            name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
            this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
            break;
          case 'KernPairs':
            match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
            if (match) {
              this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
            }
        }
      }
    };

    WIN_ANSI_MAP = {
      402: 131,
      8211: 150,
      8212: 151,
      8216: 145,
      8217: 146,
      8218: 130,
      8220: 147,
      8221: 148,
      8222: 132,
      8224: 134,
      8225: 135,
      8226: 149,
      8230: 133,
      8364: 128,
      8240: 137,
      8249: 139,
      8250: 155,
      710: 136,
      8482: 153,
      338: 140,
      339: 156,
      732: 152,
      352: 138,
      353: 154,
      376: 159,
      381: 142,
      382: 158
    };

    AFMFont.prototype.encodeText = function(text) {
      var char, i, j, ref, res;
      res = [];
      for (i = j = 0, ref = text.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        char = text.charCodeAt(i);
        char = WIN_ANSI_MAP[char] || char;
        res.push(char.toString(16));
      }
      return res;
    };

    AFMFont.prototype.glyphsForString = function(string) {
      var charCode, glyphs, i, j, ref;
      glyphs = [];
      for (i = j = 0, ref = string.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        charCode = string.charCodeAt(i);
        glyphs.push(this.characterToGlyph(charCode));
      }
      return glyphs;
    };

    AFMFont.prototype.characterToGlyph = function(character) {
      return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
    };

    AFMFont.prototype.widthOfGlyph = function(glyph) {
      return this.glyphWidths[glyph] || 0;
    };

    AFMFont.prototype.getKernPair = function(left, right) {
      return this.kernPairs[left + '\0' + right] || 0;
    };

    AFMFont.prototype.advancesForGlyphs = function(glyphs) {
      var advances, index, j, left, len, right;
      advances = [];
      for (index = j = 0, len = glyphs.length; j < len; index = ++j) {
        left = glyphs[index];
        right = glyphs[index + 1];
        advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
      }
      return advances;
    };

    characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);

    return AFMFont;

  })();

  module.exports = AFMFont;

}).call(this);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var EmbeddedFont, PDFFont, PDFObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  PDFFont = __webpack_require__(49);

  PDFObject = __webpack_require__(26);

  EmbeddedFont = (function(superClass) {
    var toHex;

    extend(EmbeddedFont, superClass);

    function EmbeddedFont(document, font, id) {
      this.document = document;
      this.font = font;
      this.id = id;
      this.subset = this.font.createSubset();
      this.unicode = [[0]];
      this.widths = [this.font.getGlyph(0).advanceWidth];
      this.name = this.font.postscriptName;
      this.scale = 1000 / this.font.unitsPerEm;
      this.ascender = this.font.ascent * this.scale;
      this.descender = this.font.descent * this.scale;
      this.lineGap = this.font.lineGap * this.scale;
      this.bbox = this.font.bbox;
      this.layoutCache = Object.create(null);
    }

    EmbeddedFont.prototype.layoutRun = function(text, features) {
      var i, j, key, len, position, ref, run;
      run = this.font.layout(text, features);
      ref = run.positions;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        position = ref[i];
        for (key in position) {
          position[key] *= this.scale;
        }
        position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
      }
      return run;
    };

    EmbeddedFont.prototype.layoutCached = function(text) {
      var cached, run;
      if (cached = this.layoutCache[text]) {
        return cached;
      }
      run = this.layoutRun(text);
      this.layoutCache[text] = run;
      return run;
    };

    EmbeddedFont.prototype.layout = function(text, features, onlyWidth) {
      var advanceWidth, glyphs, index, last, positions, ref, run;
      if (onlyWidth == null) {
        onlyWidth = false;
      }
      if (features) {
        return this.layoutRun(text, features);
      }
      glyphs = onlyWidth ? null : [];
      positions = onlyWidth ? null : [];
      advanceWidth = 0;
      last = 0;
      index = 0;
      while (index <= text.length) {
        if ((index === text.length && last < index) || ((ref = text.charAt(index)) === ' ' || ref === '\t')) {
          run = this.layoutCached(text.slice(last, ++index));
          if (!onlyWidth) {
            glyphs.push.apply(glyphs, run.glyphs);
            positions.push.apply(positions, run.positions);
          }
          advanceWidth += run.advanceWidth;
          last = index;
        } else {
          index++;
        }
      }
      return {
        glyphs: glyphs,
        positions: positions,
        advanceWidth: advanceWidth
      };
    };

    EmbeddedFont.prototype.encode = function(text, features) {
      var base, base1, gid, glyph, glyphs, i, j, len, positions, ref, res;
      ref = this.layout(text, features), glyphs = ref.glyphs, positions = ref.positions;
      res = [];
      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
        glyph = glyphs[i];
        gid = this.subset.includeGlyph(glyph.id);
        res.push(('0000' + gid.toString(16)).slice(-4));
        if ((base = this.widths)[gid] == null) {
          base[gid] = glyph.advanceWidth * this.scale;
        }
        if ((base1 = this.unicode)[gid] == null) {
          base1[gid] = glyph.codePoints;
        }
      }
      return [res, positions];
    };

    EmbeddedFont.prototype.widthOfString = function(string, size, features) {
      var scale, width;
      width = this.layout(string, features, true).advanceWidth;
      scale = size / 1000;
      return width * scale;
    };

    EmbeddedFont.prototype.embed = function() {
      var bbox, descendantFont, descriptor, familyClass, flags, fontFile, i, isCFF, name, ref, tag;
      isCFF = this.subset.cff != null;
      fontFile = this.document.ref();
      if (isCFF) {
        fontFile.data.Subtype = 'CIDFontType0C';
      }
      this.subset.encodeStream().pipe(fontFile);
      familyClass = (((ref = this.font['OS/2']) != null ? ref.sFamilyClass : void 0) || 0) >> 8;
      flags = 0;
      if (this.font.post.isFixedPitch) {
        flags |= 1 << 0;
      }
      if ((1 <= familyClass && familyClass <= 7)) {
        flags |= 1 << 1;
      }
      flags |= 1 << 2;
      if (familyClass === 10) {
        flags |= 1 << 3;
      }
      if (this.font.head.macStyle.italic) {
        flags |= 1 << 6;
      }
      tag = ((function() {
        var j, results;
        results = [];
        for (i = j = 0; j < 6; i = ++j) {
          results.push(String.fromCharCode(Math.random() * 26 + 65));
        }
        return results;
      })()).join('');
      name = tag + '+' + this.font.postscriptName;
      bbox = this.font.bbox;
      descriptor = this.document.ref({
        Type: 'FontDescriptor',
        FontName: name,
        Flags: flags,
        FontBBox: [bbox.minX * this.scale, bbox.minY * this.scale, bbox.maxX * this.scale, bbox.maxY * this.scale],
        ItalicAngle: this.font.italicAngle,
        Ascent: this.ascender,
        Descent: this.descender,
        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
        XHeight: (this.font.xHeight || 0) * this.scale,
        StemV: 0
      });
      if (isCFF) {
        descriptor.data.FontFile3 = fontFile;
      } else {
        descriptor.data.FontFile2 = fontFile;
      }
      descriptor.end();
      descendantFont = this.document.ref({
        Type: 'Font',
        Subtype: isCFF ? 'CIDFontType0' : 'CIDFontType2',
        BaseFont: name,
        CIDSystemInfo: {
          Registry: new String('Adobe'),
          Ordering: new String('Identity'),
          Supplement: 0
        },
        FontDescriptor: descriptor,
        W: [0, this.widths]
      });
      descendantFont.end();
      this.dictionary.data = {
        Type: 'Font',
        Subtype: 'Type0',
        BaseFont: name,
        Encoding: 'Identity-H',
        DescendantFonts: [descendantFont],
        ToUnicode: this.toUnicodeCmap()
      };
      return this.dictionary.end();
    };

    toHex = function() {
      var code, codePoints, codes;
      codePoints = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      codes = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = codePoints.length; j < len; j++) {
          code = codePoints[j];
          results.push(('0000' + code.toString(16)).slice(-4));
        }
        return results;
      })();
      return codes.join('');
    };

    EmbeddedFont.prototype.toUnicodeCmap = function() {
      var cmap, codePoints, encoded, entries, j, k, len, len1, ref, value;
      cmap = this.document.ref();
      entries = [];
      ref = this.unicode;
      for (j = 0, len = ref.length; j < len; j++) {
        codePoints = ref[j];
        encoded = [];
        for (k = 0, len1 = codePoints.length; k < len1; k++) {
          value = codePoints[k];
          if (value > 0xffff) {
            value -= 0x10000;
            encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
            value = 0xdc00 | value & 0x3ff;
          }
          encoded.push(toHex(value));
        }
        entries.push("<" + (encoded.join(' ')) + ">");
      }
      cmap.end("/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n<0000> <" + (toHex(entries.length - 1)) + "> [" + (entries.join(' ')) + "]\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend");
      return cmap;
    };

    return EmbeddedFont;

  })(PDFFont);

  module.exports = EmbeddedFont;

}).call(this);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var LineWrapper, number;

  LineWrapper = __webpack_require__(285);

  number = __webpack_require__(26).number;

  module.exports = {
    initText: function() {
      this.x = 0;
      this.y = 0;
      return this._lineGap = 0;
    },
    lineGap: function(_lineGap) {
      this._lineGap = _lineGap;
      return this;
    },
    moveDown: function(lines) {
      if (lines == null) {
        lines = 1;
      }
      this.y += this.currentLineHeight(true) * lines + this._lineGap;
      return this;
    },
    moveUp: function(lines) {
      if (lines == null) {
        lines = 1;
      }
      this.y -= this.currentLineHeight(true) * lines + this._lineGap;
      return this;
    },
    _text: function(text, x, y, options, lineCallback) {
      var j, len, line, ref, wrapper;
      options = this._initOptions(x, y, options);
      text = text == null ? '' : '' + text;
      if (options.wordSpacing) {
        text = text.replace(/\s{2,}/g, ' ');
      }
      if (options.width) {
        wrapper = this._wrapper;
        if (!wrapper) {
          wrapper = new LineWrapper(this, options);
          wrapper.on('line', lineCallback);
        }
        this._wrapper = options.continued ? wrapper : null;
        this._textOptions = options.continued ? options : null;
        wrapper.wrap(text, options);
      } else {
        ref = text.split('\n');
        for (j = 0, len = ref.length; j < len; j++) {
          line = ref[j];
          lineCallback(line, options);
        }
      }
      return this;
    },
    text: function(text, x, y, options) {
      return this._text(text, x, y, options, this._line.bind(this));
    },
    widthOfString: function(string, options) {
      if (options == null) {
        options = {};
      }
      return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
    },
    heightOfString: function(text, options) {
      var height, lineGap, ref, x, y;
      if (options == null) {
        options = {};
      }
      ref = this, x = ref.x, y = ref.y;
      options = this._initOptions(options);
      options.height = 2e308;
      lineGap = options.lineGap || this._lineGap || 0;
      this._text(text, this.x, this.y, options, (function(_this) {
        return function(line, options) {
          return _this.y += _this.currentLineHeight(true) + lineGap;
        };
      })(this));
      height = this.y - y;
      this.x = x;
      this.y = y;
      return height;
    },
    list: function(list, x, y, options, wrapper) {
      var flatten, i, indent, itemIndent, items, level, levels, midLine, r;
      options = this._initOptions(x, y, options);
      midLine = Math.round((this._font.ascender / 1000 * this._fontSize) / 2);
      r = options.bulletRadius || Math.round((this._font.ascender / 1000 * this._fontSize) / 3);
      indent = options.textIndent || r * 5;
      itemIndent = options.bulletIndent || r * 8;
      level = 1;
      items = [];
      levels = [];
      flatten = function(list) {
        var i, item, j, len, results;
        results = [];
        for (i = j = 0, len = list.length; j < len; i = ++j) {
          item = list[i];
          if (Array.isArray(item)) {
            level++;
            flatten(item);
            results.push(level--);
          } else {
            items.push(item);
            results.push(levels.push(level));
          }
        }
        return results;
      };
      flatten(list);
      wrapper = new LineWrapper(this, options);
      wrapper.on('line', this._line.bind(this));
      level = 1;
      i = 0;
      wrapper.on('firstLine', (function(_this) {
        return function() {
          var diff, l;
          if ((l = levels[i++]) !== level) {
            diff = itemIndent * (l - level);
            _this.x += diff;
            wrapper.lineWidth -= diff;
            level = l;
          }
          _this.circle(_this.x - indent + r, _this.y + midLine, r);
          return _this.fill();
        };
      })(this));
      wrapper.on('sectionStart', (function(_this) {
        return function() {
          var pos;
          pos = indent + itemIndent * (level - 1);
          _this.x += pos;
          return wrapper.lineWidth -= pos;
        };
      })(this));
      wrapper.on('sectionEnd', (function(_this) {
        return function() {
          var pos;
          pos = indent + itemIndent * (level - 1);
          _this.x -= pos;
          return wrapper.lineWidth += pos;
        };
      })(this));
      wrapper.wrap(items.join('\n'), options);
      return this;
    },
    _initOptions: function(x, y, options) {
      var key, ref, val;
      if (x == null) {
        x = {};
      }
      if (options == null) {
        options = {};
      }
      if (typeof x === 'object') {
        options = x;
        x = null;
      }
      options = (function() {
        var k, opts, v;
        opts = {};
        for (k in options) {
          v = options[k];
          opts[k] = v;
        }
        return opts;
      })();
      if (this._textOptions) {
        ref = this._textOptions;
        for (key in ref) {
          val = ref[key];
          if (key !== 'continued') {
            if (options[key] == null) {
              options[key] = val;
            }
          }
        }
      }
      if (x != null) {
        this.x = x;
      }
      if (y != null) {
        this.y = y;
      }
      if (options.lineBreak !== false) {
        if (options.width == null) {
          options.width = this.page.width - this.x - this.page.margins.right;
        }
      }
      options.columns || (options.columns = 0);
      if (options.columnGap == null) {
        options.columnGap = 18;
      }
      return options;
    },
    _line: function(text, options, wrapper) {
      var lineGap;
      if (options == null) {
        options = {};
      }
      this._fragment(text, this.x, this.y, options);
      lineGap = options.lineGap || this._lineGap || 0;
      if (!wrapper) {
        return this.x += this.widthOfString(text);
      } else {
        return this.y += this.currentLineHeight(true) + lineGap;
      }
    },
    _fragment: function(text, x, y, options) {
      var addSegment, align, base, characterSpacing, commands, d, encoded, encodedWord, flush, hadOffset, i, j, key, last, len, len1, lineWidth, lineY, m, mode, name, pos, positions, positionsWord, ref, ref1, ref2, renderedWidth, scale, space, spaceWidth, textWidth, val, word, wordSpacing, words;
      text = ('' + text).replace(/\n/g, '');
      if (text.length === 0) {
        return;
      }
      align = options.align || 'left';
      wordSpacing = options.wordSpacing || 0;
      characterSpacing = options.characterSpacing || 0;
      if (options.width) {
        switch (align) {
          case 'right':
            textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
            x += options.lineWidth - textWidth;
            break;
          case 'center':
            x += options.lineWidth / 2 - options.textWidth / 2;
            break;
          case 'justify':
            words = text.trim().split(/\s+/);
            textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
            spaceWidth = this.widthOfString(' ') + characterSpacing;
            wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
        }
      }
      renderedWidth = options.textWidth + (wordSpacing * (options.wordCount - 1)) + (characterSpacing * (text.length - 1));
      if (options.link) {
        this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
      }
      if (options.underline || options.strike) {
        this.save();
        if (!options.stroke) {
          this.strokeColor.apply(this, this._fillColor);
        }
        lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
        this.lineWidth(lineWidth);
        d = options.underline ? 1 : 2;
        lineY = y + this.currentLineHeight() / d;
        if (options.underline) {
          lineY -= lineWidth;
        }
        this.moveTo(x, lineY);
        this.lineTo(x + renderedWidth, lineY);
        this.stroke();
        this.restore();
      }
      this.save();
      this.transform(1, 0, 0, -1, 0, this.page.height);
      y = this.page.height - y - (this._font.ascender / 1000 * this._fontSize);
      if ((base = this.page.fonts)[name = this._font.id] == null) {
        base[name] = this._font.ref();
      }
      this.addContent("BT");
      this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
      this.addContent("/" + this._font.id + " " + (number(this._fontSize)) + " Tf");
      mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
      if (mode) {
        this.addContent(mode + " Tr");
      }
      if (characterSpacing) {
        this.addContent((number(characterSpacing)) + " Tc");
      }
      if (wordSpacing) {
        words = text.trim().split(/\s+/);
        wordSpacing += this.widthOfString(' ') + characterSpacing;
        wordSpacing *= 1000 / this._fontSize;
        encoded = [];
        positions = [];
        for (j = 0, len = words.length; j < len; j++) {
          word = words[j];
          ref = this._font.encode(word, options.features), encodedWord = ref[0], positionsWord = ref[1];
          encoded.push.apply(encoded, encodedWord);
          positions.push.apply(positions, positionsWord);
          space = {};
          ref1 = positions[positions.length - 1];
          for (key in ref1) {
            val = ref1[key];
            space[key] = val;
          }
          space.xAdvance += wordSpacing;
          positions[positions.length - 1] = space;
        }
      } else {
        ref2 = this._font.encode(text, options.features), encoded = ref2[0], positions = ref2[1];
      }
      scale = this._fontSize / 1000;
      commands = [];
      last = 0;
      hadOffset = false;
      addSegment = (function(_this) {
        return function(cur) {
          var advance, hex;
          if (last < cur) {
            hex = encoded.slice(last, cur).join('');
            advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
            commands.push("<" + hex + "> " + (number(-advance)));
          }
          return last = cur;
        };
      })(this);
      flush = (function(_this) {
        return function(i) {
          addSegment(i);
          if (commands.length > 0) {
            _this.addContent("[" + (commands.join(' ')) + "] TJ");
            return commands.length = 0;
          }
        };
      })(this);
      for (i = m = 0, len1 = positions.length; m < len1; i = ++m) {
        pos = positions[i];
        if (pos.xOffset || pos.yOffset) {
          flush(i);
          this.addContent("1 0 0 1 " + (number(x + pos.xOffset * scale)) + " " + (number(y + pos.yOffset * scale)) + " Tm");
          flush(i + 1);
          hadOffset = true;
        } else {
          if (hadOffset) {
            this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
            hadOffset = false;
          }
          if (pos.xAdvance - pos.advanceWidth !== 0) {
            addSegment(i + 1);
          }
        }
        x += pos.xAdvance * scale;
      }
      flush(i);
      this.addContent("ET");
      return this.restore();
    }
  };

}).call(this);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var EventEmitter, LineBreaker, LineWrapper,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  EventEmitter = __webpack_require__(32).EventEmitter;

  LineBreaker = __webpack_require__(117);

  LineWrapper = (function(superClass) {
    extend(LineWrapper, superClass);

    function LineWrapper(document, options) {
      var ref;
      this.document = document;
      this.indent = options.indent || 0;
      this.characterSpacing = options.characterSpacing || 0;
      this.wordSpacing = options.wordSpacing === 0;
      this.columns = options.columns || 1;
      this.columnGap = (ref = options.columnGap) != null ? ref : 18;
      this.lineWidth = (options.width - (this.columnGap * (this.columns - 1))) / this.columns;
      this.spaceLeft = this.lineWidth;
      this.startX = this.document.x;
      this.startY = this.document.y;
      this.column = 1;
      this.ellipsis = options.ellipsis;
      this.continuedX = 0;
      this.features = options.features;
      if (options.height != null) {
        this.height = options.height;
        this.maxY = this.startY + options.height;
      } else {
        this.maxY = this.document.page.maxY();
      }
      this.on('firstLine', (function(_this) {
        return function(options) {
          var indent;
          indent = _this.continuedX || _this.indent;
          _this.document.x += indent;
          _this.lineWidth -= indent;
          return _this.once('line', function() {
            _this.document.x -= indent;
            _this.lineWidth += indent;
            if (options.continued && !_this.continuedX) {
              _this.continuedX = _this.indent;
            }
            if (!options.continued) {
              return _this.continuedX = 0;
            }
          });
        };
      })(this));
      this.on('lastLine', (function(_this) {
        return function(options) {
          var align;
          align = options.align;
          if (align === 'justify') {
            options.align = 'left';
          }
          _this.lastLine = true;
          return _this.once('line', function() {
            _this.document.y += options.paragraphGap || 0;
            options.align = align;
            return _this.lastLine = false;
          });
        };
      })(this));
    }

    LineWrapper.prototype.wordWidth = function(word) {
      return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
    };

    LineWrapper.prototype.eachWord = function(text, fn) {
      var bk, breaker, fbk, l, last, lbk, shouldContinue, w, word, wordWidths;
      breaker = new LineBreaker(text);
      last = null;
      wordWidths = Object.create(null);
      while (bk = breaker.nextBreak()) {
        word = text.slice((last != null ? last.position : void 0) || 0, bk.position);
        w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
        if (w > this.lineWidth + this.continuedX) {
          lbk = last;
          fbk = {};
          while (word.length) {
            l = word.length;
            while (w > this.spaceLeft) {
              w = this.wordWidth(word.slice(0, --l));
            }
            fbk.required = l < word.length;
            shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
            lbk = {
              required: false
            };
            word = word.slice(l);
            w = this.wordWidth(word);
            if (shouldContinue === false) {
              break;
            }
          }
        } else {
          shouldContinue = fn(word, w, bk, last);
        }
        if (shouldContinue === false) {
          break;
        }
        last = bk;
      }
    };

    LineWrapper.prototype.wrap = function(text, options) {
      var buffer, emitLine, lc, nextY, textWidth, wc, y;
      if (options.indent != null) {
        this.indent = options.indent;
      }
      if (options.characterSpacing != null) {
        this.characterSpacing = options.characterSpacing;
      }
      if (options.wordSpacing != null) {
        this.wordSpacing = options.wordSpacing;
      }
      if (options.ellipsis != null) {
        this.ellipsis = options.ellipsis;
      }
      nextY = this.document.y + this.document.currentLineHeight(true);
      if (this.document.y > this.maxY || nextY > this.maxY) {
        this.nextSection();
      }
      buffer = '';
      textWidth = 0;
      wc = 0;
      lc = 0;
      y = this.document.y;
      emitLine = (function(_this) {
        return function() {
          options.textWidth = textWidth + _this.wordSpacing * (wc - 1);
          options.wordCount = wc;
          options.lineWidth = _this.lineWidth;
          y = _this.document.y;
          _this.emit('line', buffer, options, _this);
          return lc++;
        };
      })(this);
      this.emit('sectionStart', options, this);
      this.eachWord(text, (function(_this) {
        return function(word, w, bk, last) {
          var lh, shouldContinue;
          if ((last == null) || last.required) {
            _this.emit('firstLine', options, _this);
            _this.spaceLeft = _this.lineWidth;
          }
          if (w <= _this.spaceLeft) {
            buffer += word;
            textWidth += w;
            wc++;
          }
          if (bk.required || w > _this.spaceLeft) {
            if (bk.required) {
              _this.emit('lastLine', options, _this);
            }
            lh = _this.document.currentLineHeight(true);
            if ((_this.height != null) && _this.ellipsis && _this.document.y + lh * 2 > _this.maxY && _this.column >= _this.columns) {
              if (_this.ellipsis === true) {
                _this.ellipsis = '…';
              }
              buffer = buffer.replace(/\s+$/, '');
              textWidth = _this.wordWidth(buffer + _this.ellipsis);
              while (textWidth > _this.lineWidth) {
                buffer = buffer.slice(0, -1).replace(/\s+$/, '');
                textWidth = _this.wordWidth(buffer + _this.ellipsis);
              }
              buffer = buffer + _this.ellipsis;
            }
            if (bk.required && w > _this.spaceLeft) {
              buffer = word;
              textWidth = w;
              wc = 1;
            }
            emitLine();
            if (_this.document.y + lh > _this.maxY) {
              shouldContinue = _this.nextSection();
              if (!shouldContinue) {
                wc = 0;
                buffer = '';
                return false;
              }
            }
            if (bk.required) {
              _this.spaceLeft = _this.lineWidth;
              buffer = '';
              textWidth = 0;
              return wc = 0;
            } else {
              _this.spaceLeft = _this.lineWidth - w;
              buffer = word;
              textWidth = w;
              return wc = 1;
            }
          } else {
            return _this.spaceLeft -= w;
          }
        };
      })(this));
      if (wc > 0) {
        this.emit('lastLine', options, this);
        emitLine();
      }
      this.emit('sectionEnd', options, this);
      if (options.continued === true) {
        if (lc > 1) {
          this.continuedX = 0;
        }
        this.continuedX += options.textWidth;
        return this.document.y = y;
      } else {
        return this.document.x = this.startX;
      }
    };

    LineWrapper.prototype.nextSection = function(options) {
      var ref;
      this.emit('sectionEnd', options, this);
      if (++this.column > this.columns) {
        if (this.height != null) {
          return false;
        }
        this.document.addPage();
        this.column = 1;
        this.startY = this.document.page.margins.top;
        this.maxY = this.document.page.maxY();
        this.document.x = this.startX;
        if (this.document._fillColor) {
          (ref = this.document).fillColor.apply(ref, this.document._fillColor);
        }
        this.emit('pageBreak', options, this);
      } else {
        this.document.x += this.lineWidth + this.columnGap;
        this.document.y = this.startY;
        this.emit('columnBreak', options, this);
      }
      this.emit('sectionStart', options, this);
      return true;
    };

    return LineWrapper;

  })(EventEmitter);

  module.exports = LineWrapper;

}).call(this);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

;(function (exports) {
	'use strict';

  var Arr = (typeof Uint8Array !== 'undefined')
    ? Uint8Array
    : Array

	var PLUS   = '+'.charCodeAt(0)
	var SLASH  = '/'.charCodeAt(0)
	var NUMBER = '0'.charCodeAt(0)
	var LOWER  = 'a'.charCodeAt(0)
	var UPPER  = 'A'.charCodeAt(0)
	var PLUS_URL_SAFE = '-'.charCodeAt(0)
	var SLASH_URL_SAFE = '_'.charCodeAt(0)

	function decode (elt) {
		var code = elt.charCodeAt(0)
		if (code === PLUS ||
		    code === PLUS_URL_SAFE)
			return 62 // '+'
		if (code === SLASH ||
		    code === SLASH_URL_SAFE)
			return 63 // '/'
		if (code < NUMBER)
			return -1 //no match
		if (code < NUMBER + 10)
			return code - NUMBER + 26 + 26
		if (code < UPPER + 26)
			return code - UPPER
		if (code < LOWER + 26)
			return code - LOWER + 26
	}

	function b64ToByteArray (b64) {
		var i, j, l, tmp, placeHolders, arr

		if (b64.length % 4 > 0) {
			throw new Error('Invalid string. Length must be a multiple of 4')
		}

		// the number of equal signs (place holders)
		// if there are two placeholders, than the two characters before it
		// represent one byte
		// if there is only one, then the three characters before it represent 2 bytes
		// this is just a cheap hack to not do indexOf twice
		var len = b64.length
		placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

		// base64 is 4/3 + up to two characters of the original data
		arr = new Arr(b64.length * 3 / 4 - placeHolders)

		// if there are placeholders, only get up to the last complete 4 chars
		l = placeHolders > 0 ? b64.length - 4 : b64.length

		var L = 0

		function push (v) {
			arr[L++] = v
		}

		for (i = 0, j = 0; i < l; i += 4, j += 3) {
			tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
			push((tmp & 0xFF0000) >> 16)
			push((tmp & 0xFF00) >> 8)
			push(tmp & 0xFF)
		}

		if (placeHolders === 2) {
			tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
			push(tmp & 0xFF)
		} else if (placeHolders === 1) {
			tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
			push((tmp >> 8) & 0xFF)
			push(tmp & 0xFF)
		}

		return arr
	}

	function uint8ToBase64 (uint8) {
		var i,
			extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
			output = "",
			temp, length

		function encode (num) {
			return lookup.charAt(num)
		}

		function tripletToBase64 (num) {
			return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
		}

		// go through the array every three bytes, we'll deal with trailing stuff later
		for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
			temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
			output += tripletToBase64(temp)
		}

		// pad the end with zeros, but make sure to not forget the extra bytes
		switch (extraBytes) {
			case 1:
				temp = uint8[uint8.length - 1]
				output += encode(temp >> 2)
				output += encode((temp << 4) & 0x3F)
				output += '=='
				break
			case 2:
				temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
				output += encode(temp >> 10)
				output += encode((temp >> 4) & 0x3F)
				output += encode((temp << 2) & 0x3F)
				output += '='
				break
		}

		return output
	}

	exports.toByteArray = b64ToByteArray
	exports.fromByteArray = uint8ToBase64
}( false ? (this.base64js = {}) : exports))


/***/ }),
/* 287 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var AI, AL, B2, BA, BB, BK, CB, CJ, CL, CM, CP, CR, EX, GL, H2, H3, HL, HY, ID, IN, IS, JL, JT, JV, LF, NL, NS, NU, OP, PO, PR, QU, RI, SA, SG, SP, SY, WJ, XX, ZW;

  exports.OP = OP = 0;

  exports.CL = CL = 1;

  exports.CP = CP = 2;

  exports.QU = QU = 3;

  exports.GL = GL = 4;

  exports.NS = NS = 5;

  exports.EX = EX = 6;

  exports.SY = SY = 7;

  exports.IS = IS = 8;

  exports.PR = PR = 9;

  exports.PO = PO = 10;

  exports.NU = NU = 11;

  exports.AL = AL = 12;

  exports.HL = HL = 13;

  exports.ID = ID = 14;

  exports.IN = IN = 15;

  exports.HY = HY = 16;

  exports.BA = BA = 17;

  exports.BB = BB = 18;

  exports.B2 = B2 = 19;

  exports.ZW = ZW = 20;

  exports.CM = CM = 21;

  exports.WJ = WJ = 22;

  exports.H2 = H2 = 23;

  exports.H3 = H3 = 24;

  exports.JL = JL = 25;

  exports.JV = JV = 26;

  exports.JT = JT = 27;

  exports.RI = RI = 28;

  exports.AI = AI = 29;

  exports.BK = BK = 30;

  exports.CB = CB = 31;

  exports.CJ = CJ = 32;

  exports.CR = CR = 33;

  exports.LF = LF = 34;

  exports.NL = NL = 35;

  exports.SA = SA = 36;

  exports.SG = SG = 37;

  exports.SP = SP = 38;

  exports.XX = XX = 39;

}).call(this);


/***/ }),
/* 288 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.7.1
(function() {
  var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;

  exports.DI_BRK = DI_BRK = 0;

  exports.IN_BRK = IN_BRK = 1;

  exports.CI_BRK = CI_BRK = 2;

  exports.CP_BRK = CP_BRK = 3;

  exports.PR_BRK = PR_BRK = 4;

  exports.pairTable = [[PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, CP_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK]];

}).call(this);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var PDFImage;

  PDFImage = __webpack_require__(290);

  module.exports = {
    initImages: function() {
      this._imageRegistry = {};
      return this._imageCount = 0;
    },
    image: function(src, x, y, options) {
      var base, bh, bp, bw, h, hp, image, ip, name, ref, ref1, ref2, ref3, w, wp;
      if (options == null) {
        options = {};
      }
      if (typeof x === 'object') {
        options = x;
        x = null;
      }
      x = (ref = x != null ? x : options.x) != null ? ref : this.x;
      y = (ref1 = y != null ? y : options.y) != null ? ref1 : this.y;
      if (typeof src === 'string') {
        image = this._imageRegistry[src];
      }
      if (!image) {
        if (src.width && src.height) {
          image = src;
        } else {
          image = this.openImage(src);
        }
      }
      if (!image.obj) {
        image.embed(this);
      }
      if ((base = this.page.xobjects)[name = image.label] == null) {
        base[name] = image.obj;
      }
      w = options.width || image.width;
      h = options.height || image.height;
      if (options.width && !options.height) {
        wp = w / image.width;
        w = image.width * wp;
        h = image.height * wp;
      } else if (options.height && !options.width) {
        hp = h / image.height;
        w = image.width * hp;
        h = image.height * hp;
      } else if (options.scale) {
        w = image.width * options.scale;
        h = image.height * options.scale;
      } else if (options.fit) {
        ref2 = options.fit, bw = ref2[0], bh = ref2[1];
        bp = bw / bh;
        ip = image.width / image.height;
        if (ip > bp) {
          w = bw;
          h = bw / ip;
        } else {
          h = bh;
          w = bh * ip;
        }
      } else if (options.cover) {
        ref3 = options.cover, bw = ref3[0], bh = ref3[1];
        bp = bw / bh;
        ip = image.width / image.height;
        if (ip > bp) {
          h = bh;
          w = bh * ip;
        } else {
          w = bw;
          h = bw / ip;
        }
      }
      if (options.fit || options.cover) {
        if (options.align === 'center') {
          x = x + bw / 2 - w / 2;
        } else if (options.align === 'right') {
          x = x + bw - w;
        }
        if (options.valign === 'center') {
          y = y + bh / 2 - h / 2;
        } else if (options.valign === 'bottom') {
          y = y + bh - h;
        }
      }
      if (this.y === y) {
        this.y += h;
      }
      this.save();
      this.transform(w, 0, 0, -h, x, y + h);
      this.addContent("/" + image.label + " Do");
      this.restore();
      return this;
    },
    openImage: function(src) {
      var image;
      if (typeof src === 'string') {
        image = this._imageRegistry[src];
      }
      if (!image) {
        image = PDFImage.open(src, 'I' + (++this._imageCount));
        if (typeof src === 'string') {
          this._imageRegistry[src] = image;
        }
      }
      return image;
    }
  };

}).call(this);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

/*
PDFImage - embeds images in PDF documents
By Devon Govett
 */

(function() {
  var Data, JPEG, PDFImage, PNG, fs;

  fs = __webpack_require__(9);

  Data = __webpack_require__(291);

  JPEG = __webpack_require__(292);

  PNG = __webpack_require__(293);

  PDFImage = (function() {
    function PDFImage() {}

    PDFImage.open = function(src, label) {
      var data, match;
      if (Buffer.isBuffer(src)) {
        data = src;
      } else if (src instanceof ArrayBuffer) {
        data = new Buffer(new Uint8Array(src));
      } else {
        if (match = /^data:.+;base64,(.*)$/.exec(src)) {
          data = new Buffer(match[1], 'base64');
        } else {
          data = fs.readFileSync(src);
          if (!data) {
            return;
          }
        }
      }
      if (data[0] === 0xff && data[1] === 0xd8) {
        return new JPEG(data, label);
      } else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') {
        return new PNG(data, label);
      } else {
        throw new Error('Unknown image format.');
      }
    };

    return PDFImage;

  })();

  module.exports = PDFImage;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var Data;

  Data = (function() {
    function Data(data) {
      this.data = data != null ? data : [];
      this.pos = 0;
      this.length = this.data.length;
    }

    Data.prototype.readByte = function() {
      return this.data[this.pos++];
    };

    Data.prototype.writeByte = function(byte) {
      return this.data[this.pos++] = byte;
    };

    Data.prototype.byteAt = function(index) {
      return this.data[index];
    };

    Data.prototype.readBool = function() {
      return !!this.readByte();
    };

    Data.prototype.writeBool = function(val) {
      return this.writeByte(val ? 1 : 0);
    };

    Data.prototype.readUInt32 = function() {
      var b1, b2, b3, b4;
      b1 = this.readByte() * 0x1000000;
      b2 = this.readByte() << 16;
      b3 = this.readByte() << 8;
      b4 = this.readByte();
      return b1 + b2 + b3 + b4;
    };

    Data.prototype.writeUInt32 = function(val) {
      this.writeByte((val >>> 24) & 0xff);
      this.writeByte((val >> 16) & 0xff);
      this.writeByte((val >> 8) & 0xff);
      return this.writeByte(val & 0xff);
    };

    Data.prototype.readInt32 = function() {
      var int;
      int = this.readUInt32();
      if (int >= 0x80000000) {
        return int - 0x100000000;
      } else {
        return int;
      }
    };

    Data.prototype.writeInt32 = function(val) {
      if (val < 0) {
        val += 0x100000000;
      }
      return this.writeUInt32(val);
    };

    Data.prototype.readUInt16 = function() {
      var b1, b2;
      b1 = this.readByte() << 8;
      b2 = this.readByte();
      return b1 | b2;
    };

    Data.prototype.writeUInt16 = function(val) {
      this.writeByte((val >> 8) & 0xff);
      return this.writeByte(val & 0xff);
    };

    Data.prototype.readInt16 = function() {
      var int;
      int = this.readUInt16();
      if (int >= 0x8000) {
        return int - 0x10000;
      } else {
        return int;
      }
    };

    Data.prototype.writeInt16 = function(val) {
      if (val < 0) {
        val += 0x10000;
      }
      return this.writeUInt16(val);
    };

    Data.prototype.readString = function(length) {
      var i, j, ref, ret;
      ret = [];
      for (i = j = 0, ref = length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        ret[i] = String.fromCharCode(this.readByte());
      }
      return ret.join('');
    };

    Data.prototype.writeString = function(val) {
      var i, j, ref, results;
      results = [];
      for (i = j = 0, ref = val.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        results.push(this.writeByte(val.charCodeAt(i)));
      }
      return results;
    };

    Data.prototype.stringAt = function(pos, length) {
      this.pos = pos;
      return this.readString(length);
    };

    Data.prototype.readShort = function() {
      return this.readInt16();
    };

    Data.prototype.writeShort = function(val) {
      return this.writeInt16(val);
    };

    Data.prototype.readLongLong = function() {
      var b1, b2, b3, b4, b5, b6, b7, b8;
      b1 = this.readByte();
      b2 = this.readByte();
      b3 = this.readByte();
      b4 = this.readByte();
      b5 = this.readByte();
      b6 = this.readByte();
      b7 = this.readByte();
      b8 = this.readByte();
      if (b1 & 0x80) {
        return ((b1 ^ 0xff) * 0x100000000000000 + (b2 ^ 0xff) * 0x1000000000000 + (b3 ^ 0xff) * 0x10000000000 + (b4 ^ 0xff) * 0x100000000 + (b5 ^ 0xff) * 0x1000000 + (b6 ^ 0xff) * 0x10000 + (b7 ^ 0xff) * 0x100 + (b8 ^ 0xff) + 1) * -1;
      }
      return b1 * 0x100000000000000 + b2 * 0x1000000000000 + b3 * 0x10000000000 + b4 * 0x100000000 + b5 * 0x1000000 + b6 * 0x10000 + b7 * 0x100 + b8;
    };

    Data.prototype.writeLongLong = function(val) {
      var high, low;
      high = Math.floor(val / 0x100000000);
      low = val & 0xffffffff;
      this.writeByte((high >> 24) & 0xff);
      this.writeByte((high >> 16) & 0xff);
      this.writeByte((high >> 8) & 0xff);
      this.writeByte(high & 0xff);
      this.writeByte((low >> 24) & 0xff);
      this.writeByte((low >> 16) & 0xff);
      this.writeByte((low >> 8) & 0xff);
      return this.writeByte(low & 0xff);
    };

    Data.prototype.readInt = function() {
      return this.readInt32();
    };

    Data.prototype.writeInt = function(val) {
      return this.writeInt32(val);
    };

    Data.prototype.slice = function(start, end) {
      return this.data.slice(start, end);
    };

    Data.prototype.read = function(bytes) {
      var buf, i, j, ref;
      buf = [];
      for (i = j = 0, ref = bytes; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
        buf.push(this.readByte());
      }
      return buf;
    };

    Data.prototype.write = function(bytes) {
      var byte, j, len, results;
      results = [];
      for (j = 0, len = bytes.length; j < len; j++) {
        byte = bytes[j];
        results.push(this.writeByte(byte));
      }
      return results;
    };

    return Data;

  })();

  module.exports = Data;

}).call(this);


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var JPEG, fs,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  fs = __webpack_require__(9);

  JPEG = (function() {
    var MARKERS;

    MARKERS = [0xFFC0, 0xFFC1, 0xFFC2, 0xFFC3, 0xFFC5, 0xFFC6, 0xFFC7, 0xFFC8, 0xFFC9, 0xFFCA, 0xFFCB, 0xFFCC, 0xFFCD, 0xFFCE, 0xFFCF];

    function JPEG(data, label) {
      var channels, marker, pos;
      this.data = data;
      this.label = label;
      if (this.data.readUInt16BE(0) !== 0xFFD8) {
        throw "SOI not found in JPEG";
      }
      pos = 2;
      while (pos < this.data.length) {
        marker = this.data.readUInt16BE(pos);
        pos += 2;
        if (indexOf.call(MARKERS, marker) >= 0) {
          break;
        }
        pos += this.data.readUInt16BE(pos);
      }
      if (indexOf.call(MARKERS, marker) < 0) {
        throw "Invalid JPEG.";
      }
      pos += 2;
      this.bits = this.data[pos++];
      this.height = this.data.readUInt16BE(pos);
      pos += 2;
      this.width = this.data.readUInt16BE(pos);
      pos += 2;
      channels = this.data[pos++];
      this.colorSpace = (function() {
        switch (channels) {
          case 1:
            return 'DeviceGray';
          case 3:
            return 'DeviceRGB';
          case 4:
            return 'DeviceCMYK';
        }
      })();
      this.obj = null;
    }

    JPEG.prototype.embed = function(document) {
      if (this.obj) {
        return;
      }
      this.obj = document.ref({
        Type: 'XObject',
        Subtype: 'Image',
        BitsPerComponent: this.bits,
        Width: this.width,
        Height: this.height,
        ColorSpace: this.colorSpace,
        Filter: 'DCTDecode'
      });
      if (this.colorSpace === 'DeviceCMYK') {
        this.obj.data['Decode'] = [1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0];
      }
      this.obj.end(this.data);
      return this.data = null;
    };

    return JPEG;

  })();

  module.exports = JPEG;

}).call(this);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
(function() {
  var PNG, PNGImage, zlib;

  zlib = __webpack_require__(47);

  PNG = __webpack_require__(294);

  PNGImage = (function() {
    function PNGImage(data, label) {
      this.label = label;
      this.image = new PNG(data);
      this.width = this.image.width;
      this.height = this.image.height;
      this.imgData = this.image.imgData;
      this.obj = null;
    }

    PNGImage.prototype.embed = function(document) {
      var k, len1, mask, palette, params, rgb, val, x;
      this.document = document;
      if (this.obj) {
        return;
      }
      this.obj = this.document.ref({
        Type: 'XObject',
        Subtype: 'Image',
        BitsPerComponent: this.image.bits,
        Width: this.width,
        Height: this.height,
        Filter: 'FlateDecode'
      });
      if (!this.image.hasAlphaChannel) {
        params = this.document.ref({
          Predictor: 15,
          Colors: this.image.colors,
          BitsPerComponent: this.image.bits,
          Columns: this.width
        });
        this.obj.data['DecodeParms'] = params;
        params.end();
      }
      if (this.image.palette.length === 0) {
        this.obj.data['ColorSpace'] = this.image.colorSpace;
      } else {
        palette = this.document.ref();
        palette.end(new Buffer(this.image.palette));
        this.obj.data['ColorSpace'] = ['Indexed', 'DeviceRGB', (this.image.palette.length / 3) - 1, palette];
      }
      if (this.image.transparency.grayscale) {
        val = this.image.transparency.greyscale;
        return this.obj.data['Mask'] = [val, val];
      } else if (this.image.transparency.rgb) {
        rgb = this.image.transparency.rgb;
        mask = [];
        for (k = 0, len1 = rgb.length; k < len1; k++) {
          x = rgb[k];
          mask.push(x, x);
        }
        return this.obj.data['Mask'] = mask;
      } else if (this.image.transparency.indexed) {
        return this.loadIndexedAlphaChannel();
      } else if (this.image.hasAlphaChannel) {
        return this.splitAlphaChannel();
      } else {
        return this.finalize();
      }
    };

    PNGImage.prototype.finalize = function() {
      var sMask;
      if (this.alphaChannel) {
        sMask = this.document.ref({
          Type: 'XObject',
          Subtype: 'Image',
          Height: this.height,
          Width: this.width,
          BitsPerComponent: 8,
          Filter: 'FlateDecode',
          ColorSpace: 'DeviceGray',
          Decode: [0, 1]
        });
        sMask.end(this.alphaChannel);
        this.obj.data['SMask'] = sMask;
      }
      this.obj.end(this.imgData);
      this.image = null;
      return this.imgData = null;
    };

    PNGImage.prototype.splitAlphaChannel = function() {
      return this.image.decodePixels((function(_this) {
        return function(pixels) {
          var a, alphaChannel, colorByteSize, done, i, imgData, len, p, pixelCount;
          colorByteSize = _this.image.colors * _this.image.bits / 8;
          pixelCount = _this.width * _this.height;
          imgData = new Buffer(pixelCount * colorByteSize);
          alphaChannel = new Buffer(pixelCount);
          i = p = a = 0;
          len = pixels.length;
          while (i < len) {
            imgData[p++] = pixels[i++];
            imgData[p++] = pixels[i++];
            imgData[p++] = pixels[i++];
            alphaChannel[a++] = pixels[i++];
          }
          done = 0;
          zlib.deflate(imgData, function(err, imgData1) {
            _this.imgData = imgData1;
            if (err) {
              throw err;
            }
            if (++done === 2) {
              return _this.finalize();
            }
          });
          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
            _this.alphaChannel = alphaChannel1;
            if (err) {
              throw err;
            }
            if (++done === 2) {
              return _this.finalize();
            }
          });
        };
      })(this));
    };

    PNGImage.prototype.loadIndexedAlphaChannel = function(fn) {
      var transparency;
      transparency = this.image.transparency.indexed;
      return this.image.decodePixels((function(_this) {
        return function(pixels) {
          var alphaChannel, i, j, k, ref;
          alphaChannel = new Buffer(_this.width * _this.height);
          i = 0;
          for (j = k = 0, ref = pixels.length; k < ref; j = k += 1) {
            alphaChannel[i++] = transparency[pixels[j]];
          }
          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
            _this.alphaChannel = alphaChannel1;
            if (err) {
              throw err;
            }
            return _this.finalize();
          });
        };
      })(this));
    };

    return PNGImage;

  })();

  module.exports = PNGImage;

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.4.0

/*
# MIT LICENSE
# Copyright (c) 2011 Devon Govett
# 
# Permission is hereby granted, free of charge, to any person obtaining a copy of this 
# software and associated documentation files (the "Software"), to deal in the Software 
# without restriction, including without limitation the rights to use, copy, modify, merge, 
# publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons 
# to whom the Software is furnished to do so, subject to the following conditions:
# 
# The above copyright notice and this permission notice shall be included in all copies or 
# substantial portions of the Software.
# 
# THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING 
# BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
# NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, 
# DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
# OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


(function() {
  var PNG, fs, zlib;

  fs = __webpack_require__(9);

  zlib = __webpack_require__(47);

  module.exports = PNG = (function() {

    PNG.decode = function(path, fn) {
      return fs.readFile(path, function(err, file) {
        var png;
        png = new PNG(file);
        return png.decode(function(pixels) {
          return fn(pixels);
        });
      });
    };

    PNG.load = function(path) {
      var file;
      file = fs.readFileSync(path);
      return new PNG(file);
    };

    function PNG(data) {
      var chunkSize, colors, i, index, key, section, short, text, _i, _j, _ref;
      this.data = data;
      this.pos = 8;
      this.palette = [];
      this.imgData = [];
      this.transparency = {};
      this.text = {};
      while (true) {
        chunkSize = this.readUInt32();
        section = ((function() {
          var _i, _results;
          _results = [];
          for (i = _i = 0; _i < 4; i = ++_i) {
            _results.push(String.fromCharCode(this.data[this.pos++]));
          }
          return _results;
        }).call(this)).join('');
        switch (section) {
          case 'IHDR':
            this.width = this.readUInt32();
            this.height = this.readUInt32();
            this.bits = this.data[this.pos++];
            this.colorType = this.data[this.pos++];
            this.compressionMethod = this.data[this.pos++];
            this.filterMethod = this.data[this.pos++];
            this.interlaceMethod = this.data[this.pos++];
            break;
          case 'PLTE':
            this.palette = this.read(chunkSize);
            break;
          case 'IDAT':
            for (i = _i = 0; _i < chunkSize; i = _i += 1) {
              this.imgData.push(this.data[this.pos++]);
            }
            break;
          case 'tRNS':
            this.transparency = {};
            switch (this.colorType) {
              case 3:
                this.transparency.indexed = this.read(chunkSize);
                short = 255 - this.transparency.indexed.length;
                if (short > 0) {
                  for (i = _j = 0; 0 <= short ? _j < short : _j > short; i = 0 <= short ? ++_j : --_j) {
                    this.transparency.indexed.push(255);
                  }
                }
                break;
              case 0:
                this.transparency.grayscale = this.read(chunkSize)[0];
                break;
              case 2:
                this.transparency.rgb = this.read(chunkSize);
            }
            break;
          case 'tEXt':
            text = this.read(chunkSize);
            index = text.indexOf(0);
            key = String.fromCharCode.apply(String, text.slice(0, index));
            this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
            break;
          case 'IEND':
            this.colors = (function() {
              switch (this.colorType) {
                case 0:
                case 3:
                case 4:
                  return 1;
                case 2:
                case 6:
                  return 3;
              }
            }).call(this);
            this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;
            colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
            this.pixelBitlength = this.bits * colors;
            this.colorSpace = (function() {
              switch (this.colors) {
                case 1:
                  return 'DeviceGray';
                case 3:
                  return 'DeviceRGB';
              }
            }).call(this);
            this.imgData = new Buffer(this.imgData);
            return;
          default:
            this.pos += chunkSize;
        }
        this.pos += 4;
        if (this.pos > this.data.length) {
          throw new Error("Incomplete or corrupt PNG file");
        }
      }
      return;
    }

    PNG.prototype.read = function(bytes) {
      var i, _i, _results;
      _results = [];
      for (i = _i = 0; 0 <= bytes ? _i < bytes : _i > bytes; i = 0 <= bytes ? ++_i : --_i) {
        _results.push(this.data[this.pos++]);
      }
      return _results;
    };

    PNG.prototype.readUInt32 = function() {
      var b1, b2, b3, b4;
      b1 = this.data[this.pos++] << 24;
      b2 = this.data[this.pos++] << 16;
      b3 = this.data[this.pos++] << 8;
      b4 = this.data[this.pos++];
      return b1 | b2 | b3 | b4;
    };

    PNG.prototype.readUInt16 = function() {
      var b1, b2;
      b1 = this.data[this.pos++] << 8;
      b2 = this.data[this.pos++];
      return b1 | b2;
    };

    PNG.prototype.decodePixels = function(fn) {
      var _this = this;
      return zlib.inflate(this.imgData, function(err, data) {
        var byte, c, col, i, left, length, p, pa, paeth, pb, pc, pixelBytes, pixels, pos, row, scanlineLength, upper, upperLeft, _i, _j, _k, _l, _m;
        if (err) {
          throw err;
        }
        pixelBytes = _this.pixelBitlength / 8;
        scanlineLength = pixelBytes * _this.width;
        pixels = new Buffer(scanlineLength * _this.height);
        length = data.length;
        row = 0;
        pos = 0;
        c = 0;
        while (pos < length) {
          switch (data[pos++]) {
            case 0:
              for (i = _i = 0; _i < scanlineLength; i = _i += 1) {
                pixels[c++] = data[pos++];
              }
              break;
            case 1:
              for (i = _j = 0; _j < scanlineLength; i = _j += 1) {
                byte = data[pos++];
                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                pixels[c++] = (byte + left) % 256;
              }
              break;
            case 2:
              for (i = _k = 0; _k < scanlineLength; i = _k += 1) {
                byte = data[pos++];
                col = (i - (i % pixelBytes)) / pixelBytes;
                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
                pixels[c++] = (upper + byte) % 256;
              }
              break;
            case 3:
              for (i = _l = 0; _l < scanlineLength; i = _l += 1) {
                byte = data[pos++];
                col = (i - (i % pixelBytes)) / pixelBytes;
                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
                pixels[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
              }
              break;
            case 4:
              for (i = _m = 0; _m < scanlineLength; i = _m += 1) {
                byte = data[pos++];
                col = (i - (i % pixelBytes)) / pixelBytes;
                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                if (row === 0) {
                  upper = upperLeft = 0;
                } else {
                  upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
                  upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + (i % pixelBytes)];
                }
                p = left + upper - upperLeft;
                pa = Math.abs(p - left);
                pb = Math.abs(p - upper);
                pc = Math.abs(p - upperLeft);
                if (pa <= pb && pa <= pc) {
                  paeth = left;
                } else if (pb <= pc) {
                  paeth = upper;
                } else {
                  paeth = upperLeft;
                }
                pixels[c++] = (byte + paeth) % 256;
              }
              break;
            default:
              throw new Error("Invalid filter algorithm: " + data[pos - 1]);
          }
          row++;
        }
        return fn(pixels);
      });
    };

    PNG.prototype.decodePalette = function() {
      var c, i, length, palette, pos, ret, transparency, _i, _ref, _ref1;
      palette = this.palette;
      transparency = this.transparency.indexed || [];
      ret = new Buffer(transparency.length + palette.length);
      pos = 0;
      length = palette.length;
      c = 0;
      for (i = _i = 0, _ref = palette.length; _i < _ref; i = _i += 3) {
        ret[pos++] = palette[i];
        ret[pos++] = palette[i + 1];
        ret[pos++] = palette[i + 2];
        ret[pos++] = (_ref1 = transparency[c++]) != null ? _ref1 : 255;
      }
      return ret;
    };

    PNG.prototype.copyToImageData = function(imageData, pixels) {
      var alpha, colors, data, i, input, j, k, length, palette, v, _ref;
      colors = this.colors;
      palette = null;
      alpha = this.hasAlphaChannel;
      if (this.palette.length) {
        palette = (_ref = this._decodedPalette) != null ? _ref : this._decodedPalette = this.decodePalette();
        colors = 4;
        alpha = true;
      }
      data = (imageData != null ? imageData.data : void 0) || imageData;
      length = data.length;
      input = palette || pixels;
      i = j = 0;
      if (colors === 1) {
        while (i < length) {
          k = palette ? pixels[i / 4] * 4 : j;
          v = input[k++];
          data[i++] = v;
          data[i++] = v;
          data[i++] = v;
          data[i++] = alpha ? input[k++] : 255;
          j = k;
        }
      } else {
        while (i < length) {
          k = palette ? pixels[i / 4] * 4 : j;
          data[i++] = input[k++];
          data[i++] = input[k++];
          data[i++] = input[k++];
          data[i++] = alpha ? input[k++] : 255;
          j = k;
        }
      }
    };

    PNG.prototype.decode = function(fn) {
      var ret,
        _this = this;
      ret = new Buffer(this.width * this.height * 4);
      return this.decodePixels(function(pixels) {
        _this.copyToImageData(ret, pixels);
        return fn(ret);
      });
    };

    return PNG;

  })();

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  module.exports = {
    annotate: function(x, y, w, h, options) {
      var key, ref, val;
      options.Type = 'Annot';
      options.Rect = this._convertRect(x, y, w, h);
      options.Border = [0, 0, 0];
      if (options.Subtype !== 'Link') {
        if (options.C == null) {
          options.C = this._normalizeColor(options.color || [0, 0, 0]);
        }
      }
      delete options.color;
      if (typeof options.Dest === 'string') {
        options.Dest = new String(options.Dest);
      }
      for (key in options) {
        val = options[key];
        options[key[0].toUpperCase() + key.slice(1)] = val;
      }
      ref = this.ref(options);
      this.page.annotations.push(ref);
      ref.end();
      return this;
    },
    note: function(x, y, w, h, contents, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Text';
      options.Contents = new String(contents);
      options.Name = 'Comment';
      if (options.color == null) {
        options.color = [243, 223, 92];
      }
      return this.annotate(x, y, w, h, options);
    },
    link: function(x, y, w, h, url, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Link';
      options.A = this.ref({
        S: 'URI',
        URI: new String(url)
      });
      options.A.end();
      return this.annotate(x, y, w, h, options);
    },
    _markup: function(x, y, w, h, options) {
      var ref1, x1, x2, y1, y2;
      if (options == null) {
        options = {};
      }
      ref1 = this._convertRect(x, y, w, h), x1 = ref1[0], y1 = ref1[1], x2 = ref1[2], y2 = ref1[3];
      options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
      options.Contents = new String;
      return this.annotate(x, y, w, h, options);
    },
    highlight: function(x, y, w, h, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Highlight';
      if (options.color == null) {
        options.color = [241, 238, 148];
      }
      return this._markup(x, y, w, h, options);
    },
    underline: function(x, y, w, h, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Underline';
      return this._markup(x, y, w, h, options);
    },
    strike: function(x, y, w, h, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'StrikeOut';
      return this._markup(x, y, w, h, options);
    },
    lineAnnotation: function(x1, y1, x2, y2, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Line';
      options.Contents = new String;
      options.L = [x1, this.page.height - y1, x2, this.page.height - y2];
      return this.annotate(x1, y1, x2, y2, options);
    },
    rectAnnotation: function(x, y, w, h, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Square';
      options.Contents = new String;
      return this.annotate(x, y, w, h, options);
    },
    ellipseAnnotation: function(x, y, w, h, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'Circle';
      options.Contents = new String;
      return this.annotate(x, y, w, h, options);
    },
    textAnnotation: function(x, y, w, h, text, options) {
      if (options == null) {
        options = {};
      }
      options.Subtype = 'FreeText';
      options.Contents = new String(text);
      options.DA = new String;
      return this.annotate(x, y, w, h, options);
    },
    _convertRect: function(x1, y1, w, h) {
      var m0, m1, m2, m3, m4, m5, ref1, x2, y2;
      y2 = y1;
      y1 += h;
      x2 = x1 + w;
      ref1 = this._ctm, m0 = ref1[0], m1 = ref1[1], m2 = ref1[2], m3 = ref1[3], m4 = ref1[4], m5 = ref1[5];
      x1 = m0 * x1 + m2 * y1 + m4;
      y1 = m1 * x1 + m3 * y1 + m5;
      x2 = m0 * x2 + m2 * y2 + m4;
      y2 = m1 * x2 + m3 * y2 + m5;
      return [x1, y1, x2, y2];
    }
  };

}).call(this);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(0).isArray;

function typeName(bold, italics) {
	var type = 'normal';
	if (bold && italics) {
		type = 'bolditalics';
	} else if (bold) {
		type = 'bold';
	} else if (italics) {
		type = 'italics';
	}
	return type;
}

function FontProvider(fontDescriptors, pdfKitDoc) {
	this.fonts = {};
	this.pdfKitDoc = pdfKitDoc;
	this.fontCache = {};

	for (var font in fontDescriptors) {
		if (fontDescriptors.hasOwnProperty(font)) {
			var fontDef = fontDescriptors[font];

			this.fonts[font] = {
				normal: fontDef.normal,
				bold: fontDef.bold,
				italics: fontDef.italics,
				bolditalics: fontDef.bolditalics
			};
		}
	}
}

FontProvider.prototype.provideFont = function (familyName, bold, italics) {
	var type = typeName(bold, italics);
	if (!this.fonts[familyName] || !this.fonts[familyName][type]) {
		throw new Error('Font \'' + familyName + '\' in style \'' + type + '\' is not defined in the font section of the document definition.');
	}

	this.fontCache[familyName] = this.fontCache[familyName] || {};

	if (!this.fontCache[familyName][type]) {
		var def = this.fonts[familyName][type];
		if (!isArray(def)) {
			def = [def];
		}
		this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
	}

	return this.fontCache[familyName][type];
};

module.exports = FontProvider;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TraversalTracker = __webpack_require__(118);
var DocPreprocessor = __webpack_require__(298);
var DocMeasure = __webpack_require__(299);
var DocumentContext = __webpack_require__(120);
var PageElementWriter = __webpack_require__(301);
var ColumnCalculator = __webpack_require__(76);
var TableProcessor = __webpack_require__(303);
var Line = __webpack_require__(121);
var isString = __webpack_require__(0).isString;
var isArray = __webpack_require__(0).isArray;
var pack = __webpack_require__(0).pack;
var offsetVector = __webpack_require__(0).offsetVector;
var fontStringify = __webpack_require__(0).fontStringify;
var isFunction = __webpack_require__(0).isFunction;
var TextTools = __webpack_require__(75);
var StyleContextStack = __webpack_require__(119);

function addAll(target, otherArray) {
	otherArray.forEach(function (item) {
		target.push(item);
	});
}

/**
 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
 *
 * @param {Object} pageSize - an object defining page width and height
 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
 */
function LayoutBuilder(pageSize, pageMargins, imageMeasure) {
	this.pageSize = pageSize;
	this.pageMargins = pageMargins;
	this.tracker = new TraversalTracker();
	this.imageMeasure = imageMeasure;
	this.tableLayouts = {};
}

LayoutBuilder.prototype.registerTableLayouts = function (tableLayouts) {
	this.tableLayouts = pack(this.tableLayouts, tableLayouts);
};

/**
 * Executes layout engine on document-definition-object and creates an array of pages
 * containing positioned Blocks, Lines and inlines
 *
 * @param {Object} docStructure document-definition-object
 * @param {Object} fontProvider font provider
 * @param {Object} styleDictionary dictionary with style definitions
 * @param {Object} defaultStyle default style definition
 * @return {Array} an array of pages
 */
LayoutBuilder.prototype.layoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {

	function addPageBreaksIfNecessary(linearNodeList, pages) {

		if (!isFunction(pageBreakBeforeFct)) {
			return false;
		}

		linearNodeList = linearNodeList.filter(function (node) {
			return node.positions.length > 0;
		});

		linearNodeList.forEach(function (node) {
			var nodeInfo = {};
			[
				'id', 'text', 'ul', 'ol', 'table', 'image', 'qr', 'canvas', 'columns',
				'headlineLevel', 'style', 'pageBreak', 'pageOrientation',
				'width', 'height'
			].forEach(function (key) {
				if (node[key] !== undefined) {
					nodeInfo[key] = node[key];
				}
			});
			nodeInfo.startPosition = node.positions[0];
			nodeInfo.pageNumbers = node.positions.map(function (node) {
				return node.pageNumber;
			}).filter(function (element, position, array) {
				return array.indexOf(element) === position;
			});
			nodeInfo.pages = pages.length;
			nodeInfo.stack = isArray(node.stack);

			node.nodeInfo = nodeInfo;
		});

		return linearNodeList.some(function (node, index, followingNodeList) {
			if (node.pageBreak !== 'before' && !node.pageBreakCalculated) {
				node.pageBreakCalculated = true;
				var pageNumber = node.nodeInfo.pageNumbers[0];

				var followingNodesOnPage = followingNodeList.slice(index + 1).filter(function (node0) {
					return node0.nodeInfo.pageNumbers.indexOf(pageNumber) > -1;
				});

				var nodesOnNextPage = followingNodeList.slice(index + 1).filter(function (node0) {
					return node0.nodeInfo.pageNumbers.indexOf(pageNumber + 1) > -1;
				});

				var previousNodesOnPage = followingNodeList.slice(0, index).filter(function (node0) {
					return node0.nodeInfo.pageNumbers.indexOf(pageNumber) > -1;
				});

				if (
					pageBreakBeforeFct(
						node.nodeInfo,
						followingNodesOnPage.map(function (node) {
							return node.nodeInfo;
						}),
						nodesOnNextPage.map(function (node) {
							return node.nodeInfo;
						}),
						previousNodesOnPage.map(function (node) {
							return node.nodeInfo;
						}))) {
					node.pageBreak = 'before';
					return true;
				}
			}
		});
	}

	this.docPreprocessor = new DocPreprocessor();
	this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.tableLayouts, images);


	function resetXYs(result) {
		result.linearNodeList.forEach(function (node) {
			node.resetXY();
		});
	}

	var result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
	while (addPageBreaksIfNecessary(result.linearNodeList, result.pages)) {
		resetXYs(result);
		result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
	}

	return result.pages;
};

LayoutBuilder.prototype.tryLayoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {

	this.linearNodeList = [];
	docStructure = this.docPreprocessor.preprocessDocument(docStructure);
	docStructure = this.docMeasure.measureDocument(docStructure);

	this.writer = new PageElementWriter(
		new DocumentContext(this.pageSize, this.pageMargins), this.tracker);

	var _this = this;
	this.writer.context().tracker.startTracking('pageAdded', function () {
		_this.addBackground(background);
	});

	this.addBackground(background);
	this.processNode(docStructure);
	this.addHeadersAndFooters(header, footer);
	if (watermark != null) {
		this.addWatermark(watermark, fontProvider, defaultStyle);
	}

	return {pages: this.writer.context().pages, linearNodeList: this.linearNodeList};
};


LayoutBuilder.prototype.addBackground = function (background) {
	var backgroundGetter = isFunction(background) ? background : function () {
		return background;
	};

	var context = this.writer.context();
	var pageSize = context.getCurrentPage().pageSize;

	var pageBackground = backgroundGetter(context.page + 1, pageSize);

	if (pageBackground) {
		this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
		pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
		this.processNode(this.docMeasure.measureDocument(pageBackground));
		this.writer.commitUnbreakableBlock(0, 0);
		context.backgroundLength[context.page] += pageBackground.positions.length;
	}
};

LayoutBuilder.prototype.addStaticRepeatable = function (headerOrFooter, sizeFunction) {
	this.addDynamicRepeatable(function () {
		return JSON.parse(JSON.stringify(headerOrFooter)); // copy to new object
	}, sizeFunction);
};

LayoutBuilder.prototype.addDynamicRepeatable = function (nodeGetter, sizeFunction) {
	var pages = this.writer.context().pages;

	for (var pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++) {
		this.writer.context().page = pageIndex;

		var node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);

		if (node) {
			var sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
			this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
			node = this.docPreprocessor.preprocessDocument(node);
			this.processNode(this.docMeasure.measureDocument(node));
			this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
		}
	}
};

LayoutBuilder.prototype.addHeadersAndFooters = function (header, footer) {
	var headerSizeFct = function (pageSize, pageMargins) {
		return {
			x: 0,
			y: 0,
			width: pageSize.width,
			height: pageMargins.top
		};
	};

	var footerSizeFct = function (pageSize, pageMargins) {
		return {
			x: 0,
			y: pageSize.height - pageMargins.bottom,
			width: pageSize.width,
			height: pageMargins.bottom
		};
	};

	if (isFunction(header)) {
		this.addDynamicRepeatable(header, headerSizeFct);
	} else if (header) {
		this.addStaticRepeatable(header, headerSizeFct);
	}

	if (isFunction(footer)) {
		this.addDynamicRepeatable(footer, footerSizeFct);
	} else if (footer) {
		this.addStaticRepeatable(footer, footerSizeFct);
	}
};

LayoutBuilder.prototype.addWatermark = function (watermark, fontProvider, defaultStyle) {
	if (isString(watermark)) {
		watermark = {'text': watermark};
	}

	if (!watermark.text) { // empty watermark text
		return;
	}

	watermark.font = watermark.font || defaultStyle.font || 'Roboto';
	watermark.color = watermark.color || 'black';
	watermark.opacity = watermark.opacity || 0.6;
	watermark.bold = watermark.bold || false;
	watermark.italics = watermark.italics || false;

	var watermarkObject = {
		text: watermark.text,
		font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
		size: getSize(this.pageSize, watermark, fontProvider),
		color: watermark.color,
		opacity: watermark.opacity
	};

	var pages = this.writer.context().pages;
	for (var i = 0, l = pages.length; i < l; i++) {
		pages[i].watermark = watermarkObject;
	}

	function getSize(pageSize, watermark, fontProvider) {
		var width = pageSize.width;
		var height = pageSize.height;
		var targetWidth = Math.sqrt(width * width + height * height) * 0.8; /* page diagonal * sample factor */
		var textTools = new TextTools(fontProvider);
		var styleContextStack = new StyleContextStack(null, {font: watermark.font, bold: watermark.bold, italics: watermark.italics});
		var size;

		/**
		 * Binary search the best font size.
		 * Initial bounds [0, 1000]
		 * Break when range < 1
		 */
		var a = 0;
		var b = 1000;
		var c = (a + b) / 2;
		while (Math.abs(a - b) > 1) {
			styleContextStack.push({
				fontSize: c
			});
			size = textTools.sizeOfString(watermark.text, styleContextStack);
			if (size.width > targetWidth) {
				b = c;
				c = (a + b) / 2;
			} else if (size.width < targetWidth) {
				a = c;
				c = (a + b) / 2;
			}
			styleContextStack.pop();
		}
		/*
		 End binary search
		 */
		return {size: size, fontSize: c};
	}
};

function decorateNode(node) {
	var x = node.x, y = node.y;
	node.positions = [];

	if (isArray(node.canvas)) {
		node.canvas.forEach(function (vector) {
			var x = vector.x, y = vector.y, x1 = vector.x1, y1 = vector.y1, x2 = vector.x2, y2 = vector.y2;
			vector.resetXY = function () {
				vector.x = x;
				vector.y = y;
				vector.x1 = x1;
				vector.y1 = y1;
				vector.x2 = x2;
				vector.y2 = y2;
			};
		});
	}

	node.resetXY = function () {
		node.x = x;
		node.y = y;
		if (isArray(node.canvas)) {
			node.canvas.forEach(function (vector) {
				vector.resetXY();
			});
		}
	};
}

LayoutBuilder.prototype.processNode = function (node) {
	var self = this;

	this.linearNodeList.push(node);
	decorateNode(node);

	applyMargins(function () {
		var unbreakable = node.unbreakable;
		if (unbreakable) {
			self.writer.beginUnbreakableBlock();
		}

		var absPosition = node.absolutePosition;
		if (absPosition) {
			self.writer.context().beginDetachedBlock();
			self.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
		}

		var relPosition = node.relativePosition;
		if (relPosition) {
			self.writer.context().beginDetachedBlock();
			self.writer.context().moveTo((relPosition.x || 0) + self.writer.context().x, (relPosition.y || 0) + self.writer.context().y);
		}

		if (node.stack) {
			self.processVerticalContainer(node);
		} else if (node.columns) {
			self.processColumns(node);
		} else if (node.ul) {
			self.processList(false, node);
		} else if (node.ol) {
			self.processList(true, node);
		} else if (node.table) {
			self.processTable(node);
		} else if (node.text !== undefined) {
			self.processLeaf(node);
		} else if (node.toc) {
			self.processToc(node);
		} else if (node.image) {
			self.processImage(node);
		} else if (node.canvas) {
			self.processCanvas(node);
		} else if (node.qr) {
			self.processQr(node);
		} else if (!node._span) {
			throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
		}

		if (absPosition || relPosition) {
			self.writer.context().endDetachedBlock();
		}

		if (unbreakable) {
			self.writer.commitUnbreakableBlock();
		}
	});

	function applyMargins(callback) {
		var margin = node._margin;

		if (node.pageBreak === 'before') {
			self.writer.moveToNextPage(node.pageOrientation);
		}

		if (margin) {
			self.writer.context().moveDown(margin[1]);
			self.writer.context().addMargin(margin[0], margin[2]);
		}

		callback();

		if (margin) {
			self.writer.context().addMargin(-margin[0], -margin[2]);
			self.writer.context().moveDown(margin[3]);
		}

		if (node.pageBreak === 'after') {
			self.writer.moveToNextPage(node.pageOrientation);
		}
	}
};

// vertical container
LayoutBuilder.prototype.processVerticalContainer = function (node) {
	var self = this;
	node.stack.forEach(function (item) {
		self.processNode(item);
		addAll(node.positions, item.positions);

		//TODO: paragraph gap
	});
};

// columns
LayoutBuilder.prototype.processColumns = function (columnNode) {
	var columns = columnNode.columns;
	var availableWidth = this.writer.context().availableWidth;
	var gaps = gapArray(columnNode._gap);

	if (gaps) {
		availableWidth -= (gaps.length - 1) * columnNode._gap;
	}

	ColumnCalculator.buildColumnWidths(columns, availableWidth);
	var result = this.processRow(columns, columns, gaps);
	addAll(columnNode.positions, result.positions);


	function gapArray(gap) {
		if (!gap) {
			return null;
		}

		var gaps = [];
		gaps.push(0);

		for (var i = columns.length - 1; i > 0; i--) {
			gaps.push(gap);
		}

		return gaps;
	}
};

LayoutBuilder.prototype.processRow = function (columns, widths, gaps, tableBody, tableRow, height) {
	var self = this;
	var pageBreaks = [], positions = [];

	this.tracker.auto('pageChanged', storePageBreakData, function () {
		widths = widths || columns;

		self.writer.context().beginColumnGroup();

		for (var i = 0, l = columns.length; i < l; i++) {
			var column = columns[i];
			var width = widths[i]._calcWidth;
			var leftOffset = colLeftOffset(i);

			if (column.colSpan && column.colSpan > 1) {
				for (var j = 1; j < column.colSpan; j++) {
					width += widths[++i]._calcWidth + gaps[i];
				}
			}

			self.writer.context().beginColumn(width, leftOffset, getEndingCell(column, i));
			if (!column._span) {
				self.processNode(column);
				addAll(positions, column.positions);
			} else if (column._columnEndingContext) {
				// row-span ending
				self.writer.context().markEnding(column);
			}
		}

		self.writer.context().completeColumnGroup(height);
	});

	return {pageBreaks: pageBreaks, positions: positions};

	function storePageBreakData(data) {
		var pageDesc;

		for (var i = 0, l = pageBreaks.length; i < l; i++) {
			var desc = pageBreaks[i];
			if (desc.prevPage === data.prevPage) {
				pageDesc = desc;
				break;
			}
		}

		if (!pageDesc) {
			pageDesc = data;
			pageBreaks.push(pageDesc);
		}
		pageDesc.prevY = Math.max(pageDesc.prevY, data.prevY);
		pageDesc.y = Math.min(pageDesc.y, data.y);
	}

	function colLeftOffset(i) {
		if (gaps && gaps.length > i) {
			return gaps[i];
		}
		return 0;
	}

	function getEndingCell(column, columnIndex) {
		if (column.rowSpan && column.rowSpan > 1) {
			var endingRow = tableRow + column.rowSpan - 1;
			if (endingRow >= tableBody.length) {
				throw 'Row span for column ' + columnIndex + ' (with indexes starting from 0) exceeded row count';
			}
			return tableBody[endingRow][columnIndex];
		}

		return null;
	}
};

// lists
LayoutBuilder.prototype.processList = function (orderedList, node) {
	var self = this,
		items = orderedList ? node.ol : node.ul,
		gapSize = node._gapSize;

	this.writer.context().addMargin(gapSize.width);

	var nextMarker;
	this.tracker.auto('lineAdded', addMarkerToFirstLeaf, function () {
		items.forEach(function (item) {
			nextMarker = item.listMarker;
			self.processNode(item);
			addAll(node.positions, item.positions);
		});
	});

	this.writer.context().addMargin(-gapSize.width);

	function addMarkerToFirstLeaf(line) {
		// I'm not very happy with the way list processing is implemented
		// (both code and algorithm should be rethinked)
		if (nextMarker) {
			var marker = nextMarker;
			nextMarker = null;

			if (marker.canvas) {
				var vector = marker.canvas[0];

				offsetVector(vector, -marker._minWidth, 0);
				self.writer.addVector(vector);
			} else if (marker._inlines) {
				var markerLine = new Line(self.pageSize.width);
				markerLine.addInline(marker._inlines[0]);
				markerLine.x = -marker._minWidth;
				markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
				self.writer.addLine(markerLine, true);
			}
		}
	}
};

// tables
LayoutBuilder.prototype.processTable = function (tableNode) {
	var processor = new TableProcessor(tableNode);

	processor.beginTable(this.writer);

	var rowHeights = tableNode.table.heights;
	for (var i = 0, l = tableNode.table.body.length; i < l; i++) {
		processor.beginRow(i, this.writer);

		var height;
		if (isFunction(rowHeights)) {
			height = rowHeights(i);
		} else if (isArray(rowHeights)) {
			height = rowHeights[i];
		} else {
			height = rowHeights;
		}

		if (height === 'auto') {
			height = undefined;
		}

		var result = this.processRow(tableNode.table.body[i], tableNode.table.widths, tableNode._offsets.offsets, tableNode.table.body, i, height);
		addAll(tableNode.positions, result.positions);

		processor.endRow(i, this.writer, result.pageBreaks);
	}

	processor.endTable(this.writer);
};

// leafs (texts)
LayoutBuilder.prototype.processLeaf = function (node) {
	var line = this.buildNextLine(node);
	var currentHeight = (line) ? line.getHeight() : 0;
	var maxHeight = node.maxHeight || -1;

	if (node._tocItemRef) {
		line._pageNodeRef = node._tocItemRef;
	}

	if (node._pageRef) {
		line._pageNodeRef = node._pageRef._nodeRef;
	}

	if (line && line.inlines && isArray(line.inlines)) {
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			if (line.inlines[i]._tocItemRef) {
				line.inlines[i]._pageNodeRef = line.inlines[i]._tocItemRef;
			}

			if (line.inlines[i]._pageRef) {
				line.inlines[i]._pageNodeRef = line.inlines[i]._pageRef._nodeRef;
			}
		}
	}

	while (line && (maxHeight === -1 || currentHeight < maxHeight)) {
		var positions = this.writer.addLine(line);
		node.positions.push(positions);
		line = this.buildNextLine(node);
		if (line) {
			currentHeight += line.getHeight();
		}
	}
};

LayoutBuilder.prototype.processToc = function (node) {
	if (node.toc.title) {
		this.processNode(node.toc.title);
	}
	this.processNode(node.toc._table);
};

LayoutBuilder.prototype.buildNextLine = function (textNode) {

	function cloneInline(inline) {
		var newInline = inline.constructor();
		for (var key in inline) {
			newInline[key] = inline[key];
		}
		return newInline;
	}

	if (!textNode._inlines || textNode._inlines.length === 0) {
		return null;
	}

	var line = new Line(this.writer.context().availableWidth);
	var textTools = new TextTools(null);

	var isForceContinue = false;
	while (textNode._inlines && textNode._inlines.length > 0 &&
		(line.hasEnoughSpaceForInline(textNode._inlines[0], textNode._inlines.slice(1)) || isForceContinue)) {
		var isHardWrap = false;
		var inline = textNode._inlines.shift();
		isForceContinue = false;

		if (!inline.noWrap && inline.text.length > 1 && inline.width > line.getAvailableWidth()) {
			var widthPerChar = inline.width / inline.text.length;
			var maxChars = Math.floor(line.getAvailableWidth() / widthPerChar);
			if (maxChars < 1) {
				maxChars = 1;
			}
			if (maxChars < inline.text.length) {
				var newInline = cloneInline(inline);

				newInline.text = inline.text.substr(maxChars);
				inline.text = inline.text.substr(0, maxChars);

				newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing, newInline.fontFeatures);
				inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing, inline.fontFeatures);

				textNode._inlines.unshift(newInline);
				isHardWrap = true;
			}
		}

		line.addInline(inline);

		isForceContinue = inline.noNewLine && !isHardWrap;
	}

	line.lastLineInParagraph = textNode._inlines.length === 0;

	return line;
};

// images
LayoutBuilder.prototype.processImage = function (node) {
	var position = this.writer.addImage(node);
	node.positions.push(position);
};

LayoutBuilder.prototype.processCanvas = function (node) {
	var height = node._minHeight;

	if (node.absolutePosition === undefined && this.writer.context().availableHeight < height) {
		// TODO: support for canvas larger than a page
		// TODO: support for other overflow methods

		this.writer.moveToNextPage();
	}

	this.writer.alignCanvas(node);

	node.canvas.forEach(function (vector) {
		var position = this.writer.addVector(vector);
		node.positions.push(position);
	}, this);

	this.writer.context().moveDown(height);
};

LayoutBuilder.prototype.processQr = function (node) {
	var position = this.writer.addQr(node);
	node.positions.push(position);
};

module.exports = LayoutBuilder;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

var isString = __webpack_require__(0).isString;
var isNumber = __webpack_require__(0).isNumber;
var isBoolean = __webpack_require__(0).isBoolean;
var isArray = __webpack_require__(0).isArray;
var isUndefined = __webpack_require__(0).isUndefined;
var fontStringify = __webpack_require__(0).fontStringify;

function DocPreprocessor() {

}

DocPreprocessor.prototype.preprocessDocument = function (docStructure) {
	this.parentNode = null;
	this.tocs = [];
	this.nodeReferences = [];
	return this.preprocessNode(docStructure);
};

DocPreprocessor.prototype.preprocessNode = function (node) {
	// expand shortcuts and casting values
	if (isArray(node)) {
		node = {stack: node};
	} else if (isString(node)) {
		node = {text: node};
	} else if (isNumber(node) || isBoolean(node)) {
		node = {text: node.toString()};
	} else if (node === undefined || node === null) {
		node = {text: ''};
	} else if (Object.keys(node).length === 0) { // empty object
		node = {text: ''};
	} else if ('text' in node && (node.text === undefined || node.text === null)) {
		node.text = '';
	}

	if (node.columns) {
		return this.preprocessColumns(node);
	} else if (node.stack) {
		return this.preprocessVerticalContainer(node);
	} else if (node.ul) {
		return this.preprocessList(node);
	} else if (node.ol) {
		return this.preprocessList(node);
	} else if (node.table) {
		return this.preprocessTable(node);
	} else if (node.text !== undefined) {
		return this.preprocessText(node);
	} else if (node.toc) {
		return this.preprocessToc(node);
	} else if (node.image) {
		return this.preprocessImage(node);
	} else if (node.canvas) {
		return this.preprocessCanvas(node);
	} else if (node.qr) {
		return this.preprocessQr(node);
	} else if (node.pageReference || node.textReference) {
		return this.preprocessText(node);
	} else {
		throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
	}
};

DocPreprocessor.prototype.preprocessColumns = function (node) {
	var columns = node.columns;

	for (var i = 0, l = columns.length; i < l; i++) {
		columns[i] = this.preprocessNode(columns[i]);
	}

	return node;
};

DocPreprocessor.prototype.preprocessVerticalContainer = function (node) {
	var items = node.stack;

	for (var i = 0, l = items.length; i < l; i++) {
		items[i] = this.preprocessNode(items[i]);
	}

	return node;
};

DocPreprocessor.prototype.preprocessList = function (node) {
	var items = node.ul || node.ol;

	for (var i = 0, l = items.length; i < l; i++) {
		items[i] = this.preprocessNode(items[i]);
	}

	return node;
};

DocPreprocessor.prototype.preprocessTable = function (node) {
	var col, row, cols, rows;

	for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
		for (row = 0, rows = node.table.body.length; row < rows; row++) {
			var rowData = node.table.body[row];
			var data = rowData[col];
			if (data !== undefined) {
				if (data === null) { // transform to object
					data = '';
				}
				if (!data._span) {
					rowData[col] = this.preprocessNode(data);
				}
			}
		}
	}

	return node;
};

DocPreprocessor.prototype.preprocessText = function (node) {
	if (node.tocItem) {
		if (!isArray(node.tocItem)) {
			node.tocItem = [node.tocItem];
		}

		for (var i = 0, l = node.tocItem.length; i < l; i++) {
			if (!isString(node.tocItem[i])) {
				node.tocItem[i] = '_default_';
			}

			var tocItemId = node.tocItem[i];

			if (!this.tocs[tocItemId]) {
				this.tocs[tocItemId] = {toc: {_items: [], _pseudo: true}};
			}

			var tocItemRef = {
				_nodeRef: this._getNodeForNodeRef(node),
				_textNodeRef: node
			};
			this.tocs[tocItemId].toc._items.push(tocItemRef);
		}
	}

	if (node.id) {
		if (this.nodeReferences[node.id]) {
			if (!this.nodeReferences[node.id]._pseudo) {
				throw "Node id '" + node.id + "' already exists";
			}

			this.nodeReferences[node.id]._nodeRef = this._getNodeForNodeRef(node);
			this.nodeReferences[node.id]._textNodeRef = node;
			this.nodeReferences[node.id]._pseudo = false;
		} else {
			this.nodeReferences[node.id] = {
				_nodeRef: this._getNodeForNodeRef(node),
				_textNodeRef: node
			};
		}
	}

	if (node.pageReference) {
		if (!this.nodeReferences[node.pageReference]) {
			this.nodeReferences[node.pageReference] = {
				_nodeRef: {},
				_textNodeRef: {},
				_pseudo: true
			};
		}
		node.text = '00000';
		node._pageRef = this.nodeReferences[node.pageReference];
	}

	if (node.textReference) {
		if (!this.nodeReferences[node.textReference]) {
			this.nodeReferences[node.textReference] = {_nodeRef: {}, _pseudo: true};
		}

		node.text = '';
		node._textRef = this.nodeReferences[node.textReference];
	}

	if (node.text && node.text.text) {
		node.text = [this.preprocessNode(node.text)];
	} else if (isArray(node.text)) {
		var isSetParentNode = false;
		if (this.parentNode === null) {
			this.parentNode = node;
			isSetParentNode = true;
		}

		for (var i = 0, l = node.text.length; i < l; i++) {
			node.text[i] = this.preprocessNode(node.text[i]);
		}

		if (isSetParentNode) {
			this.parentNode = null;
		}
	}

	return node;
};

DocPreprocessor.prototype.preprocessToc = function (node) {
	if (!node.toc.id) {
		node.toc.id = '_default_';
	}

	node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
	node.toc._items = [];

	if (this.tocs[node.toc.id]) {
		if (!this.tocs[node.toc.id].toc._pseudo) {
			throw "TOC '" + node.toc.id + "' already exists";
		}

		node.toc._items = this.tocs[node.toc.id].toc._items;
	}

	this.tocs[node.toc.id] = node;

	return node;
};

DocPreprocessor.prototype.preprocessImage = function (node) {
	if (!isUndefined(node.image.type) && !isUndefined(node.image.data) && (node.image.type === 'Buffer') && isArray(node.image.data)) {
		node.image = Buffer.from(node.image.data);
	}
	return node;
};

DocPreprocessor.prototype.preprocessCanvas = function (node) {
	return node;
};

DocPreprocessor.prototype.preprocessQr = function (node) {
	return node;
};

DocPreprocessor.prototype._getNodeForNodeRef = function (node) {
	if (this.parentNode) {
		return this.parentNode;
	}

	return node;
}

module.exports = DocPreprocessor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-unused-vars: ["error", {"args": "none"}]*/



var TextTools = __webpack_require__(75);
var StyleContextStack = __webpack_require__(119);
var ColumnCalculator = __webpack_require__(76);
var isString = __webpack_require__(0).isString;
var isNumber = __webpack_require__(0).isNumber;
var isObject = __webpack_require__(0).isObject;
var isArray = __webpack_require__(0).isArray;
var fontStringify = __webpack_require__(0).fontStringify;
var pack = __webpack_require__(0).pack;
var qrEncoder = __webpack_require__(300);

/**
 * @private
 */
function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, tableLayouts, images) {
	this.textTools = new TextTools(fontProvider);
	this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
	this.imageMeasure = imageMeasure;
	this.tableLayouts = tableLayouts;
	this.images = images;
	this.autoImageIndex = 1;
}

/**
 * Measures all nodes and sets min/max-width properties required for the second
 * layout-pass.
 * @param  {Object} docStructure document-definition-object
 * @return {Object}              document-measurement-object
 */
DocMeasure.prototype.measureDocument = function (docStructure) {
	return this.measureNode(docStructure);
};

DocMeasure.prototype.measureNode = function (node) {

	var self = this;

	return this.styleStack.auto(node, function () {
		// TODO: refactor + rethink whether this is the proper way to handle margins
		node._margin = getNodeMargin(node);

		if (node.columns) {
			return extendMargins(self.measureColumns(node));
		} else if (node.stack) {
			return extendMargins(self.measureVerticalContainer(node));
		} else if (node.ul) {
			return extendMargins(self.measureUnorderedList(node));
		} else if (node.ol) {
			return extendMargins(self.measureOrderedList(node));
		} else if (node.table) {
			return extendMargins(self.measureTable(node));
		} else if (node.text !== undefined) {
			return extendMargins(self.measureLeaf(node));
		} else if (node.toc) {
			return extendMargins(self.measureToc(node));
		} else if (node.image) {
			return extendMargins(self.measureImage(node));
		} else if (node.canvas) {
			return extendMargins(self.measureCanvas(node));
		} else if (node.qr) {
			return extendMargins(self.measureQr(node));
		} else {
			throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
		}
	});

	function extendMargins(node) {
		var margin = node._margin;

		if (margin) {
			node._minWidth += margin[0] + margin[2];
			node._maxWidth += margin[0] + margin[2];
		}

		return node;
	}

	function getNodeMargin() {

		function processSingleMargins(node, currentMargin) {
			if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) {
				return [
					node.marginLeft || currentMargin[0] || 0,
					node.marginTop || currentMargin[1] || 0,
					node.marginRight || currentMargin[2] || 0,
					node.marginBottom || currentMargin[3] || 0
				];
			}
			return currentMargin;
		}

		function flattenStyleArray(styleArray) {
			var flattenedStyles = {};
			for (var i = styleArray.length - 1; i >= 0; i--) {
				var styleName = styleArray[i];
				var style = self.styleStack.styleDictionary[styleName];
				for (var key in style) {
					if (style.hasOwnProperty(key)) {
						flattenedStyles[key] = style[key];
					}
				}
			}
			return flattenedStyles;
		}

		function convertMargin(margin) {
			if (isNumber(margin)) {
				margin = [margin, margin, margin, margin];
			} else if (isArray(margin)) {
				if (margin.length === 2) {
					margin = [margin[0], margin[1], margin[0], margin[1]];
				}
			}
			return margin;
		}

		var margin = [undefined, undefined, undefined, undefined];

		if (node.style) {
			var styleArray = isArray(node.style) ? node.style : [node.style];
			var flattenedStyleArray = flattenStyleArray(styleArray);

			if (flattenedStyleArray) {
				margin = processSingleMargins(flattenedStyleArray, margin);
			}

			if (flattenedStyleArray.margin) {
				margin = convertMargin(flattenedStyleArray.margin);
			}
		}

		margin = processSingleMargins(node, margin);

		if (node.margin) {
			margin = convertMargin(node.margin);
		}

		if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) {
			return null;
		} else {
			return margin;
		}
	}
};

DocMeasure.prototype.convertIfBase64Image = function (node) {
	if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
		var label = '$$pdfmake$$' + this.autoImageIndex++;
		this.images[label] = node.image;
		node.image = label;
	}
};

DocMeasure.prototype.measureImage = function (node) {
	if (this.images) {
		this.convertIfBase64Image(node);
	}

	var imageSize = this.imageMeasure.measureImage(node.image);

	if (node.fit) {
		var factor = (imageSize.width / imageSize.height > node.fit[0] / node.fit[1]) ? node.fit[0] / imageSize.width : node.fit[1] / imageSize.height;
		node._width = node._minWidth = node._maxWidth = imageSize.width * factor;
		node._height = imageSize.height * factor;
	} else {
		node._width = node._minWidth = node._maxWidth = node.width || imageSize.width;
		node._height = node.height || (imageSize.height * node._width / imageSize.width);

		if (isNumber(node.maxWidth) && node.maxWidth < node._width) {
			node._width = node._minWidth = node._maxWidth = node.maxWidth;
			node._height = node._width * imageSize.height / imageSize.width;
		}

		if (isNumber(node.maxHeight) && node.maxHeight < node._height) {
			node._height = node.maxHeight;
			node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
		}

		if (isNumber(node.minWidth) && node.minWidth > node._width) {
			node._width = node._minWidth = node._maxWidth = node.minWidth;
			node._height = node._width * imageSize.height / imageSize.width;
		}

		if (isNumber(node.minHeight) && node.minHeight > node._height) {
			node._height = node.minHeight;
			node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
		}
	}

	node._alignment = this.styleStack.getProperty('alignment');
	return node;
};

DocMeasure.prototype.measureLeaf = function (node) {

	if (node._textRef && node._textRef._textNodeRef.text) {
		node.text = node._textRef._textNodeRef.text;
	}

	// Make sure style properties of the node itself are considered when building inlines.
	// We could also just pass [node] to buildInlines, but that fails for bullet points.
	var styleStack = this.styleStack.clone();
	styleStack.push(node);

	var data = this.textTools.buildInlines(node.text, styleStack);

	node._inlines = data.items;
	node._minWidth = data.minWidth;
	node._maxWidth = data.maxWidth;

	return node;
};

DocMeasure.prototype.measureToc = function (node) {
	if (node.toc.title) {
		node.toc.title = this.measureNode(node.toc.title);
	}

	var body = [];
	var textStyle = node.toc.textStyle || {};
	var numberStyle = node.toc.numberStyle || textStyle;
	var textMargin = node.toc.textMargin || [0, 0, 0, 0];
	for (var i = 0, l = node.toc._items.length; i < l; i++) {
		var item = node.toc._items[i];
		var lineStyle = item._textNodeRef.tocStyle || textStyle;
		var lineMargin = item._textNodeRef.tocMargin || textMargin;
		body.push([
			{text: item._textNodeRef.text, alignment: 'left', style: lineStyle, margin: lineMargin},
			{text: '00000', alignment: 'right', _tocItemRef: item._nodeRef, style: numberStyle, margin: [0, lineMargin[1], 0, lineMargin[3]]}
		]);
	}


	node.toc._table = {
		table: {
			dontBreakRows: true,
			widths: ['*', 'auto'],
			body: body
		},
		layout: 'noBorders'
	};

	node.toc._table = this.measureNode(node.toc._table);

	return node;
};

DocMeasure.prototype.measureVerticalContainer = function (node) {
	var items = node.stack;

	node._minWidth = 0;
	node._maxWidth = 0;

	for (var i = 0, l = items.length; i < l; i++) {
		items[i] = this.measureNode(items[i]);

		node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
		node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
	}

	return node;
};

DocMeasure.prototype.gapSizeForList = function () {
	return this.textTools.sizeOfString('9. ', this.styleStack);
};

DocMeasure.prototype.buildUnorderedMarker = function (styleStack, gapSize, type) {
	function buildDisc(gapSize, color) {
		// TODO: ascender-based calculations
		var radius = gapSize.fontSize / 6;
		return {
			canvas: [{
					x: radius,
					y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
					r1: radius,
					r2: radius,
					type: 'ellipse',
					color: color
				}]
		};
	}

	function buildSquare(gapSize, color) {
		// TODO: ascender-based calculations
		var size = gapSize.fontSize / 3;
		return {
			canvas: [{
					x: 0,
					y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - (gapSize.fontSize / 3) - (size / 2),
					h: size,
					w: size,
					type: 'rect',
					color: color
				}]
		};
	}

	function buildCircle(gapSize, color) {
		// TODO: ascender-based calculations
		var radius = gapSize.fontSize / 6;
		return {
			canvas: [{
					x: radius,
					y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
					r1: radius,
					r2: radius,
					type: 'ellipse',
					lineColor: color
				}]
		};
	}

	var marker;
	var color = styleStack.getProperty('markerColor') || styleStack.getProperty('color') || 'black';

	switch (type) {
		case 'circle':
			marker = buildCircle(gapSize, color);
			break;

		case 'square':
			marker = buildSquare(gapSize, color);
			break;

		case 'none':
			marker = {};
			break;

		case 'disc':
		default:
			marker = buildDisc(gapSize, color);
			break;
	}

	marker._minWidth = marker._maxWidth = gapSize.width;
	marker._minHeight = marker._maxHeight = gapSize.height;

	return marker;
};

DocMeasure.prototype.buildOrderedMarker = function (counter, styleStack, type, separator) {
	function prepareAlpha(counter) {
		function toAlpha(num) {
			return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[num % 26 >> 0];
		}

		if (counter < 1) {
			return counter.toString();
		}

		return toAlpha(counter - 1);
	}

	function prepareRoman(counter) {
		if (counter < 1 || counter > 4999) {
			return counter.toString();
		}
		var num = counter;
		var lookup = {M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1}, roman = '', i;
		for (i in lookup) {
			while (num >= lookup[i]) {
				roman += i;
				num -= lookup[i];
			}
		}
		return roman;
	}

	function prepareDecimal(counter) {
		return counter.toString();
	}

	var counterText;
	switch (type) {
		case 'none':
			counterText = null;
			break;

		case 'upper-alpha':
			counterText = prepareAlpha(counter).toUpperCase();
			break;

		case 'lower-alpha':
			counterText = prepareAlpha(counter);
			break;

		case 'upper-roman':
			counterText = prepareRoman(counter);
			break;

		case 'lower-roman':
			counterText = prepareRoman(counter).toLowerCase();
			break;

		case 'decimal':
		default:
			counterText = prepareDecimal(counter);
			break;
	}

	if (counterText === null) {
		return {};
	}

	if (separator) {
		if (isArray(separator)) {
			if (separator[0]) {
				counterText = separator[0] + counterText;
			}

			if (separator[1]) {
				counterText += separator[1];
			}
			counterText += ' ';
		} else {
			counterText += separator + ' ';
		}
	}

	var textArray = {text: counterText};
	var markerColor = styleStack.getProperty('markerColor');
	if (markerColor) {
		textArray.color = markerColor;
	}

	return {_inlines: this.textTools.buildInlines(textArray, styleStack).items};
};

DocMeasure.prototype.measureUnorderedList = function (node) {
	var style = this.styleStack.clone();
	var items = node.ul;
	node.type = node.type || 'disc';
	node._gapSize = this.gapSizeForList();
	node._minWidth = 0;
	node._maxWidth = 0;

	for (var i = 0, l = items.length; i < l; i++) {
		var item = items[i] = this.measureNode(items[i]);

		if (!item.ol && !item.ul) {
			item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
		}

		node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
		node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
	}

	return node;
};

DocMeasure.prototype.measureOrderedList = function (node) {
	var style = this.styleStack.clone();
	var items = node.ol;
	node.type = node.type || 'decimal';
	node.separator = node.separator || '.';
	node.reversed = node.reversed || false;
	if (!node.start) {
		node.start = node.reversed ? items.length : 1;
	}
	node._gapSize = this.gapSizeForList();
	node._minWidth = 0;
	node._maxWidth = 0;

	var counter = node.start;
	for (var i = 0, l = items.length; i < l; i++) {
		var item = items[i] = this.measureNode(items[i]);

		if (!item.ol && !item.ul) {
			item.listMarker = this.buildOrderedMarker(item.counter || counter, style, item.listType || node.type, node.separator);
			if (item.listMarker._inlines) {
				node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
			}
		}  // TODO: else - nested lists numbering

		node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
		node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);

		if (node.reversed) {
			counter--;
		} else {
			counter++;
		}
	}

	node._minWidth += node._gapSize.width;
	node._maxWidth += node._gapSize.width;

	for (var i = 0, l = items.length; i < l; i++) {
		var item = items[i];
		if (!item.ol && !item.ul) {
			item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
		}
	}

	return node;
};

DocMeasure.prototype.measureColumns = function (node) {
	var columns = node.columns;
	node._gap = this.styleStack.getProperty('columnGap') || 0;

	for (var i = 0, l = columns.length; i < l; i++) {
		columns[i] = this.measureNode(columns[i]);
	}

	var measures = ColumnCalculator.measureMinMax(columns);

	var numGaps = (columns.length > 0) ? (columns.length - 1) : 0;
	node._minWidth = measures.min + node._gap * numGaps;
	node._maxWidth = measures.max + node._gap * numGaps;

	return node;
};

DocMeasure.prototype.measureTable = function (node) {
	extendTableWidths(node);
	node._layout = getLayout(this.tableLayouts);
	node._offsets = getOffsets(node._layout);

	var colSpans = [];
	var col, row, cols, rows;

	for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
		var c = node.table.widths[col];
		c._minWidth = 0;
		c._maxWidth = 0;

		for (row = 0, rows = node.table.body.length; row < rows; row++) {
			var rowData = node.table.body[row];
			var data = rowData[col];
			if (data === undefined) {
				console.error('Malformed table row ', rowData, 'in node ', node);
				throw 'Malformed table row, a cell is undefined.';
			}
			if (data === null) { // transform to object
				data = '';
			}

			if (!data._span) {
				data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));

				if (data.colSpan && data.colSpan > 1) {
					markSpans(rowData, col, data.colSpan);
					colSpans.push({col: col, span: data.colSpan, minWidth: data._minWidth, maxWidth: data._maxWidth});
				} else {
					c._minWidth = Math.max(c._minWidth, data._minWidth);
					c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
				}
			}

			if (data.rowSpan && data.rowSpan > 1) {
				markVSpans(node.table, row, col, data.rowSpan);
			}
		}
	}

	extendWidthsForColSpans();

	var measures = ColumnCalculator.measureMinMax(node.table.widths);

	node._minWidth = measures.min + node._offsets.total;
	node._maxWidth = measures.max + node._offsets.total;

	return node;

	function measureCb(_this, data) {
		return function () {
			if (isObject(data)) {
				data.fillColor = _this.styleStack.getProperty('fillColor');
			}
			return _this.measureNode(data);
		};
	}

	function getLayout(tableLayouts) {
		var layout = node.layout;

		if (isString(layout)) {
			layout = tableLayouts[layout];
		}

		var defaultLayout = {
			hLineWidth: function (i, node) {
				return 1;
			},
			vLineWidth: function (i, node) {
				return 1;
			},
			hLineColor: function (i, node) {
				return 'black';
			},
			vLineColor: function (i, node) {
				return 'black';
			},
			hLineStyle: function (i, node) {
				return null;
			},
			vLineStyle: function (i, node) {
				return null;
			},
			paddingLeft: function (i, node) {
				return 4;
			},
			paddingRight: function (i, node) {
				return 4;
			},
			paddingTop: function (i, node) {
				return 2;
			},
			paddingBottom: function (i, node) {
				return 2;
			},
			fillColor: function (i, node) {
				return null;
			},
			defaultBorder: true
		};

		return pack(defaultLayout, layout);
	}

	function getOffsets(layout) {
		var offsets = [];
		var totalOffset = 0;
		var prevRightPadding = 0;

		for (var i = 0, l = node.table.widths.length; i < l; i++) {
			var lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
			offsets.push(lOffset);
			totalOffset += lOffset;
			prevRightPadding = layout.paddingRight(i, node);
		}

		totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);

		return {
			total: totalOffset,
			offsets: offsets
		};
	}

	function extendWidthsForColSpans() {
		var q, j;

		for (var i = 0, l = colSpans.length; i < l; i++) {
			var span = colSpans[i];

			var currentMinMax = getMinMax(span.col, span.span, node._offsets);
			var minDifference = span.minWidth - currentMinMax.minWidth;
			var maxDifference = span.maxWidth - currentMinMax.maxWidth;

			if (minDifference > 0) {
				q = minDifference / span.span;

				for (j = 0; j < span.span; j++) {
					node.table.widths[span.col + j]._minWidth += q;
				}
			}

			if (maxDifference > 0) {
				q = maxDifference / span.span;

				for (j = 0; j < span.span; j++) {
					node.table.widths[span.col + j]._maxWidth += q;
				}
			}
		}
	}

	function getMinMax(col, span, offsets) {
		var result = {minWidth: 0, maxWidth: 0};

		for (var i = 0; i < span; i++) {
			result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
			result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
		}

		return result;
	}

	function markSpans(rowData, col, span) {
		for (var i = 1; i < span; i++) {
			rowData[col + i] = {
				_span: true,
				_minWidth: 0,
				_maxWidth: 0,
				rowSpan: rowData[col].rowSpan
			};
		}
	}

	function markVSpans(table, row, col, span) {
		for (var i = 1; i < span; i++) {
			table.body[row + i][col] = {
				_span: true,
				_minWidth: 0,
				_maxWidth: 0,
				fillColor: table.body[row][col].fillColor
			};
		}
	}

	function extendTableWidths(node) {
		if (!node.table.widths) {
			node.table.widths = 'auto';
		}

		if (isString(node.table.widths)) {
			node.table.widths = [node.table.widths];

			while (node.table.widths.length < node.table.body[0].length) {
				node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
			}
		}

		for (var i = 0, l = node.table.widths.length; i < l; i++) {
			var w = node.table.widths[i];
			if (isNumber(w) || isString(w)) {
				node.table.widths[i] = {width: w};
			}
		}
	}
};

DocMeasure.prototype.measureCanvas = function (node) {
	var w = 0, h = 0;

	for (var i = 0, l = node.canvas.length; i < l; i++) {
		var vector = node.canvas[i];

		switch (vector.type) {
			case 'ellipse':
				w = Math.max(w, vector.x + vector.r1);
				h = Math.max(h, vector.y + vector.r2);
				break;
			case 'rect':
				w = Math.max(w, vector.x + vector.w);
				h = Math.max(h, vector.y + vector.h);
				break;
			case 'line':
				w = Math.max(w, vector.x1, vector.x2);
				h = Math.max(h, vector.y1, vector.y2);
				break;
			case 'polyline':
				for (var i2 = 0, l2 = vector.points.length; i2 < l2; i2++) {
					w = Math.max(w, vector.points[i2].x);
					h = Math.max(h, vector.points[i2].y);
				}
				break;
		}
	}

	node._minWidth = node._maxWidth = w;
	node._minHeight = node._maxHeight = h;
	node._alignment = this.styleStack.getProperty('alignment');

	return node;
};

DocMeasure.prototype.measureQr = function (node) {
	node = qrEncoder.measure(node);
	node._alignment = this.styleStack.getProperty('alignment');
	return node;
};

module.exports = DocMeasure;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-unused-vars: ["error", {"args": "none"}]*/
/*eslint no-redeclare: "off"*/


/* qr.js -- QR code generator in Javascript (revision 2011-01-19)
 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
 *
 * This source code is in the public domain; if your jurisdiction does not
 * recognize the public domain the terms of Creative Commons CC0 license
 * apply. In the other words, you can always do what you want.
 */


// per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
//
// [0]: the degree of generator polynomial by ECC levels
// [1]: # of code blocks by ECC levels
// [2]: left-top positions of alignment patterns
//
// the number in this table (in particular, [0]) does not exactly match with
// the numbers in the specficiation. see augumenteccs below for the reason.
var VERSIONS = [
	null,
	[[10, 7, 17, 13], [1, 1, 1, 1], []],
	[[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]],
	[[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]],
	[[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]],
	[[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]],
	[[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]],
	[[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]],
	[[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]],
	[[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]],
	[[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]],
	[[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]],
	[[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]],
	[[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]],
	[[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]],
	[[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]],
	[[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]],
	[[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]],
	[[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]],
	[[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]],
	[[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]],
	[[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]],
	[[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]],
	[[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]],
	[[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]],
	[[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]],
	[[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]],
	[[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]],
	[[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]],
	[[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]],
	[[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]],
	[[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]],
	[[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]],
	[[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]],
	[[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]],
	[[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]],
	[[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]],
	[[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]],
	[[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]],
	[[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]],
	[[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]];

// mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
var MODE_TERMINATOR = 0;
var MODE_NUMERIC = 1, MODE_ALPHANUMERIC = 2, MODE_OCTET = 4, MODE_KANJI = 8;

// validation regexps
var NUMERIC_REGEXP = /^\d*$/;
var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;

// ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
var ECCLEVEL_L = 1, ECCLEVEL_M = 0, ECCLEVEL_Q = 3, ECCLEVEL_H = 2;

// GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
// invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
var GF256_MAP = [], GF256_INVMAP = [-1];
for (var i = 0, v = 1; i < 255; ++i) {
	GF256_MAP.push(v);
	GF256_INVMAP[v] = i;
	v = (v * 2) ^ (v >= 128 ? 0x11d : 0);
}

// generator polynomials up to degree 30
// (should match with polynomials in JIS X 0510:2004 Appendix A)
//
// generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
// ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
// from the result; also other coefficients are written in terms of the exponent
// to \alpha to avoid the redundant calculation. (see also calculateecc below.)
var GF256_GENPOLY = [[]];
for (var i = 0; i < 30; ++i) {
	var prevpoly = GF256_GENPOLY[i], poly = [];
	for (var j = 0; j <= i; ++j) {
		var a = (j < i ? GF256_MAP[prevpoly[j]] : 0);
		var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
		poly.push(GF256_INVMAP[a ^ b]);
	}
	GF256_GENPOLY.push(poly);
}

// alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
var ALPHANUMERIC_MAP = {};
for (var i = 0; i < 45; ++i) {
	ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
}

// mask functions in terms of row # and column #
// (cf. Table 20 in JIS X 0510:2004 p. 42)
/*jshint unused: false */
var MASKFUNCS = [
	function (i, j) {
		return (i + j) % 2 === 0;
	},
	function (i, j) {
		return i % 2 === 0;
	},
	function (i, j) {
		return j % 3 === 0;
	},
	function (i, j) {
		return (i + j) % 3 === 0;
	},
	function (i, j) {
		return (((i / 2) | 0) + ((j / 3) | 0)) % 2 === 0;
	},
	function (i, j) {
		return (i * j) % 2 + (i * j) % 3 === 0;
	},
	function (i, j) {
		return ((i * j) % 2 + (i * j) % 3) % 2 === 0;
	},
	function (i, j) {
		return ((i + j) % 2 + (i * j) % 3) % 2 === 0;
	}];

// returns true when the version information has to be embeded.
var needsverinfo = function (ver) {
	return ver > 6;
};

// returns the size of entire QR code for given version.
var getsizebyver = function (ver) {
	return 4 * ver + 17;
};

// returns the number of bits available for code words in this version.
var nfullbits = function (ver) {
	/*
	 * |<--------------- n --------------->|
	 * |        |<----- n-17 ---->|        |
	 * +-------+                ///+-------+ ----
	 * |       |                ///|       |    ^
	 * |  9x9  |       @@@@@    ///|  9x8  |    |
	 * |       | # # # @5x5@ # # # |       |    |
	 * +-------+       @@@@@       +-------+    |
	 *       #                               ---|
	 *                                        ^ |
	 *       #                                |
	 *     @@@@@       @@@@@       @@@@@      | n
	 *     @5x5@       @5x5@       @5x5@   n-17
	 *     @@@@@       @@@@@       @@@@@      | |
	 *       #                                | |
	 * //////                                 v |
	 * //////#                               ---|
	 * +-------+       @@@@@       @@@@@        |
	 * |       |       @5x5@       @5x5@        |
	 * |  8x9  |       @@@@@       @@@@@        |
	 * |       |                                v
	 * +-------+                             ----
	 *
	 * when the entire code has n^2 modules and there are m^2-3 alignment
	 * patterns, we have:
	 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
	 *   format information;
	 * - 2n-34 (= 2(n-17)) modules for timing patterns;
	 * - 36 (= 3x6 + 6x3) modules for version information, if any;
	 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
	 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
	 *   timing patterns.
	 */
	var v = VERSIONS[ver];
	var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
	if (needsverinfo(ver))
		nbits -= 36; // version information
	if (v[2].length) { // alignment patterns
		nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
	}
	return nbits;
};

// returns the number of bits available for data portions (i.e. excludes ECC
// bits but includes mode and length bits) in this version and ECC level.
var ndatabits = function (ver, ecclevel) {
	var nbits = nfullbits(ver) & ~7; // no sub-octet code words
	var v = VERSIONS[ver];
	nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
	return nbits;
};

// returns the number of bits required for the length of data.
// (cf. Table 3 in JIS X 0510:2004 p. 16)
var ndatalenbits = function (ver, mode) {
	switch (mode) {
		case MODE_NUMERIC:
			return (ver < 10 ? 10 : ver < 27 ? 12 : 14);
		case MODE_ALPHANUMERIC:
			return (ver < 10 ? 9 : ver < 27 ? 11 : 13);
		case MODE_OCTET:
			return (ver < 10 ? 8 : 16);
		case MODE_KANJI:
			return (ver < 10 ? 8 : ver < 27 ? 10 : 12);
	}
};

// returns the maximum length of data possible in given configuration.
var getmaxdatalen = function (ver, mode, ecclevel) {
	var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
	switch (mode) {
		case MODE_NUMERIC:
			return ((nbits / 10) | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
		case MODE_ALPHANUMERIC:
			return ((nbits / 11) | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
		case MODE_OCTET:
			return (nbits / 8) | 0;
		case MODE_KANJI:
			return (nbits / 13) | 0;
	}
};

// checks if the given data can be encoded in given mode, and returns
// the converted data for the further processing if possible. otherwise
// returns null.
//
// this function does not check the length of data; it is a duty of
// encode function below (as it depends on the version and ECC level too).
var validatedata = function (mode, data) {
	switch (mode) {
		case MODE_NUMERIC:
			if (!data.match(NUMERIC_REGEXP))
				return null;
			return data;

		case MODE_ALPHANUMERIC:
			if (!data.match(ALPHANUMERIC_REGEXP))
				return null;
			return data.toUpperCase();

		case MODE_OCTET:
			if (typeof data === 'string') { // encode as utf-8 string
				var newdata = [];
				for (var i = 0; i < data.length; ++i) {
					var ch = data.charCodeAt(i);
					if (ch < 0x80) {
						newdata.push(ch);
					} else if (ch < 0x800) {
						newdata.push(0xc0 | (ch >> 6),
							0x80 | (ch & 0x3f));
					} else if (ch < 0x10000) {
						newdata.push(0xe0 | (ch >> 12),
							0x80 | ((ch >> 6) & 0x3f),
							0x80 | (ch & 0x3f));
					} else {
						newdata.push(0xf0 | (ch >> 18),
							0x80 | ((ch >> 12) & 0x3f),
							0x80 | ((ch >> 6) & 0x3f),
							0x80 | (ch & 0x3f));
					}
				}
				return newdata;
			} else {
				return data;
			}
	}
};

// returns the code words (sans ECC bits) for given data and configurations.
// requires data to be preprocessed by validatedata. no length check is
// performed, and everything has to be checked before calling this function.
var encode = function (ver, mode, data, maxbuflen) {
	var buf = [];
	var bits = 0, remaining = 8;
	var datalen = data.length;

	// this function is intentionally no-op when n=0.
	var pack = function (x, n) {
		if (n >= remaining) {
			buf.push(bits | (x >> (n -= remaining)));
			while (n >= 8)
				buf.push((x >> (n -= 8)) & 255);
			bits = 0;
			remaining = 8;
		}
		if (n > 0)
			bits |= (x & ((1 << n) - 1)) << (remaining -= n);
	};

	var nlenbits = ndatalenbits(ver, mode);
	pack(mode, 4);
	pack(datalen, nlenbits);

	switch (mode) {
		case MODE_NUMERIC:
			for (var i = 2; i < datalen; i += 3) {
				pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
			}
			pack(parseInt(data.substring(i - 2), 10), [0, 4, 7][datalen % 3]);
			break;

		case MODE_ALPHANUMERIC:
			for (var i = 1; i < datalen; i += 2) {
				pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 +
					ALPHANUMERIC_MAP[data.charAt(i)], 11);
			}
			if (datalen % 2 == 1) {
				pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
			}
			break;

		case MODE_OCTET:
			for (var i = 0; i < datalen; ++i) {
				pack(data[i], 8);
			}
			break;
	}

	// final bits. it is possible that adding terminator causes the buffer
	// to overflow, but then the buffer truncated to the maximum size will
	// be valid as the truncated terminator mode bits and padding is
	// identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
	pack(MODE_TERMINATOR, 4);
	if (remaining < 8)
		buf.push(bits);

	// the padding to fill up the remaining space. we should not add any
	// words when the overflow already occurred.
	while (buf.length + 1 < maxbuflen)
		buf.push(0xec, 0x11);
	if (buf.length < maxbuflen)
		buf.push(0xec);
	return buf;
};

// calculates ECC code words for given code words and generator polynomial.
//
// this is quite similar to CRC calculation as both Reed-Solomon and CRC use
// the certain kind of cyclic codes, which is effectively the division of
// zero-augumented polynomial by the generator polynomial. the only difference
// is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
// uses the different generator polynomial than CRC's.
var calculateecc = function (poly, genpoly) {
	var modulus = poly.slice(0);
	var polylen = poly.length, genpolylen = genpoly.length;
	for (var i = 0; i < genpolylen; ++i)
		modulus.push(0);
	for (var i = 0; i < polylen; ) {
		var quotient = GF256_INVMAP[modulus[i++]];
		if (quotient >= 0) {
			for (var j = 0; j < genpolylen; ++j) {
				modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
			}
		}
	}
	return modulus.slice(polylen);
};

// auguments ECC code words to given code words. the resulting words are
// ready to be encoded in the matrix.
//
// the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
// the code is simplified using the fact that the size of each code & ECC
// blocks is almost same; for example, when we have 4 blocks and 46 data words
// the number of code words in those blocks are 11, 11, 12, 12 respectively.
var augumenteccs = function (poly, nblocks, genpoly) {
	var subsizes = [];
	var subsize = (poly.length / nblocks) | 0, subsize0 = 0;
	var pivot = nblocks - poly.length % nblocks;
	for (var i = 0; i < pivot; ++i) {
		subsizes.push(subsize0);
		subsize0 += subsize;
	}
	for (var i = pivot; i < nblocks; ++i) {
		subsizes.push(subsize0);
		subsize0 += subsize + 1;
	}
	subsizes.push(subsize0);

	var eccs = [];
	for (var i = 0; i < nblocks; ++i) {
		eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
	}

	var result = [];
	var nitemsperblock = (poly.length / nblocks) | 0;
	for (var i = 0; i < nitemsperblock; ++i) {
		for (var j = 0; j < nblocks; ++j) {
			result.push(poly[subsizes[j] + i]);
		}
	}
	for (var j = pivot; j < nblocks; ++j) {
		result.push(poly[subsizes[j + 1] - 1]);
	}
	for (var i = 0; i < genpoly.length; ++i) {
		for (var j = 0; j < nblocks; ++j) {
			result.push(eccs[j][i]);
		}
	}
	return result;
};

// auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
// genpoly. the both input and output are in binary numbers, and unlike
// calculateecc genpoly should include the 1 bit for the highest degree.
//
// actual polynomials used for this procedure are as follows:
// - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
// - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
var augumentbch = function (poly, p, genpoly, q) {
	var modulus = poly << q;
	for (var i = p - 1; i >= 0; --i) {
		if ((modulus >> (q + i)) & 1)
			modulus ^= genpoly << i;
	}
	return (poly << q) | modulus;
};

// creates the base matrix for given version. it returns two matrices, one of
// them is the actual one and the another represents the "reserved" portion
// (e.g. finder and timing patterns) of the matrix.
//
// some entries in the matrix may be undefined, rather than 0 or 1. this is
// intentional (no initialization needed!), and putdata below will fill
// the remaining ones.
var makebasematrix = function (ver) {
	var v = VERSIONS[ver], n = getsizebyver(ver);
	var matrix = [], reserved = [];
	for (var i = 0; i < n; ++i) {
		matrix.push([]);
		reserved.push([]);
	}

	var blit = function (y, x, h, w, bits) {
		for (var i = 0; i < h; ++i) {
			for (var j = 0; j < w; ++j) {
				matrix[y + i][x + j] = (bits[i] >> j) & 1;
				reserved[y + i][x + j] = 1;
			}
		}
	};

	// finder patterns and a part of timing patterns
	// will also mark the format information area (not yet written) as reserved.
	blit(0, 0, 9, 9, [0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x17f, 0x00, 0x40]);
	blit(n - 8, 0, 8, 9, [0x100, 0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x7f]);
	blit(0, n - 8, 9, 8, [0xfe, 0x82, 0xba, 0xba, 0xba, 0x82, 0xfe, 0x00, 0x00]);

	// the rest of timing patterns
	for (var i = 9; i < n - 8; ++i) {
		matrix[6][i] = matrix[i][6] = ~i & 1;
		reserved[6][i] = reserved[i][6] = 1;
	}

	// alignment patterns
	var aligns = v[2], m = aligns.length;
	for (var i = 0; i < m; ++i) {
		var minj = (i === 0 || i === m - 1 ? 1 : 0), maxj = (i === 0 ? m - 1 : m);
		for (var j = minj; j < maxj; ++j) {
			blit(aligns[i], aligns[j], 5, 5, [0x1f, 0x11, 0x15, 0x11, 0x1f]);
		}
	}

	// version information
	if (needsverinfo(ver)) {
		var code = augumentbch(ver, 6, 0x1f25, 12);
		var k = 0;
		for (var i = 0; i < 6; ++i) {
			for (var j = 0; j < 3; ++j) {
				matrix[i][(n - 11) + j] = matrix[(n - 11) + j][i] = (code >> k++) & 1;
				reserved[i][(n - 11) + j] = reserved[(n - 11) + j][i] = 1;
			}
		}
	}

	return {matrix: matrix, reserved: reserved};
};

// fills the data portion (i.e. unmarked in reserved) of the matrix with given
// code words. the size of code words should be no more than available bits,
// and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
var putdata = function (matrix, reserved, buf) {
	var n = matrix.length;
	var k = 0, dir = -1;
	for (var i = n - 1; i >= 0; i -= 2) {
		if (i == 6)
			--i; // skip the entire timing pattern column
		var jj = (dir < 0 ? n - 1 : 0);
		for (var j = 0; j < n; ++j) {
			for (var ii = i; ii > i - 2; --ii) {
				if (!reserved[jj][ii]) {
					// may overflow, but (undefined >> x)
					// is 0 so it will auto-pad to zero.
					matrix[jj][ii] = (buf[k >> 3] >> (~k & 7)) & 1;
					++k;
				}
			}
			jj += dir;
		}
		dir = -dir;
	}
	return matrix;
};

// XOR-masks the data portion of the matrix. repeating the call with the same
// arguments will revert the prior call (convenient in the matrix evaluation).
var maskdata = function (matrix, reserved, mask) {
	var maskf = MASKFUNCS[mask];
	var n = matrix.length;
	for (var i = 0; i < n; ++i) {
		for (var j = 0; j < n; ++j) {
			if (!reserved[i][j])
				matrix[i][j] ^= maskf(i, j);
		}
	}
	return matrix;
};

// puts the format information.
var putformatinfo = function (matrix, reserved, ecclevel, mask) {
	var n = matrix.length;
	var code = augumentbch((ecclevel << 3) | mask, 5, 0x537, 10) ^ 0x5412;
	for (var i = 0; i < 15; ++i) {
		var r = [0, 1, 2, 3, 4, 5, 7, 8, n - 7, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1][i];
		var c = [n - 1, n - 2, n - 3, n - 4, n - 5, n - 6, n - 7, n - 8, 7, 5, 4, 3, 2, 1, 0][i];
		matrix[r][8] = matrix[8][c] = (code >> i) & 1;
		// we don't have to mark those bits reserved; always done
		// in makebasematrix above.
	}
	return matrix;
};

// evaluates the resulting matrix and returns the score (lower is better).
// (cf. JIS X 0510:2004 sec 8.8.2)
//
// the evaluation procedure tries to avoid the problematic patterns naturally
// occuring from the original matrix. for example, it penaltizes the patterns
// which just look like the finder pattern which will confuse the decoder.
// we choose the mask which results in the lowest score among 8 possible ones.
//
// note: zxing seems to use the same procedure and in many cases its choice
// agrees to ours, but sometimes it does not. practically it doesn't matter.
var evaluatematrix = function (matrix) {
	// N1+(k-5) points for each consecutive row of k same-colored modules,
	// where k >= 5. no overlapping row counts.
	var PENALTY_CONSECUTIVE = 3;
	// N2 points for each 2x2 block of same-colored modules.
	// overlapping block does count.
	var PENALTY_TWOBYTWO = 3;
	// N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
	// 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
	// but 13W:3B:3W:9B:3W:3B counts).
	var PENALTY_FINDERLIKE = 40;
	// N4*k points for every (5*k)% deviation from 50% black density.
	// i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
	var PENALTY_DENSITY = 10;

	var evaluategroup = function (groups) { // assumes [W,B,W,B,W,...,B,W]
		var score = 0;
		for (var i = 0; i < groups.length; ++i) {
			if (groups[i] >= 5)
				score += PENALTY_CONSECUTIVE + (groups[i] - 5);
		}
		for (var i = 5; i < groups.length; i += 2) {
			var p = groups[i];
			if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p &&
				groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) {
				// this part differs from zxing...
				score += PENALTY_FINDERLIKE;
			}
		}
		return score;
	};

	var n = matrix.length;
	var score = 0, nblacks = 0;
	for (var i = 0; i < n; ++i) {
		var row = matrix[i];
		var groups;

		// evaluate the current row
		groups = [0]; // the first empty group of white
		for (var j = 0; j < n; ) {
			var k;
			for (k = 0; j < n && row[j]; ++k)
				++j;
			groups.push(k);
			for (k = 0; j < n && !row[j]; ++k)
				++j;
			groups.push(k);
		}
		score += evaluategroup(groups);

		// evaluate the current column
		groups = [0];
		for (var j = 0; j < n; ) {
			var k;
			for (k = 0; j < n && matrix[j][i]; ++k)
				++j;
			groups.push(k);
			for (k = 0; j < n && !matrix[j][i]; ++k)
				++j;
			groups.push(k);
		}
		score += evaluategroup(groups);

		// check the 2x2 box and calculate the density
		var nextrow = matrix[i + 1] || [];
		nblacks += row[0];
		for (var j = 1; j < n; ++j) {
			var p = row[j];
			nblacks += p;
			// at least comparison with next row should be strict...
			if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) {
				score += PENALTY_TWOBYTWO;
			}
		}
	}

	score += PENALTY_DENSITY * ((Math.abs(nblacks / n / n - 0.5) / 0.05) | 0);
	return score;
};

// returns the fully encoded QR code matrix which contains given data.
// it also chooses the best mask automatically when mask is -1.
var generate = function (data, ver, mode, ecclevel, mask) {
	var v = VERSIONS[ver];
	var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
	buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);

	var result = makebasematrix(ver);
	var matrix = result.matrix, reserved = result.reserved;
	putdata(matrix, reserved, buf);

	if (mask < 0) {
		// find the best mask
		maskdata(matrix, reserved, 0);
		putformatinfo(matrix, reserved, ecclevel, 0);
		var bestmask = 0, bestscore = evaluatematrix(matrix);
		maskdata(matrix, reserved, 0);
		for (mask = 1; mask < 8; ++mask) {
			maskdata(matrix, reserved, mask);
			putformatinfo(matrix, reserved, ecclevel, mask);
			var score = evaluatematrix(matrix);
			if (bestscore > score) {
				bestscore = score;
				bestmask = mask;
			}
			maskdata(matrix, reserved, mask);
		}
		mask = bestmask;
	}

	maskdata(matrix, reserved, mask);
	putformatinfo(matrix, reserved, ecclevel, mask);
	return matrix;
};

// the public interface is trivial; the options available are as follows:
//
// - version: an integer in [1,40]. when omitted (or -1) the smallest possible
//   version is chosen.
// - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
//   possible mode is chosen.
// - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
// - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
//

function generateFrame(data, options) {
	var MODES = {'numeric': MODE_NUMERIC, 'alphanumeric': MODE_ALPHANUMERIC,
		'octet': MODE_OCTET};
	var ECCLEVELS = {'L': ECCLEVEL_L, 'M': ECCLEVEL_M, 'Q': ECCLEVEL_Q,
		'H': ECCLEVEL_H};

	options = options || {};
	var ver = options.version || -1;
	var ecclevel = ECCLEVELS[(options.eccLevel || 'L').toUpperCase()];
	var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
	var mask = 'mask' in options ? options.mask : -1;

	if (mode < 0) {
		if (typeof data === 'string') {
			if (data.match(NUMERIC_REGEXP)) {
				mode = MODE_NUMERIC;
			} else if (data.match(ALPHANUMERIC_OUT_REGEXP)) {
				// while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
				mode = MODE_ALPHANUMERIC;
			} else {
				mode = MODE_OCTET;
			}
		} else {
			mode = MODE_OCTET;
		}
	} else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC ||
		mode == MODE_OCTET)) {
		throw 'invalid or unsupported mode';
	}

	data = validatedata(mode, data);
	if (data === null)
		throw 'invalid data format';

	if (ecclevel < 0 || ecclevel > 3)
		throw 'invalid ECC level';

	if (ver < 0) {
		for (ver = 1; ver <= 40; ++ver) {
			if (data.length <= getmaxdatalen(ver, mode, ecclevel))
				break;
		}
		if (ver > 40)
			throw 'too large data for the Qr format';
	} else if (ver < 1 || ver > 40) {
		throw 'invalid Qr version! should be between 1 and 40';
	}

	if (mask != -1 && (mask < 0 || mask > 8))
		throw 'invalid mask';
	//console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
	return generate(data, ver, mode, ecclevel, mask);
}


// options
// - modulesize: a number. this is a size of each modules in pixels, and
//   defaults to 5px.
// - margin: a number. this is a size of margin in *modules*, and defaults to
//   4 (white modules). the specficiation mandates the margin no less than 4
//   modules, so it is better not to alter this value unless you know what
//   you're doing.
function buildCanvas(data, options) {

	var canvas = [];
	var background = options.background || '#fff';
	var foreground = options.foreground || '#000';
	//var margin = options.margin || 4;
	var matrix = generateFrame(data, options);
	var n = matrix.length;
	var modSize = Math.floor(options.fit ? options.fit / n : 5);
	var size = n * modSize;

	canvas.push({
		type: 'rect',
		x: 0, y: 0, w: size, h: size, lineWidth: 0, color: background
	});

	for (var i = 0; i < n; ++i) {
		for (var j = 0; j < n; ++j) {
			if (matrix[i][j]) {
				canvas.push({
					type: 'rect',
					x: modSize * j,
					y: modSize * i,
					w: modSize,
					h: modSize,
					lineWidth: 0,
					color: foreground
				});
			}
		}
	}

	return {
		canvas: canvas,
		size: size
	};

}

function measure(node) {
	var cd = buildCanvas(node.qr, node);
	node._canvas = cd.canvas;
	node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
	return node;
}

module.exports = {
	measure: measure
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isUndefined = __webpack_require__(0).isUndefined;
var ElementWriter = __webpack_require__(302);

/**
 * Creates an instance of PageElementWriter - an extended ElementWriter
 * which can handle:
 * - page-breaks (it adds new pages when there's not enough space left),
 * - repeatable fragments (like table-headers, which are repeated everytime
 *                         a page-break occurs)
 * - transactions (used for unbreakable-blocks when we want to make sure
 *                 whole block will be rendered on the same page)
 */
function PageElementWriter(context, tracker) {
	this.transactionLevel = 0;
	this.repeatables = [];
	this.tracker = tracker;
	this.writer = new ElementWriter(context, tracker);
}

function fitOnPage(self, addFct) {
	var position = addFct(self);
	if (!position) {
		self.moveToNextPage();
		position = addFct(self);
	}
	return position;
}

PageElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
	return fitOnPage(this, function (self) {
		return self.writer.addLine(line, dontUpdateContextPosition, index);
	});
};

PageElementWriter.prototype.addImage = function (image, index) {
	return fitOnPage(this, function (self) {
		return self.writer.addImage(image, index);
	});
};

PageElementWriter.prototype.addQr = function (qr, index) {
	return fitOnPage(this, function (self) {
		return self.writer.addQr(qr, index);
	});
};

PageElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
	return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index);
};

PageElementWriter.prototype.beginClip = function (width, height) {
	return this.writer.beginClip(width, height);
};

PageElementWriter.prototype.endClip = function () {
	return this.writer.endClip();
};

PageElementWriter.prototype.alignCanvas = function (node) {
	this.writer.alignCanvas(node);
};

PageElementWriter.prototype.addFragment = function (fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
	if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
		this.moveToNextPage();
		this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
	}
};

PageElementWriter.prototype.moveToNextPage = function (pageOrientation) {

	var nextPage = this.writer.context.moveToNextPage(pageOrientation);

	// moveToNextPage is called multiple times for table, because is called for each column
	// and repeatables are inserted only in the first time. If columns are used, is needed
	// call for table in first column and then for table in the second column (is other repeatables).
	this.repeatables.forEach(function (rep) {
		if (isUndefined(rep.insertedOnPages[this.writer.context.page])) {
			rep.insertedOnPages[this.writer.context.page] = true;
			this.writer.addFragment(rep, true);
		} else {
			this.writer.context.moveDown(rep.height);
		}
	}, this);

	this.writer.tracker.emit('pageChanged', {
		prevPage: nextPage.prevPage,
		prevY: nextPage.prevY,
		y: this.writer.context.y
	});
};

PageElementWriter.prototype.beginUnbreakableBlock = function (width, height) {
	if (this.transactionLevel++ === 0) {
		this.originalX = this.writer.context.x;
		this.writer.pushContext(width, height);
	}
};

PageElementWriter.prototype.commitUnbreakableBlock = function (forcedX, forcedY) {
	if (--this.transactionLevel === 0) {
		var unbreakableContext = this.writer.context;
		this.writer.popContext();

		var nbPages = unbreakableContext.pages.length;
		if (nbPages > 0) {
			// no support for multi-page unbreakableBlocks
			var fragment = unbreakableContext.pages[0];
			fragment.xOffset = forcedX;
			fragment.yOffset = forcedY;

			//TODO: vectors can influence height in some situations
			if (nbPages > 1) {
				// on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
				if (forcedX !== undefined || forcedY !== undefined) {
					fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
				} else {
					fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
					for (var i = 0, l = this.repeatables.length; i < l; i++) {
						fragment.height -= this.repeatables[i].height;
					}
				}
			} else {
				fragment.height = unbreakableContext.y;
			}

			if (forcedX !== undefined || forcedY !== undefined) {
				this.writer.addFragment(fragment, true, true, true);
			} else {
				this.addFragment(fragment);
			}
		}
	}
};

PageElementWriter.prototype.currentBlockToRepeatable = function () {
	var unbreakableContext = this.writer.context;
	var rep = {items: []};

	unbreakableContext.pages[0].items.forEach(function (item) {
		rep.items.push(item);
	});

	rep.xOffset = this.originalX;

	//TODO: vectors can influence height in some situations
	rep.height = unbreakableContext.y;

	rep.insertedOnPages = [];

	return rep;
};

PageElementWriter.prototype.pushToRepeatables = function (rep) {
	this.repeatables.push(rep);
};

PageElementWriter.prototype.popFromRepeatables = function () {
	this.repeatables.pop();
};

PageElementWriter.prototype.context = function () {
	return this.writer.context;
};

module.exports = PageElementWriter;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Line = __webpack_require__(121);
var isNumber = __webpack_require__(0).isNumber;
var pack = __webpack_require__(0).pack;
var offsetVector = __webpack_require__(0).offsetVector;
var DocumentContext = __webpack_require__(120);

/**
 * Creates an instance of ElementWriter - a line/vector writer, which adds
 * elements to current page and sets their positions based on the context
 */
function ElementWriter(context, tracker) {
	this.context = context;
	this.contextStack = [];
	this.tracker = tracker;
}

function addPageItem(page, item, index) {
	if (index === null || index === undefined || index < 0 || index > page.items.length) {
		page.items.push(item);
	} else {
		page.items.splice(index, 0, item);
	}
}

ElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
	var height = line.getHeight();
	var context = this.context;
	var page = context.getCurrentPage(),
		position = this.getCurrentPositionOnPage();

	if (context.availableHeight < height || !page) {
		return false;
	}

	line.x = context.x + (line.x || 0);
	line.y = context.y + (line.y || 0);

	this.alignLine(line);

	addPageItem(page, {
		type: 'line',
		item: line
	}, index);
	this.tracker.emit('lineAdded', line);

	if (!dontUpdateContextPosition) {
		context.moveDown(height);
	}

	return position;
};

ElementWriter.prototype.alignLine = function (line) {
	var width = this.context.availableWidth;
	var lineWidth = line.getWidth();

	var alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;

	var offset = 0;
	switch (alignment) {
		case 'right':
			offset = width - lineWidth;
			break;
		case 'center':
			offset = (width - lineWidth) / 2;
			break;
	}

	if (offset) {
		line.x = (line.x || 0) + offset;
	}

	if (alignment === 'justify' &&
		!line.newLineForced &&
		!line.lastLineInParagraph &&
		line.inlines.length > 1) {
		var additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);

		for (var i = 1, l = line.inlines.length; i < l; i++) {
			offset = i * additionalSpacing;

			line.inlines[i].x += offset;
			line.inlines[i].justifyShift = additionalSpacing;
		}
	}
};

ElementWriter.prototype.addImage = function (image, index) {
	var context = this.context;
	var page = context.getCurrentPage(),
		position = this.getCurrentPositionOnPage();

	if (!page || (image.absolutePosition === undefined && context.availableHeight < image._height && page.items.length > 0)) {
		return false;
	}

	if (image._x === undefined) {
		image._x = image.x || 0;
	}

	image.x = context.x + image._x;
	image.y = context.y;

	this.alignImage(image);

	addPageItem(page, {
		type: 'image',
		item: image
	}, index);

	context.moveDown(image._height);

	return position;
};

ElementWriter.prototype.addQr = function (qr, index) {
	var context = this.context;
	var page = context.getCurrentPage(),
		position = this.getCurrentPositionOnPage();

	if (!page || (qr.absolutePosition === undefined && context.availableHeight < qr._height)) {
		return false;
	}

	if (qr._x === undefined) {
		qr._x = qr.x || 0;
	}

	qr.x = context.x + qr._x;
	qr.y = context.y;

	this.alignImage(qr);

	for (var i = 0, l = qr._canvas.length; i < l; i++) {
		var vector = qr._canvas[i];
		vector.x += qr.x;
		vector.y += qr.y;
		this.addVector(vector, true, true, index);
	}

	context.moveDown(qr._height);

	return position;
};

ElementWriter.prototype.alignImage = function (image) {
	var width = this.context.availableWidth;
	var imageWidth = image._minWidth;
	var offset = 0;
	switch (image._alignment) {
		case 'right':
			offset = width - imageWidth;
			break;
		case 'center':
			offset = (width - imageWidth) / 2;
			break;
	}

	if (offset) {
		image.x = (image.x || 0) + offset;
	}
};

ElementWriter.prototype.alignCanvas = function (node) {
	var width = this.context.availableWidth;
	var canvasWidth = node._minWidth;
	var offset = 0;
	switch (node._alignment) {
		case 'right':
			offset = width - canvasWidth;
			break;
		case 'center':
			offset = (width - canvasWidth) / 2;
			break;
	}
	if (offset) {
		node.canvas.forEach(function (vector) {
			offsetVector(vector, offset, 0);
		});
	}
};

ElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
	var context = this.context;
	var page = context.getCurrentPage(),
		position = this.getCurrentPositionOnPage();

	if (page) {
		offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
		addPageItem(page, {
			type: 'vector',
			item: vector
		}, index);
		return position;
	}
};

ElementWriter.prototype.beginClip = function (width, height) {
	var ctx = this.context;
	var page = ctx.getCurrentPage();
	page.items.push({
		type: 'beginClip',
		item: {x: ctx.x, y: ctx.y, width: width, height: height}
	});
	return true;
};

ElementWriter.prototype.endClip = function () {
	var ctx = this.context;
	var page = ctx.getCurrentPage();
	page.items.push({
		type: 'endClip'
	});
	return true;
};

function cloneLine(line) {
	var result = new Line(line.maxWidth);

	for (var key in line) {
		if (line.hasOwnProperty(key)) {
			result[key] = line[key];
		}
	}

	return result;
}

ElementWriter.prototype.addFragment = function (block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
	var ctx = this.context;
	var page = ctx.getCurrentPage();

	if (!useBlockXOffset && block.height > ctx.availableHeight) {
		return false;
	}

	block.items.forEach(function (item) {
		switch (item.type) {
			case 'line':
				var l = cloneLine(item.item);

				l.x = (l.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
				l.y = (l.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

				page.items.push({
					type: 'line',
					item: l
				});
				break;

			case 'vector':
				var v = pack(item.item);

				offsetVector(v, useBlockXOffset ? (block.xOffset || 0) : ctx.x, useBlockYOffset ? (block.yOffset || 0) : ctx.y);
				page.items.push({
					type: 'vector',
					item: v
				});
				break;

			case 'image':
				var img = pack(item.item);

				img.x = (img.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
				img.y = (img.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

				page.items.push({
					type: 'image',
					item: img
				});
				break;
		}
	});

	if (!dontUpdateContextPosition) {
		ctx.moveDown(block.height);
	}

	return true;
};

/**
 * Pushes the provided context onto the stack or creates a new one
 *
 * pushContext(context) - pushes the provided context and makes it current
 * pushContext(width, height) - creates and pushes a new context with the specified width and height
 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
 */
ElementWriter.prototype.pushContext = function (contextOrWidth, height) {
	if (contextOrWidth === undefined) {
		height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
		contextOrWidth = this.context.availableWidth;
	}

	if (isNumber(contextOrWidth)) {
		contextOrWidth = new DocumentContext({width: contextOrWidth, height: height}, {left: 0, right: 0, top: 0, bottom: 0});
	}

	this.contextStack.push(this.context);
	this.context = contextOrWidth;
};

ElementWriter.prototype.popContext = function () {
	this.context = this.contextStack.pop();
};

ElementWriter.prototype.getCurrentPositionOnPage = function () {
	return (this.contextStack[0] || this.context).getCurrentPosition();
};


module.exports = ElementWriter;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ColumnCalculator = __webpack_require__(76);
var isFunction = __webpack_require__(0).isFunction;

function TableProcessor(tableNode) {
	this.tableNode = tableNode;
}

TableProcessor.prototype.beginTable = function (writer) {
	var tableNode;
	var availableWidth;
	var self = this;

	tableNode = this.tableNode;
	this.offsets = tableNode._offsets;
	this.layout = tableNode._layout;

	availableWidth = writer.context().availableWidth - this.offsets.total;
	ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth);

	this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
	this.rowSpanData = prepareRowSpanData();
	this.cleanUpRepeatables = false;

	this.headerRows = tableNode.table.headerRows || 0;
	this.rowsWithoutPageBreak = this.headerRows + (tableNode.table.keepWithHeaderRows || 0);
	this.dontBreakRows = tableNode.table.dontBreakRows || false;

	if (this.rowsWithoutPageBreak) {
		writer.beginUnbreakableBlock();
	}

	// update the border properties of all cells before drawing any lines
	prepareCellBorders(this.tableNode.table.body);

	this.drawHorizontalLine(0, writer);

	function getTableInnerContentWidth() {
		var width = 0;

		tableNode.table.widths.forEach(function (w) {
			width += w._calcWidth;
		});

		return width;
	}

	function prepareRowSpanData() {
		var rsd = [];
		var x = 0;
		var lastWidth = 0;

		rsd.push({left: 0, rowSpan: 0});

		for (var i = 0, l = self.tableNode.table.body[0].length; i < l; i++) {
			var paddings = self.layout.paddingLeft(i, self.tableNode) + self.layout.paddingRight(i, self.tableNode);
			var lBorder = self.layout.vLineWidth(i, self.tableNode);
			lastWidth = paddings + lBorder + self.tableNode.table.widths[i]._calcWidth;
			rsd[rsd.length - 1].width = lastWidth;
			x += lastWidth;
			rsd.push({left: x, rowSpan: 0, width: 0});
		}

		return rsd;
	}

	// Iterate through all cells. If the current cell is the start of a
	// rowSpan/colSpan, update the border property of the cells on its
	// bottom/right accordingly. This is needed since each iteration of the
	// line-drawing loops draws lines for a single cell, not for an entire
	// rowSpan/colSpan.
	function prepareCellBorders(body) {
		for (var rowIndex = 0; rowIndex < body.length; rowIndex++) {
			var row = body[rowIndex];

			for (var colIndex = 0; colIndex < row.length; colIndex++) {
				var cell = row[colIndex];

				if (cell.border) {
					var rowSpan = cell.rowSpan || 1;
					var colSpan = cell.colSpan || 1;

					for (var rowOffset = 0; rowOffset < rowSpan; rowOffset++) {
						// set left border
						if (cell.border[0] !== undefined && rowOffset > 0) {
							setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
						}

						// set right border
						if (cell.border[2] !== undefined) {
							setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
						}
					}

					for (var colOffset = 0; colOffset < colSpan; colOffset++) {
						// set top border
						if (cell.border[1] !== undefined && colOffset > 0) {
							setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
						}

						// set bottom border
						if (cell.border[3] !== undefined) {
							setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
						}
					}
				}
			}
		}

		// helper function to set the border for a given cell
		function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
			var cell = body[rowIndex][colIndex];
			cell.border = cell.border || {};
			cell.border[borderIndex] = borderValue;
		}
	}
};

TableProcessor.prototype.onRowBreak = function (rowIndex, writer) {
	var self = this;
	return function () {
		var offset = self.rowPaddingTop + (!self.headerRows ? self.topLineWidth : 0);
		writer.context().availableHeight -= self.reservedAtBottom;
		writer.context().moveDown(offset);
	};
};

TableProcessor.prototype.beginRow = function (rowIndex, writer) {
	this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
	this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
	this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
	this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);

	this.rowCallback = this.onRowBreak(rowIndex, writer);
	writer.tracker.startTracking('pageChanged', this.rowCallback);
	if (this.dontBreakRows) {
		writer.beginUnbreakableBlock();
	}
	this.rowTopY = writer.context().y;
	this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;

	writer.context().availableHeight -= this.reservedAtBottom;

	writer.context().moveDown(this.rowPaddingTop);
};

TableProcessor.prototype.drawHorizontalLine = function (lineIndex, writer, overrideY) {
	var lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
	if (lineWidth) {
		var style = this.layout.hLineStyle(lineIndex, this.tableNode);
		var dash;
		if (style && style.dash) {
			dash = style.dash;
		}

		var offset = lineWidth / 2;
		var currentLine = null;
		var body = this.tableNode.table.body;

		for (var i = 0, l = this.rowSpanData.length; i < l; i++) {
			var data = this.rowSpanData[i];
			var shouldDrawLine = !data.rowSpan;

			// draw only if the current cell requires a top border or the cell in the
			// row above requires a bottom border
			if (shouldDrawLine && i < l - 1) {
				var topBorder = false, bottomBorder = false;

				// the current cell
				if (lineIndex < body.length) {
					var cell = body[lineIndex][i];
					topBorder = cell.border ? cell.border[1] : this.layout.defaultBorder;
				}

				// the cell in the row above
				if (lineIndex > 0) {
					var cellAbove = body[lineIndex - 1][i];
					bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
				}

				shouldDrawLine = topBorder || bottomBorder;
			}

			if (!currentLine && shouldDrawLine) {
				currentLine = {left: data.left, width: 0};
			}

			if (shouldDrawLine) {
				currentLine.width += (data.width || 0);
			}

			var y = (overrideY || 0) + offset;

			if (!shouldDrawLine || i === l - 1) {
				if (currentLine && currentLine.width) {
					writer.addVector({
						type: 'line',
						x1: currentLine.left,
						x2: currentLine.left + currentLine.width,
						y1: y,
						y2: y,
						lineWidth: lineWidth,
						dash: dash,
						lineColor: isFunction(this.layout.hLineColor) ? this.layout.hLineColor(lineIndex, this.tableNode) : this.layout.hLineColor
					}, false, overrideY);
					currentLine = null;
				}
			}
		}

		writer.context().moveDown(lineWidth);
	}
};

TableProcessor.prototype.drawVerticalLine = function (x, y0, y1, vLineIndex, writer) {
	var width = this.layout.vLineWidth(vLineIndex, this.tableNode);
	if (width === 0) {
		return;
	}
	var style = this.layout.vLineStyle(vLineIndex, this.tableNode);
	var dash;
	if (style && style.dash) {
		dash = style.dash;
	}
	writer.addVector({
		type: 'line',
		x1: x + width / 2,
		x2: x + width / 2,
		y1: y0,
		y2: y1,
		lineWidth: width,
		dash: dash,
		lineColor: isFunction(this.layout.vLineColor) ? this.layout.vLineColor(vLineIndex, this.tableNode) : this.layout.vLineColor
	}, false, true);
};

TableProcessor.prototype.endTable = function (writer) {
	if (this.cleanUpRepeatables) {
		writer.popFromRepeatables();
	}
};

TableProcessor.prototype.endRow = function (rowIndex, writer, pageBreaks) {
	var l, i;
	var self = this;
	writer.tracker.stopTracking('pageChanged', this.rowCallback);
	writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
	writer.context().availableHeight += this.reservedAtBottom;

	var endingPage = writer.context().page;
	var endingY = writer.context().y;

	var xs = getLineXs();

	var ys = [];

	var hasBreaks = pageBreaks && pageBreaks.length > 0;
	var body = this.tableNode.table.body;

	ys.push({
		y0: this.rowTopY,
		page: hasBreaks ? pageBreaks[0].prevPage : endingPage
	});

	if (hasBreaks) {
		for (i = 0, l = pageBreaks.length; i < l; i++) {
			var pageBreak = pageBreaks[i];
			ys[ys.length - 1].y1 = pageBreak.prevY;

			ys.push({y0: pageBreak.y, page: pageBreak.prevPage + 1});
		}
	}

	ys[ys.length - 1].y1 = endingY;

	var skipOrphanePadding = (ys[0].y1 - ys[0].y0 === this.rowPaddingTop);
	for (var yi = (skipOrphanePadding ? 1 : 0), yl = ys.length; yi < yl; yi++) {
		var willBreak = yi < ys.length - 1;
		var rowBreakWithoutHeader = (yi > 0 && !this.headerRows);
		var hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
		var y1 = ys[yi].y0;
		var y2 = ys[yi].y1;

		if (willBreak) {
			y2 = y2 + this.rowPaddingBottom;
		}

		if (writer.context().page != ys[yi].page) {
			writer.context().page = ys[yi].page;

			//TODO: buggy, availableHeight should be updated on every pageChanged event
			// TableProcessor should be pageChanged listener, instead of processRow
			this.reservedAtBottom = 0;
		}

		for (i = 0, l = xs.length; i < l; i++) {
			var leftBorder = false, rightBorder = false;
			var colIndex = xs[i].index;

			// the current cell
			if (colIndex < body[rowIndex].length) {
				var cell = body[rowIndex][colIndex];
				leftBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
			}

			// the cell from before column
			if (colIndex > 0) {
				var cell = body[rowIndex][colIndex - 1];
				rightBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
			}

			if (leftBorder || rightBorder) {
				this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer);
			}

			if (i < l - 1) {
				var fillColor = body[rowIndex][colIndex].fillColor;
				if (!fillColor) {
					fillColor = isFunction(this.layout.fillColor) ? this.layout.fillColor(rowIndex, this.tableNode, colIndex) : this.layout.fillColor;
				}
				if (fillColor) {
					var wBorder = (leftBorder || rightBorder) ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
					var xf = xs[i].x + wBorder;
					var yf = this.dontBreakRows ? y1 : y1 - hzLineOffset;
					writer.addVector({
						type: 'rect',
						x: xf,
						y: yf,
						w: xs[i + 1].x - xf,
						h: y2 + this.bottomLineWidth - yf,
						lineWidth: 0,
						color: fillColor
					}, false, true, writer.context().backgroundLength[writer.context().page]);
				}
			}
		}

		if (willBreak && this.layout.hLineWhenBroken !== false) {
			this.drawHorizontalLine(rowIndex + 1, writer, y2);
		}
		if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) {
			this.drawHorizontalLine(rowIndex, writer, y1);
		}
	}

	writer.context().page = endingPage;
	writer.context().y = endingY;

	var row = this.tableNode.table.body[rowIndex];
	for (i = 0, l = row.length; i < l; i++) {
		if (row[i].rowSpan) {
			this.rowSpanData[i].rowSpan = row[i].rowSpan;

			// fix colSpans
			if (row[i].colSpan && row[i].colSpan > 1) {
				for (var j = 1; j < row[i].rowSpan; j++) {
					this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
				}
			}
		}

		if (this.rowSpanData[i].rowSpan > 0) {
			this.rowSpanData[i].rowSpan--;
		}
	}

	this.drawHorizontalLine(rowIndex + 1, writer);

	if (this.headerRows && rowIndex === this.headerRows - 1) {
		this.headerRepeatable = writer.currentBlockToRepeatable();
	}

	if (this.dontBreakRows) {
		writer.tracker.auto('pageChanged',
			function () {
				if (!self.headerRows && self.layout.hLineWhenBroken !== false) {
					self.drawHorizontalLine(rowIndex, writer);
				}
			},
			function () {
				writer.commitUnbreakableBlock();
			}
		);
	}

	if (this.headerRepeatable && (rowIndex === (this.rowsWithoutPageBreak - 1) || rowIndex === this.tableNode.table.body.length - 1)) {
		writer.commitUnbreakableBlock();
		writer.pushToRepeatables(this.headerRepeatable);
		this.cleanUpRepeatables = true;
		this.headerRepeatable = null;
	}

	function getLineXs() {
		var result = [];
		var cols = 0;

		for (var i = 0, l = self.tableNode.table.body[rowIndex].length; i < l; i++) {
			if (!cols) {
				result.push({x: self.rowSpanData[i].left, index: i});

				var item = self.tableNode.table.body[rowIndex][i];
				cols = (item._colSpan || item.colSpan || 0);
			}
			if (cols > 0) {
				cols--;
			}
		}

		result.push({x: self.rowSpanData[self.rowSpanData.length - 1].left, index: self.rowSpanData.length - 1});

		return result;
	}
};

module.exports = TableProcessor;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	'4A0': [4767.87, 6740.79],
	'2A0': [3370.39, 4767.87],
	A0: [2383.94, 3370.39],
	A1: [1683.78, 2383.94],
	A2: [1190.55, 1683.78],
	A3: [841.89, 1190.55],
	A4: [595.28, 841.89],
	A5: [419.53, 595.28],
	A6: [297.64, 419.53],
	A7: [209.76, 297.64],
	A8: [147.40, 209.76],
	A9: [104.88, 147.40],
	A10: [73.70, 104.88],
	B0: [2834.65, 4008.19],
	B1: [2004.09, 2834.65],
	B2: [1417.32, 2004.09],
	B3: [1000.63, 1417.32],
	B4: [708.66, 1000.63],
	B5: [498.90, 708.66],
	B6: [354.33, 498.90],
	B7: [249.45, 354.33],
	B8: [175.75, 249.45],
	B9: [124.72, 175.75],
	B10: [87.87, 124.72],
	C0: [2599.37, 3676.54],
	C1: [1836.85, 2599.37],
	C2: [1298.27, 1836.85],
	C3: [918.43, 1298.27],
	C4: [649.13, 918.43],
	C5: [459.21, 649.13],
	C6: [323.15, 459.21],
	C7: [229.61, 323.15],
	C8: [161.57, 229.61],
	C9: [113.39, 161.57],
	C10: [79.37, 113.39],
	RA0: [2437.80, 3458.27],
	RA1: [1729.13, 2437.80],
	RA2: [1218.90, 1729.13],
	RA3: [864.57, 1218.90],
	RA4: [609.45, 864.57],
	SRA0: [2551.18, 3628.35],
	SRA1: [1814.17, 2551.18],
	SRA2: [1275.59, 1814.17],
	SRA3: [907.09, 1275.59],
	SRA4: [637.80, 907.09],
	EXECUTIVE: [521.86, 756.00],
	FOLIO: [612.00, 936.00],
	LEGAL: [612.00, 1008.00],
	LETTER: [612.00, 792.00],
	TABLOID: [792.00, 1224.00]
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

function ImageMeasure(pdfKitDoc, imageDictionary) {
	this.pdfKitDoc = pdfKitDoc;
	this.imageDictionary = imageDictionary || {};
}

ImageMeasure.prototype.measureImage = function (src) {
	var image;
	var that = this;

	if (!this.pdfKitDoc._imageRegistry[src]) {
		try {
			image = this.pdfKitDoc.openImage(realImageSrc(src));
		} catch (error) {
			image = null;
		}
		if (image === null || image === undefined) {
			throw 'invalid image, images dictionary should contain dataURL entries (or local file paths in node.js)';
		}
		image.embed(this.pdfKitDoc);
		this.pdfKitDoc._imageRegistry[src] = image;
	} else {
		image = this.pdfKitDoc._imageRegistry[src];
	}

	return {width: image.width, height: image.height};

	function realImageSrc(src) {
		var img = that.imageDictionary[src];

		if (!img) {
			return src;
		}

		var index = img.indexOf('base64,');
		if (index < 0) {
			return that.imageDictionary[src];
		}

		return Buffer.from(img.substring(index + 7), 'base64');
	}
};

module.exports = ImageMeasure;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).Buffer))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(0).isArray;

function groupDecorations(line) {
	var groups = [], currentGroup = null;
	for (var i = 0, l = line.inlines.length; i < l; i++) {
		var inline = line.inlines[i];
		var decoration = inline.decoration;
		if (!decoration) {
			currentGroup = null;
			continue;
		}
		if (!isArray(decoration)) {
			decoration = [decoration];
		}
		var color = inline.decorationColor || inline.color || 'black';
		var style = inline.decorationStyle || 'solid';
		for (var ii = 0, ll = decoration.length; ii < ll; ii++) {
			var decorationItem = decoration[ii];
			if (!currentGroup || decorationItem !== currentGroup.decoration ||
				style !== currentGroup.decorationStyle || color !== currentGroup.decorationColor) {

				currentGroup = {
					line: line,
					decoration: decorationItem,
					decorationColor: color,
					decorationStyle: style,
					inlines: [inline]
				};
				groups.push(currentGroup);
			} else {
				currentGroup.inlines.push(inline);
			}
		}
	}

	return groups;
}

function drawDecoration(group, x, y, pdfKitDoc) {
	function maxInline() {
		var max = 0;
		for (var i = 0, l = group.inlines.length; i < l; i++) {
			var inline = group.inlines[i];
			max = inline.fontSize > max ? i : max;
		}
		return group.inlines[max];
	}
	function width() {
		var sum = 0;
		for (var i = 0, l = group.inlines.length; i < l; i++) {
			var justifyShift = (group.inlines[i].justifyShift || 0);
			sum += group.inlines[i].width + justifyShift;
		}
		return sum;
	}
	var firstInline = group.inlines[0],
		biggerInline = maxInline(),
		totalWidth = width(),
		lineAscent = group.line.getAscenderHeight(),
		ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize,
		height = biggerInline.height,
		descent = height - ascent;

	var lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;

	switch (group.decoration) {
		case 'underline':
			y += lineAscent + descent * 0.45;
			break;
		case 'overline':
			y += lineAscent - (ascent * 0.85);
			break;
		case 'lineThrough':
			y += lineAscent - (ascent * 0.25);
			break;
		default:
			throw 'Unkown decoration : ' + group.decoration;
	}
	pdfKitDoc.save();

	if (group.decorationStyle === 'double') {
		var gap = Math.max(0.5, lw * 2);
		pdfKitDoc.fillColor(group.decorationColor)
			.rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill()
			.rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2).fill();
	} else if (group.decorationStyle === 'dashed') {
		var nbDashes = Math.ceil(totalWidth / (3.96 + 2.84));
		var rdx = x + firstInline.x;
		pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
		pdfKitDoc.fillColor(group.decorationColor);
		for (var i = 0; i < nbDashes; i++) {
			pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
			rdx += 3.96 + 2.84;
		}
	} else if (group.decorationStyle === 'dotted') {
		var nbDots = Math.ceil(totalWidth / (lw * 3));
		var rx = x + firstInline.x;
		pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
		pdfKitDoc.fillColor(group.decorationColor);
		for (var ii = 0; ii < nbDots; ii++) {
			pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
			rx += (lw * 3);
		}
	} else if (group.decorationStyle === 'wavy') {
		var sh = 0.7, sv = 1;
		var nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
		var rwx = x + firstInline.x - 1;
		pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
		pdfKitDoc.lineWidth(0.24);
		pdfKitDoc.moveTo(rwx, y);
		for (var iii = 0; iii < nbWaves; iii++) {
			pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y)
				.bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
			rwx += sh * 6;
		}
		pdfKitDoc.stroke(group.decorationColor);
	} else {
		pdfKitDoc.fillColor(group.decorationColor)
			.rect(x + firstInline.x, y - lw / 2, totalWidth, lw)
			.fill();
	}
	pdfKitDoc.restore();
}

function drawDecorations(line, x, y, pdfKitDoc) {
	var groups = groupDecorations(line);
	for (var i = 0, l = groups.length; i < l; i++) {
		drawDecoration(groups[i], x, y, pdfKitDoc);
	}
}

function drawBackground(line, x, y, pdfKitDoc) {
	var height = line.getHeight();
	for (var i = 0, l = line.inlines.length; i < l; i++) {
		var inline = line.inlines[i];
		if (!inline.background) {
			continue;
		}
		var justifyShift = (inline.justifyShift || 0);
		pdfKitDoc.fillColor(inline.background)
			.rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height)
			.fill();
	}
}

module.exports = {
	drawBackground: drawBackground,
	drawDecorations: drawDecorations
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc ? doc.createElementNS("http://www.w3.org/1999/xhtml", "a") : []
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__(308) !== null) && (__webpack_require__(309) !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdfmake.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports) {

this.pdfMake = this.pdfMake || {}; this.pdfMake.vfs = {
  "Roboto-Italic.ttf": "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",
  "Roboto-Medium.ttf": "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",
  "Roboto-MediumItalic.ttf": "AAEAAAARAQAABAAQR1BPUyEcbY8AAhQcAABZakdTVULEnLdcAAJtiAAAGXxPUy8yoQuw+wAAAZgAAABgY21hcNhuDxIAABpsAAAGXGN2dCAElytKAAAjUAAAAFZmcGdte/lhqwAAIMgAAAG8Z2FzcAAIABMAAhQQAAAADGdseWZgubUGAAAtcAAB42poZG14LxpP7wAAFYAAAATsaGVhZPi2qwsAAAEcAAAANmhoZWEM2xKRAAABVAAAACRobXR4rRqYNAAAAfgAABOIbG9jYSKZqcwAACOoAAAJxm1heHAHEgLZAAABeAAAACBuYW1lRuRz4wACENwAAAMUcG9zdP9hAGQAAhPwAAAAIHByZXAbsfg2AAAihAAAAMwAAQAAAAIAALDh6v1fDzz1ABsIAAAAAADE8BEuAAAAANDbTpf6Qf3VCXgIcwACAAkAAgAAAAAAAAABAAAHbP4MAAAJN/pB/mwJeAgAAbMAAAAAAAAAAAAAAAAE4gABAAAE4gCPABYAVgAFAAEAAAAAAA4AAAIAAfIABgABAAMEGQH0AAUAAAWaBTMAAAEfBZoFMwAAA9EAZgIAAAACAAAAAAAAAAAA4AAK/1AAIX8AAAAhAAAAAEdPT0cAAQAA//0GAP4AAGYHmgIAIAABnwAAAAAEOgWwACAAIAACA5YAZAAKAAAACgAAAfkAAAH5AAACHwA3Ao4AoQTHADsEcwBCBb0AtQUAAC0BWgCQAr8AaALG/5QDeABnBF0APQG//4kClgA2AjUAMAMc/38EcwBgBHMA7wRzAAsEcwAmBHMACQRzAFoEcwBjBHMAhgRzADsEcwCOAhkAKwHi/5oD/AAyBGIAYgQUAC8D0ACVBvsAMgU0/6QE7wAnBRsAZQUcACcEbQAnBE0AJwVSAGsFjQAnAjsANQRZAAME7gAnBD0AJwbVACcFjAAnBWYAawUAACcFZgBkBOIAJwS5ACQEwACcBRkAWwUPAJsG3gC3BPP/wwTFAKEEtv/lAir/7wNIAKwCKv96A1sARAOK/3kCigDKBD0AIgRoABAEGgA4BGsAOwQ0ADsCygBfBHD/9wRZAA0CBQAfAfz/DAQXABECBQAfBssAEARbAA0EdQA5BGj/xwRyADsCxAAQBAsAHAKfADsEWgBKA+EAZAXOAHcD8f+5A9H/tQPx/+cCpAAwAf0AIAKk/5kFMgBbAfkAAAIY/+YEZQBMBJv/9gV8AAgExQBQAff/7ATc/9wDdADRBh4AXgOAAL4DzgBJBFUAgAKWADYGHgBeA8cA7wL9AOQEMwAbAukAVgLpAGcCkQDIBKH/3QPZAH0COwCeAgr/0wLpAOEDlQC+A84AAgWtALkGBgCxBjAAlgPQ/9IFNP+kBTT/pAU0/6QFNP+kBTT/pAU0/6QHVf+HBRsAZQRtACcEbQAnBG0AJwRtACcCOwA1AjsANQI7ADUCOwA1BTr//wWMACcFZgBrBWYAawVmAGsFZgBrBWYAawQtACMFZAAVBRkAWwUZAFsFGQBbBRkAWwTFAKEErwAnBMsAGwQ9ACIEPQAiBD0AIgQ9ACIEPQAiBD0AIgaXAA8EGgA4BDQAOwQ0ADsENAA7BDQAOwIUACICFAAiAhQAIgIUACIEjQBGBFsADQR1ADkEdQA5BHUAOQR1ADkEdQA5BHgAPQRvACoEWgBKBFoASgRaAEoEWgBKA9H/tQR+/80D0f+1BTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBRsAZQQaADgFGwBlBBoAOAUbAGUEGgA4BRsAZQQaADgFHAAnBQEAOwU6//8EiQA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADwEbQAnBDQAOwVSAGsEcP/3BVIAawRw//cFUgBrBHD/9wVSAGsEcP/3BY0AJwRZAA0FjgAuBHcAKwI7ADUCFAAUAjsANQIUAB8COwA1AhQAIgI7/44CBf92AjsANQIUACIGlAA1BAEAHwRZAAMCIP8PBO4AJwQXABEEfwAhBD0AJwIFAB8EPQAnAgX/ogQ9ACcCmwAfBD0AJwLhAB8ETAAhAkcAHwWMACcEWwANBYwAJwRbAA0FjAAnBFsADQRbAA0FcgAjBG8AEQVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQeDAFAHDQBCBOIAJwLEABAE4gAnAsT/nATiACcCxAAQBLkAJAQLABwEuQAkBAsAHAS5ACQECwAcBLkAJAQLABwEwACcAp8AOwTAAJwCxwA7BMAAnAKf/+IFGQBbBFoASgUZAFsEWgBKBRkAWwRaAEoFGQBbBFoASgUZAFsEWgBKBRkAWwRaAEoG3gC3Bc4AdwTFAKED0f+1BMUAoQS2/+UD8f/nBLb/5QPx/+cEtv/lA/H/5wIGAB4FaABOAsT/SgVpAFsEhQA2BYMAWwTWAEoCIP8PBVIAawRw//cFjAAnBFsADQU0/6QEPQAiB1X/hwaXAA8FZAAVBG8AKgU0/6QEPQAiBG0AJwQ0ADsCO//JAhT/fgVmAGsEdQA5BOIAJwLEAAcFGQBbBFoASgS5ACQECwAcBMAAnAKfADsCIP8PBCUANgG5AIoD0gECA54BDQPIAO8DawD+AgUBAgKnAPoCRf+oA8QA3gMRAKwCY//uAAr9VAAK/dcACvz2AAr91gAK/L8ACvygAlUBLgQlAOgFNP+kAjsAngTR/74F8f/GAp//ygV6ABgFKf9YBVAAHQKgAAsFNP+kBO8AJwRdAC4Fnf+qBG0AJwS2/+UFjQAnBVoAXgI7ADUE7gAnBRr/sgbVACcFjAAnBHcAAAVmAGsFjwAuBQAAJwR3/9wEwACcBMUAoQXLAFIE8//DBYkAdQU8AAkCOwA1BMUAoQRrAD4ESAAoBG8AEQKgAG4ESABXBGsAPgSr/+UD+QB3BG8AOARIACgEBQBmBG8AEQSHAGwCoABuBH8AIQRS/6gEof/dA+EAZAP+AD4EdQA5BNcAXQRv/8sEIQA7BHcAOAQXAG4ESABXBa0AMgPx/7kFpwA/BmsAVAKgAEwESABXBHUAOQRIAFcGawBUBJkAUARjAG0Ex/8kBkoAVwRtACcEbQAnBdoAkQRdAC4FOgBnBLkAJAI7ADUCOwA1BFkAAwhQ/8oIVwAuBjQAoATuACcFhwAnBO0AmwWJACUFNP+kBOsAIwTvACcEXQAuBeL/hARtACcHcf+lBLsAHgWHACcFhwAnBQoALgWI/8oG1QAnBY0AJwVmAGsFjwAuBQAAJwUbAGUEwACcBO0AmwY4AFYE8//DBdUAJQVoAMUHawArB8YAKwX1AIkGzQAuBOoAIwUxAE8HJgAyBNv/sAQ9ACIEZQBDBHYAIgNKABgE2v+FBDQAOwZO/60EAQAWBH8AGQR/ABkEVgAiBIH/vwXfACIEfgAZBHUAOQR/ABkEaP/HBBoAOAPhAFMD0f+1BbAAPQPx/7kEuAAZBE4AcAZmABkGwQASBPoATwZIACIEUAAiBCUAIwZcACQEWP+2BDQAOwQ0ADsEWQANA0oAGAQlADsECwAcAgUAHwIUACIB/P8MBqf/vQa5ABkEcAANBFYAIgR/ABkD0f+1BH8AGQcbAGAGKQBEBOoAIwRPACEG+wArBd0AGQTv/64ESP+cBxQAPgYQADAGwgAUBcMAFgj1ADUHxgAiBAr/qgPc/7UFiQB1BacAPwVaAGIEbwA2BP0AqAP5AHcE/QCoA/kAdwk3AGsIRgA5BVoAZgRvADgHFwBiBh4ASwcbAGAGKQBEBP0AVgQzAEUE4wA4AAr85gAK/Q4ACv4rAAr+PAAK+kEACvpvBYcAJwR/ABkE6gAjBE8AIQT2ACcEbf/HBFIAIgOPABEEXf/8A0r/ywSdAC4ECgARB3H/pQZO/60EuwAeBAEAFgUKAC4EVgAiBQ4AIwSRACEFHgA3BC4AGQZsAKQFgwBsBY0AJwR+ABkHngAnBYkAEQgRAC4GygARBgUAZQTjAEsFGwBlBBoAOATAAJwD4QBTBMUAoQP5AHcExQChA/kAVATz/8MD8f+5BwQAnQVQAFYFaADFBE4AcAVUALkEWwCFBWcA5wRZAA0F/wBiBKj/9AX/AGIEqP/0AjsANQdx/6UGTv+tBQQAIwRgACEFiP/KBIH/vwWNAC4EbwARBY0AJwR+ABkFaADFBE4AcAbVACcF3wAiAjsANQU0/6QEPQAiBTT/pAQ9ACIHVf+HBpcADwRtACcENAA7BWgASAQlADYFaABIBCUANgdx/6UGTv+tBLsAHgQBABYEjAAvBIz/8AWHACcEfwAZBYcAJwR/ABkFZgBrBHUAOQVaAGIEbwA2BVoAYgRvADYFMQBPBCUAIwTtAJsD0f+1BO0AmwPR/7UE7QCbA9H/tQVoAMUETgBwBF0ALgNKABgGzQAuBkgAIgSsADMDQwAJBPP/wwPx/7kE8//DA/H/uQTqADAEawA7BsYARQayAEcGLACqBQoAYQRjAJIEJwCMB43/3gZ0/94HygAnBnUACwTnAEwEFgA9BYkAkAUAAHMFNgBWBEgAKAWI/8oEgf+/BTT/pAQ9ACIE7wAnBGgAEAUcACcEawA7BRwAJwRrADsFjQAnBFkADQTuACcEFwARBO4AJwQXABEEPQAnAgX/5AbVACcGywAQBtUAJwbLABAFjAAnBFsADQUAACcEaP/HBOIAJwLE/94EuQAkBAsAHATAAJwCnwA7BQ8AmwPhAGQFDwCbA+EAZAbeALcFzgB3Bt4AtwXOAHcG3gC3Bc4AdwbeALcFzgB3BLb/5QPx/+cFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIFNP+kBD0AIgU0/6QEPQAiBTT/pAQ9ACIEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7BG0AJwQ0ADsEbQAnBDQAOwRtACcENAA7AjsANQIUACICO///AgX/5AVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQVmAGsEdQA5BWYAawR1ADkFZgBrBHUAOQVmAGsEdQA5BWkAWwSFADYFaQBbBIUANgVpAFsEhQA2BWkAWwSFADYFaQBbBIUANgUZAFsEWgBKBRkAWwRaAEoFgwBbBNYASgWDAFsE1gBKBYMAWwTWAEoFgwBbBNYASgWDAFsE1gBKBMUAoQPR/7UExQChA9H/tQTFAKED0f+1BMUAoQPR/7UFrP6zAx4A7AP/AAAH9AAAA/8AAAf0AAACrgAAAgQAAAFcAAAEZgAAAikAAAGfAAAA1QAAAAoAAAKXADYClwA2BQsAnAYKAIIGCgCCA4v/TgG9AK4BuQCKAcr/pAGlAM0DBgC3Aw0AlwL7/6EERQBpBID/+wLAAJ4D5QAzBYUAMwFrADYHdgCdAVoAkAKOAKECaQBdAmD/+QQ+ADcDiv/hAukAYwNMAG4ETf/DBJv/9gZJAA0GjgArCFsAJwdYACoGZAAQBIn/9ARzAE4F0QBCBB4AOwSIABAFP//kBV3/5gXBAMIDzgAxB/kAIwTsAO0E9wB9Bg8AtgayAIIGpwCIBnkAtQR4AEUFdQAfBL7/pwRqAJwEmAA0CA8ASQIm/xcEdQAwBGIAYgP8/9UEFAAXA/cAOgJTAGkCjgBmAez/zwT+AF8EjgBLBKIAXwb2AF8G9gBfBPQAXwaNABcACgAAB/v/qQg1AFwDhv/XBGP/pwSmADoEY/+nA6YACgQ2AC0ETgARBB4ADgQXABQFGwAuBBoAFAUKAC4FJgAuBKEAOwQl/4cCpwEGBL0ACgLpADMC6QAIAukAIwLpABYC6QAKAun/8QLp//QC6f/jAukAbQLpABcEBP/ZBXwAQwU1AHAEyAAAA6YAkwXjAIwEYwBwBGsAOQQlAGIEHgAOBEUACgSmADcEVQAKBKYAOgTCAAoF4gAKA6YACgREAAoDwv/yAfcAGATDAAoEjAA/A7IACgPMAAoEYgAKBGcAOQRIAAoEhf+bAf8A6wOPAQQD9gDcA/YAEwP2ANgD9gDXA48BBAOPAQUDjwEEBEb/pAQlAG0EZwA5BXAAYgQdAFUEegAqAgr/BwGw/7IEFP/WByb/wQcpAAoFdgBiBLwACgRZAAsFOv+DBhT/qQQvAAwEyAALBEUACgSw/8EELwByBT4ACgRzAF0GXAAKBt4ACgU7AEoF+wALBE8ACwRnABMGagAKBG//0gQM//UGav+pBIQACgT9AAoFTgBiBcwAQARDAG0Eqf+kBmwAYgRzAF0EcwAKBdoANwS3ADQELwAMBKYAOgROAAQD4wAeCAEACgTP/9kEbwAQBCYANwR/ADsDkgCkBIcANAR7/8cEhgA7BDQAOwRwADAFWgBvBYEAcQVmAC4FvQByBb8AcgQFAKsEaQAfA6YACgRA/38EpP/RAukAigLpAGQC6QB9AukAiQLpAJYC6QB7AukApgRT/9QEGAAnBm8AOgSaAEcEzwBOAiD/DwIg/w8CFQAiAhX/fQIVACIESAAKBGL/lwRi/5cEJQBiBIX/mwSF/5sEhf+bBIX/mwSF/5sEhf+bBIX/mwRnADkDzAAKA8wACgPMAAoDzAAKAfcAGAH3ABgB9wAYAfcAGATCAAoEpgA6BKYAOgSmADoEpgA6BKYAOgRrADkEmwB0BIcAjgRzAFoEcwAJBHMAJgRzAAsEawA5BGsAOQRrADkEJQBtBIX/mwSF/5sEhf+bBGcAOQRnADkEZwA5BGcAOQRiAAoDzAAKA8wACgPMAAoDzAAKA8wACgSMAD8EjAA/BIwAPwSMAD8EwwAKAfcADQH3ABgB9wAYAff/igH3ABgDwv/yBEQACgOmAAoDpgAKA6YACgOmAAoEwgAKBMIACgTCAAoEpgA6BKYAOgSmADoERQAKBEUACgRFAAoEHgAOBB4ADgQeAA4EHgAOBCUAYgQlAGIEJQBiBGsAOQRrADkEawA5BGsAOQRrADkEawA6BeMAjAQlAG0EJQBtBBT/1gQU/9YEFP/WBIX/mwQI/20E//94AjP/ewSw/9IEYf8sBNL/4gSF/5sESAAKA8wACgQU/9YEwwAKAfcAGAREAAoF4gAKBKYAOgRVAAoEJQBiBCUAbQRG/6QB9wAYBCUAbQPMAAoDpgAKBB4ADgH3ABgB9wAYA8L/8gREAAoELwByBIX/mwRIAAoDpgAKA8wACgTIAAsF4gAKBMMACgSmADoEvQAKBFUACgRnADkEJQBiBEb/pAQvAA0EwwAKBGcAOgQlAG0F2gA3BMgACwQvAHIFfABDBTT/pAQ9ACIEbQAnBDQAOwIU/+QAAAABAAAE5AkKBAAAAgICAwUFBgYCAwMEBQIDAgQFBQUFBQUFBQUFAgIEBQUECAYGBgYFBQYGAwUGBQgGBgYGBgUFBgYIBgUFAgQCBAQDBQUFBQUDBQUCAgUCCAUFBQUDBQMFBAcEBAQDAgMGAgIFBQYFAgUEBwQEBQMHBAMFAwMDBQQDAgMEBAYHBwQGBgYGBgYIBgUFBQUDAwMDBgYGBgYGBgUGBgYGBgUFBQUFBQUFBQcFBQUFBQICAgIFBQUFBQUFBQUFBQUFBAUEBgUGBQYFBgUGBQYFBgUGBgYFBQUFBQUFBQUFBQYFBgUGBQYFBgUGBQMCAwIDAgMCAwIHBQUCBgUFBQIFAgUDBQMFAwYFBgUGBQUGBQYFBgUGBQgIBgMGAwYDBQUFBQUFBQUFAwUDBQMGBQYFBgUGBQYFBgUIBwUEBQUEBQQFBAIGAwYFBgUCBgUGBQYFCAcGBQYFBQUDAgYFBgMGBQUFBQMCBQIEBAQEAgMDBAMDAAAAAAAAAwUGAwUHAwYGBgMGBgUGBQUGBgMGBggGBQYGBgUFBQcGBgYDBQUFBQMFBQUEBQUFBQUDBQUFBAQFBQUFBQUFBgQGBwMFBQUHBQUFBwUFBwUGBQMDBQkJBwYGBgYGBgYFBwUIBQYGBgYIBgYGBgYFBgcGBwYICQcIBgYIBQUFBQQFBQcFBQUFBQcFBQUFBQQEBgQFBQcIBgcFBQcFBQUFBAUFAgICBwgFBQUEBQgHBgUIBwYFCAcIBgoJBQQGBgYFBgQGBAoJBgUIBwgHBgUGAAAAAAAABgUGBQYFBQQFBAUFCAcFBQYFBgUGBQcGBgUJBgkIBwYGBQUEBQQFBAYECAYGBQYFBgUHBQcFAwgHBgUGBQYFBgUGBQgHAwYFBgUIBwUFBgUGBQgHBQUFBQYFBgUGBQYFBgUGBQYEBgQGBAYFBQQIBwUEBgQGBAYFCAgHBgUFCQcJBwYFBgYGBQYFBgUGBQYFBgUGBQYFBgUFAggICAgGBQYFBgMFBQUDBgQGBAgHCAcIBwgHBQQGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUFBQUFBQUFBQUFBQUFBQUFAwIDAgYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQQFBAUEBQQGBAUJBQkDAgIFAgIBAAMDBgcHBAICAgIDAwMFBQMEBgIIAgMDAwUEAwQFBQcHCQgHBQUHBQUGBgYECQYGBwgHBwUGBQUFCQIFBQQFBAMDAgYFBQgIBgcACQkEBQUFBAUFBQUGBQYGBQUDBQMDAwMDAwMDAwMFBgYFBAcFBQUFBQUFBQUHBAUEAgUFBAQFBQUFAgQEBAQEBAQEBQUFBgUFAgIFCAgGBQUGBwUFBQUFBgUHCAYHBQUHBQUHBQYGBwUFBwUFBwUFBQUECQUFBQUEBQUFBQUGBgYGBgUFBAUFAwMDAwMDAwUFBwUFAgICAgIFBQUFBQUFBQUFBQUEBAQEAgICAgUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUFAgICAgIEBQQEBAQFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBQUGAgUFBQUFBAUFAgUHBQUFBQUCBQQEBQICBAUFBQUEBAUHBQUFBQUFBQUFBQUHBQUGBgUFBQIAAAADAAAAAwAAABwAAwABAAAAHAADAAoAAAKkAAQCiAAAAJ4AgAAGAB4AAAACAA0AfgF/AY8BkgGhAbAB8AH/AhsCNwJZArwCxwLJAt0C8wMBAwMDCQMPAyMDigOMA6EDzgPSA9YEhgUTHgEePx6FHvkfTSALIBEgFSAeICIgJyAwIDMgOiA8IEQgdCB/IKQgrCCxILogvSEFIRMhFiEiISYhLiFeIgIiBiIPIhIiGiIeIisiSCJgImUlyu4C9sP7BP7///3//wAAAAAAAgANACAAoAGPAZIBoAGvAfAB+gIYAjcCWQK8AsYCyQLYAvMDAAMDAwkDDwMjA4QDjAOOA6MD0QPWBAAEiB4AHj4egB6gH00gACAQIBMgFyAgICUgMCAyIDkgPCBEIHQgfyCjIKYgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5P/D/7T/sv+l/5j/Wf9U/0j/Lf8M/qr+of6g/pL+ff5x/nD+a/5m/lP98/3y/fH98P3u/ez9w/3C5NbkqOR45GLkD+Ne41rjWeNY41fjVeNN40zjR+NG4z/jEOMG4uPi4uLe4tfi1uKP4oLigOJ14HPiauI+4Zvff+GP4Y7hh+GE4XjhXOFF4ULd3hWoDOgIrAS0A7gAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAAAA7gAAAAAAAAATgAAAAAAAAAAAAAAAQAAAAIAAAACAAAAAgAAAA0AAAANAAAAAwAAACAAAAB+AAAABAAAAKAAAAF/AAAAYwAAAY8AAAGPAAABQwAAAZIAAAGSAAABRAAAAaAAAAGhAAABRQAAAa8AAAGwAAABRwAAAfAAAAHwAAABSQAAAfoAAAH/AAABTgAAAhgAAAIbAAABYAAAAjcAAAI3AAABZAAAAlkAAAJZAAABZQAAArwAAAK8AAABZgAAAsYAAALHAAABZwAAAskAAALJAAABaQAAAtgAAALdAAABagAAAvMAAALzAAABcAAAAwAAAAMBAAABcQAAAwMAAAMDAAABcwAAAwkAAAMJAAABdAAAAw8AAAMPAAABdQAAAyMAAAMjAAABdgAAA4QAAAOKAAABdwAAA4wAAAOMAAABfgAAA44AAAOhAAABfwAAA6MAAAPOAAABkwAAA9EAAAPSAAABvwAAA9YAAAPWAAABwgAABAAAAASGAAABwwAABIgAAAUTAAACSgAAHgAAAB4BAAAC1gAAHj4AAB4/AAAC5gAAHoAAAB6FAAAC+AAAHqAAAB75AAADAgAAH00AAB9NAAADXAAAIAAAACALAAADXgAAIBAAACARAAADagAAIBMAACAVAAADbAAAIBcAACAeAAADbwAAICAAACAiAAADdwAAICUAACAnAAADegAAIDAAACAwAAADfQAAIDIAACAzAAADfgAAIDkAACA6AAADgAAAIDwAACA8AAADggAAIEQAACBEAAADgwAAIHQAACB0AAADhAAAIH8AACB/AAADhQAAIKMAACCkAAADhgAAIKYAACCsAAADiAAAILEAACCxAAADjwAAILkAACC6AAADkAAAILwAACC9AAADkgAAIQUAACEFAAADlAAAIRMAACETAAADlQAAIRYAACEWAAADlgAAISIAACEiAAADlwAAISYAACEmAAABmQAAIS4AACEuAAADmAAAIVsAACFeAAADmQAAIgIAACICAAADnQAAIgYAACIGAAABhQAAIg8AACIPAAADngAAIhEAACISAAADnwAAIhoAACIaAAADoQAAIh4AACIeAAADogAAIisAACIrAAADowAAIkgAACJIAAADpAAAImAAACJgAAADpQAAImQAACJlAAADpgAAJcoAACXKAAADqAAA7gEAAO4CAAADqQAA9sMAAPbDAAADqwAA+wEAAPsEAAADrQAA/v8AAP7/AAADswAA//wAAP/9AAADtLAALEuwCVBYsQEBjlm4Af+FsIQdsQkDX14tsAEsICBFaUSwAWAtsAIssAEqIS2wAywgRrADJUZSWCNZIIogiklkiiBGIGhhZLAEJUYgaGFkUlgjZYpZLyCwAFNYaSCwAFRYIbBAWRtpILAAVFghsEBlWVk6LbAELCBGsAQlRlJYI4pZIEYgamFksAQlRiBqYWRSWCOKWS/9LbAFLEsgsAMmUFhRWLCARBuwQERZGyEhIEWwwFBYsMBEGyFZWS2wBiwgIEVpRLABYCAgRX1pGESwAWAtsAcssAYqLbAILEsgsAMmU1iwQBuwAFmKiiCwAyZTWCMhsICKihuKI1kgsAMmU1gjIbDAioobiiNZILADJlNYIyG4AQCKihuKI1kgsAMmU1gjIbgBQIqKG4ojWSCwAyZTWLADJUW4AYBQWCMhuAGAIyEbsAMlRSMhIyFZGyFZRC2wCSxLU1hFRBshIVktsAossClFLbALLLAqRS2wDCyxJwGIIIpTWLlAAAQAY7gIAIhUWLkAKQPocFkbsCNTWLAgiLgQAFRYuQApA+hwWVlZLbANLLBAiLggAFpYsSoARBu5ACoD6ERZLbAMK7AAKwCyAQ0CKwGyDgECKwG3DjowJRsQAAgrALcBOC4kGhEACCu3Ak5AMiMVAAgrtwNIOy4hFAAIK7cETkAyIxUACCu3BTAoHxYOAAgrtwZjUT8tGwAIK7cHQDQkGhEACCu3CFtKOikZAAgrtwmDZE46IwAIK7cKd2JMNiEACCu3C5F3XDojAAgrtwx2YEs2HQAIK7cNLCQcFAwACCsAsg8NByuwACBFfWkYRLKwEwFzslATAXSygBMBdLJwEwF1sg8fAXOybx8BdQAqAMwAkQCeAJEA7AByALIAfQBWAF8ATgBgAQQAxAAAABT+YAAUApsAEP85AA3+lwASAyEACwQ6ABQEjQAQBbAAFAYYABUGwAAQAlsAEgcEAAUAAAAAAAAAAABgAGAAYABgAGAAnQDIAUYB1QKDAxYDMQNgA4sDvgPmBAUEHARFBFwEvQTsBUUFwAYGBnEG4gcQB5kICAgUCCAIQQhpCIoI+Qm1CfUKYwrDCxMLVguOC/gMOwxWDJAM2Qz+DVgNlg36DkoOtQ8RD4cPsw/5ECoQeRDDEPURLxFVEWwRkxG6EdUR9RKCEu0TQxOrFCcUfxUMFVYVlBXmFi8WSxbDFxIXbRfaGEsYixkEGVwZqhnaGikacRq1Gu8bPRtUG6Ib5xvnHCQciBz2HWMdyh3rHosewh93H/Af/CAaICIg5iD9IT8hhCHdIlIiciLEIvMjFyNJI3gjzSPZI/MkDSQnJJgkryTGJN0k7yUCJRUleiWGJZ0ltCXLJd4l9SYMJiMmNiajJrUmzCbeJvAnAicVJ1EnzyfmJ/0oFCgsKEMomykQKScpPilUKWopgimaKn8qiyqiKrkqzyrmKvwrEispK0EruyvRK+gr/ywVLCssPSyZLRctLi1ALVEtZC12Ldkt6y4CLhMuJS43LqcvVi9oL3ovjC+dL68vwS/TL+Qv+zAHMHQw/DETMSQxNjFHMVkxazHfMn4ylTKmMrgyyTLbMuwy/jMQMxwzLjNFM1czujQkNDY0SDRfNHY0iDSaNKU0sDTCNN006TT1NQc1HjUqNTY1hDWbNbI1vjXKNd817zX7Ngc2UzaTNqo2vDbINtQ26zb8Nww3aDfLN9037jgAOBI4JTg4OMY5gzmVOac5szm/OdE54jn0OgY6GDopOjU6QTpTOmQ6cDp8OpM6nzrlO1g7ajt7O407njuwO8I71TvoO/s8Djx5PPI9CT0gPTc9TT1gPXc9jj2gPbI9xD3VPgo+fD7nP2I/1kAzQJlAq0C9QM9A5kD9QQlBFUEsQT5BVUFsQYRBnEG0QcxB5EH8QhRCLEJEQlxCdEKMQphCpEKwQrxC60NVQ2FDnEPEQ8xD/EQiRGFEjkTVRQtFUUVwRZBFmUXLRf1GHkY3RolGlEacRqhGtEbARsxG2EbkRvpHAkcKRzFHXkdmR25HdkgASAhIEEg9SEVITUiPSJdIx0jPSQ1JFUkdSZtJo0oDSnJKhUqYSqpKvErOSt9K9Et+S/lMLUytTT5Nm03qTnFOok6qTwVPDU8VT4xPlE/sUE9Qt1EnUW9RulIqUjJSlFMPUyJTNFNGU1hTalPqVERUUFTPVOZU+VVhVXhV91ZtVnVWiFaQVw5XhVfgV/dYDlggWF9YZ1jDWMtY01ksWTRZoVopWmRadlp+Wspa0lraWuJa6lryWvpbAltHW8JbylwCXElciVzVXTBdmF3pXmle9V9VX11f22BcYINg3GDkYVNh6WIkYjZiiGLRYxxjdWN9Y61jtWQLZDhkQGTgZOhlIGVoZahl8GZLZrFnAGdzZ/5oXWh0aIZpBWkcaYVpjWmVaahpsGopaqBrCmshazhrSWuIa/lsZWzSbUBty25YbqVu9G9hb9BwSHC6cUxx3HJ5cyhzMHM4c7V0JXRpdK50xnTedOp09nVqddh2s3eIeBh4qHkFeV95k3mweel6AHoXevJ7YXt8e5d8BHxzfM99S317faV95n4ofoR+037ffut+938Dfw9/G391f8yALICKgNyBM4E/gUuBmIHpgk+CqYNUg++D+4QHhBOEH4QnhC+Ee4TLhNeE44UshXKFfoWKheGGMYZ2hn6HAIeNh5mHpYeth7+H0YgziI6ImoimiQmJZ4lziX+Ji4mXiaOJr4m3icmJ24nuigGKCYoRiiOKNIqniq+KworUiueK+osNix+Lhovni/6MFIwnjDqMTYxfjGeMb4yCjJSMp4y5jMuM3IzvjQGNFI0sjT+NUY1djWmNhY2hjbCNwI3MjdiOMo6JjtyO5I9Oj+eQY5DakU2Ru5Iukp2TEJOCk+OUOpSTlOqVb5V3lYOVj5WblaeVs5W/lcuV15Xjle+V+5YHlhmWK5Y3lkOWT5ZblnKWhJaQlpyWqJa0lsaW2JbklvCW/JcIlxSXIJcyl0OXT5dbl3KXiZegl7eXypfdl+mX9ZgBmA2YGZglmDeYSZhhmHiYkJinmL+Y1pjumQWZIJk6mVKZaZl8mY6ZoZmzmcaZ2Jnzmg6aGpommjiaSppcmm2ahZqcmrSay5rjmvqbEpspm0SbXptwm4Kbjpuam6abspvEm9ab7pwFnB2cNJxMnGOce5ySnK2cx5zenPWdDJ0jnTqdUZ1onX6dip2WnaKdrp3Fndyd854KniGeOJ5PnmaefZ6Tnp+eq57Cntie5J7wnwKfFJ8mnzefQ59vn2+fb59vn2+fb59vn2+fb59vn2+fb59vn3eff5+Jn5OfnZ+4n9qf/KAboD2gSaBVoIigyaEuoVOhX6FvoYiicqKBopiitKLRot2i8KMEo0+jW6PqpJOlLqU6pgymd6aRpxin1Kg3qLipF6mMqj2qqqtIq6msE6wtrEesYax7rPStHK1WrW2toq5Broiu/69Ar0+vXq+Xr6qv1K/tr/mwaLDKsXKyDrKas3CzcLU2tZ+16rYbtpi2zrb5t3O33rhduKC45LksuXa57bpkuyi7fLuvvBy8rLzZvUG9qr3vvmS+vL7mvzi/fL/twE3AuMDPwRrBSsGNwbnCMcKMwu/DPcOew9jEK8RQxJXEy8TmxUPFr8Xqxi/GfcbZx2jHpsfFyBPIWsigyP7JdMnDyiTKmcrjyxTLj8vxzB7MqMzZzO/NBc16zfDOSM6KzubPPc+60BvQWdCz0PfRQNF70cLR/dI+0prSptL302/T/NRa1J/VJ9WO1ffWXNbz1v/XUteh1/XYPdix2RrZgNoA2pjbIdvD3ETcsd0J3XPde93c3kXes98t37TgFOCD4NPhPuGt4djiM+Jh4r7jCOMc4zDjQuNW42jjf+OT4/bkHeSn5RjlduV+5YbljuWZ5aHmD+Y65mXmdeaM5qPmuebK5t3m8Ob85wjnH+c250znXud054rnoee058bn3efv6ADoEugl6DzoROhM6FToXOhk6GzofuiP6KLouejP6OHpVeln6Xjpiumb6bHpx+nY6erqXup06oXql+qp6rXqy+rd6vTrBusR6yLrOetF61vrZ+t864jrn+ur68Lr0+vl6/jsCuwW7CfsOexK7FbsZ+xz7Insleym7Lfsyezc7O/tWe1w7YbtmO2v7cHt++4H7hPuH+4r7jfuQ+5P7lfuX+5n7m/ud+5/7ofuj+6X7p/up+6v7rfuyu7c7u7vAO8I7xDvI+8r7z3vT+9X71/vZ+9v74Hvie+R75nvoe+p77Hvue/B8F3w0vE68ULxTvFg8XHxefGF8ZHxnfGp8bUAAAAFAGQAAAMoBbAAAwAGAAkADAAPAG+yDBARERI5sAwQsADQsAwQsAbQsAwQsAnQsAwQsA3QALAARViwAi8bsQIfPlmwAEVYsAAvG7EADz5ZsgQCABESObIFAgAREjmyBwIAERI5sggCABESObAK3LIMAgAREjmyDQIAERI5sAIQsA7cMDEhIREhAxEBAREBAyEBNQEhAyj9PALENv7u/roBDOQCA/7+AQL9/QWw+qQFB/19Anf7EQJ4/V4CXogCXgACADf/7wIgBbAAAwAOADuyAg8QERI5sAIQsAvQALAARViwAi8bsQIfPlmwAEVYsAwvG7EMDz5ZsgcNCitYIdgb9FmwAdCwAS8wMQEjEzMBNDY3NhYUBgcGJgFWzJz6/hdLOjlOSzo3UAGtBAP6vztMAgJKcksCAkcAAAIAoQP0AsIGAAAEAAkAJQCwAEVYsAMvG7EDIT5ZsALQsAIvsAfQsAcvsAMQsAjQsAgvMDEBAyMTMwUDIxMzAYdcilOqAQ1cilOqBWz+iAIMlP6IAgwAAgA7AAAE5QWwABsAHwCNALAARViwDC8bsQwfPlmwAEVYsBAvG7EQHz5ZsABFWLACLxuxAg8+WbAARViwGi8bsRoPPlmyHQwCERI5sB0vsgADCitYIdgb9FmwBNCwHRCwBtCwHRCwC9CwCy+yCAMKK1gh2Bv0WbALELAO0LALELAS0LAIELAU0LAdELAW0LAAELAY0LAIELAe0DAxASMDIxMjNzMTIzchEzMDMxMzAzMHIwMzByMDIwMzEyMCltORqpHeHPpv6RwBBZWpldSUqZTHHORu1BzxkakJ02/TAZr+ZgGangE5nwGg/mABoP5gn/7Hnv5mAjgBOQAAAQBC/y0EUQabADUAb7InNjcREjkAsABFWLAQLxuxEB8+WbAARViwJy8bsScPPlmyBCcQERI5sBAQsA3QshUnEBESObAQELIYAQorWCHYG/RZsAQQsh8BCitYIdgb9FmwJxCwKtCyLhAnERI5sCcQsjIBCitYIdgb9FkwMQE2JyYnJiYnJjc2NzY3NzMHFhcWByM2JicmBgcGFxYXFhcWBwYHBgcHIzcmJyY3FwYWFxY3NgL+CSkodjteJKoOC3JxtSidKZVKTArsCVRYXXwNCSgodHU+uA8Ld3W9JJwlp1lYCe0HZWNqR0kBg0w4OTEZMxyBz6psbRXa3iB4er6AjAMCb2NNNTYzNCyC2q1raRTDxBl6eb8BgIYCAjk6AAUAtf/nBT4FyAANABsAKQA3ADsAibInPD0REjmwJxCwBdCwJxCwFtCwJxCwK9CwJxCwONAAsDgvsDovsABFWLAALxuxAB8+WbAARViwIy8bsSMPPlmwABCwB9CwBy+yEQIKK1gh2Bv0WbAAELIYAgorWCHYG/RZsCMQsBzQsBwvsCMQsi0CCitYIdgb9FmwHBCyNAIKK1gh2Bv0WTAxARYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwEWFgcHBgYnJiY3NzY2AwYWFxY2Nzc2JicmBgcFJwEXAg+DkggGD7mCfpkIBw23JAc4OjxYCwkHODs9WggCvYKTCAYOuoJ8mgYFC7kiBTo3PVUMCgU6N0BYCP3xeANveAXGBKqATYmmBAKqf0qJqv6BQFcCAldGTkFYAgJdSv4CBKp+ToepBAKmhEGOrf6CRVMCAlNLT0hQAgJdSO5PBGdPAAMALf/pBKEFyAAeACgANABysi01NhESObAtELAR0LAtELAh0ACwAEVYsAkvG7EJHz5ZsABFWLAYLxuxGA8+WbAARViwHC8bsRwPPlmyEgkYERI5shUJGBESObIfAQorWCHYG/RZsiMJGBESObIsCRgREjmwCRCyMgEKK1gh2Bv0WTAxEzY3NyYmNzY2Fx4CBwYGBwcTNjc3AgcXIScGJyYmBRY2NwMHBgcGFhMGFxc3Njc2JiMiBjgMxnI9KAQM5KxdllAFBWl2edZTFcsYoKH+/j2wx7vsAbdEeDjzIokRDGhwCjAXY4EMBkg3SGQBgbaMS3CNP6rUBANSkVdanVJQ/rx8kAH+8K36X3YEAt4eATQjAXEWYHdgeAOgRVwqPlJqOUlpAAEAkAP8AZYGAAAEABYAsABFWLADLxuxAyE+WbAC0LACLzAxAQMjEzMBgVSdUbUFd/6FAgQAAAEAaP4xAyAGYAARABCyBhITERI5ALADL7AMLzAxExIANxcAAwYHBhIXByYCEzY3gDUBT/gk/qpmJQECZGI4q7cIAgwCTAFtAjlukP74/czOv8v+0VeFagHAASpgVgAB/5T+LwJQBl8ADwAQsgkQERESOQCwCC+wAC8wMQMnNhITNxAnNxYWEgcCAgBHJdTwGgTEOXOjTwQJs/7e/i+KpQIvAX98AaWshkb9/qS1/un99f6XAAEAZwJLA6UFsAAOACAAsABFWLAELxuxBB8+WbAA0BmwAC8YsAnQGbAJLxgwMQElNwUTMwMlFwUTBwMDJwF//uhPARctsEsBLhj+wZeVfNyGA9FYoXcBXf6ocLRY/vFiASH+7G4AAAEAPQCSBC4EtgALABoAsAkvsADQsAkQsgYBCitYIdgb9FmwA9AwMQEhByEDIxMhNyETMwK9AXEn/pBL50z+jCgBckbnAyHe/k8Bsd4BlQAAAf+J/rgBFADrAAcAGLIHCAkREjkAsAgvsgQNCitYIdgb9FkwMRMnNjc3MwcGCH92GyXVGij+uFCed86h9wABADYCCQJYAs0AAwARALACL7IBAQorWCHYG/RZMDEBITchAjX+ASMB/wIJxAAAAQAw//IBQwEDAAsAIrIIDA0REjkAsABFWLAJLxuxCQ8+WbIDDQorWCHYG/RZMDE3NDY3NhYVFAYHBiYwTTw7T0w9O091PU0CAks7Ok0CAkoAAAH/f/+DA4IFsAADABMAsAAvsABFWLACLxuxAh8+WTAxFyMBM0PEAz7FfQYtAAACAGD/5wQ6BckAEQAgAEayFyEiERI5sBcQsADQALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZsAkQshYBCitYIdgb9FmwABCyHgEKK1gh2Bv0WTAxBSYmNzY3ExIAFxYWBwYHBwIAEzY1JicmBgcDBhcUFxYTAd+9wgMBCScxARjevMMDAQknM/7riA0FoHqUHi4MAaTiQRQE/eRKSgEEATIBLgUE+ORLSf3+x/7NA5ByMOIHBbzN/sNnPOoHDQFuAAEA7wAAA3gFtQAGADkAsABFWLAFLxuxBR8+WbAARViwAC8bsQAPPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxMFNyUzAoHsyv6QJQJAJASMetfMAAABAAsAAAQ/BccAGABVsgkZGhESOQCwAEVYsBAvG7EQHz5ZsABFWLAALxuxAA8+WbIDEAAREjmwEBCyCAEKK1gh2Bv0WbIMEAAREjmyFRAAERI5sAAQshcBCitYIdgb9FkwMSEhNwE2NzYmJyYGBwc+AhcWFgcGBwcBIQPC/EkcAl2pEQ1aWm+YEOwKj+2Kvt0NEeQ+/lsCh7ECRaWGX38EBJN/AYbWdwME1LLM4z3+dAAAAQAm/+gEOQXFACoAZ7IIKywREjkAsABFWLAPLxuxDx8+WbAARViwGy8bsRsPPlmwAdCwAS+wDxCyBwEKK1gh2Bv0WbAPELAL0LABELIpAQorWCHYG/RZshUpARESObAbELAg0LAbELIjAQorWCHYG/RZMDEBFzI2NzYmJyYGBwc+AhcWFgcGBgcWFxUGBCcuAjcXBhYXFjY3NiYnJwGggXWcCwteXV6KDu0JiNt/w+ENB4Z/rQsN/tnWe8RpBOwEZ2NtmQwMc2yZA0cBfmljcQICcl0BdbhjAQTbuGSnPFDGMMT0BAFnu3gBYHUDBIhub3QDAQAAAgAJAAAEKgWwAAoADgBJALAARViwCS8bsQkfPlmwAEVYsAQvG7EEDz5ZsgEJBBESObABL7ICAQorWCHYG/RZsAbQsAEQsAvQsggGCxESObINCQQREjkwMQEzByMDIxMhNwEzASETBwN6sCKvOe04/Z4VAwL9/QcBaXEYAgfD/rwBRKADzPxXAmMiAAABAFr/5wRzBbAAHQBqshoeHxESOQCwAEVYsAEvG7EBHz5ZsABFWLANLxuxDQ8+WbABELIDAQorWCHYG/RZsgcBDRESObAHL7IaAQorWCHYG/RZsgUHGhESObANELIUAQorWCHYG/RZshEUGhESObIdGhQREjkwMRMTIQchAzYzFhIHBgAnJiYnMxYWFxY2NzYmJyYGB7q/Avoh/c9nZni5xxIS/tzXtuMG4wdlW2+XDwxqaUBlMALVAtvS/qM6Av701dv+6gQE4rlmcwIDqIx8mQICLSgAAgBj/+gEEwW4ABcAJQBbshkmJxESObAZELAG0ACwAEVYsAAvG7EAHz5ZsABFWLAPLxuxDw8+WbAAELICAQorWCHYG/RZsgcADxESObAHL7IYAQorWCHYG/RZsA8QsiABCitYIdgb9FkwMQEHJyYEBzYXHgIHDgInJiYnJjcSACEBJgYHBhcUFhcWNjc2JgPMFA3A/uZQhKl1pEwMDI7liK3YDwkgQQGpAUj+tFCMMAsBXlhslw8NYAW4ygEC09aABAJ/3YKO7YEDBO7Ca7MBZQGW/UkCWVJlK4CWAgOoiH+iAAEAhgAABJwFsAAGADIAsABFWLAFLxuxBR8+WbAARViwAS8bsQEPPlmwBRCyAwEKK1gh2Bv0WbIAAwUREjkwMQEBIQEhNyEEhf0E/v0C+f0qHwPUBR364wTtwwAAAwA7/+gERQXIABYAIgAuAGuyGi8wERI5sBoQsBLQsBoQsCfQALAARViwEy8bsRMfPlmwAEVYsAgvG7EIDz5ZsCzQsCwvshoBCitYIdgb9FmyAiwaERI5sg0aLBESObAIELIgAQorWCHYG/RZsBMQsiYBCitYIdgb9FkwMQEGBxYWBwYEJyYmNzYlJiY3NiQXHgIBNiYnJgYHBhYXFjYTNiYnJgYHBhYXFjYEPBLuWVcIDf7g1cLlDRIBEUtIBg4BDMd3tVr+tQtkXmqWDAtmXWyTYAlVU1uBCwlWUVyBBDjZdzmwasDtBATftfN9NqFcvOUEA2S0/PhlgwICj21newICigL7WnYCAoBmXnICAoIAAAIAjv/5BC8FyAAYACYAWLIZJygREjmwGRCwFdAAsABFWLANLxuxDR8+WbAARViwFi8bsRYPPlmyAAEKK1gh2Bv0WbIFFg0REjmwBS+yGQEKK1gh2Bv0WbANELIhAQorWCHYG/RZMDE3FiQ3BicuAjc+AhceAhcWBwIAISM3ARY2PwI2JicmBhcWFvfUAQpCiJhxplIMDY/kh3WtYAcFHED+XP68FhMBSkqEMA0EA1hYfaAPB1rCAtHRhAICd+CIkfKEBANx0YFroP6O/njKAdoCVUthRoKZBAT4qFls//8AK//yAdAEVAAmABL7AAAHABIAjQNR////mv64AbwEVAAnABIAeQNRAAYAEBEAAAEAMgCqA8MEVAAGABeyAAcIERI5ALAARViwBS8bsQUbPlkwMQEFBwE3AQcBMgIWKf0TIgNvLQJy4OgBdcEBdP4AAAIAYgFkBBQD1gADAAcAJQCwBy+wA9CwAy+yAAEKK1gh2Bv0WbAHELIEAQorWCHYG/RZMDEBITchAyE3IQPx/LokA0Vt/LsjA0YDDMr9jskAAQAvAJ8D2QRJAAYAF7IABwgREjkAsABFWLACLxuxAhs+WTAxASU3AQcBNwLb/c8oAwci/HgsAoHj5f6Lwf6M+gAAAgCV//ED3wXJABgAJABesh4lJhESObAeELAK0ACwAEVYsBAvG7EQHz5ZsABFWLAiLxuxIg8+WbIcDQorWCHYG/RZsADQsAAvsgQQABESObAQELIJAQorWCHYG/RZsg0QIhESObIVABAREjkwMQE+Ajc2JyYmJyYGBwc2JBcWFgcGBwcGBwE0Njc2FhUUBiMGJgE/DF3LH14SCEg5UnER7BEBAL6xyg4PvXpeFP7WSzo4Tk82OE4Bq32wrCRsdjQ9AQJjVQGy0gQEzqqxo2ZWjf7FO0wCAko5PUkCRwAAAgAy/jsGpAWTADsARwB8sh5ISRESObAeELBF0ACwKy+wNC+wAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbIDNAAREjmyDDQAERI5sAwvsAAQsj4ECitYIdgb9FmwFNCwNBCyHQIKK1gh2Bv0WbArELImBAorWCHYG/RZsAwQskQECitYIdgb9FkwMQUmJicGJyYmNzYSNhcWFhcDBwYWFxY2Ejc2JicmJyYEAgIHBhIWFxY3FwYjJiQCJyYSACQXFgQSFxYCBgEGFxY2NxMmJyYGBwSmTXYUg4tyegkHn+KEVYVDhggHKC9ZiVYHBDs8ffKn/trrhQcIadufpq0biuXD/t2cBASeASABb8nAARqaBASB5/1jBWo4dx2BLSmCsSQVAkpOnAMCtaChAU+uAgI5MP3JPD9JAgSQAROshtZHkgQDkf7f/ou+rf70iwECS4xWAaQBONPdAcABWrEDA6L+ycjT/pLEAUyiAwNrTAHxEQIF++UAAAL/pAAABK4FsAAHAAoARgCwAEVYsAQvG7EEHz5ZsABFWLACLxuxAg8+WbAARViwBi8bsQYPPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMhATMBIwEhAwN9/d+u/vYDEt4BGvj+DgGYYwFT/q0FsPpQAh8CWgAAAwAnAAAEvAWwAA0AFgAeAGmyGB8gERI5sBgQsA3QsBgQsBDQALAARViwAi8bsQIfPlmwAEVYsAAvG7EADz5ZsBfQsBcvsp8XAV2yDgEKK1gh2Bv0WbIHDhcREjmwABCyEAEKK1gh2Bv0WbACELIdAQorWCHYG/RZMDEzEwUWFgcGBxYWBwYEIwMDBTI2NzYmJyUXMjY3NiclJ/0Bv+ztDhLxWmIHDv7b8K1PAQN1pA8OWmj++ON6mg4Z1v7/BbABAcu01GsgqnbI6AKR/jkBfGxndAS7AXRjuwcBAAEAZf/oBQ0FxwAeAE6yCx8gERI5ALAARViwDC8bsQwfPlmwAEVYsAMvG7EDDz5ZsgAMAxESObIQDAMREjmwDBCyEwEKK1gh2Bv0WbADELIcAQorWCHYG/RZMDEBBgAnLgInJhISJBcWEhcjJiYnJgYPAgYWFhcEEwSqJf6w8YvRdgcGRMEBGazZ/Qj1BXl3o9wmFAkILXJYARdPAdvk/vEEA37xmHIBiQE4ngME/vfpnIsDBfTphWZntV8DCwEtAAIAJwAABOAFsAALABYARrIKFxgREjmwChCwD9AAsABFWLABLxuxAR8+WbAARViwAC8bsQAPPlmwARCyDAEKK1gh2Bv0WbAAELIOAQorWCHYG/RZMDEzEwUyBBIHBwYCBCMTAxcyJDc2JyYmJyf8AYq2AQd2Fwsezf68wiq2ksYBBSUaBwmXhgWwAbX+wcBPyf7JrATk++YB+92YcZGkBAABACcAAAS6BbAACwBOALAARViwBi8bsQYfPlmwAEVYsAQvG7EEDz5ZsgsGBBESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhA9P9vE4CpiP8Y/wDlyT9YUYCRQKK/kDKBbDM/m4AAAEAJwAABKcFsAAJAEAAsABFWLAELxuxBB8+WbAARViwAi8bsQIPPlmyCQQCERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASEDIxMhByEDIQPB/chr9/wDhCT9dEsCOQJp/ZcFsMz+TwABAGv/6gUWBcgAIQBbsh8iIxESOQCwAEVYsA0vG7ENHz5ZsABFWLADLxuxAw8+WbANELAQ0LANELITAQorWCHYG/RZsAMQshsBCitYIdgb9FmyIA0DERI5sCAvsh8BCitYIdgb9FkwMSUGBCcuAicmEhI3NhcWFhcnAicmBgcGBwYWFxY3EyE3IQSQUP7ctJDcgQkHQKV2oM7b9xDvFuOq2ygXAgaPia9xNv7cIgIXvWhrAgF/85t4AXQBIVJvBAT03AEBAQcF+euJV7POAgRbAR3AAAEAJwAABYcFsAALAFOyBwwNERI5ALAARViwBi8bsQYfPlmwAEVYsAovG7EKHz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyCQYAERI5sAkvsgIBCitYIdgb9FkwMSEjEyEDIxMzAyETMwSK9nD9inD3/fdqAnZp9wKH/XkFsP2iAl4AAQA1AAACKAWwAAMAHQCwAEVYsAIvG7ECHz5ZsABFWLAALxuxAA8+WTAxISMTMwEr9v32BbAAAQAD/+cEYQWwAA4ANrIMDxAREjkAsABFWLAALxuxAB8+WbAARViwBS8bsQUPPlmyCAAFERI5sgsBCitYIdgb9FkwMQEzAwYEJyYmNxcGFxY2NwNr9q4f/uPRzNcK9g7AZI8VBbD8A9T4BATqxwHlBASGegABACcAAAVxBbAADABTALAARViwBC8bsQQfPlmwAEVYsAgvG7EIHz5ZsABFWLACLxuxAg8+WbAARViwCy8bsQsPPlmyAAQCERI5tGoAegACXbIGBAIREjm0ZQZ1BgJdMDEBBwMjEzMDNwEhAQEhAjPITff993WZAfYBPP14AZn+7AJzt/5EBbD9Y58B/v1v/OEAAAEAJwAAA8MFsAAFACgAsABFWLAELxuxBB8+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WTAxJSEHIRMzAUECgiT8iP33ysoFsAAAAQAnAAAGzgWwAA4AbgCwAEVYsAAvG7EAHz5ZsABFWLACLxuxAh8+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbIBAAQREjm0ZQF1AQJdsgcABBESObRqB3oHAl2yCgAEERI5tGoKegoCXTAxARMBIQMjExMBIwsCIxMCXtUCVwFE/PZVgf2ost9bUfb9BbD7pgRa+lAB7QJf+7QEbf1m/i0FsAAAAQAnAAAFhgWwAAkATLIBCgsREjkAsABFWLAFLxuxBR8+WbAARViwCC8bsQgfPlmwAEVYsAAvG7EADz5ZsABFWLADLxuxAw8+WbICBQAREjmyBwUAERI5MDEhIwEDIxMzARMzBInv/jm19/3vAce29gQT++0FsPvpBBcAAAIAa//nBSEFyAASACIARrIZIyQREjmwGRCwANAAsABFWLAKLxuxCh8+WbAARViwAC8bsQAPPlmwChCyGAEKK1gh2Bv0WbAAELIfAQorWCHYG/RZMDEFLgInJhISNzYXFgAXFgICBwYTNzYmJicmBgIHBhYXFhI3AleO13gIBzuXaa3j2AEBDAY5i2ey2gkGMndbfsN5CgqEhK3hIxQDgvedfQFOARNXjgQE/t73fP6//vNanAMYam25YQMElv7O57fSBAUBDvUAAgAnAAAFBAWwAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDHz5ZsABFWLABLxuxAQ8+WbILAQMREjmwCy+yAAEKK1gh2Bv0WbADELITAQorWCHYG/RZMDEBAyMTBTIEBwYEIyUFMjY3NiYnJQF8Xvf9AfjkAQQREv7K+/7vARuGqxEOb3D+zAId/eMFsAH5zdT5zAKIem+HBQEAAAIAZP8EBRoFyAAWACYARrIDJygREjmwAxCwJNAAsABFWLAOLxuxDh8+WbAARViwBS8bsQUPPlmwDhCyHAEKK1gh2Bv0WbAFELIjAQorWCHYG/RZMDElFwclBicmACcmEhI3NhceAhcWBwcCAzc2JiYnJgIDBhYWFxYSNwOr0K7/AFAv1f79DAY7nXOo2JDWegcECgw+rQkGM3hbxPEOBjR3WaXiKFbIivQMAQIBJPZ9AUkBHlmCBAOC+5xWVlf+bgHtam64YAMG/pf+uG+6YQMHAQDzAAACACcAAATYBbAADgAXAFqyBRgZERI5sAUQsBDQALAARViwBC8bsQQfPlmwAEVYsAIvG7ECDz5Zsg8CBBESObAPL7IBAQorWCHYG/RZsgsBDxESObACELAO0LAEELIXAQorWCHYG/RZMDEBIQMjEwUyFgcGBgcTByEBFzI2NzYmJyUClv7qYvf9Acvt/BELppbXAf76/lLvga0PD25w/vgCMf3PBbAB5MuNzzv9pg8C/AKHdHF5BAEAAQAk/+oEuwXHACkAYbIDKisREjkAsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyAx8KERI5sAoQsA7QsAoQshIBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAfELAk0LAfELInAQorWCHYG/RZMDEBNicnJiY3PgIXHgIHJzYmJyYGBwYXFxYWBw4CJy4CNxcGFhcWNgNMFrNR4r4JCJn6jYjUcAT2B3N0daEOFL5L5bYLCo77l4/pfAX3CIqBeKEBfpBGHk/Yj3y9ZgMDccmBAXJ+AwJyYX9JG1Ldl3u3ZAIBdtGFAXyGAgJqAAABAJwAAAUiBbAABwAuALAARViwBi8bsQYfPlmwAEVYsAIvG7ECDz5ZsAYQsgABCitYIdgb9FmwBNAwMQEhAyMTITchBP7+SNn22v5LJARiBOT7HATkzAAAAQBb/+YFLwWwABIAPLIPExQREjkAsABFWLAALxuxAB8+WbAARViwCS8bsQkfPlmwAEVYsAQvG7EEDz5Zsg4BCitYIdgb9FkwMQEDBgAnJgI3NxMzAwYWFxY2NxMFL6Ui/rXr2v0LA6X2pRJ2e4e0GacFsPwz6f7sBAQBAM4mA878MYucBASakAPUAAABAJsAAAWBBbAABgA4sgAHCBESOQCwAEVYsAEvG7EBHz5ZsABFWLAFLxuxBR8+WbAARViwAy8bsQMPPlmyAAEDERI5MDEBASEBIwEhAlECGAEY/SDv/ukBBgE/BHH6UAWwAAEAtwAABzoFsAAMAGCyBQ0OERI5ALAARViwAS8bsQEfPlmwAEVYsAgvG7EIHz5ZsABFWLALLxuxCx8+WbAARViwAy8bsQMPPlmwAEVYsAYvG7EGDz5ZsgABAxESObIFAQMREjmyCgEDERI5MDEBATMBIwMBIwMzEwEzBLsBhPv91uxl/kjuYu8wAbfPAWoERvpQBCT73AWw+78EQQAAAf/DAAAFRwWwAAsAUwCwAEVYsAEvG7EBHz5ZsABFWLAKLxuxCh8+WbAARViwBC8bsQQPPlmwAEVYsAcvG7EHDz5ZsgABBBESObIGAQQREjmyAwAGERI5sgkGABESOTAxAQEhAQEhAwEhAQEhAqMBegEq/dsBPv7u3P58/tUCMf7JARADowIN/SP9LQIV/esC6QLHAAEAoQAABU0FsAAIADEAsABFWLABLxuxAR8+WbAARViwBy8bsQcfPlmwAEVYsAQvG7EEDz5ZsgABBBESOTAxAQEhAQMjEwEhAnMBvAEe/X5b+GD+yQEFAwACsPxb/fUCJQOLAAAB/+UAAATnBbAACQBEALAARViwBy8bsQcfPlmwAEVYsAIvG7ECDz5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIQchNwEhNyEHAToC7CT74x8Djf0yJAQAHsrKsAQ0zKwAAAH/7/68ArUGjgAHACIAsAQvsAcvsgABCitYIdgb9FmwBBCyAwEKK1gh2Bv0WTAxASMDMwchASECl5/+oB7+cwE5AY0F0PmpvQfSAAABAKz/gwLIBbAAAwATALACL7AARViwAC8bsQAfPlkwMRMzASOs4AE84AWw+dMAAf96/rwCQwaOAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIQEhNzMTI7QBj/7H/nAeov6jBo74Lr0GVwAAAQBEAtkDLgWwAAYAJ7IABwgREjkAsABFWLADLxuxAx8+WbAA0LIBBwMREjmwAS+wBdAwMQEDIwEzEyMCFP3TAaCno70EpP41Atf9KQAAAf95/0EDFgAAAAMAGwCwAEVYsAMvG7EDDz5ZsgABCitYIdgb9FkwMQUhNyEC9PyFIgN7v78AAQDKBNECVgYAAAMAJACwAS+yDwEBXbAD0LADL7QPAx8DAl2yAAEDERI5GbAALxgwMQEjAzMCVrXX/gTRAS8AAAIAIv/oA9wEUAAgACsAhbIKLC0REjmwChCwJtAAsABFWLAYLxuxGBs+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEGBESObIKGAAREjmwCi+wGBCyEAcKK1gh2Bv0WbITChAREjlACQwTHBMsEzwTBF2wBBCyIQEKK1gh2Bv0WbAKELImBworWCHYG/RZMDEhJjcGJyYmNzYkMxc3NicmJyYGBwc+AhcWFgcDBwYXByUWNjc3JyIGBwYWApMMAoabjbkGCAEY7JoOBgYUe0xzDe0HgNR2scYRUwgDEgH+IUuALSVxhqALCEsoPX0EArGIq8QCSicibAMCUUQCZJdUAgTNo/4FWjs4Eq4CSTrNAWVYQ00AAAIAEP/oBA8GAAARAB4AZLIEHyAREjmwBBCwG9AAsAkvsABFWLANLxuxDRs+WbAARViwBy8bsQcPPlmwAEVYsAQvG7EEDz5ZsgYNBxESObILDQcREjmwDRCyFQEKK1gh2Bv0WbAEELIaAQorWCHYG/RZMDEBBgIGJyYnByMBMwM2FxYWFxYnNCYnJgcDFhcWNjc2BAcUict/tVwm2QEK7mx5pp2xBQHsWlWPY04skXibFggCGKX+9YADBId2BgD90YEEBN7BPC9tewIEjv5AiAUDvq1VAAABADj/6QPuBFIAHABLsgAdHhESOQCwAEVYsBEvG7ERGz5ZsABFWLAILxuxCA8+WbIAAQorWCHYG/RZsgQRCBESObIVCBEREjmwERCyGAEKK1gh2Bv0WTAxJRY2NzcOAicuAjc3PgIXFhYVIzQmJyYGBwIB6FWDEuALhdBxi8RaDwMRleyQsNLeW1aLoAYHrQJnUwFrsGIDAoz3mCOd/4oEBOG0XXYEBPTe/vMAAgA7/+cEiAYAABIAHQBhsgQeHxESObAEELAb0ACwBy+wAEVYsAQvG7EEGz5ZsABFWLAJLxuxCQ8+WbAARViwDS8bsQ0PPlmyBgQJERI5sgsECRESObIWAQorWCHYG/RZsAQQshsBCitYIdgb9FkwMRM2EjYXFhcTMwEjNwYnJiYnJjcXBhYXFjcTJicmBkQUjM5+pV1o7v711BB+qpe1BwMG6QdbWolkUS+HiKYCHqcBCoMDBHcCLPoAcIkEAuW+PjtIfJICBIkB0X0EBPgAAAIAO//qBAIEUQAWAB8Ag7IRICEREjmwERCwF9AAsABFWLAJLxuxCRs+WbAARViwAC8bsQAPPlmyGgAJERI5sBovtL8azxoCXbRfGm8aAnG0HxovGgJxso8aAV207xr/GgJxsg0HCitYIdgb9FmwABCyEQEKK1gh2Bv0WbITCQAREjmwCRCyFwEKK1gh2Bv0WTAxBS4CNzc2EjYXFhIHByEGFhcWNxcGBgMmAwU3NicmJgH6jc9jDAMSneqJy8sZDv1XCXprmYF4RN4fvF4BwQQHBgtaFAOI7JEppQEHiAME/trsaIGeAgWKfmFrA6IG/vABFS4sR1IAAQBfAAADXgYaABUAY7IVFhcREjkAsABFWLAILxuxCCE+WbAARViwAy8bsQMbPlmwAEVYsBEvG7ERGz5ZsABFWLAALxuxAA8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwARCwE9CwFNAwMTMTIzczNzY2FxYXByYjJgYHBzMHIwNjnaEgoBAa2609UBosLVVsDw/WINWdA4a0dKjEAgISvgoBXlNmtPx6AAAC//f+TwRCBFEAHAAqAIOyBCssERI5sAQQsCPQALAARViwCC8bsQgbPlmwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDBE+WbAARViwGC8bsRgPPlmyBggYERI5sAwQshIBCitYIdgb9FmyEBIYERI5shYIGBESObAYELIiAQorWCHYG/RZsAQQsicBCitYIdgb9FkwMRM2EjYXFhc3FwMGBCcmJic3FhcWNjc3BicmJicmNwYXFhYXFjcTJicmBgdGE4nQhrJbJdizHv7X1XLMPn5fmXSnHBF9n5i3CQPzBgICXFWHZVU0hXikGQIeogEGiwIEf28B++TU+wYCZFKPgwQEh31MeQQC4r88PjM7anwDBYIB3ncEA8CtAAABAA0AAAP5BgAAEgBJsgETFBESOQCwES+wAEVYsAIvG7ECGz5ZsABFWLAGLxuxBg8+WbAARViwDy8bsQ8PPlmyAAIGERI5sAIQsgwBCitYIdgb9FkwMQE2FxYWBwMjEzYnJicmBwMjATMBl4esmpUTdO12BQMNg4Roh+0BCu4Dw44EAta9/UgCuyslegMChPz6BgAAAgAfAAACCQXYAAMADwA+sgQQERESObAEELAA0ACwAEVYsAIvG7ECGz5ZsABFWLAALxuxAA8+WbACELAN0LANL7IHDQorWCHYG/RZMDEhIxMzAzQ2NzYWFRQGBwYmAQztvO3LSD06TUs6OU4EOgEVN04CAks2OUoCAkkAAAL/DP5GAf4F2AAMABgASbIBGRoREjmwARCwDdAAsABFWLAALxuxABs+WbAARViwBC8bsQQRPlmyCQEKK1gh2Bv0WbAAELAW0LAWL7IQDQorWCHYG/RZMDEBAwYGJyYnNxYzMjcTEzQ2NzYWFRQGByImAcPHFryXQEcULiZ/GskdSDw6TUs6PEoEOvtnqLMCAhHAC5UElQEVOksCAkk4OUoCRwAAAQARAAAESgYAAAwAUwCwAEVYsAQvG7EEIT5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgAIAhESObRqAHoAAl2yBggCERI5tGUGdQYCXTAxAQcDIwEzAzcBIQEBIQG/hjvtAQrtmFMBWAEv/iABPP7/Ac53/qkGAPyYVgFM/jL9lAABAB8AAAIXBgAAAwAdALAARViwAi8bsQIhPlmwAEVYsAAvG7EADz5ZMDEhIwEzAQztAQvtBgAAAAEAEAAABmgEUgAhAHeyFiIjERI5ALAARViwAy8bsQMbPlmwAEVYsAgvG7EIGz5ZsABFWLAALxuxABs+WbAARViwDC8bsQwPPlmwAEVYsBYvG7EWDz5ZsABFWLAfLxuxHw8+WbIBCAwREjmyBggMERI5sAgQshIBCitYIdgb9FmwHNAwMQEHNhcWFhc2FxYWBwMjEzYnJicmBwcDIxM2JyYnJgcDIxMBqRWGumaHGJbCnpkTde12BQQQhJNVA3zudgUEEISFWYntuwQ7c4oEAlpKqgQE0bz9QwK/LCV1AwSlFv0vArwrJXkDAnn87wQ6AAEADQAAA/oEUgASAFOyAhMUERI5ALAARViwAy8bsQMbPlmwAEVYsAAvG7EAGz5ZsABFWLAHLxuxBw8+WbAARViwEC8bsRAPPlmyAQMHERI5sAMQsg0BCitYIdgb9FkwMQEHNhcWFgcDIxM2JyYnJgcDIxMBpxiLtpiSE3XtdgUEDYGHZoftuwQ7f5YEA9O9/UUCvisldwMCh/z9BDoAAgA5/+gEJwRSABAAIABDshshIhESObAbELAE0ACwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDA8+WbIUAQorWCHYG/RZsAQQshsBCitYIdgb9FkwMRM2EjYXHgIHBgIGJy4CNxcWFhcWNjc3NCYnJgcGBwZJEZnwkovKXQ4Qm/GTisleDewFZVp6pRUGZmGYWDUOCAIhnwEEjgQCkPqZrP74jQQCj/mWdGl/AwPCqGKAkgQEmV15VAAC/8f+YAQNBFIAEgAeAGeyBB8gERI5sAQQsB3QALAARViwDS8bsQ0bPlmwAEVYsAovG7EKGz5ZsABFWLAHLxuxBxE+WbAARViwBC8bsQQPPlmyCw0HERI5sA0QshcBCitYIdgb9FmwBBCyHAEKK1gh2Bv0WTAxAQYCBicmJwMjATcHNhceAhcWBzc2JicmBwMWFxY2BAUUhc1/qWFh7gEE2RJ8q2eYUQMB8gUDW1uGYlQtinahAhmi/viHAwR0/f0F2gFwhwQBZ8R4PT9JgY4CBH/+HXkEA74AAAIAO/5gBDgEUgASACAAa7IEISIREjmwBBCwGNAAsABFWLAILxuxCBs+WbAARViwBC8bsQQbPlmwAEVYsAkvG7EJET5ZsABFWLANLxuxDQ8+WbIGCA0REjmyCwgNERI5shcBCitYIdgb9FmwBBCyHQEKK1gh2Bv0WTAxEzYSNhcWFzcXASMTBicmJicmNzMHBhYXFjY3EyYnJgYHRBSOzn+sXCfW/vztYnmcm7QHAwbuBQNbWEtvLVg0gnKfHAIfqwEJfwMEfW0B+iYB/XUEAuO+PzxIh4sCA0U4Ae5yBAOypAABABAAAALvBFMADQBGsgkODxESOQCwAEVYsAgvG7EIGz5ZsABFWLALLxuxCxs+WbAARViwBS8bsQUPPlmwCxCyAgEKK1gh2Bv0WbIJCwUREjkwMQEmIyYHAyMTNwc2FzIXAtQuL5xcgu274RhvkSE6A1wKBIX9GwQ6AXuTAw8AAAEAHP/pA8QEUAAkAHSyIyUmERI5ALAARViwCC8bsQgbPlmwAEVYsBsvG7EbDz5ZsgMbCBESObILCBsREjmyHAsBXbILCwFdsAgQsg8BCitYIdgb9FmwAxCyEwEKK1gh2Bv0WbIeCBsREjm0BB4UHgJdsBsQsiIBCitYIdgb9FkwMQE2JCcmNzY2FxYWByc2JiciBgcGBBcWBw4CJyYmNxcWFhcyNgKXEf7dNc4HBf+yrNkC6wJWS09xCQ4BHETGBwV90nax6QLlAmRXWHUBLGNNF1i0kr8CAr6aAUtVAk4/W0ceV7lnmVEDAsqeAVdaAUkAAQA7/+0CrgVBABYAXLIWFxgREjkAsABFWLABLxuxARs+WbAARViwFC8bsRQbPlmwAEVYsA4vG7EODz5ZsAEQsADQsAAvsAEQsgMBCitYIdgb9FmwDhCyCQEKK1gh2Bv0WbADELAS0DAxAQMzByMDBhcWFzI3BwYjJiY3EyM3MxMCIy65H7pmAwIGSiUvEEpLfHsNZa0grC4FQf75tP2iGRRBAwm+FQKliAJqtAEHAAABAEr/6AQxBDoAEwBQsgEUFRESOQCwAEVYsAcvG7EHGz5ZsABFWLAQLxuxEBs+WbAARViwEi8bsRIPPlmwAEVYsAIvG7ECDz5ZsgAQEhESObINAQorWCHYG/RZMDElBicuAjcTMwMGFxYXFjcTMwMjAq17uWmLOwx17XYEAwpznWGI7bvea4MEAmSzeQK8/UElI3wFBoQDCvvGAAABAGQAAAQNBDoABgA4sgAHCBESOQCwAEVYsAEvG7EBGz5ZsABFWLAFLxuxBRs+WbAARViwAy8bsQMPPlmyAAUDERI5MDEBATMBIwMzAboBVv39687G7gE3AwP7xgQ6AAABAHcAAAX4BDoADABgsgUNDhESOQCwAEVYsAEvG7EBGz5ZsABFWLAILxuxCBs+WbAARViwCy8bsQsbPlmwAEVYsAMvG7EDDz5ZsABFWLAGLxuxBg8+WbIACwMREjmyBQsDERI5sgoLAxESOTAxAQEzASMDASMDMxMBMwPhASnu/ibDX/6ixGPgKQFWswFRAun7xgLk/RwEOv0iAt4AAAH/uQAABBMEOgALAFMAsABFWLABLxuxARs+WbAARViwCi8bsQobPlmwAEVYsAQvG7EEDz5ZsABFWLAHLxuxBw8+WbIACgQREjmyBgoEERI5sgMABhESObIJBgAREjkwMQETIQETIwMBIQEDMwH//wEV/mLx+Jf+9v7sAavp+ALYAWL94P3mAXH+jwIwAgoAAAH/tf5FBBIEOgAPAEOyABARERI5ALAARViwDy8bsQ8bPlmwAEVYsAEvG7EBGz5ZsABFWLAFLxuxBRE+WbIABQ8REjmyCQEKK1gh2Bv0WTAxAQEhAQInJic3FxY2NzcDMwG4AVQBBv1/hts2RRQrVnAmObX2AV4C3PsL/wADAhK8BANHS3AEJwAB/+cAAAPkBDoACQBEALAARViwBy8bsQcbPlmwAEVYsAIvG7ECDz5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIQchNwEhNyEHATgCJiL8qx4CiP39IwM3HcLCqwLLxKUAAAEAMP6ZAwUGQAAbADayDBwdERI5ALAOL7AARViwAC8bsQAXPlmyCQ4AERI5sAkvsggHCitYIdgb9FmyFAgJERI5MDEBJiY3NzYnJic3Njc3EiUXBgMHBgcWFg8CBhcBzZ6cExwFBA2GEccfHzkBYyPBIx0huUk2CR4DA4P+mTPwrswtJ3oLsgrd4AFQaI9G/vraxWA3oljmR6o6AAEAIP7yAdIFsAADABMAsAAvsABFWLACLxuxAh8+WTAxEyMBM8SkAQ6k/vIGvgAB/5n+lQJvBjsAHAA2shodHhESOQCwDi+wAEVYsBwvG7EcFz5ZshYOHBESObAWL7IXBworWCHYG/RZsgUXFhESOTAxBzY3NzY3JicmPwI0JzcWFgcHBhcWFwcGBwcCBWe4KSIjvnAOBQUeBIE3o5ASHAUEDYcSyB4fOf6d20D49MNbSpArLeZIqjmJNvGozC4mfAuyCtvf/qxmAAABAFsBfgTKAzQAFgA8sgUXGBESOQCwDi+wANCyAxcOERI5sAMvsA4QsggBCitYIdgb9FmwAxCwCtCwAxCyEwEKK1gh2Bv0WTAxAQYGJy4DIyYHIzY2Fx4DMzI2NwTKDMSUUX50QyGHIrsOx5FSgnBEH0RdEAMUrugEAkp0JAPAr9wEAkxyJGlcAAAC/+b+lAHOBFAAAwAOAD6yCw8QERI5sAsQsALQALAARViwDC8bsQwbPlmwAEVYsAIvG7ECFz5ZsAwQsgcNCitYIdgb9FmwAdCwAS8wMRMzAyMBFAYGJjU0Njc2Fq/MmvsB6Ep2TEo7Ok0Clvv+BTs5TQRKODlMAgJLAAEATP8LBAYFJgAhAFeyEiIjERI5ALAARViwFS8bsRUbPlmwAEVYsAcvG7EHDz5ZsgABCitYIdgb9FmyBAcVERI5sAcQsArQsBUQsBLQshkVBxESObAVELIcAQorWCHYG/RZMDElFjY3NwYGBwcjNy4CNzc2Ejc3MwcWFgcjNCYnJgIVFBYB9liAFN8O1qAvxDBriToOAhn2wS7DLoSTAt1cU4+pXK0CaFIBjccd6uwbk9+EFOUBIiLh4yHSm2FxBAb+9vBqfQAAAf/2AAAEpQXHACAAarIcISIREjkAsABFWLATLxuxEx8+WbAARViwBS8bsQUPPlmyHhMFERI5sB4vsgABCitYIdgb9FmwBRCyAwEKK1gh2Bv0WbAI0LAAELAL0LAeELAN0LATELAW0LATELIaAQorWCHYG/RZMDEBBwYHJQchNxc2NzcjNzM3PgIXFhYHJzYmJyYGBwchBwHuFhFZAqgk/AQkRWQcGJ0jlx8Qi9l/tMsI7wVSU1p/Dh0BLiMCVq6CXwPKyQIksrnH+3/HaQQE2bYBX2cEAoZw6scAAAIACP/lBX8E8QAcACwAP7IiLS4REjmwIhCwENAAsABFWLACLxuxAg8+WbAR0LARL7ACELIhBworWCHYG/RZsBEQsikHCitYIdgb9FkwMSUGJyYnByc3JicmEjcnNxc2FxYXNxcHFgcGBxcHAQYWFhcWNjY3NiYmJyYGBgPUtrzDh5h4mhsKE1hmc5dur7K5iKp5qT4UGoNvmPz4D0SaaXHRjxAPRJppctOMaYEEBHqEm4BVVpMBHHWbhY90BAJylJyOuafJnpWGAnJuyXkEBHnZd27HeAQEetQAAQBQAAAFOAWwABYAcgCwAEVYsBYvG7EWHz5ZsABFWLAMLxuxDA8+WbIADBYREjmwFhCwAdCyDwwWERI5sA8vsBPQsBMvtA8THxMCXbAE0LAEL7ATELISBAorWCHYG/RZsAbQsA8QsAfQsAcvsA8Qsg4ECitYIdgb9FmwCtAwMQEBIQEzByEHIQchAyMTITchNyE3IQEhAnoBoAEe/gf+G/6uGAFTG/6uNPc1/qgbAVcY/qgbARj+/gEFAzYCev02mIqX/tMBLZeKmALKAAAC/+z+8gH4BbAAAwAHABgAsAAvsABFWLAGLxuxBh8+WbIFAQMrMDEDEzMDEyMTMxSL34qo4ITg/vIDG/zlA8gC9gAC/9z+IwSxBcYALgA5AICyJzo7ERI5sCcQsDTQALAIL7AARViwHy8bsR8fPlmyAggfERI5sAgQsAzQsAgQsg8BCitYIdgb9FmyFQgfERI5shofCBESObAfELAj0LAfELImAQorWCHYG/RZsiwIHxESObAVELIzAQorWCHYG/RZsCwQsjkBCitYIdgb9FkwMQEGBxYHDgInJiY3MwYWFzI2NzYvAiQ3NjcmNzYkFxYWByc2JicmBwYHBgQXFiUGBwYfAjY3NicEUg7IYQ0Jj/CR4PsF8AZ+eHidDRW5kln+6xUOxmANDgEq49brCewGdGlyTlMOFgF8VOX9bnkUFrbDKIEUFsIBz7VpaKh5rFkDAuLFa3kCYlN4QTAjd/W4Z22ksNACBOTGAWx7AgIuMVqGcSt0IDd2iD1ADztygUQAAAIA0QTeA4MFzQAKABUAIgCwES+yDxEBXbILBQorWCHYG/RZsADQsBEQsAbQsAYvMDEBMhYVFAYHIiY0NiUyFhUUBgciJjQ2AUw2RkY1OEREAfI4REY1N0VFBc1DMTNFAkRgSAFEMDNFAkJkRgAAAwBe/+gF6QXHABsAKQA6AJWyLjs8ERI5sC4QsBLQsC4QsCfQALAARViwLy8bsS8fPlmwAEVYsDcvG7E3Dz5ZsgM3LxESObADL7QPAx8DAl2yCi83ERI5sAovtAAKEAoCXbIAAwoREjmyDgoDERI5shECCitYIdgb9FmwAxCyGQIKK1gh2Bv0WbA3ELIfCAorWCHYG/RZsC8QsiYICitYIdgb9FkwMQEGBicmJjc3NjYXFhYHJzYmJyYGBhUXFhYXFjcFFgAXFiQSJyYCJyYEAgc2EjYkFxYEEgcGAgQnJiQCBEMMuZmSpA4KE9CelZoEmAVIUV17HQIFS0KnH/09EwEBvLgBSbcSE/zAuf63uWIRieABDZCyAR6PFRbm/qW/tv7mkAJUlqgEBNinZbzcAgSpjwFaWQICjvgbLEtYAwe5GMz++wIE2wF3wcoBAQUE2v6JKJYBF9lvAwLF/qbEyf6ayAQExAFcAAACAL4CswNQBccAHQAnAGuyEigpERI5sBIQsB7QALAARViwFi8bsRYfPlmyBCgWERI5sAQvsADQsAAvsgoEFhESObAKL7AWELIQAgorWCHYG/RZsAoQsRIKK1jYG9xZsAQQsh4CCitYIdgb9FmwChCxIgorWNgb3FkwMQEmNwYjIiY3NjYzFzc2JyYnJgcnNjYXFhYHAwcGFyUyNzcjBgYHBhYCbgUCXW1qeQQCu6hoCwQBB0x3G6wLsYJ6jAo2BAEJ/rVFWhtTUmYIBzECvygeUnthc30BNRkWSwMEZw5vfQICln3+pTotL4I+igM+NSYs//8ASQCKA60DqQAmA4DsAAAHA4ABSAAAAAEAgAF2A8oDJQAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjEyE3IQN/xC79lx8DKwF2AQSr//8ANgIJAlgCzQIGABEAAAAEAF7/6AXpBcgADwAfADgAQQCfsjpCQxESObA6ELAD0LA6ELAd0LA6ELA40ACwAEVYsAQvG7EEHz5ZsABFWLAMLxuxDA8+WbIUCAorWCHYG/RZsAQQshwICitYIdgb9FmyIQwEERI5sCEvsiQEDBESObAkL7QAJBAkAl2yICEkERI5sCAvsiAgAV2yOQgKK1gh2Bv0WbIpIDkREjmwIRCwMdCwJBCyQAgKK1gh2Bv0WTAxEzYSJBcWBBIHBgIEJyYkAjceAhcWJBI3NgImJyYEAgUDIxMFFhYHBgcWFxYGFxcHIyY3Njc2JicnFzY2NzYmJydzFt4BXsWyAR6PFRbm/qW/tv7mkIoMfsl+nAEnyRcVaeCYuf63uAG4NZSFAQSPlAUHiUkHAg0BBAGVBQIBDAYsQpCBSmUKCztZigLSxgFhzwQCxf6mxMn+msgEBMQBXCuD13YDBKQBLaufAR6mBATa/oxw/q8DUgEFhnF0TC5kH3kcPhIlJCFfP0QEiAECQzY7PQMBAAEA7wUSA8sFsAADABEAsAEvsgIDCitYIdgb9FkwMQEhNyEDsv09GQLDBRKeAAACAOQDrALkBccACwAXAC8AsABFWLADLxuxAx8+WbAP0LAPL7IJAgorWCHYG/RZsAMQshUCCitYIdgb9FkwMRM2NhcWFgcGBicmJjcGFjMyNjc2JiMiBuYCpG9jhgIEoGxmiIoGNjE3UAYGNS82VASvb6kCAplpcqMCApZrLElPNDFJVAACABsAAQQFBPwACwAPAEYAsAkvsABFWLANLxuxDQ8+WbAJELAA0LAJELIGAQorWCHYG/RZsAPQsA0Qsg4BCitYIdgb9FmyBQ4GERI5tAsFGwUCXTAxASEHIQMjEyE3IRMzEyE3IQK4AU0g/rQ90z3+pSABWTzTYfzHHwM5A4PH/nwBhMcBefsFxAABAFYCmwLxBb8AFwBZsggYGRESOQCwAEVYsA8vG7EPHz5ZsABFWLAALxuxABM+WbIWAgorWCHYG/RZsgIAFhESObIDDwAREjmwDxCyCAIKK1gh2Bv0WbIMDwAREjmyEw8AERI5MDEBITcBNjc2JiciBgcHNjYXFhYHBg8CBQKp/a0YAVZhDAcrKTpDDLYKr4J/kgUFlk+dAV8Cm4cBGVNDKS8BRzQBeZgCAoNofnc8bgIAAQBnAo0C+AW+ACQAb7IJJSYREjkAsABFWLANLxuxDR8+WbAARViwGC8bsRgTPlmyARgNERI5fLABLxiwDRCyBwIKK1gh2Bv0WbIKAQcREjmwARCyIwIKK1gh2Bv0WbITIwEREjmwGBCyHgIKK1gh2Bv0WbIcIx4REjkwMQEzNjY3NicnJgcHNjYXFhYHBgYHFgcGBicmJjUXFhcyNjc2JyMBWVM9TQcJShddHLoJpn2BmQUDSVJ2BAO8i32ZsQRqNlMHDXhcBGwCOC5DDQICTAFpegIDd2I7VyYpgW+CAgKDbQFZAjgvWQUAAQDIBNEC0gYAAAMAIwCwAi+yDwIBXbAA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGDAxASEBIwG1AR3+xM4GAP7RAAH/3f5gBFQEOgATAFayDRQVERI5ALAARViwAC8bsQAbPlmwAEVYsAgvG7EIGz5ZsABFWLARLxuxERE+WbAARViwCi8bsQoPPlmwAEVYsA4vG7EODz5ZsgUBCitYIdgb9FkwMQEDBhcWFxY3EzMDIzcGJyInAyMBAc1mCAIFhZhaiu271w9ojGxSVuwBBAQ6/ZJVKJ0DBHwDE/vGVm4COf49BdoAAQB9AAAD3AWxAAoAK7ICCwwREjkAsABFWLAILxuxCB8+WbAARViwAC8bsQAPPlmyAQAIERI5MDEhEycmJjc2ADMFAwISWjjT5BQTASvhASz9AggBA//J0wEKAfpQAAEAngJCAbEDVQALABiyAwwNERI5ALADL7IJDQorWCHYG/RZMDETNDY3NhYVFAYHBiaeTTs9Tk48O04Cxj1OAgJPODtNAgJKAAH/0/49AS8ABAAOACmyAg8QERI5ALAAL7AHL7IIAgorWCHYG/RZsg0IABESObIBAA0REjkwMTcHFhYHBgYHNzY3NicnN8UTPj8BArKnAokQCVI4LQQ7DlU/bXcGjQZaPA0GiQABAOECoAKBBbMABgA5sgEHCBESOQCwAEVYsAUvG7EFHz5ZsABFWLAALxuxABM+WbIEBQAREjmwBBCyAwIKK1gh2Bv0WTAxASMTBzclMwH/tWPMGwFuFwKgAjYvmXMAAgC+Aq0DfQXIAA4AHABAshEdHhESObARELAO0ACwAEVYsAAvG7EAHz5ZsgcdABESObAHL7ISAgorWCHYG/RZsAAQshkCCitYIdgb9FkwMQEWFgcHBgYnJiY3Nz4CAwYWFxY2Nzc2JicmBgcCSpCjCwYP0pmNpwsGCmemcQhFRk9sDAgIRUZQbAsFxQTHmUKkzgQExJtCbqlb/klhbAICdWdGZGkCAnZkAP//AAIAigN1A6kAJgOBCQAABwOBAXMAAP//ALkAAAUqBasAJwPPAEwCmAAnA4MBFAAIAQcDzAKwAAAAEACwAEVYsAUvG7EFHz5ZMDH//wCxAAAFgAWuACcDgwDqAAgAJwPPAEQCmwEHA84DAgAAABAAsABFWLAJLxuxCR8+WTAx//8AlgAABZ8FvwAnA4MBnQAIACcDzAMlAAABBwPNAKICmwAQALAARViwIC8bsSAfPlkwMQAC/9L+egMjBFEAGAAkAGGyISUmERI5sCEQsALQALAARViwIi8bsSIbPlmwAEVYsBAvG7EQFz5ZsCIQshwNCitYIdgb9FmwANCwAC+yBBAAERI5sBAQsgkBCitYIdgb9FmyDBAAERI5shUAEBESOTAxAQYGBwcGBwYWFxY2NzMGBCcmJjc2Nzc2NwEUBgcGJjU0Njc2FgJrC1dfUngOC0pOU3MR7RH+/Ly3yQ0Pw21fFAEsSjo7TEo7OkwClnSrV0ptb1JgAgJlV7PTBATMqbOrXlaMATs7SwICSjg5TAICSgD///+kAAAErgc2AiYAJQAAAQcARAFbATYAEwCwAEVYsAQvG7EEHz5ZsAzcMDEA////pAAABMgHNgImACUAAAEHAHcB9gE2ABMAsABFWLAFLxuxBR8+WbAN3DAxAP///6QAAASuBzcCJgAlAAABBwFnAPIBNgATALAARViwBC8bsQQfPlmwD9wwMQD///+kAAAEyQcrAiYAJQAAAQcBbgEAATcACQCwBC+wFdwwMQD///+kAAAErgcDAiYAJQAAAQcAawEoATYADACwBC+wHNywC9AwMf///6QAAASuB5UCJgAlAAABBwFsAYwBagAMALAEL7AU3LAX0DAxAAL/hwAAB3gFsAAPABIAdwCwAEVYsAYvG7EGHz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyEQYAERI5sBEvsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WbILBgAREjmwCy+yDAEKK1gh2Bv0WbAAELIOAQorWCHYG/RZshIGABESOTAxISETIQMhASEHIQMhByEDIQEhEwa3/Jks/iHu/tgEJgPLI/2ONwIVI/30PAKE+1gBZlUBVP6sBbDF/mjF/jYBZwJ6AP//AGX+OAUNBccCJgAnAAAABwB7Abr/+///ACcAAAS6Bz0CJgApAAABBwBEASMBPQATALAARViwBi8bsQYfPlmwDdwwMQD//wAnAAAEugc9AiYAKQAAAQcAdwG+AT0AEwCwAEVYsAYvG7EGHz5ZsA7cMDEA//8AJwAABLoHPgImACkAAAEHAWcAugE9ABMAsABFWLAGLxuxBh8+WbAR3DAxAP//ACcAAAS6BwoCJgApAAABBwBrAPABPQAMALAGL7Ad3LAM0DAx//8ANQAAAjIHPQImAC0AAAEHAET/3AE9ABMAsABFWLACLxuxAh8+WbAF3DAxAP//ADUAAANIBz0CJgAtAAABBwB3AHYBPQATALAARViwAy8bsQMfPlmwBtwwMQD//wA1AAADEgc+AiYALQAAAQcBZ/9zAT0AEwCwAEVYsAIvG7ECHz5ZsAjcMDEA//8ANQAAAywHCgImAC0AAAEHAGv/qQE9AAwAsAIvsBXcsATQMDEAAv//AAAE/gWwAA8AHgBpsh4fIBESObAeELAO0ACwAEVYsAUvG7EFHz5ZsABFWLAALxuxAA8+WbIDAAUREjl8sAMvGLICBworWCHYG/RZsBHQsAAQshMBCitYIdgb9FmwBRCyHAEKK1gh2Bv0WbADELAd0LAe0DAxMxMjNzMTBTIEEgcHBgIEIxMjAxcyJDc2JyYmJycDM0Vxtx62bgGKtgEHdhcLHs3+vMKf3U6SxgEFJRoHCZeGuUveAoyqAnoBtf7BwE/J/smsAoz+PgH73ZhxkaQEAf5SAP//ACcAAAWGBysCJgAyAAABBwFuASgBNwAJALAFL7AU3DAxAP//AGv/5wUhBzYCJgAzAAABBwBEAXIBNgATALAARViwCi8bsQofPlmwJNwwMQD//wBr/+cFIQc2AiYAMwAAAQcAdwINATYACQCwCi+wJdwwMQD//wBr/+cFIQc3AiYAMwAAAQcBZwEJATYACQCwCi+wJNwwMQD//wBr/+cFIQcrAiYAMwAAAQcBbgEXATcACQCwCi+wLdwwMQD//wBr/+cFIQcDAiYAMwAAAQcAawE/ATYADACwCi+wNNywI9AwMQABACMA1gQUBIYACwA4ALADL7IJDAMREjmwCS+yCgkDERI5sgQDCRESObIBCgQREjmwAxCwBdCyBwQKERI5sAkQsAvQMDETAQM3EwEXARMHAwEjAWv7nvoBan/+lfue+/6XAXcBQQFDi/6/AUGh/r/+vYsBQP7AAAADABX/oQWYBe0AFwAhACsAVbIeLC0REjmwHhCwC9CwHhCwJ9AAsABFWLAMLxuxDB8+WbAARViwAC8bsQAPPlmyJwEKK1gh2Bv0WbAl0LAa0LAMELIdAQorWCHYG/RZsBvQsCTQMDEFJicHJzcmNzcSEiQXFhc3MwcWFxYCAgQBBhcBJicmAgcGATYnARYXFhI3NwJXnHt2tcJsAgMTwQE1vr6AcLPEOA4RSsn+5P5hAxQCfT6BpuIpGgLQBQb9kz9gsOMkERUESZcB8LDiTwEMAX7KAgRjj/R5gKr+Zf7ImwIiVVMDP04FBf8A6ZUBEEZH/NYyAgUBF/p5AP//AFv/5gUvBzYCJgA5AAABBwBEAUoBNgATALAARViwCi8bsQofPlmwFNwwMQD//wBb/+YFLwc2AiYAOQAAAQcAdwHlATYAEwCwAEVYsBIvG7ESHz5ZsBXcMDEA//8AW//mBS8HNwImADkAAAEHAWcA4QE2ABMAsABFWLAKLxuxCh8+WbAX3DAxAP//AFv/5gUvBwMCJgA5AAABBwBrARcBNgAWALAARViwCi8bsQofPlmwJNywGdAwMf//AKEAAAVNBzYCJgA9AAABBwB3Ab0BNgATALAARViwAS8bsQEfPlmwC9wwMQAAAgAnAAAEggWwAAwAFQBXsg8WFxESObAPELAI0ACwAEVYsAAvG7EAHz5ZsABFWLAKLxuxCg8+WbICAAoREjmwAi+yDwAKERI5sA8vsggBCitYIdgb9FmwAhCyFQEKK1gh2Bv0WTAxAQMXFhYHBgQjJwMjExMDFzY2NzYmJwIRMcve+Q8Q/s3r/DXt/ZtV4YCsDw5wagWw/ugBAerCy/QB/tQFsP4l/hoCAolxa3wEAAABABv/5wRMBhoALQBYsiEuLxESOQCwAEVYsAUvG7EFIT5ZsABFWLAALxuxAA8+WbAARViwFS8bsRUPPlmyDgUVERI5shoBCitYIdgb9FmyIBUFERI5sAUQsioBCitYIdgb9FkwMSEjEzYkFxYWBw4DBwYeAgcGBicmJzcWMzI2NzYmJyY3PgM3NiYnJgYHAQjtvRwBAMinvg0EJGAcBwguiDUCCfi9q3FEZ2xYdgsIMkZ+CQQyPDQHCUVGWnUUBFHS9wQEvZwxV5pCJjFmmW44rcUEAkHBQllJNGZLhm85XVlcN0xcBAODh///ACL/6APcBgACJgBFAAABBwBEALMAAAATALAARViwGC8bsRgbPlmwLdwwMQD//wAi/+gEIAYAAiYARQAAAQcAdwFOAAAAEwCwAEVYsBgvG7EYGz5ZsC7cMDEA//8AIv/oA+kGAQImAEUAAAEGAWdKAAATALAARViwGC8bsRgbPlmwMNwwMQD//wAi/+gEIQX1AiYARQAAAQYBblgBABMAsABFWLAYLxuxGBs+WbAv3DAxAP//ACL/6AQDBc0CJgBFAAABBwBrAIAAAAAWALAARViwGC8bsRgbPlmwMtywPdAwMf//ACL/6APcBl8CJgBFAAABBwFsAOQANAAWALAARViwGC8bsRgbPlmwNdywO9AwMQADAA//6AZwBFIAKwA1AD4A+LICP0AREjmwAhCwL9CwAhCwOdAAsABFWLAdLxuxHRs+WbAARViwGS8bsRkbPlmwAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbIDHQAREjmyCwUZERI5sAsvsBkQshEBCitYIdgb9FmyFAsRERI5QAkMFBwULBQ8FARdshsdABESObI6HQAREjmwOi+0HzovOgJxso86AV20XzpvOgJxtL86zzoCXbTvOv86AnGyIQcKK1gh2Bv0WbAAELIlAQorWCHYG/RZsigdABESObAFELIsBworWCHYG/RZsAsQsjAHCitYIdgb9FmwHRCyNgEKK1gh2Bv0WTAxBSImJwYnJiY3NiQzFzc2JyYnJgYHJz4CFxYXNhcWEgcHIQYWFxY2NxcGBiUyNzcnBgYHBhYBJgYHITc2JyYEanO8Naz9mrQICgEF5r8NBgQRd1d3De0He9t711qbucLHGhX9Yw53c1WXSjpB0/y2coooqWuRDAlOA41gki4BtgYHBA4TU0ykBAKvk6GyAkomInUDAlRJE2KZUwIFgIgEBv7y1o2InQICNSeoOT64ZtIBA15PP0gC5wOHhyEtKo0A//8AOP44A+4EUgImAEcAAAAHAHsBPP/7//8AO//qBAIGAAImAEkAAAEHAEQAnAAAABMAsABFWLAJLxuxCRs+WbAh3DAxAP//ADv/6gQJBgACJgBJAAABBwB3ATcAAAATALAARViwCS8bsQkbPlmwItwwMQD//wA7/+oEAgYBAiYASQAAAQYBZzMAABMAsABFWLAJLxuxCRs+WbAk3DAxAP//ADv/6gQCBc0CJgBJAAABBgBraQAAFgCwAEVYsAkvG7EJGz5ZsCbcsDHQMDH//wAiAAAB5wX5AiYA9AAAAQYARJH5ABMAsABFWLACLxuxAhs+WbAF3DAxAP//ACIAAAL9BfkCJgD0AAABBgB3K/kAEwCwAEVYsAMvG7EDGz5ZsAbcMDEA//8AIgAAAscF+gImAPQAAAEHAWf/KP/5ABMAsABFWLACLxuxAhs+WbAI3DAxAP//ACIAAALhBcYCJgD0AAABBwBr/17/+QAWALAARViwAi8bsQIbPlmwCtywFdAwMQACAEb/6ARKBiwAHgAqAF6yECssERI5sBAQsCjQALAARViwGi8bsRohPlmwAEVYsAgvG7EIDz5ZshAaCBESObAQL7AaELIZAQorWCHYG/RZsBAQsiEHCitYIdgb9FmwCBCyJwEKK1gh2Bv0WTAxARYSBwcGAgYnLgI3PgIXFhcmJwcnNyYnNxYXNxcBJicmBgcGFhcWNjcDpVtBFwwXqOyJf8VgDA2I4IWKawRg4D+4W6Vb3pTJPv74NpN/qxAOaWJ2oxkFFJv+vLNWp/7siQMEgNyBkPCGBARZmYqIeWxJMMI2g3p5/TlhBQK2k3ilAwXQrQD//wANAAAEJwX1AiYAUgAAAQYBbl4BABMAsABFWLADLxuxAxs+WbAW3DAxAP//ADn/6AQnBgACJgBTAAABBwBEALAAAAATALAARViwBC8bsQQbPlmwItwwMQD//wA5/+gEJwYAAiYAUwAAAQcAdwFLAAAAEwCwAEVYsAQvG7EEGz5ZsCPcMDEA//8AOf/oBCcGAQImAFMAAAEGAWdHAAATALAARViwBC8bsQQbPlmwJdwwMQD//wA5/+gEJwX1AiYAUwAAAQYBblUBABMAsABFWLAELxuxBBs+WbAk3DAxAP//ADn/6AQnBc0CJgBTAAABBgBrfQAADACwBC+wMtywIdAwMQADAD0AkAQ6BM8AAwAPABsAUrIYHB0REjmwGBCwANCwGBCwBtAAsAMvsgABCitYIdgb9FmwAxCxDQorWNgb3FmyBw0KK1gh2Bv0WbAAELETCitY2BvcWbIZDQorWCHYG/RZMDEBITchATQ2NzYWFRQGBwYmAzQ2NzYWFRQGBwYmBBT8KSUD2P3CTjo9Tks+O0+OTD05UUw9OVECRtQBKT1LAgJMODlOAgJI/Qo5UAICSTw7SwICSAAAAwAq/3cEMwS7ABsAJAAuAFWyKy8wERI5sCsQsBHQsCsQsCLQALAARViwBS8bsQUbPlmwAEVYsBIvG7ESDz5ZsioBCitYIdgb9FmwKNCwHtCwBRCyIQEKK1gh2Bv0WbAf0LAn0DAxEzY2NzYXFhc3FwcWFxYHBgIGJyYnByc3JicmNxcGFwEmJyYGBiU2JwEWFxY2NzZED15OnN9eX2GbknAHAggUm/SUVltlm5J2CAMH4QEUAZQmNWSXUAIQARL+cCgqeaseDAIgdtNOnQQCI5AB0oTDOlOf/v6LAgIflAHRgsc9PHw/PQJnEwIBgfGDPDz9oQ4CA76vVAD//wBK/+gEMQYAAiYAWQAAAQcARAC1AAAAEwCwAEVYsAgvG7EIGz5ZsBXcMDEA//8ASv/oBDEGAAImAFkAAAEHAHcBUAAAAAkAsAcvsBbcMDEA//8ASv/oBDEGAQImAFkAAAEGAWdMAAAJALAHL7AV3DAxAP//AEr/6AQxBc0CJgBZAAABBwBrAIIAAAAMALAHL7Al3LAU0DAx////tf5FBBIGAAImAF0AAAEHAHcBGgAAAAkAsAEvsBLcMDEAAAL/zf5gBBQGAAARAB0AVrIEHh8REjmwBBCwHNAAsAkvsABFWLANLxuxDRs+WbAARViwBy8bsQcRPlmwAEVYsAQvG7EEDz5ZsA0QshYBCitYIdgb9FmwBBCyGwEKK1gh2Bv0WTAxAQYCBicmJwMjATMDNhcWFhcWBzc2JicmBwMWFxY2BAwUiM19qGJh7gFT7Wp6o52xBQHzBQNaXYViVS+JdqECGKT+94QDBHX9/Qeg/dZ8BATewTxBSn+NBAR//h15BAO+////tf5FBBIFzQImAF0AAAEGAGtMAAAMALABL7Ah3LAQ0DAx////pAAABMUG6gImACUAAAEHAHIA+gE6ABMAsABFWLAELxuxBB8+WbAM3DAxAP//ACL/6AQdBbQCJgBFAAABBgByUgQACQCwGC+wLNwwMQD///+kAAAErgcdAiYAJQAAAQcBagEwATYACQCwBC+wDtwwMQD//wAi/+gD9AXnAiYARQAAAQcBagCIAAAACQCwGC+wL9wwMQAAAv+k/lEErgWwABcAGgB3shUbHBESObAVELAa0ACwAEVYsBUvG7EVHz5ZsABFWLALLxuxCxE+WbAARViwEy8bsRMPPlmwAEVYsBcvG7EXDz5ZsAsQsgYDCitYIdgb9FmwFxCwENCwEC+yGRMVERI5sBkvshEBCitYIdgb9FmyGhUTERI5MDEhFwcGBwYXFjcXBiciJjc2NwMhAyEBMwEBIQMEcQUvgwcFOBs9DEVVV2kCA7Q2/d+u/vYDEt4BGv0WAZhjAx9WVjkDAReQKwJtVJVpAUH+rQWw+lACHwJaAAACACL+UQPcBFAAMAA7AJuyGjw9ERI5sBoQsDbQALAARViwKC8bsSgbPlmwAEVYsAsvG7ELET5ZsABFWLAALxuxAA8+WbAARViwFC8bsRQPPlmwABCwENCwEC+yEigAERI5shoUKBESObAaL7AoELIgBworWCHYG/RZsiQaIBESOUAJDCQcJCwkPCQEXbAUELIxAQorWCHYG/RZsBoQsjYHCitYIdgb9FkwMSEXBwYHBhcWNxcGJyImNzY3JzUGJyYmNzYkMxc3NicmJyYGBwc+AhcWFgcDBwYXByUWNjc3JyIGBwYWA0oFL4MHBTgbPQxFVVdpAgO1BIabjbkGCAEY7JoOBgYUe0xzDe0HgNR2scYRUwgDEgH+IUuALSVxhqALCEsDH1ZWOQMBF5ArAm1UlmkpKX0EArGIq8QCSicibAMCUUQCZJdUAgTNo/4FWjs4Eq4CSTrNAWVYQ00A//8AZf/oBQ0HSwImACcAAAEHAHcB+AFLAAkAsAwvsCHcMDEA//8AOP/pA/MGAAImAEcAAAEHAHcBIQAAAAkAsBEvsB/cMDEA//8AZf/oBQ0HTAImACcAAAEHAWcA9AFLAAkAsAwvsCDcMDEA//8AOP/pA+4GAQImAEcAAAEGAWcdAAAJALARL7Ae3DAxAP//AGX/6AUNBywCJgAnAAABBwFrAdUBVAAJALAML7An3DAxAP//ADj/6QPuBeECJgBHAAABBwFrAP4ACQAJALARL7Al3DAxAP//AGX/6AUNB1ACJgAnAAABBwFoAQsBSwAJALAML7Aj3DAxAP//ADj/6QPwBgUCJgBHAAABBgFoNAAACQCwES+wIdwwMQD//wAnAAAE4AdCAiYAKAAAAQcBaACbAT0AEwCwAEVYsAEvG7EBHz5ZsBzcMDEA//8AO//nBdUGAgAmAEgAAAAHA6sEvwT8AAL//wAABP4FsAAPAB4AabIeHyAREjmwHhCwDtAAsABFWLAFLxuxBR8+WbAARViwAC8bsQAPPlmyAwAFERI5fLADLxiyAgcKK1gh2Bv0WbAR0LAAELITAQorWCHYG/RZsAUQshwBCitYIdgb9FmwAxCwHdCwHtAwMTMTIzczEwUyBBIHBwYCBCMTIwMXMiQ3NicmJicnAzNFcbcetm4BirYBB3YXCx7N/rzCn91OksYBBSUaBwmXhrlL3gKMqgJ6AbX+wcBPyf7JrAKM/j4B+92YcZGkBAH+UgAAAgA7/+cFGQYAABoAJQCMsgUmJxESObAFELAj0ACwFy+wAEVYsBAvG7EQGz5ZsABFWLADLxuxAw8+WbAARViwBi8bsQYPPlmyLxcBXbIPFwFdshYXAxESObAWL7ITBworWCHYG/RZsAHQsgQGEBESObISEAYREjmwFhCwGdCwBhCyHgEKK1gh2Bv0WbAQELIjAQorWCHYG/RZMDEBIwMjNwYnJiYnJjc3NhI2FxYXNyM3MzczBzMBBhYXFjcTJicmBgT7qdXUEH6ql7UHAwYDFIzOfqVdLvAe8RvuGar8EQdbWolkUS+HiKYEyfs3cIkEAuW+PjsVpwEKgwMEd/WqjY38TnySAgSJAdF9BAT4AP//ACcAAAS6BvECJgApAAABBwByAMIBQQATALAARViwBi8bsQYfPlmwDdwwMQD//wA7/+oEBgW0AiYASQAAAQYAcjsEAAkAsAkvsCDcMDEA//8AJwAABLoHJAImACkAAAEHAWoA+AE9AAkAsAYvsA/cMDEA//8AO//qBAIF5wImAEkAAAEGAWpxAAAJALAJL7Aj3DAxAP//ACcAAAS6Bx4CJgApAAABBwFrAZsBRgAJALAGL7AU3DAxAP//ADv/6gQCBeECJgBJAAABBwFrARQACQAJALAJL7Ao3DAxAAABACf+UQS6BbAAHACAshEdHhESOQCwAEVYsBcvG7EXHz5ZsABFWLAQLxuxEBE+WbAARViwBC8bsQQPPlmwAEVYsBUvG7EVDz5ZshsVFxESObAbL7IBAQorWCHYG/RZsBUQsgIBCitYIdgb9FmwA9CwEBCyCwMKK1gh2Bv0WbAXELIZAQorWCHYG/RZMDEBIQMhByMXBwYHBhcWNxcGJyImNzY3IRMhByEDIQPT/bxOAqYjcQUvgwcFOBs9DEVVV2kCA5b9sPwDlyT9YUYCRQKK/kDKAx9WVjkDAReQKwJtVIxgBbDM/m4AAgA8/mwECARRACMALAChsgYtLhESObAGELAk0ACwAEVYsBkvG7EZGz5ZsABFWLAMLxuxDBE+WbAARViwES8bsREPPlmwA9CyJi0ZERI5sCYvso8mAV20HyYvJgJxtJ8mryYCcbRfJm8mAnG0vybPJgJdtO8m/yYCcbQvJj8mAnKyHQcKK1gh2Bv0WbARELIhAQorWCHYG/RZsiMRGRESObAZELIkAQorWCHYG/RZMDElBgcHBgcGFxY3FwYnIiY3NjcmAjc3NhI2FxYSBwchBhYXFjcDJgMFNzYnJiYDplWNMW0IBTgbPQxFVVdpAgJgt8wRAxKd6onLyxkO/VcJemuZgcm8XgHBBAcGC1q2eDIhTFI5AwEXkCsCbVRtVRkBHM4ppQEHiAME/trsaIGeAgWKAlgG/vABFS4sR1L//wAnAAAEugdCAiYAKQAAAQcBaADRAT0AEwCwAEVYsAYvG7EGHz5ZsBHcMDEA//8AO//qBAYGBQImAEkAAAEGAWhKAAAJALAJL7Ak3DAxAP//AGv/6gUWB0wCJgArAAABBwFnAPEBSwAJALANL7Aj3DAxAP////f+TwRCBgECJgBLAAABBgFnPgAACQCwBC+wLNwwMQD//wBr/+oFFgcyAiYAKwAAAQcBagEvAUsACQCwDS+wJdwwMQD////3/k8EQgXnAiYASwAAAQYBanwAAAkAsAQvsC7cMDEA//8Aa//qBRYHLAImACsAAAEHAWsB0gFUAAkAsA0vsCrcMDEA////9/5PBEIF4QImAEsAAAEHAWsBHwAJAAkAsAQvsDPcMDEA//8Aa/35BRYFyAImACsAAAAHA6sBbv6S////9/5PBEIGqwImAEsAAAEHA+0BNAB+AAkAsAQvsC/cMDEA//8AJwAABYcHPgImACwAAAEHAWcBEgE9ABMAsABFWLAHLxuxBx8+WbAQ3DAxAP//AA0AAAP5B14CJgBMAAABBwFnAFIBXQAJALARL7AU3DAxAAACAC4AAAXbBbAAEwAXAGsAsABFWLAPLxuxDx8+WbAARViwCC8bsQgPPlmyFAgPERI5sBQvshAUDxESObAQL7AA0LAQELIXBworWCHYG/RZsAPQsAgQsAXQsBQQsgcBCitYIdgb9FmwFxCwCtCwEBCwDdCwDxCwEtAwMQEzByMDIxMhAyMTIzczEzMDIRMzASE3IQVffB17s/Zw/Ypw9rN4HHgt9y4Cdi32/CsCdiH9igSuovv0Aof9eQQMogEC/v4BAv2iugABACsAAAQXBgAAGgB0sgMbHBESOQCwGC+wAEVYsAQvG7EEGz5ZsABFWLARLxuxEQ8+WbAARViwCS8bsQkPPlmyLxgBXbIPGAFdshoRGBESObAaL7IBBworWCHYG/RZsgIRBBESObAEELIOAQorWCHYG/RZsAEQsBPQsBoQsBbQMDEBIwM2FxYWBwMjEzYnJicmBwMjEyM3MzczBzMCy+Qyh6yalRN07XYFAw2DhGiH7dS/Hr4Z7hziBMf+/I4EAta9/UgCuyslegMChPz6BMeqj48A//8ANQAAA0oHMgImAC0AAAEHAW7/gQE+AAkAsAIvsA7cMDEA//8AFAAAAv8F7gImAPQAAAEHAW7/Nv/6AAkAsAIvsA7cMDEA//8ANQAAA0YG8QImAC0AAAEHAHL/ewFBABMAsABFWLACLxuxAh8+WbAF3DAxAP//AB8AAAL7Ba0CJgD0AAABBwBy/zD//QATALAARViwAi8bsQIbPlmwBdwwMQD//wA1AAADHQckAiYALQAAAQcBav+xAT0ACQCwAi+wB9wwMQD//wAiAAAC0gXgAiYA9AAAAQcBav9m//kACQCwAi+wB9wwMQD///+O/lcCKAWwAiYALQAAAAYBbeYG////dv5RAgkF2AImAE0AAAAGAW3OAP//ADUAAAJUBx4CJgAtAAABBwFrAFMBRgAJALACL7AM3DAxAAABACIAAAHLBDoAAwAdALAARViwAi8bsQIbPlmwAEVYsAAvG7EADz5ZMDEhIxMzAQ/tvO0EOv//ADX/5wacBbAAJgAtAAAABwAuAjsAAP//AB/+RgQDBdgAJgBNAAAABwBOAgUAAP//AAP/5wUxBzcCJgAuAAABBwFnAZIBNgAJALAAL7AQ3DAxAP///w/+SALHBd8CJgFkAAABBwFn/yj/3gATALAARViwDC8bsQwbPlmwEdwwMQD//wAn/fkFcQWwAiYALwAAAAcDqwFf/pL//wAR/fkESgYAAiYATwAAAAcDqwDu/pIAAQAhAAAEjQQ6AAwAXwCwAEVYsAQvG7EEGz5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgYCBBESObAGL7QfBi8GAnGyjwYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQHLc0vsvOxLSAGRATb+BwFF/uUBrP5UBDr+UAGw/ef93wD//wAnAAADwwc2AiYAMAAAAQcAdwBqATYAEwCwAEVYsAUvG7EFHz5ZsAjcMDEA//8AHwAAAz0HkQImAFAAAAEHAHcAawGRABMAsABFWLADLxuxAyE+WbAG3DAxAP//ACf9+QPDBbACJgAwAAAABwOrASX+kv///6L9+QIXBgACJgBQAAAABwOr/9P+kv//ACcAAAPfBbECJgAwAAABBwOrAskEqwAQALAARViwCi8bsQofPlkwMf//AB8AAAN0BgIAJgBQAAABBwOrAl4E/AAGALAILzAx//8AJwAAA8MFsAImADAAAAAHAWsBXP3U//8AHwAAAvMGAAAmAFAAAAAHAWsA8v2vAAEAIQAAA9IFsAANAFsAsABFWLAMLxuxDB8+WbAARViwBi8bsQYPPlmyAQwGERI5sAEvsADQsAEQsgIHCitYIdgb9FmwA9CwBhCyBAEKK1gh2Bv0WbADELAI0LAJ0LAAELAL0LAK0DAxATcHBwMhByETBzc3EzMBxfAc71oCgiP8h3CFG4Vy9wNsRptH/frKAoImmycCkgAAAQAfAAACWwYAAAsASgCwAEVYsAovG7EKIT5ZsABFWLAELxuxBA8+WbIBBAoREjmwAS+wANCwARCyAgcKK1gh2Bv0WbAD0LAG0LAH0LAAELAJ0LAI0DAxATcHBwMjEwc3NxMzAcKZHJiA7nKMHIp/7QN/NJw1/R4Ciy+cLwLZAP//ACcAAAWGBzYCJgAyAAABBwB3Ah4BNgATALAARViwCC8bsQgfPlmwDNwwMQD//wANAAAEJgYAAiYAUgAAAQcAdwFUAAAACQCwAy+wFdwwMQD//wAn/fkFhgWwAiYAMgAAAAcDqwGQ/pL//wAN/fkD+gRSAiYAUgAAAAcDqwD6/pL//wAnAAAFhgc7AiYAMgAAAQcBaAExATYAEwCwAEVYsAYvG7EGHz5ZsA/cMDEA//8ADQAABCMGBQImAFIAAAEGAWhnAAAJALADL7AX3DAxAP//AA0AAAP6BgMCJgBSAAABBwOrAEAE/QAGALAXLzAxAAEAI/5GBXgFsAATAGeyBhQVERI5ALAARViwAC8bsQAfPlmwAEVYsBAvG7EQHz5ZsABFWLAELxuxBBE+WbAARViwDC8bsQwPPlmwAEVYsA4vG7EODz5ZsAQQsgkBCitYIdgb9FmyDQAMERI5shIOABESOTAxAQEGBiciJzcWMzI3NwEDIxMzARMFeP7/GNelO0wjNimBIgf+SLf2/e4Bu7cFsPoYtswCFMYOxCgEH/vhBbD74gQeAAABABH+RgQGBFIAGwBhsgIcHRESOQCwAEVYsAMvG7EDGz5ZsABFWLAALxuxABs+WbAARViwCi8bsQoRPlmwAEVYsBkvG7EZDz5ZsgEDGRESObAKELIPAQorWCHYG/RZsAMQshYBCitYIdgb9FkwMQEHNhcWFgcDBgYnJic3FjMyNxM2JyYnJgcDIxMBpReGu6GWFnYY0KNBRCM5J4EfdgUCB4uDZY3uvAQ7mK8EA+bE/SC1xgIBE8UPuwLTLSmMBQRq/N8EOv//AGv/5wUhBuoCJgAzAAABBwByAREBOgAJALAKL7Aj3DAxAP//ADn/6AQnBbQCJgBTAAABBgByTwQACQCwBC+wIdwwMQD//wBr/+cFIQcdAiYAMwAAAQcBagFHATYACQCwCi+wJtwwMQD//wA5/+gEJwXnAiYAUwAAAQcBagCFAAAACQCwBC+wJNwwMQD//wBr/+cFdwc1AiYAMwAAAQcBbwGOATYADACwCi+wJdywJ9AwMf//ADn/6AS1Bf8CJgBTAAABBwFvAMwAAAAMALAEL7Aj3LAl0DAxAAIAUP/uB4oFxQAXACUAkbIbJicREjmwGxCwFtAAsABFWLAMLxuxDB8+WbAARViwDi8bsQ4fPlmwAEVYsAMvG7EDDz5ZsABFWLAALxuxAA8+WbAOELIQAQorWCHYG/RZshMADhESObATL7IUAQorWCHYG/RZsAAQshcBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAMELIdAQorWCHYG/RZMDEhIQcHJiYCNxM2EiQzFxchByEDIQchAyEFFjcTJicmBgcDBhcWFgaU/MXEV57naRQyHLUBE6VKzwNSJP1hRgJFJP29TgKm+5BPe8ZzTKDaHi8JBgiBEQEEnQEQoQE9qQENkgITzP5uyP5AGQMMBDsOAgLZwv7TSEZ0iAAAAwBC/+gG3ARSACAALwA5ALiyGjo7ERI5sBoQsCnQsBoQsDPQALAARViwCS8bsQkbPlmwAEVYsAQvG7EEGz5ZsABFWLAcLxuxHA8+WbAARViwFy8bsRcPPlmyBwkcERI5sjQJHBESObA0L7KPNAFdtB80LzQCcbINBworWCHYG/RZsBcQshEBCitYIdgb9FmyExcJERI5shoJHBESObAcELIlAQorWCHYG/RZsAQQsiwBCitYIdgb9FmwCRCyMAEKK1gh2Bv0WTAxEzYSNhcWFhc2FxYSBwchBhYXFjcXBgYnJiYnBicuAjczBxcWFxY2Nzc1JicmBgcBJgYHITc2JyYmVBSY7pRytzGmzsPJGhb9cA1raJqaQUPMe3a1MablisJYEOwFAQ6se6QVBwi0cqAcA/tShTYBpwUHBQhTAiChAQSMAgJeUbQEBP7z14+FnwMFX6A+QQICXE6xBAKO+ZZLLt8HA8alYR3yCAOxpAFTAXqMHC0pQ03//wAnAAAE2Ac2AiYANgAAAQcAdwGoATYACQCwBC+wGtwwMQD//wAQAAADhgYAAiYAVgAAAQcAdwC0AAAACQCwCy+wENwwMQD//wAn/fkE2AWwAiYANgAAAAcDqwEm/pL///+c/fkC7wRTAiYAVgAAAAcDq//N/pL//wAnAAAE2Ac7AiYANgAAAQcBaAC7ATYACQCwBC+wHNwwMQD//wAQAAADhAYFAiYAVgAAAQYBaMgAAAkAsAsvsBLcMDEA//8AJP/qBLsHNgImADcAAAEHAHcBxAE2AAkAsAovsCzcMDEA//8AHP/pBAMGAAImAFcAAAEHAHcBMQAAAAkAsAgvsCfcMDEA//8AJP/qBLsHNwImADcAAAEHAWcAwAE2AAkAsAovsCvcMDEA//8AHP/pA8wGAQImAFcAAAEGAWctAAAJALAIL7Am3DAxAP//ACT+PQS7BccCJgA3AAAABwB7AZAAAP//ABz+NAPEBFACJgBXAAAABwB7AUL/9///ACT/6gS7BzsCJgA3AAABBwFoANcBNgAJALAKL7Au3DAxAP//ABz/6QQABgUCJgBXAAABBgFoRAAACQCwCC+wKdwwMQD//wCc/kAFIgWwAiYAOAAAAAcAewF/AAP//wA7/j0CrgVBAiYAWAAAAAcAewDVAAD//wCcAAAFIgc7AiYAOAAAAQcBaADJATYAEwCwAEVYsAYvG7EGHz5ZsA3cMDEA//8AO//tA8gGgwAmAFgAAAAHA6sCsgV9AAEAnAAABSIFsAAPAEwAsABFWLAKLxuxCh8+WbAARViwAi8bsQIPPlmyDwoCERI5sA8vsgAHCitYIdgb9FmwBNCwDxCwBtCwChCyCAEKK1gh2Bv0WbAM0DAxASMDIxMjNzMTITchByEDMwO+yYj2ic0ezDT+SyQEYiT+SDTKAxL87gMSqgEozMz+2AAAAf/i/+0CrgVBAB4AgLIXHyAREjkAsABFWLAVLxuxFRs+WbAARViwGS8bsRkbPlmwAEVYsAsvG7ELDz5Zsh4ZCxESObAeL7IABworWCHYG/RZsAsQsgYBCitYIdgb9FmwABCwD9CwHhCwEdCwFRCyEwEKK1gh2Bv0WbAVELAX0LAXL7ATELAb0LAc0DAxASMDBhcWFzI3BwYjJiY3EyM3MzcjNzMTMwMzByMHMwJt0S0DAgZKJS8QSkt8ew0uzx7NG60grC7uLrkfuhzSAjf+8RkUQQMJvhUCpYgBG6qltAEH/vm0pf//AFv/5gUvBysCJgA5AAABBwFuAO8BNwAJALAAL7Ad3DAxAP//AEr/6AQxBfUCJgBZAAABBgFuWgEACQCwBy+wHtwwMQD//wBb/+YFLwbqAiYAOQAAAQcAcgDpAToACQCwAC+wE9wwMQD//wBK/+gEMQW0AiYAWQAAAQYAclQEAAkAsAcvsBTcMDEA//8AW//mBS8HHQImADkAAAEHAWoBHwE2AAkAsAAvsBbcMDEA//8ASv/oBDEF5wImAFkAAAEHAWoAigAAAAkAsAcvsBfcMDEA//8AW//mBS8HlQImADkAAAEHAWwBewFqAAwAsAAvsBzcsB/QMDH//wBK/+gEMQZfAiYAWQAAAQcBbADmADQADACwBy+wHdywINAwMf//AFv/5gVPBzUCJgA5AAABBwFvAWYBNgAMALAAL7AV3LAX0DAx//8ASv/oBLoF/wImAFkAAAEHAW8A0QAAAAwAsAcvsBbcsBjQMDEAAQBb/ogFMgWwACAAYbIHISIREjkAsABFWLAALxuxAB8+WbAARViwFy8bsRcfPlmwAEVYsA0vG7ENFz5ZsABFWLASLxuxEg8+WbIEEgAREjmwDRCyCAMKK1gh2Bv0WbASELIcAQorWCHYG/RZMDEBAwYGBwYHBhcWNxcGJyImNzY3LgI3EzMDBhYXFjY3EwUypRe+lXoKBTgbPQxFVVdpAgI9kNJgEaX2pRJ2e4e0GacFsPwzpPY4UFg5AwEXkCsCbVRYSAiE34wDzvwxi5wEBJqQA9QAAAEASv5RBDEEOgAjAHeyEiQlERI5ALAARViwGC8bsRgbPlmwAEVYsCEvG7EhGz5ZsABFWLALLxuxCxE+WbAARViwAC8bsQAPPlmwAEVYsBMvG7ETDz5ZsAsQsgYDCitYIdgb9FmwABCwENCwEC+yESEAERI5sBMQsh4BCitYIdgb9FkwMSEXBwYHBhcWNxcGJyImNzY3NwYnLgI3EzMDBhcWFxY3EzMDA1wFL4MHBTgbPQxFVVdpAgOxEnu5aYs7DHXtdgQDCnOdYYjtuwMfVlY5AwEXkCsCbVSWZ1qDBAJks3kCvP1BJSN8BQaEAwr7xgD//wC3AAAHOgc3AiYAOwAAAQcBZwG/ATYAEwCwAEVYsAwvG7EMHz5ZsA/cMDEA//8AdwAABfgGAQImAFsAAAEHAWcBAgAAABMAsABFWLALLxuxCxs+WbAR3DAxAP//AKEAAAVNBzcCJgA9AAABBwFnALkBNgATALAARViwAS8bsQEfPlmwC9wwMQD///+1/kUEEgYBAiYAXQAAAQYBZxYAABMAsABFWLAPLxuxDxs+WbAU3DAxAP//AKEAAAVNBwMCJgA9AAABBwBrAO8BNgAMALABL7Aa3LAJ0DAx////5QAABOcHNgImAD4AAAEHAHcBuQE2ABMAsABFWLAHLxuxBx8+WbAM3DAxAP///+cAAAPxBgACJgBeAAABBwB3AR8AAAATALAARViwBy8bsQcbPlmwDNwwMQD////lAAAE5wcXAiYAPgAAAQcBawGWAT8ACQCwBy+wEtwwMQD////nAAAD5AXhAiYAXgAAAQcBawD8AAkACQCwBy+wEtwwMQD////lAAAE5wc7AiYAPgAAAQcBaADMATYACQCwBy+wDtwwMQD////nAAAD7gYFAiYAXgAAAQYBaDIAAAkAsAcvsA7cMDEAAAEAHgAAAyAGGgANADKyAg4PERI5ALAARViwBC8bsQQhPlmwAEVYsAAvG7EADz5ZsAQQsgkBCitYIdgb9FkwMTMTNjYXFhcHJiciBgcDHskX2qo8YiwsLVBoD8oEn7HKAgEXuAwCY1n7ZgACAE7/6AUvBcMAGgAkAF6yDSUmERI5sA0QsBzQALAARViwEi8bsRIfPlmwAEVYsAAvG7EADz5ZsggSABESObAIL7ASELINAQorWCHYG/RZsAAQshsBCitYIdgb9FmwCBCyHgEKK1gh2Bv0WTAxBSYkJycmNzcFNicmJicmByc2IRYEEgcHBgIEJxY2NyEHBhcWFgJJ0/77GgQFDBYDrw8KEqqLpNEehgEfvgELdxkPHsv+1p2R2kP9RQcOChCRFATr1DJUWo8BW1OHlwMDSclUA7D+w8Rozf68rtcDy9EiTkNsdwAB/0r+RgNMBhkAHQBxsgIeHxESOQCwAEVYsBQvG7EUIT5ZsABFWLAPLxuxDxs+WbAARViwHC8bsRwbPlmwAEVYsAUvG7EFET5ZsBwQsgABCitYIdgb9FmwBRCyCgEKK1gh2Bv0WbAAELAN0LAO0LAUELIZAQorWCHYG/RZMDEBIwMGBicmJzcWFzI3EyM3Mzc2NhcWFwcmIyIHBzMCocOUE8iiQ0AgNyR4HZehHaAMFdiqNWcqNyekGwvDA4b8NK7GAgISvg4CqQPTtGWyyAIBFrsMxVIAAgBb/+gGJgYuABoAKwBbsiAsLRESObAgELAa0ACwAEVYsAovG7EKHz5ZsABFWLAALxuxAA8+WbINCgAREjmwDS+yEwgKK1gh2Bv0WbAKELIfAQorWCHYG/RZsAAQsigBCitYIdgb9FkwMQUuAicmEhI3NhcWFhc2NjczAgUWFxYCAgcGEzc2JicmAg8CBhYWFxYSNwJIj9R7CAc/mWyr3nfFQ1JlE7Ug/vIVBQU9o3Wl9AkKg4as5SMJCAY1d1ml4igUA4H3oX4BUAESV4kEAlhQD4CF/q5HZ2WG/p3+21h7AxhqtdAEBf7u9UBpbbxhAwcBAPMAAgA2/+YFBQSoABgAJwBbsh0oKRESObAdELAE0ACwAEVYsAQvG7EEGz5ZsABFWLAVLxuxFQ8+WbIHBBUREjmwBy+yDggKK1gh2Bv0WbAVELIcAQorWCHYG/RZsAQQsiMBCitYIdgb9FkwMRM2EjYXFhYXNjc3MwYGBxYXFgcCACcmAjcXFhYXFjY3NzYmJyYGBwZREp3xlGKvPmcbDqEOc24PAwIIJf7K3dTgGOoDY1l6qBgHA2NieqYZCAIgoAEGiwICSU0pfEyQqSdIR0dJ/vH+zAUGATXlc2l/BAPCqWJ9lQQDw6xRAAEAW//oBq0GAgAaAFSyFxscERI5ALAARViwAC8bsQAfPlmwAEVYsBEvG7ERHz5ZsABFWLAMLxuxDA8+WbIBAAwREjmwAS+yCAgKK1gh2Bv0WbAMELIWAQorWCHYG/RZMDEBBzY2NzcGBgcDBgAnLgI3EzMDBhYXFjY3EwUyKGp3Fa0T1c1sIv658JXcZxGl9qUSdX2HsxmnBbDfC4mcAdbiDP2k6P7uBAN+5JEDzvwxip4EBJqRA9QAAAEASv/oBWEElAAbAGiyFBwdERI5ALAARViwDS8bsQ0bPlmwAEVYsBYvG7EWGz5ZsABFWLAELxuxBA8+WbAARViwCC8bsQgPPlmyGBYEERI5sBgvsgMICitYIdgb9FmyBhYEERI5sAgQshMBCitYIdgb9FkwMQEGBgcDIzcGJy4CNxMzAwYXFhcWNxMzBzY2NwVhD6Slk94Ve7lpizsMde11BAMHdp5fiO0fUlISBJSuqQz8z2uDBAJks3kCvP1BJSN8BQaEAwqLDVx7////D/5IAvsF4wImAWQAAAEHAWj/P//eAAkAsAAvsBHcMDEA//8Aa//qBRYHSwImACsAAAEHAHcB9QFLAAkAsA0vsCTcMDEA////9/5PBEIGAAImAEsAAAEHAHcBQgAAAAkAsAQvsC3cMDEA//8AJwAABYYHNgImADIAAAEHAEQBgwE2ABMAsABFWLAGLxuxBh8+WbAL3DAxAP//AA0AAAP6BgACJgBSAAABBwBEALkAAAATALAARViwAy8bsQMbPlmwFNwwMQD///+kAAAE2gexAiYAJQAAAAcDxQGEARz//wAi/+gEMgZ8AiYARQAAAAcDxQDc/+f///+HAAAHeAdCAiYAiQAAAQcAdwLqAUIAEwCwAEVYsAYvG7EGHz5ZsBXcMDEA//8AD//oBnAGAQImAKkAAAEHAHcCawABAAkAsBkvsEHcMDEA//8AFf+hBZgHgAImAJsAAAEHAHcCIAGAABMAsABFWLAMLxuxDB8+WbAu3DAxAP//ACr/dwQzBf4CJgC7AAABBwB3ATP//gATALAARViwBS8bsQUbPlmwMdwwMQD///+kAAAErgchAiYAJQAAAQcBdQSKATMAFgCwAEVYsAQvG7EEHz5ZsAzcsBDQMDH//wAi/+gD3AXsAiYARQAAAQcBdQPi//4AFgCwAEVYsBgvG7EYGz5ZsC3csDHQMDH//wAnAAAEugcoAiYAKQAAAQcBdQRSAToAFgCwAEVYsAYvG7EGHz5ZsA3csBHQMDH//wA7/+oEAgXsAiYASQAAAQcBdQPL//4AFgCwAEVYsAkvG7EJGz5ZsCHcsCXQMDH////JAAACvQcoAiYALQAAAQcBdQMKAToAFgCwAEVYsAIvG7ECHz5ZsAXcsAnQMDH///9+AAACcgXkAiYA9AAAAQcBdQK///YAFgCwAEVYsAIvG7ECGz5ZsAXcsAnQMDH//wBr/+cFIQchAiYAMwAAAQcBdQShATMAFgCwAEVYsAovG7EKHz5ZsCTcsCjQMDH//wA5/+gEJwXsAiYAUwAAAQcBdQPf//4AFgCwAEVYsAQvG7EEGz5ZsCLcsCbQMDH//wAnAAAE2AchAiYANgAAAQcBdQQ8ATMAFgCwAEVYsAQvG7EEHz5ZsBncsB3QMDH//wAHAAAC+wXsAiYAVgAAAQcBdQNI//4AFgCwAEVYsAcvG7EHGz5ZsA/csBPQMDH//wBb/+YFLwchAiYAOQAAAQcBdQR5ATMAFgCwAEVYsAovG7EKHz5ZsBTcsBjQMDH//wBK/+gEMQXsAiYAWQAAAQcBdQPk//4AFgCwAEVYsAgvG7EIGz5ZsBXcsBnQMDH//wAk/fkEuwXHAiYANwAAAAcDqwE+/pL//wAc/fkDxARQAiYAVwAAAAcDqwDw/pL//wCc/fkFIgWwAiYAOAAAAAcDqwEt/pL//wA7/fkCrgVBAiYAWAAAAAcDqwCD/pIAAf8P/kgB3AQ6AAwAKACwAEVYsAwvG7EMGz5ZsABFWLAELxuxBBE+WbIJAQorWCHYG/RZMDEBAwYGIyInNxYzMjcTAdzDGMyjPUYfNSp/IcIEOvuItcURwRDCBG4AAAIANv/qA/YEUAAVAB0AZbIQHh8REjmwEBCwFtAAsABFWLAALxuxABs+WbAARViwCC8bsQgPPlmyDAAIERI5sAwvsAAQshABCitYIdgb9FmyEgwQERI5sAgQshYBCitYIdgb9FmwDBCyGAcKK1gh2Bv0WTAxARYSBwcOAicmAjc3ITYmJyYHJzY2ExYTIQYXFhYCRc7jFgcVmuSDxcgaFgKQDGppl5xBQ8wHqGf+WA0GCFUETgT+1eY5l/yDAwYBDNWPg6EDBV+gPkL8XQYBC0kpQ0///wCKBAAB/gYAAwYDcQAAAAYAsAQvMDEAAQECBN0DnwYBAAgASgCwBS+yDwUBXbAG0BmwBi8YsADQGbAALxiwBRCwAdCwAS+wBRCwBNCwBC+wAtCwAi+wBRCwB9CwBy+0DwcfBwJdsgMFBxESOTAxARUnJwcHJwEzA5+5da3BAQEtiATuEQObmgQSARIAAAEBDQTgA7wGBQAIACUAsAQvsg8EAV2wAtCwAi+0DwIfAgJdsgAEAhESObAH0LAHLzAxATc3FQEjAzUXAkKp0f7MkunEBWeZBBD+7AEVEAT//wDvBRIDywWwAAYAcgAAAAEA/gTIA2wF5wAMACwAsAMvsg8DAV2wANCwAC+0DwAfAAJdsAbQsAYvsAMQsgkCCitYIdgb9FkwMQEGBicmJjUXBjMyNjcDbAq6h4SfsAV4Q0wMBeeFmgQCmYABjE49AAEBAgTcAgEF2AAKAB2yAAsMERI5ALAIL7IPCAFdsgIFCitYIdgb9FkwMQE0NjYWFRQGBwYmAQJHbkpHNzZLBVU4RwRFNjlEAgJFAAACAPoEjAKoBisACwAXAC8AsAkvsg8JAV2wFdCwFS+yDxUBXbIDDAorWCHYG/RZsAkQsg8KCitYIdgb9FkwMRM0NjMyFhUUBiMiJjcGFjMyNjc2JiMiBvqFXVJ6hF1XdmsGMisySQYGMSsySgVSWn91VFl9dFQoQkguK0BJAAAB/6j+UQEkAD0ADwAbALAARViwCi8bsQoRPlmyBQMKK1gh2Bv0WTAxBQcGBwYXFjcXBiciJjc2JQEkL4MHBTgbPQxFVVdpAgMBCAMfVlY5AwEXkCsCbVSzdgABAN4E2wPJBfQAFABBALADL7AI0LAIL7QPCB8IAl2yDgMKK1gh2Bv0WbAU0LAA0LADELAK0LAKL7AL0LALL7ADELISAworWCHYG/RZMDEBBgYjIi4CBwYHJzY2FxYWFxc2NwPJDIFeGC1rNB1PG5UKgmAwliIZURwF6XeMDj0TAQNlCHKXAgFZBAEDZgAAAgCsBNED6QX/AAMABwBAALACL7IPAgFdsADQsAAvtA8AHwACXbACELAD0BmwAy8YsAAQsAXQsAUvsAIQsAbQsAYvsAMQsAfQGbAHLxgwMQEzASMDMwEjAu/6/snSVvP+9MUF//7SAS7+0gAAAv/u/mkBTf+/AAsAFwA9ALAYL7AD0LADL0APAAMQAyADMANAA1ADYAMHXbAP0LAPL7IJCQorWCHYG/RZsAMQshUJCitYIdgb9FkwMQc0NjMyFhUUBiMiJjcGFjMyNjc2JiciBhJqS0lhaUhKZGEEJR0hNgYFHiAjOfVNZ2JESmZeRh8rMyEdMQE2AAAB/VQE0f7ZBgAAAwAjALABL7IPAQFdsADQGbAALxiwARCwAtCwAi+0DwIfAgJdMDEBIwMz/tm00fwE0QEvAAH91wTR/+kGAAADACMAsAIvsg8CAV2wAdCwAS+0DwEfAQJdsAIQsAPQGbADLxgwMQEhASP+yQEg/r7QBgD+0f///PYE2//hBfQABwFu/BgAAAAB/dYE5f89Bn8ADgAlALAOL7AH0LAHL7IBDgcREjmyCAgKK1gh2Bv0WbINAQ4REjkwMQE3NzY3NicnNxcEBwYHB/3WDi9fCQprIhEoAQwDA6AKBOaSBQs6PAQBfAIWoX0eRgAAAvy/BOT/swXuAAMABwA3ALABL7AA0BmwAC8YsAEQsAXQsAUvsAbQsAYvtg8GHwYvBgNdsAPQsAMvsAAQsATQGbAELxgwMQEjAyEBIwMh/pHd9QESAeLOwAEEBOQBCv72AQoAAAH8oP6R/az/jgALABEAsAMvsgkNCitYIdgb9FkwMQU0Njc2FhUUBgcGJvygSzo3UEo7Ok31NkkCAkQ3OUUCAkYAAAEBLgTpAogGQQADABcAsAIvsADQsAAvsAIQsAPQGbADLxgwMQEzAyMBpuLElgZB/qgAAwDoBNwEIwavAAMADwAbAD4AsA0vsALQsAIvsADQsAAvtA8AHwACXbACELAD0BmwAy8YsA0QsgcFCitYIdgb9FmwE9CwDRCwGdCwGS8wMQEzAyMFNDY3NhYVBgYHBiYlNjY3NhYVFAYHBiYCneizl/6tRDcySgFGMzJLAkQBRjMyS0U2NEgGr/7WMjBIAgJCNDREAgJCMzREAgJCNDBIAgJEAP///6QAAASuBkECJgAlAAAABgF3wQD//wCeAkIBsQNVAgYAegAA////vgAABR4GQQAmAClkAAAHAXf+kAAA////xgAABesGQQAmACxkAAAHAXf+mAAA////ygAAAowGQwAmAC1kAAAHAXf+nAAC//8AGP/nBTUGQQAmADMUAAAHAXf+6gAA////WAAABbEGQQAmAD1kAAAHAXf+KgAA//8AHQAABQsGQQAmAZkUAAAHAXf+9AAA//8AC//0A0YGmgImAakAAAEHAXj/I//rABIAsAAvsCfcsA7QsCcQsBLQMDH///+kAAAErgWwAgYAJQAA//8AJwAABLwFsAIGACYAAAABAC4AAASsBbAABQArALAARViwBC8bsQQfPlmwAEVYsAIvG7ECDz5ZsAQQsgABCitYIdgb9FkwMQEhAyMTIQSI/XXZ9vwDggTk+xwFsAAC/6oAAAUJBbAAAwAGAC8AsABFWLAALxuxAB8+WbAARViwAi8bsQIPPlmyBAEKK1gh2Bv0WbIGAgAREjkwMQEzASElIQMC6+0BMfqhAXoCybcFsPpQygO5AP//ACcAAAS6BbACBgApAAD////lAAAE5wWwAgYAPgAA//8AJwAABYcFsAIGACwAAAADAF7/5wUWBcgAAwAVACUAg7IbJicREjmwGxCwAtCwGxCwDdAAsABFWLANLxuxDR8+WbAARViwBC8bsQQPPlmyAgQNERI5fLACLxiyYAIBXbJCAgFdsnICAV200ALgAgJdsjACAV2yAAIBcbIBAQorWCHYG/RZsA0QshoBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxASE3IQEuAicmEhI3NgQAFxYCAgcGEzc2JicmAg8CBhYXFhI3A5D+SyMBtP6aj9Z6CAc6n3SoAbABAQwGOYtnstwJB4ODr+IiCggKhIWl4igCecL8sQOD+J1zAVEBIVqCCP7e93z+v/7zWpwDGWq8yQQF/u3tR2m30gQHAQDzAP//ADUAAAIoBbACBgAtAAD//wAnAAAFcQWwAgYALwAAAAH/sgAABH8FsAAGADEAsABFWLADLxuxAx8+WbAARViwAS8bsQEPPlmwAEVYsAUvG7EFDz5ZsgADARESOTAxAQEhATMTIQLe/eX+7wLr7/P/AARB+78FsPpQ//8AJwAABs4FsAIGADEAAP//ACcAAAWGBbACBgAyAAAAAwAAAAAEiAWwAAMABwALAEsAsABFWLAILxuxCB8+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WbIFCAIREjmwBS+yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IQchEyEHIRMhByEkA6Yj/Fn0AuEj/R84A38j/IDKygNNxgMpzAD//wBr/+cFIQXIAgYAMwAAAAEALgAABYMFsAAHADgAsABFWLAGLxuxBh8+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsAYQsgIBCitYIdgb9FkwMSEjEyEDIxMhBIb22f2U2fb8BFkE5PscBbAA//8AJwAABQQFsAIGADQAAAAB/9wAAASfBbAADAA8ALAARViwCC8bsQgfPlmwAEVYsAMvG7EDDz5ZsgEBCitYIdgb9FmwBdCwCBCyCgEKK1gh2Bv0WbAH0DAxAQEhByE3AQE3IQchAQMb/i8CniP8FxwCIP6oGQPGJP12ASsC0f35yqICQwI+jcz+AQD//wCcAAAFIgWwAgYAOAAA//8AoQAABU0FsAIGAD0AAAADAFIAAAWxBbAAFQAcACMAdbITJCUREjmwExCwGtCwExCwIdAAsABFWLAVLxuxFR8+WbAARViwCC8bsQgPPlmyExUIERI5sBMvsADQsAAvsgoIFRESObAKL7AH0LAHL7AKELIZAQorWCHYG/RZsBMQshoBCitYIdgb9FmwINCwGRCwIdAwMQEWAAcGAgQHByM3LgI3NhI3Njc3MwEGFhcTBgYFNiYnAzY2A9XbAQEVD63+6ack9ySR3GwPD6qKj6sm9/1YEXyFgpjHA0QSeoWBlccE/Qr+zOaf/wCNA6qrBY72k6ABAElLA7L9F5KuCwKyCMCMlbAN/U4Ivf///8MAAAVHBbACBgA8AAAAAQB1AAAF1wWwABkAXLIKGhsREjkAsABFWLAELxuxBB8+WbAARViwEC8bsRAfPlmwAEVYsBgvG7EYHz5ZsABFWLAKLxuxCg8+WbIXBAoREjmwFy+wANCwFxCyDAEKK1gh2Bv0WbAJ0DAxATY2NxMzAwYABwMjEyYCNxMzAwYXFhYXEzMDQYarGVX3Vir+wfZI9kjc2x1T9lQIAwVjWZ70Aj8bxZoB9/4C+f7VF/6JAXcfAUHoAfH+Dj48YocYA20AAQAJAAAE9wXHACMAWbIAJCUREjkAsABFWLAZLxuxGR8+WbAARViwDy8bsQ8PPlmwAEVYsCIvG7EiDz5ZsiEBCitYIdgb9FmwANCwGRCyBwEKK1gh2Bv0WbAAELAO0LAhELAR0DAxJTYSEzc1AicmBgIHBhYXByE3NwITNzYSJBcWFhIHBwIFNwchAoCPqyEGC8+Qvj4DBVFRIP4UJdGhJQ0atAESpJ3gZhUNNf720ST+Hc4nATMBN08zAQ8IBdv+fHaQrxnQywIBDgESXbgBJp8EBKT+3qhX/p7RBMv//wA1AAADLAcKAiYALQAAAQcAa/+pAT0ADACwAi+wFdywBNAwMf//AKEAAAVNBwMCJgA9AAABBwBrAO8BNgAMALABL7Aa3LAJ0DAx//8APv/qBDMGQQImAaEAAAEHAXcBRgAAAAkAsBovsC7cMDEA//8AKP/qBAIGQQImAaUAAAEHAXcBEAAAAAkAsAgvsCrcMDEA//8AEf5hBAYGQQImAacAAAEHAXcBGgAAAAkAsAMvsBXcMDEA//8Abv/0ApIGLAImAakAAAEGAXcK6wAJALAAL7AQ3DAxAP//AFf/5QQ9BqICJgG1AAABBgF4GvMAEgCwCi+wMNywF9CwMBCwG9AwMQACAD7/6gQzBFEAHQArAHmyGiwtERI5sBoQsCTQALAARViwGi8bsRobPlmwAEVYsAAvG7EAGz5ZsABFWLAQLxuxEA8+WbAARViwCi8bsQoPPlmyBQEKK1gh2Bv0WbINGhAREjmyHBoQERI5sBAQsiMBCitYIdgb9FmwGhCyKAEKK1gh2Bv0WTAxAQMGFxYXMzcXBicmJicGBicmJicmNzc2EjYXFhc3AQYXFhYXFjcTJicmBgcEM4AHAgInDg0GNUBOXg08lGSatAcDBgMVi8yArVUx/cwGAQJZUoRiUC9/eZ4WBDr9BjQaNAIDtx0CAlRLS1kCAtu1PTwVrAEThgMElYX9uDM4ZHQCA4sByYkEBdO2AAAC/+X+dwRrBccAFAApAGWyFCorERI5sBQQsBzQALAPL7AARViwAC8bsQAfPlmwAEVYsAwvG7EMDz5ZshUADBESObAVL7InAQorWCHYG/RZsgUnFRESObAAELIbAQorWCHYG/RZsAwQsiEBCitYIdgb9FkwMQEWFgcGBxYWBw4CJyYnAyMTPgITNjY3NiYnJgYHAxYXMjY3NiYnJzcC27jYDQ7cXl4ICobbhJ10V+z3EJLiF2mCCwlYUWCREotKkXGjEA5ZWIQaBcQE1anDdS66dYXRbwMEUv42Bah3xG39lAJ0aVhuBAKAZvzeUAKPcmWMBQG4AAABAHf+XwQwBDoACAA4sgAJChESOQCwAEVYsAEvG7EBGz5ZsABFWLAHLxuxBxs+WbAARViwBC8bsQQRPlmyAAcEERI5MDEBATMBAyMTAzMByQFp/v3fTu1TsOwBPgL8++L+QwHeA/0AAAIAOP/nBDgGJAAfAC4AYrICLzAREjmwAhCwJtAAsABFWLADLxuxAyE+WbAARViwFS8bsRUPPlmwAxCyCAEKK1gh2Bv0WbIOFQMREjmwDi+yKwEKK1gh2Bv0WbIcKw4REjmwFRCyJQEKK1gh2Bv0WTAxATY2FxYXByYHIgYHBhcXBAMHDgInLgI3NjY3NSYmAwYXFhYXFjY3NiYnBgYHAUEH67FsmRWEakxrCg9wLAGGJwMUme+QisRcDhLbnkhNBwYDA2NXd6QcDmZgeqUYBOKVrQICMcQ4AkE3TTcUrP51FJ36iAQEh/GUvv8cDyeG/XM1O2h9AwO9vH+7HgO6qgABACj/6gQCBFEAJwCgshQoKRESOQCwAEVYsAgvG7EIGz5ZsABFWLAlLxuxJQ8+WbIVCCUREjmwFS+yjxUBXbQfFS8VAnG0XxVvFQJxtL8VzxUCXbTvFf8VAnGyWhUBXbIXBworWCHYG/RZsgIXFRESObAIELIPAQorWCHYG/RZsgwVDxESObYMDBwMLAwDXbAlELIdAQorWCHYG/RZsiAXHRESObQDIBMgAl0wMRM2NyYmNzYkFxYWFSc0JiMmBgcGFxcHJyIGBwYWFxY2NzMOAicmJi8K5j1PAgUBDc6y2+llTlmGChOx0R+0boQJCGdcWo4O7gmC3X7D7AEpt1MhbUiargQFspABQkgCUER5BgGtAVVKP04DAlVKa5xQAgSqAAEAZv59BFAFsAAbAE+yEhwdERI5ALAML7AARViwAC8bsQAfPlmyGQEKK1gh2Bv0WbIBGQAREjmyAgwAERI5shMMABESObATELIGAQorWCHYG/RZshgADBESOTAxAQcBBhcWFxcWFgcGByc3Njc2JyckEzYSNwEhNwRQHP4W4gcDXbBZSQQK3norPwsKTnX+7xwOqrEBFP3eIgWwnP4J9NleJD0hYUmlpGsvSDo3HCRbAQ2KASqyAQ/DAAEAEf5hBAYEUgASAFOyCBMUERI5ALAARViwAy8bsQMbPlmwAEVYsAAvG7EAGz5ZsABFWLAHLxuxBxE+WbAARViwEC8bsRAPPlmyAQMQERI5sAMQsg0BCitYIdgb9FkwMQEHNhcWFgcDIxM2JyYnJgcDIxMBpRSKtaGVE7vtvAUDDoaIZYnuvAQ7hZwEBNTA+6sEVCwngAMEffzuBDoAAwBs/+cEPwXJABEAGQAiAIayICMkERI5sCAQsADQsCAQsBjQALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZshMJABESOXywEy8YsmATAV2yQhMBXbJyEwFdtNAT4BMCXbIwEwFdsgATAXGwCRCyFwEKK1gh2Bv0WbATELIaAQorWCHYG/RZsAAQsiABCitYIdgb9FkwMQUmAjc0NzcSABcWEgcGBwcCAAEhNjUmJyYDASEGFxQWFxYTAei4xAIJHzEBHt+5wgEBCSI0/uf+tgHJFQWf2UsBn/43FQFUTtZOFAQBBetLR8wBQgFJBQT+/OdLR93+xf68A1GDUe8HCP6i/s2DS3mCAwwBZAAAAQBu//QCCgQ6AA0AKACwAEVYsAAvG7EAGz5ZsABFWLAJLxuxCQ8+WbIEAQorWCHYG/RZMDEBAxUWFzI3BwYnJiY3EwHrgwNLJy0QSkt8ew2DBDr89S1AAwm+FgICo4kDFv//ACEAAASNBDoCBgD7AAAAAf+o//AD1gX7ABoAUbIPGxwREjkAsAAvsABFWLALLxuxCw8+WbAARViwEC8bsRAPPlmwCxCyBgEKK1gh2Bv0WbIPABAREjmyEhAAERI5sAAQshYBCitYIdgb9FkwMQEWFxMWFhczNwcGIyYmJwMBIQEnJiYnJwc3NgGZuDDoCB4kEhENKipfch1p/pb+9AIxLgsqKxsbDj4F+QSl+8QfNgUBwwgCZmsCBP05BB3AKC0CAQG4D////93+YARUBDoCBgB4AAD//wBkAAAEDQQ6AgYAWgAAAAEAPv51BCYFxQAtAFayBS4vERI5ALAXL7AARViwKy8bsSsfPlmyAgEKK1gh2Bv0WbIHLisREjmwBy+yCgEKK1gh2Bv0WbIeFysREjmwHhCyEAEKK1gh2Bv0WbIlCgcREjkwMQEmIyIGBwYFFwcnIgYHBhYfAhYHBgYHJzc2NzYnJyYnJhM2NjcmJjc2JDMyFwPue1h8mAwbAQ+FI36s0xILYWCELqkIBXhsgC9CCQc/KqBC2hUKuKtUYAQIAR/bjIgE2iZbTq8CAcYBmY5dgxwlDzyQUqlNajFIPTIZDzMjcgEBjcs4KIlYrsYuAP//ADn/6AQnBFICBgBTAAAAAQBd//UE2gQ6ABYAXLINFxgREjkAsABFWLAVLxuxFRs+WbAARViwCy8bsQsPPlmwAEVYsBEvG7ERDz5ZsBUQsgABCitYIdgb9FmwCxCyBgEKK1gh2Bv0WbAAELAP0LAQ0LAT0LAU0DAxASMDBhcWFzI3BwYjJiY3EyEDIxMjNyEEuZtjAwIGSiYvEUVQfHsNYv7Am+2bpyIEWwN8/bQZFEEDCb4VAqOKAlj8hAN8vgAC/8v+YAQMBFMAEgAgAFCyDiEiERI5sA4QsBbQALAARViwBS8bsQUbPlmwAEVYsBEvG7ERET5ZsABFWLAOLxuxDg8+WbIVAQorWCHYG/RZsAUQsh0BCitYIdgb9FkwMRM2Njc2FxYWFxYHBwYGJyYnAyMBFhcWNjc2JyYmJyYGB3UQW0iQ0LDICQMHDSz3salhYe4BazSDdZ4VCwMIVU5rjhkCPm/JSZQFBOnHRUVT3/gFBHb9+wK/bwQDs591PXFsAwK/ogABADv+iQPwBFMAIABZsg0hIhESOQCwAEVYsAAvG7EAGz5ZsABFWLAaLxuxGg8+WbAARViwEy8bsRMXPlmwABCxAworWNgb3FmwABCyBwEKK1gh2Bv0WbAaELINAQorWCHYG/RZMDEBFhYHJzYmJyYGBwcGFxcWBwYGByc3Njc2JicmAjc3EgACc7TJCN4FVVRzoRYEHO5toAcDe2x5KUMJBCU6zb8TAh0BMQROBOG0AWRuBAPAoyPtVyc9j1GrTWssSj8hKBA+AQTEFAECATUAAgA4/+gEtgQ7ABEAIgBhshgjJBESObAYELAH0ACwAEVYsBAvG7EQGz5ZsABFWLARLxuxERs+WbAARViwCC8bsQgPPlmwERCyAAEKK1gh2Bv0WbAIELIXAQorWCHYG/RZsBAQsiABCitYIdgb9FkwMQEFFgcHDgInLgI3NzYAMwUBBhcWFhcWNjc3NicmJicmBgSS/v6DEQMQlu+Ki8RZEAIiATHeAjv8gAYCBGBXb50cBwYCBV5VeKADdgOrxxaR7YUEApD8lRD7ASEB/dE2PW58AgOspS80OmZ3AwO2AAABAG7/6wQjBDoAEQBJsgMSExESOQCwAEVYsBAvG7EQGz5ZsABFWLAKLxuxCg8+WbAQELIAAQorWCHYG/RZsAoQsgUBCitYIdgb9FmwABCwDtCwD9AwMQEhAwcUMxY3FwYnJiY3EyE3IQQB/qNlAj8hPRVSX3x6DmH+tyIDkwN5/a8oSgEVtCsCAquWAknBAAABAFf/5QP+BDwAFgA8shAXGBESOQCwAEVYsAovG7EKGz5ZsABFWLAALxuxABs+WbAARViwES8bsREPPlmyBQEKK1gh2Bv0WTAxAQMHBhYXFhIDJicXFgcGAgYnJiY3NxMBv20FAjs5lcMOBiHiOgsPm/iZqbgKA24EOv1rTExfAgYBdAEkgX0Bqdf7/sahBAPXwCYCkQACADL+IgVtBEQAGwAkAFmyGSUmERI5sBkQsBzQALAaL7AARViwEi8bsRIbPlmwAEVYsAcvG7EHGz5ZsABFWLAALxuxAA8+WbAZ0LIcAQorWCHYG/RZsA7QsBIQsiIBCitYIdgb9FkwMQUmJyY3NhI3FwYCFxYWFxM2NhceAgcGAAUDIwE2NicmJgcGBwH67nJoGRObhohxbgwKcWBxDqZ7h9FmDhr+r/7zV+0BXq3KAgNnVjYMDCOqnOCgAQlblmj+9H1jhhoChXWTAgKQ9Y30/tEa/jECkSTxq4GQBgQ2////uQAABBMEOgIGAFwAAAABAD/+IgWKBDwAHQBSsg4eHxESOQCwDy+wAEVYsAAvG7EAGz5ZsABFWLAILxuxCBs+WbAARViwFS8bsRUbPlmwAEVYsBEvG7ERDz5ZsA7QsgEBCitYIdgb9FmwHNAwMQEDNjYSJyYnFxYXEgcGBQMjEyYCNxMzAwYXFhYXEwOeo5K/RAwJI94rCh/vqf70V+1X4dkgUu1SCQMDZ1+iBDr8eiK3AQ6rfngCdn/+ROGfGf4yAdIiAUT3Aen+FEJAa44cA4MAAQBU/+QGEAQ9ACsAXrIjLC0REjkAsABFWLAALxuxABs+WbAARViwGy8bsRsbPlmwAEVYsCEvG7EhDz5ZsABFWLAmLxuxJg8+WbIHAQorWCHYG/RZsgwhABESObAhELISAQorWCHYG/RZMDEBBwYGBwYWFxY2NxMzAwYXFxYXFjY3NzYnJicXFhcWAgYnJiYnBicmJjcQEwIoUk9GAwNDPVt9EzX1NAkDAhByVnkcChEMDC3iNAwTcuakapgYhdOirALeBDmYleiDd3sDBqCZAUb+uksxG5gDBKmqQIKCgXwDeILd/lnVBAJ4ZeYHBOnXAV8BKwD//wBM//QC/gW4AiYBqQAAAQcAa/97/+sADACwAC+wH9ywDtAwMf//AFf/5QP+BcACJgG1AAABBgBrcvMADACwCi+wKNywF9AwMf//ADn/6AQnBkECJgBTAAABBwF3AQ0AAAAJALAEL7Aj3DAxAP//AFf/5QP+BjQCJgG1AAABBwF3AQL/8wAJALAKL7AZ3DAxAP//AFT/5AYQBjICJgG5AAABBwF3Ahj/8QAJALAaL7Au3DAxAAACAFD/5gSNBckAHgAoAGuyFCkqERI5sBQQsCDQALAARViwGS8bsRkfPlmwAEVYsAYvG7EGDz5ZsiEZBhESObAhL7ITAQorWCHYG/RZsALQsgwZBhESObAGELIQAQorWCHYG/RZsCEQsB3QsBkQsiUBCitYIdgb9FkwMQEGBwcGBCcuAjcTNwMGFhcWEzcmAjc2NhcWFgcDNwEGFxM3NCcmBgcEgjlLEyX+58h+vFsPL+cwDmRhyjQUt8sOE9yfmKESNHL98RK6OARUOUoLAlYTC3Xh/AYDedeAASMC/tp4jgMHASBvLAEVu7/RBATZrf7LGAEh4UwBODdwAgJUTQAAAQBtAAAFBgXJABgAVLIMGRoREjkAsABFWLAELxuxBB8+WbAARViwFi8bsRYfPlmwAEVYsAwvG7EMDz5ZsgAWDBESObAEELIIAQorWCHYG/RZsBYQshEBCitYIdgb9FkwMQEBNjYXFhcHJwYHAQMjEwMmJyYHJzYzFhcCRwETP4pXO1E1M0Es/mhZ9l6nFTgRJRE8QK8/AwkB53lgAgIZwwYDRf1d/fwCHwKJPgMBBcQYBMv///8kAAAFagZBACYBwGQAAAcBd/32AAAAAgBX/+MGfQQ6ABQAKgBmsgkrLBESObAJELAh0ACwAEVYsBMvG7ETGz5ZsABFWLAMLxuxDA8+WbATELIBAQorWCHYG/RZsAwQsAfQsgoTDBESObABELAX0LAS0LAMELIdAQorWCHYG/RZsiEMEhESObAn0DAxAScXBgIGBicmJicGJyYmNxI3BzchASYnJQYGBwYXFjY3NzMHBhcWFxYTNgZaeAMCPHixb2ucGIbamKEGBHhyIgX0/n4BB/zdSDwGC3Bbfhgk9CIIAwqBkzYbA4MBpIr+29xtAwJ4aesHBOvdAQDQArb+plFSAonXfPYGB5ad6eNJNbIDBAEpl///ACcAAAS6Bz0CJgApAAABBwBEASMBPQATALAARViwBi8bsQYfPlmwDdwwMQD//wAnAAAEugcKAiYAKQAAAQcAawDwAT0ADACwBi+wHdywDNAwMQABAJH/8QWFBbAAGQBusgEaGxESOQCwAEVYsBgvG7EYHz5ZsABFWLAKLxuxCg8+WbAARViwFC8bsRQPPlmwGBCyAAEKK1gh2Bv0WbIEGBQREjmwBC+wChCyCwEKK1gh2Bv0WbAEELIRAQorWCHYG/RZsAAQsBbQsBfQMDEBIQM2FxYWBwYEBzc2Njc2JicmBwMjEyE3IQTf/iJNjW/f9hES/sj+E4ujDw1yeW6SdvfZ/ockBE4E5P5zJwIC88rZ8QK/BIl6boEEAyD9cwTkzAD//wAuAAAErAc9AiYBhAAAAQcAdwG5AT0AEwCwAEVYsAQvG7EEHz5ZsAjcMDEAAAEAZ//oBREFxwAgAIWyFCEiERI5ALAARViwDC8bsQwfPlmwAEVYsAMvG7EDDz5ZsgAMAxESObIQAwwREjmwDBCyEwEKK1gh2Bv0WbIWDAMREjl8sBYvGLJgFgFdsnIWAV2yQhYBXbIwFgFdtNAW4BYCXbIAFgFxshkBCitYIdgb9FmwAxCyHQEKK1gh2Bv0WTAxAQYAJy4CJyYSEiQXFhIXIyYmJyYGByUHIQcGFhcWNjcEqSH+r/CL0XcHBkTCARyp2PwL9QV7dpbUPQH0JP4ZCQZ+fIu2JAHb4/7wBAN+75pxAYkBOZ4DBP74656LAwXT6wHKYqS5BAaXkwAAAQAk/+oEuwXHACkAYbIDKisREjkAsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyAx8KERI5sAoQsA7QsAoQshIBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WbAfELAk0LAfELInAQorWCHYG/RZMDEBNicnJiY3PgIXHgIHJzYmJyYGBwYXFxYWBw4CJy4CNxcGFhcWNgNMFrNR4r4JCJn6jYjUcAT2B3N0daEOFL5L5bYLCo77l4/pfAX3CIqBeKEBfpBGHk/Yj3y9ZgMDccmBAXJ+AwJyYX9JG1Ldl3u3ZAIBdtGFAXyGAgJqAP//ADUAAAIoBbACBgAtAAD//wA1AAADLAcKAiYALQAAAQcAa/+pAT0ADACwAi+wFdywBNAwMf//AAP/5wRhBbACBgAuAAAAAv/KAAAH9QWwABkAIgB5sgojJBESObAKELAb0ACwAEVYsBgvG7EYHz5ZsABFWLAILxuxCA8+WbAARViwEC8bsRAPPlmyARgIERI5sAEvsBgQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbAIELIcAQorWCHYG/RZsAEQsiIBCitYIdgb9FkwMQEFHgIHBgAjIRMhAwcCAgcjNzc2Njc3EyEDAwU2Njc2JicFIAERitRmCxH+xfT939n+UnEeQ/vCWxYkf6IpE4oDkX9bARJ/sBIPcWkDoQEEdsyC0/77BOT99ZL+z/7vBcoBCd/3bwKX/Sb99AIClH1uiAQAAgAuAAAH/QWwABIAGwCCsgEcHRESObABELAU0ACwAEVYsAIvG7ECHz5ZsABFWLARLxuxER8+WbAARViwCy8bsQsPPlmwAEVYsA8vG7EPDz5ZsgECCxESObABL7IFAgsREjmwBS+wARCyDQEKK1gh2Bv0WbALELIVAQorWCHYG/RZsAUQshsBCitYIdgb9FkwMQEhEzMDFxYWBwYEIyETIQMjEzMBAwU2Njc2JicBtQJrbPZh/OL+DxD+xvT93279lW72/PYC3lUBEoGuDw5xawNFAmv90gEB8cPO/gJ6/YYFsP0I/hgCAoxzaHwEAAEAoAAABZgFsAAWAF2yARcYERI5ALAARViwFS8bsRUfPlmwAEVYsAgvG7EIDz5ZsABFWLARLxuxEQ8+WbAVELIAAQorWCHYG/RZsgQVCBESObAEL7IOAQorWCHYG/RZsAAQsBPQsBTQMDEBIQM2FxYWBwMjEzYnJicmBwMjEyE3IQTh/iBGgobq6xhL90wIBxW+ZK999tn+lSQEQQTk/pocAgT11/44AclAMI4GAxz9TATkzAD//wAnAAAFcQc2AiYALwAAAQcAdwGlATYAEwCwAEVYsAUvG7EFHz5ZsA/cMDEA//8AJwAABXwHPQImAdsAAAEHAEQBggE9ABMAsABFWLAILxuxCB8+WbAL3DAxAP//AJv/5wVTByQCJgHmAAABBwFqARUBPQAJALABL7AU3DAxAAABACX+mAV8BbAACwBIALAJL7AARViwAC8bsQAfPlmwAEVYsAQvG7EEHz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAD0DAxATMDIRMzAyEDIxMhASL32gJs2vf9/lk/9z/+RAWw+xoE5vpQ/pgBaP///6QAAASuBbACBgAlAAAAAgAjAAAEoQWwAAwAFQBesg8WFxESObAPELAJ0ACwAEVYsAsvG7ELHz5ZsABFWLAJLxuxCQ8+WbALELIAAQorWCHYG/RZsgMLCRESObADL7AJELIPAQorWCHYG/RZsAMQshUBCitYIdgb9FkwMQEhAxcWFgcGBCMhEyEBAwU2Njc2JicEff12Pf7j/REQ/sf0/d38A4L88lYBEoGuDw5wawTk/p8BAe/E0P4FsP0I/hICApB3aXkE//8AJwAABLwFsAIGACYAAP//AC4AAASsBbACBgGEAAAAAv+E/poFkQWwAA4AFQBVshIWFxESObASELAL0ACwAS+wAEVYsAsvG7ELHz5ZsABFWLACLxuxAg8+WbABELAE0LACELINAQorWCHYG/RZsBDQsAbQsAsQshEBCitYIdgb9FkwMQEjEyEDIxMXNhITEyEDMwUlEyEDBwIE/us+/GA/7ltlc543iAN92bT79gJft/5mbhFV/poBZv6aAjADUwEzAQ4CVfsaBAQEGv4aQv68//8AJwAABLoFsAIGACkAAAAB/6UAAAfgBbAAFQB9ALAARViwCS8bsQkfPlmwAEVYsA0vG7ENHz5ZsABFWLARLxuxER8+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAULxuxFA8+WbIQCQIREjmwEC+yAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIwMjEyMBIQEBIRMzEzMDMwEhAQEhBOSjbvZunf45/r4CWP7SARvpnWr2aooBtwE5/dsBN/7dAnT9jAJ0/YwDEwKd/aACYP2gAmD9Tf0DAAEAHv/tBKgFxQApAIGyByorERI5ALAARViwDi8bsQ4fPlmwAEVYsBovG7EaDz5ZsgAOGhESObAAL7IfAAFxsp8AAV2yegABXbJKAAFdsA4QsgYBCitYIdgb9FmyCg4aERI5sAAQsicBCitYIdgb9FmyEycAERI5sh0OGhESObAaELIhAQorWCHYG/RZMDEBMjY3NiYnJgYHBz4CFxYWBwYFFhYHBgQHByYkNxcGFhcWNjc2LwI3And+oQwMfW1nohH1CY74jOD4DhH+/WNcBwz+2eU10v7/B/MEgmZ+wQ4b0SS1IwNJeGpecAICcGEBd7ppAgXYuc94Lqxsu+sMAQLnvwFkeQIEgW7FGQMByAAAAQAnAAAFfAWwAAkARQCwAEVYsAAvG7EAHz5ZsABFWLAHLxuxBx8+WbAARViwAi8bsQIPPlmwAEVYsAUvG7EFDz5ZsgQAAhESObIJAAIREjkwMQEzAyMTASMTMwMEff/997L86/7997IFsPpQA/78AgWw/AEA//8AJwAABXwHJAImAdsAAAEHAWoBVwE9AAkAsAAvsA3cMDEA//8ALgAABXsFsAIGA8EAAAAB/8oAAAV8BbAAEQBNsgQSExESOQCwAEVYsAAvG7EAHz5ZsABFWLABLxuxAQ8+WbAARViwCS8bsQkPPlmwABCyAwEKK1gh2Bv0WbAJELIMAQorWCHYG/RZMDEBAyMTIQMHAgIHIzc3NjY3NxMFfP322f5ScR5E/MNYFiJ+oSoWigWw+lAE5P31kv7L/vACygIH1PCCApcA//8AJwAABs4FsAIGADEAAP//ACcAAAWHBbACBgAsAAD//wBr/+cFIQXIAgYAMwAA//8ALgAABYMFsAIGAZEAAP//ACcAAAUEBbACBgA0AAD//wBl/+gFDQXHAgYAJwAA//8AnAAABSIFsAIGADgAAAABAJv/5wVTBbAAEABDsgAREhESOQCwAEVYsAEvG7EBHz5ZsABFWLAPLxuxDx8+WbAARViwBi8bsQYPPlmyAAEGERI5sgsBCitYIdgb9FkwMQEBIQEGBiciJzcWNzI3NwEhApcBnwEd/U1Uwn8vQRc0H25DRP7XAQICuAL4+1WbgwIHyAcBbHwEFgADAFb/xAYSBewAFwAfACkAXrIVKisREjmwFRCwHdCwFRCwIdAAsAovsBcvsgAXChESObAAL7IMChcREjmwDC+wCdCwABCwFNCwDBCyGwEKK1gh2Bv0WbAUELIdAQorWCHYG/RZsCDQsBsQsCHQMDEBMhYSBwYCBCcnByM3IiYCNzYSJBcXNzMBBhYXFxMiBiUDMjY3NicmJicEDKLwdBARvf7XqxQo7Sik73YQErsBKqwWKub9IBSQlRWTuugCkJG06BgKChCFawUkmv7xoaz+6ZgDAb/AlgENoa0BGJsCAcf83KzIBwEDEd7d/O/ZtkxFan0IAP///8MAAAVHBbACBgA8AAAAAQAl/qEFfAWwAAsAOwCwCS+wAEVYsAAvG7EAHz5ZsABFWLAELxuxBB8+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAG0DAxATMDIRMzAzMDIxMhASL32gJs2vfZq3TjPfvxBbD7GgTm+xz91QFfAAEAxQAABWoFsAAQAEayBRESERI5ALAARViwAC8bsQAfPlmwAEVYsAkvG7EJHz5ZsABFWLABLxuxAQ8+WbINAQkREjmwDS+yBQEKK1gh2Bv0WTAxAQMjEwYnJiY3EzMDBhYENxMFav32a5qt5vAZTPZMEGABBs58BbD6UAI+LAQC89wByf42gIIGKgKoAAABACsAAAdjBbAACwBIALAARViwAC8bsQAfPlmwAEVYsAMvG7EDHz5ZsABFWLAHLxuxBx8+WbAARViwCS8bsQkPPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAQMhEzMDIRMzAyETAh/ZAa3Z99oBqtr2/fnF/AWw+xoE5vsaBOb6UAWwAAEAK/6iB2MFsAAPAFQAsAsvsABFWLAALxuxAB8+WbAARViwAy8bsQMfPlmwAEVYsAcvG7EHHz5ZsABFWLANLxuxDQ8+WbIBAQorWCHYG/RZsAXQsAbQsAnQsArQsALQMDEBAyETMwMhEzMDMwMjEyETAh/ZAa3Z99oBqtr226Vy2T36DPwFsPsaBOb7GgTm+xL94AFeBbAAAgCJAAAFnQWwAAwAFQBesgEWFxESObABELAN0ACwAEVYsAAvG7EAHz5ZsABFWLAJLxuxCQ8+WbIDAAkREjmwAy+wABCyCwEKK1gh2Bv0WbAJELIPAQorWCHYG/RZsAMQshUBCitYIdgb9FkwMRMhAxcWFgcGBCMhEyEBAwUyNjc2JierAnVg/eH/DxD+x/b939v+gAIUVgESgK8PDW1tBbD90wEB7MbR/gTt/cv+EgGRd2d7BAADAC4AAAa9BbAACgATABcAcLIGGBkREjmwBhCwD9CwBhCwFdAAsABFWLAJLxuxCR8+WbAARViwFi8bsRYfPlmwAEVYsAcvG7EHDz5ZsABFWLAULxuxFA8+WbIBCQcREjmwAS+wBxCyDQEKK1gh2Bv0WbABELITAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDBTY2NzYmJwEjEzMBwf7j/REQ/sf0/d3994RWARKBrg8OcGsC9fb99gODAQHvxND+BbD9CP4SAgKQd2l5BP1JBbAAAgAjAAAElAWwAAoAEwBQsg0UFRESObANELAH0ACwAEVYsAkvG7EJHz5ZsABFWLAHLxuxBw8+WbIBCQcREjmwAS+wBxCyDQEKK1gh2Bv0WbABELITAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDBTY2NzYmJwG2/uP9ERD+x/T93f33hFYBEoGuDw5wawODAQHvxND+BbD9CP4SAgKQd2l5BAAAAQBP/+kE9wXIACAAhbIOISIREjkAsABFWLAULxuxFB8+WbAARViwHS8bsR0PPlmyAwEKK1gh2Bv0WbIIFB0REjl8sAgvGLIwCAFdsnIIAV2y4ggBXbJCCAFdsmAIAV2y0AgBXbIACAFxsgcBCitYIdgb9FmwFBCyDQEKK1gh2Bv0WbIRFB0REjmyIB0UERI5MDEBFhYXFjY3BTchNzYmJyYGBwc2ABceAhcWAgIEJyYAJwFDB358lM46/gUkAe4IA4N+irAj9SgBS+uO1HkJBke9/uyn3v79CAHam4gDBdbsAcxkn7YEBJqUAeYBFAQDfvGYeP5z/tGdAwQBBeUAAAIAMv/nBvkFxwAYACgAg7INKSoREjmwDRCwJNAAsABFWLAILxuxCB8+WbAARViwEC8bsRAfPlmwAEVYsAYvG7EGDz5ZsABFWLAALxuxAA8+WbIKCAYREjl8sAovGLIfCgFxtGAKcAoCXbIEAQorWCHYG/RZsBAQsh4BCitYIdgb9FmwABCyJQEKK1gh2Bv0WTAxBSYAETcjAyMTMwMzNhI3NhcWABcWAgIHBhM3NiYmJyYGAgcGFhcWEjcEL+P+/AG4afb99nKsJ++ub3zYAQEMBjmLZ7LaCQYyd1t+w3kKCoSEreEjFAUBPAEJJ/2jBbD9ceIBVEQsAwT+3vd8/r/+81qcAxhqbblhAwSW/s7nt9IEBQEO9QAC/7AAAATTBbEADgAXAGGyEhgZERI5sBIQsAvQALAARViwDS8bsQ0fPlmwAEVYsAAvG7EADz5ZsABFWLADLxuxAw8+WbITDQAREjmwEy+yAQEKK1gh2Bv0WbIFEwEREjmwDRCyFAEKK1gh2Bv0WTAxIRMhASEBJiY3PgIzBQMBBhYXFxMnIgYC31/+9/6Q/usBsWdYCguX/p4B6f39yg9rc/FZ14atAiD94AJvQcV3jc1rAfpQA+FxhwQBAgACi///ACL/6APcBFACBgBFAAAAAgBD/+YEYQYTABsAKwBishgsLRESObAYELAd0ACwAEVYsBMvG7ETIT5ZsABFWLAGLxuxBg8+WbIAEwYREjmwAC+yFwATERI5shETFxESObIaAAYREjmyHAEKK1gh2Bv0WbAGELIlAQorWCHYG/RZMDEBFhIHBgAnLgI3NzU3EgA3NzY3Mw4CBAYHNhcmBgYHBhcWFhcWNjc3NiYCnrrPEhb+0eCLx1sQAgoxASPnXpMVwQhSmv7Xv0GegE99TQsHBAdiWHWgFQINZwP+BP7s1/f+zgQEjvmWFQNLAVABjjISHWZkgFM5pJeYxAJNjFtKOmRzAwOwoBWLoAAAAwAiAAAEFgQ6AA4AFwAfAI6yGSAhERI5sBkQsA7QsBkQsBHQALAARViwAS8bsQEbPlmwAEVYsAAvG7EADz5ZshgAARESObAYL7KMGAFdtF8YbxgCcbTvGP8YAnG0vxjPGAJdtBwYLBgCcbJaGAFdsg8HCitYIdgb9FmyCA8YERI5sAAQshABCitYIdgb9FmwARCyHwEKK1gh2Bv0WTAxMxMFFhcWBwYHFhYHBgYHAwMXNjY3NiYnJxcyNzYmJycivAGelGKkCQrQVGECBenMzC/0YW8JCkdS8rbUFglNZMsEOgEEK0mqoFEZelaUpgMBzf7zAQNKQTlDA68Bgjo/AwEAAQAYAAADiQQ6AAUAKwCwAEVYsAQvG7EEGz5ZsABFWLACLxuxAg8+WbAEELIAAQorWCHYG/RZMDEBIQMjEyEDZv45mu28ArUDdvyKBDoAAv+F/r4EZAQ6AA4AFABbshIVFhESObASELAE0ACwDC+wAEVYsAQvG7EEGz5ZsABFWLAKLxuxCg8+WbIAAQorWCHYG/RZsAbQsAfQsAwQsAnQsAcQsA/QsBDQsAQQshEBCitYIdgb9FkwMTc2NjcTIQMzAyMTIQMjEwUlEyEDAjFqgR9OAtuakVrsOP1hOPFbAWgBlXb++TY/v2HvqgGB/Ij9/AFC/r4CAwMEAqf+9f70//8AO//qBAIEUQIGAEkAAAAB/60AAAZyBDoAFQCCALAARViwCS8bsQkbPlmwAEVYsA0vG7ENGz5ZsABFWLARLxuxERs+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAULxuxFA8+WbIQEQIREjmwEC+yjxABXbIAAQorWCHYG/RZsATQsggQABESObAQELAL0LITABAREjkwMQEjAyMTIwEhAQMhEzMTMwMzASEBEyED/4NM7Uxz/sL+zwHI6wETpHRK7UpnATkBMP5T+P7oAbP+TQGz/k0CPwH7/lcBqf5XAan98P3WAAABABb/6QO8BFAAKQCjshkqKxESOQCwAEVYsCYvG7EmGz5ZsABFWLAKLxuxCg8+WbIZJgoREjmwGS+07xn/GQJxtB8ZLxkCcbK/GQFxtF8ZbxkCcbS/Gc8ZAl2yjBkBXbJaGQFdshYHCitYIdgb9FmyAxYZERI5sAoQshEBCitYIdgb9FmyDhYRERI5tAMOEw4CXbAmELIfAQorWCHYG/RZsiIZHxESObQMIhwiAl0wMQEGBgcWFgcOAicmJjczBhYzMjY3NicnNxc2Njc2JiMmBgcHNjYXHgIDtgVeZkhFBAV8132w2wTpAmJQV3kLFaW4H5xVZwkHT0RLcw/tDPm4c7BcAxpKdjMhfU9pl1EDAr2XRVZVSIcFAa8BAklEP0cCTUEBlLUCAkqJAAABABkAAARIBDoACQBFALAARViwAC8bsQAbPlmwAEVYsAcvG7EHGz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyBAcCERI5sgkHAhESOTAxATMDIxMBIxMzAwNU9LztfP3y9LztfAQ6+8YCwv0+BDr9PgD//wAZAAAESAXaAiYB+wAAAQcBagCc//MACQCwAC+wDdwwMQAAAQAiAAAEgQQ6AAwAaACwAEVYsAQvG7EEGz5ZsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmwAEVYsAsvG7ELDz5ZsgYCBBESOXywBi8YtNMG4wYCXbRDBlMGAl2yEwYBcbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQHYfkvtvO1LXgFtATb+HwE0/t0BrP5UBDr+UAGw/e792AAB/7///wRJBDoAEABNsgQREhESOQCwAEVYsAAvG7EAGz5ZsABFWLABLxuxAQ8+WbAARViwCC8bsQgPPlmwABCyAwEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDEBAyMTIQMGBicjNzc2Njc3EwRJu+6a/tpjNcyfUhYkW3MfD2AEOvvGA3b+PObNAckDCJevUgHOAAEAIgAABZoEOgAMAFkAsABFWLABLxuxARs+WbAARViwCy8bsQsbPlmwAEVYsAMvG7EDDz5ZsABFWLAGLxuxBg8+WbAARViwCS8bsQkPPlmyAAsDERI5sgULAxESObIICwMREjkwMQEBIQMjEwEjAwMjEyECrwG9AS687Xr+bKKmgO28ASUBLQMN+8YCuv1GAtr9JgQ6AAEAGQAABEcEOgALAH4AsABFWLAGLxuxBhs+WbAARViwCi8bsQobPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIJCgAREjmwCS+0vwnPCQJdsr8JAXG0Lwk/CQJysl8JAXK07wn/CQJxtB8JLwkCcbKPCQFdtI8JnwkCcrICAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMDi+5M/mpM7rzuTwGXTu4Btf5LBDr+PQHDAP//ADn/6AQnBFICBgBTAAAAAQAZAAAESAQ6AAcAOACwAEVYsAYvG7EGGz5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmwBhCyAgEKK1gh2Bv0WTAxISMTIQMjEyEDjO6a/mma7rwDcwN2/IoEOgD////H/mAEDQRSAgYAVAAAAAEAOP/pA+4EUgAcAEuyAB0eERI5ALAARViwES8bsREbPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyBBEIERI5shUIERESObARELIYAQorWCHYG/RZMDElFjY3Nw4CJy4CNzc+AhcWFhUjNCYnJgYHAgHoVYMS4AuF0HGLxFoPAxGV7JCw0t5bVougBgetAmdTAWuwYgMCjPeYI53/igQE4bRddgQE9N7+8wABAFMAAAQIBDoABwAxALAARViwBi8bsQYbPlmwAEVYsAIvG7ECDz5ZsAYQsgABCitYIdgb9FmwBNCwBdAwMQEhAyMTITchA+b+rJvtmv6vIgOTA3n8hwN5wf///7X+RQQSBDoCBgBdAAAAAwA9/mAFUQYAACEALAA4AHyyEzk6ERI5sBMQsCnQsBMQsDTQALADL7AARViwAC8bsQAbPlmwAEVYsAcvG7EHGz5ZsABFWLAULxuxFBE+WbAARViwGC8bsRgPPlmwAEVYsBEvG7ERDz5ZsAAQsjYBCitYIdgb9FmwJtCwGBCyMQEKK1gh2Bv0WbAr0DAxARYXEzMDNhcWFgcGBwcOAicmJwMjEwYjIiYnJjc3NhI2ATYnJicmBwMWMzIBBhcWFxY3EyYjJgMCGERFWO1aRkiYnwEBBgUXhLxxT0hS7VI+RpKhAwEGBhqBvwK5CQEFkCMxgycm5v0ECQMKiBg3hCQh1zsEUAIdAc/+LSECAvHRQDgko/ByAwEg/lUBpxnZuDw3K7QBBH79wls52QcCDP03CwFHVzC0BwEIAswLBP6ZAP///7kAAAQTBDoCBgBcAAAAAQAZ/r8ESAQ6AAsAOwCwCC+wAEVYsAAvG7EAGz5ZsABFWLAELxuxBBs+WbAARViwCi8bsQoPPlmyAgEKK1gh2Bv0WbAG0DAxEzMDIRMzAzMDIxMh1e6bAZia7puQbdk4/OoEOvyIA3j8iP39AUEAAAEAcAAABCAEOwASAEiyDhMUERI5ALAARViwCC8bsQgbPlmwAEVYsBEvG7ERGz5ZsABFWLAALxuxAA8+WbIOEQAREjl8sA4vGLIEAQorWCHYG/RZMDEhIxMGIyYmNxMzAwYXFhcWNxMzA2TtRlthws8TNe42BgUMklNyYe0BaxYC3LwBTP6zMCZ5BgMXAg0AAAEAGQAABioEOgALAEgAsABFWLAALxuxABs+WbAARViwAy8bsQMbPlmwAEVYsAcvG7EHGz5ZsABFWLAJLxuxCQ8+WbIBAQorWCHYG/RZsAXQsAbQMDEBAyETMwMhEzMDIRMBw5sBRpvtmgFHmu28+qu8BDr8iAN4/IgDePvGBDoAAQAS/r8GPAQ6AA8ASwCwDC+wAEVYsAAvG7EAGz5ZsABFWLADLxuxAxs+WbAARViwBy8bsQcbPlmwAEVYsA0vG7ENDz5ZsgEBCitYIdgb9FmwBdCwCdAwMQEDIRMzAyETMwMzAyMTIRMBu5sBR5rtmgFHm+yatG3ZOfrjuwQ6/IgDePyIA3j8iP39AUEEOgAAAgBPAAAEpgQ6AAwAFQBesgwWFxESObAMELAN0ACwAEVYsAsvG7ELGz5ZsABFWLAHLxuxBw8+WbIBCwcREjmwAS+wCxCyCQEKK1gh2Bv0WbAHELIPAQorWCHYG/RZsAEQshUBCitYIdgb9FkwMQEXFhYHBgQjIRMhNyEDAxc2Njc2JicCUdawzwkL/vzL/iGa/tEiAhxdPdhcfA0LTEwC4gEEwqGp0QN2xP3l/qMBAl5TTVkEAAADACIAAAXxBDoACgATABcAbbICGBkREjmwAhCwEdCwAhCwFdAAsABFWLAJLxuxCRs+WbAARViwFi8bsRYbPlmwAEVYsAcvG7EHDz5ZsABFWLAULxuxFA8+WbIBBwkREjmwAS+yCwEKK1gh2Bv0WbAHELINAQorWCHYG/RZMDEBFxYWBwYEIyETMwMDFzY2NzYmJwEjEzMBj9awzwkL/vzL/iG87V092Fx8DQtNSwLU7bztAuIBBMKhqdEEOv3l/qMBAl5TTVkE/eIEOgACACIAAAPkBDoACgATAE2yDRQVERI5sA0QsAfQALAARViwCS8bsQkbPlmwAEVYsAcvG7EHDz5ZsgEHCRESObABL7ILAQorWCHYG/RZsAcQsg0BCitYIdgb9FkwMQEXFhYHBgQjIRMzAwMXNjY3NiYnAY/WsM8JC/78y/4hvO1dPdhcfA0LTUsC4gEEwqGp0QQ6/eX+owECXlNNWQQAAAEAI//oA9QEUAAfAHSyACAhERI5ALAARViwCC8bsQgbPlmwAEVYsBEvG7ERDz5ZsAgQsgABCitYIdgb9FmyHAgRERI5fLAcLxiyUxwBXbJAHAFdsgMcABESObIbBworWCHYG/RZsBEQshgBCitYIdgb9FmyFRsYERI5slMVAV0wMQEmBgcHPgIXHgIHBwYCBicmJjcXBhYXFhMFNyE2JgIsVH0Q3wmDznKIvVcPAxKW7o6r0AbfBVdRx1z+rh4BQwhdA4wCaVEBbLBhAQSM+JYbn/7+jQQE4LMBW3YEBgEqAah+kwAAAgAk/+kGEARTABcAJwCLsiYoKRESObAmELAP0ACwAEVYsBYvG7EWGz5ZsABFWLAELxuxBBs+WbAARViwFC8bsRQPPlmwAEVYsA4vG7EODz5ZsgAWFBESObAAL7QfAC8AAnGyvwABcbKPAAFdsl8AAXKyEwEKK1gh2Bv0WbAOELIdAQorWCHYG/RZsAQQsiQBCitYIdgb9FkwMQEzNiQXHgIHBwYCBwYnLgI3BwMjEzMBBhcWFhcWNjc3NCYnJgYHAYG7RwEhwIvEXRACFrSNZHp+xWMIy0/tvO0BTQYDA2Jad6oZB2FgeacZAofb8QQEjP2YFq7+7z8tAwN914IB/jwEOv3RNzxpgAMFwaxhhI8EA8GvAAAC/7YAAAQWBDsADQAWAGGyFBcYERI5sBQQsATQALAARViwAC8bsQAbPlmwAEVYsAEvG7EBDz5ZsABFWLAFLxuxBQ8+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAxIREjmwABCyEwEKK1gh2Bv0WTAxAQMjEyMBIQEmJjc2JDMDBhYXFxMnBgYEFrzsRdP+2v78AU5QTQUKAQjF6wtORPM2y1x/BDr7xgGN/nMBui2WW6HC/pdATgIBATgBAl///wA7/+oEAgYAAiYASQAAAQcARACcAAAAEwCwAEVYsAkvG7EJGz5ZsCHcMDEA//8AO//qBAIFzQImAEkAAAEGAGtpAAAMALAJL7Ax3LAg0DAxAAEADf5HA/kGAAAjAIWyAyQlERI5ALAhL7AARViwBC8bsQQbPlmwAEVYsAsvG7ELET5ZsABFWLAaLxuxGg8+WbafIa8hvyEDXbIvIQFdsg8hAV2yIxohERI5sCMvsB/QshwHCitYIdgb9FmwAdCyAhoEERI5sAsQshABCitYIdgb9FmwBBCyFwEKK1gh2Bv0WTAxASEHNhcWFgcDBgYjJic3FjMyNxM2JyYnJgcDIxMjNzM3MwchAsz+/jOHq5mXE3oYyaVDQh81K38gfAUEDYOFZoftz5kemR3uHgEEBK3qjgQC08D9CbXFAhDBEMIC7yslegMChPz6BK2rqKj//wAYAAADmAXzAiYB9gAAAQcAdwDG//MAEwCwAEVYsAQvG7EEGz5ZsAjcMDEAAAEAO//oA/YEVAAfAGKyGCAhERI5ALAARViwEC8bsRAbPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyGhAIERI5fLAaLxiyHAcKK1gh2Bv0WbIDABwREjmwEBCyFwEKK1gh2Bv0WbIUGhcREjkwMSUWNjc3DgInLgI3NxIAFxYWByM0JicmBgclByEGFgHlVoMU3wuE1XGMv1YQAh0BMN6wzgLdXFNoky0BWB7+tw1frQJnUwFrr2QDBIr3mBQBAgE2BgThtGFyBAOMmgGogJMA//8AHP/pA8QEUAIGAFcAAP//AB8AAAIJBdgCBgBNAAD//wAiAAAC4QXGAiYA9AAAAQcAa/9e//kADACwAi+wFdywBNAwMf///wz+RgH+BdgCBgBOAAAAAv+9AAAGRgQ6ABcAHwB5sgogIRESObAKELAZ0ACwAEVYsAAvG7EAGz5ZsABFWLAILxuxCA8+WbAARViwDy8bsQ8PPlmyAgAIERI5sAIvsAAQsgoBCitYIdgb9FmwDxCyEQEKK1gh2Bv0WbAIELIaAQorWCHYG/RZsAIQsh8BCitYIdgb9FkwMQEDFxYWBwYEIyETIQMCBgcjNzc2Njc3EwEDFzY2NzYnBDBB1rLPCQv/AMz+IZr+8Us3yaZkFSVcbx4SYAJ7N9hZfQ0SowQ6/ocBBbeZpcYDdv6r/tXxBckDCJadZQHO/cX+wQECXE+ICgACABkAAAZcBDoAEgAbAIKyARwdERI5sAEQsBPQALAARViwAi8bsQIbPlmwAEVYsBEvG7ERGz5ZsABFWLALLxuxCw8+WbAARViwDy8bsQ8PPlmyARELERI5sAEvsgQRCxESObAEL7ABELINAQorWCHYG/RZsAQQshMBCitYIdgb9FmwCxCyFAEKK1gh2Bv0WTAxASETMwMXFhYHBgQjIRMhAyMTMwEDFzY2NzYmJwF7AZdH7kLWss8JCf7/zf4hU/5qU+687gIhONhdewsKSlECnwGb/ocBBbeZpMcB3f4jBDr9xf7BAQJfTEBNBQAAAQANAAAD+QYAABoAc7IDGxwREjkAsBgvsABFWLAELxuxBBs+WbAARViwES8bsREPPlmwAEVYsAkvG7EJDz5Zsr8YAV2yLxgBXbIPGAFdshoRGBESObAaL7AW0LITBworWCHYG/RZsAHQsgIEERESObAEELIOAQorWCHYG/RZMDEBIQc2FxYWBwMjEzYnJicmBwMjEyM3MzczByEC4f7kLoesmpUTdO12BQMNg4Roh+3Qhx6HHO4fARkEtfKOBALWvf1IArsrJXoDAoT8+gS1qqGhAP//ACIAAASBBfICJgH9AAABBwB3AUT/8gATALAARViwBC8bsQQbPlmwD9wwMQD//wAZAAAESAXzAiYB+wAAAQcARADH//MAEwCwAEVYsAgvG7EIGz5ZsAvcMDEA////tf5FBBIF5wImAF0AAAEGAWpUAAAJALABL7AT3DAxAAABABn+mgRIBDoACwBFALAIL7AARViwAC8bsQAbPlmwAEVYsAMvG7EDGz5ZsABFWLAFLxuxBQ8+WbAARViwCS8bsQkPPlmyAQEKK1gh2Bv0WTAxAQMhEzMDIQMjEyETAcObAZia7rz+vz7uP/67vAQ6/IgDePvG/poBZgQ6AAABAGD/5gcuBbAAIwBgsgYkJRESOQCwAEVYsAAvG7EAHz5ZsABFWLANLxuxDR8+WbAARViwGC8bsRgfPlmwAEVYsAQvG7EEDz5ZsABFWLAJLxuxCQ8+WbIHAAQREjmyFAEKK1gh2Bv0WbAf0DAxAQMGBCcmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhcWFhcWNjcTBy6vHf7vzmygJY7au88VrvevBQMFS0NkiRSv+68FBQdQRV+BFa8FsPv90PcEAldMqQQE+sQEBPv7KitIVwMEg3gEBfv7LStLUQMDf3sEBQAAAQBE/+YGHgQ6ACIAXLIXIyQREjkAsABFWLAALxuxABs+WbAARViwDS8bsQ0bPlmwAEVYsBcvG7EXGz5ZsABFWLAJLxuxCQ8+WbAE0LAEL7IHFwkREjmwCRCyEwEKK1gh2Bv0WbAe0DAxAQMGBicmJicGJyYmNxMzAwcUFhcWNjcTMwMGFxYWFxY2NxMGHnMc8rdbjiKCuqmyE3PtcgQ4OFN0E3PucgQCAkI7T2gQcwQ6/VLE4gQCSkKRBATmtgKv/VBHQ1EDBXNwArD9UCYmQ04BA3ZrArAAAgAjAAAElAWwABIAGwB0shUcHRESObAVELAJ0ACwAEVYsA8vG7EPHz5ZsABFWLAJLxuxCQ8+WbISCQ8REjmwEi+yAAcKK1gh2Bv0WbIDDwkREjmwAy+wABCwC9CwDNCwEhCwDdCwCRCyFQEKK1gh2Bv0WbADELIbAQorWCHYG/RZMDEBIwcXFhYHBgQjIRMjNzM3MwczAQMFNjY3NiYnArHZIv7j/REQ/sf0/d2+ux67Ifci2v7EVgESga4PDnBrBEfEAQHvxND+BEeqv7/9x/4SAgKQd2l5BAACACH//APpBhgAEgAbAHGyFRwdERI5sBUQsAPQALAARViwDy8bsQ8hPlmwAEVYsAkvG7EJDz5ZshIPCRESObASL7IABworWCHYG/RZsgIPCRESObACL7AAELAL0LASELAN0LACELITAQorWCHYG/RZsAkQshQBCitYIdgb9FkwMQEhAxcWFgcGBCchEyM3MxMzAyEBAxc2Njc2JicC4/7nNse51QwN/vTC/h+8qR6oNu02ARr+ckPZYHwLCkZPBDr+yQEBzKm22gQEOqsBM/7N/Vv+ggICcFZMZgUAAQAr/+kG3wXKACYAibIcJygREjkAsABFWLAlLxuxJR8+WbAARViwBC8bsQQfPlmwAEVYsCMvG7EjDz5ZsABFWLAbLxuxGw8+WbIAJSMREjmwAC+yBwQbERI5sAQQsgsBCitYIdgb9FmwABCwDtCwABCyIgEKK1gh2Bv0WbAR0LAbELIVAQorWCHYG/RZshgbBBESOTAxARcSABcWEhcjJiYnJgYHJQchBwYWFwQTNwYAJy4CJyY3BwMjEzMBtKZQAV362PsL9QV5d5XSPAHiIv4rCg19fwEXT/Yn/q7widF4BgQOtXH2/PcDTwEBMgFKBQT++uyciwMFz+EBw2SqwgQLAS0B5P7yBAN+6pJRUgH9dAWwAAABABn/6AWkBFMAJgCVsg0nKBESOQCwAEVYsCYvG7EmGz5ZsABFWLAELxuxBBs+WbAARViwIy8bsSMPPlmwAEVYsB4vG7EeDz5Zsg4eBBESOXywDi8YslIOAV2yQA4BXbAB0LAEELILAQorWCHYG/RZsggOCxESObAOELIPBworWCHYG/RZsB4QshYBCitYIdgb9FmyGRYPERI5sA8QsCHQMDEBMzYkFxYWByM0JicmAyUHIQYXFhcWFxY2NzcOAicmAjcHAyMTMwFzjkUBHMOv0ALdWVbRVgF5Hv6WBQULSiU6WIET4AuI03DF4RKhTu687gJx7fUFBOC1X3QEBv7eAasyMmwwGAECaVEBbLBiAwQBEccB/joEOgAC/64AAASEBbAACwAOAFYAsABFWLAILxuxCB8+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsABFWLAKLxuxCg8+WbINCAIREjmwDS+yAAEKK1gh2Bv0WbAE0LIOCAIREjkwMQEjAyMTIwMhATMTIwEhAwNOfUrcSmnV/vcC8+/09v5cAUhLAar+VgGq/lYFsPpQAmgB9QAAAv+cAAADuAQ6AAsAEABWALAARViwCC8bsQgbPlmwAEVYsAIvG7ECDz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyDQIIERI5sA0vsgEBCitYIdgb9FmwBNCyDwgCERI5MDEBIwMjEyMDIwEzEyMBMwMnBwKfYzC+MVKW+wJY4ePi/rPwNgUuARf+6QEX/ukEOvvGAcQBE1RtAAACAD4AAAaNBbAAEwAWAHwAsABFWLACLxuxAh8+WbAARViwEi8bsRIfPlmwAEVYsAQvG7EEDz5ZsABFWLAILxuxCA8+WbAARViwDC8bsQwPPlmwAEVYsBAvG7EQDz5ZshUCBBESObAVL7AA0LAVELIGAQorWCHYG/RZsArQsAYQsA7QshYCBBESOTAxASEBMxMjAyMDIxMjAyETIQMjEzMBIQMBnwFYAbLw9PZAfUrdSmjV/vbe/utL9v32AcIBSEwCZwNJ+lABqv5WAar+VgGr/lUFsPy4AfYAAAIAMAAABX0EOgATABgAfwCwAEVYsAIvG7ECGz5ZsABFWLASLxuxEhs+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbAARViwEC8bsRAPPlmyABASERI5sAAvsAHQsg4BCitYIdgb9FmwC9CwB9CwARCwFNCwFdCyFxIEERI5MDEBMwEzEyMDIwMjEyMDIxMjAyMTMwEzAycHAWvwAV7h4+c2XTK+MVKW+5uuMe277gF18DYFLgHEAnb7xgEX/ukBF/7pARf+6QQ6/YoBE1RtAAIAFAAABmQFsAAbAB4Ad7IMHyAREjmwDBCwHNAAsABFWLAaLxuxGh8+WbAARViwBC8bsQQPPlmwAEVYsAwvG7EMDz5ZsABFWLATLxuxEw8+WbIYGgQREjmwGC+wANCwGBCyDwEKK1gh2Bv0WbAJ0LIcGgQREjmwGhCyHQEKK1gh2Bv0WTAxARYWBwMjEzYmJycHAyMTJyYGBwMjEzYkJRcDIQEBIQR52dQXOfY5EFZ8aAxs9mlshZ8WOvY5IAEbAQER9gTA/SQBLP4+AyQE79H+oAFheX0FAw/9sAJcAgFzhv6aAWDk4wIBAoj9jAGnAAIAFgAABSoEOgAbAB4Ac7IcHyAREjmwHBCwFNAAsABFWLAFLxuxBRs+WbAARViwAC8bsQAPPlmwAEVYsAsvG7ELDz5ZsABFWLAULxuxFA8+WbAE0LAEL7AH0LAEELISAQorWCHYG/RZsBfQshwFABESObAFELIdAQorWCHYG/RZMDEzNzY2NwMhARYWBwcjNzYnJicnBwMjEyciBgcHARMhFhod59CxA9f+lKSfFBnuGgYBBpokBk3sTiZyhBUcAd3C/uCvzNcOAdr+IBDjvqmqNC2NDQII/mEBpgFzfrYCawEgAAIANQAACJkFsAAhACQAl7IdJSYREjmwHRCwJNAAsABFWLAHLxuxBx8+WbAARViwCy8bsQsfPlmwAEVYsAAvG7EADz5ZsABFWLAFLxuxBQ8+WbAARViwES8bsREPPlmwAEVYsBovG7EaDz5ZsgkHABESObAJL7IdAQorWCHYG/RZsAPQsAkQsA3QsB0QsBfQsiIHABESObALELIjAQorWCHYG/RZMDEhEzY3BQMjEzMDIQMhARYWBwMjEzYnJicnBwMjEycmBgcDAQEhAkc7F1b+p2v2/fZwAx3+BML+E9nUFzn2OgcGErJnC2z2aW6EnxY7AoABK/49AV+fawP9mgWw/XsChf10BO/R/qABYT0uigYDDf2uAlwCAXOG/poDOgGpAAACACIAAActBDoAIQAkAJmyGyUmERI5sBsQsCTQALAARViwBy8bsQcbPlmwAEVYsAsvG7ELGz5ZsABFWLAALxuxAA8+WbAARViwBS8bsQUPPlmwAEVYsBEvG7ERDz5ZsABFWLAaLxuxGg8+WbAFELAJ0LAJL7AK0LIcAQorWCHYG/RZsATQsAoQsA3QsBwQsBfQsiILABESObALELIjAQorWCHYG/RZMDEhNzY3BQMjEzMDIQMhARYWBwcjNzYnJicnBwMjEyMGBgcHARMhAhgcGk3+vkrtvO1SApa5A9f+laGgFBntGgcCB5ojBk3sTitzgRQaAd3C/uCpnmQD/lgEOv4nAdn+IBDiv6mqNSyRCQII/mEBpgF2haoCawEgAAAC/6r+QgQxB4wAKgAzAIuyCTQ1ERI5sAkQsDPQALAbL7AwL7AARViwCS8bsQkfPlmwAEVYsBUvG7EVDz5ZsgAJFRESObAAL7AJELIGAQorWCHYG/RZsAAQsigBCitYIdgb9FmyDygAERI5sBUQsiIBCitYIdgb9FmyDzABXbAwELAy0LAyL7IPMgFdsiswMhESObAt0LAtLzAxATI2NzYmJyU3Fx4CBwYFFhYHBgQnJwYHBhcHJiY3NjYzFzI2NzYmJyc3ATc3FQEjAzUXAaR9pA4LZWv+3iP4h9JqCBH+9mZoBw/+1ds1jBEQh1t0hQYFxqo0cqkPDniAmSMBlKrQ/s2T6cQDTXNqVmMFAccBAVypdOFtLKtwye8CAQVpaD6VKrlxhJcBgWxreQUBxwOgmQQQ/uwBFRAEAAL/tf5KA8UGIAAlAC4Av7IrLzAREjmwKxCwBNAAsCsvsABFWLAHLxuxBxs+WbAARViwFy8bsRcRPlmwAEVYsBEvG7ERDz5ZsgARBxESObAAL7S/AM8AAl20XwBvAAJxtC8APwACcrTvAP8AAnG0HwAvAAJxso8AAV2yvwABcrAHELIEAQorWCHYG/RZsAAQsiMHCitYIdgb9FmyDCMAERI5sBEQsh0BCitYIdgb9FmwKxCwLdCwLS+0Dy0fLQJdsiYrLRESObAo0LAoLzAxATY3NichNxcWFgcGBxYHBgQjIwYHBhcHJiY3NjYzFzI2NzYnIzcBNzcXASMDNRcBhOQXEsL+3iHvzukHCtGsBAX+89YlkxEQf1loggQFv6EwaI0NFOahHgFPqtAB/syT6cMCbgaRdQe5AQGajZ1cRpqerwVqYUKPLrFtf48BUEaGB6kDE5kEEf7tARQRBAD//wB1AAAF1wWwAgYBmAAA//8AP/4iBYoEPAIGAbgAAAADAGL/5wUaBcgAEgAbACQAcLIUJSYREjmwFBCwCdCwFBCwHdAAsABFWLAKLxuxCh8+WbAARViwAC8bsQAPPlmwChCyEwEKK1gh2Bv0WbIWCgAREjl8sBYvGLJzFgFdsmAWAV2wABCyHAEKK1gh2Bv0WbAWELIgBworWCHYG/RZMDEFLgInJhI3NiQXFgAXFgICBwYDJgYHJTY3NiYBFjY3BQYVFBYCUI/WeggHOEVgATO92AEBDAY5i2eyGpnaPgKoBwEDhP68mtU+/VgGhhQDg/idcwFDh7vJBAT+3vd8/r/+81qcBQwF3vIBMDWnuvvMBdvvATAzp7YAAwA2/+cEJgRSABEAFwAdAGqyGB4fERI5sBgQsAzQsBgQsBLQALAARViwBC8bsQQbPlmwAEVYsA0vG7ENDz5ZshIBCitYIdgb9FmyGgQNERI5fLAaLxiyUhoBXbJAGgFdshUHCitYIdgb9FmwBBCyGAEKK1gh2Bv0WTAxEzYSNhceAgcHBgIGJyYCNzcBFhMFBhYTJgMlNiZGEpvzk4vHWxACFJzzksjhCgMBp9Jh/g4IZeXNZAHxCGgCIJ4BBY8EBI78lhaf/v6MBAUBGdoo/qIHASQBg5YC3Af+4AF9mAABAKgAAAVeBcYADwBGsgIQERESOQCwAEVYsAYvG7EGHz5ZsABFWLAPLxuxDx8+WbAARViwDC8bsQwPPlmyAQwPERI5sAYQsggBCitYIdgb9FkwMQEXNwE2NhcXByciBwEjAzMCKgQyAVdLtHYyGRFbPv3i7uf+AYBjdgLtspQCAdcBgfuUBbAAAQB3AAAERARSABAARrINERIREjkAsABFWLAFLxuxBRs+WbAARViwEC8bsRAbPlmwAEVYsA0vG7ENDz5ZsgENEBESObAFELIKAQorWCHYG/RZMDEBFzcTEjMyFwcmByIHASMDMwGpAiS/d884OCcYEks3/nvOp+cBbmBgAcIBIhjBCgJv/O4EOwD//wCoAAAFXgb8AiYCNwAAAQcBdQRXAQ4AFgCwAEVYsA8vG7EPHz5ZsBHcsBXQMDH//wB3AAAERAXQAiYCOAAAAQcBdQPC/+IAFgCwAEVYsA8vG7EPGz5ZsBLcsBbQMDH//wBr/kUJeAXIACYAMwAAAAcAXQVmAAD//wA5/kUIhwRSACYAUwAAAAcAXQR1AAAAAgBm/3UFFAYvABQAJgBVshknKBESObAZELAA0ACwAEVYsA0vG7ENHz5ZsABFWLADLxuxAw8+WbAA0LANELAK0LANELIXAQorWCHYG/RZsBrQsAMQsiABCitYIdgb9FmwI9AwMQUHJzcmAic3EgAlNxcHFhIXFgcCABMmJwcnNwYCAxUWFzcXByQTNgKkHMEcscgEARIBTQEQGcEZr8cFAhw0/saVBZwVwhalsg8MmBXCFgEPPhgMfwGAJAEe4kwBbgHDJnIBdCT+4eZ4lv7n/qoDofBAYgFkNf6y/sVC4z1iAWJXAZS2AAIAOP+HBDUEtQATACMAWLIAJCUREjmwFNAAsABFWLAALxuxABs+WbAARViwCi8bsQoPPlmwABCwA9CwChCwDdCwChCyFAEKK1gh2Bv0WbAAELIcAQorWCHYG/RZsBnQsBQQsCHQMDEBNxcHFhIHBwYABwcnNyYCNzc2EhM2Njc2JwcnNwYGBwYXNxcCNRm0GaamFQIc/vrIGLQYpaMVByP/1G99BgRuFbQWbXkHB2wXtARGbwFvJ/7bzxbg/tscbAFuJwEjyzHaARL8ki3ss7g8YQFjMOextj9pAQADAGL/5QbcB0QAMQBGAE8Ar7I9UFEREjmwPRCwCdCwPRCwR9AAsABFWLAULxuxFB8+WbAARViwBy8bsQcPPlmwFBCwANCwAC+yCgcUERI5sAcQsAzQsBQQshUBCitYIdgb9FmwBxCyKQEKK1gh2Bv0WbAe0LIiFAcREjmwFRCwMdCwFBCwPtCwPi+wM9CwMy+yMggKK1gh2Bv0WbAzELA50LA5L7JCCAorWCHYG/RZsD4QsEvQsEsvsE/QsE8vMDEBFhIHAwYAJyYmJwYnLgI3EzYkNwcGBgcDBhcWFhcWNjcTMwMGFxYWFxY2NxM2NSYnEwcjLgMjIgYHByc3NjYXHgMBNjY3NxcHBgcFWL3HF1Ue/u/JZ6MpktB8s1IPVR8BEdUXYYAVVQUBAklEZokUP+8/BQUIVUdefBZWBgSKsQkeO3FxbTczQAkCgwIIgmwwWrVi/e0rJwgSpQ0RngWxCf77zf3t3P7/BAJTSaMGAnnagwIT3voEzAKMgv3sKi5TXwQFhnsBf/58LyxJUQMDiogCFS0upgoB5ogCJy8kODETASZscQIBF0kZ/ooxPiVeAWZvWwADAEv/5QXDBegAMABFAE0Ar7I6Tk8REjmwOhCwCtCwOhCwRtAAsABFWLAVLxuxFRs+WbAARViwDS8bsQ0PPlmwFRCwANCwAC+wDRCwCNCyCw0VERI5sBUQshYBCitYIdgb9FmwDRCyHQEKK1gh2Bv0WbIhFQ0REjmwKNCwFhCwMNCwFRCwPdCwPS+wMtCwMi+yMQgKK1gh2Bv0WbAyELA40LA4L7JBCAorWCHYG/RZsD0QsEnQsEkvsE3QsE0vMDEBHgIHBwYGJyYmJwYnJiY3EzY3NjcHBg8CBhYXFjY3NzMHBhcWFhcWNjcTNzYmJwEHIy4DIyIGBwcnNzY2Fx4DATY3NxcHBgcEa3GeSQ0hHeyyWY0jgLCorhQkIYx3rxWpJyQEBDc2UG8RH+YdBAMDRTtHYhEmBAI7OgEDCSE6bXhrNzJACQKEAgiCbDBav1n98EsPEaYNEKAESAZvxHzu0+0FAktElAQE8b4BA9hvXgPDB+X9SEhfAgV3bMfHJiZCUAEDenUBDD9FVQYB6ogCJTIjODETASZscQIBF00V/ohVP14BZW9cAAACAGD/5ActBxEAIwArAIWyBiwtERI5sAYQsCrQALAARViwAC8bsQAfPlmwAEVYsA0vG7ENHz5ZsABFWLAYLxuxGB8+WbAARViwCS8bsQkPPlmwBNCwBC+yBwAJERI5sAkQshQBCitYIdgb9FmwH9CwABCwKtCwKi+wKNCwKC+yJggKK1gh2Bv0WbAoELAr0LArLzAxAQMGBCcmJicGJyYmNxMzAwYXFhYXFjY3EzMDBhcWFhcWNjcTJTchByEHIzcHLa8d/u7NaaImj9m/yhSu968FAwVLQ2SJFK/7rwUFB1BFXYMVr/x9FgM9Ff6xF7EXBbD7/dD5BAJXTqoEBvvCBAT7+yorSlUDBIN4BAX7+y0rS1EDA358BAXnenp/fwACAET/5gYeBbEAIgAqAImyFyssERI5sBcQsCnQALAARViwAC8bsQAbPlmwAEVYsA0vG7ENGz5ZsABFWLAXLxuxFxs+WbAARViwBC8bsQQPPlmwAEVYsAkvG7EJDz5ZsgcXBBESObITAQorWCHYG/RZsB7QsBcQsCnQsCkvsCrQsCovsiQICitYIdgb9FmwKhCwJ9CwJy8wMQEDBgYnJiYnBicmJjcTMwMHFBYXFjY3EzMDBhcWFhcWNjcTJTchByEHIzcGHnMc87ZbjiKDuamyE3PtcgQ4OFNzE3TucgQCAkI7T2gQc/ziFgMhE/6+F7EWBDr9UsbgBAJKQpIEBOm0Aq/9UEdDUQMDcGsCtv1QJiZDTgEDdmsCsPx7e39/AAABAFb+jATqBcoAGQBTsgAaGxESOQCwAEVYsAovG7EKHz5ZsABFWLAALxuxABc+WbAARViwAi8bsQIPPlmwChCwDtCwChCyEAEKK1gh2Bv0WbACELIYAQorWCHYG/RZMDEBIxMmJgI3ExIAFxYSBycSJyYGBwMHBhYXFwJ69UV9rUoTKi0BXfLk9wz2EviPyyAtAwN0aqf+jAFoGqkBApIBDAEfAVQFBP735gEBIAcD4sj+4UCRqQQBAAABAEX+iQP8BFMAGQBTsgAaGxESOQCwAEVYsAovG7EKGz5ZsABFWLAALxuxABc+WbAARViwAi8bsQIPPlmwChCwDtCwChCyEQEKK1gh2Bv0WbACELIYAQorWCHYG/RZMDEBIxMmAjc3Ejc2FxYWByc2JicmBgcHBhYXFwIk7UWbnBYBHZmZ1qzPBt8FVlJxoxYKB1ZYnf6JAWwnASDMCwEGnpwFBOOyAVt3BAXCo2p8kwQCAAABADgAAAS6BT4AEwATALAOL7AARViwBC8bsQQPPlkwMQEXBycDIwEnNxcBJzcXEzcBBQcnAjD7VP3puQEm+1T+AQv9Vv3tt/7VAQBZ+QG4rHWq/r8Bl6t1qwFzq3erAUcB/mKrdKkAAAH85gSi/+IF/QAHABEAsAAvsgMGCitYIdgb9FkwMQEHJzchNxcH/aoWrisCEROtJwUgfgHubAHcAAAB/Q4FFv/zBhQAEgArALAEL7AI0LAIL7IAAgorWCHYG/RZsAQQsA3QsA0vsg4CCitYIdgb9FkwMQMWFgcHJzc2JyYGBAcHNzI+AuRkcwQDggIGVipT/vNBQwtKV9FhBhMCbGcoARRdBAIQYgUBhxNNFwAB/isFFf8CBmAABQAMALABL7AF0LAFLzAxATczBxcH/isWuR4mUAXneaRsOwAAAf48BRf/WwZgAAUADACwAy+wANCwAC8wMQEnNzczB/6KTk8XuRkFF05yiY8AAAj6Qf7CAZ4FsQALABcAIwAvADsARwBTAF8AegCwPy+wSy+wVy+wMy+wAEVYsAMvG7EDHz5ZsgkJCitYIdgb9FmwPxCwD9CwPxCyRQkKK1gh2Bv0WbAV0LBLELAb0LBLELJRCQorWCHYG/RZsCHQsFcQsCfQsFcQsl0JCitYIdgb9FmwLdCwMxCyOQkKK1gh2Bv0WTAxATY2FzIWFSc2IyYHATY2MxYWFyc2IyIHAzY2FxYWFyc2IyYHATY2FxYWFyc2IyYHATY2FxYWFyc2IyYHATY2FzIWFSc2IyIHATY2FxYWFyc2IyYHAzY2FxYWFyc2IyYH/Z0Ib1tXbWsFUFUbAZ0Ib1pZawJsBVBSHRIIbltYagJrBVBTHv56CHFXWGoCawVQUh79MAhwW1hqAmsFUFMe/kIIcFtXbWsFT1Qd/o8IbltYagJrBVBTHicIb1pYawJsBVBSHgTzWGYBaVYBZgJm/upXZgFmWAFmZP4HWGYBAWZXAWYCZv33WWYCAWZXAWYCZv7jWWUBAWdXAWYCZgUZWWUBaVYBZmT+B1hmAQFmVwFmAmb991hmAQFmVwFmAmYAAAj6b/5jAXMFxgAEAAkADgATABgAHQAiACcALwCwIS+wFi+wEi+wCy+wGy+wJi+wAEVYsAcvG7EHHz5ZsABFWLACLxuxAhE+WTAxBRcDIxMTJxMzAwE3BQclBQclNwUBNyUXBQEHBSclEycDNxMBFxMHA/3kDqtmfaQOqmZ9AakKATkQ/sD7jwr+xxEBPwPOAwFKP/7Q/GYD/rZAATJtEV9BlgKxEV9DlDoT/rABYAShEQFR/qH+EQqAWkQ8CoBaRAGuEphOvvyNE5hPvwLkAQFTO/7Q/OYB/q49ATAA//8AJ/5+BXwHJAImAdsAAAAnAWoBVwE9AQcAEARU/8YAEwCwAEVYsAgvG7EIHz5ZsA3cMDEA//8AGf5+BHYF2gImAfsAAAAnAWoAnP/zAQcAEANi/8YAEwCwAEVYsAgvG7EIGz5ZsA3cMDEAAAIAIwAABJQFsAASABsAdLIVHB0REjmwFRCwCdAAsABFWLAPLxuxDx8+WbAARViwCS8bsQkPPlmyEgkPERI5sBIvsgAHCitYIdgb9FmyAw8JERI5sAMvsAAQsAvQsAzQsBIQsA3QsAkQshUBCitYIdgb9FmwAxCyGwEKK1gh2Bv0WTAxASMHFxYWBwYEIyETIzczNzMHMwEDBTY2NzYmJwKx2SL+4/0REP7H9P3dvrseuyH3Itr+xFYBEoGuDw5wawRHxAEB78TQ/gRHqr+//cf+EgICkHdpeQQAAgAh//wD6QZiABIAGwB0shUcHRESObAVELAD0ACwAEVYsA0vG7ENHz5ZsABFWLARLxuxER8+WbAARViwCS8bsQkPPlmwERCyAAcKK1gh2Bv0WbICDQkREjmwAi+wABCwC9CwDNCwAhCyEwEKK1gh2Bv0WbAJELIUAQorWCHYG/RZMDEBIQMXFhYHBgQnIRMjNzM3MwchAQMXNjY3NiYnAwb+51nHudUMDf70wv4f36keqCDtHwEZ/k9D2WB8CwpGTwUF/f4BAcypttoEBQWrsrL8kP6CAgJwVkxmBQAAAgAnAAAFBQWwAA4AGwBNsgQcHRESObAEELAX0ACwAEVYsAMvG7EDHz5ZsABFWLABLxuxAQ8+WbIWAwEREjmwFi+yAAEKK1gh2Bv0WbADELIUAQorWCHYG/RZMDEBAyMTBTIEBwYHFwcnBiMBNjc2JiclAyE2Nyc3AXxe9/0B9+YBBBMTlF9xZ4KrARssCxJxbf7MWAEZR05YcgId/eMFsAH7zMOBjVqWNgFDRENuigQB/gQCF4hZAAL/x/5gBA8EUgAVACYAbrIFJygREjmwBRCwH9AAsABFWLAOLxuxDhs+WbAARViwCy8bsQsbPlmwAEVYsAgvG7EIET5ZsABFWLAFLxuxBQ8+WbIHDgUREjmyDA4FERI5sA4QshkBCitYIdgb9FmwBRCyHgEKK1gh2Bv0WTAxJRcHJwYnJicDIwE3BzYXFhYXFgcHBgMmJicmBwMWFzI3JzcXNjc2A1RRcU5jZqViYe4BBNkSfKycsQYCBwUjwQJcVYViVS6EO0lRc0Q4EgqCgFl4NgICc/3+BdoBcIcEBNzEQD0k7wGDa34CBH/+HXgCIoNZaGFxSQAAAQAiAAAE3wcQAAkAMrIDCgsREjkAsABFWLAGLxuxBh8+WbAARViwBC8bsQQPPlmwBhCyAgEKK1gh2Bv0WTAxASMHIQMjEyETMwSOBwH9bNn3/QKdPeYE7Qn7HAWwAWAAAQARAAADzAVzAAcAKwCwAEVYsAQvG7EEGz5ZsABFWLACLxuxAg8+WbAEELIAAQorWCHYG/RZMDEBIQMjEyETMwN0/iWa7rwB3DfsA3b8igQ6ATkAAf/8AAAErAWwAA0ASQCwAEVYsAgvG7EIHz5ZsABFWLACLxuxAg8+WbINCAIREjmwDS+yAAcKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIwMjEyM3MxMhByEDMwKH73T2dKYepWsDgiT9dUfvAp/9YQKfqgJnzP5lAAH/ywAAA4kEOgANAEkAsABFWLAILxuxCBs+WbAARViwAi8bsQIPPlmyDQgCERI5sA0vsgAHCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASEDIxMjNzMTIQchByECVv8AUe1Rnh6dTgK1I/45LAEBAdH+LwHRqgG/xPsAAAEALv7EBKwFsAAXAFuyAxgZERI5ALAKL7AARViwFi8bsRYfPlmwAEVYsBQvG7EUDz5ZsBYQsgABCitYIdgb9FmyAxYUERI5sAMvsAoQsgsHCitYIdgb9FmwAxCyEgEKK1gh2Bv0WTAxASEDMxYWEgcCAAc3NhM2JyYmJyMDIxMhBIj9dUmYqe5rERv+zvwS70cgDQ2Gd7Rt9vwDggTk/l4Ej/79qf77/swGuwYBF4BxbnkE/YgFsAABABH+3wOCBDoAFQBKsg8WFxESOQCwCi+wAEVYsBQvG7EUGz5ZsABFWLASLxuxEg8+WbAUELIAAQorWCHYG/RZsgMUEhESObADL7IQAQorWCHYG/RZMDEBIQcXHgIHBgIHJzY3NiYnJwMjEyEDX/46KECP2WkND/O0QuseDnV1XE/uvAK1A3blAQN51oij/vwws1HUeZEEAf46BDoA////pf6aB+AFsAImAdkAAAAHA/0GgwAA////rf6aBnIEOgImAfkAAAAHA/0FPAAA//8AHv46BKgFxQImAdoAAAAHA/0Bdf+g//8AFv47A7wEUAImAfoAAAAHA/0BH/+h//8ALv6aBXsFsAImA8EAAAAHA/0EDwAA//8AIv6aBIEEOgImAf0AAAAHA/0DWQAAAAEAIwAABYMFsAAUAGEAsABFWLAALxuxAB8+WbAARViwDC8bsQwfPlmwAEVYsAIvG7ECDz5ZsABFWLAKLxuxCg8+WbIPCgwREjmwDy+ynw8BXbIIAQorWCHYG/RZsgEIDxESObAF0LAPELAS0DAxCQIhAycHIzcjAyMTMwMzNzMDMwEFg/4IARX+1rZBLp8pVWz3/fdrVC2gMzIBfwWw/U79AgJtAerp/ZMFsP2a/v8AAmgAAAEAIQAABM0EOgAUAFwAsABFWLANLxuxDRs+WbAARViwFC8bsRQbPlmwAEVYsAovG7EKDz5ZsABFWLADLxuxAw8+WbIOCg0REjmwDi+yCQEKK1gh2Bv0WbIBCQ4REjmwBdCwDhCwEtAwMQEBEyEDJwcjNyMDIxMzAzM3MwczAQTN/mrl/uCGLySYIFNL7LzsS1IkmCkiARYEOv3x/dUBrAGzsv5UBDr+UMfJAbIAAAEANwAABY8FsAAUAG4AsABFWLAELxuxBB8+WbAARViwEi8bsRIfPlmwAEVYsAsvG7ELDz5ZsABFWLAILxuxCA8+WbITEgsREjmwEy+wENCyDQcKK1gh2Bv0WbAB0LICCxIREjmwAi+yCgEKK1gh2Bv0WbIGCgIREjkwMQEjBzMBIQEBIQEjAyMTIzczNzMHMwLCzip9AgoBPv2YAYb+6P69rmz2vMcexiP2I88EP/MCZP07/RUCcP2QBD+qx8cAAAEAGQAABFkGAAAUAGoAsBIvsABFWLAELxuxBBs+WbAARViwCy8bsQsPPlmwAEVYsAgvG7EIDz5ZshMSCxESObATL7IBBworWCHYG/RZsgILBBESObACL7IKAQorWCHYG/RZsgYKAhESObABELAN0LATELAQ0DAxASMDMwEhAQEhAyMDIxMjNzM3MwczAqS+Xl0BTwEl/kkBGP793nJS7dLhHuEb7Bu+BLv94QGe/gX9wQHZ/icEu6qbmwAAAQCkAAAG4wWwAA4AYQCwAEVYsAYvG7EGHz5ZsABFWLAKLxuxCh8+WbAARViwAi8bsQIPPlmwAEVYsA0vG7ENDz5ZsggGAhESObAIL7IBAQorWCHYG/RZsAYQsgQBCitYIdgb9FmyDAEIERI5MDEBIwMjEyE3IQMzASEBASEDpq9s9tr+NSMCwGp9AgsBPv2XAYb+6AJw/ZAE7MT9nAJk/Tv9FQABAGwAAAW7BDoADgBrALAARViwBi8bsQYbPlmwAEVYsAovG7EKGz5ZsABFWLACLxuxAg8+WbAARViwDS8bsQ0PPlmyCQoCERI5sAkvsi8JAXGyjAkBXbIAAQorWCHYG/RZsAYQsgQBCitYIdgb9FmyDAAJERI5MDEBIwMjEyE3IQMzASEBASEDEX5K7Zr+diICd0xfAW0BNv4eATT+3gGs/lQDdsT+UAGw/e392f//ACf+mgWHBbACJgAsAAAABwP9BGkAAP//ABn+mgRpBDoCJgIAAAAABwP9A2sAAAABACcAAAffBbAADQBdALAARViwAi8bsQIfPlmwAEVYsAwvG7EMHz5ZsABFWLAGLxuxBg8+WbAARViwCi8bsQoPPlmyAQIGERI5sAEvsAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASETIQchAyMTIQMjEzMBsQJ2aQNPIv2o2/Zw/Ypw9/33A1ICXsP7EwKH/XkFsAAAAQARAAAFkgQ6AA0AZgCwAEVYsAIvG7ECGz5ZsABFWLAMLxuxDBs+WbAARViwBi8bsQYPPlmwAEVYsAovG7EKDz5ZsgEMBhESOXywAS8YtEABUAECXbACELIEAQorWCHYG/RZsAEQsggBCitYIdgb9FkwMQEhEyEHIQMjEyEDIxMzAWwBl04CQSP+rprtTP5pTO687gJ3AcPE/IoBtf5LBDoAAQAu/sIHhgWwABkAaLIUGhsREjkAsAgvsABFWLAYLxuxGB8+WbAARViwEi8bsRIPPlmwAEVYsBYvG7EWDz5ZsgEYEhESObABL7AIELIJBworWCHYG/RZsAEQshABCitYIdgb9FmwGBCyFAEKK1gh2Bv0WTAxATMWFhIHAgAHNzYTNicmJicjAyMTIQMjEyEFFm6p7msRG/7O/BLvRyANDYZ3im322f2U2fb8BFkDQASP/v2p/vv+zAa7BgEXgHFueQT9igTk+xwFsAAAAQAR/uMGUgQ6ABcAV7IQGBkREjkAsAcvsABFWLAWLxuxFhs+WbAARViwEC8bsRAPPlmwAEVYsBQvG7EUDz5ZsgEWEBESObABL7IOAQorWCHYG/RZsBYQshIBCitYIdgb9FkwMQEXFgAHBgIHJzY2NzYmJycDIxMhAyMTIQP2Ye4BDRMP9LNCeYQMD39/jVDtmf5pmu68A3MClAEC/vzUpv8AMLIqmGN4kwQB/jYDdvyKBDoAAgBl/+gF2QXHACsAOgCMshk7PBESObAZELA60ACwAEVYsCAvG7EgHz5ZsABFWLAOLxuxDh8+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEIBESObACL7AOELIPAQorWCHYG/RZsAQQshcBCitYIdgb9FmwABCyKwEKK1gh2Bv0WbACELAv0LAgELI2AQorWCHYG/RZMDEFJicGJy4CJyY3NxIANwcGBgIGFxYWFzI3JhM3NhI2FxYWFxcWBwcCBxYXARYWFzYTNzY1NCcmAwcGBUrSpKuikOmQEAkMGi4BOOAYb5o/CQYMmX8xMqUlIBiSxnaRtRMEAQciMdtPaf4AA0U+rSwiCn+rNiQJFwdBSQQCf+qWV1arASsBUgXUAs7+iHg8jqcDCPABFtGkAQh9AwTRtTdCPdr+2sIOAgGkWpo5jQEA4lMyzgcI/sbvPQAAAgBL/+oEkgRSACcAMgCMshszNBESObAbELAp0ACwAEVYsB0vG7EdGz5ZsABFWLAMLxuxDBs+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgIEHRESObACL7AMELINAQorWCHYG/RZsAQQshQBCitYIdgb9FmwABCyJwMKK1gh2Bv0WbACELAq0LAdELIwAQorWCHYG/RZMDEFJicGJyYmAjc3NhI3BwYHBxUWFhczNyY3Nz4CFxYWFxYHBwYHFhcBBhc2PwI0JyYHBE2zh4mBjtBgEQca870WlyYOBWdbFxZfFhMSbZpae5IGAgURIZ45Yf5pEV9rFw8GS28dFAQ0OgICmgEImDvcAQsGyhP+eE1vhQMCqcaOesRcAwTBnjQvftWWCwIBjqdwZaSBV5kDBvYA//8AZf4+BQ0FxwImACcAAAAHA/0BuP+k//8AOP4+A+4EUgImAEcAAAAHA/0BOv+k//8AnP6aBSIFsAImADgAAAAHA/0COwAA//8AU/6aBAgEOgImAgUAAAAHA/0B2AAA//8AoQAABU0FsAIGAD0AAP//AHf+XwQwBDoCBgGjAAAAAQChAAAFTQWwAA4AVrIKDxAREjkAsABFWLAILxuxCB8+WbAARViwCy8bsQsfPlmwAEVYsAIvG7ECDz5ZsgYCCBESObAGL7IFBworWCHYG/RZsAHQsgoIAhESObAGELAO0DAxASMDIxMjNzMBIRMBIQEzA5nPWvhaxB59/vgBBc0BvAEe/e58AgT9/AIEqgMC/VACsPz+AAABAFT+XwQwBDoADgBjsgoPEBESOQCwAEVYsAgvG7EIGz5ZsABFWLALLxuxCxs+WbAARViwAi8bsQIRPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIGBworWCHYG/RZsgoLABESObAN0LAO0DAxBSMDIxMjNzMDMxMBMwEzAt/VSe1IyB6inexmAWn+/iilAf5gAaCqA5H9BAL8/G/////D/poFRwWwAiYAPAAAAAcD/QPAAAD///+5/poEEwQ6AiYAXAAAAAcD/QLNAAAAAQCd/qEGbgWwAA8ATwCwDS+wAEVYsAgvG7EIHz5ZsABFWLACLxuxAh8+WbAARViwDi8bsQ4PPlmwAhCyAAEKK1gh2Bv0WbAF0LAOELIGAQorWCHYG/RZsArQMDEBITchByEDIRMzAzMDIxMhAfP+qiMDoyP+qrgCbdn22atz4z778ATsxMT73gTm+xz91QFfAAABAFb+vwTYBDoADwBLALANL7AARViwAy8bsQMbPlmwAEVYsA8vG7EPDz5ZsAMQsgQBCitYIdgb9FmwANCwDxCyBgEKK1gh2Bv0WbADELAI0LAGELAK0DAxASM3IQcjAyETMwMzAyMTIQFE7iICsCPUeAGXm+2aj23YOPzqA3fDw/1LA3j8iP39AUEA//8Axf6aBWoFsAImAeoAAAAHA/0EPQAA//8AcP6aBDoEOwImAgoAAAAHA/0DPAAAAAEAuQAABVwFsAAYAE+yBRkaERI5ALAARViwAC8bsQAfPlmwAEVYsAsvG7ELHz5ZsABFWLAOLxuxDg8+WbIFDgAREjmwBS+wCNCwBRCyFAEKK1gh2Bv0WbAR0DAxAQMGFxYXEzMDNjcTMwMjEwYHByM3JiY3EwISSwcFDKk7nzhecHv3/fdrUX8uoC/Y0xdLBbD+NToujREBK/7bCxgCqPpQAj0WDOznDPbPAckAAAEAhQAABDQEOwAVAE+yBBYXERI5ALAARViwCi8bsQobPlmwAEVYsBQvG7EUGz5ZsABFWLAALxuxAA8+WbIPFAAREjmwDy+yBgEKK1gh2Bv0WbAD0LAPELAS0DAxISMTBwcjNyYmNxMzAwcGFxMzAzcTMwN57kV1HaAfnZsSNuw4BANZNaA1dGDtAWoTi40X26QBTP6yQGsiAQv+7hQCDQABAOcAAAWMBbAAEABGsgIREhESOQCwAEVYsAEvG7EBHz5ZsABFWLAALxuxAA8+WbAARViwCS8bsQkPPlmyBQkBERI5sAUvsg4BCitYIdgb9FkwMTMTMwM2FxYWBwMjEzYmJAcD5/32a5qt5vAZTPZMEGD++s58BbD9wiwEAvPc/jcByn+DBir9WP//AA0AAAP5BgACBgBMAAAAAgBi/+oFwQXIACEALABkshwtLhESObAcELAr0ACwAEVYsBAvG7EQHz5ZsABFWLAALxuxAA8+WbIjABAREjmwIy+yFgEKK1gh2Bv0WbAF0LAjELAM0LAAELIdAQorWCHYG/RZsBAQsikBCitYIdgb9FkwMQUmJAI3NyYmNxcHFBc2EiQXFhIXFgcHJQcGFxYWFxY3FwYBJTc2JyYmJyYGBwNosP73dB4Ng4EJsAJeJbwBC5/Q6QUBCxb8ugwPCg6bgJ3DHXT98QJbBwsDBXZoh8Q3FgGkASGvSBzTpQFEdCi0ASGZBAT+6upSUYkBOFNKdYgDA0jIUwNlBSFCQnCBAwXGzwAC//T/6gSDBFMAHAAmAJGyDScoERI5sA0QsB7QALAARViwDi8bsQ4bPlmwAEVYsAAvG7EADz5ZsiEOABESObAhL7S/Ic8hAl20XyFvIQJxsr8hAXG0HyEvIQJxso8hAV207yH/IQJxshIHCitYIdgb9FmwBNCwIRCwC9CwABCyFwEKK1gh2Bv0WbIZDgAREjmwDhCyHQEKK1gh2Bv0WTAxBS4CNyYmNxcHBhc2JBcWEgcHIQYWFhcWNxcGBgMmBgcFNzYnJiYCbYvQYRRpaAekBANCSQEas8rJHg/9VwctaEmagHhD4g9ejTUBwQUHBQpYFAOI7Ykgu5QBOF8t0+kFBf7Z6mhRgU0CBYl9YWsDogN9kAIWLixHUv//AGL+QwXBBcgCJgJ+AAAABwP9Asf/qf////T+RgSDBFMCJgJ/AAAABwP9Adf/rP//ADUAAAIoBbACBgAtAAD///+lAAAH4AckAiYB2QAAAQcBagJQAT0ACQCwCS+wGdwwMQD///+tAAAGcgXaAiYB+QAAAQcBagGF//MACQCwCS+wGdwwMQAAAQAj/r0FWwWwABkAXrIYGhsREjkAsBAvsABFWLAELxuxBB8+WbAARViwCC8bsQgfPlmwAEVYsAIvG7ECDz5ZsgcEAhESObAHL7IYAQorWCHYG/RZsgoHGBESObAQELIRAQorWCHYG/RZMDEBIwMjEzMDMwEhARYSBwIABzc2NhInJiYnJwGVCHP3/fdqZAIOATz9t8jIGBv+x/wTcZxIDQ2Ecv0Ccv2OBbD9pAJc/YYf/szj/vf+ygTDBIkBAXdteQQCAAEAIf7nBIAEOgAWAF6yBhcYERI5ALAGL7AARViwES8bsREbPlmwAEVYsBUvG7EVGz5ZsABFWLAPLxuxDw8+WbITDxEREjmwEy+yDgEKK1gh2Bv0WbIADhMREjmwBhCyBwcKK1gh2Bv0WTAxARYWBwYGByc2Njc2JicnAyMTMwMzASECt4+WDg/yskJ1hgwOcm62S+y87EtIAYMBNwJcKuado/cusiWRYm2HBgH+VAQ6/lABsAD////K/n4FfAWwAiYB3gAAAAcAEART/8b///+//n4EeAQ6AiYB/gAAAAcAEANk/8YAAQAu/kYFggWwABQAdLIKFRYREjkAsABFWLAALxuxAB8+WbAARViwAy8bsQMfPlmwAEVYsBIvG7ESDz5ZsABFWLAILxuxCBE+WbICABIREjl8sAIvGLRgAnACAl20MAJAAgJdsAgQsg0BCitYIdgb9FmwAhCyEAEKK1gh2Bv0WTAxAQMhEzMBBgYnIic3FjMyNxMhAyMTAiBuAmpv9/7+GNamN04jNimAIW/9lmv2/AWw/YMCffoXuMkCE8cOxAKR/ZcFsAAAAQAR/kcEPwQ6ABQAbbILFRYREjkAsABFWLAALxuxABs+WbAARViwAy8bsQMbPlmwAEVYsBIvG7ESDz5ZsABFWLAILxuxCBE+WbICAxIREjl8sAIvGLRAAlACAl2wCBCyDQEKK1gh2Bv0WbACELIQAQorWCHYG/RZMDEBAyETMwMGBiMiJzcWMzI3EyEDIxMBu08Bl0/twxjNoztIHj0jgCFS/mlM7rwEOv49AcP7h7TGEsEQwgHp/ksEOv//ACf+fgWHBbACJgAsAAAABwAQBF//xv//ABn+fgR1BDoCJgIAAAAABwAQA2H/xv//AMX+mgVqBbACJgHqAAAABwP9AroAAP//AHD+mgQgBDsCJgIKAAAABwP9AbkAAP//ACf+fgbOBbACJgAxAAAABwAQBZ7/xv//ACL+fgXJBDoCJgH/AAAABwAQBLX/xv//ADUAAAIoBbACBgAtAAD///+kAAAErgcdAiYAJQAAAQcBagEwATYACQCwBC+wDtwwMQD//wAi/+gD9AXnAiYARQAAAQcBagCIAAAACQCwGC+wL9wwMQD///+kAAAErgcDAiYAJQAAAQcAawEoATYADACwBC+wHNywC9AwMf//ACL/6AQDBc0CJgBFAAABBwBrAIAAAAAMALAYL7A93LAs0DAx////hwAAB3gFsAIGAIkAAP//AA//6AZwBFICBgCpAAD//wAnAAAEugckAiYAKQAAAQcBagD4AT0ACQCwBi+wD9wwMQD//wA7/+oEAgXnAiYASQAAAQYBanEAAAkAsAkvsCPcMDEAAAIASP/oBTcFwwAaACQAXrIVJSYREjmwFRCwHNAAsABFWLAALxuxAB8+WbAARViwCi8bsQoPPlmyEAAKERI5sBAvsAAQshUBCitYIdgb9FmwChCyGwEKK1gh2Bv0WbAQELIeAQorWCHYG/RZMDEBFgQXFgcHBgIEJyYmAjc3BTYnJiYnJgcnNjYTFjY3IQcGFxYWAu+9AQ89PxkQHcr+1qyz8mQaFgOvDwoSqouk0R5AwQyR2kP9RQcOChCRBcMCrpqgym7G/ryvBASqATDFjwFbU4eXAwNJySkr+vwDy9EiTkNsdwD//wA2/+oD9gRQAgYBZQAA//8ASP/oBTcG3AImApoAAAEHAGsA9wEPAAwAsAAvsDbcsCXQMDH//wA2/+oD9gXOAiYBZQAAAQYAa3IBAAwAsAAvsC/csB7QMDH///+lAAAH4AcKAiYB2QAAAQcAawJIAT0ADACwCS+wJ9ywFtAwMf///60AAAZyBcACJgH5AAABBwBrAX3/8wAMALAJL7An3LAW0DAx//8AHv/tBKgHGAImAdoAAAEHAGsA4wFLAAwAsA4vsDvcsCrQMDH//wAW/+kD2gXNAiYB+gAAAQYAa1cAAAwAsCYvsDvcsCrQMDEAAQAv/+YEnAWwABsAarIZHB0REjkAsABFWLACLxuxAh8+WbAARViwDC8bsQwPPlmwAhCyAAEKK1gh2Bv0WbIEAAIREjmyGwwCERI5sBsvshkHCitYIdgb9FmyBRsZERI5shAMGRESObAMELITAQorWCHYG/RZMDEBITchBwEWFgcOAicmJjczBhYXFjY3NiYnJzcDU/2uJAN3Hf5FqLAOC5b7k8joCPQEbVpvrRARdIGXIATkzK7+VRnvr4bJawQE7LtkeQIEf2+BiwQBtwAB//D+cgRUBDoAGwBdsgscHRESOQCwDC+wAEVYsAIvG7ECGz5ZsgABCitYIdgb9FmyBAACERI5shsMAhESObAbL7IZBworWCHYG/RZsgUZGxESObIPAgwREjmwDBCyEwEKK1gh2Bv0WTAxASE3IQcBFhYHDgInJiY3FwYWFxY2NzYmJyc3Awn9tiMDchz+RaW1DwuW+JLG5wjsBGtfcrEQEXaCmiADdsSm/koZ67CFyGsDBOu6AWR+AgSDcIOKBAG2//8AJwAABXwG8QImAdsAAAEHAHIBIQFBABMAsABFWLAILxuxCB8+WbAL3DAxAP//ABkAAARIBacCJgH7AAABBgByZvcAEwCwAEVYsAcvG7EHGz5ZsAvcMDEA//8AJwAABXwHCgImAdsAAAEHAGsBTwE9AAwAsAAvsBvcsArQMDH//wAZAAAESAXAAiYB+wAAAQcAawCU//MADACwAC+wG9ywCtAwMf//AGv/5wUhBwMCJgAzAAABBwBrAT8BNgAMALAKL7A03LAj0DAx//8AOf/oBCcFzQImAFMAAAEGAGt9AAAMALAEL7Ay3LAh0DAx//8AYv/nBRoFyAIGAjUAAP//ADb/5wQmBFICBgI2AAD//wBi/+cFGgcHAiYCNQAAAQcAawFNAToADACwCi+wNtywJdAwMf//ADb/5wQmBc0CJgI2AAABBgBrewAADACwBC+wL9ywHtAwMf//AE//6QT3BxkCJgHwAAABBwBrASEBTAAMALAUL7Ay3LAh0DAx//8AI//oA+UFzQImAhAAAAEGAGtiAAAMALAIL7Ax3LAg0DAx//8Am//nBVMG8QImAeYAAAEHAHIA3wFBAAkAsAEvsBHcMDEA////tf5FBBIFtAImAF0AAAEGAHIeBAAJALABL7AQ3DAxAP//AJv/5wVTBwoCJgHmAAABBwBrAQ0BPQAMALABL7Ai3LAR0DAx////tf5FBBIFzQImAF0AAAEGAGtMAAAMALABL7Ah3LAQ0DAx//8Am//nBVMHPAImAeYAAAEHAW8BXAE9AAwAsAEvsBPcsBXQMDH///+1/kUEhAX/AiYAXQAAAQcBbwCbAAAAFgCwAEVYsA8vG7EPGz5ZsBbcsBLQMDH//wDFAAAFagcKAiYB6gAAAQcAawFJAT0ADACwAC+wItywEdAwMf//AHAAAAQgBcACJgIKAAABBgBrbfMADACwCC+wJNywE9AwMf//AC7+mgSsBbACJgGEAAAABwP9AP8AAP//ABj+mgOJBDoCJgH2AAAABwP9AOUAAP//AC4AAAa9BwsAJgHvCwAAJwAtBJUAAAEHAGsB9wE+ABYAsABFWLAKLxuxCh8+WbAe3LAp0DAx//8AIgAABfEFwAAmAg8AAAAnAPQEJgAAAQcAawFy//MAFgCwAEVYsAovG7EKGz5ZsB7csCnQMDH//wAz/kYE/AWwACYBhFAAACYD1a4pAAcD/AEsAAD//wAJ/kQD2wQ6ACYB9lIAACcD1f+J/3oABwP8AQL//v///8P+RgVHBbACJgA8AAAABwP8A7AAAP///7n+RgQTBDoCJgBcAAAABwP8Ar0AAAAB/8MAAAVHBbAAEQBjALAARViwCy8bsQsfPlmwAEVYsA4vG7EOHz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyEQsCERI5sBEvsgAHCitYIdgb9FmyBAsCERI5sAfQsBEQsAnQsg0LAhESOTAxASMBIQMBIQEjNzMBIRMBIQEzA8eKASP+7tz+fP7VAfF4HnT+7wEQ1gF6ASr+LHIClf1rAhX96wKVqgJx/fMCDf2PAAAB/7kAAAQTBDoAEQBjALAARViwCy8bsQsbPlmwAEVYsA4vG7EOGz5ZsABFWLACLxuxAg8+WbAARViwBS8bsQUPPlmyEQ4CERI5sBEvsgAHCitYIdgb9FmyBA4CERI5sAfQsBEQsAnQsg0OAhESOTAxASMTIwMBIQEjNzMDMxMTIQEzAymW0/iX/vb+7AFngh6ExfiM/wEV/rCEAdf+KQFx/o8B16oBuf6eAWL+RwACADAAAAT4BbAADAAVAFCyDBYXERI5sAwQsA/QALAARViwAS8bsQEfPlmwAEVYsAMvG7EDDz5ZsgABAxESObAAL7ADELINAQorWCHYG/RZsAAQsg4BCitYIdgb9FkwMQETMwMlLgI3PgIzExMlBgYHBhYXA6Rd9/39+YvSZwsLmf+ZsFr+7oCtDxFvaQObAhX6UAEEc8yEjNVz/S4CBgICj3dvjAT//wA7/+cEiAYAAgYASAAAAAIARQAABoAFsAAYACEAWrIZIiMREjmwGRCwCdAAsABFWLAKLxuxCh8+WbAARViwGC8bsRgPPlmyCAoYERI5sAgvsBgQsgwBCitYIdgb9FmyEgoYERI5sBnQsAgQshoBCitYIdgb9FkwMSUuAjc+AjMFEzMDFzY2NTQnFxYXEgAjJRMlBgYHBhYXAgiL0mYLC5r9mQEuXfbZO3+aFeYSBhD+3/n+11r+7H2uEQ9uaQEEdMuEjNZyAQIV+xoCAubfXVgBWVv+1v6bygIGAgKNeHCMBAAAAgBH/+YGUQYYACMAMgCAsgYzNBESObAGELAk0ACwAEVYsAcvG7EHIT5ZsABFWLAaLxuxGg8+WbAARViwHy8bsR8PPlmyBAcfERI5sAQvsgYHHxESObAaELIOAQorWCHYG/RZshMHHxESObIdBx8REjmwBBCyJgEKK1gh2Bv0WbAfELIvAQorWCHYG/RZMDETNhI2FxYXEzMDBhcWFhcWEhM2JxcWFxYCBCciJicGJyYmJyYBJicmBgcHBhcWFhcWNzdPFYrLgZxZbe3NAwMDNy+OrwcCEt8OBAeL/vWpdp8chr+ZsgcDAtE3d3ydFQMGAQJaUn5lBgIHsAEVhgMEdwJE+04eHzdAAwkBKwENZGQBZGPb/qK9A1pZuAQE07g7AW5jBALPsRQzOGZzAgR1RQAAAQCq/+gFugWwACoAY7IVKywREjkAsABFWLANLxuxDR8+WbAARViwJy8bsScPPlmyBisNERI5sAYvsgMBCitYIdgb9FmwDRCyDAEKK1gh2Bv0WbIUAwYREjmwJxCyGwEKK1gh2Bv0WbIgDScREjkwMQE2JicnNxcyNjc2JyU3BRYWBwYGBxYWBwcGFhcWEhM2JxcWFxYCBicmJjcCZAlVV+Ekj5WkDhnm/p0kAS/v9Q8IkZliXwkHBS0tgpoHAhHoDQQHif+nl54IAXtlewUCzQF4dL8JAc0BAdbAb6s+IqR+RjZIAgkBMAEBZGQBZGPd/qS9AgKwmwABAGH/4wTNBDoAKQBgsiUqKxESOQCwAEVYsB8vG7EfGz5ZsABFWLAQLxuxEA8+WbIDAQorWCHYG/RZsgkQHxESObIYKh8REjmwGC+yFwEKK1gh2Bv0WbAfELIeAQorWCHYG/RZsiYXGBESOTAxJRUWFxY2NicmJxcWFxYCBicmJjc3NicnNxc2NzYnJTcXFhYHBgYHFhYHAq4DN0lyPQUEFN4RCRJw5ZWXkQUJC4PwH6XOFBWr/vQc9r3MCAVja09GBukhMwMFbNV5T04BTk6a/tagAQN8dExxBwK9AQaJhAoBwwEFpo9PdS8aeFIAAQCS/rkD2QWwACcAX7IkKCkREjkAsBsvsABFWLAKLxuxCh8+WbAARViwHy8bsR8PPlmyASgKERI5sAEvsgABCitYIdgb9FmwChCyCQEKK1gh2Bv0WbIQAAEREjmwHxCyGAUKK1gh2Bv0WTAxEzcXMjY3NiYnJTcXFhYHBgUWFhcWDwI3BwYHJzY3ByYnJjc3NiYnkiK1jqcODm5r/tof+OXyDxH++kdUCAQHFgPPGijHg2QslSUEAwoSDl1eAlzDAXlzbXEEAcMBAd7A3nUeeFQzNXcMBKD3nFGHbwEuRyxMfW2ABAABAIz+qAO5BDoAIwBfsh8kJRESOQCwGS+wAEVYsAkvG7EJGz5ZsABFWLAdLxuxHQ8+WbIBJAkREjmwAS+yAAEKK1gh2Bv0WbAJELIIAQorWCHYG/RZshAAARESObAdELIVAQorWCHYG/RZMDETNxc2NzYmJyU3BRYWBwYGBxYXFgcHNwcGByc2NwcmNzc2JieMH9LWFwpUVP7aHgENvdUKBWVnbg0EBga+GSbIg2somSMGDwlNTAGbswEGkENQAgHBAQWwkFB7MTR7JighAaHxoVGWcQEtToBOTgMAAf/e/+UHSgWwACMAYrIjJCUREjkAsABFWLANLxuxDR8+WbAARViwIC8bsSAPPlmwAEVYsAUvG7EFDz5ZsA0QsgABCitYIdgb9FmwBRCyCAEKK1gh2Bv0WbAgELIUAQorWCHYG/RZshkNBRESOTAxASEDAgIHIzc3NjY3NxMhAwYXFhYXFhITNicXFhcWAgQnJiY3BFn+b5BD+cBeFzN0mykUiwN1ugMDAzUuiaoFAhLpDgQHjv74p62vEgTj/Vv+1P7zBcoDDNbpcgKm+7kdHzRAAwkBJQEMZGQBZGPf/qO9BATPrgAB/97/5wYmBDoAIgBisgAjJBESOQCwAEVYsA0vG7ENGz5ZsABFWLAFLxuxBQ8+WbAARViwHy8bsR8PPlmwDRCyAAEKK1gh2Bv0WbAFELIHAQorWCHYG/RZsB8QshIBCitYIdgb9FmyGA0FERI5MDEBIwMGBicjNzc2Njc3EyEDBhYXFjY3NzYnFxYXFgIGJyYmNwMw/mI3zqBNFSVbcx8OYALMeQg8Pm6GDQIBEt8OBQp57ZmssxIDdP4/6s0EyQMImrBOAc79LFFlAgTp3DxeXgFeXsP+trYDAsyvAAABACf/5gdQBbAAHgBxshYfIBESOQCwAEVYsAAvG7EAHz5ZsABFWLAaLxuxGh8+WbAARViwEi8bsRIPPlmwAEVYsBgvG7EYDz5ZsBIQsgYBCitYIdgb9FmyCwAYERI5sh0AGBESOXywHS8YtDAdQB0CXbIWAQorWCHYG/RZMDEBAwYXFhYXFhITNicXFhcWAgQnJiY3NyEDIxMzAyETBXi3AwMEMy2JqwUCEukOBAeO/vmpp68OJ/2Xa/b99m8CaW8FsPu3HR42PwEIASIBDmRkAWRj4P6juwMCzrH//ZcFsP2DAn0AAAEAC//mBikEOgAeAHSyCB8gERI5ALAARViwBC8bsQQbPlmwAEVYsAgvG7EIGz5ZsABFWLAbLxuxGw8+WbAARViwAi8bsQIPPlmyBwgCERI5fLAHLxiyUwcBXbJABwFdsgABCitYIdgb9FmwGxCyDwEKK1gh2Bv0WbIUCAIREjkwMQEhAyMTMwMhEzMDBhcWFhcWEjc0JxcWFxYCBicmJjcC5/5eTe287U4Bok3teQMDBTswd40CEd4OBQp47pmpsQwBuv5GBDr+QwG9/SwfIDZBAQYBE+9eXgFeXr7+srgDAsqyAAEATP/oBJQFxwAhAEeyFyIjERI5ALAARViwCS8bsQkfPlmwAEVYsAAvG7EADz5ZsAkQsg4BCitYIdgb9FmwABCyFwEKK1gh2Bv0WbIcCQAREjkwMQUmJgI3EzYSJBcWFwcmJyYGBwcGFxYWFxY2JyYnFxcWAgQCUqPycRYpHL8BIqzMj1B6m6LqHigKCQ2Nb5OuAQEN6w0Ki/7yFQSkARymAQazAR6bAQRYtkUCAu6+/UZKeZMDAtDiWFcBrtb+75YAAQA9/+cDqgRRAB8AQ7IAICEREjkAsABFWLATLxuxExs+WbAARViwCi8bsQoPPlmyAAEKK1gh2Bv0WbAKELAE0LATELIYAQorWCHYG/RZMDElFjY3JzMXFgYGJy4CNzc+AhcWFwcmIyIGBwYXFhYCBVliAgXfCAZszH6Ny18OBRKZ8pGobUFdgXiqFwsGCWyvAmmWbm2ew2UDBI71lCqZ/YwBAkS7Pb+dXz9oegAAAQCQ/+YFNAWwABoATbIJGxwREjkAsABFWLACLxuxAh8+WbAARViwFy8bsRcPPlmwAhCyAAEKK1gh2Bv0WbAE0LAF0LAXELIKAQorWCHYG/RZshACFxESOTAxASE3IQchAwcWFhcWEjc3NicXFhcWAgQnJiY3AkX+SyQEXyT+TJYBAzUuh6cLAQIS6A4DB4n++Kuorw4E483N/IU7NEADBgER/x5kZAFkY9n+ocADAs6xAAEAc//oBJcEOgAZAE2yChobERI5ALAARViwAi8bsQIbPlmwAEVYsBYvG7EWDz5ZsAIQsgABCitYIdgb9FmwBNCwBdCwFhCyCwEKK1gh2Bv0WbIQAhYREjkwMQEhNyEHIQMGFxYWFxY2JyYnFxYHBgQnJiY3Aa/+xCIDciP+uFgDAwU7MXeICgUU3SkOGf73wqmyDgN3w8P97x8gN0ABBOywS0oBtHfN+wICzK8AAAEAVv/oBSIFyAArAHSyGywtERI5ALAARViwHC8bsRwfPlmwAEVYsA4vG7EODz5ZsikcDhESObApL7IfKQFxskopAV2yAAEKK1gh2Bv0WbAOELIGAQorWCHYG/RZsgocDhESObIUACkREjmyHxwOERI5sBwQsiMBCitYIdgb9FkwMQEiBgcGFhcWNjc3BgYEJy4CNzYlJicmNzY2JBcWBAcnNiYnJgYHBhYXFwcCw6C7Dw2bh4K/EfULof71m5z6dwoRATBQMT4GCJ8BEKbVAQgE9ASGbo3BDw6DhL0kAoN8d2N3AwJ+ZQGFwmYDAm67evtnLENVZojAZAMF4bUBXW8CA3lnZWsBAcj//wAo/+oEAgRRAgYBpQAA////yv5GBYwFsAImAd4AAAAHA/wETQAA////v/5GBJ0EOgImAf4AAAAHA/wDXgAA////pP5sBK4FsAImACUAAAAHAXABbwAD//8AIv5wA9wEUAImAEUAAAAHAXAAqQAH//8AJ/6bBLwFsAImACYAAAAHAXYElwAK//8AEP6IBA8GAAImAEYAAAAHAXYEpf/3//8AJ/6bBOAFsAImACgAAAAHAXYEcwAK//8AO/6RBIgGAAImAEgAAAAHAXYEkAAA//8AJ/35BOAFsAImACgAAAAHA6sBAf6S//8AO/35BIgGAAImAEgAAAAHA6sBHv6S//8AJ/6bBYcFsAImACwAAAAHAXYFAAAK//8ADf6bA/kGAAImAEwAAAAHAXYEfwAK//8AJwAABXEHNgImAC8AAAEHAHcBpQE2AAkAsAQvsA/cMDEA//8AEQAABHUHPQImAE8AAAEHAHcBowE9AAkAsAQvsA/cMDEA//8AJ/7cBXEFsAImAC8AAAAHAXYE0QBL//8AEf7HBEoGAAImAE8AAAAHAXYEYAA2//8AJ/6bA8MFsAImADAAAAAHAXYElwAK////5P6bAhcGAAImAFAAAAAHAXYDRAAK//8AJwAABs4HNgImADEAAAEHAHcCvgE2ABMAsABFWLACLxuxAh8+WbAR3DAxAP//ABAAAAZoBgACJgBRAAABBwB3ApgAAAAJALADL7Ak3DAxAP//ACf+mwbOBbACJgAxAAAABwF2BasACv//ABD+mwZoBFICJgBRAAAABwF2Ba4ACv//ACf+lwWGBbACJgAyAAAABwF2BQIABv//AA3+mwP6BFICJgBSAAAABwF2BGwACv//ACcAAAUEB0ICJgA0AAABBwB3AasBQgAJALADL7AW3DAxAP///8f+YARtBfcCJgBUAAABBwB3AZv/9wAJALANL7Ah3DAxAP//ACf+mwTYBbACJgA2AAAABwF2BJgACv///97+mwLvBFMCJgBWAAAABwF2Az4ACv//ACT+kQS7BccCJgA3AAAABwF2BLAAAP//ABz+iAPEBFACJgBXAAAABwF2BGL/9///AJz+lAUiBbACJgA4AAAABwF2BJ8AA///ADv+kQKuBUECJgBYAAAABwF2A/UAAP//AJsAAAWBBzcCJgA6AAABBwFuAN0BQwAJALABL7AR3DAxAP//AGQAAAQNBewCJgBaAAABBgFuFvgACQCwAS+wEdwwMQD//wCb/psFgQWwAiYAOgAAAAcBdgTVAAr//wBk/psEDQQ6AiYAWgAAAAcBdgRCAAr//wC3AAAHOgc2AiYAOwAAAQcARAIoATYAEwCwAEVYsAsvG7ELHz5ZsA7cMDEA//8AdwAABfgGAAImAFsAAAEHAEQBawAAABMAsABFWLALLxuxCxs+WbAO3DAxAP//ALcAAAc6BzYCJgA7AAABBwB3AsMBNgATALAARViwDC8bsQwfPlmwD9wwMQD//wB3AAAF+AYAAiYAWwAAAQcAdwIGAAAAEwCwAEVYsAwvG7EMGz5ZsA/cMDEA//8AtwAABzoHAwImADsAAAEHAGsB9QE2AAwAsAEvsB7csA3QMDH//wB3AAAF+AXNAiYAWwAAAQcAawE4AAAADACwAS+wHtywDdAwMf//ALf+mwc6BbACJgA7AAAABwF2BcUACv//AHf+mwX4BDoCJgBbAAAABwF2BScACv///+X+mwTnBbACJgA+AAAABwF2BJ8ACv///+f+mwPkBDoCJgBeAAAABwF2BEMACv///6T+lASuBbACJgAlAAAABwF2BOcAA///ACL+mAPcBFACJgBFAAAABwF2BCEAB////6QAAASuB7sCJgAlAAABBwF0BRUBPAAJALAEL7AZ3DAxAP//ACL/6APcBoUCJgBFAAABBwF0BG0ABgAJALAYL7A63DAxAP///6QAAAYYB7ECJgAlAAABBwPvAOsBIQAWALAARViwBS8bsQUfPlmwDtywFNAwMf//ACL/6AVwBnwCJgBFAAABBgPvQ+wAFgCwAEVYsBgvG7EYGz5ZsC/csDXQMDH///+kAAAErgeuAiYAJQAAAQcD8ADyASsAFgCwAEVYsAQvG7EEHz5ZsA7csBPQMDH//wAi/+gD8gZ5AiYARQAAAQYD8Er2ABYAsABFWLAYLxuxGBs+WbAt3LA00DAx////pAAABYAH3gImACUAAAEHA/EA7AETABYAsABFWLAFLxuxBR8+WbAM3LAS0DAx//8AIv/oBNgGqQImAEUAAAEGA/FE3gAWALAARViwGC8bsRgbPlmwLdywM9AwMf///6QAAASuB9UCJgAlAAABBwPyAOsBBQAWALAARViwBC8bsQQfPlmwDtywFdAwMf//ACL/6APsBqACJgBFAAABBgPyQ9AAFgCwAEVYsBgvG7EYGz5ZsC3csDbQMDH///+k/pQErgc3AiYAJQAAACcBZwDyATYBBwF2BOcAAwATALAARViwBC8bsQQfPlmwD9wwMQD//wAi/pgD6QYBAiYARQAAACYBZ0oAAQcBdgQhAAcAEwCwAEVYsBgvG7EYGz5ZsDDcMDEA////pAAABK4HrgImACUAAAEHA/MBHAEwABYAsABFWLAELxuxBB8+WbAO3LAa0DAx//8AIv/oA+4GeQImAEUAAAEGA/N0+wAWALAARViwGC8bsRgbPlmwL9ywO9AwMf///6QAAASuB64CJgAlAAABBwPuARwBMAAMALAEL7AO3LAa0DAx//8AIv/oA+4GeQImAEUAAAEGA+50+wAMALAYL7Av3LA40DAx////pAAABK4IPgImACUAAAEHA/QBHAE2AAwAsAQvsA7csBjQMDH//wAi/+gD4gcIAiYARQAAAQYD9HQAAAwAsBgvsC/csDnQMDH///+kAAAErggXAiYAJQAAAQcD9QEgATwADACwBC+wDtywF9AwMf//ACL/6AP6BuECJgBFAAABBgP1eAYADACwGC+wL9ywONAwMf///6T+lASuBx0CJgAlAAAAJwFqATABNgEHAXYE5wADABMAsABFWLAELxuxBB8+WbAO3DAxAP//ACL+mAP0BecCJgBFAAAAJwFqAIgAAAEHAXYEIQAHABMAsABFWLAYLxuxGBs+WbAv3DAxAP//ACf+mwS6BbACJgApAAAABwF2BKgACv//ADv+kQQCBFECJgBJAAAABwF2BHYAAP//ACcAAAS6B8ICJgApAAABBwF0BN0BQwAJALAGL7Aa3DAxAP//ADv/6gQCBoUCJgBJAAABBwF0BFYABgAJALAJL7Au3DAxAP//ACcAAAS6BzICJgApAAABBwFuAMgBPgAJALAGL7AW3DAxAP//ADv/6gQKBfUCJgBJAAABBgFuQQEACQCwCS+wKtwwMQD//wAnAAAF4Ae4AiYAKQAAAQcD7wCzASgAFgCwAEVYsAcvG7EHHz5ZsA/csBXQMDH//wA7/+oFWQZ8AiYASQAAAQYD7yzsABYAsABFWLAJLxuxCRs+WbAj3LAp0DAx//8AJwAABLoHtQImACkAAAEHA/AAugEyABYAsABFWLAGLxuxBh8+WbAP3LAU0DAx//8AO//qBAIGeQImAEkAAAEGA/Az9gAWALAARViwCS8bsQkbPlmwI9ywKNAwMf//ACcAAAVIB+UCJgApAAABBwPxALQBGgAWALAARViwBi8bsQYfPlmwD9ywE9AwMf//ADv/6gTBBqkCJgBJAAABBgPxLd4AFgCwAEVYsAkvG7EJGz5ZsCHcsCfQMDH//wAnAAAEugfcAiYAKQAAAQcD8gCzAQwAFgCwAEVYsAYvG7EGHz5ZsA/csBbQMDH//wA7/+oEAgagAiYASQAAAQYD8izQABYAsABFWLAJLxuxCRs+WbAh3LAq0DAx//8AJ/6bBLoHPgImACkAAAAnAWcAugE9AQcBdgSoAAoAEwCwAEVYsAYvG7EGHz5ZsBDcMDEA//8AO/6RBAIGAQImAEkAAAAmAWczAAEHAXYEdgAAABMAsABFWLAJLxuxCRs+WbAk3DAxAP//ADUAAALSB8ICJgAtAAABBwF0A5UBQwAJALACL7AS3DAxAP//ACIAAAKHBn4CJgD0AAABBwF0A0r//wAJALACL7AS3DAxAP/////+lwIoBbACJgAtAAAABwF2A18ABv///+T+mwIJBdgCJgBNAAAABwF2A0QACv//AGv+kQUhBcgCJgAzAAAABwF2BPYAAP//ADn+jwQnBFICJgBTAAAABwF2BIT//v//AGv/5wUhB7sCJgAzAAABBwF0BSwBPAAJALAKL7Ax3DAxAP//ADn/6AQnBoUCJgBTAAABBwF0BGoABgAJALAEL7Av3DAxAP//AGv/5wYvB7ECJgAzAAABBwPvAQIBIQAWALAARViwCi8bsQofPlmwJtywLNAwMf//ADn/6AVtBnwCJgBTAAABBgPvQOwAFgCwAEVYsAQvG7EEGz5ZsCTcsCrQMDH//wBr/+cFIQeuAiYAMwAAAQcD8AEJASsAFgCwAEVYsAovG7EKHz5ZsCTcsCvQMDH//wA5/+gEJwZ5AiYAUwAAAQYD8Ef2ABYAsABFWLAELxuxBBs+WbAk3LAp0DAx//8Aa//nBZcH3gImADMAAAEHA/EBAwETABYAsABFWLAKLxuxCh8+WbAk3LAq0DAx//8AOf/oBNUGqQImAFMAAAEGA/FB3gAWALAARViwBC8bsQQbPlmwItywKNAwMf//AGv/5wUhB9UCJgAzAAABBwPyAQIBBQAWALAARViwCi8bsQofPlmwJNywLdAwMf//ADn/6AQnBqACJgBTAAABBgPyQNAAFgCwAEVYsAQvG7EEGz5ZsCLcsCvQMDH//wBr/pEFIQc3AiYAMwAAACcBZwEJATYBBwF2BPYAAAATALAARViwCi8bsQofPlmwJdwwMQD//wA5/o8EJwYBAiYAUwAAACYBZ0cAAQcBdgSE//4AEwCwAEVYsAQvG7EEGz5ZsCPcMDEA//8AW//oBiYHMwImAUUAAAEHAHcCBgEzABMAsABFWLAKLxuxCh8+WbAu3DAxAP//ADb/5gUFBgACJgFGAAABBwB3AVoAAAATALAARViwBC8bsQQbPlmwKtwwMQD//wBb/+gGJgczAiYBRQAAAQcARAFrATMAEwCwAEVYsAovG7EKHz5ZsC3cMDEA//8ANv/mBQUGAAImAUYAAAEHAEQAvwAAABMAsABFWLAELxuxBBs+WbAp3DAxAP//AFv/6AYmB7gCJgFFAAABBwF0BSUBOQATALAARViwCi8bsQofPlmwOtwwMQD//wA2/+YFBQaFAiYBRgAAAQcBdAR5AAYAEwCwAEVYsAQvG7EEGz5ZsCjcMDEA//8AW//oBiYHKAImAUUAAAEHAW4BEAE0ABMAsABFWLAKLxuxCh8+WbAv3DAxAP//ADb/5gUFBfUCJgFGAAABBgFuZAEAEwCwAEVYsAQvG7EEGz5ZsCvcMDEA//8AW/6RBiYGLgImAUUAAAAHAXYE4AAA//8ANv6IBQUEqAImAUYAAAAHAXYEdf/3//8AW/6RBS8FsAImADkAAAAHAXYEzAAA//8ASv6RBDEEOgImAFkAAAAHAXYEIQAA//8AW//mBS8HuwImADkAAAEHAXQFBAE8ABMAsABFWLAKLxuxCh8+WbAT3DAxAP//AEr/6AQxBoUCJgBZAAABBwF0BG8ABgATALAARViwCC8bsQgbPlmwFNwwMQD//wBb/+gGrQdCAiYBRwAAAQcAdwINAUIAEwCwAEVYsBovG7EaHz5ZsB3cMDEA//8ASv/oBWEF7AImAUgAAAEHAHcBVf/sABMAsABFWLAWLxuxFhs+WbAe3DAxAP//AFv/6AatB0ICJgFHAAABBwBEAXIBQgATALAARViwEi8bsRIfPlmwHNwwMQD//wBK/+gFYQXsAiYBSAAAAQcARAC6/+wAEwCwAEVYsA4vG7EOGz5ZsB3cMDEA//8AW//oBq0HxwImAUcAAAEHAXQFLAFIABMAsABFWLASLxuxEh8+WbAb3DAxAP//AEr/6AVhBnECJgFIAAABBwF0BHT/8gATALAARViwDi8bsQ4bPlmwHNwwMQD//wBb/+gGrQc3AiYBRwAAAQcBbgEXAUMAEwCwAEVYsBovG7EaHz5ZsB7cMDEA//8ASv/oBWEF4QImAUgAAAEGAW5f7QATALAARViwFi8bsRYbPlmwH9wwMQD//wBb/ogGrQYCAiYBRwAAAAcBdgTw//f//wBK/pEFYQSUAiYBSAAAAAcBdgQlAAD//wChAAAFTQc2AiYAPQAAAQcARAEiATYAEwCwAEVYsAgvG7EIHz5ZsArcMDEA////tf5FBBIGAAImAF0AAAEGAER/AAATALAARViwDy8bsQ8bPlmwEdwwMQD//wCh/qEFTQWwAiYAPQAAAAcBdgSkABD///+1/gwEEgQ6AiYAXQAAAAcBdgUH/3v//wChAAAFTQe7AiYAPQAAAQcBdATcATwACQCwAS+wF9wwMQD///+1/kUEEgaFAiYAXQAAAQcBdAQ5AAYACQCwAS+wHtwwMQD//wChAAAFTQcrAiYAPQAAAQcBbgDHATcACQCwAS+wE9wwMQD///+1/kUEEgX1AiYAXQAAAQYBbiQBAAkAsAEvsBrcMDEA///+s//nBWcF2AAmADNGAAAHA139xwAAAAIA7ARxA2AF2AAFAA4AFQCwDC+wB9CwAdCwDBCwBNCwBdAwMQETNwcBBwMzBwYWFwcmNwH1nc4B/vFd660PCQ4mTZgQBJkBPgEY/sMBAVVTPGQwQ12xAP//ADYCCQJYAs0ABgARAAD//wA2AgkCWALNAAYAEQAA//8AnAJtBKUDMQBGA6DhAEzNQAD//wCCAm0F4wMxAEYDoIkAZmZAAP//AIICbQXjAzEARgOgiQBmZkAA////Tv4/AxcAAAAnAEP/1f7+AQYAQwEAABwAtgACEAIgAgNdtBACIAICcbaAApACoAIDXTAxAAEArgQgAiIGGgAHAB2yBwgJERI5ALAARViwAC8bsQAhPlmwBNCwBC8wMQEXBgcHIzc2Aat3axwd0BQmBhpPjX+ffOcAAQCKBAAB/gYAAAcAHbICCAkREjkAsABFWLAELxuxBCE+WbAA0LAALzAxASc2NzczBwYBAXdqHB7QFiUEAE+LgaWI4gAB/6T+1gEVAMoABwAYsgcICRESOQCwCC+yBA0KK1gh2Bv0WTAxEyc2NzczBwYadmYbHNQTI/7WUImBmnvgAAEAzQQBAdIGAAAKABOyCAsMERI5ALAAL7AG0LAGLzAxAQcGFxYXByYmNzcBwBkMCgkke0VFDBYGAJFOSElGSUfIYo7//wC3BCADcQYaACYDcAkAAAcDcAFPAAD//wCXBAADTwYAACYDcQ0AAAcDcQFRAAAAAv+h/sICWwD/AAgAEQAhsg0SExESObANELAF0ACwEi+yBA0KK1gh2Bv0WbAN0DAxEyc2NzczBwYGFyc2NzczBwYGG3pvGiDUHRJ733p0GSDVHhJ+/sJQoJS5tnHPR1Cjkbm3dMkAAQBpAAAESwWwAAsASwCwAEVYsAgvG7EIHz5ZsABFWLAGLxuxBhs+WbAARViwCi8bsQobPlmwAEVYsAIvG7ECDz5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhAyMTITchEzMDIQQr/pSK7ov+lyABZzvuOwFtA3L8jgNyyAF2/ooAAAH/+/5gBGUFsAATAHwAsABFWLAMLxuxDB8+WbAARViwCi8bsQobPlmwAEVYsA4vG7EOGz5ZsABFWLACLxuxAhE+WbAARViwAC8bsQAPPlmwAEVYsAQvG7EEDz5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISEDIxMhNyETITchEzMDIQchAyEDvP6TQe1B/pkfAWZs/pkfAWc67jsBbR/+lG0Bbv5gAaDCArTEAXb+isT9TAABAJ4CBAJNA9wADQAWsgMODxESOQCwAy+xCgorWNgb3FkwMRM2NjMWFhUHBgYjIiY1nwZ9YFtwAgd9X1pwAvxkfAJ2Xitkc3Rb//8AM//yAwIBAwAmABIDAAAHABIBvwAA//8AM//yBK4BAwAmABIDAAAnABIBvwAAAAcAEgNrAAAAAQA2AgkBLgLNAAMAGLIABAUREjkAsAMvsgABCitYIdgb9FkwMQEjNzMBC9Uj1QIJxAAGAJ3/6AcGBccAFgAkACgANgBEAFIAuLICU1QREjmwAhCwGdCwAhCwJ9CwAhCwK9CwAhCwONCwAhCwTdAAsCUvsCcvsABFWLAXLxuxFx8+WbAARViwEy8bsRMPPlmwA9CwAy+yBQMTERI5sAfQsAcvsBMQsA7QsA4vshETAxESObAXELAe0LAeL7ATELIsAgorWCHYG/RZsAMQsjMCCitYIdgb9FmwLBCwOtCwMxCwQdCwHhCySAIKK1gh2Bv0WbAXELJPAgorWCHYG/RZMDEBNjYXFhc2FxYWBwcGBicmJicGJyYmNwMWFgcHBgYnJiY3NzY2EycBFwEGFhcWNjc3NiYnJgYHBQYWFxY2Nzc2JicmBgcBBhYXFjY3NzYmJyYGBwLrDr6ElDxngn2VCAYNuodAcSBmgn2VBvaAlggHDbyBepUIBQu1AngDb3n+rwU6N0FUCwkHOjk+VwsBsAU6OD9VCwoHOjk+Wgn79wU6Nz1WDAoFODo9VgwBZIarAgVrcAICqoBEjK0CATY4bwICqn8ErgSqgEqIqgQCq39AjLD6qE8EZ0/8P0VTAgJYRk9CVgICWEVQRVMCAldHT0JWAgJaSgLrSFACAlZITUVVAgJWSf//AJAD/AGWBgADBgALAAAADACwBC+wAdCwAS8wMf//AKED9ALCBgADBgAGAAAAGwCwCS+wBtCwBi+wAdCwAS+wCRCwBNCwBC8wMQAAAQBdAIoCZQOpAAYAEACwBS+yAgcFERI5sAIvMDEBEyMDNwEzASamlNsBAVSzAgz+fgGFFAGGAAAB//kAigICA6kABgAQALAAL7IDBwAREjmwAy8wMQETBwEjAQMBJtwC/q20AT+lA6n+fBX+egGbAYT//wA3/+8EPwWwACYABQAAAAcABQIfAAAAAf/hAG8DyQUlAAMACQCwAC+wAi8wMTcnARdaeQNweG9PBGdPAP//AGMCkwLsBakDBwPMAHICkwATALAARViwCS8bsQkfPlmwDdAwMQAAAQBuAowDUwW6ABIATLIPExQREjkAsABFWLAELxuxBB8+WbAARViwAC8bsQAfPlmwAEVYsBAvG7EQEz5ZsABFWLAILxuxCBM+WbAEELINAworWCHYG/RZMDEBFzY2MzIWBwMjEzc2JyYHAyMTAYoCNGxBcnQPUsFLBARfVj9hwYsFrXpIP6eM/gUByj1/AgJb/dEDIAD////DAAAEpwWwAiYAKgAAAAcD1f8w/mkAAf/2AAAEpQXJACYAmrIWJygREjkAsABFWLAXLxuxFx8+WbAARViwBi8bsQYPPlmyJRcGERI5sCUvsgACCitYIdgb9FmwBhCyCQEKK1gh2Bv0WbAE0LAEL7AAELAN0LAlELAP0LAPL7AlELAT0LATL7YPEx8TLxMDXbIQAgorWCHYG/RZsBcQsh0BCitYIdgb9FmyGxMdERI5sBMQsCHQsBAQsCPQMDEBIQcGByUHITcXNjc3BzczNyM3Mzc2JBcWFgcnNicmBgcHIQchByEDA/7hBxRbAqgk/AQkRWQfCqgamxKYGZMTGAEVx7TLCO8Jqlp+DhIBNhr+0BEBLQHULYFfA8rJASSxOAGReZCgxvUGBNm2AcUEAoVpoJB5AAUADQAABl8FsAAbAB8AIwAmACkAvbIKKisREjmwChCwH9CwChCwIdCwChCwJtCwChCwKNAAsABFWLAaLxuxGh8+WbAARViwFy8bsRcfPlmwAEVYsAwvG7EMDz5ZsABFWLAJLxuxCQ8+WbIFCRoREjmwBS+wAdCwAS+yDwEBXbIDAworWCHYG/RZsAUQsgcDCitYIdgb9FmwJdCwCtCwDtCwBRCwHdCwIdCwEdCwAxCwHtCwItCwEtCwARCwGdCwJ9CwFdCwCRCwJNCwFxCwKdAwMQEzByMHMwcjAyMDIQMjEyM3MzcjNzMTMxMhEzMBMzcjBTMnIwE3BwE3JwWN0hzRG9Ic0Vbv2P6xVvZWzRzMG80czFbu1gFTVvX96pUb8v5g7kKRAjATL/4HKhsDxaCXoP4SAe7+EgHuoJegAev+FQHr/N6Xl5f+fU4DAdUDRgAAAgAr/+0GWAWwACAAKQCisiYqKxESObAmELAY0ACwAEVYsBcvG7EXHz5ZsABFWLAcLxuxHBs+WbAARViwHy8bsR8bPlmwAEVYsBQvG7EUDz5ZsABFWLALLxuxCw8+WbAfELIAAQorWCHYG/RZsAsQsgYBCitYIdgb9FmwABCwD9CwENCyIhQXERI5sCIvshIBCitYIdgb9FmwHxCwHtCwHi+wFxCyKAEKK1gh2Bv0WTAxASMDBhcWFzI3BwYnJiY3EyMCIScDIxMFHgIHNxMzAzMBFzY3NicmJycGOblnAwIGSiYvEUtKe3sNZWmC/nCbXvT8AXN8v2gEeS7tLrn7SILKQiMLE6CbA4b9ohkUQQMJvhUBAqOJAmr+lAH95QWwAQNcqG8BAQf++f6tAgOsXF2OCAEA//8AJ//pCBQFsAAmADYAAAAHAFcEUAAAAAcAKgAAB30FsAAfACMAJwArAC4AMQA0AOuyMjU2ERI5sDIQsB7QsDIQsCLQsDIQsCfQsDIQsCrQsDIQsC7QsDIQsDDQALAARViwAi8bsQIfPlmwAEVYsB8vG7EfHz5ZsABFWLAbLxuxGx8+WbAARViwEC8bsRAPPlmwAEVYsA0vG7ENDz5ZsgkQAhESObAJL7AF0LAFL7IPBQFdsAHQsAUQsgcDCitYIdgb9FmwCRCyCgMKK1gh2Bv0WbAt0LAO0LAw0LAS0LAJELAl0LAp0LAh0LAV0LAHELAm0LAq0LAi0LAW0LABELAd0LAZ0LAQELAv0LAs0LAfELAy0LABELA00DAxASETMwMzByMHMwcjAyMDIQMjAyM3MycjNzMDMxMhEzMBMzcjBTM3IwUzJyMBNyMFNyMBBzcEvQEnnvupkxy2Qdsc/tntLf787e0b/xzaB7cckhXvCwEps8/9XZhG4QLZmT7i/puzDGABQUdT/SdNUAH2EA4EBwGp/legoqD92wIl/dsCJaCioAGp/lcBqf0VoqKioqL+Ary0tAIHKQIAAAIAEP/8BjYEOgAOABsAaLIAHB0REjmwEdAAsABFWLAOLxuxDhs+WbAARViwFi8bsRYbPlmwAEVYsAwvG7EMDz5ZsABFWLAPLxuxDw8+WbISAQorWCHYG/RZsA4QsgsBCitYIdgb9FmyBRILERI5shALEhESOTAxARYWBwMjEzYnJiclAyMbAjMDBRY3EzMDBgQnAzmklxUz7jUFAgqD/q6a7bvRf+1dATnIJ3XucRv+9c4EOQXMxP7AAUIsJXgFAvyKBDr7xgLW/e0CAsQCt/1bxNUEAP////T+rgUZBgAAJgBIAAAAJwPVAd0CQgEHAEMAe/9tABIAsi8hAV2yHyEBcbKfIQFdMDEAAQBO/+0EngXGACYAirIMJygREjkAsABFWLAZLxuxGR8+WbAARViwCy8bsQsPPlmyJhkLERI5sCYvsgACCitYIdgb9FmwCxCyBgEKK1gh2Bv0WbAAELAQ0LAmELAR0LAmELAW0LAWL7YPFh8WLxYDXbITAgorWCHYG/RZsBkQsh4BCitYIdgb9FmwFhCwIdCwExCwI9AwMQEhBhcWFhcWNxcGJy4CNwc3MzcjNzMSABcWFwcmJyYGByEHIQchA0T+qwkIC3ppW3MHenOZ3WUUrxmmF6gZoEIBSPBjjDFfX5TCLgFhGf6nFwFaAg9EPWNxAwIizxsCA4r5mwGNgI0BBwEWAgIezSMCAq6njYAABABCAAAGDwWwABoAHwAkACkA27IaKisREjmwGhCwHdCwGhCwI9CwGhCwKNAAsABFWLALLxuxCx8+WbAARViwAS8bsQEPPlmwCxCyJAEKK1gh2Bv0WbAK0LAKL0ARAAoQCiAKMApAClAKYApwCghdsgcDCitYIdgb9FmwBtCwBi9ACwAGEAYgBjAGQAYFXbIDAworWCHYG/RZsCfQsCcvQA8wJ0AnUCdgJ3AngCeQJwddsgABCitYIdgb9FmwChCwINCwIC+wD9CwDy+wBxCwHdCwEtCwBhCwHtCwHi+wFNCwFC+wAxCwJtCwF9AwMQEDIxMjNxc3BzczEwUyFhczBycGBzcHBwYEIwE3IQchJSUmJyUBBQclNgG/XveLsx2tFbgdsi8B/LTqJekdsQgPvh7OUf7+tgFNCf3OFAIw/fgB4y92/tUBlP4dEQEbdwId/eMDH6ACTAKgAQkBjHygAikkA6ABg38BxClM6AQ5AQP+PAE7AgEAAAEAOwAABIcFsAAZAGayEBobERI5ALAARViwGC8bsRgfPlmwAEVYsAwvG7EMDz5ZsBgQshcBCitYIdgb9FmwANCwFxCwE9CwEy+wA9CwExCyEgcKK1gh2Bv0WbAG0LASELAO0LAOL7IJBworWCHYG/RZMDEBIxYHNwcjBgYHARUhATcXMjcFNyEmJyU3IQQ01RsE0VCNN+3QAWb+7v5xGOnLZf3tUQHUDsL+5VkDmwT5VlsBtqirFP3jDwJcjgKtAraVBQHMAAEAEP/nBEcFsAAeAJGyGx8gERI5ALAARViwES8bsREfPlmwAEVYsAUvG7EFDz5ZshMRBRESObATL7AX0LAXL7IAFwFdshgBCitYIdgb9FmwGdCwCNCwCdCwFxCwFtCwC9CwCtCwExCyFAEKK1gh2Bv0WbAV0LAM0LAN0LATELAS0LAP0LAO0LAFELIaAQorWCHYG/RZsh4FERESOTAxAQcGAgQnJicTBz8CBzc3EzMHNw8CNwcHAzYSNzcERwgbxf7bsHSDYuUl5BblJeQ29yXqJekX6yXqXa7eHwgC/0zT/rWuAgIVAldW0Vd+VtJXATbRWdJaflnSWf3+BQEH7E0AAAH/5AAABKwEOgAaAFyyDRscERI5ALAARViwGS8bsRkbPlmwAEVYsAYvG7EGDz5ZsABFWLANLxuxDQ8+WbAARViwEi8bsRIPPlmyAA0ZERI5sAAvsgwBCitYIdgb9FmwD9CwABCwGNAwMQEWFhcWBwcjNzc2JicDIxMGAwcjNxIAPwIzAzqduxEJDh3tIQgFTVN57nr4RibtIzQBLNoMK+0DaCj6vG9sr85pgbco/WkCmGH+pt3LARkBWikC0QAC/+YAAAVgBbAAFgAfAHiyGCAhERI5sBgQsA3QALAARViwDC8bsQwfPlmwAEVYsAIvG7ECDz5ZsgYCDBESObAGL7IFAQorWCHYG/RZsAHQsAYQsArQsAovsg8KAV2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDElIQcjNyM3MzcjNzMTBTIEBwYEIyUHIQEFMjY3NiYnJQLb/skp9ijHJMYTxyPHfAH35gEBERL+xvX+yxMBOf79AReFsBEOc2v+y+fn58trywLIAfjK2fgBawE2Aod/boUEAQAEAML/5wU+BckAHAAqADgAPACUsgE9PhESObABELAo0LABELAs0LABELA50ACwOS+wOy+wAEVYsAovG7EKHz5ZsABFWLAkLxuxJA8+WbAKELAD0LADL7IOAwoREjmwChCyEQIKK1gh2Bv0WbADELIZAgorWCHYG/RZshwDChESObAkELAd0LAdL7AkELIuAgorWCHYG/RZsB0QsjUCCitYIdgb9FkwMQEGBicmJjc3NjYXFhYVJzYmIyIGBwcVFhYXMjY3ARYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwUnARcC7Aqhe3eNCAYNrH95jKUCMjI3TAoJAi0nMEMOAeJ+lwgGDbeHfpkIBQu6JAU8Nj5UDAoFOjc/WAn96nkDb3oEJXiQAgKrf0SNrQIElHMBOEBYRU4yLjgBPDf+bAKogUSMrgQCqoBCjaz+g0dSAgJVSk9IUAICW0nvTwRnTgACADH/6gPiBf8AGgAkAFqyFiUmERI5sBYQsBvQALAOL7AARViwAC8bsQAPPlmyCAAOERI5sAgvsgcHCitYIdgb9FmwFdCwABCyGgEKK1gh2Bv0WbAIELAb0LAOELIhAQorWCHYG/RZMDEFLgI3NwYHNzY3EzY2FxYWBwcGAAcHBhUUFwM2PwI0JyYHBwJmg7tQFgRLdhRbZlQay5WAjgsEFP76xQ8InWvHHQUCNlMaBxYHc8p/EBEFvAIVAd/I3gUEuYwst/6wZk4zLpgLAj+00yUlVQUFmSwAAAQAIwAAB+kFxQADABEAHwApAKGyICorERI5sCAQsAHQsCAQsBDQsCAQsBPQALAARViwJS8bsSUfPlmwAEVYsCgvG7EoHz5ZsABFWLAHLxuxBx8+WbAARViwIC8bsSAPPlmwAEVYsCMvG7EjDz5ZsAcQsA7QsA4vsAPQsAMvsgACCitYIdgb9FmwDhCyFQIKK1gh2Bv0WbAHELIcAgorWCHYG/RZsiIlIBESObInJSAREjkwMQEhNyEBNjYXFhYHBwYGJyYmNxcGFhcWNjc3NiYnJgYHASMBAyMTMwETMwc9/a8bAlD95BHTl46lCwcQ1JWQpAqsCEVHTWoPCghESFBpDv4Q//7Ntu79/gE1t+wBnJUCLp/HBATDmkqoxQQExJcCYGkCA21jVV9rAgJxXvugBBT77AWw++kEFwACAO0DkwTLBbAADAAUAG0AsABFWLAGLxuxBh8+WbAARViwCS8bsQkfPlmwAEVYsBMvG7ETHz5ZsgEVBhESObABL7IACQEREjmyAwEGERI5sATQsggBCRESObABELAL0LAGELENCitY2BvcWbABELAP0LANELAR0LAS0DAxAQMHAwMjEzMTEzMDIwEjAyMTIzchBD6uPDxDbl+COcOHXm3+b4ZNc02JEQGCBPb+nwIBfv6DAhz+hgF6/eQBvf5FAbtfAAIAff/pBHcEUgAWAB0AYrIUHh8REjmwFBCwGNAAsABFWLAKLxuxChs+WbAARViwAi8bsQIPPlmyGgoCERI5sBovsg8MCitYIdgb9FmwAhCyEwwKK1gh2Bv0WbIWCgIREjmwChCyFwwKK1gh2Bv0WTAxJQYnJiYCNzYSJBceAgcHIQMWFxY2NwMmBwMhEyYDrLLChM9oDg6xAQOJgsBfCgX9Ezxdj1O6dcqKmjQCCjVcXHMEApcBAoyRARSZBASO+JEx/rZnBAM3RAMrA3z+6gEgawD//wC2//IFiQWZACcDzwBJAoYAJwODAPMAAAEHA8gDCQAAABAAsABFWLAFLxuxBR8+WTAx//8Agv/yBiEFuAAnA80AjgKUACcDgwGbAAABBwPIA6EAAAAQALAARViwDS8bsQ0fPlkwMf//AIj/8gYWBagAJwPLAH4CkwAnA4MBgAAAAQcDyAOWAAAAEACwAEVYsAEvG7EBHz5ZMDH//wC1//IF1gWjACcDyQCSAo4AJwODASoAAAEHA8gDVgAAABAAsABFWLAFLxuxBR8+WTAxAAIARf/nBEgF9QAdAC0AVLIILi8REjmwCBCwHtAAsA0vsABFWLAVLxuxFQ8+WbIADRUREjmwAC+wDRCyBwEKK1gh2Bv0WbAAELIeAQorWCHYG/RZsBUQsicBCitYIdgb9FkwMQEWFzYnJiYnJgYHJzYXFhITFQICBCcuAjc3PgIXJgYHBwYXFhYXFjY3NyYmAmSkawMCCoRuRYNCDJGi0N0GDZ7++amKw1sQAhGR4pl2phUDBgQFYVd6pSANDnQEBQR7KjCVsgQDIBW5QwEE/tf+6kb+1/530gQCivGTFpHqfcYDqJQVNjlkcwMFzs5VTlsAAQAf/xsFVQWwAAcAJwCwBC+wAEVYsAYvG7EGHz5ZsAQQsAHQsAYQsgIBCitYIdgb9FkwMQUjEyEDIwEhBE3u6f2t6e0BBwQv5QXU+iwGlQAB/6f+8wT6BbAADAA1ALADL7AARViwCC8bsQgfPlmwAxCyAgEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEHITcBATchByEBA3P9lAMiIvugHAK5/j0ZBCgi/QQBmQJF/XHDogLIAsaNw/11AAEAnAJtA/gDMQADABEAsAIvsgEBCitYIdgb9FkwMQEhNyED1fzHIwM5Am3EAAABADQAAAUJBbAACAA8sgAJChESOQCwBy+wAEVYsAEvG7EBHz5ZsABFWLADLxuxAw8+WbIAAQMREjmwBxCyBgEKK1gh2Bv0WTAxAQEzASMDIzchAfcCNd39KcBu0CMBWQEtBIP6UAJBxQAAAwBJ/+gHrgRSAB4ALwBBAGKyBkJDERI5sAYQsCnQsAYQsDvQALAARViwCi8bsQoPPlmwBNCwChCwE9CwEy+wGdCyBxkKERI5shYZChESObATELI/AQorWCHYG/RZsCTQsAoQsjUBCitYIdgb9FmwLNAwMQEGAgYnJiYnBgYnLgI3NzYSNhcWFhc2NhcWFhcWByc2JycmJyYGBwcGFhYXFjY3BQYXFhYXFjY2Nzc2JicmJyYGB58Sn/SPiNUuevCFhMRgDwISn/OOi9YtePGHicksJg3pBgQFIp513SoHBkZ6RXyyF/qLBgUHZlhLl38bBgQmJVFqe7ACGJv+/JEEBLKVtJsDBI79lBeXAQWRBASykrKZAwKeiHaCATU9Jb4FAtaGJEulaAIFyqMQNjxpfAMCXq5YJDd4M2wEBcsAAf8X/kUDIgYZABYAPbIBFxgREjkAsABFWLAOLxuxDiE+WbAARViwAy8bsQMRPlmyCAEKK1gh2Bv0WbAOELITAQorWCHYG/RZMDEFBgYnIic3FjMWNxM2NhcWFwcmIyIGBwEfFcqjOU0jORWPG74V16o1ZykwKVBlDU+vvQQVvA8EsATrscYCARa4DWBTAAIAMAD+BDUD+QASACUAeLIOJicREjmwDhCwINAAsAIvsAbQsAYvsAIQsAjQsAYQsgsBCitYIdgb9FmwAhCyEAEKK1gh2Bv0WbALELAS0LACELAV0LAVL7AZ0LAZL7AVELAb0LAZELIeAQorWCHYG/RZsBUQsiMBCitYIdgb9FmwHhCwJdAwMRM2MzIWFjMyNwcGJyIuAiMGBwc2MzIWFjMyNwcGJyIuAiMGB45tjV3ZTS17ghZtfDxka2Y/hogzbYld20wteocYa4AxVqZVLoeDA5BpeRd92WsCKT0qAnzKaXkXfdlrAhxcGAJ8AAABAGIAggQUBMEAEwA3ALATL7IAAQorWCHYG/RZsATQsBMQsAfQsBMQsA/QsA8vshABCitYIdgb9FmwCNCwDxCwC9AwMQEhByc3IzchNyE3ITcXBzMHIQchA6f9+qNqcqQjARGh/nQkAfiranmxI/7hoAGZAWTiRZ3J38rrRabK3wD////VABMD2wRxAGcAIAAYAItAADmaAAcDoP85/ab//wAXABMD8wRnAGcAIgAaAItAADmaAAcDoP97/aYAAgA6AAAD4gWwAAUACQA4sgYKCxESObAGELAE0ACwAEVYsAAvG7EAHz5ZsABFWLADLxuxAw8+WbIGAAMREjmyCAADERI5MDEBMxMBIwMBARMBAiW//v4WwP4CKv7AlAE/BbD9Gv02AuQBx/4f/jcB4wD//wBpAKgCDgUKACcAEgA5ALYBBwASAMsEBwAJALADL7AV3DAxAAACAGYCfwKCBDkAAwAHACqyAAgJERI5sAXQALACL7AARViwBi8bsQYbPlmyAAgCERI5sAAvsATQMDEBIxMzEyMTMwEAmk2a55pOmgJ/Abr+RgG6AAAB/8//ZwEWAQYABwAMALAEL7AA0LAALzAxFyc2NzczBwZKe18VD8QNJJlPhXhTVsUA//8AXwAABZEGGgAmAEoAAAAHAEoCMwAAAAIASwAABEwGGgAVABkAg7IHGhsREjmwBxCwF9AAsABFWLAILxuxCCE+WbAARViwAy8bsQMbPlmwAEVYsBIvG7ESGz5ZsABFWLAYLxuxGBs+WbAARViwAC8bsQAPPlmwAEVYsBYvG7EWDz5ZsAMQsgEBCitYIdgb9FmwCBCyDgEKK1gh2Bv0WbABELAT0LAU0DAxMxMjNxc3NjYXFhYXByYjJgcHNwcjAyEjEzNPnKAgmA4j/MNOlUo5fnDUKA3XIM6dAlXuvO0DhrQBUb7SBAEmF8gzAspCAbT8egQ6AAEAXwAABKQGGQAYAG2yEhkaERI5ALAARViwEy8bsRMhPlmwAEVYsAYvG7EGGz5ZsABFWLAOLxuxDhs+WbAARViwCi8bsQoPPlmwAEVYsBcvG7EXDz5ZsBMQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WbAM0LAN0DAxASYHIgYHBzMHIwMjEyM/AjY2FxYXFwMjA59tNV14Dw7XINWd7Z2hIJ8OGu+7bW3a/+wFQhABX15atPx6A4a0AWW2wwICECD6GwACAF8AAAa1BhoAJwArAL6yEywtERI5sBMQsCnQALAARViwFi8bsRYhPlmwAEVYsAMvG7EDGz5ZsABFWLARLxuxERs+WbAARViwIC8bsSAbPlmwAEVYsCovG7EqGz5ZsABFWLAILxuxCCE+WbAARViwAC8bsQAPPlmwAEVYsCMvG7EjDz5ZsABFWLAoLxuxKA8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwFhCyHAEKK1gh2Bv0WbABELAh0LAi0LAl0LAm0DAxMxMjNzM3NjYXFhcHJiMmBgcHBTc2NhcWFhcHJicmBwc3ByMDIxMhAyEjEzNjnaEgoA0Z3648UBosLVVsDw8BYBEm+MBOlko6enTTKA3XIM6d7Zz+mZ0Eqe287QOGtGC3yQICEr4KAV5TZgFhtskCAiYXyDECAspCAbT8egOG/HoEOgABAF8AAAb5BhsAKgCrshMrLBESOQCwAEVYsAgvG7EIIT5ZsABFWLAWLxuxFiE+WbAARViwAy8bsQMbPlmwAEVYsBEvG7ERGz5ZsABFWLAiLxuxIhs+WbAARViwAC8bsQAPPlmwAEVYsBovG7EaDz5ZsABFWLAmLxuxJg8+WbADELIBAQorWCHYG/RZsAgQsg0BCitYIdgb9FmwFhCyHgEKK1gh2Bv0WbABELAk0LAl0LAo0LAp0DAxMxMjNzM3NjYXFhcHJiMmBgcHJTc2NhcWFxcBIxMmIyIGBwczByMDIxMhA2OdoSCgDRnirTJYGjchVWwPEAFnDRrvu2Zk6/8A7e2GIVt5EA7WH9Wd7Zz+mZ0DhrRfuMoEARK+CgFfUmYBZbbDAgEOI/obBUEQXFtgtPx6A4b8egABAF//7QT7BhkAJwCUshAoKRESOQCwAEVYsCIvG7EiIT5ZsABFWLARLxuxERs+WbAARViwHS8bsR0bPlmwAEVYsCYvG7EmGz5ZsABFWLAZLxuxGQ8+WbAARViwCy8bsQsPPlmwJhCyAAEKK1gh2Bv0WbALELIGAQorWCHYG/RZsAAQsA/QsBDQsCIQshUBCitYIdgb9FmwEBCwG9CwHNAwMQEjAwYXFhcWNwcGJyYmNxMjNzM3JiMiBgcDIxMjNzM3NjYXFhYXAzME27lmAwIGSSMyEUpKe3wNZa0grC9CY01nD8vtnaEgoA0Z16py22k6uQOG/aIZFEADAgq+FQECo4kCarT6Il1Y+18DhrRfuMgCAT8r/o4AAQAX/+kGnQYaAEoAwLIpS0wREjkAsABFWLA+LxuxPhs+WbAARViwRS8bsUUhPlmwAEVYsBAvG7EQGz5ZsABFWLBJLxuxSRs+WbAARViwLC8bsSwPPlmwAEVYsAovG7EKDz5ZsEkQsgEBCitYIdgb9FmwChCyBQEKK1gh2Bv0WbABELAO0LBFELIVBworWCHYG/RZsh1JLBESObA+ELIgAQorWCHYG/RZsjcsPhESObA3ELImAQorWCHYG/RZsCwQsjMBCitYIdgb9FkwMQEjAwcWFxY3BwYnJiY3EyM3Mzc2JicmBh8CFgcHNiYnIgYHBgQXFgcOAicmJjczFBYXMjY3NiQnJjc2JBcyFyY3NjYXFhYHBzMGfrlkAgNLIzIRS0p7eA9gpx+mDQpKTV1zCQQTBgTuAlJMTnMLDwEQRM0KBX7VdrHkAuZjVlp1DBH+7hb4CAcBBbFLXxMGDuuoucUVDLkDhv22L1IDAgq+FQECtJkCSbRZX2kCA4WNPKo6OQFLVgJNQVpFHVe7aJlRAwLJn1hZAklBYE4IWMOWvgIZfDmJpQIE1qxYAAAW/6n+cghFBa4ADQAaACgANwA9AEMASQBPAFYAWgBeAGIAZgBqAG4AdgB6AH4AggCGAIoAjgGhsluPkBESObBbELAM0LBbELAa0LBbELAc0LBbELAx0LBbELA80LBbELA+0LBbELBG0LBbELBK0LBbELBS0LBbELBX0LBbELBh0LBbELBj0LBbELBp0LBbELBt0LBbELBw0LBbELB60LBbELB+0LBbELCC0LBbELCE0LBbELCI0LBbELCM0ACwPS+wAEVYsEYvG7FGHz5Zsn86Ayuyd4IDK7J7egMrskl+AyuyiU4DK7KFiAMrso2EAyuyQYwDK7IKPUYREjmwCi+wA9CwAy+wDtCwDi+wChCwD9CwDy+ybw4PERI5fLBvLxiyUAsKK1gh2Bv0WbIVUG8REjmwChCyHgsKK1gh2Bv0WbADELIlCworWCHYG/RZsA8QsCnQsCkvsA4QsC7QsC4vsjQLCitYIdgb9FmwPRCwa9CwZ9CwY9CwPtCyPwwKK1gh2Bv0WbBl0LBp0LBt0LA80LBGELJHDAorWCHYG/RZsF/QsFvQsFfQsErQsEYQsGDQsFzQsFjQsEvQsA4QslELCitYIdgb9FmwDxCydgsKK1gh2Bv0WTAxAQYGJyYmNzc2NhcWFgcTExcWBwYGBxYVFAYHATYmJyYGBwcGFhcWNjcBMwMGBiMGJicXBjcyNjcBEzMHMwchNzM3MwMBEyEHIwclNyEDIzcBBzM2NzYnATchByE3IQchNyEHEzchByE3IQchNyEHATc2NzYvAgEjNzM3IzczAyM3MyUjNzM3IzczAyM3MwMPCohgYXQECAiFZV11AgxgqL8DAiY4T21g/rUHNzo/VQsPBzg7P1QLA9BjOwhpT1NnAlgEVi06CflkN28kvxQE/xTAJG03+bUyAS0Uvh4F2xQBLzNtHvvoHm1uEg1RAUgVARAV/W0VAQ8V/W4VAQ4VzBQBDxT9bhQBDhT9bxQBDRQBV1Z6EApAI2D8znAtbxVvLHCvcC1vBwBtLG4UbSxur24tbQHUZnkCAn1ecGB+AgJ4Yv64AiUBBoknOCAdWElWAwFMQFACAlRDcUBRAgJRRQFP/oVNXQFTVQJfAjkq/MkBO8pxccr+xQYfAR10qal0/uOp/LapBVVHBwNLdHR0dHR0+ThxcXFxcXEDwgEGUTYIAwL+0fx++vwV+X78fvr8FfkAAAUAXP3VB9cIcwADABwAIAAkACgATACwIS+wJS+wANCwAC+wIRCwAtCwAi+yIAIAERI5sCAvsB3QsB0vsATQsAQvsg0AAhESObANL7AU0LAUL7IHBBQREjmyGRQEERI5MDEJAwU0Njc2NjU0JiMiBgczNjYzMhYVFAcGBhUXIxUzAzMVIwMzFSMEGAO//EH8RAQPHiRKXKeVkKACywI6Kzk4XVsvysrKSwQEAgQEBlL8MfwxA8/xOjoYJ4dKgJeLfzM0QDRfPEFcTFuq/UwECp4EAAP/1wAAA58EjQADAAcACwBesgQMDRESObAEELAA0LAEELAI0ACwAEVYsAovG7EKHT5ZsABFWLAALxuxAA8+WbICAQorWCHYG/RZsgcKABESObAHL7IEAQorWCHYG/RZsAoQsggBCitYIdgb9FkwMSEhNyEDITchEyE3IQLU/QMjAv0S/ZAjAnB0/QMjAv3DATjEAQrEAAH/pwAAA+wEjQAIADiyBwkKERI5ALAARViwAi8bsQIdPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIHAgAREjkwMTMjATMTIQMnB5HqAnbt4v7/gwUiBI37cwNHXlEAAwA6/+oEYwSiAAMAFAAiAHGyGCMkERI5sBgQsALQsBgQsA3QALAARViwDS8bsQ0dPlmwAEVYsAQvG7EEDz5ZsgMNBBESOXywAy8YtGADcAMCXbQwA0ADAl2yAAEKK1gh2Bv0WbANELIYAQorWCHYG/RZsAQQsh8BCitYIdgb9FkwMQEhNyEBJiYCNzcSNzYXFhYSBwcCABMmJicmAgcXFhYXFhI3AxD+ZSMBm/7Jk9FeEQMhsaHkk85dEQQg/rmDBWximsAJAQVsYpfACwHfw/1OApUBBJ4cAR2omAUEkv78niH+7f65AvttgwQG/vzoR3GFBAYBAPAAAAL/pwAAA+wEjQADAAgAPLIFCQoREjmwBRCwAtAAsABFWLACLxuxAh0+WbAARViwAC8bsQAPPlmyBQACERI5sgcBCitYIdgb9FkwMSEhATMDJwcBIQPs+7sCdu2iBRz+rwHXBI3+ul5E/WIAAAEACgAAA98EjQAFADKyAQYHERI5ALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsAQQsgABCitYIdgb9FkwMQEhAyMTIQO8/eOo7coDCwPJ/DcEjQAAAQAtAAAEiASNABgAlbIAGRoREjkAsABFWLABLxuxAR0+WbAARViwGC8bsRgdPlmwAEVYsAwvG7EMDz5ZsgAMGBESObIJDAEREjmwCS+wBNCwBC9ADQ8EHwQvBD8ETwRfBAZdts8E3wTvBANdsgYCCitYIdgb9FmwCRCyCgIKK1gh2Bv0WbAO0LAJELAQ0LAQL7AGELAT0LAEELAW0LAWLzAxAQEhATMHJQcHJQchByM3ITcFNychNzMDMwIUAWMBEf5iyRv+6RoMATIa/tQm7Sf+0hoBKBID/tQb3NP2AnwCEf23kwMgLAKR2dmRATkPkwJJAAEAEQAABAkEogAfAGWyGyAhERI5ALAARViwFC8bsRQdPlmwAEVYsAYvG7EGDz5Zsh8GFBESObAfL7AP0LIOAgorWCHYG/RZsADQsAYQsgUBCitYIdgb9FmwCNCwFBCyGgEKK1gh2Bv0WbIXHxoREjkwMQElBgYHJQchNxc2PwIHNzM3NjYXFhYHJzYnJgYHByEDG/6YETs6Aokk/H8dCF0iDQOlHJYMGPG4rb0I7guPUmcNCgF2AeUBVJJAA8PCASWvRw4Fk2jT7wQE1rgBxgcChH5iAAABAA7/EwP/BXMAKwBvsh8sLRESOQCwAEVYsAkvG7EJHT5ZsABFWLAiLxuxIg8+WbIDIgkREjmwCRCwDNCwAxCyGQEKK1gh2Bv0WbAJELITAQorWCHYG/RZshAZExESObAiELAf0LAiELIpAQorWCHYG/RZsiUDKRESOTAxATYnJyYmNzY2NzczBxYWByc2JiciBgcGFxcWFgcGBgcHIzcmJjcXBhYzMjYCuxGPPMysBwnjsyydLZGjAusDZlVdewwRnT7IoQgJ2rQunC6kvATsBW5uYHsBOWovEjitfo60EdnfG7uKAVZXAVBDYDASPbOAjqsR4eMYx5QBXWJNAAEAFAAABDUGGAAKAEwAsABFWLADLxuxAyE+WbAARViwBi8bsQYbPlmwAEVYsAEvG7EBDz5ZsABFWLAJLxuxCQ8+WbIABgEREjmyBQYBERI5sggABRESOTAxAQMjATMDASEBASEBWFftAQ/tmgGKATX9+wFi/vUB9f4LBhj8kQGR/gH9xQAAAQAuAAAFZwWwAAsATACwAEVYsAMvG7EDHz5ZsABFWLAHLxuxBx8+WbAARViwAS8bsQEPPlmwAEVYsAovG7EKDz5ZsgADARESObIFAwEREjmyCQAFERI5MDEBAyMTMwM3ASEBASEBmXX2/PZ2AgJ4AUP9LwHl/uMCo/1dBbD9fQECgv0q/SYAAAEAFAAABEUGAAAMAFMAsABFWLAELxuxBCE+WbAARViwCC8bsQgbPlmwAEVYsAIvG7ECDz5ZsABFWLALLxuxCw8+WbIHCAIREjmwBy+yAAEKK1gh2Bv0WbIKAAcREjkwMQEjAyMBMwMzASEBASEBxXJS7QEL7JddAU8BJf5JARj+/QHZ/icGAPycAZ7+Bf3BAAEALgAABXsFsAAMAFgAsABFWLAELxuxBB8+WbAARViwCC8bsQgfPlmwAEVYsAIvG7ECDz5ZsABFWLALLxuxCw8+WbIGAgQREjmwBi+yHwYBcbIBAQorWCHYG/RZsgoBBhESOTAxASMDIxMzAzMBIQEBIQI+rmz2/PZqfQIKAT79mAGG/ugCcP2QBbD9nAJk/Tv9FQACAC7//wTwBbAAHgAnAGGyICgpERI5sCAQsB7QALAARViwAy8bsQMfPlmwAEVYsBUvG7EVDz5ZsABFWLABLxuxAQ8+WbIgAwEREjmwIC+yHgEKK1gh2Bv0WbIKHiAREjmwAxCyJwEKK1gh2Bv0WTAxAQMjEwUyFgcGBgcWFxYHBwYXFhcHByYnJjc3NicmJyUXMjY3NiYnJQGMaPb8Afbh7w8Ij5OUEQUGFAcEBCQC9SMFAwoSBgYUlP7w/4uiDg1paP7ZAlb9qgWwAdvCcKk9QKs0Nos3JD0pGwEsSixMeTAqjAnLAXdwam8EAQAAAgA7/+MEkQRUABIAIwBushkkJRESObAZELAK0ACwAEVYsAovG7EKGz5ZsABFWLAOLxuxDhs+WbAARViwAi8bsQIPPlmwAEVYsBIvG7ESDz5ZsgACChESObINCgIREjmwAhCyGAEKK1gh2Bv0WbAKELIgAQorWCHYG/RZMDElBicmJj8CNgAXFhYXNzMDEyMBBhcWFhcWNj8CJyYnJgYHAxCO46u5CQMIJwEGwW2gJ0TczBHT/jIGAgJcUmaiIAYBBBuPdZobxeIHBf/cLTn6ASoFA3Fmxf3T/fMB8jM5ZXUCA76cLkQ13AcFx8IAAAP/h/5HBFAEUAArADkARwCbsidISRESObAnELA50LAnELBE0ACwAEVYsCgvG7EoGz5ZsABFWLAWLxuxFhE+WbAoELAr0LArL7IAAworWCHYG/RZsgcWKBESObAHL7IOFgcREjmwDi+yLAEKK1gh2Bv0WbIbLA4REjmyIAcoERI5sBYQsjMBCitYIdgb9FmwBxCyPQEKK1gh2Bv0WbAoELJEAQorWCHYG/RZMDEBBxYHBwYEJyInBgcGFhcXFhYHBgYEJyYmNzY3Jjc2NjcmJjc3NjY3NxcXIQEmJwYHBhYzMjY3NiYnAwYWFzI2Nzc2JicmBgcENoMgCQQX/u26Q1IyBwYpOq2ztAcFl/7kh8/pBAfQIQYHVjtHQwUDEPW3KCpwAXX88DgeYw4JcWeFuA0JP1e/BmBQWIUNAwZgUFSIDgOgAVxeH6PHAhQyJyAiAwIGmINmomIDBY54pWYyPUllJjaYWCGWxQoBAxP73gMFO1k/SVtKMzgDAq1JYAJoThVNXwICZlQAAwEGBEcDVgaVAAMADgAZAE4AsA0vsBfQsBcvsgcJCitYIdgb9FmwAtCwAi+wANCwAC9ADw8AHwAvAD8ATwBfAG8AB12wAhCwA9AZsAMvGLANELIRCQorWCHYG/RZMDEBFwUnBzQ2MzIWFRQGIiY3FjMyNjc2JiMiBgJh9f7wpppuTUxibJhlYQNAJDoGBCQeJjcGlQHBAeZPa2hETWhiR1E3JCQxNAAAAQAKAAAEpASNAAcAP7IBCAkREjkAsABFWLAGLxuxBh0+WbAARViwBC8bsQQPPlmwAEVYsAEvG7EBDz5ZsAYQsgIBCitYIdgb9FkwMSEjEyEDIxMhA9nuqP4MqO3KA9ADyfw3BI0AAgAz//UCggMjABQAIQBnsggiIxESObAIELAc0ACwAEVYsAgvG7EIGT5ZsABFWLAPLxuxDw8+WbICDwgREjmwAi+2DwIfAi8CA12wDxCyEgIKK1gh2Bv0WbACELIVAgorWCHYG/RZsAgQshwCCitYIdgb9FkwMQEGIyImNzY2FxYWBwcGBCMnNzMWNicWNzc2JyYjIgYHBhYBsktMbXsEBrmAgYsJBRb+/NkVDQx3jkQ9OgwDAgtNNEwHBiwBNzmLc4GmAgSwkTTV3gGTAlSsAjZHGBlWVDoxQwADAAj/8gKAAyMAFAAgACwAirIXLS4REjmwFxCwEtCwFxCwJNAAsABFWLASLxuxEhk+WbAARViwCC8bsQgPPlmyKggSERI5sCovtt8q7yr/KgNdtg8qHyovKgNdtq8qvyrPKgNxshgCCitYIdgb9FmyAxgqERI5sg0qGBESObAIELIeAgorWCHYG/RZsBIQsiQCCitYIdgb9FkwMQEGBgcWBwYGJyYmNzY3Jjc2NhcWFgM2JiMiBgcGFjMyNhM2JiMiBgcGFjMyNgJ9A0BGZgQEr4Z/lgMDmlYEBKd6do/eBTMwMkwHBzYuL08vBSsmKkEHBi0mKkACSTlYKD5xcH8CAndkfE86ZGt+AgJ0/kUoLzgrKDI0AXwnKjEqJysyAAABACMAAAK7AxUABgAyALAARViwBS8bsQUZPlmwAEVYsAIvG7ECDz5ZsAUQsgQCCitYIdgb9FmyAAQFERI5MDEBASMBITchAqf+Sc0BuP5fGwJmAp/9YQJ/lgACABb/8gJzAyQAFAAhAFuyHSIjERI5sB0QsAfQALAARViwAC8bsQAZPlmwAEVYsA0vG7ENDz5ZsAAQsgICCitYIdgb9FmyBw0AERI5sAcvshUCCitYIdgb9FmwDRCyHAIKK1gh2Bv0WTAxAQcnJgYHNjMyFgcGBicmJjc3NjY3AyIHBwYXFjMyNjc2JgJEDgd0pTBQXWZ6BAS2g4iUCgcZ/smsTToFAwMKVjNSBgczAySbAQNba0WMc3ugAgKxjUXB4An+WD4kGxpaTjUyOwAAAQAK//ICkQMVABwAarIHHR4REjkAsABFWLACLxuxAhk+WbAARViwDS8bsQ0PPlmwAhCyAwIKK1gh2Bv0WbIHAg0REjmwBy+yGggKK1gh2Bv0WbIFBxoREjmwDRCyFAIKK1gh2Bv0WbIRFBoREjmyHBoUERI5MDETEyEHJQc2NzYWBwYGJyYmJxcWFjc2Njc2JiciBzh4AeEb/rk3OENtgwQEuIJ4mwSwBDMvPEgIBzY1QTUBgwGSlgGXGQIChHR+ngICgmYBLyQBAUk5NT8BJwAAAv/xAAACegMWAAoADgBJALAARViwCS8bsQkZPlmwAEVYsAQvG7EEDz5ZsgEJBBESObABL7ICAgorWCHYG/RZsAbQsAEQsAvQsggLBhESObINCQQREjkwMQE3ByMHIzchNwE3ATM3BwIWZBxcHLge/qUNAbC6/lOqMxIBOQGXo6OFAewC/iT1GAAAAf/0//MChQMkACQAb7ICJSYREjkAsABFWLANLxuxDRk+WbAARViwGC8bsRgPPlmyARgNERI5fLABLxiwDRCyBwIKK1gh2Bv0WbIJAQcREjmwARCyIwIKK1gh2Bv0WbITIwEREjmwGBCyHgIKK1gh2Bv0WbIbHiMREjkwMRMzNjY3NicnJgcHNjYXFhYHBgYHFgcGBicmJjUXFhcyNjc2JyPmUz1NBwlKF10cugmmfYGZBQNJUnYEA7yLfZmxBGo2UwcNeFwB0gI4LkMNAgJMAWl6AgN3YjtXJimBb4ICAoNtAVkCOC9ZBQAAAf/jAAACfgMkABcAWbIIGBkREjkAsABFWLAPLxuxDxk+WbAARViwAC8bsQAPPlmyFgIKK1gh2Bv0WbICFgAREjmyAw8AERI5sA8QsggCCitYIdgb9FmyDAAPERI5shUADxESOTAxISE3ATY3NiYnIgYHBzY2FxYWBwYPAgUCNv2tGAFWYQwHKyk6Qwy2Cq+Cf5IFBZZPnQFfhwEZU0MpLwFHNAF5mAICg2h+dzxuAgABAG0AAAINAxMABgAxALAARViwBS8bsQUZPlmwAEVYsAEvG7EBDz5ZsAUQsATQsAQvsgMCCitYIdgb9FkwMSEjEwc3JTMBi7VjzBsBbhcCNi+ZcwACABf/8AKMAyUADQAZAEayERobERI5sBEQsAfQALAARViwBy8bsQcZPlmwAEVYsAAvG7EADz5ZsAcQshECCitYIdgb9FmwABCyFwIKK1gh2Bv0WTAxBSYmNzc2NhcWFgcHBgYTNzQnJg8CFBcWNwElhIoLEBOyiISJCw8SsR0CVnYXFgJZdhcMBLCWj6iwBASylo+msAHzN28DA7WwMG8DB8MAAAH/2QAABAcEjQAMAEuyAA0OERI5ALAARViwCC8bsQgdPlmwAEVYsAMvG7EDDz5ZsgEBCitYIdgb9FmyBQEDERI5sAgQsgoBCitYIdgb9FmyBwoIERI5MDEBASEHITcBAzchByETAnv+swJWI/x4HQGC7RkDYyP9w9UCRP6AxKQBtwGmjMT+kAADAEMAAAU3BI4AEQAXAB0AbLIQHh8REjmwEBCwFdCwEBCwG9AAsABFWLAQLxuxEB0+WbAARViwBy8bsQcPPlmyDxAHERI5sA8vsADQsgYHEBESObAGL7AJ0LIUAQorWCHYG/RZsA8QshUBCitYIdgb9FmwGtCwFBCwG9AwMQEWFgcGAAcHIzcmJjc2JDc3FwEGFxMGBgU2JwM2NgN+0OkPEP7K+RjuGdHoDxABOPcb7f2kH/Jqj54C7xvta4ujBBMU9bzR/wAQbW4T+sHP/A55Af2v7yICLhCTZ+ch/dIPlwAAAQBwAAAFUQSNABkAXLIYGhsREjkAsABFWLAELxuxBB0+WbAARViwEC8bsRAdPlmwAEVYsBgvG7EYHT5ZsABFWLAKLxuxCg8+WbIXBAoREjmwFy+wANCwFxCyDAEKK1gh2Bv0WbAJ0DAxATY2NxMzAwYABwMjEyYCNxMzAwYHBhYXEzMDAXqZHDPuNSn+3eQ37jjLxB4y7TIIAQNRVH7tAdoauaoBNv7F/P7bGP7nARkdATnvAS/+0Dk8aYoYArAAAQAAAAAEeAShACQAWbIAJSYREjkAsABFWLAaLxuxGh0+WbAARViwEC8bsRAPPlmwAEVYsCMvG7EjDz5ZsiEBCitYIdgb9FmwANCwGhCyCAEKK1gh2Bv0WbAAELAP0LAhELAS0DAxJTY2NzYnJiYnJgYGBxcWFwchNzcmNzc+AhceAgcHAgc3ByECTnyVGQwGDG9gaaBUAwEMkh7+PCSpgRcFEqX+k43UZw0FI+C0I/48xyXIsWg8YmsDA23QtyTDOMnEArf6K5LufwQDg+iPK/7nnATEAAEAkwKHAzwDMQADABEAsAIvsgEBCitYIdgb9FkwMQEhNyEDHv11HgKLAoeqAAABAIwAAAYeBI0ADABZALAARViwAS8bsQEdPlmwAEVYsAgvG7EIHT5ZsABFWLALLxuxCx0+WbAARViwAy8bsQMPPlmwAEVYsAYvG7EGDz5ZsgABAxESObIFAQMREjmyCgEDERI5MDEBATMBIwMBIwMzEwEzA/IBQOz+JOVA/pzmR+AUAWfRAS4DX/tzAz78wgSN/KEDXwABAHAAAAS4BI4ACAAxALAARViwAy8bsQMdPlmwAEVYsAcvG7EHHT5ZsABFWLAFLxuxBQ8+WbIBAwUREjkwMQEXNwEhASMDNwHkBSMBqAEE/Ynw4eoBOEpTA0z7cwSNAQABADn/6wRqBI0AEQA8sg4SExESOQCwAEVYsAAvG7EAHT5ZsABFWLAILxuxCB0+WbAARViwBC8bsQQPPlmyDQEKK1gh2Bv0WTAxAQMGBCcmJjcTMwMGFhcWNjcTBGqAG/7l0sngFIHsggtbZ2uOEoMEjf0BwuEEBOW1AwD8/2VyAwRvaQMHAAEAYgAABFoEjQAHAC4AsABFWLAGLxuxBh0+WbAARViwAi8bsQIPPlmwBhCyAAEKK1gh2Bv0WbAE0DAxASEDIxMhNyEEN/6KqO2o/o4jA9UDyfw3A8nEAAABAA7/7QP/BJ8AJgBtshEnKBESOQCwAEVYsAkvG7EJHT5ZsABFWLAcLxuxHA8+WbICHAkREjmyDAkcERI5sgwMAV2wCRCyEAEKK1gh2Bv0WbACELIVAQorWCHYG/RZsiAJHBESObIDIAFdsBwQsiQBCitYIdgb9FkwMQE2LwImNzYkFxYWByc2JiciBgcGBBcWBw4CJyYnJjcXBhYzMjYCuxGPdkf9DQkBC7+84ALrA2dUXXsMEQE9RsQKB3/YgJ5ypgTsBW1uYXsBOWovJBpk1Ju8AgXCogFWVgFQQ2FdJWfGbJdPAwJHaMgBXWJNAAACAAoAAAQWBI0ADQAVAF6yABYXERI5sA/QALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsABFWLAMLxuxDA8+WbIPBAIREjmwDy+yAAEKK1gh2Bv0WbIKAA8REjmwBBCyFQEKK1gh2Bv0WTAxASMDIxMFFhYHBgUTFSMBFzY2NzYnJwIf3krtygGsxdEKD/8Aufz+qMNohgwWutwBqf5XBI0BBbeb8GH+KQ0CawICYFWfCQEAAAIAN/8wBGAEowATACIARrIDIyQREjmwAxCwH9AAsABFWLANLxuxDR0+WbAARViwBS8bsQUPPlmwDRCyFwEKK1gh2Bv0WbAFELIeAQorWCHYG/RZMDElFwcnBiMmJgI3NxIAFxYWEgcHAgMmJicmAgcVFhYXFjY3NgMqr6XdOiiRz14RAyABSe2Tz10RBy6yB2ximb8KBWxigLQfFkyefsgHApUBBp4bAREBSwYEkv75oTr+vwICb4AEBv785khxhgQFt6p3AAIACgAABDYEjQAKABMATbIEFBUREjmwBBCwDNAAsABFWLADLxuxAx0+WbAARViwAS8bsQEPPlmyCwEDERI5sAsvsgABCitYIdgb9FmwAxCyEgEKK1gh2Bv0WTAxAQMjEwUWFgcGBCMnFzI2NzYmJycBPkftygHIvN4LCv7t19fda4wMC1xY+AGZ/mcEjQEE0KWvzMUBYFVSYQQBAAIAOv/qBGMEoQAQACAARrIeISIREjmwHhCwCNAAsABFWLAJLxuxCR0+WbAARViwAC8bsQAPPlmwCRCyFgEKK1gh2Bv0WbAAELIdAQorWCHYG/RZMDEFJiYCNzc2EjYXFhYSBwcCABM2JyYmJyYCBxcWFhcWNjcB+5PRXREJGKX8mJPOXREDIP65fgYDBWtimsAJAQVtYYe4GRAElQEDnUOlAQWLBASS/vucHP7p/rcCfj1AboIEBv765UhxhQQFzr8AAQAKAAAEqASNAAkARQCwAEVYsAUvG7EFHT5ZsABFWLAILxuxCB0+WbAARViwAC8bsQAPPlmwAEVYsAMvG7EDDz5ZsgIFABESObIHBQAREjkwMSEjAQMjEzMBEzMD3uT+iYztyuUBd4zsAyX82wSN/NoDJgABAAoAAAXIBI0ADgBgsgEPEBESOQCwAEVYsAAvG7EAHT5ZsABFWLACLxuxAh0+WbAARViwBC8bsQQPPlmwAEVYsAgvG7EIDz5ZsABFWLAMLxuxDA8+WbIBAAQREjmyBwAEERI5sgoABBESOTAxARMBIQMjExMBIwsCIxMCA7QB1QE8y+w5dP4dpb5NNezKBI38twNJ+3MBSAIX/KEDfP2y/tIEjQAAAQAKAAADNASNAAUAKACwAEVYsAQvG7EEHT5ZsABFWLACLxuxAg8+WbIAAQorWCHYG/RZMDElIQchEzMBGQIbI/z5yu3CwgSNAAABAAoAAASdBI0ADABLALAARViwBC8bsQQdPlmwAEVYsAgvG7EIHT5ZsABFWLACLxuxAg8+WbAARViwCy8bsQsPPlmyBgIEERI5sAYQsAHQsgoBBhESOTAxAQcDIxMzAzcBIQEBIQHVpDrtyu1XfAGAATf96gFQ/vYB2Yv+sgSN/gt+AXf97P2HAAAB//L/6wOwBI0ADgAvsgUPEBESOQCwAEVYsAAvG7EAHT5ZsABFWLAFLxuxBQ8+WbILAQorWCHYG/RZMDEBMwMGBicmJjcXBhcWNjcCw+2GGfettcYG7QmfSmgPBI384LPPBATDqgGrBAJjWwABABgAAAHPBI0AAwAdALAARViwAi8bsQIdPlmwAEVYsAAvG7EADz5ZMDEhIxMzAQXty+wEjQABAAoAAASpBI0ACwCGALAARViwBi8bsQYdPlmwAEVYsAovG7EKHT5ZsABFWLAALxuxAA8+WbAARViwBC8bsQQPPlmyCQYAERI5sAkvtK8JvwkCXbI/CQFxss8JAXGyPwkBcrL/CQFxsg8JAXK0bwl/CQJxtN8J7wkCXbJfCQFytBwJLAkCXbICAQorWCHYG/RZMDEhIxMhAyMTMwMhEzMD3+1S/gZT7crtVgH7Vu0B2/4lBI3+EQHvAAABAD//8ARRBKMAIABksgIhIhESOQCwAEVYsAsvG7ELHT5ZsABFWLADLxuxAw8+WbIfCwMREjmwHy+wCxCyEQEKK1gh2Bv0WbIPHxEREjmyDA8BXbADELIaAQorWCHYG/RZsB8Qsh0BCitYIdgb9FkwMSUGBQcuAjc3EgAXFhYXJyYnJgYHBwYXFhYXFjc3IzchA+d//to6ldRgEQYfAUHtwd0Q5BK9hrUbDAcFCHRmh1oo8yAB3ZKUDQECkP+eNwERATwGBMm4AbwGBbuqWkFBbnsDAjrIsQABAAoAAAPmBI0ACQBFALAARViwBC8bsQQdPlmwAEVYsAIvG7ECDz5ZsgkEAhESObAJL7JKCQFdsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASEDIxMhByEDIQMs/h5T7coDEiP93DQB5AHb/iUEjcT+1QAAAQAKAAAD+QSNAAsAUwCwAEVYsAYvG7EGHT5ZsABFWLAELxuxBA8+WbILBgQREjmwCy+ySQsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASEDIQchEyEHIQMhAzX+GjYCOyP82coDJSP9yS8B6AH4/srCBI3E/vIAAgAKAAAEGgSNAAoAFgBDsg4XGBESObAOELAC0ACwAEVYsAIvG7ECHT5ZsABFWLAALxuxAA8+WbINAQorWCHYG/RZsAIQshYBCitYIdgb9FkwMTMTBR4CBwcGACETAxcyNjc3NicmJicKygFil+FsEAUd/qH+9x+GcKnPGAYIBgp5bgSNAQSP/Zks/f7GA8n8+QHBtSxHQGhyBAAAAQA5/+wESQSjABwATrITHR4REjkAsABFWLALLxuxCx0+WbAARViwAy8bsQMPPlmyAAsDERI5sg4LAxESObALELISAQorWCHYG/RZsAMQshoBCitYIdgb9FkwMQEGBCcuAjc3EgAXFhYXJyYmJyYGBwYXFBYXFjcD/Bz+39SQyVkSBiABQenC4grrA2BrhbAaEAFkYeM4AYW93AQCkP+fNAEOAUEGBN29AWdwBAXAtIk/cH8ECNoAAAMACgAABAAEjQAOABYAHgCsshgfIBESObAYELAC0LAYELAW0ACwAEVYsAEvG7EBHT5ZsABFWLAALxuxAA8+WbIYAAEREjmwGC+yvxgBcrSvGL8YAl20bxh/GAJxsv8YAXGyDxgBcrSPGJ8YAnKyXxgBcrLPGAFxsj8YAXG0HxgvGAJdsnkYAV2ySRgBXbIWAQorWCHYG/RZsggWGBESObAAELIRAQorWCHYG/RZsAEQsh4BCitYIdgb9FkwMTMTBQQXFgcGBxYWBwYGIwMDFzY2NzYnJxc2Njc2JycKygGUASZUHgYKz0tUBAj33pA2z2V6DBam18FfcgwUss0EjQEIpDlTrFcaiFmksgH7/scBA1JJkgmrAQNPRYgFAQAC/5sAAAQFBI0ABwAKAEYAsABFWLAELxuxBB0+WbAARViwAi8bsQIPPlmwAEVYsAYvG7EGDz5ZsgkEAhESObAJL7IAAQorWCHYG/RZsgoEAhESOTAxJSEHIwEzEyMBIQMC7v4uiPkCk9r95v5iAUhX+fkEjftzAbIBuAAAAQDrBGkCNgYtAAcAFgCwAEVYsAAvG7EAIT5ZsATQsAQvMDEBFwYHByM3NgG1gVEWFs4RHwYtV312enfXAAACAQQE0QN6Bn4ACwAPAFoAsAMvsAbQsAYvQAsPBh8GLwY/Bk8GBV2wANCwAC+wAxCyCQYKK1gh2Bv0WbAGELAP0LAPL7AM0LAML0APDwwfDC8MPwxPDF8MbwwHXbAPELAO0BmwDi8YMDEBBgYnJiYnFwYXFjclMxcjA3oItYyLoAKqBICGG/7Rok5tBbFoeAMDeGQCbwICc83AAAACANwE5wUtBpAABgAKAFsAsAMvsAXQsAUvsADQsAAvQAkPAB8ALwA/AARdsAMQsALQGbACLxiyBAMAERI5sAbQGbAGLxiwAxCwCdCwCS+wB9CwBy+2DwcfBy8HA12wCRCwCtAZsAovGDAxATMXIycHIwEXASMCIp3wuYKy5gNp6P8AqgXh+o2NAakB/vYAAgATBNoDqAaDAAYACgBbALADL7AE0BmwBC8YsADQGbAALxiwAxCwAdCwAS+wBtCwBi9ACQ8GHwYvBj8GBF2yAgMGERI5sAMQsAjQsAgvsAfQGbAHLxiwCBCwCtCwCi+2DwofCi8KA10wMQEjJwcjJTMFIwMzA6i7gbLlAUad/oeKoscE2o2N+lwBCwACANgE5wSUBssABgAVAGgAsAMvsATQGbAELxiwANAZsAAvGLADELAB0LABL7ADELAF0LAFL0AJDwUfBS8FPwUEXbICAwUREjmwAxCwB9CwBy+wDtCwDi+yPw4BXbIIBw4REjmyDwYKK1gh2Bv0WbIUCAcREjkwMQEjJwcnJTMXNzc2NzYnJzcWFgcGBwcDqqeRydEBObaoCyJaBwdNKg93gQEDiAkE56GhAfl0fQMKMy8GAmoDU0hrGT0AAAIA1wTnA6kG0AAGABoAjgCwAy+wBNAZsAQvGLAA0BmwAC8YsAMQsAHQsAEvsAMQsAXQsAUvQAkPBR8FLwU/BQRdsgIDBRESObAK0LAKL0AJPwpPCl8KbwoEXbAO0LAOL0ANDw4fDi8OPw5PDl8OBl2wChCwENCwEC+wDhCyFAYKK1gh2Bv0WbAKELIYBgorWCHYG/RZsBQQsBrQMDEBIycHIyUzNwYGIyImJgcGByc2NjMyFhY3NjcDqaWVxdMBS4/mCVU7I24kEjMgWgpTPCFzIRI5HATnjY3t30RbPQkCA0MYSFo+CAEERQAAAgEEBNADegZ+AAwAEABaALADL7AG0LAGL0ALDwYfBi8GPwZPBgVdsADQsAAvsAMQsgkGCitYIdgb9FmwBhCwD9CwDy+wDdCwDS9ADw8NHw0vDT8NTw1fDW8NB12wDxCwENAZsBAvGDAxAQYGJyYmJxcGFxY2NycXByMDegi1jIugAqoEgDpZDkDDxo8FsGh4AwN4ZAJvAgE3O84BvgACAQUE0gNuBwgADAAbAF0AsAMvsAbQsAYvQAsPBh8GLwY/Bk8GBV2wANCwAC+wAxCyCQYKK1gh2Bv0WbAGELAb0LAbL7AU0LAUL7Q/FE8UAl2yDhsUERI5shUMCitYIdgb9FmyGg4bERI5MDEBBgYnJiYnFwYXFjY3Jzc3Njc2Jyc3FxYVBgcHA24JsYiDogKmBH46WA7QCjBXCQlfKg1I2AOXCQWxa3QCAnZmAmwCATU6GXYCBjArBAFhBBN4XRg8AAIBBATNA4IG2wALACAAdgCwAy+wBtCwBi9ACw8GHwYvBj8GTwYFXbAA0LAAL7ADELIJBgorWCHYG/RZsAAQsBDQsBAvsBPQsBMvQAsPEx8TLxM/E08TBV2wEBCwFdCwFS+wExCyGQgKK1gh2Bv0WbAQELIeCAorWCHYG/RZsBkQsCDQMDEBBgYnJiYnFwYXFjcTBgcGByImBwYHJzY2MzIWFxY3NjcDcQiyi4WhAqgEfYUbvQosLkYoiSg7H2YJXkYWJy9GKDwfBbBreAICe2YCbgICcgERVDIzAk4DA1QbUGsNGicDA1MAAAH/pAAABIAEjQALAFMAsABFWLABLxuxAR0+WbAARViwCi8bsQodPlmwAEVYsAQvG7EEDz5ZsABFWLAHLxuxBw8+WbIAAQQREjmyBgEEERI5sgMABhESObIJBgAREjkwMQEBIQEBIQMBIQEBIQIrATEBJP4lARX+97D+x/7cAeb+/AEEAvsBkv2y/cEBmP5oAlcCNgABAG0AAASABI0ACAAxALAARViwAS8bsQEdPlmwAEVYsAcvG7EHHT5ZsABFWLAELxuxBA8+WbIAAQQREjkwMQEBIQEDIxMBMwIMAWIBEv3cROxL/vb3AnwCEfz6/nkBrgLfAAEAOf/sBEkEowAeAISyHB8gERI5ALAARViwCy8bsQsdPlmwAEVYsAMvG7EDDz5ZsgALAxESObIOCwMREjmwCxCyEgEKK1gh2Bv0WbIVCwMREjl8sBUvGLLwFQFdsgAVAXG0MBVAFQJdtIAVkBUCcbRgFXAVAl2yFgEKK1gh2Bv0WbADELIcAQorWCHYG/RZMDEBBgQnLgI3NxIAFxYWFycmJicmAyEHIQYXFhYXFjcD/Bz+39SQyVkSBiABQerB4grrA2Br7VwBfSL+kgYFB2VX4zkBhb3cBAKQ/580AQ4BQQYE3b0BZ3AEB/7HxDg2W2gDCNoAAAEAYv/rBQ0EjQAXAGuyBRgZERI5ALAARViwAi8bsQIdPlmwAEVYsBYvG7EWDz5ZsABFWLAOLxuxDg8+WbACELIAAQorWCHYG/RZsATQsAXQsggCFhESObAIL7AOELIPBworWCHYG/RZsAgQshMBCitYIdgb9FkwMQEhNyEHIQc2FxYWBwYEBzc2NzYnJgcDIwGy/rAjA5Ij/qwyhIjA0wwO/vbyFPAZGs5nn2PtA8nExO8pAwLVubzHAr0FwcoGAyf95gABAFUAAARiBbAABgAyALAARViwBS8bsQUfPlmwAEVYsAEvG7EBDz5ZsAUQsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITchBEj9B/oC9/1eIgOWBRz65ATtwwACACr+UARMBFEAHAAqAHyyBCssERI5sAQQsCfQALAARViwBy8bsQcbPlmwAEVYsAQvG7EEGz5ZsABFWLAMLxuxDBE+WbAARViwFi8bsRYPPlmyBgcWERI5sAwQshEBCitYIdgb9FmyFAcWERI5sBYQsiIBCitYIdgb9FmwBBCyJwEKK1gh2Bv0WTAxEzYSNhcWFzczAwYAJyYnNxYXBBM3BicuAicmNxcGFxYWFxY3EyYnJgYHRBOU14G2WirPqiL+1+Sum0JzjAEFSgd+oGWdXAYEBu4GBAViVYpkVTSGfqwXAh+jAQyDAwSDc/wZ8f7uBARZsk0CBwE8G3wEAWjDdj89ATU7Z30DBYUB23cEA8amAAAB/wf+RgE/AM0ADAAsALANL7AARViwBC8bsQQRPlmyCQEKK1gh2Bv0WbANELIMBQorWCHYG/RZMDElAwYGJyYnNxYzMjcTAT8qGNCiREAiOSZ+ICvN/vS0xwICEsUPrwEMAAH/sv6aAP4AtQADABIAsAQvsALQsAIvsAHQsAEvMDETIxMzoO5e7v6aAhv////WAAAEJwYjAiYEqQAAAQYBaEseABMAsABFWLAHLxuxBx0+WbAP3DAxAAAC/8H//wbEBI0AGAAhAGuyBSIjERI5sAUQsBrQALAARViwEy8bsRMdPlmwAEVYsAMvG7EDDz5ZsABFWLALLxuxCw8+WbATELIFAQorWCHYG/RZshYTAxESObAWL7ADELIbAQorWCHYG/RZsBYQsiEBCitYIdgb9FkwMQEGBCMhEyEDBwIGJyM3NzY2NzcTIQMXFhYlAxc2Njc2JicGuQv+7dr+Hqn+sEQZO+e6PhgiZnwfD2gDJEbHxub9a0HcZo8NC1hZAYev2APJ/rZ//uztAcwBBqTAXAH6/mwBAcoI/o4BAmtaTFoFAAACAAoAAAbHBI0AEgAbAIGyAhwdERI5sAIQsBTQALAARViwAi8bsQIdPlmwAEVYsBEvG7ERHT5ZsABFWLALLxuxCw8+WbAARViwDy8bsQ8PPlmyAQILERI5sAEvsAIQsRsKK1jYG9xZsgUBCitYIdgb9FmwARCyDQEKK1gh2Bv0WbALELIVAQorWCHYG/RZMDEBIRMzAxcWFgcGBCMhEyEDIxMzAQMXNjY3NiYnAWsB7FbuR8nF5QsL/u3Y/h1T/hRT7crtAnJB3GiNDQtYWQKeAe/+bAEByqav2AHb/iUEjf2o/o4BAmtaTFoFAAEAYgAABQ4EjQAWAFqyBRcYERI5ALAARViwAi8bsQIdPlmwAEVYsAwvG7EMDz5ZsABFWLAVLxuxFQ8+WbACELIAAQorWCHYG/RZsATQsAXQsggCDBESObAIL7ISAQorWCHYG/RZMDEBITchByEHNhcWFgcDIxM2JyYnJgcDIwGy/rAjA5Ij/qwygYrJzBQ47TkGBRObbJtj7QPJxMTuJwIE4ML+pgFbNCl/BgMm/eYAAQAK/p8EowSNAAsAT7IDDA0REjkAsAIvsABFWLAGLxuxBh0+WbAARViwCi8bsQodPlmwAEVYsAAvG7EADz5ZsABFWLAELxuxBA8+WbIIAQorWCHYG/RZsAnQMDEhIQMjEyETMwMhEzMD2P6WPu0+/onK7agB9Kju/p8BYQSN/DYDygAAAgAL//wD9wSNAA0AFgBeshQXGBESObAUELAJ0ACwAEVYsAwvG7EMHT5ZsABFWLALLxuxCw8+WbAMELIAAQorWCHYG/RZsgMMCxESObADL7ALELIOAQorWCHYG/RZsAMQshQBCitYIdgb9FkwMQEhBxcWFgcOAiclEyEBNjY3NCYnJwMD1f3JJ/nAxRUQkueF/jnLAyH+GWh8Amlc3D4Dy+ABBcOid7FcAwEEjfw1AmZXTFcCAf6cAAL/g/6vBMAEjQAOABQAVrISFRYREjmwEhCwCdAAsABFWLAELxuxBB0+WbAARViwCi8bsQoPPlmyAAEKK1gh2Bv0WbEMCitY2BvcWbAI0LIPBAoREjmwBBCyEQEKK1gh2Bv0WTAxNzY2NxMhAzMDIxMhAyMTBSUTIQMCMW+DJFIDJ6mSXO07/RA77V0BZwHjhv6uQEHAZf3FAab8Nv3sAVH+rwITAwQDBv64/twAAAH/qQAABjsEjQAVAJ6yARYXERI5ALAARViwES8bsREdPlmwAEVYsA4vG7EOHT5ZsABFWLAKLxuxCh0+WbAARViwBi8bsQYPPlmwAEVYsAMvG7EDDz5ZsABFWLAVLxuxFQ8+WbIMAw4REjmwDC+yPwwBcbJfDAFyss8MAXG0rwy/DAJdtI8MnwwCcrAP0LIBAQorWCHYG/RZsATQsggPBBESObITAQ8REjkwMQEjAyMTIwEhAQMhEzMTMwMzASEBEyEDymZR7VJV/rr+zAHDywEJnFdT7lRJAUQBJP5h5v7uAdX+KwHV/isCYQIs/iAB4P4gAeD9w/2wAAABAAz/7gPvBKAAJgBBsiAnKBESOQCwAC+wAEVYsBgvG7EYDz5ZsgkAGBESObIMABgREjmyHwEKK1gh2Bv0WbAAELIkBworWCHYG/RZMDEBMjY3NiYiBgcHNjYXFhYHBgcWFgcOAicmJjczFhYzFjY3NicnNwIFZoAKCmWwag/uDP3Cw94ICulRWgQFfOyLud4E6gJcVmqQDBXchyACqlNNRExFPgGYsgIDpo21ZSOGWWqdVwICuZxHTANZT6ABAbAAAAEACwAABK4EjQAJAEyyAAoLERI5ALAARViwAC8bsQAdPlmwAEVYsAgvG7EIHT5ZsABFWLAFLxuxBQ8+WbAARViwAy8bsQMPPlmyBAMAERI5sgkFCBESOTAxATMDIxMBIxMzAwPL48vqj/1m48vqjwSN+3MDMfzPBI380gABAAoAAARtBI0ADAB3sgANDhESOQCwAEVYsAgvG7EIHT5ZsABFWLAFLxuxBR0+WbAARViwAi8bsQIPPlmwAEVYsAwvG7EMDz5ZsgYCBRESObAGL7I/BgFxsl8GAXKyzwYBcbSvBr8GAl20jwafBgJysgEBCitYIdgb9FmyCgEGERI5MDEBIwMjEzMDMwEhAQEhAbZtUu3K7VRXAYMBJv4QATP+6QHV/isEjf4gAeD9uf26AAAB/8EAAASXBI0AEQA/sgQSExESOQCwAEVYsAAvG7EAHT5ZsABFWLABLxuxAQ8+WbAARViwCS8bsQkPPlmwABCyAwEKK1gh2Bv0WTAxAQMjEyEDBwIGByM3NzY2NzcTBJfK7qn+sUYZPOK0RxgkZ3scD2kEjftzA8n+tn3+7e0CzAMKqbhZAfoAAQBy/+gEggSOAA8ATrIBEBEREjkAsAcvsABFWLAPLxuxDx0+WbAARViwCC8bsQgPPlmyAQ8IERI5sgIPCBESObACL7AIELEKCitY2BvcWbIODwgREjmwDi8wMQEXASEBBgYjJzcXNjY3AzcCEAcBXAEP/d1csnRrEVI6TiP69QJKOAJ7/HSjdgXEBgE6KwN8AQABAAr+rwS4BI0ACwBCsgkMDRESOQCwAy+wAEVYsAcvG7EHHT5ZsABFWLAKLxuxCh0+WbAARViwBS8bsQUPPlmyCAEKK1gh2Bv0WbAA0DAxJTMDIxMhEzMDIRMzA/u9cNg7/F/K7agB9Kjvw/3sAVEEjfw2A8oAAQBdAAAEZASNABIARrIOExQREjkAsABFWLAILxuxCB0+WbAARViwES8bsREdPlmwAEVYsAAvG7EADz5Zsg4IABESObAOL7IEAQorWCHYG/RZMDEhIxMGJyYmNxMzAwYXFhcWNxMzA5ruUn9/0NMVOO46BgYTm2+YZO0BqycCAuDEAWH+njQpgAMDJQIgAAEACgAABkMEjQALAEGyBwwNERI5ALAARViwAy8bsQMdPlmwAEVYsAEvG7EBDz5ZsgQBCitYIdgb9FmwAxCwBtCwBBCwCNCwBhCwCtAwMSEhEzMDIRMzAyETMwV4+pLK7agBU6juqQFUqO4Ejfw2A8r8NgPKAAABAAr+rwZYBI0ADwBBsgsQERESOQCwAy+wAEVYsAcvG7EHHT5ZsABFWLAELxuxBA8+WbIAAQorWCHYG/RZsA3QsAnQsAcQsArQsA7QMDElMwMjEyETMwMhEzMDIRMzBZu9cNg7+r/K7agBU6juqQFUqO/D/ewBUQSN/DYDyvw2A8oAAgBK//sE4wSNAAwAFQBesgsWFxESObALELAU0ACwAEVYsAovG7EKHT5ZsABFWLAHLxuxBw8+WbIACgcREjmwAC+wChCyCAEKK1gh2Bv0WbAHELINAQorWCHYG/RZsAAQshMBCitYIdgb9FkwMQEWFgcGBCclEyE3IQMTNjY3NiYnJwMDXrvKFhj+1cz+OKj+rCMCPkaXZX8CAm1Y20EC+AXKorPZBAEDycT+bP3JAmtZTlwCAf6O//8AC//7BeEEjQAmBBEAAAAHA+QEEgAAAAIAC//7A/cEjQAKABMAT7IRFBUREjmwERCwANAAsABFWLAILxuxCB0+WbAARViwBy8bsQcPPlmwCBCxEQorWNgb3FmyAAEKK1gh2Bv0WbAHELILAQorWCHYG/RZMDEBFhYHBgQnJRMzAxM2Njc2JicnAwJyu8oWGP7Vy/44y+pHl2OCAgJsWttBAvgFyaOz2QQBBI3+bP3JAmtZTV0CAf6OAAEAE//qBB4EoQAdAIGyCx4fERI5ALAARViwEi8bsRIdPlmwAEVYsBovG7EaDz5ZsgAaEhESObIDAQorWCHYG/RZsggSGhESOXywCC8YtGAIcAgCXbQwCEAIAl2y8AgBXbIACAFxtIAIkAgCcbIFAQorWCHYG/RZsBIQsgsBCitYIdgb9FmyDxIaERI5MDETFhYXFhMhNyE2JicmBgcHNiQXFhIPAgIAJyYmJ/0FZWzuVv6CIwFuDWltcYwa7iABINDK6AgEBiH+w+fD6QgBhWpnAwcBO8SPoAMEc2oBvuIEA/7r4zcz/vD+wgYE2LkAAAIACv/rBiIEogAWACMAlrIBJCUREjmwARCwH9AAsABFWLAOLxuxDh0+WbAARViwCS8bsQkdPlmwAEVYsAYvG7EGDz5ZsABFWLAALxuxAA8+WbIKBgkREjl8sAovGLRgCnAKAl2y8AoBXbIACgFxtDAKQAoCXbSACpAKAnGyBQEKK1gh2Bv0WbAOELIaAQorWCHYG/RZsAAQsiABCitYIdgb9FkwMQUuAjcHAyMTMwMzNgAXFhYSBwcGAgQTNCYnJgIHBhYXFhI3A7qHz2cLvlTsyuxVrEUBNdKUzl0RBBWg/v/Ta2mdxAIDa2ybvwgRBIPkiQH+HgSN/hj0AQkFBJP+/Z4ksv7wlALSiJAEBv7v94abBAYBDO4AAAL/0gAABFYEjgANABYAYbIRFxgREjmwERCwDNAAsABFWLAHLxuxBx0+WbAARViwAC8bsQAPPlmwAEVYsAkvG7EJDz5ZshIHABESObASL7ILAQorWCHYG/RZsgELEhESObAHELITAQorWCHYG/RZMDEjASYmNzYkMwUDIxMjARMGFhcXEyciBi4BclJSBgkBB88B0cruTuL+1LELVVHjOslfgwIPK5Fep74B+3MBvP5EAxtKTwIBAUoBWwAAAf/1AAAERASNAA0AULIBDg8REjkAsABFWLAILxuxCB0+WbAARViwAi8bsQIPPlmyBwIIERI5sAcvsgQHCitYIdgb9FmwAdCwCBCyCwEKK1gh2Bv0WbAHELAM0DAxASMDIxMjNzMTIQchAzMCgM9V7VTOHs1ZAwsj/eM20AHm/hoB5qoB/cT+xwAAAf+p/q8GOwSNABkAqrIIGhsREjkAsAMvsABFWLARLxuxER0+WbAARViwBS8bsQUPPlmwAEVYsAkvG7EJDz5ZsABFWLANLxuxDQ8+WbIXCREREjmwFy+yPxcBcbJfFwFyss8XAXG0rxe/FwJdtI8XnxcCcrIHAQorWCHYG/RZsgAHFxESObAFELIBAQorWCHYG/RZsAcQsAvQsg8XBxESObAXELAS0LARELAU0LAUL7AY0LAYLzAxARMzAyMTIwMjAyMTIwEhAQMhEzMTMwMzASEEnJvAXcs7n6VhUu1SVf66/swBw8sBCZxXU+5USQFEASQCUP5y/e0BUQHV/isB1f4rAmECLP4gAeD+IAHgAAABAAr+rwRtBI0AEACIsgAREhESOQCwBC+wAEVYsAwvG7EMHT5ZsABFWLAPLxuxDx0+WbAARViwCS8bsQkPPlmwAEVYsAYvG7EGDz5Zsg0JDBESObANL7I/DQFxsl8NAXKyzw0BcbSvDb8NAl20jw2fDQJysggBCitYIdgb9FmyAAgNERI5sAYQsgEBCitYIdgb9FkwMQETMwMjEyMDIwMjEzMDMwEhAn3Ny13LO4/jbVLtyu1UVwGDASYCRv58/e0BUQHV/isEjf4gAeAAAAEACgAABSQEjQAUAICyBRUWERI5ALAARViwFC8bsRQdPlmwAEVYsAYvG7EGHT5ZsABFWLARLxuxEQ8+WbAARViwCi8bsQoPPlmyABEUERI5sAAvsj8AAXGyXwABcrLPAAFxtK8AvwACXbSPAJ8AAnKwBNCwABCyEAEKK1gh2Bv0WbAM0LIIDAAREjkwMQEzNzMHNwEhAQEhAycHIzcjAyMTMwFpRCugLjIBgwEl/hABNP7q4j8poClEVu3K5gKr4OABAeH9uP27AdUBzM3+KQSNAAEAYgAABXIEjQAOAIWyCQ8QERI5ALAARViwBy8bsQcdPlmwAEVYsAovG7EKHT5ZsABFWLACLxuxAg8+WbAARViwDi8bsQ4PPlmyCAIHERI5sAgvsj8IAXGyXwgBcrLPCAFxtK8IvwgCXbSPCJ8IAnKyAQEKK1gh2Bv0WbAHELIEAQorWCHYG/RZsgwBCBESOTAxASMDIxMhNyEDMwEFAQEhArxtUu2o/qojAkJUVwGCASb+EQEz/ukB1f4rA8rD/iAB4AH9uf27AAACAED/6gV5BKkAJAAvAIKyAzAxERI5sAMQsC/QALAARViwCy8bsQsdPlmwAEVYsBsvG7EbHT5ZsABFWLAELxuxBA8+WbAA0LICBBsREjmwAi+wCxCyDAEKK1gh2Bv0WbAEELITAQorWCHYG/RZsAAQsiQBCitYIdgb9FmwAhCwJ9CwGxCyLAEKK1gh2Bv0WTAxBSYnBickABM3EgA3BwYGBwcGFhc3JiY3NzYSFxYWFxYHBgcWMwEWFzY3NzYnJgMGBRzbnaKY/vX+4RsDHAEu5xZ4mxoGFZ6kP0gvDAUe+7mdsQkEESPHZ0j9+gN/tCANDIe6JwkSBzM+AgIBRwETHgEIATUEzQKzrivC0AIDaeF+JvEBDwUEya1PePmxBwFls1x+8o7QBQb+zGEA//8AbQAABIAEjQAmA/cAAAAHA9UABf7VAAH/pP6vBIAEjQAPAFqyChARERI5ALAHL7AARViwAS8bsQEdPlmwAEVYsA8vG7EPHT5ZsABFWLALLxuxCw8+WbAARViwCS8bsQkPPlmyAA8LERI5sgQBCitYIdgb9FmyCgsPERI5MDEBASEBEzMDIxMjAwEhAQEhAisBMQEk/iW4xlzLO4aw/sf+3AHm/vwBBAL7AZL9sv6D/e0BUQGY/mgCVwI2AAABAGL+rwW6BI0ADwBcsgkQERESOQCwAi+wAEVYsAgvG7EIHT5ZsABFWLAOLxuxDh0+WbAARViwBC8bsQQPPlmyAAEKK1gh2Bv0WbAIELIGAQorWCHYG/RZsArQsAvQsAAQsAzQsA3QMDElMwMjEyETITchByEDIRMzBPu/cNk7/GCo/q4jA4ci/raGAfWo7cP97AFRA8nExPz6A8oAAAEAXQAABGQEjQAYAE+yBRkaERI5ALAARViwCy8bsQsdPlmwAEVYsBcvG7EXHT5ZsABFWLAALxuxAA8+WbIRCwAREjmwES+yBwEKK1gh2Bv0WbAE0LARELAU0DAxISMTBgcHIzcmJjcTMwMGFxYXNzMHNjcTMwOa7lFGXCqfKq+wFDnuOgcCA3Uxny9EXWTtAasVC83KEty2AWH+pCsoeBv08woXAiAAAAEACgAABBEEjQASAEayDhMUERI5ALAARViwAC8bsQAdPlmwAEVYsAgvG7EIDz5ZsABFWLARLxuxEQ8+WbIEAAgREjmwBC+yDgEKK1gh2Bv0WTAxEzMDNhcWFgcDIxM2JyYnJgcDI9TtUYR40NUVOe06BgYTm2ybZO0Ejf5VJwIC4cP+nwFiNCl/BgMm/d8AAAIAN//xBaUEpwAbACQAZLIOJSYREjmwDhCwHdAAsABFWLAPLxuxDx0+WbAARViwAC8bsQAPPlmyIA8AERI5sCAvshMBCitYIdgb9FmwBNCwIBCwDNCwABCyFwEKK1gh2Bv0WbAPELIcAQorWCHYG/RZMDEFLgI3JiY3FwYXFhc2ABcWEgcHIQYWFxY3FwYDJgYHITYnJiYDWJrydRCXmQu8AwMHcz0BQtnm7x0X/N4SkpGBqS93fX23LQI6EQsPdA8Bg+eREtu1ASckeBvoAQ8EBP7Y9JmOngIDP71KA+4Dn5dTN05YAAACADT/7AR6BKIAFQAfAF6yESAhERI5sBEQsBfQALAARViwAC8bsQAdPlmwAEVYsAgvG7EIDz5Zsg4ACBESObAOL7AAELIRAQorWCHYG/RZsAgQshYBCitYIdgb9FmwDhCyGQEKK1gh2Bv0WTAxAR4CBwcGACcuAjc3ITYmJyYHJzYTFjY3IQcGFxYWAoOf620RDSD+q+eZ11wTGAMgEpKPgKswenx8ty39xwYLChB1BKIDivicZfv+ywQDifWfmZGbAgM/vEv8EgOflxk9M1BXAAABAAz/5wQFBI0AGgBqshMbHBESOQCwAEVYsAIvG7ECHT5ZsABFWLAMLxuxDA8+WbACELIAAQorWCHYG/RZsgQAAhESObIaDAIREjmwGi+yGAEKK1gh2Bv0WbIFGBoREjmwDBCyEgEKK1gh2Bv0WbIQEhgREjkwMQEhNyEHARYWBw4CJyYmNzMWFxY2NzYmJyc3ArH9+CIDOhv+lomeCAeG6Ii82gTqBLVsjAoKX2CRIgPJxKX+xRe5gXWnWQMFvJyUBQJiVE1XAwHFAAADADr/7ARjBKMAEAAXAB4AiLIZHyAREjmwGRCwENCwGRCwEtAAsABFWLAILxuxCB0+WbAARViwAC8bsQAPPlmwCBCyEQEKK1gh2Bv0WbIVCAAREjl8sBUvGLIwFQFdskMVAV20YBVwFQJdsvAVAV2yABUBcbSAFZAVAnGwABCyGAEKK1gh2Bv0WbAVELIbAQorWCHYG/RZMDEFJiYCNzcSABcWFhIHBwYCBBEmBgchNiYDFjY3IQYWAfuS0V4RAx8BSe+Rz14RBBWg/v9yrTMCJQpv/3OrMv3cCnAQApUBBJ4cAREBTQYCkv76niSy/vGUA+0FmKCMovzeBZmdhqYAAQAEAAAECgSiACYAprIlJygREjkAsABFWLAeLxuxHh0+WbAARViwDC8bsQwPPlmyBh4MERI5sAYvsg8GAV2wAdCwAS+yzwEBXUAJHwEvAT8BTwEEXbIAAQFdsgICCitYIdgb9FmwBhCyBwIKK1gh2Bv0WbAMELIPAQorWCHYG/RZsArQsAcQsBPQsAYQsBTQsAIQsBjQsAEQsBnQsB4QsiQBCitYIdgb9FmyIQEkERI5MDEBIQclBwclByUGByUHITcXNjc3BzcXNzcHNzM3NjYXFhYHJzYnJgMBvgGCGv6TDwgBdhv+iSM2Aokk/H8dCDQfE5gclgYQoBuNAxvwva69CO0KkKQoArqSAkMZApMBRDoDw8IBFkApA5MCEUsCkhjX+QQE0bMBwAMD/v8AAAEAHv/wA+sEogAiAJuyHSMkERI5ALAVL7AARViwCC8bsQgPPlmyIhUIERI5sCIvsg8iAV2yzyIBXbQQIiAiAl2yAAIKK1gh2Bv0WbAIELIDAQorWCHYG/RZsAAQsAzQsCIQsA3QsCIQsB3QsB0vss8dAV22Hx0vHT8dA12yAB0BXbIgAgorWCHYG/RZsA/QsB0QsBLQsBIvsBUQshoBCitYIdgb9FkwMQEhBhcWNxcGJyYmNwc3MzcjNzM2JBcWFwcmJyIGByUHIQchAxH+lQTCRYMMc2i+6QScGo0RjhqJQQEVx16FJVprZ48wAXka/okQAXgBhMsEAx3BHgIC3LUBklyTydQCAh7BHgJocwGTXAAEAAoAAAe+BKMAAwARAB8AKQCqsiAqKxESObAgELAB0LAgELAN0LAgELAT0ACwAEVYsCUvG7ElHT5ZsABFWLAoLxuxKB0+WbAARViwBC8bsQQdPlmwAEVYsCAvG7EgDz5ZsABFWLAjLxuxIw8+WbAEELAL0LALL7AD0LADL7YAAxADIAMDXbIAAgorWCHYG/RZsAsQshUCCitYIdgb9FmwBBCyHAIKK1gh2Bv0WbIiJSAREjmyJyUgERI5MDElITchAxYWBwcGBicmJjc3NjYDBhYXFjY3NzYmJyYGBwEjAQMjEzMBEzMHCv3UGwIrm4+mCgYO0JmQpgoFDNU7B0ZHS2sOCgdGRkxsDv4f5P6JjO3K5QF3jOzIlQNCBLuRQpzCBAS+jUCdxP5dWWACBGhZTllgAgJkWvyxAyX82wSN/NoDJgAC/9kAAASyBI0AFgAfAJOyACAhERI5sB/QALAARViwDC8bsQwdPlmwAEVYsAIvG7ECDz5ZsgYCDBESObAGL7QfBi8GAnGyBQcKK1gh2Bv0WbAB0LAGELAK0LAKL7QfCi8KAnG2DwofCi8KA122jwqfCq8KA12yCQcKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAXL7AMELIfAQorWCHYG/RZMDElIQcjNyM3MzcjNzMTBRYWBwYEIycHIQMXNjY3NiYnJwKT/v0b7RvKIMkOyyHJYwHOudkLCv7w0v4OAQTX5GKLDQxXVP2ZmZm2TbcCOgEFzJ+r1gFNAQQBAmpZT18EAQACABD/6AQjBgAAEgAfAGSyBCAhERI5sAQQsBzQALAJL7AARViwDS8bsQ0bPlmwAEVYsAcvG7EHDz5ZsABFWLAELxuxBA8+WbIGDQcREjmyCw0HERI5sA0QshYBCitYIdgb9FmwBBCyGwEKK1gh2Bv0WTAxAQYCBicmJwcjATMDNhcWFhcWBycnJicmBwMWFxY2NzYEGhOS1n+3XS3PAQrubHmmobsJAwbqBByejWVRM4t8qRgIAhig/vODAwSMewYA/dGBBATfv0E+cye8BQSJ/jWDBAPCqFQAAAEAN//oBAMEVAAbAEuyABwdERI5ALAARViwDy8bsQ8bPlmwAEVYsAgvG7EIDz5ZsgABCitYIdgb9FmyBA8IERI5shMIDxESObAPELIWAQorWCHYG/RZMDElFjY3Nw4CJyYCNzcSABcWFhUjJiYnJgYHBhYB8VeDFt8OhtRw094YAh0BNt+w0N0CXlKKrAgGYq0CZ1MBbK9jAwUBMOgUAQEBNwYE4rNicQQG8uKCjQAAAgA7/+cEmwYAABIAHwBhsgQgIRESObAEELAZ0ACwBy+wAEVYsAQvG7EEGz5ZsABFWLAJLxuxCQ8+WbAARViwDS8bsQ0PPlmyBgQJERI5sgsECRESObIYAQorWCHYG/RZsAQQsh0BCitYIdgb9FkwMRM2EjYXFhcTMwEjNwYnJiYnJjczBhcWFhcWNxMmJyYGRBOW1oGjX2jt/vbMDH+um74MBAbuBgQFYleFZ1Q1g32sAh+jAQyEAwR2Aiv6AHWOBATluz88NTtnfgQEhQHaeAQDwv//AKQAAAMtBbUABgAVtQAAAgA0/+gEPwRRABMAIwBDshgkJRESObAYELAE0ACwAEVYsAUvG7EFGz5ZsABFWLAOLxuxDg8+WbIXAQorWCHYG/RZsAUQsh8BCitYIdgb9FkwMRM2Ejc2Fx4CBwcGAgYnJiYnJjcXFhYXFjY3NicmJicmBgcGRRa7kmV5jMxhEAIUoPuTjc4vLQ/rB2lae7McBgQJall+shcIAiCwARNBLQMCkPyWFp7+/40EApJ/e5F2aXwDBcS9OD5rfwMDy6VRAAAC/8f+YAQhBFIAEgAeAGCyBB8gERI5sAQQsB3QALAARViwDS8bsQ0bPlmwAEVYsAovG7EKGz5ZsABFWLAHLxuxBxE+WbAARViwBC8bsQQPPlmwDRCyFwEKK1gh2Bv0WbAEELIcAQorWCHYG/RZMDEBBgIGJyYnAyMBNwc2FxYWFxYHJzc0JicmBwMWFxY2BBgTkdZ/qGFh7gEE0g58r569CQMG7QRmX4RjVzKHerECGJ7+84UDBHP9/gXaAXKJBALkvUA+AUt+jQQEfP4VdAQDxgACADv+YARLBFEAEgAeAGuyDB8gERI5sAwQsBjQALAARViwBy8bsQcbPlmwAEVYsAQvG7EEGz5ZsABFWLAJLxuxCRE+WbAARViwDS8bsQ0PPlmyBgcNERI5sgsHDRESObIXAQorWCHYG/RZsAQQshwBCitYIdgb9FkwMRM2EjYXFhc3MwEjEwYnJiYnJjcXBxQWFxY3EyYnJgZEEpLZha9cKtD+/O1jeZ2cwAwEBu4EZF6DZFk3f32xAh+eAQ6GAwR/b/omAf11BALhvz89AUp7lAIEeQH3bwMDxwAAAgA7/+sECARUABUAHgCAsgAfIBESObAW0ACwAEVYsAgvG7EIGz5ZsABFWLAALxuxAA8+WbIZCAAREjmwGS+0vxnPGQJdtF8ZbxkCcbQfGS8ZAnGyjxkBXbTvGf8ZAnGyDAcKK1gh2Bv0WbAAELIQAQorWCHYG/RZshIACBESObAIELIWAQorWCHYG/RZMDEFLgI3NzYAFxYSBwchBhYXFjcXBgYDJgMFNzYnJiYCDZDYag4CGQE518fNGxP9WAqGfYmSLT69EcBiAcIGCAUIWBMBiPSXFP4BQQYE/urign+fAgRRqDM3A6EG/vABHS8rQk8AAAIAMP5QBDoEUQAbACkAfLIEKisREjmwBBCwJtAAsABFWLAHLxuxBxs+WbAARViwBC8bsQQbPlmwAEVYsAwvG7EMET5ZsABFWLAWLxuxFg8+WbIGBxYREjmwDBCyEQEKK1gh2Bv0WbIUBxYREjmwFhCyIQEKK1gh2Bv0WbAEELImAQorWCHYG/RZMDETNhI2FxYXNzMDBgAnJic3FhcWEzcGJyYmJyY3MwYXFBYXFjcTJicmBgdGFIbOgrVcK86tIv7Y4aCSQmx7+EwRfp+asAcDBu0GAVhWi2JSMIh5nxYCH6UBBocCBIRz/Azt/vcEBEyxPwIHARBFegQE4ME+OzM7aH8EBIkB1HoEA8GrAAEAb//nBUYFyAAdAE6yDB4fERI5ALAARViwDS8bsQ0fPlmwAEVYsAMvG7EDDz5ZsgANAxESObIRAw0REjmwDRCyEwEKK1gh2Bv0WbADELIaAQorWCHYG/RZMDEBBgAnLgInJjc2EiQXFgAXIwInJgADBwYWFxY2NwTeI/6x9ZLehQsIGSPTASit3wEKCvUN/cj/ABICA5OIi7kmAdzj/u4EA4T7nnOSzQFHpAME/vTnASQHBv6X/uYvvdgEBpyPAAEAcf/oBUoFyAAkAFyyFSUmERI5ALAARViwDi8bsQ4fPlmwAEVYsAMvG7EDDz5ZshEOAxESObAOELIUAQorWCHYG/RZsAMQsh4BCitYIdgb9FmyIw4DERI5sCMvsiIBCitYIdgb9FkwMSUGBCcuAicmNzc2EiQXFgQXJwInJgYGBwYXFBYWFxY3EyE3IQTAS/7atpjsjg4ICwQbzwE1tt4BBRLwF/V0w4kXDAFIjmC6cDX+5SICELxjcQMDhPqeVl4n0wFbtQME9N0BAQAIA3/7m149dbtlAQVYARvAAAIALgAABR0FsAALABYAQ7IPFxgREjmwDxCwCtAAsABFWLACLxuxAh8+WbAARViwAC8bsQAPPlmyDgEKK1gh2Bv0WbACELIWAQorWCHYG/RZMDEzEwUyBBIHBwYCBAcTAxcyADc2JyYmJy78AZi9ARuDFQUZ1/6mxgq2mtMBKSocDxSxkQWwAbf+vcYsxv69uAIE5PvmAQEB2JB3k6MEAAACAHL/6AVyBcgAEwAnAEayCigpERI5sAoQsBvQALAARViwCy8bsQsfPlmwAEVYsAAvG7EADz5ZsAsQshoBCitYIdgb9FmwABCyJAEKK1gh2Bv0WTAxBS4CJyY3NzYSJBceAhcWAgIEATY3NCYmJyYABwcGFRQWFhcWADcCf4/hiA0ICgwi1QEzrZDgiA0OZNb+5gFOBgFBg1y1/vUiAgZCg1ywAQInFQOH/qBWV1LCAUetAwOG/J6u/pn+6o8DDjQ6br1kAwX+y/YPNDpwwGcDBwEh5QAAAgBy/wMFbAXIABkAKwBGsiEsLRESObAhELAD0ACwAEVYsBAvG7EQHz5ZsABFWLAFLxuxBQ8+WbAQELIgAQorWCHYG/RZsAUQsicBCitYIdgb9FkwMSUXBycGIy4CJyY3NzYSJBcWFhIXFgcHBgIDNjc0JiYnJgYCFRQWFxY2EjcD2Mau9UY4kt2IDQcKCSDVATSxk+GHDAYKCB/ICAcBP4NeiduGl4pzxo4WU8aK9AsDhv+hV1c+xgFQsQMDiP8AnVhXN8r+xQI/NTpyvGUDBK7+wri83QQFfQECmgAAAQCrAAADNQSMAAYAMgCwAEVYsAUvG7EFHT5ZsABFWLAALxuxAA8+WbIEAAUREjmwBC+yAwEKK1gh2Bv0WTAxISMTBTclMwJx7Zf+kCYCQCQDZHrXywABAB8AAAQKBKAAGQBVsgoaGxESOQCwAEVYsBEvG7ERHT5ZsABFWLAALxuxAA8+WbIDEQAREjmwERCyCQEKK1gh2Bv0WbINEQAREjmyFwARERI5sAAQshkBCitYIdgb9FkwMSEhNwE3Njc2JicmBgcHPgIXFhYHBgcHAQUDpfx6HgIbPW0OCVNOZIoQ6wmI4oK20AoMt03+pwIwqQGkM19lRlQCAnpiAne9aAEFspWnnUD+9QIAAAEACgAABBUFxAAHADKyAwgJERI5ALAARViwBi8bsQYdPlmwAEVYsAUvG7EFDz5ZsAYQsgIBCitYIdgb9FkwMQEzAyEDIxMhAyfuWf3jqO3KAh0FxP4F/DcEjQAAAf9//qAEFQSNABgAWbIFGRoREjkAsAwvsABFWLACLxuxAh0+WbIAAQorWCHYG/RZsgQAAhESObIFDAIREjmwBS+wDBCyEQEKK1gh2Bv0WbAFELIWAworWCHYG/RZshgWBRESOTAxASE3IQcBFhYHBgYEJyYnNxYXFjY3EiUnNwLA/dQjA14b/mSTpw0OrP7cqrLSSo+joekTI/7hZRIDycSa/oYe9KGi+YsDA2a0WQICwJcBChQChgAAAv/R/sQEIwSMAAoADgBSALAARViwCS8bsQkdPlmwAEVYsAIvG7ECDz5ZsABFWLAGLxuxBg8+WbIAAQorWCHYG/RZsAYQsAXQsAUvsggGABESObAAELAM0LINCQIREjkwMSUzByMDIxMhNwEzASETBwNysSKwN+03/W0VAzn8/NcBlHcewsP+xQE7oAPt/DYCgywA//8AigKIAv8FvQMHA9AAcwKYABMAsABFWLAHLxuxBx8+WbAR0DAxAP//AGQCmALtBa4DBwPMAHMCmAATALAARViwCS8bsQkfPlmwDdAwMQD//wB9AooDBAWtAwcDywBzApgAEACwAEVYsAEvG7EBHz5ZMDH//wCJAooC5gW8AwcDygBzApgAEwCwAEVYsBQvG7EUHz5ZsBXQMDEA//8AlgKYAy4FrQMHA8kAcwKYABAAsABFWLAFLxuxBR8+WTAx//8AewKKAvMFuwMHA8gAcwKYABkAsABFWLASLxuxEh8+WbAY0LASELAk0DAxAP//AKYCjQL1BbsDBwPHAHMCmAATALAARViwCC8bsQgfPlmwHNAwMQAAAf/U/p0ETgSMABwAXbIHHR4REjkAsA8vsABFWLABLxuxAR0+WbIDAQorWCHYG/RZsgcBDxESObAHL7IaAQorWCHYG/RZsgUaBxESObAPELIUAQorWCHYG/RZshIUGhESObIcGhQREjkwMRMTIQchAzYXMhYWBwYGBCcmJzcWFxY2NzYmJyYHWeEDFCX9r3FjgHqvUA0Pnv73pM+5WneykcwTDmhplEgBdgMW0v6oNgJ634mX840CBHWvZAICvpZ/nwMEcgAAAQAn/sQEVASMAAYAJQCwAS+wAEVYsAUvG7EFHT5ZsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITchBDr85vkDDP1NIwOxA/n6ywUFwwAAAgA6//IGoQSfABgAJACRsgElJhESObABELAb0ACwAEVYsAwvG7EMHT5ZsABFWLAPLxuxDx0+WbAARViwAi8bsQIPPlmwAEVYsAAvG7EADz5ZsA8QshEBCitYIdgb9FmyFAAPERI5sBQvshUBCitYIdgb9FmwABCyGAEKK1gh2Bv0WbACELIZAQorWCHYG/RZsAwQshwBCitYIdgb9FkwMSEhBSMmJgI3NzYSNhcyFjMhByEDIQchAyEFNxMnJgYHBhcWFhcF2f17/vJOkdBdEQYXov+dWcRdAoEj/cowAegj/ho2Ajv8a2WWxIK2IRYFBWpdDgKUAQOdNqkBCJABEcT+8sP+ygwEAxYMArSpcGNwhAQAAgBH/rAERgSjABkAKABRsiMpKhESObAjELAE0ACwFS+wAEVYsAwvG7EMHT5ZsBUQsgABCitYIdgb9FmyBRUMERI5sAUvshoBCitYIdgb9FmwDBCyIgEKK1gh2Bv0WTAxBRY2NwYnJgI3PgIXFhYSBwcGAgQnJic3FgEWNzc2JyYmJyYGBhcWFgFQkdpQgpm8zRQOlOiLk8tYEx0kxf7krYyRQXIBIqFxHAcCA2RaW45HCgleiwO50l0EAgEV15P4hgIEkf7+osLx/qarAwI9tC8B6QR7rjg8aHoDA3jWZ1xtAAIATv/mBIoEpQAMAB0ARrISHh8REjmwEhCwANAAsABFWLAGLxuxBh0+WbAARViwAC8bsQAPPlmwBhCyEQEKK1gh2Bv0WbAAELIaAQorWCHYG/RZMDEFJgITEgAXFhIDBwIAEzc0JicmBgcHBhcWFhcWNjcCGOLoGyQBR+/g5xsLMP7EjQVraIq8GQQGAwVsYYq7GRUFAUoBAQEhAUkFBf66/v5H/v7+3AKAU4yVBAXUwiA8QnSLBAXWxwD///8P/kgB3AQ6AgYBZAAA////D/5IAdwEOgIGAWQAAP//ACIAAAHLBDoABgD0AAD///99/lsBywQ6ACYA9AAAAAYBbdUK//8AIgAAAcsEOgAGAPQAAAABAAr/5gPoBKEAIABpsgchIhESOQCwAEVYsBQvG7EUHT5ZsABFWLAeLxuxHg8+WbAARViwDy8bsQ8PPlmwHhCyAgEKK1gh2Bv0WbIJHhQREjmwCS+yBwcKK1gh2Bv0WbAUELIMBworWCHYG/RZshgJBxESOTAxJRYzMjY3NicnNzcmJyYHAyMTNjYXFhYXARYWBwYGJyYnAZBFRU9vCxPSYB/uNU+xKn/pfh7ywXK/Xv7Ygo4GCvCubnfbM25TlAIBrvo2AgP3/RQC7NbfBARnav7TFqF3r9gCAjb///+XAAAEGgSNAiYD6QAAAQcD1f8E/24AOwCyHxoBcbJvGgFxsv8aAXGyDxoBcrKfGgFysl8aAXK2vxrPGt8aA3GyPxoBcbLfGgFdtB8aLxoCXTAxAP///5cAAAQaBI0CJgPpAAABBwPV/wT/bgA7ALIfGgFxsm8aAXGy/xoBcbIPGgFysp8aAXKyXxoBcra/Gs8a3xoDcbI/GgFxst8aAV20HxovGgJdMDEA//8AYgAABFoEjQImA9kAAAEGA9UlvgAIALIACwFdMDH///+bAAAEBQYeAiYD7AAAAQcARADSAB4AEwCwAEVYsAQvG7EEHT5ZsAzcMDEA////mwAABD8GHgImA+wAAAEHAHcBbQAeABMAsABFWLAFLxuxBR0+WbAN3DAxAP///5sAAAQIBh8CJgPsAAABBgFnaR4AEwCwAEVYsAQvG7EEHT5ZsA/cMDEA////mwAABEAGEwImA+wAAAEGAW53HwAJALAEL7AV3DAxAP///5sAAAQiBesCJgPsAAABBwBrAJ8AHgAMALAEL7Ac3LAL0DAx////mwAABAUGfQImA+wAAAEHAWwBAwBSAAwAsAQvsBTcsBfQMDH///+bAAAEUQaZAiYD7AAAAAcDxQD7AAT//wA5/j0ESQSjAiYD6gAAAAcAewFgAAD//wAKAAAD+QYeAiYD6AAAAQcARACiAB4AEwCwAEVYsAYvG7EGHT5ZsA3cMDEA//8ACgAABA8GHgImA+gAAAEHAHcBPQAeABMAsABFWLAHLxuxBx0+WbAO3DAxAP//AAoAAAP5Bh8CJgPoAAABBgFnOR4AEwCwAEVYsAYvG7EGHT5ZsBDcMDEA//8ACgAAA/kF6wImA+gAAAEGAGtvHgAMALAGL7Ad3LAM0DAx//8AGAAAAeAGHgImA+QAAAEGAESKHgATALAARViwAi8bsQIdPlmwBdwwMQD//wAYAAAC9gYeAiYD5AAAAQYAdyQeABMAsABFWLADLxuxAx0+WbAG3DAxAP//ABgAAALABh8CJgPkAAABBwFn/yEAHgATALAARViwAi8bsQIdPlmwCNwwMQD//wAYAAAC2gXrAiYD5AAAAQcAa/9XAB4ADACwAi+wFdywBNAwMf//AAoAAASoBhMCJgPfAAABBwFuAJUAHwAJALAFL7AU3DAxAP//ADr/6gRjBh4CJgPeAAABBwBEAN8AHgATALAARViwCS8bsQkdPlmwItwwMQD//wA6/+oEYwYeAiYD3gAAAQcAdwF6AB4ACQCwCS+wI9wwMQD//wA6/+oEYwYfAiYD3gAAAQYBZ3YeAAkAsAkvsCLcMDEA//8AOv/qBGMGEwImA94AAAEHAW4AhAAfAAkAsAkvsCvcMDEA//8AOv/qBGMF6wImA94AAAEHAGsArAAeAAwAsAkvsDLcsCHQMDH//wA5/+sEagYeAiYD2AAAAQcARADAAB4AEwCwAEVYsAkvG7EJHT5ZsBPcMDEA//8AdP/nBE4FyQAGABQUAP//AI7/+QQvBcgABgAdAAD//wBa/+cEcwWwAgYAGQAA//8ACQAABCoFsAIGABgAAP//ACb/6AQ5BcUCBgAXAAD//wALAAAEPwXHAgYAFgAA//8AOf/rBGoGHgImA9gAAAEHAHcBWwAeAAkAsAAvsBTcMDEA//8AOf/rBGoGHwImA9gAAAEGAWdXHgAJALAAL7AT3DAxAP//ADn/6wRqBesCJgPYAAABBwBrAI0AHgAMALAAL7Aj3LAS0DAx//8AbQAABIAGHgImA/cAAAEHAHcBNQAeABMAsABFWLABLxuxAR0+WbAL3DAxAP///5sAAAQ8BdICJgPsAAABBgBycSIAEwCwAEVYsAQvG7EEHT5ZsAzcMDEA////mwAABBMGBQImA+wAAAEHAWoApwAeAAkAsAQvsA7cMDEAAAL/m/5RBAUEjQAXABoAhLIVGxwREjmwFRCwGtAAsABFWLAVLxuxFR0+WbAARViwCy8bsQsRPlmwAEVYsAAvG7EADz5ZsABFWLATLxuxEw8+WbAARViwAS8bsQEPPlmwCxCyBgMKK1gh2Bv0WbABELAQ0LAQL7IZFQAREjmwGS+yEQcKK1gh2Bv0WbIaFQAREjkwMSEXBwYHBhcWNxcGJyImNzY3JyEHIwEzEwEhAwPQBS+DBwU4Gz0MRVVXaQIDvCz+Loj5ApPa/f18AUhXAx9WVjkDAReQKwJtVJhr4vkEjftzAbIBuP//ADn/7ARJBh4CJgPqAAABBwB3AWoAHgAJALALL7Af3DAxAP//ADn/7ARJBh8CJgPqAAABBgFnZh4ACQCwCy+wHtwwMQD//wA5/+wESQX/AiYD6gAAAQcBawFHACcACQCwCy+wJdwwMQD//wA5/+wESQYjAiYD6gAAAQYBaH0eAAkAsAsvsCHcMDEA//8ACgAABBoGIwImA+kAAAEGAWj+HgATALAARViwAi8bsQIdPlmwG9wwMQD//wAKAAAEDAXSAiYD6AAAAQYAckEiABMAsABFWLAGLxuxBh0+WbAN3DAxAP//AAoAAAP5BgUCJgPoAAABBgFqdx4ACQCwBi+wD9wwMQD//wAKAAAD+QX/AiYD6AAAAQcBawEaACcACQCwBi+wFNwwMQAAAQAK/lED+QSNABwAgLIVHR4REjkAsABFWLAXLxuxFx0+WbAARViwEC8bsRARPlmwAEVYsAQvG7EEDz5ZsABFWLAVLxuxFQ8+WbIcFwQREjmwHC+yAAEKK1gh2Bv0WbAVELICAQorWCHYG/RZsAPQsBAQsgsDCitYIdgb9FmwFxCyGQEKK1gh2Bv0WTAxASEDIQcjFwcGBwYXFjcXBiciJjc2NyETIQchAyEDNf4aNgI7I2AFL4MHBTgbPQxFVVdpAgOW/hXKAyUj/ckvAegB+P7KwgMfVlY5AwEXkCsCbVSMYASNxP7y//8ACgAABAwGIwImA+gAAAEGAWhQHgATALAARViwBi8bsQYdPlmwEdwwMQD//wA///AEUQYfAiYD5gAAAQYBZ2oeAAkAsAsvsCLcMDEA//8AP//wBFEGBQImA+YAAAEHAWoAqAAeAAkAsAsvsCTcMDEA//8AP//wBFEF/wImA+YAAAEHAWsBSwAnAAkAsAsvsCncMDEA//8AP/35BFEEowImA+YAAAAHA6sBIP6S//8ACgAABKkGHwImA+UAAAEGAWd8HgATALAARViwBy8bsQcdPlmwENwwMQD//wANAAAC+AYTAiYD5AAAAQcBbv8vAB8ACQCwAi+wDtwwMQD//wAYAAAC9AXSAiYD5AAAAQcAcv8pACIAEwCwAEVYsAIvG7ECHT5ZsAXcMDEA//8AGAAAAssGBQImA+QAAAEHAWr/XwAeAAkAsAIvsAfcMDEA////iv5RAc8EjQImA+QAAAAGAW3iAP//ABgAAAICBf8CJgPkAAABBgFrAScACQCwAi+wDNwwMQD////y/+sEkAYfAiYD4wAAAQcBZwDxAB4AEwCwAEVYsAAvG7EAHT5ZsBPcMDEA//8ACv35BJ0EjQImA+IAAAAHA6sAzP6S//8ACgAAAzQGHgImA+EAAAEGAHcbHgATALAARViwBS8bsQUdPlmwCNwwMQD//wAK/fkDNASNAiYD4QAAAAcDqwDK/pL//wAKAAADOwSQAiYD4QAAAQcDqwIlA4oAEACwAEVYsAovG7EKHT5ZMDH//wAKAAADNASNAiYD4QAAAAcBawDu/Ub//wAKAAAEqAYeAiYD3wAAAQcAdwGLAB4AEwCwAEVYsAgvG7EIHT5ZsAzcMDEA//8ACv35BKgEjQImA98AAAAHA6sBLv6S//8ACgAABKgGIwImA98AAAEHAWgAngAeABMAsABFWLAGLxuxBh0+WbAP3DAxAP//ADr/6gRjBdICJgPeAAABBgByfiIACQCwCS+wIdwwMQD//wA6/+oEYwYFAiYD3gAAAQcBagC0AB4ACQCwCS+wJNwwMQD//wA6/+oE5AYdAiYD3gAAAQcBbwD7AB4ADACwCS+wI9ywJdAwMf//AAoAAAQWBh4CJgPbAAABBwB3ASAAHgAJALAEL7AY3DAxAP//AAr9+QQWBI0CJgPbAAAABwOrANL+kv//AAoAAAQWBiMCJgPbAAABBgFoMx4ACQCwBC+wGtwwMQD//wAO/+0EGwYeAiYD2gAAAQcAdwFJAB4ACQCwCS+wKdwwMQD//wAO/+0D/wYfAiYD2gAAAQYBZ0UeAAkAsAkvsCjcMDEA//8ADv49A/8EnwImA9oAAAAHAHsBRQAA//8ADv/tBBgGIwImA9oAAAEGAWhcHgAJALAJL7Ar3DAxAP//AGL9+QRaBI0CJgPZAAAABwOrAN7+kv//AGIAAARaBiMCJgPZAAABBgFoSh4AEwCwAEVYsAYvG7EGHT5ZsA3cMDEA//8AYv5DBFoEjQImA9kAAAAHAHsBMAAG//8AOf/rBGoGEwImA9gAAAEGAW5lHwAJALAAL7Ac3DAxAP//ADn/6wRqBdICJgPYAAABBgByXyIACQCwAC+wEtwwMQD//wA5/+sEagYFAiYD2AAAAQcBagCVAB4ACQCwAC+wFdwwMQD//wA5/+sEagZ9AiYD2AAAAQcBbADxAFIADACwAC+wG9ywHtAwMf//ADn/6wTFBh0CJgPYAAABBwFvANwAHgAMALAAL7AU3LAW0DAxAAEAOv6BBGoEjQAfAGGyBSAhERI5ALAARViwAC8bsQAdPlmwAEVYsBYvG7EWHT5ZsABFWLANLxuxDRc+WbAARViwEi8bsRIPPlmyBBIAERI5sA0QsggDCitYIdgb9FmwEhCyGwEKK1gh2Bv0WTAxAQMGBgcGBwYXFjcXBiciJjc2NyYmNxMzAwYWFxY2NxMEaoIYp4R5CgU4Gz0MRVVXaQICS7LCE4HsggtbZ2uOEoMEjfz1jcMpT1g5AwEXkCsCbVRiTRPdqgMA/P9lcgMEb2kDBwD//wCMAAAGHgYfAiYD1gAAAQcBZwEVAB4AEwCwAEVYsAEvG7EBHT5ZsA/cMDEA//8AbQAABIAGHwImA/cAAAEGAWcxHgATALAARViwCC8bsQgdPlmwDdwwMQD//wBtAAAEgAXrAiYD9wAAAQYAa2ceAAwAsAEvsBrcsAnQMDH////WAAAEJwYeAiYEqQAAAQcAdwE4AB4AEwCwAEVYsAgvG7EIHT5ZsAzcMDEA////1gAABCcF/wImBKkAAAEHAWsBFQAnAAkAsAcvsBLcMDEAAAH/1gAABCcEjQAJAEQAsABFWLAHLxuxBx0+WbAARViwAi8bsQIPPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMSUhByE3ASE3IQcBMAJgI/xpGwLf/a8jA4UawsKYAzHElgD///+bAAAEBQUeAiYD7AAAAAcBd/9I/t3///9tAAAENQUhACYD6DwAAAcBd/4//uD///94AAAE5QUcACYD5TwAAAcBd/5K/tv///97AAACCwUhACYD5DwAAAcBd/5N/uD////S/+oEbQUeACYD3goAAAcBd/6k/t3///8sAAAEvAUeACYD9zwAAAcBd/3+/t3////iAAAEggUeACYD1AoAAAcBd/60/t3///+bAAAEBQSNAgYD7AAA//8ACgAABAAEjQIGA+sAAP//AAoAAAP5BI0CBgPoAAD////WAAAEJwSNAgYEqQAA//8ACgAABKkEjQIGA+UAAP//ABgAAAHPBI0CBgPkAAD//wAKAAAEnQSNAgYD4gAA//8ACgAABcgEjQIGA+AAAP//ADr/6gRjBKECBgPeAAD//wAKAAAENgSNAgYD3QAA//8AYgAABFoEjQIGA9kAAP//AG0AAASABI0CBgP3AAD///+kAAAEgASNAgYD9gAA//8AGAAAAtoF6wImA+QAAAEHAGv/VwAeAAwAsAIvsBXcsATQMDH//wBtAAAEgAXrAiYD9wAAAQYAa2ceAAwAsAEvsBrcsAnQMDH//wAKAAAD+QXrAiYD6AAAAQYAa28eAAwAsAYvsB3csAzQMDH//wAKAAAD/gYeAiYDugAAAQcAdwEsAB4ACQCwBC+wCNwwMQD//wAO/+0D/wSfAgYD2gAA//8AGAAAAc8EjQIGA+QAAP//ABgAAALaBesCJgPkAAABBwBr/1cAHgAMALACL7AV3LAE0DAx////8v/rA7AEjQIGA+MAAP//AAoAAASdBh4CJgPiAAABBwB3ASAAHgAJALAEL7AP3DAxAP//AHL/6ASCBgUCJgQKAAABBwFqAIgAHgAJALAPL7AT3DAxAP///5sAAAQFBI0CBgPsAAD//wAKAAAEAASNAgYD6wAA//8ACgAAA98EjQIGA7oAAP//AAoAAAP5BI0CBgPoAAD//wALAAAErgYFAiYEBwAAAQcBagDGAB4ACQCwAC+wDdwwMQD//wAKAAAFyASNAgYD4AAA//8ACgAABKkEjQIGA+UAAP//ADr/6gRjBKECBgPeAAD//wAKAAAEpASNAgYDxgAA//8ACgAABDYEjQIGA90AAP//ADn/7ARJBKMCBgPqAAD//wBiAAAEWgSNAgYD2QAA////pAAABIAEjQIGA/YAAAABAA3+OQPuBKAAKACwsiIpKhESOQCwGC+wAEVYsAwvG7EMHT5ZsABFWLAXLxuxFw8+WbAMELIGAQorWCHYG/RZsigXDBESObAoL7K/KAFytK8ovygCXbRvKH8oAnGy/ygBcbIPKAFysl8oAXKyzygBcbI/KAFxtB8oLygCXbKPKAFyskooAV2yCSgGERI5siYBCitYIdgb9FmyESYoERI5sBcQsBrQsBcQsiEBCitYIdgb9FmyHiYhERI5MDEBMjY3NiYiBgcHNjYXFhYHBgcWFgcGBgcDIxMmJjczFhYzFjY3NicnNwIEZoAKCmWwag/uDP3Cw94ICulRWgQH2LZN7k+GhgLqAlxWapAMFdyHIAKqU01ETEU+AZiyAgOmjbVlI4ZZjrUU/kQByCOqeUdMA1lPoAEBsAABAAr+mgS9BI0ADwCosgMQERESOQCwAEVYsAwvG7EMHT5ZsABFWLAJLxuxCR0+WbAARViwAS8bsQEXPlmwAEVYsAYvG7EGDz5ZsABFWLADLxuxAw8+WbIKBgkREjmwCi+0rwq/CgJdsj8KAXGyzwoBcbI/CgFysv8KAXGyDwoBcrRvCn8KAnG03wrvCgJdtB8KLwoCXbJfCgFysgUBCitYIdgb9FmwAxCyDgcKK1gh2Bv0WTAxASMTIxMhAyMTMwMhEzMDMwRf7j69Uv4GU+3K7VYB+1btq7/+mgFmAdv+JQSN/hEB7/woAAABADr+QwRPBKMAHgBesgMfIBESOQCwAEVYsA0vG7ENHT5ZsABFWLAELxuxBBE+WbAARViwAy8bsQMPPlmyAAMNERI5sAbQshENAxESObANELIUAQorWCHYG/RZsAMQshwBCitYIdgb9FkwMQEGBgcDIxMmAjc3EgAXFhYXJyYmJyYGBwYXFBYXFjcEAhnorEvuTpuVFwYgAUHpwuIK6wNga4WwGhABZGHjOAGFp9QV/k4BwS8BKMU0AQ4BQQYE3b0BZ3AEBcC0iT9wfwQI2gD//wBtAAAEgASNAgYD9wAA//8AN/46BaUEpwImBCAAAAAHA/0Cv/+g//8ACwAABK4F0gImBAcAAAEHAHIAkAAiAAkAsAAvsArcMDEA//8Acv/oBIIF0gImBAoAAAEGAHJSIgAJALAPL7AQ3DAxAP//AEMAAAU3BI4CBgPSAAD///+k/lQErgWwAiYAJQAAAAcBbQFtAAP//wAi/lgD3ARQAiYARQAAAAcBbQCnAAf//wAn/lsEugWwAiYAKQAAAAcBbQEuAAr//wA7/lEEAgRRAiYASQAAAAcBbQD8AAD////k/psBywQ6AiYA9AAAAAcBdgNEAAoAAAAAAA8AugADAAEECQAAAF4AAAADAAEECQABABoAXgADAAEECQACAAwAeAADAAEECQADACgAhAADAAEECQAEACgAhAADAAEECQAFACwArAADAAEECQAGACYA2AADAAEECQAHAEAA/gADAAEECQAJAAwBPgADAAEECQALABQBSgADAAEECQAMACYBXgADAAEECQANAFwBhAADAAEECQAOAFQB4AADAAEECQAQAAwCNAADAAEECQARABoCQABDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8AIABNAGUAZABpAHUAbQBJAHQAYQBsAGkAYwBSAG8AYgBvAHQAbwAgAE0AZQBkAGkAdQBtACAASQB0AGEAbABpAGMAVgBlAHIAcwBpAG8AbgAgADIALgAwADAAMQAxADUAMgA7ACAAMgAwADEANABSAG8AYgBvAHQAbwAtAE0AZQBkAGkAdQBtAEkAdABhAGwAaQBjAFIAbwBiAG8AdABvACAAaQBzACAAYQAgAHQAcgBhAGQAZQBtAGEAcgBrACAAbwBmACAARwBvAG8AZwBsAGUALgBHAG8AbwBnAGwAZQBHAG8AbwBnAGwAZQAuAGMAbwBtAEMAaAByAGkAcwB0AGkAYQBuACAAUgBvAGIAZQByAHQAcwBvAG4ATABpAGMAZQBuAHMAZQBkACAAdQBuAGQAZQByACAAdABoAGUAIABBAHAAYQBjAGgAZQAgAEwAaQBjAGUAbgBzAGUALAAgAFYAZQByAHMAaQBvAG4AIAAyAC4AMABoAHQAdABwADoALwAvAHcAdwB3AC4AYQBwAGEAYwBoAGUALgBvAHIAZwAvAGwAaQBjAGUAbgBzAGUAcwAvAEwASQBDAEUATgBTAEUALQAyAC4AMABSAG8AYgBvAHQAbwBNAGUAZABpAHUAbQAgAEkAdABhAGwAaQBjAAMAAP/0AAD/agBkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQACAAgAAv//AA8AAQAAAAoAXACsAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAA4Y3BzcAA+Y3BzcABEa2VybgBKa2VybgBKa2VybgBKa2VybgBKAAAAAQABAAAAAQADAAAAAQACAAAAAQAAAAAAAQAEAAUADAAMAAwADAHeAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBmAGgAgwCEAIUAhgCHAIgAigCLAIwAjQCOAI8AkACRAJIAkwCUAJUAlgCXAJgAmQCcAJ0AngCfAKAAwwDFAMcAyQDLAM0AzwDRANMA1QDXANkA2wDdAN8A4QDjAOUA5wDrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEIAQoBDwERARMBFQEXARkBGwEdAR8BIQEjASUBJwEpASsBLQEvATEBMwE1ATcBOQE7ATwBPgFAAU4BYgF5AXsBfAF9AX4BfwGAAYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY8BkAGRAZIBkwGUAZUBlgGXAZgBmQGaAZsBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0QHSAdMB1AHVAdYB1wHYAdkB2gHbAdwB3QHeAd8B4AHhAeIB4wHkAeUB5gHnAegB6QHqAesB7AHtAe4B7wHwAfEB8gJSAlQCWAJaAlwCXgJiAmQCagJsAnACcgJ0AnYCegJ8An4CgAKaAqICpAKqArADhwOOA5MDlgACAAAAAgAKO9oAAQNsAAQAAAGxBtI6+jr6BvwHUjfeI2I7mDuqOHYHWDiWOJY43jTeDqg4ljiWO6omhAqSCxQ1MDjeNI43uDdKOOQPYgt+OFQ2GjiMC8AM6gz0N643rji4NhoO1g3qOW4OTDeoOW4OZjfeN9433jfeN9433juYOHY4djh2OHY4ljiWOJY4ljuqOJY7qjuqO6o7qjuqON443jjeON445DhUOFQ4VDhUOFQ4VDiMOIw4jDiMN644uDi4OLg4uDi4OW42GjluN944VDfeOFQ33jhUO5g7mDuYO5g7qjuqOHY4jDh2OIw4djiMOHY4jDh2OIw4ljeuOJY4ljiWOJY4ljjeNN4OqA6oDqgOqDiWN644ljeuOJY3rjeuO6o4uDuqOLg7qji4DtYO1g7WNTA1MDUwON443jjeON443jjeN7g45DluOOQPYg9iD2I33jhUNTAO6Dr6N944djiWOJY7qjjkN94jYjZ+N944dg9iOJY7qjiWNN433jiWOJYPhDuqJoQQfjUwOOQRfDdKElo4ljjkN64S+DluEv43rhW8OW4Xlji4GKgYwhjIGM4ayBrOGwQbNji4OHY4dhu0Nn44ljiWON4dKh7cIJo03jY0OJY33iHQI2I2fiNsOHY3SiW6OJY03jiWOJY4ljuqJoQ7mDUwNjQ3SjiWOJYmpihAND4pHingKm44VCrMK6Y3QCwwOIw3qCz6LSQ4uDYaLoo5bjYaN6gxEDFOMoA0aDYaMwI4jDiMN0AziDOyNAg5bjQ+NGg33ji4NI45bjSOOW40tDYaNn43QDZ+N0o3qDTeNN403jTeOJY7mDUwOOQ5bjjkN0o3qDeuOJY3SjeoOJY4ljiWN944VDfeOFQ4djiMOIw4jDdKN6g7qji4OLg2GjY0OW42NDluNjQ5bjZ+N0A3QDdKN6g33jhUOJY3rje4N7g3uDfeOFQ33jhUN944VDfeOFQ33jhUN944VDfeOFQ33jhUN944VDfeOFQ33jhUN944VDh2OIw4djiMOHY4jDh2OIw4djiMOHY4jDh2OIw4djiMOJY4ljuqOLg7qji4O6o4uDuqOLg7qji4O6o4uDuqOLg4uDjeON445DluOOQ5bjjkOW445DluO6o6+jmIOvo6+jr6Ovo6+jsAOwo7HDsuO0A7XjtoO3I7mDuqO6oAAQGxAAQABgALAAwAEwAlACYAJwAoACkAKgAsAC0ALgAvADAAMQAyADMANAA1ADYAOAA5ADoAOwA8AD0APgA/AEUARgBJAEoATABPAFEAUgBTAFQAVgBYAFoAWwBcAF0AXwCDAIQAhQCGAIcAiACKAIsAjACNAI4AjwCQAJEAkgCTAJQAlQCWAJcAmACZAJwAnQCeAJ8AoACjAKQApQCmAKcAqACrAKwArQCuALQAtQC2ALcAuAC5AMAAwQDCAMMAxADFAMYAxwDIAMkAywDNAM8A0QDTANUA1gDXANgA2QDaANsA3ADdAN4A5wDoAOsA7QDvAPEA8wD3APkA/AD+AQABAgEGAQcBCAEJAQoBCwEMAQ8BEAERARIBEwEUARgBGgEcASUBJwEpASsBLQEvATEBMwE1ATcBOQE6ATsBPAE+AUABTgFPAWIBZQFmAXkBewF8AX0BfgF/AYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY4BjwGQAZIBkwGUAZUBlgGXAZgBmgGbAZ4BoQGjAaYBpwGpAa0BrgGvAbEBsgGzAbQBtQG2AbgBuQG8AcMBxAHFAcYByQHKAcsBzAHNAc4BzwHRAdIB0wHUAdUB1gHXAdgB2QHaAdsB3QHeAd8B4AHhAeMB5AHlAeYB6AHpAesB7AHtAe8B8AHxAfIB8wH0AfUB9gH3AfgB+QH6Af0CAQIDAgUCBgIHAggCCQIMAg0CDwIQAhECEwIUAhYCFwIcAh0CIQIlAiYCKQI2AjcCOAI5AjoCRAJRAlICUwJUAlgCWQJcAl4CYAJiAmQCbAJuAnACcQJyAnQCdQJ9AoICgwKEAosCjwKRApICkwKUApUCmAKZApsCnQKeAp8CqAKpAq0CrwKwArECsgKzArQCtQK4ArkCvQK+Ar8C1gLXAuYC5wL4AvoC/AMCAwMDBAMFAwYDBwMIAwkDCgMLAwwDDQMOAw8DEAMRAxIDEwMUAxUDFgMXAxgDGQMaAxsDHAMdAx4DHwMgAyEDIgMjAyQDJQMmAycDKAMpAyoDLAMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDQwNGA0gDVANVA1YDVwNYA1kDWgNbA1wDcANxA3MDdAN1A34DfwPZA9sD3APeA+ED4gPpA+wEMQQzBDQACgA4/8QBJf/EASf/xAFi/8QBxf/EAc7/xAHl/8QCYv/EAm7/xAJ2/8QAFQA6ABQAOwAmAD0AFgCgABYBNwAmATkAFgE7ABYBfwAWAZUAFgGbABYCNwAUAjkAFAJwABYCcgAWAvgAJgL6ACYC/AAmA1QAFgNWABYDWAAWA1oAFgABABP/CADOABD+7gAS/u4AJf9AAC7/MAA4ABQARf/eAEf/6wBI/+sASf/rAEv/6wBT/+sAVf/rAFb/5gBZ/+oAWv/oAF3/6ACD/0AAhP9AAIX/QACG/0AAh/9AAIj/QACj/94ApP/eAKX/3gCm/94Ap//eAKj/3gCq/+sAq//rAKz/6wCt/+sArv/rALX/6wC2/+sAt//rALj/6wC5/+sAvP/qAL3/6gC+/+oAv//qAMD/6ADC/+gAw/9AAMT/3gDF/0AAxv/eAMf/QADI/94Ayv/rAMz/6wDO/+sA0P/rANL/6wDW/+sA2P/rANr/6wDc/+sA3v/rAOD/6wDi/+sA5P/rAOb/6wD3/zABEP/rARL/6wEU/+sBFv/rASUAFAEnABQBLP/qAS7/6gEw/+oBMv/qATT/6gE2/+oBOv/oAUb/6wFI/+oBTv9AAU//3gFiABQBef9AAYL/QAGF/0ABjP9AAZz/6wGg/+oBof/rAaP/6AGt/+gBr//rAbL/6wGz/+sBtf/qAbv/6gG8/+sBvf/qAcUAFAHL/zABzgAUAdP/QAHlABQB8//eAfj/6wIB/+sCBP/rAgb/6AIH/+sCE//rAhT/6wIX/+sCIf/oAin/QAI2/+sCOP/oAjr/6AI8/+sCQP/rAkT/6wJiABQCa//rAm3/6wJuABQCcf/oAnYAFAKS/0ACk//eApT/QAKV/94Cmf/rApv/6wKd/+sCqf/rAqv/6wKt/+sCsf/oArP/6AK1/+gCw//rAsT/6wLF/+sCz//rAtb/QALX/94DAv9AAwP/3gME/0ADBf/eAwb/QAMH/94DCP9AAwn/3gMK/0ADC//eAwz/QAMN/94DDv9AAw//3gMQ/0ADEf/eAxL/QAMT/94DFP9AAxX/3gMW/0ADF//eAxj/QAMZ/94DG//rAx3/6wMf/+sDIf/rAyP/6wMl/+sDJ//rAyn/6wMv/+sDMf/rAzP/6wM1/+sDN//rAzn/6wM7/+sDPf/rAz//6wNB/+sDQ//rA0X/6wNH/+oDSf/qA0v/6gNN/+oDT//qA1H/6gNT/+oDVf/oA1f/6ANZ/+gDW//oA3L+7gN2/u4Dev7uA3v+7gPs/8AAIAA4/98AOv/kADv/7AA9/90AoP/dASX/3wEn/98BN//sATn/3QE7/90BYv/fAX//3QGV/90Bm//dAcX/3wHO/98B5f/fAjf/5AI5/+QCYv/fAm7/3wJw/90Ccv/dAnb/3wL4/+wC+v/sAvz/7ANU/90DVv/dA1j/3QNa/90D7AAOABoAOP/OADr/7QA9/9AAoP/QASX/zgEn/84BOf/QATv/0AFi/84Bf//QAZX/0AGb/9ABxf/OAc7/zgHl/84CN//tAjn/7QJi/84Cbv/OAnD/0AJy/9ACdv/OA1T/0ANW/9ADWP/QA1r/0AAQAC7/7gA5/+4AnP/uAJ3/7gCe/+4An//uAPf/7gEr/+4BLf/uAS//7gEx/+4BM//uATX/7gHL/+4DRv/uA0j/7gBKAAYAEAALABAADQAUAEEAEgBH/+gASP/oAEn/6ABL/+gAVf/oAGEAEwCq/+gAq//oAKz/6ACt/+gArv/oAMr/6ADM/+gAzv/oAND/6ADS/+gA1v/oANj/6ADa/+gA3P/oAN7/6ADg/+gA4v/oAOT/6ADm/+gBFv/oAUb/6AFmABABnP/oAaH/6AGy/+gBs//oAfj/6AIE/+gCB//oAhP/6AIU/+gCF//oAjz/6AJA/+gCRP/oAmv/6AJt/+gCmf/oApv/6AKd/+gCq//oAsP/6ALE/+gCxf/oAs//6AMb/+gDHf/oAx//6AMh/+gDI//oAyX/6AMn/+gDKf/oAz3/6AM//+gDQf/oA0X/6ANwABADcQAQA3MAEAN0ABADdQAQA34AEAN/ABAAAgIF/9YDcf+YAD0AR//sAEj/7ABJ/+wAS//sAFX/7ACq/+wAq//sAKz/7ACt/+wArv/sAMr/7ADM/+wAzv/sAND/7ADS/+wA1v/sANj/7ADa/+wA3P/sAN7/7ADg/+wA4v/sAOT/7ADm/+wBFv/sAUb/7AGc/+wBof/sAbL/7AGz/+wB+P/sAgT/7AIH/+wCE//sAhT/7AIX/+wCPP/sAkD/7AJE/+wCa//sAm3/7AKZ/+wCm//sAp3/7AKr/+wCw//sAsT/7ALF/+wCz//sAxv/7AMd/+wDH//sAyH/7AMj/+wDJf/sAyf/7AMp/+wDPf/sAz//7ANB/+wDRf/sABgAU//iALX/4gC2/+IAt//iALj/4gC5/+IBEP/iARL/4gEU/+IBr//iAbz/4gIB/+ICNv/iAqn/4gKt/+IDL//iAzH/4gMz/+IDNf/iAzf/4gM5/+IDO//iA0P/4gNxABgABgAQ/4QAEv+EA3L/hAN2/4QDev+EA3v/hAAQAC7/7AA5/+wAnP/sAJ3/7ACe/+wAn//sAPf/7AEr/+wBLf/sAS//7AEx/+wBM//sATX/7AHL/+wDRv/sA0j/7AALAFv/zAPW/9cD1/+4A9j/7gPZ/70D3P/yA97/8gPm//ED6v/zA+wAEwP3/7cABABKABQAWAAyAFsAEQNxABAAHgAG//IAC//yAFr/8wBd//MAwP/zAML/8wE6//MBZv/yAaP/8wGt//MCBf/1Agb/8wIh//MCOP/zAjr/8wJx//MCsf/zArP/8wK1//MDVf/zA1f/8wNZ//MDW//zA3D/8gNx//IDc//yA3T/8gN1//IDfv/yA3//8gAIAFv/5QGW/8sBuP/kA9z/7APe/+wD5v/rA+r/7QPsAA0APgAn//MAK//zADP/8wA1//MAiv/zAJX/8wCW//MAl//zAJj/8wCZ//MAm//zAMn/8wDL//MAzf/zAM//8wDf//MA4f/zAOP/8wDl//MBD//zARH/8wET//MBFf/zAUX/8wFS//MBfv/zAYn/8wGQ//MBqwANAcf/8wHh//MB5P/zAiP/8wI1//MCO//zAj3/8wI///MCQf/zAkP/8wJq//MCbP/zAqj/8wKq//MCrP/zAs7/8wMu//MDMP/zAzL/8wM0//MDNv/zAzj/8wM6//MDPP/zAz7/8wNA//MDQv/zA0T/8wNc//MEMf/zBDL/8wQ0//MENf/zAD8AJ//mACv/5gAz/+YANf/mAIr/5gCV/+YAlv/mAJf/5gCY/+YAmf/mAJv/5gDJ/+YAy//mAM3/5gDP/+YA3//mAOH/5gDj/+YA5f/mAQ//5gER/+YBE//mARX/5gFF/+YBUv/mAX7/5gGJ/+YBkP/mAZb/wgGrABABx//mAeH/5gHk/+YCI//mAjX/5gI7/+YCPf/mAj//5gJB/+YCQ//mAmr/5gJs/+YCqP/mAqr/5gKs/+YCzv/mAy7/5gMw/+YDMv/mAzT/5gM2/+YDOP/mAzr/5gM8/+YDPv/mA0D/5gNC/+YDRP/mA1z/5gQx/+YEMv/mBDT/5gQ1/+YANwAl/+QAPP/SAD3/0wCD/+QAhP/kAIX/5ACG/+QAh//kAIj/5ACg/9MAw//kAMX/5ADH/+QBOf/TATv/0wFO/+QBef/kAX//0wGC/+QBhf/kAYz/5AGV/9MBl//SAZv/0wGr/+IB0//kAdn/0gHo/9ICKf/kAlj/0gJw/9MCcv/TAnT/0gKD/9ICkv/kApT/5AKe/9ICvv/SAtb/5AMC/+QDBP/kAwb/5AMI/+QDCv/kAwz/5AMO/+QDEP/kAxL/5AMU/+QDFv/kAxj/5ANU/9MDVv/TA1j/0wNa/9MAJwAQ/0YAEv9GACX/zQCD/80AhP/NAIX/zQCG/80Ah//NAIj/zQDD/80Axf/NAMf/zQFO/80Bef/NAYL/zQGF/80BjP/NAbH/8gHT/80CKf/NApL/zQKU/80C1v/NAwL/zQME/80DBv/NAwj/zQMK/80DDP/NAw7/zQMQ/80DEv/NAxT/zQMW/80DGP/NA3L/RgN2/0YDev9GA3v/RgABAasADgCvAEf/3ABI/9wASf/cAEv/3ABR/8EAUv/BAFP/1gBU/8EAVf/cAFn/3QBa/+EAXf/hAKr/3ACr/9wArP/cAK3/3ACu/9wAtP/BALX/1gC2/9YAt//WALj/1gC5/9YAvP/dAL3/3QC+/90Av//dAMD/4QDC/+EAyv/cAMz/3ADO/9wA0P/cANL/3ADW/9wA2P/cANr/3ADc/9wA3v/cAOD/3ADi/9wA5P/cAOb/3AEH/8EBCf/BAQv/wQEM/8EBEP/WARL/1gEU/9YBFv/cASz/3QEu/90BMP/dATL/3QE0/90BNv/dATr/4QFG/9wBSP/dAZz/3AGe/8EBoP/dAaH/3AGj/+EBpf/mAaf/wQGo/+sBqf/pAa3/4QGu//ABr//WAbD/5wGy/9wBs//cAbT/4wG1/90Btv/OAbj/1AG5/9sBu//dAbz/1gG9/90B9v/BAfj/3AH7/8EB/P/BAf3/wQH//8ECAP/BAgH/1gIC/8ECA//BAgT/3AIG/+ECB//cAgn/wQIL/8ECDP/BAg//wQIR/8ECE//cAhT/3AIW/8ECF//cAh3/wQIf/8ECIP/BAiH/4QI2/9YCOP/hAjr/4QI8/9wCQP/cAkT/3AJN/8ECXf/BAmX/wQJn/8ECa//cAm3/3AJx/+ECiv/BAoz/wQKQ/8ECmf/cApv/3AKd/9wCpf/BAqf/wQKp/9YCq//cAq3/1gKx/+ECs//hArX/4QK5/8ECu//BAr3/wQLD/9wCxP/cAsX/3ALP/9wC5//BAxv/3AMd/9wDH//cAyH/3AMj/9wDJf/cAyf/3AMp/9wDL//WAzH/1gMz/9YDNf/WAzf/1gM5/9YDO//WAz3/3AM//9wDQf/cA0P/1gNF/9wDR//dA0n/3QNL/90DTf/dA0//3QNR/90DU//dA1X/4QNX/+EDWf/hA1v/4QB2AAb/2gAL/9oAR//wAEj/8ABJ//AAS//wAFX/8ABZ/+8AWv/cAF3/3ACq//AAq//wAKz/8ACt//AArv/wALz/7wC9/+8Avv/vAL//7wDA/9wAwv/cAMr/8ADM//AAzv/wAND/8ADS//AA1v/wANj/8ADa//AA3P/wAN7/8ADg//AA4v/wAOT/8ADm//ABFv/wASz/7wEu/+8BMP/vATL/7wE0/+8BNv/vATr/3AFG//ABSP/vAWb/2gGc//ABoP/vAaH/8AGj/9wBqP/sAasADwGt/9wBsP/qAbL/8AGz//ABtP/OAbX/7wG2/+cBu//vAb3/7wH4//ACBP/wAgb/3AIH//ACE//wAhT/8AIX//ACIf/cAjj/3AI6/9wCPP/wAkD/8AJE//ACa//wAm3/8AJx/9wCmf/wApv/8AKd//ACq//wArH/3AKz/9wCtf/cAsP/8ALE//ACxf/wAs//8AMb//ADHf/wAx//8AMh//ADI//wAyX/8AMn//ADKf/wAz3/8AM///ADQf/wA0X/8ANH/+8DSf/vA0v/7wNN/+8DT//vA1H/7wNT/+8DVf/cA1f/3ANZ/9wDW//cA3D/2gNx/9oDc//aA3T/2gN1/9oDfv/aA3//2gBEABAADAASAAwAR//nAEj/5wBJ/+cAS//nAFX/5wCq/+cAq//nAKz/5wCt/+cArv/nAMr/5wDM/+cAzv/nAND/5wDS/+cA1v/nANj/5wDa/+cA3P/nAN7/5wDg/+cA4v/nAOT/5wDm/+cBFv/nAUb/5wGc/+cBof/nAasADwGy/+cBs//nAfj/5wIE/+cCB//nAhP/5wIU/+cCF//nAjz/5wJA/+cCRP/nAmv/5wJt/+cCmf/nApv/5wKd/+cCq//nAsP/5wLE/+cCxf/nAs//5wMb/+cDHf/nAx//5wMh/+cDI//nAyX/5wMn/+cDKf/nAz3/5wM//+cDQf/nA0X/5wNyAAwDdgAMA3oADAN7AAwABgG0/+oB9//uAgX/1QIP/+0CY//sAtH/7AABAgX/wAABAbQAIAB+AAYADAALAAwAR//oAEj/6ABJ/+gASgAMAEv/6ABT/+oAVf/oAFoACwBdAAsAqv/oAKv/6ACs/+gArf/oAK7/6AC1/+oAtv/qALf/6gC4/+oAuf/qAMAACwDCAAsAyv/oAMz/6ADO/+gA0P/oANL/6ADW/+gA2P/oANr/6ADc/+gA3v/oAOD/6ADi/+gA5P/oAOb/6AEQ/+oBEv/qART/6gEW/+gBOgALAUb/6AFmAAwBnP/oAaH/6AGjAAsBq/+QAa0ACwGv/+oBsAALAbL/6AGz/+gBtAAMAbz/6gH4/+gCAf/qAgT/6AIGAAsCB//oAhP/6AIU/+gCF//oAiEACwI2/+oCOAALAjoACwI8/+gCQP/oAkT/6AJr/+gCbf/oAnEACwKZ/+gCm//oAp3/6AKp/+oCq//oAq3/6gKxAAsCswALArUACwLD/+gCxP/oAsX/6ALP/+gDG//oAx3/6AMf/+gDIf/oAyP/6AMl/+gDJ//oAyn/6AMv/+oDMf/qAzP/6gM1/+oDN//qAzn/6gM7/+oDPf/oAz//6ANB/+gDQ//qA0X/6ANVAAsDVwALA1kACwNbAAsDcAAMA3EADANzAAwDdAAMA3UADAN+AAwDfwAMA9cADQPZAA4D2v/1A9z/7APe/+0D5v/sA+r/7gPs/78D9wANAAECBf/iAA0AXP/tAF7/7QE9/+0BP//tAUH/7QH5/+0CBf/AAgj/7QJZ/+0Cdf/tAoT/7QKf/+0Cv//tAAwAXP/yAF7/8gE9//IBP//yAUH/8gH5//ICCP/yAln/8gJ1//IChP/yAp//8gK///IAHwBa//QAXP/yAF3/9ABe//MAwP/0AML/9AE6//QBPf/zAT//8wFB//MBo//0Aa3/9AH5//ICBv/0Agj/8gIh//QCOP/0Ajr/9AJZ//ICcf/0AnX/8gKE//ICn//yArH/9AKz//QCtf/0Ar//8gNV//QDV//0A1n/9ANb//QAXQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBa/+YAXP/vAF3/5gCg/9MAwP/mAML/5gEl/9IBJ//SATn/0wE6/+YBO//TAWL/0gFm/8oBf//TAZX/0wGX//QBm//TAaP/5gGt/+YBxf/SAc7/0gHR/+0B2f/0AeX/0gHm/+0B6P/0Aer/4QHv/9QB+f/vAgX/yQIG/+YCCP/vAg//0QIh/+YCJP/lAjf/1AI4/+YCOf/UAjr/5gJC/+MCWP/0Aln/7wJi/9ICY//EAm7/0gJw/9MCcf/mAnL/0wJ0//QCdf/vAnb/0gJ4/+ECev/hAoP/9AKE/+8Cjf/hAp7/9AKf/+8CsP/tArH/5gKy/+0Cs//mArT/7QK1/+YCtv/hAr7/9AK//+8Cxv/UAsf/9QLI/+cC0P9kAtH/yQNU/9MDVf/mA1b/0wNX/+YDWP/TA1n/5gNa/9MDW//mA3D/ygNx/8oDc//KA3T/ygN1/8oDfv/KA3//ygBsAAb/wAAL/8AAOP+dADr/xwA8//AAPf+rAFH/0gBS/9IAVP/SAKD/qwC0/9IBB//SAQn/0gEL/9IBDP/SASX/nQEn/50BOf+rATv/qwFi/50BZv/AAX//qwGV/6sBl//wAZv/qwGe/9IBp//SAcX/nQHM//UBzv+dAdH/6gHZ//AB3v/1AeX/nQHm/+oB6P/wAer/5QHv/8EB9v/SAfv/0gH8/9IB/f/SAf//0gIA/9ICAv/SAgP/0gIF/80CCf/SAgv/0gIM/9ICD//SAhH/0gIW/9ICHf/SAh//0gIg/9ICN//HAjn/xwJN/9ICWP/wAl3/0gJi/50CY//MAmX/0gJn/9ICbv+dAnD/qwJy/6sCdP/wAnb/nQJ4/+UCev/lAn7/3wKD//ACh//1Aor/0gKM/9ICjf/lApD/0gKe//ACpf/SAqf/0gKw/+oCsv/qArT/6gK2/+UCuf/SArv/0gK9/9ICvv/wAsb/zgLI/+oCyv/1AtD/ngLR/84C1P/1Auf/0gNU/6sDVv+rA1j/qwNa/6sDcP/AA3H/wANz/8ADdP/AA3X/wAN+/8ADf//AAG8ABv+xAAv/sQA4/54AOv/FADz/8gA9/6gAUf/PAFL/zwBU/88AXP/vAKD/qAC0/88BB//PAQn/zwEL/88BDP/PASX/ngEn/54BOf+oATv/qAFi/54BZv+xAX//qAGV/6gBl//yAZv/qAGe/88Bp//PAcX/ngHO/54B0f/sAdn/8gHl/54B5v/sAej/8gHq/+EB7//CAfb/zwH5/+8B+//PAfz/zwH9/88B///PAgD/zwIC/88CA//PAgX/xgII/+8CCf/PAgv/zwIM/88CD//PAhH/zwIW/88CHf/PAh//zwIg/88CN//FAjn/xQJN/88CWP/yAln/7wJd/88CYv+eAmP/wAJl/88CZ//PAm7/ngJw/6gCcv+oAnT/8gJ1/+8Cdv+eAnj/4QJ6/+ECfv/fAoP/8gKE/+8Civ/PAoz/zwKN/+ECkP/PAp7/8gKf/+8Cpf/PAqf/zwKw/+wCsv/sArT/7AK2/+ECuf/PArv/zwK9/88Cvv/yAr//7wLG/80CyP/oAtD/nwLR/8YC5//PA1T/qANW/6gDWP+oA1r/qANw/7EDcf+xA3P/sQN0/7EDdf+xA37/sQN//7EATQA4/74AUf/hAFL/4QBU/+EAWv/vAF3/7wC0/+EAwP/vAML/7wEH/+EBCf/hAQv/4QEM/+EBJf++ASf/vgE6/+8BYv++AZ7/4QGj/+8Bp//hAa3/7wHF/74Bzv++AeX/vgHv/8kB9v/hAfv/4QH8/+EB/f/hAf//4QIA/+ECAv/hAgP/4QIF/98CBv/vAgn/4QIL/+ECDP/hAg//4QIR/+ECFv/hAh3/4QIf/+ECIP/hAiH/7wIk/+0COP/vAjr/7wJC/+sCTf/hAl3/4QJi/74CY//fAmX/4QJn/+ECbv++AnH/7wJ2/74Cfv/pAor/4QKM/+ECkP/hAqX/4QKn/+ECsf/vArP/7wK1/+8Cuf/hArv/4QK9/+ECx//1AtH/4ALn/+EDVf/vA1f/7wNZ/+8DW//vAGQAOP/mADr/5wA8//IAPf/nAFH/1gBS/9YAVP/WAFz/8QCg/+cAtP/WAQf/1gEJ/9YBC//WAQz/1gEl/+YBJ//mATn/5wE7/+cBYv/mAX//5wGV/+cBl//yAZv/5wGe/9YBp//WAcX/5gHO/+YB0f/uAdn/8gHl/+YB5v/uAej/8gHq/+gB7//mAfb/1gH5//EB+//WAfz/1gH9/9YB///WAgD/1gIC/9YCA//WAgX/0AII//ECCf/WAgv/1gIM/9YCD//WAhH/1gIW/9YCHf/WAh//1gIg/9YCN//nAjn/5wJN/9YCWP/yAln/8QJd/9YCYv/mAmP/zgJl/9YCZ//WAm7/5gJw/+cCcv/nAnT/8gJ1//ECdv/mAnj/6AJ6/+gCg//yAoT/8QKK/9YCjP/WAo3/6AKQ/9YCnv/yAp//8QKl/9YCp//WArD/7gKy/+4CtP/uArb/6AK5/9YCu//WAr3/1gK+//ICv//xAsb/5wLI/+0C0P/mAtH/0ALn/9YDVP/nA1b/5wNY/+cDWv/nAAICLQALAtD/5gCTACUAEAAn/+gAK//oADP/6AA1/+gAOP/gADr/4AA9/98AgwAQAIQAEACFABAAhgAQAIcAEACIABAAiv/oAJX/6ACW/+gAl//oAJj/6ACZ/+gAm//oAKD/3wDDABAAxQAQAMcAEADJ/+gAy//oAM3/6ADP/+gA3//oAOH/6ADj/+gA5f/oAQ//6AER/+gBE//oARX/6AEl/+ABJ//gATn/3wE7/98BRf/oAU4AEAFS/+gBYv/gAXkAEAF+/+gBf//fAYIAEAGFABABif/oAYwAEAGQ/+gBlf/fAZv/3wHF/+ABx//oAcwAEAHO/+AB0wAQAdcAFAHeABAB4f/oAeT/6AHl/+AB6v/hAe//4AH3ABMB/gAQAgr/4AIcABACI//oAikAEAI1/+gCN//gAjn/4AI7/+gCPf/oAj//6AJB/+gCQ//oAmL/4AJq/+gCbP/oAm7/4AJw/98Ccv/fAnb/4AJ4/+ECef/gAnr/4QJ7/+ACf//hAocAEAKIABACjf/hAo7/4AKSABAClAAQApr/6QKo/+gCqv/oAqz/6AK2/+ECt//gAsb/3wLI/94CygAQAs7/6ALQ/98C0v/yAtQAEALVABAC1gAQAwIAEAMEABADBgAQAwgAEAMKABADDAAQAw4AEAMQABADEgAQAxQAEAMWABADGAAQAy7/6AMw/+gDMv/oAzT/6AM2/+gDOP/oAzr/6AM8/+gDPv/oA0D/6ANC/+gDRP/oA1T/3wNW/98DWP/fA1r/3wNc/+gEMf/oBDL/6AQ0/+gENf/oADIAG//yADj/8QA6//QAPP/0AD3/8ACg//ABJf/xASf/8QE5//ABO//wAWL/8QF///ABlf/wAZf/9AGb//ABxf/xAcz/9QHO//EB0f/zAdn/9AHe//UB5f/xAeb/8wHo//QB7//xAjf/9AI5//QCWP/0AmL/8QJu//ECcP/wAnL/8AJ0//QCdv/xAoP/9AKH//UCnv/0ArD/8wKy//MCtP/zAr7/9ALG//ICyP/yAsr/9QLQ//IC1P/1A1T/8ANW//ADWP/wA1r/8AAIAFgADgCJ/tcBq/+YAbH/xwHX/xIB9/9SAsL/zwPs/4AAZgAlAA8AOP/mADr/5gA8AA4APf/mAIMADwCEAA8AhQAPAIYADwCHAA8AiAAPAKD/5gDDAA8AxQAPAMcADwEl/+YBJ//mATn/5gE7/+YBTgAPAWL/5gF5AA8Bf//mAYIADwGFAA8BjAAPAZX/5gGXAA4Bm//mAcX/5gHMAA4Bzv/mAdEACwHTAA8B1wATAdkADgHeAA4B5f/mAeYACwHoAA4B6v/lAe//5gHw//QB9wASAf4ADwIF/+cCCv/oAg//5wIcAA8CKQAPAjf/5gI5/+YCWAAOAmL/5gJj/+cCbv/mAnD/5gJy/+YCdAAOAnb/5gJ4/+UCef/oAnr/5QJ7/+gCgwAOAocADgKIAA8Cjf/lAo7/6AKSAA8ClAAPAp4ADgKwAAsCsgALArQACwK2/+UCt//oAr4ADgLG/+YCyP/mAsoADgLQ/+YC0f/nAtQADgLVAA8C1gAPAwIADwMEAA8DBgAPAwgADwMKAA8DDAAPAw4ADwMQAA8DEgAPAxQADwMWAA8DGAAPA1T/5gNW/+YDWP/mA1r/5gA3AAb/vwAL/78AOP+fADr/yQA9/60AoP+tASX/nwEn/58BOf+tATv/rQFi/58BZv+/AX//rQGV/60Bm/+tAcX/nwHO/58B0f/sAeX/nwHm/+wB6v/mAe//xAIF/80CD//VAjf/yQI5/8kCYv+fAmP/zAJu/58CcP+tAnL/rQJ2/58CeP/mAnr/5gJ+/98Cjf/mArD/7AKy/+wCtP/sArb/5gLG/9ECyP/sAtD/oQLR/88DVP+tA1b/rQNY/60DWv+tA3D/vwNx/78Dc/+/A3T/vwN1/78Dfv+/A3//vwAwADj/4wA8/+UAPf/kAKD/5AEl/+MBJ//jATn/5AE7/+QBYv/jAX//5AGV/+QBl//lAZv/5AHF/+MBzP/lAc7/4wHR/+kB1//iAdn/5QHe/+UB5f/jAeb/6QHo/+UB/v/qAhz/6gJY/+UCYv/jAm7/4wJw/+QCcv/kAnT/5QJ2/+MCg//lAof/5QKI/+oCnv/lArD/6QKy/+kCtP/pAr7/5QLK/+UC0P/kAtT/5QLV/+oDVP/kA1b/5ANY/+QDWv/kACMAOP/iADz/5AEl/+IBJ//iAWL/4gGX/+QBxf/iAcz/5AHO/+IB0f/pAdf/4QHZ/+QB3v/kAeX/4gHm/+kB6P/kAff/5AH+/+sCHP/rAlj/5AJi/+ICbv/iAnT/5AJ2/+ICg//kAof/5AKI/+sCnv/kArD/6QKy/+kCtP/pAr7/5ALK/+QC1P/kAtX/6wAXADj/6wA9//MAoP/zASX/6wEn/+sBOf/zATv/8wFi/+sBf//zAZX/8wGb//MBxf/rAc7/6wHl/+sCYv/rAm7/6wJw//MCcv/zAnb/6wNU//MDVv/zA1j/8wNa//MANgBR/+8AUv/vAFT/7wBc//AAtP/vAQf/7wEJ/+8BC//vAQz/7wGe/+8Bp//vAfb/7wH3/+4B+f/wAfv/7wH8/+8B/f/vAf//7wIA/+8CAv/vAgP/7wIF/+4CCP/wAgn/7wIL/+8CDP/vAg//7wIR/+8CFv/vAh3/7wIf/+8CIP/vAiT/9AJC//ECTf/vAln/8AJd/+8CY//vAmX/7wJn/+8Cdf/wAoT/8AKK/+8CjP/vApD/7wKf//ACpf/vAqf/7wK5/+8Cu//vAr3/7wK///AC0f/vAuf/7wAiAAb/8gAL//IAWv/1AF3/9QDA//UAwv/1ATr/9QFm//IBo//1Aa3/9QIF//QCBv/1Ag//9AIh//UCJP/1Ajj/9QI6//UCY//1AnH/9QKx//UCs//1ArX/9QLR//UDVf/1A1f/9QNZ//UDW//1A3D/8gNx//IDc//yA3T/8gN1//IDfv/yA3//8gAyAFH/7gBS/+4AVP/uALT/7gEH/+4BCf/uAQv/7gEM/+4Bnv/uAaf/7gH2/+4B9wAUAfv/7gH8/+4B/f/uAf//7gIA/+4CAv/uAgP/7gIF/+0CCf/uAgr/7QIL/+4CDP/uAg3/0AIP/+4CEf/uAhb/7gId/+4CH//uAiD/7gJN/+4CXf/uAmP/7QJl/+4CZ//uAnn/7QJ7/+0Civ/uAoz/7gKO/+0CkP/uAqX/7gKn/+4Ct//tArn/7gK7/+4Cvf/uAtH/7QLn/+4ACgAG//UAC//1AWb/9QNw//UDcf/1A3P/9QN0//UDdf/1A37/9QN///UAWQBH//AASP/wAEn/8ABL//AAU//HAFX/8ACq//AAq//wAKz/8ACt//AArv/wALX/xwC2/8cAt//HALj/xwC5/8cAyv/wAMz/8ADO//AA0P/wANL/8ADW//AA2P/wANr/8ADc//AA3v/wAOD/8ADi//AA5P/wAOb/8AEQ/8cBEv/HART/xwEW//ABRv/wAZz/8AGh//ABr//HAbL/8AGz//ABvP/HAfj/8AIB/8cCBP/wAgf/8AIT//ACFP/wAhf/8AI2/8cCPP/wAj7/6wJA//ACRP/wAmv/8AJt//ACmf/wApv/8AKd//ACqf/HAqv/8AKt/8cCw//wAsT/8ALF//ACz//wAxv/8AMd//ADH//wAyH/8AMj//ADJf/wAyf/8AMp//ADL//HAzH/xwMz/8cDNf/HAzf/xwM5/8cDO//HAz3/8AM///ADQf/wA0P/xwNF//AD3P/rA97/6wPm/+kD6v/rAKEABgANAAsADQBF//AAR//AAEj/wABJ/8AASgANAEv/wABT/+IAVf/AAFoACwBdAAsAo//wAKT/8ACl//AApv/wAKf/8ACo//AAqv/AAKv/wACs/8AArf/AAK7/wAC1/+IAtv/iALf/4gC4/+IAuf/iAMAACwDCAAsAxP/wAMb/8ADI//AAyv/AAMz/wADO/8AA0P/AANL/wADW/8AA2P/AANr/wADc/8AA3v/AAOD/wADi/8AA5P/AAOb/wAEQ/+IBEv/iART/4gEW/8ABOgALAUb/wAFP//ABZgANAZz/wAGh/8ABowALAa0ACwGv/+IBsf/WAbL/wAGz/8ABtv/VAbz/4gHz//AB9//IAfj/wAH+/9cCAf/iAgT/wAIGAAsCB//AAhP/wAIU/8ACF//AAhz/1wIhAAsCNv/iAjgACwI6AAsCPP/AAj7/7AJA/8ACQgAMAkT/wAJr/8ACbf/AAnEACwKI/9cCk//wApX/8AKZ/8ACm//AAp3/wAKp/+ICq//AAq3/4gKxAAsCswALArUACwLD/8ACxP/AAsX/wALHAAsCyQALAs//wALV/9cC1//wAwP/8AMF//ADB//wAwn/8AML//ADDf/wAw//8AMR//ADE//wAxX/8AMX//ADGf/wAxv/wAMd/8ADH//AAyH/wAMj/8ADJf/AAyf/wAMp/8ADL//iAzH/4gMz/+IDNf/iAzf/4gM5/+IDO//iAz3/wAM//8ADQf/AA0P/4gNF/8ADVQALA1cACwNZAAsDWwALA3AADQNxAA0DcwANA3QADQN1AA0DfgANA38ADQPXAA0D2QAOA9r/9QPc/+wD3v/tA+b/7APq/+4D7P+/A/cADQAPAfcAFAH+ABACBf/wAgr/8AIP//ACEgAWAhwAEAJj/+YCef/wAnv/3AKIABACjv/wArf/8ALR//AC1QAQAEwAR//uAEj/7gBJ/+4AS//uAFX/7gCq/+4Aq//uAKz/7gCt/+4Arv/uAMr/7gDM/+4Azv/uAND/7gDS/+4A1v/uANj/7gDa/+4A3P/uAN7/7gDg/+4A4v/uAOT/7gDm/+4BFv/uAUb/7gGc/+4Bof/uAbL/7gGz/+4B9wASAfj/7gH+AA4CBP/uAgX/4wIH/+4CCv/jAg3/uAIP/+MCE//uAhT/7gIX/+4CHAAOAjz/7gJA/+4CRP/uAmP/ugJr/+4Cbf/uAnn/4wJ7/9kCiAAOAo7/4wKZ/+4Cm//uAp3/7gKr/+4Ct//jAsP/7gLE/+4Cxf/uAs//7gLR/+MC1QAOAxv/7gMd/+4DH//uAyH/7gMj/+4DJf/uAyf/7gMp/+4DPf/uAz//7gNB/+4DRf/uACAAWv/AAF3/wADA/8AAwv/AATr/wAGj/8ABrf/AAgX/gAIG/8ACCv/uAg//8AIh/8ACJP/bAjj/wAI6/8ACQv/cAmP/RwJx/8ACef/uAnv/7gKO/+4Csf/AArP/wAK1/8ACt//uAscABwLJ//QC0f9/A1X/wANX/8ADWf/AA1v/wAAhAFr/9ABc//AAXf/0AMD/9ADC//QBOv/0AaP/9AGt//QB9//vAfn/8AH+//MCBv/0Agj/8AIP/+4CHP/zAiH/9AI4//QCOv/0Aln/8AJx//QCdf/wAoT/8AKI//MCn//wArH/9AKz//QCtf/0Ar//8ALV//MDVf/0A1f/9ANZ//QDW//0AAoABv/WAAv/1gFm/9YDcP/WA3H/1gNz/9YDdP/WA3X/1gN+/9YDf//WABUAXP/gAfn/4AIF/3YCCP/gAgr/wgIP/9MCJP/ZAkL/2wJZ/+ACY/8eAnX/4AJ5/8ICe//tAoT/4AKO/8ICn//gArf/wgK//+ACx//wAsn/8gLR/1YADQIF/2QCCv/SAg//2QIk/9kCQv/bAmP/HgJ5/9ICe//tAo7/0gK3/9ICx//wAsn/8gLR/1YACgHv/8MCBf/PAg//1AJj/84Cev/nAn7/3wLG/9ECyP/sAtD/oALR/9EACQIF/2oCD//GAiT/2QJC/9sCY/8eAnv/7QLH//ACyf/yAtH/VgAJAA0AFABBABEAVv/iAGEAEwPc/9kD3v/ZA+b/2QPq/9kD7P+0AAoABv/XAAv/1wFm/9cDcP/XA3H/1wNz/9cDdP/XA3X/1wN+/9cDf//XABQAW//BAZb/xQG0/7QB9P/XAgX/uQIP/+kCJP+yAj7/0gJC/8gCY/+gAnv/xQKa/+QCx//MAsn/zALR/8sC0v/vA9z/5wPe/+cD5v/mA+r/6AA6AAT/xABW/78AW//RAG7/bAB+/24Aif9DAKn/rAC7/6EBlv+4AaX/fgGp/3sBsP+bAbH/eQG0/7IBtv9+Abj/fQG5/3wB1/+vAe8ADwH0/+QB9f+gAff/dAH6/4ACBf+yAg7/fQIP/7ICEP+AAhL/eQIVACgCIv99AiT/fwI+/2YCQv/aAlH/gQJT/5gCX/99AmP/swJp/6ACe/98An7/mgJ//2wCmv/mAsL/awLH/5ICyf+tAs3/ewLQAA8C0f+RAtL/8gPW//ED2f/xA9r/vAPc/7kD3v+5A+b/uQPq/7kD7P+vA/b/7QAGAbT/6gH3/+4CBf/WAg//7QJj/+wC0f/sABIB1/+uAe8AEgH1/+AB9/+tAfr/1gIO/98CEv/SAiL/4AI+/84CUf/dAlP/4gJf/+ACaf/gAnv/6QJ//9oCwv+9As3/3wLQABEAMABW/34AW/+dAG7+8QB+/vQAif6rAKn/XgC7/0sBlv9yAaX/DwGp/woBsP9BAbH/BwG0/2gBtv8PAbj/DgG5/wwB1/9jAe8ABQH0/70B9f9JAff+/gH6/xMCBf9oAg7/DgIP/2gCEP8TAhL/BwIVADACIv8OAiT/EQI+/ucCQv+sAlH/FQJT/zwCX/8OAmP/agJp/0kCe/8MAn7/PwJ//vECmv/AAsL+7wLH/zECyf9fAs3/CgLQAAUC0f8wAtL/1QACAff/aAI+/+4AFwGW/9QBqP/tAasAEQG0/+ABtv/nAbj/5QG5/+4B1wASAfT/6QIF/9cCY//XAnv/0wJ+/9YCf//FApr/5wLGAA0CyAAMAtH/1gLS//ID3P/pA97/5wPm/+cD6v/pAAECPv/xAAICBf/WA3H/iAAJAA0ADwBBAAwAVv/rAGEADgPc/+cD3v/nA+b/5wPq/+kD7P/LAB0AI/+vAFj/7wBb/98BR//uAZb/5QGY/9EBqwARAbT/yAHXABMB7//FAgX/ygIP/9ACY/+BAnr/ZQJ7/4UCfv9mAn//3QKa//ICxv+xAsj/ygLQ/6kC0f/IA9b/3QPX/80D2P/xA9n/xwPe//UD5v/1A/f/xAAIAgX/8AIP//ACJP/xAkL/8wJj//ECx//zAsn/8wLR//EABQBK/+4AW//qA9b/7QPX//AD9//wAAICBf/1A3H/wAAIAdcAFQH3ABUCev/kAnv/5QJ+/+QCxv/jAsj/4gLQ/+QACQG0/+oB9/+4AgX/4gIk//ACQv/xAmP/6wLH//UC0f/sA3H/kAABA+z/6wAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbv+uAH7/zQCJ/6AAqf/BALv/wAGW/9ABov/qAaX/xgGmAA0BqP/pAan/1gGw/+gBsf+6AbT/6QG2/8sBuP/aAbn/xwN5/9MD1v/zA9n/8wPc/8sD3v/LA+b/ywPq/80D7P+rA/b/7wAGAEoADQGwAAsBsf/qAbQADAH3/8gCPv/xAFwAR/+YAEj/mABJ/5gAS/+YAFP/cABV/5gAV/8YAFsACwCq/5gAq/+YAKz/mACt/5gArv+YALX/cAC2/3AAt/9wALj/cAC5/3AAyv+YAMz/mADO/5gA0P+YANL/mADW/5gA2P+YANr/mADc/5gA3v+YAOD/mADi/5gA5P+YAOb/mAEQ/3ABEv9wART/cAEW/5gBHv8YASD/GAEi/xgBJP8YAUb/mAFh/xgBnP+YAaH/mAGv/3ABsv+YAbP/mAG8/3AB+P+YAgH/cAIE/5gCB/+YAhP/mAIU/5gCF/+YAhj/GAI2/3ACPP+YAkD/mAJE/5gCa/+YAm3/mAKZ/5gCm/+YAp3/mAKp/3ACq/+YAq3/cALD/5gCxP+YAsX/mALP/5gDG/+YAx3/mAMf/5gDIf+YAyP/mAMl/5gDJ/+YAyn/mAMv/3ADMf9wAzP/cAM1/3ADN/9wAzn/cAM7/3ADPf+YAz//mANB/5gDQ/9wA0X/mAABAFsACwACA9cADQP3AA0ABAPW//UD1//xA9n/8gP3/+4ABAPW//ED1//rA9n/6QP3/+UABAPX//ED2f/uA/b/7AP3/+oABwPW/9UD1/+3A9j/7APZ/7sD3P/wA97/7wP3/7QAAgPc/+sD3v/rAAID1v/1A9f/7gAJA9b/2APX/8cD2P/sA9n/wAPc//ID3v/yA+b/8gPq//ID9/+/AAQADf/mAEH/9ABh/+8Cf//tAAkAif/fAY//8wGT//ABq//qAdf/3wHv/+AC0P/gA+z/7QP2//UAAgeKAAQAAAqkEqAAIQAdAAD/2/+I/87/xf/s/6X/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/uMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+IAAAAAAAA/9D/9AAA/+v/iP/v/7P/2f9q//X/zgAMABH/yQAS/98AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAP/oAAD/yQAAAAAAAAAAAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+sAAAAAAAAAAAAAAAD/qwAA/+oAAP/VAAAAAAAA/+EAAAAAAAAAAP+G/+r/6QAAAAAAAAAAAAAAAAAAAAD/7QAA/+0AAAAAABQAAAAAAAAAAP/v/+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEgAAAAAAAAAAAAAAAP/jAAAAAAAA/+QAAAAAAAAAEf/kABH/5QAAAAAAEQAAAAAAAAAAAAAAAAAA/+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/5gAA/+UAAP/hAAAAAAAAAAAAAP/p/9gAAAAAAAAAAP+jAAAAAAAAAAD/XAAAAAAAAAAA/uAAEwAAAAAAAAAAAAD/wP8z/+j/Mv+j/un/8v+FAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/07/9f/zAAD/8wAAAAAAAAAAAAAAAAAAAAAADwAA/28AAP+nAAAAAP5s/83/3AAA/0gAAAAAAAAAAP+I/1j/p/+n/zD/tP/kABAAAAAQAA8AEP+//67/xP/LAAD/fv98AAD+/gAAAAD+8P8o//D/swAAAAD/tf/S/9QAAP/SAAD/8wAAAAAAAAAAAAD/5P/1AAAAAAAAAAAAAAAA/ykAAAAA/2MAAAAAAAAAAAAA/9X/3//hAAD/4QAAAAAADgAAAAAAAAAA/+0AAAAAAAAAAAAAAAAAAP9xAAAAAP/EAAAAAAAAAAAAAAAAAAD/5gAA/+sAAP/nAAAAAAAOAAAAAP/r/+EAAAARAAAAEf/RAAAAAAAAAAD/ZAAAAAAAAAAAAAD/av/B/7//2P+//8b/4wAR/6AAEgARABL/2f/s/+IAAAAAAAAAAAAA/xkADQAA/2j/oP/w/+kAAAAAAA0AAP/rAAD/6wAA/+YAAAAAAAAAAAAA/+3/5QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1//EAAAAA//IAAAAAAAAAAAAAAAAAAAAA//EAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8f/wAAAAAP/wAAAAAAAAAAAAAAAAAAAAAP/rAAAAEAAA/+L/7QAA/9wAAAAAAAAAAAAAAAAAAAAAABIAAAAAAAAAAAAAAAD/UwAAAAAAAAAAAAAAAAAAAA8AAP/x//MAAP/xAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAA/1kAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAD/2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAA//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/M/9f/1X/Vf9m/2v/vQAHAAAABwAFAAf/fv9h/4b/kgAA/w//DAAA/jYAAAAA/h4AAP/R/2oAAP/AAAAAAAAAAAAAAAAAAAD/nwAA/8gAAP+tAAAAAAAAAAD/5wAAAAD/6wAAAAAAAAAAAAAAAP/JAAAAAP+l/6//vf+u/73/0v/pABIAAAAAAAAAEgAAAAAAAP/KAAD/u//pAAD+dwAAAAD/OQAAAAAAAAAAAAAAAAAA/+wAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/tQAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAP/rAAEBiwAGAAsAEAASACUAJgAnACgAKQAsAC0ALgAvADAAMQAyADMANAA4ADkAOgA7ADwAPQA+AEUARgBHAEkATABRAFIAUwBUAFYAWgBcAF0AXgCDAIQAhQCGAIcAiACKAIsAjACNAI4AjwCQAJEAkgCTAJQAlQCWAJcAmACZAJwAnQCeAJ8AoACjAKQApQCmAKcAqACqAKsArACtAK4AtAC1ALYAtwC4ALkAwADBAMIAwwDEAMUAxgDHAMgAyQDKAMsAzADNAM4AzwDQANEA0wDVANYA1wDYANkA2gDbANwA3QDeAOcA6ADrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEHAQgBCQEKAQsBDAEPARABEQESARMBFAEYARoBHAElAScBKQErAS0BLwExATMBNQE3ATkBOgE7ATwBPQE+AT8BQAFBAU4BTwFiAWYBeQF7AXwBfQF+AX8BggGDAYQBhQGGAYcBiAGJAYoBiwGMAY0BjgGQAZIBlAGVAZcBmgGbAZ4BowGnAa0BrwGxAbwBwwHEAcYByQHKAcsBzAHNAc8B0QHSAdMB1QHWAdgB2QHbAd0B3gHfAeAB4QHjAeQB5QHmAegB6QHrAe0B7wHzAfYB+AH5AgECAwIEAgYCBwIIAg0CDwIQAhMCFAIWAhwCHQIhAiUCJgIpAjYCNwI4AjkCOgJRAlICUwJUAlgCWQJcAl4CYAJiAmQCbAJtAm4CcAJxAnICdAJ1An0CggKDAoQCiwKPApECkgKTApQClQKYApkCmwKdAp4CnwKoAqkCrQKvArACsQKyArMCtAK1ArgCuQK9Ar4CvwLWAtcC5gLnAvgC+gL8AwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMsAy4DLwMwAzEDMgMzAzQDNQM2AzcDOAM5AzoDOwNDA0YDSANUA1UDVgNXA1gDWQNaA1sDXANwA3EDcgNzA3QDdQN2A3oDewN+A38EMQQzBDQAAgFUABAAEAABABIAEgABACUAJQACACYAJgADACcAJwAEACgAKAAFACkAKQAGACwALQAHAC4ALgAIAC8ALwAJADAAMAAKADEAMgAHADMAMwAFADQANAALADgAOAAMADkAOQAIADoAOgANADsAOwAOADwAPAAPAD0APQAQAD4APgARAEUARQASAEYARgATAEcARwAUAEkASQAVAEwATAAWAFEAUgAWAFMAUwAXAFQAVAATAFYAVgAYAFoAWgAZAFwAXAAaAF0AXQAZAF4AXgAbAIMAiAACAIoAigAEAIsAjgAGAI8AkgAHAJMAkwAFAJQAlAAHAJUAmQAFAJwAnwAIAKAAoAAQAKMAqAASAKoAqgAUAKsArgAVALQAtAAWALUAuQAXAMAAwAAZAMEAwQATAMIAwgAZAMMAwwACAMQAxAASAMUAxQACAMYAxgASAMcAxwACAMgAyAASAMkAyQAEAMoAygAUAMsAywAEAMwAzAAUAM0AzQAEAM4AzgAUAM8AzwAEANAA0AAUANEA0QAFANMA0wAFANUA1QAGANYA1gAVANcA1wAGANgA2AAVANkA2QAGANoA2gAVANsA2wAGANwA3AAVAN0A3QAGAN4A3gAVAOcA5wAHAOgA6AAWAOsA6wAHAO0A7QAHAO8A7wAHAPEA8QAHAPMA8wAHAPcA9wAIAPkA+QAJAPwA/AAKAP4A/gAKAQABAAAKAQIBAgAKAQYBBgAHAQcBBwAWAQgBCAAHAQkBCQAWAQoBCgAHAQsBDAAWAQ8BDwAFARABEAAXAREBEQAFARIBEgAXARMBEwAFARQBFAAXARgBGAAYARoBGgAYARwBHAAYASUBJQAMAScBJwAMASkBKQAMASsBKwAIAS0BLQAIAS8BLwAIATEBMQAIATMBMwAIATUBNQAIATcBNwAOATkBOQAQAToBOgAZATsBOwAQATwBPAARAT0BPQAbAT4BPgARAT8BPwAbAUABQAARAUEBQQAbAU4BTgACAU8BTwASAWIBYgAMAXkBeQACAXsBewAGAXwBfQAHAX4BfgAFAX8BfwAQAYIBggACAYMBgwADAYQBhAAcAYUBhQACAYYBhgAGAYcBhwARAYgBiAAHAYkBiQAFAYoBigAHAYsBiwAJAYwBjAACAY0BjgAHAZABkAAFAZIBkgALAZQBlAAMAZUBlQAQAZcBlwAPAZoBmgAHAZsBmwAQAZ4BngAWAaMBowAZAacBpwAWAa0BrQAZAa8BrwAXAbEBsQATAbwBvAAXAcMBxAAGAcYBxgAcAckBygAHAcsBywAIAcwBzQAdAc8BzwAJAdEB0QAeAdIB0gAHAdMB0wACAdUB1QADAdYB1gAcAdgB2AAGAdkB2QAPAdsB2wAHAd0B3QAJAd4B4AAHAeEB4QAFAeMB4wALAeQB5AAEAeUB5QAMAeYB5gAeAegB6AAPAekB6QAHAesB6wAHAe0B7QAdAe8B7wAdAfMB8wASAfYB9gAfAfgB+AAVAfkB+QAaAgECAQAXAgMCAwATAgQCBAAUAgYCBgAZAgcCBwATAggCCAAaAg0CDQAgAg8CDwAgAhACEAATAhMCFAAVAhYCFgAfAhwCHQAgAiECIQAZAiUCJQAdAiYCJgAgAikCKQACAjYCNgAXAjcCNwANAjgCOAAZAjkCOQANAjoCOgAZAlECUQATAlICUgAcAlMCUwAfAlQCVAAcAlgCWAAPAlkCWQAaAlwCXAAJAl4CXgAJAmACYAAJAmICYgAJAmQCZAAHAmwCbAAEAm0CbQAUAm4CbgAMAnACcAAQAnECcQAZAnICcgAQAnQCdAAPAnUCdQAaAn0CfQAWAoICggAHAoMCgwAPAoQChAAaAosCiwAHAo8CjwAHApECkQAHApICkgACApMCkwASApQClAACApUClQASApgCmAAGApkCmQAVApsCmwAVAp0CnQAVAp4CngAPAp8CnwAaAqgCqAAFAqkCqQAXAq0CrQAXAq8CrwATArACsAAeArECsQAZArICsgAeArMCswAZArQCtAAeArUCtQAZArgCuAAcArkCuQAfAr0CvQAfAr4CvgAPAr8CvwAaAtYC1gACAtcC1wASAuYC5gAHAucC5wAWAvgC+AAOAvoC+gAOAvwC/AAOAwIDAgACAwMDAwASAwQDBAACAwUDBQASAwYDBgACAwcDBwASAwgDCAACAwkDCQASAwoDCgACAwsDCwASAwwDDAACAw0DDQASAw4DDgACAw8DDwASAxADEAACAxEDEQASAxIDEgACAxMDEwASAxQDFAACAxUDFQASAxYDFgACAxcDFwASAxgDGAACAxkDGQASAxoDGgAGAxsDGwAVAxwDHAAGAx0DHQAVAx4DHgAGAx8DHwAVAyADIAAGAyEDIQAVAyIDIgAGAyMDIwAVAyQDJAAGAyUDJQAVAyYDJgAGAycDJwAVAygDKAAGAykDKQAVAyoDKgAHAywDLAAHAy4DLgAFAy8DLwAXAzADMAAFAzEDMQAXAzIDMgAFAzMDMwAXAzQDNAAFAzUDNQAXAzYDNgAFAzcDNwAXAzgDOAAFAzkDOQAXAzoDOgAFAzsDOwAXA0MDQwAXA0YDRgAIA0gDSAAIA1QDVAAQA1UDVQAZA1YDVgAQA1cDVwAZA1gDWAAQA1kDWQAZA1oDWgAQA1sDWwAZA1wDXAAFA3IDcgABA3YDdgABA3oDewABBDEEMQAEBDMENAAFAAEABgQwAAEAAAAAAAAAAAABAAAAAAAAAAAAFgAZABYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAAgAAAAAAAAACAAAAAAAGgAAAAAAAAAAAAgAAAAIAAAAGwAJAAoACwAMABcADQAYAAAAAAAAAAAAAAAAAAMAAAAEAAQABAAAAAQAAAAAAAAAAAAAAAUABQAGAAUABAAAAAcAAAAOAA8AAAAcAA8AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAIAAgACAAIAAgAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAgACAAIAAgAAAAIAAoACgAKAAoADQAAAAAAAwADAAMAAwADAAMAAAAEAAQABAAEAAQAAAAAAAAAAAAAAAUABgAGAAYABgAGAAAAAAAOAA4ADgAOAA8AAAAPAAIAAwACAAMAAgADAAgABAAIAAQACAAEAAgABAAAAAQAAAAAAAAABAAAAAQAAAAEAAAABAAAAAQACAAEAAgABAAIAAQACAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABQAAAAUABQAAAAAACAAGAAgABgAIAAYACAAEAAAAAAAAAAAAAAAAABsABwAbAAcAGwAHABsABwAJAAAACQAAAAAAAAAKAA4ACgAOAAoADgAKAA4ACgAOAAoADgAMAAAADQAPAA0AGAAQABgAEAAYABAAAAAAAAAACAAEAAAADgAAAAAAAAAAAAAAAgADAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwAHAAkAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAAAAAACAANAAAAAAACAAAAAAACAAAAGAAAAAgAAAAAAAIAAAAAAAAACAAAAAAAAAAAAA0AAAAXAAAAAAAAAA0ABAAAAAUAAAAOAAQAAAAPAAAAAAAAAAUAAAAAAAAAAAAAAA8AAAAGAAAAAAAEAAQAAAAOAAAAAAAAAAAAAAAOAAYADgAAAAAAAAAAAAAAAAAAAAkAAAAIAAAAAAAAABoAEQAAAAkAAAAAABUAAAACAAAAAAAAAAAAAAAXAAAAAAAAAAAAEQAAAAAACAAAAAAACAAJABUAAAAXAAAAEgAAAAAAAAAAAAAAAAAAAAAAAwAAAAAABQAAAAQAHAAAAAUABQAFABMABQAFAAYABQAFAAQAAAAPAAQAHAAFABQABQAFAAAAAAAFAAAABQAAAAQABAAAAAUABAAHAAAAAAAAABMABQAAAAUABQAPAAAACAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAGAAsADwALAA8ACAAEAAgAAAAIAAQACAAAAAgABAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAABcAHAAAAAAAAAAFAAAAAAAAAAAACQAAAAAABQAAAAUAAAAAAAgABAAIAAQACQAAAA0ADwANAAAAFwAcAAkAAAASABQAAAAAAAAAAAAAAAAAAAAAAAAAFwAcAAAAAAARABMAAAAFAAAABQASABQAAAAFAAAAAgADAAIAAwAAAAAAAAAEAAAABAAAAAQAFwAcAAAAAAAAAAAAAAAFAAAABQAIAAYACAAEAAgABgAAAAAAFQAPABUADwAVAA8AEgAUAAAABQAAAAUAAAAFABcAHAAAAAAAAAAEAAQABAAAAAAAAAAAABEAAAAAAAAACAAEAAAAAAAAAAAAEQATAAIAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAAAwAAAAMAAAAAAAAAAAAAAACAAMAAgADAAIAAwACAAMAAgADAAIAAwACAAMAAgADAAIAAwACAAMAAgADAAIAAwAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAAAAAAAAAACAAGAAgABgAIAAYACAAGAAgABgAIAAYACAAGAAgABAAIAAQACAAEAAgABgAIAAQACgAOAAoADgAAAA4AAAAOAAAADgAAAA4AAAAOAA0ADwANAA8ADQAPAA0ADwAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkAGQAZAAAAAQABABYAAQABAAEAFgAAAAAAAAAWABYAAAAAAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAgAAAAIAAgAAAABAAAACgIGCBAABERGTFQAGmN5cmwASGdyZWsAdmxhdG4ApAAEAAAAAP//ABIAAAAKABQAHgAoADQAQQBLAFUAXwBpAHMAfQCHAJEAmwClAK8ABAAAAAD//wASAAEACwAVAB8AKQA1AEIATABWAGAAagB0AH4AiACSAJwApgCwAAQAAAAA//8AEgACAAwAFgAgACoANgBDAE0AVwBhAGsAdQB/AIkAkwCdAKcAsQAoAAZBWkUgAFRDUlQgAH5NT0wgAKhOQVYgANRST00gAQBUVVIgASwAAP//ABMAAwANABcAIQArADIANwBEAE4AWABiAGwAdgCAAIoAlACeAKgAsgAA//8AEgAEAA4AGAAiACwAOABFAE8AWQBjAG0AdwCBAIsAlQCfAKkAswAA//8AEgAFAA8AGQAjAC0AOQBGAFAAWgBkAG4AeACCAIwAlgCgAKoAtAAA//8AEwAGABAAGgAkAC4AOgA+AEcAUQBbAGUAbwB5AIMAjQCXAKEAqwC1AAD//wATAAcAEQAbACUALwA7AD8ASABSAFwAZgBwAHoAhACOAJgAogCsALYAAP//ABMACAASABwAJgAwADwAQABJAFMAXQBnAHEAewCFAI8AmQCjAK0AtwAA//8AEwAJABMAHQAnADEAMwA9AEoAVABeAGgAcgB8AIYAkACaAKQArgC4ALljMnNjBFhjMnNjBF5jMnNjBGRjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjMnNjBGpjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBjY21wBHBkbGlnBHhkbGlnBH5kbGlnBIRkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbGlnBIpkbm9tBJBkbm9tBJZkbm9tBJxkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJkbm9tBKJmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhmcmFjBKhsaWdhBLJsaWdhBLpsbnVtBMBsbnVtBMZsbnVtBMxsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsbnVtBNJsb2NsBNhsb2NsBN5sb2NsBORudW1yBOpudW1yBPBudW1yBPZudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxudW1yBPxvbnVtBQJvbnVtBQhvbnVtBQ5vbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRvbnVtBRRwbnVtBRpwbnVtBSBwbnVtBSZwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxwbnVtBSxzbWNwBTJzbWNwBThzbWNwBT5zbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzbWNwBURzczAxBUpzczAxBVBzczAxBVZzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAxBVxzczAyBWJzczAyBWhzczAyBW5zczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAyBXRzczAzBXpzczAzBYBzczAzBYZzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczAzBYxzczA0BZJzczA0BZhzczA0BZ5zczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA0BaRzczA1BapzczA1BbBzczA1BbZzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA1BbxzczA2BcJzczA2BchzczA2Bc5zczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA2BdRzczA3BdpzczA3BeBzczA3BeZzczA3BexzczA3BexzczA3BexzczA3BexzczA3BexzczA3BexzczA3Bex0bnVtBfJ0bnVtBfh0bnVtBf50bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgR0bnVtBgQAAAABAAEAAAABAAMAAAABAAIAAAABAAAAAAACAAgACQAAAAEADgAAAAEAEAAAAAEADwAAAAEADQAAAAEAQwAAAAEARQAAAAEARAAAAAEAQgAAAAMAPwBAAEEAAAACABEAEgAAAAEAEgAAAAEAPAAAAAEAPgAAAAEAPQAAAAEAOwAAAAEACgAAAAEADAAAAAEACwAAAAEARwAAAAEASQAAAAEASAAAAAEARgAAAAEAMAAAAAEAMgAAAAEAMQAAAAEALwAAAAEAOAAAAAEAOgAAAAEAOQAAAAEANwAAAAEABQAAAAEABwAAAAEABgAAAAEABAAAAAEAFAAAAAEAFgAAAAEAFQAAAAEAEwAAAAEAGAAAAAEAGgAAAAEAGQAAAAEAFwAAAAEAHAAAAAEAHgAAAAEAHQAAAAEAGwAAAAEAIAAAAAEAIgAAAAEAIQAAAAEAHwAAAAEAJAAAAAEAJgAAAAEAJQAAAAEAIwAAAAEAKAAAAAEAKgAAAAEAKQAAAAEAJwAAAAEALAAAAAEALgAAAAEALQAAAAEAKwAAAAEANAAAAAEANgAAAAEANQAAAAEAMwBLAJgAmACYAJgEJgQmBCYEJgcUB8AOUA5QDmYOiA6IDogOiA6+DuQPEg8SDxIPEg8mDyYPJg8mDzoPOg86DzoPTg9OD04PTg9gD2APYA9gD3oPeg96D3oPvA+8D7wPvA/aD9oP2g/aD/gP+A/4D/gQKhAqECoQKhBcEFwQXBBcEI4QohDuEMwQzBDMEMwQ7hDuEO4Q7hEaAAEAAAABAAgAAgHEAN8DvQPsA+sD6gPpA+gD5wPmA+UD5APjA+ID4QPgA98D3gPdA9wD2wPaA9kD2APXA9YD9gP3BKkDvAO7BFAEUQRSBFMEVARVBFcEWARZBFoEWwRcBF0EXgRfBE4EYARhBGIEYwRkBGUEZgRtBG4EbwRwBEwEcQRyBHMEdAR1BHYEdwR4BE0EeQR6BHsEfAR9BH4EfwSABIEEggSDBIQEhQSGBIcEiASJBIoEiwSMBI0EjgSPBJAEkQSSBJMERASUBJUElgSXBJgEmQSaBJ0EnARPBJ4EnwSgBKEEogSjBKQEpQSmBKcEqAP+BFYEmwSqBKsErAStBK4ErwSwBLEEsgO6A7kEswS0BLUDuAS2BLcDtwS4A7YEuQPGBLoD0QS7BLwD0gS9A9MD1AS+BL8EwAP5BMED+ATCBMMExATFA/8EAAQBBMYExwQCBMgEAwTJBMoEBATLBAUEBgQHBMwECAQJBM0EzgTPBNAE0QTSBNMECgTcBNQECwQMBA0EDgQPBBAEEQQSBBMEFAQ4BBUEFgTVBBcEGAQZBNYEGgTXBNgEGwQcBB0EHgQfBCAE2QQhBCIE2gQjBNsEJAQlBCcEJgABAN8ACAAlACYAJwAoACkAKgArACwALQAuAC8AMAAxADIAMwA0ADUANgA3ADgAOQA6ADsAPAA9AD4AZgBoAIMAhACFAIYAhwCIAIoAiwCMAI0AjgCPAJAAkQCSAJMAlACVAJYAlwCYAJkAnACdAJ4AnwCgAKIAwwDFAMcAyQDLAM0AzwDRANMA1QDXANkA2wDdAN8A4QDjAOUA5wDrAO0A7wDxAPMA9wD5APwA/gEAAQIBBgEIAQoBDwERARMBFQEXARkBGwEdAR8BIQEjASUBJwEpASsBLQEvATEBMwE1ATcBOQE7ATwBPgFAAU4BYgF5AXsBfAF9AX4BfwGAAYIBgwGEAYUBhgGHAYgBiQGKAYsBjAGNAY8BkAGRAZIBkwGUAZUBlgGXAZgBmQGaAZsBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0QHSAdMB1AHVAdYB1wHYAdkB2gHbAdwB3QHeAd8B4AHhAeIB4wHkAeUB5gHnAegB6QHqAesB7AHtAe4B7wHwAfEB8gJSAlQCWAJaAlwCXgJiAmQCagJsAnACcgJ0AnYCegJ8An4CgAKaAqICpAKqArADhwOOA5MDlgABAAAAAQAIAAIBdAC3A+wD6wPqA+kD6APnA+YD5QPkA+MD4gPhA+AD3wPeA90D3APbA9oD2QPYA9cD1gP2A/cEqQRQBFEEUgRTBFQEVQRXBFgEWQRaBFsEXARdBF4EXwROBGAEYQRiBGMEZARlBGYEbQRuBG8EcASmBHEEcgRzBHQEdQR2BHcEeARNBHkEegR7BHwEfQR+BH8EgASBBIIEgwSEBIUEhgSHBIgEiQSKBIsEjASNBI4EjwSQBJEEkgSTBEQElASVBJYElwSYBJkEmgSdBJwETwSeBJ8EoAShBKIEowSkBKUEpwSoA/4EVgSbBMgEAwTJBMoEBATLBAUEBgQHBMwECAQJBM0EzgTPBNAE0QTSBNMECgTcBNQECwQMBA0EDgQPBBAEEQQSBBMEFATAA/kEwQP4BMIEwwTEBMUD/wQABAEExgTHBAIEOAQVBBYE1QQXBBgEGQTWBBoE1wTYBBsEHAQdBB4EHwQgBNkEIQQiBNoEIwTbAAEAtwBFAEYARwBIAEkASgBLAEwATQBOAE8AUABRAFIAUwBUAFUAVgBXAFgAWQBaAFsAXABdAF4AowCkAKUApgCnAKgAqgCrAKwArQCuAK8AsACxALIAswC0ALUAtgC3ALgAuQC8AL0AvgC/AMAAwgDEAMYAyADKAMwAzgDQANIA1ADWANgA2gDcAN4A4ADiAOQA5gDoAOwA7gDwAPIA9AD4APoA/QD/AQEBAwEHAQkBCwEQARIBFAEWARgBGgEcAR4BIAEiASQBJgEoASoBLAEuATABMgE0ATYBOAE6AT0BPwFBAU8BYwHzAfQB9QH2AfcB+AH5AfoB+wH8Af0B/gH/AgACAQICAgMCBAIFAgYCBwIIAgkCCgILAgwCDQIOAg8CEAIRAhICFAIVAhYCFwIYAhkCGgIbAhwCHQIeAh8CIQIiAlMCVQJZAlsCXQJfAmMCZQJrAm0CcQJzAnUCdwJ7An0CfwKBApsCowKlAqsCsQAGAAAABgASACoAQgBaAHIAigADAAAAAQASAAEAkAABAAAASgABAAEATQADAAAAAQASAAEAeAABAAAASgABAAEATgADAAAAAQASAAEAYAABAAAASgABAAEA8gADAAAAAQASAAEASAABAAAASgABAAECGQADAAAAAQASAAEAMAABAAAASgABAAECGwADAAAAAQASAAEAGAABAAAASgABAAEDLQACAAEBcQF1AAAABAAAAAEACAABBh4ANgByAKQArgC4AMoA/AEOARgBSgFkAX4BkAG6AewB9gIYAjICRAJ2AogCogLMAt4DEAMaAyQDNgNoA3IDfAOGA6ADugPMA/YEKAQyBFQEbgSABLIExATeBQgFGgUkBS4FOAVCBWwFlgXABeoGFAAGAA4AFAAaACAAJgAsAIMAAgFxAIQAAgFyAIYAAgFzAwQAAgF0AVQAAgF1AwIAAgF2AAEABALYAAIBdgABAAQAyQACAXIAAgAGAAwC2gACAXYC3AACA6sABgAOABQAGgAgACYALACLAAIBcQCMAAIBcgMeAAIBcwMcAAIBdAFWAAIBdQMaAAIBdgACAAYADAFKAAIBcgDlAAIDqwABAAQC3gACAXYABgAOABQAGgAgACYALACPAAIBcQCQAAIBcgDrAAIBcwMqAAIBdAFYAAIBdQMsAAIBdgADAAgADgAUAuAAAgFyAuIAAgF2APkAAgOrAAMACAAOABQA/AACAXIC5AACAXYA/gACA6sAAgAGAAwC5gACAXIC6AACAXYABQAMABIAGAAeACQBTAACAXEBBgACAXIAlAACAXMC6gACAXYBCAACA6sABgAOABQAGgAgACYALACVAAIBcQCWAAIBcgCYAAIBcwMwAAIBdAFaAAIBdQMuAAIBdgABAAQC7AACAXIABAAKABAAFgAcARcAAgFyAVwAAgF1Au4AAgF2ARkAAgOrAAMACAAOABQBHQACAXIC8AACAXYBYAACA6sAAgAGAAwC8gACAXYBYgACA6sABgAOABQAGgAgACYALACcAAIBcQCdAAIBcgErAAIBcwNIAAIBdAFeAAIBdQNGAAIBdgACAAYADAL0AAIBcwL2AAIBdgADAAgADgAUAvgAAgFxAvoAAgFyAv4AAgF2AAUADAASABgAHgAkA1QAAgFxAKAAAgFyA1oAAgFzA1gAAgF0A1YAAgF2AAIABgAMATwAAgFyAwAAAgF2AAYADgAUABoAIAAmACwAowACAXEApAACAXIApgACAXMDBQACAXQBVQACAXUDAwACAXYAAQAEAtkAAgF2AAEABADKAAIBcgACAAYADALbAAIBdgLdAAIDqwAGAA4AFAAaACAAJgAsAKsAAgFxAKwAAgFyAx8AAgFzAx0AAgF0AVcAAgF1AxsAAgF2AAEABAFLAAIBcgABAAQC3wACAXYAAQAEAy0AAgF2AAMACAAOABQC4QACAXIC4wACAXYA+gACA6sAAwAIAA4AFAD9AAIBcgLlAAIBdgD/AAIDqwACAAYADALnAAIBcgLpAAIBdgAFAAwAEgAYAB4AJAFNAAIBcQEHAAIBcgC0AAIBcwLrAAIBdgEJAAIDqwAGAA4AFAAaACAAJgAsALUAAgFxALYAAgFyALgAAgFzAzEAAgF0AVsAAgF1Ay8AAgF2AAEABALtAAIBcgAEAAoAEAAWABwBGAACAXIBXQACAXUC7wACAXYBGgACA6sAAwAIAA4AFAEeAAIBcgLxAAIBdgFhAAIDqwACAAYADALzAAIBdgFjAAIDqwAGAA4AFAAaACAAJgAsALwAAgFxAL0AAgFyASwAAgFzA0kAAgF0AV8AAgF1A0cAAgF2AAIABgAMAvUAAgFzAvcAAgF2AAMACAAOABQC+QACAXEC+wACAXIC/wACAXYABQAMABIAGAAeACQDVQACAXEAwAACAXIDWwACAXMDWQACAXQDVwACAXYAAgAGAAwBPQACAXIDAQACAXYAAQAEAVAAAgFyAAEABAFSAAIBcgABAAQBUQACAXIAAQAEAVMAAgFyAAUADAASABgAHgAkAK8AAgFxALAAAgFyAOwAAgFzAysAAgF0AVkAAgF1AAUADAASABgAHgAkAz4AAgFxAzwAAgFyA0IAAgFzA0AAAgF0A0QAAgF2AAUADAASABgAHgAkAz8AAgFxAz0AAgFyA0MAAgFzA0EAAgF0A0UAAgF2AAUADAASABgAHgAkA0wAAgFxA0oAAgFyA1AAAgFzA04AAgF0A1IAAgF2AAUADAASABgAHgAkA00AAgFxA0sAAgFyA1EAAgFzA08AAgF0A1MAAgF2AAEABAHBAAIBcgACABEAJQApAAAAKwAtAAUALwA0AAgANgA7AA4APQA+ABQARQBJABYASwBNABsATwBUAB4AVgBbACQAXQBeACoAiQCJACwAmwCbAC0AqQCpAC4AuwC7AC8A9AD0ADABRQFIADEBwAHAADUAAQAAAAEACAABAAYAPwABAAIBIQEiAAEAAAABAAgAAgAOAAQE3QTeBN8E4AABAAQAxwDIANsA3AAEAAAAAQAIAAEAJgACAAoAHAACAAYADAOsAAIASgOxAAIAWAABAAQDsgACAFgAAQACAEoAVwAEAAAAAQAIAAEARAACAAoAFAABAAQDrQACAE0AAQAEA68AAgBNAAQAAAABAAgAAQAeAAIACgAUAAEABAOuAAIAUAABAAQDsAACAFAAAQACAEoDrAABAAAAAQAIAAEABgN5AAEAAQBLAAEAAAABAAgAAQAGAiIAAQABAaEAAQAAAAEACAABAAYDjAABAAEANgABAAAAAQAIAAIAHAACA8EDwAABAAAAAQAIAAIACgACA78DvgABAAIALwBPAAEAAAABAAgAAgAeAAwEMQQzBDIENAQ1BCgEKQQqA/sELAQtBC4AAQAMACcAKAArADMANQBGAEcASABLAFMAVABVAAEAAAABAAgAAgAMAAMELwQwBDAAAQADAEkASwP7AAEAAAABAAgAAgBmAAgERgQ2BDcEOQQ6BEIEQwRFAAEAAAABAAgAAgAWAAgAGwAVABQAHQAZABgAFwAWAAEACAP6BCsEZwRoBGkEagRrBGwAAQAAAAEACAACABYACARnBCsEbARrBGoEaQP6BGgAAQAIABQAFQAWABcAGAAZABsAHQABAAAAAQAIAAIAFgAIABUAFgAXABgAGQAbAB0AFAABAAgENgQ3BDkEOgRCBEMERQRGAAEAAAABAAgAAQAGA3AAAQABABMABgAAAAEACAADAAEAEgABAGYAAAABAAAASgACAAIDgwODAAADxwPQAAEAAQAAAAEACAACADwACgPQA88DzgPNA8wDywPKA8kDyAPHAAEAAAABAAgAAgAaAAoEOwB8AHUAdgQ8BD0EPgQ/BEAEQQACAAEAFAAdAAAAAQAAAAEACAACACYAEAPQA88DzgPNA8wDywPKA8kDyAPHBEkERwRKBEsESAThAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgDyAhkCGwMt",
  "Roboto-Regular.ttf": "AAEAAAASAQAABAAgR0RFRtRX1FkAAg/sAAACREdQT1NKcuCzAAISMAAAUiRHU1VCw4aZEQACZFQAABfoT1MvMqCnsaYAAAGoAAAAYGNtYXBAmkl2AAAafAAAEshjdnQgJEEG5QAAL9wAAABMZnBnbWf0XKsAAC1EAAABvGdhc3AACAATAAIP4AAAAAxnbHlmHN2bBQAAOfAAAdM2aGRteDc4ERcAABWQAAAE7GhlYWT4RqsOAAABLAAAADZoaGVhCroKggAAAWQAAAAkaG10eOiEiIgAAAIIAAATiGxvY2HgyGepAAAwKAAACcZtYXhwBxIC+QAAAYgAAAAgbmFtZTVTY1kAAg0oAAACmHBvc3T/bQBkAAIPwAAAACBwcmVwdKCP7AAALwAAAADbAAEAAAACAACEKlnoXw889QAbCAAAAAAAxPARLgAAAADQ206a+hv91QkwCHMAAAAJAAIAAAAAAAAAAQAAB2z+DAAACUn6G/5KCTAAAQAAAAAAAAAAAAAAAAAABOIAAQAABOIAjwAWAFQABQABAAAAAAAOAAACAAIUAAYAAQADBIUBkAAFAAAFmgUzAAABHwWaBTMAAAPRAGYCAAAAAgAAAAAAAAAAAOAACv9QACF/AAAAIQAAAABHT09HAEAAAP/9BgD+AABmB5oCACAAAZ8AAAAABDoFsAAgACAAAgOMAGQAAAAAAAAAAAH7AAAB+wAAAg8AoAKPAIgE7QB3BH4AbgXcAGkE+QBlAWUAZwK8AIUCyAAmA3IAHASJAE4BkgAdAjUAJQIbAJADTAASBH4AcwR+AKoEfgBdBH4AXgR+ADUEfgCaBH4AhAR+AE0EfgBwBH4AZAHwAIYBsQApBBEASARkAJgELgCGA8cASwcvAGoFOAAcBPsAqQU1AHcFPwCpBIwAqQRsAKkFcwB6BbQAqQItALcEagA1BQQAqQROAKkG/ACpBbQAqQWAAHYFDACpBYAAbQTtAKgEvwBQBMYAMQUwAIwFFwAcBxkAPQUEADkEzgAPBMoAVgIfAJIDSAAoAh8ACQNYAEADnAAEAnkAOQRaAG0EfQCMBDAAXASDAF8EPQBdAscAPAR9AGAEaACMAfEAjQHp/78EDgCNAfEAnAcDAIsEagCMBJAAWwR9AIwEjABfArUAjAQgAF8CnQAJBGkAiAPgACEGAwArA/cAKQPJABYD9wBYArUAQAHzAK8CtQATBXEAgwHzAIsEYABpBKYAWwW0AGkE2AAfAesAkwToAFoDWABmBkkAWwOTAJMDwQBmBG4AfwZKAFoDqgB4Av0AggRGAGEC7wBCAu8APgKCAHsEiACaA+kAQwIWAJMB+wB0Au8AegOjAHoDwABmBdwAVQY1AFAGOQBvA8kARAd6//IERABZBYAAdgS6AKYEwgCLBsEATgSwAH4EkQBHBIgAWwScAJUFmgAdAfoAmwRzAJoETwAiAikAIgWLAKIEiACRB6EAaAdEAGEB/ACgBYcAXQK5/+QFfgBlBJIAWwWQAIwE8wCIAgP/tAQ3AGIDxACpA40AjAOrAHgDagCBAfEAjQKtAHkCKgAyA8YAewL8AF4CWgB+AAD8pwAA/W8AAPyLAAD9XgAA/CcB7/04Ag0AtwQLAHECFwCTBHMAsQWkAB8FcQBnBT4AMgSRAHgFtQCyBJEARQW7AE0FiQBaBVIAcQSFAGQEvQCgBAIALgSIAGAEUABjBCUAbQSIAJEEjgB6ApcAwwRuACUD7ABlBMQAKQSIAJEETQBlBIgAYAQsAFEEXQCPBaMAVwWaAF8GlwB6BKEAeQRC/9oGSABKBf8AKgVkAHsIkQAxCKQAsQaCAD4FtACwBQsAogYEADIHQwAbBL8AUAW0ALEFqQAvBQcATQYsAFMF2QCvBXoAlgeHALAHwACwBhIAEAbrALIFBQCjBWQAkwcnALcFGABZBGwAYQSSAJ0DWwCaBNQALgYgABUEEABYBJ4AnARSAJwEoAAsBe8AnQSdAJwEngCcA9gAKAXNAGQEvQCcBFkAZwZ4AJwGngCRBPcAHgY2AJ0EWACdBE0AZAaHAJ0EZAAvBGj/6ARNAGcGyQAnBuQAnASJ//0EngCcBwgAnAYrAIEEVv/cBysAtwX4AJkE0gAoBEYADwcLAMkGCwC8BtEAkwXhAJYJBAC2B9EAmwQjAFAD2wBMBXEAZwSLAFsFCgAWBAMALgVxAGcEiABbBwEAnAYkAH4HCACcBisAgQUyAHUERwBkBP0AdAAA/GcAAPxxAAD9ZgAA/aQAAPobAAD6LARW/9wFGwCoBIkAjARjAKIDkACRBNsAsQQFAJEFCQCjBH4AmgaMAEQFgwA+B88AqAW0AJEIMQCwBvQAkQXuAHEE0wBtBywANAVcAB8FbwCWBGoAgwVwAIoGLwA/BL3/3gUJAKMEWgCaBbIAsQSIAJEFhwBdBKgAaASoAGkEtwA6A0kAOwT2AFcGlABZBuQAZAZWADYFKwAxBEkAUgQHAHkHwQBEBnUAPwf7AKkGoQCQBPYAdgQdAGUFrQAjBSAARgVkAJYDIABvBBQAAAgpAAAEFAAACCkAAAK5AAACCgAAAVwAAAR/AAACMAAAAaIAAADRAAAAAAAAAjQAJQI0ACUFQACiBj8AkAOmAA0BmQBgAZkAMAGXACQBmQBPAtQAaALbADwCwQAkBGkARgSPAFcCsgCKA8QAlAVaAJQA9gAmB6oARAJmAGwCZgBZA6MAOwLvADYDYAB6BKYAWwZVAB8GkACnCHYAqAdjADkGKwCMBH4AXwXaAB8EIgAqBHQAIAVIAF0FTwAfBecAegPOAGgIOgCiBQEAZwUXAJgGJgBUBtcAZAbPAGMGagBZBI8AagWOAKkErwBFBJIAqATFAD8IOgBiAgz/sASCAGUEZACYBBEAPgQvAIUECAArAkwAtQKPAG4CAwBcBPMAPARuAB8EiwA8BtQAPAbUADwE7gA8BpsAXwAAAAAIMwBbCDUAXAQgADsEngBaAfz/tgGRAGcDpACDA54AgQOfAIED9ABpBA4AaQPz/14D7wBuA6QAgQH9AJ8EhQATBFAAigR8AGAEgACKA+YAigPLAIoErABjBOMAigHoAJcDzwArBFQAigO0AIoGAgCKBOMAigS7AGAEXACKBLsAWQRKAIoEIABDBCYAKAR8AHQEZwAUBhUAMQRUACYEKwANBCMARwLvAFAC7wB6Au8AQgLvAD4C7wA2Au8AWwLvAFYC7wA6Au8ATwLvAEkDlgCPArUAngQ6AB4EwwBkBUwAsQUkALIEEwCSBT0AsgQPAJIEIABDBDMAMAQ8ABYDrwCKBGcAFAS7AGAEZwAUA4kAPgTOAIoD7wA/BWcAYAUXAGAE8gB1BXIAJgR8AGAHQQAnB08AigV0ACgEzQCKBFkAigUkAC4GCwAfBD8ARwTsAIoETgCLBMEAJwQfACIFKACKBGoAPQZRAIoGrACKBR0ACAXxAIoETgCKBHsASwZ2AIoEhwBQBBEACwZHAB8EeQCLBQkAiwU3ACMFwgBgBF8ADQSoACYGYQAmBGoAPQRqAIoFwwACBMoAXgQ/AEcEuwBgBDMAMAPjAEIIIgCKBKsAKAR9AIwEMgBcBJMAWwSMAFsDeQBXBI0AjAScAFsEPQBdBH0AYAWBAH4FrgB+BZMAsgXgAH4F4wB+A9UAoASCAIMDrwCKBFgADwTPAD4C7wBQAu8ANgLvAFsC7wBWAu8AOgLvAE8C7wBJBGsAZQQuAEoGpABgBLkAggUAAHgCBv+0AgT/tAH7AJsB+//6AfsAmwH7AIYEUACKAfsAAAI1ACUFXQAlBV0AJQSGAAAExgAxAp3/9AU4ABwFOAAcBTgAHAU4ABwFOAAcBTgAHAU4ABwFNQB3BIwAqQSMAKkEjACpBIwAqQIt/+ACLQCwAi3/6QIt/9YFtACpBYAAdgWAAHYFgAB2BYAAdgWAAHYFMACMBTAAjAUwAIwFMACMBM4ADwRaAG0EWgBtBFoAbQRaAG0EWgBtBFoAbQRaAG0EMABcBD0AXQQ9AF0EPQBdBD0AXQH6/8YB+gCWAfr/zwH6/7wEagCMBJAAWwSQAFsEkABbBJAAWwSQAFsEaQCIBGkAiARpAIgEaQCIA8kAFgPJABYFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FNQB3BDAAXAU1AHcEMABcBTUAdwQwAFwFNQB3BDAAXAU/AKkFGQBfBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQVzAHoEfQBgBXMAegR9AGAFcwB6BH0AYAVzAHoEfQBgBbQAqQRoAIwCLf+3Afr/nQIt/7YB+v+cAi3/7AH6/9ICLQAYAfH/+wItAKoGlwC3A9oAjQRqADUCA/+0BQQAqQQOAI0ETgChAfEAkwROAKkB8QBXBE4AqQKHAJwETgCpAs0AnAW0AKkEagCMBbQAqQRqAIwFtACpBGoAjARq/7wFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsE7QCoArUAjATtAKgCtQBTBO0AqAK1AGMEvwBQBCAAXwS/AFAEIABfBL8AUAQgAF8EvwBQBCAAXwS/AFAEIABfBMYAMQKdAAkExgAxAp0ACQTGADECxQAJBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBTAAjARpAIgFMACMBGkAiAUwAIwEaQCIBxkAPQYDACsEzgAPA8kAFgTOAA8EygBWA/cAWATKAFYD9wBYBMoAVgP3AFgHev/yBsEATgWAAHYEiABbBID/vgSA/74EJgAoBIUAEwSFABMEhQATBIUAEwSFABMEhQATBIUAEwR8AGAD5gCKA+YAigPmAIoD5gCKAej/vgHoAI4B6P/HAej/tATjAIoEuwBgBLsAYAS7AGAEuwBgBLsAYAR8AHQEfAB0BHwAdAR8AHQEKwANBIUAEwSFABMEhQATBHwAYAR8AGAEfABgBHwAYASAAIoD5gCKA+YAigPmAIoD5gCKA+YAigSsAGMErABjBKwAYwSsAGME4wCKAej/lQHo/5QB6P/KAegABgHoAIkDzwArBFQAigO0AIIDtACKA7QAigO0AIoE4wCKBOMAigTjAIoEuwBgBLsAYAS7AGAESgCKBEoAigRKAIoEIABDBCAAQwQgAEMEIABDBCYAKAQmACgEJgAoBHwAdAR8AHQEfAB0BHwAdAR8AHQEfAB0BhUAMQQrAA0EKwANBCMARwQjAEcEIwBHBTgAHATw//AGGP/+ApEABAWU//oFMv94BWb//QKX/5sFOAAcBPsAqQSMAKkEygBWBbQAqQItALcFBACpBvwAqQW0AKkFgAB2BQwAqQTGADEEzgAPBQQAOQIt/9YEzgAPBIUAZARQAGMEiACRApcAwwRdAI8EcwCaBJAAWwSIAJoD4AAhA/cAKQKX/+YEXQCPBJAAWwRdAI8GlwB6BIwAqQRzALEEvwBQAi0AtwIt/9YEagA1BSQAsgUEAKkFBwBNBTgAHAT7AKkEcwCxBIwAqQW0ALEG/ACpBbQAqQWAAHYFtQCyBQwAqQU1AHcExgAxBQQAOQRaAG0EPQBdBJ4AnASQAFsEfQCMBDAAXAPJABYD9wApBD0AXQNbAJoEIABfAfEAjQH6/7wB6f+/BFIAnAPJABYHGQA9BgMAKwcZAD0GAwArBxkAPQYDACsEzgAPA8kAFgFlAGcCjwCIBB4AoAID/7QBmQAwBvwAqQcDAIsFOAAcBFoAbQSMAKkFtACxBD0AXQSeAJwFiQBaBZoAXwUKABYEA//7CFkAWwlJAHYEvwBQBBAAWAU1AHcEMABcBM4ADwQCAC4CLQC3B0MAGwYgABUCLQC3BTgAHARaAG0FOAAcBFoAbQd6//IGwQBOBIwAqQQ9AF0FhwBdBDcAYgQ3AGIHQwAbBiAAFQS/AFAEEABYBbQAsQSeAJwFtACxBJ4AnAWAAHYEkABbBXEAZwSLAFsFcQBnBIsAWwVkAJMETQBkBQcATQPJABYFBwBNA8kAFgUHAE0DyQAWBXoAlgRZAGcG6wCyBjYAnQUEADkD9wApBIMAXwWpAC8EoAAsBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARa/8oFOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBTgAHARaAG0FOAAcBFoAbQU4ABwEWgBtBIwAqQQ9AF0EjACpBD0AXQSMAKkEPQBdBIwAqQQ9AF0EjP/wBD3/ugSMAKkEPQBdBIwAqQQ9AF0EjACpBD0AXQItALcB+gCbAi0AowHxAIUFgAB2BJAAWwWAAHYEkABbBYAAdgSQAFsFgABHBJD/xAWAAHYEkABbBYAAdgSQAFsFgAB2BJAAWwV+AGUEkgBbBX4AZQSSAFsFfgBlBJIAWwV+AGUEkgBbBX4AZQSSAFsFMACMBGkAiAUwAIwEaQCIBZAAjATzAIgFkACMBPMAiAWQAIwE8wCIBZAAjATzAIgFkACMBPMAiATOAA8DyQAWBM4ADwPJABYEzgAPA8kAFgShAF8EoQBfBSQAsgRSAJwFtACpBJ0AnATGADED2AAoBQQAOQP3ACkFegCWBFkAZwV6AJYEWQBnBHMAsQNbAJoHQwAbBiAAFQYvAD8Evf/eBGgAjAUF/9QFBf/UBHMAAwNb//wFOAALBCf/0wW0ALEEngCcBbQAqQSdAJwG/ACpBe8AnQWpAC8EoAAsBM4ADwQCAC4FBAA5A/cAKQRQAGMEbAASBj8AkAR+AF0EfgBeBH4ANQR+AJoEkgBkBKYAhwVzAHoEfQBgBbQAqQRqAIwFOAAcBFoAOQSMAF8EPQApAi3/CgH6/vAFgAB2BJAAMwTtAFUCtf+LBTAAjARpACsEpv86BPsAqQR9AIwFPwCpBIMAXwU/AKkEgwBfBbQAqQRoAIwFBACpBA4AjQUEAKkEDgCNBE4AqQHxAIYG/ACpBwMAiwW0AKkEagCMBQwAqQR9AIwE7QCoArUAggS/AFAEIABfBMYAMQKdAAkFFwAcA+AAIQUXABwD4AAhBxkAPQYDACsEygBWA/cAWAXG/ngEhQATBCL/nwUf/7wCJP/ABMX/3wRn/1cE/P/4BIUAEwRQAIoD5gCKBCMARwTjAIoB6ACXBFQAigYCAIoEuwBgBFwAigQmACgEKwANBFQAJgHo/7QEKwANA+YAigOvAIoEIABDAegAlwHo/7QDzwArBFQAigQfACIEhQATBFAAigOvAIoD5gCKBOwAigYCAIoE4wCKBLsAYATOAIoEXACKBHwAYAQmACgEVAAmBD8ARwTjAIoEfABgBCsADQXDAAIE7ACKBB8AIgVnAGAFOAAcBFoAbQSMAKkEPQBdAAAAAQAABOQJCgQAAAICAgMGBQcGAgMDBAUCAgIEBQUFBQUFBQUFBQICBQUFBAgGBgYGBQUGBgIFBgUIBgYGBgYFBQYGCAYFBQIEAgQEAwUFBQUFAwUFAgIFAggFBQUFAwUDBQQHBAQEAwIDBgIFBQYFAgYEBwQEBQcEAwUDAwMFBAICAwQEBwcHBAgFBgUFCAUFBQUGAgUFAgYFCQgCBgMGBQYGAgUEBAQEAgMCBAMDAAAAAAACAgUCBQYGBgUGBQYGBgUFBQUFBQUFAwUEBQUFBQUFBgYHBQUHBwYKCgcGBgcIBQYGBgcHBggJBwgGBggGBQUEBQcFBQUFBwUFBAcFBQcHBgcFBQcFBQUICAUFCAcFCAcFBQgHCAcKCQUEBgUGBQYFCAcIBwYFBgAAAAAAAAUGBQUEBQUGBQcGCQYJCAcFCAYGBQYHBQYFBgUGBQUFBAYHCAcGBQUJBwkHBgUGBgYEBQkFCQMCAgUCAgEAAgIGBwQCAgICAwMDBQUDBAYBCQMDBAMEBQcHCggHBQcFBQYGBwQJBgYHCAgHBQYFBQUJAgUFBQUFAwMCBgUFCAgGBwAJCQUFAgIEBAQEBQQEBAIFBQUFBAQFBgIEBQQHBgUFBQUFBQUFBwUFBQMDAwMDAwMDAwMEAwUFBgYFBgUFBQUEBQUFBAUEBgYGBgUICAYFBQYHBQYFBQUGBQcIBgcFBQcFBQcFBgYGBQUHBQUGBQUFBQQJBQUFBQUEBQUFBQYGBgcHBAUEBQUDAwMDAwMDBQUHBQYCAgICAgIFAgIGBgUFAwYGBgYGBgYGBQUFBQICAgIGBgYGBgYGBgYGBQUFBQUFBQUFBQUFBQICAgIFBQUFBQUFBQUFBAQGBQYFBgUGBQYFBgUGBQYGBQUFBQUFBQUFBQYFBgUGBQYFBgUCAgICAgICAgIHBAUCBgUFAgUCBQMFAwYFBgUGBQUGBQYFBgUGAwYDBgMFBQUFBQUFBQUFBQMFAwUDBgUGBQYFBgUGBQYFCAcFBAUFBAUEBQQICAYFBQUFBQUFBQUFBQUEBAQEAgICAgYFBQUFBQUFBQUFBQUFBQUFBQUEBAQEBAUFBQUGAgICAgIEBQQEBAQGBgYFBQUFBQUFBQUFBQUFBQUFBQUFBwUFBQUFBgYHAwYGBgMGBgUFBgIGCAYGBgUFBgIFBQUFAwUFBQUEBAMFBQUHBQUFAgIFBgYGBgYFBQYIBgYGBgYFBgUFBQUFBQQEBQQFAgICBQQIBwgHCAcFBAIDBQICCAgGBQUGBQUGBgYFCQoFBQYFBQUCCAcCBgUGBQgIBQUGBQUIBwUFBgUGBQYFBgUGBQYFBgQGBAYEBgUIBwYEBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBQUFBQUFBQUFBQUFBQUFBQICAgIGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgUGBQYFBgYGBgYGBgYGBgUEBQQFBAUFBgUGBQUEBgQGBQYFBQQIBwcFBQYGBQQGBQYFBgUIBwYFBQUGBAUFBwUFBQUFBQYFBgUGBQUFAgIGBQYDBgUFBgUGBQYFBgUGBQYFBQIICAYFBgUGAwUFBQMGBAYECAcFBAcFBQYCBQUGBQUEBQYCBQcFBQUFBQIFBAQFAgIEBQUFBQQEBgcGBQUFBQUFBQYFBQYGBQYGBQUFAAAAAwAAAAMAAAAcAAMAAQAAABwAAwAKAAAGiAAEBmwAAADqAIAABgBqAAAAAgANAH4AoACsAK0AvwDGAM8A5gDvAP4BDwERASUBJwEwAVMBXwFnAX4BfwGPAZIBoQGwAfAB/wIbAjcCWQK8AscCyQLdAvMDAQMDAwkDDwMjA4oDjAOSA6EDsAO5A8kDzgPSA9YEJQQvBEUETwRiBG8EeQSGBM4E1wThBPUFAQUQBRMeAR4/HoUe8R7zHvkfTSALIBEgFSAeICIgJyAwIDMgOiA8IEQgdCB/IKQgqiCsILEguiC9IQUhEyEWISIhJiEuIV4iAiIGIg8iEiIaIh4iKyJIImAiZSXK7gL2w/sE/v///f//AAAAAAACAA0AIACgAKEArQCuAMAAxwDQAOcA8AD/ARABEgEmASgBMQFUAWABaAF/AY8BkgGgAa8B8AH6AhgCNwJZArwCxgLJAtgC8wMAAwMDCQMPAyMDhAOMA44DkwOjA7EDugPKA9ED1gQABCYEMARGBFAEYwRwBHoEiATPBNgE4gT2BQIFER4AHj4egB6gHvIe9B9NIAAgECATIBcgICAlIDAgMiA5IDwgRCB0IH8goyCmIKsgsSC5ILwhBSETIRYhIiEmIS4hWyICIgYiDyIRIhoiHiIrIkgiYCJkJcruAfbD+wH+///8//8AAQAA//b/5AGl/8IBmf/BAAABjAAAAYcAAAGDAAABgQAAAX8AAAF3AAABef8V/wb/BP73/uoBuwAAAAD+ZP5DAPD91/3W/cj9s/2n/ab9of2c/YkAAP/L/8oAAAAA/QkAAP+r/P38+gAA/LkAAPyxAAD8pgAA/KAAAP71AAD+8gAA/EkAAOWv5W/lIOVP5LTlTeVd4VvhVwAA4VThU+FR4UnjduFB427hOOEJ4P8AAODaAADg1eDO4M3ghuB54HfgbN+T4GHgNd+S3qvfht+F337fe99v31PfPN8529UTnwrfBqMCqwGvAAEAAAAAAAAAAAAAAAAAAAAAANoAAADkAAABDgAAASgAAAEoAAABKAAAAWoAAAAAAAAAAAAAAAAAAAFqAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYgAAAAABagGGAAABngAAAAAAAAG2AAAB/gAAAiYAAAJIAAACWAAAAuIAAALyAAADBgAAAAAAAAAAAAAAAAAAAAAAAAL4AAAAAAAAAAAAAAAAAAAAAAAAAAAC6AAAAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACTAJNAk4CTwJQAlEAgQJIAlwCXQJeAl8CYAJhAIIAgwJiAmMCZAJlAmYAhACFAmcCaAJpAmoCawJsAIYAhwJ3AngCeQJ6AnsCfACIAIkCfQJ+An8CgAKBAIoCRwRHAIsCSQCMArACsQKyArMCtAK1AI0CtgK3ArgCuQK6ArsCvAK9AI4AjwK+Ar8CwALBAsICwwLEAJAAkQLFAsYCxwLIAskCygCSAJMC2QLaAt0C3gLfAuACSgJLAlICbQL4AvkC+gL7AtcC2ALbAtwArQCuA1MArwNUA1UDVgCwALEDXQNeA18AsgNgA2EAswNiA2MAtANkALUDZQC2A2YDZwC3A2gAuAC5A2kDagNrA2wDbQNuA28DcADDA3IDcwDEA3EAxQDGAMcAyADJAMoAywN0AMwAzQOxA3oA0QN7ANIDfAN9A34DfwDTANQA1QOBA7IDggDWA4MA1wOEA4UA2AOGANkA2gDbA4cDgADcA4gDiQOKA4sDjAONA44A3QDeA48DkADpAOoA6wDsA5EA7QDuAO8DkgDwAPEA8gDzA5MA9AOUA5UA9QOWAPYDlwOzA5gBAQOZAQIDmgObA5wDnQEDAQQBBQOeA7QDnwEGAQcBCARdA7UDtgEWARcBGAEZA7cDuAO6A7kBJwEoBGIEYwRcASkBKgErASwBLQReBF8BLgEvBFcEWAO7A7wESQRKATABMQRgBGEBMgEzBEsETAE0ATUBNgE3ATgBOQO9A74ETQROA78DwARqBGsETwRQAToBOwRRBFIBPAE9AT4EWwE/AUAEWQRaA8EDwgPDAUEBQgRoBGkBQwFEBGQEZQRTBFQEZgRnAUUDzgPNA88D0APRA9ID0wFGAUcEVQRWA+gD6QFIAUkD6gPrBGwEbQFKA+wEbgPtA+4BaQFqBHAEbwF/BEgBhQAMAAAAAAxAAAAAAAAAAQQAAAAAAAAAAAAAAAEAAAACAAAAAgAAAAIAAAANAAAADQAAAAMAAAAgAAAAfgAAAAQAAACgAAAAoAAAAkUAAAChAAAArAAAAGMAAACtAAAArQAAAkYAAACuAAAAvwAAAG8AAADAAAAAxQAAAkwAAADGAAAAxgAAAIEAAADHAAAAzwAAAlMAAADQAAAA0AAAAkgAAADRAAAA1gAAAlwAAADXAAAA2AAAAIIAAADZAAAA3QAAAmIAAADeAAAA3wAAAIQAAADgAAAA5QAAAmcAAADmAAAA5gAAAIYAAADnAAAA7wAAAm4AAADwAAAA8AAAAIcAAADxAAAA9gAAAncAAAD3AAAA+AAAAIgAAAD5AAAA/QAAAn0AAAD+AAAA/gAAAIoAAAD/AAABDwAAAoIAAAEQAAABEAAAAkcAAAERAAABEQAABEcAAAESAAABJQAAApMAAAEmAAABJgAAAIsAAAEnAAABJwAAAkkAAAEoAAABMAAAAqcAAAExAAABMQAAAIwAAAEyAAABNwAAArAAAAE4AAABOAAAAI0AAAE5AAABQAAAArYAAAFBAAABQgAAAI4AAAFDAAABSQAAAr4AAAFKAAABSwAAAJAAAAFMAAABUQAAAsUAAAFSAAABUwAAAJIAAAFUAAABXwAAAssAAAFgAAABYQAAAtkAAAFiAAABZQAAAt0AAAFmAAABZwAAAkoAAAFoAAABfgAAAuEAAAF/AAABfwAAAJQAAAGPAAABjwAAAJUAAAGSAAABkgAAAJYAAAGgAAABoQAAAJcAAAGvAAABsAAAAJkAAAHwAAAB8AAAA6sAAAH6AAAB+gAAAlIAAAH7AAAB+wAAAm0AAAH8AAAB/wAAAvgAAAIYAAACGQAAAtcAAAIaAAACGwAAAtsAAAI3AAACNwAAAJsAAAJZAAACWQAAAJwAAAK8AAACvAAAA6wAAALGAAACxwAAAJ0AAALJAAACyQAAAJ8AAALYAAAC3QAAAKAAAALzAAAC8wAAAKYAAAMAAAADAQAAAKcAAAMDAAADAwAAAKkAAAMJAAADCQAAAKoAAAMPAAADDwAAAKsAAAMjAAADIwAAAKwAAAOEAAADhQAAAK0AAAOGAAADhgAAA1MAAAOHAAADhwAAAK8AAAOIAAADigAAA1QAAAOMAAADjAAAA1cAAAOOAAADkgAAA1gAAAOTAAADlAAAALAAAAOVAAADlwAAA10AAAOYAAADmAAAALIAAAOZAAADmgAAA2AAAAObAAADmwAAALMAAAOcAAADnQAAA2IAAAOeAAADngAAALQAAAOfAAADnwAAA2QAAAOgAAADoAAAALUAAAOhAAADoQAAA2UAAAOjAAADowAAALYAAAOkAAADpQAAA2YAAAOmAAADpgAAALcAAAOnAAADpwAAA2gAAAOoAAADqQAAALgAAAOqAAADsAAAA2kAAAOxAAADuQAAALoAAAO6AAADugAAA3AAAAO7AAADuwAAAMMAAAO8AAADvQAAA3IAAAO+AAADvgAAAMQAAAO/AAADvwAAA3EAAAPAAAADxgAAAMUAAAPHAAADxwAAA3QAAAPIAAADyQAAAMwAAAPKAAADzgAAA3UAAAPRAAAD0gAAAM4AAAPWAAAD1gAAANAAAAQAAAAEAAAAA7EAAAQBAAAEAQAAA3oAAAQCAAAEAgAAANEAAAQDAAAEAwAAA3sAAAQEAAAEBAAAANIAAAQFAAAECAAAA3wAAAQJAAAECwAAANMAAAQMAAAEDAAAA4EAAAQNAAAEDQAAA7IAAAQOAAAEDgAAA4IAAAQPAAAEDwAAANYAAAQQAAAEEAAAA4MAAAQRAAAEEQAAANcAAAQSAAAEEwAAA4QAAAQUAAAEFAAAANgAAAQVAAAEFQAAA4YAAAQWAAAEGAAAANkAAAQZAAAEGQAAA4cAAAQaAAAEGgAAA4AAAAQbAAAEGwAAANwAAAQcAAAEIgAAA4gAAAQjAAAEJAAAAN0AAAQlAAAEJQAAA48AAAQmAAAELwAAAN8AAAQwAAAEMAAAA5AAAAQxAAAENAAAAOkAAAQ1AAAENQAAA5EAAAQ2AAAEOAAAAO0AAAQ5AAAEOQAAA5IAAAQ6AAAEPQAAAPAAAAQ+AAAEPgAAA5MAAAQ/AAAEPwAAAPQAAARAAAAEQQAAA5QAAARCAAAEQgAAAPUAAARDAAAEQwAAA5YAAAREAAAERAAAAPYAAARFAAAERQAAA5cAAARGAAAETwAAAPcAAARQAAAEUAAAA7MAAARRAAAEUQAAA5gAAARSAAAEUgAAAQEAAARTAAAEUwAAA5kAAARUAAAEVAAAAQIAAARVAAAEWAAAA5oAAARZAAAEWwAAAQMAAARcAAAEXAAAA54AAARdAAAEXQAAA7QAAAReAAAEXgAAA58AAARfAAAEYQAAAQYAAARiAAAEYgAABF0AAARjAAAEbwAAAQkAAARwAAAEcQAAA7UAAARyAAAEdQAAARYAAAR2AAAEdwAAA7cAAAR4AAAEeAAAA7oAAAR5AAAEeQAAA7kAAAR6AAAEhgAAARoAAASIAAAEiQAAAScAAASKAAAEiwAABGIAAASMAAAEjAAABFwAAASNAAAEkQAAASkAAASSAAAEkwAABF4AAASUAAAElQAAAS4AAASWAAAElwAABFcAAASYAAAEmQAAA7sAAASaAAAEmwAABEkAAAScAAAEnQAAATAAAASeAAAEnwAABGAAAASgAAAEoQAAATIAAASiAAAEowAABEsAAASkAAAEqQAAATQAAASqAAAEqwAAA70AAASsAAAErQAABE0AAASuAAAErwAAA78AAASwAAAEsQAABGoAAASyAAAEswAABE8AAAS0AAAEtQAAAToAAAS2AAAEtwAABFEAAAS4AAAEugAAATwAAAS7AAAEuwAABFsAAAS8AAAEvQAAAT8AAAS+AAAEvwAABFkAAATAAAAEwgAAA8EAAATDAAAExAAAAUEAAATFAAAExgAABGgAAATHAAAEyAAAAUMAAATJAAAEygAABGQAAATLAAAEzAAABFMAAATNAAAEzgAABGYAAATPAAAE1wAAA8QAAATYAAAE2AAAAUUAAATZAAAE2QAAA84AAATaAAAE2gAAA80AAATbAAAE3wAAA88AAATgAAAE4QAAAUYAAATiAAAE9QAAA9QAAAT2AAAE9wAABFUAAAT4AAAE+QAAA+gAAAT6AAAE+wAAAUgAAAT8AAAE/QAAA+oAAAT+AAAE/wAABGwAAAUAAAAFAAAAAUoAAAUBAAAFAQAAA+wAAAUCAAAFEAAAAUsAAAURAAAFEQAABG4AAAUSAAAFEwAAA+0AAB4AAAAeAQAAA68AAB4+AAAePwAAA60AAB6AAAAehQAAA6AAAB6gAAAe8QAAA+8AAB7yAAAe8wAAA6YAAB70AAAe+QAABEEAAB9NAAAfTQAABKoAACAAAAAgCwAAAVsAACAQAAAgEQAAAWcAACATAAAgFAAAAWkAACAVAAAgFQAABHAAACAXAAAgHgAAAWsAACAgAAAgIgAAAXMAACAlAAAgJwAAAXYAACAwAAAgMAAAAXkAACAyAAAgMwAAA6gAACA5AAAgOgAAAXoAACA8AAAgPAAAA6oAACBEAAAgRAAAAXwAACB0AAAgdAAAAX0AACB/AAAgfwAAAX4AACCjAAAgowAABG8AACCkAAAgpAAAAX8AACCmAAAgqgAAAYAAACCrAAAgqwAABEgAACCsAAAgrAAAAYUAACCxAAAgsQAAAYYAACC5AAAgugAAAYcAACC8AAAgvQAAAYkAACEFAAAhBQAAAYsAACETAAAhEwAAAYwAACEWAAAhFgAAAY0AACEiAAAhIgAAAY4AACEmAAAhJgAAALkAACEuAAAhLgAAAY8AACFbAAAhXgAAAZAAACICAAAiAgAAAZQAACIGAAAiBgAAALEAACIPAAAiDwAAAZUAACIRAAAiEgAAAZYAACIaAAAiGgAAAZgAACIeAAAiHgAAAZkAACIrAAAiKwAAAZoAACJIAAAiSAAAAZsAACJgAAAiYAAAAZwAACJkAAAiZQAAAZ0AACXKAAAlygAAAZ8AAO4BAADuAgAAAaAAAPbDAAD2wwAAAaIAAPsBAAD7BAAAAaQAAP7/AAD+/wAAAaoAAP/8AAD//QAAAauwACxLsAlQWLEBAY5ZuAH/hbCEHbEJA19eLbABLCAgRWlEsAFgLbACLLABKiEtsAMsIEawAyVGUlgjWSCKIIpJZIogRiBoYWSwBCVGIGhhZFJYI2WKWS8gsABTWGkgsABUWCGwQFkbaSCwAFRYIbBAZVlZOi2wBCwgRrAEJUZSWCOKWSBGIGphZLAEJUYgamFkUlgjilkv/S2wBSxLILADJlBYUViwgEQbsEBEWRshISBFsMBQWLDARBshWVktsAYsICBFaUSwAWAgIEV9aRhEsAFgLbAHLLAGKi2wCCxLILADJlNYsEAbsABZioogsAMmU1gjIbCAioobiiNZILADJlNYIyGwwIqKG4ojWSCwAyZTWCMhuAEAioobiiNZILADJlNYIyG4AUCKihuKI1kgsAMmU1iwAyVFuAGAUFgjIbgBgCMhG7ADJUUjISMhWRshWUQtsAksS1NYRUQbISFZLbAKLLAkRS2wCyywJUUtsAwssScBiCCKU1i5QAAEAGO4CACIVFi5ACQD6HBZG7AjU1iwIIi4EABUWLkAJAPocFlZWS2wDSywQIi4IABaWLElAEQbuQAlA+hEWS2wDCuwACsAsgEOAisBsg8BAisBtw86MCUbEAAIKwC3AUg7LiEUAAgrtwJYSDgoFAAIK7cDUkM0JRYACCu3BF5NPCsZAAgrtwU2LCIZDwAIK7cGcV1GMhsACCu3B5F3XDojAAgrtwh+Z1A5GgAIK7cJVEU2JhcACCu3CnZgSzYdAAgrtwuDZE46IwAIK7cM2bKKYzwACCu3DRQRDQkGAAgrtw48MiccEQAIKwCyEAoHK7AAIEV9aRhEsjASAXOysBQBc7JQFAF0soAUAXSycBQBdbIPHAFzsm8cAXUAACoAnQCAAIoAeADUAGQATgBaAIcAYABWADQCPAC8AMQAAAAU/mAAFAKbACADIQALBDoAFASNABAFsAAUBhgAFQGmABEGwAAOAAAAAAAAAGEAYQBhAGEAYQCTALgBOAGqAjoCzQLkAw4DOANrA5ADrwPFA+YD/QRKBHgExwU8BX8F3wY+BmsG3wdGB1sHcAePB7YH1QgzCNYJFQl0CcgKDQpNCoMK6wstC0gLewvQC/QMQgx+DNMNHg2DDd8OSg50DrYO5g87D5APwA/4EBwQMxBYEH8QmhC6ETIRkBHjEkESqBL6E3QTuRPxFD0UlBSvFRoVZRWzFhcWeBa1Fx8XcRe4F+gYNhh9GMIY+hk7GVIZkhnZGgwaaBraGz0bnBu7HGAcjx01HaMdrx3MHoQemh7WHxkfaR/kIAQgTSB5IJgg0yEFIU8hWyF1IY8hqSIKIm0iqyMmI3oj6iSoJRclaCXZJjgmliaxJwEnSyeIJ9koNCi3KVEpginnKk4quCsYK2srxCvyLFUsgyynLLUs4Cz/LTgtbC2wLeMuIS4+LlsuZC6XLsgu5C8AL0MvTy91L6IwHTBKMIwwujD2MWcxwTIpMp4zEzNGM7c0IzR/NMo1SjV3NdA2PjaPNuk3RDebN944HziIOOQ5SznCOhU6izrmO1871TxHPJs81z0uPYY99D5pPq4++D9AP7E/50AsQGlAskEKQW1BuUI2QsdDIkOSRAlEL0SFRPhFcUWqRgFGSEaQRuxHGkdGR9FIB0hHSIRIyEkfSYFJy0o9SsNLHkuVTBVMikz3TV5Nmk38TlxOxE9GT+FQLVB8UOdRVlHLUjpSxVNPU99UelT8VXRVuFX+VmpW0VeKWERYw1lCWZNZ4FoVWjFaaFp+WpRbZVvYXEBcm10OXT5daF29XhJeaV7LXx9ffl/IYDFgj2DtYYxiI2JzYrZjBmNUY5ZkBmR3ZM9lM2WsZiNmi2brZ0RnU2dnZ7RoF2ieaQ5pe2neaj5qrGsVa55sIGx8bM5tIG1xbeZuFW4VbhVuFW4VbhVuFW4VbhVuFW4VbhVuFW4dbiVuL245blBudG6Ybrpu1W7hbu1vJW9jb8Rv52/zcANwF3DocQRxIXE0cUhxj3IXcrRzQ3NPdA90cnTudYt17XZmdr93KXfZeD9403kxeZN5pHm1ecZ513pIem56pnrBevV7h3vIfFN8k3yxfM99CH0VfT99Yn1ufdZ+KH60fyJ/lIBXgFeCBoJygp+C6IMTgymDmYP5hEeEtIULhVOFm4XqhgSGQ4aphv2HRIeHh76IHYheiHmIr4jyiRaJZ4mgifOKPYqbivOLWIuCi7+L74xHjJCMwIz4jUGNbI27jiqObI7IjyGPTo/KkCeQPZCikUuRrpIRkmGSppLnkymTnJQAlG6UmJTOlTSVZpWyleSWI5aJluCXQZefmA+Yg5j4mUqZiZngmjeaq5skm2CbsJv4nD6ceZy6nPmdQ52bnaed9J5jnuCfN595n/6gX6DAoR2hsKHBohyiaKK2ovijaKPLpC+kn6UxpbWmS6a9px2nb6fPqEmoUai2qRepeanwqkuqu6sHq2arzqv4rEusd6zHrQutH60zrUWtWa1rrYKtlq3srhKuk671r0OvS69Tr1uvZq9ur3qv3a/dr+WwS7CxsRCxUrG2sc2x5LH7shKyK7JEslCyXLJzsoqyobK6stGy6LL/sxizL7NGs12zdLOLs6Szu7PSs+m0ArQZtDC0R7RdtHO0jLSltLG0vbTUtOu1AbUatTC1RrVdtXa1jLWjtbq10LXmtf+2FrYttkO2XLZztou2ora4ts+25rdJt9+39rgNuCS4OrhRuGi4f7iVuKy43bj0uQq5Ibk4uU+5ZrnOulK6abp/upa6rLrDutq68bsIuxS7K7tCu1S7a7uCu5m7sLvHu9676bv0vAu8F7wjvDq8UbxdvGm8gLyXvKO8r7zEvPm9Bb0RvSi9P71LvVe9br2EvZS9q73Bvdi9774IviG+OL5Pvlu+Z75+vpS+q77Cvtm+7777vwe/E78fvza/TL9Yv2S/cL98v5O/n7+2v8y/47/5wBDAJ8BAwFnAcsCLwOjBTsFlwXzBk8GpwcLB2cHwwgfCHsI1wkvCYsJ5wpDCp8LKwvLDBcMcwzPDScNfw3jDkcOdw6nDwMPXw+3EBcQbxDHESMRhxHjEj8SmxL3E1MTtxQTFG8UxxUrFYcV3xY7F8cYIxh7GNcZMxmLGeMaOxqXHDsckxzrHUcdox3THi8eix7nH0Mfbx/HICMgUyCrINshLyFfIbsh6yJHIqMi/yNjI78j7yRHJKMk+yUrJYMlsyYLJjsmkybrJ0cnqygPKX8p2yozKpMq7ytLK6Mrzyv/LC8sXyyPLL8s7y1fLX8tny2/Ld8t/y4fLj8uXy5/Lp8uvy7fLv8vHy+DL+cwQzCfMPsxUzG/Md8x/zIfMj8yXzK/Mx8zezPXNDM0lzTzNp82vzcjN0M3Yze/OBs4OzhbOHs4mzj3ORc5NzlXOXc5lzm3Odc59zoXOjc6kzqzOtM8Hzw/PF88wz0fPT89Xz3DPeM+Pz6XPvM/Tz+rQAdAa0DPQStBh0GnQcdB90JTQnNCz0MrQ1tDi0PnRENEn0T7RRtFO0WfRgNGM0ZjRpNGw0bzRyNHQ0djR4NH30g7SFtIt0kTSW9J00nzShNKb0rLSy9LT0uzTBdMe0zfTT9Nm03zTldOu08fT4NPo0/DUCdQi1DvUU9Rq1IDUmdSx1MrU49T81RTVMdVO1VrVZtVu1XrVhtWS1Z7VtdXM1eXV/dYW1i7WR9Zf1njWkNar1sXW3tb31xDXKddC11vXdNeN16jXw9fP19vX8tgJ2CDYNthP2GfYgNiY2LHYydji2PrZFdkv2UbZXdlp2XXZgdmN2aTZu9nU2ezaBdod2jbaTtpn2n/amtq02sva4tr52xDbJ9s+21Xba9t324Pbj9ub27Lbydvg2/fcDtwl3DzcU9xq3IDcjNyY3KTcsNzH3N7c9d0L3YHdlt2i3a7dut3G3dLd3t3q3fbeAt4O3hreJt4y3j7eSt5W3mLebt523tTfMt9037PgF+B14JDgq+C34MPgz+Db4Ofg8+E94Y3h5eI74kPiT+JZ4mHiaeJx4nnigeKJ4qDit+LO4uXi/uMX4zDjSeNi43vjlOOt48bj3+P45BHkHeQp5DXkQeRN5FnkZeRx5H3klOSm5LLkvuTK5Nbk4uTu5PrlBuUd5TTlQOVM5VjlZOVw5Xzlk+Wp5bXlweXN5dnl5eXx5f3mCeYV5iHmLeY55kXmUeZZ5mHmaeZx5nnmgeaJ5pHmmeah5qnmsea55tLm6ucC5xnnIecp50LnSudh53fnf+eH54/nl+eu57bnvufG587n1ufe5+bn7uh46MTpIukq6TbpTelj6Wvpd+mD6Y/pmwAAAAUAZAAAAygFsAADAAYACQAMAA8AcbIMEBEREjmwDBCwANCwDBCwBtCwDBCwCdCwDBCwDdAAsABFWLACLxuxAhw+WbAARViwAC8bsQAQPlmyBAIAERI5sgUCABESObIHAgAREjmyCAIAERI5sQoM9LIMAgAREjmyDQIAERI5sAIQsQ4M9DAxISERIQMRAQERAQMhATUBIQMo/TwCxDb+7v66AQzkAgP+/gEC/f0FsPqkBQf9fQJ3+xECeP1eAl6IAl4AAgCg//UBewWwAAMADAAvALAARViwAi8bsQIcPlmwAEVYsAsvG7ELED5ZsgYFCitYIdgb9FmyAQYCERI5MDEBIwMzAzQ2MhYUBiImAVunDcLJN2w4OGw3AZsEFfqtLT09Wjs7AAIAiAQSAiMGAAAEAAkAGQCwAy+yAgoDERI5sAIvsAfQsAMQsAjQMDEBAyMTMwUDIxMzARUebwGMAQ4ebwGMBXj+mgHuiP6aAe4AAgB3AAAE0wWwABsAHwCPALAARViwDC8bsQwcPlmwAEVYsBAvG7EQHD5ZsABFWLACLxuxAhA+WbAARViwGi8bsRoQPlmyHQwCERI5fLAdLxiyAAMKK1gh2Bv0WbAE0LAdELAG0LAdELAL0LALL7IIAworWCHYG/RZsAsQsA7QsAsQsBLQsAgQsBTQsB0QsBbQsAAQsBjQsAgQsB7QMDEBIQMjEyM1IRMhNSETMwMhEzMDMxUjAzMVIwMjAyETIQL9/vhQj1DvAQlF/v4BHVKPUgEIUpBSzOdF4ftQkJ4BCEX++AGa/mYBmokBYosBoP5gAaD+YIv+non+ZgIjAWIAAAEAbv8wBBEGnAArAGYAsABFWLAJLxuxCRw+WbAARViwIi8bsSIQPlmyAiIJERI5sAkQsAzQsAkQsBDQsAkQshMBCitYIdgb9FmwAhCyGQEKK1gh2Bv0WbAiELAf0LAiELAm0LAiELIpAQorWCHYG/RZMDEBNCYnJiY1NDY3NTMVFhYVIzQmIyIGFRQWBBYWFRQGBxUjNSYmNTMUFjMyNgNYgZnVw7+nlai7uIZyd36FATGrUcu3lLrTuZKGg5YBd1x+M0HRoaTSFNvcF+zNjaZ7bmZ5Y3eeaqnOE7+/EefGi5Z+AAUAaf/rBYMFxQANABoAJgA0ADgAeACwAEVYsAMvG7EDHD5ZsABFWLAjLxuxIxA+WbADELAK0LAKL7IRBAorWCHYG/RZsAMQshgECitYIdgb9FmwIxCwHdCwHS+wIxCyKgQKK1gh2Bv0WbAdELIxBAorWCHYG/RZsjUjAxESObA1L7I3AyMREjmwNy8wMRM0NjMyFhUVFAYjIiY1FxQWMzI2NTU0JiIGFQE0NiAWFRUUBiAmNRcUFjMyNjU1NCYjIgYVBScBF2mng4Wlp4GCqopYSkdXVpRWAjunAQaop/78qopYSkhWV0lHWf4HaQLHaQSYg6qriEeEp6eLB05lYlVJTmZmUvzRg6moi0eDqaeLBk9lY1VKT2RjVPNCBHJCAAMAZf/sBPMFxAAeACcAMwCFALAARViwCS8bsQkcPlmwAEVYsBwvG7EcED5ZsABFWLAYLxuxGBA+WbIiHAkREjmyKgkcERI5sgMiKhESObIQKiIREjmyEQkcERI5shMcCRESObIZHAkREjmyFhEZERI5sBwQsh8BCitYIdgb9FmyIR8RERI5sAkQsjEBCitYIdgb9FkwMRM0NjcmJjU0NjMyFhUUBgcHATY1MxQHFyMnBgYjIiQFMjcBBwYVFBYDFBc3NjY1NCYjIgZldaVhQsSolsRZb2sBRESne9DeYUrHZ9X+/gHXk3r+nSGnmSJ2dkQyZExSYAGHabB1dpBHpryvhViVUk/+fYKf/6j5c0JF4ktwAakYe4J2jgPlYJBTMFc+Q1lvAAEAZwQhAP0GAAAEABAAsAMvsgIFAxESObACLzAxEwMjEzP9FYEBlQWR/pAB3wABAIX+KgKVBmsAEQAJALAOL7AELzAxEzQSEjcXBgIDBxATFhcHJicChXnwgSaSuwkBjVV1JoV57AJP4gGgAVRGenD+NP7jVf5+/uSqYHFKrgFUAAABACb+KgI3BmsAEQAJALAOL7AELzAxARQCAgcnNhITNTQCAic3FhISAjd18YQnmrsCWJ1iJ4TvdwJF3/5n/qZJcXYB8QEvINIBaQEeUHFJ/qr+ZAABABwCYQNVBbAADgAgALAARViwBC8bsQQcPlmwANAZsAAvGLAJ0BmwCS8YMDEBJTcFAzMDJRcFEwcDAycBSv7SLgEuCZkKASku/s3GfLq0fQPXWpdwAVj+o26YW/7xXgEg/udbAAABAE4AkgQ0BLYACwAaALAJL7AA0LAJELIGAQorWCHYG/RZsAPQMDEBIRUhESMRITUhETMCngGW/mq6/moBlroDDa/+NAHMrwGpAAEAHf7eATQA2wAIABcAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBoZpXgS1Y/7eSIOLp5FlygAAAQAlAh8CDQK2AAMAEQCwAi+yAQEKK1gh2Bv0WTAxASE1IQIN/hgB6AIflwABAJD/9QF2ANEACQAbALAARViwBy8bsQcQPlmyAgUKK1gh2Bv0WTAxNzQ2MhYVFAYiJpA5cjs7cjlhMEBAMC4+PgABABL/gwMQBbAAAwATALAAL7AARViwAi8bsQIcPlkwMRcjATOxnwJgnn0GLQAAAgBz/+wECgXEAA0AGwA5ALAARViwCi8bsQocPlmwAEVYsAMvG7EDED5ZsAoQshEBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMnNCYjIgYHERQWMzI2NwQK3uzp4ATe7eveA7mEj46CAomLiYUDAm3+u/7EATUBM/cBQQE4/tP+xg3r19be/tjs4dTkAAEAqgAAAtkFtwAGADkAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvsgMBCitYIdgb9FmyAgMFERI5MDEhIxEFNSUzAtm6/osCEh0E0YmoxwAAAQBdAAAEMwXEABcATQCwAEVYsBAvG7EQHD5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQsgMQFxESObAQELIJAQorWCHYG/RZsBAQsAzQshUXEBESOTAxISE1ATY2NTQmIyIGFSM0JDMyFhUUAQEhBDP8RgH4cFWKc4qZuQED2cvs/u7+egLbhQIwf59VcpKdjMn41bHX/tf+WQABAF7/7AP5BcQAJgB4ALAARViwDS8bsQ0cPlmwAEVYsBkvG7EZED5ZsgANGRESObAAL7LPAAFdsp8AAXGyLwABXbJfAAFysA0QsgYBCitYIdgb9FmwDRCwCdCwABCyJgEKK1gh2Bv0WbITJgAREjmwGRCwHNCwGRCyHwEKK1gh2Bv0WTAxATM2NjUQIyIGFSM0NjMyFhUUBgcWFhUUBCAkNTMUFjMyNjU0JicjAYaLg5b/eI+5/cPO6ntqeIP/AP5m/v+6ln6GjpyTiwMyAoZyAQCJca3l2sJfsiwmsH/E5t62c4qMg3+IAgACADUAAARQBbAACgAOAEkAsABFWLAJLxuxCRw+WbAARViwBC8bsQQQPlmyAQkEERI5sAEvsgIBCitYIdgb9FmwBtCwARCwC9CyCAYLERI5sg0JBBESOTAxATMVIxEjESE1ATMBIREHA4bKyrr9aQKMxf2BAcUWAemX/q4BUm0D8fw5AsooAAEAmv/sBC0FsAAdAGEAsABFWLABLxuxARw+WbAARViwDS8bsQ0QPlmwARCyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGgEKK1gh2Bv0WbIFBxoREjmwDRCwEdCwDRCyFAEKK1gh2Bv0WbAHELAd0DAxExMhFSEDNjMyEhUUAiMiJiczFhYzMjY1NCYjIgcHzkoC6v2zLGuIx+rz2sH0Ea8RkHaBk5+EeUUxAtoC1qv+cz/++eDh/v3WvX1/sJuSsTUoAAIAhP/sBBwFsQAUACEATgCwAEVYsAAvG7EAHD5ZsABFWLANLxuxDRA+WbAAELIBAQorWCHYG/RZsgcNABESObAHL7IVAQorWCHYG/RZsA0QshwBCitYIdgb9FkwMQEVIwYEBzYzMhIVFAIjIgA1NRAAJQMiBgcVFBYzMjY1NCYDTyLY/wAUc8e+4/XO0f78AVcBU9JfoB+ieX2PkQWxnQT44YT+9NTh/vIBQf1HAZIBqQX9cHJWRLTcuJWWuQABAE0AAAQlBbAABgAyALAARViwBS8bsQUcPlmwAEVYsAEvG7EBED5ZsAUQsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhBCX9pcICWfzsA9gFSPq4BRiYAAADAHD/7AQOBcQAFwAhACsAYQCwAEVYsBUvG7EVHD5ZsABFWLAJLxuxCRA+WbInCRUREjmwJy+yzycBXbIaAQorWCHYG/RZsgMaJxESObIPJxoREjmwCRCyHwEKK1gh2Bv0WbAVELIiAQorWCHYG/RZMDEBFAYHFhYVFAYjIiY1NDY3JiY1NDYzMhYDNCYiBhQWMzI2ASIGFRQWMjY0JgPsc2Jyhf/Q0v2BcmFw7MHA7Zeb+peTg4KU/upth4XehYoENG2qMDG8d73g4bx2vjEwqmy42Nj8oXqamPiOjwQah3RviYnejAAAAgBk//8D+AXEABcAJABYALAARViwCy8bsQscPlmwAEVYsBMvG7ETED5ZsgMTCxESObADL7IAAwsREjmwExCyFAEKK1gh2Bv0WbADELIYAQorWCHYG/RZsAsQsh8BCitYIdgb9FkwMQEGBiMiJiY1NDY2MzISERUQAAUjNTM2NiUyNjc1NCYjIgYVFBYDPjqhYH67Zm/MiNj5/rD+rSQn5fb+7l2dJJ55epSPAoBFVHzhiJLqfP69/uk2/lf+eQWcBOf6clRKtuS7mZXBAP//AIb/9QFtBEQAJgAS9gABBwAS//cDcwAQALAARViwDS8bsQ0YPlkwMf//ACn+3gFVBEQAJwAS/98DcwEGABAMAAAQALAARViwAy8bsQMYPlkwMQABAEgAwwN6BEoABgAWALAARViwBS8bsQUYPlmwAtCwAi8wMQEFFQE1ARUBCAJy/M4DMgKE/cQBe5IBesQAAAIAmAGPA9oDzwADAAcAJQCwBy+wA9CwAy+yAAEKK1gh2Bv0WbAHELIEAQorWCHYG/RZMDEBITUhESE1IQPa/L4DQvy+A0IDLqH9wKAAAAEAhgDEA9wESwAGABYAsABFWLACLxuxAhg+WbAF0LAFLzAxAQE1ARUBNQMb/WsDVvyqAooBA77+hpL+hcAAAgBL//UDdgXEABgAIQBRALAARViwEC8bsRAcPlmwAEVYsCAvG7EgED5ZshsFCitYIdgb9FmyABsQERI5sgQQABESObAQELIJAQorWCHYG/RZsBAQsAzQshUAEBESOTAxATY2Nzc2NTQmIyIGFSM2NjMyFhUUBwcGFQM0NjIWFAYiJgFlAjJNg1RuaWZ8uQLjtr3Tom1JwTdsODhsNwGad4pUh19taXdsW6LHy7GvqmxRmP7DLT09Wjs7AAACAGr+OwbWBZcANQBCAGgAsDIvsABFWLAILxuxCBA+WbAD0LIPMggREjmwDy+yBQgPERI5sAgQsjkCCitYIdgb9FmwFdCwMhCyGwIKK1gh2Bv0WbAIELAq0LAqL7IjAgorWCHYG/RZsA8QskACCitYIdgb9FkwMQEGAiMiJwYGIyImNzYSNjMyFhcDBjMyNjcSACEiBAIHBhIEMzI2NxcGBiMiJAITEhIkMzIEEgEGFjMyNjc3EyYjIgYGygzYtbs1NotKjpITD3m/aVGAUDQTk3GMBhP+uf6yyf7ItAsMkAEn0Vq1PCU+zWn6/pizDAzeAXzv+QFkrvvyDlFYPG8kAS44QHWZAfby/uioVVPozaUBA5QrP/3W5+C0AYUBmMf+iPb4/pPBLCNzJzLhAacBGwETAbfv4P5a/pCOmGZfCQH3He4AAAIAHAAABR0FsAAHAAoARgCwAEVYsAQvG7EEHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwPN/Z6JxgIsqAItxf1NAe/4AXz+hAWw+lACGgKpAAMAqQAABIgFsAAOABYAHwBVALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7IPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQsh8BCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NRAhJSEyNjU0JiMhqQHc7e90ZHaJ/uj+xwE9hpv+4v7AASJ+l4yP/uQFsMTAZp0rIbmAxOACqf30i3oBB5p+bHhtAAABAHf/7ATYBcQAHABFALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYEIyAAETU0EiQzMgAXIyYmIyICFRUUEjMyNjcE2Bv+4e7+/v7JkQEKr+gBGBfBGaeWuNHGsqCrHAHO5/sBcgE2jMsBNKX+/eWunP7w+43t/uiRtAACAKkAAATGBbAACwAVADkAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyEjU1NAInqQGbvgEknwGf/tnE08re9+nWBbCo/srJXc7+yqYCBRL7iwEU/1X4ARMCAAABAKkAAARGBbAACwBOALAARViwBi8bsQYcPlmwAEVYsAQvG7EEED5ZsgsEBhESObALL7IAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA+D9iQLd/GMDk/0tAncCof38nQWwnv4sAAEAqQAABC8FsAAJAEAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyCQIEERI5sAkvsgABCitYIdgb9FmwBBCyBgEKK1gh2Bv0WTAxASERIxEhFSERIQPM/Z3AA4b9OgJjAoP9fQWwnv4OAAEAev/sBNwFxAAfAGIAsABFWLALLxuxCxw+WbAARViwAy8bsQMQPlmwCxCwD9CwCxCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZsh4DCxESObAeL7QPHh8eAl20Px5PHgJdsh0BCitYIdgb9FkwMSUGBCMiJAInNRAAITIEFyMCISICAxUUEjMyNjcRITUhBNxK/vewsv7slwIBMwEW5AEWH8A2/t7BxwHgv2yiNf6vAhC/ammnATTLfwFJAWrp1gEh/vH+/3f1/t8wOQFHnAABAKkAAAUIBbAACwBVALAARViwBi8bsQYcPlmwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmwABCwCdCwCS+ynwkBcrIvCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwUIwf0iwMAC3sECof1fBbD9jgJyAAABALcAAAF3BbAAAwAdALAARViwAi8bsQIcPlmwAEVYsAAvG7EAED5ZMDEhIxEzAXfAwAWwAAABADX/7APMBbAADwAuALAARViwAC8bsQAcPlmwAEVYsAUvG7EFED5ZsAnQsAUQsgwBCitYIdgb9FkwMQEzERQGIyImNTMUFjMyNjcDC8H70dnywImCd5MBBbD7+dHs3sh9jJaHAAABAKkAAAUFBbAACwB0ALAARViwBS8bsQUcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIFERI5QBFKAFoAagB6AIoAmgCqALoACF2yOQABXbIGBQIREjlAEzYGRgZWBmYGdgaGBpYGpga2BgldMDEBBxEjETMRATMBASMCG7LAwAKH6P3DAmrmAqW5/hQFsP0wAtD9ffzTAAEAqQAABBwFsAAFACgAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAWoCsvyNwZ2dBbAAAAEAqQAABlIFsAAOAFkAsABFWLAALxuxABw+WbAARViwAi8bsQIcPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmyAQAEERI5sgcABBESObIKAAQREjkwMQkCMxEjERMBIwETESMRAaEB3AHc+cAS/iKT/iMTwAWw+1wEpPpQAjcCZPtlBJj9n/3JBbAAAAEAqQAABQgFsAAJAEyyAQoLERI5ALAARViwBS8bsQUcPlmwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyAgUAERI5sgcFABESOTAxISMBESMRMwERMwUIwf0jwcEC378EYvueBbD7mQRnAAIAdv/sBQkFxAARAB8AOQCwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIVAQorWCHYG/RZsAQQshwBCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFScQAiMiAgcVFBIzMhI3BQmQ/viwrP72kwKSAQusrwELkL/Qu7bRA9O5uswDAqnW/sGoqQE5zmnSAUKrqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgCpAAAEwAWwAAoAEwBNsgoUFRESObAKELAM0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbILAwEREjmwCy+yAAEKK1gh2Bv0WbADELISAQorWCHYG/RZMDEBESMRITIEFRQEIyUhMjY1NCYnIQFpwAIZ7wEP/vf3/qkBWZqkpI/+nAI6/cYFsPTJ1OWdkYmCnAMAAgBt/woFBgXEABUAIgBNsggjJBESObAIELAZ0ACwAEVYsBEvG7ERHD5ZsABFWLAILxuxCBA+WbIDCBEREjmwERCyGQEKK1gh2Bv0WbAIELIgAQorWCHYG/RZMDEBFAIHBQclBiMiJAInNTQSJDMyBBIVJxACIyICBxUUEiASNwUBhnkBBIP+zUhQrP72kwKSAQussAELkMDNvrXRA9EBdMwDAqnT/s9WzHn0EqkBOc5p0gFCq6r+wdUBAQEBF/7r9mv6/uABD/0AAAIAqAAABMkFsAAOABcAYbIFGBkREjmwBRCwFtAAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwAEVYsA0vG7ENED5ZshAEAhESObAQL7IAAQorWCHYG/RZsgsABBESObAEELIWAQorWCHYG/RZMDEBIREjESEyBBUUBgcBFSMBITI2NTQmJyECv/6qwQHi9gEJk4MBVs79bgEnj6mhmP7aAk39swWw4NaIyjL9lgwC6pR8h5ABAAABAFD/7ARyBcQAJgBhsgAnKBESOQCwAEVYsAYvG7EGHD5ZsABFWLAaLxuxGhA+WbAGELAL0LAGELIOAQorWCHYG/RZsiYaBhESObAmELIUAQorWCHYG/RZsBoQsB/QsBoQsiIBCitYIdgb9FkwMQEmJjU0JDMyFhYVIzQmIyIGFRQWBBYWFRQEIyIkJjUzFBYzMjY0JgJW9+EBE9yW64HBqJmOn5cBa81j/uznlv78jcHDo5iilgKJR8+YrOF0zHmEl31vWXtme6RvsdVzyH+EmXzWdQAAAQAxAAAElwWwAAcALgCwAEVYsAYvG7EGHD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQMDEBIREjESE1IQSX/iy//i0EZgUS+u4FEp4AAQCM/+wEqgWwABIAPLIFExQREjkAsABFWLAALxuxABw+WbAARViwCS8bsQkcPlmwAEVYsAUvG7EFED5Zsg4BCitYIdgb9FkwMQERBgAHByIAJxEzERQWMzI2NREEqgH+/9wz7/7kAr6uoaOtBbD8Is7++hACAQLiA+D8Jp6vrp4D2wAAAQAcAAAE/QWwAAYAOLIABwgREjkAsABFWLABLxuxARw+WbAARViwBS8bsQUcPlmwAEVYsAMvG7EDED5ZsgABAxESOTAxJQEzASMBMwKLAaDS/eSq/eXR/wSx+lAFsAAAAQA9AAAG7QWwABIAWQCwAEVYsAMvG7EDHD5ZsABFWLAILxuxCBw+WbAARViwES8bsREcPlmwAEVYsAovG7EKED5ZsABFWLAPLxuxDxA+WbIBAwoREjmyBgMKERI5sg0DChESOTAxARc3ATMBFzcTMwEjAScHASMBMwHjHCkBIKIBGSgf4sH+n6/+1BcX/smv/qDAAcvArQP4/AiwxAPk+lAEJW9v+9sFsAABADkAAATOBbAACwBrALAARViwAS8bsQEcPlmwAEVYsAovG7EKHD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyAAEEERI5QAmGAJYApgC2AARdsgYBBBESOUAJiQaZBqkGuQYEXbIDAAYREjmyCQYAERI5MDEBATMBASMBASMBATMChAFd4v40Adfk/pr+mOMB2P4z4QOCAi79Lv0iAjj9yALeAtIAAAEADwAABLsFsAAIADEAsABFWLABLxuxARw+WbAARViwBy8bsQccPlmwAEVYsAQvG7EEED5ZsgABBBESOTAxAQEzAREjEQEzAmUBfNr+CsD+CtwC1QLb/G/94QIfA5EAAAEAVgAABHoFsAAJAEQAsABFWLAHLxuxBxw+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WbIEAAIREjmwBxCyBQEKK1gh2Bv0WbIJBQcREjkwMSUhFSE1ASE1IRUBOQNB+9wDHvzvA/ednZAEgp6NAAABAJL+yAILBoAABwAiALAEL7AHL7IAAQorWCHYG/RZsAQQsgMBCitYIdgb9FkwMQEjETMVIREhAgu/v/6HAXkF6Pl4mAe4AAABACj/gwM4BbAAAwATALACL7AARViwAC8bsQAcPlkwMRMzASMosAJgsAWw+dMAAQAJ/sgBgwaAAAcAJQCwAi+wAS+wAhCyBQEKK1gh2Bv0WbABELIGAQorWCHYG/RZMDETIREhNTMRIwkBev6GwcEGgPhImAaIAAABAEAC2QMUBbAABgAnsgAHCBESOQCwAEVYsAMvG7EDHD5ZsADQsgEHAxESObABL7AF0DAxAQMjATMBIwGqvqwBK38BKqsEu/4eAtf9KQABAAT/aQOYAAAAAwAbALAARViwAy8bsQMQPlmyAAEKK1gh2Bv0WTAxBSE1IQOY/GwDlJeXAAABADkE2AHaBf4AAwAjALABL7IPAQFdsADQGbAALxiwARCwAtCwAi+0DwIfAgJdMDEBIwEzAdqf/v7fBNgBJgAAAgBt/+wD6gROAB4AKAB5shcpKhESObAXELAg0ACwAEVYsBcvG7EXGD5ZsABFWLAELxuxBBA+WbAARViwAC8bsQAQPlmyAhcEERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObAEELIfAQorWCHYG/RZsAsQsiMBCitYIdgb9FkwMSEmJwYjIiY1NCQzMzU0JiMiBhUjNDY2MzIWFxEUFxUlMjY3NSMgFRQWAygQCoGzoM0BAem0dHFjhrpzxXa71AQm/gtXnCOR/qx0IFKGtYupu1Vhc2RHUZdYu6T+DpVYEI1aSN7HV2IAAgCM/+wEIAYAAA4AGQBkshIaGxESObASELAD0ACwCC+wAEVYsAwvG7EMGD5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyBQgDERI5sgoMAxESObAMELISAQorWCHYG/RZsAMQshcBCitYIdgb9FkwMQEUAiMiJwcjETMRNiASESc0JiMiBxEWMzI2BCDkwM1wCaq5cAGK4bmSibdQVbSFlAIR+P7TkX0GAP3Di/7W/v0Fvc6q/iyqzgABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygAAAgBf/+wD8AYAAA8AGgBkshgbHBESObAYELAD0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAMLxuxDBA+WbAARViwCC8bsQgQPlmyBQMMERI5sgoDDBESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFxEzESMnBiMiAjUXFBYzMjcRJiMiBl/sv75vuaoJb8a87bmYhrBRU6yImAIm+QEvggI0+gB0iAE0+Ae40J4B8ZnSAAACAF3/7APzBE4AFQAdAGmyCB4fERI5sAgQsBbQALAARViwCC8bsQgYPlmwAEVYsAAvG7EAED5ZshoIABESObAaL7S/Gs8aAl2yDAEKK1gh2Bv0WbAAELIQAQorWCHYG/RZshMIABESObAIELIWAQorWCHYG/RZMDEFIgA1NTQ2NjMyEhEVIRYWMzI2NxcGASIGByE1JiYCTdz+7HvdgdPq/SMEs4piiDNxiP7ZcJgSAh4IiBQBIfIiof2P/ur+/U2gxVBCWNEDyqOTDo2bAAEAPAAAAsoGFQAVAGOyDxYXERI5ALAARViwCC8bsQgePlmwAEVYsAMvG7EDGD5ZsABFWLARLxuxERg+WbAARViwAC8bsQAQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMR56uruqpAPwovNVpi5+cDq49vrr4RlglpYnKP/FUAAgBg/lYD8gROABkAJACDsiIlJhESObAiELAL0ACwAEVYsAMvG7EDGD5ZsABFWLAGLxuxBhg+WbAARViwCy8bsQsSPlmwAEVYsBcvG7EXED5ZsgUDFxESObIPFwsREjmwCxCyEQEKK1gh2Bv0WbIVAxcREjmwFxCyHQEKK1gh2Bv0WbADELIiAQorWCHYG/RZMDETNBIzMhc3MxEUBiMiJic3FjMyNjU1BiMiAjcUFjMyNxEmIyIGYOrBxm8JqfnSdeA7YHesh5dvwL7rupaHr1JVqoeYAib9ASuMePvg0vJkV2+TmIpdgAEy87fRnwHum9IAAAEAjAAAA98GAAARAEmyChITERI5ALAQL7AARViwAi8bsQIYPlmwAEVYsAUvG7EFED5ZsABFWLAOLxuxDhA+WbIAAgUREjmwAhCyCgEKK1gh2Bv0WTAxATYzIBMRIxEmJiMiBgcRIxEzAUV7xQFXA7kBaW9aiCa5uQO3l/59/TUCzHVwYE78/QYAAAIAjQAAAWgFxAADAAwAPrIGDQ4REjmwBhCwAdAAsABFWLACLxuxAhg+WbAARViwAC8bsQAQPlmwAhCwCtCwCi+yBgUKK1gh2Bv0WTAxISMRMwM0NjIWFAYiJgFVubnIN2w4OGw3BDoBHy0+Plo8PAAC/7/+SwFZBcQADAAWAEmyEBcYERI5sBAQsADQALAARViwDC8bsQwYPlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDBCwFdCwFS+yEAUKK1gh2Bv0WTAxAREQISInNRYzMjY1EQM0NjMyFhQGIiYBS/7lPTQgND5BEzc1Njg4bDYEOvtJ/sgSlAhDUwS7AR8sPz5aPDwAAAEAjQAABAwGAAAMAHUAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIACAIREjlAFToASgBaAGoAegCKAJoAqgC6AMoACl2yBggCERI5QBU2BkYGVgZmBnYGhgaWBqYGtgbGBgpdMDEBBxEjETMRNwEzAQEjAbp0ubljAVHh/lsB1tkB9Xn+hAYA/F93AWT+PP2KAAEAnAAAAVUGAAADAB0AsABFWLACLxuxAh4+WbAARViwAC8bsQAQPlkwMSEjETMBVbm5BgAAAAEAiwAABngETgAdAHeyBB4fERI5ALAARViwAy8bsQMYPlmwAEVYsAgvG7EIGD5ZsABFWLAALxuxABg+WbAARViwCy8bsQsQPlmwAEVYsBQvG7EUED5ZsABFWLAbLxuxGxA+WbIBCAsREjmyBQgLERI5sAgQshABCitYIdgb9FmwGNAwMQEXNjMyFzY2MyATESMRNCYjIgYHESMRNCMiBxEjEQE6BXfK41I2rXYBZAa5an1niAu657ZDuQQ6eIyuTmD+h/0rAsp0c3to/TICxeyb/OoEOgABAIwAAAPfBE4AEQBTsgsSExESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBi8bsQYQPlmwAEVYsA8vG7EPED5ZsgEDBhESObADELILAQorWCHYG/RZMDEBFzYzIBMRIxEmJiMiBgcRIxEBOwZ8yAFXA7kBaW9aiCa5BDqInP59/TUCzHVwYE78/QQ6AAACAFv/7AQ0BE4ADwAbAEOyDBwdERI5sAwQsBPQALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshMBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyIANRcUFjMyNjU0JiMiBlt934/dARF54ZLc/u+6p4yNpqmMiagCJ5/+iv7O/g2e+4wBMvwJtNrdx7Ld2gACAIz+YAQeBE4ADwAaAG6yExscERI5sBMQsAzQALAARViwDC8bsQwYPlmwAEVYsAkvG7EJGD5ZsABFWLAGLxuxBhI+WbAARViwAy8bsQMQPlmyBQwDERI5sgoMAxESObAMELITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMQEUAiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNgQe4sHFcbmpCXHJw+O5nIioVFOrhZ0CEff+0n399wXaeIz+2v76BLfUlf37lNMAAAIAX/5gA+8ETgAPABoAa7IYGxwREjmwGBCwA9AAsABFWLADLxuxAxg+WbAARViwBi8bsQYYPlmwAEVYsAgvG7EIEj5ZsABFWLAMLxuxDBA+WbIFAwwREjmyCgMMERI5shMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxEzQSMzIXNzMRIxEGIyICNRcUFjMyNxEmIyIGX+rFwG8IqrlwusTpuZ2FpVdYooaeAib/ASmBbfomAgR4ATH8CLrUkgISj9UAAQCMAAAClwROAA0ARrIEDg8REjkAsABFWLALLxuxCxg+WbAARViwCC8bsQgYPlmwAEVYsAUvG7EFED5ZsAsQsgIBCitYIdgb9FmyCQsFERI5MDEBJiMiBxEjETMXNjMyFwKXKjG2Qbm0A1unNhwDlAeb/QAEOn2RDgABAF//7AO7BE4AJgBhsgknKBESOQCwAEVYsAkvG7EJGD5ZsABFWLAcLxuxHBA+WbIDHAkREjmwCRCwDdCwCRCyEAEKK1gh2Bv0WbADELIVAQorWCHYG/RZsBwQsCHQsBwQsiQBCitYIdgb9FkwMQE0JiQmJjU0NjMyFhUjNCYjIgYVFBYEFhYVFAYjIiYmNTMWFjMyNgMCcf7npU/hr7jluoFiZXJqARWsU+i5gshxuQWLcml/AR9LUzxUdFCFuL6UTG5YR0NEPlZ5V5GvXKVgXW1VAAEACf/sAlYFQAAVAF+yDhYXERI5ALAARViwAS8bsQEYPlmwAEVYsBMvG7ETGD5ZsABFWLANLxuxDRA+WbABELAA0LAAL7ABELIDAQorWCHYG/RZsA0QsggBCitYIdgb9FmwAxCwEdCwEtAwMQERMxUjERQWMzI3FQYjIiY1ESM1MxEBh8rKNkEgOElFfH7FxQVA/vqP/WFBQQyWFJaKAp+PAQYAAQCI/+wD3AQ6ABAAU7IKERIREjkAsABFWLAGLxuxBhg+WbAARViwDS8bsQ0YPlmwAEVYsAIvG7ECED5ZsABFWLAQLxuxEBA+WbIADQIREjmwAhCyCgEKK1gh2Bv0WTAxJQYjIiYnETMRFDMyNxEzESMDKGzRrbUBucjURrmwa3/JxQLA/UX2ngMT+8YAAAEAIQAAA7oEOgAGADiyAAcIERI5ALAARViwAS8bsQEYPlmwAEVYsAUvG7EFGD5ZsABFWLADLxuxAxA+WbIABQMREjkwMSUBMwEjATMB8QEMvf58jf54vfsDP/vGBDoAAAEAKwAABdMEOgAMAGCyBQ0OERI5ALAARViwAS8bsQEYPlmwAEVYsAgvG7EIGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsgALAxESObIFCwMREjmyCgsDERI5MDElEzMBIwEBIwEzExMzBErQuf7Flv75/wCW/sa41fyV/wM7+8YDNPzMBDr81gMqAAEAKQAAA8oEOgALAFMAsABFWLABLxuxARg+WbAARViwCi8bsQoYPlmwAEVYsAQvG7EEED5ZsABFWLAHLxuxBxA+WbIACgQREjmyBgoEERI5sgMABhESObIJBgAREjkwMQETMwEBIwMDIwEBMwH38Nj+ngFt1vr61wFt/p7WAq8Bi/3p/d0Blf5rAiMCFwABABb+SwOwBDoADwBJsgAQERESOQCwAEVYsAEvG7EBGD5ZsABFWLAOLxuxDhg+WbAARViwBS8bsQUSPlmyAA4FERI5sgkBCitYIdgb9FmwABCwDdAwMQETMwECIycnNRcyNjc3ATMB7vzG/k1l3CNFMl5pIin+fsoBDwMr+x/+8gMNlgRMZW4ELgABAFgAAAOzBDoACQBEALAARViwBy8bsQcYPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAToCefylAlX9tAM0l5eIAxmZgwAAAQBA/pICngY9ABgAMbITGRoREjkAsA0vsAAvsgcNABESObAHL7IfBwFdsgYDCitYIdgb9FmyEwYHERI5MDEBJiY1NTQjNTI1NTY2NxcGERUUBxYVFRIXAnixs9TUAq+zJtGnpwPO/pIy5bzH85Hy0LfhM3ND/ubK41la5c7+7UIAAAEAr/7yAUQFsAADABMAsAAvsABFWLACLxuxAhw+WTAxASMRMwFElZX+8ga+AAABABP+kgJyBj0AGAAxsgUZGhESOQCwCy+wGC+yEQsYERI5sBEvsh8RAV2yEgMKK1gh2Bv0WbIFEhEREjkwMRc2EzU0NyY1NRAnNxYWFxUUMxUiFRUUBgcTywe1tdEmsbIB1NS1r/tBAQrc51RS6csBGkNzMuG50u+R88q84jIAAAEAgwGSBO8DIgAXAEKyERgZERI5ALAARViwDy8bsQ8WPlmwANCwDxCwFNCwFC+yAwEKK1gh2Bv0WbAPELIIAQorWCHYG/RZsAMQsAvQMDEBFAYjIi4CIyIGFQc0NjMyFhYXFzI2NQTvu4lIgKlKKk5UobiLTIywQB1MXwMJntk1lCRrXgKgzkChCgJ0XwACAIv+mAFmBE0AAwAMADKyBg0OERI5sAYQsADQALACL7AARViwCy8bsQsYPlmyBgUKK1gh2Bv0WbIBAgYREjkwMRMzEyMTFAYiJjQ2MhaqqA3CyTdsODhsNwKs++wFTC0+Plo8PAABAGn/CwP5BSYAIQBSsgAiIxESOQCwAEVYsBQvG7EUGD5ZsABFWLAKLxuxChA+WbAH0LIAAQorWCHYG/RZsAoQsAPQsBQQsBHQsBQQsBjQsBQQshsBCitYIdgb9FkwMSUyNjczBgYHFSM1JgI1NTQSNzUzFRYWFyMmJiMiBhUVFBYCSmSUCK8GxpC5s8jKsbmWwAavCI9pjZubg3lZfska6eoiARzcI9QBHSHi3xfUlmmHy8Aju8oAAQBbAAAEaAXEACEAfLIcIiMREjkAsABFWLAULxuxFBw+WbAARViwBS8bsQUQPlmyHxQFERI5sB8vsl8fAXKyjx8BcbK/HwFdsgABCitYIdgb9FmwBRCyAwEKK1gh2Bv0WbAH0LAI0LAAELAN0LAfELAP0LAUELAY0LAUELIbAQorWCHYG/RZMDEBFxQHIQchNTM2Njc1JyM1MwM0NjMyFhUjNCYjIgYVEyEVAcEIPgLdAfv4TSgyAgiloAn1yL7ev39vaYIJAT8CbtyaW52dCYNgCN2dAQTH7tSxa3yaff78nQAAAgBp/+UFWwTxABsAKgA/sgIrLBESObACELAn0ACwAEVYsAIvG7ECED5ZsBDQsBAvsAIQsh8BCitYIdgb9FmwEBCyJwEKK1gh2Bv0WTAxJQYjIicHJzcmNTQ3JzcXNjMyFzcXBxYVFAcXBwEUFhYyNjY1NCYmIyIGBgRPn9HPn4aCi2hwk4KTnsPEn5WEl25mj4T8YHPE4sRxccVwccRzcISCiIeNnMrOo5eIlnh5mImao8vEn5CIAnt71Hp703t603l41AAAAQAfAAAErQWwABYAawCwAEVYsBYvG7EWHD5ZsABFWLABLxuxARw+WbAARViwDC8bsQwQPlmyDxMDK7IADBYREjm0DxMfEwJdsBMQsAPQsBMQshICCitYIdgb9FmwBtCwDxCwB9CwDxCyDgIKK1gh2Bv0WbAK0DAxAQEzASEVIRUhFSERIxEhNSE1ITUhATMCZgFs2/5eATj+gAGA/oDB/oYBev6GATn+XtwDDgKi/TB9pXz+vgFCfKV9AtAAAAIAk/7yAU0FsAADAAcAGACwAC+wAEVYsAYvG7EGHD5ZsgUBAyswMRMRMxERIxEzk7q6uv7yAxf86QPIAvYAAgBa/hEEeQXEADQARACAsiNFRhESObAjELA10ACwCC+wAEVYsCMvG7EjHD5ZshYIIxESObAWELI/AQorWCHYG/RZsgIWPxESObAIELAO0LAIELIRAQorWCHYG/RZsjAjCBESObAwELI3AQorWCHYG/RZsh03MBESObAjELAn0LAjELIqAQorWCHYG/RZMDEBFAcWFhUUBCMiJicmNTcUFjMyNjU0JicuAjU0NyYmNTQkMzIEFSM0JiMiBhUUFhYEHgIlJicGBhUUFhYEFzY2NTQmBHm6RUj+/ORwyUaLurSciKaO0bbAXbZCRwEL3ugBBLmoi46hOIcBH6lxOv3hWktQSzaFARwsTlSLAa+9VTGIZKjHODlxzQKCl3VgWWk+MG+bb7pYMYhkpsjizX2bc2JFUEFQSGGBqxgbE2VFRlBCUhEUZUVYbQAAAgBmBPAC7wXFAAgAEQAdALAHL7ICBQorWCHYG/RZsAvQsAcQsBDQsBAvMDETNDYyFhQGIiYlNDYyFhQGIiZmN2w4OGw3Aa43bDg4bDcFWy09PVo8PCstPj5aPDwAAAMAW//rBeYFxAAbACoAOQCVsic6OxESObAnELAD0LAnELA20ACwAEVYsC4vG7EuHD5ZsABFWLA2LxuxNhA+WbIDNi4REjmwAy+0DwMfAwJdsgouNhESObAKL7QAChAKAl2yDgoDERI5shECCitYIdgb9FmwAxCyGAIKK1gh2Bv0WbIbAwoREjmwNhCyIAQKK1gh2Bv0WbAuELInBAorWCHYG/RZMDEBFAYjIiY1NTQ2MzIWFSM0JiMiBhUVFBYzMjY1JRQSBCAkEjU0AiQjIgQCBzQSJCAEEhUUAgQjIiQCBF+tnp29v5ugrJJfW15sbF5cXf0BoAETAUABEqCe/u2hoP7sn3O7AUsBgAFKu7T+tcbF/rW2AlWZodO2brDTpJVjVYp7cXiKVGWErP7bpqYBJayqASKnpf7cqsoBWsfH/qbKxf6o0c8BWAAAAgCTArMDDwXEABsAJQBssg4mJxESObAOELAd0ACwAEVYsBUvG7EVHD5ZsgQmFRESObAEL7AA0LICBBUREjmyCwQVERI5sAsvsBUQsg4DCitYIdgb9FmyEQsVERI5sAQQshwDCitYIdgb9FmwCxCyIAQKK1gh2Bv0WTAxASYnBiMiJjU0NjMzNTQjIgYVJzQ2MzIWFREUFyUyNjc1IwYGFRQCagwGTIB3gqesbHxFT6GsiYWaGv6kK1gccFNZAsEiJlZ8Z294NIc2Mwxngo+G/sRhUXsoG44BPzNe//8AZgCXA2QDswAmAXr6/gAHAXoBRP/+AAEAfwF3A74DIAAFABoAsAQvsAHQsAEvsAQQsgIBCitYIdgb9FkwMQEjESE1IQO+uv17Az8BdwEIoQAEAFr/6wXlBcQADgAeADQAPQCpsjY+PxESObA2ELAL0LA2ELAT0LA2ELAj0ACwAEVYsAMvG7EDHD5ZsABFWLALLxuxCxA+WbITBAorWCHYG/RZsAMQshsECitYIdgb9FmyIAsDERI5sCAvsiIDCxESObAiL7QAIhAiAl2yNSAiERI5sDUvsr81AV20ADUQNQJdsh8CCitYIdgb9FmyKB81ERI5sCAQsC/QsC8vsCIQsj0CCitYIdgb9FkwMRM0EiQgBBIVFAIEIyIkAjcUEgQzMiQSNTQCJCMiBAIFESMRITIWFRQHFhcVFBcVIyY0JyYnJzM2NjU0JiMjWrsBSwGAAUq7tP61xsX+tbZzoAEToKEBFJ2d/uyhoP7snwHAjQEUmamAegERkQ4DEHOwnEhYTmSKAtnKAVrHx/6mysX+qNHPAVjHrP7bpqkBIqyrASGnpf7c9f6uA1GDfXtBMpo9ViYQJLkRYASAAkI2ST0AAAEAeAUhA0IFsAADABEAsAEvsgIDCitYIdgb9FkwMQEhNSEDQv02AsoFIY8AAgCCA8ACfAXEAAsAFgAvALAARViwAy8bsQMcPlmwDNCwDC+yCQIKK1gh2Bv0WbADELISAgorWCHYG/RZMDETNDYzMhYVFAYjIiYXMjY1NCYjIgYUFoKVamiTk2hplv82Sko2N0tLBMBonJtpapaWFkc5OktPbEoAAgBhAAAD9QTzAAsADwBGALAJL7AARViwDS8bsQ0QPlmwCRCwANCwCRCyBgEKK1gh2Bv0WbAD0LANELIOAQorWCHYG/RZsgUOBhESObQLBRsFAl0wMQEhFSERIxEhNSERMwEhNSECiQFs/pSn/n8BgacBQfy9A0MDVpf+YgGelwGd+w2YAAABAEICmwKrBbsAFgBUsggXGBESOQCwAEVYsA4vG7EOHD5ZsABFWLAALxuxABQ+WbIWAgorWCHYG/RZsALQsgMOFhESObAOELIIAgorWCHYG/RZsA4QsAvQshQWDhESOTAxASE1ATY1NCYjIgYVIzQ2IBYVFA8CIQKr/akBLG1APEtHnacBCJprVLABjwKbbAEaZkUxPUw5cpR/bmhrT5EAAQA+Ao8CmgW6ACYAibIgJygREjkAsABFWLAOLxuxDhw+WbAARViwGS8bsRkUPlmyABkOERI5sAAvtm8AfwCPAANdsj8AAXG2DwAfAC8AA12yXwABcrAOELIHAgorWCHYG/RZsgoOGRESObAAELImBAorWCHYG/RZshQmABESObIdGQ4REjmwGRCyIAIKK1gh2Bv0WTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWARlPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAQB7BNgCHAX+AAMAIwCwAi+yDwIBXbAA0LAAL7QPAB8AAl2wAhCwA9AZsAMvGDAxATMBIwE84P70lQX+/toAAAEAmv5gA+4EOgASAFCyDRMUERI5ALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLAQLxuxEBI+WbAARViwDS8bsQ0QPlmyBAEKK1gh2Bv0WbILBw0REjkwMQERFhYzMjcRMxEjJwYjIicRIxEBUwFndMc+uqcJXaqTUbkEOv2Ho5yYAyD7xnOHSf4rBdoAAQBDAAADQAWwAAoAK7ICCwwREjkAsABFWLAILxuxCBw+WbAARViwAC8bsQAQPlmyAQAIERI5MDEhESMiJDU0JDMhEQKGVOb+9wEK5gENAgj+1tX/+lAAAAEAkwJrAXkDSQAJABayAwoLERI5ALACL7EICitY2BvcWTAxEzQ2MhYVFAYiJpM5cjs7cjkC2TBAQDAvPz8AAQB0/k0BqgAAAA4AQbIFDxAREjkAsABFWLAALxuxABA+WbAARViwBi8bsQYSPlm0EwYjBgJdsgEGABESObEHCitY2BvcWbABELAN0DAxIQcWFRQGIycyNjU0Jic3AR0MmaCPB09XQGIgNBuSYXFrNC8sKgmGAAEAegKiAe8FtwAGAECyAQcIERI5ALAARViwBS8bsQUcPlmwAEVYsAAvG7EAFD5ZsgQABRESObAEL7IDAgorWCHYG/RZsgIDBRESOTAxASMRBzUlMwHvndgBYxICogJZOYB1AAACAHoCsgMnBcQADAAaAECyAxscERI5sAMQsBDQALAARViwAy8bsQMcPlmyChsDERI5sAovshADCitYIdgb9FmwAxCyFwMKK1gh2Bv0WTAxEzQ2MzIWFRUUBiAmNRcUFjMyNjU1NCYjIgYHeryam7y7/sy+o2FUU19hU1FgAgRjnsPBpkqfwsKlBmRyc2VOY3JuYQD//wBmAJgDeAO1ACYBew0AAAcBewFqAAD//wBVAAAFkQWtACcB1f/bApgAJwF8ARgACAEHAdgC1gAAABAAsABFWLAFLxuxBRw+WTAx//8AUAAABckFrQAnAXwA7AAIACcB1f/WApgBBwHWAx4AAAAQALAARViwCS8bsQkcPlkwMf//AG8AAAXtBbsAJwF8AZcACAAnAdgDMgAAAQcB1wAxApsAEACwAEVYsCEvG7EhHD5ZMDEAAgBE/n8DeARNABgAIgBXsgkjJBESObAJELAc0ACwEC+wAEVYsCEvG7EhGD5ZsgAQIRESObIDEAAREjmwEBCyCQEKK1gh2Bv0WbAQELAM0LIVABAREjmwIRCyGwUKK1gh2Bv0WTAxAQ4DBwcUFjMyNjUzBgYjIiY1NDc3NjUTFAYiJjU0NjIWAkwBKWC4CwJ0bWR9uQLht8TWoG1CwTdsODhsNwKoan92wWMlbXNxW6HMybOtr3FOkgE9LT4+LSw8PAAC//IAAAdXBbAADwASAHcAsABFWLAGLxuxBhw+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZshEGABESObARL7ICAQorWCHYG/RZsAYQsggBCitYIdgb9FmyCwAGERI5sAsvsgwBCitYIdgb9FmwABCyDgEKK1gh2Bv0WbISBgAREjkwMSEhAyEDIwEhFSETIRUhEyEBIQMHV/yND/3MzeIDcAO3/U0UAk79uBYCwfqvAcgfAWH+nwWwmP4pl/3tAXgC3QABAFkAzgPdBGMACwA4ALADL7IJDAMREjmwCS+yCgkDERI5sgQDCRESObIBCgQREjmwAxCwBdCyBwQKERI5sAkQsAvQMDETAQE3AQEXAQEHAQFZAUr+uHcBSQFJd/64AUp3/rX+tQFJAVABT3v+sQFPe/6x/rB7AVH+rwAAAwB2/6MFHQXsABcAIAApAGayBCorERI5sAQQsB3QsAQQsCbQALAARViwEC8bsRAcPlmwAEVYsAQvG7EEED5ZshoQBBESObIjEAQREjmwIxCwG9CwEBCyHQEKK1gh2Bv0WbAaELAk0LAEELImAQorWCHYG/RZMDEBFAIEIyInByM3JhE1NBIkMzIXNzMHFhMFFBcBJiMiAgcFNCcBFjMyEjcFCZD++LCrg2GOkL6SAQus1pRnjZ+JAvwsYgI0Zqa20QMDFTj921t5uswDAqnW/sGoUpvnwAFoU9IBQqt9pf+7/tpj9I0DiG/+6/YNtoP8j0ABD/0AAgCmAAAEXQWwAA0AFgBXsgkXGBESObAJELAQ0ACwAEVYsAAvG7EAHD5ZsABFWLALLxuxCxA+WbIBAAsREjmwAS+yEAALERI5sBAvsgkBCitYIdgb9FmwARCyDgEKK1gh2Bv0WTAxAREhMhYWFRQEIyERIxETESEyNjU0JicBYAEXk9x3/vjj/u66ugEVjqCgiAWw/ttpwn7C5/7HBbD+Q/3el3h7lwEAAQCL/+wEagYSACoAabIhKywREjkAsABFWLAFLxuxBR4+WbAARViwEy8bsRMQPlmwAEVYsAAvG7EAED5ZsgoTBRESObIOBRMREjmwExCyGgEKK1gh2Bv0WbIgEwUREjmyIwUTERI5sAUQsigBCitYIdgb9FkwMSEjETQ2MzIWFRQGFRQeAhUUBiMiJic3FhYzMjY1NC4CNTQ2NTQmIyIRAUS5z7q0xYBLvFbLtlG1JisxhzVrcUq9V4toWNoEV9Drs599y0UzX5CITJ+yLBybICxeUjRgk4pRWc9UXmv+2wADAE7/7AZ8BE4AKgA1AD0AxrICPj8REjmwAhCwLtCwAhCwOdAAsABFWLAXLxuxFxg+WbAARViwHS8bsR0YPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbICHQAREjmyDAUXERI5sAwvtL8MzwwCXbAXELIQAQorWCHYG/RZshMMFxESObIaHQAREjmyOh0AERI5sDovtL86zzoCXbIhAQorWCHYG/RZsAAQsiUBCitYIdgb9FmyKB0AERI5sCvQsAwQsi8BCitYIdgb9FmwEBCwNtAwMQUgJwYGIyImNTQ2MzM1NCYjIgYVJzQ2MzIWFzY2MzISFRUhFhYzMjc3FwYlMjY3NSMGBhUUFgEiBgchNTQmBO7++4hB4o2nvOPd325oaYy48rtzsDI/rmnS6P0oB66VlHkvQJ78CUieMuR1jGoDUHOVEQIahhS0Vl6tl52uVWt7blETj7VTU09X/v/pc7C/TB+IeZZKNu0CblNNXQM0q4sfhJMAAAIAfv/sBC0GLAAdACsAVLIHLC0REjmwBxCwKNAAsABFWLAZLxuxGR4+WbAARViwBy8bsQcQPlmyDxkHERI5sA8vshEZBxESObIiAQorWCHYG/RZsAcQsigBCitYIdgb9FkwMQESERUUBgYjIiYmNTQ2NjMyFyYnByc3Jic3Fhc3FwMnJiYjIgYVFBYzMjY1AzT5ddiGh9x5cM+Bo3kwjdpJwIS3Oe+vvUloAiGLXJGip4B9mQUV/vj+Z12e/ZCB4IaT6YJyw42UY4NbMZ82i4Fk/PM4PUm/p4zE4rgAAAMARwCsBC0EugADAA0AFwBOsgcYGRESObAHELAA0LAHELAR0ACwAi+yAQEKK1gh2Bv0WbACELEMCitY2BvcWbEGCitY2BvcWbABELEQCitY2BvcWbEWCitY2BvcWTAxASE1IQE0NjIWFRQGIiYRNDYyFhUUBiImBC38GgPm/aA5cjs7cjk5cjs7cjkCWLgBOjBAQDAvPj78/jBAQDAuPz8AAAMAW/96BDQEuAAVAB0AJgBjsgQnKBESObAEELAb0LAEELAj0ACwAEVYsAQvG7EEGD5ZsABFWLAPLxuxDxA+WbIjAQorWCHYG/RZsiEjBBESObAhELAY0LAEELIbAQorWCHYG/RZshkbDxESObAZELAg0DAxEzQ2NjMyFzczBxYRFAYGIyInByM3JhMUFwEmIyIGBTQnARYzMjY1W3vhj25eSXxmw3zgkGhWSnxkzblhAVc+SIqoAmZX/qw3QounAief/YsqlM2a/sCe/okjlcuVATfCbwK2INq1tm/9UBnbuQACAJX+YAQnBgAADwAaAGSyGBscERI5sBgQsAzQALAIL7AARViwDC8bsQwYPlmwAEVYsAYvG7EGEj5ZsABFWLADLxuxAxA+WbIFDAMREjmyCgwDERI5sAwQshMBCitYIdgb9FmwAxCyGAEKK1gh2Bv0WTAxARQCIyInESMRMxE2MzISESc0JiMiBxEWMzI2BCfiwcVxublxwsPjuZyIqFRTq4WdAhH3/tJ9/fcHoP3KhP7a/voEt9SV/fuU0wAAAgAdAAAFiAWwABMAFwBrALAARViwDy8bsQ8cPlmwAEVYsAgvG7EIED5ZshQIDxESObAUL7IQFA8REjmwEC+wANCwEBCyFwEKK1gh2Bv0WbAD0LAIELAF0LAUELIHAQorWCHYG/RZsBcQsArQsBAQsA3QsA8QsBLQMDEBMxUjESMRIREjESM1MxEzESERMwEhNSEFAoaGwf0jwYaGwQLdwfxiAt39IwSOjvwAAqH9XwQAjgEi/t4BIv2OwgABAJsAAAFVBDoAAwAdALAARViwAi8bsQIYPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVW6ugQ6AAABAJoAAAQ/BDoADABoALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbS/Bs8GAl2yLwYBXbL/BgFdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAb9rurpbAY3f/jwB6OkBzf4zBDr+NgHK/fP90wAAAQAiAAAEGwWwAA0AWwCwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbIBDAYREjmwAS+wANCwARCyAgEKK1gh2Bv0WbAD0LAGELIEAQorWCHYG/RZsAMQsAjQsAnQsAAQsAvQsArQMDEBJRUFESEVIREHNTcRMwFpAQf++QKy/I2GhsEDS1R9VP3PnQKRKn0qAqIAAAEAIgAAAgoGAAALAEoAsABFWLAKLxuxCh4+WbAARViwBC8bsQQQPlmyAQQKERI5sAEvsADQsAEQsgIBCitYIdgb9FmwA9CwBtCwB9CwABCwCdCwCNAwMQE3FQcRIxEHNTcRMwFsnp66kJC6A2U9ez39FgKjN3s3AuIAAQCi/ksE8QWwABMAWrIGFBUREjkAsABFWLAALxuxABw+WbAARViwEC8bsRAcPlmwAEVYsAQvG7EEEj5ZsABFWLAOLxuxDhA+WbAEELIJAQorWCHYG/RZsg0OEBESObISDgAREjkwMQERFAYjIic3FjMyNTUBESMRMwERBPGrnD02DiU9iP0zwMACzQWw+f2ouhKaDtBHBGr7lgWw+5gEaAAAAQCR/ksD8AROABoAYbINGxwREjkAsABFWLADLxuxAxg+WbAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAYLxuxGBA+WbIBGAMREjmwChCyDwEKK1gh2Bv0WbADELIVAQorWCHYG/RZMDEBFzYzMhYXERQGIyInNxYzMjURNCYjIgcRIxEBNw10y7O4AqebPTYOI0KJb32vUboEOpqu0Mv89KS4Ep0NwgL3i4CF/NQEOgACAGj/6wcJBcQAFwAjAJGyASQlERI5sAEQsBrQALAARViwDC8bsQwcPlmwAEVYsA4vG7EOHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmwDhCyEAEKK1gh2Bv0WbITAA4REjmwEy+yFAEKK1gh2Bv0WbAAELIWAQorWCHYG/RZsAMQshgBCitYIdgb9FmwDBCyHQEKK1gh2Bv0WTAxISEGIyImAicRNBI2MzIXIRUhESEVIREhBTI3ESYjIgYHERQWBwn8sLJyov6MAYv+onyqA0b9LQJ3/YkC3fuMcWZtbK3CAsMVlgEPqwE1rAERlxSe/iyd/fwbDgSOD+XP/sfT6wAAAwBh/+wHAAROACAALAA0AJayBjU2ERI5sAYQsCbQsAYQsDDQALAARViwBC8bsQQYPlmwAEVYsAovG7EKGD5ZsABFWLAXLxuxFxA+WbAARViwHS8bsR0QPlmyBwoXERI5sjEKFxESObAxL7IOAQorWCHYG/RZsBcQshIBCitYIdgb9FmyFAoXERI5shoKFxESObAk0LAEELIqAQorWCHYG/RZsC3QMDETNDY2MzIWFzY2MzIWFRUhFhYzMjcXBiMiJicGBiMiADUXFBYzMjY1NCYjIgYlIgYHITU0JmF5246JyT1BxHDP6v0yB6SGvHhKifWHzT8+x4bc/vi5oIuJoKGKh6IELWOWFgIOiQInoP6JdWRmc/7rdKrFbH6EcGRjcQEw/gm32NfOttnW1qOKGn2WAAABAKAAAAKCBhUADAAysgMNDhESOQCwAEVYsAQvG7EEHj5ZsABFWLAALxuxABA+WbAEELIJAQorWCHYG/RZMDEzETY2MzIXByYjIhURoAGwojtUFygztwSuqb4Vjgvd+2AAAAIAXf/sBRIFxAAXAB8AW7IAICEREjmwGNAAsABFWLAQLxuxEBw+WbAARViwAC8bsQAQPlmyBRAAERI5sAUvsBAQsgkBCitYIdgb9FmwABCyGAEKK1gh2Bv0WbAFELIbAQorWCHYG/RZMDEFIAARNSE1EAIjIgcHJzc2MyAAERUUAgQnMhI3IRUUFgK5/uP+wQP09N2liz0vFp7oAS4BZJz+6qep3g/8z9MUAVkBRXUHAQIBHDoajw1Y/of+sVTF/r+2ngEF2yLa5AAB/+T+SwK8BhUAHgBxshQfIBESOQCwAEVYsBUvG7EVHj5ZsABFWLAQLxuxEBg+WbAARViwHS8bsR0YPlmwAEVYsAUvG7EFEj5ZsB0QsgABCitYIdgb9FmwBRCyCgEKK1gh2Bv0WbAAELAO0LAP0LAVELIaAQorWCHYG/RZMDEBIxEUBiMiJzcWMzI2NREjNTM1NjYzMhcHJiMiBxUzAmDLqJo9Mg4eQ0FHq6sCr6E7VBYmPKsEywOr+/6ntxKTDWhcBASPeKe8FZMKw3oAAAIAZf/sBZ0GNwAXACUAU7IEJicREjmwBBCwItAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmyDw0EERI5sA8QsBXQsA0QshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyFzY2NTMQBRYXBxACIyICBxUUEjMyEhEE+JD++LCr/vaVAZIBC6zwm2Bdp/75YQG+z7220QPTub/LAqnW/sGoqAE+z2TSAUGsmweDhP6zPaz2BAECARb+6/Zr+/7hARoBAQAAAgBb/+wEugSwABYAIwBTshMkJRESObATELAa0ACwAEVYsAQvG7EEGD5ZsABFWLATLxuxExA+WbIGBBMREjmwBhCwDNCwExCyGgEKK1gh2Bv0WbAEELIhAQorWCHYG/RZMDETNDY2MzIXNjY1MxAHFhUVFAYGIyIANRcUFjMyNjU1NCYjIgZbe+GPz4hHQJbPSXzgkN7+8bmnjYunqYuKqAInn/2LighkgP7dM4qpFp7+iQEz+wm02tu5ELXa2gAAAQCM/+wGHQYCABoATLIMGxwREjkAsABFWLASLxuxEhw+WbAARViwGi8bsRocPlmwAEVYsA0vG7ENED5ZsgENGhESObABELAI0LANELIWAQorWCHYG/RZMDEBFTY2NTMUBgcRBgIHByIAJxEzERQWMzI2NREEqnNhn7HCAfTTSe/+5AK+rqGjrQWw1QuJk9LRDP1+x/78FgQBAuID4Pwmnq+ungPbAAEAiP/sBQ8EkAAZAGCyBxobERI5ALAARViwEy8bsRMYPlmwAEVYsA0vG7ENGD5ZsABFWLAILxuxCBA+WbAARViwBS8bsQUQPlmyFQgTERI5sBUQsAPQsgYIExESObAIELIQAQorWCHYG/RZMDEBFAYHESMnBiMiJicRMxEUMzI3ETMVPgI1BQ+ToLAEbNGttQG5yNRGuUREHQSQtJME/Ltrf8nFAsD9RfaeAxODAiNIbAAB/7T+SwFlBDoADQAoALAARViwAC8bsQAYPlmwAEVYsAQvG7EEEj5ZsgkBCitYIdgb9FkwMQERFAYjIic3FjMyNjURAWWqmDs0Dh5DQUgEOvttqrISkw1oXASTAAIAYv/sA+kETwAUABwAZbIIHR4REjmwCBCwFdAAsABFWLAALxuxABg+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshABCitYIdgb9FmyEgAIERI5sAgQshUBCitYIdgb9FmwDRCyGAEKK1gh2Bv0WTAxATIAFRUUBgYnIiY1NSEmJiMiByc2ATI2NyEVFBYB/9wBDnzYetDpAs0HoYi6e0mMAQ5ilxX984kET/7U+SSV+I0B/ul0qMhsfYb8NaSJGn2WAAEAqQTkAwYGAAAIADQAsAQvsAfQsAcvtA8HHwcCXbIFBAcREjkZsAUvGLAB0BmwAS8YsAQQsALQsgMEBxESOTAxARUjJwcjNRMzAwaZlpWZ9nAE7gqqqgwBEAAAAQCMBOMC9gX/AAgAIACwBC+wAdCwAS+0DwEfAQJdsgAEARESObAI0LAILzAxATczFQMjAzUzAcCWoP5x+50FVaoK/u4BEgr//wB4BSEDQgWwAQYAcAAAAAoAsAEvsQID9DAxAAEAgQTLAtgF1wAMACayCQ0OERI5ALADL7IPAwFdsgkECitYIdgb9FmwBtCwBi+wDNAwMQEUBiAmNTMUFjMyNjUC2KX+9KaXTElGTwXXeZOUeEZPTkcAAQCNBO4BaAXCAAgAGLICCQoREjkAsAcvsgIFCitYIdgb9FkwMRM0NjIWFAYiJo03bDg4bDcFVy0+Plo8PAACAHkEtAInBlAACQAUACqyAxUWERI5sAMQsA3QALADL7AH0LAHL7I/BwFdsAMQsA3QsAcQsBLQMDEBFAYjIiY0NjIWBRQWMzI2NCYjIgYCJ3xbXHt7uHv+tUMxMERDMTJCBYBXdXasenpWL0RCYkVGAAABADL+TwGSADgAEAAusgUREhESOQCwEC+wAEVYsAovG7EKEj5ZsgUDCitYIdgb9Fm2DxAfEC8QA10wMSEHBhUUMzI3FwYjIiY1NDY3AX46cU4wNA1GWllnhnstW1ZIGnksaFZZmjgAAAEAewTZAz4F6AAXAD4AsAMvsAjQsAgvtA8IHwgCXbADELAL0LALL7AIELIPAworWCHYG/RZsAMQshQDCitYIdgb9FmwDxCwF9AwMQEUBiMiLgIjIgYVJzQ2MzIeAjMyNjUDPntcKTxhKxwpOnx5XSM4YDMfKzkF3GyGFD4NPzEHa4wUOhJELQACAF4E0AMsBf8AAwAHADsAsAIvsADQsAAvtA8AHwACXbACELAD0BmwAy8YsAAQsAXQsAUvsAIQsAbQsAYvsAMQsAfQGbAHLxgwMQEzASMDMwMjAl3P/vOpbcXalgX//tEBL/7RAAACAH7+awHV/7UACwAWADQAsAMvQAsAAxADIAMwA0ADBV2wCdCwCS9ACTAJQAlQCWAJBF2yAAkBXbAO0LADELAU0DAxFzQ2MzIWFRQGIyImNxQWMjY1NCYjIgZ+ZEpHYmBJTGJXNEYwMCMlMvJGYWBHRl1eRSMwMCMkMjQAAfynBNj+SAX+AAMAHgCwAS+wANAZsAAvGLABELAC0LACL7QPAh8CAl0wMQEjATP+SJ/+/uAE2AEmAAH9bwTY/xAF/gADAB4AsAIvsAHQsAEvtA8BHwECXbACELAD0BmwAy8YMDEBMwEj/jDg/vSVBf7+2v///IsE2f9OBegABwCk/BAAAAAB/V4E2f6UBnQADgAuALAAL7IPAAFdsAfQsAcvQAkPBx8HLwc/BwRdsAbQsgEABhESObINAAcREjkwMQEnNjY0JiM3MhYVFAYHB/10AUtGW0sHlZpOTQEE2ZkFHk4namdVPVALRwAC/CcE5P8HBe4AAwAHADcAsAEvsADQGbAALxiwARCwBdCwBS+wBtCwBi+2DwYfBi8GA12wA9CwAy+wABCwBNAZsAQvGDAxASMBMwEjAzP+Aqn+zuEB/5b2zgTkAQr+9gEKAAH9OP6i/hP/dgAIABEAsAIvsgcFCitYIdgb9FkwMQU0NjIWFAYiJv04N2w4OGw39S0+Plo8PAAAAQC3BO4BmwY/AAMAHQCwAi+wANCwAC+yDwABXbIDAgAREjkZsAMvGDAxEzMDI+2udHAGP/6vAAADAHEE8AODBogAAwAMABUANwCwCy+wAtCwAi+wAdCwAS+wAhCwA9AZsAMvGLALELIGBQorWCHYG/RZsA/QsAsQsBTQsBQvMDEBMwMjBTQ2MhYUBiImJTQ2MhYUBiImAeG8ZYf+wDdsODhsNwI3N2w4OGw3Boj++CUtPT1aPDwrLT4+Wjw8//8AkwJrAXkDSQEGAHgAAAAGALACLzAxAAEAsQAABDAFsAAFACsAsABFWLAELxuxBBw+WbAARViwAi8bsQIQPlmwBBCyAAEKK1gh2Bv0WTAxASERIxEhBDD9QsEDfwUS+u4FsAACAB8AAAVzBbAAAwAGAC8AsABFWLAALxuxABw+WbAARViwAi8bsQIQPlmyBAEKK1gh2Bv0WbIGAgAREjkwMQEzASElIQEChqoCQ/qsAQYDTP5nBbD6UJ0EKAADAGf/7AT6BcQAAwAVACMAd7IIJCUREjmwCBCwAdCwCBCwINAAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAggRERI5sAIvss8CAV2y/wIBXbIvAgFdtL8CzwICcbIBAQorWCHYG/RZsBEQshkBCitYIdgb9FmwCBCyIAEKK1gh2Bv0WTAxASE1IQUUAgQjIiQCJzU0EiQzMgQSFwcQAiMiAgcVFBIzMhI3A8D9+wIFATqP/vixrP72kwKSAQusrwEIkQK/0Lu20QPRu7rMAwKTmILV/sKqqQE5zmnSAUKrqP7FzwsBAwEV/uv2a/r+4AEP/QABADIAAAUDBbAABgAxALAARViwAy8bsQMcPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbIAAwEREjkwMQEBIwEzASMCmv5mzgISrAITzwSJ+3cFsPpQAAADAHgAAAQhBbAAAwAHAAsATwCwAEVYsAgvG7EIHD5ZsABFWLACLxuxAhA+WbIAAQorWCHYG/RZsAIQsAXQsAUvsi8FAV2yBgEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDE3IRUhEyEVIQMhFSF4A6n8V1cC8v0OUwOU/GydnQM/nQMOngABALIAAAUBBbAABwA4ALAARViwBi8bsQYcPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQUBwf0ywARPBRL67gWwAAEARQAABEQFsAAMADwAsABFWLAILxuxCBw+WbAARViwAy8bsQMQPlmyAQEKK1gh2Bv0WbAF0LAIELIKAQorWCHYG/RZsAfQMDEBASEVITUBATUhFSEBAvL+QwMP/AEB4f4fA879JAG7As79z52PAkoCR5Ce/dQAAAMATQAABXQFsAAUABsAIwBssgokJRESObAKELAV0LAKELAc0ACwAEVYsBMvG7ETHD5ZsABFWLAJLxuxCRA+WbISEwkREjmwEi+wANCyCAkTERI5sAgvsAvQsAgQsh0BCitYIdgb9FmwFdCwEhCyFgEKK1gh2Bv0WbAc0DAxATIEFhUUBgQjFSM1IiQmEDY2MzUzAxEjIgYQFgERMzI2NTQmA0KgAQOPkv8AoMKi/v6Pkf+jwsIFrMPCAXQErMPDBPeM/Jud/Yuvr436ATj9jLn7ngMK0v6Y0AMK/PbRtbPRAAABAFoAAAUhBbAAGABcsgAZGhESOQCwAEVYsAQvG7EEHD5ZsABFWLARLxuxERw+WbAARViwFy8bsRccPlmwAEVYsAsvG7ELED5ZshYECxESObAWL7AA0LAWELINAQorWCHYG/RZsArQMDEBNjY1ETMRFAYGBxEjESYAJxEzERYWFxEzAxacrsF/7Z/B5/7vA8ABpZXBAgsX16oCDf3wn/WTD/6WAWoXASrtAhj976PXGQOkAAABAHEAAATLBcQAJABcshklJhESOQCwAEVYsBkvG7EZHD5ZsABFWLAOLxuxDhA+WbAARViwIy8bsSMQPlmwDhCyEAEKK1gh2Bv0WbAN0LAA0LAZELIGAQorWCHYG/RZsBAQsCHQsCLQMDElNhI3NTQmIAYVFRQSFxUhNTMmAjU1NBI2MzIWEhcVFAIHMxUhAuGKmgPC/q7AnZH+FN1qeI3+oaD9jgN4atz+HKIbARzqhuf2+uVx8P7YHKKdZgEzom+6ASSfnP7ktIKg/s1mnQAAAgBk/+sEdwROABYAIQB8sh8iIxESObAfELAT0ACwAEVYsBMvG7ETGD5ZsABFWLAWLxuxFhg+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsAgQsgMBCitYIdgb9FmyChMIERI5shUTCBESObAMELIaAQorWCHYG/RZsBMQsh8BCitYIdgb9FkwMQERFjMyNxcGIyInBiMiAjU1EBIzMhc3ARQWMzI3ESYjIgYD7gJOEw8XMEqTJmvRwOTixMtrEf3MkoetUlWohpUEOvzjjAWJIqWlARv0DwEIAT2hjf26r8O6Ab684wAAAgCg/oAETQXEABQAKgBpsgArLBESObAY0ACwDy+wAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBA+WbIoAAwREjmwKC+yJQEKK1gh2Bv0WbIGJSgREjmyDgwAERI5sAAQshgBCitYIdgb9FmwDBCyHwEKK1gh2Bv0WTAxATIWFRQGBxYWFRQGIyInESMRNDY2ATQmIyIGBxEWFjMyNjU0JicjNTMyNgJdwetiWHuD+c21eLp6zwFniGtslgEskF6GmoxtllV4fgXE265bmC4tw4LN71/+NQWxbLxr/ntmh45r/MM0P6CBdqUDmHcAAQAu/mAD3wQ6AAgAOLIACQoREjkAsABFWLABLxuxARg+WbAARViwBy8bsQcYPlmwAEVYsAQvG7EEEj5ZsgAHBBESOTAxAQEzAREjEQEzAgoBGL3+hbr+hL0BFAMm+//+JwHgA/oAAgBg/+wEJwYcAB4AKgBeshQrLBESObAUELAi0ACwAEVYsAMvG7EDHj5ZsABFWLAULxuxFBA+WbADELIIAQorWCHYG/RZshsUAxESObAbL7IoCworWCHYG/RZsAzQsBQQsiIBCitYIdgb9FkwMRM0NjMyFwcmIyIGFRQEEhcVFAYGIyIANTU0EjcnJiYTFBYzMjY1NCYnIgbdy6+LhgKXfFZlAbvPBXbbkd7++byQAWNrPqGJiKCpfYikBPWInzegO0g+bJn+88QnmfOFASfyDaUBCCMFJ4z9Y7DLysaI2xnNAAEAY//sA+wETQAlAG+yAyYnERI5ALAARViwFS8bsRUYPlmwAEVYsAovG7EKED5ZsgMBCitYIdgb9FmwChCwBtCwChCwItCwIi+yLyIBXbK/IgFdsiMBCitYIdgb9FmyDyMiERI5shkVIhESObAVELIcAQorWCHYG/RZMDEBFBYzMjY1MxQGIyImNTQ3JiY1NDYzMhYVIzQmIyIGFRQzMxUjBgEek3Zxm7n/xsz4zVhi58q6+bmPa3CH9MTg6gEwTWJuUZu5sZO6QiR6SZSms45GZVtKoJQGAAEAbf6BA8MFsAAfAEuyCCAhERI5ALAPL7AARViwAC8bsQAcPlmyHQEKK1gh2Bv0WbAB0LIVIAAREjmyAhUAERI5sBUQsgcBCitYIdgb9FmyHAAVERI5MDEBFQEGBhUUFhcXFhYVBgYHJzY2NTQkJyYmNTQSNwEhNQPD/qKKZkNS91FHAmxDYi8z/sw2Z1uSfwEd/YMFsHj+VaHlhVphGUgYWE5FrDZUNVUtRE4YLZmBggFAlgFDmAABAJH+YQPwBE4AEgBTsgwTFBESOQCwAEVYsAMvG7EDGD5ZsABFWLAALxuxABg+WbAARViwBy8bsQcSPlmwAEVYsBAvG7EQED5ZsgEQAxESObADELIMAQorWCHYG/RZMDEBFzYzMhYXESMRNCYjIgYHESMRATgLeMi+rgG5bIBcgiK6BDqInMXM+6QEUYh8V0787wQ6AAADAHr/7AQSBcQADQAWAB4AkrIDHyAREjmwAxCwE9CwAxCwG9AAsABFWLAKLxuxChw+WbAARViwAy8bsQMQPlmyDgMKERI5sA4vsl8OAV2y/w4BXbSPDp8OAnG0vw7PDgJxsi8OAXGyzw4BXbIvDgFdtO8O/w4CcbAKELITAQorWCHYG/RZsA4QshgBCitYIdgb9FmwAxCyGwEKK1gh2Bv0WTAxARACIyICAzUQEjMyEhMFITU0JiMiBhUFIRUUFiA2NwQS7N/b7gTs397rBP0hAiWLiIaMAiX925IBBI0CAoD+v/6tAUwBNM0BPQFO/rz+zSw34/Hx488n5frw4wAAAQDD//QCSwQ6AAwAKACwAEVYsAAvG7EAGD5ZsABFWLAJLxuxCRA+WbIEAQorWCHYG/RZMDEBERQWMzI3FwYjIhERAXw3QDAnAUZJ+QQ6/Nc/QAyXEwEmAyAAAQAl/+8EOwXuABoAULIQGxwREjkAsAAvsABFWLALLxuxCxA+WbAARViwES8bsREQPlmwCxCyBwEKK1gh2Bv0WbIQAAsREjmwEBCwE9CwABCyFwEKK1gh2Bv0WTAxATIWFwEWFjM3FwYjIiYmJwMBIwEnJiYjByc2AQVieCEBqxQtIyYGJCpNTj4d5v7izgGKYBc1LS8BKgXuUF/7qzMnA5gMJVZQAlH89QQF6zguAo4MAAEAZf53A6kFxAAtAFayAy4vERI5ALAXL7AARViwKy8bsSscPlmyAgEKK1gh2Bv0WbIILisREjmwCC+yCQEKK1gh2Bv0WbIeLisREjmwHhCyDwEKK1gh2Bv0WbIlCQgREjkwMQEmIyIGFRQhMxUjBgYVFBYEFhcWFRQGByc3NjU0LgQ1NDY3JiY1NCQzMhcDcoRhjaABTYWWtseQAQ98IE9oSGs5MUzmqXdBpJZ2gwEC5JFwBQgkZ1XbmAKco3CdQSUUMWlApz1UQDw+Jy4zQmmZb5HLLiqYYJ+5JwABACn/9ASkBDoAFABcsgsVFhESOQCwAEVYsBMvG7ETGD5ZsABFWLAKLxuxChA+WbAARViwDy8bsQ8QPlmwExCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA3QsA7QsBHQsBLQMDEBIxEUFjMyNxcGIyIRESERIxEjNSEEcZw2QTAnAUZJ+f5vuakESAOh/XJAQQyXEwEmAof8XwOhmQACAJH+YAQfBE4ADwAbAFeyEhwdERI5sBIQsADQALAARViwAC8bsQAYPlmwAEVYsAovG7EKEj5ZsABFWLAHLxuxBxA+WbIJAAcREjmyEgEKK1gh2Bv0WbAAELIYAQorWCHYG/RZMDEBMhIXFxQCIyInESMRNDY2AxYzMjY1NCYjIgYVAlDP9AsB4L/DcrpxzYRTq4eWkYV1kARO/ub+QvD+6Hz9+APknuyA/MiTw8PN4NipAAABAGX+igPhBE4AIgBJsgAjJBESOQCwFC+wAEVYsAAvG7EAGD5ZsABFWLAbLxuxGxA+WbAAELAE0LAAELIHAQorWCHYG/RZsBsQsg0BCitYIdgb9FkwMQEyFhUjNCYjIgYVFRAFFxYWFQYGByc3NjU0JicmAjU1NDY2Aj2956+Gb4SbAUCGYlACY0piLzFGVuz4d9cETtW0boPbsyD+/GMmHWBQP6c+VTY8RisrEzQBAdMqmPuJAAIAYP/sBHsEOgARAB0ATLIIHh8REjmwCBCwFdAAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbAIELIVAQorWCHYG/RZsAAQsBvQMDEBIRYRFRQGBiMiADU1NDY2NyEBFBYzMjY1NCYjIgYEe/7kyHrdjNr+9nbZjAJA/J+gioufoYuJnwOhlP7vEYzriAEv/w2Y8ogB/de319nLrM7MAAEAUf/sA9kEOgAQAEmyChESERI5ALAARViwDy8bsQ8YPlmwAEVYsAkvG7EJED5ZsA8QsgABCitYIdgb9FmwCRCyBAEKK1gh2Bv0WbAAELAN0LAO0DAxASERFDMyNxcGIyImJxEhNSED2f6NaSsxKkxqfXUB/qUDiAOk/WmFGoI0k5ICk5YAAQCP/+wD9gQ6ABIAPLIOExQREjkAsABFWLAALxuxABg+WbAARViwCC8bsQgYPlmwAEVYsA4vG7EOED5ZsgMBCitYIdgb9FkwMQEREDMyNjUmAzMWERAAIyImJxEBScmBqgV2w3H+/9rCyAIEOv15/s/6tucBIfH+6f75/sHg1wKXAAIAV/4iBUwEOgAZACIAXLIPIyQREjmwDxCwGtAAsBgvsABFWLAGLxuxBhg+WbAARViwEC8bsRAYPlmwAEVYsBcvG7EXED5ZsADQsBcQshoBCitYIdgb9FmwDNCwEBCyIAEKK1gh2Bv0WTAxBSQANTQSNxcGBxQWFxE0NjMyFhYVFAAFESMTNjY1JiYjIhUCbP8A/uuBf2WhCrWminGC4YL+3v77ubmqxAWlgkIRFwEz+6gBB1eFjPWt5RoCzGl9jfiV8/7XFf4zAmYW3qSp2FIAAAEAX/4oBUMEOgAZAFiyABobERI5ALANL7AARViwAC8bsQAYPlmwAEVYsAYvG7EGGD5ZsABFWLATLxuxExg+WbAARViwDC8bsQwQPlmyAQEKK1gh2Bv0WbAMELAP0LABELAY0DAxARE2NjUmAzMWERAABREjESYAEREzERYWFxEDHKvDBXrCdv7j/va5//77ugKmogQ6/E4Y5bLoARvs/un+/f7QFf45AckaATYBEwHm/g7C5BkDsQABAHr/7AYZBDoAIwBashskJRESOQCwAEVYsAAvG7EAGD5ZsABFWLATLxuxExg+WbAARViwGS8bsRkQPlmwAEVYsB4vG7EeED5ZsgUBCitYIdgb9FmyCQAeERI5sA7QshsTGRESOTAxAQIHFBYzMjY1ETMRFhYzMjY1JgMzFhEQAiMiJwYGIyICERA3AcSKB3JqbHG7AXFranIHisOHz7zwVSmkd7zPhwQ6/uXvy+OtpgEt/s6kquLM7wEb9P7q/u3+z+51eQExARMBH+sAAAIAef/sBHkFxgAfACgAbrIUKSoREjmwFBCwJtAAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyHRkGERI5sB0vsgIBCitYIdgb9FmyCxkGERI5sAYQsg8BCitYIdgb9FmwAhCwE9CwHRCwI9CwGRCyJgEKK1gh2Bv0WTAxAQYHFQYGIyImNRE3ERQWMzI2NTUmADU0NjMyFhURNjcBFBYXESYjIhUEeTxTAuXIy/e6jHx0gtn+87iWn7I/SP2UoooFk5QCcxcJptPu99cBRwL+sI+bkpimHwEa2aC7xbL+oQUTAVKFvR4BaMbEAAAB/9oAAARuBbwAGgBJsgAbHBESOQCwAEVYsAQvG7EEHD5ZsABFWLAXLxuxFxw+WbAARViwDS8bsQ0QPlmyAAQNERI5sAQQsgkBCitYIdgb9FmwEtAwMQETNjYzMhcHJiMiBwERIxEBJiMiByc2MzIWFwIk4StrV0g0JA0nRiT+17/+2CdDJw0kNEdYayoDBgH7Y1gblwhP/Xf9xgI8AodPCJYcVF0AAgBK/+wGGwQ6ABIAJgBwsggnKBESObAIELAe0ACwAEVYsBEvG7ERGD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwERCyAAEKK1gh2Bv0WbIIEQYREjmwD9CwENCwFdCwFtCwChCyGwEKK1gh2Bv0WbIfChEREjmwJNAwMQEjFhUQAiMiJwYjIgIRNDcjNSEBJichBgcUFjMyNjcRMxEWFjMyNgYbiEC8q/FTU/CqvUB0BdH+/gRK/LtLBGBYaXECuwJxalZgA6Gsxf7v/s3v7wEwARS/spn99qrHyKnL46eiAQf++aKn4gABACr/9QWxBbAAGABhshEZGhESOQCwAEVYsBcvG7EXHD5ZsABFWLAJLxuxCRA+WbAXELIAAQorWCHYG/RZsgQXCRESObAEL7AJELIKAQorWCHYG/RZsAQQshABCitYIdgb9FmwABCwFdCwFtAwMQEhETYzMgQQBCMnMjY1JiYjIgcRIxEhNSEElP32nYT0ARL+/O0Cm5gCo6KWisH+YQRqBRL+OTDx/k7jlpGUjpYu/VoFEp4AAAEAe//sBNwFxAAfAIayAyAhERI5ALAARViwCy8bsQscPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmyFgMLERI5sBYvtL8WzxYCcbLPFgFdsp8WAXGy/xYBXbIvFgFdsl8WAXKyjxYBcrIXAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBCMgABE1NBIkMzIAFyMmJiMiAgchFSEVFBIzMjY3BNwb/uHu/v7+yY8BC7DoARgXwBmnl7nOAgI6/cbGsqCrHAHO5/sBcgE2i8kBNaf+/eWsnv7x6p0C7f7okbQAAgAxAAAIOwWwABgAIQB0sgkiIxESObAJELAZ0ACwAEVYsAAvG7EAHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwEBCyEgEKK1gh2Bv0WbABELIZAQorWCHYG/RZsBIQsBrQsBvQMDEBESEWBBUUBAchESEDAgIGByM1Nz4CNxMBESEyNjU0JicE7gFp3gEG/v7e/dP+ABoPWayQPyhdZDQLHgN3AV+Mop2KBbD9ywPwy8bzBAUS/b/+3v7ciQKdAgdr6vMCwv0t/cCehICcAgACALEAAAhNBbAAEgAbAIKyARwdERI5sAEQsBPQALAARViwEi8bsRIcPlmwAEVYsAIvG7ECHD5ZsABFWLAPLxuxDxA+WbAARViwDC8bsQwQPlmyAAIPERI5sAAvsgQMAhESObAEL7AAELIOAQorWCHYG/RZsAQQshMBCitYIdgb9FmwDBCyFAEKK1gh2Bv0WTAxASERMxEhFgQVFAQHIREhESMRMwERITI2NTQmJwFyAs7AAWriAQH+/9/90/0ywcEDjgFfjqCYigM5Anf9ngPivb/pBAKc/WQFsP0B/fWOenSMAwABAD4AAAXUBbAAFQBdsg4WFxESOQCwAEVYsBQvG7EUHD5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmwFBCyAAEKK1gh2Bv0WbIEFAgREjmwBC+yDQEKK1gh2Bv0WbAAELAS0LAT0DAxASERNjMyFhcRIxEmJiMiBxEjESE1IQSm/fCgr/ryA8EBiaSppsD+aARoBRL+UCja3f4tAc6Yhir9PgUSngABALD+mQT/BbAACwBIALAJL7AARViwAC8bsQAcPlmwAEVYsAQvG7EEHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAD0DAxEzMRIREzESERIxEhsMECzsD+QMH+MgWw+u0FE/pQ/pkBZwACAKIAAASxBbAADAAVAFuyDxYXERI5sA8QsAPQALAARViwCy8bsQscPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAgsJERI5sAIvsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxASERIRYEFRQEByERIQERITI2NTQmJwQh/UIBauQBAP7+3/3SA3/9QgFfj5+ZjQUS/kwD5MTF6gQFsP0Q/d2YgHuOAgACADL+mgXJBbAADgAVAFuyEhYXERI5sBIQsAvQALAEL7AARViwCy8bsQscPlmwAEVYsAIvG7ECED5ZsAQQsAHQsAIQsgYBCitYIdgb9FmwDdCwDtCwD9CwENCwCxCyEQEKK1gh2Bv0WTAxASMRIREjAzM2EjcTIREzISERIQMGAgXHv/vrwAF3Xm8OIANnvvu7Asb+ExUNa/6bAWX+mgIDagFl1QJv+u0Edf5U+/6eAAEAGwAABzUFsAAVAIYAsABFWLAJLxuxCRw+WbAARViwDS8bsQ0cPlmwAEVYsBEvG7ERHD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsi8QAV2yzxABXbIAAQorWCHYG/RZsATQsggQABESObAQELAL0LITABAREjkwMQEjESMRIwEjAQEzATMRMxEzATMBASMEqJzApf5k8AHq/jzjAYOlwJ4Bg+L+PAHq7wKY/WgCmP1oAwACsP2IAnj9iAJ4/VH8/wABAFD/7ARqBcQAKABysgMpKhESOQCwAEVYsAsvG7ELHD5ZsABFWLAWLxuxFhA+WbALELIDAQorWCHYG/RZsAsQsAbQsiUWCxESObAlL7LPJQFdsp8lAXGyJAEKK1gh2Bv0WbIRJCUREjmwFhCwG9CwFhCyHgEKK1gh2Bv0WTAxATQmIyIGFSM0NjYzMgQVFAYHBBUUBCMiJiY1MxQWMzI2NRAlIzUzNjYDlKmZgK3Af+SK9AEOfG8BAf7c9JHthMC2jJ27/sO0s5KWBCl0iY1odLhn28NlpjBW/8TmZ76Dc5mSeAEABZ4DfgABALEAAAT/BbAACQBdALAARViwAC8bsQAcPlmwAEVYsAcvG7EHHD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAACERI5QAmKBJoEqgS6BARdsgkAAhESOUAJhQmVCaUJtQkEXTAxATMRIxEBIxEzEQQ/wMD9M8HBBbD6UARi+54FsPueAAABAC8AAAT2BbAAEQBNsgQSExESOQCwAEVYsAAvG7EAHD5ZsABFWLABLxuxARA+WbAARViwCS8bsQkQPlmwABCyAwEKK1gh2Bv0WbAJELILAQorWCHYG/RZMDEBESMRIQMCAgYHIzU3PgI3EwT2wP32Gg9ZrJA/KF1kNAseBbD6UAUS/b/+3v7ciQKdAgdr6vMCwgAAAQBN/+sEywWwABEASrIEEhMREjkAsABFWLABLxuxARw+WbAARViwEC8bsRAcPlmwAEVYsAcvG7EHED5ZsgABBxESObILAQorWCHYG/RZsg8HEBESOTAxAQEzAQ4CIyInNxcyPwIBMwKdAU/f/f00WnlbTxYGW2kzGSb+ENcCYwNN+0N0YTMJmARlNFkENgAAAwBT/8QF4wXsABgAIQAqAFuyDCssERI5sAwQsCDQsAwQsCLQALALL7AXL7IVFwsREjmwFS+wANCyCQsXERI5sAkvsA3QsBUQshkBCitYIdgb9FmwCRCyJAEKK1gh2Bv0WbAf0LAZELAi0DAxATMWBBIVFAIEByMVIzUjIiQCEBIkMzM1MwMiBhUUFjMzETMRMzI2NTQmIwN4H6UBEJeY/vSkI7ocp/7vl5cBEaccuta829q/Grocv9fXwwUeAZj+9aWm/vKXAsTEmAEMAU4BDJjO/pvnzc7lA2f8mevKyOoAAAEAr/6hBZcFsAALADsAsAkvsABFWLAALxuxABw+WbAARViwBC8bsQQcPlmwAEVYsAovG7EKED5ZsgIBCitYIdgb9FmwBtAwMRMzESERMxEzAyMRIa/BAs7AmRKt+9cFsPrtBRP68f4AAV8AAAEAlgAABMgFsAASAEayBRMUERI5ALAARViwAC8bsQAcPlmwAEVYsAovG7EKHD5ZsABFWLABLxuxARA+WbIPAAEREjmwDy+yBgEKK1gh2Bv0WTAxAREjEQYGIyImJxEzERYWMzI3EQTIwWmsbvnyA8EBiaO+xQWw+lACWx4X2N8B0/4ymIY2ArYAAAEAsAAABtcFsAALAEgAsABFWLAALxuxABw+WbAARViwAy8bsQMcPlmwAEVYsAcvG7EHHD5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZsAXQsAbQMDEBESERMxEhETMRIREBcQH1vwHywPnZBbD67QUT+u0FE/pQBbAAAQCw/qEHagWwAA8AVACwCy+wAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsA0vG7ENED5ZsgEBCitYIdgb9FmwBdCwBtCwCdCwCtCwAtAwMQERIREzESERMxEzAyMRIREBcQH1vwHywJMSpfn9BbD67QUT+u0FE/rn/goBXwWwAAACABAAAAW4BbAADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAcPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERITIEFRQEByERIQERITI2NTQmJxACWwFa7wEE/v7i/db+ZgJbAV+On5mMBbD9ruXGxesDBRj9qP3dmIB7jgIAAAMAsgAABjAFsAAKABMAFwBtshIYGRESObASELAG0LASELAV0ACwAEVYsAkvG7EJHD5ZsABFWLAWLxuxFhw+WbAARViwBy8bsQcQPlmwAEVYsBQvG7EUED5ZsgAJBxESObAAL7ILAQorWCHYG/RZsAcQsgwBCitYIdgb9FkwMQEhFgQVFAQHIREzEREhMjY1NCYnASMRMwFyAWrkAQD+/t/908ABX4+fmY0DV8DAA14D5MTF6gQFsP0Q/d2YgHuOAv1ABbAAAAIAowAABLEFsAAKABMATbINFBUREjmwDRCwAdAAsABFWLAJLxuxCRw+WbAARViwBy8bsQcQPlmyAAkHERI5sAAvsgsBCitYIdgb9FmwBxCyDAEKK1gh2Bv0WTAxASEWBBUUBAchETMRESEyNjU0JicBYwFq5AEA/v7f/dPAAV+Pn5mNA14D5MTF6gQFsP0Q/d2YgHuOAgAAAQCT/+wE9AXEAB8Aj7IMICEREjkAsABFWLATLxuxExw+WbAARViwHC8bsRwQPlmwANCwHBCyAwEKK1gh2Bv0WbIIHBMREjmwCC+07wj/CAJxss8IAV2yLwgBcbS/CM8IAnGynwgBcbL/CAFdsi8IAV2yXwgBcrKPCAFysgYBCitYIdgb9FmwExCyDAEKK1gh2Bv0WbATELAP0DAxARYWMzISNyE1ITQCIyIGByM2ADMyBBIVFRQCBCMiJCcBVByroK3JAv3DAj3PupanGcEXARjosAELj47+/aju/uEbAc60kQEO8J7tARScruUBA6f+y8mRyf7MpfvnAAIAt//sBtoFxAAXACUAobIhJicREjmwIRCwEtAAsABFWLATLxuxExw+WbAARViwDS8bsQ0cPlmwAEVYsAQvG7EEED5ZsABFWLAKLxuxChA+WbIPCg0REjmwDy+yXw8BXbL/DwFdtE8PXw8CcbSPD58PAnGyLw8BcbLPDwFdsi8PAV2yzw8BcbIIAQorWCHYG/RZsBMQshsBCitYIdgb9FmwBBCyIgEKK1gh2Bv0WTAxARQCBCMiJAInIxEjETMRMzYSJDMyBBIVJxACIyICBxUUEjMyEjcG2pD++LCm/vmVCNHAwNADkAEKrK8BC5C/0Lu20QPTubrMAwKp1v7BqKABKsf9gwWw/WTOATerqf6/1QIBAwEV/uv2a/v+4QEP/QAAAgBZAAAEZAWwAAwAFQBhshAWFxESObAQELAK0ACwAEVYsAovG7EKHD5ZsABFWLAALxuxABA+WbAARViwAy8bsQMQPlmyEQoAERI5sBEvsgEBCitYIdgb9FmyBQEKERI5sAoQshIBCitYIdgb9FkwMSERIQEjASQRNCQzIREBFBYXIREhIgYDo/6w/tPNAVL+5gER8wHP/O2lkwEa/u+cpQI3/ckCbG8BHtDn+lAD+YSgAQI+lAACAGH/7AQoBhEAGwAoAGKyHCkqERI5sBwQsAjQALAARViwEi8bsRIePlmwAEVYsAgvG7EIED5ZsgASCBESObAAL7IXABIREjmyDxIXERI5shoACBESObIcAQorWCHYG/RZsAgQsiMBCitYIdgb9FkwMQEyEhUVFAYGIyIANTUQEjc2NjUzFAYHBwYGBzYXIgYVFRQWMzI2NTQmAmfM9XbdkNr+9v33jGKYcXyKpaUZk6+IoKGJiqChA/z+798RmfGFASP1WgFVAZIsGUg/fYwdHye5mqqYt6IQrsvMxJm5AAMAnQAABCkEOgAOABYAHACOshgdHhESObAYELAC0LAYELAW0ACwAEVYsAEvG7EBGD5ZsABFWLAALxuxABA+WbIXAQAREjmwFy+0vxfPFwJdtJ8XrxcCcbL/FwFdsg8XAXG0Lxc/FwJdtG8XfxcCcrIPAQorWCHYG/RZsggPFxESObAAELIQAQorWCHYG/RZsAEQshsBCitYIdgb9FkwMTMRITIWFRQGBxYWFRQGIwERITI2NTQjJTMgECcjnQGm2OdaWGJ328j+0AEydHPu/tXvAQT2/QQ6l5JLeSAXhl2VngHb/rpWTqKUATAFAAABAJoAAANHBDoABQArALAARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQNH/g26Aq0DofxfBDoAAgAu/sIEkwQ6AA4AFABbshIVFhESObASELAE0ACwDC+wAEVYsAQvG7EEGD5ZsABFWLAKLxuxChA+WbIAAQorWCHYG/RZsAbQsAfQsAwQsAnQsAcQsA/QsBDQsAQQshEBCitYIdgb9FkwMTc3NhMTIREzESMRIREjEyEhESEDAoNAbA8RArmLuf0NuQEBLwHx/rMLEZdPjAEYAbD8Xf4rAT7+wgHVAvj+/v69AAEAFQAABgQEOgAVAJAAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsBEvG7ERGD5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmwAEVYsBQvG7EUED5ZsAIQsBDQsBAvsr8QAV2y/xABXbIvEAFdss8QAXGyAAEKK1gh2Bv0WbAE0LIIEAAREjmwEBCwC9CyEwAQERI5MDEBIxEjESMBIwEBMwEzETMRMwEzAQEjA+uCuYL+0eoBg/6i4AEXf7l+ARng/qEBg+oB1v4qAdb+KgIwAgr+QAHA/kABwP31/dEAAQBY/+0DrARNACYAhrIDJygREjkAsABFWLAKLxuxChg+WbAARViwFS8bsRUQPlmwChCyAwEKK1gh2Bv0WbIlChUREjmwJS+0LyU/JQJdtL8lzyUCXbSfJa8lAnG0byV/JQJysgYlChESObIiAQorWCHYG/RZshAiJRESObIZFQoREjmwFRCyHAEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFRQGIyImNTMUFjMyNjU0JiMjNTM2At90ZWKDuOyxvtRYUb3mwLvzuI1paoJtc7nJvQMSTFlmRY20o5dJeiRAvJWut5xPcWJOW0+cBQABAJwAAAQBBDoACQBFALAARViwAC8bsQAYPlmwAEVYsAcvG7EHGD5ZsABFWLACLxuxAhA+WbAARViwBS8bsQUQPlmyBAcCERI5sgkHAhESOTAxATMRIxEBIxEzEQNIubn+Dbm5BDr7xgMV/OsEOvzqAAABAJwAAAQ/BDoADAB3ALAARViwBC8bsQQYPlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmwAhCwBtCwBi+ynwYBXbL/BgFdss8GAXGynwYBcbS/Bs8GAl2yLwYBXbJvBgFysgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAd2Hurp5AWzg/lQB0OsBzf4zBDr+NgHK/fj9zgABACwAAAQDBDoADwBNsgQQERESOQCwAEVYsAAvG7EAGD5ZsABFWLABLxuxARA+WbAARViwCC8bsQgQPlmwABCyAwEKK1gh2Bv0WbAIELIKAQorWCHYG/RZMDEBESMRIQMCBgcjNTc2NjcTBAO6/pAWEpekSjVaTgsUBDr7xgOh/mv+6fAFowQKvP4BzwAAAQCdAAAFUgQ6AAwAWQCwAEVYsAEvG7EBGD5ZsABFWLALLxuxCxg+WbAARViwAy8bsQMQPlmwAEVYsAYvG7EGED5ZsABFWLAJLxuxCRA+WbIACwMREjmyBQsDERI5sggLAxESOTAxJQEzESMRASMBESMRMwL7AXDnuf6igP6bufD1A0X7xgMT/O0DJPzcBDoAAQCcAAAEAAQ6AAsAigCwAEVYsAYvG7EGGD5ZsABFWLAKLxuxChg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAAQsAnQsAkvsm8JAV20vwnPCQJdsj8JAXG0zwnfCQJxsg8JAXK0nwmvCQJxsv8JAV2yDwkBcbKfCQFdsi8JAV20bwl/CQJysgIBCitYIdgb9FkwMSEjESERIxEzESERMwQAuf4PuroB8bkBzv4yBDr+KwHVAAEAnAAABAEEOgAHADgAsABFWLAGLxuxBhg+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsAYQsgIBCitYIdgb9FkwMSEjESERIxEhBAG5/g66A2UDofxfBDoAAQAoAAADsAQ6AAcAMQCwAEVYsAYvG7EGGD5ZsABFWLACLxuxAhA+WbAGELIAAQorWCHYG/RZsATQsAXQMDEBIREjESE1IQOw/pW5/pwDiAOk/FwDpJYAAAMAZP5gBWkGAAAaACUAMAB/sgcxMhESObAHELAg0LAHELAr0ACwBi+wAEVYsAMvG7EDGD5ZsABFWLAKLxuxChg+WbAARViwEy8bsRMSPlmwAEVYsBAvG7EQED5ZsABFWLAXLxuxFxA+WbAKELIeAQorWCHYG/RZsBAQsiMBCitYIdgb9FmwKdCwHhCwLtAwMRMQEjMyFxEzETYzMhIRFAIjIicRIxEGIyICNSU0JiMiBxEWMzI2JRQWMzI3ESYjIgZk0rdVQLlGXrjS0bdhRblCVbbRBEyMez8vLUN8ifxtgno6Lyo9eoQCCQEPATYdAc/+KyP+yv7c7/7mIP5VAagdARr1D8zhFPzxEcCytrwSAxER2gAAAQCc/r8EggQ6AAsAOwCwCC+wAEVYsAAvG7EAGD5ZsABFWLAELxuxBBg+WbAARViwCi8bsQoQPlmyAgEKK1gh2Bv0WbAG0DAxEzMRIREzETMDIxEhnLoB8rmBEqb80gQ6/F0Do/xd/igBQQAAAQBnAAADvQQ7ABAARrIEERIREjkAsABFWLAILxuxCBg+WbAARViwDy8bsQ8YPlmwAEVYsAAvG7EAED5ZsgwPABESObAML7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERYzMjcRMwO9unqAy9UCuQXkgHq6AYgg0MABQ/638iACGgABAJwAAAXgBDoACwBIALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAHLxuxBxg+WbAARViwCS8bsQkQPlmyAQEKK1gh2Bv0WbAF0LAG0DAxAREhETMRIREzESERAVYBjLkBi7r6vAQ6/F0Do/xdA6P7xgQ6AAEAkf6/Bm0EOgAPAEsAsAwvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAcvG7EHGD5ZsABFWLANLxuxDRA+WbIBAQorWCHYG/RZsAXQsAnQMDEBESERMxEhETMRMwMjESERAUsBjLkBi7qYEqb63AQ6/F0Do/xdA6P8Xf4oAUEEOgACAB4AAAS/BDoADAAVAF6yARYXERI5sAEQsA3QALAARViwAC8bsQAYPlmwAEVYsAkvG7EJED5ZsgIACRESObACL7AAELILAQorWCHYG/RZsAIQsg0BCitYIdgb9FmwCRCyDgEKK1gh2Bv0WTAxEyERIRYWFRQGIyERIQERITI2NTQmJx4B+gEZuNbcuv42/r8B+gETaHJvZAQ6/osCvKGixAOi/oz+aWtdWnMCAAADAJ0AAAV/BDoACgAOABcAbbIGGBkREjmwBhCwDNCwBhCwE9AAsABFWLAJLxuxCRg+WbAARViwDS8bsQ0YPlmwAEVYsAcvG7EHED5ZsABFWLALLxuxCxA+WbIADQcREjmwAC+yDwEKK1gh2Bv0WbAHELIQAQorWCHYG/RZMDEBIRYWFRQGIyERMwEjETMBESEyNjU0JicBVgEZuNbcuv42uQQpurr71wETaHJvZALFAryhosQEOvvGBDr99P5pa11acwIAAgCdAAAD/QQ6AAoAEwBNsgcUFRESObAHELAN0ACwAEVYsAkvG7EJGD5ZsABFWLAHLxuxBxA+WbIACQcREjmwAC+yCwEKK1gh2Bv0WbAHELIMAQorWCHYG/RZMDEBIRYWFRQGIyERMxERITI2NTQmJwFWARm41ty6/ja5ARNocm9kAsUCvKGixAQ6/fT+aWtdWnMCAAEAZP/sA+AETgAfAIKyACAhERI5ALAARViwCC8bsQgYPlmwAEVYsBAvG7EQED5ZsAgQsgABCitYIdgb9FmyHQgQERI5sB0vtC8dPx0CXbS/Hc8dAl20nx2vHQJxtG8dfx0CcrIDCB0REjmyFBAIERI5sBAQshcBCitYIdgb9FmwHRCyGgEKK1gh2Bv0WTAxASIGFSM0NjYzMgAVFRQGBiMiJjUzFBYzMjY3ITUhJiYCCGORsHbEatMBBXfXirTwsI5md5oM/moBlA6WA7Z+Vl2qZf7P9h+Y+4ngp2aLuKGYkrEAAAIAnf/sBjAETgAUAB8AnbINICEREjmwDRCwFdAAsABFWLAULxuxFBg+WbAARViwBC8bsQQYPlmwAEVYsBEvG7ERED5ZsABFWLAMLxuxDBA+WbIAERQREjmwAC+0vwDPAAJdtJ8ArwACcbL/AAFdsg8AAXG0LwA/AAJdtl8AbwB/AANyshABCitYIdgb9FmwDBCyGAEKK1gh2Bv0WbAEELIdAQorWCHYG/RZMDEBITYAMzIAFxcUBgYjIgAnIREjETMBFBYgNjU0JiMiBgFWAQQVAQnK1AEOCwF84JDR/vYQ/v25uQG6pwEapaiMiqgCb9gBB/7i5Tqe/okBEdr+KQQ6/de02t7Gsd7aAAACAC8AAAPHBDoADQAWAGGyFBcYERI5sBQQsA3QALAARViwAC8bsQAYPlmwAEVYsAEvG7EBED5ZsABFWLAFLxuxBRA+WbISAAEREjmwEi+yAwEKK1gh2Bv0WbIHAwAREjmwABCyEwEKK1gh2Bv0WTAxAREjESEDIwEmJjU0NjcDFBYXIREhIgYDx7r+6f/IARBob9663mxZASb+9md6BDr7xgGl/lsBwSafapS1Af60T2EBAWdlAAH/6P5LA98GAAAiAISyDSMkERI5ALAfL7AARViwBC8bsQQYPlmwAEVYsBkvG7EZED5ZsABFWLAKLxuxChI+WbK/HwFdsi8fAV2yDx8BXbIeGR8REjmwHi+wIdCyAQEKK1gh2Bv0WbICGQQREjmwChCyDwEKK1gh2Bv0WbAEELIVAQorWCHYG/RZsAEQsBvQMDEBIRE2MyATERQGIyInNxYyNjURNCYjIgYHESMRIzUzNTMVIQJj/uJ7xQFXA6qYPTYPI4JIaXBaiCa5pKS5AR4Euf7+l/59/NyqshKTDWhcAyB4cmBO/P0EuZivrwABAGf/7AP3BE4AHwCcsgAgIRESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsgMIEBESObIbEAgREjmwGy+0DxsfGwJytL8bzxsCXbSfG68bAnG0zxvfGwJxsv8bAV2yDxsBcbQvGz8bAl20bxt/GwJysr8bAXKyFBAbERI5sBAQshcBCitYIdgb9FmwGxCyHAEKK1gh2Bv0WTAxJTI2NzMOAiMiABE1NDY2MzIWFyMmJiMiBgchFSEWFgJIY5QIsAV4xG7e/v112JS28QiwCI9ogpoKAZT+bAqZg3haXqhjASgBAB6f94barmmHsZ2YoK0AAgAnAAAGhgQ6ABYAHwB5sgkgIRESObAJELAX0ACwAEVYsAAvG7EAGD5ZsABFWLAILxuxCBA+WbAARViwDy8bsQ8QPlmyAQAIERI5sAEvsAAQsgoBCitYIdgb9FmwDxCyEQEKK1gh2Bv0WbABELIXAQorWCHYG/RZsAgQshgBCitYIdgb9FkwMQERIRYWFRQGByERIQMCBgcjNTc2NjcTAREhMjY1NCYnA98BHrbT07f+Kf6vFxScpUE2VU0NFwK8ARNldXJjBDr+ZAO1lJO8AwOh/lr+6+QCowQKp9MCD/3M/o9pVlFgAQAAAgCcAAAGpwQ6ABIAGwB7sgEcHRESObABELAT0ACwAEVYsAIvG7ECGD5ZsABFWLARLxuxERg+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgERCxESObABL7AE0LABELINAQorWCHYG/RZsAQQshMBCitYIdgb9FmwCxCyFAEKK1gh2Bv0WTAxASERMxEhFhYVFAYjIREhESMRMwERITI2NTQmJwFWAfG5ASK00dm9/jb+D7q6AqoBE2V1cmMCoQGZ/mMEsZaXuwIK/fYEOv3M/o9pVlFgAQAB//0AAAPfBgAAGQB5sgwaGxESOQCwFi+wAEVYsAQvG7EEGD5ZsABFWLAHLxuxBxA+WbAARViwEC8bsRAQPlmyvxYBXbIvFgFdsg8WAV2yGRAWERI5sBkvsgABCitYIdgb9FmyAgQHERI5sAQQsgwBCitYIdgb9FmwABCwEtCwGRCwFNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnn+zHvFAVcDuQFpb1qIJrmPj7kBNAS+/vmX/n39NQLMdXBgTvz9BL6Xq6sAAAEAnP6cBAEEOgALAEUAsAgvsABFWLAALxuxABg+WbAARViwAy8bsQMYPlmwAEVYsAUvG7EFED5ZsABFWLAJLxuxCRA+WbIBAQorWCHYG/RZMDEBESERMxEhESMRIREBVgHyuf6tuf6nBDr8XQOj+8b+nAFkBDoAAAEAnP/sBnUFsAAgAGCyByEiERI5ALAARViwAC8bsQAcPlmwAEVYsA4vG7EOHD5ZsABFWLAXLxuxFxw+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsgcABBESObITAQorWCHYG/RZsBzQMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NREGdeHDbasxNLJxvdcBwXJicoLHfGlqegWw+97G3FdZWVfbwwQm+917iol8BCP73X2IiX0EIgABAIH/6wWtBDoAHgBgsgYfIBESOQCwAEVYsAAvG7EAGD5ZsABFWLAMLxuxDBg+WbAARViwFS8bsRUYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbIGFQQREjmyEQEKK1gh2Bv0WbAa0DAxAREUBiMiJwYjIiYnETMRFhYzMjY1ETMRFBYzMjY3EQWtyq7GWV/Op8ABuQFbU2JvumVcWWUBBDr9J7DGlJTDsALc/SNmdXhnAtn9J2d4dWYC3QAC/9wAAAP8BhYAEQAaAHGyFBscERI5sBQQsAPQALAARViwDi8bsQ4ePlmwAEVYsAgvG7EIED5ZshEOCBESObARL7IAAQorWCHYG/RZsgIOCBESObACL7AAELAK0LARELAM0LACELISAQorWCHYG/RZsAgQshMBCitYIdgb9FkwMQEhESEWFhAGByERIzUzETMRIQERITI2NTQmJwKW/r8BGLvU1Lf+Kr+/ugFB/r8BEmlxb2QEOv6wAsr+ttEDBDqXAUX+u/2B/kV3ZGF9AgAAAQC3/+0GoAXFACYAh7IeJygREjkAsABFWLAFLxuxBRw+WbAARViwJi8bsSYcPlmwAEVYsB0vG7EdED5ZsABFWLAjLxuxIxA+WbIQBR0REjmwEC+wANCwBRCwCdCwBRCyDAEKK1gh2Bv0WbAQELIRAQorWCHYG/RZsB0QshYBCitYIdgb9FmwHRCwGdCwERCwIdAwMQEzNhIkMzIAFyMmJiMiAgchFSEVFBIzMjY3MwYEIyAAETUjESMRMwF4xwWTAQas5gEZGMAZp5e0zwYCHv3ixrKjqRzAG/7h7v7+/snHwcEDQMEBJp7/AOisnv774pca7f7ok7Ln+wFyATYU/VcFsAABAJn/7AWhBE4AJADEsgMlJhESOQCwAEVYsAQvG7EEGD5ZsABFWLAkLxuxJBg+WbAARViwIS8bsSEQPlmwAEVYsBwvG7EcED5Zsg8cBBESObAPL7S/D88PAl20Pw9PDwJxtM8P3w8CcbQPDx8PAnK0nw+vDwJxsv8PAV2yDw8BcbQvDz8PAl20bw9/DwJysADQsggPBBESObAEELILAQorWCHYG/RZsA8QshABCitYIdgb9FmwHBCyFAEKK1gh2Bv0WbIXHAQREjmwEBCwH9AwMQEzNhIzMhYXIyYmIyIGByEVIRYWMzI2NzMOAiMiAicjESMRMwFTvxD/0bbxCLAIj2iEmAoBtf5LCpmDY5QIsAV4xG7R/hDAuroCZ98BCNquaYexnpegrXhaXqhjAQbe/jAEOgAAAgAoAAAE5AWwAAsADgBWALAARViwCC8bsQgcPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCyDggCERI5MDEBIxEjESMDIwEzASMBIQMDiaq8npjFAg2rAgTF/Z8Bk8cBtv5KAbb+SgWw+lACWgJJAAACAA8AAAQlBDoACwAQAFYAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsABFWLAKLxuxChA+WbINAggREjmwDS+yAQEKK1gh2Bv0WbAE0LIPCAIREjkwMQEjESMRIwMjATMBIwEhAycHAu11uXx3vQG6nwG9vv4ZAS+AGBgBKf7XASn+1wQ6+8YBwQE7WVkAAAIAyQAABvUFsAATABYAfACwAEVYsAIvG7ECHD5ZsABFWLASLxuxEhw+WbAARViwBC8bsQQQPlmwAEVYsAgvG7EIED5ZsABFWLAMLxuxDBA+WbAARViwEC8bsRAQPlmyFQIEERI5sBUvsADQsBUQsgYBCitYIdgb9FmwCtCwBhCwDtCyFgIEERI5MDEBIQEzASMDIxEjESMDIxMhESMRMwEhAwGKAYcBNasCBMWWqryemMWe/rPBwQJFAZPHAlkDV/pQAbb+SgG2/koBuP5IBbD8qgJJAAACALwAAAXkBDoAEwAYAH8AsABFWLACLxuxAhg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEED5ZsABFWLAILxuxCBA+WbAARViwDC8bsQwQPlmwAEVYsBAvG7EQED5ZsgAQEhESObAAL7AB0LIOAQorWCHYG/RZsAvQsAfQsAEQsBTQsBXQshcSBBESOTAxASEBMwEjAyMRIxEjAyMTIxEjETMBIQMnBwF2AQ8BA58Bvb56dbl8d7150bq6AckBL4AYGAHBAnn7xgEp/tcBKf7XASj+2AQ6/YcBO1lZAAACAJMAAAY/BbAAHQAhAHayHiIjERI5sB4QsA7QALAARViwHC8bsRwcPlmwAEVYsAUvG7EFED5ZsABFWLANLxuxDRA+WbAARViwFS8bsRUQPlmyAQ0cERI5sAEvsgoBCitYIdgb9FmwENCwARCwGtCwARCwHtCwHBCyIAEKK1gh2Bv0WTAxATMyFhcRIxEmJicjBxEjEScjIgYHESMRNjYzMwEhATMBIQRBG/TsA8EBfJqFFcENiJ6CBMAD7PMq/ngEsv2fEAEa/bsDKtTY/oIBeJCCAiP9lwJ2FnuN/nwBftjUAob9egHoAAACAJYAAAVLBDoAGwAfAHOyHCAhERI5sBwQsBTQALAARViwBi8bsQYYPlmwAEVYsBsvG7EbED5ZsABFWLAULxuxFBA+WbAARViwDC8bsQwQPlmyHBQGERI5sBwvsATQsBwQsAfQshABCitYIdgb9FmwF9CwBhCyHgEKK1gh2Bv0WTAxMzU2NjcBIQEWFhcVIzUmJiMjBxEjEScjIgYHFQEzEyGWBMrS/uEDv/7gzsUCugJzjDULuQY+jHUCAaIIt/6Lts3SBgHf/iEL09CtsZKBE/5PAbsJfpWxAlwBRgACALYAAAhyBbAAIgAmAJOyJicoERI5sCYQsB7QALAARViwCC8bsQgcPlmwAEVYsAsvG7ELHD5ZsABFWLAFLxuxBRA+WbAARViwIi8bsSIQPlmwAEVYsBsvG7EbED5ZsABFWLATLxuxExA+WbIJBQgREjmwCS+yBAEKK1gh2Bv0WbAJELAj0LAN0LAEELAe0LAY0LALELImAQorWCHYG/RZMDEhETY3IREjETMRIQEhATMyFhcRIxEmJicjBxEjEScjIgYHEQEzASECxQFP/mLBwQNZ/nkEs/54G/TsA8EBfJqFFsAOh56CBAIVEAEa/bsBeLNp/WwFsP18AoT9etTY/oIBeJCCAiX9mQJ1F3uN/nwDKgHoAAIAmwAABzsEOgAhACUAlrIeJicREjmwHhCwJdAAsABFWLAHLxuxBxg+WbAARViwCy8bsQsYPlmwAEVYsAAvG7EAED5ZsABFWLAFLxuxBRA+WbAARViwES8bsREQPlmwAEVYsBkvG7EZED5ZsgoLABESObAKL7IdAQorWCHYG/RZsAPQsAoQsA3QsB0QsBbQsAoQsCLQsAsQsiQBCitYIdgb9FkwMSE1NjchESMRMxEhASEBFhYXFSM1JiYjIwcRIxEnIwYGBxUBMxMhAoYCRv6HuroC0f7hA7/+4M7FAroCc4w1C7kGS4VvAgGiCLf+i6+taP48BDr+IgHe/iEL09CtsZKBE/5PAbsJAoCTrwJcAUYAAAIAUP5GA6oHhgApADIAh7IqMzQREjmwKhCwAtAAsBkvsC4vsABFWLAFLxuxBRw+WbAARViwEi8bsRIQPlmwBRCyAwEKK1gh2Bv0WbIoBRIREjmwKC+yJQEKK1gh2Bv0WbIMJSgREjmwEhCyHwEKK1gh2Bv0WbIPLgFdsC4QsCvQsCsvtA8rHysCXbIqLisREjmwMtAwMQE0JiMhNSEyBBUUBgcWFhUUBCMjBhUUFxcHJiY1NDY3MzY2NRAlIzUzIAM3MxUDIwM1MwLanYf+zgEr3gEGgXOCif734DSNgh9Keo2lojSGn/6+mYYBP7yXoP5y+p0EKm6AmNiyZ6QtKa2CxOUDbWlCD301qGN6gwEBlHkBCAWYA6WqCv7uARIKAAIATP5GA3YGMAApADIAnrIuMzQREjmwLhCwH9AAsBgvsC4vsABFWLAFLxuxBRg+WbAARViwES8bsREQPlmwBRCyAwEKK1gh2Bv0WbIoBREREjmwKC+0Lyg/KAJdtL8ozygCXbSfKK8oAnG0byh/KAJysiUBCitYIdgb9FmyDCUoERI5sBEQsh4BCitYIdgb9FmwLhCwK9CwKy+0DysfKwJdsiouKxESObAy0DAxATQmJyE1ITIWFRQGBxYVFAYjIwYVFBcXByYmNTQ2NzM2NzY1NCUjNTMgAzczFQMjAzUzAqd/cP7JASfK7mZb1/PIMo2CH0t8iqWiNnJDP/7omYgBE9qXoP5y+p0DCUNTApmqi0l3JEKvlK8DbWlCD303qGF6gwECMC5IogOYAx2qCv7uARIKAAADAGf/7AT6BcQAEQAYAB8AibIEICEREjmwBBCwEtCwBBCwGdAAsABFWLANLxuxDRw+WbAARViwBC8bsQQQPlmwDRCyEgEKK1gh2Bv0WbIWDQQREjmwFi+yLxYBXbLPFgFdsi8WAXGy/xYBXbJfFgFdtE8WXxYCcbKfFgFxsAQQshkBCitYIdgb9FmwFhCyHAEKK1gh2Bv0WTAxARQCBCMiJAInNTQSJDMyBBIXASICByEmAgMyEjchFhIE+o/++LGs/vaTApIBC6yvAQiRAv22ttAEAxQEzra2ygj87AjTAqnV/sKqqQE5zmnSAUKrqP7FzwIN/u3y+AEN+3ABAPTs/vgAAAMAW//sBDQETgAPABUAHACHsgQdHhESObAEELAT0LAEELAW0ACwAEVYsAQvG7EEGD5ZsABFWLAMLxuxDBA+WbIaDAQREjmwGi+0vxrPGgJdtJ8arxoCcbL/GgFdsg8aAXG0Lxo/GgJdtM8a3xoCcbIQAQorWCHYG/RZsAwQshQBCitYIdgb9FmwBBCyFgEKK1gh2Bv0WTAxEzQ2NjMyABcXFAYGIyIANQUhFhYgNgEiBgchJiZbe+GP1AEOCwF84JDe/vEDHP2fDaQBAqH+3H2iDwJeEqMCJ5/9i/7i5Tqe/okBM/tEm7i6Anm1k5exAAEAFgAABN0FwwAPAEayAhARERI5ALAARViwBi8bsQYcPlmwAEVYsA8vG7EPHD5ZsABFWLAMLxuxDBA+WbIBBgwREjmwBhCyCAEKK1gh2Bv0WTAxARc3ATY2MxcHIgYHASMBMwJDISMBCDOGZy4BQEAf/nyq/gfQAXaCgQM/l3gBqzxU+3kFsAABAC4AAAQLBE0AEQBGsgISExESOQCwAEVYsAUvG7EFGD5ZsABFWLARLxuxERg+WbAARViwDi8bsQ4QPlmyAQUOERI5sAUQsgoBCitYIdgb9FkwMQEXNxM2MzIXByYjIgYHASMBMwHbFxmdTaxHIxUNHR88EP7Xjf6DvQE8ZGQCH/IYlAgwLfy0BDoAAAIAZ/9zBPoGNAATACcAUrIFKCkREjmwBRCwGdAAsABFWLANLxuxDRw+WbAARViwAy8bsQMQPlmwBtCwDRCwENCyFwEKK1gh2Bv0WbAa0LADELIkAQorWCHYG/RZsCHQMDEBEAAHFSM1JgADNRAANzUzFRYAESc0AicVIzUGAhUVFBIXNTMVNhI1BPr+/uO55f7xAQEO57niAQO/mY25k6OkkrmPlwKp/t3+kSOBfx8BcQEjYAEkAXYfdngl/pD+2QfgAQkjYWQf/u7fXd7+7B9mZCIBC+IAAAIAW/+JBDQEtQATACUAWLIDJicREjmwAxCwHNAAsABFWLADLxuxAxg+WbAARViwEC8bsRAQPlmwAxCwBtCwEBCwDdCwEBCyIwEKK1gh2Bv0WbAU0LADELIdAQorWCHYG/RZsBrQMDETNBI3NTMVFhIVFRQCBxUjNSYCNQE2NjU0JicVIzUGBhUUFhc1M1vUubm62d22ubTZAkZjdnRluWJycWO5AifSASoicG8g/tjdENj+2B1rbB8BJ9z+eR/Nq5HQIGJhIdClkssiZgAAAwCc/+sGbwdRACwAQABJAKayCkpLERI5sAoQsDLQsAoQsEnQALAARViwFC8bsRQcPlmwAEVYsA0vG7ENED5ZsBQQsADQsA0QsAfQsgoNFBESObAUELIVAQorWCHYG/RZsA0QshwBCitYIdgb9FmyIBQNERI5sCXQsBUQsCzQsBQQsDjQsDgvsC/Qsi0CCitYIdgb9FmwLxCwNNCwNC+yPAIKK1gh2Bv0WbA4ELBE0LBJ0LBJLzAxATIWFREUBiMiJicGBiMiJicRNDYzFSIGFREUFjMyNjURMxEUFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBNu72dm7cLI0NLBwudgE2L1jcXJicoLBgnNjcG9kaCtQgrg0GHGAf24oSL9q/kBCA51bOwWv8Nb9xtTwVVhYVejNAkrU8Z6dif3EjJuJfAGs/lR6i5yMAjqInwHCfyJQDHAPJG5sEVIb/pBQPGlmMnUgAAMAfv/rBaoF8QArAD8ASACssglJShESObAJELA80LAJELBI0ACwAEVYsBMvG7ETGD5ZsABFWLAMLxuxDBA+WbATELAA0LAMELAH0LIJDBMREjmwExCyFAEKK1gh2Bv0WbAMELIbAQorWCHYG/RZsh8TDBESObAk0LAUELAr0LATELA30LA3L7At0LAtL7IsAgorWCHYG/RZsC0QsDPQsDMvsjsCCitYIdgb9FmwNxCwQ9CwQy+wSNCwSC8wMQEyFhURFAYjIicGBiMiJicRNDYzFSIGFREUFjMyNjU1MxUWFjMyNjURNCYjExUjIi4CIyIVFSM1NDYzMh4CATY3NTMVFAYHBEKowMCo0F8vnGKjwQTAqFJdXFNib7kBcGFRXV1RqixPfsAwGHKAf28pSrdt/kFBA55bOwRE28L+38HalUtK0LsBMsHbmIh8/t57iXhn6+5ndYh9ASF8iAHHfyBSC28PJG5sElAc/oZOP2hmMnUgAAIAnP/sBnUHAwAgACgAgrIHKSoREjmwBxCwJ9AAsABFWLAPLxuxDxw+WbAARViwFy8bsRccPlmwAEVYsCAvG7EgHD5ZsABFWLAKLxuxChA+WbAE0LIHCg8REjmwChCyEwEKK1gh2Bv0WbAc0LAPELAn0LAnL7Ao0LAoL7IiBgorWCHYG/RZsCgQsCXQsCUvMDEBERQGIyImJwYGIyImJxEzERQWMzI2NREzERQWMzI2NRElNSEXIRUjNQZ14cNtqzE0snG91wHBcmJygsd8aWp6/EIDLAH+tagFsPvextxXWVlX28MEJvvde4qJfAQj+919iIl9BCLoa2t9fQAAAgCB/+sFrQWwAB4AJgCFsgYnKBESObAGELAj0ACwAEVYsA0vG7ENGD5ZsABFWLAVLxuxFRg+WbAARViwHi8bsR4YPlmwAEVYsAgvG7EIED5ZsATQsAQvsgYIDRESObAIELIRAQorWCHYG/RZsBrQsA0QsCXQsCUvsCbQsCYvsiAGCitYIdgb9FmwJhCwI9CwIy8wMQERFAYjIicGIyImJxEzERYWMzI2NREzERQWMzI2NxEBNSEXIRUjNQWtyq7GWV/Op8ABuQFbU2JvumVcWWUB/JMDLAP+s6kEOv0nsMaUlMOwAtz9I2Z1eGcC2f0nZ3h1ZgLdAQtra4CAAAABAHX+hAS8BcUAGQBJshgaGxESOQCwAC+wAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshkBCitYIdgb9FkwMQEjESYANTU0EiQzMgAXIyYmIyICFRUUEhczAxS/2P74jgEAoPcBIALBArWhoM3FnXz+hAFsHAFW//SxASCf/vjgnqz+/NT0yv77BAABAGT+ggPgBE4AGQBJshgaGxESOQCwAC+wAEVYsAovG7EKGD5ZsABFWLACLxuxAhA+WbAKELAO0LAKELIRAQorWCHYG/RZsAIQshgBCitYIdgb9FkwMQEjESYCNTU0NjYzMhYVIzQmIyIGFRUUFhczAqK5sdR314uz8K+PZYScloJt/oIBcB4BJtkjmfmK4ahljNq1H6jbAwAAAQB0AAAEkAU+ABMAEwCwDi+wAEVYsAQvG7EEED5ZMDEBBQclAyMTJTcFEyU3BRMzAwUHJQJYASFE/t22qOH+30QBJc3+3kYBI7yl5wElSP7gAb6se6r+vwGOq3urAW2rfasBS/5oq3qqAAH8ZwSm/ycF/AAHABEAsAAvsgMGCitYIdgb9FkwMQEVJzchJxcV/Q2mAQIbAaUFI30B6WwB2AAAAfxxBRf/ZAYVABMALgCwDi+wCNCwCC+yAAIKK1gh2Bv0WbAOELAF0LAFL7AOELIPAgorWCHYG/RZMDEBMhYVFSM1NCMiBwcGByM1Mj4C/nZvf4ByKi1viXY8bGrBRwYVbG4kDnASLzoCfhtTEQAB/WYFFv5UBlcABQAMALABL7AF0LAFLzAxATUzFRcH/WazO00F3HuMdEEAAAH9pAUW/pMGVwAFAAwAsAMvsADQsAAvMDEBJzcnMxX98U07AbUFFkF0jHsACPob/sQBtgWvAAwAGgAnADUAQgBPAFwAagB6ALBFL7BTL7BgL7A4L7AARViwAi8bsQIcPlmyCQsKK1gh2Bv0WbBFELAQ0LBFELJMCworWCHYG/RZsBfQsFMQsB7QsFMQsloLCitYIdgb9FmwJdCwYBCwK9CwYBCyZwsKK1gh2Bv0WbAy0LA4ELI/CworWCHYG/RZMDEBNDYyFhUjNCYjIgYVATQ2MzIWFSM0JiMiBhUTNDYzMhYVIzQmIgYVATQ2MzIWFSM0JiMiBhUBNDYyFhUjNCYjIgYVATQ2MhYVIzQmIyIGFQE0NjMyFhUjNCYiBhUTNDYzMhYVIzQmIyIGFf0Ic750cDMwLjMB3nRdX3VxNS4sM0h1XV90cDVcM/7LdF1fdHA1Li0z/U9zvnRwMzAuM/1NdL50cDMwLjP+3nVdX3RwNVwzNXVdX3VxNS4tMwTzVGhoVC43NTD+61RoZ1UxNDUw/glVZ2hUMTQ3Lv35VGhoVDE0Ny7+5FRoaFQuNzcuBRpUaGhULjc1MP4JVWdoVDE0Ny79+VVnZ1UxNDUwAAj6LP5jAWsFxgAEAAkADgATABgAHQAiACcAOQCwIS+wEi+wCy+wGy+wJi+wAEVYsAcvG7EHHD5ZsABFWLAWLxuxFho+WbAARViwAi8bsQISPlkwMQUXAyMTAycTMwMBNwUVJQUHJTUFATclFwUBBwUnJQMnAzcTARcTBwP+Lwt6YEY6DHpgRgIdDQFN/qb7dQ3+swFaA5wCAUBE/tv88wL+wEUBJisRlEHGA2ARlELEPA7+rQFhBKIOAVL+oP4RDHxiRzsMfGJHAa4QmUTI/I4RmUXIAuQCAUZF/tX84wL+u0cBKwAAAv/cAAAD/AZxABEAGgB0shQbHBESObAUELAD0ACwAEVYsAwvG7EMHD5ZsABFWLAQLxuxEBw+WbAARViwCC8bsQgQPlmwEBCyAAEKK1gh2Bv0WbICDAgREjmwAi+wABCwCtCwC9CwAhCyEgEKK1gh2Bv0WbAIELITAQorWCHYG/RZMDEBIREhFhYQBgchESM1MzUzFSEBESEyNjU0JicClv6/ARi71NS3/iq/v7oBQf6/ARJpcW9kBRj90gLK/rbRAwUYmMHB/KL+RXdkYX0CAAIAqAAABNcFsAAOABsAVLIEHB0REjmwBBCwF9AAsABFWLADLxuxAxw+WbAARViwAS8bsQEQPlmyFgMBERI5sBYvsgABCitYIdgb9FmyCQADERI5sAMQshQBCitYIdgb9FkwMQERIxEhMgQVFAcXBycGIwE2NTQmJyERITI3JzcBacECGewBE2d+bYt2qAEZJaWR/qABWGJFbm4COv3GBbDyy7pwimeZNwEbQVuCnQL9xR15ZgAAAgCM/mAEIwROABMAIgB1shwjJBESObAcELAQ0ACwAEVYsBAvG7EQGD5ZsABFWLANLxuxDRg+WbAARViwCi8bsQoSPlmwAEVYsAcvG7EHED5ZsgIHEBESObIJEAcREjmyDhAHERI5sBAQshcBCitYIdgb9FmwBxCyHAEKK1gh2Bv0WTAxARQHFwcnBiMiJxEjETMXNjMyEhEnNCYjIgcRFjMyNyc3FzYEHmpvbm5Zc8VxuakJccnD47mciKhUU6tSPGZuWjICEe6XfWZ7OH399wXaeIz+2v76BLfUlf37lCdzZ2diAAABAKIAAAQjBwAACQA1sgMKCxESOQCwCC+wAEVYsAYvG7EGHD5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEBIxUhESMRIREzBCMD/ULAAsi5BRgG+u4FsAFQAAABAJEAAANCBXYABwAuALAGL7AARViwBC8bsQQYPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIREzA0L+CboB+LkDofxfBDoBPAABALH+3wR8BbAAFQBbsgoWFxESOQCwCS+wAEVYsBQvG7EUHD5ZsABFWLASLxuxEhA+WbAUELIAAQorWCHYG/RZsgMUCRESObADL7AJELIKAQorWCHYG/RZsAMQshABCitYIdgb9FkwMQEhETMgABEQAiMnMjY1JiYjIxEjESEEMP1CsgEcATz15AKRkAHMzrXBA38FEv4v/s/+8P74/ueTw8vL1P1hBbAAAAEAkf7lA74EOgAWAFuyCxcYERI5ALAKL7AARViwFS8bsRUYPlmwAEVYsBMvG7ETED5ZsBUQsgABCitYIdgb9FmyAxUKERI5sAMvsAoQsgsBCitYIdgb9FmwAxCyEQEKK1gh2Bv0WTAxASERMzIAFRQGBgcnNjY1NCYjIxEjESEDPv4NbO8BGGKqdTCAeLKYcLoCrQOh/uT+/NdiyIYVkiGZeZGo/h0EOgAAAQCjAAAE/wWwABQAYgCwAEVYsAAvG7EAHD5ZsABFWLAMLxuxDBw+WbAARViwAi8bsQIQPlmwAEVYsAovG7EKED5ZsA/QsA8vsi8PAV2yzw8BXbIIAQorWCHYG/RZsgEIDxESObAF0LAPELAS0DAxCQIjASMVIzUjESMRMxEzETMRMwEE0v5wAb3x/qJQlGjBwWiUTQFDBbD9Tv0CAo709P1yBbD9fwEA/wACgQAAAQCaAAAEfwQ6ABQAewCwAEVYsA0vG7ENGD5ZsABFWLAULxuxFBg+WbAARViwCi8bsQoQPlmwAEVYsAMvG7EDED5ZsAoQsA7QsA4vsp8OAV2y/w4BXbKfDgFxtL8Ozw4CXbIvDgFdsm8OAXKyCQEKK1gh2Bv0WbIBCQ4REjmwBdCwDhCwEtAwMQkCIwEjFSM1IxEjETMRMzUzFTMBBFr+rgF36/7rMpRlurpllCoBAwQ6/f79yAHNwsL+MwQ6/jbV1QHKAAEARAAABosFsAAOAGsAsABFWLAGLxuxBhw+WbAARViwCi8bsQocPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIBgIREjmwCC+yLwgBXbLPCAFdsgEBCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAQgREjkwMQEjESMRITUhETMBMwEBIwOQsMH+JQKclgH87/3UAlbsAo79cgUYmP1+AoL9P/0RAAEAPgAABX0EOgAOAIAAsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbACELAJ0LAJL7KfCQFdsv8JAV2ynwkBcbS/Cc8JAl2yLwkBXbJvCQFysgABCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbIMAAkREjkwMQEjESMRITUhETMBMwEBIwMbiLr+ZQJVegFr4f5TAdHrAc3+MwOhmf42Acr9+P3OAAABAKgAAAeEBbAADQBeALAARViwAi8bsQIcPlmwAEVYsAwvG7EMHD5ZsABFWLAGLxuxBhA+WbAARViwCi8bsQoQPlmwAdCwAS+yLwEBXbACELIEAQorWCHYG/RZsAEQsggBCitYIdgb9FkwMQEhESEVIREjESERIxEzAWkC3gM9/YPA/SLBwQM+AnKY+ugCof1fBbAAAQCRAAAFaQQ6AA0AmwCwAEVYsAIvG7ECGD5ZsABFWLAMLxuxDBg+WbAARViwBi8bsQYQPlmwAEVYsAovG7EKED5ZsAYQsAHQsAEvsm8BAV20vwHPAQJdsj8BAXG0zwHfAQJxsg8BAXK0nwGvAQJxsv8BAV2yDwEBcbKfAQFdsi8BAV20bwF/AQJysAIQsgQBCitYIdgb9FmwARCyCAEKK1gh2Bv0WTAxASERIRUhESMRIREjETMBSwHxAi3+jLn+D7q6AmUB1Zn8XwHO/jIEOgAAAQCw/t8HzQWwABcAaLIRGBkREjkAsAcvsABFWLAWLxuxFhw+WbAARViwFC8bsRQQPlmwAEVYsBEvG7ERED5ZsgEWBxESObABL7AHELIIAQorWCHYG/RZsAEQsg4BCitYIdgb9FmwFhCyEgEKK1gh2Bv0WTAxATMgABEQAiMnMjY1JiYjIxEjESERIxEhBP92ARwBPPXkApGQAczOecH9MsAETwNB/s/+8P74/ueTw8vL1P1hBRL67gWwAAABAJH+5QawBDoAGABoshIZGhESOQCwCC+wAEVYsBcvG7EXGD5ZsABFWLAVLxuxFRA+WbAARViwEi8bsRIQPlmyARcIERI5sAEvsAgQsgkBCitYIdgb9FmwARCyDwEKK1gh2Bv0WbAXELITAQorWCHYG/RZMDEBMzIAFQcGBgcnNjY1NCYjIxEjESERIxEhA/ag+AEiAxTRmTB8e7ygpLn+DroDZQKF/vzXJqPhG5Igln2Sp/4dA6H8XwQ6AAIAcf/kBaIFxQAoADYAm7IYNzgREjmwGBCwKdAAsABFWLANLxuxDRw+WbAARViwHy8bsR8cPlmwAEVYsAQvG7EEED5ZsADQsAAvsgIEHxESObACL7ANELIOAQorWCHYG/RZsAQQshUBCitYIdgb9FmwAhCyLAEKK1gh2Bv0WbIXAiwREjmyJiwCERI5sAAQsigBCitYIdgb9FmwHxCyMwEKK1gh2Bv0WTAxBSInBiMiJAI1NTQSNjMXIgYVFRQSMzI3JgI1NTQ2NjMyEhUVFAIHFjMBFBYXNjY1NTQmIyIGFQWi17OOrLL+5J910oQBdpTsv0Y4eYRovXa25m9maHn9fXh1Ymh5Y2F6HElCsgFCxKyxASKjpf7Zpuz+1w1hARWq45r9jf7M/eue/vZfGgI0mO1KSOeN+bHO0rIAAAIAbf/rBJwETwAkAC8AorIEMDEREjmwBBCwJdAAsABFWLAMLxuxDBg+WbAARViwHC8bsRwYPlmwAEVYsAQvG7EEED5ZsABFWLAALxuxABA+WbICBBwREjmwAi+wDBCyDQEKK1gh2Bv0WbAEELIUAQorWCHYG/RZsAIQsicBCitYIdgb9FmyFhQnERI5sAAQsiQBCitYIdgb9FmyIickERI5sBwQsiwBCitYIdgb9FkwMQUiJwYjIiYCNTU0EjMVIgYVFRQWMzI3JhE1NDYzMhYVFRQHFjMBFBc2NzU0JiIGBwScsox2j4zhf8WbSV2piS4swa2PjLKAT2H+D59mA0l4RgEMOUKVARKnOs0BDp6tkjjB8AuiARFewOv5zmLjnRUBqdZ0c7p1gp6NegAAAQA0/qEGkwWwABMAWwCwES+wAEVYsAcvG7EHHD5ZsABFWLAMLxuxDBw+WbAARViwEy8bsRMQPlmwBxCyCAEKK1gh2Bv0WbAA0LAHELAF0LAD0LAC0LATELIKAQorWCHYG/RZsA7QMDEBITUhNTMVIRUhESERMxEzAyMRIQGr/okBd8EBgf5/As7BmBKs+9YFGJcBAZf7hQUT+vH+AAFfAAEAH/6/BRYEOgAPAEsAsA0vsABFWLADLxuxAxg+WbAARViwDy8bsQ8QPlmwAxCyBAEKK1gh2Bv0WbAA0LAPELIGAQorWCHYG/RZsAMQsAjQsAYQsArQMDEBITUhFSMRIREzETMDIxEhATH+7gLE+QHyuoASpfzSA6OXl/z0A6P8Xf4oAUEAAQCWAAAEyAWwABcAT7IEGBkREjkAsABFWLAALxuxABw+WbAARViwCi8bsQocPlmwAEVYsAwvG7EMED5ZsgcADBESObAHL7AE0LAHELIQAQorWCHYG/RZsBPQMDEBERYWMxEzETY3ETMRIxEGBxUjNSImJxEBVwGJoJV5eMHBcn+V+O8EBbD+MpqEATb+0g0hArb6UAJbIg3u6NnaAdcAAAEAgwAAA9kEOwAWAE+yBhcYERI5ALAARViwCy8bsQsYPlmwAEVYsBUvG7EVGD5ZsABFWLAALxuxABA+WbIPFQAREjmwDy+yBwEKK1gh2Bv0WbAE0LAPELAS0DAxISMRBgcVIzUmJicRMxEWFxEzETY3ETMD2bpGU5awuwK5Ba+WVEW6AYgTCYeFDcy1AUP+tdMaARj+6goRAhoAAAEAigAABLwFsAARAEayBRITERI5ALAARViwAS8bsQEcPlmwAEVYsAAvG7EAED5ZsABFWLAJLxuxCRA+WbIFAQAREjmwBS+yDgEKK1gh2Bv0WTAxMxEzETYzMhYXESMRJiYjIgcRisG5yvnyA8EBiaO7yAWw/aU12N/+LQHOmIY3/UsAAAIAP//qBb0FwwAdACUAZLIXJicREjmwFxCwJNAAsABFWLAPLxuxDxw+WbAARViwAC8bsQAQPlmyHw8AERI5sB8vshMBCitYIdgb9FmwBNCwHxCwC9CwABCyGAEKK1gh2Bv0WbAPELIjAQorWCHYG/RZMDEFIAARNSYmNTMUFhc0EjYzIAARFSEVFBYzMjcXBgYBITU0JiMiAgPp/uL+s5mmmFBXjv2WAQIBHPyC3syzpi9A0v3gAr6zq57CFgFRASlbE8WiWn0UtAEfov6j/r5sXdz3U48tNQNaIdnl/v0AAv/e/+wEYwROABkAIQByshQiIxESObAUELAb0ACwAEVYsA0vG7ENGD5ZsABFWLAALxuxABA+WbIeDQAREjmwHi+0vx7PHgJdshEBCitYIdgb9FmwA9CwHhCwCdCwABCyFQEKK1gh2Bv0WbIXDQAREjmwDRCyGgEKK1gh2Bv0WTAxBSIANSYmNTMUFz4CMzISERUhFhYzMjcXBgEiBgchNSYmAr3c/ux4d5NlFITIcNPq/SMEs4qub3GI/tlwmBICHgiIFAEh+h2uhpMwgslu/ur+/U2gxZJY0QPKo5MOjZsAAAEAo/7WBMwFsAAWAF2yFRcYERI5ALAOL7AARViwAi8bsQIcPlmwAEVYsAYvG7EGHD5ZsABFWLAALxuxABA+WbIEAAIREjmwBC+wCNCwDhCyDwEKK1gh2Bv0WbAEELIWAQorWCHYG/RZMDEhIxEzETMBMwEWABUQAiMnMjY1JiYnIQFkwcGFAgHi/fj4AQ355gKQkALHx/7sBbD9jwJx/YgW/tL6/vj+5JjBycrSAQAAAQCa/v4EGQQ6ABYAebINFxgREjkAsAcvsABFWLARLxuxERg+WbAARViwFS8bsRUYPlmwAEVYsA8vG7EPED5ZsBPQsBMvsp8TAV2y/xMBXbKfEwFxtL8TzxMCXbIvEwFdss8TAXGwANCwBxCyCAEKK1gh2Bv0WbATELIOAQorWCHYG/RZMDEBFhYVFAYGByc2NTQmJyMRIxEzETMBMwJ/w85krHAw+K2lsrq6WwGK4AJkH+K0XcV8E5I55oqSAv4zBDr+NgHKAAABALH+SwT+BbAAFQCnsgoWFxESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwCC8bsQgSPlmwAEVYsBMvG7ETED5ZsALQsAIvsl8CAV2yzwIBXbIfAgFxtG8CfwICcbS/As8CAnG0DwIfAgJysu8CAXGynwIBcbJPAgFxsv8CAV2yrwIBXbIvAgFdsj8CAXKwCBCyDQEKK1gh2Bv0WbACELIRAQorWCHYG/RZMDEBESERMxEUBiMiJzcWMzI2NREhESMRAXICzMCrnDw2DiU9QUj9NMEFsP1uApL5/ai6EpoOZ1wC1f1/BbAAAAEAkf5LA/UEOgAWAJ+yChcYERI5ALAARViwAC8bsQAYPlmwAEVYsAMvG7EDGD5ZsABFWLAILxuxCBI+WbAARViwFC8bsRQQPlmwAtCwAi+ybwIBXbS/As8CAl2yPwIBcbTPAt8CAnGyDwIBcrSfAq8CAnGy/wIBXbIPAgFxsp8CAV2yLwIBXbRvAn8CAnKwCBCyDgEKK1gh2Bv0WbACELISAQorWCHYG/RZMDEBESERMxEUBiMiJzcWFxcyNjURIREjEQFLAfG5q5g8NA8RPBRCSP4PugQ6/isB1fttqrISkwcFAWhcAif+MgQ6AAACAF3/7AUSBcQAFwAfAF6yCCAhERI5sAgQsBjQALAARViwAC8bsQAcPlmwAEVYsAgvG7EIED5Zsg0ACBESObANL7AAELIRAQorWCHYG/RZsAgQshgBCitYIdgb9FmwDRCyGwEKK1gh2Bv0WTAxASAAERUUAgQjIAARNSE1EAIjIgcHJzc2ATISNyEVFBYCgAEuAWSc/uqn/uP+wQP09N2liz0vFp4BIaneD/zP0wXE/of+sVTF/r+2AVkBRXUHAQIBHDoajw1Y+sYBBdsi2uQAAQBo/+sELAWwABsAZ7ILHB0REjkAsABFWLACLxuxAhw+WbAARViwCy8bsQsQPlmwAhCyAAEKK1gh2Bv0WbAE0LIFAgsREjmwBS+wCxCwENCwCxCyEwEKK1gh2Bv0WbAFELIZAQorWCHYG/RZsAUQsBvQMDEBITUhFwEWFhUUBCMiJiY1MxQWMzI2NTQmIyM1Ax39dgNrAf5r2en+8+CG23bAnHuJo6aejQUSnn3+Hg7nxsPoab6CcpqSeJ2OlwAAAQBp/nUEKAQ6ABoAWrILGxwREjkAsAsvsABFWLACLxuxAhg+WbIAAQorWCHYG/RZsATQsgUCCxESObAFL7ALELAQ0LALELITAQorWCHYG/RZsAUQshgDCitYIdgb9FmwBRCwGtAwMQEhNSEXARYWFRQEIyImJjUzFBYzMjY1ECUjNQMM/YgDZQH+ctTo/vTehNd6up59jaT+yaADoZl2/hEQ4cXD52a/g3GflXkBIgiX//8AOv5LBHQFsAAmALBEAAAmAd6rQAAHAa8A8AAA//8AO/5LA5YEOgAmAOtPAAAmAd6sjgEHAa8A4QAAAAgAsgAGAV0wMQACAFcAAARlBbAACgATAFCyBBQVERI5sAQQsA3QALAARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAAL7ADELILAQorWCHYG/RZsAAQsgwBCitYIdgb9FkwMQERMxEhIiQ1NDY3AREhIgYVFBYXA6PC/d/k/vf/4AFt/qGMoZ+KA3MCPfpQ8svH6wT9KgI4loCCnwEAAgBZAAAGZwWwABcAHwBasgcgIRESObAHELAY0ACwAEVYsAgvG7EIHD5ZsABFWLAALxuxABA+WbIHCAAREjmwBy+wABCyGAEKK1gh2Bv0WbAK0LIQAAgREjmwBxCyGQEKK1gh2Bv0WTAxISIkNTQkNyERMxE3NjY3NiczFxYHBgYjJREhIgYUFhcCR+X+9wEB4wFqwVhvcgMEQLoWLwME5cP+7/6gjp6YhfTJxu0DAj366wECknuip0SXbsPonQI4l/6fBAAAAgBk/+cGbgYYAB8AKwCDshosLRESObAaELAq0ACwAEVYsAYvG7EGHj5ZsABFWLADLxuxAxg+WbAARViwGC8bsRgQPlmwAEVYsBwvG7EcED5ZsgUDGBESObAYELILAQorWCHYG/RZshEDGBESObIaAxgREjmwAxCyIgEKK1gh2Bv0WbAcELIoAQorWCHYG/RZMDETEBIzMhcRMxEGFjM2Njc2JzcWFgcOAiMGJwYjIgI1ASYjIgYVFBYzMjcnZOLEt2q5Al9OiZcEBEGzHCkCAnnZifJObNvA5ALHUqGHlJGIp1MFAgkBCAE9gwJN+0FfeALQvbrYAWbHZqn5hAS6tgEb9AExht/erb+TPgAAAQA2/+MF1QWwACcAY7IQKCkREjkAsABFWLAJLxuxCRw+WbAARViwIS8bsSEQPlmyASgJERI5sAEvsgABCitYIdgb9FmwCRCyBwEKK1gh2Bv0WbIPAAEREjmwIRCyFQEKK1gh2Bv0WbIaIQkREjkwMRM1MzY2NTQhITUhFhYVFAcWExUUFjM2Njc2JzMXFgcGAiMEAzU0Jif+m5+T/sv+oAFr7/zt2wVTQXSGBARBuhcwAwT2x/69D4d1AnmeAnuD+54B0cnoYkX+/FBPWwLOubvYWLuA/f7XCAFNQHiQAQABADH/4wToBDoAJwBgsg8oKRESOQCwAEVYsB8vG7EfGD5ZsABFWLAOLxuxDhA+WbICAQorWCHYG/RZsgcOHxESObIXKB8REjmwFy+yFAEKK1gh2Bv0WbAfELIdAQorWCHYG/RZsiUUFxESOTAxJQYzNjY3NiczFhYHBgYjBiYnNTQjIyczNjY1NCYjISchFhYVFAcWFwLnAl9wdgMEQrQtGAEE57iHiQfYzQLAem59df77BgEYxNy8tgTVWAKbiZmmhoA5zfADcINHnZYBV0pVXZYDp5idSjSyAAEAUv7XA/UFrwAhAF2yICIjERI5ALAXL7AARViwCS8bsQkcPlmwAEVYsBovG7EaED5ZsgEiCRESObABL7IAAQorWCHYG/RZsAkQsgcBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETNTM2NjUQISE1IRYWFRQHFhMVMxUUBgcnNjcjJic1NCYjr6mkm/7K/vEBIej05d4EqWFNalEOazwDkncCeZcBfYUBBZcD0sniZEb++KmUYchASHNuNKuPfo0AAAEAef7HA9kEOgAgAF2yICEiERI5ALAXL7AARViwCC8bsQgYPlmwAEVYsBovG7EaED5ZsgEhCBESObABL7IAAQorWCHYG/RZsAgQsgYBCitYIdgb9FmyDwABERI5sBoQsRIKK1jYG9xZMDETJzM2NTQjITUhFhcWFRQHFhcVMxUUBgcnNjcjJic1NCPCAdvp9f7pASfdbFa+vQGaYk1pVA1nMwLaAbiXAqGylgNnU4ShSTXKTJRhyj5IdH0hhV60AAEARP/rB3AFsAAjAGKyACQlERI5ALAARViwDi8bsQ4cPlmwAEVYsCAvG7EgED5ZsABFWLAHLxuxBxA+WbAOELIAAQorWCHYG/RZsAcQsggBCitYIdgb9FmwIBCyEwEKK1gh2Bv0WbIZDiAREjkwMQEhAwICBgcjNTc+AjcTIREUFjMyNjc2JzcWFgcGAgcHIiY1BCf+GhoPWayQPyhdZDQLHgNfWU+ClwQCP7ocKQID6cMus7cFEv2//t7+3IkCnQIHa+rzAsL7rGB0zbzA0gFmx2bs/toSArq0AAABAD//6wY6BDoAIQBisiAiIxESOQCwAEVYsAwvG7EMGD5ZsABFWLAeLxuxHhA+WbAARViwBi8bsQYQPlmwDBCyAAEKK1gh2Bv0WbAGELIHAQorWCHYG/RZsB4QshEBCitYIdgb9FmyFh4MERI5MDEBIQMCBgcjNTc2NjcTIREUFjMyNjc2JzMXFgcOAiMiJicDMf67FxScpUE2VU0NFwKvWk9sewQEQbMWMAMCbL54rrMBA6H+Wv7r5AKjBAqn0wIP/SFgebersstQsXya5nm4sQABAKn/5wdxBbAAHQCushQeHxESOQCwAEVYsAAvG7EAHD5ZsABFWLAZLxuxGRw+WbAARViwES8bsREQPlmwAEVYsBcvG7EXED5ZsBEQsgQBCitYIdgb9FmyCgARERI5sBcQsBzQsBwvsu8cAXGyXxwBXbLPHAFdsh8cAXG0bxx/HAJxtL8czxwCcbKfHAFxsk8cAXGy/xwBXbKvHAFdsi8cAV20DxwfHAJysj8cAXKyFQEKK1gh2Bv0WTAxAREUFjM2Njc2JzcWFgcOAiMGJicRIREjETMRIREE6V1KhpQEBEK7GysCAnvYiqu1CP1CwcECvgWw+6xlbwLNurfbAWLKZ6j7gwS4uwEn/X8FsP1uApIAAQCQ/+cGTQQ6ABwAo7IbHR4REjkAsABFWLAELxuxBBg+WbAARViwCC8bsQgYPlmwAEVYsBkvG7EZED5ZsABFWLACLxuxAhA+WbAH0LAHL7JvBwFdtL8HzwcCXbI/BwFxtM8H3wcCcbIPBwFytJ8HrwcCcbL/BwFdsg8HAXGynwcBXbIvBwFdtG8HfwcCcrIAAQorWCHYG/RZsBkQsg0BCitYIdgb9FmyEhkIERI5MDEBIREjETMRIREzERQWMzY2NzYnMxcWBwYCIwYmJwND/ga5uQH6uVxNbHwEBEGyFzADBOa7p7MIAc3+MwQ6/ioB1v0hZHUCtaus0VOxeer+8QS3uwABAHb/6wSgBcUAIgBHshUjJBESOQCwAEVYsAkvG7EJHD5ZsABFWLAALxuxABA+WbAJELIOAQorWCHYG/RZsAAQshYBCitYIdgb9FmyGwAJERI5MDEFIiQCJxE0EiQzMhcHJiMiAhUVFBYWMzY2NzYnMxcWBw4CArmk/viVApQBCqXchzuGoqzXYrBxjZYDAzW6JhMBAnveFZsBGK0BEK8BHp1YikT+/tL+g9V1ApmGms+zW1uIyW0AAQBl/+sDxwROAB4ARLITHyAREjkAsABFWLATLxuxExg+WbAARViwCy8bsQsQPlmyAAEKK1gh2Bv0WbIFCxMREjmwExCyGAEKK1gh2Bv0WTAxJTY2NzQnMxYHBgYjIgA1NTQ2NjMyFwcmIyIGFRUUFgJRYFoCFLIcAQTErdz+8HbWi7lgLGOKg5umggJQWXpyllaZqQEy9x6X+YxCkDrcsx+r2wABACP/5wVHBbAAGABNsgUZGhESOQCwAEVYsAIvG7ECHD5ZsABFWLAVLxuxFRA+WbACELIAAQorWCHYG/RZsATQsAXQsBUQsgkBCitYIdgb9FmyDgIVERI5MDEBITUhFSERFBYzNjYSJzcWFgcOAiMGJicB/v4lBID+HFxMhpQIQrobKwMCedmJqrcIBRKenvxIYHIC0AFu2wFiymep+YQEt7wAAAEARv/nBLcEOgAYAE2yFhkaERI5ALAARViwAi8bsQIYPlmwAEVYsBUvG7EVED5ZsAIQsgABCitYIdgb9FmwBNCwBdCwFRCyCQEKK1gh2Bv0WbIOFQIREjkwMQEhNSEVIREUFjM2Njc2JzMWFgcGBiMGJicBrP6aA4v+lV5NcXcDBECyKhsBBOi5qrMIA6SWlv21Y3QCnYmXrn2MPNDvBLm5AAEAlv/sBP8FxQApAG+yJCorERI5ALAARViwFi8bsRYcPlmwAEVYsAsvG7ELED5ZsgMBCitYIdgb9FmwCxCwBtCyJQsWERI5sCUvss8lAV2ynyUBcbImAQorWCHYG/RZshAmJRESObAWELAb0LAWELIeAQorWCHYG/RZMDEBFBYzMjY1MxQGBiMgJDU0JSYmNTQkITIWFhUjNCYjIgYVFBYXMxUjBgYBWM+wm8zBjf6d/vv+xAEUeIYBJQEGk/WMwcGSp8Kto8TEsbUBkniSmHSDvmflxf9WMKZlxNtlunVnj4h2dX0CngJ+AAIAbwRwAskF1gAFAA0AIwCwCy+wB9CwBy+wAdCwAS+wCxCwBNCwBC+wBdAZsAUvGDAxARMzFQMjATMVFhcHJjUBkXTE31n+3qgDUEmyBJQBQhX+wwFSW3tVO1+7AP//ACUCHwINArYABgARAAD//wAlAh8CDQK2AAYAEQAA//8AogKLBI0DIgBGAZfZAEzNQAD//wCQAosFyQMiAEYBl4QAZmZAAP//AA3+bAOhAAAAJwBDAAn/AwEGAEMJAAAUAEAJAwITAiMCMwIEXbKwAgFdMDEAAQBgBDEBeAYTAAgAIbIICQoREjkAsABFWLAALxuxAB4+WbIFCQAREjmwBS8wMQEXBgcVIzU0NgEOal0DuGEGE0h/k4h0ZsgAAQAwBBYBRwYAAAgAIbIICQoREjkAsABFWLAELxuxBB4+WbIACQQREjmwAC8wMRMnNjc1MxUGBplpXQO3AWEEFkiCkJCCZMcAAQAk/uUBOwC1AAgAHrIICQoREjkAsAkvsgQFCitYIdgb9FmwANCwAC8wMRMnNjc1MxUUBo1pWwO5Y/7lSX+SdmRlygABAE8EFgFnBgAACAAMALAIL7AE0LAELzAxARUWFwcmJic1AQYEXWpNXwIGAJOQf0hAwmGHAP//AGgEMQK7BhMAJgFsCAAABwFsAUMAAP//ADwEFgKGBgAAJgFtDAAABwFtAT8AAAACACT+0wJkAPYACAARADCyChITERI5sAoQsAXQALASL7IEBQorWCHYG/RZsADQsAAvsAnQsAkvsAQQsA3QMDETJzY3NTMVFAYXJzY3NTMVFAaNaVsDuWPdaVsDumH+00iJmbmkbNNASImZuaRr0QAAAQBGAAAEJAWwAAsASwCwAEVYsAgvG7EIHD5ZsABFWLAGLxuxBhg+WbAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZsAoQsgABCitYIdgb9FmwBNCwBdAwMQEhESMRITUhETMRIQQk/my6/nABkLoBlAOh/F8DoZkBdv6KAAEAV/5gBDQFsAATAHwAsABFWLAMLxuxDBw+WbAARViwCi8bsQoYPlmwAEVYsA4vG7EOGD5ZsABFWLACLxuxAhI+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgYBCitYIdgb9FmwDhCyCAEKK1gh2Bv0WbAJ0LAQ0LAR0LAGELAS0LAT0DAxISERIxEhNSERITUhETMRIRUhESEENP5quv5zAY3+cwGNugGW/moBlv5gAaCXAwqZAXb+ipn89gAAAQCKAhcCIgPLAA0AFrIKDg8REjkAsAMvsQoKK1jYG9xZMDETNDYzMhYVFRQGIyImNYpvXFtybl5dbwMEV3BtXSVXbm9Y//8AlP/1Ay8A0QAmABIEAAAHABIBuQAA//8AlP/1BM4A0QAmABIEAAAnABIBuQAAAAcAEgNYAAAAAQAmAh4AzwK3AAMADwCwAi+xAQorWNgb3FkwMRMjNTPPqakCHpkAAAYARP/rB1cFxQAVACMAJwA1AEMAUQC4sgJSUxESObACELAb0LACELAm0LACELAo0LACELA20LACELBJ0ACwAEVYsBkvG7EZHD5ZsABFWLASLxuxEhA+WbAD0LADL7AH0LAHL7ASELAO0LAOL7AZELAg0LAgL7IkEhkREjmwJC+yJhkSERI5sCYvsBIQsisECitYIdgb9FmwAxCyMgQKK1gh2Bv0WbArELA50LAyELBA0LAgELJHBAorWCHYG/RZsBkQsk4ECitYIdgb9FkwMQE0NjMyFzYzMhYVFRQGIyInBiMiJjUBNDYzMhYVFRQGIyImNQEnARcDFBYzMjY1NTQmIyIGFQUUFjMyNjU1NCYjIgYVARQWMzI2NTU0JiMiBhUDN6eDmE1Pl4Oop4KZT0yXgqr9DaeDhKelhIKqAWloAsdos1hKSFZXSUdZActYSUhWV0lIV/tCWEpHV1ZKSFgBZYOpeXmoi0eDqXh4p4sDe4OqqohIgaqni/wcQgRyQvw3T2VjVUpPZGNUSk9lZlJKT2RkUwLqTmViVUlOZmVTAAABAGwAmQIgA7UABgAQALAFL7ICBwUREjmwAi8wMQEBIwE1ATMBHgECjf7ZASeNAib+cwGEEwGFAAEAWQCYAg4DtQAGABAAsAAvsgMHABESObADLzAxEwEVASMBAecBJ/7ZjgEC/v4Dtf57E/57AY4BjwABADsAbgNqBSIAAwAJALAAL7ACLzAxNycBF6NoAsdobkIEckIA//8ANgKQArsFpQMHAdgAAAKQABMAsABFWLAJLxuxCRw+WbAN0DAxAAABAHoCiwL4BboADwBTsgoQERESOQCwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxw+WbAARViwDS8bsQ0UPlmwAEVYsAYvG7EGFD5ZsgENAxESObADELIKAworWCHYG/RZMDETFzYzIBERIxEmIyIHESMR+h5KkgEEqgONbiyqBat7iv7G/gsB5rlt/c4DIAAAAQBbAAAEaAXEACkAlrIhKisREjkAsABFWLAZLxuxGRw+WbAARViwBi8bsQYQPlmyKRkGERI5sCkvsgACCitYIdgb9FmwBhCyBAEKK1gh2Bv0WbAI0LAJ0LAAELAO0LApELAQ0LApELAV0LAVL7YPFR8VLxUDXbISAgorWCHYG/RZsBkQsB3QsBkQsiABCitYIdgb9FmwFRCwJNCwEhCwJtAwMQEhFxQHIQchNTM2Njc1JyM1MycjNTMnNDYzMhYVIzQmIyIGFRchFSEXIQMV/rEDPgLdAfv4TSgyAgOqpgSinQb1yL7ev39vaYIGAVz+qQQBUwHWRJpbnZ0Jg2AIRX2IfbfH7tSxa3yafbd9iAAFAB8AAAY2BbAAGwAfACMAJgApALEAsABFWLAXLxuxFxw+WbAARViwGi8bsRocPlmwAEVYsAwvG7EMED5ZsABFWLAJLxuxCRA+WbIQDBcREjmwEC+wFNCwFC+0DxQfFAJdsCTQsCQvsBjQsBgvsADQsAAvsBQQshMBCitYIdgb9FmwH9CwI9CwA9CwEBCwHNCwHC+wINCwIC+wBNCwBC+wEBCyDwEKK1gh2Bv0WbAL0LAp0LAH0LImFwwREjmyJwkaERI5MDEBMxUjFTMVIxEjASERIxEjNTM1IzUzETMBIREzASEnIwUzNSElMycBNSMFV9/f39/C/sH+YsDZ2dnZwAFRAY+//GEBO2HaAhTM/tT+THd3AuBoA6yYlJj+GAHo/hgB6JiUmAIE/fwCBPzQlJSUmLb8558AAAIAp//sBgMFsAAfACgAorIjKSoREjmwIxCwEdAAsABFWLAWLxuxFhw+WbAARViwGi8bsRoYPlmwAEVYsB4vG7EeGD5ZsABFWLAKLxuxChA+WbAARViwFC8bsRQQPlmwHhCyAAEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAAQsA7QsA/QsiEUFhESObAhL7ISAQorWCHYG/RZsB4QsB3QsB0vsBYQsicBCitYIdgb9FkwMQEjERQWMzI3FwYjIiY1ESMGBgcjESMRITIWFzMRMxEzATMyNjU0JicjBf7KNkEjNAFJRnx+jxTnx8m5AXnK7RSPusr7YsCLi4eEywOr/WFBQQyWFJaKAp+3vQL9ywWwwLYBBv76/pKNl5iOAv//AKj/7AgQBbAAJgA2AAAABwBXBFUAAAAHADkAAAcpBbAAHwAjACcAKwAwADUAOgC3ALAARViwHi8bsR4cPlmwAEVYsBsvG7EbHD5ZsABFWLACLxuxAhw+WbAARViwDS8bsQ0QPlmwAEVYsBAvG7EQED5ZshQQGxESObAUL7AY0LAYL7Ac0LA20LAA0LAE0LAYELIXAQorWCHYG/RZsCfQsCPQsCvQsAfQsBQQsCTQsCDQsCjQsAjQsBQQshMBCitYIdgb9FmwMtCwD9CwLdCwC9CyNBAeERI5sDQQsC/QsjkeEBESOTAxASETMwMzFSMHMxUhAyMDIQMjAyE1MycjNTMDMxMhEzMDIScjBTM3IQUzNyETIxcXNyUjFxc3ATMnJwcEhwFTbMFzlbov6f7ydK+I/oSNr3X+9uUvtpFzwG4BVoih4wEkN7T+eqU3/vgDP6Us/vm5WQwpH/zpVwYdKAFEXRcXFwPUAdz+JJjCmP4eAeL+HgHimMKYAdz+JAHc/MrCwsLCwv6mKrLGFhfArQIcUW9vAAACAIwAAAWeBDoADQAbAGQAsABFWLAWLxuxFhg+WbAARViwAC8bsQAYPlmwAEVYsAsvG7ELED5ZsABFWLAOLxuxDhA+WbIRAQorWCHYG/RZsgURABESObAFL7AAELIKAQorWCHYG/RZsg8KCxESObAPLzAxATIWFxEjETQmJyERIxEBETMRITI2NxEzEQYGBwK6r6gEuWVv/r25AYm5AT5xZwG5AqWtBDrBv/6jAUx/eAH8XwQ6+8YC3f27dX4Cr/1OwsQCAAABAF//7AQcBcQAIwCHshUkJRESOQCwAEVYsBYvG7EWHD5ZsABFWLAJLxuxCRA+WbIjCRYREjmwIy+yAAIKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAAQsAzQsCMQsA/QsCMQsB/QsB8vtg8fHx8vHwNdsiACCitYIdgb9FmwENCwHxCwE9CwFhCyGwEKK1gh2Bv0WTAxASEWFjMyNxcGIyIAAyM1MzUjNTMSADMyFwcmIyIGByEVIRUhA1H+gAS0pXRmFHh4+P7jBrKysrIKAR3zaocUbW6ksQYBf/6AAYACHcPSIqAeASUBDHyJfQEGAR8foiPLvH2JAAQAHwAABbwFsAAZAB4AIwAoALgAsABFWLALLxuxCxw+WbAARViwAS8bsQEQPlmwCxCyKAEKK1gh2Bv0WbIkKAEREjmwJC+ycCQBcbYAJBAkICQDXbIcAQorWCHYG/RZsB3QsB0vsnAdAXG2AB0QHSAdA12yIAEKK1gh2Bv0WbAh0LAhL7JwIQFxsiAhAV2yAAEKK1gh2Bv0WbAgELAD0LAdELAG0LAGL7AcELAH0LAkELAK0LAkELAP0LAcELAS0LAdELAU0LAULzAxAREjESM1MzUjNTM1ITIWFzMVIxcHMxUjBiEBJyEVIQchFSEyASEmIyEBpcDGxsbGAhmx6zbswwMCwuVr/owBRAT9bQKVP/2qAVms/fsCSlSe/qgCOv3GAzCXXpf0hHCXMiyX9gG3NF6XWQHlVgAAAQAqAAAD+AWwABoAZgCwAEVYsBkvG7EZHD5ZsABFWLAMLxuxDBA+WbAZELIYAQorWCHYG/RZsAHQsBgQsBTQsBQvsAPQsBQQshMBCitYIdgb9FmwBtCwExCwDtCwDi+yCQEKK1gh2Bv0WbINCQ4REjkwMQEjFhczByMGBiMBFSMBJzM2NjchNyEmJyE3IQPK7EARyS6YEvbbAe3j/e4B+X2cFf29LgITMPb+5y8DnQUSUXWesrT9xAwCaX0Ba1yevgieAAEAIP/uBBoFsAAeAI0AsABFWLARLxuxERw+WbAARViwBS8bsQUQPlmyExEFERI5sBMvsBfQsBcvsgAXAV2yGAEKK1gh2Bv0WbAZ0LAI0LAJ0LAXELAW0LAL0LAK0LATELIUAQorWCHYG/RZsBXQsAzQsA3QsBMQsBLQsA/QsA7QsAUQshoBCitYIdgb9FmyHgURERI5sB4vMDEBFQYCBCMiJxEHNTc1BzU3ETMRNxUHFTcVBxE2EhE1BBoCkP73r1Bs9PT09MD7+/v7vskDA2TS/semEgJab7JvmW+ybwFZ/v9zsnOZc7Jz/d4CARABCVgAAQBdAAAE6wQ6ABcAXLIAGBkREjkAsABFWLAWLxuxFhg+WbAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsABFWLAQLxuxEBA+WbIAChYREjmwAC+yCQEKK1gh2Bv0WbAM0LAAELAV0DAxARYAERUjNSYCJxEjEQYCBxUjNRIANzUzAv/nAQW5Ap6TuY+fArkDAQffuQNxIf6N/tq3yN8BBSD9NALKIf712MbFAR0BbSLJAAIAHwAABQMFsAAWAB8AbQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIGAwwREjmwBi+yBQEKK1gh2Bv0WbAB0LAGELAK0LAKL7QPCh8KAl2yCQEKK1gh2Bv0WbAU0LAGELAV0LAKELAX0LAMELIfAQorWCHYG/RZMDEBIREjESM1MzUjNTMRITIEFRQEByEVIQEhMjY1NCYnIQL8/rG/z8/PzwIZ6gES/vny/qMBT/6xAVqboqiP/qABE/7tAROeiZ0C2e7L1ecBiQEmkox/nQEABAB6/+sFgwXFABsAJwA1ADkAt7IcOjsREjmwHBCwANCwHBCwKNCwHBCwONAAsABFWLAKLxuxChw+WbAARViwJS8bsSUQPlmwChCwA9CwAy+yDgoDERI5tioOOg5KDgNdsAoQshEECitYIdgb9FmwAxCyGAQKK1gh2Bv0WbIbAwoREjm0NhtGGwJdsiUbAV2wJRCwH9CwHy+wJRCyKwQKK1gh2Bv0WbAfELIyBAorWCHYG/RZsjYlChESObA2L7I4CiUREjmwOC8wMQEUBiMiJjU1NDYzMhYVIzQmIyIGFRUUFjMyNjUBNDYgFhUVFAYgJjUXFBYzMjY1NTQmIyIGFQUnARcCqJh7eqGee3mciklCQU1PQT1MARCnAQaop/78qopYSkhWV0lHWf4GaQLHaQQebpCoiUeCq5FvOk1mUklOZUw6/UeDqaiLR4Opp4sGT2VjVUpPZGNU80IEckIAAAIAaP/rA2oGEwAXACEAZLITIiMREjmwExCwGNAAsABFWLAMLxuxDB4+WbAARViwAC8bsQAQPlmyBgwAERI5sAYvsgUBCitYIdgb9FmwE9CwABCyFwEKK1gh2Bv0WbAGELAY0LAMELIfAQorWCHYG/RZMDEFIiY1BiM1MjcRNjYzMhYVFRQCBxUUFjMDNjY1NTQmIyIHAszC0mJucV8BnYV4l86ra3DbWWcwJmcDFerrHLAjAiSyxq2TJcH+j2timo0CY1X1eydSTNEAAAQAogAAB8YFwAADABAAHgAoAKOyHykqERI5sB8QsAHQsB8QsATQsB8QsBHQALAARViwJy8bsSccPlmwAEVYsCUvG7ElHD5ZsABFWLAHLxuxBxw+WbAARViwIi8bsSIQPlmwAEVYsCAvG7EgED5ZsAcQsA3QsALQsAIvshACAV2yAQMKK1gh2Bv0WbANELIUAworWCHYG/RZsAcQshsDCitYIdgb9FmyISUgERI5siYgJRESOTAxASE1IQE0NiAWFRUUBiMiJjUXFBYzMjY3NTQmIyIGFQEjAREjETMBETMHpP2ZAmf9dboBOLu5nJ66o19WVF0BX1VUX/68zP2vucsCVLcBnI4CPZu+u6Ndnbq7oQVia2pgZWFra2P7mwRu+5IFsPuPBHEAAgBnA5cEOAWwAAwAFABtALAARViwBi8bsQYcPlmwAEVYsAkvG7EJHD5ZsABFWLATLxuxExw+WbIBFQYREjmwAS+yAAkBERI5sgMBBhESObAE0LIIAQkREjmwARCwC9CwBhCxDQorWNgb3FmwARCwD9CwDRCwEdCwEtAwMQEDIwMRIxEzExMzESMBIxEjESM1IQPejDSMWnCQkHBa/guTW5QBggUh/nYBif53Ahn+cQGP/ecByP44AchRAAACAJj/7ASTBE4AFQAcAGKyAh0eERI5sAIQsBbQALAARViwCi8bsQoYPlmwAEVYsAIvG7ECED5ZshoKAhESObAaL7IPCgorWCHYG/RZsAIQshMKCitYIdgb9FmyFQoCERI5sAoQshYKCitYIdgb9FkwMSUGIyImAjU0EjYzMhYWFxUhERYzMjcBIgcRIREmBBa3u5H0h5D4hIXjhAP9AHeaxKz+kJd6AhxzXnKdAQGTjwEDn4vzkD7+uG56Ayp6/usBHnH//wBU//UFswWbACcB1f/aAoYAJwF8AOYAAAAHAdwDFAAA//8AZP/1BlMFtAAnAdcAJgKUACcBfAGlAAAABwHcA7QAAP//AGP/9QZJBaQAJwHZAAgCjwAnAXwBgwAAAAcB3AOqAAD//wBZ//UF/QWkACcB2wAfAo8AJwF8ASAAAAAHAdwDXgAAAAIAav/rBDIF7AAbACoAW7IVKywREjmwFRCwI9AAsA0vsABFWLAVLxuxFRA+WbIADRUREjmwAC+yAwAVERI5sA0QsgcBCitYIdgb9FmwABCyHAEKK1gh2Bv0WbAVELIjAQorWCHYG/RZMDEBMhYXLgIjIgcnNzYzIAARFRQCBiMiADU1NAAXIgYVFRQWMzI2NTUnJiYCPF2mOg5ppmCBmxAxdJcBBwEfeN6Q2v74AQDkjJ+fio6fBBygA/5NRIzZeTuXFTD+Tv5uMrz+1qUBI/YO3AEQmLugEKrP+ds9D1pqAAABAKn/KwTlBbAABwAnALAEL7AARViwBi8bsQYcPlmwBBCwAdCwBhCyAgEKK1gh2Bv0WTAxBSMRIREjESEE5bn9NrkEPNUF7foTBoUAAQBF/vMEqwWwAAwANQCwAy+wAEVYsAgvG7EIHD5ZsAMQsgIBCitYIdgb9FmwBdCwCBCyCgEKK1gh2Bv0WbAH0DAxAQEhFSE1AQE1IRUhAQNr/bsDhfuaAmH9nwQZ/McCRgJB/UqYjwLMAtKQmP1CAAEAqAKLA+sDIgADABsAsABFWLACLxuxAhY+WbIBAQorWCHYG/RZMDEBITUhA+v8vQNDAouXAAEAPwAABJgFsAAIADyyAwkKERI5ALAHL7AARViwAS8bsQEcPlmwAEVYsAMvG7EDED5ZsgABAxESObAHELIGAQorWCHYG/RZMDEBATMBIwMjNSECMAGrvf3ijfW5ATsBHASU+lACdJoAAwBi/+sHywROABwALAA8AG+yBz0+ERI5sAcQsCTQsAcQsDTQALAARViwBC8bsQQQPlmwAEVYsAovG7EKED5ZsBPQsBMvsBnQsBkvsgcZBBESObIWGQQREjmwChCyIAEKK1gh2Bv0WbATELIpAQorWCHYG/RZsDDQsCAQsDnQMDEBFAIGIyImJwYGIyImAjU1NBI2MzIWFzY2MzIAFQUUFjMyNjc3NS4CIyIGFSU0JiMiBgcHFR4CMzI2NQfLft+Jke5QUeyQid6Aft+Ike1RUO+SzgEW+VCmiHK5NAsYcpJQhqYF96aFc7w1CRZ1kFCIpQIPk/8Akbixs7aPAQCXGJMBAJK3s7G5/sHzDbHcvKMnKmPAYdy5CK7fvagfKmHFYN64AAH/sP5LAo4GFQAVAD2yAhYXERI5ALAARViwDi8bsQ4ePlmwAEVYsAMvG7EDEj5ZsggBCitYIdgb9FmwDhCyEwEKK1gh2Bv0WTAxBRQGIyInNxYzMjURNDYzMhcHJiMiFQFlpJ45OhIuIZuxoTxUGCU2tmuiqBSRDbEFGaq+FY4L2wACAGUBGAQLA/QAFQArAI2yHCwtERI5sBwQsAXQALADL7IPAwFdsA3QsA0vsgANAV2yCAEKK1gh2Bv0WbADELAK0LAKL7ADELISAQorWCHYG/RZsA0QsBXQsBUvsA0QsBnQsBkvsCPQsCMvsgAjAV2yHgEKK1gh2Bv0WbAZELAg0LAgL7AZELIoAQorWCHYG/RZsCMQsCvQsCsvMDETNjYzNhcXFjMyNxUGIyInJyYHIgYHBzY2MzYXFxYzMjcXBiMiJycmByIGB2Ywg0JSSphCToZmZ4VOQqFET0KDMAEwgkJSSpVEUIVmAWeFTkKYSlJCgzADhTM6AiNOH4C+bR9THwJEPOUzOwIjTSGAvW0fTiMCRDwAAAEAmACbA9oE1QATADcAsBMvsgABCitYIdgb9FmwBNCwExCwB9CwExCwD9CwDy+yEAEKK1gh2Bv0WbAI0LAPELAL0DAxASEHJzcjNSE3ITUhExcHMxUhByED2v3tjl9srgELlf5gAf6ZX3fD/t+UAbUBj/Q7uaD/oQEGO8uh/wD//wA+AAIDgQQ+AGYAIABhQAA5mgEHAZf/lv13AB0AsABFWLAFLxuxBRg+WbAARViwCC8bsQgQPlkwMQD//wCFAAED3ARRAGYAIgBzQAA5mgEHAZf/3f12AB0AsABFWLACLxuxAhg+WbAARViwCC8bsQgQPlkwMQAAAgArAAAD3AWwAAUACQA4sggKCxESObAIELAB0ACwAEVYsAAvG7EAHD5ZsABFWLADLxuxAxA+WbIGAAMREjmyCAADERI5MDEBMwEBIwkEAbyMAZT+cI3+bAHW/ukBHAEYBbD9J/0pAtcCD/3x/fICDgD//wC1AKcBmwT1ACcAEgAlALIABwASACUEJAACAG4CeQIzBDoAAwAHACwAsABFWLACLxuxAhg+WbAARViwBi8bsQYYPlmwAhCwANCwAC+wBNCwBdAwMRMjETMBIxEz+42NATiNjQJ5AcH+PwHBAAABAFz/XwFXAO8ACAAgsggJChESOQCwCS+wBNCwBC+0QARQBAJdsADQsAAvMDEXJzY3NTMVFAbFaUgCsU+hSG1/XExbswD//wA8AAAE9gYVACYASgAAAAcASgIsAAAAAgAfAAADzQYVABUAGQCDsggaGxESObAIELAX0ACwAEVYsAgvG7EIHj5ZsABFWLADLxuxAxg+WbAARViwES8bsREYPlmwAEVYsBgvG7EYGD5ZsABFWLAALxuxABA+WbAARViwFi8bsRYQPlmwAxCyAQEKK1gh2Bv0WbAIELINAQorWCHYG/RZsAEQsBPQsBTQMDEzESM1MzU0NjMyFwcmIyIGFRUzFSMRISMRM8qrq8+9cKsffXF3ad3dAkm6ugOrj1y1yj2cMmtrXo/8VQQ6AAEAPAAAA+kGFQAWAFwAsABFWLASLxuxEh4+WbAARViwBi8bsQYYPlmwAEVYsAkvG7EJED5ZsABFWLAWLxuxFhA+WbASELICAQorWCHYG/RZsAYQsgcBCitYIdgb9FmwC9CwBhCwDtAwMQEmIyIVFTMVIxEjESM1MzU2NjMyBREjAzB8TMjn57mrqwHAsWUBK7kFYxTSa4/8VQOrj3atuD36KAAAAgA8AAAGMgYVACcAKwCdALAARViwFi8bsRYePlmwAEVYsAgvG7EIHj5ZsABFWLAgLxuxIBg+WbAARViwEi8bsRIYPlmwAEVYsAQvG7EEGD5ZsABFWLAqLxuxKhg+WbAARViwKS8bsSkQPlmwAEVYsCMvG7EjED5ZsABFWLAnLxuxJxA+WbAgELIhAQorWCHYG/RZsCXQsAHQsAgQsg0BCitYIdgb9FmwG9AwMTMRIzUzNTQ2MzIXByYjIgYVFSE1NDYzMhcHJiMiBhUVMxUjESMRIREhIxEz56uruqpAPwovNVpiAZDPvXCrH31yd2ne3rn+cASSubkDq49vrr4RlglpYnJctco9nDJqbF6P/FUDq/xVBDoAAAEAPAAABjIGFQAoAGoAsABFWLAILxuxCB4+WbAARViwIS8bsSEYPlmwAEVYsCgvG7EoED5ZsCEQsiIBCitYIdgb9FmwJtCwAdCwIRCwEtCwBNCwCBCyDQEKK1gh2Bv0WbAIELAW0LAoELAl0LAa0LANELAd0DAxMxEjNTM1NDYzMhcHJiMiBhUVITU2NjMyBREjESYjIhUVMxUjESMRIRHnq6u6qkA/Ci81WmIBkAHAsWUBK7l8TMjn57n+cAOrj2+uvhGWCWlicnatuD36KAVjFNJrj/xVA6v8VQABADz/7ASbBhUAJgBzALAARViwIS8bsSEePlmwAEVYsB0vG7EdGD5ZsABFWLAYLxuxGBA+WbAARViwCi8bsQoQPlmwHRCwENCwJdCyAQEKK1gh2Bv0WbAKELIFAQorWCHYG/RZsAEQsA7QsCEQshUBCitYIdgb9FmwDhCwGtAwMQEjERQWMzI3FwYjIiY1ESM1MxEmJyciFREjESM1MzU0NjMyFhcRMwSWyjZBIzQBSUZ8fsXFPWYYt7mrq7OgXdtaygOr/WFBQQyWFJaKAp+PAR8cBwHd+2ADq49wrb45LP6KAAABAF//7AZUBhEATAC5shZNThESOQCwAEVYsEcvG7FHHj5ZsABFWLAPLxuxDxg+WbAARViwSy8bsUsYPlmwAEVYsEAvG7FAGD5ZsABFWLAJLxuxCRA+WbAARViwLC8bsSwQPlmwSxCyAQEKK1gh2Bv0WbAJELIEAQorWCHYG/RZsAEQsA3QsEcQshQBCitYIdgb9FmwQBCyIAEKK1gh2Bv0WbI6LEAREjmwOhCyJQEKK1gh2Bv0WbAsELI0AQorWCHYG/RZMDEBIxEUMzI3FwYjIiY1ESM1MzU0JiMiBhUUHgIVIzQmIyIGFRQWBBYWFRQGIyImJjUzFhYzMjY1NCYkJiY1NDYzMhcmNTQ2MzIWFRUzBk/KdyM0AU1CdoS8vGZiWFwfJR66gWJlcmoBFaxT6LmCyHG5BYtyaX9x/uelT+GvYFYsypu5ycoDq/1+nwyWFKaXAoKPVXJ1WEY7aXB8TExuWEdDRD5WeVeRr1ylYF1tVUdLUzxUdFCFuB5uUnylx8NNAAAWAFv+cgfuBa4ADQAaACgANwA9AEMASQBPAFYAWgBeAGIAZgBqAG4AdgB6AH4AggCGAIoAjgG+shCPkBESObAQELAA0LAQELAb0LAQELAw0LAQELA80LAQELA+0LAQELBG0LAQELBK0LAQELBQ0LAQELBX0LAQELBb0LAQELBh0LAQELBj0LAQELBn0LAQELBt0LAQELBw0LAQELB30LAQELB70LAQELB/0LAQELCE0LAQELCI0LAQELCM0ACwPS+wAEVYsEYvG7FGHD5Zsn5JAyuyensDK7KCdwMrsn86AyuyCj1GERI5sAovsAPQsAMvsA7QsA4vsAoQsA/QsA8vslAODxESObBQL7JvBworWCHYG/RZshVQbxESObAKELIeBworWCHYG/RZsAMQsiUHCitYIdgb9FmwDxCwKdCwKS+wDhCwLtCwLi+yNAcKK1gh2Bv0WbA9ELI8CgorWCHYG/RZsD0QsGvQsGfQsGPQsD7QsDwQsGzQsGjQsGTQsD/QsDoQsEHQsEYQsGDQsFzQsFjQsEvQskoKCitYIdgb9FmwWtCwXtCwYtCwR9CwSRCwTtCwDhCyUQcKK1gh2Bv0WbAPELJ2BworWCHYG/RZsHcQsITQsHoQsIXQsHsQsIjQsH4QsInQsH8QsIzQsIIQsI3QMDEBFAYjIiYnNTQ2MzIWFxMRMzIWFRQHFhYVFCMBNCYjIgYVFRQWMzI2NQEzERQGIyImNTMUMzI2NQERMxUzFSE1MzUzEQERIRUjFSU1IREjNQEVMzI1NCcTNSEVITUhFSE1IRUBNSEVITUhFSE1IRUTMzI1NCYjIwEjNTM1IzUzESM1MyUjNTM1IzUzESM1MwM5gWRmgAJ+aGWAAkO8YnJUMjTQ/o9KQUBKSkJASQO6XGlSWG1daCk2+cRxxAUox2/4bQE1xAXsATZv/Fx+Z2LLARb9WwEV/VwBFAIKARb9WwEV/VwBFLxddjo8XfzxcXFxcXFxByJvb29vb28B1GJ5eF51X3x4Xv6zAiVJTVQgDUYtmwFIRU5ORXBFTk5FAU/+hk5dUVNbNiz8yQE7ynFxyv7FBh8BHXSpqXT+46n8tqlTUgQDSnR0dHR0dPk4cXFxcXFxA8RQKR7+0/x++vwV+X78fvr8FfkABQBc/dUH1whzAAMAHAAgACQAKABSsxEPEAQrswQPHAQrswoPFwQrsAQQsB3QsBwQsB7QALAhL7AlL7IcHgMrsCUQsADQsAAvsCEQsALQsAIvsg0AAhESObANL7IfHgIREjmwHy8wMQkDBTQ2NzY2NTQmIyIGBzM2NjMyFhUUBwYGFRcjFTMDMxUjAzMVIwQYA7/8QfxEBA8eJEpcp5WQoALLAjorOThdWy/KyspLBAQCBAQGUvwx/DEDz/E6Ohgnh0qAl4t/MzRANF88QVxMW6r9TAQKngQAAQA7AAAD0gWwAAYAMgCwAEVYsAUvG7EFHD5ZsABFWLABLxuxARA+WbAFELIDAQorWCHYG/RZsgADBRESOTAxAQEjASE1IQPS/b66AkD9JQOXBUj6uAUYmAAAAgBa/+wERAROABAAHAA2ALAARViwBC8bsQQYPlmwAEVYsAwvG7EMED5ZshQBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyABUVFAYGIyImJic3FBYzMjY1NCYjIgZagOOQ3QEafuWSj+OBArmvjY6usY2LrwInnP+M/sz7Dp38jIj5mgqw3uDEr+DeAAAB/7b+SwFnAJgADAAnALANL7AARViwBC8bsQQSPlmyCQEKK1gh2Bv0WbANELAM0LAMLzAxJRUGBiMiJzcWMzI1NQFnAaqXOzQOHkOJmPWosBKdDcLpAAEAZ/6ZASEAmQADABIAsAQvsALQsAIvsAHQsAEvMDEBIxEzASG6uv6ZAgAAAgCDBNkC0gbQAA0AIQB7ALADL7AH0LAHL0ANDwcfBy8HPwdPB18HBl2wAxCyCgQKK1gh2Bv0WbAHELAN0LANL7AHELAR0LARL7AU0LAUL0ALDxQfFC8UPxRPFAVdsBEQsBfQsBcvsBQQshsECitYIdgb9FmwERCyHgQKK1gh2Bv0WbAbELAh0DAxARQGIyImNTMUFjMyNjUTFAYjIiYjIgYVJzQ2MzIWMzI2NQLSoYaHoZZKSEdKjWBGOncsIjBTYEUwgSwjMAWuX3Z2XzZAQDYBCkppSzMmFUtrSzMmAAACAIEE4ALKBwMADQAcAGUAsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsA7QsA4vsBXQsBUvQA8PFR8VLxU/FU8VXxVvFQddsBTQsg8UDhESObIbDhUREjkwMQEUBiMiJjUzFBYzMjY1Jyc2NjU0IzcyFhUUBgcHAsqhg4ShkkpJRUzJAUpCoAeQlFFEAQWwXnJzXTU+PTYRfAQYHTtSTkIyOwc+AAACAIEE3wLgBooADQARAF8AsAMvsAfQsAcvQA0PBx8HLwc/B08HXwcGXbADELIKBAorWCHYG/RZsAcQsA3QsA0vsAcQsBDQsBAvsA/QsA8vQA8PDx8PLw8/D08PXw9vDwddsBAQsBHQGbARLxgwMQEUBiMiJjUzFBYzMjY1JzMHIwLgqIeIqJhPSUdPYJmkZgWwX3JyXzc9PzXaxgACAGkE5ANGBtQABgAaAIUAsAMvsAHQsAEvsAbQsAYvQAkPBh8GLwY/BgRdsgQDBhESORmwBC8YsADQsgIGARESObAGELAK0LAKL7Q/Ck8KAl2wDdCwDS9ADQ8NHw0vDT8NTw1fDQZdsAoQsBDQsBAvsA0QshQECitYIdgb9FmwChCyFwQKK1gh2Bv0WbAUELAa0DAxASMnByMlMzcUBiMiJiMiBhUnNDYzMhYzMjY1A0aqxcWpAS2Dw2BBNm4oHTZNYEAqfCYfNATknp705T5eRy4dEz9iRi0cAAIAaQTkA+wGzwAGABUAYQCwAy+wBdCwBS+2DwUfBS8FA12yBAMFERI5GbAELxiwANCwAxCwAdCwAS+yAgUDERI5sAfQsAcvsA7QsA4vQA0PDh8OLw4/Dk8OXw4GXbAN0LIIBw0REjmyFA4HERI5MDEBIycHIwEzFyc2NjU0IzcyFhUUBgcHA0aqxcWpARC8vgFBO40FgIZKPAEE5Lq6AQZ8gwQaIUNcWEk7Qgc8AAL/XgTPA0YGggAGAAoAXQCwAy+yDwMBXbAE0BmwBC8YsADQGbAALxiwAxCwAdCwAS+wBtCwBi+2DwYfBi8GA12yAgMGERI5sAMQsAjQsAgvsAfQGbAHLxiwCBCwCtCwCi+2DwofCi8KA10wMQEjJwcjATMFIwMzA0bFqqrEASKY/o+MyMcEz56eAQZVAQIAAAIAbgThBFgGlQAGAAoAXQCwAy+yDwMBXbAF0LAFL7AA0LAAL7YPAB8ALwADXbADELAC0BmwAi8YsgQDABESObAG0BmwBi8YsAMQsAnQsAkvsAfQsAcvtg8HHwcvBwNdsAkQsArQGbAKLxgwMQEzASMnByMBMwMjAZKYASLFqarGAyLIyY0F6P75n58BtP79AAIAgQTfAuAGigANABEAXwCwAy+wB9CwBy9ADQ8HHwcvBz8HTwdfBwZdsAMQsgoECitYIdgb9FmwBxCwDdCwDS+wBxCwEdCwES+wD9CwDy9ADw8PHw8vDz8PTw9fD28PB12wERCwENAZsBAvGDAxARQGIyImNTMUFjMyNjUlMxcjAuCoh4iomE9JR0/+pppwZQWwX3JyXzc9PzXaxgAAAQCfBI4BlgY7AAgADACwAC+wBNCwBC8wMQEXBgcVIzU0NgErazsDuVQGO1Njb4iCTa0AAAIAEwAABHAEjQAHAAoARgCwAEVYsAQvG7EEGj5ZsABFWLACLxuxAhA+WbAARViwBi8bsQYQPlmyCQQCERI5sAkvsgABCitYIdgb9FmyCgQCERI5MDEBIQMjATMBIwEhAwNG/fhuvQHfpgHYvP3GAZHHARf+6QSN+3MBrgH9AAMAigAAA+8EjQAOABYAHgBoALAARViwAS8bsQEaPlmwAEVYsAAvG7EAED5ZshcAARESObAXL7K/FwFdtB8XLxcCXbTfF+8XAl2yDwEKK1gh2Bv0WbIIDxcREjmwABCyEAEKK1gh2Bv0WbABELIeAQorWCHYG/RZMDEzESEyFhUUBgcWFhUUBgcBESEyNjU0IyUzMjY1NCcjigGW0d5fWGN02sn+9wEGc3rr/vjqbHzl7QSNo5tRfiEYlWWergECEv6FYlXEjVVTqAUAAAEAYP/wBDAEnQAcAEyyAx0eERI5ALAARViwCy8bsQsaPlmwAEVYsAMvG7EDED5ZsAsQsA/QsAsQshIBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WbADELAc0DAxAQYGIyIAETU0NjYzMhYXIyYmIyIGBxUUFjMyNjcEMBT80eD+8XvnmMz3E7kSjX6ZpwGfl4eNFAF5u84BJwEDXqT5iNO7gnTLvWq9z2+DAAIAigAABB8EjQAKABQARrICFRYREjmwAhCwFNAAsABFWLABLxuxARo+WbAARViwAC8bsQAQPlmwARCyCwEKK1gh2Bv0WbAAELIMAQorWCHYG/RZMDEzESEyFhYXFRQAIQMRMzI2NTU0JiOKAWmi+4wD/sn++Z6kusa9twSNhfafTfz+1gP0/KPQwEDAzQABAIoAAAOuBI0ACwBUALAARViwBi8bsQYaPlmwAEVYsAQvG7EEED5ZsAvQsAsvst8LAV2yHwsBXbIAAQorWCHYG/RZsAQQsgIBCitYIdgb9FmwBhCyCAEKK1gh2Bv0WTAxASERIRUhESEVIREhA1f97AJr/NwDHv2bAhQCDv6JlwSNmf6yAAEAigAAA5sEjQAJAEEAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmwCdCwCS+yHwkBXbIAAQorWCHYG/RZsAQQsgYBCitYIdgb9FkwMQEhESMRIRUhESEDS/34uQMR/agCCAHz/g0EjZn+mAAAAQBj//AENQSdAB0AX7IKHh8REjkAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmyHQoDERI5sB0vsg0dChESObAKELIQAQorWCHYG/RZsAMQshcBCitYIdgb9FmwHRCyGgMKK1gh2Bv0WTAxJQYGIyIAJzUQADMyFhcjJiMiBhUVFBYzMjc1ITUhBDVC6Zfu/uACAQvyyPIbuCb1n6a5oLZR/ucB0ZZTUwEq/FoBBgEnvLXZzsdUvtdK7pAAAAEAigAABFgEjQALAFMAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIJAAoREjl8sAkvGLKjCQFdsgIBCitYIdgb9FkwMSEjESERIxEzESERMwRYuf2kubkCXLkB8v4OBI39/QIDAAABAJcAAAFRBI0AAwAdALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZMDEhIxEzAVG6ugSNAAABACv/8ANNBI0ADwA1sgUQERESOQCwAEVYsAAvG7EAGj5ZsABFWLAFLxuxBRA+WbAJ0LAFELIMAQorWCHYG/RZMDEBMxEUBiMiJjUzFBYzMjY1ApK71LHC27pxclxuBI38xZ3Ft6ReZm1fAAABAIoAAARXBI0ADABMALAARViwBC8bsQQaPlmwAEVYsAgvG7EIGj5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAIIERI5sgYCBBESObIKAggREjkwMQEHESMRMxE3ATMBASMB1pO5uYIBjeP+IQIB4QIHjv6HBI391ZABm/35/XoAAAEAigAAA4sEjQAFACgAsABFWLAELxuxBBo+WbAARViwAi8bsQIQPlmyAAEKK1gh2Bv0WTAxJSEVIREzAUMCSPz/uZeXBI0AAAEAigAABXcEjQAOAGCyAQ8QERI5ALAARViwAC8bsQAaPlmwAEVYsAIvG7ECGj5ZsABFWLAELxuxBBA+WbAARViwCC8bsQgQPlmwAEVYsAwvG7EMED5ZsgEABBESObIHAAQREjmyCgAEERI5MDEJAjMRIxETASMBExEjEQF6AYcBhfG4E/5yiP5zE7gEjfxxA4/7cwGRAhX8WgOi/e/+bwSNAAEAigAABFgEjQAJAEUAsABFWLAFLxuxBRo+WbAARViwCC8bsQgaPlmwAEVYsAAvG7EAED5ZsABFWLADLxuxAxA+WbICBQAREjmyBwUAERI5MDEhIwERIxEzAREzBFi4/aO5uQJduANs/JQEjfyTA20AAAIAYP/wBFoEnQANABsARrIDHB0REjmwAxCwEdAAsABFWLAKLxuxCho+WbAARViwAy8bsQMQPlmwChCyEQEKK1gh2Bv0WbADELIYAQorWCHYG/RZMDEBEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1BFr+7Ojl/ucBF+XpARMCt6yblq+wl5ypAiT++/7RATIBBz4BAgE0/tD/BcbS1sVCw9fTxwACAIoAAAQbBI0ACgATAE2yChQVERI5sAoQsAzQALAARViwAy8bsQMaPlmwAEVYsAEvG7EBED5ZsgsDARESObALL7IAAQorWCHYG/RZsAMQshIBCitYIdgb9FkwMQERIxEhMhYVFAYjJSEyNjU0JichAUO5AdPM8urW/ugBGnyIiHf+4QG2/koEjceoqr6YamRgdwEAAgBZ/zYEVwSdABMAIQBNsggiIxESObAIELAe0ACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIDCBAREjmwEBCyFwEKK1gh2Bv0WbAIELIeAQorWCHYG/RZMDEBFAYHFwclBiMiABE1NBI2MzIAESc0JiMiBgcVFBYzMjY1BFVwZth8/vk2RuT+5X/oluoBFbesnJSsBK6YnKoCJKbzRqBvxw0BMQEIPqkBA4r+zf75BsbSz7lVwtjTxwACAIoAAAQlBI0ADQAWAGGyFRcYERI5sBUQsAXQALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsABFWLAMLxuxDBA+WbIPBAIREjmwDy+yAAEKK1gh2Bv0WbIKAAQREjmwBBCyFQEKK1gh2Bv0WTAxASERIxEhMhYVFAcBFSMBMzI2NTQmIyMCWv7puQGq1efrASDG/eT2dYmGfvABwf4/BI26quRZ/h4KAlhtXWRuAAEAQ//wA90EnQAlAFoAsABFWLAJLxuxCRo+WbAARViwHC8bsRwQPlmyAhwJERI5sAkQsA3QsAkQshABCitYIdgb9FmwAhCyFgEKK1gh2Bv0WbAcELAg0LAcELIjAQorWCHYG/RZMDEBNCYkJyY1NDYzMhYVIzQmIyIGFRQWBBYWFRQGIyIkNTMUFjMyNgMjef7aVsPzv8T5uY15cYZ7ATiwVvPHz/7vupqMfoIBKlBYSitis4+yyJxia1lQQVhQZYhbk6nLomZyWwABACgAAAP9BI0ABwAuALAARViwBi8bsQYaPlmwAEVYsAIvG7ECED5ZsAYQsgABCitYIdgb9FmwBNAwMQEhESMRITUhA/3+cbn+cwPVA/T8DAP0mQABAHT/8AQKBI0AEQA8sgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBo+WbAARViwBC8bsQQQPlmyDQEKK1gh2Bv0WTAxAREUBiMiJicRMxEUFjMyNjURBAr60dL2A7ePhYOPBI389Lbb07YDFPz0eYF/ewMMAAEAFAAABFMEjQAIADEAsABFWLADLxuxAxo+WbAARViwBy8bsQcaPlmwAEVYsAUvG7EFED5ZsgEDBRESOTAxARc3ATMBIwEzAhoZGgFAxv43rf43xwEkXlwDa/tzBI0AAAEAMQAABfEEjQASAGCyDhMUERI5ALAARViwAy8bsQMaPlmwAEVYsAgvG7EIGj5ZsABFWLARLxuxERo+WbAARViwCi8bsQoQPlmwAEVYsA8vG7EPED5ZsgEDChESObIGAwoREjmyDQMKERI5MDEBFzcTMxMXNxMzASMBJwcBIwEzAa8LD/il9A0Mxrj+1q7+/AEB/vSt/te3ASZQQAN3/IY7UANl+3MDlQUF/GsEjQAAAQAmAAAEMQSNAAsAUwCwAEVYsAEvG7EBGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmwAEVYsAcvG7EHED5ZsgABBBESObIGAQQREjmyAwAGERI5sgkGABESOTAxAQEzAQEjAQEjAQEzAigBH9z+dQGZ3P7V/tjcAZb+c9sC2gGz/b79tQG7/kUCSwJCAAABAA0AAAQcBI0ACAAxALAARViwAS8bsQEaPlmwAEVYsAcvG7EHGj5ZsABFWLAELxuxBBA+WbIAAQQREjkwMQEBMwERIxEBMwIUATjQ/lK5/ljQAkoCQ/0K/mkBogLrAAABAEcAAAPgBI0ACQBEALAARViwBy8bsQcaPlmwAEVYsAIvG7ECED5ZsgABCitYIdgb9FmyBAACERI5sAcQsgUBCitYIdgb9FmyCQUHERI5MDElIRUhNQEhNSEVAS8CsfxnApj9cQN4l5d8A3iZeQAAAgBQ//UCnQMgAA0AFwBGsgMYGRESObADELAQ0ACwAEVYsAovG7EKFj5ZsABFWLADLxuxAxA+WbAKELIQAgorWCHYG/RZsAMQshUCCitYIdgb9FkwMQEUBiMiJic1NDYzMhYXJzQjIgcVFDMyNwKdmI2LnAGbi42YAp2KhQSLhAQBRaKurKCOo66snQfAtLPCtQABAHoAAAHvAxUABgA1ALAARViwBS8bsQUWPlmwAEVYsAEvG7EBED5ZsgQFARESObAEL7IDAgorWCHYG/RZsALQMDEhIxEHNSUzAe+d2AFjEgJZOYB1AAEAQgAAAqsDIAAWAFSyCBcYERI5ALAARViwDi8bsQ4WPlmwAEVYsAAvG7EAED5ZshUCCitYIdgb9FmwAtCyFBUOERI5sgMOFBESObAOELIIAgorWCHYG/RZsA4QsAvQMDEhITUBNjU0JiMiBhUjNDYgFhUUDwIhAqv9qQEsbUA8S0edpwEImmtUsAGPbAEaZkUxPUw5cpR/bmhrT5EAAQA+//UCmgMgACYAcQCwAEVYsA4vG7EOFj5ZsABFWLAZLxuxGRA+WbIAGQ4REjl8sAAvGLaAAJAAoAADXbAOELIHAgorWCHYG/RZsgoABxESObAAELImAgorWCHYG/RZshQmABESObAZELIgAgorWCHYG/RZsh0mIBESOTAxATMyNjU0JiMiBhUjNDYzMhYVFAYHFhUUBiMiJjUzFBYzMjY1NCcjAQlUSkg/RjlLnaN8iZxGQpWqiISmnk9DRkmcWAHLPTAtOjMpYnt5aDdbGSmPan1+ay08PDNxAgAAAgA2AAACuwMVAAoADgBJALAARViwCS8bsQkWPlmwAEVYsAQvG7EEED5ZsgEJBBESObABL7ICAgorWCHYG/RZsAbQsAEQsAvQsggLBhESObINCQQREjkwMQEzFSMVIzUhJwEzATMRBwJQa2ud/okGAXmh/oTfEQErgqmpZgIG/hYBIRwAAQBb//UCpwMVABsAYQCwAEVYsAEvG7EBFj5ZsABFWLANLxuxDRA+WbABELIECQorWCHYG/RZsgcNARESObAHL7IZAgorWCHYG/RZsgUHGRESObANELAR0LANELITAgorWCHYG/RZsAcQsBvQMDETEyEVIQc2MzIWFRQGIyImJzMWMzI2NTQmIyIHcDIB3v6jFkFKgI+ghnmnBpsKgUFITkpJOwGDAZKEqh2JeXyRfmVjS0Q+TSsAAAIAVv/1AqsDHgATAB8ATgCwAEVYsAAvG7EAFj5ZsABFWLAMLxuxDBA+WbAAELIBAgorWCHYG/RZsgYMABESObAGL7IUAgorWCHYG/RZsAwQshsCCitYIdgb9FkwMQEVIwQHNjMyFhUUBiMiJjU1NDY3AyIGBxUUFjMyNjQmAigR/vQXSHJ2h5+Ei6fezX4zTRFTPz1ORwMegwLbTZF3dJqmlzPQ5AX+biwgIlRVT3xMAAABADoAAAKlAxUABgAyALAARViwBS8bsQUWPlmwAEVYsAIvG7ECED5ZsAUQsgQCCitYIdgb9FmyAAUEERI5MDEBASMBITUhAqX+o6YBXf47AmsCu/1FApOCAAADAE//9QKfAyAAEwAeACgAegCwAEVYsBEvG7ERFj5ZsABFWLAGLxuxBhA+WbIkBhEREjmwJC+23yTvJP8kA122DyQfJC8kA12y/yQBcbQPJB8kAnKyFwIKK1gh2Bv0WbICJBcREjmyDBckERI5sAYQsh0CCitYIdgb9FmwERCyHwIKK1gh2Bv0WTAxARQHFhUUBiAmNTQ2NyY1NDYzMhYDNCYjIgYVFBYyNgMiBhUUFjI2NCYCi3eLoP7woEpAd5d9fpeJTj4/S0x+TIw3Pz9wP0ACQ3Y3O4NqeXlqQmEbN3Zndnb+OjQ6OjQ1OjoB8DUwLjg4XDcAAAIASf/5ApUDIAASAB4AWgCwAEVYsAgvG7EIFj5ZsABFWLAPLxuxDxA+WbICDwgREjmwAi+2DwIfAi8CA12wDxCyEAIKK1gh2Bv0WbACELITAgorWCHYG/RZsAgQshkCCitYIdgb9FkwMQEGIyImNTQ2MzIWFxUQBQc1MjYnMjc1NCYjIgYVFBYB9kVldo2jgYmcA/5zN5aEe14qTzw7TEoBQEGKfnmgpZQ9/mQUAX9inkc8U1BUQ0FOAAEAjwKLAwsDIgADABEAsAIvsgEBCitYIdgb9FkwMQEhNSEDC/2EAnwCi5cAAwCeBEACbgZyAAMADwAbAHIAsABFWLANLxuxDRg+WbAH0LAHL0AJPwdPB18HbwcEXbAC0LACL7Y/Ak8CXwIDXbAA0LAAL0ARDwAfAC8APwBPAF8AbwB/AAhdsAIQsAPQGbADLxiwDRCyEwcKK1gh2Bv0WbAHELIZBworWCHYG/RZMDEBMwcjBzQ2MzIWFRQGIyImNxQWMzI2NTQmIyIGAbG93HKCZEhEY2FGSGRVMyQjMDAjJTIGcrjXRmFeSUdcXkUjMjEkJjI0AAMAHv5KBBEETgApADcARACPALAARViwJi8bsSYYPlmwAEVYsBYvG7EWEj5ZsCYQsCnQsCkvsgADCitYIdgb9FmyCBYmERI5sAgvsg4IFhESObAOL7SQDqAOAl2yNwEKK1gh2Bv0WbIcNw4REjmyIAgmERI5sBYQsjABCitYIdgb9FmwCBCyOwEKK1gh2Bv0WbAmELJCAQorWCHYG/RZMDEBIxYXFRQGBiMiJwYVFBczFhYVFAYGIyImNTQ2NyY1NDcmNTU0NjMyFyEBBgYVFBYzMjY1NCYnIwMUFjMyNjU1NCYiBhUEEZc6AW/DeE9JNHq3yM6N9JfR/15UOHOu8btQRwFv/Tw4PJSDks1obO90jGlniorSigOnVGkZYqZeFSpAUAIBlY9UoWCbelOKKi9KfFJqxQudyhT7+BpdN0pZckxKQQICpVN7elgSV3h4WgAAAgBk/+sEWAROABAAHABhALAARViwCS8bsQkYPlmwAEVYsAwvG7EMGD5ZsABFWLACLxuxAhA+WbAARViwEC8bsRAQPlmyAAIJERI5sgsJAhESObACELIUAQorWCHYG/RZsAkQshoBCitYIdgb9FkwMSUCISICNTUQEjMgEzczAxMjARQWMzITNSYmIyIGA4Js/vLA5OLEAQlsIrBqcbD9dZKH00gckmuGlfH++gEb9A8BCAE9/v/t/eL95AH0r8MBhyS+y+MAAgCxAAAE4wWvABYAHgBhshgfIBESObAYELAE0ACwAEVYsAMvG7EDHD5ZsABFWLABLxuxARA+WbAARViwDy8bsQ8QPlmyFwMBERI5sBcvsgABCitYIdgb9FmyCRcAERI5sAMQsh0BCitYIdgb9FkwMQERIxEhMhYVFAcWExUWFxUjJic1NCYjJSEyNjUQISEBcsECDvD77d4FAkHGOwOMf/6eATminf7P/rkCdP2MBa/SzOVjRf76nI09GDasi3iPnXyEAQAAAQCyAAAFHQWwAAwAaACwAEVYsAQvG7EEHD5ZsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YtGMGcwYCXbQzBkMGAl2ykwYBXbIBAQorWCHYG/RZsgoBBhESOTAxASMRIxEzETMBMwEBIwIjscDAlgH97/3UAlXrAo79cgWw/X4Cgv0+/RIAAAEAkgAABBQGAAAMAFMAsABFWLAELxuxBB4+WbAARViwCC8bsQgYPlmwAEVYsAIvG7ECED5ZsABFWLALLxuxCxA+WbIHCAIREjmwBy+yAAEKK1gh2Bv0WbIKAAcREjkwMQEjESMRMxEzATMBASMBzIC6un4BO9v+hgGu2wH1/gsGAPyOAaz+E/2zAAEAsgAABPoFsAALAEwAsABFWLADLxuxAxw+WbAARViwBy8bsQccPlmwAEVYsAEvG7EBED5ZsABFWLAKLxuxChA+WbIAAwEREjmyBQMBERI5sgkABRESOTAxAREjETMRMwEzAQEjAXLAwAwCY/H9awK97QK1/UsFsP15Aof9O/0VAAABAJIAAAPxBhgADABMALAARViwBC8bsQQePlmwAEVYsAgvG7EIGD5ZsABFWLACLxuxAhA+WbAARViwCy8bsQsQPlmyAAgCERI5sgYIAhESObIKBgAREjkwMQEjESMRMxEzATMBASMBUAS6ugEBivD+KwH/5AHz/g0GGPx1Aa3+Df25AAABAEP/EwPdBXMAKwBmALAARViwCS8bsQkaPlmwAEVYsCIvG7EiED5ZsgIiCRESObAJELAM0LAJELAQ0LAJELITAQorWCHYG/RZsAIQshkBCitYIdgb9FmwIhCwH9CwIhCwJtCwIhCyKQEKK1gh2Bv0WTAxATQmJCcmNTQ2NzUzFRYWFSM0JiMiBhUUFgQWFhUUBgcVIzUmJjUzFBYzMjYDI3n+2lbDy6aVo8a5jXlxhnsBOLBWw6mVut+6mox+ggEqUFhKK2KzgqwQ2dsVwohia1lQQVhQZYhbgqYQ4eETwpRmclsAAAEAMAAAA+8EnQAgAGAAsABFWLAULxuxFBo+WbAARViwBy8bsQcQPlmyDwcUERI5sA8vsg4ECitYIdgb9FmwAdCwBxCyBAEKK1gh2Bv0WbAI0LAUELAY0LAUELIbAQorWCHYG/RZsA8QsB/QMDEBIRcWByEHITUzNjc3JyM1MycmNjMyFhUjNCYjIgYXFyEDHf5wAQU4ApQB/IQKTwkBAaSgBAbLtbfKuWhgXWgEBAGUAfQiy2+YmBfdRiJ5e8nszLdwd4+KewAAAQAWAAAEJQSNABcAigCwAEVYsBcvG7EXGj5ZsABFWLABLxuxARo+WbAARViwDS8bsQ0QPlmyAA0XERI5shANFxESObAQL7IPEAFdsBTQsBQvtA8UHxQCcUAPDxQfFC8UPxRPFF8UbxQHXbAD0LAUELITBAorWCHYG/RZsAbQsBAQsAjQsBAQsg8ECitYIdgb9FmwC9AwMQEBMwEzFSEHFSEVIRUjNSE1ITUhNSEBMwIdATjQ/pv7/sEFAUT+vLn+vAFE/rwBAP6c0AJLAkL9jHkJQnjd3XhLeQJ0AAEAigAAA4UEjQAFADKyAQYHERI5ALAARViwBC8bsQQaPlmwAEVYsAIvG7ECED5ZsAQQsgABCitYIdgb9FkwMQEhESMRIQOF/b65AvsD9PwMBI0AAAIAFAAABFMEjQADAAgAPLIFCQoREjmwBRCwAtAAsABFWLACLxuxAho+WbAARViwAC8bsQAQPlmyBQIAERI5sgcBCitYIdgb9FkwMSEhATMDJwcBIQRT+8EBya09Ghn++AJDBI3+3Vxe/TAAAAMAYP/wBFoEnQADABEAHwBeALAARViwDi8bsQ4aPlmwAEVYsAcvG7EHED5ZsgIHDhESOXywAi8YtGACcAICcbRgAnACAl2yAQEKK1gh2Bv0WbAOELIVAQorWCHYG/RZsAcQshwBCitYIdgb9FkwMQEhNSEFEAAjIgARNRAAMzIAFwc0JiMiBhUVFBYzMjY1A1X+HwHhAQX+7Ojl/ucBF+XpARMCt6yblq+wl5ypAfmZbv77/tEBMgEHPgECATT+0P8FxtLWxULD19PHAAEAFAAABFMEjQAIADiyBwkKERI5ALAARViwAi8bsQIaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbIHAgAREjkwMTMjATMBIwEnB9vHAcmtAcnG/sAaGQSN+3MDalxeAAADAD4AAANLBI0AAwAHAAsAY7IEDA0REjmwBBCwAdCwBBCwCdAAsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyAgEKK1gh2Bv0WbIHCgAREjmwBy+yvwcBXbIEAQorWCHYG/RZsAoQsggBCitYIdgb9FkwMSEhNSEDITUhEyE1IQNL/PMDDUP9dwKJQ/zzAw2YAXuYAUmZAAEAigAABEQEjQAHAD+yAQgJERI5ALAARViwBi8bsQYaPlmwAEVYsAAvG7EAED5ZsABFWLAELxuxBBA+WbAGELICAQorWCHYG/RZMDEhIxEhESMRIQREuv25uQO6A/T8DASNAAABAD8AAAPIBI0ADABDsgYNDhESOQCwAEVYsAgvG7EIGj5ZsABFWLADLxuxAxA+WbIBAQorWCHYG/RZsAXQsAgQsgoBCitYIdgb9FmwB9AwMQEBIRUhNQEBNSEVIQECb/62AqP8dwFR/q8DV/2PAUoCOv5fmZABtwG2kJn+XwADAGAAAAUGBI0AEQAXAB4AXACwAEVYsBAvG7EQGj5ZsABFWLAILxuxCBA+WbIPEAgREjmwDy+wANCyCQgQERI5sAkvsAbQsAkQshQBCitYIdgb9FmwDxCyFQEKK1gh2Bv0WbAb0LAUELAc0DAxARYEFRQEBxUjNSYkNTQkNzUzARAFEQYGBTQmJxE2NgMQ5gEQ/u3juen+8gEQ57n+CAE/mqUDNqaYmKYEFg36y838DW5uDfvMzfsNdv21/tgRAnMJl5iZlQn9jgqWAAABAGAAAAS2BI0AFQBcsgAWFxESOQCwAEVYsAMvG7EDGj5ZsABFWLAPLxuxDxo+WbAARViwFC8bsRQaPlmwAEVYsAkvG7EJED5ZshMDCRESObATL7AA0LATELILAQorWCHYG/RZsAjQMDEBJBERMxEGAgcRIxEmAicRMxEQBREzAugBFbkD8tm62fAFugEUugG7MwFrATT+vfP+4hj+3wEfFAEd8gFL/sv+ji0C1AABAHUAAAR+BJ0AIQBcsgciIxESOQCwAEVYsBgvG7EYGj5ZsABFWLAPLxuxDxA+WbAARViwIC8bsSAQPlmwDxCyEQEKK1gh2Bv0WbAO0LAA0LAYELIHAQorWCHYG/RZsBEQsB7QsB/QMDElNjY1NTQmIyIGFRUUFhcVITUzJhE1NAAzMgAVFRAHMxUhAruIf66dnKyNf/4+r7MBG+foARyytf49nR/fzSazwMG3IczfIJ2XnQE6Hu4BI/7c9Rz+y5yXAAEAJv/sBSwEjQAZAGuyFhobERI5ALAARViwAi8bsQIaPlmwAEVYsA4vG7EOED5ZsABFWLAYLxuxGBA+WbACELIAAQorWCHYG/RZsATQsAXQsggCDhESObAIL7AOELIPAQorWCHYG/RZsAgQshUBCitYIdgb9FkwMQEhNSEVIRE2MzIWFRQGIzUyNjU0JiMiBxEjAYr+nAOJ/pSXnNTi5eCNf32AnZa5A/SZmf7XMdDEvr6XbXiDeTL9zgAAAQBg//AEMASdAB4AfbIDHyAREjkAsABFWLALLxuxCxo+WbAARViwAy8bsQMQPlmyDwsDERI5sAsQshIBCitYIdgb9FmyFgsDERI5fLAWLxiyoBYBXbRgFnAWAl2yMBYBcbRgFnAWAnGyFwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsh4DCxESOTAxAQYGIyIAETU0NjYzMhYXIyYmIyIGByEVIRYWMzI2NwQwFPzR4P7xe+eYzPcTuRKNfpmiBgG//kEEoZGHjRQBebvOAScBA16k+YjTu4J0w6+YssJvgwACACcAAAb7BI0AFwAgAHayBCEiERI5sAQQsBjQALAARViwEi8bsRIaPlmwAEVYsAMvG7EDED5ZsABFWLALLxuxCxA+WbASELIFAQorWCHYG/RZsAsQsg4BCitYIdgb9FmyFBIDERI5sBQvshgBCitYIdgb9FmwAxCyGQEKK1gh2Bv0WTAxARQGByERIQMOAgcjNzc2NhMTIREhFhYlESEyNjU0JiMG++bD/iv+Xg8LTZd7OwQuYFEKFAMOASTB4P07ARVyhINzAW6lxwID9P5l7fZ1AaUBBL4BCQIc/koEwS3+WXVjX3AAAgCKAAAHCQSNABIAGwCJsgEcHRESObABELAT0ACwAEVYsAIvG7ECGj5ZsABFWLARLxuxERo+WbAARViwCy8bsQsQPlmwAEVYsA8vG7EPED5ZsgECCxESOXywAS8YsqABAV2yBAILERI5sAQvsAEQsg0BCitYIdgb9FmwBBCyEwEKK1gh2Bv0WbALELIUAQorWCHYG/RZMDEBIREzESEWFhUUBgchESERIxEzAREhMjY1NCYnAUMCSLkBJMHg5sP+K/24ubkDAQEVc4R9bgKKAgP+SgTBpKXHAgHy/g4Ejf2y/ll3YVtxAwAAAQAoAAAFLgSNABUAWrIHFhcREjkAsABFWLACLxuxAho+WbAARViwDC8bsQwQPlmwAEVYsBQvG7EUED5ZsAIQsgABCitYIdgb9FmwBNCwBdCyCAIMERI5sAgvshEBCitYIdgb9FkwMQEhNSEVIRE2MzIWFxEjETQmIyIHESMBi/6dA4n+lJOg1N4Eun1/nZa6A/SZmf7XMcrB/o8BZId5Mv3OAAABAIr+mwRDBI0ACwBPsgMMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsggBCitYIdgb9FmwCdAwMSEhESMRIREzESERMwRD/oG5/n+5Ake5/psBZQSN/AsD9QACAIoAAAQIBI0ADAAVAF6yAxYXERI5sAMQsA3QALAARViwCy8bsQsaPlmwAEVYsAkvG7EJED5ZsAsQsgABCitYIdgb9FmyAwsJERI5sAMvsAkQsg0BCitYIdgb9FmwAxCyEwEKK1gh2Bv0WTAxASERITIWFRQGByERIQEyNjU0JichEQOV/a4BEc7m5MX+KwML/sNzhH1u/t8D9/7gxKWkyAIEjfwLd2FbcQP+WQACAC7+rATnBI0ADwAVAFuyExYXERI5sBMQsAXQALAJL7AARViwBS8bsQUaPlmwAEVYsAsvG7ELED5ZsgABCitYIdgb9FmwB9CwCNCwCRCwDdCwCBCwENCwEdCwBRCyEgEKK1gh2Bv0WTAxNzc2NjcTIREzESMRIREjEyEhESEDAoUpR0cHDgMHj7n8uroBAS4CQv5kDBGYMVb92AGZ/Av+FAFU/q0B6wNc/sj+mQABAB8AAAXrBI0AFQCRsgEWFxESOQCwAEVYsAkvG7EJGj5ZsABFWLANLxuxDRo+WbAARViwES8bsREaPlmwAEVYsAIvG7ECED5ZsABFWLAGLxuxBhA+WbAARViwFC8bsRQQPlmyEAkCERI5fLAQLxiyoBABXbRgEHAQAl2yAAEKK1gh2Bv0WbAE0LITEAAREjmwExCwCNCwEBCwC9AwMQEjESMRIwEjAQEzATMRMxEzATMBASMDxWO6ZP7F6gGG/p7gASxZulkBLOD+nAGI6gH2/goB9v4KAlECPP4DAf3+AwH9/c39pgAAAQBH//AD1ASdACgAfbIkKSoREjkAsABFWLAKLxuxCho+WbAARViwFi8bsRYQPlmwChCyAwEKK1gh2Bv0WbIGChYREjmyJwoWERI5sCcvtB8nLycCXbK/JwFdtN8n7ycCXbIkAQorWCHYG/RZshAkJxESObIcFgoREjmwFhCyHwEKK1gh2Bv0WTAxATQmIyIGFSM0NjMyFhUUBgcWFhUUBiMiJicmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnH+1VupPXm5BYN5iJL+/52c7wNQVF1YT461qJZWjSkkkluetCwuWZ1WYGBYwQWYBQABAIoAAARhBI0ACQBMsgAKCxESOQCwAEVYsAAvG7EAGj5ZsABFWLAHLxuxBxo+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZsgQAAhESObIJAAIREjkwMQEzESMRASMRMxEDqLm5/Zu5uQSN+3MDdPyMBI38jAABAIsAAAQsBI0ADABosgoNDhESOQCwAEVYsAQvG7EEGj5ZsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmwAEVYsAsvG7ELED5ZsgYCBBESOXywBi8YsqAGAV20YAZwBgJdsgEBCitYIdgb9FmyCgEGERI5MDEBIxEjETMRMwEzAQEjAa5qublkAYXf/jUB6+8B9v4KBI3+AwH9/cX9rgAAAQAnAAAENgSNAA8ATbIEEBEREjkAsABFWLAALxuxABo+WbAARViwAS8bsQEQPlmwAEVYsAgvG7EIED5ZsAAQsgMBCitYIdgb9FmwCBCyCgEKK1gh2Bv0WTAxAREjESEDAgIHIzc3NjY3EwQ2uf5eDw2ksEQEKV5QDRkEjftzA/T+gv6q/uUFpQMHnuICXgAAAQAi/+wECwSNABEAQ7IBEhMREjkAsABFWLACLxuxAho+WbAARViwEC8bsRAaPlmwAEVYsAgvG7EIED5ZsgEIAhESObIMAQorWCHYG/RZMDEBFwEzAQcGBwciJzcXMjY3ATMB9S0BFNX+XiVQqiZQFAZcMUkg/mbWAjB4AtX8RUmRCwEIkwUxOwOfAAABAIr+rATxBI0ACwBFsgkMDRESOQCwAi+wAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0DAxJTMDIxEhETMRIREzBEStEqX8ULkCR7qY/hQBVASN/AsD9QAAAQA9AAAD3wSNABEARrIEEhMREjkAsABFWLAILxuxCBo+WbAARViwEC8bsRAaPlmwAEVYsAAvG7EAED5Zsg0IABESObANL7IEAQorWCHYG/RZMDEhIxEGIyImJxEzERQWMzI3ETMD37mQo9TeBLl+f52WuQHCMMrBAXD+nYd5MgIxAAEAigAABcYEjQALAE+yBQwNERI5ALAARViwAi8bsQIaPlmwAEVYsAYvG7EGGj5ZsABFWLAKLxuxCho+WbAARViwAC8bsQAQPlmyBAEKK1gh2Bv0WbAI0LAJ0DAxISERMxEhETMRIREzBcb6xLkBiLoBiLkEjfwLA/X8CwP1AAEAiv6sBnUEjQAPAFiyCxARERI5ALACL7AARViwBi8bsQYaPlmwAEVYsAovG7EKGj5ZsABFWLAOLxuxDho+WbAARViwBC8bsQQQPlmyAAEKK1gh2Bv0WbAI0LAJ0LAM0LAN0DAxJTMDIxEhETMRIREzESERMwXHrhKm+s25AYi6AYi6mP4UAVQEjfwLA/X8CwP1AAACAAgAAATWBI0ADQAWAF6yCBcYERI5sAgQsBXQALAARViwBy8bsQcaPlmwAEVYsAMvG7EDED5ZsAcQsgUBCitYIdgb9FmyCgcDERI5sAovsAMQsg4BCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxARQGByERITUhESEyFhYBMjY1NCYjIREE1uTE/ir+sAIKARaEwmj+UXKEg3P+6wFupMgCA/SZ/kpYo/68dWNfcP5Z//8AigAABWcEjQAmAggAAAAHAcIEFgAAAAIAigAABAgEjQAKABMAULIIFBUREjmwCBCwC9AAsABFWLAFLxuxBRo+WbAARViwAy8bsQMQPlmyCAUDERI5sAgvsAMQsgsBCitYIdgb9FmwCBCyEQEKK1gh2Bv0WTAxARQGByERMxEhMhYBMjY1NCYnIREECOTF/iu5ARHO5v5Qc4R9bv7fAW6kyAIEjf5KxP6Fd2FbcQP+WQABAEv/8AQbBJ0AHgB6sgMfIBESOQCwAEVYsBMvG7ETGj5ZsABFWLAbLxuxGxA+WbIAGxMREjmyAwEKK1gh2Bv0WbIJExsREjl8sAkvGLKgCQFdtGAJcAkCXbIwCQFxtGAJcAkCcbIGAQorWCHYG/RZsBMQsgwBCitYIdgb9FmyDxMbERI5MDEBFhYzMjY3ITUhJiYjIgYHIzY2MzIAFxUUBgYjIiYnAQQUjYeNogf+QQG+BaOYfo0SuRP3zOQBEQV44pXP/hQBeYNvu7mYr8N0grvT/t/0daP5h867AAACAIr/8AYVBJ0AEwAhAIqyBCIjERI5sAQQsBjQALAARViwEC8bsRAaPlmwAEVYsAsvG7ELGj5ZsABFWLADLxuxAxA+WbAARViwCC8bsQgQPlmyDQgLERI5fLANLxi0YA1wDQJxsqANAV20YA1wDQJdsgYBCitYIdgb9FmwEBCyFwEKK1gh2Bv0WbADELIeAQorWCHYG/RZMDEBEAAjIgAnIxEjETMRMzYAMzIAFwc0JiMiBhUVFBYzMjY1BhX+7Ojd/usM2Lm52A4BFNrpARMCt6yblq+wl5ypAiT++/7RARzy/gIEjf4J8QEW/tD/BcbS1sVCw9fTxwAAAgBQAAAD/ASNAA0AFABhshMVFhESObATELAH0ACwAEVYsAcvG7EHGj5ZsABFWLAALxuxABA+WbAARViwCS8bsQkQPlmyEQcAERI5sBEvsgsBCitYIdgb9FmyAQsHERI5sAcQshIBCitYIdgb9FkwMTMBJiY1NDY3IREjESEDExQXIREhIlABInpx3MgB0bn+0P8u5gEb/u/wAg0mnWihsgL7cwHf/iEDMLQEAXwAAQALAAAD5wSNAA0AULIBDg8REjkAsABFWLAILxuxCBo+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASMRIxEjNTMRIRUhETMCh+K54eEC+/2+4gH9/gMB/ZcB+Zn+oAAAAQAf/qwGIgSNABkAqrIIGhsREjkAsABFWLAQLxuxEBo+WbAARViwFC8bsRQaPlmwAEVYsBgvG7EYGj5ZsABFWLANLxuxDRA+WbAARViwCi8bsQoQPlmwAEVYsAUvG7EFED5ZshcKGBESOXywFy8YsqAXAV20YBdwFwJdtGAXcBcCcbIHAQorWCHYG/RZsgAHFxESObAFELIBAQorWCHYG/RZsAcQsAvQsg8XBxESObAXELAS0DAxAQEzESMRIwEjESMRIwEjAQEzATMRMxEzATMEYwEmmad6/sRjumT+xeoBhv6e4AEsWbpZASzgAlr+PP4WAVQB9v4KAfb+CgJRAjz+AwH9/gMB/QABAIv+rAROBI0AEACAsgAREhESOQCwAy+wAEVYsAsvG7ELGj5ZsABFWLAPLxuxDxo+WbAARViwCS8bsQkQPlmwAEVYsAUvG7EFED5Zsg0JCxESOXywDS8YtGANcA0CcbKgDQFdtGANcA0CXbIIAQorWCHYG/RZsgAIDRESObAFELIBAQorWCHYG/RZMDEBATMRIxEjASMRIxEzETMBMwJBAW+eqGn+cWq5uWQBhd8CUv5E/hYBVAH2/goEjf4DAf0AAAEAiwAABOcEjQAUAHiyCxUWERI5ALAARViwBi8bsQYaPlmwAEVYsBMvG7ETGj5ZsABFWLAJLxuxCRA+WbAARViwES8bsREQPlmyABETERI5fLAALxiyoAABXbRgAHAAAl20YABwAAJxsATQsAAQshABCitYIdgb9FmyCBAAERI5sAzQMDEBMzUzFTMBMwEBIwEjFSM1IxEjETMBRFCUPAGE4P40Aevv/nFBlFC5uQKQ5OQB/f3F/a4B9s7O/goEjQAAAQAjAAAFFQSNAA4AfbIADxAREjkAsABFWLAGLxuxBho+WbAARViwCi8bsQoaPlmwAEVYsAIvG7ECED5ZsABFWLANLxuxDRA+WbIIAgYREjl8sAgvGLKgCAFdtGAIcAgCXbRgCHAIAnGyAQEKK1gh2Bv0WbAGELIEAQorWCHYG/RZsgwBCBESOTAxASMRIxEhNSERMwEzAQEjApdpuv6vAgtjAYXg/jQB6+8B9v4KA/WY/gMB/f3F/a4AAgBg/+sFWwSfACMALgCUshQvMBESObAUELAk0ACwAEVYsAsvG7ELGj5ZsABFWLAbLxuxGxo+WbAARViwAC8bsQAQPlmwAEVYsAQvG7EEED5ZsgIEGxESObACL7ALELIMAQorWCHYG/RZsAQQshMBCitYIdgb9FmwAhCyJgEKK1gh2Bv0WbIVEyYREjmyIQImERI5sBsQsiwBCitYIdgb9FkwMQUiJwYjIAARNRASMxciBhUVFBYzMjcmAzU0EjMyEhUVEAcWMwEQFzYRNTQmIyIDBVvZpomj/ur+xvTSAX6Q0Mc2MuMBz7W4zbZedv2S4bZiasYFFDs8AUUBKhoBAwEonsPIIejlCLIBRSfrAQT+//E4/tqyEgH9/sx5gQEeOKyj/sP//wANAAAEHASNACYB0gAAAQcB3gBE/t4ACACyAAoBXTAxAAEAJv6sBHEEjQAQAGuyCxESERI5ALAHL7AARViwAS8bsQEaPlmwAEVYsA8vG7EPGj5ZsABFWLAJLxuxCRA+WbAARViwDC8bsQwQPlmyAAEMERI5sgsMARESObIDCwAREjmwCRCyBAEKK1gh2Bv0WbIOAAsREjkwMQEBMwEBNTMRIxEjAQEjAQEzAigBH9z+dQExqKh0/tX+2NwBlv5z2wLaAbP9vv5KAf4WAVQBu/5FAksCQgAAAQAm/qwF8gSNAA8AXLIJEBEREjkAsAIvsABFWLAILxuxCBo+WbAARViwDi8bsQ4aPlmwAEVYsAQvG7EEED5ZsgABCitYIdgb9FmwCBCyBgEKK1gh2Bv0WbAK0LAL0LAAELAM0LAN0DAxJTMDIxEhESE1IRUhESERMwVErhKl/FD+mwOJ/pUCRrqY/hQBVAP0mZn8pAP1AAABAD0AAAPfBI0AFwBPsgQYGRESOQCwAEVYsAsvG7ELGj5ZsABFWLAWLxuxFho+WbAARViwAC8bsQAQPlmyEAsAERI5sBAvsgcBCitYIdgb9FmwBNCwEBCwE9AwMSEjEQYHFSM1JiYnETMRFBYXNTMVNjcRMwPfuWNplbzJA7lnaJVnZbkBwiELxsMKyboBbf6de3gL8O0LIgIxAAABAIoAAAQsBI0AEQBGsgQSExESOQCwAEVYsAAvG7EAGj5ZsABFWLAILxuxCBA+WbAARViwEC8bsRAQPlmyBAAIERI5sAQvsg0BCitYIdgb9FkwMRMzETYzMhYXESMRNCYjIgcRI4q5mpnU3gS5fn+Ym7kEjf4+McrB/o8BZId5M/3PAAACAAL/8AVrBJ0AHAAkAGmyFSUmERI5sBUQsB7QALAARViwDi8bsQ4aPlmwAEVYsAAvG7EAED5ZsiEOABESObAhL7K/IQFdshIBCitYIdgb9FmwA9CwIRCwCtCwABCyFgEKK1gh2Bv0WbAOELIdAQorWCHYG/RZMDEFIgA1JiY1MxQWFz4CMzIAERUhFBYzMjY3FwYGAyIGByE1NCYDkf/+zqa4mV9mBYfpjvgBEPyuwbdMh1A5PLiWj7UGApmuEAEi8wvGqF53DJPsgf7r/v2CscAfKJIoLwQRwqQboaoAAAIAXv/wBGkEnQAWAB4AXrIIHyAREjmwCBCwF9AAsABFWLAALxuxABo+WbAARViwCC8bsQgQPlmyDQAIERI5sA0vsAAQshEBCitYIdgb9FmwCBCyFwEKK1gh2Bv0WbANELIaAQorWCHYG/RZMDEBMgAXFRQGBiMiABE1ITU0JiMiByc2NhMyNjchFRQWAkf3ASkChOyT+P7wA1LBt5OQOUHAiZGzBv1nrQSd/uDviJn0iQEVAQGCAbHBSJIpL/vtxqEboKwAAAEAR//tA9QEjQAcAG2yGh0eERI5ALAARViwAi8bsQIaPlmwAEVYsAsvG7ELED5ZsAIQsgABCitYIdgb9FmyBAACERI5sgULAhESObAFL7IRCwIREjmwCxCyFAEKK1gh2Bv0WbAFELIaAQorWCHYG/RZshwFGhESOTAxASE1IRcBFhYVFAYjIiYnJjUzFhYzMjY1NCYjIzUCs/28AzgC/qmx0fzXWas8erkFiXOIkoqGgAP0mXb+mxDFi6e+LS5anllkaGpfaqUAAwBg//AEWgSdAA0AFAAbAHOyAxwdERI5sAMQsA7QsAMQsBXQALAARViwCi8bsQoaPlmwAEVYsAMvG7EDED5Zsg4BCitYIdgb9FmyGQoDERI5fLAZLxiyoBkBXbRgGXAZAl20YBlwGQJxshEBCitYIdgb9FmwChCyFQEKK1gh2Bv0WTAxARAAIyIAETUQADMyABcBMjY3IRYWEyIGByEmJgRa/uzo5f7nARfl6QETAv4Ek6gJ/XYKrY2RqwgCigmqAiT++/7RATIBBz4BAgE0/tD//hy8tLDAA3fDrLO8AAABADAAAAPvBJ0AJwCush0oKRESOQCwAEVYsB0vG7EdGj5ZsABFWLAMLxuxDBA+WbIGHQwREjmwBi+yDwYBcbIPBgFdsk8GAXGwAdCwAS9ACR8BLwE/AU8BBF2yAAEBXbICBAorWCHYG/RZsAYQsgcECitYIdgb9FmwDBCyCgEKK1gh2Bv0WbAO0LAP0LAHELAR0LAGELAT0LACELAW0LABELAY0LIhAR0REjmwHRCyJAEKK1gh2Bv0WTAxASEVIRcVIRUhBgchByE1MzY3IzUzNScjNTMnJjYzMhYVIzQmIyIGFwGHAZb+bgMBj/5sCiQClAH8hAo/FJ+lA6KeAgbLtbfKuWhgXWgEAqh5XRB5akeYmBKfeRBdeUDJ7My3cHePigAAAQBC//ADngSdACEAnrIUIiMREjkAsABFWLAVLxuxFRo+WbAARViwCC8bsQgQPlmyIRUIERI5sCEvsg8hAV20ECEgIQJdsgAECitYIdgb9FmwCBCyAwEKK1gh2Bv0WbAAELAL0LAhELAN0LAhELAS0LASL0AJHxIvEj8STxIEXbIAEgFdsg8ECitYIdgb9FmwFRCyGgEKK1gh2Bv0WbASELAc0LAPELAe0DAxASESITI3FwYjIiYnIzUzNSM1MzY2MzIXByYjIAMhFSEVIQMv/mggAQJiaBt2b9P1FJuXl5sW9c9ghxVZef8AIAGY/mQBnAGW/vEclR7azHlteczcH5Uc/vB5bQAABACKAAAHrQSdAAMAEAAeACgAqLIfKSoREjmwHxCwAdCwHxCwBNCwHxCwEdAAsABFWLAnLxuxJxo+WbAARViwJS8bsSUaPlmwAEVYsAcvG7EHGj5ZsABFWLAiLxuxIhA+WbAARViwIC8bsSAQPlmwBxCwDdCwDS+wAtCwAi+0AAIQAgJdsgEDCitYIdgb9FmwDRCyFAMKK1gh2Bv0WbAHELIbAworWCHYG/RZsiEnIBESObImICcREjkwMSUhNSEBNDYgFhUVFAYjIiY1FxQWMzI2NTU0JiMiBhUBIwERIxEzAREzB2790wIt/ZK8ATS9vpeZv6NeV1ReYVNSYf61uP2jubkCXbi9jgIDlbq4m1CYtrecBVlqaVxSWmhnXvy1A2z8lASN/JMDbQAAAgAoAAAEZgSNABYAHwCDsgAgIRESObAY0ACwAEVYsAwvG7EMGj5ZsABFWLACLxuxAhA+WbIWDAIREjmwFi+yAAEKK1gh2Bv0WbAE0LAWELAG0LAWELAL0LALL0AJDwsfCy8LPwsEXbS/C88LAl2yCAEKK1gh2Bv0WbAT0LALELAX0LAMELIeAQorWCHYG/RZMDElIRUjNSM1MzUjNTMRITIWFRQGByEVISUhMjY1NCYjIQKk/v66wMDAwAHPxerjvv7dAQL+/gEVcoOEcP7qtLS0mFmYAlDMqKXLBFnxeGJkegAAAgCM/+wENAYAABAAGwBkshQcHRESObAUELAN0ACwCS+wAEVYsA0vG7ENGD5ZsABFWLAELxuxBBA+WbAARViwBy8bsQcQPlmyBg0EERI5sgsNBBESObANELIUAQorWCHYG/RZsAQQshkBCitYIdgb9FkwMQEUBgYjIicHIxEzETYzMhIRJzQmIyIHERYzMjYENG/JgNFwD6C5cMXJ8bmjjLdQVbSKowISn/yLlYEGAP3Di/7T/v8HtNaq/iyr2AAAAQBc/+wD7wROAB0ASbIAHh8REjkAsABFWLAQLxuxEBg+WbAARViwCC8bsQgQPlmyAAEKK1gh2Bv0WbAIELAD0LAQELAU0LAQELIXAQorWCHYG/RZMDElMjY3Mw4CIyIANTU0NjYzMhYXIyYmIyIGFRUUFgJAY5QIsAV4xG7f/vt225O28QiwCI9oj5udg3haXqhjASr8IJ35htquaYfOvyG8yQACAFv/7AQABgAAEQAcAGSyGh0eERI5sBoQsATQALAHL7AARViwBC8bsQQYPlmwAEVYsA0vG7ENED5ZsABFWLAJLxuxCRA+WbIGBA0REjmyCwQNERI5sA0QshUBCitYIdgb9FmwBBCyGgEKK1gh2Bv0WTAxEzQ2NjMyFxEzESMnBiMiJiYnNxQWMzI3ESYjIgZbcc6Avm+5oQ5vynzLdQG5qIqvUlOsjacCJp/8jYICNPoAeIyM+5gGsdifAfGZ1gACAFv+VgQABE4AGwAmAHyyHycoERI5sB8QsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwGC8bsRgQPlmyBQMYERI5sAsQshIBCitYIdgb9FmyFgMYERI5sBgQsh8BCitYIdgb9FmwAxCyJAEKK1gh2Bv0WTAxEzQSMzIXNzMRBgIjIiYnNxYWMzI2NTUGIyICNRcUFjMyNxEmIyIGW/jGzG8PnQL04FbISDc/n0+Vim/Bwvq5pouvU1OtjqUCJvYBMpSA/A7v/v03MooqMrCoKIEBOPQHsNmhAeud1wD//wBXAAAChgW3AAYAFa0AAAIAjP5gBDIETgAQABsAbrIZHB0REjmwGRCwDdAAsABFWLANLxuxDRg+WbAARViwCi8bsQoYPlmwAEVYsAcvG7EHEj5ZsABFWLAELxuxBBA+WbIGDQQREjmyCw0EERI5sA0QshQBCitYIdgb9FmwBBCyGQEKK1gh2Bv0WTAxARQGBiMiJxEjETMXNjMyEhcHNCYjIgcRFjMyNgQybsiBxXG5nw90ysHuCripj6hUU6uMqgIRnvyLff33Bdp9kf7p6iew25X9+5TfAAACAFv+YAP/BE4ADwAaAGuyGBscERI5sBgQsAPQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLAILxuxCBI+WbAARViwDC8bsQwQPlmyBQMMERI5sgoDDBESObITAQorWCHYG/RZsAMQshgBCitYIdgb9FkwMRM0EjMyFzczESMRBiMiAjUXFBYzMjcRJiMiBlv3zMRvDqC5cLrH+rmqjKZWWKKOqgIl9QE0hnL6JgIEeAE19geu35MCEY/fAAIAXf/sA/METgAUABwAYrIIHR4REjmwCBCwFdAAsABFWLAILxuxCBg+WbAARViwAC8bsQAQPlmyGQgAERI5sBkvtL8ZzxkCXbIMAQorWCHYG/RZsAAQshABCitYIdgb9FmwCBCyFQEKK1gh2Bv0WTAxBSIAJyc0NjYzMhIVFSEWFjMyNxcGASIGByE1NCYCceX+3QsBfN2A1ej9JAjCmaB4OYP+7nOYEQIgiRQBF+NOm/WK/v7wdJ3IWn9yA8qglhmDmgACAGD+VgPyBE4AGgAlAHyyIyYnERI5sCMQsAvQALAARViwAy8bsQMYPlmwAEVYsAYvG7EGGD5ZsABFWLALLxuxCxI+WbAARViwFy8bsRcQPlmyBQMXERI5sAsQshEBCitYIdgb9FmyFQMXERI5sBcQsh4BCitYIdgb9FmwAxCyIwEKK1gh2Bv0WTAxEzQSMzIXNzMRFAYjIiYnNxYzMjY1NQYjIgI1FxQWMzI3ESYjIgZg6MPKcBCd9eFSr0E3eo+ViW/Avuu6lYivUlWqiZYCJfoBL5N//AXq/y0pikmnnjqAATL6CLXToAHum9AAAQB+/+sFHQXFAB4ATLIMHyAREjkAsABFWLAMLxuxDBw+WbAARViwAy8bsQMQPlmwDBCwENCwDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsAMQsB7QMDEBBgAjIiQCJzU0EiQzMgAXIyYmIyICERUUEhYzMjY3BRwY/tvusf7hogGdARuy7QEvGcEYv53A6m7IfaGwGgHO3/78tAFHy0TTAUqz/vrjo6j+y/7+N6H/AJCdqQABAH7/6wUeBcQAIgBtsgwjJBESOQCwAEVYsAwvG7EMHD5ZsABFWLADLxuxAxA+WbIQAwwREjmwEC+wDBCyEwEKK1gh2Bv0WbADELIbAQorWCHYG/RZsiIMAxESObAiL7Q/Ik8iAl20DyIfIgJdsh8BCitYIdgb9FkwMSUGBCMiJAInNTQSJDMyBBcjJiYjIgIHBxQSFjMyNjcRITUhBR5D/uOwu/7WqAObARy18QEhIsAeupy17AoBeNOFcrUq/rACD75hcrQBR9It2wFOtuXalYz+3PJGrP72jDowAUabAAIAsgAABREFsAALABUARrIDFhcREjmwAxCwFdAAsABFWLABLxuxARw+WbAARViwAC8bsQAQPlmwARCyDAEKK1gh2Bv0WbAAELINAQorWCHYG/RZMDEzESEyBBIXFRQCBAcDETMyABE1NAAjsgGxwQE4sQSt/sLL6d/qARP+9+gFsKz+xMg+0P7BsQIFEvuLASoBAyT8ASgAAgB+/+sFXwXFABEAIgBGsgQjJBESObAEELAf0ACwAEVYsA0vG7ENHD5ZsABFWLAELxuxBBA+WbANELIWAQorWCHYG/RZsAQQsh8BCitYIdgb9FkwMQEUAgQjIiQCJzU0EiQzMgQSFwc0AiYjIgYGBxUUEhYzMhI1BV+i/uKvq/7hpgKkASGrrQEgowG/bsd9eMZyAXHJecHvAsLO/rC5uQFKyDfNAU+8uf60zAWiAQCPj/6cNaD+/pIBO/8AAAIAfv8EBV8FxQAVACYATbIIJygREjmwCBCwI9AAsABFWLARLxuxERw+WbAARViwCC8bsQgQPlmyAwgRERI5sBEQshoBCitYIdgb9FmwCBCyIwEKK1gh2Bv0WTAxARQCBxcHJQYjIiQCJzU0EiQzMgQSFSc0AiYjIgYGBxUUEhYzMhI1BV+plPqD/sw5PKv+4KQDogEirK4BIaK/bsd9eMdxAXHJecHvAsLU/qxaw3nzDLoBRsY6zAFQvrv+sM4BowEBj5D/nDOg/v6SATv/AAABAKAAAALJBI0ABgAyALAARViwBS8bsQUaPlmwAEVYsAAvG7EAED5ZsgQABRESObAEL7IDAQorWCHYG/RZMDEhIxEFNSUzAsm5/pACCh8DpouoygABAIMAAAQgBKAAGABUsgkZGhESOQCwAEVYsBEvG7ERGj5ZsABFWLAALxuxABA+WbIXAQorWCHYG/RZsALQshYXERESObIDERYREjmwERCyCQEKK1gh2Bv0WbARELAM0DAxISE1ATY3NzQmIyIGFSM0NjYzMhYVFAcBIQQg/IcB/X0KA31mepW5eNJ+u+HF/oYCeIMByXNUNVRsjnVwv2y4mLG0/qwAAQCKAAADhQXEAAcAMrIDCAkREjkAsABFWLAGLxuxBho+WbAARViwBC8bsQQQPlmwBhCyAgEKK1gh2Bv0WTAxATMRIREjESECzLn9vrkCQgXE/jD8DASNAAEAD/6jA94EjQAYAE4AsAsvsABFWLACLxuxAho+WbIBAQorWCHYG/RZsATQsgULAhESObAFL7ALELIQAQorWCHYG/RZsAUQshcBCitYIdgb9FmyGBcFERI5MDEBITUhFQEWFhUUACMiJzcWMzI2NTQmIyM1AuT9dANy/oCy4v7M/8rSNKWxtNe5wDwD9Jl2/mwY9rP5/tpni1jKpaulZwACAD7+tgSgBI0ACgAOAEsAsABFWLAJLxuxCRo+WbAARViwAi8bsQIQPlmwAEVYsAYvG7EGED5ZsgABCitYIdgb9FmwBhCwBdCwBS+wABCwDNCyDQkCERI5MDElMxUjESMRITUBMwEhEQcD28XFuv0dAtbH/TwCChyWl/63AUltBCH8CQL8NQD//wBQAo0CnQW4AwcB1AAAApgAEwCwAEVYsAovG7EKHD5ZsBDQMDEA//8ANgKYArsFrQMHAdgAAAKYABMAsABFWLAJLxuxCRw+WbAN0DAxAP//AFsCjQKnBa0DBwHZAAACmAAQALAARViwAS8bsQEcPlkwMf//AFYCjQKrBbYDBwHaAAACmAATALAARViwAC8bsQAcPlmwFNAwMQD//wA6ApgCpQWtAwcB2wAAApgAEACwAEVYsAUvG7EFHD5ZMDH//wBPAo0CnwW4AwcB3AAAApgAGQCwAEVYsBEvG7ERHD5ZsBfQsBEQsB/QMDEA//8ASQKRApUFuAMHAd0AAAKYABMAsABFWLAILxuxCBw+WbAZ0DAxAAABAGX+oAQFBIwAGwBOALANL7AARViwAS8bsQEaPlmyBAEKK1gh2Bv0WbIHDQEREjmwBy+yGAEKK1gh2Bv0WbIFBxgREjmwDRCyEgEKK1gh2Bv0WbAHELAb0DAxExMhFSEDNjc2EhUUACMiJzcWMzI2NTQmIyIGB4ZmAxT9fjZvlcjx/uDx4K86gtOZv6WHanUiAXQDGKv+dEACAv714e/+4nKLZc+kj7Y6UwAAAQBK/rYD8gSNAAYAJQCwAS+wAEVYsAUvG7EFGj5ZsgMBCitYIdgb9FmyAAMFERI5MDEBASMBITUhA/L9oLoCV/0bA6gEI/qTBT+YAAIAYP/wBm0EnQATAB0AmrIVHh8REjmwFRCwCtAAsABFWLAJLxuxCRo+WbAARViwCy8bsQsaPlmwAEVYsAIvG7ECED5ZsABFWLAALxuxABA+WbALELIMAQorWCHYG/RZsAAQsA/QsA8vsh8PAV2y3w8BXbIQAQorWCHYG/RZsAAQshMBCitYIdgb9FmwAhCyFAEKK1gh2Bv0WbAJELIXAQorWCHYG/RZMDEhIQUiABE1EAAzBSEVIREhFSERIQU3ESciBhUVFBYGbf1j/o7l/ucBF+UBWwKv/ZsCFP3sAmz78erslq+wEAEyAQc+AQIBNBCZ/rKY/okNBwNnCdbFQsPXAAIAgv6pBD8EoQAYACUASwCwFC+wAEVYsAwvG7EMGj5ZsBQQsgABCitYIdgb9FmyBRQMERI5sAUvsgMFDBESObIaAQorWCHYG/RZsAwQsiABCitYIdgb9FkwMQUyNjcGIyICNTQ2NjMyABMVFAIEIyInNxYTMjY3NTQmIyIGFRQWAd+x3BV3t9L/ddKE6wEFApL+86+fdiZ64GmfIqGSf5ijv/TZaQEU4pzsfv7c/vb63P66rjyOMgH8XFKUxcXDq5XJAAACAHj/6wSJBKEACwAZADkAsABFWLAILxuxCBo+WbAARViwAy8bsQMQPlmwCBCyDwEKK1gh2Bv0WbADELIWAQorWCHYG/RZMDEBEAAgAAM1EAAgABMnNCYjIgYHFRQWMzI2NwSJ/uj+Iv7mAQEZAd4BGQG6sp2bsgK2m5qxAgI8/ur+xQE8ARQUARQBPv7E/usNyuLgxTTJ5d3KAP///7T+SwFlBDoABgCbAAD///+0/ksBZQQ6AAYAmwAA//8AmwAAAVUEOgAGAIwAAP////r+WQFaBDoAJgCMAAAABgCjyAr//wCbAAABVQQ6AAYAjAAA//8Ahv6sAWEEOgAmAIwAAAAHAKwDTgAKAAEAiv/sA/kEnQAhAFwAsABFWLAVLxuxFRo+WbAARViwEC8bsRAQPlmwAEVYsB8vG7EfED5ZsgIBCitYIdgb9FmyGR8VERI5sBkvsQgKK1jYG9xZsBkQsArQsBUQsg0BCitYIdgb9FkwMSUWMzI2NTQmIyM1EyYjIgMRIxE2NjMyFhcBFhYVFAYjIicBw1JYYXKIh1TtTmPTBLgBxclrw2X+7qm217V3aLUze2NiVYkBJz7+9f0GAvXS1lVi/rYPo4aszDEA//8AJQIfAg0CtgIGABEAAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAACACUAAATkBbAADwAdAGYAsABFWLAFLxuxBRw+WbAARViwAC8bsQAQPlmyBAAFERI5sAQvss8EAV2yLwQBXbKfBAFxsgEBCitYIdgb9FmwEdCwABCyEgEKK1gh2Bv0WbAFELIbAQorWCHYG/RZsAQQsBzQMDEzESM1MxEhMgQSFxUUAgQHEyERMzISNzU0AicjESHHoqIBm74BJJ8Bn/7ZxEf+5sne9wHp1uABGgKalwJ/qP7KyV3O/sqmAgKa/gMBEvld+AETAv4fAAABAAAAAAP9BgAAGQBqALAXL7AARViwBC8bsQQYPlmwAEVYsBAvG7EQED5ZsABFWLAILxuxCBA+WbIvFwFdsg8XAV2yFRAXERI5sBUvshIBCitYIdgb9FmwAdCyAhAEERI5sAQQsgwBCitYIdgb9FmwFRCwGNAwMQEhETYzIBMRIxEmJiMiBgcRIxEjNTM1MxUhAnz+53vFAVcDuQFpb1qIJrmqqrkBGQTS/uWX/n39NQLMdXBgTvz9BNKXl5cAAQAxAAAElwWwAA8ATACwAEVYsAovG7EKHD5ZsABFWLACLxuxAhA+WbIPCgIREjmwDy+yAAEKK1gh2Bv0WbAE0LAPELAG0LAKELIIAQorWCHYG/RZsAzQMDEBIxEjESM1MxEhNSEVIREzA6rnv9bW/i0EZv4s5wM3/MkDN5cBRJ6e/rwAAf/0/+wCcAVAAB0AcwCwAEVYsAEvG7EBGD5ZsABFWLARLxuxERA+WbABELAA0LAAL7ABELIEAQorWCHYG/RZsAEQsAXQsAUvsgAFAV2yCAEKK1gh2Bv0WbARELIMAQorWCHYG/RZsAgQsBXQsAUQsBjQsAQQsBnQsAEQsBzQMDEBETMVIxUzFSMRFBYzMjcVBiMiJjURIzUzNSM1MxEBh8rK6ek2QSA4SUV8ftraxcUFQP76j7qX/rJBQQyWFJaKAU6Xuo8BBv//ABwAAAUdBzQCJgAlAAABBwBEATABNgAUALAARViwBC8bsQQcPlmxDAj0MDH//wAcAAAFHQc0AiYAJQAAAQcAdQG/ATYAFACwAEVYsAUvG7EFHD5ZsQ0I9DAx//8AHAAABR0HNgImACUAAAEHAJ0AyQE2ABQAsABFWLAELxuxBBw+WbEPBvQwMf//ABwAAAUdByICJgAlAAABBwCkAMUBOgAUALAARViwBS8bsQUcPlmxDgT0MDH//wAcAAAFHQb7AiYAJQAAAQcAagD5ATYAFwCwAEVYsAQvG7EEHD5ZsREE9LAb0DAxAP//ABwAAAUdB5ECJgAlAAABBwCiAVABQQAXALAARViwBC8bsQQcPlmxDgb0sBjQMDEA//8AHAAABR0HlAImACUAAAAHAd8BWgEi//8Ad/5EBNgFxAImACcAAAAHAHkB0v/3//8AqQAABEYHQAImACkAAAEHAEQA+wFCABQAsABFWLAGLxuxBhw+WbENCPQwMf//AKkAAARGB0ACJgApAAABBwB1AYoBQgAUALAARViwBi8bsQYcPlmxDgj0MDH//wCpAAAERgdCAiYAKQAAAQcAnQCUAUIAFACwAEVYsAYvG7EGHD5ZsRAG9DAx//8AqQAABEYHBwImACkAAAEHAGoAxAFCABcAsABFWLAGLxuxBhw+WbESBPSwG9AwMQD////gAAABgQdAAiYALQAAAQcARP+nAUIAFACwAEVYsAIvG7ECHD5ZsQUI9DAx//8AsAAAAlEHQAImAC0AAAEHAHUANQFCABQAsABFWLADLxuxAxw+WbEGCPQwMf///+kAAAJGB0ICJgAtAAABBwCd/0ABQgAUALAARViwAi8bsQIcPlmxCAb0MDH////WAAACXwcHAiYALQAAAQcAav9wAUIAFwCwAEVYsAIvG7ECHD5ZsQoE9LAU0DAxAP//AKkAAAUIByICJgAyAAABBwCkAPsBOgAUALAARViwBi8bsQYcPlmxDQT0MDH//wB2/+wFCQc2AiYAMwAAAQcARAFSATgAFACwAEVYsA0vG7ENHD5ZsSEI9DAx//8Adv/sBQkHNgImADMAAAEHAHUB4QE4ABQAsABFWLANLxuxDRw+WbEiCPQwMf//AHb/7AUJBzgCJgAzAAABBwCdAOsBOAAUALAARViwDS8bsQ0cPlmxIgb0MDH//wB2/+wFCQckAiYAMwAAAQcApADnATwAFACwAEVYsA0vG7ENHD5ZsSME9DAx//8Adv/sBQkG/QImADMAAAEHAGoBGwE4ABcAsABFWLANLxuxDRw+WbEnBPSwMNAwMQD//wCM/+wEqgc0AiYAOQAAAQcARAErATYAFACwAEVYsAovG7EKHD5ZsRQI9DAx//8AjP/sBKoHNAImADkAAAEHAHUBugE2ABQAsABFWLASLxuxEhw+WbEVCPQwMf//AIz/7ASqBzYCJgA5AAABBwCdAMQBNgAUALAARViwCi8bsQocPlmxFwb0MDH//wCM/+wEqgb7AiYAOQAAAQcAagD0ATYAFwCwAEVYsAovG7EKHD5ZsRkE9LAj0DAxAP//AA8AAAS7BzQCJgA9AAABBwB1AYgBNgAUALAARViwAS8bsQEcPlmxCwj0MDH//wBt/+wD6gX+AiYARQAAAQcARADVAAAAFACwAEVYsBcvG7EXGD5ZsSoJ9DAx//8Abf/sA+oF/gImAEUAAAEHAHUBZAAAABQAsABFWLAXLxuxFxg+WbErCfQwMf//AG3/7APqBgACJgBFAAABBgCdbgAAFACwAEVYsBcvG7EXGD5ZsSsB9DAx//8Abf/sA+oF7AImAEUAAAEGAKRqBAAUALAARViwFy8bsRcYPlmxLAH0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP//AG3/7APqBlsCJgBFAAABBwCiAPUACwAXALAARViwFy8bsRcYPlmxLAT0sDbQMDEA//8Abf/sA+oGXwImAEUAAAAHAd8A///t//8AXP5EA+wETgImAEcAAAAHAHkBP//3//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AF3/7APzBf4CJgBJAAABBwB1AVQAAAAUALAARViwCC8bsQgYPlmxIAn0MDH//wBd/+wD8wYAAiYASQAAAQYAnV4AABQAsABFWLAILxuxCBg+WbEgAfQwMf//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA////xgAAAWcF/QImAIwAAAEGAESN/wAUALAARViwAi8bsQIYPlmxBQn0MDH//wCWAAACNwX9AiYAjAAAAQYAdRv/ABQAsABFWLADLxuxAxg+WbEGCfQwMf///88AAAIsBf8CJgCMAAABBwCd/yb//wAUALAARViwAi8bsQIYPlmxCAH0MDH///+8AAACRQXEAiYAjAAAAQcAav9W//8AFwCwAEVYsAIvG7ECGD5ZsQsB9LAU0DAxAP//AIwAAAPfBewCJgBSAAABBgCkYQQAFACwAEVYsAMvG7EDGD5ZsRUB9DAx//8AW//sBDQF/gImAFMAAAEHAEQAzwAAABQAsABFWLAELxuxBBg+WbEdCfQwMf//AFv/7AQ0Bf4CJgBTAAABBwB1AV4AAAAUALAARViwBC8bsQQYPlmxHgn0MDH//wBb/+wENAYAAiYAUwAAAQYAnWgAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AFv/7AQ0BewCJgBTAAABBgCkZAQAFACwAEVYsAQvG7EEGD5ZsR8B9DAx//8AW//sBDQFxQImAFMAAAEHAGoAmAAAABcAsABFWLAELxuxBBg+WbEjAfSwLNAwMQD//wCI/+wD3AX+AiYAWQAAAQcARADHAAAAFACwAEVYsAcvG7EHGD5ZsRIJ9DAx//8AiP/sA9wF/gImAFkAAAEHAHUBVgAAABQAsABFWLANLxuxDRg+WbETCfQwMf//AIj/7APcBgACJgBZAAABBgCdYAAAFACwAEVYsAcvG7EHGD5ZsRUB9DAx//8AiP/sA9wFxQImAFkAAAEHAGoAkAAAABcAsABFWLAHLxuxBxg+WbEYAfSwIdAwMQD//wAW/ksDsAX+AiYAXQAAAQcAdQEbAAAAFACwAEVYsAEvG7EBGD5ZsRIJ9DAx//8AFv5LA7AFxQImAF0AAAEGAGpVAAAXALAARViwDy8bsQ8YPlmxFwH0sCDQMDEA//8AHAAABR0G7gImACUAAAEHAHAAxwE+ABMAsABFWLAELxuxBBw+WbAM3DAxAP//AG3/7APqBbgCJgBFAAABBgBwbAgAEwCwAEVYsBcvG7EXGD5ZsCrcMDEA//8AHAAABR0HDgImACUAAAEHAKAA9AE3ABMAsABFWLAELxuxBBw+WbAN3DAxAP//AG3/7APqBdgCJgBFAAABBwCgAJkAAQATALAARViwFy8bsRcYPlmwK9wwMQAAAgAc/k8FHQWwABYAGQBnALAARViwFi8bsRYcPlmwAEVYsBQvG7EUED5ZsABFWLABLxuxARA+WbAARViwDC8bsQwSPlmyBwMKK1gh2Bv0WbABELAR0LARL7IXFBYREjmwFy+yEwEKK1gh2Bv0WbIZFhQREjkwMQEBIwcGFRQzMjcXBiMiJjU0NwMhAyMBAyEDAvACLSY6cU4wNA1GWllnqYf9nonGAiyjAe/4BbD6UC1bVkgaeSxoVpBsAXP+hAWw/GoCqQAAAgBt/k8D6gROAC0ANwCQALAARViwFy8bsRcYPlmwAEVYsAQvG7EEED5ZsABFWLAeLxuxHhA+WbAARViwKS8bsSkSPlmwHhCwANCwAC+yAgQXERI5sgsXBBESObALL7AXELIPAQorWCHYG/RZshILFxESObApELIkAworWCHYG/RZsAQQsi4BCitYIdgb9FmwCxCyMwEKK1gh2Bv0WTAxJSYnBiMiJjU0JDMzNTQmIyIGFSM0NjYzMhYXERQXFSMHBhUUMzI3FwYjIiY1NCcyNjc1IyAVFBYDJA8HgbOgzQEB6bR0cWOGunPFdrvUBCYhOnFOMDQNRlpZZ4hXnCOR/qx0ByZFhrWLqbtVYXNkR1GXWLuk/g6VWBAtW1ZIGnksaFaQ8FpI3sdXYgD//wB3/+wE2AdVAiYAJwAAAQcAdQHGAVcAFACwAEVYsAsvG7ELHD5ZsR8I9DAx//8AXP/sA+wF/gImAEcAAAEHAHUBMwAAABQAsABFWLAQLxuxEBg+WbEgCfQwMf//AHf/7ATYB1cCJgAnAAABBwCdANABVwAUALAARViwCy8bsQscPlmxHwb0MDH//wBc/+wD7AYAAiYARwAAAQYAnT0AABQAsABFWLAQLxuxEBg+WbEgAfQwMf//AHf/7ATYBxkCJgAnAAABBwChAa4BVwAUALAARViwCy8bsQscPlmxIwT0MDH//wBc/+wD7AXCAiYARwAAAQcAoQEbAAAAFACwAEVYsBAvG7EQGD5ZsSQB9DAx//8Ad//sBNgHVwImACcAAAEHAJ4A5gFYABQAsABFWLALLxuxCxw+WbEhBvQwMf//AFz/7APsBgACJgBHAAABBgCeUwEAFACwAEVYsBAvG7EQGD5ZsSIB9DAx//8AqQAABMYHQgImACgAAAEHAJ4AnwFDABQAsABFWLABLxuxARw+WbEbBvQwMf//AF//7AUrBgIAJgBIAAABBwGiA9QFEwBIALLwHwFysh8fAV2ynx8BXbIfHwFxtM8f3x8CcbLfHwFysl8fAXKyTx8BcbLPHwFdtE8fXx8CXbJgHwFdsuAfAXGy4B8BXTAx//8AqQAABEYG+gImACkAAAEHAHAAkgFKABMAsABFWLAGLxuxBhw+WbAN3DAxAP//AF3/7APzBbgCJgBJAAABBgBwXAgAEwCwAEVYsAgvG7EIGD5ZsB/cMDEA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wCpAAAERgcEAiYAKQAAAQcAoQFyAUIAFACwAEVYsAYvG7EGHD5ZsRME9DAx//8AXf/sA/MFwgImAEkAAAEHAKEBPAAAABQAsABFWLAILxuxCBg+WbElAfQwMQABAKn+TwRGBbAAGwB2ALAARViwFi8bsRYcPlmwAEVYsBUvG7EVED5ZsABFWLAPLxuxDxI+WbAARViwBC8bsQQQPlmyGhUWERI5sBovsgEBCitYIdgb9FmwFRCyAgEKK1gh2Bv0WbAPELIKAworWCHYG/RZsBYQshkBCitYIdgb9FkwMQEhESEVIwcGFRQzMjcXBiMiJjU0NyERIRUhESED4P2JAt1JOnFOMDQNRlpZZ5v9XQOT/S0CdwKh/fydLVtWSBp5LGhWimkFsJ7+LAAAAgBd/mgD8wROACUALQB6ALAARViwGi8bsRoYPlmwAEVYsA0vG7ENEj5ZsABFWLASLxuxEhA+WbAE0LANELIIAworWCHYG/RZsioSGhESObAqL7S/Ks8qAl2yHgEKK1gh2Bv0WbASELIiAQorWCHYG/RZsiUSGhESObAaELImAQorWCHYG/RZMDElBgczBwYVFDMyNxcGIyImNTQ3JgA1NTQ2NjMyEhEVIRYWMzI2NwEiBgchNSYmA+VHcwE6cU4wNA1GWllnYtr+9XvdgdPq/SMEs4piiDP+wnCYEgIeCIi9bjYtW1ZIGnksaFZsWgQBIe8hof2P/ur+/U2gxVBCAqGjkw6NmwD//wCpAAAERgdCAiYAKQAAAQcAngCqAUMAFACwAEVYsAYvG7EGHD5ZsREG9DAx//8AXf/sA/MGAAImAEkAAAEGAJ50AQAUALAARViwCC8bsQgYPlmxIgH0MDH//wB6/+wE3AdXAiYAKwAAAQcAnQDIAVcAFACwAEVYsAsvG7ELHD5ZsSIG9DAx//8AYP5WA/IGAAImAEsAAAEGAJ1VAAAUALAARViwAy8bsQMYPlmxJwH0MDH//wB6/+wE3AcvAiYAKwAAAQcAoADzAVgAEwCwAEVYsAsvG7ELHD5ZsCLcMDEA//8AYP5WA/IF2AImAEsAAAEHAKAAgAABABMAsABFWLADLxuxAxg+WbAn3DAxAP//AHr/7ATcBxkCJgArAAABBwChAaYBVwAUALAARViwCy8bsQscPlmxJwT0MDH//wBg/lYD8gXCAiYASwAAAQcAoQEzAAAAFACwAEVYsAMvG7EDGD5ZsSwB9DAx//8Aev3/BNwFxAImACsAAAAHAaIBo/6g//8AYP5WA/IGkwImAEsAAAEHAbkBKwBYABMAsABFWLADLxuxAxg+WbAq3DAxAP//AKkAAAUIB0ICJgAsAAABBwCdAPEBQgAUALAARViwBy8bsQccPlmxEAb0MDH//wCMAAAD3wdBAiYATAAAAQcAnQAdAUEACQCwES+wFNwwMQD///+3AAACegcuAiYALQAAAQcApP88AUYAFACwAEVYsAMvG7EDHD5ZsQcE9DAx////nQAAAmAF6gImAIwAAAEHAKT/IgACABQAsABFWLADLxuxAxg+WbEHAfQwMf///7YAAAKABvoCJgAtAAABBwBw/z4BSgATALAARViwAi8bsQIcPlmwBdwwMQD///+cAAACZgW2AiYAjAAAAQcAcP8kAAYAEwCwAEVYsAIvG7ECGD5ZsAXcMDEA////7AAAAkMHGgImAC0AAAEHAKD/awFDABMAsABFWLACLxuxAhw+WbAH3DAxAP///9IAAAIpBdcCJgCMAAABBwCg/1EAAAATALAARViwAi8bsQIYPlmwB9wwMQD//wAY/lgBeAWwAiYALQAAAAYAo+YJ////+/5PAWgFxAImAE0AAAAGAKPJAP//AKoAAAGFBwQCJgAtAAABBwChAB0BQgAUALAARViwAi8bsQIcPlmxCwT0MDH//wC3/+wF+QWwACYALQAAAAcALgItAAD//wCN/ksDSgXEACYATQAAAAcATgHxAAD//wA1/+wEggc1AiYALgAAAQcAnQF8ATUAFACwAEVYsAAvG7EAHD5ZsRQG9DAx////tP5LAjkF2AImAJsAAAEHAJ3/M//YABQAsABFWLANLxuxDRg+WbESBPQwMf//AKn9/wUFBbACJgAvAAAABwGiAZT+oP//AI39/wQMBgACJgBPAAAABwGiARH+oP//AKEAAAQcBy8CJgAwAAABBwB1ACYBMQAUALAARViwBS8bsQUcPlmxCAj0MDH//wCTAAACNAeUAiYAUAAAAQcAdQAYAZYAFACwAEVYsAMvG7EDHj5ZsQYJ9DAx//8Aqf3/BBwFsAImADAAAAAHAaIBbP6g//8AV/3/AVUGAAImAFAAAAAHAaL/+/6g//8AqQAABBwFsQImADAAAAEHAaIB1QTCABAAsABFWLAKLxuxChw+WTAx//8AnAAAAq0GAgAmAFAAAAEHAaIBVgUTAFAAsh8IAV2ynwgBXbQfCC8IAnGyrwgBcbQvCD8IAnKy3wgBcrZfCG8IfwgDcrTPCN8IAnGyTwgBcbLPCAFdtE8IXwgCXbJgCAFdsvAIAXIwMf//AKkAAAQcBbACJgAwAAAABwChAbz9xf//AJwAAAKgBgAAJgBQAAAABwChATj9tv//AKkAAAUIBzQCJgAyAAABBwB1AfUBNgAUALAARViwCC8bsQgcPlmxDAj0MDH//wCMAAAD3wX+AiYAUgAAAQcAdQFbAAAAFACwAEVYsAMvG7EDGD5ZsRQJ9DAx//8Aqf3/BQgFsAImADIAAAAHAaIB0P6g//8AjP3/A98ETgImAFIAAAAHAaIBM/6g//8AqQAABQgHNgImADIAAAEHAJ4BFQE3ABQAsABFWLAGLxuxBhw+WbEPBvQwMf//AIwAAAPfBgACJgBSAAABBgCeewEAFACwAEVYsAMvG7EDGD5ZsRYB9DAx////vAAAA98GBAImAFIAAAEHAaL/YAUVAAYAsBcvMDH//wB2/+wFCQbwAiYAMwAAAQcAcADpAUAAEwCwAEVYsA0vG7ENHD5ZsCHcMDEA//8AW//sBDQFuAImAFMAAAEGAHBmCAATALAARViwBC8bsQQYPlmwHdwwMQD//wB2/+wFCQcQAiYAMwAAAQcAoAEWATkAEwCwAEVYsA0vG7ENHD5ZsCLcMDEA//8AW//sBDQF2AImAFMAAAEHAKAAkwABABMAsABFWLAELxuxBBg+WbAf3DAxAP//AHb/7AUJBzcCJgAzAAABBwClAWsBOAAXALAARViwDS8bsQ0cPlmxJgj0sCLQMDEA//8AW//sBDQF/wImAFMAAAEHAKUA6AAAABcAsABFWLAELxuxBBg+WbEiCfSwHtAwMQD//wCoAAAEyQc0AiYANgAAAQcAdQGAATYAFACwAEVYsAQvG7EEHD5ZsRoI9DAx//8AjAAAAtIF/gImAFYAAAEHAHUAtgAAABQAsABFWLALLxuxCxg+WbEQCfQwMf//AKj9/wTJBbACJgA2AAAABwGiAWP+oP//AFP9/wKXBE4CJgBWAAAABwGi//f+oP//AKgAAATJBzYCJgA2AAABBwCeAKABNwAUALAARViwBC8bsQQcPlmxHQb0MDH//wBjAAACzQYAAiYAVgAAAQYAntcBABQAsABFWLALLxuxCxg+WbESAfQwMf//AFD/7ARyBzYCJgA3AAABBwB1AY0BOAAUALAARViwBi8bsQYcPlmxKQj0MDH//wBf/+wDuwX+AiYAVwAAAQcAdQFRAAAAFACwAEVYsAkvG7EJGD5ZsSkJ9DAx//8AUP/sBHIHOAImADcAAAEHAJ0AlwE4ABQAsABFWLAGLxuxBhw+WbEpBvQwMf//AF//7AO7BgACJgBXAAABBgCdWwAAFACwAEVYsAkvG7EJGD5ZsSkB9DAx//8AUP5NBHIFxAImADcAAAAHAHkBnwAA//8AX/5FA7sETgImAFcAAAAHAHkBXf/4//8AUP3/BHIFxAImADcAAAAHAaIBdf6g//8AX/3/A7sETgImAFcAAAAHAaIBM/6g//8AUP/sBHIHOAImADcAAAEHAJ4ArQE5ABQAsABFWLAGLxuxBhw+WbErBvQwMf//AF//7AO7BgACJgBXAAABBgCecQEAFACwAEVYsAkvG7EJGD5ZsSsB9DAx//8AMf3/BJcFsAImADgAAAAHAaIBZv6g//8ACf3/AlYFQAImAFgAAAAHAaIAxf6g//8AMf5NBJcFsAImADgAAAAHAHkBkAAA//8ACf5NApkFQAImAFgAAAAHAHkA7wAA//8AMQAABJcHNgImADgAAAEHAJ4AogE3ABQAsABFWLAGLxuxBhw+WbENBvQwMf//AAn/7ALsBnkAJgBYAAAABwGiAZUFiv//AIz/7ASqByICJgA5AAABBwCkAMABOgAUALAARViwEi8bsRIcPlmxFgT0MDH//wCI/+wD3AXsAiYAWQAAAQYApFwEABQAsABFWLANLxuxDRg+WbEUAfQwMf//AIz/7ASqBu4CJgA5AAABBwBwAMIBPgATALAARViwEi8bsRIcPlmwE9wwMQD//wCI/+wD3AW4AiYAWQAAAQYAcF4IABMAsABFWLAHLxuxBxg+WbAS3DAxAP//AIz/7ASqBw4CJgA5AAABBwCgAO8BNwATALAARViwCi8bsQocPlmwFtwwMQD//wCI/+wD3AXYAiYAWQAAAQcAoACLAAEAEwCwAEVYsAcvG7EHGD5ZsBTcMDEA//8AjP/sBKoHkQImADkAAAEHAKIBSwFBABcAsABFWLAKLxuxChw+WbEWBvSwINAwMQD//wCI/+wD3AZbAiYAWQAAAQcAogDnAAsAFwCwAEVYsAcvG7EHGD5ZsRQE9LAe0DAxAP//AIz/7ASqBzUCJgA5AAABBwClAUQBNgAXALAARViwEi8bsRIcPlmxFQj0sBnQMDEA//8AiP/sBAwF/wImAFkAAAEHAKUA4AAAABcAsABFWLANLxuxDRg+WbETCfSwF9AwMQAAAQCM/nsEqgWwACAAUwCwAEVYsBgvG7EYHD5ZsABFWLANLxuxDRI+WbAARViwEy8bsRMQPlmwGBCwINCyBBMgERI5sA0QsggDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREGBgcGFRQzMjcXBiMiJjU0NwciACcRMxEUFjMyNjURBKoBioObTjA0DUZaWWdPFu/+5AK+rqGjrQWw/CGU4jtyYEgaeSxoVmFTAQEC4gPg/Caer66eA9sAAQCI/k8D5gQ6AB8AbQCwAEVYsBcvG7EXGD5ZsABFWLAdLxuxHRg+WbAARViwHy8bsR8QPlmwAEVYsBIvG7ESED5ZsABFWLAKLxuxChI+WbIFAworWCHYG/RZsB8QsA/QsA8vshASHRESObASELIaAQorWCHYG/RZMDEhBwYVFDMyNxcGIyImNTQ3JwYjIiYnETMRFDMyNxEzEQPSOnFOMDQNRlpZZ6YEbNGttQG5yNRGuS1bVkgaeSxoVo9qZX/JxQLA/UX2ngMT+8b//wA9AAAG7Qc2AiYAOwAAAQcAnQHFATYAFACwAEVYsAMvG7EDHD5ZsRcG9DAx//8AKwAABdMGAAImAFsAAAEHAJ0BJAAAABQAsABFWLAMLxuxDBg+WbEPAfQwMf//AA8AAAS7BzYCJgA9AAABBwCdAJIBNgAUALAARViwAS8bsQEcPlmxCwb0MDH//wAW/ksDsAYAAiYAXQAAAQYAnSUAABQAsABFWLAPLxuxDxg+WbEUAfQwMf//AA8AAAS7BvsCJgA9AAABBwBqAMIBNgAXALAARViwCC8bsQgcPlmxEAT0sBnQMDEA//8AVgAABHoHNAImAD4AAAEHAHUBhwE2ABQAsABFWLAHLxuxBxw+WbEMCPQwMf//AFgAAAOzBf4CJgBeAAABBwB1ASEAAAAUALAARViwBy8bsQcYPlmxDAn0MDH//wBWAAAEegb4AiYAPgAAAQcAoQFvATYAFACwAEVYsAcvG7EHHD5ZsREE9DAx//8AWAAAA7MFwgImAF4AAAEHAKEBCQAAABQAsABFWLAHLxuxBxg+WbERAfQwMf//AFYAAAR6BzYCJgA+AAABBwCeAKcBNwAUALAARViwBy8bsQccPlmxDwb0MDH//wBYAAADswYAAiYAXgAAAQYAnkEBABQAsABFWLAHLxuxBxg+WbEPAfQwMf////IAAAdXB0ACJgCBAAABBwB1AskBQgAUALAARViwBi8bsQYcPlmxFQj0MDH//wBO/+wGfAX/AiYAhgAAAQcAdQJ6AAEAFACwAEVYsB0vG7EdGD5ZsUAJ9DAx//8Adv+jBR0HfgImAIMAAAEHAHUB6QGAABQAsABFWLAQLxuxEBw+WbEsCPQwMf//AFv/egQ0Bf4CJgCJAAABBwB1ATcAAAAUALAARViwBC8bsQQYPlmxKQn0MDH///++AAAEHwSNAiYBvQAAAQcB3v8v/3gALACyHxgBcbTfGO8YAnG0HxgvGAJdsh8YAXKyTxgBcbTvGP8YAl2yXxgBXTAx////vgAABB8EjQImAb0AAAEHAd7/L/94ADYAtO8X/xcCXbJPFwFxsh8XAXKy3xcBcrJvFwFytN8X7xcCcbIfFwFxsl8XAV20HxcvFwJdMDH//wAoAAAD/QSNAiYBzQAAAQYB3kXgAA0AsgMKAV2ysAoBXTAxAP//ABMAAARwBhwCJgG6AAABBwBEANUAHgAUALAARViwBC8bsQQaPlmxDAb0MDH//wATAAAEcAYcAiYBugAAAQcAdQFkAB4AFACwAEVYsAUvG7EFGj5ZsQ0G9DAx//8AEwAABHAGHgImAboAAAEGAJ1uHgAUALAARViwBC8bsQQaPlmxDwT0MDH//wATAAAEcAYKAiYBugAAAQYApGoiABQAsABFWLAFLxuxBRo+WbEOAvQwMf//ABMAAARwBeMCJgG6AAABBwBqAJ4AHgAXALAARViwBC8bsQQaPlmxEgL0sBvQMDEA//8AEwAABHAGeQImAboAAAEHAKIA9QApABcAsABFWLAELxuxBBo+WbEOBvSwGNAwMQD//wATAAAEcAZ8AiYBugAAAAcB3wD/AAr//wBg/koEMASdAiYBvAAAAAcAeQF0//3//wCKAAADrgYcAiYBvgAAAQcARACoAB4AFACwAEVYsAYvG7EGGj5ZsQ0G9DAx//8AigAAA64GHAImAb4AAAEHAHUBNwAeABQAsABFWLAHLxuxBxo+WbEOBvQwMf//AIoAAAOuBh4CJgG+AAABBgCdQR4AFACwAEVYsAYvG7EGGj5ZsRAE9DAx//8AigAAA64F4wImAb4AAAEGAGpxHgAXALAARViwBi8bsQYaPlmxEwL0sBzQMDEA////vgAAAV8GHAImAcIAAAEGAESFHgAUALAARViwAi8bsQIaPlmxBQb0MDH//wCOAAACLwYcAiYBwgAAAQYAdRMeABQAsABFWLADLxuxAxo+WbEGBvQwMf///8cAAAIkBh4CJgHCAAABBwCd/x4AHgAUALAARViwAi8bsQIaPlmxCAT0MDH///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AIoAAARYBgoCJgHHAAABBwCkAJUAIgAUALAARViwBi8bsQYaPlmxDQL0MDH//wBg//AEWgYcAiYByAAAAQcARADuAB4AFACwAEVYsAovG7EKGj5ZsR0G9DAx//8AYP/wBFoGHAImAcgAAAEHAHUBfQAeABQAsABFWLAKLxuxCho+WbEeBvQwMf//AGD/8ARaBh4CJgHIAAABBwCdAIcAHgAUALAARViwCi8bsQoaPlmxIAT0MDH//wBg//AEWgYKAiYByAAAAQcApACDACIAFACwAEVYsAovG7EKGj5ZsR8C9DAx//8AYP/wBFoF4wImAcgAAAEHAGoAtwAeABcAsABFWLAKLxuxCho+WbEjAvSwLNAwMQD//wB0//AECgYcAiYBzgAAAQcARADPAB4AFACwAEVYsAkvG7EJGj5ZsRMG9DAx//8AdP/wBAoGHAImAc4AAAEHAHUBXgAeABQAsABFWLARLxuxERo+WbEUBvQwMf//AHT/8AQKBh4CJgHOAAABBgCdaB4AFACwAEVYsAkvG7EJGj5ZsRYE9DAx//8AdP/wBAoF4wImAc4AAAEHAGoAmAAeABcAsABFWLAJLxuxCRo+WbEZAvSwItAwMQD//wANAAAEHAYcAiYB0gAAAQcAdQEzAB4AFACwAEVYsAEvG7EBGj5ZsQsG9DAx//8AEwAABHAF1gImAboAAAEGAHBsJgATALAARViwBC8bsQQaPlmwDNwwMQD//wATAAAEcAX2AiYBugAAAQcAoACZAB8AFACwAEVYsAQvG7EEGj5ZsQ4I9DAxAAIAE/5PBHAEjQAWABkAZwCwAEVYsAAvG7EAGj5ZsABFWLAULxuxFBA+WbAARViwAS8bsQEQPlmwAEVYsAwvG7EMEj5ZsgcDCitYIdgb9FmwARCwEdCwES+yFxQAERI5sBcvshMBCitYIdgb9FmyGQAUERI5MDEBASMHBhUUMzI3FwYjIiY1NDcDIQMjAQMhAwKYAdgmOnFOMDQNRlpZZ7Bo/fhuvQHfeAGRxwSN+3MtW1ZIGnksaFaUbAEK/ukEjf0hAf0A//8AYP/wBDAGHAImAbwAAAEHAHUBaQAeABQAsABFWLALLxuxCxo+WbEfBvQwMf//AGD/8AQwBh4CJgG8AAABBgCdcx4AFACwAEVYsAsvG7ELGj5ZsSEE9DAx//8AYP/wBDAF4AImAbwAAAEHAKEBUQAeABQAsABFWLALLxuxCxo+WbEjAvQwMf//AGD/8AQwBh4CJgG8AAABBwCeAIkAHwAUALAARViwCy8bsQsaPlmxIQb0MDH//wCKAAAEHwYeAiYBvQAAAQYAnjIfABQAsABFWLABLxuxARo+WbEaBvQwMf//AIoAAAOuBdYCJgG+AAABBgBwPyYAEwCwAEVYsAYvG7EGGj5ZsA3cMDEA//8AigAAA64F9gImAb4AAAEGAKBsHwAUALAARViwBi8bsQYaPlmxDwj0MDH//wCKAAADrgXgAiYBvgAAAQcAoQEfAB4AFACwAEVYsAYvG7EGGj5ZsRMC9DAxAAEAiv5PA64EjQAbAHgAsABFWLAWLxuxFho+WbAARViwFC8bsRQQPlmwAEVYsA8vG7EPEj5ZsBQQsBvQsBsvsh8bAV2y3xsBXbIAAQorWCHYG/RZsBQQsgIBCitYIdgb9FmwFBCwBdCwDxCyCgMKK1gh2Bv0WbAWELIZAQorWCHYG/RZMDEBIREhFSMHBhUUMzI3FwYjIiY1NDchESEVIREhA1f97AJrPTpxTjA0DUZaWWeb/coDHv2bAhQCDv6Jly1bVkgaeSxoVoppBI2Z/rIA//8AigAAA64GHgImAb4AAAEGAJ5XHwAUALAARViwBi8bsQYaPlmxEQb0MDH//wBj//AENQYeAiYBwAAAAQYAnXEeABQAsABFWLAKLxuxCho+WbEgBPQwMf//AGP/8AQ1BfYCJgHAAAABBwCgAJwAHwAUALAARViwCi8bsQoaPlmxIAj0MDH//wBj//AENQXgAiYBwAAAAQcAoQFPAB4AFACwAEVYsAovG7EKGj5ZsSUC9DAx//8AY/38BDUEnQImAcAAAAAHAaIBT/6d//8AigAABFgGHgImAcEAAAEHAJ0AkAAeABQAsABFWLAHLxuxBxo+WbEQBPQwMf///5UAAAJYBgoCJgHCAAABBwCk/xoAIgAUALAARViwAy8bsQMaPlmxBwL0MDH///+UAAACXgXWAiYBwgAAAQcAcP8cACYAEwCwAEVYsAIvG7ECGj5ZsAXcMDEA////ygAAAiEF9gImAcIAAAEHAKD/SQAfABQAsABFWLACLxuxAho+WbEHCPQwMf//AAb+TwFmBI0CJgHCAAAABgCj1AD//wCJAAABZAXgAiYBwgAAAQYAofweABQAsABFWLACLxuxAho+WbELAvQwMf//ACv/8AQNBh4CJgHDAAABBwCdAQcAHgAUALAARViwAC8bsQAaPlmxFAT0MDH//wCK/fwEVwSNAiYBxAAAAAcBogEU/p3//wCCAAADiwYcAiYBxQAAAQYAdQceABQAsABFWLAFLxuxBRo+WbEIBvQwMf//AIr9/AOLBI0CJgHFAAAABwGiARD+nf//AIoAAAOLBI4CJgHFAAABBwGiAX4DnwAQALAARViwCi8bsQoaPlkwMf//AIoAAAOLBI0CJgHFAAAABwChAWb9N///AIoAAARYBhwCJgHHAAABBwB1AY8AHgAUALAARViwCC8bsQgaPlmxDAb0MDH//wCK/fwEWASNAiYBxwAAAAcBogFs/p3//wCKAAAEWAYeAiYBxwAAAQcAngCvAB8AFACwAEVYsAYvG7EGGj5ZsQ8G9DAx//8AYP/wBFoF1gImAcgAAAEHAHAAhQAmABMAsABFWLAKLxuxCho+WbAd3DAxAP//AGD/8ARaBfYCJgHIAAABBwCgALIAHwAUALAARViwCi8bsQoaPlmxHwj0MDH//wBg//AEWgYdAiYByAAAAQcApQEHAB4AFwCwAEVYsAovG7EKGj5ZsR4G9LAi0DAxAP//AIoAAAQlBhwCJgHLAAABBwB1AScAHgAUALAARViwBS8bsQUaPlmxGQb0MDH//wCK/fwEJQSNAiYBywAAAAcBogEN/p3//wCKAAAEJQYeAiYBywAAAQYAnkcfABQAsABFWLAELxuxBBo+WbEcBvQwMf//AEP/8APdBhwCJgHMAAABBwB1AT4AHgAUALAARViwCS8bsQkaPlmxKAb0MDH//wBD//AD3QYeAiYBzAAAAQYAnUgeABQAsABFWLAJLxuxCRo+WbEqBPQwMf//AEP+TQPdBJ0CJgHMAAAABwB5AVMAAP//AEP/8APdBh4CJgHMAAABBgCeXh8AFACwAEVYsAkvG7EJGj5ZsSoG9DAx//8AKP38A/0EjQImAc0AAAAHAaIBFP6d//8AKAAAA/0GHgImAc0AAAEGAJ5RHwAUALAARViwBi8bsQYaPlmxDQb0MDH//wAo/k8D/QSNAiYBzQAAAAcAeQE+AAL//wB0//AECgYKAiYBzgAAAQYApGQiABQAsABFWLARLxuxERo+WbEVAvQwMf//AHT/8AQKBdYCJgHOAAABBgBwZiYAEwCwAEVYsAkvG7EJGj5ZsBPcMDEA//8AdP/wBAoF9gImAc4AAAEHAKAAkwAfABQAsABFWLAJLxuxCRo+WbEVCPQwMf//AHT/8AQKBnkCJgHOAAABBwCiAO8AKQAXALAARViwCS8bsQkaPlmxFQb0sB/QMDEA//8AdP/wBBQGHQImAc4AAAEHAKUA6AAeABcAsABFWLARLxuxERo+WbEUBvSwGNAwMQAAAQB0/nQECgSNACAAUwCwAEVYsBgvG7EYGj5ZsABFWLAOLxuxDhI+WbAARViwEy8bsRMQPlmwGBCwINCyBRMgERI5sA4QsgkDCitYIdgb9FmwExCyHAEKK1gh2Bv0WTAxAREUBgcHBhUUMzI3FwYjIiY1NDciJicRMxEUFjMyNjURBAp4bzJsTjA0DUZaWWdazfkEt4+Fg48EjfzzerowKFtSSBp5LGhWaFbOuAMX/PR5gX97AwwA//8AMQAABfEGHgImAdAAAAEHAJ0BOwAeABQAsABFWLADLxuxAxo+WbEXBPQwMf//AA0AAAQcBh4CJgHSAAABBgCdPR4AFACwAEVYsAgvG7EIGj5ZsQ0E9DAx//8ADQAABBwF4wImAdIAAAEGAGptHgAXALAARViwCC8bsQgaPlmxEAL0sBnQMDEA//8ARwAAA+AGHAImAdMAAAEHAHUBMwAeABQAsABFWLAILxuxCBo+WbEMBvQwMf//AEcAAAPgBeACJgHTAAABBwChARsAHgAUALAARViwBy8bsQcaPlmxEQL0MDH//wBHAAAD4AYeAiYB0wAAAQYAnlMfABQAsABFWLAHLxuxBxo+WbEPBvQwMf//ABwAAAUdBj8CJgAlAAAABgCtBAD////wAAAEqgY/ACYAKWQAAAcArf85AAD////+AAAFbAZBACYALGQAAAcArf9HAAL//wAEAAAB2wZAACYALWQAAAcArf9NAAH////6/+wFHQY/ACYAMxQAAAcArf9DAAD///94AAAFHwY/ACYAPWQAAAcArf7BAAD////9AAAE3wY/ACYAuRQAAAcArf9GAAD///+b//QCrQZ0AiYAwgAAAQcArv8q/+wAHQCwAEVYsAwvG7EMGD5ZsRgB9LAP0LAYELAh0DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AqQAABEYFsAIGACkAAP//AFYAAAR6BbACBgA+AAD//wCpAAAFCAWwAgYALAAA//8AtwAAAXcFsAIGAC0AAP//AKkAAAUFBbACBgAvAAD//wCpAAAGUgWwAgYAMQAA//8AqQAABQgFsAIGADIAAP//AHb/7AUJBcQCBgAzAAD//wCpAAAEwAWwAgYANAAA//8AMQAABJcFsAIGADgAAP//AA8AAAS7BbACBgA9AAD//wA5AAAEzgWwAgYAPAAA////1gAAAl8HBwImAC0AAAEHAGr/cAFCABcAsABFWLACLxuxAhw+WbELBPSwFNAwMQD//wAPAAAEuwb7AiYAPQAAAQcAagDCATYAFwCwAEVYsAgvG7EIHD5ZsRAE9LAZ0DAxAP//AGT/6wR3BjoCJgC6AAABBwCtAXX/+wAUALAARViwEy8bsRMYPlmxJAH0MDH//wBj/+wD7AY5AiYAvgAAAQcArQEr//oAFACwAEVYsBUvG7EVGD5ZsSgB9DAx//8Akf5hA/AGOgImAMAAAAEHAK0BRv/7ABQAsABFWLADLxuxAxg+WbEVAfQwMf//AMP/9AJLBiUCJgDCAAABBgCtKuYAFACwAEVYsAwvG7EMGD5ZsQ8B9DAx//8Aj//sA/YGdAImAMoAAAEGAK4h7AAdALAARViwAC8bsQAYPlmxHQH0sBXQsB0QsCfQMDEA//8AmgAABD8EOgIGAI0AAP//AFv/7AQ0BE4CBgBTAAD//wCa/mAD7gQ6AgYAdgAA//8AIQAAA7oEOgIGAFoAAP//ACkAAAPKBDoCBgBcAAD////m//QCbwWxAiYAwgAAAQYAaoDsABcAsABFWLAMLxuxDBg+WbEUAfSwHdAwMQD//wCP/+wD9gWxAiYAygAAAQYAanfsABcAsABFWLAALxuxABg+WbEaAfSwI9AwMQD//wBb/+wENAY6AiYAUwAAAQcArQFD//sAFACwAEVYsAQvG7EEGD5ZsR4B9DAx//8Aj//sA/YGJQImAMoAAAEHAK0BIv/mABQAsABFWLAALxuxABg+WbEVAfQwMf//AHr/7AYZBiICJgDNAAABBwCtAlP/4wAUALAARViwAC8bsQAYPlmxJgH0MDH//wCpAAAERgcHAiYAKQAAAQcAagDEAUIAFwCwAEVYsAYvG7EGHD5ZsRME9LAc0DAxAP//ALEAAAQwB0ACJgCwAAABBwB1AZABQgAUALAARViwBC8bsQQcPlmxCAj0MDEAAQBQ/+wEcgXEACYAYbIAJygREjkAsABFWLAGLxuxBhw+WbAARViwGi8bsRoQPlmwBhCwC9CwBhCyDgEKK1gh2Bv0WbImGgYREjmwJhCyFAEKK1gh2Bv0WbAaELAf0LAaELIiAQorWCHYG/RZMDEBJiY1NCQzMhYWFSM0JiMiBhUUFgQWFhUUBCMiJCY1MxQWMzI2NCYCVvfhARPcluuBwaiZjp+XAWvNY/7s55b+/I3Bw6OYopYCiUfPmKzhdMx5hJd9b1l7Znukb7HVc8h/hJl81nUA//8AtwAAAXcFsAIGAC0AAP///9YAAAJfBwcCJgAtAAABBwBq/3ABQgAXALAARViwAi8bsQIcPlmxCwT0sBTQMDEA//8ANf/sA8wFsAIGAC4AAP//ALIAAAUdBbACBgHjAAD//wCpAAAFBQcuAiYALwAAAQcAdQF7ATAAFACwAEVYsAUvG7EFHD5ZsQ4I9DAx//8ATf/rBMsHGgImAN0AAAEHAKAA2gFDABMAsABFWLARLxuxERw+WbAV3DAxAP//ABwAAAUdBbACBgAlAAD//wCpAAAEiAWwAgYAJgAA//8AsQAABDAFsAIGALAAAP//AKkAAARGBbACBgApAAD//wCxAAAE/wcaAiYA2wAAAQcAoAExAUMAEwCwAEVYsAgvG7EIHD5ZsA3cMDEA//8AqQAABlIFsAIGADEAAP//AKkAAAUIBbACBgAsAAD//wB2/+wFCQXEAgYAMwAA//8AsgAABQEFsAIGALUAAP//AKkAAATABbACBgA0AAD//wB3/+wE2AXEAgYAJwAA//8AMQAABJcFsAIGADgAAP//ADkAAATOBbACBgA8AAD//wBt/+wD6gROAgYARQAA//8AXf/sA/METgIGAEkAAP//AJwAAAQBBcQCJgDvAAABBwCgAKL/7QATALAARViwCC8bsQgYPlmwDdwwMQD//wBb/+wENAROAgYAUwAA//8AjP5gBB4ETgIGAFQAAAABAFz/7APsBE4AHQBJshAeHxESOQCwAEVYsBAvG7EQGD5ZsABFWLAILxuxCBA+WbIAAQorWCHYG/RZsAgQsAPQsBAQsBTQsBAQshcBCitYIdgb9FkwMSUyNjczDgIjIgARNTQ2NjMyFhcjJiYjIgYVFRQWAj5jlAivBXbFbt3++3TZlLbxCK8Ij2mNm5qDeFpdqGQBJwEAH572iNquaYfLwCO7ygD//wAW/ksDsAQ6AgYAXQAA//8AKQAAA8oEOgIGAFwAAP//AF3/7APzBcUCJgBJAAABBwBqAI4AAAAXALAARViwCC8bsQgYPlmxJQH0sC7QMDEA//8AmgAAA0cF6gImAOsAAAEHAHUAzf/sABQAsABFWLAELxuxBBg+WbEICfQwMf//AF//7AO7BE4CBgBXAAD//wCNAAABaAXEAgYATQAA////vAAAAkUFxAImAIwAAAEHAGr/Vv//ABcAsABFWLACLxuxAhg+WbELAfSwFNAwMQD///+//ksBWQXEAgYATgAA//8AnAAABD8F6QImAPAAAAEHAHUBO//rABQAsABFWLAELxuxBBg+WbEPCfQwMf//ABb+SwOwBdgCJgBdAAABBgCgUAEAEwCwAEVYsA8vG7EPGD5ZsBPcMDEA//8APQAABu0HNAImADsAAAEHAEQCLAE2ABQAsABFWLADLxuxAxw+WbEUCPQwMf//ACsAAAXTBf4CJgBbAAABBwBEAYsAAAAUALAARViwCy8bsQsYPlmxDgn0MDH//wA9AAAG7Qc0AiYAOwAAAQcAdQK7ATYAFACwAEVYsAQvG7EEHD5ZsRUI9DAx//8AKwAABdMF/gImAFsAAAEHAHUCGgAAABQAsABFWLAMLxuxDBg+WbEPCfQwMf//AD0AAAbtBvsCJgA7AAABBwBqAfUBNgAXALAARViwAy8bsQMcPlmxGgT0sCPQMDEA//8AKwAABdMFxQImAFsAAAEHAGoBVAAAABcAsABFWLALLxuxCxg+WbEUAfSwHdAwMQD//wAPAAAEuwc0AiYAPQAAAQcARAD5ATYAFACwAEVYsAgvG7EIHD5ZsQoI9DAx//8AFv5LA7AF/gImAF0AAAEHAEQAjAAAABQAsABFWLAPLxuxDxg+WbERCfQwMf//AGcEIQD9BgACBgALAAD//wCIBBICIwYAAgYABgAA//8AoP/1A4oFsAAmAAUAAAAHAAUCDwAA////tP5LAj8F2AImAJsAAAEHAJ7/Sf/ZABQAsABFWLANLxuxDRg+WbETAfQwMf//ADAEFgFHBgACBgFtAAD//wCpAAAGUgc0AiYAMQAAAQcAdQKZATYAFACwAEVYsAIvG7ECHD5ZsREI9DAx//8AiwAABngF/gImAFEAAAEHAHUCrQAAABQAsABFWLADLxuxAxg+WbEgCfQwMf//ABz+awUdBbACJgAlAAAABwCmAX8AAP//AG3+awPqBE4CJgBFAAAABwCmAMcAAP//AKkAAARGB0ACJgApAAABBwBEAPsBQgAUALAARViwBi8bsQYcPlmxDQj0MDH//wCxAAAE/wdAAiYA2wAAAQcARAFtAUIAFACwAEVYsAgvG7EIHD5ZsQsI9DAx//8AXf/sA/MF/gImAEkAAAEHAEQAxQAAABQAsABFWLAILxuxCBg+WbEfCfQwMf//AJwAAAQBBeoCJgDvAAABBwBEAN7/7AAUALAARViwCC8bsQgYPlmxCwn0MDH//wBaAAAFIQWwAgYAuAAA//8AX/4oBUMEOgIGAMwAAP//ABYAAATdBugCJgEYAAABBwCrBDkA+gAXALAARViwDy8bsQ8cPlmxEQj0sBXQMDEA////+wAABAsFwQImARkAAAEHAKsD1P/TABcAsABFWLARLxuxERg+WbETCfSwF9AwMQD//wBb/ksIQAROACYAUwAAAAcAXQSQAAD//wB2/ksJMAXEACYAMwAAAAcAXQWAAAD//wBQ/lEEagXEAiYA2gAAAAcBsAGc/7j//wBY/lIDrARNAiYA7gAAAAcBsAFD/7n//wB3/lEE2AXEAiYAJwAAAAcBsAHl/7j//wBc/lED7AROAiYARwAAAAcBsAFS/7j//wAPAAAEuwWwAgYAPQAA//8ALv5gA98EOgIGALwAAP//ALcAAAF3BbACBgAtAAD//wAbAAAHNQcaAiYA2QAAAQcAoAH4AUMAEwCwAEVYsA0vG7ENHD5ZsBncMDEA//8AFQAABgQFxAImAO0AAAEHAKABX//tABMAsABFWLANLxuxDRg+WbAZ3DAxAP//ALcAAAF3BbACBgAtAAD//wAcAAAFHQcOAiYAJQAAAQcAoAD0ATcAEwCwAEVYsAQvG7EEHD5ZsA7cMDEA//8Abf/sA+oF2AImAEUAAAEHAKAAmQABABMAsABFWLAXLxuxFxg+WbAs3DAxAP//ABwAAAUdBvsCJgAlAAABBwBqAPkBNgAUALAARViwBC8bsQQcPlmxEgT0MDH//wBt/+wD6gXFAiYARQAAAQcAagCeAAAAFwCwAEVYsBcvG7EXGD5ZsTAB9LA50DAxAP////IAAAdXBbACBgCBAAD//wBO/+wGfAROAgYAhgAA//8AqQAABEYHGgImACkAAAEHAKAAvwFDABMAsABFWLAGLxuxBhw+WbAP3DAxAP//AF3/7APzBdgCJgBJAAABBwCgAIkAAQATALAARViwCC8bsQgYPlmwIdwwMQD//wBd/+wFEgbZAiYBRQAAAQcAagDTARQAFwCwAEVYsAAvG7EAHD5ZsScE9LAw0DAxAP//AGL/7APpBE8CBgCcAAD//wBi/+wD6QXGAiYAnAAAAQcAagCHAAEAFwCwAEVYsAAvG7EAGD5ZsSQB9LAt0DAxAP//ABsAAAc1BwcCJgDZAAABBwBqAf0BQgAXALAARViwDS8bsQ0cPlmxHQT0sCbQMDEA//8AFQAABgQFsQImAO0AAAEHAGoBZP/sABcAsABFWLANLxuxDRg+WbEdAfSwJtAwMQD//wBQ/+wEagccAiYA2gAAAQcAagC3AVcAFwCwAEVYsAsvG7ELHD5ZsTAE9LA50DAxAP//AFj/7QOsBcUCJgDuAAABBgBqXgAAFwCwAEVYsAovG7EKGD5ZsS4B9LA30DAxAP//ALEAAAT/BvoCJgDbAAABBwBwAQQBSgATALAARViwCC8bsQgcPlmwC9wwMQD//wCcAAAEAQWkAiYA7wAAAQYAcHX0ABMAsABFWLAHLxuxBxg+WbAL3DAxAP//ALEAAAT/BwcCJgDbAAABBwBqATYBQgAXALAARViwCC8bsQgcPlmxEQT0sBrQMDEA//8AnAAABAEFsQImAO8AAAEHAGoAp//sABcAsABFWLAILxuxCBg+WbERAfSwGtAwMQD//wB2/+wFCQb9AiYAMwAAAQcAagEbATgAFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BcUCJgBTAAABBwBqAJgAAAAXALAARViwBC8bsQQYPlmxIwH0sCzQMDEA//8AZ//sBPoFxAIGARYAAP//AFv/7AQ0BE4CBgEXAAD//wBn/+wE+gcCAiYBFgAAAQcAagEOAT0AFwCwAEVYsA0vG7ENHD5ZsScE9LAw0DAxAP//AFv/7AQ0BccCJgEXAAABBwBqAIgAAgAXALAARViwBC8bsQQYPlmxJAH0sC3QMDEA//8Ak//sBPQHHQImAOYAAAEHAGoBDQFYABcAsABFWLATLxuxExw+WbEnBPSwMNAwMQD//wBk/+wD4AXFAiYA/gAAAQYAanwAABcAsABFWLAILxuxCBg+WbEnAfSwMNAwMQD//wBN/+sEywb6AiYA3QAAAQcAcACtAUoAEwCwAEVYsBEvG7ERHD5ZsBPcMDEA//8AFv5LA7AFuAImAF0AAAEGAHAjCAATALAARViwDi8bsQ4YPlmwEdwwMQD//wBN/+sEywcHAiYA3QAAAQcAagDfAUIAFwCwAEVYsBEvG7ERHD5ZsRkE9LAi0DAxAP//ABb+SwOwBcUCJgBdAAABBgBqVQAAFwCwAEVYsA8vG7EPGD5ZsRcB9LAg0DAxAP//AE3/6wTLB0ECJgDdAAABBwClAS8BQgAXALAARViwAS8bsQEcPlmxFAj0sBjQMDEA//8AFv5LA9EF/wImAF0AAAEHAKUApQAAABcAsABFWLAPLxuxDxg+WbEWCfSwEtAwMQD//wCWAAAEyAcHAiYA4AAAAQcAagEJAUIAFwCwAEVYsAsvG7ELHD5ZsRoE9LAj0DAxAP//AGcAAAO9BbECJgD4AAABBgBqZOwAFwCwAEVYsAkvG7EJGD5ZsRgB9LAh0DAxAP//ALIAAAYwBwcAJgDlDwAAJwAtBLkAAAEHAGoB0wFCABcAsABFWLAKLxuxChw+WbEfBPSwKNAwMQD//wCdAAAFfwWxACYA/QAAACcAjAQqAAABBwBqAW3/7AAXALAARViwCi8bsQoYPlmxHwH0sCjQMDEA//8AOf5LBQ4FsAImADwAAAAHAa8DpwAA//8AKf5LBBwEOgImAFwAAAAHAa8CtQAA//8AX//sA/AGAAIGAEgAAP//AC/+SwWsBbACJgDcAAAABwGvBEUAAP//ACz+SwS7BDoCJgDxAAAABwGvA1QAAP//ABz+ogUdBbACJgAlAAAABwCsBQIAAP//AG3+ogPqBE4CJgBFAAAABwCsBEoAAP//ABwAAAUdB7oCJgAlAAABBwCqBO4BRgAUALAARViwBC8bsQQcPlmxCwj0MDH//wBt/+wD6gaEAiYARQAAAQcAqgSTABAAFACwAEVYsBcvG7EXGD5ZsSkB9DAx//8AHAAABR0HwwImACUAAAEHAbcAwwEuABcAsABFWLAFLxuxBRw+WbEODPSwFNAwMQD//wBt/+wEwAaOAiYARQAAAQYBt2j5ABcAsABFWLAXLxuxFxg+WbEsCPSwMtAwMQD//wAcAAAFHQe/AiYAJQAAAQcBtgDHAT0AFwCwAEVYsAQvG7EEHD5ZsQ4M9LAT0DAxAP///8r/7APqBokCJgBFAAABBgG2bAcAFwCwAEVYsBcvG7EXGD5ZsSwI9LAx0DAxAP//ABwAAAUdB+oCJgAlAAABBwG1AMgBGwAXALAARViwBS8bsQUcPlmxDAz0sCDQMDEA//8Abf/sBFkGtQImAEUAAAEGAbVt5gAXALAARViwFy8bsRcYPlmxKgj0sDDQMDEA//8AHAAABR0H2gImACUAAAEHAbQAxwEGABcAsABFWLAFLxuxBRw+WbEMDPSwFdAwMQD//wBt/+wD6galAiYARQAAAQYBtGzRABcAsABFWLAXLxuxFxg+WbEqCPSwM9AwMQD//wAc/qIFHQc2AiYAJQAAACcAnQDJATYBBwCsBQIAAAAUALAARViwBC8bsQQcPlmxDwb0MDH//wBt/qID6gYAAiYARQAAACYAnW4AAQcArARKAAAAFACwAEVYsBcvG7EXGD5ZsS0B9DAx//8AHAAABR0HtwImACUAAAEHAbMA6gEtABcAsABFWLAELxuxBBw+WbEOB/SwG9AwMQD//wBt/+wD6gaCAiYARQAAAQcBswCP//gAFwCwAEVYsBcvG7EXGD5ZsSwE9LA50DAxAP//ABwAAAUdB7cCJgAlAAABBwG4AOoBLQAXALAARViwBC8bsQQcPlmxDgf0sBzQMDEA//8Abf/sA+oGggImAEUAAAEHAbgAj//4ABcAsABFWLAXLxuxFxg+WbEsBPSwOtAwMQD//wAcAAAFHQhAAiYAJQAAAQcBsgDuAT0AFwCwAEVYsAQvG7EEHD5ZsQ4H9LAn0DAxAP//AG3/7APqBwoCJgBFAAABBwGyAJMABwAXALAARViwFy8bsRcYPlmxLAT0sEXQMDEA//8AHAAABR0IFQImACUAAAEHAbEA7gFFABcAsABFWLAELxuxBBw+WbEOB/SwHNAwMQD//wBt/+wD6gbfAiYARQAAAQcBsQCTAA8AFwCwAEVYsBcvG7EXGD5ZsSwE9LA60DAxAP//ABz+ogUdBw4CJgAlAAAAJwCgAPQBNwEHAKwFAgAAABMAsABFWLAELxuxBBw+WbAO3DAxAP//AG3+ogPqBdgCJgBFAAAAJwCgAJkAAQEHAKwESgAAABMAsABFWLAXLxuxFxg+WbAs3DAxAP//AKn+ogRGBbACJgApAAAABwCsBMAAAP//AF3+ogPzBE4CJgBJAAAABwCsBIwAAP//AKkAAARGB8YCJgApAAABBwCqBLkBUgAUALAARViwBi8bsQYcPlmxDAj0MDH//wBd/+wD8waEAiYASQAAAQcAqgSDABAAFACwAEVYsAgvG7EIGD5ZsR4B9DAx//8AqQAABEYHLgImACkAAAEHAKQAkAFGABQAsABFWLAGLxuxBhw+WbEPBPQwMf//AF3/7APzBewCJgBJAAABBgCkWgQAFACwAEVYsAgvG7EIGD5ZsSEB9DAx//8AqQAABOYHzwImACkAAAEHAbcAjgE6ABcAsABFWLAHLxuxBxw+WbEPDPSwFdAwMQD//wBd/+wEsAaOAiYASQAAAQYBt1j5ABcAsABFWLAILxuxCBg+WbEhCPSwJ9AwMQD////wAAAERgfLAiYAKQAAAQcBtgCSAUkAFwCwAEVYsAYvG7EGHD5ZsQ8M9LAU0DAxAP///7r/7APzBokCJgBJAAABBgG2XAcAFwCwAEVYsAgvG7EIGD5ZsSEI9LAm0DAxAP//AKkAAAR/B/YCJgApAAABBwG1AJMBJwAXALAARViwBi8bsQYcPlmxDwz0sBPQMDEA//8AXf/sBEkGtQImAEkAAAEGAbVd5gAXALAARViwCC8bsQgYPlmxHwj0sCXQMDEA//8AqQAABEYH5gImACkAAAEHAbQAkgESABcAsABFWLAGLxuxBhw+WbEPDPSwFtAwMQD//wBd/+wD8walAiYASQAAAQYBtFzRABcAsABFWLAILxuxCBg+WbEhCPSwKNAwMQD//wCp/qIERgdCAiYAKQAAACcAnQCUAUIBBwCsBMAAAAAUALAARViwBi8bsQYcPlmxEAb0MDH//wBd/qID8wYAAiYASQAAACYAnV4AAQcArASMAAAAFACwAEVYsAgvG7EIGD5ZsSAB9DAx//8AtwAAAfgHxgImAC0AAAEHAKoDZAFSABQAsABFWLACLxuxAhw+WbEECPQwMf//AJsAAAHeBoICJgCMAAABBwCqA0oADgAUALAARViwAi8bsQIYPlmxBAH0MDH//wCj/qIBfgWwAiYALQAAAAcArANrAAD//wCF/qIBaAXEAiYATQAAAAcArANNAAD//wB2/qIFCQXEAiYAMwAAAAcArAUYAAD//wBb/qIENAROAiYAUwAAAAcArASdAAD//wB2/+wFCQe8AiYAMwAAAQcAqgUQAUgAFACwAEVYsA0vG7ENHD5ZsS4I9DAx//8AW//sBDQGhAImAFMAAAEHAKoEjQAQABQAsABFWLAELxuxBBg+WbEqAfQwMf//AHb/7AU9B8UCJgAzAAABBwG3AOUBMAAXALAARViwDS8bsQ0cPlmxIwz0sCnQMDEA//8AW//sBLoGjgImAFMAAAEGAbdi+QAXALAARViwBC8bsQQYPlmxHwj0sCXQMDEA//8AR//sBQkHwQImADMAAAEHAbYA6QE/ABcAsABFWLANLxuxDRw+WbEhDPSwKNAwMQD////E/+wENAaJAiYAUwAAAQYBtmYHABcAsABFWLAELxuxBBg+WbEdCPSwJNAwMQD//wB2/+wFCQfsAiYAMwAAAQcBtQDqAR0AFwCwAEVYsA0vG7ENHD5ZsSEM9LAn0DAxAP//AFv/7ARTBrUCJgBTAAABBgG1Z+YAFwCwAEVYsAQvG7EEGD5ZsR0I9LAj0DAxAP//AHb/7AUJB9wCJgAzAAABBwG0AOkBCAAXALAARViwDS8bsQ0cPlmxIQz0sCrQMDEA//8AW//sBDQGpQImAFMAAAEGAbRm0QAXALAARViwBC8bsQQYPlmxHQj0sCbQMDEA//8Adv6iBQkHOAImADMAAAAnAJ0A6wE4AQcArAUYAAAAFACwAEVYsA0vG7ENHD5ZsSIG9DAx//8AW/6iBDQGAAImAFMAAAAmAJ1oAAEHAKwEnQAAABQAsABFWLAELxuxBBg+WbEeAfQwMf//AGX/7AWdBy8CJgCXAAABBwB1Ad0BMQAUALAARViwDS8bsQ0cPlmxKAj0MDH//wBb/+wEugX+AiYAmAAAAQcAdQFlAAAAFACwAEVYsAQvG7EEGD5ZsSYJ9DAx//8AZf/sBZ0HLwImAJcAAAEHAEQBTgExABQAsABFWLANLxuxDRw+WbEnCPQwMf//AFv/7AS6Bf4CJgCYAAABBwBEANYAAAAUALAARViwBC8bsQQYPlmxJQn0MDH//wBl/+wFnQe1AiYAlwAAAQcAqgUMAUEAFACwAEVYsA0vG7ENHD5ZsTQI9DAx//8AW//sBLoGhAImAJgAAAEHAKoElAAQABQAsABFWLAELxuxBBg+WbEyAfQwMf//AGX/7AWdBx0CJgCXAAABBwCkAOMBNQAUALAARViwDS8bsQ0cPlmxKQT0MDH//wBb/+wEugXsAiYAmAAAAQYApGsEABQAsABFWLAELxuxBBg+WbEnAfQwMf//AGX+ogWdBjcCJgCXAAAABwCsBQkAAP//AFv+ogS6BLACJgCYAAAABwCsBJsAAP//AIz+ogSqBbACJgA5AAAABwCsBO4AAP//AIj+ogPcBDoCJgBZAAAABwCsBFEAAP//AIz/7ASqB7oCJgA5AAABBwCqBOkBRgAUALAARViwCi8bsQocPlmxEwj0MDH//wCI/+wD3AaEAiYAWQAAAQcAqgSFABAAFACwAEVYsAcvG7EHGD5ZsREB9DAx//8AjP/sBh0HQAImAJkAAAEHAHUB1AFCABQAsABFWLAaLxuxGhw+WbEdCPQwMf//AIj/7AUPBeoCJgCaAAABBwB1AWP/7AAUALAARViwEy8bsRMYPlmxHAn0MDH//wCM/+wGHQdAAiYAmQAAAQcARAFFAUIAFACwAEVYsBIvG7ESHD5ZsRwI9DAx//8AiP/sBQ8F6gImAJoAAAEHAEQA1P/sABQAsABFWLANLxuxDRg+WbEbCfQwMf//AIz/7AYdB8YCJgCZAAABBwCqBQMBUgAUALAARViwGi8bsRocPlmxKQj0MDH//wCI/+wFDwZwAiYAmgAAAQcAqgSS//wAFACwAEVYsBMvG7ETGD5ZsSgB9DAx//8AjP/sBh0HLgImAJkAAAEHAKQA2gFGABQAsABFWLASLxuxEhw+WbEeBPQwMf//AIj/7AUPBdgCJgCaAAABBgCkafAAFACwAEVYsBMvG7ETGD5ZsR0B9DAx//8AjP6iBh0GAgImAJkAAAAHAKwFCQAA//8AiP6iBQ8EkAImAJoAAAAHAKwEVwAA//8AD/6iBLsFsAImAD0AAAAHAKwEuwAA//8AFv4FA7AEOgImAF0AAAAHAKwFHP9j//8ADwAABLsHugImAD0AAAEHAKoEtwFGABQAsABFWLAILxuxCBw+WbEJCPQwMf//ABb+SwOwBoQCJgBdAAABBwCqBEoAEAAUALAARViwDy8bsQ8YPlmxEAH0MDH//wAPAAAEuwciAiYAPQAAAQcApACOAToAFACwAEVYsAEvG7EBHD5ZsQwE9DAx//8AFv5LA7AF7AImAF0AAAEGAKQhBAAUALAARViwAS8bsQEYPlmxEwH0MDEAAgBf/+wErAYAABcAIgB/ALAUL7AARViwDS8bsQ0YPlmwAEVYsAMvG7EDED5ZsABFWLAGLxuxBhA+WbIPFAFdsi8UAV2yEwMUERI5sBMvshABCitYIdgb9FmwAdCyBAYNERI5sg8NBhESObATELAW0LAGELIbAQorWCHYG/RZsA0QsiABCitYIdgb9FkwMQEjESMnBiMiAjU1NBIzMhcRITUhNTMVMwEUFjMyNxEmIyIGBKy8qglvxrzt7L++b/75AQe5vPxsmIawUVOsiJgE0vsudIgBNPgO+QEvggEGl5eX/Ki40J4B8ZnSAP//AF/+zQSsBgAAJgBIAAAAJwHeAaECRwEHAEMAn/9kAAgAsi8eAV0wMf//ALL+mAVEBbACJgHjAAAABwGwBCP/////AJz+mQSBBDoCJgDwAAAABwGwA2AAAP//AKn+mQWpBbACJgAsAAAABwGwBIgAAP//AJz+mQSiBDoCJgDzAAAABwGwA4EAAP//ADH+mQSXBbACJgA4AAAABwGwAj8AAP//ACj+mQOwBDoCJgD1AAAABwGwAcYAAP//ADn+mQT4BbACJgA8AAAABwGwA9cAAP//ACn+mQQGBDoCJgBcAAAABwGwAuUAAP//AJb+mQVmBbACJgDgAAAABwGwBEUAAP//AGf+mQReBDsCJgD4AAAABwGwAz0AAP//AJb+mQTIBbACJgDgAAAABwGwAv4AAP//AGf+mQO9BDsCJgD4AAAABwGwAfUAAP//ALH+mQQwBbACJgCwAAAABwGwAO8AAP//AJr+mQNHBDoCJgDrAAAABwGwANUAAP//ABv+mQeCBbACJgDZAAAABwGwBmEAAP//ABX+mQY9BDoCJgDtAAAABwGwBRwAAP//AD/+VQW9BcMCJgE/AAAABwGwAwb/vP///97+WQRjBE4CJgFAAAAABwGwAgH/wP//AIwAAAPfBgACBgBMAAAAAv/UAAAEsQWwABIAGwBhALAARViwDy8bsQ8cPlmwAEVYsAovG7EKED5ZsgIKDxESObACL7IODwIREjmwDi+yCwEKK1gh2Bv0WbAB0LAOELAR0LACELITAQorWCHYG/RZsAoQshQBCitYIdgb9FkwMQEjFSEWBBUUBAchESM1MzUzFTMDESEyNjU0JicCUO0BauQBAP7+3/3Tz8/A7e0BX4+fmY0EUPID5MTF6gQEUJfJyf3Z/d2YgHuOAgAC/9QAAASxBbAAEgAbAGEAsABFWLAQLxuxEBw+WbAARViwCi8bsQoQPlmyAgoQERI5sAIvshECEBESObARL7IBAQorWCHYG/RZsAvQsBEQsA7QsAIQshMBCitYIdgb9FmwChCyFAEKK1gh2Bv0WTAxASMVIRYEFRQEByERIzUzNTMVMwMRITI2NTQmJwJQ7QFq5AEA/v7f/dPPz8Dt7QFfj5+ZjQRQ8gPkxMXqBARQl8nJ/dn93ZiAe44CAAEAAwAABDAFsAANAE4AsABFWLAILxuxCBw+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsnoNAV2yAAEKK1gh2Bv0WbAE0LANELAG0LAIELIKAQorWCHYG/RZMDEBIREjESM1MxEhFSERIQJ//vPBrq4Df/1CAQ0CrP1UAqyXAm2e/jEAAAH//AAAA0cEOgANAEkAsABFWLAILxuxCBg+WbAARViwAi8bsQIQPlmyDQgCERI5sA0vsgABCitYIdgb9FmwBNCwDRCwBtCwCBCyCgEKK1gh2Bv0WTAxASERIxEjNTMRIRUhESECeP7cup6eAq3+DQEkAd/+IQHflwHEmf7VAAEACwAABTEFsAAUAH4AsABFWLAILxuxCBw+WbAARViwEC8bsRAcPlmwAEVYsAIvG7ECED5ZsABFWLATLxuxExA+WbIOCAIREjmwDi+yLw4BXbLPDgFdsgEBCitYIdgb9FmyBwgCERI5sAcvsgQBCitYIdgb9FmwBxCwCtCwBBCwDNCyEgEOERI5MDEBIxEjESM1MzUzFSEVIREzATMBASMCN7HAu7vAAQH+/5YB/e/91AJV6wKO/XIEN5fi4pf+9wKC/T79EgAAAf/TAAAEKAYAABQAdACwAEVYsAgvG7EIHj5ZsABFWLAQLxuxEBg+WbAARViwAi8bsQIQPlmwAEVYsBMvG7ETED5Zsg4QAhESObAOL7IBAQorWCHYG/RZsgcIEBESObAHL7IEAQorWCHYG/RZsAcQsArQsAQQsAzQshIBDhESOTAxASMRIxEjNTM1MxUzFSMRMwEzAQEjAeCAutPTuu/vfgE72/6GAa7bAfX+CwTBl6iol/3NAaz+E/2zAP//ALH+mwWyBxoCJgDbAAAAJwCgATEBQwEHABAEfv+9ABMAsABFWLAILxuxCBw+WbAN3DAxAP//AJz+mwS1BcQCJgDvAAAAJwCgAKL/7QEHABADgf+9ABMAsABFWLAILxuxCBg+WbAN3DAxAP//AKn+mwW7BbACJgAsAAAABwAQBIf/vf//AJz+mwS0BDoCJgDzAAAABwAQA4D/vf//AKn+mwb4BbACJgAxAAAABwAQBcT/vf//AJ3+mwYGBDoCJgDyAAAABwAQBNL/vf//AC/+mwWoBbACJgDcAAAABwAQBHT/vf//ACz+mwS3BDoCJgDxAAAABwAQA4P/vQABAA8AAAS7BbAADgBWsgoPEBESOQCwAEVYsAgvG7EIHD5ZsABFWLALLxuxCxw+WbAARViwAi8bsQIQPlmyBggCERI5sAYvsgUBCitYIdgb9FmwANCyCggCERI5sAYQsA7QMDEBIxEjESM1MwEzAQEzATMDpuHA25T+UdwBegF82v5RmgIJ/fcCCZcDEP0lAtv88AAAAQAu/mAD3wQ6AA4AY7IKDxAREjkAsABFWLAILxuxCBg+WbAARViwCy8bsQsYPlmwAEVYsAIvG7ECEj5ZsABFWLAALxuxABA+WbAARViwBC8bsQQQPlmyBgEKK1gh2Bv0WbIKCwAREjmwDdCwDtAwMQUjESMRIzUzATMBATMBMwNK5rrcv/6hvQEfARi9/qPIC/5rAZWXA6782gMm/FIAAAEAOQAABM4FsAARAGMAsABFWLALLxuxCxw+WbAARViwDi8bsQ4cPlmwAEVYsAIvG7ECED5ZsABFWLAFLxuxBRA+WbIRCwIREjmwES+yAAEKK1gh2Bv0WbIECwIREjmwB9CwERCwCdCyDQsCERI5MDEBIwEjAQEjASM1MwEzAQEzATMDxKQBruT+mv6Y4wGvoJH+a+EBXwFd4v5rlgKe/WICOP3IAp6XAnv90gIu/YUAAQApAAADygQ6ABEAYwCwAEVYsAsvG7ELGD5ZsABFWLAOLxuxDhg+WbAARViwAi8bsQIQPlmwAEVYsAUvG7EFED5ZshEOAhESObARL7IAAQorWCHYG/RZsgQOAhESObAH0LARELAJ0LINDgIREjkwMQEjASMDAyMBIzUzATMTEzMBMwM8swFB1vr61wFBqp7+1tbt8Nj+1qcB4f4fAZX+awHhlwHC/nUBi/4+//8AY//sA+wETQIGAL4AAP//ABIAAAQvBbACJgAqAAAABwHe/4P+f///AJACiwXJAyIARgGXhABmZkAA//8AXQAABDMFxAIGABYAAP//AF7/7AP5BcQCBgAXAAD//wA1AAAEUAWwAgYAGAAA//8Amv/sBC0FsAIGABkAAP//AGT//wP4BcQABgAdAAD//wCH/+wEHgXEAAYAFBQA//8Aev/sBNwHVQImACsAAAEHAHUBvgFXABQAsABFWLALLxuxCxw+WbEiCPQwMf//AGD+VgPyBf4CJgBLAAABBwB1AUsAAAAUALAARViwAy8bsQMYPlmxJwn0MDH//wCpAAAFCAc0AiYAMgAAAQcARAFmATYAFACwAEVYsAYvG7EGHD5ZsQsI9DAx//8AjAAAA98F/gImAFIAAAEHAEQAzAAAABQAsABFWLADLxuxAxg+WbETCfQwMf//ABwAAAUdByACJgAlAAABBwCrBG0BMgAXALAARViwBC8bsQQcPlmxDAj0sBDQMDEA//8AOf/sA+oF6wImAEUAAAEHAKsEEv/9ABcAsABFWLAXLxuxFxg+WbEqCfSwLtAwMQD//wBfAAAERgcsAiYAKQAAAQcAqwQ4AT4AFwCwAEVYsAYvG7EGHD5ZsQ0I9LAR0DAxAP//ACn/7APzBesCJgBJAAABBwCrBAL//QAXALAARViwCC8bsQgYPlmxHwn0sCPQMDEA////CgAAAeoHLAImAC0AAAEHAKsC4wE+ABcAsABFWLACLxuxAhw+WbEFCPSwCdAwMQD///7wAAAB0AXpAiYAjAAAAQcAqwLJ//sAFwCwAEVYsAIvG7ECGD5ZsQUJ9LAJ0DAxAP//AHb/7AUJByICJgAzAAABBwCrBI8BNAAXALAARViwDS8bsQ0cPlmxIQj0sCXQMDEA//8AM//sBDQF6wImAFMAAAEHAKsEDP/9ABcAsABFWLAELxuxBBg+WbEdCfSwIdAwMQD//wBVAAAEyQcgAiYANgAAAQcAqwQuATIAFwCwAEVYsAQvG7EEHD5ZsRkI9LAd0DAxAP///4sAAAKXBesCJgBWAAABBwCrA2T//QAXALAARViwCy8bsQsYPlmxDwn0sBPQMDEA//8AjP/sBKoHIAImADkAAAEHAKsEaAEyABcAsABFWLAJLxuxCRw+WbEUCPSwGNAwMQD//wAr/+wD3AXrAiYAWQAAAQcAqwQE//0AFwCwAEVYsAcvG7EHGD5ZsRIJ9LAW0DAxAP///zoAAATSBj8AJgDPZAAABwCt/oMAAP//AKn+ogSIBbACJgAmAAAABwCsBLoAAP//AIz+ogQgBgACJgBGAAAABwCsBKsAAP//AKn+ogTGBbACJgAoAAAABwCsBLkAAP//AF/+ogPwBgACJgBIAAAABwCsBL0AAP//AKn9/wTGBbACJgAoAAAABwGiAWX+oP//AF/9/wPwBgACJgBIAAAABwGiAWn+oP//AKn+ogUIBbACJgAsAAAABwCsBR8AAP//AIz+ogPfBgACJgBMAAAABwCsBKEAAP//AKkAAAUFBy4CJgAvAAABBwB1AXsBMAAUALAARViwBS8bsQUcPlmxDgj0MDH//wCNAAAEDAc/AiYATwAAAQcAdQFEAUEACQCwBS+wD9wwMQD//wCp/qIFBQWwAiYALwAAAAcArAToAAD//wCN/qIEDAYAAiYATwAAAAcArARlAAD//wCp/qIEHAWwAiYAMAAAAAcArATAAAD//wCG/qIBYQYAAiYAUAAAAAcArANOAAD//wCp/qIGUgWwAiYAMQAAAAcArAXSAAD//wCL/qIGeAROAiYAUQAAAAcArAXWAAD//wCp/qIFCAWwAiYAMgAAAAcArAUkAAD//wCM/qID3wROAiYAUgAAAAcArASHAAD//wCpAAAEwAdAAiYANAAAAQcAdQF8AUIAFACwAEVYsAMvG7EDHD5ZsRYI9DAx//8AjP5gBB4F9QImAFQAAAEHAHUBk//3ABQAsABFWLAMLxuxDBg+WbEdCfQwMf//AKj+ogTJBbACJgA2AAAABwCsBLcAAP//AIL+ogKXBE4CJgBWAAAABwCsA0oAAP//AFD+ogRyBcQCJgA3AAAABwCsBMkAAP//AF/+ogO7BE4CJgBXAAAABwCsBIcAAP//ADH+ogSXBbACJgA4AAAABwCsBLoAAP//AAn+ogJWBUACJgBYAAAABwCsBBkAAP//ABwAAAT9By4CJgA6AAABBwCkALQBRgAUALAARViwBi8bsQYcPlmxCgT0MDH//wAhAAADugXjAiYAWgAAAQYApB37ABQAsABFWLABLxuxARg+WbEKAfQwMf//ABz+ogT9BbACJgA6AAAABwCsBOQAAP//ACH+ogO6BDoCJgBaAAAABwCsBE0AAP//AD3+ogbtBbACJgA7AAAABwCsBe8AAP//ACv+ogXTBDoCJgBbAAAABwCsBVMAAP//AFb+ogR6BbACJgA+AAAABwCsBLoAAP//AFj+ogOzBDoCJgBeAAAABwCsBGIAAP///nj/7AVPBdYAJgAzRgAABwFa/gkAAP//ABMAAARwBRwCJgG6AAAABwCt/9z+3f///58AAAPqBR8AJgG+PAAABwCt/uj+4P///7wAAASUBRwAJgHBPAAABwCt/wX+3f///8AAAAGNBR4AJgHCPAAABwCt/wn+3////9//8ARkBRwAJgHICgAABwCt/yj+3f///1cAAARYBRwAJgHSPAAABwCt/qD+3f////gAAASIBRsAJgHzCgAABwCt/0H+3P//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA64EjQIGAb4AAP//AEcAAAPgBI0CBgHTAAD//wCKAAAEWASNAgYBwQAA//8AlwAAAVEEjQIGAcIAAP//AIoAAARXBI0CBgHEAAD//wCKAAAFdwSNAgYBxgAA//8AYP/wBFoEnQIGAcgAAP//AIoAAAQbBI0CBgHJAAD//wAoAAAD/QSNAgYBzQAA//8ADQAABBwEjQIGAdIAAP//ACYAAAQxBI0CBgHRAAD///+0AAACPQXjAiYBwgAAAQcAav9OAB4AFwCwAEVYsAIvG7ECGj5ZsQsC9LAU0DAxAP//AA0AAAQcBeMCJgHSAAABBgBqbR4AFwCwAEVYsAgvG7EIGj5ZsRAC9LAZ0DAxAP//AIoAAAOuBeMCJgG+AAABBgBqcR4AFwCwAEVYsAYvG7EGGj5ZsRMC9LAc0DAxAP//AIoAAAOFBhwCJgHqAAABBwB1ATQAHgAUALAARViwBC8bsQQaPlmxCAb0MDH//wBD//AD3QSdAgYBzAAA//8AlwAAAVEEjQIGAcIAAP///7QAAAI9BeMCJgHCAAABBwBq/04AHgAXALAARViwAi8bsQIaPlmxCwL0sBTQMDEA//8AK//wA00EjQIGAcMAAP//AIoAAARXBhwCJgHEAAABBwB1ASUAHgAUALAARViwBS8bsQUaPlmxDwb0MDH//wAi/+wECwX2AiYCAQAAAQYAoGcfABQAsABFWLACLxuxAho+WbEUCPQwMf//ABMAAARwBI0CBgG6AAD//wCKAAAD7wSNAgYBuwAA//8AigAAA4UEjQIGAeoAAP//AIoAAAOuBI0CBgG+AAD//wCKAAAEYQX2AiYB/gAAAQcAoADJAB8AFACwAEVYsAgvG7EIGj5ZsQ0I9DAx//8AigAABXcEjQIGAcYAAP//AIoAAARYBI0CBgHBAAD//wBg//AEWgSdAgYByAAA//8AigAABEQEjQIGAe8AAP//AIoAAAQbBI0CBgHJAAD//wBg//AEMASdAgYBvAAA//8AKAAAA/0EjQIGAc0AAP//ACYAAAQxBI0CBgHRAAAAAQBH/lAD1ASdACkAmgCwAEVYsAovG7EKGj5ZsABFWLAZLxuxGRA+WbAARViwGC8bsRgSPlmwChCyAwEKK1gh2Bv0WbIGChkREjmyJxkKERI5fLAnLxiy8CcBXbIAJwFxsqAnAV20YCdwJwJdsjAnAXG0YCdwJwJxsiYBCitYIdgb9FmyECYnERI5sBkQsBbQsh0ZChESObAZELIgAQorWCHYG/RZMDEBNCYjIgYVIzQ2MzIWFRQGBxYWFRQGBxEjESYmNTMWFjMyNjU0JSM1MzYDCIp9boG67bzT7m5ndnHLr7qjtrkFg3mIkv7/nZzvA1BUXVhPjrWollaNKSSSW4yvEv5bAacUrYhWYGBYwQWYBQAAAQCK/pkE+gSNAA8AXQCwAS+wAEVYsAkvG7EJGj5ZsABFWLADLxuxAxA+WbAARViwBi8bsQYQPlmyCwMJERI5fLALLxiyoAsBXbIEAQorWCHYG/RZsAkQsAzQsAMQsg4BCitYIdgb9FkwMQEjESMRIREjETMRIREzETME+rqh/aS5uQJcuaL+mQFnAfL+DgSN/f0CA/wMAAABAGD+VgQwBJ0AHwBYALAARViwDi8bsQ4aPlmwAEVYsAMvG7EDED5ZsABFWLAFLxuxBRI+WbADELAG0LAOELAS0LAOELIVAQorWCHYG/RZsAMQshwBCitYIdgb9FmwAxCwH9AwMQEGBgcRIxEmAjU1NDY2MzIWFyMmJiMiBgcVFBYzMjY3BDAUy6m6t9d755jM9xO5Eo1+macBn5eHjRQBeajHFP5gAaIeAR7jYaT5iNO7gnTLvWq9z2+D//8ADQAABBwEjQIGAdIAAP//AAL+UQVrBJ0CJgIXAAAABwGwArz/uP//AIoAAARhBdYCJgH+AAABBwBwAJwAJgATALAARViwCC8bsQgaPlmwC9wwMQD//wAi/+wECwXWAiYCAQAAAQYAcDomABMAsABFWLARLxuxERo+WbAT3DAxAP//AGAAAAUGBI0CBgHxAAD//wAc/k8FHQWwAiYAJQAAAAcAowF8AAD//wBt/k8D6gROAiYARQAAAAcAowDEAAD//wCp/lkERgWwAiYAKQAAAAcAowE6AAr//wBd/k8D8wROAiYASQAAAAcAowEGAAAAAAAAAA0AogADAAEECQAAAF4AAAADAAEECQABAAwAXgADAAEECQACAA4AagADAAEECQADAAwAXgADAAEECQAEAAwAXgADAAEECQAFACwAeAADAAEECQAGABwApAADAAEECQAHAEAAwAADAAEECQAJAAwBAAADAAEECQALABQBDAADAAEECQAMACYBIAADAAEECQANAFwBRgADAAEECQAOAFQBogBDAG8AcAB5AHIAaQBnAGgAdAAgADIAMAAxADEAIABHAG8AbwBnAGwAZQAgAEkAbgBjAC4AIABBAGwAbAAgAFIAaQBnAGgAdABzACAAUgBlAHMAZQByAHYAZQBkAC4AUgBvAGIAbwB0AG8AUgBlAGcAdQBsAGEAcgBWAGUAcgBzAGkAbwBuACAAMgAuADAAMAAxADEAMAAxADsAIAAyADAAMQA0AFIAbwBiAG8AdABvAC0AUgBlAGcAdQBsAGEAcgBSAG8AYgBvAHQAbwAgAGkAcwAgAGEAIAB0AHIAYQBkAGUAbQBhAHIAawAgAG8AZgAgAEcAbwBvAGcAbABlAC4ARwBvAG8AZwBsAGUARwBvAG8AZwBsAGUALgBjAG8AbQBDAGgAcgBpAHMAdABpAGEAbgAgAFIAbwBiAGUAcgB0AHMAbwBuAEwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAQQBwAGEAYwBoAGUAIABMAGkAYwBlAG4AcwBlACwAIABWAGUAcgBzAGkAbwBuACAAMgAuADAAaAB0AHQAcAA6AC8ALwB3AHcAdwAuAGEAcABhAGMAaABlAC4AbwByAGcALwBsAGkAYwBlAG4AcwBlAHMALwBMAEkAQwBFAE4AUwBFAC0AMgAuADAAAwAAAAAAAP9qAGQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAIACAAC//8ADwABAAAADAAAAAAAAAACAF4AJQA+AAEARQBeAAEAeQB5AAMAgQCBAAEAgwCDAAEAhgCGAAEAiQCJAAEAiwCVAAEAlwCcAAEAowCjAAMApwCsAAMAsACwAAEAuQC6AAEAvgC+AAEAwADAAAEAwgDCAAEAxgDGAAEAygDKAAEAzADNAAEAzwDQAAEA0gDSAAEA2QDdAAEA4ADgAAEA5ADkAAEA5gDoAAEA6gD6AAEA/AD8AAEA/gEAAAEBAgECAAEBBwEIAAEBFQEZAAEBGwEbAAEBHwEhAAEBIwEkAAMBOAE5AAEBPgFAAAEBRQFFAAEBTQFNAAEBTwFPAAEBUwFTAAEBVQFXAAEBWQFZAAEBogGiAAMBowGpAAIBugHTAAEB4gHiAAEB5AHkAAEB6gHqAAEB8wHzAAEB9QH1AAEB/AH+AAECAAIBAAECAwIDAAECBwIHAAECCQILAAECEQIRAAECFgIYAAECGgIaAAECPgJDAAECRwKvAAECsgNYAAEDWwNqAAEDcQNxAAEDcwN3AAEDegN/AAEDgQOEAAEDhgOKAAEDjAOnAAEDqwOrAAEDrQO0AAEDtgO4AAEDvQO/AAEDwQPNAAEDzwPZAAED3APsAAED7wRIAAEESwRLAAEETQRNAAEETwRQAAEEWwRbAAEEYgRkAAEEZgRmAAEEagRqAAEEbARtAAEEbwRvAAEEdwSGAAEEhwSHAAIEiASwAAEEsgTKAAEEzATQAAEE0gTVAAEE1wTZAAEE2wTcAAEE3gThAAEAAQAAAAoAXACaAARERkxUABpjeXJsAChncmVrADZsYXRuAEQABAAAAAD//wACAAAABAAEAAAAAP//AAIAAQAFAAQAAAAA//8AAgACAAYABAAAAAD//wACAAMABwAIY3BzcAAyY3BzcAAyY3BzcAAyY3BzcAAya2VybgA4a2VybgA4a2VybgA4a2VybgA4AAAAAQAAAAAAAQABAAIABgHYAAEAAAABAAgAAQAKAAUAJABIAAEA3gAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAkgCwALEAsgCzALQAtQC2ALcAuAC5ANEA0gDTANQA1QDWANcA2ADZANoA2wDcAN0A3gDfAOAA4QDiAOMA5ADlAOYA5wDoASwBMAEyATgBOgE8AT4BPwFFAUYBfwGFAYoBjQJHAkgCSgJMAk0CTgJPAlACUQJSAlMCVAJVAlYCVwJYAlkCWgJbAlwCXQJeAl8CYAJhAmICYwJkAmUCZgKDAoUChwKJAosCjQKPApECkwKVApcCmQKbAp0CnwKhAqMCpQKnAqkCqwKtAq8CsgK0ArYCuAK6ArwCvgLAAsICxQLHAskCywLNAs8C0QLTAtUC2QLbAt0C3wLhAuMC5QLnAukC6wLtAu8C8QLyAvQC9gNTA1QDVQNWA1cDWANZA1sDXANdA14DXwNgA2EDYgNkA2UDZgNnA2gDaQNqA3oDewN8A30DfgN/A4ADgQOCA4MDhAOFA4YDhwOIA4kDigOLA4wDjQOOA48DuwO9A78D1APaA+AESQRLBE8EVwRZBF4EagACAAAABAAOD84V8jViAAEDVAAEAAABpQrSCtIGggtwCoAK/g+aDAAGiA7uDu4MRg6gCiIO7g7uD5oKigaSDGYMRgrYCqwNUg8QCl4L4gsQDBYGmA22DbYNtgwgCxAKUAxMDbAMTAsQBqYN5gtwD5oLcAasBrIGvAbCBsgMTAbOBtgNtgb+BxQHKgcwB0YHTAdSB4QHigeQDcANwAe+Du4H4AgCDVIIMA7uDu4LJg7uDu4IRg3ADcAIeAiCCIwIpg1ICLgNsAjSCOgLEAkyCUwJaAloCxAJYgloCWgJaAtwDCAK2AxMCxAN5g1IDqAOoA1ICtIK0grSCtIK0gmKCbAJugnECeIJ9AoGChgK/g+aD5oPmg+aDGYLcAtwC3ALcAtwC3ALcAr+DAAMAAwADAAO7g7uDu4O7g7uD5oPmg+aD5oPmgxGDEYMRgxGDxAL4gviC+IL4gviC+IL4gwWDBYMFgwWDbYMIAwgDCAMIAwgDEwMTAtwC+ILcAviC3AL4gr+Cv4K/gr+D5oMAAwWDAAMFgwADBYMAAwWDAAMFg7uDbYO7g7uDu4O7g7uDEYOoAoiCiIKIgoiDu4Ntg7uDbYO7g22DbYPmgwgD5oMIA+aDCAKUApQClAMZgxmDGYMRgxGDEYMRgxGDEYKrA8QDEwPEApeCl4KXgtwDAAO7g7uD5oPEAtwCoAMAApeDu4O7g6gDu4O7g+aCooMZg8QDVIO7g8QDbYMIAxMDCAMAA3mDu4O7gxGDqAOoAsmC3AKgA3mDAAO7g7uD5oKigr+DGYNUgviDBYMIAsQDEwNsAwWDUgMTAqsCqwKrA8QDEwK0grSCtIO7g22C3AL4gwADBYK2AxMCv4PEAxMDu4NUg2wDu4LcAviC3AL4gwADBYMFgwWDVINsA+aDCAMIAsQCyYMTAsmDEwLJgxMDVINsAtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gtwC+ILcAviC3AL4gwADBYMAAwWDAAMFgwADBYMAAwWDAAMFgwADBYMAAwWDu4O7g+aDCAPmgwgD5oMIA+aDCAPmgwgD5oMIA+aDCAMIAxGDEYPEAxMDxAMTA8QDEwOoA7uDGYNUg2wDeYNSA1SDbANtg3ADeYOoA7uDu4PEA+aAAIAhwAGAAYAAAALAAsAAQATABMAAgAlACoAAwAsADUACQA4AD4AEwBFAEYAGgBJAEoAHABMAEwAHgBRAFQAHwBWAFYAIwBaAFoAJABcAF0AJQCKAIoAJwCcAJwAKACwALQAKQC2ALgALgC6ALoAMQC8AL0AMgC/AMAANADCAMQANgDGAMsAOQDRANEAPwDTAN0AQADfAN8ASwDhAOMATADlAOcATwDpAO0AUgDwAPAAVwD1APcAWAD6APsAWwD9AP8AXQEDAQQAYAEJAQkAYgEMAQwAYwEXARkAZAErAS0AZwEwATAAagEyATIAawFJAUkAbAFsAW0AbQFvAXEAbwG6AboAcgG9Ab0AcwHEAcUAdAHIAcgAdgHKAcsAdwHNAc0AeQIoAigAegIqAisAewJHAkgAfQJKAkoAfwJMAm0AgAJvAnIAogJ3AnwApgKBAokArAKLAosAtQKNAo0AtgKPAo8AtwKRApEAuAKTApwAuQKlAqcAwwKpAqkAxgKrAqsAxwKtAq0AyAKvAq8AyQKyArIAygK0ArQAywK2ArYAzAK4ArgAzQK6AroAzgK8ArwAzwK+AsoA0ALMAswA3QLOAs4A3gLQAtAA3wLbAtsA4ALdAt0A4QLfAt8A4gLhAuEA4wLjAuMA5ALlAuUA5QLnAucA5gLpAukA5wLrAusA6ALtAu0A6QLvAvIA6gL0AvQA7gL2AvYA7wNTA1gA8ANbA2oA9gNtA20BBgNxA3EBBwNzA3MBCAN3A3cBCQN6A3sBCgN9A4YBDAOIA4oBFgOMA5EBGQOTA5QBHwOWA5kBIQOfA6ABJQOiA6IBJwOkA6QBKAOmA6kBKQOsA7EBLQOzA7MBMwO3A7gBNAO9A70BNgO/A8gBNwPLA8wBQQPOA9EBQwPYA9kBRwPdA90BSQPfA+UBSgPqA+sBUQPvBBcBUwQZBBkBfAQbBCgBfQQwBDABiwQzBDMBjAQ1BDUBjQRBBEYBjgRJBEkBlARLBEsBlQRNBE0BlgRPBFABlwRVBFgBmQRbBFsBnQRdBF4BngRgBGABoARkBGQBoQRmBGYBogRqBGoBowSqBKoBpAABABP/IAACAFb/5gG6/8AAAQG6AA4AAwANABQAQQASAGEAEwABAPX/9QABAMMADQACALf/wgDDABAAAQDD/+IAAQDG//IAAQDDAA4AAgDJ/+0A9f/AAAkAvv/mAMH/6wDC/+kAxP/wAMX/5wDJ/+MAy//OAMz/1ADN/9sABQDB/+wAwwAPAMX/6gDJ/8QAy//nAAUASv/pAMH/7gDDABAAxf/sAMn/IAABAMMADwAFAMn/6gDs/+4A9f+rATP/7AFY/+wAAQD1/9UAAQDJAAsADABKAAwAxQALAMkADAG6/78BvP/uAcD/7AHI/+0Byv/sAcz/9QHNAA4BzwANAdIADQABAPX/2AABAPX/qgALAOX/1AD1/8kBCP/lAR//4wEz/8QBPP/hAU3/1AFO//UBT//nAVf/0gFY/8kACADl/8kA9f/fAQj/7QEf/+sBM//fAT//6QFO//UBWP/gAAgA5f/mAPX/0AEz/84BPP/oAU3/5wFP/+0BV//mAVj/0AALANgAFADl/+AA7AATATz/4QE9/+ABQP/hAUX/6QFN/98BT//eAVf/3wFZ//IABQAb//IA5f/xAU3/8gFP//IBV//yAAwA2AATAOX/5gDm//QA7AASAPX/5wEz/+cBPP/lAT3/6AFN/+YBT//mAVf/5gFY/+cAAgDY/+IBV//kAAIA2P/hAOz/5AAGAOz/7gD1/+4BCP/0AR//8QEz/+8BWP/vAAQA9f/0AQj/9QEz//UBWP/1AAYA7AAUAPX/7QD7/+IBM//tAT3/7QFY/+0ABQEb/+sBvP/rAcD/6QHI/+sByv/rABIASgANAMb/qwDH/8AAy//VAOz/qgEb/+IBHwAMAU4ACwFQAAsBuv+/Abz/7gHA/+wByP/tAcr/7AHM//UBzQAOAc8ADQHSAA0ABgDsABQA9f/wAQAADAEz//ABPf/mAVj/8AAFAOwAOgD1/+MBM//iAT3/4wFY/+MAAQDs/+8ACAD1/7oBCP/PAR//2wEz/1ABPf+dAU7/8AFQ//IBWP9MAAkBvP/yAcD/8gHI//IByv/yAc3/wAHO/+wBz//HAdD/2AHS/78AAgHP/+4B0P/1AAIByP/rAcr/6wAHAcj/7wHK//ABzf+7Ac7/7AHP/7cB0P/VAdL/tAAEAc3/7gHP//EB0f/sAdL/6gAEAc3/6QHP/+sB0P/xAdL/5QAEAc3/8gHP//EB0P/1AdL/7gACAc8ADQHSAA0ACwBb/6QBugATAbz/8wHA//EByP/yAcr/8QHN/zsBzv/aAc//VAHQ/5EB0v8/AAMASgAPAFgAMgBbABEACABb/+UAt//LAMz/5AG6AA0BvP/tAcD/6wHI/+wByv/sAAIBEAALAVf/5gAIAFgADgCB/58Aw//eAMb/5QDY/6gA7P/KAUr/4wG6/8YACQANAA8AQQAMAFb/6wBhAA4Buv/LAbz/6QHA/+cByP/nAcr/5wABAFsACwAJAA0AFABBABEAVv/iAGEAEwG6/7QBvP/ZAcD/2QHI/9kByv/ZAAQADf/mAEH/9ABh/+8BQP/tAAUAyf/qAOz/7gD1/7ABM//sAVj/7AASANj/rgDlABIA6v/gAOz/rQDu/9YA/P/fAQD/0gEG/+ABG//OASv/3QEt/+IBMf/gATf/4AE9/+kBQP/aAUr/vQFU/98BVwARABwAI//DAFj/7wBb/98Amf/uALf/5QC4/9EAwwARAMn/yADYABMA5f/FAPX/ygEz/58BPP9RAT3/ewE//8oBQP/dAUX/8gFN/3UBT//KAVf/TwFY/4wBwP/1Acj/9QHN/8cBzv/xAc//zQHQ/90B0v/EAAcA9f/wAQj/8QEf//MBM//xAU7/8wFQ/+kBWP/TAAUASv/uAFv/6gHP//AB0P/tAdL/8AACAPX/9QFt/7AACQDJ/+oA7P+4APX/6gEI//ABH//xATP/6wFO//UBWP/sAW3/sAABAbr/6wAGAEoADQDFAAsAxv/qAMkADADs/8gBG//xADgABP/YAFb/tQBb/8cAbf64AHz/KACB/00Ahv+OAIn/oQC3/64Avv9+AML/ZwDF/4cAxv9lAMn/ngDL/2oAzP9zAM3/XgDY/6UA5QAPAOn/5ADq/6AA7P90AO7/gAD1/7IA/P99AP7/gAEA/3kBBv99AQj/fwEb/5gBH//aASv/gQEt/5gBMf99ATP/swE3/6ABPf98AT//mgFA/2wBRf/mAUr/awFO/5IBUP+tAVT/ewFXAA8BWP+RAVn/8gG6/68BvP+5AcD/uQHI/7kByv+5Acz/vAHN//EB0P/xAdH/7QACAOz/yQEb/+4AFwC3/9QAwf/tAMMAEQDJ/+AAy//nAMz/5QDN/+4A2AASAOn/6QD1/9cBM//XAT3/0wE//9YBQP/FAUX/5wFNAA0BTwAMAVj/1gFZ//IBvP/pAcD/5wHI/+cByv/pAAEBG//xAAIA9f/AAW3/sAAJAOX/wwD1/88BM//OATz/5wE//98BTf/RAU//7AFX/6ABWP/RAC4AVv9tAFv/jABt/b8AfP59AIH+vACG/ysAif9LALf/YQC+/w8Awv7oAMX/HwDG/uUAyf9GAMv+7QDM/v0Azf7ZANj/UgDlAAUA6f+9AOr/SQDs/v4A7v8TAPX/aAD8/w4A/v8TAQD/BwEG/w4BCP8RARv/PAEf/6wBK/8VAS3/PAEx/w4BM/9qATf/SQE9/wwBP/8/AUD+8QFF/8ABSv7vAU7/MQFQ/18BVP8KAVcABQFY/zABWf/VABMAW//BALf/xQDJ/7QA6f/XAPX/uQEI/7IBG//SAR//yAEz/6ABPf/FAUX/5AFO/8wBUP/MAVj/ywFZ/+8BvP/oAcD/5gHI/+cByv/nAAgA2AAVAOwAFQE8/+QBPf/lAT//5AFN/+MBT//iAVf/5AAiAAr/4gANABQADv/PAEEAEgBK/+oAVv/YAFj/6gBhABMAbf+uAHz/zQCB/6AAhv/BAIn/wAC3/9AAu//qAL7/xgC/AA0Awf/pAML/1gDF/+gAxv+6AMn/6QDL/8sAzP/aAM3/xwF1/9MBuv+rAbz/zQHA/8sByP/LAcr/ywHN//MB0P/zAdH/7wAJAIH/3wC0//MAtv/wAMP/6gDY/98A5f/gAVf/4AG6/+0B0f/1AAEAGAAEAAAABwAqAFQAqgPcBFoExAUGAAEABwAEAAwAKgA1ADYAPwBKAAoAOP/YANH/2ADV/9gBMv/YATr/2ALb/9gC3f/YAt//2AOO/9gETf/YABUAOgAUADsAEgA9ABYBGAAUAmYAFgLtABIC7wAWAvEAFgNYABYDZwAWA2oAFgOgABIDogASA6QAEgOmABYDtwAUA78AFgRBABYEQwAWBEUAFgRqABYAzAAQ/xYAEv8WACX/VgAu/vgAOAAUAEX/3gBH/+sASP/rAEn/6wBL/+sAU//rAFX/6wBZ/+oAWv/oAF3/6ACT/+sAmP/rAJr/6gCx/1YAs/9WALr/6wC8/+gAx//rAMj/6wDK/+oA0QAUANUAFAD2/+sBAv/rAQz/VgEX/+sBGf/oAR3/6wEh/+sBMgAUATn/6wE6ABQBS//rAUz/6wFW/+sBbv8WAXL/FgF2/xYBd/8WAkz/VgJN/1YCTv9WAk//VgJQ/1YCUf9WAlL/VgJn/94CaP/eAmn/3gJq/94Ca//eAmz/3gJt/94Cbv/rAm//6wJw/+sCcf/rAnL/6wJ4/+sCef/rAnr/6wJ7/+sCfP/rAn3/6gJ+/+oCf//qAoD/6gKB/+gCgv/oAoP/VgKE/94Chf9WAob/3gKH/1YCiP/eAor/6wKM/+sCjv/rApD/6wKS/+sClP/rApb/6wKY/+sCmv/rApz/6wKe/+sCoP/rAqL/6wKk/+sCsv74Asb/6wLI/+sCyv/rAtsAFALdABQC3wAUAuL/6gLk/+oC5v/qAuj/6gLq/+oC7P/qAvD/6ANT/1YDW/9WA2v/6wNv/+oDcf/rA3P/6AN2/+oDd//rA3j/6gN//vgDg/9WA44AFAOQ/94Dkf/rA5P/6wOV/+sDlv/oA5j/6wOf/+gDp//oA6//VgOw/94Ds//rA7j/6AO5/+sDvv/rA8D/6APF/1YDxv/eA8f/VgPI/94DzP/rA87/6wPP/+sD2f/rA9v/6wPd/+sD4f/oA+P/6APl/+gD7P/rA+//VgPw/94D8f9WA/L/3gPz/1YD9P/eA/X/VgP2/94D9/9WA/j/3gP5/1YD+v/eA/v/VgP8/94D/f9WA/7/3gP//1YEAP/eBAH/VgQC/94EA/9WBAT/3gQF/1YEBv/eBAj/6wQK/+sEDP/rBA7/6wQQ/+sEEv/rBBT/6wQW/+sEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/6wQs/+sELv/rBDD/6wQy/+sENP/qBDb/6gQ4/+oEOv/qBDz/6gQ+/+oEQP/qBEL/6ARE/+gERv/oBE0AFAAfADj/1QA6/+QAO//sAD3/3QDR/9UA1f/VARj/5AEy/9UBOv/VAmb/3QLb/9UC3f/VAt//1QLt/+wC7//dAvH/3QNY/90DZ//dA2r/3QOO/9UDoP/sA6L/7AOk/+wDpv/dA7f/5AO//90EQf/dBEP/3QRF/90ETf/VBGr/3QAaADj/sAA6/+0APf/QANH/sADV/7ABGP/tATL/sAE6/7ACZv/QAtv/sALd/7AC3/+wAu//0ALx/9ADWP/QA2f/0ANq/9ADjv+wA6b/0AO3/+0Dv//QBEH/0ARD/9AERf/QBE3/sARq/9AAEAAu/+4AOf/uAmL/7gJj/+4CZP/uAmX/7gKy/+4C4f/uAuP/7gLl/+4C5//uAun/7gLr/+4Df//uBDP/7gQ1/+4ARwAGABAACwAQAEf/6ABI/+gASf/oAEv/6ABV/+gAk//oAJj/6AC6/+gAx//oAMj/6AD2/+gBAv/oAR3/6AEh/+gBOf/oAUv/6AFM/+gBVv/oAWwAEAFtABABbwAQAXAAEAFxABACbv/oAm//6AJw/+gCcf/oAnL/6AKK/+gCjP/oAo7/6AKQ/+gCkv/oApT/6AKW/+gCmP/oApr/6AKc/+gCnv/oAqD/6AKi/+gCpP/oA2v/6AOR/+gDlf/oA5j/6AOoABADqQAQA6wAEAOz/+gDuf/oA77/6APM/+gDzv/oA8//6APb/+gD7P/oBAj/6AQK/+gEDP/oBA7/6AQQ/+gEEv/oBBT/6AQW/+gEKv/oBCz/6AQu/+gEMv/oAAEAVgAEAAAAJgCmAZwB+gIUAlYCzAPCBLgFkgYsCMYKjAteDFQOGg5MDn4O/BDiEVgSKhRMFQIWaBciF6gYBhjIGT4ewBlQGqIc4B0CHhgelh7AHuoAAQAmAE8AWABbAF8AnAC0ALYAtwC4AL8AwgDDAMQAyQDLAMwAzQDRANUA1wDYANoA4gDmAOcA6ADpAOoA7ADuAPAA9QD3APoA/wECASEBbQA9AEf/7ABI/+wASf/sAEv/7ABV/+wAk//sAJj/7AC6/+wAx//sAMj/7AD2/+wBAv/sAR3/7AEh/+wBOf/sAUv/7AFM/+wBVv/sAm7/7AJv/+wCcP/sAnH/7AJy/+wCiv/sAoz/7AKO/+wCkP/sApL/7AKU/+wClv/sApj/7AKa/+wCnP/sAp7/7AKg/+wCov/sAqT/7ANr/+wDkf/sA5X/7AOY/+wDs//sA7n/7AO+/+wDzP/sA87/7APP/+wD2//sA+z/7AQI/+wECv/sBAz/7AQO/+wEEP/sBBL/7AQU/+wEFv/sBCr/7AQs/+wELv/sBDL/7AAXAFP/7AEX/+wCeP/sAnn/7AJ6/+wCe//sAnz/7ALG/+wCyP/sAsr/7ANx/+wDd//sA5P/7APZ/+wD3f/sBBz/7AQe/+wEIP/sBCL/7AQk/+wEJv/sBCj/7AQw/+wABgAQ/4QAEv+EAW7/hAFy/4QBdv+EAXf/hAAQAC7/7AA5/+wCYv/sAmP/7AJk/+wCZf/sArL/7ALh/+wC4//sAuX/7ALn/+wC6f/sAuv/7AN//+wEM//sBDX/7AAdAAb/8gAL//IAWv/zAF3/8wC8//MBGf/zAWz/8gFt//IBb//yAXD/8gFx//ICgf/zAoL/8wLw//MDc//zA5b/8wOf//MDp//zA6j/8gOp//IDrP/yA7j/8wPA//MD4f/zA+P/8wPl//MEQv/zBET/8wRG//MAPQAn//MAK//zADP/8wA1//MAg//zAJL/8wCX//MAsv/zANL/8wEH//MBFv/zARr/8wEc//MBHv/zASD/8wE4//MBVf/zAij/8wIp//MCK//zAiz/8wJT//MCXf/zAl7/8wJf//MCYP/zAmH/8wKJ//MCi//zAo3/8wKP//MCnf/zAp//8wKh//MCo//zAsX/8wLH//MCyf/zAvr/8wNX//MDZP/zA4r/8wON//MDuv/zA73/8wPY//MD2v/zA9z/8wQb//MEHf/zBB//8wQh//MEI//zBCX/8wQn//MEKf/zBCv/8wQt//MEL//zBDH/8wSq//MAPQAn/+YAK//mADP/5gA1/+YAg//mAJL/5gCX/+YAsv/mANL/5gEH/+YBFv/mARr/5gEc/+YBHv/mASD/5gE4/+YBVf/mAij/5gIp/+YCK//mAiz/5gJT/+YCXf/mAl7/5gJf/+YCYP/mAmH/5gKJ/+YCi//mAo3/5gKP/+YCnf/mAp//5gKh/+YCo//mAsX/5gLH/+YCyf/mAvr/5gNX/+YDZP/mA4r/5gON/+YDuv/mA73/5gPY/+YD2v/mA9z/5gQb/+YEHf/mBB//5gQh/+YEI//mBCX/5gQn/+YEKf/mBCv/5gQt/+YEL//mBDH/5gSq/+YANgAl/+QAPP/SAD3/0wCx/+QAs//kANn/0gEM/+QCTP/kAk3/5AJO/+QCT//kAlD/5AJR/+QCUv/kAmb/0wKD/+QChf/kAof/5ALv/9MC8f/TA1P/5ANY/9MDW//kA2f/0wNo/9IDav/TA4P/5AOP/9IDpv/TA6//5AO//9MDwv/SA8X/5APH/+QD0P/SA+r/0gPv/+QD8f/kA/P/5AP1/+QD9//kA/n/5AP7/+QD/f/kA///5AQB/+QEA//kBAX/5ARB/9MEQ//TBEX/0wRP/9IEV//SBGr/0wAmABD/HgAS/x4AJf/NALH/zQCz/80BDP/NAW7/HgFy/x4Bdv8eAXf/HgJM/80CTf/NAk7/zQJP/80CUP/NAlH/zQJS/80Cg//NAoX/zQKH/80DU//NA1v/zQOD/80Dr//NA8X/zQPH/80D7//NA/H/zQPz/80D9f/NA/f/zQP5/80D+//NA/3/zQP//80EAf/NBAP/zQQF/80ApgBH/9wASP/cAEn/3ABL/9wAUf/zAFL/8wBT/9YAVP/zAFX/3ABZ/90AWv/hAF3/4QCT/9wAmP/cAJr/3QC6/9wAvP/hAMD/8wDH/9wAyP/cAMr/3QDr//MA7//zAPD/8wDy//MA8//zAPT/8wD2/9wA9//zAPn/8wD6//MA/f/zAP//8wEC/9wBBP/zARf/1gEZ/+EBHf/cASH/3AE1//MBOf/cAUT/8wFJ//MBS//cAUz/3AFW/9wCbv/cAm//3AJw/9wCcf/cAnL/3AJ3//MCeP/WAnn/1gJ6/9YCe//WAnz/1gJ9/90Cfv/dAn//3QKA/90Cgf/hAoL/4QKK/9wCjP/cAo7/3AKQ/9wCkv/cApT/3AKW/9wCmP/cApr/3AKc/9wCnv/cAqD/3AKi/9wCpP/cAr//8wLB//MCw//zAsT/8wLG/9YCyP/WAsr/1gLi/90C5P/dAub/3QLo/90C6v/dAuz/3QLw/+EDa//cA23/8wNv/90Dcf/WA3P/4QN2/90Dd//WA3j/3QOR/9wDkv/zA5P/1gOU//MDlf/cA5b/4QOY/9wDmf/zA57/8wOf/+EDp//hA67/8wOz/9wDtP/zA7j/4QO5/9wDvv/cA8D/4QPM/9wDzv/cA8//3APV//MD1//zA9n/1gPb/9wD3f/WA+H/4QPj/+ED5f/hA+n/8wPs/9wECP/cBAr/3AQM/9wEDv/cBBD/3AQS/9wEFP/cBBb/3AQc/9YEHv/WBCD/1gQi/9YEJP/WBCb/1gQo/9YEKv/cBCz/3AQu/9wEMP/WBDL/3AQ0/90ENv/dBDj/3QQ6/90EPP/dBD7/3QRA/90EQv/hBET/4QRG/+EESv/zBEz/8wRW//MEY//zBGX/8wRn//MAcQAG/9oAC//aAEf/8ABI//AASf/wAEv/8ABV//AAWf/vAFr/3ABd/9wAk//wAJj/8ACa/+8Auv/wALz/3ADH//AAyP/wAMr/7wD2//ABAv/wARn/3AEd//ABIf/wATn/8AFL//ABTP/wAVb/8AFs/9oBbf/aAW//2gFw/9oBcf/aAm7/8AJv//ACcP/wAnH/8AJy//ACff/vAn7/7wJ//+8CgP/vAoH/3AKC/9wCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALi/+8C5P/vAub/7wLo/+8C6v/vAuz/7wLw/9wDa//wA2//7wNz/9wDdv/vA3j/7wOR//ADlf/wA5b/3AOY//ADn//cA6f/3AOo/9oDqf/aA6z/2gOz//ADuP/cA7n/8AO+//ADwP/cA8z/8APO//ADz//wA9v/8APh/9wD4//cA+X/3APs//AECP/wBAr/8AQM//AEDv/wBBD/8AQS//AEFP/wBBb/8AQq//AELP/wBC7/8AQy//AENP/vBDb/7wQ4/+8EOv/vBDz/7wQ+/+8EQP/vBEL/3ARE/9wERv/cADQABv+gAAv/oABZ//EAWv/FAF3/xQCa//EAvP/FAMr/8QEZ/8UBbP+gAW3/oAFv/6ABcP+gAXH/oAJ9//ECfv/xAn//8QKA//ECgf/FAoL/xQLi//EC5P/xAub/8QLo//EC6v/xAuz/8QLw/8UDb//xA3P/xQN2//EDeP/xA5b/xQOf/8UDp//FA6j/oAOp/6ADrP+gA7j/xQPA/8UD4f/FA+P/xQPl/8UENP/xBDb/8QQ4//EEOv/xBDz/8QQ+//EEQP/xBEL/xQRE/8UERv/FAD0AR//nAEj/5wBJ/+cAS//nAFX/5wCT/+cAmP/nALr/5wDH/+cAyP/nAPb/5wEC/+cBHf/nASH/5wE5/+cBS//nAUz/5wFW/+cCbv/nAm//5wJw/+cCcf/nAnL/5wKK/+cCjP/nAo7/5wKQ/+cCkv/nApT/5wKW/+cCmP/nApr/5wKc/+cCnv/nAqD/5wKi/+cCpP/nA2v/5wOR/+cDlf/nA5j/5wOz/+cDuf/nA77/5wPM/+cDzv/nA8//5wPb/+cD7P/nBAj/5wQK/+cEDP/nBA7/5wQQ/+cEEv/nBBT/5wQW/+cEKv/nBCz/5wQu/+cEMv/nAHEABgAMAAsADABH/+gASP/oAEn/6ABL/+gAU//qAFX/6ABaAAsAXQALAJP/6ACY/+gAuv/oALwACwDH/+gAyP/oAPb/6AEC/+gBF//qARkACwEd/+gBIf/oATn/6AFL/+gBTP/oAVb/6AFsAAwBbQAMAW8ADAFwAAwBcQAMAm7/6AJv/+gCcP/oAnH/6AJy/+gCeP/qAnn/6gJ6/+oCe//qAnz/6gKBAAsCggALAor/6AKM/+gCjv/oApD/6AKS/+gClP/oApb/6AKY/+gCmv/oApz/6AKe/+gCoP/oAqL/6AKk/+gCxv/qAsj/6gLK/+oC8AALA2v/6ANx/+oDcwALA3f/6gOR/+gDk//qA5X/6AOWAAsDmP/oA58ACwOnAAsDqAAMA6kADAOsAAwDs//oA7gACwO5/+gDvv/oA8AACwPM/+gDzv/oA8//6APZ/+oD2//oA93/6gPhAAsD4wALA+UACwPs/+gECP/oBAr/6AQM/+gEDv/oBBD/6AQS/+gEFP/oBBb/6AQc/+oEHv/qBCD/6gQi/+oEJP/qBCb/6gQo/+oEKv/oBCz/6AQu/+gEMP/qBDL/6ARCAAsERAALBEYACwAMAFz/7QBe/+0A7f/tAvP/7QL1/+0C9//tA5f/7QPD/+0D0f/tA+v/7QRQ/+0EWP/tAAwAXP/yAF7/8gDt//IC8//yAvX/8gL3//IDl//yA8P/8gPR//ID6//yBFD/8gRY//IAHwBa//QAXP/yAF3/9ABe//MAvP/0AO3/8gEZ//QCgf/0AoL/9ALw//QC8//zAvX/8wL3//MDc//0A5b/9AOX//IDn//0A6f/9AO4//QDwP/0A8P/8gPR//ID4f/0A+P/9APl//QD6//yBEL/9ARE//QERv/0BFD/8gRY//IAeQAG/8oAC//KADj/0gA6/9QAPP/0AD3/0wBR/9EAUv/RAFT/0QBa/+YAXP/vAF3/5gC8/+YAwP/RANH/0gDV/9IA2f/0AN3/7QDg/+EA6//RAO3/7wDv/9EA8P/RAPL/0QDz/9EA9P/RAPf/0QD5/9EA+v/RAP3/0QD//9EBBP/RARj/1AEZ/+YBMv/SATX/0QE6/9IBRP/RAUn/0QFs/8oBbf/KAW//ygFw/8oBcf/KAmb/0wJ3/9ECgf/mAoL/5gK//9ECwf/RAsP/0QLE/9EC2//SAt3/0gLf/9IC7//TAvD/5gLx/9MDWP/TA2f/0wNo//QDav/TA23/0QNz/+YDgv/tA47/0gOP//QDkv/RA5T/0QOW/+YDl//vA5n/0QOe/9EDn//mA6b/0wOn/+YDqP/KA6n/ygOs/8oDrv/RA7T/0QO3/9QDuP/mA7//0wPA/+YDwv/0A8P/7wPQ//QD0f/vA9X/0QPX/9ED4P/tA+H/5gPi/+0D4//mA+T/7QPl/+YD5v/hA+n/0QPq//QD6//vBEH/0wRC/+YEQ//TBET/5gRF/9MERv/mBEr/0QRM/9EETf/SBE//9ARQ/+8EUf/hBFP/4QRW/9EEV//0BFj/7wRj/9EEZf/RBGf/0QRq/9MAHQA4/74AWv/vAF3/7wC8/+8A0f++ANX/vgEZ/+8BMv++ATr/vgKB/+8Cgv/vAtv/vgLd/74C3/++AvD/7wNz/+8Djv++A5b/7wOf/+8Dp//vA7j/7wPA/+8D4f/vA+P/7wPl/+8EQv/vBET/7wRG/+8ETf++ADQAOP/mADr/5wA8//IAPf/nAFz/8QDR/+YA1f/mANn/8gDd/+4A4P/oAO3/8QEY/+cBMv/mATr/5gJm/+cC2//mAt3/5gLf/+YC7//nAvH/5wNY/+cDZ//nA2j/8gNq/+cDgv/uA47/5gOP//IDl//xA6b/5wO3/+cDv//nA8L/8gPD//ED0P/yA9H/8QPg/+4D4v/uA+T/7gPm/+gD6v/yA+v/8QRB/+cEQ//nBEX/5wRN/+YET//yBFD/8QRR/+gEU//oBFf/8gRY//EEav/nAIgAJQAQACf/6AAr/+gAM//oADX/6AA4/+AAOv/gAD3/3wCD/+gAkv/oAJf/6ACxABAAsv/oALMAEADR/+AA0v/oANMAEADV/+AA3AAQAOD/4QDxABAA+P/gAQMAEAEH/+gBDAAQARb/6AEY/+ABGv/oARz/6AEe/+gBIP/oATL/4AE4/+gBOv/gAVEAEAFV/+gCKP/oAin/6AIr/+gCLP/oAkwAEAJNABACTgAQAk8AEAJQABACUQAQAlIAEAJT/+gCXf/oAl7/6AJf/+gCYP/oAmH/6AJm/98CgwAQAoUAEAKHABACif/oAov/6AKN/+gCj//oAp3/6AKf/+gCof/oAqP/6ALF/+gCx//oAsn/6ALb/+AC3f/gAt//4ALv/98C8f/fAvr/6ANTABADV//oA1j/3wNbABADZP/oA2f/3wNq/98DgwAQA4r/6AON/+gDjv/gA6b/3wOvABADt//gA7r/6AO9/+gDv//fA8UAEAPHABAD2P/oA9r/6APc/+gD5v/hA+f/4APtABAD7gAQA+8AEAPxABAD8wAQA/UAEAP3ABAD+QAQA/sAEAP9ABAD/wAQBAEAEAQDABAEBQAQBBv/6AQd/+gEH//oBCH/6AQj/+gEJf/oBCf/6AQp/+gEK//oBC3/6AQv/+gEMf/oBEH/3wRD/98ERf/fBE3/4ARR/+EEUv/gBFP/4QRU/+AEaAAQBGkAEARq/98Eqv/oAC0AOP/xADr/9AA8//QAPf/wANH/8QDT//UA1f/xANn/9ADc//UA3f/zARj/9AEy//EBOv/xAVH/9QJm//AC2//xAt3/8QLf//EC7//wAvH/8ANY//ADZ//wA2j/9ANq//ADgv/zA47/8QOP//QDpv/wA7f/9AO///ADwv/0A9D/9APg//MD4v/zA+T/8wPq//QD7f/1BEH/8ARD//AERf/wBE3/8QRP//QEV//0BGj/9QRq//AAWQAlAA8AOP/mADr/5gA8AA4APf/mALEADwCzAA8A0f/mANMADgDV/+YA2QAOANwADgDdAAsA4P/lAPEADwD4/+gBAwAPAQwADwEY/+YBMv/mATr/5gFRAA4CTAAPAk0ADwJOAA8CTwAPAlAADwJRAA8CUgAPAmb/5gKDAA8ChQAPAocADwLb/+YC3f/mAt//5gLv/+YC8f/mA1MADwNY/+YDWwAPA2f/5gNoAA4Dav/mA4IACwODAA8Djv/mA48ADgOm/+YDrwAPA7f/5gO//+YDwgAOA8UADwPHAA8D0AAOA+AACwPiAAsD5AALA+b/5QPn/+gD6gAOA+0ADgPuAA8D7wAPA/EADwPzAA8D9QAPA/cADwP5AA8D+wAPA/0ADwP/AA8EAQAPBAMADwQFAA8EQf/mBEP/5gRF/+YETf/mBE8ADgRR/+UEUv/oBFP/5QRU/+gEVwAOBGgADgRpAA8Eav/mAC4AOP/jADz/5QA9/+QA0f/jANP/5QDV/+MA2f/lANz/5QDd/+kA8f/qAQP/6gEy/+MBOv/jAVH/5QJm/+QC2//jAt3/4wLf/+MC7//kAvH/5ANY/+QDZ//kA2j/5QNq/+QDgv/pA47/4wOP/+UDpv/kA7//5APC/+UD0P/lA+D/6QPi/+kD5P/pA+r/5QPt/+UD7v/qBEH/5ARD/+QERf/kBE3/4wRP/+UEV//lBGj/5QRp/+oEav/kACEAOP/iADz/5ADR/+IA0//kANX/4gDZ/+QA3P/kAN3/6QDx/+sBA//rATL/4gE6/+IBUf/kAtv/4gLd/+IC3//iA2j/5AOC/+kDjv/iA4//5APC/+QD0P/kA+D/6QPi/+kD5P/pA+r/5APt/+QD7v/rBE3/4gRP/+QEV//kBGj/5ARp/+sAFwA4/+sAPf/zANH/6wDV/+sBMv/rATr/6wJm//MC2//rAt3/6wLf/+sC7//zAvH/8wNY//MDZ//zA2r/8wOO/+sDpv/zA7//8wRB//MEQ//zBEX/8wRN/+sEav/zADAAUf/vAFL/7wBU/+8AXP/wAMD/7wDr/+8A7f/wAO//7wDw/+8A8v/vAPP/7wD0/+8A9//vAPn/7wD6/+8A/f/vAP//7wEE/+8BNf/vAUT/7wFJ/+8Cd//vAr//7wLB/+8Cw//vAsT/7wNt/+8Dkv/vA5T/7wOX//ADmf/vA57/7wOu/+8DtP/vA8P/8APR//AD1f/vA9f/7wPp/+8D6//wBEr/7wRM/+8EUP/wBFb/7wRY//AEY//vBGX/7wRn/+8AHQAG//IAC//yAFr/9QBd//UAvP/1ARn/9QFs//IBbf/yAW//8gFw//IBcf/yAoH/9QKC//UC8P/1A3P/9QOW//UDn//1A6f/9QOo//IDqf/yA6z/8gO4//UDwP/1A+H/9QPj//UD5f/1BEL/9QRE//UERv/1AAQA+P/tA+f/7QRS/+0EVP/tAFQAR//wAEj/8ABJ//AAS//wAFP/6wBV//AAk//wAJj/8AC6//AAx//wAMj/8AD2//ABAv/wARf/6wEd//ABIf/wATn/8AFL//ABTP/wAVb/8AJu//ACb//wAnD/8AJx//ACcv/wAnj/6wJ5/+sCev/rAnv/6wJ8/+sCiv/wAoz/8AKO//ACkP/wApL/8AKU//AClv/wApj/8AKa//ACnP/wAp7/8AKg//ACov/wAqT/8ALG/+sCyP/rAsr/6wNr//ADcf/rA3f/6wOR//ADk//rA5X/8AOY//ADs//wA7n/8AO+//ADzP/wA87/8APP//AD2f/rA9v/8APd/+sD7P/wBAj/8AQK//AEDP/wBA7/8AQQ//AEEv/wBBT/8AQW//AEHP/rBB7/6wQg/+sEIv/rBCT/6wQm/+sEKP/rBCr/8AQs//AELv/wBDD/6wQy//AAjwAGAA0ACwANAEX/8ABH/7AASP+wAEn/sABL/7AAU//WAFX/sABaAAsAXQALAJP/sACY/7AAuv+wALwACwDI/7AA8f+vAPb/sAEC/7ABA/+vARf/1gEZAAsBHf+wASH/sAE5/7ABS/+wAUz/sAFW/7ABbAANAW0ADQFvAA0BcAANAXEADQJn//ACaP/wAmn/8AJq//ACa//wAmz/8AJt//ACbv+wAm//sAJw/7ACcf+wAnL/sAJ4/9YCef/WAnr/1gJ7/9YCfP/WAoEACwKCAAsChP/wAob/8AKI//ACiv+wAoz/sAKO/7ACkP+wApL/sAKU/7AClv+wApj/sAKa/7ACnP+wAp7/sAKg/7ACov+wAqT/sALG/9YCyP/WAsr/1gLwAAsDa/+wA3H/1gNzAAsDd//WA5D/8AOR/7ADk//WA5X/sAOWAAsDmP+wA58ACwOnAAsDqAANA6kADQOsAA0DsP/wA7P/sAO4AAsDuf+wA77/sAPAAAsDxv/wA8j/8APM/7ADzv+wA8//sAPZ/9YD2/+wA93/1gPhAAsD4wALA+UACwPs/7AD7v+vA/D/8APy//AD9P/wA/b/8AP4//AD+v/wA/z/8AP+//AEAP/wBAL/8AQE//AEBv/wBAj/sAQK/7AEDP+wBA7/sAQQ/7AEEv+wBBT/sAQW/7AEHP/WBB7/1gQg/9YEIv/WBCT/1gQm/9YEKP/WBCr/sAQs/7AELv+wBDD/1gQy/7AEQgALBEQACwRGAAsEaf+vAAgA8QAQAPj/8AEDABAD5//wA+4AEARS//AEVP/wBGkAEABFAEcADABIAAwASQAMAEsADABVAAwAkwAMAJgADAC6AAwAxwAMAMgADADxABgA9gAMAPj/9wECAAwBAwAYAR0ADAEhAAwBOQAMAUsADAFMAAwBVgAMAm4ADAJvAAwCcAAMAnEADAJyAAwCigAMAowADAKOAAwCkAAMApIADAKUAAwClgAMApgADAKaAAwCnAAMAp4ADAKgAAwCogAMAqQADANrAAwDkQAMA5UADAOYAAwDswAMA7kADAO+AAwDzAAMA84ADAPPAAwD2wAMA+f/9wPsAAwD7gAYBAgADAQKAAwEDAAMBA4ADAQQAAwEEgAMBBQADAQWAAwEKgAMBCwADAQuAAwEMgAMBFL/9wRU//cEaQAYAB8AWv/0AFz/8ABd//QAvP/0AO3/8ADx//MBA//zARn/9AKB//QCgv/0AvD/9ANz//QDlv/0A5f/8AOf//QDp//0A7j/9APA//QDw//wA9H/8APh//QD4//0A+X/9APr//AD7v/zBEL/9ARE//QERv/0BFD/8ARY//AEaf/zAAoABv/WAAv/1gFs/9YBbf/WAW//1gFw/9YBcf/WA6j/1gOp/9YDrP/WAAoABv/1AAv/9QFs//UBbf/1AW//9QFw//UBcf/1A6j/9QOp//UDrP/1ACEATAAgAE8AIABQACAAU/+AAFf/kAEX/4ACeP+AAnn/gAJ6/4ACe/+AAnz/gALG/4ACyP+AAsr/gALS/5AC1P+QAtb/kALY/5AC2v+QA3H/gAN3/4ADk/+AA5r/kAPZ/4AD3f+ABBz/gAQe/4AEIP+ABCL/gAQk/4AEJv+ABCj/gAQw/4AAAgeKAAQAAApeEb4AIQAdAAAAEf/O/48AEv/1/+//iP/0/7v/f//1AAz/qf+i/8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+UAAAAA/+j/yQAA//MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAD/5QARAAAAAAAAAAAAAP/jAAAAAAAA/+T/5AAAABIAEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/4QAAAAAAAAAAAAAAAAAAAAD/5QAAAAD/6v/VAAAAAP/r/+r/mv/pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+YAAAAAAAAAAAAA/+0AAAAU/+8AAAAAAAAAAAAAAAAAAAAAAAD/7QAAAAAAAAAAAAAAAAAAAAD/y/+4/3z/fv/kAAAAAP+dAA8AEP+h/8QAEAAQAAAAAP+xAAD/JgAA/53/s/8Y/5P/8P+P/4z/EAAA/5L/cv8M/w//vQAAAAD/RAAFAAf/S/+GAAcABwAAAAD/PgAA/noAAP9E/2r+Yv8z/9H/LP8nAAAAAAAAAAAAAP/YAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/7AAAAAAAAAAAAAAAAAAAAAAAAP/Y/6MAAP/hAAAAAP/lAAAAAP/pAAAAAAAAAAAAAAAAAAAAAAAA/+YAAP/A/+kAAAAAAAAAAAAAAAD/ewAAAAD/v//K/rAAAP9x/u3/1AAA/1H/EQAAAAAAEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/JAA8AAP/ZAAAAAAAA//MAAAAAAAAAAAAAAAAAAAAA/3b/4f68/+b/8wAAAAAAAAAA//UAAP84AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9QAAAAD/8wAAAAD/0gAAAAD/5AAAAAAAAAAAAAD/tQAA/x8AAP/UAAD/2wAAAAD/0gAAAAAAAAAR/+H/0QAR/+cAAAAA/+sAAAAA/+sAAAAOAAAAAAAAAAAAAAAAAAD/5gAA/9IAAAAAAAAAAAAAAAAAAP/sAAAAAP/j/6AAAP+/ABEAEf/Z/+IAEgASAAAAAP+iAA3/LQAA/7//6f/M/9j/8P+3/8b/oAAAAAAAAAAAAAAAAAAAAAD/4QAAAA7/7QAAAAAAAAAAAAD/1QAA/4UAAP/hAAD/xAAAAAD/3wAAAAAAAAAA/+UAAAAA/+YAAAAA/+sAAAAA/+0AAAAAAAAAAAAAAA0AAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAD/ygAA/+n/u//pAAAAAP+9AAAAEgAAAAAAAAASAAAAAP+lAAD+bQAA/70AAP+J/5oAAP+R/9IAAAAAAAD/8QAAAAAAAAAA/70AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAD/8gAAAAD/4wAAAAAAAAAA//EAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAAAAD/8wAAAAAAAAAA//IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+YAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/xAAD/8AAAAAD/eAAAAAAAAAAA//AAAAAAAAAAAAAAAAAAAAAAAAD/6wAAAAAAAAAAAAAAAAAAAAAAAAAA/9cAAAAAAA//8QAAAAAAAAAAAAAAAAAAAAAAAAAA/5UAAP/zAAAAAAAAAAD/8QAAAAAAAAAAABIAAAAAAAAAAAAQ/+wAAAAAAAAAAAAAAAAAAAAAAAAAAP+FAAD/7QAAAAAAAAAA/9gAAAAAAAAAAAAAAAAAAAAAAAAAAP/sAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP+V/8MAAAAAAAAAAAAAAAAAAAAA/4gAAAAAAAD/xQAAAAD/7AAA/87/sAAAAAAAAAAAAAAAAAAAAAD/VgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//UAAAAAAAAAAAAA/8AAAAAA/vUAAAAA/8j/rf/n/+sAAP/wAAAAAAAA/8kAAAAAAAAAAAAAAAAAAAAA/93/2QAAAAAAAP95AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/1AAAAAAAAAAAAAAAAAAIAeAAGAAYAAAALAAsAAQAQABAAAgASABIAAwAlACkABAAsADQACQA4AD4AEgBFAEcAGQBJAEkAHABMAEwAHQBRAFQAHgBWAFYAIgBaAFoAIwBcAF4AJACKAIoAJwCwALMAKAC8ALwALADAAMAALQDGAMYALgDTANQALwDWANYAMQDZANkAMgDbAN0AMwDfAN8ANgDhAOEANwDjAOMAOADlAOUAOQDrAOsAOgDtAO0AOwD2APYAPAD7APsAPQD9AP4APgEDAQQAQAEJAQkAQgEMAQwAQwEXARkARAErAS0ARwEwATAASgEyATIASwFJAUkATAFsAXIATQF2AXcAVAIoAigAVgIqAisAVwJHAkgAWQJKAkoAWwJMAnIAXAJ3AnwAgwKBApEAiQKTApwAmgKlAqcApAKpAqkApwKrAqsAqAKtAq0AqQKvAq8AqgKyArIAqwK0ArQArAK2ArYArQK4ArgArgK6AroArwK8ArwAsAK+AsoAsQLMAswAvgLOAs4AvwLQAtAAwALbAtsAwQLdAt0AwgLfAt8AwwLhAuEAxALjAuMAxQLlAuUAxgLnAucAxwLpAukAyALrAusAyQLtAu0AygLvAvcAywNTA1gA1ANbA2oA2gNtA20A6gNxA3EA6wNzA3MA7AN3A3cA7QN6A3sA7gN9A4YA8AOIA4oA+gOMA5EA/QOTA5kBAwOfA6ABCgOiA6IBDAOkA6QBDQOmA6kBDgOsA7EBEgOzA7MBGAO3A7gBGQO9A8gBGwPLA8wBJwPOA9EBKQPYA9kBLQPdA90BLwPfA+UBMAPqA+sBNwPvBBcBOQQZBBkBYgQbBCgBYwQwBDABcQQzBDMBcgQ1BDUBcwRBBEYBdARJBEkBegRLBEsBewRNBE0BfARPBFABfQRVBFgBfwRbBFsBgwRdBF4BhARgBGABhgRkBGQBhwRmBGYBiARqBGoBiQSqBKoBigACAToABgAGAB0ACwALAB0AEAAQAB4AEgASAB4AJgAmAAEAJwAnAAQAKAAoAAMAKQApAAUALAAtAAIALgAuAAwALwAvAAkAMAAwAAoAMQAyAAIAMwAzAAMANAA0AAsAOAA4AAYAOQA5AAwAOgA6AA0AOwA7ABAAPAA8AA4APQA9AA8APgA+ABEARQBFABMARgBGABUARwBHABQASQBJABYATABMABcAUQBSABcAUwBTABgAVABUABUAVgBWABoAWgBaABkAXABcABsAXQBdABkAXgBeABwAigCKABUAsACwAAcAsgCyAAMAvAC8ABkAwADAABcAxgDGABUA0wDUAB8A1gDWAAIA2QDZAA4A2wDcAAIA3QDdABIA3wDfAAIA4QDhAAIA4wDjAB8A5QDlAB8A6wDrAAgA7QDtABsA9gD2ABUA+wD7ACAA/QD9ACAA/gD+ABUBAwEEACABCQEJACABFwEXABgBGAEYAA0BGQEZABkBKwErABUBLAEsAAcBLQEtAAgBMAEwAAkBMgEyAAkBSQFJAAgBbAFtAB0BbgFuAB4BbwFxAB0BcgFyAB4BdgF3AB4CKAIoAAQCKgIrAAMCRwJIAAMCSgJKAAYCUwJTAAQCVAJXAAUCWAJcAAICXQJhAAMCYgJlAAwCZgJmAA8CZwJtABMCbgJuABQCbwJyABYCdwJ3ABcCeAJ8ABgCgQKCABkChAKEABMChgKGABMCiAKIABMCiQKJAAQCigKKABQCiwKLAAQCjAKMABQCjQKNAAQCjgKOABQCjwKPAAQCkAKQABQCkQKRAAMCkwKTAAUClAKUABYClQKVAAUClgKWABYClwKXAAUCmAKYABYCmQKZAAUCmgKaABYCmwKbAAUCnAKcABYCpQKlAAICpgKmABcCpwKnAAICqQKpAAICqwKrAAICrQKtAAICrwKvAAICsgKyAAwCtAK0AAkCtgK2AAoCuAK4AAoCugK6AAoCvAK8AAoCvgK+AAICvwK/ABcCwALAAAICwQLBABcCwgLCAAICwwLEABcCxQLFAAMCxgLGABgCxwLHAAMCyALIABgCyQLJAAMCygLKABgCzALMABoCzgLOABoC0ALQABoC2wLbAAYC3QLdAAYC3wLfAAYC4QLhAAwC4wLjAAwC5QLlAAwC5wLnAAwC6QLpAAwC6wLrAAwC7QLtABAC7wLvAA8C8ALwABkC8QLxAA8C8gLyABEC8wLzABwC9AL0ABEC9QL1ABwC9gL2ABEC9wL3ABwDVANUAAUDVQNWAAIDVwNXAAMDWANYAA8DXANcAAEDXQNdAAUDXgNeABEDXwNgAAIDYQNhAAkDYgNjAAIDZANkAAMDZQNlAAsDZgNmAAYDZwNnAA8DaANoAA4DaQNpAAIDagNqAA8DbQNtABcDcQNxABgDcwNzABkDdwN3ABgDegN6AAUDewN7AAcDfQN+AAIDfwN/AAwDgAOBAAkDggOCABIDhAOEAAEDhQOFAAcDhgOGAAUDiAOJAAIDigOKAAMDjAOMAAsDjQONAAQDjgOOAAYDjwOPAA4DkAOQABMDkQORABYDkwOTABgDlAOUABUDlQOVABQDlgOWABkDlwOXABsDmAOYABYDmQOZAAgDnwOfABkDoAOgABADogOiABADpAOkABADpgOmAA8DpwOnABkDqAOpAB0DrAOsAB0DrQOtAAIDrgOuABcDsAOwABMDsQOxAAUDswOzABYDtwO3AA0DuAO4ABkDvQO9AAQDvgO+ABQDvwO/AA8DwAPAABkDwQPBAAIDwgPCAA4DwwPDABsDxAPEAAIDxgPGABMDyAPIABMDywPLAAUDzAPMABYDzgPPABYD0APQAA4D0QPRABsD2APYAAMD2QPZABgD3QPdABgD3wPfABUD4APgABID4QPhABkD4gPiABID4wPjABkD5APkABID5QPlABkD6gPqAA4D6wPrABsD8APwABMD8gPyABMD9AP0ABMD9gP2ABMD+AP4ABMD+gP6ABMD/AP8ABMD/gP+ABMEAAQAABMEAgQCABMEBAQEABMEBgQGABMEBwQHAAUECAQIABYECQQJAAUECgQKABYECwQLAAUEDAQMABYEDQQNAAUEDgQOABYEDwQPAAUEEAQQABYEEQQRAAUEEgQSABYEEwQTAAUEFAQUABYEFQQVAAUEFgQWABYEFwQXAAIEGQQZAAIEGwQbAAMEHAQcABgEHQQdAAMEHgQeABgEHwQfAAMEIAQgABgEIQQhAAMEIgQiABgEIwQjAAMEJAQkABgEJQQlAAMEJgQmABgEJwQnAAMEKAQoABgEMAQwABgEMwQzAAwENQQ1AAwEQQRBAA8EQgRCABkEQwRDAA8ERAREABkERQRFAA8ERgRGABkESQRJAAkESwRLAAIETQRNAAYETwRPAA4EUARQABsEVQRVAAcEVgRWAAgEVwRXAA4EWARYABsEWwRbABcEXQRdAB8EXgReAAcEYARgAAkEZARkAAIEZgRmAAIEagRqAA8EqgSqAAMAAgFtAAYABgAHAAsACwAHABAAEAATABEAEQAXABIAEgATACUAJQARACcAJwAFACsAKwAFAC4ALgAcADMAMwAFADUANQAFADcANwAZADgAOAAKADkAOQAGADoAOgANADsAOwAJADwAPAASAD0APQAOAD4APgAUAEUARQAaAEcASQAVAEsASwAVAFEAUgAYAFMAUwAIAFQAVAAYAFUAVQAVAFcAVwAbAFkAWQALAFoAWgACAFwAXAAWAF0AXQACAF4AXgAMAIMAgwAFAJIAkgAFAJMAkwAVAJcAlwAFAJgAmAAVAJoAmgALALEAsQARALIAsgAFALMAswARALoAugAVALwAvAACAMAAwAAYAMcAyAAVAMoAygALANEA0QAKANIA0gAFANMA0wABANUA1QAKANkA2QASANwA3AABAN0A3QAQAOAA4AAPAOsA6wAYAO0A7QAWAO8A8AAYAPEA8QAEAPIA9AAYAPYA9gAVAPcA9wAYAPgA+AADAPkA+gAYAP0A/QAYAP8A/wAYAQIBAgAVAQMBAwAEAQQBBAAYAQcBBwAFAQwBDAARARYBFgAFARcBFwAIARgBGAANARkBGQACARoBGgAFARwBHAAFAR0BHQAVAR4BHgAFASABIAAFASEBIQAVATIBMgAKATUBNQAYATgBOAAFATkBOQAVAToBOgAKAUQBRAAYAUkBSQAYAUsBTAAVAVEBUQABAVUBVQAFAVYBVgAVAWkBagAXAWwBbQAHAW4BbgATAW8BcQAHAXIBcgATAXYBdwATAigCKQAFAisCLAAFAkYCRgAXAkwCUgARAlMCUwAFAl0CYQAFAmICZQAGAmYCZgAOAmcCbQAaAm4CcgAVAncCdwAYAngCfAAIAn0CgAALAoECggACAoMCgwARAoQChAAaAoUChQARAoYChgAaAocChwARAogCiAAaAokCiQAFAooCigAVAosCiwAFAowCjAAVAo0CjQAFAo4CjgAVAo8CjwAFApACkAAVApICkgAVApQClAAVApYClgAVApgCmAAVApoCmgAVApwCnAAVAp0CnQAFAp4CngAVAp8CnwAFAqACoAAVAqECoQAFAqICogAVAqMCowAFAqQCpAAVArICsgAcAr8CvwAYAsECwQAYAsMCxAAYAsUCxQAFAsYCxgAIAscCxwAFAsgCyAAIAskCyQAFAsoCygAIAtEC0QAZAtIC0gAbAtMC0wAZAtQC1AAbAtUC1QAZAtYC1gAbAtcC1wAZAtgC2AAbAtkC2QAZAtoC2gAbAtsC2wAKAt0C3QAKAt8C3wAKAuEC4QAGAuIC4gALAuMC4wAGAuQC5AALAuUC5QAGAuYC5gALAucC5wAGAugC6AALAukC6QAGAuoC6gALAusC6wAGAuwC7AALAu0C7QAJAu8C7wAOAvAC8AACAvEC8QAOAvIC8gAUAvMC8wAMAvQC9AAUAvUC9QAMAvYC9gAUAvcC9wAMAvoC+gAFA1MDUwARA1cDVwAFA1gDWAAOA1sDWwARA14DXgAUA2QDZAAFA2cDZwAOA2gDaAASA2oDagAOA2sDawAVA20DbQAYA28DbwALA3EDcQAIA3MDcwACA3YDdgALA3cDdwAIA3gDeAALA38DfwAcA4IDggAQA4MDgwARA4oDigAFA40DjQAFA44DjgAKA48DjwASA5ADkAAaA5EDkQAVA5IDkgAYA5MDkwAIA5QDlAAYA5UDlQAVA5YDlgACA5cDlwAWA5gDmAAVA5kDmQAYA5oDmgAbA54DngAYA58DnwACA6ADoAAJA6IDogAJA6QDpAAJA6YDpgAOA6cDpwACA6gDqQAHA6wDrAAHA64DrgAYA68DrwARA7ADsAAaA7MDswAVA7QDtAAYA7cDtwANA7gDuAACA7kDuQAVA7oDugAFA70DvQAFA74DvgAVA78DvwAOA8ADwAACA8IDwgASA8MDwwAWA8UDxQARA8YDxgAaA8cDxwARA8gDyAAaA8wDzAAVA84DzwAVA9AD0AASA9ED0QAWA9UD1QAYA9cD1wAYA9gD2AAFA9kD2QAIA9oD2gAFA9sD2wAVA9wD3AAFA90D3QAIA+AD4AAQA+ED4QACA+ID4gAQA+MD4wACA+QD5AAQA+UD5QACA+YD5gAPA+cD5wADA+kD6QAYA+oD6gASA+sD6wAWA+wD7AAVA+0D7QABA+4D7gAEA+8D7wARA/AD8AAaA/ED8QARA/ID8gAaA/MD8wARA/QD9AAaA/UD9QARA/YD9gAaA/cD9wARA/gD+AAaA/kD+QARA/oD+gAaA/sD+wARA/wD/AAaA/0D/QARA/4D/gAaA/8D/wARBAAEAAAaBAEEAQARBAIEAgAaBAMEAwARBAQEBAAaBAUEBQARBAYEBgAaBAgECAAVBAoECgAVBAwEDAAVBA4EDgAVBBAEEAAVBBIEEgAVBBQEFAAVBBYEFgAVBBsEGwAFBBwEHAAIBB0EHQAFBB4EHgAIBB8EHwAFBCAEIAAIBCEEIQAFBCIEIgAIBCMEIwAFBCQEJAAIBCUEJQAFBCYEJgAIBCcEJwAFBCgEKAAIBCkEKQAFBCoEKgAVBCsEKwAFBCwELAAVBC0ELQAFBC4ELgAVBC8ELwAFBDAEMAAIBDEEMQAFBDIEMgAVBDMEMwAGBDQENAALBDUENQAGBDYENgALBDgEOAALBDoEOgALBDwEPAALBD4EPgALBEAEQAALBEEEQQAOBEIEQgACBEMEQwAOBEQERAACBEUERQAOBEYERgACBEoESgAYBEwETAAYBE0ETQAKBE8ETwASBFAEUAAWBFEEUQAPBFIEUgADBFMEUwAPBFQEVAADBFYEVgAYBFcEVwASBFgEWAAWBGMEYwAYBGUEZQAYBGcEZwAYBGgEaAABBGkEaQAEBGoEagAOBHAEcAAXBKoEqgAFAAEAAAAKAgYG8AAEREZMVAAaY3lybABIZ3JlawB2bGF0bgCkAAQAAAAA//8AEgAAAAoAFAAeACgANABBAEsAVQBfAGkAcwB9AIcAkQCbAKUArwAEAAAAAP//ABIAAQALABUAHwApADUAQgBMAFYAYABqAHQAfgCIAJIAnACmALAABAAAAAD//wASAAIADAAWACAAKgA2AEMATQBXAGEAawB1AH8AiQCTAJ0ApwCxACgABkFaRSAAVENSVCAAfk1PTCAAqE5BViAA1FJPTSABAFRVUiABLAAA//8AEwADAA0AFwAhACsAMgA3AEQATgBYAGIAbAB2AIAAigCUAJ4AqACyAAD//wASAAQADgAYACIALAA4AEUATwBZAGMAbQB3AIEAiwCVAJ8AqQCzAAD//wASAAUADwAZACMALQA5AEYAUABaAGQAbgB4AIIAjACWAKAAqgC0AAD//wATAAYAEAAaACQALgA6AD4ARwBRAFsAZQBvAHkAgwCNAJcAoQCrALUAAP//ABMABwARABsAJQAvADsAPwBIAFIAXABmAHAAegCEAI4AmACiAKwAtgAA//8AEwAIABIAHAAmADAAPABAAEkAUwBdAGcAcQB7AIUAjwCZAKMArQC3AAD//wATAAkAEwAdACcAMQAzAD0ASgBUAF4AaAByAHwAhgCQAJoApACuALgAuWMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGMyc2MEWGNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmNjbXAEXmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRsaWcEZmRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGRub20EbGZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmZyYWMEcmxpZ2EEfGxpZ2EEhGxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxudW0EimxvY2wEkGxvY2wElmxvY2wEnG51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom51bXIEom9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqG9udW0EqHBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnBudW0ErnNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNtY3AEtHNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDEEunNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDIEwHNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDMExnNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDQEzHNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDUE0nNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDYE2HNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nNzMDcE3nRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5HRudW0E5AAAAAEAAAAAAAIAAgADAAAAAQAHAAAAAQAYAAAAAwAVABYAFwAAAAIACAAJAAAAAQAJAAAAAQAUAAAAAQAEAAAAAQAGAAAAAQAFAAAAAQAZAAAAAQARAAAAAQATAAAAAQABAAAAAQAKAAAAAQALAAAAAQAMAAAAAQANAAAAAQAOAAAAAQAPAAAAAQAQAAAAAQASABsAOAPGBrQHYA3wDfAOBg4oDl4OhA6yDsYO2g7uDwAPGg9cD3oPmA/KD/wQLhBCEHoQbBB6EKYAAQAAAAEACAACAcQA3wHnAboBuwG8Ab0BvgG/AcABwQHCAcMBxAHFAcYBxwHIAckBygHLAcwBzQHOAc8B0AHRAdIB0wHoAekCRAI7AeoB6wHsAe0B7gHvAfAB8QHyAfMB9AH1AfYB9wH4AfkB+gH7AfwB/QH+AgACAQTdAgICAwIEAgUCBgIHAggCCQIKAgsCLwIPAhACEQIUAhUCFgIXAhgCGQIbAhwCHgIdAvwC/QL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZAxoDGwMcAx0DHgMfAyADIQMiAyMDJAMlAyYDJwMoAykDKgMrAywDLQMuAy8DMAMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNPA1ADUQNSBKsErAStBK4ErwSwBLEEsgSzBLQEtQS2BLcEuAS5BLoEuwS8BL0EvgS/BMAEwQTCBMMExATFBMYB/wTHBMgEyQTKBMsEzATNBM4EzwTQBNEE0gTTBNQE1QTWBNgE2QTbAhoE3AIOBNcCEwINBNoCDAISAAEA3wAIACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0APgBlAGcAhQCSALAAsQCyALMAtAC1ALYAtwC4ALkA0QDSANMA1ADVANYA1wDYANkA2gDbANwA3QDeAN8A4ADhAOIA4wDkAOUA5gDnAOgBLAEwATIBOAE6ATwBPgE/AUUBRgF/AYUBigGNAkcCSAJKAkwCTQJOAk8CUAJRAlICUwJUAlUCVgJXAlgCWQJaAlsCXAJdAl4CXwJgAmECYgJjAmQCZQJmAoMChQKHAokCiwKNAo8CkQKTApUClwKZApsCnQKfAqECowKlAqcCqQKrAq0CrwKyArQCtgK4AroCvAK+AsACwgLFAscCyQLLAs0CzwLRAtMC1QLZAtsC3QLfAuEC4wLlAucC6QLrAu0C7wLxAvIC9AL2A1MDVANVA1YDVwNYA1kDWwNcA10DXgNfA2ADYQNiA2QDZQNmA2cDaANpA2oDegN7A3wDfQN+A38DgAOBA4IDgwOEA4UDhgOHA4gDiQOKA4sDjAONA44DjwO7A70DvwPUA9oD4ARJBEsETwRXBFkEXgRqAAEAAAABAAgAAgF0ALcBugG7AbwBvQG+Ab8BwAHBAcIBwwHEAcUBxgHHAcgByQHKAcsBzAHNAc4BzwHQAdEB0gHTAv0DMAI7AfoEygTLAfsB/AH9Af4B/wIABM4EzwTRBNQE3QICAgMCBAIFAgYCBwIIAgkCCgILAfQB9QH2AfcB+AH5Ai8CDwIQAhECFAIVAhcCGQL+Av8DAAMBAwIDAwMEAwUDBgMHAwgDCQMKAwsDDAMNAw4DDwMQAxEDEgMTAxQDFQMWAxcDGAMZA08DGgMbAxwDHQMeAx8DIAMhAyIDIwMkAyUDJgMnAygDKQMqAysDLAMtAy4DLwMxAzIDMwM0AzUDNgM3AzgDOQM6AzsDPAM9Az4DPwNAA0EDQgNDA0QDRgNFA0cDSANJA0oDSwNMA00DTgNQA1EDUgTJBMwEzQTQBNIE0wIBBNUEwQTCBMMExATFBMYExwTIBNYE2ATZAhgE2wIaBNwC/AIOBNcCEwINBNoCFgIMAhIAAQC3AEUARgBHAEgASQBKAEsATABNAE4ATwBQAFEAUgBTAFQAVQBWAFcAWABZAFoAWwBcAF0AXgCHAIwAkwDpAOoA6wDsAO0A7gDvAPAA8QDyAPMA9AD1APYA9wD4APkA+gD7APwA/QD+AP8BAAEBAQIBAwEEAQUBBgEtATEBMwE5ATsBPQFAAUcCSwJnAmgCaQJqAmsCbAJtAm4CbwJwAnECcgJzAnQCdQJ2AncCeAJ5AnoCewJ8An0CfgJ/AoACgQKCAoQChgKIAooCjAKOApACkgKUApYCmAKaApwCngKgAqICpAKmAqgCqgKsAq4CswK1ArcCuQK7Ar0CvwLBAsMCxgLIAsoCzALOAtAC0gLUAtYC2gLcAt4C4ALiAuQC5gLoAuoC7ALuAvAC8wL1AvcDkAORA5IDkwOUA5UDlgOXA5gDmQOaA5sDnAOdA54DnwO8A74DwAPOA9UD2wPhBEcESgRMBFAEWARaBFsEXwRrAAYAAAAGABIAKgBCAFoAcgCKAAMAAAABABIAAQCQAAEAAAAaAAEAAQBNAAMAAAABABIAAQB4AAEAAAAaAAEAAQBOAAMAAAABABIAAQBgAAEAAAAaAAEAAQKuAAMAAAABABIAAQBIAAEAAAAaAAEAAQObAAMAAAABABIAAQAwAAEAAAAaAAEAAQOdAAMAAAABABIAAQAYAAEAAAAaAAEAAQQaAAIAAQCnAKsAAAAEAAAAAQAIAAEGHgA2AHIApACuALgAygD8AQ4BGAFKAWQBfgGQAboB7AH2AhgCMgJEAnYCiAKiAswC3gMQAxoDJAM2A2gDcgN8A4YDoAO6A8wD9gQoBDIEVARuBIAEsgTEBN4FCAUaBSQFLgU4BUIFbAWWBcAF6gYUAAYADgAUABoAIAAmACwCTAACAKcCTQACAKgCTwACAKkD8QACAKoEewACAKsD7wACAKwAAQAEBIgAAgCsAAEABAKJAAIAqAACAAYADASKAAIArASMAAIBogAGAA4AFAAaACAAJgAsAlQAAgCnAlUAAgCoBAsAAgCpBAkAAgCqBH0AAgCrBAcAAgCsAAIABgAMBHcAAgCoAqMAAgGiAAEABASOAAIArAAGAA4AFAAaACAAJgAsAlgAAgCnAlkAAgCoAqcAAgCpBBcAAgCqBH8AAgCrBBkAAgCsAAMACAAOABQEkAACAKgEkgACAKwCtAACAaIAAwAIAA4AFAK2AAIAqASUAAIArAK4AAIBogACAAYADAOtAAIAqASWAAIArAAFAAwAEgAYAB4AJAR5AAIApwK+AAIAqAJcAAIAqQSYAAIArALAAAIBogAGAA4AFAAaACAAJgAsAl0AAgCnAl4AAgCoAmAAAgCpBB0AAgCqBIEAAgCrBBsAAgCsAAEABASaAAIAqAAEAAoAEAAWABwCywACAKgEgwACAKsEnAACAKwCzQACAaIAAwAIAA4AFALRAAIAqASeAAIArALXAAIBogACAAYADASgAAIArALbAAIBogAGAA4AFAAaACAAJgAsAmIAAgCnAmMAAgCoAuEAAgCpBDUAAgCqBIUAAgCrBDMAAgCsAAIABgAMBKIAAgCpBKQAAgCsAAMACAAOABQDoAACAKcDogACAKgEpgACAKwABQAMABIAGAAeACQDpgACAKcCZgACAKgERQACAKkEQwACAKoEQQACAKwAAgAGAAwC8gACAKgEqAACAKwABgAOABQAGgAgACYALAJnAAIApwJoAAIAqAJqAAIAqQPyAAIAqgR8AAIAqwPwAAIArAABAAQEiQACAKwAAQAEAooAAgCoAAIABgAMBIsAAgCsBI0AAgGiAAYADgAUABoAIAAmACwCbwACAKcCcAACAKgEDAACAKkECgACAKoEfgACAKsECAACAKwAAQAEBHgAAgCoAAEABASPAAIArAABAAQEGgACAKwAAwAIAA4AFASRAAIAqASTAAIArAK1AAIBogADAAgADgAUArcAAgCoBJUAAgCsArkAAgGiAAIABgAMA64AAgCoBJcAAgCsAAUADAASABgAHgAkBHoAAgCnAr8AAgCoAncAAgCpBJkAAgCsAsEAAgGiAAYADgAUABoAIAAmACwCeAACAKcCeQACAKgCewACAKkEHgACAKoEggACAKsEHAACAKwAAQAEBJsAAgCoAAQACgAQABYAHALMAAIAqASEAAIAqwSdAAIArALOAAIBogADAAgADgAUAtIAAgCoBJ8AAgCsAtgAAgGiAAIABgAMBKEAAgCsAtwAAgGiAAYADgAUABoAIAAmACwCfQACAKcCfgACAKgC4gACAKkENgACAKoEhgACAKsENAACAKwAAgAGAAwEowACAKkEpQACAKwAAwAIAA4AFAOhAAIApwOjAAIAqASnAAIArAAFAAwAEgAYAB4AJAOnAAIApwKBAAIAqARGAAIAqQREAAIAqgRCAAIArAACAAYADALzAAIAqASpAAIArAABAAQC+AACAKgAAQAEAvoAAgCoAAEABAL5AAIAqAABAAQC+wACAKgABQAMABIAGAAeACQCcwACAKcCdAACAKgCqAACAKkEGAACAKoEgAACAKsABQAMABIAGAAeACQEKwACAKcEKQACAKgELwACAKkELQACAKoEMQACAKwABQAMABIAGAAeACQELAACAKcEKgACAKgEMAACAKkELgACAKoEMgACAKwABQAMABIAGAAeACQEOQACAKcENwACAKgEPQACAKkEOwACAKoEPwACAKwABQAMABIAGAAeACQEOgACAKcEOAACAKgEPgACAKkEPAACAKoEQAACAKwAAQAEBIcAAgCoAAIAEQAlACkAAAArAC0ABQAvADQACAA2ADsADgA9AD4AFABFAEkAFgBLAE0AGwBPAFQAHgBWAFsAJABdAF4AKgCBAIEALACDAIMALQCGAIYALgCJAIkALwCMAIwAMACXAJoAMQDPAM8ANQABAAAAAQAIAAEABgACAAEAAgLVAtYAAQAAAAEACAACAA4ABATeBN8E4AThAAEABAKHAogCmQKaAAQAAAABAAgAAQAmAAIACgAcAAIABgAMAaMAAgBKAagAAgBYAAEABAGpAAIAWAABAAIASgBXAAQAAAABAAgAAQBEAAIACgAUAAEABAGkAAIATQABAAQBpgACAE0ABAAAAAEACAABAB4AAgAKABQAAQAEAaUAAgBQAAEABAGnAAIAUAABAAIASgGjAAEAAAABAAgAAQAGAZUAAQABAEsAAQAAAAEACAABAAYBJwABAAEAugABAAAAAQAIAAEABgGsAAEAAQA2AAEAAAABAAgAAgAcAAIB4wHkAAEAAAABAAgAAgAKAAIB5QHmAAEAAgAvAE8AAQAAAAEACAACAB4ADAIoAioCKQIrAiwCHwIgAiECIgGuAiQCJQABAAwAJwAoACsAMwA1AEYARwBIAEsAUwBUAFUAAQAAAAEACAACAAwAAwImAicCJwABAAMASQBLAiIAAQAAAAEACAACAGYACAI9Ai0CLgIwAjECOQI6AjwAAQAAAAEACAACABYACAAbABUAFgAXABgAGQAdABQAAQAIAa0CIwRxBHIEcwR0BHUEdgABAAAAAQAIAAIAFgAIBHYCIwRxBHIEcwR0Aa0EdQABAAgAFAAVABYAFwAYABkAGwAdAAEAAAABAAgAAgAWAAgAFQAWABcAGAAZABsAHQAUAAEACAItAi4CMAIxAjkCOgI8Aj0AAQAAAAEACAABAAYBaQABAAEAEwAGAAAAAQAIAAMAAQASAAEAUgAAAAEAAAAaAAIAAgF8AXwAAAHUAd0AAQABAAAAAQAIAAEAKAHAAAEAAAABAAgAAgAaAAoCMgB6AHMAdAIzAjQCNQI2AjcCOAACAAEAFAAdAAAAAQAAAAEACAACACYAEAHUAdUB1gHXAdgB2QHaAdsB3AHdAkACPgJBAkICPwJDAAEAEAAUABUAFgAXABgAGQAaABsAHAAdAE0ATgKuA5sDnQQa"
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(14)))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _colorLuminance = __webpack_require__(10);

var _getModal = __webpack_require__(9);

var _hasClass$isDescendant = __webpack_require__(6);

/*
 * User clicked on "Confirm"/"OK" or "Cancel"
 */
var handleButton = function handleButton(event, params, modal) {
  var e = event || window.event;
  var target = e.target || e.srcElement;

  var targetedConfirm = target.className.indexOf('confirm') !== -1;
  var targetedOverlay = target.className.indexOf('sweet-overlay') !== -1;
  var modalIsVisible = _hasClass$isDescendant.hasClass(modal, 'visible');
  var doneFunctionExists = params.doneFunction && modal.getAttribute('data-has-done-function') === 'true';

  // Since the user can change the background-color of the confirm button programmatically,
  // we must calculate what the color should be on hover/active
  var normalColor, hoverColor, activeColor;
  if (targetedConfirm && params.confirmButtonColor) {
    normalColor = params.confirmButtonColor;
    hoverColor = _colorLuminance.colorLuminance(normalColor, -0.04);
    activeColor = _colorLuminance.colorLuminance(normalColor, -0.14);
  }

  function shouldSetConfirmButtonColor(color) {
    if (targetedConfirm && params.confirmButtonColor) {
      target.style.backgroundColor = color;
    }
  }

  switch (e.type) {
    case 'mouseover':
      shouldSetConfirmButtonColor(hoverColor);
      break;

    case 'mouseout':
      shouldSetConfirmButtonColor(normalColor);
      break;

    case 'mousedown':
      shouldSetConfirmButtonColor(activeColor);
      break;

    case 'mouseup':
      shouldSetConfirmButtonColor(hoverColor);
      break;

    case 'focus':
      var $confirmButton = modal.querySelector('button.confirm');
      var $cancelButton = modal.querySelector('button.cancel');

      if (targetedConfirm) {
        $cancelButton.style.boxShadow = 'none';
      } else {
        $confirmButton.style.boxShadow = 'none';
      }
      break;

    case 'click':
      var clickedOnModal = modal === target;
      var clickedOnModalChild = _hasClass$isDescendant.isDescendant(modal, target);

      // Ignore click outside if allowOutsideClick is false
      if (!clickedOnModal && !clickedOnModalChild && modalIsVisible && !params.allowOutsideClick) {
        break;
      }

      if (targetedConfirm && doneFunctionExists && modalIsVisible) {
        handleConfirm(modal, params);
      } else if (doneFunctionExists && modalIsVisible || targetedOverlay) {
        handleCancel(modal, params);
      } else if (_hasClass$isDescendant.isDescendant(modal, target) && target.tagName === 'BUTTON') {
        sweetAlert.close();
      }
      break;
  }
};

/*
 *  User clicked on "Confirm"/"OK"
 */
var handleConfirm = function handleConfirm(modal, params) {
  var callbackValue = true;

  if (_hasClass$isDescendant.hasClass(modal, 'show-input')) {
    callbackValue = modal.querySelector('input').value;

    if (!callbackValue) {
      callbackValue = '';
    }
  }

  params.doneFunction(callbackValue);

  if (params.closeOnConfirm) {
    sweetAlert.close();
  }
  // Disable cancel and confirm button if the parameter is true
  if (params.showLoaderOnConfirm) {
    sweetAlert.disableButtons();
  }
};

/*
 *  User clicked on "Cancel"
 */
var handleCancel = function handleCancel(modal, params) {
  // Check if callback function expects a parameter (to track cancel actions)
  var functionAsStr = String(params.doneFunction).replace(/\s/g, '');
  var functionHandlesCancel = functionAsStr.substring(0, 9) === 'function(' && functionAsStr.substring(9, 10) !== ')';

  if (functionHandlesCancel) {
    params.doneFunction(false);
  }

  if (params.closeOnCancel) {
    sweetAlert.close();
  }
};

exports['default'] = {
  handleButton: handleButton,
  handleConfirm: handleConfirm,
  handleCancel: handleCancel
};
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _stopEventPropagation$fireClick = __webpack_require__(6);

var _setFocusStyle = __webpack_require__(9);

var handleKeyDown = function handleKeyDown(event, params, modal) {
  var e = event || window.event;
  var keyCode = e.keyCode || e.which;

  var $okButton = modal.querySelector('button.confirm');
  var $cancelButton = modal.querySelector('button.cancel');
  var $modalButtons = modal.querySelectorAll('button[tabindex]');

  if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
    // Don't do work on keys we don't care about.
    return;
  }

  var $targetElement = e.target || e.srcElement;

  var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
  for (var i = 0; i < $modalButtons.length; i++) {
    if ($targetElement === $modalButtons[i]) {
      btnIndex = i;
      break;
    }
  }

  if (keyCode === 9) {
    // TAB
    if (btnIndex === -1) {
      // No button focused. Jump to the confirm button.
      $targetElement = $okButton;
    } else {
      // Cycle to the next button
      if (btnIndex === $modalButtons.length - 1) {
        $targetElement = $modalButtons[0];
      } else {
        $targetElement = $modalButtons[btnIndex + 1];
      }
    }

    _stopEventPropagation$fireClick.stopEventPropagation(e);
    $targetElement.focus();

    if (params.confirmButtonColor) {
      _setFocusStyle.setFocusStyle($targetElement, params.confirmButtonColor);
    }
  } else {
    if (keyCode === 13) {
      if ($targetElement.tagName === 'INPUT') {
        $targetElement = $okButton;
        $okButton.focus();
      }

      if (btnIndex === -1) {
        // ENTER/SPACE clicked outside of a button.
        $targetElement = $okButton;
      } else {
        // Do nothing - let the browser handle it.
        $targetElement = undefined;
      }
    } else if (keyCode === 27 && params.allowEscapeKey === true) {
      $targetElement = $cancelButton;
      _stopEventPropagation$fireClick.fireClick($targetElement, e);
    } else {
      // Fallback - let the browser handle it.
      $targetElement = undefined;
    }
  }
};

exports['default'] = handleKeyDown;
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var injectedHTML =

// Dark overlay
"<div class=\"sweet-overlay\" tabIndex=\"-1\"></div>" +

// Modal
"<div class=\"sweet-alert\">" +

// Error icon
"<div class=\"sa-icon sa-error\">\n      <span class=\"sa-x-mark\">\n        <span class=\"sa-line sa-left\"></span>\n        <span class=\"sa-line sa-right\"></span>\n      </span>\n    </div>" +

// Warning icon
"<div class=\"sa-icon sa-warning\">\n      <span class=\"sa-body\"></span>\n      <span class=\"sa-dot\"></span>\n    </div>" +

// Info icon
"<div class=\"sa-icon sa-info\"></div>" +

// Success icon
"<div class=\"sa-icon sa-success\">\n      <span class=\"sa-line sa-tip\"></span>\n      <span class=\"sa-line sa-long\"></span>\n\n      <div class=\"sa-placeholder\"></div>\n      <div class=\"sa-fix\"></div>\n    </div>" + "<div class=\"sa-icon sa-custom\"></div>" +

// Title, text and input
"<h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type=\"text\" tabIndex=\"3\" />\n      <div class=\"sa-input-error\"></div>\n    </fieldset>" +

// Input errors
"<div class=\"sa-error-container\">\n      <div class=\"icon\">!</div>\n      <p>Not valid!</p>\n    </div>" +

// Cancel and confirm buttons
"<div class=\"sa-button-container\">\n      <button class=\"cancel\" tabIndex=\"2\">Cancel</button>\n      <div class=\"sa-confirm-button-container\">\n        <button class=\"confirm\" tabIndex=\"1\">OK</button>" +

// Loading animation
"<div class=\"la-ball-fall\">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div>" +

// End of modal
"</div>";

exports["default"] = injectedHTML;
module.exports = exports["default"];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _isIE8 = __webpack_require__(10);

var _getModal$getInput$setFocusStyle = __webpack_require__(9);

var _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide = __webpack_require__(6);

var alertTypes = ['error', 'warning', 'info', 'success', 'input', 'prompt'];

/*
 * Set type, text and actions on modal
 */
var setParameters = function setParameters(params) {
  var modal = _getModal$getInput$setFocusStyle.getModal();

  var $title = modal.querySelector('h2');
  var $text = modal.querySelector('p');
  var $cancelBtn = modal.querySelector('button.cancel');
  var $confirmBtn = modal.querySelector('button.confirm');

  /*
   * Title
   */
  $title.innerHTML = params.html ? params.title : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.title).split('\n').join('<br>');

  /*
   * Text
   */
  $text.innerHTML = params.html ? params.text : _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.text || '').split('\n').join('<br>');
  if (params.text) _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($text);

  /*
   * Custom class
   */
  if (params.customClass) {
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, params.customClass);
    modal.setAttribute('data-custom-class', params.customClass);
  } else {
    // Find previously set classes and remove them
    var customClass = modal.getAttribute('data-custom-class');
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.removeClass(modal, customClass);
    modal.setAttribute('data-custom-class', '');
  }

  /*
   * Icon
   */
  _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide(modal.querySelectorAll('.sa-icon'));

  if (params.type && !_isIE8.isIE8()) {
    var _ret = (function () {

      var validType = false;

      for (var i = 0; i < alertTypes.length; i++) {
        if (params.type === alertTypes[i]) {
          validType = true;
          break;
        }
      }

      if (!validType) {
        logStr('Unknown alert type: ' + params.type);
        return {
          v: false
        };
      }

      var typesWithIcons = ['success', 'error', 'warning', 'info'];
      var $icon = undefined;

      if (typesWithIcons.indexOf(params.type) !== -1) {
        $icon = modal.querySelector('.sa-icon.' + 'sa-' + params.type);
        _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($icon);
      }

      var $input = _getModal$getInput$setFocusStyle.getInput();

      // Animate icon
      switch (params.type) {

        case 'success':
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animate');
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-tip'), 'animateSuccessTip');
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-long'), 'animateSuccessLong');
          break;

        case 'error':
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'animateErrorIcon');
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-x-mark'), 'animateXMark');
          break;

        case 'warning':
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon, 'pulseWarning');
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-body'), 'pulseWarningIns');
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass($icon.querySelector('.sa-dot'), 'pulseWarningIns');
          break;

        case 'input':
        case 'prompt':
          $input.setAttribute('type', params.inputType);
          $input.value = params.inputValue;
          $input.setAttribute('placeholder', params.inputPlaceholder);
          _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.addClass(modal, 'show-input');
          setTimeout(function () {
            $input.focus();
            $input.addEventListener('keyup', swal.resetInputError);
          }, 400);
          break;
      }
    })();

    if (typeof _ret === 'object') {
      return _ret.v;
    }
  }

  /*
   * Custom image
   */
  if (params.imageUrl) {
    var $customIcon = modal.querySelector('.sa-icon.sa-custom');

    $customIcon.style.backgroundImage = 'url(' + params.imageUrl + ')';
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.show($customIcon);

    var _imgWidth = 80;
    var _imgHeight = 80;

    if (params.imageSize) {
      var dimensions = params.imageSize.toString().split('x');
      var imgWidth = dimensions[0];
      var imgHeight = dimensions[1];

      if (!imgWidth || !imgHeight) {
        logStr('Parameter imageSize expects value with format WIDTHxHEIGHT, got ' + params.imageSize);
      } else {
        _imgWidth = imgWidth;
        _imgHeight = imgHeight;
      }
    }

    $customIcon.setAttribute('style', $customIcon.getAttribute('style') + 'width:' + _imgWidth + 'px; height:' + _imgHeight + 'px');
  }

  /*
   * Show cancel button?
   */
  modal.setAttribute('data-has-cancel-button', params.showCancelButton);
  if (params.showCancelButton) {
    $cancelBtn.style.display = 'inline-block';
  } else {
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($cancelBtn);
  }

  /*
   * Show confirm button?
   */
  modal.setAttribute('data-has-confirm-button', params.showConfirmButton);
  if (params.showConfirmButton) {
    $confirmBtn.style.display = 'inline-block';
  } else {
    _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.hide($confirmBtn);
  }

  /*
   * Custom text on cancel/confirm buttons
   */
  if (params.cancelButtonText) {
    $cancelBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.cancelButtonText);
  }
  if (params.confirmButtonText) {
    $confirmBtn.innerHTML = _hasClass$addClass$removeClass$escapeHtml$_show$show$_hide$hide.escapeHtml(params.confirmButtonText);
  }

  /*
   * Custom color on confirm button
   */
  if (params.confirmButtonColor) {
    // Set confirm button to selected background color
    $confirmBtn.style.backgroundColor = params.confirmButtonColor;

    // Set the confirm button color to the loading ring
    $confirmBtn.style.borderLeftColor = params.confirmLoadingButtonColor;
    $confirmBtn.style.borderRightColor = params.confirmLoadingButtonColor;

    // Set box-shadow to default focused button
    _getModal$getInput$setFocusStyle.setFocusStyle($confirmBtn, params.confirmButtonColor);
  }

  /*
   * Allow outside click
   */
  modal.setAttribute('data-allow-outside-click', params.allowOutsideClick);

  /*
   * Callback function
   */
  var hasDoneFunction = params.doneFunction ? true : false;
  modal.setAttribute('data-has-done-function', hasDoneFunction);

  /*
   * Animation
   */
  if (!params.animation) {
    modal.setAttribute('data-animation', 'none');
  } else if (typeof params.animation === 'string') {
    modal.setAttribute('data-animation', params.animation); // Custom animation
  } else {
    modal.setAttribute('data-animation', 'pop');
  }

  /*
   * Timer
   */
  modal.setAttribute('data-timer', params.timer);
};

exports['default'] = setParameters;
module.exports = exports['default'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(219);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f5701d8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-734af0f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4558beca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.name)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option",
    attrs: {
      "id": "res-air-temp"
    }
  }, [_c('input', {
    attrs: {
      "id": "ref-set-flow",
      "type": "number",
      "min": "0",
      "max": "30",
      "step": ".1",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm._f("RounderOut")(_vm.item.value)
    },
    on: {
      "focus": function($event) {
        $event.preventDefault();
        $event.target.blur()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__unit"
  }, [_vm._v(_vm._s(_vm.$t(_vm.converterType)))])])
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    class: {
      disabled: _vm.disabled
    }
  }, [_c('div', {
    staticClass: "setting__label",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.sub()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__plusmin",
    attrs: {
      "id": "set-flow-air"
    }
  }, [_c('span', {
    staticClass: "setting__plusmin"
  }, [_c('span', {
    staticClass: "sub",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.sub()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    attrs: {
      "disabled": _vm.disabled,
      "id": "ref-set-flow",
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".1"
    },
    domProps: {
      "value": _vm._f("Rounder")(_vm.item.value)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.target.blur()
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.onFocus(_vm.index, $event)
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.onBlur(_vm.index, $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.add()
      }
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__unit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.add()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.converterType)))])])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper",
    class: [_vm.settings.Language.items[_vm.settings.Language.selected].name, _vm.setDeviceClass],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "aside-overlay",
    class: [{
      active: _vm.settingsActive
    }, {
      active: _vm.referenceconditions
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "splash",
    class: {
      active: _vm.splashActive
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "aside-wrapper aside-wrapper--info",
    class: {
      active: _vm.referenceconditions
    }
  }, [_c('div', {
    staticClass: "aside__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('t-reference-conditions-explanation')))]), _vm._v(" "), _c('a', {
    staticClass: "aside__close",
    attrs: {
      "href": "#",
      "title": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside__body"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('t-reference-conditions-explanation-text')) + "\n\t\t\t"), _c('table', {
    staticClass: "reference-conditions-table"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('t-unit')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-pressure')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-temperature')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('t-Relativehumidity')))])]), _vm._v(" "), _vm._l((_vm.referenceConditionsData), function(item, index) {
    return _c('tr', {
      key: ('reftab' + index)
    }, [_c('td', {
      domProps: {
        "innerHTML": _vm._s(item.unit)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.pressure)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.temperature)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(item.Relativehumidity)
      }
    })])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "aside-wrapper aside-wrapper--settings",
    class: {
      active: _vm.settingsActive
    }
  }, [_c('div', {
    staticClass: "aside__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('t-settings')))]), _vm._v(" "), _c('a', {
    staticClass: "aside__close",
    attrs: {
      "href": "#",
      "title": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(false)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-close"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside__body"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.updateLanguage))]), _vm._v(" "), _c('inputdropdown', {
    attrs: {
      "item": _vm.settings.Language
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CompressedAirFlow
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.Pressure
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.Temperature
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CoolingWaterflow
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.CoolingWaterInput
    }
  }), _vm._v(" "), _c('inputtabs', {
    attrs: {
      "item": _vm.settings.GlycolType
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.GlycolConcentrationInCoolingWater,
      "unit": '%',
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('h3', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(true)
      }
    }
  }, [_c('svg', {
    staticClass: "icon-warning",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#warning2"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-reference-conditions')))]), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferenceTemperature,
      "unit": _vm.settings.Temperature.items[_vm.settings.Temperature.selected].name,
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferencePressure,
      "unit": _vm.settings.Pressure.items[_vm.settings.Pressure.selected].name,
      "selectedindex": _vm.unitlist.selected
    }
  }), _vm._v(" "), _c('inputfield', {
    attrs: {
      "item": _vm.settings.ReferenceRelativeHumidity,
      "unit": '%',
      "selectedindex": _vm.unitlist.selected
    }
  })], 1)]), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "header__inner"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header__title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('t-hd-coolers-calculation-tool')))])]), _vm._v(" "), _c('div', {
    staticClass: "header__btn"
  }, [_c('a', {
    staticClass: "header__btn--info btn--toggle ",
    attrs: {
      "href": "#",
      "data-aside-target": "distribution"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendReport()
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-info"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "header__btn--settings",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSettings(false)
      }
    }
  }, [_c('svg', {
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#btn-settings"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      active: _vm.isContentActive
    }
  }, [_c('div', {
    staticClass: "content-tabs"
  }, [_c('div', {
    staticClass: "setting__option tabs",
    attrs: {
      "id": "air-flow"
    }
  }, _vm._l((_vm.unitlist.items), function(item, index) {
    return _c('button', {
      key: item.id,
      staticClass: "tab-btn",
      class: {
        active: (_vm.unitlist.selected === index)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unitlistClicked(index)
        }
      }
    }, [_vm._v(_vm._s(item.Model))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-settings"
  }, [_c('div', {
    staticClass: "content-settings__box content-settings__box--left"
  }, [_c('div', {
    staticClass: "content-settings__box--top"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#air"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-inlet-compressed-air')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.inletCompressedAir), function(item, index) {
    return _c('inputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "Limitations": _vm.Limitations,
        "inputType": 'Fluid',
        "plugindataInput": _vm.plugindataInput
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box--bottom"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#water"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-cooling-water-input')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.coolingWateInput), function(item, index) {
    return _c('inputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "Limitations": _vm.Limitations,
        "inputType": 'Coolant',
        "plugindataInput": _vm.plugindataInput
      }
    })
  })], 2)]), _vm._v(" "), _c('bg-image', {
    attrs: {
      "unitlist": _vm.unitlist
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box content-settings__box--right content-settings__box--result"
  }, [_c('div', {
    staticClass: "content-settings__box--top content-settings__box--top-result"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#air"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-outlet-compressed-air')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.outletCompressedAir), function(item, index) {
    return _c('outputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "inputType": 'Fluid'
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-settings__box--bottom"
  }, [_c('h4', [_c('svg', {
    staticClass: "icon-settings-box",
    attrs: {
      "role": "img"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "./assets/img/svg_sprite/svg_sprite.svg#water"
    }
  })]), _vm._v(_vm._s(_vm.$t('t-cooling-water-output')) + "\n\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.coolingWaterOuput), function(item, index) {
    return _c('outputComponent', {
      key: item.id,
      attrs: {
        "item": item,
        "index": index,
        "inputType": 'Coolant'
      }
    })
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash__infobox"
  }, [_c('h3', {
    staticClass: "splash__title"
  }, [_vm._v("ATLAS COPCO\n\t\t\t\t"), _c('br'), _vm._v("HD Coolers Calculation Tool")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header__logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(214),
      "alt": "Atlas Copco logo"
    }
  })])
}]}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting "
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option tabs"
  }, _vm._l((_vm.item.items), function(options, index) {
    return _c('button', {
      key: options.id,
      staticClass: "tab-btn",
      class: {
        active: (_vm.item.selected === index)
      },
      attrs: {
        "type": "button",
        "value": index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.item.selected = index
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(options.name)) + "\n            ")])
  }))])
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.getLabel))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__plusmin",
    attrs: {
      "id": "set-flow-air"
    }
  }, [_c('span', {
    staticClass: "setting__plusmin"
  }, [_c('span', {
    staticClass: "sub",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sub()
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    class: _vm.isExceedingLimitations,
    attrs: {
      "id": "ref-set-flow",
      "type": "number",
      "min": "0",
      "max": "1000",
      "step": ".1"
    },
    domProps: {
      "value": _vm._f("Rounder")(_vm.item.value)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.target.blur()
      },
      "focus": function($event) {
        $event.preventDefault();
        _vm.onFocus(_vm.index, $event)
      },
      "blur": function($event) {
        $event.preventDefault();
        _vm.onBlur(_vm.index, $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add()
      }
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__unit"
  }, [_vm._v(_vm._s(_vm.$t(_vm.converterType)))])])
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.selected),
      expression: "item.selected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.item, "selected", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.ddTitle)))]), _vm._v(" "), _vm._l((_vm.item.items), function(options, index) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(options.name))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    staticClass: "content-settings__box content-settings__box--center outer",
    attrs: {
      "name": "imagelist",
      "tag": "div"
    }
  }, _vm._l((_vm.unitlist.items), function(item, index) {
    return (index === _vm.unitlist.selected) ? _c('div', {
      key: item.Model,
      staticClass: "bgimage inner",
      style: ({
        'background-image': 'url(' + item.Image + ')'
      })
    }) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(205);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("734b9d82", content, true, {});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(206);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4bab5a10", content, true, {});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0db8753f", content, true, {});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(208);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("49945c4a", content, true, {});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(209);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("555965d0", content, true, {});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("eebb03fc", content, true, {});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(211);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b60cfa6e", content, true, {});

/***/ }),
/* 245 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.963ca284ae4e8ba3f489.js